(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["OktaSignIn"] = factory();
	else
		root["OktaSignIn"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 620);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(453);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault2 = __webpack_require__(1);

var _lastIndexOf = _interopRequireDefault2(__webpack_require__(455));

var _reverse = _interopRequireDefault2(__webpack_require__(943));

var _keys = _interopRequireDefault2(__webpack_require__(117));

var _includes = _interopRequireDefault2(__webpack_require__(52));

var _getIterator2 = _interopRequireDefault2(__webpack_require__(458));

var _isIterable2 = _interopRequireDefault2(__webpack_require__(313));

var _from = _interopRequireDefault2(__webpack_require__(953));

var _getPrototypeOf = _interopRequireDefault2(__webpack_require__(955));

var _setPrototypeOf = _interopRequireDefault2(__webpack_require__(959));

var _create = _interopRequireDefault2(__webpack_require__(963));

var _typeof3 = _interopRequireDefault2(__webpack_require__(26));

var _flat = _interopRequireDefault2(__webpack_require__(989));

var _flags = _interopRequireDefault2(__webpack_require__(483));

var _isArray = _interopRequireDefault2(__webpack_require__(35));

var _forEach = _interopRequireDefault2(__webpack_require__(17));

var _every = _interopRequireDefault2(__webpack_require__(1006));

var _findIndex = _interopRequireDefault2(__webpack_require__(153));

var _filter = _interopRequireDefault2(__webpack_require__(39));

var _indexOf = _interopRequireDefault2(__webpack_require__(78));

var _some = _interopRequireDefault2(__webpack_require__(320));

var _splice = _interopRequireDefault2(__webpack_require__(154));

var _reduce = _interopRequireDefault2(__webpack_require__(140));

var _values = _interopRequireDefault2(__webpack_require__(1033));

var _map = _interopRequireDefault2(__webpack_require__(40));

var _setInterval2 = _interopRequireDefault2(__webpack_require__(194));

var _setTimeout2 = _interopRequireDefault2(__webpack_require__(71));

var _isInteger = _interopRequireDefault2(__webpack_require__(492));

var _find = _interopRequireDefault2(__webpack_require__(13));

var _trim = _interopRequireDefault2(__webpack_require__(321));

var _parseInt3 = _interopRequireDefault2(__webpack_require__(323));

var _parseFloat3 = _interopRequireDefault2(__webpack_require__(1058));

var _stringify = _interopRequireDefault2(__webpack_require__(98));

var _slice = _interopRequireDefault2(__webpack_require__(495));

var _concat = _interopRequireDefault2(__webpack_require__(18));

var _keys2 = _interopRequireDefault2(__webpack_require__(324));

var _bind = _interopRequireDefault2(__webpack_require__(27));

var _iterator = _interopRequireDefault2(__webpack_require__(1077));

var _symbol = _interopRequireDefault2(__webpack_require__(1079));

var _defineProperty = _interopRequireDefault2(__webpack_require__(0));

/*! THIS FILE IS GENERATED FROM PACKAGE @okta/courage@4.5.0-5100-g8598522 */
module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      (0, _defineProperty.default)(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 35);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscore = _interopRequireDefault(__webpack_require__(37));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta-ui/no-specific-methods: 0, @okta/okta-ui/no-specific-modules: 0 */


  _underscore.default.mixin({
    resultCtx: function resultCtx(object, property, context, defaultValue) {
      var value = _underscore.default.isObject(object) ? object[property] : void 0;

      if (_underscore.default.isFunction(value)) {
        value = value.call(context || object);
      }

      if (value) {
        return value;
      } else {
        return !_underscore.default.isUndefined(defaultValue) ? defaultValue : value;
      }
    },
    isInteger: function isInteger(x) {
      return _underscore.default.isNumber(x) && x % 1 === 0;
    },
    // TODO: This will be deprecated at some point. Views should use precompiled templates
    // eslint-disable-next-line @okta/okta-ui/no-bare-templates
    template: function template(source, data) {
      var template = _handlebars.default.compile(source);

      return data ? template(data) : function (data) {
        return template(data);
      };
    }
  });

  var _default = _underscore.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _View = _interopRequireDefault(__webpack_require__(14));

  var _TemplateUtil = _interopRequireDefault(__webpack_require__(43));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var eventBus = _underscoreWrapper.default.clone(_backbone.default.Events); // add `broadcast` and `listen` functionality to all views
  // We use one event emitter per all views
  // This means we need to be very careful with event names


  var proto = {
    constructor: function constructor() {
      _View.default.apply(this, arguments);

      this.module && this.$el.attr('data-view', this.module.id);
    },

    /**
     * @deprecated Use {@link #removeChildren}
     */
    empty: function empty() {
      return this.removeChildren();
    },
    compileTemplate: _TemplateUtil.default.tpl,

    /**
     *
     * Broadcasts a global event that all views and controllers can subscribe to
     * for framework use only - prefer using a shared model
     *
     * @param {String} eventName A unique identifier for the event
     * @param {...String} param Parameter to pass with the event (can pass more than one parameter)
     * @deprecated For internal use only
     * @private
     */
    broadcast: function broadcast() {
      eventBus.trigger.apply(eventBus, arguments);
      return this;
    },

    /**
     * Subscribe to broadcast events
     * for framework use only - prefer using a shared model
     *
     * @param {String} eventName The event identifier to subscribe
     * @param {Function} fn The callback function to invoke
     * @deprecated For internal use only
     * @private
     */
    listen: function listen(name, fn) {
      eventBus.off(name, fn);
      this.listenTo(eventBus, name, fn);
      return this;
    },

    /**
     * Shows a notification box
     * @param {String} level success / warning / error
     * @param {String} message The message to display
     * @param {Object} [options]
     * @param {Number} [options.width] Set a custom width
     * @param {String} [options.title] Set a custom title
     * @param {Boolean} [options.hide=true] Do we want to auto-hide this notification?
     * @param {Boolean} [options.dismissable] Show a dismiss button
     * @example
     * view.notify('success', 'Group created successfully');
     */
    notify: function notify(level, message, options) {
      this.broadcast('notification', _underscoreWrapper.default.defaults({
        message: message,
        level: level
      }, options));
      return this;
    },

    /**
     * Shows a confirmation dialog
     *
     * The main difference between this and the native javascript `confirm` method
     * Is this method is non blocking (note the callback pattern).
     *
     * The callback function will run in the context (`this`) of the invoking view.
     *
     * @param {String} [title] The title of the confirmation dialog
     * @param {String} [message] The message of the confirmation dialog
     * @param {Function} [okfn] The callback to run when the user hits "OK" (runs in the context of the invoking view)
     * @param {Function} [cancelfn] The callback to run when the user hits "Cancel"
     *        (runs in the context of the invoking view)
     * @example
     * view.confirm('Delete Group', 'Are you sure you want to delete the selected group?', function () {
     *   model.destroy();
     * });
     *
     * // title will be auto-set to "Okta"
     * view.confirm('Are you sure you want to delete the selected group?', function () {
     *   model.destroy();
     * });
     *
     * view.confirm({
     *   title: 'Delete Group', //=> Modal title
     *   subtitle: 'Are you sure you want to delete the selected group?', //=> Modal subtitle
     *   content: '<h3 color="red">THIS WILL DELETE THE GROUP!</h3>', //=> A template or a view to add to the modal
     *   save: 'Delete Group', //=> Button label
     *   ok: _.bind(model.save, model) // Callback function on hitting "ok" button
     *   cancel: 'Cancel', //=> Button label
     *   cancelFn: _.bind(model.destroy, model) // Callback function on hitting "cancel" button
     * });
     */
    confirm: function confirm(title, message, okfn, cancelfn) {
      var options;
      /* eslint max-statements: [2, 12] */

      if (_typeof(title) === 'object') {
        options = title;
      } else {
        if (arguments.length === 2 && _underscoreWrapper.default.isFunction(message)) {
          options = {
            title: 'Okta',
            // eslint-disable-line @okta/okta/no-unlocalized-text
            subtitle: title,
            ok: message
          };
        } else {
          options = {
            title: title,
            subtitle: message,
            ok: okfn,
            cancelFn: cancelfn
          };
        }
      }

      if (_underscoreWrapper.default.isFunction(options.ok)) {
        var _context;

        options.ok = (0, _bind.default)(_context = _underscoreWrapper.default).call(_context, options.ok, this);
      }

      if (_underscoreWrapper.default.isFunction(options.cancelFn)) {
        var _context2;

        options.cancelFn = (0, _bind.default)(_context2 = _underscoreWrapper.default).call(_context2, options.cancelFn, this);
      }

      this.broadcast('confirmation', options);
      return this;
    },

    /**
     * Shows an alert box
     *
     * The main difference between this and the native javascript `alert` method
     * Is this method is non blocking.
     *
     * @param {String} message The message
     * @example
     * view.alert('Mission complete');
     */
    alert: function alert(params) {
      if (_underscoreWrapper.default.isString(params)) {
        params = {
          subtitle: params
        };
      }

      this.confirm(_underscoreWrapper.default.extend({}, params, {
        noCancelButton: true
      }));
      return this;
    }
  };
  /**
   * See {@link src/framework/View} for more detail and examples from the base class.
   * @class module:Okta.View
   * @extends src/framework/View
   */

  /** @lends module:Okta.View.prototype */

  var _default = _View.default.extend(proto,
  /** @lends View.prototype */
  {
    /** @method */
    decorate: function decorate(TargetView) {
      var BaseViewView = TargetView.extend({});

      _underscoreWrapper.default.defaults(BaseViewView.prototype, proto);

      return BaseViewView;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(4);
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jquery = _interopRequireDefault(__webpack_require__(12));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable @okta/okta-ui/enforce-requirejs-names, @okta/okta-ui/no-specific-modules */


  _jquery.default.ajaxSetup({
    beforeSend: function beforeSend(xhr) {
      xhr.setRequestHeader('X-Okta-XsrfToken', (0, _jquery.default)('#_xsrfToken').text());
    },
    converters: {
      'text secureJSON': function textSecureJSON(str) {
        if (str.substring(0, 11) === 'while(1){};') {
          str = str.substring(11);
        }

        return JSON.parse(str);
      }
    }
  }); // Selenium Hook
  // Widget such as autocomplete and autosuggest needs to be triggered from the running version of jQuery.
  // We have 2 versions of jQuery running in parallel and they don't share the same events bus


  window.jQueryCourage = _jquery.default;
  var _default = _jquery.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _oktaI18nBundles = _interopRequireDefault(__webpack_require__(41));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var entityMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': '\'',
    '&#039;': '\'',
    '&#x2F;': '/'
  };
  var emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  /**
  * Converts the locale code identifier from "${languageCode}-${countryCode}" to "${languageCode}_${countryCode}"
  * Follows the ISO-639-1 language code and 2-letter ISO-3166-1-alpha-2 country code structure.
  * @param {String} locale code identifier
  * @return {String} converted locale code identifier
  */

  var parseLocale = function parseLocale(locale) {
    if (/-/.test(locale)) {
      var parts = locale.split('-');
      parts[1] = parts[1].toUpperCase();
      return parts.join('_');
    }

    return locale;
  };
  /* eslint max-len: 0*/

  /**
   * Returns the language bundle based on the current locale.
   * - If a locale is not provided, default to English ('en')
   * - Legacy Support: If the named language bundle does not exist, fall back to the default named bundle.
   *
   * @param {*} bundleName
   */


  function getBundle(bundleName) {
    var _context4;

    if (!bundleName) {
      var _context3;

      return _oktaI18nBundles.default[(0, _keys2.default)(_context3 = _underscoreWrapper.default).call(_context3, _oktaI18nBundles.default)[0]];
    }

    var locale = parseLocale(window && window.okta && window.okta.locale) || 'en';
    return _oktaI18nBundles.default[(0, _concat.default)(_context4 = "".concat(bundleName, "_")).call(_context4, locale)] || _oktaI18nBundles.default[bundleName];
  }
  /**
   *
   * CustomEvent polyfill for IE
   * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
   */


  function IECustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  /**
   * Call the window.okta.emitL10nError function if it is defined
   * @param {String} key The i18n key
   * @param {String} bundleName The i18n bundle name
   * @param {String} reason Could be 'bundle' (Bundle not found), 'key' (Key not found) or 'parameters' (Parameters mismatch).
   */


  function emitL10nError(key, bundleName, reason) {
    // CustomEvent polyfill for IE
    if (!window.CustomEvent) {
      window.CustomEvent = IECustomEvent;
    } // dispatchEvent for sentry


    if (typeof window.CustomEvent === 'function') {
      var event = new CustomEvent('okta-i18n-error', {
        detail: {
          type: 'l10n-error',
          key: key,
          bundleName: bundleName,
          reason: reason
        }
      });
      document.dispatchEvent(event);
    }
  }

  var StringUtil =
  /** @lends module:Okta.internal.util.StringUtil */
  {
    /** @static */
    sprintf: function sprintf() {
      var args = (0, _slice.default)(Array.prototype).apply(arguments);
      var value = args.shift();
      var oldValue = value;
      /* eslint max-statements: [2, 15] */

      function triggerError() {
        throw new Error('Mismatch number of variables: ' + arguments[0] + ', ' + (0, _stringify.default)(args));
      }

      for (var i = 0, l = args.length; i < l; i++) {
        var entity = args[i];
        value = value.replace('{' + i + '}', entity);

        if (entity === undefined || entity === null || value === oldValue) {
          triggerError();
        }

        oldValue = value;
      }

      if (/\{[\d+]\}/.test(value)) {
        triggerError();
      }

      return value;
    },

    /**
     * Converts a URI encoded query string into a hash map
     * @param  {String} query The query string
     * @return {Object} The map
     * @static
     * @example
     * StringUtil.parseQuery('foo=bar&baz=qux') // {foo: 'bar', baz: 'qux'}
     */
    parseQuery: function parseQuery(query) {
      var params = {};
      var pairs = decodeURIComponent(query.replace(/\+/g, ' ')).split('&');

      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var data = pair.split('=');
        params[data.shift()] = data.join('=');
      }

      return params;
    },

    /** @static */
    encodeJSObject: function encodeJSObject(jsObj) {
      return encodeURIComponent((0, _stringify.default)(jsObj));
    },

    /** @static */
    decodeJSObject: function decodeJSObject(jsObj) {
      try {
        return JSON.parse(decodeURIComponent(jsObj));
      } catch (e) {
        return null;
      }
    },

    /** @static */
    unescapeHtml: function unescapeHtml(string) {
      return String(string).replace(/&[\w#\d]{2,};/g, function (s) {
        return entityMap[s] || s;
      });
    },

    /**
     * Get the original i18n template directly without string format with parameters
     * @param {String} key The key
     * @param {String} bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
     */
    getTemplate: function getTemplate(key, bundleName) {
      var bundle = getBundle(bundleName);

      if (!bundle) {
        emitL10nError(key, bundleName, 'bundle');
        return 'L10N_ERROR[' + bundleName + ']';
      }

      if (bundle[key]) {
        return bundle[key];
      } else {
        emitL10nError(key, bundleName, 'key');
        return 'L10N_ERROR[' + key + ']';
      }
    },

    /**
     * Translate a key to the localized value
     * @static
     * @param  {String} key The key
     * @param  {String} [bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
     * @param  {Array} [params] A list of parameters to apply as tokens to the i18n value
     * @return {String} The localized value
     */
    localize: function localize(key, bundleName, params) {
      var bundle = getBundle(bundleName);
      /* eslint complexity: [2, 6] */

      if (!bundle) {
        emitL10nError(key, bundleName, 'bundle');
        return 'L10N_ERROR[' + bundleName + ']';
      }

      var value = bundle[key];

      try {
        params = params && (0, _slice.default)(params) ? (0, _slice.default)(params).call(params, 0) : [];
        params.unshift(value);
        value = StringUtil.sprintf.apply(null, params);

        if (value) {
          return value;
        } else {
          emitL10nError(key, bundleName, 'key');
          return 'L10N_ERROR[' + key + ']';
        }
      } catch (e) {
        emitL10nError(key, bundleName, 'parameters');
        return 'L10N_ERROR[' + key + ']';
      }
    },

    /**
     * Convert a string to a float if valid, otherwise return the string.
     * Valid numbers may contain a negative sign and a decimal point.
     * @static
     * @param {String} string The string to convert to a number
     * @return {String|Number} Returns a number if the string can be casted, otherwise returns the original string
     */
    parseFloat: function (_parseFloat) {
      function parseFloat(_x) {
        return _parseFloat.apply(this, arguments);
      }

      parseFloat.toString = function () {
        return _parseFloat.toString();
      };

      return parseFloat;
    }(function (string) {
      var number = +string;
      return typeof string === 'string' && number === (0, _parseFloat3.default)(string) ? number : string;
    }),

    /**
     * Convert a string to an integer if valid, otherwise return the string
     * @static
     * @param {String} string The string to convert to an integer
     * @return {String|integer} Returns an integer if the string can be casted, otherwise, returns the original string
     */
    parseInt: function (_parseInt) {
      function parseInt(_x2) {
        return _parseInt.apply(this, arguments);
      }

      parseInt.toString = function () {
        return _parseInt.toString();
      };

      return parseInt;
    }(function (string) {
      var int = +string;
      return _underscoreWrapper.default.isString(string) && int === (0, _parseInt3.default)(string, 10) ? int : string;
    }),

    /**
     * Convert a string to an object if valid, otherwise return the string
     * @static
     * @param {String} string The string to convert to an object
     * @return {String|object} Returns an object if the string can be casted, otherwise, returns the original string
     */
    parseObject: function parseObject(string) {
      if (!_underscoreWrapper.default.isString(string)) {
        return string;
      }

      try {
        var object = JSON.parse(string);
        return _jqueryWrapper.default.isPlainObject(object) ? object : string;
      } catch (e) {
        return string;
      }
    },

    /**
     * Returns a random string from [a-z][A-Z][0-9] of a given length
     * @static
     * @param {Number} length The length of the random string.
     * @return {String} Returns a random string from [a-z][A-Z][0-9] of a given length
     */
    randomString: function randomString(length) {
      var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';

      if (length === undefined) {
        length = _underscoreWrapper.default.random(characters.length);
      } else if (length === 0) {
        return '';
      }

      var stringArray = [];

      while (length--) {
        stringArray.push(characters[_underscoreWrapper.default.random(characters.length - 1)]);
      }

      return stringArray.join('');
    },

    /**
     * Returns if a str ends with another string
     * @static
     * @param {String} str The string to search
     * @param {String} ends The string it should end with
     *
     * @return {Boolean} Returns if the str ends with ends
     */
    endsWith: function endsWith(str, ends) {
      str += '';
      ends += '';
      return str.length >= ends.length && str.substring(str.length - ends.length) === ends;
    },

    /** @static */
    isEmail: function isEmail(str) {
      var _context5;

      var target = (0, _trim.default)(_context5 = _jqueryWrapper.default).call(_context5, str);
      return !_underscoreWrapper.default.isEmpty(target) && emailValidator.test(target);
    }
  };
  /**
   * Handy utility functions to handle strings.
   *
   * @class module:Okta.internal.util.StringUtil
   * @hideconstructor
   */

  var _default = StringUtil;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(4);
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(1094);
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  function _log(level, args) {
    if (window.console && window.okta && window.okta.debug) {
      window.console[level].apply(window.console, args);
    }
  }
  /**
   * Utility library of logging functions.
   * @class module:Okta.Logger
   */


  var _default =
  /** @lends module:Okta.Logger */
  {
    /**
     * See [console.trace](https://developer.mozilla.org/en-US/docs/Web/API/Console.trace)
     * @static
     */
    trace: function trace() {
      return _log('trace', arguments);
    },

    /**
     * See [console.dir](https://developer.mozilla.org/en-US/docs/Web/API/Console.dir)
     * @static
     */
    dir: function dir() {
      return _log('dir', arguments);
    },

    /**
     * See [console.time](https://developer.mozilla.org/en-US/docs/Web/API/Console.time)
     * @static
     */
    time: function time() {
      return _log('time', arguments);
    },

    /**
     * See [console.timeEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.timeEnd)
     * @static
     */
    timeEnd: function timeEnd() {
      return _log('timeEnd', arguments);
    },

    /**
     * See [console.group](https://developer.mozilla.org/en-US/docs/Web/API/Console.group)
     * @static
     */
    group: function group() {
      return _log('group', arguments);
    },

    /**
     * See [console.groupEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.groupEnd)
     * @static
     */
    groupEnd: function groupEnd() {
      return _log('groupEnd', arguments);
    },

    /**
     * See [console.assert](https://developer.mozilla.org/en-US/docs/Web/API/Console.assert)
     * @static
     */
    assert: function assert() {
      return _log('assert', arguments);
    },

    /**
     * See [console.log](https://developer.mozilla.org/en-US/docs/Web/API/Console.log)
     * @static
     */
    log: function log() {
      return _log('log', arguments);
    },

    /**
     * See [console.info](https://developer.mozilla.org/en-US/docs/Web/API/Console.info)
     * @static
     */
    info: function info() {
      return _log('info', arguments);
    },

    /**
     * See [console.warn](https://developer.mozilla.org/en-US/docs/Web/API/Console.warn)
     * @static
     */
    warn: function warn() {
      return _log('warn', arguments);
    },

    /**
     * See [console.error](https://developer.mozilla.org/en-US/docs/Web/API/Console.error)
     * @static
     */
    error: function error() {
      return _log('error', arguments);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = {
    UP: 38,
    DOWN: 40,
    DEL: 46,
    TAB: 9,
    RETURN: 13,
    ENTER: 13,
    ESC: 27,
    COMMA: 188,
    PAGEUP: 33,
    PAGEDOWN: 34,
    SPACE: 32,
    BACKSPACE: 8,
    __isKey: function __isKey(e, key) {
      return (e.which || e.keyCode) === this[key];
    },
    isEnter: function isEnter(e) {
      return this.__isKey(e, 'ENTER');
    },
    isEsc: function isEsc(e) {
      return this.__isKey(e, 'ESC');
    },
    isSpaceBar: function isSpaceBar(e) {
      return this.__isKey(e, 'SPACE');
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _ButtonFactory = _interopRequireDefault(__webpack_require__(18));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _Callout = _interopRequireDefault(__webpack_require__(31));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @class BaseInput
   * @private
   * An abstract object that defines an input for {@link Okta.Form}
   *
   * BaseInputs are typically not created directly, but being passed to {@link Okta.Form#addInput}
   * @extends Okta.View
   */


  var _default = _BaseView.default.extend({
    tagName: 'span',
    attributes: function attributes() {
      return {
        'data-se': 'o-form-input-' + this.getNameString()
      };
    },

    /**
     * default placeholder text when options.placeholder is not defined
     */
    defaultPlaceholder: '',
    constructor: function constructor(options) {
      /* eslint complexity: [2, 7] */
      options = _underscoreWrapper.default.defaults(options || {}, {
        inputId: options.id || _underscoreWrapper.default.uniqueId('input'),
        placeholder: this.defaultPlaceholder,
        inlineValidation: true,
        validateOnlyIfDirty: false
      });
      delete options.id; // decorate the `enable` and `disable` and toggle the `o-form-disabled` class.
      // so we wont need to worry about this when overriding the methods

      var self = this;

      _underscoreWrapper.default.each({
        enable: 'removeClass',
        disable: 'addClass'
      }, function (method, action) {
        self[action] = _underscoreWrapper.default.wrap(self[action], function (fn) {
          fn.apply(self, arguments);
          self.$el[method]('o-form-disabled');
        });
      });

      _BaseView.default.call(this, options);

      if (_underscoreWrapper.default.result(options, 'readOnly') !== true && _underscoreWrapper.default.result(options, 'read') === true) {
        this.listenTo(this.model, 'change:__edit__', this.render);
      }

      if (_underscoreWrapper.default.isFunction(this.focus)) {
        var _context6;

        this.focus = _underscoreWrapper.default.debounce((0, _bind.default)(_context6 = _underscoreWrapper.default).call(_context6, this.focus, this), 50);
      } // Enable inline validation if this is not the first field in the form.


      if (!_underscoreWrapper.default.result(options, 'validateOnlyIfDirty')) {
        this.addInlineValidation();
      }

      this.addModelListeners();
      this.$el.addClass('o-form-input-name-' + this.getNameString());
    },
    addAriaLabel: function addAriaLabel() {
      var ariaLabel = this.options.ariaLabel;

      if (ariaLabel) {
        this.$(':input').attr('aria-label', ariaLabel);
      }
    },
    addInlineValidation: function addInlineValidation() {
      if (_underscoreWrapper.default.result(this.options, 'inlineValidation')) {
        var _context7;

        this.$el.on('focusout', ':input', (0, _bind.default)(_context7 = _underscoreWrapper.default).call(_context7, this.validate, this));
      }
    },
    toModelValue: function toModelValue() {
      var value = this.val();

      if (_underscoreWrapper.default.isFunction(this.to)) {
        value = this.to.call(this, value);
      }

      if (_underscoreWrapper.default.isFunction(this.options.to)) {
        value = this.options.to.call(this, value);
      }

      return value;
    },
    __getDependencyCalloutBtn: function __getDependencyCalloutBtn(btnConfig) {
      var self = this;

      var btnOptions = _underscoreWrapper.default.clone(btnConfig);

      var originalClick = btnOptions.click || function () {}; // add onfocus listener to re-evaluate depedency when callout button is clicked


      btnOptions.click = function () {
        (0, _jqueryWrapper.default)(window).one('focus.dependency', function () {
          self.__showInputDependencies();
        });
        originalClick.call(self);
      };

      var BaseInputCalloutBtn = _BaseView.default.extend({
        children: [_ButtonFactory.default.create(btnOptions)]
      });

      return new BaseInputCalloutBtn();
    },
    getCalloutParent: function getCalloutParent() {
      return this.$('input[value="' + this.getModelValue() + '"]').parent();
    },
    __getCalloutMsgContainer: function __getCalloutMsgContainer(calloutMsg) {
      return _BaseView.default.extend({
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "msg") || (depth0 != null ? lookupProperty(depth0, "msg") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "msg",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 29
                },
                "end": {
                  "line": 1,
                  "column": 36
                }
              }
            }) : helper)) + "</span>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            msg: calloutMsg
          };
        }
      });
    },
    showCallout: function showCallout(calloutConfig, dependencyResolved) {
      var callout = _underscoreWrapper.default.clone(calloutConfig);

      callout.className = 'dependency-callout';

      if (callout.btn) {
        callout.content = this.__getDependencyCalloutBtn(callout.btn);
        delete callout.btn;
      }

      var dependencyCallout = _Callout.default.create(callout);

      if (!dependencyResolved) {
        dependencyCallout.add(this.__getCalloutMsgContainer(_StringUtil.default.localize('dependency.callout.msg', 'courage')));
      }

      var calloutParent = this.getCalloutParent();
      calloutParent.append(dependencyCallout.render().el);

      if (callout.type === 'success') {
        _underscoreWrapper.default.delay(function () {
          // fade out success callout
          dependencyCallout.$el.fadeOut(800);
        }, 1000);
      }
    },
    removeCallout: function removeCallout() {
      var _context8;

      (0, _find.default)(_context8 = this.$el).call(_context8, '.dependency-callout').remove();
    },
    __evaluateCalloutObject: function __evaluateCalloutObject(dependencyResolved, calloutTitle) {
      var defaultCallout;

      if (dependencyResolved) {
        defaultCallout = {
          title: _StringUtil.default.localize('dependency.action.completed', 'courage'),
          size: 'large',
          type: 'success'
        };
      } else {
        defaultCallout = {
          title: _StringUtil.default.localize('dependency.action.required', 'courage', [calloutTitle]),
          size: 'large',
          type: 'warning'
        };
      }

      return defaultCallout;
    },
    __handleDependency: function __handleDependency(result, callout) {
      var self = this;
      var calloutConfig = _underscoreWrapper.default.isFunction(callout) ? callout(result) : _underscoreWrapper.default.extend({}, callout, self.__evaluateCalloutObject(result.resolved, callout.title)); // remove existing callouts if any

      self.removeCallout();
      self.showCallout(calloutConfig, result.resolved);
    },
    __showInputDependencies: function __showInputDependencies() {
      var self = this;
      var fieldDependency = self.options.deps[self.getModelValue()];

      if (fieldDependency && _underscoreWrapper.default.isFunction(fieldDependency.func)) {
        fieldDependency.func().done(function (data) {
          self.__handleDependency({
            resolved: true,
            data: data
          }, fieldDependency.callout);
        }).fail(function (data) {
          self.__handleDependency({
            resolved: false,
            data: data
          }, fieldDependency.callout);
        });
      } else {
        self.removeCallout();
      }
    },
    _isEdited: false,

    /**
     * updates the model with the input's value
     */
    update: function update() {
      if (!this._isEdited && _underscoreWrapper.default.result(this.options, 'validateOnlyIfDirty')) {
        this._isEdited = true;
        this.addInlineValidation();
      }

      this.model.set(this.options.name, this.toModelValue());

      if (this.options.deps) {
        // check for dependencies
        this.__showInputDependencies();
      }
    },

    /**
     * Is the input in edit mode
     * @return {Boolean}
     */
    isEditMode: function isEditMode() {
      var ret = !_underscoreWrapper.default.result(this.options, 'readOnly') && (_underscoreWrapper.default.result(this.options, 'read') !== true || this.model.get('__edit__') === true);
      return ret;
    },

    /**
     * Renders the input
     * @readonly
     */
    render: function render() {
      this.preRender();
      var params = this.options.params;
      this.options.params = _underscoreWrapper.default.resultCtx(this.options, 'params', this);

      if (this.isEditMode()) {
        this.editMode();

        if (_underscoreWrapper.default.resultCtx(this.options, 'disabled', this)) {
          this.disable();
        } else {
          this.enable();
        }
      } else {
        this.readMode();
      }

      this.options.params = params;
      this.addAriaLabel();
      this.postRender();
      return this;
    },

    /**
     * checks if the current value in the model is valid for this field
     */
    validate: function validate() {
      if (!this.model.get('__pending__') && this.isEditMode() && _underscoreWrapper.default.isFunction(this.model.validateField)) {
        var validationError = this.model.validateField(this.options.name);

        if (validationError) {
          var _context9;

          _underscoreWrapper.default.delay((0, _bind.default)(_context9 = function _context9() {
            this.model.trigger('form:clear-error:' + this.options.name);
            this.model.trigger('invalid', this.model, validationError, false);
          }).call(_context9, this), 100);
        }
      }
    },

    /**
     * Add model event listeners
     */
    addModelListeners: function addModelListeners() {
      this.listenTo(this.model, 'form:field-error', function (name) {
        if (this.options.name === name) {
          this.__markError();
        }
      });
      this.listenTo(this.model, 'form:clear-errors change:' + this.options.name, this.__clearError);
      this.listenTo(this.model, 'form:clear-error:' + this.options.name, this.__clearError);
    },

    /**
     * The value of the input
     * @return {Mixed}
     */
    val: function val() {
      throw new Error('val() is an abstract method');
    },

    /**
     * Set focus on the input
     */
    focus: function focus() {
      throw new Error('focus() is an abstract method');
    },

    /**
     * Default value in read mode
     * When model has no value for the field
     */
    defaultValue: function defaultValue() {
      return '';
    },

    /**
     * Renders the input in edit mode
     */
    editMode: function editMode() {
      var options = _underscoreWrapper.default.extend({}, this.options, {
        value: this.getModelValue()
      });

      this.$el.html(this.template(options));
      this.options.multi && this.$el.removeClass('margin-r');
      return this;
    },

    /**
     * Renders the readable value of the input in read mode
     */
    readMode: function readMode() {
      this.$el.text(this.getReadModeString());
      this.$el.removeClass('error-field');
      this.options.multi && this.$el.addClass('margin-r');
      return this;
    },
    getReadModeString: function getReadModeString() {
      var readModeStr = _underscoreWrapper.default.resultCtx(this.options, 'readModeString', this);

      if (readModeStr) {
        return readModeStr;
      }

      return this.toStringValue();
    },

    /**
     * The model value off the field associated with the input
     * @return {Mixed}
     */
    getModelValue: function getModelValue() {
      var value = this.model.get(this.options.name);

      if (_underscoreWrapper.default.isFunction(this.from)) {
        value = this.from.call(this, value);
      }

      if (_underscoreWrapper.default.isFunction(this.options.from)) {
        value = this.options.from.call(this, value);
      }

      return value;
    },

    /*
    * convenience method to get the textual value from the model
    * will return the textual label rather than value in case of select/radio
    * @return {String}
    */
    toStringValue: function toStringValue() {
      var value = this.getModelValue();

      if (this.options.options) {
        // dropdown or radio
        value = this.options.options[value];
      }

      if ((0, _isInteger.default)(value) || typeof value === 'boolean') {
        value = String(value);
      }

      return value || this.defaultValue();
    },

    /**
     * Triggers a form:resize event in order to tell dialogs content size has changed
     */
    resize: function resize() {
      this.model.trigger('form:resize');
    },

    /**
     * Disable the input
     */
    disable: function disable() {
      this.$(':input').prop('disabled', true);
    },

    /**
     * Enable the input
     */
    enable: function enable() {
      this.$(':input').prop('disabled', false);
    },

    /**
     * Change the type of the input field. (e.g., text <--> password)
     * @param type
     */
    changeType: function changeType(type) {
      this.$(':input').prop('type', type); // Update the options so that it keeps the uptodate state

      this.options.type = type;
    },
    getNameString: function getNameString() {
      if (_underscoreWrapper.default.isArray(this.options.name)) {
        return this.options.name.join('-');
      }

      return this.options.name;
    },

    /**
     * Get parameters, computing _.result
     * @param  {[type]} options alternative options
     * @return {Object} the params
     */
    getParams: function getParams(options) {
      var opts = options || this.options || {};
      return _underscoreWrapper.default.clone(_underscoreWrapper.default.resultCtx(opts, 'params', this) || {});
    },

    /**
     * get a parameter from options.params, compute _.result when needed.
     * @param  {String} key
     * @param  {Object} defaultValue
     * @return {Object} the params
     */
    getParam: function getParam(key, defaultValue) {
      var result = _underscoreWrapper.default.resultCtx(this.getParams(), key, this);

      return !_underscoreWrapper.default.isUndefined(result) ? result : defaultValue;
    },

    /**
     * Get a parameter from options.params or if empty, object attribute.
     *
     * @param  {String} key
     * @return {Object} the param or attribute
     */
    getParamOrAttribute: function getParamOrAttribute(key) {
      return this.getParam(key) || _underscoreWrapper.default.result(this, key);
    },
    __markError: function __markError() {
      this.$el.addClass('o-form-has-errors');
    },
    __clearError: function __clearError() {
      this.$el.removeClass('o-form-has-errors');
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _ViewUtil = _interopRequireDefault(__webpack_require__(25));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-params: [2, 6] */


  var LABEL_OPTIONS = ['model', 'id', 'inputId', 'type', 'label', 'sublabel', 'tooltip', 'name'];
  var CONTAINER_OPTIONS = ['wide', 'multi', 'input', 'label-top', 'explain', 'explain-top', 'customExplain', 'model', 'name', 'type', 'autoRender'];
  var WRAPPER_OPTIONS = ['model', 'name', 'label-top', 'readOnly', 'events', 'initialize', 'showWhen', 'bindings', 'render', 'className', 'data-se', 'toggleWhen'];
  var INPUT_OPTIONS = ['model', 'name', 'inputId', 'type', // base options
  'input', // custom input
  'placeholder', 'label', // labels
  'readOnly', 'read', 'disabled', 'readModeString', // modes
  'options', // select/radio
  'deps', // used to specify inputs that have dependencies and show a callout to user on select
  'from', 'to', // model transformers,
  'autoRender', // model attributes change event to trigger rerendering of the input
  'inlineValidation', // control inline validating against the model on focus lost
  'validateOnlyIfDirty', // check if field has been interacted with and then validate
  'ariaLabel', // 508 compliance for inputs that do not have label associated with them
  'params', 'autoComplete' // autocomplete attribute
  ];
  var // widgets params - for input specific widgets
  OTHER_OPTIONS = ['errorField'];

  var ALL_OPTIONS = _underscoreWrapper.default.uniq(_underscoreWrapper.default.union(LABEL_OPTIONS, CONTAINER_OPTIONS, WRAPPER_OPTIONS, INPUT_OPTIONS, OTHER_OPTIONS));

  var SAVE_BUTTON_PHASES = ['•         ', '•  •      ', '•  •  •   ', '•  •  •  •', '   •  •  •', '      •  •', '         •', '          ', '          ', '          '];

  function decorateDoWhen(doWhen) {
    if (doWhen && !doWhen['__edit__']) {
      return _underscoreWrapper.default.extend({
        __edit__: _underscoreWrapper.default.constant(true)
      }, doWhen);
    }
  }

  function _createButton(options) {
    options = _underscoreWrapper.default.pick(options || {}, 'action', 'id', 'className', 'text', 'type');
    var timeoutId;
    var intervalId;
    var phaseCount;
    return _BaseView.default.extend({
      tagName: 'input',
      className: 'button',
      events: {
        click: function click() {
          if (options.action && !this.disabled()) {
            options.action.call(this);
          }
        },
        keyup: function keyup(e) {
          if (_Keys.default.isEnter(e) && options.action && !this.disabled()) {
            options.action.call(this);
          }
        }
      },
      disabled: function disabled() {
        return this.$el.prop('disabled') === true;
      },
      disable: function disable() {
        this.$el.prop('disabled', true);
        this.$el.addClass('btn-disabled');
      },
      enable: function enable() {
        this.$el.prop('disabled', false);
        this.$el.removeClass('btn-disabled');
      },
      initialize: function initialize() {
        var self = this;
        this.$el.attr('type', options.type === 'save' ? 'submit' : 'button');
        this.$el.val(options.text);

        if (options.id) {
          this.$el.attr('id', options.id);
        }

        if (options.className) {
          this.$el.addClass(options.className);
        }

        if (options.type) {
          this.$el.attr('data-type', options.type);
        }

        this.$el.mousedown(function () {
          self.model.set('__pending__', true);
        });
        this.$el.mouseup(function () {
          self.model.set('__pending__', false);
        });
        this.listenTo(this.model, 'form:set-saving-state', function () {
          this.disable();

          if (options.type === 'save') {
            var _context10;

            timeoutId = (0, _setTimeout2.default)((0, _bind.default)(_context10 = _underscoreWrapper.default).call(_context10, this.__changeSaveText, this), 1000);
          }
        });
        this.listenTo(this.model, 'form:clear-saving-state', function () {
          this.enable();

          if (options.type === 'save') {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
            this.$el.val(options.text);
          }
        });
      },
      __changeSaveText: function __changeSaveText() {
        var _context11;

        phaseCount = 0;
        intervalId = (0, _setInterval2.default)((0, _bind.default)(_context11 = _underscoreWrapper.default).call(_context11, this.__showLoadingText, this), 200);
      },
      __showLoadingText: function __showLoadingText() {
        this.$el.val(SAVE_BUTTON_PHASES[phaseCount++ % SAVE_BUTTON_PHASES.length]);
      }
    });
  }

  function validateInput(options, model) {
    var _context12;

    /* eslint max-statements: 0, complexity: 0 */
    options || (options = {});

    if (options.type === 'label') {
      if (!options.label) {
        _Logger.default.warn('A label input must have a "label" parameter', options);
      }

      return;
    }

    if (options.type === 'button') {
      if (!options.title && !options.icon) {
        _Logger.default.warn('A button input must have a "title" and/or an "icon" parameter', options);
      }

      if (!options.click && !options.href) {
        _Logger.default.warn('A button input must have a "click" and/or an "href" parameter', options);
      }

      return;
    }

    if (!options.name && !options.input) {
      _Logger.default.warn('Missing "name" or "input" parameters', options);
    }

    if (_underscoreWrapper.default.isArray(options.name) && _underscoreWrapper.default.isArray(options.input)) {
      throw new Error('Not allowed to have both "name" and "input" defined as array.');
    }

    if (options.type !== 'list' && options.name && model && model.allows) {
      var names = [];

      if (_underscoreWrapper.default.isArray(options.name)) {
        names = options.name;
      } else {
        names.push(options.name);
      }

      _underscoreWrapper.default.each(names, function (name) {
        if (!model.allows(name)) {
          throw new Error('field not allowed: ' + options.name);
        }
      });
    }

    if (_underscoreWrapper.default.isArray(options.input) && options.type !== 'list') {
      _underscoreWrapper.default.each(options.input, function (input) {
        validateInput(input, model);
      });
    }

    var keys = (0, _keys2.default)(_context12 = _underscoreWrapper.default).call(_context12, options);

    var intersection = _underscoreWrapper.default.intersection(keys, ALL_OPTIONS);

    if (_underscoreWrapper.default.size(intersection) !== _underscoreWrapper.default.size(options)) {
      var fields = _underscoreWrapper.default.clone(ALL_OPTIONS);

      fields.unshift(keys);

      _Logger.default.warn('Invalid input parameters', _underscoreWrapper.default.without.apply(null, fields), options);
    }
  }

  function generateInputOptions(options, form, createFn) {
    var _context14;

    options = _underscoreWrapper.default.clone(options);

    if (_underscoreWrapper.default.contains(['list', 'group'], options.type)) {
      var _context13;

      options.params = _underscoreWrapper.default.defaults({
        create: createFn,
        inputs: (0, _map.default)(_context13 = _underscoreWrapper.default).call(_context13, _underscoreWrapper.default.isArray(options.input) ? options.input : [options.input], function (input) {
          return _underscoreWrapper.default.first(generateInputOptions(input, form, createFn));
        })
      }, options.params || {});
      delete options.input;
    }

    var inputs = _underscoreWrapper.default.isArray(options.input) ? _underscoreWrapper.default.clone(options.input) : [options];
    return (0, _map.default)(_context14 = _underscoreWrapper.default).call(_context14, inputs, function (input) {
      var target = _underscoreWrapper.default.defaults({
        model: form.model
      }, input, _underscoreWrapper.default.omit(options, 'input', 'inputs'), form.options, {
        id: _underscoreWrapper.default.uniqueId('input'),
        readOnly: form.isReadOnly(),
        read: form.hasReadMode()
      });

      if (form.isReadOnly()) {
        target.read = target.readOnly = true;
      }

      return target;
    });
  }

  var _default = {
    LABEL_OPTIONS: LABEL_OPTIONS,
    CONTAINER_OPTIONS: CONTAINER_OPTIONS,
    WRAPPER_OPTIONS: WRAPPER_OPTIONS,
    INPUT_OPTIONS: INPUT_OPTIONS,
    generateInputOptions: generateInputOptions,
    changeEventString: function changeEventString(fieldNames) {
      return 'change:' + fieldNames.join(' change:');
    },
    createReadFormButton: function createReadFormButton(options) {
      var action;
      var text;
      var ariaLabel;

      if (options.type === 'cancel') {
        text = ariaLabel = _StringUtil.default.localize('oform.cancel', 'courage');

        action = function action() {
          this.model.trigger('form:cancel');
        };
      } else {
        text = _StringUtil.default.localize('oform.edit', 'courage');
        ariaLabel = text + ' ' + options.formTitle;

        action = function action() {
          this.model.set('__edit__', true);
        };
      }

      return _BaseView.default.extend({
        tagName: 'a',
        className: options.className,
        attributes: {
          href: '#',
          'aria-label': ariaLabel
        },
        // TODO: refactor to enforce precompiled templates OKTA-309852
        // eslint-disable-next-line @okta/okta-ui/no-bare-templates
        template: function template() {
          return _underscoreWrapper.default.escape(text);
        },
        events: {
          click: function click(e) {
            e.preventDefault();
            action.call(this);
          }
        }
      });
    },
    createButton: function createButton(options) {
      options = _underscoreWrapper.default.clone(options);

      switch (options.type) {
        case 'save':
          _underscoreWrapper.default.defaults(options, {
            className: 'button-primary'
          });

          break;

        case 'cancel':
          _underscoreWrapper.default.defaults(options, {
            className: 'button-clear',
            text: _StringUtil.default.localize('oform.cancel', 'courage'),
            action: function action() {
              this.model.trigger('form:cancel');
            }
          });

          break;

        case 'previous':
          _underscoreWrapper.default.defaults(options, {
            text: _StringUtil.default.localize('oform.previous', 'courage'),
            action: function action() {
              this.model.trigger('form:previous');
            }
          });

          break;
      }

      return _createButton(options);
    },
    validateInput: validateInput,

    /**
     * Applies a show-when logic on a view instance.
     * The show-when is a map of a model field name -> a boolean or a function that returns a boolean.
     * The view will toggle based on the field value.
     *
     * @param  {Okta.View} view a view instance that has a this.model attached to it
     * @param  {Object} showWhen
     */
    applyShowWhen: function applyShowWhen(view, showWhen) {
      var toggleAndResize = function toggleAndResize(bool) {
        return function () {
          // The `toggle` is here since an event may be triggered before the el is in the DOM
          // and in that case slide events may not function as expected.
          view.$el.toggle(bool);
          view.model.trigger('form:resize');
        };
      };

      _ViewUtil.default.applyDoWhen(view, decorateDoWhen(showWhen), function (bool, options) {
        if (!options.animate) {
          view.$el.toggle(bool);
        } else {
          view.$el['slide' + (bool ? 'Down' : 'Up')](200, toggleAndResize(bool));
        }
      });
    },
    applyToggleWhen: function applyToggleWhen(view, toggleWhen) {
      _ViewUtil.default.applyDoWhen(view, decorateDoWhen(toggleWhen), function (bool, options) {
        view.$el.toggle(bool);
        view.model.trigger('form:resize');

        if (options.animate) {
          view.render();
        }
      });
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(39));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Wrapper around the more generic {@link src/framework/Model} that
   * contains Okta-specific logic.
   * @class module:Okta.Model
   * @extends src/framework/Model
   */


  var _default = _Model.default.extend(
  /** @lends module:Okta.Model.prototype */
  {
    /**
     * Is the end point using the legacy "secureJSON" format
     * @type {Function|Boolean}
     */
    secureJSON: false,
    _builtInLocalProps: {
      __edit__: 'boolean',
      __pending__: 'boolean'
    },
    constructor: function constructor() {
      this.local = _underscoreWrapper.default.defaults({}, _underscoreWrapper.default.result(this, 'local'), this._builtInLocalProps);

      if (_underscoreWrapper.default.result(this, 'secureJSON')) {
        this.sync = _underscoreWrapper.default.wrap(this.sync, function (sync, method, model, options) {
          return sync.call(this, method, model, _underscoreWrapper.default.extend({
            dataType: 'secureJSON'
          }, options));
        });
      }

      _Model.default.apply(this, arguments);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 12 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(325);
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var loc = _StringUtil.default.localize;
  var SchemaUtils = {
    STRING: 'string',
    NUMBER: 'number',
    INTEGER: 'integer',
    BOOLEAN: 'boolean',
    OBJECT: 'object',
    FORMATDISPLAYTYPE: {
      'date-time': 'date',
      uri: 'uri',
      email: 'email',
      // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
      'country-code': 'country-code',
      'language-code': 'language-code',
      'country_code': 'country_code',
      'language_code': 'language_code',
      locale: 'locale',
      timezone: 'timezone',
      'ref-id': 'reference'
    },
    ARRAYDISPLAYTYPE: {
      arrayofobject: 'arrayofobject',
      arrayofstring: 'arrayofstring',
      arrayofnumber: 'arrayofnumber',
      arrayofinteger: 'arrayofinteger',
      'arrayofref-id': 'arrayofref-id'
    },
    DISPLAYTYPES: {
      date: {
        type: 'string',
        format: 'date-time'
      },
      uri: {
        type: 'string',
        format: 'uri'
      },
      email: {
        type: 'string',
        format: 'email'
      },
      // TODO: Resolve inconsistencies in hyphens vs. underscores for these properties (OKTA-202818)
      'country-code': {
        type: 'string',
        format: 'country-code'
      },
      'language-code': {
        type: 'string',
        format: 'language-code'
      },
      'country_code': {
        type: 'string'
      },
      'language_code': {
        type: 'string'
      },
      locale: {
        type: 'string',
        format: 'locale'
      },
      timezone: {
        type: 'string',
        format: 'timezone'
      },
      string: {
        type: 'string'
      },
      number: {
        type: 'number'
      },
      boolean: {
        type: 'boolean'
      },
      integer: {
        type: 'integer'
      },
      reference: {
        type: 'string',
        format: 'ref-id'
      },
      arrayofobject: {
        type: 'array',
        items: {
          type: 'object'
        }
      },
      arrayofstring: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      arrayofnumber: {
        type: 'array',
        items: {
          type: 'number'
        }
      },
      arrayofinteger: {
        type: 'array',
        items: {
          type: 'integer'
        }
      },
      'arrayofref-id': {
        type: 'array',
        items: {
          type: 'string',
          format: 'ref-id'
        }
      },
      image: {
        type: 'image'
      },
      password: {
        type: 'string'
      }
    },
    SUPPORTSMINMAX: ['string', 'number', 'integer', 'password'],
    SUPPORTENUM: ['string', 'number', 'integer', 'object', 'arrayofstring', 'arrayofnumber', 'arrayofinteger', 'arrayofobject'],
    DATATYPE: {
      string: 'string',
      number: 'number',
      boolean: 'boolean',
      integer: 'integer',
      date: 'datetime',
      object: 'object',
      arrayofobject: 'object array',
      arrayofstring: 'string array',
      arrayofnumber: 'number array',
      arrayofinteger: 'integer array',
      'arrayofref-id': 'reference array',
      // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
      'country-code': 'country code',
      'language-code': 'language code',
      'country_code': 'country code',
      'language_code': 'language code',
      reference: 'reference',
      timezone: 'timezone',
      image: 'image'
    },
    MUTABILITY: {
      READONLY: 'READ_ONLY',
      WRITEONLY: 'WRITE_ONLY',
      READWRITE: 'READ_WRITE',
      IMMUTABLE: 'IMMUTABLE'
    },
    SCOPE: {
      NONE: 'NONE',
      SELF: 'SELF',
      SYSTEM: 'SYSTEM'
    },
    DISPLAYSCOPE: {
      SELF: 'User personal',
      SYSTEM: 'System',
      NA: 'None'
    },
    UNION: {
      DISABLE: 'DISABLE',
      ENABLE: 'ENABLE'
    },
    UNION_OPTIONS: {
      DISABLE: loc('universal-directory.profiles.attribute.form.union.enable.display', 'courage'),
      ENABLE: loc('universal-directory.profiles.attribute.form.union.disable.display', 'courage')
    },
    PERMISSION: {
      HIDE: 'HIDE',
      READ_ONLY: 'READ_ONLY',
      WRITE_ONLY: 'WRITE_ONLY',
      READ_WRITE: 'READ_WRITE'
    },
    ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
      HIDE: loc('universal-directory.profiles.attribute.enduser.permission.hide', 'courage'),
      READ_ONLY: loc('universal-directory.profiles.attribute.enduser.permission.readonly', 'courage'),
      READ_WRITE: loc('universal-directory.profiles.attribute.enduser.permission.readwrite', 'courage')
    },
    ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
      INHERIT: loc('universal-directory.profiles.attribute.source.inherit', 'courage'),
      OKTA_MASTERED: loc('universal-directory.profiles.attribute.source.oktamastered', 'courage'),
      OVERRIDE: loc('universal-directory.profiles.attribute.source.override', 'courage')
    },
    USERNAMETYPE: {
      NONE: 'non-username',
      OKTA_TO_APP: 'okta-to-app-username',
      OKTA_TO_AD: 'okta-to-ad-username',
      APP_TO_OKTA: 'app-to-okta-username',
      IDP_TO_OKTA: 'idp-to-okta-username'
    },
    LOGINPATTERNFORMAT: {
      EMAIL: 'EMAIL',
      CUSTOM: 'CUSTOM',
      NONE: 'NONE'
    },
    UNIQUENESS: {
      NOT_UNIQUE: 'NOT_UNIQUE',
      PENDING_UNIQUENESS: 'PENDING_UNIQUENESS',
      UNIQUE_VALIDATED: 'UNIQUE_VALIDATED'
    },

    /*
     * Get a display string for a schema attribute type.
     * @param {String} type Type of an attribute
     * @param {String} format Format of an attribute
     * @param {String} itemType Item type of an attribute if an array
     * @param {String} defaultValue The default value if an attribute type is undefined
     * @return {String} the display value
     */
    getDisplayType: function getDisplayType(type, format, itemType, defaultValue) {
      var displayType; // type is undefined for
      // - an un-mapped source attribute from mapping
      // - an source attribute which is mapped to username target attribute

      if (type) {
        // format is only defined for complicated types (ex. reference, date time, array)
        // not for simple types (ex. string, integer, boolean)
        if (format) {
          displayType = this.FORMATDISPLAYTYPE[format];
        } else {
          // itemType is only defined for array type
          // to specify an array element type (ex. string, integer, number)
          displayType = itemType ? this.ARRAYDISPLAYTYPE[type + 'of' + itemType] : type;
        }
      }

      if (!displayType) {
        displayType = typeof defaultValue === 'undefined' ? '' : defaultValue;
      }

      return displayType;
    },

    /*
     * Get attribute mapping source attribute username type
     * @param {String} mappingDirection
     * @param {String} targetName The mapping target attribute name
     * @param {String} appName The app name that's mapped to/from Okta
     * @return {String} the source attribute username type value
     */
    getSourceUsernameType: function getSourceUsernameType(mappingDirection, targetName, appName) {
      var sourceUsernameType = this.USERNAMETYPE.NONE;
      /* eslint complexity: [2, 7] */

      if (mappingDirection === 'oktaToApp') {
        if (targetName === 'userName') {
          sourceUsernameType = this.USERNAMETYPE.OKTA_TO_APP;
        } else if (targetName === 'cn') {
          sourceUsernameType = this.USERNAMETYPE.OKTA_TO_AD;
        }
      } else if (mappingDirection === 'appToOkta' && targetName === 'login') {
        if (appName === 'saml_idp') {
          sourceUsernameType = this.USERNAMETYPE.IDP_TO_OKTA;
        } else {
          sourceUsernameType = this.USERNAMETYPE.APP_TO_OKTA;
        }
      }

      return sourceUsernameType;
    },
    isArrayDataType: function isArrayDataType(type) {
      var _context15;

      return _underscoreWrapper.default.contains((0, _values.default)(_context15 = _underscoreWrapper.default).call(_context15, this.ARRAYDISPLAYTYPE), type);
    },
    isObjectDataType: function isObjectDataType(type) {
      return this.DATATYPE.object === type;
    }
  };
  var _default = SchemaUtils;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CHILDREN = '__children__',
      RENDERED = '__rendered__',
      PARENT = '__parent__',
      CHILD_DEFINITIONS = '__children_definitions__',
      ADD_TO_CONTAINER = '__add_to_container__';

  function getIndex(container, view) {
    for (var i = 0; i < container[CHILDREN].length; i++) {
      if (view.cid === container[CHILDREN][i].cid) {
        return i;
      }
    }
  }

  function noop() {}

  function doRender(view) {
    view[RENDERED] = true;
    var html = view.renderTemplate(view.template);

    if (html) {
      view.$el.html(html);
    } else if (view.length) {
      view.$el.empty();
    }

    view.each(function (view) {
      view[ADD_TO_CONTAINER]();
    });
  }

  function subscribeEvents(view) {
    var isEventPropertyRe = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;

    _underscoreWrapper.default.each(_underscoreWrapper.default.allKeys(view), function (key) {
      var matchKeys = key.match(isEventPropertyRe);

      if (!matchKeys) {
        return;
      }

      var bindings = _underscoreWrapper.default.result(view, key),
          entity = view.options[matchKeys[1]] || view[matchKeys[1]];

      if (!entity || !_underscoreWrapper.default.isObject(bindings) || !_underscoreWrapper.default.isFunction(entity.trigger)) {
        return;
      }

      _underscoreWrapper.default.each(bindings, function (callback, event) {
        var _context16;

        var callbacks = _underscoreWrapper.default.isFunction(callback) ? [callback] : (0, _reduce.default)(_context16 = _underscoreWrapper.default).call(_context16, callback.split(/\s+/), function (arr, name) {
          if (_underscoreWrapper.default.isFunction(view[name])) {
            arr.push(view[name]);
          }

          return arr;
        }, []);

        _underscoreWrapper.default.each(callbacks, function (cb) {
          view.listenTo(entity, event, cb);
        });
      });
    });
  }
  /**
     * A View operates on a string template, an token based template, or a model based template, with a few added hooks.
     * It provides a collection of child views, when a child view could be a View or another View.
     * Conceptually, if we were in a file system, the View is a folder, when the concrete child views are files,
     * and the child Views are sub folders.
     *
     * *Technically, when using a View as a container, it could have its own concrete logic,
     * but conceptually we like to keep it separated so a view is either a concrete view or a collection of child views.*
     *
     * In addition to the standard backbone options, we added `settings` and `state` as first class options.
     * it will automatically assign `options` to `this.options` as an instance member.
     *
     * See [Backbone.View](http://backbonejs.org/#View).
     *
     * @class src/framework/View
     * @extends external:Backbone.View
     * @param {Object} [options] options hash
     * @example
     * var DocumentView = Archer.View.extend({
     *   template: [
     *     '<header></header>',
     *     '<article></article>',
     *     '<footer></footer>'
     *   ].join(''),
     *   children: [[HeaderView, 'header'], [ContentView, 'article'], [FooterView, 'footer']]
     * });
     */


  var View = _backbone.default.View.extend(
  /** @lends src/framework/View.prototype */
  {
    /**
       * An object listing events and callback bind to this.{entity}
       * @name *Events
       * @memberof src/framework/View
       * @type {(Object|Function)}
       * @instance
       * @example
       * var FooView = View.extend({
       *   modelEvents: {
       *     'change:name': 'render'
       *   }
       * })
       * //equivalent to ==>
       * var FooView = View.extend({
       *   initialize: function() {
       *     this.listenTo(this.model, 'change:name', this.render);
       *   }
       * });
       *
       *
       * //Multiple callbacks:
       * var FooView = View.extend({
       *   modelEvents: {
       *     'change:name': 'render foo'
       *   },
       *   foo: function() {}
       * });
       *
       * //Callbacks As Function:
       * var FooView = View.extend({
       *   stateEvents: {
       *     'change': function() {
       *   }
       * });
       *
       * //Event Configuration As Function
       * var FooView = View.extend({
       *   collectionEvents: function() {
       *     var events = { 'change:name deleteItem': 'render' };
       *     events['changeItem'] = 'spin';
       *     events['addItem'] = function() {};
       *     return events;
       *   }
       * });
       */
    constructor: function constructor(options) {
      /* eslint max-statements: [2, 17] */
      this.options = options || {};

      _underscoreWrapper.default.extend(this, _underscoreWrapper.default.pick(this.options, 'state', 'settings')); // init per-instance children collection


      this[CHILDREN] = [];
      this[RENDERED] = false;
      this[PARENT] = null;
      this[CHILD_DEFINITIONS] = this.children; // we want to make sure initialize is triggered *after* we append the views from the `this.views` array

      var initialize = this.initialize;
      this.initialize = noop;

      _backbone.default.View.apply(this, arguments);

      _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, CHILD_DEFINITIONS), function (childDefinition) {
        this.add.apply(this, _underscoreWrapper.default.isArray(childDefinition) ? childDefinition : [childDefinition]);
      }, this);

      delete this[CHILD_DEFINITIONS];

      if (this.autoRender && this.model) {
        var _context17;

        var event = _underscoreWrapper.default.isArray(this.autoRender) ? (0, _map.default)(_context17 = _underscoreWrapper.default).call(_context17, this.autoRender, function (field) {
          return 'change:' + field;
        }).join(' ') : 'change';
        this.listenTo(this.model, event, function () {
          this.render();
        });
      }

      this.initialize = initialize;
      this.initialize.apply(this, arguments);
      subscribeEvents(this);
    },

    /**
       * Unregister view from container
       * Note: this will not remove the view from the dom
       * and will not call the `remove` method on the view
       *
       * @param {src/framework/View} view the view to unregister
       * @private
       */
    unregister: function unregister(view) {
      this.stopListening(view);
      var viewIndex = getIndex(this, view); // viewIndex is undefined when the view is not found (may have been removed)
      // check if it is undefined to prevent unexpected thing to happen
      // array.splice(undefined, x) removes the first x element(s) from the array
      // this protects us against issues when calling `remove` on a child view multiple times

      if (_underscoreWrapper.default.isNumber(viewIndex)) {
        var _context18;

        (0, _splice.default)(_context18 = this[CHILDREN]).call(_context18, viewIndex, 1);
      }
    },

    /**
       * Should we auto render the view upon model change. Boolean or array of field names to listen to.
       * @type {Boolean|Array}
       * @deprecated Instead, please use modelEvents
       * @example
       * modelEvents: {
       *   change:name: 'render'
       * }
       */
    autoRender: false,

    /**
       *
       * When the template is an underscore template, the render method will pass the options has to the template
       * And the associated model, if exists, when it will prefer the model over the options in case of a conflict.
       * {@link #render View.render}
       * @type {(String|Function)}
       * @example
       * var View = View.extend({
       *   template: '<p class="name">{{name}}</p>'
       * };
       */
    template: null,

    /**
       * A list of child view definitions to be passed to {@link #add this.add()}.
       * Note: these definitions will be added **before** the {@link #constructor initiliaze} method invokes.
       * @type {(Array|Function)}
       * @example
       * var Container = View.extend({
       *    template: '<p class="content"></p>',
       *    children: [
       *      [ContentView, '.content'],
       *      [OtherContentView, '.content'],
       *      OtherView
       *    ]
       *  })
       *
       * var Container = View.extend({
       *    template: '<dov class="form-wrap"></div>',
       *    children: function () {
       *      return [
       *        [FormView, '.form-wrap', {options: {model: this.optiosn.otherModel}}]
       *      ]
       *    }
       *  })
       */
    children: [],

    /**
       * Add a child view to the container.
       * If the container is already rendered, will also render the view  and append it to the DOM.
       * Otherwise will render and append once the container is rendered.
       *
       * *We believe that for the sake of encapsulation, a view should control its own chilren, so we treat this method as
       * protected and even though technically you can call `view.add` externally we strongly discourage it.*
       *
       * @param {(src/framework/View|String)} view A class (or an instance which is discouraged) of a View - or an HTML
       * string/template
       * @param {String} [selector] selector in the view's template on which the view will be added to
       * @param {Object} [options]
       * @param {Boolean} [options.bubble=false] Bubble (proxy) events from this view up the chain
       * @param {Boolean} [options.prepend=false] Prepend the view instend of appending
       * @param {String} [options.selector] Selector in the view's template on which the view will be added to
       * @param {Object} [options.options] Extra options to pass to the child constructor
       * @protected
       * @returns {src/framework/View} - The instance of itself for the sake of chaining
       * @example
       * var Container = View.extend({
       *
       *   template: [
       *     '<h1></h1>',
       *     '<section></section>',
       *   ].join(''),
       *
       *   initalize: function () {
       *
       *     this.add(TitleView, 'h1'); // will be added to <h1>
       *
       *     this.add(ContentView1, 'section'); // will be added to <section>
       *
       *     this.add(ContentView2, 'section', {prepend: true}); // will be add into <section> **before** ContentView1
       *
       *     this.add(OtherView, {
       *       options: {
       *         model: new Model()
       *       }
       *     }); // will be added **after** the <section> element
       *
       *     this.add('<p class="name">some html</p>'); //=> "<p class="name">some html</p>"
       *     this.add('<p class="name">{{name}}</p>'); //=> "<p class="name">John Doe</p>"
       *     this.add('{{name}}') //=> "<div>John Doe</div>"
       *     this.add('<span>{{name}}</span> w00t') //=> "<div><span>John Doe</span> w00t</div>"
       *   }
       *
       * });
       *
       * var container - new View({name: 'John Doe'});
       */
    add: function add(view, selector, bubble, prepend, extraOptions) {
      /* eslint max-statements: [2, 29], complexity: [2, 12] */
      var options = {},
          args = _underscoreWrapper.default.toArray(arguments); // This will throw if a compiled template function is passed accidentally


      if (_underscoreWrapper.default.isFunction(view) && (!view.prototype || !view.prototype.render)) {
        throw new Error('Type passed to add() is not a View');
      }

      if (_underscoreWrapper.default.isObject(selector)) {
        options = selector;
        selector = options.selector;
        bubble = options.bubble;
        prepend = options.prepend;
        extraOptions = options.options;
      } else if (_underscoreWrapper.default.isObject(bubble)) {
        options = bubble;
        bubble = options.bubble;
        prepend = options.prepend;
        extraOptions = options.options;
      } // TODO: This will be deprecated at some point. Views should use precompiled templates


      if (_underscoreWrapper.default.isString(view)) {
        view = function (template) {
          return View.extend({
            constructor: function constructor() {
              try {
                var $el = _backbone.default.$(template);

                if ($el.length != 1) {
                  throw 'invalid Element';
                }

                var unescapingRexExp = /&(\w+|#x\d+);/g;
                var elementUnescapedOuterHTMLLength = $el.prop('outerHTML').replace(unescapingRexExp, ' ').length;
                var templateUnescapedLength = template.replace(unescapingRexExp, ' ').length;

                if (elementUnescapedOuterHTMLLength !== templateUnescapedLength) {
                  throw 'invalid Element';
                }

                this.template = $el.html(); // Template string will be compiled by handlebars

                this.el = $el.empty()[0];
              } catch (e) {
                // not a valid html tag.
                this.template = template;
              }

              View.apply(this, arguments);
            }
          });
        }(view);
      }

      if (view.prototype && view.prototype instanceof View) {
        /* eslint new-cap: 0 */
        var viewOptions = _underscoreWrapper.default.omit(_underscoreWrapper.default.extend({}, this.options, extraOptions), 'el');

        args[0] = new view(viewOptions);
        return this.add.apply(this, args);
      } // prevent dups


      if (_underscoreWrapper.default.isNumber(getIndex(this, view))) {
        throw new Error('Duplicate child');
      }

      view[PARENT] = this; // make the view responsible for adding itself to the parent:
      // * register the selector in the closure
      // * register a reference the parent in the closure

      view[ADD_TO_CONTAINER] = function (selector) {
        return function () {
          if (selector && view[PARENT].$(selector).length != 1) {
            throw new Error('Invalid selector: ' + selector);
          }

          var $el = selector ? this[PARENT].$(selector) : this[PARENT].$el;
          this.render(); // we need to delegate events in case
          // the view was added and removed before

          this.delegateEvents(); // this[PARENT].at(index).$el.before(this.el);

          prepend ? $el.prepend(this.el) : $el.append(this.el);
        };
      }.call(view, selector); // if flag to bubble events is set
      // proxy all child view events


      if (bubble) {
        this.listenTo(view, 'all', function () {
          this.trigger.apply(this, arguments);
        });
      } // add to the dom if `render` has been called


      if (this.rendered()) {
        view[ADD_TO_CONTAINER]();
      } // add view to child views collection


      this[CHILDREN].push(view);
      return this;
    },

    /**
       * Remove all children from container
       */
    removeChildren: function removeChildren() {
      this.each(function (view) {
        view.remove();
      });
      return this;
    },

    /**
       *  Removes a view from the DOM, and calls stopListening to remove any bound events that the view has listenTo'd.
       *  Also removes all childern of the view if any, and removes itself from its parent view(s)
       */
    remove: function remove() {
      this.removeChildren();

      if (this[PARENT]) {
        this[PARENT].unregister(this);
      }

      return _backbone.default.View.prototype.remove.apply(this, arguments);
    },

    /**
       * Compile the template to function you can apply tokens on on render time.
       * Uses the underscore tempalting engine by default
       * @protected
       * @param  {String} template
       * @return {Function} a compiled template
       */
    // TODO: This will be deprecated at some point. Views should use precompiled templates
    compileTemplate: function compileTemplate(template) {
      /* eslint  @okta/okta-ui/no-specific-methods: 0*/
      return _underscoreWrapper.default.template(template);
    },

    /**
       * Render a template with `this.model` and `this.options` as parameters
       * preferring the model over the options.
       *
       * @param  {(String|Function)} template The template to build
       * @return {String} An HTML string
       * @protected
       */
    renderTemplate: function renderTemplate(template) {
      if (_underscoreWrapper.default.isString(template)) {
        // TODO: This will be deprecated at some point. Views should use precompiled templates
        template = this.compileTemplate(template);
      }

      if (_underscoreWrapper.default.isFunction(template)) {
        return template(this.getTemplateData());
      }
    },

    /**
       * The data hash passed to the compiled template
       * @return {Object}
       * @protected
       */
    getTemplateData: function getTemplateData() {
      var modelData = this.model && this.model.toJSON({
        verbose: true
      }) || {};

      var options = _underscoreWrapper.default.omit(this.options, ['state', 'settings', 'model', 'collection']);

      return _underscoreWrapper.default.defaults({}, modelData, options);
    },

    /**
       * Renders the template to `$el` and append all children in order
       * {@link #template View.template}
       */
    render: function render() {
      this.preRender();
      doRender(this);
      this.postRender();
      return this;
    },

    /**
       * Pre render routine. Will be called right *before* the logic in {@link #render} is executed
       * @method
       */
    preRender: noop,

    /**
       * Post render routine. Will be called right *after* the logic in {@link #render} is executed
       * @method
       */
    postRender: noop,

    /**
       * Was this instance rendered
       */
    rendered: function rendered() {
      return this[RENDERED];
    },

    /**
       * Get all direct child views.
       * @returns {src/framework/View[]}
       * @example
       * var container = View.extend({
       *   children: [View1, View2]
       * }).render();
       * container.getChildren() //=> [view1, view2];
       */
    getChildren: function getChildren() {
      return this.toArray();
    },

    /**
       * Get a child by index
       * @param {number} index
       * @returns {src/framework/View} The child view
       */
    at: function at(index) {
      return this.getChildren()[index];
    },

    /**
       * Invokes a method on all children down the tree
       *
       * @param {String} method The method to invoke
       */
    invoke: function invoke(methodName) {
      var args = _underscoreWrapper.default.toArray(arguments);

      this.each(function (child) {
        // if child has children, bubble down the tree
        if (child.size()) {
          child.invoke.apply(child, args);
        } // run the function on the child


        if (_underscoreWrapper.default.isFunction(child[methodName])) {
          child[methodName].apply(child, (0, _slice.default)(args).call(args, 1));
        }
      });
      return this;
    }
  }); // Code borrowed from Backbone.js source
  // Underscore methods that we want to implement on the Container.


  var methods = ['each', 'map', 'reduce', 'reduceRight', 'find', 'filter', 'reject', 'every', 'some', 'contains', 'toArray', 'size', 'first', 'initial', 'rest', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf', 'isEmpty', 'chain', 'where', 'findWhere'];

  _underscoreWrapper.default.each(methods, function (method) {
    View.prototype[method] = function () {
      var args = _underscoreWrapper.default.toArray(arguments);

      args.unshift(_underscoreWrapper.default.toArray(this[CHILDREN]));
      return _underscoreWrapper.default[method].apply(_underscoreWrapper.default, args);
    };
  }, void 0);
  /**
     * See [_.each](http://underscorejs.org/#each)
     * @name each
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Object} [context]
     */

  /**
     * See [_.map](http://underscorejs.org/#map)
     * @name map
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Object} [context]
     */

  /**
     * See [_.reduce](http://underscorejs.org/#reduce)
     * @name reduce
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Mixed} memo
     * @param {Object} [context]
     */

  /**
     * See [_.reduceRight](http://underscorejs.org/#reduceRight)
     * @name reduceRight
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} iterator
     * @param {Mixed} memo
     * @param {Object} [context]
     */

  /**
     * See [_.find](http://underscorejs.org/#find)
     * @name find
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} predicate
     * @param {Object} [context]
     */

  /**
     * See [_.filter](http://underscorejs.org/#filter)
     * @name filter
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} predicate
     * @param {Object} [context]
     */

  /**
     * See [_.reject](http://underscorejs.org/#reject)
     * @name reject
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} predicate
     * @param {Object} [context]
     */

  /**
     * See [_.every](http://underscorejs.org/#every)
     * @name every
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} [predicate]
     * @param {Object} [context]
     */

  /**
     * See [_.some](http://underscorejs.org/#some)
     * @name some
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Function} [predicate]
     * @param {Object} [context]
     */

  /**
     * See [_.contains](http://underscorejs.org/#contains)
     * @name contains
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Mixed} value
     */

  /**
     * See [_.toArray](http://underscorejs.org/#toArray)
     * @name toArray
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.size](http://underscorejs.org/#size)
     * @name size
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.first](http://underscorejs.org/#first)
     * @name first
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [n]
     */

  /**
     * See [_.initial](http://underscorejs.org/#initial)
     * @name initial
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [n]
     */

  /**
     * See [_.last](http://underscorejs.org/#last)
     * @name last
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [n]
     */

  /**
     * See [_.rest](http://underscorejs.org/#rest)
     * @name rest
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Number} [index]
     */

  /**
     * See [_.without](http://underscorejs.org/#without)
     * @name without
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.indexOf](http://underscorejs.org/#indexOf)
     * @name indexOf
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Mixed} value
     * @param {Boolean} [isSorted]
     */

  /**
     * See [_.shuffle](http://underscorejs.org/#shuffle)
     * @name shuffle
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.shuffle](http://underscorejs.org/#lastIndexOf)
     * @name lastIndexOf
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Mixed} value
     * @param {Number} [fromIndex]
     */

  /**
     * See [_.isEmpty](http://underscorejs.org/#isEmpty)
     * @name isEmpty
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.chain](http://underscorejs.org/#chain)
     * @name chain
     * @memberof src/framework/View
     * @method
     * @instance
     */

  /**
     * See [_.where](http://underscorejs.org/#where)
     * @name where
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Object} properties
     */

  /**
     * See [_.findWhere](http://underscorejs.org/#findWhere)
     * @name findWhere
     * @memberof src/framework/View
     * @method
     * @instance
     * @param {Object} properties
     */


  var _default = View;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Collection = _interopRequireDefault(__webpack_require__(38));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Wrapper around the more generic {@link src/framework/Collection} that
   * contains Okta-specific logic.
   * @class module:Okta.Collection
   * @extends src/framework/Collection
   */


  var _default = _Collection.default.extend(
  /** @lends module:Okta.Collection.prototype */
  {
    /**
     * Is the end point using the legacy "secureJSON" format
     * @type {Function|Boolean}
     */
    secureJSON: false,
    constructor: function constructor() {
      if (_underscoreWrapper.default.result(this, 'secureJSON')) {
        this.sync = _underscoreWrapper.default.wrap(this.sync, function (sync, method, collection, options) {
          return sync.call(this, method, collection, _underscoreWrapper.default.extend({
            dataType: 'secureJSON'
          }, options));
        });
      }

      _Collection.default.apply(this, arguments);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var hasProps = function hasProps(model) {
    var _context19;

    var local = _underscoreWrapper.default.omit(model.local, (0, _keys2.default)(_context19 = _underscoreWrapper.default).call(_context19, model._builtInLocalProps));

    return _underscoreWrapper.default.size(model.props) + _underscoreWrapper.default.size(local) > 0;
  };
  /**
   * @class module:Okta.BaseModel
   * @extends module:Okta.Model
   * @deprecated Use {@link module:Okta.Model|Okta.Model} instead
   * @example
   * var Model = BaseModel.extend({
   *   defaults: {
   *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
   *       return fname + ' ' + lname;
   *     })
   *   }
   * });
   * var model = new Model({fname: 'Joe', lname: 'Doe'});
   * model.get('name'); //=> "Joe Doe"
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   *
   * model.set('__private__', 'private property');
   * model.get('__private__'); //=> "private property"
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   */


  var BaseModelBaseModel = _Model.default.extend(
  /** @lends module:Okta.BaseModel.prototype */
  {
    /**
     * @type {Boolean}
     */
    flat: false,
    constructor: function constructor() {
      _Model.default.apply(this, arguments);

      this.on('sync', this._setSynced);
    },
    allows: function allows() {
      if (hasProps(this)) {
        return _Model.default.prototype.allows.apply(this, arguments);
      } else {
        return true;
      }
    },
    // bw compatibility support for old computed properties
    set: function set(key, val) {
      var attrs;

      if (_typeof(key) === 'object') {
        attrs = key;
      } else {
        (attrs = {})[key] = val;
      } // computed properties


      (0, _underscoreWrapper.default)(attrs).each(function (fn, attr) {
        if (!fn || !_underscoreWrapper.default.isArray(fn.__attributes)) {
          return;
        }

        this.on('change:' + fn.__attributes.join(' change:'), function () {
          var val = this.get(attr);

          if (val !== this['__schema__'].computedProperties[attr]) {
            this['__schema__'].computedProperties[attr] = val;
            this.trigger('change:' + attr, val);
          }
        }, this);
      }, this);
      return _Model.default.prototype.set.apply(this, arguments);
    },

    /**
     * Get the current value of an attribute from the model. For example: `note.get("title")`
     *
     * See [Model.get](http://backbonejs.org/#Model-get)
     * @param {String} attribute
     * @return {Mixed} The value of the model attribute
     */
    get: function get() {
      var value = _Model.default.prototype.get.apply(this, arguments);

      if (_underscoreWrapper.default.isFunction(value)) {
        var _context20;

        return value.apply(this, (0, _map.default)(_context20 = _underscoreWrapper.default).call(_context20, value.__attributes || [], this.get, this));
      }

      return value;
    },

    /**
     * Return a shallow copy of the model's attributes for JSON stringification.
     * This can be used for persistence, serialization, or for augmentation before being sent to the server.
     * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
     *  but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
     *
     * ```javascript
     * var artist = new Model({
     *   firstName: "Wassily",
     *   lastName: "Kandinsky"
     * });
     *
     * artist.set({birthday: "December 16, 1866"});
     * alert(JSON.stringify(artist)); // {"firstName":"Wassily","lastName":"Kandinsky","birthday":"December 16, 1866"}
     * ```
     * See [Model.toJSON](http://backbonejs.org/#Model-toJSON)
     * @param  {Object} options
     * @return {Object}
     */
    toJSON: function toJSON(options) {
      options || (options = {});

      var res = _Model.default.prototype.toJSON.apply(this, arguments); // cleanup computed properties


      (0, _underscoreWrapper.default)(res).each(function (value, key) {
        if (typeof value === 'function') {
          if (options.verbose) {
            res[key] = this.get(key);
          } else {
            delete res[key];
          }
        }
      }, this); // cleanup private properties

      if (!options.verbose) {
        (0, _underscoreWrapper.default)(res).each(function (value, key) {
          if (/^__\w+__$/.test(key)) {
            delete res[key];
          }
        });
      }

      return res;
    },
    sanitizeAttributes: function sanitizeAttributes(attributes) {
      var attrs = {};

      _underscoreWrapper.default.each(attributes, function (value, key) {
        if (!_underscoreWrapper.default.isFunction(value)) {
          attrs[key] = value;
        }
      });

      return attrs;
    },
    reset: function reset(options) {
      this.clear(options);
      this.set(this.sanitizeAttributes(this.defaults), options);
    },
    clear: function clear(options) {
      var attrs = {};

      _underscoreWrapper.default.each(this.sanitizeAttributes(this.attributes), function (value, key) {
        attrs[key] = void 0;
      });

      return this.set(attrs, _underscoreWrapper.default.extend({}, options, {
        unset: true
      }));
    },

    /**
     * @private
     */
    _setSynced: function _setSynced(newModel) {
      this._syncedData = newModel && _underscoreWrapper.default.isFunction(newModel.toJSON) ? newModel.toJSON() : {};
    },

    /**
     * @private
     */
    _getSynced: function _getSynced() {
      return this._syncedData;
    },
    isSynced: function isSynced() {
      return _underscoreWrapper.default.isEqual(this._getSynced(), this.toJSON());
    }
  },
  /** @lends module:Okta.BaseModel.prototype */
  {
    /**
     * @static
     *
     * Example:
     *
     * ```javascript
     * var Model = BaseModel.extend({
     *   defaults: {
     *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
     *       return fname + ' ' + lname;
     *     })
     *   }
     * });
     * var model = new Model({fname: 'Joe', lname: 'Doe'});
     * model.get('name'); // Joe Doe
     * model.toJSON(); // {fname: 'Joe', lname: 'Doe'}
     * ```
     *
     * @param {Array} attributes - an array of the attribute names this method depends on
     * @param {Function} callback the function that computes the value of the property
     *
     * @deprecated Use {@link #derived} instead
     */
    ComputedProperty: function ComputedProperty() {
      var args = _underscoreWrapper.default.toArray(arguments);

      var fn = args.pop();
      fn.__attributes = args.pop();
      return fn;
    }
  });

  var _default = BaseModelBaseModel;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @class SettingsModel
   * @extends {Okta.Model}
   * @private
   */


  var _default = _Model.default.extend({
    local: function local() {
      var settings = window.okta && window.okta.settings || {};
      var theme = window.okta && window.okta.theme || '';
      return {
        orgId: ['string', false, settings.orgId],
        orgName: ['string', false, settings.orgName],
        serverStatus: ['string', false, settings.serverStatus],
        persona: ['string', false, settings.persona],
        isDeveloperConsole: ['boolean', false, settings.isDeveloperConsole],
        isPreview: ['boolean', false, settings.isPreview],
        permissions: ['array', true, settings.permissions || []],
        theme: ['string', false, theme]
      };
    },
    extraProperties: true,
    constructor: function constructor() {
      this.features = window._features || [];

      _Model.default.apply(this, arguments);
    },

    /**
     * Checks if the user have a feature flag enabled (Based of the org level feature flag)
     * @param  {String}  feature Feature name
     * @return {Boolean}
     */
    hasFeature: function hasFeature(feature) {
      return _underscoreWrapper.default.contains(this.features, feature);
    },

    /**
     * Checks if any of the given feature flags are enabled (Based of the org level feature flags)
     * @param  {Array}  featureArray Features names
     * @return {Boolean} true if any of the give features are enabled. False otherwise
     */
    hasAnyFeature: function hasAnyFeature(featureArray) {
      var _context21;

      return (0, _some.default)(_context21 = _underscoreWrapper.default).call(_context21, featureArray, this.hasFeature, this);
    },

    /**
     * Checks if the user have a specific permission (based on data passed from JSP)
     * @param  {String}  permission Permission name
     * @return {Boolean}
     */
    hasPermission: function hasPermission(permission) {
      return _underscoreWrapper.default.contains(this.get('permissions'), permission);
    },

    /**
     * Checks if the org has ds theme set
     * @return {Boolean}
     */
    isDsTheme: function isDsTheme() {
      return this.get('theme') === 'dstheme';
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseButtonLink = _interopRequireDefault(__webpack_require__(45));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint '@okta/okta-ui/no-deprecated-methods': [0, [{ name: 'BaseButtonLink.extend', use: 'Okta.createButton'}, ]] */

  /**
   * A factory method wrapper for {@link BaseButtonLink} creation
   * @class module:Okta.internal.util.ButtonFactory
   */


  function normalizeEvents(options) {
    var events = _underscoreWrapper.default.extend(options.click ? {
      click: options.click
    } : {}, options.events || {});

    var target = {};

    _underscoreWrapper.default.each(events, function (fn, eventName) {
      target[eventName] = function (e) {
        if (!options.href) {
          e.preventDefault();
          e.stopPropagation();
        }

        if (!(this.disabled && eventName === 'click')) {
          fn.apply(this, arguments);
        }
      };
    });

    return target;
  }

  var _default =
  /** @lends module:Okta.internal.util.ButtonFactory */
  {
    /**
     * Creates a {@link module:Okta.internal.views.components.BaseButtonLink|BaseButtonLink}.
     * @param  {Object} options Options hash
     * @param  {String} [options.title] The button text
     * @param  {String} [options.icon]
     * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
     * @param {String} [options.href] The button link
     * @param {Function} [options.click] On click callback
     * @param {Object} [options.events] a [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
     * @returns {module:Okta.internal.views.components.BaseButtonLink} BaseButtonLink prototype ("class")
     */
    create: function create(options) {
      options = _underscoreWrapper.default.clone(options);
      options.attrs = options.attributes;
      delete options.attributes;
      return _BaseButtonLink.default.extend(_underscoreWrapper.default.extend(options, {
        events: normalizeEvents(options)
      }));
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = {
    redirect: function redirect(url) {
      window.location = url;
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    constantError: function constantError(errorMessage) {
      return function () {
        throw new Error(errorMessage);
      };
    },

    /**
     * Simply convert an URL query key value pair object into an URL query string.
     * Remember NOT to escape the query string when using this util.
     * example:
     * input: {userId: 123, instanceId: undefined, expand: 'schema,app'}
     * output: '?userId=123&expand=schema,app'
     */
    getUrlQueryString: function getUrlQueryString(queries) {
      var _context22;

      _underscoreWrapper.default.isObject(queries) || (queries = {});

      var queriesString = _underscoreWrapper.default.without((0, _map.default)(_context22 = _underscoreWrapper.default).call(_context22, queries, function (value, key) {
        if (value !== undefined && value !== null) {
          return key + '=' + encodeURIComponent(value);
        }
      }), undefined).join('&');

      return _underscoreWrapper.default.isEmpty(queriesString) ? '' : '?' + queriesString;
    },
    isABaseView: function isABaseView(obj) {
      return obj instanceof _BaseView.default || obj.prototype instanceof _BaseView.default || obj === _BaseView.default;
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseCollection = _interopRequireDefault(__webpack_require__(15));

  var _BaseModel = _interopRequireDefault(__webpack_require__(16));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _EnumTypeHelper = _interopRequireDefault(__webpack_require__(21));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: [2, 16], complexity: [2, 8], max-params: [2, 8] */


  var loc = _StringUtil.default.localize;
  var STRING = _SchemaUtil.default.STRING;
  var NUMBER = _SchemaUtil.default.NUMBER;
  var INTEGER = _SchemaUtil.default.INTEGER;
  var OBJECT = _SchemaUtil.default.OBJECT;

  var getArrayTypeName = function getArrayTypeName(type, elementType) {
    return type + 'of' + elementType;
  };

  var SchemaPropertySubSchema = _BaseModel.default.extend({
    defaults: {
      description: undefined,
      minLength: undefined,
      maxLength: undefined,
      format: undefined
    },
    parse: function parse(resp) {
      if (_underscoreWrapper.default.isString(resp.format)) {
        var matcher = /^\/(.+)\/$/.exec(resp.format);

        if (matcher) {
          resp.format = matcher[1];
        }
      }

      return resp;
    }
  });

  var SchemaPropertySubSchemaCollection = _BaseCollection.default.extend({
    model: SchemaPropertySubSchema
  });

  var SchemaPropertySubSchemaAllOfCollection = SchemaPropertySubSchemaCollection.extend({
    _type: 'allOf'
  });
  var SchemaPropertySubSchemaOneOfCollection = SchemaPropertySubSchemaCollection.extend({
    _type: 'oneOf'
  });
  var SchemaPropertySubSchemaNoneOfCollection = SchemaPropertySubSchemaCollection.extend({
    _type: 'noneOf'
  });
  var constraintTypeErrorMessages = {
    string: loc('schema.validation.field.value.must.string', 'courage'),
    number: loc('schema.validation.field.value.must.number', 'courage'),
    integer: loc('schema.validation.field.value.must.integer', 'courage'),
    object: loc('schema.validation.field.value.must.object', 'courage')
  };
  var loginFormatNonePattern = '.+';
  var escapedLoginCharsRe = /[^a-zA-Z0-9-]/;

  var SchemaPropertySchemaProperty = _BaseModel.default.extend({
    constraintHandlers: {
      between: '_checkBetweenConstraints',
      greaterThan: '_checkGreaterThanConstraint',
      lessThan: '_checkLessThanConstraint',
      equals: '_checkEqualsConstraint'
    },
    idAttribute: 'name',
    local: {
      __oneOf__: {
        type: 'array',
        minItems: 1
      }
    },
    defaults: {
      // OKTA-28445, set empty string by default as the key for each property when syncing with server
      // so that server can respond with error when a name is not provided
      name: '',
      title: undefined,
      type: undefined,
      description: undefined,
      required: false,
      format: undefined,
      // choose disable option be default.
      union: undefined,
      subSchemas: undefined,
      settings: {
        permissions: {
          SELF: _SchemaUtil.default.PERMISSION.READ_ONLY
        }
      },
      unique: undefined,
      __metadata__: undefined,
      __isSensitive__: _BaseModel.default.ComputedProperty(['settings'], function (settings) {
        return !!(settings && settings.sensitive);
      }),
      __unique__: false,
      __isUniqueValidated__: _BaseModel.default.ComputedProperty(['unique'], function (unique) {
        return unique === _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED;
      }),
      __isPendingUniqueness__: _BaseModel.default.ComputedProperty(['unique'], function (unique) {
        return unique === _SchemaUtil.default.UNIQUENESS.PENDING_UNIQUENESS;
      }),
      __isUniqueness__: _BaseModel.default.ComputedProperty(['__isUniqueValidated__', '__isPendingUniqueness__'], function (isValidated, isPending) {
        return isValidated || isPending;
      }),
      __canBeSensitive__: _BaseModel.default.ComputedProperty(['__metadata__'], function (metadata) {
        return !!(metadata && metadata.sensitivizable);
      }),
      __userPermission__: _SchemaUtil.default.PERMISSION.READ_ONLY,
      __displayType__: undefined,
      __displayTypeLabel__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _SchemaUtil.default.DATATYPE[displayType] || displayType;
      }),
      __supportsMinMax__: false,
      // use the private naming convention for these computed properties,
      // to deal with the complexity in cloning schema with properties (toJSON({verbose: true})),
      // to make sure these attributes are being excluded from api request
      __isReadOnly__: _BaseModel.default.ComputedProperty(['mutability'], function (mutability) {
        return mutability === _SchemaUtil.default.MUTABILITY.READONLY;
      }),
      __isWriteOnly__: _BaseModel.default.ComputedProperty(['mutability'], function (mutability) {
        return mutability === _SchemaUtil.default.MUTABILITY.WRITEONLY;
      }),
      __displayScope__: undefined,
      __isScopeSelf__: _BaseModel.default.ComputedProperty(['scope'], function (scope) {
        return scope === _SchemaUtil.default.SCOPE.SELF;
      }),
      __isNoneScopeArrayType__: _BaseModel.default.ComputedProperty(['__isScopeSelf__', '__displayType__'], function (isScopeSelf, displayType) {
        return !isScopeSelf && _SchemaUtil.default.isArrayDataType(displayType);
      }),
      __isImported__: _BaseModel.default.ComputedProperty(['externalName'], function (externalName) {
        return !!externalName;
      }),
      __isFromBaseSchema__: _BaseModel.default.ComputedProperty(['__schemaMeta__'], function (schemaMeta) {
        return schemaMeta && schemaMeta.name === 'base';
      }),
      // Only UI can turn on __enumDefined__ and reprocess the enum/oneOf value; otherwise,
      // it should leave existing value untouch
      __enumDefined__: false,
      __supportEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains(_SchemaUtil.default.SUPPORTENUM, displayType);
      }),
      __isNumberTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.NUMBER, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofnumber], displayType);
      }),
      __isIntegerTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.INTEGER, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofinteger], displayType);
      }),
      __isObjectTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.OBJECT, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofobject], displayType);
      }),
      __isStringTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
        return _underscoreWrapper.default.contains([_SchemaUtil.default.STRING, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofstring], displayType);
      }),
      __enumConstraintType__: _BaseModel.default.ComputedProperty(['__isStringTypeEnum__', '__isNumberTypeEnum__', '__isIntegerTypeEnum__', '__isObjectTypeEnum__'], function (isStringType, isNumberType, isIntegerType, isObjectType) {
        if (isStringType) {
          return STRING;
        }

        if (isNumberType) {
          return NUMBER;
        }

        if (isIntegerType) {
          return INTEGER;
        }

        if (isObjectType) {
          return OBJECT;
        }
      }),
      __isEnumDefinedAndSupported__: _BaseModel.default.ComputedProperty(['__enumDefined__', '__supportEnum__'], function (enumDefined, supportEnum) {
        return enumDefined && supportEnum;
      }),
      __isLoginOfBaseSchema__: _BaseModel.default.ComputedProperty(['__isFromBaseSchema__', 'name'], function (isFromBaseSchema, name) {
        return isFromBaseSchema && name === 'login';
      }),
      __isLoginFormatRestrictionToEmail__: _BaseModel.default.ComputedProperty(['__loginFormatRestriction__'], function (loginFormatRestriction) {
        return loginFormatRestriction === _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL;
      })
    },
    initialize: function initialize() {
      _BaseModel.default.prototype.initialize.apply(this, arguments);

      this.listenTo(this, 'change:__displayType__', this._updateTypeFormatConstraints);
      this.listenTo(this, 'change:type change:format change:items', this._updateDisplayType);
      this.listenTo(this, 'change:__minVal__ change:__maxVal__', this._updateMinMax);
      this.listenTo(this, 'change:__equals__', this._convertEqualsToMinMax);
      this.listenTo(this, 'change:__constraint__', this._setConstraintText);

      this._setConstraintText();

      this._setLoginPattern();
    },
    parse: function parse(resp) {
      var _context23;

      /* eslint complexity: [2, 9] */
      resp = _underscoreWrapper.default.clone(resp);

      if (resp.type === 'object' && resp.extendedType === 'image') {
        resp.type = 'image';
      }

      resp['__displayType__'] = _SchemaUtil.default.getDisplayType(resp.type, resp.format, resp.items ? resp.items.format ? resp.items.format : resp.items.type : undefined);

      this._setRangeConstraints(resp);

      resp['__supportsMinMax__'] = (0, _indexOf.default)(_context23 = _SchemaUtil.default.SUPPORTSMINMAX).call(_context23, resp['__displayType__']) !== -1;
      resp['__displayScope__'] = _SchemaUtil.default.DISPLAYSCOPE[resp.scope] || _SchemaUtil.default.DISPLAYSCOPE.NA;

      if (resp.settings && resp.settings.permissions && resp.settings.permissions.SELF) {
        resp['__userPermission__'] = resp.settings.permissions.SELF;
      }

      this._setMasterOverride(resp);

      this._setSubSchemas(resp);

      this._setUniqueness(resp);

      return resp;
    },
    validate: function validate() {
      var enumValidationError = this._validateEnumOneOf();

      if (enumValidationError) {
        return enumValidationError;
      }

      if (!this.get('__supportsMinMax__') || !this.get('__constraint__')) {
        return undefined;
      }

      var constraitType = this.get('__constraint__');
      var constraitHandler = this[this.constraintHandlers[constraitType]];

      if (_underscoreWrapper.default.isFunction(constraitHandler)) {
        return constraitHandler.call(this);
      } else {
        _Logger.default.warn('No constraint handler found for: ' + constraitType);

        return undefined;
      }
    },
    _checkBetweenConstraints: function _checkBetweenConstraints() {
      var minVal = this.get('__minVal__');
      var maxVal = this.get('__maxVal__');

      if (!minVal && !maxVal) {
        return;
      }

      if (!minVal) {
        return {
          __minVal__: 'Min value is required'
        };
      }

      if (!maxVal) {
        return {
          __maxVal__: 'Max value is required'
        };
      }

      var val = this._checkIntegerConstraints('__minVal__', 'Min value');

      if (val) {
        return val;
      }

      val = this._checkIntegerConstraints('__maxVal__', 'Max value');

      if (val) {
        return val;
      }

      if (+minVal >= +maxVal) {
        return {
          __maxVal__: 'Max val must be greater than min val'
        };
      }
    },
    _checkGreaterThanConstraint: function _checkGreaterThanConstraint() {
      var minVal = this.get('__minVal__');

      if (!minVal) {
        return;
      }

      var val = this._checkIntegerConstraints('__minVal__', 'Min value');

      if (val) {
        return val;
      }
    },
    _checkLessThanConstraint: function _checkLessThanConstraint() {
      var maxVal = this.get('__maxVal__');

      if (!maxVal) {
        return;
      }

      var val = this._checkIntegerConstraints('__maxVal__', 'Max value');

      if (val) {
        return val;
      }
    },
    _checkEqualsConstraint: function _checkEqualsConstraint() {
      var equals = this.get('__equals__');

      if (!equals) {
        return;
      }

      var val = this._checkIntegerConstraints('__equals__', 'Constraint');

      if (val) {
        return val;
      }
    },
    _checkIntegerConstraints: function _checkIntegerConstraints(field, name) {
      var val = this.get(field);
      var error = {};

      if (isNaN(val)) {
        error[field] = name + ' must be a number';
        return error;
      }

      if (+val < 0) {
        error[field] = name + ' must be greater than 0';
        return error;
      }
    },
    _setMasterOverride: function _setMasterOverride(resp) {
      if (resp.settings && resp.settings.masterOverride && resp.settings.masterOverride) {
        var masterOverrideValue = resp.settings.masterOverride.value;

        if (_underscoreWrapper.default.isArray(masterOverrideValue) && !_underscoreWrapper.default.isEmpty(masterOverrideValue)) {
          resp['__masterOverrideType__'] = 'OVERRIDE';
          resp['__masterOverrideValue__'] = masterOverrideValue || [];
        } else {
          resp['__masterOverrideType__'] = resp.settings.masterOverride.type;
        }
      } else {
        resp['__masterOverrideType__'] = 'INHERIT';
      }
    },
    _setRangeConstraints: function _setRangeConstraints(resp) {
      /* eslint complexity: [2, 11] */
      if (resp['__displayType__'] === STRING) {
        resp['__minVal__'] = resp.minLength;
        resp['__maxVal__'] = resp.maxLength;
      } else if (resp['__displayType__'] === INTEGER || resp['__displayType__'] === NUMBER) {
        resp['__minVal__'] = resp.minimum;
        resp['__maxVal__'] = resp.maximum;
      }

      if (resp['__minVal__'] && resp['__maxVal__']) {
        if (resp['__minVal__'] === resp['__maxVal__']) {
          resp['__constraint__'] = 'equals';
          resp['__equals__'] = resp['__minVal__'];
        } else {
          resp['__constraint__'] = 'between';
        }
      } else if (!resp['__minVal__'] && resp['__maxVal__']) {
        resp['__constraint__'] = 'lessThan';
      } else if (!resp['__maxVal__'] && resp['__minVal__']) {
        resp['__constraint__'] = 'greaterThan';
      }
    },
    _setSubSchemas: function _setSubSchemas(resp) {
      if (resp.allOf) {
        resp['subSchemas'] = new SchemaPropertySubSchemaAllOfCollection(resp.allOf, {
          parse: true
        });
      } else if (resp.oneOf) {
        resp['subSchemas'] = new SchemaPropertySubSchemaOneOfCollection(resp.oneOf, {
          parse: true
        });
      } else if (resp.noneOf) {
        resp['subSchemas'] = new SchemaPropertySubSchemaNoneOfCollection(resp.noneOf, {
          parse: true
        });
      }
    },
    _setUniqueness: function _setUniqueness(resp) {
      var unique = resp && resp.unique;
      resp['__unique__'] = !!(unique && (unique === _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED || unique === _SchemaUtil.default.UNIQUENESS.PENDING_UNIQUENESS));
    },
    _setLoginPattern: function _setLoginPattern() {
      if (!this.get('__isLoginOfBaseSchema__')) {
        return;
      }

      var pattern = this.get('pattern');

      if (pattern === loginFormatNonePattern) {
        this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.NONE);
      } else if (pattern) {
        this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.CUSTOM);
        this.set('__loginFormatRestrictionCustom__', this._extractLoginPattern(pattern));
      } else {
        this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL);
      }
    },
    _updateDisplayType: function _updateDisplayType() {
      var type = this.get('type');

      if (type === STRING && this.get('format')) {
        this.set('__displayType__', _SchemaUtil.default.FORMATDISPLAYTYPE[this.get('format')]);
      } else {
        var items = this.get('items');
        var arraytype = items && (items.format ? items.format : items.type);

        if (type && arraytype) {
          this.set('__displayType__', _SchemaUtil.default.ARRAYDISPLAYTYPE[getArrayTypeName(type, arraytype)]);
        } else {
          this.set('__displayType__', type);
        }
      }
    },
    _validateEnumOneOf: function _validateEnumOneOf() {
      if (!this.get('__isEnumDefinedAndSupported__')) {
        return;
      }

      var enumOneOf = this.get('__oneOf__') || [];

      if (_underscoreWrapper.default.isEmpty(enumOneOf)) {
        return {
          __oneOf__: loc('model.validation.field.blank', 'courage')
        };
      }

      if (!this._isValidateOneOfConstraint(enumOneOf)) {
        var constraintType = this.get('__enumConstraintType__');
        var errorTypeMsg = constraintTypeErrorMessages[constraintType];
        return {
          __oneOf__: errorTypeMsg
        };
      }
    },
    _isValidateOneOfConstraint: function _isValidateOneOfConstraint(values) {
      var constraintType = this.get('__enumConstraintType__');
      return _underscoreWrapper.default.all(values, function (value) {
        return _EnumTypeHelper.default.isConstraintValueMatchType(value.const, constraintType);
      });
    },
    toJSON: function toJSON() {
      var json = _BaseModel.default.prototype.toJSON.apply(this, arguments);

      json.settings = {
        permissions: {}
      };
      json.settings.permissions['SELF'] = this.get('__userPermission__'); // omit "sensitive" filed will have default it value to false.

      if (this.get('__isSensitive__')) {
        json.settings.sensitive = this.get('__isSensitive__');
      }

      if (this.get('type') === 'image') {
        json.type = 'object';
        json.extendedType = 'image';
      }

      json = this._enumAssignment(json);
      json = this._attributeOverrideToJson(json);
      json = this._normalizeUnionValue(json);
      json = this._patternAssignment(json);
      json = this._uniquenessAssignment(json);
      return json;
    },
    _attributeOverrideToJson: function _attributeOverrideToJson(json) {
      var masterOverrideType = this.get('__masterOverrideType__');
      var masterOverrideValue = this.get('__masterOverrideValue__');

      if (masterOverrideType === 'OKTA_MASTERED') {
        json.settings.masterOverride = {
          type: 'OKTA_MASTERED'
        };
      } else if (masterOverrideType === 'OVERRIDE') {
        json.settings.masterOverride = {
          type: 'ORDERED_LIST',
          value: []
        };

        if (masterOverrideValue instanceof _BaseCollection.default) {
          _underscoreWrapper.default.each(masterOverrideValue.toJSON(), function (overrideProfile) {
            json.settings.masterOverride.value.push(overrideProfile.id);
          });
        } else if (masterOverrideValue instanceof Array) {
          json.settings.masterOverride.value = masterOverrideValue;
        }

        if (_underscoreWrapper.default.isEmpty(json.settings.masterOverride.value)) {
          delete json.settings.masterOverride;
        }
      }

      if (masterOverrideType === 'INHERIT') {
        delete json.settings.masterOverride;
      }

      return json;
    },

    /**
     * Only allow set "union" value when isScopeSelf is NONE and displayType is
     * array of (string/number/integer), otherwise reset to default.
     *
     * @see /universal-directory/shared/views/components/UnionGroupValuesRadio.js
     */
    _normalizeUnionValue: function _normalizeUnionValue(json) {
      if (!this.get('__isNoneScopeArrayType__')) {
        json['union'] = undefined;
      }

      return json;
    },
    _enumAssignment: function _enumAssignment(json) {
      if (!this.get('__isEnumDefinedAndSupported__')) {
        return json;
      } // backfill empty title by constraint


      var enumOneOf = this._getEnumOneOfWithTitleCheck();

      if (this.get('type') === 'array') {
        delete json.items.enum;
        json.items.oneOf = enumOneOf;
      } else {
        delete json.enum;
        json.oneOf = enumOneOf;
      }

      return json;
    },
    _patternAssignment: function _patternAssignment(json) {
      if (!this.get('__isLoginOfBaseSchema__') || !this.get('__loginFormatRestriction__')) {
        return json;
      }

      switch (this.get('__loginFormatRestriction__')) {
        case _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL:
          delete json.pattern;
          break;

        case _SchemaUtil.default.LOGINPATTERNFORMAT.CUSTOM:
          json.pattern = this._buildLoginPattern(this.get('__loginFormatRestrictionCustom__'));
          break;

        case _SchemaUtil.default.LOGINPATTERNFORMAT.NONE:
          json.pattern = loginFormatNonePattern;
          break;
      }

      return json;
    },
    _uniquenessAssignment: function _uniquenessAssignment(json) {
      if (!this.get('__unique__')) {
        delete json.unique;
      } else if (!this.get('__isUniqueness__')) {
        json.unique = _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED;
      }

      return json;
    },

    /**
     * Character should be escaped except letters, digits and hyphen
     */
    _escapedRegexChar: function _escapedRegexChar(pattern, index) {
      var char = pattern.charAt(index);

      if (escapedLoginCharsRe.test(char)) {
        return '\\' + char;
      }

      return char;
    },
    _buildLoginPattern: function _buildLoginPattern(pattern) {
      var result = '';

      for (var i = 0; i < pattern.length; i++) {
        result = result + this._escapedRegexChar(pattern, i);
      }

      return '[' + result + ']+';
    },
    _extractLoginPattern: function _extractLoginPattern(pattern) {
      var re = /^\[(.*)\]\+/;
      var matches = pattern.match(re);
      return matches ? matches[1].replace(/\\(.)/g, '$1') : pattern;
    },
    _getEnumOneOfWithTitleCheck: function _getEnumOneOfWithTitleCheck() {
      var _context24;

      var enumOneOf = this.get('__oneOf__');
      return (0, _map.default)(_context24 = _underscoreWrapper.default).call(_context24, enumOneOf, function (value) {
        var _context25;

        if ((0, _trim.default)(_context25 = _jqueryWrapper.default).call(_context25, value.title) !== '') {
          return value;
        }

        value.title = !_underscoreWrapper.default.isString(value.const) ? (0, _stringify.default)(value.const) : value.const;
        return value;
      });
    },
    _updateTypeFormatConstraints: function _updateTypeFormatConstraints() {
      var _context26;

      var displayType = this.get('__displayType__'); // OKTA-31952 reset format according to its displayType

      this.unset('format', {
        silent: true
      });
      this.unset('items', {
        silent: true
      });
      this.set(_SchemaUtil.default.DISPLAYTYPES[displayType]);

      if (displayType !== NUMBER && displayType !== INTEGER) {
        this.unset('minimum');
        this.unset('maximum');
      }

      if (displayType !== STRING) {
        this.unset('minLength');
        this.unset('maxLength');
      }

      this.unset('__minVal__');
      this.unset('__maxVal__');
      this.unset('__equals__');
      this.set('__supportsMinMax__', (0, _indexOf.default)(_context26 = _SchemaUtil.default.SUPPORTSMINMAX).call(_context26, this.get('__displayType__')) !== -1);
    },
    _updateMinMax: function _updateMinMax() {
      var min;
      var max;
      var displayType = this.get('__displayType__');

      if (displayType === STRING) {
        min = 'minLength';
        max = 'maxLength';
      } else if (displayType === INTEGER || displayType === NUMBER) {
        min = 'minimum';
        max = 'maximum';
      }

      if (this.get('__minVal__')) {
        this.set(min, (0, _parseInt3.default)(this.get('__minVal__'), 10));
      } else {
        this.unset(min);
      }

      if (this.get('__maxVal__')) {
        this.set(max, (0, _parseInt3.default)(this.get('__maxVal__'), 10));
      } else {
        this.unset(max);
      }
    },
    _convertEqualsToMinMax: function _convertEqualsToMinMax() {
      var equals = this.get('__equals__');

      if (equals) {
        this.set('__minVal__', equals);
        this.set('__maxVal__', equals);
      }
    },

    /*
     Normally we would use a derived property here but derived properties do not work with the model Clone function
     so we use this workaround instead.
     */
    _setConstraintText: function _setConstraintText() {
      var constraint = this.get('__constraint__');
      var min = this.get('__minVal__');
      var max = this.get('__maxVal__');
      var equals = this.get('__equals__');

      switch (constraint) {
        case 'between':
          this.set('__constraintText__', 'Between ' + min + ' and ' + max);
          break;

        case 'greaterThan':
          this.set('__constraintText__', 'Greater than ' + min);
          break;

        case 'lessThan':
          this.set('__constraintText__', 'Less than ' + max);
          break;

        case 'equals':
          this.set('__constraintText__', 'Equals ' + equals);
          break;

        default:
          this.set('__constraintText__', '');
          break;
      }
    },
    cleanup: function cleanup() {
      if (this.get('__constraint__') === 'lessThan') {
        this.unset('__minVal__');
      } else if (this.get('__constraint__') === 'greaterThan') {
        this.unset('__maxVal__');
      }

      if (this.get('scope') !== _SchemaUtil.default.SCOPE.SYSTEM) {
        if (this.get('__isScopeSelf__') === true) {
          this.set({
            scope: _SchemaUtil.default.SCOPE.SELF
          }, {
            silent: true
          });
        } else {
          this.unset('scope');
        }
      }

      if (!this.get('__unique__')) {
        this.unset('unique');
      }
    },

    /**
     * Since there is not an dedicated attribute to flag enum type,
     * use enum values to determine whether the property is enum type or not.
     */
    isEnumType: function isEnumType() {
      return !!this.getEnumValues();
    },
    getEnumValues: function getEnumValues() {
      return this.get('oneOf') || this.get('enum') || this.get('items') && this.get('items')['oneOf'] || this.get('items') && this.get('items')['enum'];
    },
    detectHasEnumDefined: function detectHasEnumDefined() {
      var enumValues = this.getEnumValues();

      if (!enumValues) {
        return;
      }

      this.set('__oneOf__', _EnumTypeHelper.default.convertToOneOf(enumValues));
      this.set('__enumDefined__', true);
    }
  });

  var SchemaPropertySchemaProperties = _BaseCollection.default.extend({
    model: SchemaPropertySchemaProperty,
    clone: function clone() {
      return new this.constructor(this.toJSON({
        verbose: true
      }), {
        parse: true
      });
    },
    areAllReadOnly: function areAllReadOnly() {
      return _underscoreWrapper.default.all(this.pluck('__isReadOnly__'));
    },
    createModelProperties: function createModelProperties() {
      var _context27;

      return (0, _reduce.default)(_context27 = this).call(_context27, function (p, schemaProperty) {
        var _context28;

        var type = schemaProperty.get('type');
        p[schemaProperty.id] = _underscoreWrapper.default.clone(_SchemaUtil.default.DISPLAYTYPES[type]);

        if ((0, _indexOf.default)(_context28 = _SchemaUtil.default.SUPPORTSMINMAX).call(_context28, type) !== -1) {
          p[schemaProperty.id].minLength = schemaProperty.get('minLength');
          p[schemaProperty.id].maxLength = schemaProperty.get('maxLength');
        }

        if (type === 'string') {
          p[schemaProperty.id].format = schemaProperty.get('format');
        }

        return p;
      }, {});
    }
  });

  var _default = {
    Model: SchemaPropertySchemaProperty,
    Collection: SchemaPropertySchemaProperties
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: 0 */


  var NAME = 'name';
  var ENUM_KEY_PREFIX = '_enum_';
  /**
   * Generate Input Options in order to create an input in an Form for Enum type attribute.
   * @param {Object} config informations for creating input options
   *   config.name        schema property name
   *   config.title       schema property title
   *   config.readOnly    create an read only input?
   *   config.explain     sub-title to the input
   *   config.enumValues  list of enum values for creating input options (Dropdown/SimpleCheckBoxSet)
   *   config.displayType display type of schema property
   *
   * @return {Object} inputOptions options for create an Input view. (Dropdown/SimpleCheckBoxSet)
   *
   */

  function getEnumInputOptions(config) {
    var enumOneOf = convertToOneOf(config.enumValues);
    var inputOptions = {
      name: config.name,
      label: config.title,
      readOnly: config.readOnly,
      customExplain: config.explain,
      params: {
        enumOneOf: enumOneOf
      },
      options: getDropdownOptionsFromOneOf(enumOneOf)
    }; // input type

    if (_SchemaUtil.default.isArrayDataType(config.displayType)) {
      inputOptions.type = 'checkboxset';
      inputOptions.to = valuesToEnumObjects;
      inputOptions.from = enumObjectsToValues;
    } else {
      inputOptions.type = 'select';
      inputOptions.to = valueToEnumObject;
      inputOptions.from = enumObjectToValue;
    }

    inputOptions.input = null;
    return inputOptions;
  }

  function getDropdownOptions(values) {
    return _underscoreWrapper.default.isArray(values) ? getDropdownOptionsFromOneOf(convertToOneOf(values)) : {};
  }

  function getDropdownOptionsFromOneOf(values) {
    var _context29;

    if (!isOneOfEnumObject(values)) {
      return {};
    }

    return (0, _reduce.default)(_context29 = _underscoreWrapper.default).call(_context29, values, function (options, value, index) {
      options[convertIndexToEnumIndex(index)] = value.title;
      return options;
    }, {});
  }

  function convertToOneOf(values) {
    // assume this is a legacy enum array and convert to oneOf object
    if (!_underscoreWrapper.default.all(values, _jqueryWrapper.default.isPlainObject)) {
      return convertEnumToOneOf(values); // we assume object without const and title is an enum object which need special conversion
    } else if (!isOneOfEnumObject(values)) {
      return convertEnumObjectToOneOf(values);
    }

    return values;
  }

  function isOneOfEnumObject(values) {
    return _underscoreWrapper.default.isArray(values) && _underscoreWrapper.default.all(values, function (value) {
      return _underscoreWrapper.default.has(value, 'const') && _underscoreWrapper.default.has(value, 'title');
    });
  }

  function convertEnumToOneOf(values) {
    var _context30;

    return (0, _map.default)(_context30 = _underscoreWrapper.default).call(_context30, values, function (value) {
      return {
        const: value,
        title: valueToTitle(value)
      };
    });
  }

  function valueToTitle(value) {
    if (_underscoreWrapper.default.isObject(value)) {
      return (0, _stringify.default)(value);
    }

    if (_underscoreWrapper.default.isNumber(value)) {
      return value + '';
    }

    return value;
  }

  function convertEnumObjectToOneOf(values) {
    var findKey = _underscoreWrapper.default.partial(_underscoreWrapper.default.has, _underscoreWrapper.default, NAME); // If all object found the key NAME, use the NAME's value as display name


    if (_underscoreWrapper.default.all(values, findKey)) {
      var _context31, _context32;

      return (0, _map.default)(_context31 = (0, _filter.default)(_context32 = _underscoreWrapper.default.chain(values)).call(_context32, function (value) {
        return _jqueryWrapper.default.isPlainObject(value) && _underscoreWrapper.default.has(value, NAME);
      })).call(_context31, function (value) {
        return {
          const: value,
          title: value[NAME]
        };
      }).value();
    } // Assume a legacy object array does not need special handling and just convert to const/title enum


    return convertEnumToOneOf(values);
  }

  function convertIndexToEnumIndex(index) {
    var _context33;

    return (0, _concat.default)(_context33 = "".concat(ENUM_KEY_PREFIX)).call(_context33, index);
  }

  function enumObjectToValue(obj) {
    var _context34;

    var index = (0, _findIndex.default)(_context34 = _underscoreWrapper.default).call(_context34, this.options.params.enumOneOf, function (oneOfObj) {
      return _underscoreWrapper.default.isObject(obj) ? _underscoreWrapper.default.isEqual(oneOfObj.const, obj) : oneOfObj.const === obj;
    }); // Cannot rely on comparator in findIndex when compare objects so need special handling

    return index > -1 ? convertIndexToEnumIndex(index) : obj;
  }

  function valueToEnumObject(val) {
    if (!_underscoreWrapper.default.isString(val) || (0, _indexOf.default)(val).call(val, ENUM_KEY_PREFIX) !== 0) {
      return val;
    }

    var index = val.replace(ENUM_KEY_PREFIX, '');
    var enumValue = this.options.params && _underscoreWrapper.default.isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[index] : null; // @see `getEnumInputOptions` how enumValues has been set.

    return _underscoreWrapper.default.has(enumValue, 'const') ? enumValue.const : enumValue;
  }

  function valuesToEnumObjects(values) {
    var _context35;

    return (0, _map.default)(_context35 = _underscoreWrapper.default).call(_context35, values, (0, _bind.default)(valueToEnumObject).call(valueToEnumObject, this));
  }

  function enumObjectsToValues(values) {
    var _context36;

    return (0, _map.default)(_context36 = _underscoreWrapper.default).call(_context36, values, (0, _bind.default)(enumObjectToValue).call(enumObjectToValue, this));
  }

  function isStringConstraint(value) {
    var _context37;

    return _underscoreWrapper.default.isString(value) && (0, _trim.default)(_context37 = _jqueryWrapper.default).call(_context37, value) !== '';
  }

  function isNumberConstraint(value) {
    var _context38;

    return _underscoreWrapper.default.isNumber(value) || _underscoreWrapper.default.isNumber(_StringUtil.default.parseFloat((0, _trim.default)(_context38 = _jqueryWrapper.default).call(_context38, value)));
  }

  function isIntegerConstraint(value) {
    var _context39;

    var integer = _underscoreWrapper.default.isNumber(value) ? value : _StringUtil.default.parseInt((0, _trim.default)(_context39 = _jqueryWrapper.default).call(_context39, value));
    return typeof integer === 'number' && isFinite(integer) && Math.floor(integer) === integer;
  }

  function isObjectConstraint(value) {
    var _context40;

    if (_underscoreWrapper.default.isObject(value) && !_underscoreWrapper.default.isArray(value)) {
      return true;
    }

    var object = _StringUtil.default.parseObject((0, _trim.default)(_context40 = _jqueryWrapper.default).call(_context40, value));

    return _underscoreWrapper.default.isObject(object) && !_underscoreWrapper.default.isArray(object);
  }

  function isConstraintValueMatchType(value, type) {
    switch (type) {
      case _SchemaUtil.default.STRING:
        return isStringConstraint(value);

      case _SchemaUtil.default.NUMBER:
        return isNumberConstraint(value);

      case _SchemaUtil.default.INTEGER:
        return isIntegerConstraint(value);

      case _SchemaUtil.default.OBJECT:
        return isObjectConstraint(value);
    }
  }

  var _default = {
    getEnumInputOptions: getEnumInputOptions,
    getDropdownOptions: getDropdownOptions,
    convertToOneOf: convertToOneOf,
    isConstraintValueMatchType: isConstraintValueMatchType
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _SettingsModel = _interopRequireDefault(__webpack_require__(17));

  var _ConfirmationDialog = _interopRequireDefault(__webpack_require__(23));

  var _Notification = _interopRequireDefault(__webpack_require__(24));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-len: [2, 150], max-params: [2, 7] */


  function getRoute(router, route) {
    var root = _underscoreWrapper.default.result(router, 'root') || '';

    if (root && _underscoreWrapper.default.isString(route)) {
      return [root, route].join('/').replace(/\/{2,}/g, '/');
    }

    return route;
  }
  /**
   * BaseRouter is a standard [Backbone.Router](http://backbonejs.org/#Router)
   * with a few additions:
   * - Explicit mapping between routes and controllers
   * - Support for rendering notification and confirmation dialogs
   *
   * Checkout the [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World)
   * for a step-by-step guide to using this.
   *
   * @class module:Okta.Router
   * @extends external:Backbone.Router
   * @param {Object} options options hash
   * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
   */


  var _default = _backbone.default.Router.extend(
  /** @lends module:Okta.Router.prototype */
  {
    /**
     * The root URL for the router. When setting {@link http://backbonejs.org/#Router-routes|routes},
     * it will be prepended to each route.
     * @type {String|Function}
     */
    root: '',
    listen: _Notification.default.prototype.listen,
    constructor: function constructor(options) {
      options || (options = {});
      this.el = options.el;
      this.settings = new _SettingsModel.default(_underscoreWrapper.default.omit(options, 'el'));

      if (options.root) {
        this.root = options.root;
      }

      _backbone.default.Router.apply(this, arguments);

      this.listen('notification', this._notify);
      this.listen('confirmation', this._confirm);
    },

    /**
     * Fires up a confirmation dialog
     *
     * @param  {Object} options Options Hash
     * @param  {String} options.title The title
     * @param  {Array<string>} buttonOrder The order of the buttons
     * @param  {String} options.subtitle The explain text
     * @param  {String} options.save The text for the save button
     * @param  {Function} options.ok The callback function to run when hitting "OK"
     * @param  {String} options.cancel The text for the cancel button
     * @param  {Function} options.cancelFn The callback function to run when hitting "Cancel"
     * @param  {Boolean} options.noCancelButton Don't render the cancel button (useful for alert dialogs)
     * @param  {Boolean} options.noSubmitButton Don't render the primary button (useful for alert dialogs)
     * @private
     *
     * @return {Okta.View} the dialog view
     */
    _confirm: function _confirm(options) {
      options || (options = {});

      var Dialog = _ConfirmationDialog.default.extend(_underscoreWrapper.default.pick(options, 'title', 'subtitle', 'save', 'ok', 'cancel', 'cancelFn', 'noCancelButton', 'noSubmitButton', 'content', 'danger', 'type', 'closeOnOverlayClick', 'buttonOrder'));

      var dialog = new Dialog({
        model: this.settings
      }); // The model is here because itsa part of the BaseForm paradigm.
      // It will be ignored in the context of a confirmation dialog.

      dialog.render();
      return dialog; // test hook
    },

    /**
     * Fires up a notification banner
     *
     * @param  {Object} options Options Hash
     * @return {Okta.View} the notification view
     * @private
     */
    _notify: function _notify(options) {
      var notification = new _Notification.default(options);
      (0, _jqueryWrapper.default)('#content').prepend(notification.render().el);
      return notification; // test hook
    },

    /**
     * Renders a Controller
     * This will initialize new instance of a controller and call render on it
     *
     * @param  {Okta.Controller} Controller The controller Class we which to render
     * @param  {Object} [options] Extra options to the controller constructor
     */
    render: function render(Controller, options) {
      this.unload();
      options = _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this, 'settings', 'el'), options || {});
      this.controller = new Controller(options);
      this.controller.render();
    },

    /**
     * Starts the backbone history object
     *
     * Waits for the dom to be ready before calling `Backbone.history.start()` (IE issue).
     *
     * See [Backbone History](http://backbonejs.org/#History) for more information.
     */
    start: function start() {
      var args = arguments;
      (0, _jqueryWrapper.default)(function () {
        if (_backbone.default.History.started) {
          _Logger.default.error('History has already been started');

          return;
        }

        _backbone.default.history.start.apply(_backbone.default.history, args);
      });
    },

    /**
     * Removes active controller and frees up event listeners
     */
    unload: function unload() {
      if (this.controller) {
        this.stopListening(this.controller);
        this.stopListening(this.controller.state);
        this.controller.remove();
      }
    },
    route: function route(_route, name, callback) {
      return _backbone.default.Router.prototype.route.call(this, getRoute(this, _route), name, callback);
    },
    navigate: function navigate(fragment, options) {
      return _backbone.default.Router.prototype.navigate.call(this, getRoute(this, fragment), options);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_RESULT__; // TODO: maybe replaced by
  // https://github.com/Calvein/empty-module
  // https://github.com/crimx/empty-module-loader


  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var defaults = {
    level: 'success',
    message: 'Great Success!',
    hide: true,
    fade: 400,
    delay: 3000,
    width: 0,
    dismissable: false
  };

  var _default = _BaseView.default.extend({
    className: 'infobox infobox-confirm infobox-confirm-fixed',
    events: {
      'click .infobox-dismiss-link': function clickInfoboxDismissLink(e) {
        e.preventDefault();
        this.fadeOut();
      }
    },
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a class=\"infobox-dismiss-link\" title=\"" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "courage",
            "code": "component.dismiss"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 58
            },
            "end": {
              "line": 1,
              "column": 108
            }
          }
        })) + "\" href=\"#\"><span class=\"dismiss-icon\"></span></a>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "title",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 220
            },
            "end": {
              "line": 1,
              "column": 229
            }
          }
        }) : helper)) + "</h3>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissable") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 164
            }
          }
        })) != null ? stack1 : "") + "<span class=\"icon " + alias4((helper = (helper = lookupProperty(helpers, "level") || (depth0 != null ? lookupProperty(depth0, "level") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "level",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 182
            },
            "end": {
              "line": 1,
              "column": 191
            }
          }
        }) : helper)) + "-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 203
            },
            "end": {
              "line": 1,
              "column": 241
            }
          }
        })) != null ? stack1 : "") + "<p>" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "message",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 244
            },
            "end": {
              "line": 1,
              "column": 255
            }
          }
        }) : helper)) + "</p>";
      },
      "useData": true
    }),
    initialize: function initialize() {
      this.options = _underscoreWrapper.default.defaults({}, this.options, defaults);
      this.$el.addClass('infobox-' + this.options.level);

      if (this.options.width) {
        this.$el.width(this.options.width);
      }
    },
    getTemplateData: function getTemplateData() {
      return _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this.options, 'level', 'message', 'title'), {
        dismissable: this.options.hide === false || this.options.dismissable === true
      });
    },
    postRender: function postRender() {
      if (this.options.hide) {
        var _context41;

        _underscoreWrapper.default.delay((0, _bind.default)(_context41 = _underscoreWrapper.default).call(_context41, this.fadeOut, this), this.options.delay);
      }
    },
    fadeOut: function fadeOut() {
      var _context42;

      this.$el.fadeOut(this.options.fade, (0, _bind.default)(_context42 = _underscoreWrapper.default).call(_context42, this.remove, this));
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function changeEventString(doWhen) {
    var _context43;

    return 'change:' + (0, _keys2.default)(_context43 = _underscoreWrapper.default).call(_context43, doWhen).join(' change:');
  }

  function calcDoWhen(value, key) {
    var modelValue = this.model.get(key);

    if (_underscoreWrapper.default.isFunction(value)) {
      return value.call(this, modelValue);
    } else {
      return value === modelValue;
    }
  }

  function _doWhen(view, doWhen, fn) {
    var _context44;

    var toggle = (0, _bind.default)(_context44 = _underscoreWrapper.default).call(_context44, fn, view, view, doWhen);
    view.render = _underscoreWrapper.default.wrap(view.render, function (render) {
      var val = render.call(view);
      toggle({
        animate: false
      });
      return val;
    });
    view.listenTo(view.model, changeEventString(doWhen), function () {
      toggle({
        animate: true
      });
    });
  }

  var _default = {
    applyDoWhen: function applyDoWhen(view, doWhen, fn) {
      if (!(view.model && _underscoreWrapper.default.isObject(doWhen) && _underscoreWrapper.default.size(doWhen) && _underscoreWrapper.default.isFunction(fn))) {
        return;
      }

      _doWhen(view, doWhen, function (view, doWhen, options) {
        var _context45, _context46;

        var result = (0, _every.default)(_context45 = _underscoreWrapper.default).call(_context45, (0, _map.default)(_context46 = _underscoreWrapper.default).call(_context46, doWhen, calcDoWhen, view));
        fn.call(view, result, options);
      });
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function Class(options) {
    this.options = _underscoreWrapper.default.clone(options || {});
    this.cid = _underscoreWrapper.default.uniqueId('class');
    this.initialize.apply(this, arguments);
  }

  _underscoreWrapper.default.extend(Class.prototype, _backbone.default.Events, {
    initialize: function initialize() {}
  });

  Class.extend = _backbone.default.Model.extend;
  var _default = Class;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 27 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseView.default.extend({
    className: 'o-form-button-bar',
    buttonOrder: ['previous', 'save', 'cancel'],
    initialize: function initialize(options) {
      var _context47;

      var _this = this;

      var buttonConfigs = {
        previous: {
          type: 'previous'
        },
        save: {
          type: 'save',
          text: _underscoreWrapper.default.resultCtx(options, 'save', this),
          id: _underscoreWrapper.default.resultCtx(options, 'saveId', this),
          className: _underscoreWrapper.default.resultCtx(options, 'saveClassName', this)
        },
        cancel: {
          type: 'cancel',
          text: _underscoreWrapper.default.resultCtx(options, 'cancel', this)
        }
      };
      (0, _forEach.default)(_context47 = this.__getButtonOrder(options)).call(_context47, function (buttonName) {
        _this.addButton(buttonConfigs[buttonName]);
      });
    },

    /**
     * Adds a buttomn to the toolbar
     * @param {Object} params button parameters
     * @param {Object} options {@link Okta.View#add} options
     */
    addButton: function addButton(params, options) {
      return this.add(_FormUtil.default.createButton(params), options);
    },
    __getButtonOrder: function __getButtonOrder(options) {
      var _context48;

      var buttonOrder = _underscoreWrapper.default.resultCtx(options, 'buttonOrder', this, this.buttonOrder);

      var buttonsToSkip = [];

      if (options.noSubmitButton) {
        buttonsToSkip.push('save');
      }

      if (options.noCancelButton) {
        buttonsToSkip.push('cancel');
      }

      if (!options.hasPrevStep) {
        buttonsToSkip.push('previous');
      }

      return _underscoreWrapper.default.without.apply(_underscoreWrapper.default, (0, _concat.default)(_context48 = [buttonOrder]).call(_context48, buttonsToSkip));
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var registry = {};

  function isBaseInput(input) {
    if (_underscoreWrapper.default.isFunction(input)) {
      return _underscoreWrapper.default.isFunction(input.prototype.editMode) && _underscoreWrapper.default.isFunction(input.prototype.readMode);
    } else {
      return _underscoreWrapper.default.isObject(input) && _underscoreWrapper.default.isFunction(input.editMode) && _underscoreWrapper.default.isFunction(input.readMode);
    }
  }
  /**
   * @class module:Okta.internal.views.forms.helpers.InputRegistry
   */


  var _default =
  /** @lends module:Okta.internal.views.forms.helpers.InputRegistry */
  {
    isBaseInput: isBaseInput,

    /**
     * Register a form input
     * @param {String} type string identifier for the input
     * @param {BaseInput} input the input to register
     */
    register: function register(type, input) {
      registry[type] = input;
    },

    /**
     * Get a form input by type
     * @param {Object} options input definition
     * @param {String} options.type string identifier for the input
     * @return {BaseInput} a matching input
     */
    get: function get(options) {
      var input = registry[options.type];
      return input && (isBaseInput(input) ? input : input(options));
    },

    /**
     * Unregister an input type
     * @param {String} type
     */
    unregister: function unregister(type) {
      delete registry[type];
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 29 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(237);
  /***/
},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  __webpack_require__(78);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var template = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<select id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 12
          },
          "end": {
            "line": 1,
            "column": 23
          }
        }
      }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 31
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\"></select>";
    },
    "useData": true
  });

  var option = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<option value=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "key",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 15
          },
          "end": {
            "line": 1,
            "column": 22
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 24
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper)) + "</option>";
    },
    "useData": true
  });

  var CHOSEN_WINDOW_MARGIN = 20; // Chosen has known problems when it's at the bottom of a container that has
  // overflow:hidden set. Because it attaches to the parent container, its
  // dropdown will be cut off in the UI. Any modal with a chosen select element
  // at the bottom will manifest this behavior.
  //
  // The fix (aside from replacing Chosen) is to change Chosen's behavior -
  // use the existing styles, but attach it to 'body' and position it correctly
  // so that it is not affected by a parent overflow.
  //
  // More details can be found in OKTA-46489, OKTA-83570

  var CHOSEN_MAX_HEIGHT = 240;
  var CHOSEN_Z_INDEX = 50000;

  function defer(fn) {
    if (this.params.autoWidth) {
      return fn.call(this);
    } else {
      var _context49;

      return _underscoreWrapper.default.defer((0, _bind.default)(_context49 = _underscoreWrapper.default).call(_context49, fn, this));
    }
  }

  function findSelectWidth(self) {
    self.$select.hide();
    var select = (0, _jqueryWrapper.default)(self.$select[0]).hide();
    (0, _jqueryWrapper.default)('body').append(select);
    var width = self.params.width = select.width() * 1.2 + 'px';
    self.$el.append(select.show());
    return width;
  }

  function recalculateChosen($chosen, $results, $clone) {
    var offset = $clone.offset();
    $chosen.css({
      left: offset.left,
      top: offset.top
    }); // Update the max-height to fit within the constraints of the window. This
    // is especially important for modals because page scrolling is disabled.

    var $win = (0, _jqueryWrapper.default)(window);
    var rHeight = $results.outerHeight();
    var rBottom = rHeight + $results.offset().top - $win.scrollTop();
    var wHeight = $win.height() - CHOSEN_WINDOW_MARGIN;
    var maxHeight = Math.min(rHeight + wHeight - rBottom, CHOSEN_MAX_HEIGHT);
    $results.css('max-height', maxHeight);
  }

  function fixChosenModal($select) {
    var $chosen = $select.next('.chzn-container');
    var $clone = $chosen.clone();
    var $results = (0, _find.default)($chosen).call($chosen, '.chzn-results'); // Use a hidden clone to maintain layout and calculate offset. This is
    // necessary for more complex layouts (like adding a group rule) where
    // the chosen element is floated.

    $clone.css('visibility', 'hidden');
    $clone.removeAttr('id');
    (0, _find.default)($clone).call($clone, 'li').removeAttr('id'); // Save the original styles - we'll revert to them when the select closes

    var baseStyles = {
      left: $chosen.css('left'),
      top: $chosen.css('top'),
      position: $chosen.css('position'),
      float: $chosen.css('float'),
      'z-index': $chosen.css('z-index')
    };
    $results.hide(); // Handler for any resize events that happen when the results list is open

    var resizeHandler = _underscoreWrapper.default.debounce(function () {
      recalculateChosen($chosen, $results, $clone);
    }, 10); // When the dropdown opens, attach it to body, with the correct absolute
    // position coordinates


    $select.off('.fixChosen'); // Remove events we could have added before

    $select.on('liszt:showing_dropdown.fixChosen', function () {
      $chosen.width($chosen.width());
      $select.after($clone); // .chzn-container can trigger the vertical scrollbar if it causes scrollHeight > window height after append to
      // the body. Force top -999999 to avoid the scrollbar so $chosen can find the right offset for relocation.

      $chosen.css({
        position: 'absolute',
        float: 'none',
        'z-index': CHOSEN_Z_INDEX,
        top: -999999
      });
      (0, _jqueryWrapper.default)('body').append($chosen);
      $results.show();
      recalculateChosen($chosen, $results, $clone); // Capture scroll events:
      // - for forms that use fixed positioning (like editing attributes in
      //   Profile Editor) - window scroll
      // - for forms that are too long for the modal - o-form-content scroll

      $select.parents().scroll(resizeHandler);
      (0, _jqueryWrapper.default)(window).on('resize scroll', resizeHandler);
    }); // When the dropdown closes or the element is removed, revert to the
    // original styles and reattach it to its original placement in the dom.

    $select.on('liszt:hiding_dropdown.fixChosen remove.fixChosen', function () {
      $select.parents().off('scroll', resizeHandler);
      (0, _jqueryWrapper.default)(window).off('resize scroll', resizeHandler);
      $chosen.css(baseStyles);
      $results.hide();
      $results.css('max-height', CHOSEN_MAX_HEIGHT);
      $clone.remove();
      $select.after($chosen);
    });
  }

  var _default = _BaseInput.default.extend({
    className: 'o-form-select',

    /**
     * @Override
     */
    events: {
      'change select': 'update',
      'keyup .chzn-search > :text': function keyupChznSearchText(e) {
        if (_Keys.default.isEsc(e)) {
          this.$('.chzn-search > :text').val('');
          e.stopPropagation();
        }
      }
    },
    constructor: function constructor() {
      this.template = template;
      this.option = option;

      _BaseInput.default.apply(this, arguments);

      this.params = this.options.params || {};
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      /* eslint max-statements: [2, 13] */
      this.$el.html(template(this.options));
      this.$select = this.$('select');
      var options = this.getOptions();

      _underscoreWrapper.default.each(options, function (value, key) {
        this.$select.append(option({
          key: key,
          value: value
        }));
      }, this); // Fix a regression in jQuery 1.x on Firefox
      // jQuery.val(value) prepends an empty option to the dropdown
      // if value doesnt exist in the dropdown.
      // http://bugs.jquery.com/ticket/13514


      var value = this.getModelValue();

      if (value) {
        this.$select.val(value);
      } else {
        this.$('option:first-child').prop('selected', true);
      }

      this.$el.addClass('o-form-control');

      if (this.params.chosen !== false) {
        this.__applyChosen();
      }

      return this;
    },
    __applyChosen: function __applyChosen(update) {
      var width = this.options.wide ? '100%' : this.params.width || '62%';

      if (this.params.autoWidth) {
        width = findSelectWidth(this);
      }

      defer.call(this, function () {
        var searchThreshold = this.getParam('searchThreshold', 10);

        if (!_underscoreWrapper.default.result(this.options, 'autoRender') && update !== false) {
          this.update();
        }

        this.$select.chosen({
          width: width,
          disable_search_threshold: searchThreshold,
          //eslint-disable-line camelcase
          placeholder_text: this.options['placeholder'],
          //eslint-disable-line camelcase
          search_contains: true //eslint-disable-line camelcase

        });
        fixChosenModal(this.$select);

        if (this.params.autoWidth) {
          // fix a chosen css bug
          this.$el.width(0);
        }

        this.model.trigger('form:resize');
      });
    },

    /**
     * @Override
     */
    val: function val() {
      return this.$select && this.$select.val();
    },

    /**
     * @Override
     */
    focus: function focus() {
      if (this.$select) {
        return this.$select.focus();
      }
    },

    /**
     * @Override
     */
    toStringValue: function toStringValue() {
      var selectedOption = this.getModelValue();
      var displayString = selectedOption;
      var options = this.getOptions();

      if (!_underscoreWrapper.default.isEmpty(options)) {
        displayString = options[selectedOption];
      }

      if (_underscoreWrapper.default.isUndefined(displayString)) {
        displayString = this.defaultValue();
      }

      return displayString || '';
    },

    /**
     * Convert options to an object
     * support input options that is a
     * 1. a static object such as {key1: val1, key2: val2...}
     * 2. a function to be called to return a static object
     * will return an object with key-value pairs or with empty content
     * @return {Object} The value
     */
    getOptions: function getOptions() {
      var options = this.options.options;

      if (_underscoreWrapper.default.isFunction(options)) {
        options = options.call(this);
      }

      return _underscoreWrapper.default.isObject(options) ? options : {};
    },
    remove: function remove() {
      if (this.$select) {
        this.$select.trigger('remove');
      }

      return _BaseInput.default.prototype.remove.apply(this, arguments);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Time = _interopRequireDefault(__webpack_require__(32));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getOption(callout, option) {
    return _underscoreWrapper.default.resultCtx(callout.options, option, callout) || _underscoreWrapper.default.result(callout, option);
  }

  function getTopClass(callout) {
    var klass = 'infobox clearfix infobox-' + getOption(callout, 'type');

    switch (getOption(callout, 'size')) {
      case 'standard':
        klass += '';
        break;

      case 'slim':
        klass += ' infobox-slim';
        break;

      case 'compact':
        klass += ' infobox-compact';
        break;

      case 'large':
        klass += ' infobox-md';
        break;
    }

    if (getOption(callout, 'dismissible')) {
      klass += ' infobox-dismiss';
    }

    return klass;
  }

  var events = {
    'click .infobox-dismiss-link': function clickInfoboxDismissLink(e) {
      var _this = this;

      e.preventDefault();
      this.$el.fadeOut(_Time.default.UNLOADING_FADE, function () {
        _this.trigger('dismissed');

        _this.remove();
      });
    }
  };

  var template = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a data-se=\"dismiss-link\" class=\"infobox-dismiss-link\" title=\"" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "courage",
          "code": "component.dismiss"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 81
          },
          "end": {
            "line": 1,
            "column": 131
          }
        }
      })) + "\" href=\"#\"><span data-se=\"icon\" class=\"dismiss-icon\"></span></a>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h3 data-se=\"header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 286
          },
          "end": {
            "line": 1,
            "column": 295
          }
        }
      }) : helper)) + "</h3>";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p data-se=\"sub-header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 347
          },
          "end": {
            "line": 1,
            "column": 359
          }
        }
      }) : helper)) + "</p>";
    },
    "7": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ul data-se=\"list\" class=\"bullets\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
        "name": "each",
        "hash": {},
        "fn": container.program(8, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 420
          },
          "end": {
            "line": 1,
            "column": 483
          }
        }
      })) != null ? stack1 : "") + "</ul>";
    },
    "8": function _(container, depth0, helpers, partials, data) {
      return "<li data-se=\"list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissible") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 202
          }
        }
      })) != null ? stack1 : "") + "<span data-se=\"icon\" class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "icon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 235
          },
          "end": {
            "line": 1,
            "column": 243
          }
        }
      }) : helper)) + "\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 252
          },
          "end": {
            "line": 1,
            "column": 307
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 307
          },
          "end": {
            "line": 1,
            "column": 370
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 370
          },
          "end": {
            "line": 1,
            "column": 495
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  });

  var CalloutCallout = _BaseView.default.extend(
  /** @lends src/views/components/Callout.prototype */
  {
    attributes: {
      'data-se': 'callout'
    },

    /**
     * Custom HTML or view to inject to the callout
     * @type {String|Okta.View}
     */
    content: null,

    /**
     * Size of icon. options are standard, large, compact
     * @type {String}
     */
    size: 'standard',

    /**
     * Type of the callout. Valid values are: info, success, warning, error, tip
     * @type {String}
     */
    type: 'info',

    /**
     * Can the callout be dismissed
     * @type {Boolean}
     */
    dismissible: false,

    /**
     * Callout title
     * @type {String}
     */
    title: null,

    /**
     * Callout subtitle
     * @type {String}
     */
    subtitle: null,

    /**
     * Array of strings to render as bullet points
     * @type {Array}
     */
    bullets: null,

    /**
     * Fired after the callout is dismised - applies when
     * {@link module:Okta.internal.views.components.Callout|dismissible} is set to true
     * @event src/views/components/Callout#dismissed
     */
    constructor: function constructor() {
      this.events = _underscoreWrapper.default.defaults(this.events || {}, events);

      _BaseView.default.apply(this, arguments);

      this.$el.addClass(getTopClass(this));
      this.template = template;
      var content = getOption(this, 'content');

      if (content) {
        this.add(content);
      }
    },
    getTemplateData: function getTemplateData() {
      var icon = getOption(this, 'type');
      var size = getOption(this, 'size');

      if (icon === 'tip') {
        // css is inconsistent
        icon = 'light-bulb';
      }

      switch (size) {
        case 'slim':
          icon = '';
          break;

        case 'large':
          icon = [icon, '-', '24'].join('');
          break;

        default:
          icon = [icon, '-', '16'].join('');
      }

      return {
        icon: icon,
        title: getOption(this, 'title'),
        subtitle: getOption(this, 'subtitle'),
        bullets: getOption(this, 'bullets'),
        dismissible: getOption(this, 'dismissible')
      };
    }
  });
  /**
   * @class src/views/components/Callout
   * @extends module:Okta.View
   */

  /**
   * @class module:Okta.internal.views.components.Callout
   */


  var _default =
  /** @lends module:Okta.internal.views.components.Callout */
  {
    /**
     * Creates a {@link src/views/components/Callout|Callout}.
     * @static
     * @param {Object} options
     * @param {String|Function} [options.size] Size of icon. options are standard, large, compact, slim
     * @param {String|Okta.View} [options.content] Custom HTML or view to inject to the callout
     * @param {String|Function} [options.title] Callout title
     * @param {String|Function} [options.subtitle] Callout subtitle
     * @param {Array|Function} [options.bullets] Array of strings to render as bullet points
     * @param {Boolean|Function} [options.dismissible] Can the callout be dismissed
     * @param {String|Function} [options.type] Callout type. Valid values are: info, success, warning, error, tip
     *
     * @return {src/views/components/Callout}
     */
    create: function create(options) {
      return new CalloutCallout(options);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = {
    DEBOUNCE_DELAY: 200,
    LOADING_FADE: 400,
    UNLOADING_FADE: 400,
    ROW_EXPANDER_TRANSITION: 150,
    HIDE_ADD_MAPPING_FORM: 300
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 33 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /**
   * There are following local modifications:
   * - Author: Uzi Kilon ukilon@okta.com
   *   Bug: OKTA-20830 - solves the conflict when there are multiple labels
   */

  /**
   * --------------------------------------------------------------------
   * jQuery customInput plugin
   * Author: Maggie Costello Wachs maggie@filamentgroup.com, Scott Jehl, scott@filamentgroup.com
   * Copyright (c) 2009 Filament Group
   * licensed under MIT (filamentgroup.com/examples/mit-license.txt)
   * --------------------------------------------------------------------
  */


  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
    var $ = jQuery;

    jQuery.fn.customInput = function () {
      return $(this).each(function () {
        if ($(this).is('[type=checkbox],[type=radio]')) {
          var input = $(this); // get the associated label using the input's id

          var label = input.siblings('label[for="' + input.attr('id') + '"]:first');

          if (!label.length) {
            label = input.closest('label[for="' + input.attr('id') + '"]:first');
          } // wrap the input + label in a div


          input.add(label).wrapAll('<div class="custom-' + input.attr('type') + '"></div>'); // necessary for browsers that don't support the :hover pseudo class on labels

          label.hover(function () {
            $(this).addClass('hover');
          }, function () {
            $(this).removeClass('hover');
          }); //bind custom event, trigger it, bind click,focus,blur events

          (0, _bind.default)(input).call(input, 'updateState', function () {
            input.is(':checked') ? label.addClass('checked') : label.removeClass('checked checkedHover checkedFocus');
          }).trigger('updateState').click(function () {
            $('input[name="' + $(this).attr('name') + '"]').trigger('updateState');
          }).focus(function () {
            label.addClass('focus');

            if (input.is(':checked')) {
              $(this).addClass('checkedFocus');
            }
          }).blur(function () {
            label.removeClass('focus checkedFocus');
          });
        }
      });
    };
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  __webpack_require__(29);

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  __webpack_require__(83);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var className = 'okta-form-input-field input-fix';

  function hasTitleAndText(options) {
    var title = options.title;
    var text = options.text;
    return title && text && title !== text;
  } // options may be a string or an object.


  function createQtipContent(options) {
    if (hasTitleAndText(options)) {
      return options;
    }

    return {
      text: options.text || options
    };
  }

  var _default = _BaseInput.default.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        return "<span class=\"input-tooltip icon form-help-16\"></span>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon input-icon " + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, depth0)) + "\"></span>";
      },
      "5": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "autoComplete") || (depth0 != null ? lookupProperty(depth0, "autoComplete") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "autoComplete",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 333
            },
            "end": {
              "line": 1,
              "column": 349
            }
          }
        }) : helper));
      },
      "7": function _(container, depth0, helpers, partials, data) {
        return "off";
      },
      "9": function _(container, depth0, helpers, partials, data) {
        return "<span class=\"input-icon-divider\"></span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "innerTooltip") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 87
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 87
            },
            "end": {
              "line": 1,
              "column": 166
            }
          }
        })) != null ? stack1 : "") + "<input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "type",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 179
            },
            "end": {
              "line": 1,
              "column": 187
            }
          }
        }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 202
            },
            "end": {
              "line": 1,
              "column": 217
            }
          }
        }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 225
            },
            "end": {
              "line": 1,
              "column": 233
            }
          }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 239
            },
            "end": {
              "line": 1,
              "column": 250
            }
          }
        }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "value",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 259
            },
            "end": {
              "line": 1,
              "column": 268
            }
          }
        }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 282
            },
            "end": {
              "line": 1,
              "column": 297
            }
          }
        }) : helper)) + "\" autocomplete=\"" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "autoComplete") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(5, data, 0),
          "inverse": container.program(7, data, 0),
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 313
            },
            "end": {
              "line": 1,
              "column": 367
            }
          }
        })) != null ? stack1 : "") + "\" />" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "iconDivider") : stack1, {
          "name": "if",
          "hash": {},
          "fn": container.program(9, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 371
            },
            "end": {
              "line": 1,
              "column": 444
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),

    /**
     * @Override
     */
    events: {
      'input input': 'update',
      'change input': 'update',
      'keydown input': 'update',
      'keyup input': function keyupInput(e) {
        if (_Keys.default.isEnter(e)) {
          this.model.trigger('form:save');
        } else if (_Keys.default.isEsc(e)) {
          this.model.trigger('form:cancel');
        }
      }
    },
    constructor: function constructor() {
      _BaseInput.default.apply(this, arguments);

      this.$el.addClass('o-form-control');
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      this.$el.addClass(className);

      _BaseInput.default.prototype.editMode.apply(this, arguments);

      this.$('input').placeholder();
    },

    /**
     * @Override
     */
    readMode: function readMode() {
      _BaseInput.default.prototype.readMode.apply(this, arguments);

      if (this.options.type === 'password') {
        this.$el.text('********');
      }

      this.$el.removeClass(className);
    },

    /**
     * @Override
     */
    val: function val() {
      var inputValue = this.$('input[type="' + this.options.type + '"]').val(); //IE will only read clear text pw if type="password" is explicitly in selector

      if (this.options.type !== 'password') {
        var _context50;

        inputValue = (0, _trim.default)(_context50 = _jqueryWrapper.default).call(_context50, inputValue);
      }

      return inputValue;
    },

    /**
     * @Override
     */
    focus: function focus() {
      return this.$('input').focus();
    },
    postRender: function postRender() {
      var params = this.options.params;

      if (params && params.innerTooltip) {
        var content = createQtipContent(params.innerTooltip);
        this.$('.input-tooltip').qtip({
          content: content,
          style: {
            classes: 'okta-tooltip qtip-custom qtip-shadow'
          },
          position: {
            my: 'bottom left',
            // Note: qTip2 has a known issue calculating the tooltip offset when:
            // 1. A container element has both:
            //    a) position: relative/absolute
            //    b) overlay: value other than 'visible'
            // 2. The page is scrolled
            //
            // We set position:relative and overlay:auto on the body element,
            // where both are required for:
            // - Positioning the footer correctly
            // - Displaying long pages in embedded browsers
            //
            // The original design called for a fixed position relative to the
            // tooltip icon - this has been switched to "relative to mouse, and
            // update position when mouse moves" because of this constraint.
            target: 'mouse',
            adjust: {
              method: 'flip',
              mouse: true,
              y: -5,
              x: 5
            },
            viewport: (0, _jqueryWrapper.default)('body')
          }
        });
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(36);
  /***/
},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _BaseCollection = _interopRequireDefault(__webpack_require__(15));

  var _BaseModel = _interopRequireDefault(__webpack_require__(16));

  var _BaseSchema = _interopRequireDefault(__webpack_require__(40));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  var _SchemaProperty = _interopRequireDefault(__webpack_require__(20));

  var _BaseController = _interopRequireDefault(__webpack_require__(42));

  var _BaseRouter = _interopRequireDefault(__webpack_require__(22));

  var _ButtonFactory = _interopRequireDefault(__webpack_require__(18));

  var _Class = _interopRequireDefault(__webpack_require__(26));

  var _Cookie = _interopRequireDefault(__webpack_require__(46));

  var _Clipboard = _interopRequireDefault(__webpack_require__(48));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _Util = _interopRequireDefault(__webpack_require__(19));

  var _handlebarsWrapper = _interopRequireDefault(__webpack_require__(57));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Backbone = _interopRequireDefault(__webpack_require__(65));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _BaseDropDown = _interopRequireDefault(__webpack_require__(67));

  var _Notification = _interopRequireDefault(__webpack_require__(24));

  var _BaseForm = _interopRequireDefault(__webpack_require__(68));

  var _Toolbar = _interopRequireDefault(__webpack_require__(27));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  var _InputRegistry = _interopRequireDefault(__webpack_require__(28));

  var _SchemaFormFactory = _interopRequireDefault(__webpack_require__(76));

  var _CheckBox = _interopRequireDefault(__webpack_require__(81));

  var _PasswordBox = _interopRequireDefault(__webpack_require__(82));

  var _Radio = _interopRequireDefault(__webpack_require__(84));

  var _Select = _interopRequireDefault(__webpack_require__(30));

  var _InputGroup = _interopRequireDefault(__webpack_require__(85));

  var _TextBox = _interopRequireDefault(__webpack_require__(34));

  var _Callout = _interopRequireDefault(__webpack_require__(31));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _View = _interopRequireDefault(__webpack_require__(14));

  __webpack_require__(86);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // The string will be returned unchanged. All templates should be precompiled.


  _View.default.prototype.compileTemplate = function (str) {
    return function fakeTemplate() {
      return str;
    };
  }; // Override events to not support `Enter` submitting the form twice - OKTA-321999 and OKTA-317629


  var events = {
    'input input': 'update',
    'change input': 'update',
    'keydown input': 'update',
    'keyup input': function keyupInput(e) {
      if (_Keys.default.isEsc(e)) {
        this.model.trigger('form:cancel');
      }
    }
  };

  var TextBoxForSigninWidget = _TextBox.default.extend({
    events: events
  });

  var PasswordBoxForSigninWidget = _PasswordBox.default.extend({
    events: events
  });

  var Form = _BaseForm.default.extend({
    scrollOnError: function scrollOnError() {
      // scrollOnError is true by default. Override to false if `scrollOnError` has been set to false in widget settings.
      var settings = this.options.settings;

      if (settings.get('features.scrollOnError') === false) {
        return false;
      }

      return true;
    }
  });

  var Okta = {
    Backbone: _backbone.default,
    $: _jqueryWrapper.default,
    _: _underscoreWrapper.default,
    Handlebars: _handlebarsWrapper.default,
    loc: _StringUtil.default.localize,
    createButton: _ButtonFactory.default.create,
    createCallout: _Callout.default.create,
    registerInput: _InputRegistry.default.register,
    Model: _Model.default,
    // TODO: BaseModel has been deprecated and shall not be public
    // remove this once clean up usage in widget.
    BaseModel: _BaseModel.default,
    Collection: _BaseCollection.default,
    FrameworkView: _View.default,
    View: _BaseView.default,
    ListView: _Backbone.default,
    Router: _BaseRouter.default,
    Controller: _BaseController.default,
    Form: Form,
    internal: {
      util: {
        Util: _Util.default,
        Cookie: _Cookie.default,
        Clipboard: _Clipboard.default,
        Logger: _Logger.default,
        Class: _Class.default,
        Keys: _Keys.default
      },
      views: {
        components: {
          BaseDropDown: _BaseDropDown.default,
          Notification: _Notification.default
        },
        forms: {
          helpers: {
            FormUtil: _FormUtil.default,
            SchemaFormFactory: _SchemaFormFactory.default
          },
          components: {
            Toolbar: _Toolbar.default
          },
          inputs: {
            TextBox: TextBoxForSigninWidget,
            PasswordBox: PasswordBoxForSigninWidget,
            CheckBox: _CheckBox.default,
            Radio: _Radio.default,
            Select: _Select.default,
            InputGroup: _InputGroup.default
          }
        }
      },
      models: {
        BaseSchema: _BaseSchema.default,
        SchemaProperty: _SchemaProperty.default
      }
    }
  };
  Okta.registerInput('text', TextBoxForSigninWidget);
  Okta.registerInput('password', PasswordBoxForSigninWidget);
  Okta.registerInput('checkbox', _CheckBox.default);
  Okta.registerInput('radio', _Radio.default);
  Okta.registerInput('select', _Select.default);
  Okta.registerInput('group', _InputGroup.default);
  var _default = Okta;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 37 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(229);
  /***/
},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var STATE = '__STATE__',
      FETCH_DATA = 'FETCH_DATA',
      PAGINATION_DATA = 'PAGINATION_DATA',
      DEFAULT_PARAMS = 'DEFAULT_PARAMS',
      LINK_BY_HEADER = 'LINK_BY_HEADER',
      XHR = 'XHR';
  /*
   * Sets the next page URL on the collection from link headers
   * See: http://www.rfc-editor.org/rfc/rfc5988.txt
   *
   * This method is looking for a link header with `rel="next"`
   * An set's it as the next page's URL.
   *
   * If it doesn't find a next page, and current page is set by a link header
   * it assumes we are at the last page and deletes the current `next`
   */

  function setLinkHeadersPagination(collection, xhr) {
    try {
      var links = parseLinkHeader(xhr.getResponseHeader('link'));
      collection[STATE].set(LINK_BY_HEADER, true);
      collection.setPagination(links['next'].href);
    } catch (e) {
      if (collection[STATE].get(LINK_BY_HEADER)) {
        collection.setPagination(null);
      }
    }
  }

  function parseQuery(url) {
    var params = {},
        rawQueryStr = url && url.split('?')[1],
        queryString = rawQueryStr && decodeURIComponent(rawQueryStr.split('#')[0]).replace(/\+/g, ' '),
        props = queryString ? queryString.split('&') : [];

    for (var i = 0; i < props.length; i++) {
      var parts = props[i].split('=');
      params[parts.shift()] = parts.join('=');
    }

    return params;
  } // ################################################
  // # Source: https://gist.github.com/deiu/9335803
  // ################################################
  // unquote string (utility)


  function unquote(value) {
    if (value.charAt(0) == '"' && value.charAt(value.length - 1) == '"') {
      return value.substring(1, value.length - 1);
    }

    return value;
  }
  /*
  parse a Link header
  Link:<https://example.org/.meta>; rel=meta
  var r = parseLinkHeader(xhr.getResponseHeader('Link');
  r['meta']['href'] outputs https://example.org/.meta
  */


  function parseLinkHeader(header) {
    /* eslint max-statements: 0 */
    var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g,
        paramexp = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g;
    var matches = header.match(linkexp);
    var rels = {};

    for (var i = 0; i < matches.length; i++) {
      var split = matches[i].split('>');
      var href = split[0].substring(1);
      var link = {};
      link.href = href;
      var s = split[1].match(paramexp);

      for (var j = 0; j < s.length; j++) {
        var paramsplit = s[j].split('=');
        var name = paramsplit[0];
        link[name] = unquote(paramsplit[1]);
      }

      if (link.rel !== undefined) {
        rels[link.rel] = link;
      }
    }

    return rels;
  } // ################################################
  // # /Source
  // ################################################
  //

  /**
   *
   * Archer.Collection is a standard [Backbone.Collection](http://backbonejs.org/#Collection) with pre-set `data`
   * parameters and built in pagination - works with [http link headers](https://tools.ietf.org/html/rfc5988)
   * out of the box:
   *
   * @class src/framework/Collection
   * @extends external:Backbone.Collection
   * @example
   * var Users = Archer.Collection.extend({
   *   url: '/api/v1/users'
   *   params: {expand: true}
   * });
   * var users = new Users(null, {params: {type: 'new'}}),
   *     $button = this.$('a.fetch-more');
   *
   * $button.click(function () {
   *   users.fetchMore();
   * });
   *
   * this.listenTo(users, 'sync', function () {
   *   $button.toggle(users.hasMore());
   * });
   *
   * collection.fetch(); //=> '/api/v1/users?expand=true&type=new'
   */


  var _default = _backbone.default.Collection.extend(
  /** @lends src/framework/Collection.prototype */
  {
    /**
     * Default fetch parameters
     * @type {Object}
     */
    params: {},
    constructor: function constructor(models, options) {
      var state = this[STATE] = new _backbone.default.Model();
      state.set(DEFAULT_PARAMS, _underscoreWrapper.default.defaults(options && options.params || {}, this.params || {}));

      _backbone.default.Collection.apply(this, arguments);
    },

    /**
     * See [Backbone Collection.sync](http://backbonejs.org/#Collection-sync).
     */
    sync: function sync(method, collection, options) {
      var self = this,
          success = options.success;

      options.success = function (resp, status, xhr) {
        // its important to set the pagination data *before* we call the success callback
        // because we want the pagination data to be ready when the collection triggers the `sync` event
        setLinkHeadersPagination(self, xhr);
        success.apply(null, arguments);
      };

      return _backbone.default.Collection.prototype.sync.call(this, method, collection, options);
    },

    /**
     * See [Backbone Collection.fetch](http://backbonejs.org/#Collection-fetch).
     */
    fetch: function fetch(options) {
      options || (options = {});
      var state = this[STATE],
          xhr = state.get(XHR);
      options.data = _underscoreWrapper.default.extend({}, state.get(DEFAULT_PARAMS), options.data || {});
      options.fromFetch = true;
      state.set(FETCH_DATA, options.data);

      if (xhr && xhr.abort && options.abort !== false) {
        xhr.abort();
      }

      xhr = _backbone.default.Collection.prototype.fetch.call(this, options);
      state.set(XHR, xhr);
      return xhr;
    },

    /**
     * Set pagination data to get to the next page
     * @param {Mixed} params
     * @param {Object} [options]
     * @param {Boolean} [options.fromFetch] should we include data from the previous fetch call in this object
     * @example
     * collection.setPagination({q: 'foo', page: '2'}); //=> {q: 'foo', page: '2'}
     *
     * collection.setPagination('/path/to/resource?q=baz&page=4'); //=> {q: 'baz', page: '4'}
     *
     * collection.setPagination('/path/to/resource'); //=> {}
     *
     * collection.fetch({data: {q: 'foo'}});
     * collection.setPagination({page: 2}, {fromFetch: true}); //=> {q: 'foo', page: 2}
     *
     * any "falsy" value resets pagination
     * collection.setPagination(); //=> {}
     * collection.setPagination(null); //=> {}
     * collection.setPagination(false); //=> {}
     * collection.setPagination(''); //=> {}
     * collection.setPagination(0); //=> {}
     * @protected
     */
    setPagination: function setPagination(params, options) {
      /* eslint complexity: [2, 8] */
      if (_underscoreWrapper.default.isString(params) && params) {
        params = parseQuery(params);
      }

      if (!_underscoreWrapper.default.isObject(params) || _underscoreWrapper.default.isArray(params) || !_underscoreWrapper.default.size(params)) {
        params = null;
      } else if (options && options.fromFetch) {
        params = _underscoreWrapper.default.extend({}, this.getFetchData(), params);
      }

      this[STATE].set(PAGINATION_DATA, params);
    },

    /**
     * Returns the `data` parameters applied in th most recent `fetch` call
     * It will include parameters set by {@link #params} and optios.params passed to the constructor
     * @return {Object}
     * @protected
     */
    getFetchData: function getFetchData() {
      return this[STATE].get(FETCH_DATA) || {};
    },

    /**
     * Data object for constructing a request to fetch the next page
     * @return {Object}
     * @protected
     */
    getPaginationData: function getPaginationData() {
      return this[STATE].get(PAGINATION_DATA) || {};
    },

    /**
     * Does this collection have more data on the server (e.g is there a next "page")
     * @return {Boolean}
     */
    hasMore: function hasMore() {
      return _underscoreWrapper.default.size(this.getPaginationData()) > 0;
    },

    /**
     * Get the next page from the server
     * @return {Object} xhr returned by {@link #fetch}
     */
    fetchMore: function fetchMore() {
      if (!this.hasMore()) {
        throw new Error('Invalid Request');
      }

      return this.fetch({
        data: this.getPaginationData(),
        add: true,
        remove: false,
        update: true
      });
    },

    /**
     * See [Backbone Collection.reset](http://backbonejs.org/#Collection-reset).
     */
    reset: function reset(models, options) {
      options || (options = {}); // only reset the pagination when reset is being called explicitly.
      // this is to avoid link headers pagination being overriden and reset when
      // fetching the collection using `collection.fetch({reset: true})`

      if (!options.fromFetch) {
        this.setPagination(null);
      }

      return _backbone.default.Collection.prototype.reset.apply(this, arguments);
    },
    // we want "where" to be able to search through derived properties as well
    where: function where(attrs, first) {
      if (_underscoreWrapper.default.isEmpty(attrs)) {
        return first ? void 0 : [];
      }

      return this[first ? 'find' : 'filter'](function (model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) {
            return false;
          }
        }

        return true;
      });
    },

    /**
     * See [Backbone Collection.create](http://backbonejs.org/#Collection-create).
     */
    create: function create(model, options) {
      options || (options = {});

      if (!_underscoreWrapper.default.result(model, 'urlRoot')) {
        options.url = _underscoreWrapper.default.result(this, 'url');
      }

      return _backbone.default.Collection.prototype.create.call(this, model, options);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _backbone = _interopRequireDefault(__webpack_require__(6));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /**
     * Archer.Model is a standard [Backbone.Model](http://backbonejs.org/#Model) with a few additions:
     *
     * - {@link src/framework/Model#derived Derived properties}
     * - {@link src/framework/Model#props Built in schema validation}
     * - {@link src/framework/Model#local Private properties (with schema validation)}
     * - {@link src/framework/Model#flat Flattening of nested objects}
     *
     * Both derived and private properties are filtered out when sending the data to the server.
     *
     * See [Backbone.Model](http://backbonejs.org/#Model-constructor).
     *
     * @class src/framework/Model
     * @extends external:Backbone.Model
     * @param {Object} [attributes] - Initial model attributes (data)
     * @param {Object} [options] - Options hash
     * @example
     * var Person = Archer.Model.extend({
     *   props: {
     *     'fname': 'string',
     *     'lname': 'string'
     *   },
     *   local: {
     *     isLoggedIn: 'boolean'
     *   },
     *   derived: {
     *     name: {
     *       deps: ['fname', 'lname'],
     *       fn: function (fname, lname) {
     *         return fname + ' ' + lname;
     *       }
     *     }
     *   }
     * });
     * var model = new Person({fname: 'Joe', lname: 'Doe'});
     * model.get('name'); //=> "Joe Doe"
     * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
     *
     * model.set('isLoggedIn', true);
     * model.get('isLoggedIn'); //=> true
     * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
     */


  var Model;

  function flatten(value, objectTypeFields, key, target) {
    var filter = _underscoreWrapper.default.contains(objectTypeFields, key);

    target || (target = {});

    if (!filter && _underscoreWrapper.default.isObject(value) && !_underscoreWrapper.default.isArray(value) && !_underscoreWrapper.default.isFunction(value)) {
      _underscoreWrapper.default.each(value, function (val, i) {
        flatten(val, objectTypeFields, key ? key + '.' + i : i, target);
      });
    } // Case where target is an empty object. Guard against returning {undefined: undefined}.
    else if (key !== undefined) {
        target[key] = value;
      }

    return target;
  }

  function unflatten(data) {
    _underscoreWrapper.default.each(data, function (value, key, data) {
      if ((0, _indexOf.default)(key).call(key, '.') == -1) {
        return;
      }

      var part,
          ref = data,
          parts = key.split('.');

      while ((part = parts.shift()) !== undefined) {
        if (!ref[part]) {
          ref[part] = parts.length ? {} : value;
        }

        ref = ref[part];
      }

      delete data[key];
    });

    return data;
  }

  function createMessage(field, msg) {
    var obj = {};
    obj[field.name] = msg;
    return obj;
  }

  function normalizeSchemaDef(field, name) {
    var target;

    if (_underscoreWrapper.default.isString(field)) {
      target = {
        type: field
      };
    } else if (_underscoreWrapper.default.isArray(field)) {
      target = {
        type: field[0],
        required: field[1],
        value: field[2]
      };
    } else {
      target = _underscoreWrapper.default.clone(field);
    }

    _underscoreWrapper.default.defaults(target, {
      required: false,
      name: name
    });

    return target;
  }

  function capitalize(string) {
    return string.toLowerCase().replace(/\b[a-z]/g, function (letter) {
      return letter.toUpperCase();
    });
  }

  function _validateRegex(value, pattern, error) {
    if (!pattern.test(value)) {
      return error;
    }
  }

  var StringFormatValidators = {
    /*eslint max-len: 0 */
    email: function email(value) {
      // Taken from  http://emailregex.com/ on 2017-03-06.
      var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_EMAIL);
    },
    uri: function uri(value) {
      // source: https://mathiasbynens.be/demo/url-regex
      var pattern = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_URI);
    },
    ipv4: function ipv4(value) {
      // source: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
      var pattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_IPV4);
    },
    hostname: function hostname(value) {
      // source: http://www.regextester.com/23
      var pattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
      return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_HOSTNAME);
    }
  };

  function validateStringFormat(field, value) {
    var validator = StringFormatValidators[field.format];

    if (field.format && !validator) {
      throw new TypeError(field.format + ' is not a supported string format');
    }

    return validator && validator(value);
  }

  function validateString(field, value) {
    var createMessageWith = _underscoreWrapper.default.partial(createMessage, field),
        invalidFormat = validateStringFormat(field, value);

    if (invalidFormat) {
      return createMessageWith(invalidFormat);
    }

    if (value && field.minLength && value.length < field.minLength) {
      return createMessageWith(Model.ERROR_STRING_STRING_MIN_LENGTH, value.length);
    }

    if (value && field.maxLength && value.length > field.maxLength) {
      return createMessageWith(Model.ERROR_STRING_STRING_MAX_LENGTH, value.length);
    }
  }

  function _validateField(field, value) {
    /* eslint complexity: [2, 25], max-statements: [2, 27] */
    var createMessageWith = _underscoreWrapper.default.partial(createMessage, field),
        isDefined = !_underscoreWrapper.default.isUndefined(value) && !_underscoreWrapper.default.isNull(value),
        checkType,
        errorMessage; // If using an array validator, perform the validation


    if ((0, _isArray.default)(field.validate)) {
      var _context51;

      var output = [];
      var foundError = false;

      var _result;

      (0, _forEach.default)(_context51 = field.validate).call(_context51, function (item) {
        if (!value) {
          _result = false;
        } else {
          switch (item.type.toLowerCase()) {
            case 'regex':
              _result = new RegExp(item.value.pattern, (0, _flags.default)(item.value) || '').test(value);
              break;

            default:
              _result = false;
          }
        } // Append the result.


        foundError = foundError || !_result;
        output.push({
          // eslint-disable-next-line no-prototype-builtins
          message: item.hasOwnProperty('message') ? item.message : '',
          passed: _result
        });
      });

      if (foundError) {
        return createMessageWith(output);
      }

      return;
    } // check required fields


    if (field.required && (!isDefined || _underscoreWrapper.default.isNull(value) || value === '')) {
      return createMessageWith(Model.ERROR_BLANK);
    } // check type


    checkType = _underscoreWrapper.default['is' + capitalize(field.type)];

    if (isDefined && field.type != 'any' && (!_underscoreWrapper.default.isFunction(checkType) || !checkType(value))) {
      return createMessageWith(Model.ERROR_WRONG_TYPE);
    } // validate string format


    if (value && field.type == 'string') {
      var error = validateString(field, value);

      if (error) {
        return error;
      }
    } // check pre set values (enum)


    if (isDefined && (0, _values.default)(field) && !_underscoreWrapper.default.contains((0, _values.default)(field), value)) {
      return createMessageWith(Model.ERROR_NOT_ALLOWED);
    } // check validate method


    if (_underscoreWrapper.default.isFunction(field.validate)) {
      var result = field.validate(value);

      if (_underscoreWrapper.default.isString(result) && result) {
        return createMessageWith(result);
      } else if (result === false) {
        return createMessageWith(Model.ERROR_INVALID);
      }
    } // check array items


    if (isDefined && field.type == 'array' && (errorMessage = validateArrayField(field, value))) {
      return createMessageWith(errorMessage);
    }
  }

  function validateArrayField(field, arr) {
    if (field.minItems && arr.length < field.minItems) {
      return 'model.validation.field.array.minItems';
    } else if (field.maxItems && arr.length > field.maxItems) {
      return 'model.validation.field.array.maxItems';
    } else if (field.uniqueItems && arr.length > _underscoreWrapper.default.uniq(arr).length) {
      return Model.ERROR_IARRAY_UNIQUE;
    } else if (field.items) {
      /* eslint max-depth: [2, 3] */
      var arrayField = normalizeSchemaDef(field.items, 'placeholder');

      for (var i = 0; i < arr.length; i++) {
        var value = arr[i];

        var error = _validateField(arrayField, value);

        if (error) {
          return error['placeholder'];
        }
      }
    }
  }

  Model = _backbone.default.Model.extend(
  /** @lends src/framework/Model.prototype */
  {
    /**
       * Pass props as an object to extend, describing the observable properties of your model. The props
       * properties should not be set on an instance, as this won't define new properties, they should only be passed to
       * extend.
       * Properties can be defined in three different ways:
       *
       * - As a string with the expected dataType. One of string, number, boolean, array, object, date, or any.
       * Eg: `name: 'string'`.
       * - An array of `[dataType, required, default]`
       * - An object `{type: 'string', format: '', required: true, value: '', values: [], validate: function() {}`
       *   - `value` will be the value that the property will be set to if it is undefined, either by not being set during
       *   initialization, or by being explicitly set to undefined.
       *   - `format` is a json-schame derived string format. Supported formats are: `email`, `uri`, `hostname` and `ipv4`.
       *   - If `required` is true, one of two things will happen. If a default is set for the property, the property will
       *   start with that value. If a default is not set for the property, validation will fail
       *   - If `values` array is passed, then you'll be able to change a property to one of those values only.
       *   - If `validate` is defined, it should return false or a custom message string when the validation fails.
       *   - If the type is defined as `array`, the array elements could be defined by `minItems` (Number),
       *   `uniqueItems` (Boolean) and `items` (a field definition such as this one that will validate each array member)
       *   To the `validate` method
       *   - Trying to set a property to an invalid type will raise an exception.
       *
       * @type {Mixed}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     name: 'string',
       *     age: 'number',
       *     paying: ['boolean', true, false], //required attribute, defaulted to false
       *     type: {
       *       type: 'string',
       *       values: ['regular-hero', 'super-hero', 'mega-hero']
       *     },
       *     likes: {
       *       type: 'string',
       *       validate: function (value) {
       *         return /^[\w]+ing$/.test(value)
       *       }
       *     }
       *   }
       * });
       */
    props: {},

    /**
       * Derived properties (also known as computed properties) are properties of the model that depend on the
       * other (props, local or even derived properties to determine their value. Best demonstrated with an example:
       *
       * Each derived property, is defined as an object with the current properties:
       *
       * - `deps` {Array} - An array of property names which the derived property depends on.
       * - `fn` {Function} - A function which returns the value of the computed property. It is called in the context of
       * the current object, so that this is set correctly.
       * - `cache` {Boolean} -  - Whether to cache the property. Uncached properties are computed every time they are
       * accessed. Useful if it depends on the current time for example. Defaults to `true`.
       *
       * Derived properties are retrieved and fire change events just like any other property. They cannot be set
       * directly.
       * @type {Object}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     firstName: 'string',
       *     lastName: 'string'
       *   },
       *   derived: {
       *     fullName: {
       *       deps: ['firstName', 'lastName'],
       *       fn: function (firstName, lastName) {
       *         return firstName + ' ' + lastName;
       *       }
       *     }
       *   }
       * });
       *
       * var person = new Person({ firstName: 'Phil', lastName: 'Roberts' })
       * console.log(person.get('fullName')) //=> "Phil Roberts"
       *
       * person.set('firstName', 'Bob');
       * console.log(person.get('fullName')) //=> "Bob Roberts"
       */
    derived: {},

    /**
       * local properties are defined and work in exactly the same way as {@link src/framework/Model#props|props}, but generally only exist for
       * the lifetime of the page.
       * They would not typically be persisted to the server, and are not returned by calls to {@link src/framework/Model#toJSON|toJSON}.
       *
       * @type {Object}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     name: 'string',
       *   },
       *   local: {
       *     isLoggedIn: 'boolean'
       *   }
       * );
       */
    local: {},

    /**
       * Flatten the payload into dot notation string keys:
       *
       * @type {Boolean}
       * @example
       * var Person = Model.extend({
       *   props: {
       *     'profile.fname': 'string',
       *     'profile.lname': 'string',
       *     'profile.languages': 'object'
       *   },
       *   flat: true
       * });
       * var person = new Person({'profile': {
       *                            'fname': 'John',
       *                            'lname': 'Doe',
       *                            'languages': {name: "English", value: "EN"}
       *                         }}, {parse: true});
       * person.get('profile'); //=> undefined
       * person.get('profile.fname'); //=> 'John'
       * person.get('profile.lname'); //=> 'Doe'
       * person.get('profile.languages'); //=> {name: "English", value: "EN"}
       * person.get('profile.languages.name'); //=> undefined
       * person.toJSON(); //=> {'profile': {'fname': 'John'} }
       */
    flat: true,

    /**
       * @deprecated
       * @alias Backbone.Model#defaults
       */
    defaults: {},
    constructor: function constructor(options) {
      this.options = options || {};
      var schema = this['__schema__'] = {},
          objectTypeFields = [];
      schema.computedProperties = {};
      schema.props = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'props') || {});
      schema.derived = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'derived') || {});
      schema.local = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'local') || {});
      var defaults = {};

      _underscoreWrapper.default.each(_underscoreWrapper.default.extend({}, schema.props, schema.local), function (options, name) {
        var schemaDef = normalizeSchemaDef(options, name);

        if (!_underscoreWrapper.default.isUndefined(schemaDef.value)) {
          defaults[name] = schemaDef.value;
        }

        if (schemaDef.type === 'object') {
          objectTypeFields.push(name);
        }
      }, this);

      if (_underscoreWrapper.default.size(defaults)) {
        var localDefaults = _underscoreWrapper.default.result(this, 'defaults');

        this.defaults = function () {
          return _underscoreWrapper.default.defaults({}, defaults, localDefaults);
        };
      } // override `validate`


      this.validate = _underscoreWrapper.default.wrap(this.validate, function (validate) {
        var args = _underscoreWrapper.default.rest(arguments),
            res = _underscoreWrapper.default.extend(this._validateSchema.apply(this, args), validate.apply(this, args));

        return _underscoreWrapper.default.size(res) && res || undefined;
      }); // override `parse`

      this.parse = _underscoreWrapper.default.wrap(this.parse, function (parse) {
        var target = parse.apply(this, _underscoreWrapper.default.rest(arguments));

        if ((0, _flat.default)(this)) {
          target = flatten(target, objectTypeFields);
        }

        return target;
      });

      _backbone.default.Model.apply(this, arguments);

      _underscoreWrapper.default.each(schema.derived, function (options, name) {
        schema.computedProperties[name] = this.__getDerivedValue(name); // set initial value;

        var deps = options.deps || [];

        if (deps.length) {
          this.on('cache:clear change:' + deps.join(' change:'), function () {
            var value = this.__getDerivedValue(name);

            if (value !== schema.computedProperties[name]) {
              schema.computedProperties[name] = value;
              this.trigger('change:' + name, this, value);
            }
          }, this);
        }
      }, this);

      this.on('sync', function () {
        this.__syncedData = this.toJSON();
      }, this);
    },
    validate: function validate() {},

    /**
       * Check if the schema settings allow this field to exist in the model
       * @param  {String} key
       * @return {Boolean}
       */
    allows: function allows(key) {
      var schema = this['__schema__'],
          all = _underscoreWrapper.default.extend({}, schema.props, schema.local);

      if (!_underscoreWrapper.default.has(all, key)) {
        _Logger.default.warn('Field not defined in schema', key);
      }

      return true;
    },

    /**
       * Returns the schema for the specific property
       *
       * @param propName - The name of the property
       * @returns {*} | null
       */
    getPropertySchema: function getPropertySchema(propName) {
      var _context52;

      var schema = this['__schema__'];
      return (0, _reduce.default)(_context52 = _underscoreWrapper.default).call(_context52, [schema.props, schema.local], function (result, options) {
        return result || normalizeSchemaDef(options[propName], propName);
      }, null);
    },
    set: function set(key, val) {
      var attrs;

      if (_typeof(key) === 'object') {
        attrs = key;
      } else {
        (attrs = {})[key] = val;
      } // Don't override a computed properties


      _underscoreWrapper.default.each(attrs, function (value, key) {
        if (_underscoreWrapper.default.has(this['__schema__'].derived, key)) {
          throw 'overriding derived properties is not supported: ' + key;
        }
      }, this); // Schema validation


      var errorFields = [];

      _underscoreWrapper.default.each(attrs, function (value, key) {
        this.allows(key) || errorFields.push(key);
      }, this);

      if (errorFields.length) {
        throw 'field not allowed: ' + errorFields.join(', ');
      }

      return _backbone.default.Model.prototype.set.apply(this, arguments);
    },
    get: function get(attr) {
      var schema = this['__schema__'];

      if (_underscoreWrapper.default.has(schema.derived, attr)) {
        if (schema.derived[attr].cache !== false) {
          return schema.computedProperties[attr];
        } else {
          return this.__getDerivedValue(attr);
        }
      }

      return _backbone.default.Model.prototype.get.apply(this, arguments);
    },

    /**
       * Return a shallow copy of the model's attributes for JSON stringification.
       * This can be used for persistence, serialization, or for augmentation before being sent to the server.
       * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
       * but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
       *
       * See [Backbone.Model.toJSON](http://backbonejs.org/#Model-toJSON)
       *
       * @param  {Object} options
       * @return {Object}
       * @example
       * var artist = new Model({
       *   firstName: 'Wassily',
       *   lastName: 'Kandinsky'
       * });
       *
       * artist.set({birthday: 'December 16, 1866'});
       * JSON.stringify(artist); //=> {'firstName':'Wassily','lastName':'Kandinsky','birthday':'December 16, 1866'}
       */
    toJSON: function toJSON(options) {
      options || (options = {});

      var res = _underscoreWrapper.default.clone(_backbone.default.Model.prototype.toJSON.apply(this, arguments)),
          schema = this['__schema__']; // cleanup local properties


      if (!options.verbose) {
        var _context53;

        res = _underscoreWrapper.default.omit(res, (0, _keys2.default)(_context53 = _underscoreWrapper.default).call(_context53, schema.local));
      } else {
        // add derived properties
        _underscoreWrapper.default.each(schema.derived, function (options, name) {
          res[name] = this.get(name);
        }, this);
      }

      if ((0, _flat.default)(this)) {
        res = unflatten(res);
      }

      return res;
    },

    /**
       * Removes all attributes from the model, including the id attribute.
       * Fires a `"change"` event unless `silent` is passed as an option.
       * Sets the default values to the model
       * @param {Object} [options]
       */
    reset: function reset(options) {
      this.clear(options);
      this.set(_underscoreWrapper.default.result(this, 'defaults'), options);
    },

    /**
       * Is the data on the model has local modifications since the last sync event?
       * @return {Boolean} is the model in sync with the server
       */
    isSynced: function isSynced() {
      return _underscoreWrapper.default.isEqual(this.__syncedData, this.toJSON());
    },

    /**
       * validate a specific field in the model.
       * @param  {String} key
       * @return {Object} returns `{fieldName: errorMessage}` if invalid, otherwise undefined.
       * @readonly
       */
    validateField: function validateField(key) {
      var schema = key && this.getPropertySchema(key);
      return schema && _validateField(schema, this.get(key));
    },

    /**
       * Runs local schema validation. Invoked internally by {@link src/framework/Model#validate|validate}.
       * @return {Object}
       * @protected
       */
    _validateSchema: function _validateSchema() {
      var _context54;

      var schema = this['__schema__'];
      return (0, _reduce.default)(_context54 = _underscoreWrapper.default).call(_context54, _underscoreWrapper.default.extend({}, schema.props, schema.local), function (memo, options, name) {
        return _underscoreWrapper.default.extend(memo, this.validateField(name) || {});
      }, {}, this);
    },
    __getDerivedValue: function __getDerivedValue(name) {
      var _context55;

      var options = this['__schema__'].derived[name];

      if (_underscoreWrapper.default.isString(options)) {
        var key = options;
        options = {
          deps: [key],
          fn: function fn() {
            return this.get(key);
          }
        };
      }

      var deps = options.deps || [];
      return options.fn.apply(this, (0, _map.default)(_context55 = _underscoreWrapper.default).call(_context55, deps, this.get, this));
    }
  }, {
    ERROR_BLANK: 'model.validation.field.blank',
    ERROR_WRONG_TYPE: 'model.validation.field.wrong.type',
    ERROR_NOT_ALLOWED: 'model.validation.field.value.not.allowed',
    ERROR_INVALID: 'model.validation.field.invalid',
    ERROR_IARRAY_UNIQUE: 'model.validation.field.array.unique',
    ERROR_INVALID_FORMAT_EMAIL: 'model.validation.field.invalid.format.email',
    ERROR_INVALID_FORMAT_URI: 'model.validation.field.invalid.format.uri',
    ERROR_INVALID_FORMAT_IPV4: 'model.validation.field.invalid.format.ipv4',
    ERROR_INVALID_FORMAT_HOSTNAME: 'model.validation.field.invalid.format.hostname',
    ERROR_STRING_STRING_MIN_LENGTH: 'model.validation.field.string.minLength',
    ERROR_STRING_STRING_MAX_LENGTH: 'model.validation.field.string.maxLength'
  });
  var _default = Model;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseCollection = _interopRequireDefault(__webpack_require__(15));

  var _BaseModel = _interopRequireDefault(__webpack_require__(16));

  var _SchemaProperty = _interopRequireDefault(__webpack_require__(20));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var parseProperties = function parseProperties(resp) {
    var _context56;

    var schemaMeta = _underscoreWrapper.default.pick(resp, 'id', 'name', 'displayName');

    var properties = (0, _map.default)(_context56 = _underscoreWrapper.default).call(_context56, resp.schema.properties, function (property, name) {
      return _underscoreWrapper.default.extend({
        name: name
      }, property);
    });

    _underscoreWrapper.default.each(properties, function (property) {
      property['__schemaMeta__'] = schemaMeta;

      if (property.__metadata) {
        property['__metadata__'] = property.__metadata;
        delete property.__metadata;
      }
    });

    return properties;
  };

  var BaseSchemaSchema = _BaseModel.default.extend({
    defaults: {
      id: undefined,
      displayName: undefined,
      name: undefined
    },
    constructor: function constructor() {
      this.properties = new _SchemaProperty.default.Collection();

      _BaseModel.default.apply(this, arguments);
    },
    getProperties: function getProperties() {
      return this.properties;
    },
    clone: function clone() {
      var model = _BaseModel.default.prototype.clone.apply(this, arguments);

      model.getProperties().set(this.getProperties().toJSON({
        verbose: true
      }));
      return model;
    },
    parse: function parse(resp) {
      var properties = parseProperties(resp);
      this.properties.set(properties, {
        parse: true
      });
      return _underscoreWrapper.default.omit(resp, 'schema');
    },
    trimProperty: function trimProperty(property) {
      return _underscoreWrapper.default.omit(property, 'name');
    },
    toJSON: function toJSON() {
      var json = _BaseModel.default.prototype.toJSON.apply(this, arguments);

      json.schema = {
        properties: {}
      };
      this.getProperties().each(function (model) {
        var property = model.toJSON();
        json.schema.properties[property.name] = this.trimProperty(property);
      }, this);
      return json;
    },
    save: function save() {
      this.getProperties().each(function (model) {
        model.cleanup();
      });
      return _BaseModel.default.prototype.save.apply(this, arguments);
    }
  });

  var BaseSchemaSchemas = _BaseCollection.default.extend({
    model: BaseSchemaSchema
  });

  var _default = {
    parseProperties: parseProperties,
    Model: BaseSchemaSchema,
    Collection: BaseSchemaSchemas
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 41 */

/***/
function (module, exports) {
  module.exports = __webpack_require__(155);
  /***/
},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseRouter = _interopRequireDefault(__webpack_require__(22));

  var _SettingsModel = _interopRequireDefault(__webpack_require__(17));

  var _StateMachine = _interopRequireDefault(__webpack_require__(44));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-len: [2, 150] */


  function clean(obj) {
    var res = {};

    _underscoreWrapper.default.each(obj, function (value, key) {
      if (!_underscoreWrapper.default.isNull(value)) {
        res[key] = value;
      }
    });

    return res;
  }
  /**
   * A Controller is our application control flow component.
   *
   * Typically it will:
   * - Initialize the models, controller and main views
   * - Listen to events
   * - Create, read, update and delete models
   * - Create modal dialogs, confirmation dialogs and alert dialogs
   * - Control the application flow
   *
   * The constructor is responsible for:
   * - Create the application state object
   * - Assign or creates the application settings object
   * - Create an instance of the main view with the relevant parameters
   *
   * See:
   * [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World),
   * [Jasmine Spec](https://github.com/okta/okta-core/blob/master/WebContent/js/test/unit/spec/shared/util/BaseController_spec.js)
   *
   * @class module:Okta.Controller
   * @param {Object} options Options Hash
   * @param {SettingsModel} [options.settings] Application Settings Model
   * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
   */


  var _default = _BaseView.default.extend(
  /** @lends module:Okta.Controller.prototype */
  {
    constructor: function constructor(options) {
      /* eslint max-statements: [2, 15], complexity: [2, 9]*/
      options || (options = {}); // If 'state' is passed down as options, use it, else create a 'new StateMachine()'

      if (options.state instanceof _StateMachine.default || this.state instanceof _StateMachine.default) {
        this.state = options.state || this.state;
      } else {
        var stateData = _underscoreWrapper.default.defaults(clean(options.state), this.state || {});

        this.state = new _StateMachine.default(stateData);
        delete options.state;
      }

      if (options.settings) {
        this.settings = options.settings;
      } else {
        // allow the controller to live without a router
        this.settings = options.settings = new _SettingsModel.default(_underscoreWrapper.default.omit(options || {}, 'el'));
        this.listen('notification', _BaseRouter.default.prototype._notify);
        this.listen('confirmation', _BaseRouter.default.prototype._confirm);
      }

      _BaseView.default.call(this, options);

      this.listenTo(this.state, '__invoke__', function () {
        var args = _underscoreWrapper.default.toArray(arguments);

        var method = args.shift();

        if (_underscoreWrapper.default.isFunction(this[method])) {
          this[method].apply(this, args);
        }
      });

      if (this.View) {
        this.add(new this.View(this.toJSON()));
      }
    },

    /**
     * The default values of our application state
     * @type {Object}
     * @default {}
     */
    state: {},

    /**
     * The main view this controller operate on
     * @type {module:Okta.View}
     * @default null
     */
    View: null,

    /**
     * Renders the {@link module:Okta.Controller#View|main view} after the DOM is ready
     * in case the controller is the root component of the page (e.g there's no router)
     */
    render: function render() {
      var args = arguments;
      var self = this;
      (0, _jqueryWrapper.default)(function () {
        _BaseView.default.prototype.render.apply(self, args);
      });
      return this;
    },

    /**
     * Creates the view constructor options
     * @param {Object} [options] Extra options
     * @return {Object} The view constructor options
     */
    toJSON: function toJSON(options) {
      return _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this, 'state', 'settings', 'collection', 'model'), options || {});
    },

    /**
     * Removes the child views, empty the DOM element and stop listening to events
     */
    remove: function remove() {
      this.removeChildren();
      this.stopListening();
      this.$el.empty();
      return this;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta-ui/no-specific-methods: 0 */

  /**
   * @class module:Okta.internal.util.TemplateUtil
   * @hideconstructor
   */


  var _default =
  /** @lends module:Okta.internal.util.TemplateUtil */
  {
    /**
     * Compiles a Handlebars template
     * @static
     * @method
     */
    // TODO: This will be deprecated at some point. Views should use pre-compiled templates
    tpl: _underscoreWrapper.default.memoize(function (tpl) {
      /* eslint @okta/okta-ui/no-specific-methods: 0 */
      return function (context) {
        return _handlebars.default.compile(tpl)(context);
      };
    })
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Model = _interopRequireDefault(__webpack_require__(11));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @class StateMachine
   * @extends Okta.Model
   * @private
   *
   * A state object that holds the applciation state
   */


  var _default = _Model.default.extend({
    extraProperties: true,

    /**
     * Invokes a method on the applicable {@link Okta.Controller}
     *
     * ```javascript
     * state.invoke('methodName', 'param1', 'param2')
     * // Will call
     * contoller.methodName('param1', 'param2')
     * ```
     * @param {String} methodName the name of the controller method to invoke on the controller
     */
    invoke: function invoke() {
      var args = _underscoreWrapper.default.toArray(arguments);

      args.unshift('__invoke__');
      this.trigger.apply(this, args);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 45 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _ViewUtil = _interopRequireDefault(__webpack_require__(25));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var disabledEvents = {
    click: function click(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  /**
   * A configurable button
   * @class module:Okta.internal.views.components.BaseButtonLink
   * @extends module:Okta.View
   * @example
   * var View = BaseButtonLink.extend({
   *   title: 'Click Me',
   *   icon: 'help-text'
   * })
   */

  var _default = _BaseView.default.extend(
  /** @lends module:Okta.internal.views.components.BaseButtonLink.prototype */
  {
    attributes: function attributes() {
      var defaultAttrs = {
        'data-se': 'button'
      };

      var additionalAttr = this.__getAttribute('attrs');

      return _underscoreWrapper.default.extend(defaultAttrs, additionalAttr);
    },

    /**
     * The main text for the button
     * @name title
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {(String|Function)}
     * @instance
     */

    /**
     * The link for the button
     * @name href
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {(String|Function)}
     * @instance
     */

    /**
     * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
     * @name icon
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {(String|Function)}
     * @instance
     */

    /**
     * A [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
     * @name events
     * @memberof module:Okta.internal.views.components.BaseButtonLink
     * @type {Object}
     * @instance
     */
    tagName: 'a',
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "icon",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 30
            },
            "end": {
              "line": 1,
              "column": 38
            }
          }
        }) : helper)) + "\"></span>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "title",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 67
            },
            "end": {
              "line": 1,
              "column": 76
            }
          }
        }) : helper));
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 54
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 54
            },
            "end": {
              "line": 1,
              "column": 83
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),

    /**
     * Make this button visible, default to true.
     * @type {(Boolean|Function)}
     * @default true
     */
    visible: true,

    /**
     * Make this button enabled, default to true.
     * @type {(Boolean|Function)}
     * @default true
     */
    enabled: true,

    /**
     * The setting to determine when the button is enabled, default to {} and
     * enabled takes a higher priority.
     * @type {(Object|Function)}
     * @default {}
     */
    enableWhen: {},

    /**
     * The setting to determine when the button is visible, default to {} and
     * visible takes a higher priority.
     * @type {(Object|Function)}
     * @default {}
     */
    showWhen: {},
    constructor: function constructor(options) {
      this.options = options || {};
      var data = this.getTemplateData();
      this.disabled = false;

      _BaseView.default.apply(this, arguments);

      this.$el.addClass('link-button');

      if (data.icon) {
        this.$el.addClass('link-button-icon');

        if (!data.title) {
          this.$el.addClass('icon-only');
        }
      }
    },
    getTemplateData: function getTemplateData() {
      return {
        href: this.__getAttribute('href'),
        title: this.__getAttribute('title'),
        icon: this.__getAttribute('icon')
      };
    },
    initialize: function initialize() {
      _ViewUtil.default.applyDoWhen(this, _underscoreWrapper.default.resultCtx(this, 'enableWhen', this), this.toggle);

      _ViewUtil.default.applyDoWhen(this, _underscoreWrapper.default.resultCtx(this, 'showWhen', this), this.toggleVisible);
    },
    render: function render() {
      _BaseView.default.prototype.render.apply(this, arguments);

      if (!_underscoreWrapper.default.result(this, 'enabled')) {
        this.toggle(false);
      }

      if (!_underscoreWrapper.default.result(this, 'visible')) {
        this.toggleVisible(false);
      }

      var data = this.getTemplateData();
      this.$el.attr('href', data.href || '#');
      return this;
    },
    __getAttribute: function __getAttribute(name, defaultValue) {
      var value = _underscoreWrapper.default.resultCtx(this.options, name, this);

      if (_underscoreWrapper.default.isUndefined(value)) {
        value = _underscoreWrapper.default.result(this, name);
      }

      return !_underscoreWrapper.default.isUndefined(value) ? value : defaultValue;
    },
    enable: function enable() {
      this.toggle(true);
    },
    disable: function disable() {
      this.toggle(false);
    },
    show: function show() {
      this.toggleVisible(true);
    },
    hide: function hide() {
      this.toggleVisible(false);
    },
    toggle: function toggle(enable) {
      var bool = !!enable && _underscoreWrapper.default.result(this, 'enabled'); //this is to toggle the enability


      this.disabled = !bool;
      this.$el.toggleClass('link-button-disabled btn-disabled disabled', this.disabled);
      this.delegateEvents(this.disabled ? disabledEvents : null);
    },
    toggleVisible: function toggleVisible(visible) {
      var hidden = !visible || !_underscoreWrapper.default.result(this, 'visible');
      this.$el.toggleClass('hide', hidden);
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _js = _interopRequireDefault(__webpack_require__(47));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SECURED_COOKIE = /^https/.test(window.location.href);
  var _default = {
    setCookie: function setCookie(name, value, options) {
      _js.default.set(name, value, _underscoreWrapper.default.defaults(options || {}, {
        secure: SECURED_COOKIE,
        path: '/'
      }));
    },
    getCookie: function getCookie() {
      return _js.default.get.apply(_js.default, arguments);
    },
    removeCookie: function removeCookie() {
      return _js.default.remove.apply(_js.default, arguments);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /*!
   * JavaScript Cookie v2.1.0
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   */


  (function (factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
      module.exports = factory();
    } else {
      var _OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = _OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function init(converter) {
      function api(key, value, attributes) {
        var result; // Write

        if (arguments.length > 1) {
          attributes = extend({
            path: '/'
          }, api.defaults, attributes);

          if (typeof attributes.expires === 'number') {
            var expires = new Date();
            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
            attributes.expires = expires;
          }

          try {
            result = (0, _stringify.default)(value);

            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {}

          if (!converter.write) {
            value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          } else {
            value = converter.write(value, key);
          }

          key = encodeURIComponent(String(key));
          key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
          key = key.replace(/[\(\)]/g, escape);
          return document.cookie = [key, '=', value, attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
          attributes.path && '; path=' + attributes.path, attributes.domain && '; domain=' + attributes.domain, attributes.secure ? '; secure' : ''].join('');
        } // Read


        if (!key) {
          result = {};
        } // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all. Also prevents odd result when
        // calling "get()"


        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var rdecode = /(%[0-9A-Z]{2})+/g;
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var name = parts[0].replace(rdecode, decodeURIComponent);
          var cookie = (0, _slice.default)(parts).call(parts, 1).join('=');

          if (cookie.charAt(0) === '"') {
            cookie = (0, _slice.default)(cookie).call(cookie, 1, -1);
          }

          try {
            cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

            if (this.json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            if (key === name) {
              result = cookie;
              break;
            }

            if (!key) {
              result[name] = cookie;
            }
          } catch (e) {}
        }

        return result;
      }

      api.get = api.set = api;

      api.getJSON = function () {
        return api.apply({
          json: true
        }, (0, _slice.default)([]).call(arguments));
      };

      api.defaults = {};

      api.remove = function (key, attributes) {
        api(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
  /***/

},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _clipboard = _interopRequireDefault(__webpack_require__(49));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _View = _interopRequireDefault(__webpack_require__(14));

  var _Class = _interopRequireDefault(__webpack_require__(26));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Clipboard = _clipboard.default;
  var OPTIONS = ['success', 'error', 'target', 'text'];

  var ClipboardClipboardWrapper = _Class.default.extend({
    initialize: function initialize(el, options) {
      /* eslint complexity:0, max-statements: [2, 24] */
      options = _underscoreWrapper.default.pick(options || {}, OPTIONS);
      var trigger;
      var target;
      var text;

      if (_underscoreWrapper.default.isString(el)) {
        trigger = el;
      }

      if (_underscoreWrapper.default.isElement(el)) {
        trigger = el;
      }

      if (el instanceof _jqueryWrapper.default) {
        trigger = el.selector;
      }

      if (el instanceof _View.default) {
        trigger = el.el;
      }

      if (_underscoreWrapper.default.isFunction(options.target)) {
        target = options.target;
      }

      if (_underscoreWrapper.default.isElement(options.target)) {
        target = _underscoreWrapper.default.constant(options.target);
      }

      if (_underscoreWrapper.default.isString(options.text)) {
        text = _underscoreWrapper.default.constant(options.text);
      } else if (_underscoreWrapper.default.isFunction(options.text)) {
        text = options.text;
      }

      this.__instance = new Clipboard(trigger, {
        target: target,
        text: text
      });
      this.done = _underscoreWrapper.default.partial(this.__setCallback, 'success');
      this.error = _underscoreWrapper.default.partial(this.__setCallback, 'error');
      this.done(options.success);
      this.error(options.error);
    },
    __setCallback: function __setCallback(event, callback) {
      if (!_underscoreWrapper.default.isFunction(callback)) {
        return;
      }

      this.__instance.on(event, callback);

      return this.__instance;
    }
  });
  /**
   * @class Clipboard
   * @abstract
   *
   * Abstract class that initializes a Clipboard
   *   https://clipboardjs.com/
   *
   * ### Example:
   *
   *  ```javascript
   *  //attach a selector
   *  Clipboard.attach('.copy-button');
   *
   *  //attach a node, and set a constant string
   *  Clipboard.attach(buttonView.el, {
   *    text: 'this is the content'
   *  });
   *
   *  //attach a view, set text dynamically, and set callback
   *  Clipboard.attach(buttonView, {
   *    text: function (triggerNode) {
   *      return $(triggerNode).attr('foo') + model.get('userName');
   *    }
   *  }).done(function (targetNode) {
   *    var msg = ['"', targetNode.text, '" is copied'].join('');
   *    view.notify('success', msg);
   *  });
   *
   *  //attach a jquery object, set the target node, and set callback
   *  Clipboard.attach($('.customizeTarget'), {
   *    target: function (triggerNode) {
   *      return triggerNode;
   *    },
   *    success: function (targetNode) {
   *      view.notify('success', 'copied!');
   *    }
   *  });
   *
   * ```
   */


  var _default = {
    /**
     * @param {String|Node|View|jQuery} [el] el could be a selector (recommended),
     *           a dom node, a view or a jquery object
     * @param {Object} [options] Options hash
     * @param  {Node|Function} [options.target] a static dom node
     *           or a function that takes trigger node and returns a target node
     * @param {String|Function} [options.text] a static string or a function that returns a string dynamically
     * @param {Function} [options.success] success callback
     * @param {Function} [options.error] error callback
     * @return {Object} The clipboard object
     */
    attach: function attach(el, options) {
      return new ClipboardClipboardWrapper(el, options);
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(50), __webpack_require__(52), __webpack_require__(53)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
      global.clipboard = mod.exports;
    }
  })(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _typeof = typeof _symbol.default === "function" && (0, _typeof3.default)(_iterator.default) === "symbol" ? function (obj) {
      return (0, _typeof3.default)(obj);
    } : function (obj) {
      return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : (0, _typeof3.default)(obj);
    };

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          (0, _defineProperty.default)(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && ((0, _typeof3.default)(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (0, _typeof3.default)(superClass));
      }

      subClass.prototype = (0, _create.default)(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf.default ? (0, _setPrototypeOf.default)(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
      _inherits(Clipboard, _Emitter);
      /**
       * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
       * @param {Object} options
       */


      function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || (0, _getPrototypeOf.default)(Clipboard)).call(this));

        _this.resolveOptions(options);

        _this.listenClick(trigger);

        return _this;
      }
      /**
       * Defines if attributes would be resolved using internal setter functions
       * or custom functions that were passed in the constructor.
       * @param {Object} options
       */


      _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
          this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
          this.text = typeof options.text === 'function' ? options.text : this.defaultText;
          this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }
      }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
          var _this2 = this;

          this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
            return _this2.onClick(e);
          });
        }
      }, {
        key: 'onClick',
        value: function onClick(e) {
          var trigger = e.delegateTarget || e.currentTarget;

          if (this.clipboardAction) {
            this.clipboardAction = null;
          }

          this.clipboardAction = new _clipboardAction2.default({
            action: this.action(trigger),
            target: this.target(trigger),
            text: this.text(trigger),
            container: this.container,
            trigger: trigger,
            emitter: this
          });
        }
      }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
          return getAttributeValue('action', trigger);
        }
      }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
          var selector = getAttributeValue('target', trigger);

          if (selector) {
            return document.querySelector(selector);
          }
        }
      }, {
        key: 'defaultText',
        value: function defaultText(trigger) {
          return getAttributeValue('text', trigger);
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.listener.destroy();

          if (this.clipboardAction) {
            this.clipboardAction.destroy();
            this.clipboardAction = null;
          }
        }
      }], [{
        key: 'isSupported',
        value: function isSupported() {
          var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
          var actions = typeof action === 'string' ? [action] : action;
          var support = !!document.queryCommandSupported;
          (0, _forEach.default)(actions).call(actions, function (action) {
            support = support && !!document.queryCommandSupported(action);
          });
          return support;
        }
      }]);

      return Clipboard;
    }(_tinyEmitter2.default);
    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */


    function getAttributeValue(suffix, element) {
      var attribute = 'data-clipboard-' + suffix;

      if (!element.hasAttribute(attribute)) {
        return;
      }

      return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
  });
  /***/

},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(51)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(module, require('select'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod, global.select);
      global.clipboardAction = mod.exports;
    }
  })(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _typeof = typeof _symbol.default === "function" && (0, _typeof3.default)(_iterator.default) === "symbol" ? function (obj) {
      return (0, _typeof3.default)(obj);
    } : function (obj) {
      return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : (0, _typeof3.default)(obj);
    };

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          (0, _defineProperty.default)(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var ClipboardAction = function () {
      /**
       * @param {Object} options
       */
      function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
      }
      /**
       * Defines base properties passed from constructor.
       * @param {Object} options
       */


      _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this.action = options.action;
          this.container = options.container;
          this.emitter = options.emitter;
          this.target = options.target;
          this.text = options.text;
          this.trigger = options.trigger;
          this.selectedText = '';
        }
      }, {
        key: 'initSelection',
        value: function initSelection() {
          if (this.text) {
            this.selectFake();
          } else if (this.target) {
            this.selectTarget();
          }
        }
      }, {
        key: 'selectFake',
        value: function selectFake() {
          var _this = this;

          var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
          this.removeFake();

          this.fakeHandlerCallback = function () {
            return _this.removeFake();
          };

          this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
          this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS

          this.fakeElem.style.fontSize = '12pt'; // Reset box model

          this.fakeElem.style.border = '0';
          this.fakeElem.style.padding = '0';
          this.fakeElem.style.margin = '0'; // Move element out of screen horizontally

          this.fakeElem.style.position = 'absolute';
          this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

          var yPosition = window.pageYOffset || document.documentElement.scrollTop;
          this.fakeElem.style.top = yPosition + 'px';
          this.fakeElem.setAttribute('readonly', '');
          this.fakeElem.value = this.text;
          this.container.appendChild(this.fakeElem);
          this.selectedText = (0, _select2.default)(this.fakeElem);
          this.copyText();
        }
      }, {
        key: 'removeFake',
        value: function removeFake() {
          if (this.fakeHandler) {
            this.container.removeEventListener('click', this.fakeHandlerCallback);
            this.fakeHandler = null;
            this.fakeHandlerCallback = null;
          }

          if (this.fakeElem) {
            this.container.removeChild(this.fakeElem);
            this.fakeElem = null;
          }
        }
      }, {
        key: 'selectTarget',
        value: function selectTarget() {
          this.selectedText = (0, _select2.default)(this.target);
          this.copyText();
        }
      }, {
        key: 'copyText',
        value: function copyText() {
          var succeeded = void 0;

          try {
            succeeded = document.execCommand(this.action);
          } catch (err) {
            succeeded = false;
          }

          this.handleResult(succeeded);
        }
      }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
          var _context57;

          this.emitter.emit(succeeded ? 'success' : 'error', {
            action: this.action,
            text: this.selectedText,
            trigger: this.trigger,
            clearSelection: (0, _bind.default)(_context57 = this.clearSelection).call(_context57, this)
          });
        }
      }, {
        key: 'clearSelection',
        value: function clearSelection() {
          if (this.trigger) {
            this.trigger.focus();
          }

          window.getSelection().removeAllRanges();
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.removeFake();
        }
      }, {
        key: 'action',
        set: function set() {
          var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
          this._action = action;

          if (this._action !== 'copy' && this._action !== 'cut') {
            throw new Error('Invalid "action" value, use either "copy" or "cut"');
          }
        },
        get: function get() {
          return this._action;
        }
      }, {
        key: 'target',
        set: function set(target) {
          if (target !== undefined) {
            if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
              if (this.action === 'copy' && target.hasAttribute('disabled')) {
                throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
              }

              if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
              }

              this._target = target;
            } else {
              throw new Error('Invalid "target" value, use a valid Element');
            }
          }
        },
        get: function get() {
          return this._target;
        }
      }]);

      return ClipboardAction;
    }();

    module.exports = ClipboardAction;
  });
  /***/

},
/* 51 */

/***/
function (module, exports) {
  function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
      element.focus();
      selectedText = element.value;
    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
      var isReadOnly = element.hasAttribute('readonly');

      if (!isReadOnly) {
        element.setAttribute('readonly', '');
      }

      element.select();
      element.setSelectionRange(0, element.value.length);

      if (!isReadOnly) {
        element.removeAttribute('readonly');
      }

      selectedText = element.value;
    } else {
      if (element.hasAttribute('contenteditable')) {
        element.focus();
      }

      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
      selectedText = selection.toString();
    }

    return selectedText;
  }

  module.exports = select;
  /***/
},
/* 52 */

/***/
function (module, exports) {
  function E() {// Keep this empty so it's easier to inherit from
    // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
  }

  E.prototype = {
    on: function on(name, callback, ctx) {
      var e = this.e || (this.e = {});
      (e[name] || (e[name] = [])).push({
        fn: callback,
        ctx: ctx
      });
      return this;
    },
    once: function once(name, callback, ctx) {
      var self = this;

      function listener() {
        self.off(name, listener);
        callback.apply(ctx, arguments);
      }

      ;
      listener._ = callback;
      return this.on(name, listener, ctx);
    },
    emit: function emit(name) {
      var _context58;

      var data = (0, _slice.default)([]).call(arguments, 1);
      var evtArr = (0, _slice.default)(_context58 = (this.e || (this.e = {}))[name] || []).call(_context58);
      var i = 0;
      var len = evtArr.length;

      for (i; i < len; i++) {
        evtArr[i].fn.apply(evtArr[i].ctx, data);
      }

      return this;
    },
    off: function off(name, callback) {
      var e = this.e || (this.e = {});
      var evts = e[name];
      var liveEvents = [];

      if (evts && callback) {
        for (var i = 0, len = evts.length; i < len; i++) {
          if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
      } // Remove event from queue to prevent memory leak
      // Suggested by https://github.com/lazd
      // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910


      liveEvents.length ? e[name] = liveEvents : delete e[name];
      return this;
    }
  };
  module.exports = E;
  module.exports.TinyEmitter = E;
  /***/
},
/* 53 */

/***/
function (module, exports, __webpack_require__) {
  var is = __webpack_require__(54);

  var delegate = __webpack_require__(55);
  /**
   * Validates all params and calls the right
   * listener function based on its target type.
   *
   * @param {String|HTMLElement|HTMLCollection|NodeList} target
   * @param {String} type
   * @param {Function} callback
   * @return {Object}
   */


  function listen(target, type, callback) {
    if (!target && !type && !callback) {
      throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
      throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
      throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
      return listenNode(target, type, callback);
    } else if (is.nodeList(target)) {
      return listenNodeList(target, type, callback);
    } else if (is.string(target)) {
      return listenSelector(target, type, callback);
    } else {
      throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
  }
  /**
   * Adds an event listener to a HTML element
   * and returns a remove listener function.
   *
   * @param {HTMLElement} node
   * @param {String} type
   * @param {Function} callback
   * @return {Object}
   */


  function listenNode(node, type, callback) {
    node.addEventListener(type, callback);
    return {
      destroy: function destroy() {
        node.removeEventListener(type, callback);
      }
    };
  }
  /**
   * Add an event listener to a list of HTML elements
   * and returns a remove listener function.
   *
   * @param {NodeList|HTMLCollection} nodeList
   * @param {String} type
   * @param {Function} callback
   * @return {Object}
   */


  function listenNodeList(nodeList, type, callback) {
    (0, _forEach.default)(Array.prototype).call(nodeList, function (node) {
      node.addEventListener(type, callback);
    });
    return {
      destroy: function destroy() {
        (0, _forEach.default)(Array.prototype).call(nodeList, function (node) {
          node.removeEventListener(type, callback);
        });
      }
    };
  }
  /**
   * Add an event listener to a selector
   * and returns a remove listener function.
   *
   * @param {String} selector
   * @param {String} type
   * @param {Function} callback
   * @return {Object}
   */


  function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
  }

  module.exports = listen;
  /***/
},
/* 54 */

/***/
function (module, exports) {
  /**
   * Check if argument is a HTML element.
   *
   * @param {Object} value
   * @return {Boolean}
   */
  exports.node = function (value) {
    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
  };
  /**
   * Check if argument is a list of HTML elements.
   *
   * @param {Object} value
   * @return {Boolean}
   */


  exports.nodeList = function (value) {
    var type = Object.prototype.toString.call(value);
    return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
  };
  /**
   * Check if argument is a string.
   *
   * @param {Object} value
   * @return {Boolean}
   */


  exports.string = function (value) {
    return typeof value === 'string' || value instanceof String;
  };
  /**
   * Check if argument is a function.
   *
   * @param {Object} value
   * @return {Boolean}
   */


  exports.fn = function (value) {
    var type = Object.prototype.toString.call(value);
    return type === '[object Function]';
  };
  /***/

},
/* 55 */

/***/
function (module, exports, __webpack_require__) {
  var closest = __webpack_require__(56);
  /**
   * Delegates event to a selector.
   *
   * @param {Element} element
   * @param {String} selector
   * @param {String} type
   * @param {Function} callback
   * @param {Boolean} useCapture
   * @return {Object}
   */


  function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);
    element.addEventListener(type, listenerFn, useCapture);
    return {
      destroy: function destroy() {
        element.removeEventListener(type, listenerFn, useCapture);
      }
    };
  }
  /**
   * Delegates event to a selector.
   *
   * @param {Element|String|Array} [elements]
   * @param {String} selector
   * @param {String} type
   * @param {Function} callback
   * @param {Boolean} useCapture
   * @return {Object}
   */


  function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
      return _delegate.apply(null, arguments);
    } // Handle Element-less usage, it defaults to global delegation


    if (typeof type === 'function') {
      // Use `document` as the first parameter, then apply arguments
      // This is a short way to .unshift `arguments` without running into deoptimizations
      return (0, _bind.default)(_delegate).call(_delegate, null, document).apply(null, arguments);
    } // Handle Selector-based usage


    if (typeof elements === 'string') {
      elements = document.querySelectorAll(elements);
    } // Handle Array-like based usage


    return (0, _map.default)(Array.prototype).call(elements, function (element) {
      return _delegate(element, selector, type, callback, useCapture);
    });
  }
  /**
   * Finds closest match and invokes callback.
   *
   * @param {Element} element
   * @param {String} selector
   * @param {String} type
   * @param {Function} callback
   * @return {Function}
   */


  function listener(element, selector, type, callback) {
    return function (e) {
      e.delegateTarget = closest(e.target, selector);

      if (e.delegateTarget) {
        callback.call(element, e);
      }
    };
  }

  module.exports = delegate;
  /***/
},
/* 56 */

/***/
function (module, exports) {
  var DOCUMENT_NODE_TYPE = 9;
  /**
   * A polyfill for Element.matches()
   */

  if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;
    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
  }
  /**
   * Finds the closest parent that matches a selector.
   *
   * @param {Element} element
   * @param {String} selector
   * @return {Function}
   */


  function closest(element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
      if (typeof element.matches === 'function' && element.matches(selector)) {
        return element;
      }

      element = element.parentNode;
    }
  }

  module.exports = closest;
  /***/
},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  __webpack_require__(58);

  __webpack_require__(59);

  __webpack_require__(60);

  __webpack_require__(61);

  __webpack_require__(62);

  __webpack_require__(64);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Handlebars "wrapper" is used by frontend code. It contains all helpers.
  // This runs in a browser / webpacked environment
  // TODO: Once all templates are precompiled, this file should use handlebars/runtime

  /* eslint @okta/okta-ui/no-specific-modules: 0 */
  // from vendor/lib


  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var clonedEscapeExpression = _handlebars.default.Utils.escapeExpression;

  _handlebars.default.Utils.escapeExpression = function (string) {
    return clonedEscapeExpression(string).replace(/&#x3D;/g, '=');
  };

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _moment = _interopRequireDefault(__webpack_require__(23));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta-ui/no-specific-modules: 0, max-params: 0, max-statements: 0 */


  function formatDate(format, dateInISOString) {
    return _moment.default.utc(dateInISOString).utcOffset('-07:00').format(format);
  }

  _handlebars.default.registerHelper('shortDate', _underscoreWrapper.default.partial(formatDate, 'MMM Do'));

  _handlebars.default.registerHelper('mediumDate', _underscoreWrapper.default.partial(formatDate, 'MMMM DD, YYYY'));

  _handlebars.default.registerHelper('longDate', _underscoreWrapper.default.partial(formatDate, 'MMMM DD, YYYY, h:mma'));

  _handlebars.default.registerHelper('formatDate', formatDate);

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray(o, minLen) {
    var _context59;

    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = (0, _slice.default)(_context59 = Object.prototype.toString.call(o)).call(_context59, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return (0, _from.default)(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof _symbol.default === "undefined" || !(0, _isIterable2.default)(Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator2.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if ((0, _isArray.default)(arr)) return arr;
  }

  var hbsEscape = _handlebars.default.Utils.escapeExpression;

  function trim(str) {
    return str && str.replace(/^\s+|\s+$/g, '');
  }

  function replaceTagsWithPlaceholders(source, tag, tagValue) {
    var escapedBeginningTag = hbsEscape("<".concat(tag, ">"));
    var escapedEndTag = hbsEscape("</".concat(tag, ">"));

    var _tagValue$split = tagValue.split(tag),
        _tagValue$split2 = _slicedToArray(_tagValue$split, 2),
        beginningTag = _tagValue$split2[0],
        endTag = _tagValue$split2[1];

    if (!(0, _includes.default)(source).call(source, escapedBeginningTag) && !(0, _includes.default)(source).call(source, escapedEndTag)) {
      var _context60;

      throw Error((0, _concat.default)(_context60 = "Parsed tag \"".concat(tag, "\" is not present in \"")).call(_context60, source, "\""));
    } else if (!(0, _includes.default)(tagValue).call(tagValue, tag)) {
      var _context61;

      throw Error((0, _concat.default)(_context61 = "Parsed tag \"".concat(tag, "\" is not present in \"")).call(_context61, tagValue, "\""));
    } else if (!beginningTag || !endTag) {
      throw Error("Template value \"".concat(tagValue, "\" must contain beginning and closing tags"));
    }

    return source.replace(escapedBeginningTag, beginningTag).replace(escapedEndTag, endTag);
  }
  /* eslint max-statements: [2, 18] */


  _handlebars.default.registerHelper('i18n', function (options) {
    var _context62, _context63;

    var params;
    var key = trim(options.hash.code);
    var bundle = trim(options.hash.bundle);
    var args = trim(options.hash['arguments']);
    var tags = (0, _map.default)(_context62 = (0, _filter.default)(_context63 = (0, _keys.default)(options.hash)).call(_context63, function (prop) {
      return prop.match(/^\$\d+/);
    })).call(_context62, function (prop) {
      return {
        tag: prop,
        value: options.hash[prop]
      };
    });

    if (args) {
      var _context64;

      params = (0, _map.default)(_context64 = _underscoreWrapper.default).call(_context64, trim(args).split(';'), function (param) {
        param = trim(param);
        var val;
        var data = this;
        /*
         * the context(data) may be a deep object, ex {user: {name: 'John', gender: 'M'}}
         * arguments may be 'user.name'
         * return data['user']['name']
         */

        _underscoreWrapper.default.each(param.split('.'), function (p) {
          val = val ? val[p] : data[p];
        });

        return val;
      }, this);
    }

    var localizedValue = _StringUtil.default.localize(key, bundle, params);

    if (tags.length < 1) {
      // No HTML tags provided - return the localized and escaped string
      return localizedValue;
    }

    var escapedString = hbsEscape(localizedValue);

    try {
      (0, _forEach.default)(tags).call(tags, function (tag) {
        escapedString = replaceTagsWithPlaceholders(escapedString, tag.tag, tag.value);
      });
      return new _handlebars.default.SafeString(escapedString);
    } catch (err) {
      _Logger.default.error(err.toString());

      return localizedValue;
    }
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta-ui/no-specific-modules: 0 */


  var CACHE_BUST_URL_PREFIX = '/assets';

  function prependCachebustPrefix(path) {
    if ((0, _indexOf.default)(path).call(path, CACHE_BUST_URL_PREFIX) === 0) {
      return path;
    }

    return CACHE_BUST_URL_PREFIX + path;
  }

  _handlebars.default.registerHelper('img', function (options) {
    var _context65;

    var cdn = typeof okta !== 'undefined' && okta.cdnUrlHostname || '';
    /*global okta */

    var hash = _underscoreWrapper.default.pick(options.hash, ['src', 'alt', 'width', 'height', 'class', 'title']);

    hash.src = '' + cdn + prependCachebustPrefix(hash.src);
    var attrs = (0, _map.default)(_context65 = _underscoreWrapper.default).call(_context65, hash, function (value, attr) {
      return attr + '="' + (attr === 'src' ? encodeURI(value) : _handlebars.default.Utils.escapeExpression(value)) + '"';
    });
    return new _handlebars.default.SafeString('<img ' + attrs.join(' ') + '/>');
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _markdownToHtml = _interopRequireDefault(__webpack_require__(63));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta-ui/no-specific-modules: 0 */


  _handlebars.default.registerHelper('markdown', function (mdText) {
    return (0, _markdownToHtml.default)(_handlebars.default, mdText);
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = mdToHtml;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Simple "markdown parser" - just handles markdown formatted links. If we
  // find that we need more extensive markdown support, we should include
  // a fully formulated markdown library like:
  // https://github.com/evilstreak/markdown-js


  var RE_LINK = /\[[^\]]*\]\([^)]*\)/gi;
  var RE_LINK_HREF = /\]\(([^)]*)\)/i;
  var RE_LINK_TEXT = /\[([^\]]*)\]/i;
  var RE_LINK_JS = /javascript:/gi; // Converts links
  // FROM:
  // [some link text](http://the/link/url)
  // TO:
  // <a href="http://the/link/url">some link text</a>

  function mdToHtml(Handlebars, markdownText) {
    // TODO: use precompiled templates OKTA-309852
    // eslint-disable-next-line @okta/okta-ui/no-bare-templates
    var linkTemplate = Handlebars.compile('<a href="{{href}}">{{text}}</a>');
    /* eslint  @okta/okta-ui/no-specific-methods: 0*/

    var res;

    if (!_underscoreWrapper.default.isString(markdownText)) {
      res = '';
    } else {
      res = Handlebars.Utils.escapeExpression(markdownText).replace(RE_LINK_JS, '').replace(RE_LINK, function (mdLink) {
        return linkTemplate({
          href: mdLink.match(RE_LINK_HREF)[1],
          text: mdLink.match(RE_LINK_TEXT)[1]
        });
      });
    }

    return new Handlebars.SafeString(res);
  }

  module.exports = exports.default;
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _handlebars = _interopRequireDefault(__webpack_require__(5));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint @okta/okta-ui/no-specific-modules: 0 */


  _handlebars.default.registerHelper('xsrfTokenInput', function () {
    return new _handlebars.default.SafeString('<input type="hidden" class="hide" name="_xsrfToken" ' + 'value="' + (0, _jqueryWrapper.default)('#_xsrfToken').text() + '">');
  });

  var _default = _handlebars.default;
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _ListView = _interopRequireDefault(__webpack_require__(66));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * See {@link src/framework/ListView} for more detail and examples from the base class.
   * @class module:Okta.ListView
   * @extends src/framework/ListView
   * @mixes module:Okta.View
   */


  var _default = _BaseView.default.decorate(_ListView.default);

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _View = _interopRequireDefault(__webpack_require__(14));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable max-statements */

  /**
     * Archer.ListView is a {@link src/framework/View} that operates on a
     * collection and builds a list of "things" of the same type.
     *
     * Automagically adds, removes and sorts upon standard collection events.
     *
     * Listen to collection events so the ListView will do the right thing when
     * a model is added or the collection is reset or sorted.
     *
     * @class src/framework/ListView
     * @extends src/framework/View
     * @param {Object} options options hash
     * @param {Object} options.collection The collection which this view operates on
     * @example
     * var UserList = Archer.ListView.extend({
     *   tagName: 'ul',
     *   item: '<li>{{fname}} {{lname}}</li>'
     * });
     *
     * var users = new Archer.Collection([
     *   {fname: 'John', lname: 'Doe'},
     *   {fname: 'Jane', lname: 'Doe'}
     * ]);
     *
     * var userList = new UserList({collection: users}).render();
     * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li></ul>"
     *
     * users.push({fname: 'Jim', lname: 'Doe'});
     * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li><li>Jim Doe</li></ul>"
     *
     * users.first().destroy();
     * userList.el; //=> "<ul><li>Jane Doe</li><li>Jim Doe</li></ul>"
     */


  var _default = _View.default.extend(
  /** @lends src/framework/ListView.prototype */
  {
    constructor: function constructor() {
      _View.default.apply(this, arguments);

      if (!this.collection) {
        throw new Error('Missing collection');
      }

      this.listenTo(this.collection, 'reset sort', this.reset);
      this.listenTo(this.collection, 'add', this.addItem);

      if (this.fetchCollection) {
        this.collection.fetch();
      } else {
        this.collection.each(this.addItem, this);
      }
    },

    /**
       * The view/template we will use to render each model in the collection.
       * @type {String|module:Okta.View}
       */
    item: null,

    /**
       * A selector in the local template where to append each item
       * @type {String}
       */
    itemSelector: null,

    /**
       * Empty the list and re-add everything from the collection.
       * Usefull for handling `collection.reset()` or for handling the initial load
       * @protected
       */
    reset: function reset() {
      var _this = this;

      this.removeChildren();
      this.collection.each(function (model, index) {
        _this.addItem(model, index);
      });
      return this;
    },

    /**
       * Add an item view to the list that will represent one model from the collection
       *
       * Listen to the model so when it is destoyed or removed from the collection
       * this item will remove itself from the list
       *
       * @param {Backbone.Model} model The model this row operates on
       * @protected
       */
    addItem: function addItem(model) {
      var view = this.add(this.item, this.itemSelector, {
        options: {
          model: model
        }
      }).last();

      if (this.state && this.state.get('trackItemAdded')) {
        this.state.trigger('itemAdded', view);
      }

      view.listenTo(model, 'destroy remove', view.remove);
      return this;
    },
    addShowMore: _underscoreWrapper.default.noop
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 67 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var optionsTemplate = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "icon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 96
          },
          "end": {
            "line": 1,
            "column": 104
          }
        }
      }) : helper)) + "\"></span>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 133
          },
          "end": {
            "line": 1,
            "column": 142
          }
        }
      }) : helper));
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"option-subtitle\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 192
          },
          "end": {
            "line": 1,
            "column": 204
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"\" class=\"icon-16 " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\" data-se=\"" + alias4((helper = (helper = lookupProperty(helpers, "seleniumId") || (depth0 != null ? lookupProperty(depth0, "seleniumId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "seleniumId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 64
          }
        }
      }) : helper)) + "\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 120
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 120
          },
          "end": {
            "line": 1,
            "column": 149
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 149
          },
          "end": {
            "line": 1,
            "column": 215
          }
        }
      })) != null ? stack1 : "") + "</a>";
    },
    "useData": true
  });

  var BaseDropDownDropDownOption = _BaseView.default.extend({
    tagName: 'li',
    events: {
      click: function click(e) {
        e.preventDefault();
        this.action && this.action.call(this);
      }
    },
    constructor: function constructor() {
      _BaseView.default.apply(this, arguments);

      this.$el.addClass('okta-dropdown-option option');
    },
    render: function render() {
      this.$el.html(optionsTemplate({
        icon: _underscoreWrapper.default.result(this, 'icon'),
        className: _underscoreWrapper.default.result(this, 'className') || '',
        title: _underscoreWrapper.default.result(this, 'title'),
        subtitle: _underscoreWrapper.default.result(this, 'subtitle'),
        seleniumId: _underscoreWrapper.default.result(this, 'seleniumId')
      }));

      if (_underscoreWrapper.default.result(this, 'disabled')) {
        this.disable();
      }

      return this;
    },
    disable: function disable() {
      var _context66;

      this.$el.addClass('option-disabled');
      (0, _find.default)(_context66 = this.$el).call(_context66, 'a').attr('tabindex', '-1');
    }
  });

  var _default = _BaseView.default.extend({
    events: {
      'click a.option-selected': function clickAOptionSelected(e) {
        e.preventDefault();

        if (_underscoreWrapper.default.result(this, 'disabled')) {
          e.stopPropagation();
        }
      },
      'click .dropdown-disabled': function clickDropdownDisabled(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    items: [],
    constructor: function constructor() {
      var className = this.className; // In this very specific case we want to NOT append className to $el
      // but to the <a> tag in the template
      // so we want to disable backbone default functionality.

      this.className = null;

      _BaseView.default.apply(this, arguments);

      this.className = className;
      this.$el.addClass('dropdown more-actions float-l');

      _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, 'items'), function (option) {
        this.addOption(option, this.options);
      }, this);
    },
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "icon",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 176
            },
            "end": {
              "line": 1,
              "column": 184
            }
          }
        }) : helper)) + "\"></span>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"off-screen\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "screenReaderText") || (depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "screenReaderText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 249
            },
            "end": {
              "line": 1,
              "column": 269
            }
          }
        }) : helper)) + "</span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"link-button " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "className",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 31
            },
            "end": {
              "line": 1,
              "column": 44
            }
          }
        }) : helper)) + " link-button-icon option-selected center\" aria-expanded=\"false\" aria-controls=\"okta-dropdown-options\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 146
            },
            "end": {
              "line": 1,
              "column": 200
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 200
            },
            "end": {
              "line": 1,
              "column": 283
            }
          }
        })) != null ? stack1 : "") + "<span class=\"option-selected-text\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "title",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 318
            },
            "end": {
              "line": 1,
              "column": 327
            }
          }
        }) : helper)) + "</span><span class=\"icon-dm\"></span></a><div id=\"okta-dropdown-options\" class=\"options clearfix\" style=\"display: none;\"><ul class=\"okta-dropdown-list options-wrap clearfix\"></ul></div>";
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      var _context67;

      var className = [_underscoreWrapper.default.result(this, 'className') || '', _underscoreWrapper.default.result(this, 'disabled') ? 'dropdown-disabled' : ''];
      return {
        icon: _underscoreWrapper.default.result(this, 'icon'),
        className: (0, _trim.default)(_context67 = _jqueryWrapper.default).call(_context67, className.join(' ')),
        title: _underscoreWrapper.default.result(this, 'title'),
        screenReaderText: _underscoreWrapper.default.result(this, 'screenReaderText')
      };
    },
    addOption: function addOption(proto, options) {
      this.add(BaseDropDownDropDownOption.extend(proto), 'ul.options-wrap', {
        options: options || {}
      });
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _ReadModeBar = _interopRequireDefault(__webpack_require__(69));

  var _Toolbar = _interopRequireDefault(__webpack_require__(27));

  var _ErrorBanner = _interopRequireDefault(__webpack_require__(70));

  var _ErrorParser = _interopRequireDefault(__webpack_require__(71));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  var _InputContainer = _interopRequireDefault(__webpack_require__(72));

  var _InputFactory = _interopRequireDefault(__webpack_require__(73));

  var _InputLabel = _interopRequireDefault(__webpack_require__(74));

  var _InputWrapper = _interopRequireDefault(__webpack_require__(75));

  var _SettingsModel = _interopRequireDefault(__webpack_require__(17));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: [2, 11] */


  var template = _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 class=\"o-form-title-bar\" data-se=\"o-form-title-bar\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 75
          },
          "end": {
            "line": 1,
            "column": 84
          }
        }
      }) : helper)) + "</h2>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 192
          },
          "end": {
            "line": 1,
            "column": 288
          }
        }
      })) != null ? stack1 : "";
    },
    "4": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 267
          },
          "end": {
            "line": 1,
            "column": 276
          }
        }
      }) : helper)) + "</h2>";
    },
    "6": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"okta-form-subtitle o-form-explain\" data-se=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "subtitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 385
          },
          "end": {
            "line": 1,
            "column": 397
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 96
          }
        }
      })) != null ? stack1 : "") + "<div data-se=\"o-form-content\" class=\"o-form-content " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "layout") || (depth0 != null ? lookupProperty(depth0, "layout") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "layout",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 148
          },
          "end": {
            "line": 1,
            "column": 158
          }
        }
      }) : helper)) + " clearfix\">" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 169
          },
          "end": {
            "line": 1,
            "column": 299
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(6, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 299
          },
          "end": {
            "line": 1,
            "column": 408
          }
        }
      })) != null ? stack1 : "") + "<div class=\"o-form-error-container\" data-se=\"o-form-error-container\"></div><div class=\"o-form-fieldset-container\" data-se=\"o-form-fieldset-container\"></div></div>";
    },
    "useData": true
  });

  var sectionTitleTemplate = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h2 class=\"o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 24
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper)) + "</h2>";
    },
    "useData": true
  });

  var pointerEventsSupported = (0, _jqueryWrapper.default)('<div>').css({
    'pointer-events': 'auto'
  })[0].style.pointerEvents === 'auto'; // polyfill for `pointer-events: none;` in IE < 11
  // Logic borrowed from https://github.com/kmewhort/pointer_events_polyfill (BSD)

  function pointerEventsPolyfill(e) {
    if (!pointerEventsSupported && this.$el.hasClass('o-form-saving')) {
      var $el = (0, _jqueryWrapper.default)(e.currentTarget);
      $el.css('display', 'none');
      var underneathElem = document.elementFromPoint(e.clientX, e.clientY);
      $el.css('display', 'block');
      e.target = underneathElem;
      (0, _jqueryWrapper.default)(underneathElem).trigger(e);
      return false;
    }
  }

  var events = {
    submit: function submit(e) {
      e.preventDefault();

      this.__save();
    }
  };

  _underscoreWrapper.default.each(['click', 'dblclick', 'mousedown', 'mouseup'], function (event) {
    events[event + ' .o-form-input'] = pointerEventsPolyfill;
  });

  var attributes = function attributes(model) {
    model || (model = {});
    var collection = model && model.collection || {};
    return {
      method: 'POST',
      action: _underscoreWrapper.default.result(model, 'urlRoot') || _underscoreWrapper.default.result(collection, 'url') || window.location.pathname,
      'data-se': 'o-form',
      slot: 'content'
    };
  };

  var convertSavingState = function convertSavingState(rawSavingStateEvent, defaultEvent) {
    rawSavingStateEvent || (rawSavingStateEvent = '');
    var savingStateEvent = [];

    if (_underscoreWrapper.default.isString(rawSavingStateEvent)) {
      savingStateEvent = rawSavingStateEvent.split(' ');
    }

    savingStateEvent = _underscoreWrapper.default.union(savingStateEvent, defaultEvent);
    return savingStateEvent.join(' ');
  };

  var getErrorSummary = function getErrorSummary() {
    var responseJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if ((0, _isArray.default)(responseJSON.errorCauses) && responseJSON.errorCauses.length > 0) {
      //set errorSummary from first errorCause which is not field specific error
      return responseJSON.errorCauses[0].errorSummary;
    } else {
      //set errorSummary from top level errorSummary
      return responseJSON.errorSummary;
    }
  };
  /**
   * A Form utility framework
   *
   * Okta.Form is a form that operates on one flat model
   * It exposes one main factory method, {@link module:Okta.Form#addInput|addInput}, which add inputs to the form,
   * and each input operates on one field in the model, identified by the `name` field.
   *
   * See:
   * [Basic O-Form Tutorial](https://github.com/okta/courage/wiki/Basic-O-Form)
   *
   * @class module:Okta.Form
   * @extends module:Okta.View
   * @param {Object} options options hash (See {@link module:Okta.View|View})
   * @param {Object} options.model the model this form operates on
   * @param {Boolean} [options.label-top=false] position label on top of inputs
   * @param {Boolean} [options.wide=false] Use a wide input layout for all input
   */

  /**
   * Fired when the "Save" button is clicked
   * @event module:Okta.Form#save
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired after the model is successfully saved - applies when {@link module:Okta.Form#autoSave|autoSave}
   * is set to true
   * @event module:Okta.Form#saved
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired when the model fires an invalid event or an error event;
   * @event module:Okta.Form#error
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired when the form layout is likely to be resized
   * @event module:Okta.Form#resize
   * @param {module:Okta.Model} model Model used in the form
   */

  /**
   * Fired when the "Cancel" button is clicked
   * @event module:Okta.Form#cancel
   */


  var _default = _BaseView.default.extend(
  /** @lends module:Okta.Form.prototype */
  {
    /**
     * Specifies how to validate form:
     * - In case "local" string provided as a value of the property,
     * the form will validate only fields added as inputs to the form;
     * - In case array is provided, the validation will be performed only for fields specified in array;
     * - In case function is provided, provided function will be used as a validation function,
     * it must return an error object with the format {fieldName: 'error text'} with as many fields as you need.
     * @name validate
     * @memberof module:Okta.Form
     * @type {String|Array|Function}
     * @instance
     */
    constructor: function constructor(options) {
      /* eslint max-statements: 0, complexity: 0 */
      options || (options = {});
      this.options = options;

      if (options.settings) {
        this.settings = options.settings;
      } else {
        this.settings = options.settings = new _SettingsModel.default();
      }

      this.id = _underscoreWrapper.default.uniqueId('form');
      this.tagName = 'form';

      _underscoreWrapper.default.defaults(this.events, events);

      _underscoreWrapper.default.defaults(this.attributes, attributes(options.model));

      this.__buttons = [];
      this.__errorFields = {};

      this.__saveModelState(options.model);

      if (this.step) {
        if (!this.save) {
          this.save = !this.totalSteps || this.step === this.totalSteps ? 'Finish' : 'Next';
        }

        this.className += ' wizard';
      }

      this.className += ' o-form';
      this.__toolbar = this.__createToolbar(options);

      _BaseView.default.call(this, options);

      _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, 'inputs') || [], function (input) {
        // to ingore extra argumests from `each` iteratee function
        // http://underscorejs.org/#each
        this.__addLayoutItem(input);
      }, this);

      this.add(this.__toolbar, '');
      this.listenTo(this.model, 'change:__edit__', this.__applyMode);
      this.listenTo(this.model, 'invalid error', _underscoreWrapper.default.throttle(function (model, resp, showBanner) {
        this.__showErrors(model, resp, showBanner !== false);
      }, 100, {
        trailing: false
      }));
      this.listenTo(this.model, 'form:resize', function () {
        this.trigger('resize');
      });
      this.listenTo(this.model, 'form:cancel', _underscoreWrapper.default.throttle(this.__cancel, 100, {
        trailing: false
      }));
      this.listenTo(this.model, 'form:previous', _underscoreWrapper.default.throttle(this.__previous, 100, {
        trailing: false
      }));
      this.__save = _underscoreWrapper.default.throttle(this.__save, 200, {
        trailing: false
      });
      this.listenTo(this.model, 'form:save', function () {
        this.$el.submit();
      });
      this.listenTo(this.model, 'sync', function () {
        if (this.model.get('__edit__')) {
          this.model.set('__edit__', false, {
            silent: true
          });
        }

        this.__saveModelState(this.model);

        this.render();
      });
      var hasSavingState = this.getAttribute('hasSavingState');

      if (this.getAttribute('autoSave')) {
        this.listenTo(this, 'save', function (model) {
          var _this = this;

          var xhr = model.save();

          if (xhr && xhr.done) {
            xhr.done(function () {
              _this.trigger('saved', model);
            });
          }
        });

        if (_underscoreWrapper.default.isUndefined(hasSavingState)) {
          hasSavingState = true;
        }
      }
      /*
      * Attach model event listeners
      * by default, model's request event starts the form saving state,
      * error and sync event stops it
      * you can define customized saving start and stop state, like
      * customSavingState: {start: 'requestingAdditionalInfo', stop: 'retrievedAdditionalInfo'}
      * doing this does not override the default events
      */


      if (hasSavingState) {
        var customSavingState = this.getAttribute('customSavingState', {});
        this.listenTo(this.model, convertSavingState(customSavingState.start || '', ['request']), this.__setSavingState);
        this.listenTo(this.model, convertSavingState(customSavingState.stop || '', ['error', 'sync']), this.__clearSavingState);
      }
    },

    /**
     * Create the bottom button bar
     * @param  {Object} options options h
     * @return {Okta.View} The toolbar
     * @private
     */
    __createToolbar: function __createToolbar(options) {
      var danger = this.getAttribute('danger');
      var saveBtnClassName = danger === true ? 'button-error' : 'button-primary';
      var toolbar = new _Toolbar.default(_underscoreWrapper.default.extend({
        save: this.save || _StringUtil.default.localize('oform.save', 'courage'),
        saveId: this.saveId,
        saveClassName: saveBtnClassName,
        cancel: this.cancel || _StringUtil.default.localize('oform.cancel', 'courage'),
        noCancelButton: this.noCancelButton || false,
        noSubmitButton: this.noSubmitButton || false,
        buttonOrder: this.buttonOrder,
        hasPrevStep: this.step && this.step > 1
      }, options || this.options));

      _underscoreWrapper.default.each(this.__buttons, function (args) {
        toolbar.addButton.apply(toolbar, args);
      });

      return toolbar;
    },
    className: '',
    attributes: {},
    events: {},

    /**
     * An array of input configurations to render in the form
     * @type {Array}
     */
    inputs: [],
    template: null,

    /**
     * Does the form support read/edit toggle.
     * @type {Boolean|Function}
     * @default false
     */
    read: false,

    /**
     * Is the form in readOnly mode.
     * @type {Boolean|Function}
     * @default false
     */
    readOnly: false,

    /**
     * Should we not render the button bar
     * @type {Boolean|Function}
     * @default false
     */
    noButtonBar: false,

    /**
     * Should we not render a cancel button
     * @type {Boolean|Function}
     * @default false
     */
    noCancelButton: false,

    /**
     * Should we not render a save button
     * @type {Boolean}
     * @default false
     */
    noSubmitButton: false,

    /**
     * Set the order of the save, cancel and previous buttons (left to right).
     * @type {Array.<string>}
     * @default ['previous', 'save', 'cancel']
     */
    buttonOrder: ['previous', 'save', 'cancel'],

    /**
     * The text on the save button
     * @type {String}
     * @default "Save"
     */
    save: null,

    /**
     * The text on the cancel button
     * @type {String}
     * @default "Cancel"
     */
    cancel: null,

    /**
     * To use button-error to style the submit button instead of button-primary.
     * @type {Boolean|Function}
     * @default false
     */
    danger: false,

    /**
     * A layout CSS class to add to the form
     * @type {String|Function}
     * @default ""
     */
    layout: '',

    /**
     * The step this form is in the context of a wizard
     * @type {Number}
     */
    step: undefined,

    /**
     * The total numbers of steps the wizard this form is a part of has
     * @type {Number}
     */
    totalSteps: undefined,

    /**
     * The form's title
     * @type {String|Function}
     */
    title: null,

    /**
     * The form's subtitle
     * @type {String|Function}
     */
    subtitle: null,

    /**
     * Auto-save the model when hitting save. Triggers a `saved` event when done
     * @type {Boolean}
     * @default false
     */
    autoSave: false,

    /**
     * Scroll to the top of the form on error
     * @type {Boolean|Function}
     * @default true
     */
    scrollOnError: true,

    /**
     * Show the error banner upon error
     * @type {Boolean|Function}
     * @default true
     */
    showErrors: true,

    /**
     * The form's scrollable area
     * @type {String}
     * @default ".o-form-content"
     */
    resizeSelector: '.o-form-content',

    /**
     * Sets whether or not the form shows the saving state when
     * the model is saved.  Has no effect on setSavingState and clearSavingState as those are manual calls
     * to trigger/clear the saving state.
     * @name hasSavingState
     * @memberof module:Okta.Form
     * @type {Boolean}
     * @default false
     * @instance
     */

    /**
     * Get an attribute value from options or instance.
     * Prefer options value over instance value
     * @param  {String} name Name of the attribute
     * @param  {Object} defaultValue the default value to return if the attribute is not found
     * @return {Object} The value
     */
    getAttribute: function getAttribute(name, defaultValue) {
      var value = _underscoreWrapper.default.resultCtx(this.options, name, this);

      if (_underscoreWrapper.default.isUndefined(value)) {
        value = _underscoreWrapper.default.result(this, name);
      }

      return !_underscoreWrapper.default.isUndefined(value) ? value : defaultValue;
    },

    /**
     * Does this form have a "read" mode
     * @return {Boolean}
     */
    hasReadMode: function hasReadMode() {
      return !!this.getAttribute('read');
    },

    /**
     * Is this form in "read only" mode
     * @return {Boolean}
     */
    isReadOnly: function isReadOnly() {
      return !!this.getAttribute('readOnly');
    },

    /**
     * Does this form have a button bar
     * @return {Boolean}
     */
    hasButtonBar: function hasButtonBar() {
      return !(this.getAttribute('noButtonBar') || this.isReadOnly());
    },
    render: function render() {
      this.__readModeBar && this.__readModeBar.remove();

      if (this.hasReadMode() && !this.isReadOnly()) {
        var readModeBar = _ReadModeBar.default.extend({
          formTitle: this.getAttribute('title', '')
        });

        this.__readModeBar = this.add(readModeBar, '.o-form-title-bar').last();
      }

      var html = template({
        layout: this.getAttribute('layout', ''),
        title: this.getAttribute('title', '', true),
        subtitle: this.getAttribute('subtitle', '', true),
        hasReadMode: this.hasReadMode()
      });
      this.$el.html(html);
      delete this.template;

      _BaseView.default.prototype.render.apply(this, arguments);

      this.__applyMode();

      return this;
    },

    /**
     * Changes form UI to indicate saving.  Disables all inputs and buttons.  Use this function if you have set
     * hasSavingState to false on the the form
     * @private
     */
    __setSavingState: function __setSavingState() {
      this.model.trigger('form:set-saving-state');
      this.$el.addClass('o-form-saving');
    },

    /**
     * Changes form UI back to normal from the saving state.  Use this function if you are have set hasSavingState
     * to false on the form
     * @private
     */
    __clearSavingState: function __clearSavingState() {
      this.model.trigger('form:clear-saving-state');
      this.$el.removeClass('o-form-saving');
    },

    /**
     * Toggles the visibility of the bottom button bar
     * @private
     */
    __toggleToolbar: function __toggleToolbar() {
      this.__toolbar && this.__toolbar.remove();

      if (this.hasButtonBar() && this._editMode()) {
        this.__toolbar = this.__createToolbar();
        this.add(this.__toolbar, '');
      }

      this.trigger('resize');
    },

    /**
     * Cancels this form
     * - Reset the model to the previous state
     * - Clears all errors
     * - Triggers a `cancel` event
     * - Sets the model to read mode (if applicable)
     * @private
     * @fires cancel
     */
    __cancel: function __cancel() {
      var edit = this.model.get('__edit__');
      /* eslint max-statements: [2, 12] */

      this.model.clear({
        silent: true
      });
      var data;

      if (this.model.sanitizeAttributes) {
        data = this.model.sanitizeAttributes(this.__originalModel);
      } else {
        data = _underscoreWrapper.default.clone(this.__originalModel);
      }

      this.model.set(data, {
        silent: true
      });
      this.trigger('cancel', this.model);
      this.model.trigger('cache:clear');

      if (edit) {
        this.model.set('__edit__', false, {
          silent: true
        });
        this.model.trigger('change:__edit__', this.model, false);
      }

      this.clearErrors();
    },

    /**
     * Runs {@link module:Okta.Form#validate|validate} to check the model state.
     * Triggers an "invalid" event on the model if validation fails
     * @returns {Boolean}
     */
    isValid: function isValid() {
      var res;
      var self = this;

      function validateArray(arr) {
        var _context68;

        return (0, _reduce.default)(_context68 = _underscoreWrapper.default).call(_context68, arr, function (memo, fieldName) {
          return _underscoreWrapper.default.extend(memo, self.model.validateField(fieldName));
        }, {});
      }

      if (_underscoreWrapper.default.isUndefined(this.validate)) {
        return this.model.isValid();
      } else if (_underscoreWrapper.default.isFunction(this.validate)) {
        res = this.validate();
      } else if (_underscoreWrapper.default.isArray(this.validate)) {
        res = validateArray(this.validate);
      } else if (this.validate === 'local') {
        var _context69;

        res = validateArray((0, _map.default)(_context69 = this.getInputs()).call(_context69, function (input) {
          return input.options.name;
        }));
      }

      if (!_underscoreWrapper.default.isEmpty(res)) {
        this.model.trigger('invalid', this.model, res);
        return false;
      } else {
        return true;
      }
    },

    /**
     * A throttled function that saves the form not more than once every 100 ms
     * Basically all this method does is trigger a `save` event
     * @fires save
     * @private
     */
    __save: function __save() {
      this.clearErrors();

      if (this.isValid()) {
        this.trigger('save', this.model);
      }
    },

    /**
     * In the context of a wizard, go to previous state
     * Technically all this method does is trigger a `previous` event
     * @param  {Event} e
     * @private
     */
    __previous: function __previous() {
      this.trigger('previous', this.model);
    },

    /**
     * Renders the form in the correct mode based on the model.
     * @private
     */
    __applyMode: function __applyMode() {
      this.clearErrors();

      this.__toggleToolbar();

      if (this._editMode()) {
        this.$el.addClass('o-form-edit-mode');
        this.$el.removeClass('o-form-read-mode');
        this.$('.o-form-content').removeClass('rounded-btm-4');
        this.focus();
      } else {
        this.$el.removeClass('o-form-edit-mode');
        this.$el.addClass('o-form-read-mode');
        this.$('.o-form-content').addClass('rounded-btm-4');
      }
    },

    /**
     * Is the form in edit mode
     * @return {Boolean}
     * @private
     */
    _editMode: function _editMode() {
      return this.model.get('__edit__') || !this.hasReadMode();
    },

    /**
     * Function can be overridden to alter top level error summary.
     * @param {Object} responseJSON
     *
     * @example
     * // responseJSON object
     * {
     *  errorCauses: [{errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."}]
     *  errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."
     *  errorCode: "E0000001"
     *  errorId: "oaepsrTCHrhT-eIi8XTm6KWWg"
     *  errorLink: "E0000001"
     *  errorSummary: "Api validation failed: networkZone"
     * }
     *
     * @method
     * @default _.identity
     */
    parseErrorMessage: _underscoreWrapper.default.identity,
    _handleErrorScroll: function _handleErrorScroll() {
      if (!this.getAttribute('scrollOnError')) {
        return;
      }

      var $el = (0, _jqueryWrapper.default)('#' + this.id + ' .o-form-error-container');

      if ($el.length) {
        var $scrollContext = $el.scrollParent();
        var scrollTop; // scrollParent was almost awesome...
        // but it returns document if there are no other scrollable parents
        // document does not have offset, so here we have to replace with html, body
        // Additionally when the scroll context is html, body, $el.offset().top is fixed
        // versus when it has a different scroll context it's dynamic and requires the
        // calculation below.

        if ($scrollContext[0] === document) {
          $scrollContext = (0, _jqueryWrapper.default)('html, body');
          scrollTop = $el.offset().top;
        } else {
          scrollTop = $scrollContext.scrollTop() + $el.offset().top - $scrollContext.offset().top;
        }

        $scrollContext.animate({
          scrollTop: scrollTop
        }, 400);
      }
    },

    /**
     * Show an error message based on an XHR error
     * @param  {Okta.BaseModel} model the model
     * @param  {jqXHR} xhr The jQuery XmlHttpRequest Object
     * @private
     */
    __showErrors: function __showErrors(model, resp, showBanner) {
      this.trigger('error', model);
      /* eslint max-statements: 0 */

      if (!this.getAttribute('showErrors')) {
        return;
      }

      var errorSummary;

      var responseJSON = _ErrorParser.default.getResponseJSON(resp);

      var validationErrors = _ErrorParser.default.parseFieldErrors(resp); // trigger events for field validation errors


      if (_underscoreWrapper.default.size(validationErrors)) {
        _underscoreWrapper.default.each(validationErrors, function (errors, field) {
          var _context70;

          this.model.trigger('form:field-error', this.__errorFields[field] || field, (0, _map.default)(_context70 = _underscoreWrapper.default).call(_context70, errors, function (error) {
            return /^model\.validation/.test(error) ? _StringUtil.default.localize(error, 'courage') : error;
          }));
        }, this);
      } else {
        responseJSON = this.parseErrorMessage(responseJSON);
        errorSummary = getErrorSummary(responseJSON);
      } // show the error message


      if (showBanner) {
        this.$('.o-form-error-container').addClass('o-form-has-errors');
        this.add(_ErrorBanner.default, '.o-form-error-container', {
          options: {
            errorSummary: errorSummary
          }
        });
      } // slide to and focus on the error message


      this._handleErrorScroll();

      this.model.trigger('form:resize');
    },

    /**
     * Clears the error banner
     * @private
     */
    clearErrors: function clearErrors() {
      this.$('.o-form-error-container').removeClass('o-form-has-errors');
      this.model.trigger('form:clear-errors');
      this.model.trigger('form:resize');
    },

    /**
     * Toggles between edit and read mode
     */
    toggle: function toggle() {
      this.model.set('__edit__', !this.hasReadMode() || !this.model.get('__edit__'));
      return this;
    },
    __addLayoutItem: function __addLayoutItem(input) {
      if (_InputFactory.default.supports(input)) {
        this.addInput(input);
      } else {
        this.__addNonInputLayoutItem(input);
      }
    },
    __addNonInputLayoutItem: function __addNonInputLayoutItem(item) {
      var itemOptions = _underscoreWrapper.default.omit(item, 'type');

      switch (item.type) {
        case 'sectionTitle':
          this.addSectionTitle(item.title, _underscoreWrapper.default.omit(itemOptions, 'title'));
          break;

        case 'divider':
          this.addDivider(itemOptions);
          break;

        default:
          throw new Error('unknown input: ' + item.type);
      }
    },

    /**
     * Adds a view to the buttons tool bar
     * @param {Object} params parameterized button options
     * @param {Object} options options to send to {@link module:Okta.View#add|View.add}
     */
    addButton: function addButton(params, options) {
      this.__toolbar && this.__toolbar.addButton(params, options);

      this.__buttons.push([params, options]);
    },

    /**
     * Adds a divider
     */
    addDivider: function addDivider(options) {
      this.add('<div class="okta-form-divider form-divider"></div>');

      _FormUtil.default.applyShowWhen(this.last(), options && options.showWhen);

      _FormUtil.default.applyToggleWhen(this.last(), options && options.toggleWhen);

      return this;
    },

    /**
     * Adds section header
     * @param {String} title
     */
    addSectionTitle: function addSectionTitle(title, options) {
      this.add(sectionTitleTemplate({
        title: title
      }));

      _FormUtil.default.applyShowWhen(this.last(), options && options.showWhen);

      _FormUtil.default.applyToggleWhen(this.last(), options && options.toggleWhen);

      return this;
    },

    /**
     * Add a form input
     * @param {Object} options Options to describe the input
     * @param {String} options.type The input type.
     * The options are: `text`, `textarea`, `select`, `checkbox`, `radio`, `switch`,
     * `password`, `number`, `textselect`, `date`, `grouppicker`, `admingrouppicker`, `su-orgspicker`
     * `file/image`, `file/cert`, `checkboxset`, `list`, `group`, `zonepicker`
     * @param {String} options.name The name of the model field this input mutates
     * @param {String|Function} [options.label]
     * The input label text.
     * When passed as a function, will invoke the function (in the context of the {@link InputLabel})
     * on render time, and use the returned value.
     * @param {String} [options.sublabel] The input sub label text
     * @param {String} [options.tooltip] A popover tooltip to be displayed next to the label
     * @param {String} [options.placeholder] Placeholder text.
     * @param {String} [options.explain] Explanation text to render below the input
     * @param {Okta.View} [options.customExplain] A custom view to render below the input (deprecated)
     * @param {Boolean} [options.disabled=false] Make this input disabled
     * @param {Boolean} [options.wide=false] Use a wide input layout
     * @param {Boolean} [options.label-top=false] position label on top of an input
     * @param {Boolean} [options.explain-top=false] position explain on top of an input (requires label-top=true)
     * @param {Number} [options.multi] have multiple in-line inputs. useful when `input` is passed as an array of inputs
     * @param {String} [options.errorField] The API error field here that maps to this input
     * @param {Boolean} [options.inlineValidation=true] Validate input on focusout
     * @param {String} [options.ariaLabel] Used to add aria-label attribute to the input when label is not present.
     * @param {Object} [options.options]
     * In the context of `radio` and `select`, a key/value set of options
     *
     * @param {Object} [options.params]
     * Widget specific parameters. Varies per input.
     *
     * @param {BaseInput|Object[]} [options.input]
     * - A custom input "class" or instance - preferably a **class**, so we can automagically assign the right
     * parameters when initializing it
     * - An array of input definition object literals (such as this one)
     *
     * @param {Object} [options.showWhen]
     * Setting to define when to show (or hide) the input. The input is visible by default.
     *
     * @param {Object} [options.bindings]
     * Bind a certain model attribute to a callback function, so the function is being called on render,
     * and any time this model field changes.
     * This is similar to `showWhen` but is not limited to toggling.
     *
     * @param {Function} [options.render]
     * A post-render hook that will run upon render on InputWrapper
     *
     * @param {String|Function} className   A className to apply on the {@link InputWrapper}
     *
     * @param {Function} [options.initialize]
     * An `initialize` function to run when initializing the {@link InputWrapper}
     * Useful for state mutation on start time, and complex state logic
     *
     * @example
     * // showhen: the field will be visible when `advanced` is set to `true`
     * // and `mode` is set to `"ON"`.
     * showWhen: {
     *   'advanced': true,
     *   'mode': function (value) {
     *     return value == 'ON'; // this is identical to this.model.get('mode') == 'ON'
     *   }
     * }
     *
     * @example
     * // bindings
     * bindings: {
     *   'status mode': function (status, mode) {
     *      var labelView = this.getLabel();
     *      if (status == 1) {
     *        labelView.options.label = 'Something';
     *      }
     *      else {
     *        labelView.options.label = mode;
     *      }
     *      labelView.render();
     *   }
     * }
     */
    addInput: function addInput(_options) {
      var _context71, _context72, _context73;

      _options = _underscoreWrapper.default.clone(_options);

      _FormUtil.default.validateInput(_options, this.model);

      var inputsOptions = (0, _reverse.default)(_context71 = _FormUtil.default.generateInputOptions(_options, this, this.__createInput)).call(_context71); // We need a local variable here to keep track
      // as addInput can be called either directy or through the inputs array.

      if (_underscoreWrapper.default.isEmpty(this.getInputs().toArray())) {
        _underscoreWrapper.default.extend(inputsOptions[0], {
          validateOnlyIfDirty: true
        });
      }

      var inputs = (0, _map.default)(_context72 = _underscoreWrapper.default).call(_context72, inputsOptions, this.__createInput, this);

      _underscoreWrapper.default.each(inputsOptions, function (input) {
        if (input.errorField) {
          this.__errorFields[input.errorField] = input.name;
        }
      }, this);

      var options = {
        inputId: _underscoreWrapper.default.last(inputs).options.inputId,
        input: inputs,
        multi: inputsOptions.length > 1 ? inputsOptions.length : undefined
      };

      _underscoreWrapper.default.extend(options, _underscoreWrapper.default.omit(this.options, 'input'), _underscoreWrapper.default.omit(_options, 'input'));

      var inputWrapper = this.__createWrapper(options);

      if (options.label !== false) {
        inputWrapper.add(this.__createLabel(options));
      }

      inputWrapper.add(this._createContainer(options));
      inputWrapper.type = options.type || options.input.type || 'custom';
      var args = (0, _concat.default)(_context73 = [inputWrapper]).call(_context73, _underscoreWrapper.default.rest(arguments));
      return this.add.apply(this, args);
    },

    /**
     * @private
     */
    __createInput: function __createInput(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.INPUT_OPTIONS);
      return _InputFactory.default.create(options);
    },

    /**
     * @private
     */
    __createWrapper: function __createWrapper(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.WRAPPER_OPTIONS);
      return new _InputWrapper.default(options);
    },

    /**
     * @private
     */
    __createLabel: function __createLabel(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.LABEL_OPTIONS);
      return new _InputLabel.default(options);
    },

    /**
     * @private
     */
    _createContainer: function _createContainer(options) {
      options = _underscoreWrapper.default.pick(options, _FormUtil.default.CONTAINER_OPTIONS);
      return new _InputContainer.default(options);
    },

    /**
     * Stores the current attributes of the model to a private property
     * @param  {Okta.BaseModel} model The model
     * @private
     */
    __saveModelState: function __saveModelState(model) {
      this.__originalModel = _jqueryWrapper.default.extend(true, {}, model.attributes);
    },

    /**
     * @override
     * @ignore
     */
    add: function add() {
      var args = _underscoreWrapper.default.toArray(arguments);

      typeof args[1] === 'undefined' && (args[1] = '> div.o-form-content > .o-form-fieldset-container');
      return _BaseView.default.prototype.add.apply(this, args);
    },

    /**
     * Set the focus on the first input in the form
     */
    focus: function focus() {
      var first = this.getInputs().first();

      if (first && first.focus) {
        first.focus();
      }

      return this;
    },

    /**
     * Disable all inputs in the form
     * @deprecated not currently in use
     */
    disable: function disable() {
      this.invoke('disable');
      return this;
    },

    /**
     * Enable all inputs in the form
     * @deprecated not currently in use
     */
    enable: function enable() {
      this.invoke('enable');
    },

    /**
     * Set the max-height for o-form-content class container within the form if a height is provided,
     * otherwise, get its computed inner height
     * @param {Number} the height in pixel to set for class o-form-content
     * @return {Number}
     */
    contentHeight: function contentHeight(height) {
      var content = this.$('.o-form-content');

      if (_underscoreWrapper.default.isNumber(height)) {
        content.css('max-height', height);
      } else {
        return content.height();
      }
    },

    /**
     * Get only the input children
     * @return {InputWrapper[]} An underscore wrapped array of {@link InputWrapper} instances
     */
    getInputs: function getInputs() {
      var _context74;

      return (0, _underscoreWrapper.default)((0, _filter.default)(_context74 = this).call(_context74, function (view) {
        return view instanceof _InputWrapper.default;
      }));
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseView.default.extend({
    el: '<span class="o-form-toggle" data-type="header-btn"></span>',
    formTitle: '',
    modelEvents: {
      'change:__edit__': 'toggle'
    },
    initialize: function initialize() {
      this.addButton();
    },
    addButton: function addButton() {
      if (this.model.get('__edit__')) {
        this.add(_FormUtil.default.createReadFormButton({
          type: 'cancel'
        }));
      } else {
        this.add(_FormUtil.default.createReadFormButton({
          type: 'edit',
          formTitle: this.formTitle,
          className: 'ajax-form-edit-link'
        }));
      }
    },
    toggle: function toggle() {
      this.removeChildren();
      this.addButton();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseView.default.extend({
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "errorSummary") || (depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "errorSummary",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 130
            },
            "end": {
              "line": 1,
              "column": 146
            }
          }
        }) : helper)) + "</p>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "courage",
            "code": "oform.errorbanner.title"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 161
            },
            "end": {
              "line": 1,
              "column": 217
            }
          }
        })) + "</p>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.program(3, data, 0),
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 107
            },
            "end": {
              "line": 1,
              "column": 228
            }
          }
        })) != null ? stack1 : "") + "</div>";
      },
      "useData": true
    }),
    modelEvents: {
      'form:clear-errors': 'remove'
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FIELD_REGEX = /^([\S]+): (.+)$/;
  var _default = {
    /**
     * Helper function that returns the json output of an xhr objext
     * @param  {jqXhr} xhr
     * @return {Object}
     */
    getResponseJSON: function getResponseJSON(xhr) {
      try {
        return xhr.responseJSON || JSON.parse(xhr.responseText);
      } catch (e) {
        return;
      }
    },

    /**
     * Parses an error summary to extract a field name and an error message
     * @param  {String} errorSummary The raw error summary
     * @return {String[]} An array with two members: [field name, error message]
     */
    parseErrorSummary: function parseErrorSummary(errorSummary) {
      var matches = errorSummary.match(FIELD_REGEX); // error format is: `fieldName: The field cannot be left blank`

      if (matches) {
        return [matches[1], matches[2]];
      }
    },

    /**
     * Parses an error cause object to extract a field name from property attribute
     * and an error message form errorSummary attribute. It looks to see if there is
     * a custom override/translation for the erorrCause.reason before using the errorSummary
     * @param  {Object} errorCause object
     * @return {String[]} An array with two members: [field name, error message]
     */
    parseErrorCauseObject: function parseErrorCauseObject(errorCause) {
      if (errorCause.property && errorCause.errorSummary) {
        var localizedMsg = _StringUtil.default.localize(errorCause.reason);

        var apiMsg = errorCause.errorSummary;
        var field = errorCause.property;
        var errorMessage = (0, _indexOf.default)(localizedMsg).call(localizedMsg, 'L10N_ERROR[') === -1 ? localizedMsg : apiMsg;
        return [field, errorMessage];
      }
    },
    parseErrors: function parseErrors(resp) {
      var _context75;

      var responseJSON = this.getResponseJSON(resp);
      return (0, _map.default)(_context75 = _underscoreWrapper.default).call(_context75, responseJSON && responseJSON.errorCauses || [], function (errorCause) {
        return ('' + errorCause.errorSummary).replace(FIELD_REGEX, '$2');
      });
    },

    /**
     * Parses the response for errors
     * Returns a map of field names > array or error messages
     * Example:
     * ```javascript
     * {
     *   url: ['The field cannot be left blank', 'The field has to be a valid URI'],
     *   name: ['The field cannot be left blank']
     * }
     * ```
     * @param  {Object} resp
     * @return {Object}
     */
    parseFieldErrors: function parseFieldErrors(resp) {
      var responseJSON = this.getResponseJSON(resp);
      var errors = {}; // xhr error object

      if (responseJSON) {
        /* eslint complexity: [2, 9] */
        _underscoreWrapper.default.each(responseJSON.errorCauses || [], function (cause) {
          var res = [];

          if (cause.property && cause.errorSummary) {
            res = this.parseErrorCauseObject(cause);
          } else if (cause.location && cause.errorSummary) {
            // To handle new api error format for field level errors.
            // Ignoring the reason attribute as the translation happens in the API layer and not in the client any more.
            res = [cause.location, cause.errorSummary];
          } else {
            res = this.parseErrorSummary(cause && cause.errorSummary || '');
          }

          if (res) {
            var fieldName = res[0];
            var message = res[1];
            errors[fieldName] || (errors[fieldName] = []);
            errors[fieldName].push(message);
          }
        }, this);
      } // validation key/value object
      else if (_underscoreWrapper.default.isObject(resp) && _underscoreWrapper.default.size(resp)) {
          _underscoreWrapper.default.each(resp, function (msg, field) {
            errors[field] = [msg];
          });
        }

      return _underscoreWrapper.default.size(errors) ? errors : undefined;
    }
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 72 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Logger = _interopRequireDefault(__webpack_require__(7));

  var _Util = _interopRequireDefault(__webpack_require__(19));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var isABaseView = _Util.default.isABaseView;
  /**
   * @class InputContainer
   * @private
   *
   * TODO: OKTA-80796
   * Attention: Please change with caution since this is used in other places
   */

  var _default = _BaseView.default.extend({
    attributes: function attributes() {
      return {
        'data-se': 'o-form-input-container'
      };
    },
    className: function className() {
      var className = 'o-form-input';

      if (this.options.wide) {
        className += ' o-form-wide';
      }

      if (_underscoreWrapper.default.contains([1, 2, 3, 4], this.options.multi)) {
        className += ' o-form-multi-input-' + this.options.multi;

        if (_underscoreWrapper.default.isArray(this.options.input)) {
          var _context76;

          var inputGroup = (0, _find.default)(_context76 = _underscoreWrapper.default).call(_context76, this.options.input, function (input) {
            return _underscoreWrapper.default.contains(['text+select', 'select+text'], input.options.type);
          });
          inputGroup && (className += ' o-form-multi-input-group-' + this.options.multi);
        }
      }

      return className;
    },
    _getNames: function _getNames() {
      var names = _underscoreWrapper.default.isArray(this.options.name) ? this.options.name : [this.options.name];
      /*eslint complexity: 0 */

      if (this.options.type === 'group') {
        names.push.apply(names, _underscoreWrapper.default.pluck(this.options.input[0].options.params.inputs, 'name'));
      } else if (_underscoreWrapper.default.isArray(this.options.name)) {
        if (this.options.input && this.options.input.options && this.options.input.options.name) {
          names.push(this.options.input.options.name);
        }
      } else if (this.options.input) {
        if (_underscoreWrapper.default.isArray(this.options.input)) {
          _underscoreWrapper.default.each(this.options.input, function (inputItem) {
            names.push(inputItem.options.name);
          });
        } else {
          names.push(this.options.input.options.name);
        }
      }

      return _underscoreWrapper.default.uniq(_underscoreWrapper.default.compact(names));
    },
    _getInputElement: function _getInputElement() {
      // NOTE: this.options.input is sometimes not an array under test
      var lastInput = (0, _isArray.default)(this.options.input) ? _underscoreWrapper.default.last(this.options.input) : this.options.input; // FIXME: replace with _.get

      var id = lastInput && lastInput.options && lastInput.options.inputId;
      var el = id ? this.$('#' + id) : null;
      return el && el.length ? el : null;
    },
    constructor: function constructor() {
      /* eslint max-statements: [2, 18] */
      _BaseView.default.apply(this, arguments);

      var explainTop = this.options['explain-top'] && this.options['label-top'];

      if (this.options.input) {
        if (_underscoreWrapper.default.isArray(this.options.input)) {
          _underscoreWrapper.default.each(this.options.input, function (inputItem) {
            this.add(inputItem, {
              prepend: !explainTop
            });
          }, this);
        } else {
          this.add(this.options.input, {
            prepend: !explainTop
          });
        }
      }

      this.__setExplain(this.options);

      var names = this._getNames();

      this.listenTo(this.model, 'form:field-error', function (name, errors) {
        if (_underscoreWrapper.default.contains(names, name)) {
          this.__setError(errors, explainTop);
        }
      });
      this.listenTo(this.model, 'form:clear-errors change:' + names.join(' change:'), this.__clearError);
      this.listenTo(this.model, 'form:clear-error:' + names.join(' form:clear-error:'), this.__clearError);

      if (_underscoreWrapper.default.resultCtx(this.options, 'autoRender', this)) {
        this.listenTo(this.model, 'change:' + this.options.name, this.render);
      }

      this.__errorState = false;
    },

    /**
     * Populates the explain on the input container (if it exists). There are
     * two ways to use this:
     * 1. Raw text - wraps in the correct html template
     * 2. Custom html
     *    - pass in a View class (preferred)
     *    - pass in an instance of a View
     * Some additional notes:
     * - You can pass a function that returns any of the above
     * - This maintains support for the deprecated "customExplain" property
     *   that was used before. This pattern is superseded by explain, so use
     *   that instead.
     * @private
     */
    __setExplain: function __setExplain(options) {
      var explain; // Deprecated - if you need custom html, use explain instead

      if (options.customExplain) {
        _Logger.default.warn('Deprecated - use explain instead of customExplain');

        this.add(this.options.customExplain);
        return;
      }

      explain = options.explain;

      if (_underscoreWrapper.default.isFunction(explain) && !isABaseView(explain)) {
        explain = _underscoreWrapper.default.resultCtx(this.options, 'explain', this);
      }

      if (!explain) {
        return;
      }

      if (isABaseView(explain)) {
        this.template = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            return "<p class=\"o-form-explain\"></p>";
          },
          "useData": true
        });
        this.add(explain, ' > .o-form-explain');
      } else {
        this.template = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<p class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "explain",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 26
                },
                "end": {
                  "line": 1,
                  "column": 37
                }
              }
            }) : helper)) + "</p>";
          },
          "useData": true
        });
      }
    },

    /**
     * Highlight the input as invalid (validation failed)
     * Adds an explaination message of the error
     * @private
     */
    __setError: function __setError(errors, explainTop) {
      this.__errorState = true;
      this.$el.addClass('o-form-has-errors');

      var errorId = _underscoreWrapper.default.uniqueId('input-container-error');

      var tmpl = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = "function",
              alias4 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<p id=\"" + alias4((helper = (helper = lookupProperty(helpers, "errorId") || (depth0 != null ? lookupProperty(depth0, "errorId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
            "name": "errorId",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 7
              },
              "end": {
                "line": 1,
                "column": 18
              }
            }
          }) : helper)) + "\" class=\"okta-form-input-error o-form-input-error o-form-explain\" role=\"alert\"><span class=\"icon icon-16 error-16-small\" role=\"img\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "iconLabel") || (depth0 != null ? lookupProperty(depth0, "iconLabel") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
            "name": "iconLabel",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 162
              },
              "end": {
                "line": 1,
                "column": 175
              }
            }
          }) : helper)) + "\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
            "name": "text",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 184
              },
              "end": {
                "line": 1,
                "column": 192
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      });

      var iconLabel = _StringUtil.default.localize('oform.error.icon.ariaLabel', 'courage'); // 'Error'


      var html = tmpl({
        errorId: errorId,
        iconLabel: iconLabel,
        text: errors.join(', ')
      });
      var $elExplain = this.$('.o-form-explain').not('.o-form-input-error').first();

      if ($elExplain.length && !explainTop) {
        $elExplain.before(html);
      } else {
        this.$el.append(html);
      }

      var target = this._getInputElement() || this.$el;
      target.attr('aria-describedby', errorId);
      target.attr('aria-invalid', true);
    },

    /**
     * Un-highlight the input and remove explaination text
     * @private
     */
    __clearError: function __clearError() {
      var _this = this;

      if (this.__errorState) {
        this.$('.o-form-input-error').remove();
        var target = this._getInputElement() || this.$el;
        target.attr('aria-describedby', null);
        target.attr('aria-invalid', null);
        this.$el.removeClass('o-form-has-errors');
        this.__errorState = false;

        _underscoreWrapper.default.defer(function () {
          _this.model.trigger('form:resize');
        });
      }
    },
    focus: function focus() {
      this.each(function (view) {
        if (view.focus) {
          return view.focus();
        }
      });
      return this;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 73 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _InputRegistry = _interopRequireDefault(__webpack_require__(28));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint complexity: 0, max-statements: 0 */


  function createInput(Input, options) {
    if (_InputRegistry.default.isBaseInput(Input)) {
      return Input.prototype ? new Input(_underscoreWrapper.default.omit(options, 'input')) : Input;
    } else {
      return Input;
    }
  }

  function create(options) {
    options = _underscoreWrapper.default.clone(options);

    if (options.input) {
      return createInput(options.input, options);
    }

    var Input = _InputRegistry.default.get(options);

    if (!Input) {
      throw new Error('unknown input: ' + options.type);
    }

    return createInput(Input, options);
  }

  function supports(options) {
    return !!options.input || !!_InputRegistry.default.get(options);
  }

  var _default = {
    create: create,
    supports: supports
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  __webpack_require__(29);

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /**
   * @class InputLabel
   * @extends {Okta.View}
   * @private
   * The input's label.
   */


  var _default = _BaseView.default.extend({
    className: 'okta-form-label o-form-label',
    attributes: {
      'data-se': 'o-form-label'
    },

    /**
     * @constructor
     * @param  {Object} options options hash
     * @param  {String} [options.type] Input type
     * @param  {String|Function} [options.label] Label text
     * @param  {String|Function} [options.sublabel] Sub label text
     * @param  {String|Function} [options.tooltip] Tooltip text
     * @param  {String|Function} [options.inputId] Id of the inputs
     * @param  {String|Function} [options.id] Id of the inputs
     */
    constructor: function constructor(options) {
      /* eslint max-statements: [2, 16] complexity: [2, 7]*/
      _underscoreWrapper.default.defaults(options, {
        inputId: options.id
      });

      delete options.id;

      _BaseView.default.apply(this, arguments);
    },
    // standardLabel: space added in the end of the label to avoid selecting label text with double click in read mode
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<label for=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 33
            },
            "end": {
              "line": 1,
              "column": 44
            }
          }
        }) : helper)) + "\"></label>";
      },
      "3": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 88
            },
            "end": {
              "line": 1,
              "column": 97
            }
          }
        }) : helper));
      },
      "5": function _(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 139
            },
            "end": {
              "line": 1,
              "column": 150
            }
          }
        }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 152
            },
            "end": {
              "line": 1,
              "column": 161
            }
          }
        }) : helper)) + "&nbsp;</label>";
      },
      "7": function _(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "sublabel") || (depth0 != null ? lookupProperty(depth0, "sublabel") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "sublabel",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 228
            },
            "end": {
              "line": 1,
              "column": 240
            }
          }
        }) : helper)) + "</span>";
      },
      "9": function _(container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"o-form-tooltip icon-16 icon-only form-help-16\" title=\"" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "tooltip") : depth0) != null ? lookupProperty(stack1, "text") : stack1, depth0)) + "\"></span>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isLabelView") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 61
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isRadioOrCheckbox") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(3, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 61
            },
            "end": {
              "line": 1,
              "column": 104
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_standardLabel") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(5, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 104
            },
            "end": {
              "line": 1,
              "column": 182
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sublabel") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(7, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 182
            },
            "end": {
              "line": 1,
              "column": 254
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "tooltip") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(9, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 254
            },
            "end": {
              "line": 1,
              "column": 369
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      var options = {
        label: ''
      };

      _underscoreWrapper.default.each(['inputId', 'label', 'sublabel', 'tooltip'], function (option) {
        options[option] = _underscoreWrapper.default.resultCtx(this.options, option, this);
      }, this);

      if (this._isLabelView(options.label)) {
        options._isLabelView = true;
      } else if (_underscoreWrapper.default.contains(['radio', 'checkbox'], this.options.type) || !options.label) {
        options._isRadioOrCheckbox = true;
      } else {
        options._standardLabel = true;
      }

      if (options.tooltip) {
        if (_underscoreWrapper.default.isString(options.tooltip)) {
          options.tooltip = {
            text: options.tooltip
          };
        }
      }

      return options;
    },
    _isLabelView: function _isLabelView(label) {
      return !_underscoreWrapper.default.isUndefined(label) && label instanceof _BaseView.default;
    },
    postRender: function postRender() {
      var options = this.getTemplateData();

      if (this._isLabelView(options.label)) {
        this.removeChildren();
        this.add(options.label, 'label');
      }

      if (options.tooltip) {
        this.$('.o-form-tooltip').qtip(_underscoreWrapper.default.extend({
          style: {
            classes: 'qtip-custom qtip-shadow'
          },
          position: {
            my: window.okta && window.okta.theme === 'dstheme' ? 'bottom center' : 'bottom left',
            at: 'top center'
          },
          hide: {
            fixed: true
          },
          show: {
            delay: 0
          }
        }, options.tooltip.options));
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _FormUtil = _interopRequireDefault(__webpack_require__(10));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function runCallback(callback, field) {
    var _context77;

    callback.apply(this, (0, _map.default)(_context77 = _underscoreWrapper.default).call(_context77, field.split(/\s+/), function (field) {
      return this.model.get(field);
    }, this));
  }

  function runIf(fn, ctx) {
    if (_underscoreWrapper.default.isFunction(fn)) {
      fn.call(ctx);
    }
  }
  /**
   * @class InputWrapper
   * @extends Okta.View
   * @private
   * The outer wrapper that warps the label and the input container
   */


  var _default = _BaseView.default.extend({
    className: function className() {
      var className = 'o-form-fieldset';

      if (this.options['label-top']) {
        className += ' o-form-label-top';
      }

      if (this.options.readOnly) {
        className += ' o-form-read-mode';
      }

      return className;
    },
    attributes: function attributes() {
      return {
        'data-se': this.options['data-se'] || 'o-form-fieldset'
      };
    },

    /**
     * @constructor
     * @param  {Object} options options hash
     * @param  {Object} [options.events]
     * @param  {Object} [options.bindings]
     * @param  {Object} [options.showWhen]
     * @param  {Function} [options.initialize] post initialize callback
     * @param  {Function} [options.render] post render callback
     */
    constructor: function constructor(options) {
      if (options.className) {
        this.inputWrapperClassName = this.className;
        this.optionsClassName = options.className;

        options.className = function () {
          return _underscoreWrapper.default.result(this, 'inputWrapperClassName', '') + ' ' + _underscoreWrapper.default.result(this, 'optionsClassName');
        };
      }

      _BaseView.default.apply(this, arguments);

      _underscoreWrapper.default.each(options.events || {}, function (callback, event) {
        this.listenTo(this.model, event, callback);
      }, this);

      _underscoreWrapper.default.each(options.bindings || {}, function (callback, field) {
        var _context78;

        this.listenTo(this.model, _FormUtil.default.changeEventString(field.split(/\s+/)), (0, _bind.default)(_context78 = _underscoreWrapper.default).call(_context78, runCallback, this, callback, field));
      }, this);

      _FormUtil.default.applyShowWhen(this, options.showWhen);

      _FormUtil.default.applyToggleWhen(this, options.toggleWhen);

      runIf(options.initialize, this);
    },
    postRender: function postRender() {
      _underscoreWrapper.default.each(this.options.bindings || {}, runCallback, this);

      runIf(this.options.render, this);
    },

    /**
     * @return {InputLabel}
     */
    getLabel: function getLabel() {
      return this.size() > 1 ? this.at(0) : null;
    },

    /**
     * @deprecated ambiguous naming, use {@link #getInputContainer}
     */
    getInput: function getInput() {
      return this.getInputContainer();
    },

    /**
     * @return {InputContainer}
     */
    getInputContainer: function getInputContainer() {
      return this.at(this.size() > 1 ? 1 : 0);
    },

    /**
     * @return {BaseInput[]}
     */
    getInputs: function getInputs() {
      return this.getInputContainer().toArray();
    },
    focus: function focus() {
      return this.getInput().focus();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _BooleanSelect = _interopRequireDefault(__webpack_require__(77));

  var _TextBoxSet = _interopRequireDefault(__webpack_require__(79));

  var _EnumTypeHelper = _interopRequireDefault(__webpack_require__(21));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint max-statements: 0, max-params: 0 */
  // Maps each __displayType__ to a basic set of inputOptions.


  function defaultOptions(property) {
    var type = property.get('__displayType__');
    var values = property.get('__possibleValues__');
    var name = property.get('name');
    var title = property.get('title');
    /* eslint complexity: [2, 24] */

    var inputOptions = {
      type: 'text',
      name: name,
      label: title || name
    }; // @see customOptions for enum complex "object" type,
    // a.k.a "object" or "arrayofobject" type has enum values defined.
    // Other cases (e.g., nested object type) are not support yet.

    switch (type) {
      case 'arrayofstring':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: 'string'
        };
        break;

      case 'arrayofnumber':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: 'number'
        };
        break;

      case 'arrayofinteger':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: 'integer'
        };
        break;

      case 'arrayofobject':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: property.get('items').type
        };
        break;

      case 'arrayofref-id':
        inputOptions.input = _TextBoxSet.default;
        inputOptions.params = {
          itemType: property.get('items').format
        };
        break;

      case 'boolean':
        inputOptions.input = _BooleanSelect.default;
        break;

      case 'integer':
      case 'number':
        inputOptions.to = convertStringToNumber;
        break;

      case 'reference':
        inputOptions.type = 'select';
        inputOptions.options = getChoices(values);
        break;

      case 'image':
        inputOptions.readOnly = true;

        inputOptions.from = function (value) {
          return _underscoreWrapper.default.isEmpty(value) ? '' : _StringUtil.default.localize('user.profile.image.image_set', 'courage'); //TODO
        };

        break;

      case 'password':
        inputOptions.type = 'password';
        break;

      case 'date':
        inputOptions.type = 'date';
        break;

      case 'uri':
      case 'country-code':
      case 'country_code':
      case 'language-code':
      case 'language_code':
      case 'email':
      case 'locale':
      case 'timezone':
      case 'string':
      case 'object':
        //default input options
        break;

      default:
        throw new Error('unknown type: ' + type);
    }

    return inputOptions;
  } // Sets nonbasic inputOptions, such as an array with possible values


  function customOptions(property) {
    var inputOptions = {};
    var name = property.get('name');
    var type = property.get('__displayType__');
    var values = property.get('__possibleValues__');
    var prefix = property.get('__fieldNamePrefix__');

    if (prefix) {
      inputOptions.name = prefix + name;
      inputOptions.errorField = name;
    }

    if (property.isEnumType()) {
      var configs = {
        displayType: type,
        title: property.get('title'),
        enumValues: property.getEnumValues()
      };
      inputOptions = _underscoreWrapper.default.extend({}, _EnumTypeHelper.default.getEnumInputOptions(configs), inputOptions);
    } else if (isArray(type) && values) {
      inputOptions.type = 'checkboxset';
      inputOptions.input = null;
      inputOptions.options = getChoices(values);
    }

    return inputOptions;
  }

  function convertStringToNumber(string) {
    var number = _StringUtil.default.parseFloat(string);

    return string === '' ? null : number;
  }

  function isArray(type) {
    return type && (0, _indexOf.default)(type).call(type, 'array') >= 0;
  } // converts possibleValues to choices
  // [a, b, c] => {a: a, b: b, c: c}


  function getChoices(values) {
    return _underscoreWrapper.default.object(values, values);
  } // A schema property may have an objectName either
  // at the root level or nested in the items object


  function getObjectName(schemaProp) {
    var items = schemaProp.get('items');

    if (items) {
      return items.objectName;
    } else {
      return schemaProp.get('objectName');
    }
  }

  function augmentSchemaProp(schemaProp, possibleValues, profile) {
    var name = schemaProp.get('name');
    var prefix = profile['__nestedProperty__'];
    var defaultValues = possibleValues[name];
    var userValues = profile.get(name);
    var //TODO: Not implemented
    fixedValues;
    var values; // If API responds with a field name that differs from the form-field name
    // example: Model's 'profile.username' vs. server's 'username'

    if (prefix) {
      schemaProp.set('__fieldNamePrefix__', prefix);
    } // case 1: objectName - fixed list of values are set for the input


    fixedValues = possibleValues[getObjectName(schemaProp)]; // case 2: name only - default list of values are provided, user can add more
    // TODO: this case does not yet exist, so it is not tested

    if (defaultValues && userValues) {
      defaultValues = _underscoreWrapper.default.union(defaultValues, userValues);
    } // If both fixed and default values exist,
    // take the fixed values unless they are empty


    if (fixedValues && fixedValues.length) {
      values = fixedValues;
    } else if (defaultValues && defaultValues.length) {
      values = defaultValues;
    }

    schemaProp.set('__possibleValues__', values);
  }

  function augmentSchemaProps(schemaProps, possibleValues, profile) {
    schemaProps.each(function (schemaProp) {
      augmentSchemaProp(schemaProp, possibleValues, profile);
    });
    return schemaProps;
  }
  /**
   * Remove invalid schema properties from a collection
   *
   * @param {SchemaProperties Collection} [properties] A collection of schema properties
   * @param {Object} [values] An object of the form { key: [value1, value2]}
   * @return {Array} An array of valid schema models, this can be used to reset
   * a schema properties collection for example.
   * @private
   */


  function cleanSchema(properties, values) {
    return (0, _filter.default)(properties).call(properties, function (schema) {
      return isValidSchemaProp(schema, values);
    });
  }
  /**
   * Checks the validity of a schema property.
   *
   * @param {SchemaProperty} [schemaProp] A schema property backbone model
   * @param {Object} [values] An object of the form { key: [value1, value2]}
   * @return {Boolean} true/false
   * @private
   */


  function isValidSchemaProp(schemaProp, values) {
    var objectName = getObjectName(schemaProp);
    var results = values[objectName]; // a schema property that references an empty list of values
    // Im looking at you, google apps.

    if (objectName && (0, _underscoreWrapper.default)(results).isEmpty()) {
      return false;
    }

    return true;
  }

  var _default = {
    /**
     * Creates the options hash for BaseForm.addInput from a prepared schema
     * property.
     *
     * @param {Okta.Model} [preparedSchemaProp] A schema property backbone model
     * that has been standardized by the prepareSchema method.
     * @return {Object} An object containing all of the options needed by
     * BaseForm's addInput()
     */
    createInputOptions: function createInputOptions(preparedSchemaProp) {
      var custom = customOptions(preparedSchemaProp);
      var standard = defaultOptions(preparedSchemaProp); // underscore did not support nested extend
      // https://github.com/jashkenas/underscore/issues/162

      if (custom.params && standard.params) {
        custom.params = _underscoreWrapper.default.defaults(custom.params, standard.params);
      }

      return _underscoreWrapper.default.defaults(custom, standard);
    },
    hasValidSchemaProps: function hasValidSchemaProps(schemaProps, possibleValues) {
      if (_underscoreWrapper.default.isEmpty(schemaProps)) {
        return false;
      } else {
        var validSchema = cleanSchema(schemaProps, possibleValues);
        return !!validSchema.length;
      }
    },

    /**
     * This method is responsible for preparing a collection for the form
     * factory to use by putting all of the information to create an input
     * into the schema property and removing invalid properties.
     * The typical UD form takes 3 models:
     * The data model has the input values.
     * The schema model describes which input to use, such as a textbox or a checkbox.
     * The possible values model provide a list of default options to display, for example in a drop down menu.
     *
     * @param {SchemaProperty Collection} [schemaProps] A schema property backbone model.
     * @param {Object} [possibleValues] An object of the form { key: [value1, value2]}
     * @param {Okta.Model} [profile] A backbone model containing the property described by the schema property.
     * @return {SchemaProperty Collection} A schema property collection with standardized models.
     * The standard schema model adds a couple of additional private properties to
     * allow the form factory to reference lookup values or name prefixes without going to a second model.
     */
    prepareSchema: function prepareSchema(schemaProps, possibleValues, profile) {
      schemaProps.reset(cleanSchema(schemaProps, possibleValues));
      return augmentSchemaProps(schemaProps, possibleValues, profile);
    },

    /**
     * `prepareSchema` will reset the property list which may not be necessary at some case.
     * like when setting default value for schema properties.
     * (more detail about such case @see wiki UX, App+Entitlements+for+Provisioning)
     *
     * @param { }
     * @return {String}
     */
    augmentSchemaProps: augmentSchemaProps,
    augmentSchemaProp: augmentSchemaProp
  };
  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 77 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _Select = _interopRequireDefault(__webpack_require__(30));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var options = {
    undefined: 'undefined',
    true: 'true',
    false: 'false'
  };

  var from = function from(val) {
    if (val) {
      return 'true';
    }

    if (val === false) {
      return 'false';
    }

    return 'undefined';
  };

  var to = function to(val) {
    switch (val) {
      case 'undefined':
        return null;

      case 'true':
        return true;

      case 'false':
        return false;

      default:
        return null;
    }
  };

  var _default = _Select.default.extend({
    initialize: function initialize() {
      this.options.options = options;
      this.options.from = from;
      this.options.to = to;
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 78 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Chosen, a Select Box Enhancer for jQuery and Prototype
  // by Patrick Filler for Harvest, http://getharvest.com
  //
  // Version 0.11.1
  // Full source at https://github.com/harvesthq/chosen
  // Copyright (c) 2011 Harvest http://getharvest.com
  // MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
  // This file is generated by `grunt build`, do not edit it by hand.


  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
    (function () {
      var SelectParser;

      SelectParser = function () {
        function SelectParser() {
          this.options_index = 0;
          this.parsed = [];
        }

        SelectParser.prototype.add_node = function (child) {
          if (child.nodeName.toUpperCase() === "OPTGROUP") {
            return this.add_group(child);
          } else {
            return this.add_option(child);
          }
        };

        SelectParser.prototype.add_group = function (group) {
          var group_position, option, _i, _len, _ref, _results;

          group_position = this.parsed.length;
          this.parsed.push({
            array_index: group_position,
            group: true,
            label: group.label,
            children: 0,
            disabled: group.disabled
          });
          _ref = group.childNodes;
          _results = [];

          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            option = _ref[_i];

            _results.push(this.add_option(option, group_position, group.disabled));
          }

          return _results;
        };

        SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
          if (option.nodeName.toUpperCase() === "OPTION") {
            if (option.text !== "") {
              if (group_position != null) {
                this.parsed[group_position].children += 1;
              }

              this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                value: option.value,
                text: option.text,
                html: option.innerHTML,
                selected: option.selected,
                disabled: group_disabled === true ? group_disabled : option.disabled,
                group_array_index: group_position,
                classes: option.className,
                style: option.style.cssText
              });
            } else {
              this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                empty: true
              });
            }

            return this.options_index += 1;
          }
        };

        return SelectParser;
      }();

      SelectParser.select_to_array = function (select) {
        var child, parser, _i, _len, _ref;

        parser = new SelectParser();
        _ref = select.childNodes;

        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          parser.add_node(child);
        }

        return parser.parsed;
      };

      this.SelectParser = SelectParser;
    }).call(this);
    (function () {
      var AbstractChosen, root;
      root = this;

      AbstractChosen = function () {
        function AbstractChosen(form_field, options) {
          this.form_field = form_field;
          this.options = options != null ? options : {};

          if (!AbstractChosen.browser_is_supported()) {
            return;
          }

          this.is_multiple = this.form_field.multiple;
          this.set_default_text();
          this.set_default_values();
          this.setup();
          this.set_up_html();
          this.register_observers();
          this.finish_setup();
        }

        AbstractChosen.prototype.set_default_values = function () {
          var _this = this;

          this.click_test_action = function (evt) {
            return _this.test_active_click(evt);
          };

          this.activate_action = function (evt) {
            return _this.activate_field(evt);
          };

          this.active_field = false;
          this.mouse_on_container = false;
          this.results_showing = false;
          this.result_highlighted = null;
          this.result_single_selected = null;
          this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
          this.disable_search_threshold = this.options.disable_search_threshold || 0;
          this.disable_search = this.options.disable_search || false;
          this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
          this.search_contains = this.options.search_contains || false;
          this.single_backstroke_delete = this.options.single_backstroke_delete || false;
          this.max_selected_options = this.options.max_selected_options || Infinity;
          return this.inherit_select_classes = this.options.inherit_select_classes || false;
        };

        AbstractChosen.prototype.set_default_text = function () {
          if (this.form_field.getAttribute("data-placeholder")) {
            this.default_text = this.form_field.getAttribute("data-placeholder");
          } else if (this.is_multiple) {
            this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
          } else {
            this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
          }

          return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
        };

        AbstractChosen.prototype.mouse_enter = function () {
          return this.mouse_on_container = true;
        };

        AbstractChosen.prototype.mouse_leave = function () {
          return this.mouse_on_container = false;
        };

        AbstractChosen.prototype.input_focus = function (evt) {
          var _this = this;

          if (this.is_multiple) {
            if (!this.active_field) {
              return (0, _setTimeout2.default)(function () {
                return _this.container_mousedown();
              }, 50);
            }
          } else {
            if (!this.active_field) {
              return this.activate_field();
            }
          }
        };

        AbstractChosen.prototype.input_blur = function (evt) {
          var _this = this;

          if (!this.mouse_on_container) {
            this.active_field = false;
            return (0, _setTimeout2.default)(function () {
              return _this.blur_test();
            }, 100);
          }
        };

        AbstractChosen.prototype.result_add_option = function (option) {
          var classes, style;
          option.dom_id = this.container_id + "_o_" + option.array_index;
          classes = [];

          if (!option.disabled && !(option.selected && this.is_multiple)) {
            classes.push("active-result");
          }

          if (option.disabled && !(option.selected && this.is_multiple)) {
            classes.push("disabled-result");
          }

          if (option.selected) {
            classes.push("result-selected");
          }

          if (option.group_array_index != null) {
            classes.push("group-option");
          }

          if (option.classes !== "") {
            classes.push(option.classes);
          }

          style = option.style.cssText !== "" ? " style=\"" + option.style + "\"" : "";
          return '<li id="' + option.dom_id + '" class="' + classes.join(' ') + '"' + style + '>' + option.html + '</li>';
        };

        AbstractChosen.prototype.results_update_field = function () {
          this.set_default_text();

          if (!this.is_multiple) {
            this.results_reset_cleanup();
          }

          this.result_clear_highlight();
          this.result_single_selected = null;
          return this.results_build();
        };

        AbstractChosen.prototype.results_toggle = function () {
          if (this.results_showing) {
            return this.results_hide();
          } else {
            return this.results_show();
          }
        };

        AbstractChosen.prototype.results_search = function (evt) {
          if (this.results_showing) {
            return this.winnow_results();
          } else {
            return this.results_show();
          }
        };

        AbstractChosen.prototype.choices_count = function () {
          var option, _i, _len, _ref;

          if (this.selected_option_count != null) {
            return this.selected_option_count;
          }

          this.selected_option_count = 0;
          _ref = this.form_field.options;

          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            option = _ref[_i];

            if (option.selected) {
              this.selected_option_count += 1;
            }
          }

          return this.selected_option_count;
        };

        AbstractChosen.prototype.choices_click = function (evt) {
          evt.preventDefault();

          if (!(this.results_showing || this.is_disabled)) {
            return this.results_show();
          }
        };

        AbstractChosen.prototype.keyup_checker = function (evt) {
          var stroke, _ref;

          stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
          this.search_field_scale();

          switch (stroke) {
            case 8:
              if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
                return this.keydown_backstroke();
              } else if (!this.pending_backstroke) {
                this.result_clear_highlight();
                return this.results_search();
              }

              break;

            case 13:
              evt.preventDefault();

              if (this.results_showing) {
                return this.result_select(evt);
              }

              break;

            case 27:
              if (this.results_showing) {
                this.results_hide();
              }

              return true;

            case 9:
            case 38:
            case 40:
            case 16:
            case 91:
            case 17:
              break;

            default:
              return this.results_search();
          }
        };

        AbstractChosen.prototype.generate_field_id = function () {
          var new_id;
          new_id = this.generate_random_id();
          this.form_field.id = new_id;
          return new_id;
        };

        AbstractChosen.prototype.generate_random_char = function () {
          var chars, newchar, rand;
          chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          rand = Math.floor(Math.random() * chars.length);
          return newchar = chars.substring(rand, rand + 1);
        };

        AbstractChosen.prototype.container_width = function () {
          if (this.options.width != null) {
            return this.options.width;
          } else {
            return "" + this.form_field.offsetWidth + "px";
          }
        };

        AbstractChosen.browser_is_supported = function () {
          var _ref;

          if (window.navigator.appName === "Microsoft Internet Explorer") {
            return null !== (_ref = document.documentMode) && _ref >= 8;
          }

          return true;
        };

        AbstractChosen.default_multiple_text = "Select Some Options";
        AbstractChosen.default_single_text = "Select an Option";
        AbstractChosen.default_no_result_text = "No results match";
        return AbstractChosen;
      }();

      root.AbstractChosen = AbstractChosen;
    }).call(this);
    (function () {
      var $,
          Chosen,
          root,
          _ref,
          __hasProp = {}.hasOwnProperty,
          __extends = function __extends(child, parent) {
        for (var key in parent) {
          if (__hasProp.call(parent, key)) child[key] = parent[key];
        }

        function ctor() {
          this.constructor = child;
        }

        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
      };

      root = this; // OKTA-93521 - plugin assumes root is global scope

      var AbstractChosen = root.AbstractChosen;
      $ = jQuery;
      $.fn.extend({
        chosen: function chosen(options) {
          if (!AbstractChosen.browser_is_supported()) {
            return this;
          }

          return this.each(function (input_field) {
            var $this;
            $this = $(this);

            if (!$this.hasClass("chzn-done")) {
              return $this.data('chosen', new Chosen(this, options));
            }
          });
        }
      });

      Chosen = function (_super) {
        __extends(Chosen, _super);

        function Chosen() {
          _ref = Chosen.__super__.constructor.apply(this, arguments);
          return _ref;
        }

        Chosen.prototype.setup = function () {
          this.form_field_jq = $(this.form_field);
          this.current_selectedIndex = this.form_field.selectedIndex;
          return this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
        };

        Chosen.prototype.finish_setup = function () {
          return this.form_field_jq.addClass("chzn-done");
        };

        Chosen.prototype.set_up_html = function () {
          var _context79, _context80, _context81, _context82;

          var container_classes, container_props;
          this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, '_') : this.generate_field_id();
          this.container_id += "_chzn";
          container_classes = ["chzn-container"];
          container_classes.push("chzn-container-" + (this.is_multiple ? "multi" : "single"));

          if (this.inherit_select_classes && this.form_field.className) {
            container_classes.push(this.form_field.className);
          }

          if (this.is_rtl) {
            container_classes.push("chzn-rtl");
          }

          container_props = {
            'id': this.container_id,
            'class': container_classes.join(' '),
            'style': "width: " + this.container_width() + ";",
            'title': this.form_field.title
          };
          this.container = $("<div></div>", container_props);

          if (this.is_multiple) {
            this.container.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>');
          } else {
            this.container.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>');
          }

          this.form_field_jq.hide().after(this.container);
          this.dropdown = (0, _find.default)(_context79 = this.container).call(_context79, 'div.chzn-drop').first();
          this.search_field = (0, _find.default)(_context80 = this.container).call(_context80, 'input').first();
          this.search_results = (0, _find.default)(_context81 = this.container).call(_context81, 'ul.chzn-results').first();
          this.search_field_scale();
          this.search_no_results = (0, _find.default)(_context82 = this.container).call(_context82, 'li.no-results').first();

          if (this.is_multiple) {
            var _context83, _context84;

            this.search_choices = (0, _find.default)(_context83 = this.container).call(_context83, 'ul.chzn-choices').first();
            this.search_container = (0, _find.default)(_context84 = this.container).call(_context84, 'li.search-field').first();
          } else {
            var _context85, _context86;

            this.search_container = (0, _find.default)(_context85 = this.container).call(_context85, 'div.chzn-search').first();
            this.selected_item = (0, _find.default)(_context86 = this.container).call(_context86, '.chzn-single').first();
          }

          this.results_build();
          this.set_tab_index();
          this.set_label_behavior();
          return this.form_field_jq.trigger("liszt:ready", {
            chosen: this
          });
        };

        Chosen.prototype.register_observers = function () {
          var _context87, _context88, _context89, _context90;

          var _this = this;

          this.container.mousedown(function (evt) {
            _this.container_mousedown(evt);
          });
          this.container.mouseup(function (evt) {
            _this.container_mouseup(evt);
          });
          this.container.mouseenter(function (evt) {
            _this.mouse_enter(evt);
          });
          this.container.mouseleave(function (evt) {
            _this.mouse_leave(evt);
          });
          this.search_results.mouseup(function (evt) {
            _this.search_results_mouseup(evt);
          });
          this.search_results.mouseover(function (evt) {
            _this.search_results_mouseover(evt);
          });
          this.search_results.mouseout(function (evt) {
            _this.search_results_mouseout(evt);
          });
          (0, _bind.default)(_context87 = this.search_results).call(_context87, 'mousewheel DOMMouseScroll', function (evt) {
            _this.search_results_mousewheel(evt);
          });
          (0, _bind.default)(_context88 = this.form_field_jq).call(_context88, "liszt:updated", function (evt) {
            _this.results_update_field(evt);
          });
          (0, _bind.default)(_context89 = this.form_field_jq).call(_context89, "liszt:activate", function (evt) {
            _this.activate_field(evt);
          });
          (0, _bind.default)(_context90 = this.form_field_jq).call(_context90, "liszt:open", function (evt) {
            _this.container_mousedown(evt);
          });
          this.search_field.blur(function (evt) {
            _this.input_blur(evt);
          });
          this.search_field.keyup(function (evt) {
            _this.keyup_checker(evt);
          });
          this.search_field.keydown(function (evt) {
            _this.keydown_checker(evt);
          });
          this.search_field.focus(function (evt) {
            _this.input_focus(evt);
          });

          if (this.is_multiple) {
            return this.search_choices.click(function (evt) {
              _this.choices_click(evt);
            });
          } else {
            return this.container.click(function (evt) {
              evt.preventDefault();
            });
          }
        };

        Chosen.prototype.search_field_disabled = function () {
          this.is_disabled = this.form_field_jq[0].disabled;

          if (this.is_disabled) {
            this.container.addClass('chzn-disabled');
            this.search_field[0].disabled = true;

            if (!this.is_multiple) {
              this.selected_item.unbind("focus", this.activate_action);
            }

            return this.close_field();
          } else {
            this.container.removeClass('chzn-disabled');
            this.search_field[0].disabled = false;

            if (!this.is_multiple) {
              var _context91;

              return (0, _bind.default)(_context91 = this.selected_item).call(_context91, "focus", this.activate_action);
            }
          }
        };

        Chosen.prototype.container_mousedown = function (evt) {
          if (!this.is_disabled) {
            if (evt && evt.type === "mousedown" && !this.results_showing) {
              evt.preventDefault();
            }

            if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
              if (!this.active_field) {
                if (this.is_multiple) {
                  this.search_field.val("");
                }

                $(document).click(this.click_test_action);
                this.results_show();
              } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chzn-single").length)) {
                evt.preventDefault();
                this.results_toggle();
              }

              return this.activate_field();
            }
          }
        };

        Chosen.prototype.container_mouseup = function (evt) {
          if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
            return this.results_reset(evt);
          }
        };

        Chosen.prototype.search_results_mousewheel = function (evt) {
          var delta, _ref1, _ref2;

          delta = -((_ref1 = evt.originalEvent) != null ? _ref1.wheelDelta : void 0) || ((_ref2 = evt.originialEvent) != null ? _ref2.detail : void 0);

          if (delta != null) {
            evt.preventDefault();

            if (evt.type === 'DOMMouseScroll') {
              delta = delta * 40;
            }

            return this.search_results.scrollTop(delta + this.search_results.scrollTop());
          }
        };

        Chosen.prototype.blur_test = function (evt) {
          if (!this.active_field && this.container.hasClass("chzn-container-active")) {
            return this.close_field();
          }
        };

        Chosen.prototype.close_field = function () {
          $(document).unbind("click", this.click_test_action);
          this.active_field = false;
          this.results_hide();
          this.container.removeClass("chzn-container-active");
          this.clear_backstroke();
          this.show_search_field_default();
          return this.search_field_scale();
        };

        Chosen.prototype.activate_field = function () {
          this.container.addClass("chzn-container-active");
          this.active_field = true;
          this.search_field.val(this.search_field.val());
          return this.search_field.focus();
        };

        Chosen.prototype.test_active_click = function (evt) {
          if ($(evt.target).parents('#' + this.container_id).length) {
            return this.active_field = true;
          } else {
            return this.close_field();
          }
        };

        Chosen.prototype.results_build = function () {
          var content, data, _i, _len, _ref1;

          this.parsing = true;
          this.selected_option_count = null;
          this.results_data = root.SelectParser.select_to_array(this.form_field);

          if (this.is_multiple) {
            var _context92;

            (0, _find.default)(_context92 = this.search_choices).call(_context92, "li.search-choice").remove();
          } else if (!this.is_multiple) {
            var _context93;

            (0, _find.default)(_context93 = this.selected_item.addClass("chzn-default")).call(_context93, "span").text(this.default_text);

            if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
              this.search_field[0].readOnly = true;
              this.container.addClass("chzn-container-single-nosearch");
            } else {
              this.search_field[0].readOnly = false;
              this.container.removeClass("chzn-container-single-nosearch");
            }
          }

          content = '';
          _ref1 = this.results_data;

          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            data = _ref1[_i];

            if (data.group) {
              content += this.result_add_group(data);
            } else if (!data.empty) {
              content += this.result_add_option(data);

              if (data.selected && this.is_multiple) {
                this.choice_build(data);
              } else if (data.selected && !this.is_multiple) {
                var _context94;

                (0, _find.default)(_context94 = this.selected_item.removeClass("chzn-default")).call(_context94, "span").text(data.text);

                if (this.allow_single_deselect) {
                  this.single_deselect_control_build();
                }
              }
            }
          }

          this.search_field_disabled();
          this.show_search_field_default();
          this.search_field_scale();
          this.search_results.html(content);
          return this.parsing = false;
        };

        Chosen.prototype.result_add_group = function (group) {
          group.dom_id = this.container_id + "_g_" + group.array_index;
          return '<li id="' + group.dom_id + '" class="group-result">' + $("<div></div>").text(group.label).html() + '</li>';
        };

        Chosen.prototype.result_do_highlight = function (el) {
          var high_bottom, high_top, maxHeight, visible_bottom, visible_top;

          if (el.length) {
            this.result_clear_highlight();
            this.result_highlight = el;
            this.result_highlight.addClass("highlighted");
            maxHeight = (0, _parseInt3.default)(this.search_results.css("maxHeight"), 10);
            visible_top = this.search_results.scrollTop();
            visible_bottom = maxHeight + visible_top;
            high_top = this.result_highlight.position().top + this.search_results.scrollTop();
            high_bottom = high_top + this.result_highlight.outerHeight();

            if (high_bottom >= visible_bottom) {
              return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
            } else if (high_top < visible_top) {
              return this.search_results.scrollTop(high_top);
            }
          }
        };

        Chosen.prototype.result_clear_highlight = function () {
          if (this.result_highlight) {
            this.result_highlight.removeClass("highlighted");
          }

          return this.result_highlight = null;
        };

        Chosen.prototype.results_show = function () {
          if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
            this.form_field_jq.trigger("liszt:maxselected", {
              chosen: this
            });
            return false;
          }

          this.container.addClass("chzn-with-drop");
          this.form_field_jq.trigger("liszt:showing_dropdown", {
            chosen: this
          });
          this.results_showing = true;
          this.search_field.focus();
          this.search_field.val(this.search_field.val());
          return this.winnow_results();
        };

        Chosen.prototype.results_hide = function () {
          if (this.results_showing) {
            this.result_clear_highlight();
            this.container.removeClass("chzn-with-drop");
            this.form_field_jq.trigger("liszt:hiding_dropdown", {
              chosen: this
            });
          }

          return this.results_showing = false;
        };

        Chosen.prototype.set_tab_index = function (el) {
          var ti;

          if (this.form_field_jq.attr("tabindex")) {
            ti = this.form_field_jq.attr("tabindex");
            this.form_field_jq.attr("tabindex", -1);
            return this.search_field.attr("tabindex", ti);
          }
        };

        Chosen.prototype.set_label_behavior = function () {
          var _this = this;

          this.form_field_label = this.form_field_jq.parents("label");

          if (!this.form_field_label.length && this.form_field.id.length) {
            this.form_field_label = $("label[for='" + this.form_field.id + "']");
          }

          if (this.form_field_label.length > 0) {
            return this.form_field_label.click(function (evt) {
              if (_this.is_multiple) {
                return _this.container_mousedown(evt);
              } else {
                return _this.activate_field();
              }
            });
          }
        };

        Chosen.prototype.show_search_field_default = function () {
          if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
            this.search_field.val(this.default_text);
            return this.search_field.addClass("default");
          } else {
            this.search_field.val("");
            return this.search_field.removeClass("default");
          }
        };

        Chosen.prototype.search_results_mouseup = function (evt) {
          var target;
          target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();

          if (target.length) {
            this.result_highlight = target;
            this.result_select(evt);
            return this.search_field.focus();
          }
        };

        Chosen.prototype.search_results_mouseover = function (evt) {
          var target;
          target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();

          if (target) {
            return this.result_do_highlight(target);
          }
        };

        Chosen.prototype.search_results_mouseout = function (evt) {
          if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
            return this.result_clear_highlight();
          }
        };

        Chosen.prototype.choice_build = function (item) {
          var choice,
              close_link,
              _this = this;

          choice = $('<li></li>', {
            "class": "search-choice"
          }).html("<span>" + item.html + "</span>");

          if (item.disabled) {
            choice.addClass('search-choice-disabled');
          } else {
            close_link = $('<a></a>', {
              href: '#',
              "class": 'search-choice-close',
              rel: item.array_index
            });
            close_link.click(function (evt) {
              return _this.choice_destroy_link_click(evt);
            });
            choice.append(close_link);
          }

          return this.search_container.before(choice);
        };

        Chosen.prototype.choice_destroy_link_click = function (evt) {
          evt.preventDefault();
          evt.stopPropagation();

          if (!this.is_disabled) {
            return this.choice_destroy($(evt.target));
          }
        };

        Chosen.prototype.choice_destroy = function (link) {
          if (this.result_deselect(link.attr("rel"))) {
            this.show_search_field_default();

            if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
              this.results_hide();
            }

            link.parents('li').first().remove();
            return this.search_field_scale();
          }
        };

        Chosen.prototype.results_reset = function () {
          var _context95;

          this.form_field.options[0].selected = true;
          this.selected_option_count = null;
          (0, _find.default)(_context95 = this.selected_item).call(_context95, "span").text(this.default_text);

          if (!this.is_multiple) {
            this.selected_item.addClass("chzn-default");
          }

          this.show_search_field_default();
          this.results_reset_cleanup();
          this.form_field_jq.trigger("change");

          if (this.active_field) {
            return this.results_hide();
          }
        };

        Chosen.prototype.results_reset_cleanup = function () {
          var _context96;

          this.current_selectedIndex = this.form_field.selectedIndex;
          return (0, _find.default)(_context96 = this.selected_item).call(_context96, "abbr").remove();
        };

        Chosen.prototype.result_select = function (evt) {
          var high, high_id, item, position;

          if (this.result_highlight) {
            high = this.result_highlight;
            high_id = high.attr("id");
            this.result_clear_highlight();

            if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
              this.form_field_jq.trigger("liszt:maxselected", {
                chosen: this
              });
              return false;
            }

            if (this.is_multiple) {
              high.removeClass("active-result");
            } else {
              var _context97;

              (0, _find.default)(_context97 = this.search_results).call(_context97, ".result-selected").removeClass("result-selected");
              this.result_single_selected = high;
              this.selected_item.removeClass("chzn-default");
            }

            high.addClass("result-selected");
            position = high_id.substr((0, _lastIndexOf.default)(high_id).call(high_id, "_") + 1);
            item = this.results_data[position];
            item.selected = true;
            this.form_field.options[item.options_index].selected = true;
            this.selected_option_count = null;

            if (this.is_multiple) {
              this.choice_build(item);
            } else {
              var _context98;

              (0, _find.default)(_context98 = this.selected_item).call(_context98, "span").first().text(item.text);

              if (this.allow_single_deselect) {
                this.single_deselect_control_build();
              }
            }

            if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
              this.results_hide();
            }

            this.search_field.val("");

            if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
              this.form_field_jq.trigger("change", {
                'selected': this.form_field.options[item.options_index].value
              });
            }

            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.search_field_scale();
          }
        };

        Chosen.prototype.result_activate = function (el, option) {
          if (option.disabled) {
            return el.addClass("disabled-result");
          } else if (this.is_multiple && option.selected) {
            return el.addClass("result-selected");
          } else {
            return el.addClass("active-result");
          }
        };

        Chosen.prototype.result_deactivate = function (el) {
          return el.removeClass("active-result result-selected disabled-result");
        };

        Chosen.prototype.result_deselect = function (pos) {
          var result, result_data;
          result_data = this.results_data[pos];

          if (!this.form_field.options[result_data.options_index].disabled) {
            result_data.selected = false;
            this.form_field.options[result_data.options_index].selected = false;
            this.selected_option_count = null;
            result = $("#" + this.container_id + "_o_" + pos);
            result.removeClass("result-selected").addClass("active-result").show();
            this.result_clear_highlight();
            this.winnow_results();
            this.form_field_jq.trigger("change", {
              deselected: this.form_field.options[result_data.options_index].value
            });
            this.search_field_scale();
            return true;
          } else {
            return false;
          }
        };

        Chosen.prototype.single_deselect_control_build = function () {
          var _context99;

          if (!this.allow_single_deselect) {
            return;
          }

          if (!(0, _find.default)(_context99 = this.selected_item).call(_context99, "abbr").length) {
            var _context100;

            (0, _find.default)(_context100 = this.selected_item).call(_context100, "span").first().after("<abbr class=\"search-choice-close\"></abbr>");
          }

          return this.selected_item.addClass("chzn-single-with-deselect");
        };

        Chosen.prototype.winnow_results = function () {
          var found, option, part, parts, regex, regexAnchor, result, result_id, results, searchText, startpos, text, zregex, _i, _j, _len, _len1, _ref1;

          this.no_results_clear();
          results = 0;
          searchText = this.search_field.val() === this.default_text ? "" : $('<div></div>').text((0, _trim.default)($).call($, this.search_field.val())).html();
          regexAnchor = this.search_contains ? "" : "^";
          regex = new RegExp(regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
          zregex = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
          _ref1 = this.results_data;

          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            option = _ref1[_i];

            if (!option.empty) {
              if (option.group) {
                $('#' + option.dom_id).css('display', 'none');
              } else {
                var _context101, _context102;

                found = false;
                result_id = option.dom_id;
                result = $("#" + result_id);

                if (regex.test(option.html)) {
                  found = true;
                  results += 1;
                } else if (this.enable_split_word_search && ((0, _indexOf.default)(_context101 = option.html).call(_context101, " ") >= 0 || (0, _indexOf.default)(_context102 = option.html).call(_context102, "[") === 0)) {
                  parts = option.html.replace(/\[|\]/g, "").split(" ");

                  if (parts.length) {
                    for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                      part = parts[_j];

                      if (regex.test(part)) {
                        found = true;
                        results += 1;
                      }
                    }
                  }
                }

                if (found) {
                  if (searchText.length) {
                    startpos = option.html.search(zregex);
                    text = option.html.substr(0, startpos + searchText.length) + '</em>' + option.html.substr(startpos + searchText.length);
                    text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                  } else {
                    text = option.html;
                  }

                  result.html(text);
                  this.result_activate(result, option);

                  if (option.group_array_index != null) {
                    $("#" + this.results_data[option.group_array_index].dom_id).css('display', 'list-item');
                  }
                } else {
                  if (this.result_highlight && result_id === this.result_highlight.attr('id')) {
                    this.result_clear_highlight();
                  }

                  this.result_deactivate(result);
                }
              }
            }
          }

          if (results < 1 && searchText.length) {
            return this.no_results(searchText);
          } else {
            return this.winnow_results_set_highlight();
          }
        };

        Chosen.prototype.winnow_results_set_highlight = function () {
          var do_high, selected_results;

          if (!this.result_highlight) {
            var _context103, _context104;

            selected_results = !this.is_multiple ? (0, _find.default)(_context103 = this.search_results).call(_context103, ".result-selected.active-result") : [];
            do_high = selected_results.length ? selected_results.first() : (0, _find.default)(_context104 = this.search_results).call(_context104, ".active-result").first();

            if (do_high != null) {
              return this.result_do_highlight(do_high);
            }
          }
        };

        Chosen.prototype.no_results = function (terms) {
          var no_results_html;
          no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
          (0, _find.default)(no_results_html).call(no_results_html, "span").first().html(terms);
          return this.search_results.append(no_results_html);
        };

        Chosen.prototype.no_results_clear = function () {
          var _context105;

          return (0, _find.default)(_context105 = this.search_results).call(_context105, ".no-results").remove();
        };

        Chosen.prototype.keydown_arrow = function () {
          var next_sib;

          if (this.results_showing && this.result_highlight) {
            next_sib = this.result_highlight.nextAll("li.active-result").first();

            if (next_sib) {
              return this.result_do_highlight(next_sib);
            }
          } else {
            return this.results_show();
          }
        };

        Chosen.prototype.keyup_arrow = function () {
          var prev_sibs;

          if (!this.results_showing && !this.is_multiple) {
            return this.results_show();
          } else if (this.result_highlight) {
            prev_sibs = this.result_highlight.prevAll("li.active-result");

            if (prev_sibs.length) {
              return this.result_do_highlight(prev_sibs.first());
            } else {
              if (this.choices_count() > 0) {
                this.results_hide();
              }

              return this.result_clear_highlight();
            }
          }
        };

        Chosen.prototype.keydown_backstroke = function () {
          var next_available_destroy;

          if (this.pending_backstroke) {
            var _context106;

            this.choice_destroy((0, _find.default)(_context106 = this.pending_backstroke).call(_context106, "a").first());
            return this.clear_backstroke();
          } else {
            next_available_destroy = this.search_container.siblings("li.search-choice").last();

            if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
              this.pending_backstroke = next_available_destroy;

              if (this.single_backstroke_delete) {
                return this.keydown_backstroke();
              } else {
                return this.pending_backstroke.addClass("search-choice-focus");
              }
            }
          }
        };

        Chosen.prototype.clear_backstroke = function () {
          if (this.pending_backstroke) {
            this.pending_backstroke.removeClass("search-choice-focus");
          }

          return this.pending_backstroke = null;
        };

        Chosen.prototype.keydown_checker = function (evt) {
          var stroke, _ref1;

          stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
          this.search_field_scale();

          if (stroke !== 8 && this.pending_backstroke) {
            this.clear_backstroke();
          }

          switch (stroke) {
            case 8:
              this.backstroke_length = this.search_field.val().length;
              break;

            case 9:
              if (this.results_showing && !this.is_multiple) {
                this.result_select(evt);
              }

              this.mouse_on_container = false;
              break;

            case 13:
              evt.preventDefault();
              break;

            case 38:
              evt.preventDefault();
              this.keyup_arrow();
              break;

            case 40:
              evt.preventDefault();
              this.keydown_arrow();
              break;
          }
        };

        Chosen.prototype.search_field_scale = function () {
          var div, h, style, style_block, styles, w, _i, _len;

          if (this.is_multiple) {
            h = 0;
            w = 0;
            style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
            styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];

            for (_i = 0, _len = styles.length; _i < _len; _i++) {
              style = styles[_i];
              style_block += style + ":" + this.search_field.css(style) + ";";
            }

            div = $('<div></div>', {
              'style': style_block
            });
            div.text(this.search_field.val());
            $('body').append(div);
            w = div.width() + 25;
            div.remove();

            if (!this.f_width) {
              this.f_width = this.container.outerWidth();
            }

            if (w > this.f_width - 10) {
              w = this.f_width - 10;
            }

            return this.search_field.css({
              'width': w + 'px'
            });
          }
        };

        Chosen.prototype.generate_random_id = function () {
          var string;
          string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();

          while ($("#" + string).length > 0) {
            string += this.generate_random_char();
          }

          return string;
        };

        return Chosen;
      }(AbstractChosen);

      root.Chosen = Chosen;
    }).call(this);
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 79 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  var _DeletableBox = _interopRequireDefault(__webpack_require__(80));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _default = _BaseInput.default.extend({
    className: 'array-input',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a href=\"#\" class=\"array-inputs-button link-button\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "courage",
            "code": "oform.add.another"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 52
            },
            "end": {
              "line": 1,
              "column": 102
            }
          }
        })) + "</a>";
      },
      "useData": true
    }),
    params: {
      itemType: 'string'
    },
    events: {
      'click .array-inputs-button': function clickArrayInputsButton(e) {
        e.preventDefault();

        if (this.isEditMode()) {
          this.addNewElement();
        }
      }
    },
    initialize: function initialize(options) {
      options || (options = {});
      this.params = _underscoreWrapper.default.defaults(options.params || {}, this.params);
      this.uniqueIdPrefix = 'array';
    },
    // api returns null for an array that does not have value
    // convert it to an empty array
    from: function from(val) {
      if (!_underscoreWrapper.default.isArray(val)) {
        return [];
      }

      return val;
    },
    // @Override
    editMode: function editMode() {
      var _context107;

      this._setArrayObject();

      this.$el.html(this.template);

      _underscoreWrapper.default.each(this.arrayObject, (0, _bind.default)(_context107 = _underscoreWrapper.default).call(_context107, this._addDeletableBox, this));

      return this;
    },
    // @Override
    readMode: function readMode() {
      this.editMode();
      this.$('.array-inputs-button').addClass('link-button-disabled');
    },
    // @Override
    // converts arrayObject to a plain array
    // for string type array, returns all values
    // for number/integer type array, returns values in number type
    val: function val() {
      var _context108;

      var values = (0, _values.default)(_context108 = _underscoreWrapper.default).call(_context108, this.arrayObject);

      if (_underscoreWrapper.default.contains([_SchemaUtil.default.DATATYPE.number, _SchemaUtil.default.DATATYPE.integer], this.params.itemType)) {
        var _context109;

        values = (0, _filter.default)(_context109 = _underscoreWrapper.default).call(_context109, values, _underscoreWrapper.default.isNumber);
      }

      return values;
    },
    focus: function focus() {},
    addNewElement: function addNewElement() {
      var value = '';

      var key = _underscoreWrapper.default.uniqueId(this.uniqueIdPrefix);

      this.arrayObject[key] = value;

      this._addDeletableBox(value, key); // update is called to make sure an empty string value is added for string type array


      this.update();
    },
    _addDeletableBox: function _addDeletableBox(value, key) {
      var deletableBox = new _DeletableBox.default(_underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this.options, 'read', 'readOnly', 'model'), {
        key: key,
        value: value,
        itemType: this.params.itemType
      }));
      this.listenTo(deletableBox, 'updateArray', function (updatedValue) {
        if (_underscoreWrapper.default.isNull(updatedValue)) {
          delete this.arrayObject[key];
          this.stopListening(deletableBox);
        } else {
          this.arrayObject[key] = updatedValue;
        }

        this.update();
      });
      deletableBox.render().$el.hide();
      this.$('.array-inputs-button').before(deletableBox.el);
      deletableBox.$el.slideDown();
      return deletableBox;
    },
    _setArrayObject: function _setArrayObject() {
      var array = this.model.get(this.options.name);
      this.arrayObject = {};

      if (_underscoreWrapper.default.isArray(array) && !_underscoreWrapper.default.isEmpty(array)) {
        var keys = [];
        var self = this;
        (0, _underscoreWrapper.default)(array.length).times(function () {
          keys.push(_underscoreWrapper.default.uniqueId(self.uniqueIdPrefix));
        });
        this.arrayObject = _underscoreWrapper.default.object(keys, array);
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _SchemaUtil = _interopRequireDefault(__webpack_require__(13));

  var _StringUtil = _interopRequireDefault(__webpack_require__(4));

  var _Time = _interopRequireDefault(__webpack_require__(32));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var isVowel = function isVowel(string) {
    return /^[aeiou]/.test(string);
  };

  var getArticle = function getArticle(string) {
    return isVowel(string) ? 'an' : 'a';
  };

  var template = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"o-form-input-group-controls\"><span class=\"input-fix o-form-control\"><input type=\"text\" class=\"o-form-text\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "key",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 125
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "key",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 138
          },
          "end": {
            "line": 1,
            "column": 145
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 154
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 178
          },
          "end": {
            "line": 1,
            "column": 193
          }
        }
      }) : helper)) + "\"/></span><a href=\"#\" class=\"link-button link-button-icon icon-only\"><span class=\"icon clear-input-16 \"></span></a></div><p class=\"o-form-input-error o-form-explain\"><span class=\"icon icon-16 error-16-small\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "errorExplain") || (depth0 != null ? lookupProperty(depth0, "errorExplain") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
        "name": "errorExplain",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 408
          },
          "end": {
            "line": 1,
            "column": 424
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  });

  var errorClass = 'o-form-has-errors';
  var updateArrayEvent = 'updateArray';

  var _default = _BaseView.default.extend({
    tagName: 'div',
    className: 'o-form-input-group',
    events: {
      'click a': function clickA(e) {
        e.preventDefault();
        this.remove();
      },
      'keyup input': function keyupInput() {
        this.update();
      }
    },
    isEditMode: function isEditMode() {
      return !this.options.readOnly && (this.options.read !== true || this.model.get('__edit__') === true);
    },
    initialize: function initialize() {
      this.template = template(_underscoreWrapper.default.extend(this.options, {
        placeholder: this.getPlaceholderText(),
        errorExplain: this.getErrorExplainText()
      }));
      this.update = _underscoreWrapper.default.debounce(this.update, this.options.debounceDelay || _Time.default.DEBOUNCE_DELAY);
    },
    render: function render() {
      if (this.isEditMode()) {
        this.$el.html(this.template);
      } else {
        this.$el.text(this.options.value);
        this.$('a').hide();
      }

      return this;
    },
    remove: function remove() {
      var _arguments = arguments,
          _this = this;

      this.trigger(updateArrayEvent, null);
      this.$el.slideUp(function () {
        _BaseView.default.prototype.remove.call(_this, _arguments);
      });
    },
    update: function update() {
      var updatedValue = this.$('input').val();

      var parseFunc = _underscoreWrapper.default.object([_SchemaUtil.default.DATATYPE.number, _SchemaUtil.default.DATATYPE.integer], [_StringUtil.default.parseFloat, this.parseInt]);

      if (_underscoreWrapper.default.has(parseFunc, this.options.itemType)) {
        updatedValue = parseFunc[this.options.itemType](updatedValue);
        !_underscoreWrapper.default.isNumber(updatedValue) ? this.markInvalid() : this.clearInvalid();
      }

      this.trigger(updateArrayEvent, updatedValue);
    },
    markInvalid: function markInvalid() {
      this.$el.addClass(errorClass);
    },
    clearInvalid: function clearInvalid() {
      this.$el.removeClass(errorClass);
    },
    getPlaceholderText: function getPlaceholderText() {
      var text = ['Enter'];
      text.push(getArticle(this.options.itemType));
      text.push(this.options.itemType.toLowerCase());
      return text.join(' ');
    },
    getErrorExplainText: function getErrorExplainText() {
      var text = ['Value must be'];
      text.push(getArticle(this.options.itemType));
      text.push(this.options.itemType.toLowerCase());
      return text.join(' ');
    },
    parseInt: function (_parseInt) {
      function parseInt(_x) {
        return _parseInt.apply(this, arguments);
      }

      parseInt.toString = function () {
        return _parseInt.toString();
      };

      return parseInt;
    }(function (string) {
      // native javascript parseInt is aggressive
      // there're cases we don't want a string to be parsed even though it is convertable
      // so that we don't convert a string silently before warning a user the potential error
      // this is to make sure the string is in an integer format before we parse it
      if (/^-?\d+$/.test(string)) {
        var num = (0, _parseInt3.default)(string, 10);
        return !_underscoreWrapper.default.isNaN(num) ? num : string;
      }

      return string;
    })
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  __webpack_require__(33);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var _default = _BaseInput.default.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 29
            },
            "end": {
              "line": 1,
              "column": 37
            }
          }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 43
            },
            "end": {
              "line": 1,
              "column": 54
            }
          }
        }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "inputId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 69
            },
            "end": {
              "line": 1,
              "column": 80
            }
          }
        }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 100
            },
            "end": {
              "line": 1,
              "column": 108
            }
          }
        }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "placeholder",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 110
            },
            "end": {
              "line": 1,
              "column": 125
            }
          }
        }) : helper)) + "</label>";
      },
      "useData": true
    }),

    /**
     * @Override
     */
    events: {
      'change :checkbox': 'update',
      keyup: function keyup(e) {
        e.preventDefault();

        if (_Keys.default.isSpaceBar(e)) {
          this.$(':checkbox').click();
        } else if (_Keys.default.isEnter(e)) {
          this.model.trigger('form:save');
        }
      }
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      var placeholder = _underscoreWrapper.default.resultCtx(this.options, 'placeholder', this);

      if (placeholder === '') {
        placeholder = _underscoreWrapper.default.resultCtx(this.options, 'label', this);
      } else if (placeholder === false) {
        placeholder = '';
      }

      this.$el.html(this.template(_underscoreWrapper.default.extend(_underscoreWrapper.default.omit(this.options, 'placeholder'), {
        placeholder: placeholder
      })));
      var $input = this.$(':checkbox');
      $input.prop('checked', this.getModelValue() || false);
      this.$('input').customInput();
      this.model.trigger('form:resize');
      return this;
    },

    /**
     * @Override
     */
    readMode: function readMode() {
      this.editMode();
      this.$(':checkbox').prop('disabled', true);
      return this;
    },

    /**
     * @Override
     */
    val: function val() {
      return this.$(':checkbox').prop('checked');
    },

    /**
     * @Override
     */
    focus: function focus() {
      return this.$(':checkbox').focus();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _TextBox = _interopRequireDefault(__webpack_require__(34));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /*!
   * Copyright (c) 2015-2018, Okta, Inc. and/or its affiliates. All rights reserved.
   * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
   *
   * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
   * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   *
   * See the License for the specific language governing permissions and limitations under the License.
   */


  var toggleTemplate = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<span class=\"password-toggle\"><span class=\"eyeicon visibility-16 button-show\"></span><span class=\"eyeicon visibility-off-16 button-hide\"></span></span>";
    },
    "useData": true
  });

  var toggleTimeout = 30000;

  var _default = _TextBox.default.extend({
    initialize: function initialize() {
      if (this.__showPasswordToggle()) {
        this.events['click .password-toggle .button-show'] = '__showPassword';
        this.events['click .password-toggle .button-hide'] = '__hidePassword';
      }

      this.delegateEvents();
    },
    postRender: function postRender() {
      if (this.isEditMode() && this.__showPasswordToggle()) {
        var _context110;

        this.$el.append(toggleTemplate);
        (0, _find.default)(_context110 = this.$el).call(_context110, 'input[type="password"]').addClass('password-with-toggle');
      }

      _TextBox.default.prototype.postRender.apply(this, arguments);
    },
    __showPasswordToggle: function __showPasswordToggle() {
      return this.options.params && this.options.params.showPasswordToggle;
    },
    __showPassword: function __showPassword() {
      var _this = this;

      _TextBox.default.prototype.changeType.apply(this, ['text']);

      this.$('.password-toggle .button-show').hide();
      this.$('.password-toggle .button-hide').show();
      this.passwordToggleTimer = _underscoreWrapper.default.delay(function () {
        _this.__hidePassword();
      }, toggleTimeout);
    },
    __hidePassword: function __hidePassword() {
      _TextBox.default.prototype.changeType.apply(this, ['password']);

      this.$('.password-toggle .button-show').show();
      this.$('.password-toggle .button-hide').hide(); // clear timeout

      if (this.passwordToggleTimer) {
        clearTimeout(this.passwordToggleTimer);
      }
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 83 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /*! http://mths.be/placeholder v2.0.7 by @mathias */


  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
    var isInputSupported = ('placeholder' in document.createElement('input')),
        isTextareaSupported = ('placeholder' in document.createElement('textarea')),
        prototype = $.fn,
        valHooks = $.valHooks,
        hooks,
        placeholder;

    if (isInputSupported && isTextareaSupported) {
      placeholder = prototype.placeholder = function () {
        return this;
      };

      placeholder.input = placeholder.textarea = true;
    } else {
      var _context112;

      placeholder = prototype.placeholder = function () {
        var _context111;

        var $this = this;
        (0, _bind.default)(_context111 = (0, _filter.default)($this).call($this, (isInputSupported ? 'textarea' : ':input') + '[placeholder]').not('.placeholder')).call(_context111, {
          'focus.placeholder': clearPlaceholder,
          'blur.placeholder': setPlaceholder
        }).data('placeholder-enabled', true).trigger('blur.placeholder');
        return $this;
      };

      placeholder.input = isInputSupported;
      placeholder.textarea = isTextareaSupported;
      hooks = {
        'get': function get(element) {
          var $element = $(element);
          return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
        },
        'set': function set(element, value) {
          var $element = $(element);

          if (!$element.data('placeholder-enabled')) {
            return element.value = value;
          }

          if (value == '') {
            element.value = value; // Issue #56: Setting the placeholder causes problems if the element continues to have focus.

            if (element != document.activeElement) {
              // We can't use `triggerHandler` here because of dummy text/password inputs :(
              setPlaceholder.call(element);
            }
          } else if ($element.hasClass('placeholder')) {
            clearPlaceholder.call(element, true, value) || (element.value = value);
          } else {
            element.value = value;
          } // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363


          return $element;
        }
      };
      isInputSupported || (valHooks.input = hooks);
      isTextareaSupported || (valHooks.textarea = hooks);
      $(function () {
        // Look for forms
        $(document).delegate('form', 'submit.placeholder', function () {
          // Clear the placeholder values so they don't get submitted
          var $inputs = $('.placeholder', this).each(clearPlaceholder);
          (0, _setTimeout2.default)(function () {
            $inputs.each(setPlaceholder);
          }, 10);
        });
      }); // Clear placeholder values upon page reload

      (0, _bind.default)(_context112 = $(window)).call(_context112, 'beforeunload.placeholder', function () {
        $('.placeholder').each(function () {
          this.value = '';
        });
      });
    }

    function args(elem) {
      // Return an object of element attributes
      var newAttrs = {},
          rinlinejQuery = /^jQuery\d+$/;
      $.each(elem.attributes, function (i, attr) {
        if (attr.specified && !rinlinejQuery.test(attr.name)) {
          newAttrs[attr.name] = attr.value;
        }
      });
      return newAttrs;
    }

    function clearPlaceholder(event, value) {
      var input = this,
          $input = $(input);

      if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
        if ($input.data('placeholder-password')) {
          $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id')); // If `clearPlaceholder` was called from `$.valHooks.input.set`

          if (event === true) {
            return $input[0].value = value;
          }

          $input.focus();
        } else {
          input.value = '';
          $input.removeClass('placeholder');
          input == document.activeElement && input.select();
        }
      }
    }

    function setPlaceholder() {
      var $replacement,
          input = this,
          $input = $(input),
          $origInput = $input,
          id = this.id;

      if (input.value == '') {
        if (input.type == 'password') {
          if (!$input.data('placeholder-textinput')) {
            var _context113;

            try {
              $replacement = $input.clone().attr({
                'type': 'text'
              });
            } catch (e) {
              $replacement = $('<input>').attr($.extend(args(this), {
                'type': 'text'
              }));
            }

            (0, _bind.default)(_context113 = $replacement.removeAttr('name').data({
              'placeholder-password': true,
              'placeholder-id': id
            })).call(_context113, 'focus.placeholder', clearPlaceholder);
            $input.data({
              'placeholder-textinput': $replacement,
              'placeholder-id': id
            }).before($replacement);
          }

          $input = $input.removeAttr('id').hide().prev().attr('id', id).show(); // Note: `$input[0] != input` now!
        }

        $input.addClass('placeholder');
        $input[0].value = $input.attr('placeholder');
      } else {
        $input.removeClass('placeholder');
      }
    }
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  /***/
},
/* 84 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _runtime = _interopRequireDefault(__webpack_require__(2));

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _Keys = _interopRequireDefault(__webpack_require__(8));

  var _Util = _interopRequireDefault(__webpack_require__(19));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  __webpack_require__(33);

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof _symbol.default === "function" && typeof _iterator.default === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof _symbol.default === "function" && obj.constructor === _symbol.default && obj !== _symbol.default.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var isABaseView = _Util.default.isABaseView;

  var RadioRadioOption = _BaseView.default.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = "function",
            alias4 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<input type=\"radio\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "name",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 26
            },
            "end": {
              "line": 1,
              "column": 34
            }
          }
        }) : helper)) + "\" data-se-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "realName",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 50
            },
            "end": {
              "line": 1,
              "column": 62
            }
          }
        }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "value",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 71
            },
            "end": {
              "line": 1,
              "column": 80
            }
          }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "optionId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 86
            },
            "end": {
              "line": 1,
              "column": 98
            }
          }
        }) : helper)) + "\"><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "optionId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 112
            },
            "end": {
              "line": 1,
              "column": 124
            }
          }
        }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "realName",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 144
            },
            "end": {
              "line": 1,
              "column": 156
            }
          }
        }) : helper)) + "\" class=\"radio-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, _typeof(helper) === alias3 ? helper.call(alias1, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 178
            },
            "end": {
              "line": 1,
              "column": 187
            }
          }
        }) : helper)) + "</label>";
      },
      "useData": true
    }),
    initialize: function initialize(options) {
      var explain;
      explain = options.explain;

      if (_underscoreWrapper.default.isFunction(explain) && !isABaseView(explain)) {
        explain = _underscoreWrapper.default.resultCtx(this.options, 'explain', this);
      }

      if (!explain) {
        return;
      }

      if (isABaseView(explain)) {
        this.add('<p class="o-form-explain"></p>', '.radio-label');
        this.add(explain, '.o-form-explain');
      } else {
        this.add(_BaseView.default.extend({
          className: 'o-form-explain',
          tagName: 'p',
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "explain",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 11
                  }
                }
              }) : helper));
            },
            "useData": true
          })
        }), '.radio-label');
      }
    }
  });

  var _default = _BaseInput.default.extend({
    /**
     * @Override
     */
    events: {
      'change :radio': 'update',
      keyup: function keyup(e) {
        if (_Keys.default.isSpaceBar(e)) {
          (0, _jqueryWrapper.default)(e.target).click();
        } else if (_Keys.default.isEnter(e)) {
          this.model.trigger('form:save');
        }
      }
    },

    /**
     * @Override
     */
    editMode: function editMode() {
      var templates = [];
      this.$el.empty();

      _underscoreWrapper.default.each(this.options.options, function (value, key) {
        var options = {
          optionId: _underscoreWrapper.default.uniqueId('option'),
          name: this.options.inputId,
          realName: this.options.name,
          value: key
        };

        if (!_underscoreWrapper.default.isObject(value)) {
          value = {
            label: value
          };
        }

        _underscoreWrapper.default.extend(options, value);

        templates.push(new RadioRadioOption(options).render().el);
      }, this);

      this.$el.append(templates);
      var value = this.getModelValue();

      if (value) {
        this.$(':radio[value=' + value + ']').prop('checked', true);
      }

      this.$('input').customInput();
      this.model.trigger('form:resize');

      if (this.getParam('inline') === true) {
        this.$('div.custom-radio').addClass('inline');
      }

      return this;
    },

    /**
     * @Override
     */
    readMode: function readMode() {
      this.editMode();
      this.$(':radio').prop('disabled', true);
      return this;
    },

    /**
     * @Override
     */
    val: function val() {
      return this.$(':radio:checked').val();
    },

    /**
     * @Override
     */
    focus: function focus() {
      return this.$('label:eq(0)').focus();
    }
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 85 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  (0, _defineProperty.default)(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _underscoreWrapper = _interopRequireDefault(__webpack_require__(0));

  var _ButtonFactory = _interopRequireDefault(__webpack_require__(18));

  var _BaseView = _interopRequireDefault(__webpack_require__(1));

  var _BaseInput = _interopRequireDefault(__webpack_require__(9));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function countInputs(inputs) {
    var _context114;

    return (0, _filter.default)(_context114 = _underscoreWrapper.default).call(_context114, inputs || [], function (input) {
      return !_underscoreWrapper.default.contains(['label', 'button', 'select'], input.type);
    }).length;
  }

  var InputGroupLabelInput = _BaseInput.default.extend({
    tagName: 'span',
    initialize: function initialize() {
      this.$el.text(this.getModelValue());
    },
    editMode: function editMode() {
      this.toggle(true);
    },
    readMode: function readMode() {
      this.toggle(false);
    },
    getModelValue: function getModelValue() {
      return this.options.label;
    },
    toggle: function toggle(isEditMode) {
      this.$el.toggleClass('o-form-label-inline', isEditMode);
      this.$el.toggleClass('o-form-control', !isEditMode);
    },
    focus: _underscoreWrapper.default.noop
  });

  function createButtonInput(options) {
    return _ButtonFactory.default.create(_underscoreWrapper.default.defaults({
      getReadModeString: _underscoreWrapper.default.constant(' '),
      focus: _underscoreWrapper.default.noop
    }, _underscoreWrapper.default.pick(options, 'click', 'title', 'href', 'icon')));
  }

  var InputGroupInputGroupView = _BaseView.default.extend({
    getParams: _BaseInput.default.prototype.getParams,
    getParam: _BaseInput.default.prototype.getParam,
    className: function className() {
      var className;

      if (this.getParam('display') === 'text') {
        className = 'o-form-input-group-subtle';
      } else {
        className = 'o-form-input-group';
      }

      if (countInputs(this.getParam('inputs')) > 1) {
        className += ' o-form-input-group-2';
      }

      return className;
    },
    initialize: function initialize() {
      _underscoreWrapper.default.each(this.getParam('inputs'), function (input) {
        switch (input.type) {
          case 'label':
            this.add(InputGroupLabelInput, {
              options: input
            });
            break;

          case 'button':
            this.add(createButtonInput(input));
            break;

          default:
            input = _underscoreWrapper.default.defaults({
              model: this.model,
              params: _underscoreWrapper.default.extend({
                autoWidth: true
              }, input.params || {})
            }, input);
            this.add(this.getParams().create(input));
        }
      }, this);
    },
    focus: function focus() {
      this.first().focus();
    }
  });

  var _default = _BaseInput.default.extend({
    constructor: function constructor(options) {
      this.inputGroupView = new InputGroupInputGroupView(options);

      _BaseInput.default.apply(this, arguments);
    },
    editMode: function editMode() {
      this.inputGroupView.remove();
      this.inputGroupView = new InputGroupInputGroupView(this.options);
      this.$el.html(this.inputGroupView.render().el);
    },
    toStringValue: function toStringValue() {
      var _context115, _context116;

      var strings = (0, _map.default)(_context115 = this.inputGroupView).call(_context115, function (input) {
        return input.getReadModeString();
      });
      return strings.length && (0, _every.default)(_context116 = _underscoreWrapper.default).call(_context116, strings) ? strings.join(' ') : ' ';
    },
    focus: function focus() {
      this.inputGroupView.focus();
    }
  }, {
    // test hooks
    LabelInput: InputGroupLabelInput,
    InputGroupView: InputGroupInputGroupView
  });

  exports.default = _default;
  module.exports = exports.default;
  /***/
},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _jqueryWrapper = _interopRequireDefault(__webpack_require__(3));

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /*!
   * jQuery UI Scroll Parent @VERSION
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * Modifications Copyright 2021 Okta, Inc.
   */
  // This is required because SIW doesn't want to include jqueryui even though it's an external dependency of courage


  _jqueryWrapper.default.fn.scrollParent = function (includeHidden) {
    var _context117;

    var position = this.css("position"),
        excludeStaticParent = position === "absolute",
        overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
        scrollParent = (0, _filter.default)(_context117 = this.parents()).call(_context117, function () {
      var parent = (0, _jqueryWrapper.default)(this);

      if (excludeStaticParent && parent.css("position") === "static") {
        return false;
      }

      return overflowRegex.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
    }).eq(0);
    return position === "fixed" || !scrollParent.length ? (0, _jqueryWrapper.default)(this[0].ownerDocument || document) : scrollParent;
  };
  /***/

}
/******/
]);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var getOwnPropertyDescriptor = __webpack_require__(48).f;
var createNonEnumerableProperty = __webpack_require__(50);
var redefine = __webpack_require__(51);
var setGlobal = __webpack_require__(260);
var copyConstructorProperties = __webpack_require__(361);
var isForced = __webpack_require__(171);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(500);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(1090);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(141);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(99);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(1091);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(1093);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "BaseHeader", {
  enumerable: true,
  get: function get() {
    return _BaseHeader.default;
  }
});

_Object$defineProperty(exports, "BaseFooter", {
  enumerable: true,
  get: function get() {
    return _BaseFooter.default;
  }
});

_Object$defineProperty(exports, "BaseForm", {
  enumerable: true,
  get: function get() {
    return _BaseForm.default;
  }
});

_Object$defineProperty(exports, "BaseFormWithPolling", {
  enumerable: true,
  get: function get() {
    return _BaseFormWithPolling.default;
  }
});

_Object$defineProperty(exports, "BaseModel", {
  enumerable: true,
  get: function get() {
    return _BaseModel.default;
  }
});

_Object$defineProperty(exports, "BaseView", {
  enumerable: true,
  get: function get() {
    return _BaseView.default;
  }
});

_Object$defineProperty(exports, "addCustomButton", {
  enumerable: true,
  get: function get() {
    return _FormInputFactory.addCustomButton;
  }
});

_Object$defineProperty(exports, "createCustomButtons", {
  enumerable: true,
  get: function get() {
    return _FormInputFactory.createCustomButtons;
  }
});

_Object$defineProperty(exports, "createIdpButtons", {
  enumerable: true,
  get: function get() {
    return _FormInputFactory.createIdpButtons;
  }
});

var _BaseHeader = _interopRequireDefault(__webpack_require__(596));

var _BaseFooter = _interopRequireDefault(__webpack_require__(597));

var _BaseForm = _interopRequireDefault(__webpack_require__(206));

var _BaseFormWithPolling = _interopRequireDefault(__webpack_require__(600));

var _BaseModel = _interopRequireDefault(__webpack_require__(601));

var _BaseView = _interopRequireDefault(__webpack_require__(1337));

var _FormInputFactory = __webpack_require__(598);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(33);
var getOwnPropertyDescriptor = __webpack_require__(128).f;
var isForced = __webpack_require__(400);
var path = __webpack_require__(23);
var bind = __webpack_require__(115);
var createNonEnumerableProperty = __webpack_require__(85);
var has = __webpack_require__(59);

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseLoginModel = _interopRequireDefault(__webpack_require__(198));

var _BaseLoginController = _interopRequireDefault(__webpack_require__(156));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Toolbar = _okta.internal.views.forms.components.Toolbar;
var FormUtil = _okta.internal.views.forms.helpers.FormUtil;

var FormControllerSimpleForm = _okta.Form.extend({
  layout: 'o-form-theme',
  noCancelButton: true,
  constructor: function constructor(options) {
    _okta.Form.call(this, options);

    _okta._.each(_okta._.result(this, 'formChildren') || [], function (child) {
      switch (child.type) {
        case _FormType.default.INPUT:
          this.addInput(_okta._.extend({
            label: false,
            'label-top': true
          }, child.viewOptions));
          break;

        case _FormType.default.BUTTON:
          this.add((0, _okta.createButton)(_okta._.extend({
            model: this.model
          }, child.viewOptions)), child.addOptions);
          FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
          break;

        case _FormType.default.DIVIDER:
          this.addDivider(child.viewOptions);
          break;

        case _FormType.default.TOOLBAR:
          this.add(Toolbar, {
            options: child.viewOptions
          });
          FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
          break;

        case _FormType.default.VIEW:
          this.add(child.viewOptions.View, child.addOptions);
          FormUtil.applyShowWhen(this.last(), child.viewOptions.showWhen);
          break;

        default:
          throw new Error('Unrecognized child type: ' + child.type);
      }
    }, this);
  }
});

var _default = _BaseLoginController.default.extend({
  constructor: function constructor() {
    var initialize = this.initialize;

    this.initialize = function () {};

    _BaseLoginController.default.apply(this, arguments);

    if (this.Model && this.Form) {
      var Model = _BaseLoginModel.default.extend(_okta._.extend({
        parse: function parse(attributes) {
          this.settings = attributes.settings;
          this.appState = attributes.appState;
          return _okta._.omit(attributes, ['settings', 'appState']);
        }
      }, _okta._.result(this, 'Model')));

      this.model = new Model({
        settings: this.settings,
        appState: this.options.appState
      }, {
        parse: true
      });

      var _Form = FormControllerSimpleForm.extend(_okta._.result(this, 'Form', this));

      this.form = new _Form(this.toJSON());
      this.add(this.form);
    }

    if (this.Footer) {
      this.addFooter(this.Footer);
    }

    this.addListeners();
    initialize.apply(this, arguments);
  },
  addFooter: function addFooter(Footer, args) {
    this.footer = new Footer(_okta._.extend(this.toJSON(), args || {}));
    this.add(this.footer);
  },
  toJSON: function toJSON() {
    var data = _BaseLoginController.default.prototype.toJSON.apply(this, arguments);

    return _okta._.extend(_okta._.pick(this.options, 'appState'), data);
  },
  back: function back() {
    if (this.footer && this.footer.back) {
      this.footer.back();
    }
  }
});

exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  /* global globalThis -- safe */
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  API_RATE_LIMIT: 30000,
  //milliseconds
  WIDGET_LOGIN_CONTAINER_ID: 'okta-login-container',
  WIDGET_CONTAINER_ID: 'okta-sign-in',
  WIDGET_CONFIG_COLORS_ID: 'okta-sign-in-config-colors',
  DIRECTION_BACK: 'DIRECTION_BACK',
  RECOVERY_TYPE_PASSWORD: 'PASSWORD',
  RECOVERY_TYPE_UNLOCK: 'UNLOCK',
  RECOVERY_FACTOR_TYPE_SMS: 'SMS',
  RECOVERY_FACTOR_TYPE_EMAIL: 'EMAIL',
  RECOVERY_FACTOR_TYPE_CALL: 'CALL',
  IOS: 'ios',
  ANDROID: 'android',
  ODA: 'oda',
  MDM: 'mdm',
  // Global success messages
  SUCCESS: 'SUCCESS',
  FORGOT_PASSWORD_EMAIL_SENT: 'FORGOT_PASSWORD_EMAIL_SENT',
  UNLOCK_ACCOUNT_EMAIL_SENT: 'UNLOCK_ACCOUNT_EMAIL_SENT',
  // Global error messages
  CONFIG_ERROR: 'CONFIG_ERROR',
  UNSUPPORTED_BROWSER_ERROR: 'UNSUPPORTED_BROWSER_ERROR',
  OAUTH_ERROR: 'OAUTH_ERROR',
  AUTH_STOP_POLL_INITIATION_ERROR: 'AUTH_STOP_POLL_INITIATION_ERROR',
  U2F_ERROR: 'U2F_ERROR',
  WEB_AUTHN_ERROR: 'WEB_AUTHN_ERROR',
  WEBAUTHN_ABORT_ERROR: 'WEBAUTHN_ABORT_ERROR',
  // Enroll choice page types
  ALL_OPTIONAL_NONE_ENROLLED: 'ALL_OPTIONAL_NONE_ENROLLED',
  ALL_OPTIONAL_SOME_ENROLLED: 'ALL_OPTIONAL_SOME_ENROLLED',
  HAS_REQUIRED_NONE_ENROLLED: 'HAS_REQUIRED_NONE_ENROLLED',
  HAS_REQUIRED_SOME_REQUIRED_ENROLLED: 'HAS_REQUIRED_SOME_REQUIRED_ENROLLED',
  HAS_REQUIRED_ALL_REQUIRED_ENROLLED: 'HAS_REQUIRED_ALL_REQUIRED_ENROLLED',
  // Operations
  PRIMARY_AUTH: 'PRIMARY_AUTH',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
  // Auth Types
  SESSION_SSO: 'SESSION_SSO',
  SESSION_STEP_UP: 'SESSION_STEP_UP',
  //Registration
  ACTIVATION_EMAIL_SENT: 'ACTIVATION_EMAIL_SENT',
  REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED',
  //IDP Discovery
  IDP_DISCOVERY: 'IDP_DISCOVERY',
  //App Store Links
  OKTA_VERIFY_APPLE_APP_STORE_URL: 'https://apps.apple.com/us/app/okta-verify/id490179405',
  OKTA_VERIFY_GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.okta.android.auth',
  // Device Challenge Method
  LOOPBACK_CHALLENGE: 'LOOPBACK',
  CUSTOM_URI_CHALLENGE: 'CUSTOM_URI',
  UNIVERSAL_LINK_CHALLENGE: 'UNIVERSAL_LINK',
  APP_LINK_CHALLENGE: 'APP_LINK'
};
exports.default = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(862);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var INPUT = 'INPUT'; // Syntactic sugar to provide some structure to SimpleForm inputs - Just
// wraps options with { type: type, viewOptions: viewOptions, addOptions: addOptions }

var BUTTON = 'BUTTON';
var DIVIDER = 'DIVIDER';
var TOOLBAR = 'TOOLBAR';
var VIEW = 'VIEW';

function wrap(type) {
  return function (viewOptions, addOptions) {
    return {
      type: type,
      viewOptions: viewOptions,
      addOptions: addOptions
    };
  };
}

var _default = {
  Input: wrap(INPUT),
  Button: wrap(BUTTON),
  Divider: wrap(DIVIDER),
  Toolbar: wrap(TOOLBAR),
  View: wrap(VIEW),
  INPUT: INPUT,
  BUTTON: BUTTON,
  DIVIDER: DIVIDER,
  TOOLBAR: TOOLBAR,
  VIEW: VIEW
};
exports.default = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(493);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.BaseAuthenticatorBeacon = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _AuthenticatorFooter = _interopRequireDefault(__webpack_require__(358));

var _HeaderBeacon = _interopRequireDefault(__webpack_require__(607));

var _AuthenticatorUtil = __webpack_require__(204);

var BaseAuthenticatorBeacon = _HeaderBeacon.default.extend({
  authenticatorKey: function authenticatorKey() {
    return this.options.appState.get('authenticatorKey');
  },
  getBeaconClassName: function getBeaconClassName() {
    var authenticatorKey = _okta._.result(this, 'authenticatorKey');

    return (0, _AuthenticatorUtil.getIconClassNameForBeacon)(authenticatorKey);
  }
});

exports.BaseAuthenticatorBeacon = BaseAuthenticatorBeacon;

var _default = _internals.BaseView.extend({
  Header: _internals.BaseHeader.extend({
    HeaderBeacon: BaseAuthenticatorBeacon
  }),
  Footer: _AuthenticatorFooter.default
});

exports.default = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(486);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(498);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var shared = __webpack_require__(263);
var has = __webpack_require__(37);
var uid = __webpack_require__(167);
var NATIVE_SYMBOL = __webpack_require__(267);
var USE_SYMBOL_AS_UID = __webpack_require__(363);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(284);
var DESCRIPTORS = __webpack_require__(19);
var global = __webpack_require__(9);
var isObject = __webpack_require__(15);
var has = __webpack_require__(37);
var classof = __webpack_require__(177);
var createNonEnumerableProperty = __webpack_require__(50);
var redefine = __webpack_require__(51);
var defineProperty = __webpack_require__(25).f;
var getPrototypeOf = __webpack_require__(74);
var setPrototypeOf = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(20);
var uid = __webpack_require__(167);

var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var isPrototypeOf = ObjectPrototype.isPrototypeOf;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQIRED = false;
var NAME;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (setPrototypeOf) {
    if (isPrototypeOf.call(TypedArray, C)) return C;
  } else for (var ARRAY in TypedArrayConstructorsList) if (has(TypedArrayConstructorsList, NAME)) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (C === TypedArrayConstructor || isPrototypeOf.call(TypedArrayConstructor, C))) {
      return C;
    }
  } throw TypeError('Target is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && has(TypedArrayConstructor.prototype, KEY)) {
      delete TypedArrayConstructor.prototype[KEY];
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && has(TypedArrayConstructor, KEY)) {
        delete TypedArrayConstructor[KEY];
      }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8Array[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  if (!global[NAME]) NATIVE_ARRAY_BUFFER_VIEWS = false;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || typeof TypedArray != 'function' || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !has(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.INTERSTITIAL_REDIRECT_VIEW = exports.IDP_FORM_TYPE = exports.TERMINAL_FORMS = exports.HINTS = exports.FORM_NAME_TO_OPERATION_MAP = exports.AUTHENTICATOR_METHODS = exports.AUTHENTICATOR_KEY = exports.FORMS_FOR_VERIFICATION = exports.FORMS_WITH_STATIC_BACK_LINK = exports.FORMS_WITHOUT_SIGNOUT = exports.FORMS = exports.ACTIONS = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FORM_NAME_TO_OPERATI;

/**
 * Structure of FORMS object:
 * { [CONSTANT]: remediationForm.name }
 */
var FORMS = {
  IDENTIFY: 'identify',
  SELECT_IDENTIFY: 'select-identify',
  IDENTIFY_RECOVERY: 'identify-recovery',
  SELECT_ENROLL_PROFILE: 'select-enroll-profile',
  ENROLL_PROFILE: 'enroll-profile',
  ENROLL_PROFILE_UPDATE: 'profile-update',
  UNLOCK_ACCOUNT: 'unlock-account',
  REQUEST_ACTIVATION: 'request-activation-email',
  CONSENT_ADMIN: 'admin-consent',
  CONSENT_ENDUSER: 'consent',
  CONSENT_EMAIL_CHALLENGE: 'email-challenge-consent',
  SELECT_AUTHENTICATOR_AUTHENTICATE: 'select-authenticator-authenticate',
  SELECT_AUTHENTICATOR_UNLOCK: 'select-authenticator-unlock-account',
  AUTHENTICATOR_VERIFICATION_DATA: 'authenticator-verification-data',
  CHALLENGE_AUTHENTICATOR: 'challenge-authenticator',
  CHALLENGE_POLL: 'challenge-poll',
  RESEND: 'resend',
  SELECT_AUTHENTICATOR_ENROLL: 'select-authenticator-enroll',
  SELECT_AUTHENTICATOR_ENROLL_DATA: 'select-authenticator-enroll-data',
  AUTHENTICATOR_ENROLLMENT_DATA: 'authenticator-enrollment-data',
  ENROLL_AUTHENTICATOR: 'enroll-authenticator',
  SELECT_ENROLLMENT_CHANNEL: 'select-enrollment-channel',
  ENROLLMENT_CHANNEL_DATA: 'enrollment-channel-data',
  ENROLL_POLL: 'enroll-poll',
  REENROLL_AUTHENTICATOR: 'reenroll-authenticator',
  REENROLL_AUTHENTICATOR_WARNING: 'reenroll-authenticator-warning',
  RESET_AUTHENTICATOR: 'reset-authenticator',
  SKIP: 'skip',
  POLL: 'poll',
  FAILURE_REDIRECT: 'failure-redirect',
  SUCCESS_REDIRECT: 'success-redirect',
  REDIRECT_IDP: 'redirect-idp',
  PIV_IDP: 'piv-idp',
  DEVICE_CHALLENGE_POLL: 'device-challenge-poll',
  DEVICE_APPLE_SSO_EXTENSION: 'device-apple-sso-extension',
  CANCEL_TRANSACTION: 'cancel-transaction',
  LAUNCH_AUTHENTICATOR: 'launch-authenticator',
  DEVICE_ENROLLMENT_TERMINAL: 'device-enrollment-terminal',
  USER_CODE: 'user-code',
  // 'terminal` is not ION Form name but only coined in widget
  // for rendering a page that user has nothing to remediate.
  TERMINAL: 'terminal'
}; // Forms added here do not show the Sign out link

exports.FORMS = FORMS;
var FORMS_WITHOUT_SIGNOUT = [FORMS.IDENTIFY, FORMS.SUCCESS_REDIRECT, FORMS.ENROLL_PROFILE, FORMS.DEVICE_ENROLLMENT_TERMINAL, FORMS.CONSENT_ADMIN, FORMS.CONSENT_ENDUSER, FORMS.CONSENT_EMAIL_CHALLENGE, FORMS.USER_CODE];
exports.FORMS_WITHOUT_SIGNOUT = FORMS_WITHOUT_SIGNOUT;
var FORMS_WITH_STATIC_BACK_LINK = [FORMS.SELECT_AUTHENTICATOR_ENROLL, FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE];
exports.FORMS_WITH_STATIC_BACK_LINK = FORMS_WITH_STATIC_BACK_LINK;
var FORMS_FOR_VERIFICATION = [FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, FORMS.CHALLENGE_AUTHENTICATOR, FORMS.CHALLENGE_POLL, FORMS.RESEND];
exports.FORMS_FOR_VERIFICATION = FORMS_FOR_VERIFICATION;
var AUTHENTICATOR_KEY = {
  EMAIL: 'okta_email',
  PASSWORD: 'okta_password',
  PHONE: 'phone_number',
  WEBAUTHN: 'webauthn',
  SECURITY_QUESTION: 'security_question',
  OV: 'okta_verify',
  GOOGLE_OTP: 'google_otp',
  ON_PREM: 'onprem_mfa',
  RSA: 'rsa_token',
  DUO: 'duo',
  IDP: 'external_idp',
  CUSTOM_OTP: 'custom_otp',
  SYMANTEC_VIP: 'symantec_vip',
  YUBIKEY: 'yubikey_token',
  CUSTOM_APP: 'custom_app'
};
exports.AUTHENTICATOR_KEY = AUTHENTICATOR_KEY;
var AUTHENTICATOR_METHODS = {
  PUSH: 'push'
};
exports.AUTHENTICATOR_METHODS = AUTHENTICATOR_METHODS;
var FORM_NAME_TO_OPERATION_MAP = (_FORM_NAME_TO_OPERATI = {}, (0, _defineProperty2.default)(_FORM_NAME_TO_OPERATI, FORMS.SELECT_AUTHENTICATOR_UNLOCK, _Enums.default.UNLOCK_ACCOUNT), (0, _defineProperty2.default)(_FORM_NAME_TO_OPERATI, FORMS.IDENTIFY, _Enums.default.PRIMARY_AUTH), (0, _defineProperty2.default)(_FORM_NAME_TO_OPERATI, FORMS.IDENTIFY_RECOVERY, _Enums.default.FORGOT_PASSWORD), _FORM_NAME_TO_OPERATI);
exports.FORM_NAME_TO_OPERATION_MAP = FORM_NAME_TO_OPERATION_MAP;
var ENROLLED_PASSWORD_RECOVERY_LINK = 'currentAuthenticatorEnrollment-recover';
var ORG_PASSWORD_RECOVERY_LINK = 'currentAuthenticator-recover';
var ACTIONS = {
  ENROLLED_PASSWORD_RECOVERY_LINK: ENROLLED_PASSWORD_RECOVERY_LINK,
  ORG_PASSWORD_RECOVERY_LINK: ORG_PASSWORD_RECOVERY_LINK
}; // Possible Remediation Form Field Hints

exports.ACTIONS = ACTIONS;
var HINTS = {
  CAPTCHA: 'captcha'
};
exports.HINTS = HINTS;
var TERMINAL_FORMS = [FORMS.TERMINAL, FORMS.DEVICE_ENROLLMENT_TERMINAL];
exports.TERMINAL_FORMS = TERMINAL_FORMS;
var IDP_FORM_TYPE = {
  X509: 'X509'
}; // Possible options for the SIW interstitial redirect view

exports.IDP_FORM_TYPE = IDP_FORM_TYPE;
var INTERSTITIAL_REDIRECT_VIEW = {
  DEFAULT: 'DEFAULT',
  NONE: 'NONE'
};
exports.INTERSTITIAL_REDIRECT_VIEW = INTERSTITIAL_REDIRECT_VIEW;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(359);
var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(81);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol$iterator = __webpack_require__(967);

var _Symbol = __webpack_require__(315);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1072);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(23);

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SymbolProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return supportsArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return supportsDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return nativeIsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return nativeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return nativeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return nativeIsView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _isFinite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasEnumBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return nonEnumerableProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_ARRAY_INDEX; });
// Current version.
var VERSION = '1.13.1';

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = typeof self == 'object' && self.self === self && self ||
          typeof global == 'object' && global.global === global && global ||
          Function('return this')() ||
          {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = Array.prototype, ObjProto = Object.prototype;
var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

// Modern feature detection.
var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
    supportsDataView = typeof DataView !== 'undefined';

// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create,
    nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

// Create references to these builtin functions because we override them.
var _isNaN = isNaN,
    _isFinite = isFinite;

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(108)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _startsWith = _interopRequireDefault(__webpack_require__(239));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _map = _interopRequireDefault(__webpack_require__(40));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

/* eslint-disable max-statements */

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13], max-depth: [2, 3] */
var Util = {};

var buildInputForParameter = function buildInputForParameter(name, value) {
  var input = document.createElement('input');
  input.name = name;
  input.value = decodeURIComponent(value);
  input.type = 'hidden';
  return input;
};

var buildSubmitInput = function buildSubmitInput() {
  var input = document.createElement('input');
  input.type = 'submit';
  return input;
};

var buildDynamicForm = function buildDynamicForm() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var method = arguments.length > 1 ? arguments[1] : undefined;
  var splitOnFragment = url.split('#');
  var fragment = splitOnFragment[1];
  var splitOnQuery = (splitOnFragment[0] || '').split('?');
  var query = splitOnQuery[1];
  var targetUrl = splitOnQuery[0];

  if (fragment) {
    targetUrl += '#' + fragment;
  }

  var form = document.createElement('form');
  form.method = method;
  form.setAttribute('style', 'display: none;');
  form.action = targetUrl;

  if (query && query.length) {
    var queryParts = query.split('&');
    (0, _forEach.default)(queryParts).call(queryParts, function (queryPart) {
      var parameterParts = queryPart.split('=');
      var input = buildInputForParameter(parameterParts[0], parameterParts[1]);
      form.appendChild(input);
    });
  }

  form.appendChild(buildSubmitInput());
  return form;
};

Util.transformErrorXHR = function (xhr) {
  // Handle network connection error
  if (xhr.status === 0 && _okta._.isEmpty(xhr.responseJSON)) {
    xhr.responseJSON = {
      errorSummary: (0, _okta.loc)('error.network.connection', 'login')
    };
    return xhr;
  }

  if (!xhr.responseJSON) {
    if (!xhr.responseText) {
      xhr.responseJSON = {
        errorSummary: (0, _okta.loc)('oform.error.unexpected', 'login')
      };
      return xhr;
    }

    xhr.responseJSON = xhr.responseText;
  } // Temporary solution to display field errors
  // Assuming there is only one field error in a response


  if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
    xhr.responseJSON.errorSummary = xhr.responseJSON.errorCauses[0].errorSummary;
  } // Replace error messages


  if (!_okta._.isEmpty(xhr.responseJSON)) {
    var errorMsg = (0, _okta.loc)('errors.' + xhr.responseJSON.errorCode, 'login');

    if ((0, _indexOf.default)(errorMsg).call(errorMsg, 'L10N_ERROR[') === -1) {
      xhr.responseJSON.errorSummary = errorMsg;

      if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
        // BaseForm will consume errorCauses before errorSummary if it is an array,
        // so, we have to make sure to remove it when we have a valid error code
        delete xhr.responseJSON.errorCauses;
      }
    }
  }

  return xhr;
}; // Simple helper function to lowercase all strings in the given array


Util.toLower = function (strings) {
  return (0, _map.default)(_okta._).call(_okta._, strings, function (str) {
    return str.toLowerCase();
  });
}; // A languageCode can be composed of multiple parts, i.e:
// {{langage}}-{{region}}-{{dialect}}
//
// In these cases, it's necessary to generate a list of other possible
// combinations that we might support (in preferred order).
//
// For example:
// en-US -> [en-US, en]
// de-DE-bavarian -> [de-DE-bavarian, de-DE, de]


function expandLanguage(language) {
  var expanded = [language];
  var parts = language.split('-');

  while (parts.pop() && parts.length > 0) {
    expanded.push(parts.join('-'));
  }

  return expanded;
} // Following the rules of expanding one language, this will generate
// all potential languages in the given order (where higher priority is
// given to expanded languages over other downstream languages).


Util.expandLanguages = function (languages) {
  var _context;

  return (0, _map.default)(_context = _okta._.chain(languages)).call(_context, expandLanguage).flatten().uniq().value();
}; //helper to call setTimeout


Util.callAfterTimeout = function (callback, time) {
  return (0, _setTimeout2.default)(callback, time);
}; // Helper function to provide consistent formatting of template literals
// that are logged when in development mode.


Util.debugMessage = function (message) {
  _Logger.default.warn("\n".concat(message.replace(/^(\s)+/gm, '')));
}; // Trigger an afterError event


Util.triggerAfterError = function (controller) {
  var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!err.statusCode && err.xhr && err.xhr.status) {
    // Bring the statusCode to the top-level of the Error
    err.statusCode = err.xhr.status;
  } // Some controllers return the className as a function - process it here:


  var className = _okta._.isFunction(controller.className) ? controller.className() : controller.className;

  var error = _okta._.pick(err, 'name', 'message', 'statusCode', 'xhr');

  controller.trigger('afterError', {
    controller: className
  }, error); // Logs to console only in dev mode

  _Logger.default.warn('controller: ' + className + ', error: ' + error);
};

Util.redirect = function (url) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var isAppLink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!url) {
    _Logger.default.error("Cannot redirect to empty URL: (".concat(url, ")"));

    return;
  }

  if (_BrowserFeatures.default.isAndroid() && !isAppLink) {
    Util.redirectWithFormGet(url);
  } else {
    win.location.href = url;
  }
};
/**
 * Why redirect via Form get rather using `window.location.href`?
 * At the time of writing, Chrome (<72) in Android would block window location change
 * at following case
 * 1. An AJAX is trigger because of user action.
 * 2. 5+ seconds passed without any further user interaction.
 * 3. User takes an action results in window location change.
 *
 * Luckily we discovered that uses Form submit would work around this problem
 * even though it changed window location.
 *
 * Check the commit history for more details.
 */


Util.redirectWithFormGet = function (url) {
  Util.redirectWithForm(url, 'get');
};

Util.redirectWithForm = function (url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';

  if (!url) {
    _Logger.default.error("Cannot redirect to empty URL: (".concat(url, ")"));

    return;
  }

  var mainContainer = document.getElementById(_Enums.default.WIDGET_CONTAINER_ID);

  if (!mainContainer) {
    _Logger.default.error('Cannot find okta-sign-in container append to which a form');

    return;
  }

  var form = buildDynamicForm(url, method);
  mainContainer.appendChild(form);
  form.querySelector('input[type="submit"]').click();
};
/**
 * When we want to show an explain text, we need to check if this is different from
 * the label text, to not have an explain that look like a duplicated label.
 * okta-signin-widget gives the possibility to customize every i18n, so we cannot
 * know ahead if these two are equal or different, we need to call this function everytime.
 */


Util.createInputExplain = function (explainKey, labelKey, bundleName, explainParams, labelParams) {
  var explain = explainParams ? (0, _okta.loc)(explainKey, bundleName, explainParams) : (0, _okta.loc)(explainKey, bundleName);
  var label = labelParams ? (0, _okta.loc)(labelKey, bundleName, labelParams) : (0, _okta.loc)(labelKey, bundleName);

  if (explain === label) {
    return false;
  }

  return explain;
};

Util.isV1StateToken = function (token) {
  return !!(token && _okta._.isString(token) && (0, _startsWith.default)(token).call(token, '00'));
}; // TODO: remove when auth-js is updated: OKTA-325445


Util.removeNils = function removeNils(obj) {
  var cleaned = {};

  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      var value = obj[prop];

      if (value !== null && value !== undefined) {
        cleaned[prop] = value;
      }
    }
  }

  return cleaned;
};

var _default = Util;
exports.default = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(49);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var shared = __webpack_require__(290);
var has = __webpack_require__(59);
var uid = __webpack_require__(228);
var NATIVE_SYMBOL = __webpack_require__(291);
var USE_SYMBOL_AS_UID = __webpack_require__(402);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(484);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

__webpack_require__(237);

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
//note: not including Okta here and explicitly including jquery and Handlebars
//because we want to be explicit about which TextBox we are extending here
//and want to avoid the cirucular dependency that occurs if we
//include Okta
var TextBox = _okta.internal.views.forms.inputs.TextBox;

var _default = TextBox.extend({
  postRender: function postRender() {
    if (this.options.type === 'number') {
      var input = this.$('input');
      input.attr({
        pattern: '[0-9]*',
        inputmode: 'numeric'
      });
    }

    TextBox.prototype.postRender.apply(this, arguments);
  },
  // Override the focus() to ignore focus in IE. IE (8-11) has a known bug where
  // the placeholder text disappears when the input field is focused.
  focus: function focus() {
    if (_BrowserFeatures.default.isIE()) {
      return;
    }

    return TextBox.prototype.focus.apply(this, arguments);
  }
});

exports.default = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(487);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(490);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _reduce = _interopRequireDefault(__webpack_require__(140));

var _trim = _interopRequireDefault(__webpack_require__(321));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _map = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(2);

var _TimeUtil = _interopRequireDefault(__webpack_require__(1114));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 38], max-statements: [2, 38] */
var fn = {};
var factorData = {
  OKTA_VERIFY: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpSoft.oktaVerify',
    description: 'factor.totpSoft.description',
    iconClassName: 'mfa-okta-verify',
    sortOrder: 1
  },
  OKTA_VERIFY_PUSH: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.oktaVerifyPush',
    description: 'factor.push.description',
    iconClassName: 'mfa-okta-verify',
    sortOrder: 1
  },
  U2F: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.u2f',
    description: function description(brandName) {
      return brandName ? 'factor.u2f.description.specific' : 'factor.u2f.description.generic';
    },
    iconClassName: 'mfa-u2f',
    sortOrder: 2
  },
  WEBAUTHN: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.webauthn.biometric',
    description: 'factor.webauthn.biometric.description',
    iconClassName: 'mfa-webauthn',
    sortOrder: 2
  },
  WINDOWS_HELLO: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.windowsHello',
    description: function description(brandName) {
      return brandName ? 'factor.windowsHello.signin.description.specific' : 'factor.windowsHello.signin.description.generic';
    },
    iconClassName: 'mfa-windows-hello',
    sortOrder: 3
  },
  YUBIKEY: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpHard.yubikey',
    description: 'factor.totpHard.yubikey.description',
    iconClassName: 'mfa-yubikey',
    sortOrder: 4
  },
  GOOGLE_AUTH: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpSoft.googleAuthenticator',
    description: 'factor.totpSoft.description',
    iconClassName: 'mfa-google-auth',
    sortOrder: 5
  },
  CUSTOM_HOTP: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: 'factor.hotp.description',
    iconClassName: 'mfa-hotp',
    sortOrder: 6
  },
  SMS: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.sms',
    description: 'factor.sms.description',
    iconClassName: 'mfa-okta-sms',
    sortOrder: 7
  },
  CALL: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.call',
    description: 'factor.call.description',
    iconClassName: 'mfa-okta-call',
    sortOrder: 8
  },
  EMAIL: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.email',
    description: 'factor.email.description',
    iconClassName: 'mfa-okta-email',
    sortOrder: 9
  },
  QUESTION: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.securityQuestion',
    description: 'factor.securityQuestion.description',
    iconClassName: 'mfa-okta-security-question',
    sortOrder: 10
  },
  DUO: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.duo',
    description: 'factor.duo.description',
    iconClassName: 'mfa-duo',
    sortOrder: 11
  },
  SYMANTEC_VIP: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpHard.symantecVip',
    description: 'factor.totpHard.description',
    iconClassName: 'mfa-symantec',
    sortOrder: 12
  },
  RSA_SECURID: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpHard.rsaSecurId',
    description: 'factor.totpHard.description',
    iconClassName: 'mfa-rsa',
    sortOrder: 13
  },
  ON_PREM: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: 'factor.totpHard.description',
    iconClassName: 'mfa-onprem',
    sortOrder: 14
  },
  PASSWORD: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.password',
    description: '',
    iconClassName: 'mfa-okta-password',
    sortOrder: 15
  },
  CUSTOM_CLAIMS: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: 'factor.customFactor.description',
    iconClassName: 'mfa-custom-factor',
    sortOrder: 16
  },
  GENERIC_SAML: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: function description(brandName) {
      return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
    },
    iconClassName: 'mfa-custom-factor',
    sortOrder: 17
  },
  GENERIC_OIDC: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: function description(brandName) {
      return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
    },
    iconClassName: 'mfa-custom-factor',
    sortOrder: 18
  }
};

var getPasswordComplexityRequirementsAsArray = function getPasswordComplexityRequirementsAsArray(policy, i18nKeys) {
  var setExcludeAttributes = function setExcludeAttributes(policyComplexity) {
    var excludeAttributes = policyComplexity.excludeAttributes;
    policyComplexity.excludeFirstName = _okta._.contains(excludeAttributes, 'firstName');
    policyComplexity.excludeLastName = _okta._.contains(excludeAttributes, 'lastName');
    return _okta._.omit(policyComplexity, 'excludeAttributes');
  };

  if (policy.complexity) {
    var complexityFields = i18nKeys.complexity;
    var policyComplexity = setExcludeAttributes(policy.complexity);
    var requirements = (0, _map.default)(_okta._).call(_okta._, policyComplexity, function (complexityValue, complexityType) {
      if (complexityValue <= 0) {
        // to skip 0 and -1
        return;
      }

      var params = complexityFields[complexityType];
      return params.args ? (0, _okta.loc)(params.i18n, 'login', [complexityValue]) : (0, _okta.loc)(params.i18n, 'login');
    });
    return _okta._.compact(requirements);
  }

  return [];
};

var getPasswordHistoryRequirementDescription = function getPasswordHistoryRequirementDescription(policy, i18nKeys) {
  if (policy.age && policy.age.historyCount > 0) {
    return (0, _okta.loc)(i18nKeys.history.i18n, 'login', [policy.age.historyCount]);
  }

  return null;
};

var getPasswordAgeRequirementDescription = function getPasswordAgeRequirementDescription(policy, i18nKeys) {
  var getPasswordAgeRequirement = function getPasswordAgeRequirement(displayableTime) {
    var propertiesString;

    switch (displayableTime.unit) {
      case 'DAY':
        propertiesString = i18nKeys.age.days.i18n;
        break;

      case 'HOUR':
        propertiesString = i18nKeys.age.hours.i18n;
        break;

      case 'MINUTE':
        propertiesString = i18nKeys.age.minutes.i18n;
    }

    return (0, _okta.loc)(propertiesString, 'login', [displayableTime.time]);
  };

  if (policy.age && policy.age.minAgeMinutes > 0) {
    var displayableTime = _TimeUtil.default.getTimeInHighestRelevantUnit(policy.age.minAgeMinutes, 'MINUTE');

    return getPasswordAgeRequirement(displayableTime);
  }

  return null;
};

var getPasswordRequirements = function getPasswordRequirements(policy, i18nKeys) {
  var passwordRequirements = {
    complexity: [],
    history: [],
    age: []
  };
  passwordRequirements.complexity = getPasswordComplexityRequirementsAsArray(policy, i18nKeys);
  var historyRequirement = getPasswordHistoryRequirementDescription(policy, i18nKeys);

  if (historyRequirement) {
    passwordRequirements.history.push(historyRequirement);
  }

  var ageRequirement = getPasswordAgeRequirementDescription(policy, i18nKeys);

  if (ageRequirement) {
    passwordRequirements.age.push(ageRequirement);
  }

  return passwordRequirements;
};

fn.getFactorName = function (provider, factorType) {
  if (provider === 'OKTA' && factorType === 'token:software:totp') {
    return 'OKTA_VERIFY';
  }

  if (provider === 'OKTA' && factorType === 'push') {
    return 'OKTA_VERIFY_PUSH';
  }

  if (provider === 'GOOGLE') {
    return 'GOOGLE_AUTH';
  }

  if (provider === 'SYMANTEC' && factorType === 'token') {
    return 'SYMANTEC_VIP';
  }

  if (provider === 'RSA' && factorType === 'token') {
    return 'RSA_SECURID';
  }

  if (provider === 'DEL_OATH' && factorType === 'token') {
    return 'ON_PREM';
  }

  if (provider === 'DUO' && factorType === 'web') {
    return 'DUO';
  }

  if (provider === 'YUBICO' && factorType === 'token:hardware') {
    return 'YUBIKEY';
  }

  if (provider === 'OKTA' && factorType === 'sms') {
    return 'SMS';
  }

  if (provider === 'OKTA' && factorType === 'call') {
    return 'CALL';
  }

  if (provider === 'OKTA' && factorType === 'question') {
    return 'QUESTION';
  }

  if (provider === 'OKTA' && factorType === 'email') {
    return 'EMAIL';
  }

  if (provider === 'OKTA' && factorType === 'password') {
    return 'PASSWORD';
  }

  if (provider === 'GENERIC_SAML' && factorType === 'assertion:saml2') {
    return 'GENERIC_SAML';
  }

  if (provider === 'GENERIC_OIDC' && factorType === 'assertion:oidc') {
    return 'GENERIC_OIDC';
  }

  return fn.getFactorNameForFactorType.call(this, factorType);
};

fn.getFactorNameForFactorType = function (factorType) {
  if (factorType === 'u2f') {
    return 'U2F';
  }

  if (factorType === 'token:software:totp') {
    return 'OKTA_VERIFY';
  }

  if (factorType === 'webauthn') {
    if (this.settings.get('features.webauthn')) {
      return 'WEBAUTHN';
    } else {
      return 'WINDOWS_HELLO';
    }
  }

  if (factorType === 'token:hotp') {
    return 'CUSTOM_HOTP';
  }

  if (factorType === 'claims_provider') {
    return 'CUSTOM_CLAIMS';
  }
};

fn.isOktaVerify = function (provider, factorType) {
  return provider === 'OKTA' && (factorType === 'token:software:totp' || factorType === 'push');
};

fn.getFactorLabel = function (provider, factorType) {
  var key = factorData[fn.getFactorName.apply(this, [provider, factorType])].label;
  return (0, _okta.loc)(key, 'login');
};

fn.getFactorDescription = function (provider, factorType) {
  var descriptionKey = factorData[fn.getFactorName.apply(this, [provider, factorType])].description;

  if (_okta._.isFunction(descriptionKey)) {
    var brandName = this.settings.get('brandName');
    var key = descriptionKey(brandName);
    return brandName ? (0, _okta.loc)(key, 'login', [brandName]) : (0, _okta.loc)(key, 'login');
  } else {
    return (0, _okta.loc)(descriptionKey, 'login');
  }
};

fn.getFactorIconClassName = function (provider, factorType) {
  return factorData[fn.getFactorName.apply(this, [provider, factorType])].iconClassName;
};

fn.getFactorSortOrder = function (provider, factorType) {
  return factorData[fn.getFactorName.apply(this, [provider, factorType])].sortOrder;
};

fn.getRememberDeviceValue = function (appState) {
  return appState && appState.get('rememberDeviceByDefault');
};

fn.getSecurityQuestionLabel = function (questionObj) {
  var localizedQuestion = (0, _okta.loc)('security.' + questionObj.question);
  return (0, _indexOf.default)(localizedQuestion).call(localizedQuestion, 'L10N_ERROR') < 0 ? localizedQuestion : questionObj.questionText;
};

fn.removeRequirementsFromError = function (responseJSON, policy) {
  var passwordRequirementsAsString = this.getPasswordComplexityDescription(policy);

  if (responseJSON.errorCauses && responseJSON.errorCauses.length > 0 && _okta._.isString(responseJSON.errorCauses[0].errorSummary)) {
    var _context;

    responseJSON.errorCauses[0].errorSummary = (0, _trim.default)(_context = responseJSON.errorCauses[0].errorSummary.replace(passwordRequirementsAsString, '')).call(_context);
  }

  return responseJSON;
};

fn.getPasswordComplexityDescriptionForHtmlList = function (policy) {
  var passwordRequirementHtmlI18nKeys = {
    complexity: {
      minLength: {
        i18n: 'password.complexity.length.description',
        args: true
      },
      minLowerCase: {
        i18n: 'password.complexity.lowercase.description'
      },
      minUpperCase: {
        i18n: 'password.complexity.uppercase.description'
      },
      minNumber: {
        i18n: 'password.complexity.number.description'
      },
      minSymbol: {
        i18n: 'password.complexity.symbol.description'
      },
      excludeUsername: {
        i18n: 'password.complexity.no_username.description'
      },
      excludeFirstName: {
        i18n: 'password.complexity.no_first_name.description'
      },
      excludeLastName: {
        i18n: 'password.complexity.no_last_name.description'
      }
    },
    history: {
      i18n: 'password.complexity.history.description'
    },
    age: {
      minutes: {
        i18n: 'password.complexity.minAgeMinutes.description'
      },
      hours: {
        i18n: 'password.complexity.minAgeHours.description'
      },
      days: {
        i18n: 'password.complexity.minAgeDays.description'
      }
    }
  };
  var passwordRequirements = getPasswordRequirements(policy, passwordRequirementHtmlI18nKeys);
  return _okta._.union(passwordRequirements.complexity, passwordRequirements.history, passwordRequirements.age);
};

fn.getPasswordComplexityDescription = function (policy) {
  var passwordRequirementI18nKeys = {
    complexity: {
      minLength: {
        i18n: 'password.complexity.length',
        args: true
      },
      minLowerCase: {
        i18n: 'password.complexity.lowercase'
      },
      minUpperCase: {
        i18n: 'password.complexity.uppercase'
      },
      minNumber: {
        i18n: 'password.complexity.number'
      },
      minSymbol: {
        i18n: 'password.complexity.symbol'
      },
      excludeUsername: {
        i18n: 'password.complexity.no_username'
      },
      excludeFirstName: {
        i18n: 'password.complexity.no_first_name'
      },
      excludeLastName: {
        i18n: 'password.complexity.no_last_name'
      }
    },
    history: {
      i18n: 'password.complexity.history'
    },
    age: {
      minutes: {
        i18n: 'password.complexity.minAgeMinutes'
      },
      hours: {
        i18n: 'password.complexity.minAgeHours'
      },
      days: {
        i18n: 'password.complexity.minAgeDays'
      }
    }
  };
  var result = [];
  var passwordRequirements = getPasswordRequirements(policy, passwordRequirementI18nKeys);
  var requirements = passwordRequirements.complexity; // Generate and add complexity string to result

  if (requirements.length > 0) {
    requirements = (0, _reduce.default)(_okta._).call(_okta._, requirements, function (result, requirement) {
      return result ? result + (0, _okta.loc)('password.complexity.list.element', 'login', [requirement]) : requirement;
    });
    result.push((0, _okta.loc)('password.complexity.requirements', 'login', [requirements]));
  } // Only 1 value expected in history and age for now


  result.push(passwordRequirements.history[0]);
  result.push(passwordRequirements.age[0]);
  return _okta._.compact(result).join(' ');
};

fn.getCardinalityText = function (enrolled, required, cardinality) {
  if (cardinality) {
    if (enrolled) {
      return cardinality.enrolled === 1 ? '' : (0, _okta.loc)('enroll.choices.cardinality.setup', 'login', [cardinality.enrolled]);
    } else if (required && cardinality.maximum > 1) {
      return (0, _okta.loc)('enroll.choices.cardinality.setup.remaining', 'login', [cardinality.enrolled, cardinality.minimum]);
    }
  }

  return '';
};

fn.findFactorInFactorsArray = function (factors, provider, factorType) {
  var factor = factors.findWhere({
    provider: provider,
    factorType: factorType
  });

  if (factor === undefined) {
    //for factors that support cardinality and only have factorType
    factor = factors.findWhere({
      factorType: factorType
    });
  }

  return factor;
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(23);
var has = __webpack_require__(59);
var wrappedWellKnownSymbolModule = __webpack_require__(314);
var defineProperty = __webpack_require__(86).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    "use strict";

    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.

    // Montage Require
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);

    // CommonJS
    } else if (true) {
        module.exports = definition();

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
        define(definition);

    // SES (Secure EcmaScript)
    } else if (typeof ses !== "undefined") {
        if (!ses.ok()) {
            return;
        } else {
            ses.makeQ = definition;
        }

    // <script>
    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
        // Prefer window over self for add-on scripts. Use self for
        // non-windowed contexts.
        var global = typeof window !== "undefined" ? window : self;

        // Get the `window` object, save the previous Q global
        // and initialize Q as a global.
        var previousQ = global.Q;
        global.Q = definition();

        // Add a noConflict function so Q can be removed from the
        // global namespace.
        global.Q.noConflict = function () {
            global.Q = previousQ;
            return this;
        };

    } else {
        throw new Error("This environment was not anticipated by Q. Please file a bug.");
    }

})(function () {
"use strict";

var hasStacks = false;
try {
    throw new Error();
} catch (e) {
    hasStacks = !!e.stack;
}

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// Use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick =(function () {
    // linked list of tasks (single, with head node)
    var head = {task: void 0, next: null};
    var tail = head;
    var flushing = false;
    var requestTick = void 0;
    var isNodeJS = false;
    // queue for late tasks, used by unhandled rejection tracking
    var laterQueue = [];

    function flush() {
        /* jshint loopfunc: true */
        var task, domain;

        while (head.next) {
            head = head.next;
            task = head.task;
            head.task = void 0;
            domain = head.domain;

            if (domain) {
                head.domain = void 0;
                domain.enter();
            }
            runSingle(task, domain);

        }
        while (laterQueue.length) {
            task = laterQueue.pop();
            runSingle(task);
        }
        flushing = false;
    }
    // runs a single function in the async queue
    function runSingle(task, domain) {
        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function () {
                    throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    nextTick = function (task) {
        tail = tail.next = {
            task: task,
            domain: isNodeJS && process.domain,
            next: null
        };

        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };

    if (typeof process === "object" &&
        process.toString() === "[object process]" && process.nextTick) {
        // Ensure Q is in a real Node environment, with a `process.nextTick`.
        // To see through fake Node environments:
        // * Mocha test runner - exposes a `process` global without a `nextTick`
        // * Browserify - exposes a `process.nexTick` function that uses
        //   `setTimeout`. In this case `setImmediate` is preferred because
        //    it is faster. Browserify's `process.toString()` yields
        //   "[object Object]", while in a real Node environment
        //   `process.nextTick()` yields "[object process]".
        isNodeJS = true;

        requestTick = function () {
            process.nextTick(flush);
        };

    } else if (typeof setImmediate === "function") {
        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
        if (typeof window !== "undefined") {
            requestTick = setImmediate.bind(window, flush);
        } else {
            requestTick = function () {
                setImmediate(flush);
            };
        }

    } else if (typeof MessageChannel !== "undefined") {
        // modern browsers
        // http://www.nonblocking.io/2011/06/windownexttick.html
        var channel = new MessageChannel();
        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
        // working message ports the first time a page loads.
        channel.port1.onmessage = function () {
            requestTick = requestPortTick;
            channel.port1.onmessage = flush;
            flush();
        };
        var requestPortTick = function () {
            // Opera requires us to provide a message payload, regardless of
            // whether we use it.
            channel.port2.postMessage(0);
        };
        requestTick = function () {
            setTimeout(flush, 0);
            requestPortTick();
        };

    } else {
        // old browsers
        requestTick = function () {
            setTimeout(flush, 0);
        };
    }
    // runs a task after all other tasks have been run
    // this is useful for unhandled rejection tracking that needs to happen
    // after all `then`d tasks have been run.
    nextTick.runAfter = function (task) {
        laterQueue.push(task);
        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };
    return nextTick;
})();

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this **might** have the nice side-effect of reducing the size of
// the minified code by reducing x.call() to merely x()
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
var call = Function.call;
function uncurryThis(f) {
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

function isObject(value) {
    return value === Object(value);
}

// generator related shims

// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

// FIXME: Remove this helper and Q.return once ES6 generators are in
// SpiderMonkey.
var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible, transform the error stack trace by removing Node and Q
    // cruft, then concatenating with the stack trace of `promise`. See #57.
    if (hasStacks &&
        promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
        var stacks = [];
        for (var p = promise; !!p; p = p.source) {
            if (p.stack) {
                stacks.unshift(p.stack);
            }
        }
        stacks.unshift(error.stack);

        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
        error.stack = filterStackString(concatedStacks);
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function getFileNameAndLineNumber(stackLine) {
    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
    // In IE10 function name can have spaces ("Anonymous function") O_o
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) {
        return [attempt1[1], Number(attempt1[2])];
    }

    // Anonymous functions: "at filename:lineNumber:columnNumber"
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) {
        return [attempt2[1], Number(attempt2[2])];
    }

    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) {
        return [attempt3[1], Number(attempt3[2])];
    }
}

function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

    if (!fileNameAndLineNumber) {
        return false;
    }

    var fileName = fileNameAndLineNumber[0];
    var lineNumber = fileNameAndLineNumber[1];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (!hasStacks) {
        return;
    }

    try {
        throw new Error();
    } catch (e) {
        var lines = e.stack.split("\n");
        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
        if (!fileNameAndLineNumber) {
            return;
        }

        qFileName = fileNameAndLineNumber[0];
        return fileNameAndLineNumber[1];
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" &&
            typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative +
                         " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
function Q(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (value instanceof Promise) {
        return value;
    }

    // assimilate thenables
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}
Q.resolve = Q;

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Controls whether or not long stack traces will be on
 */
Q.longStackSupport = false;

// enable long stacks if Q_DEBUG is set
if (typeof process === "object" && process && process.env && process.env.Q_DEBUG) {
    Q.longStackSupport = true;
}

/**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */
Q.defer = defer;
function defer() {
    // if "messages" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the messages array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the `resolve` function because it handles both fully
    // non-thenable values and other thenables gracefully.
    var messages = [], progressListeners = [], resolvedPromise;

    var deferred = object_create(defer.prototype);
    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (messages) {
            messages.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            Q.nextTick(function () {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        }
    };

    // XXX deprecated
    promise.valueOf = function () {
        if (messages) {
            return promise;
        }
        var nearerValue = nearer(resolvedPromise);
        if (isPromise(nearerValue)) {
            resolvedPromise = nearerValue; // shorten chain
        }
        return nearerValue;
    };

    promise.inspect = function () {
        if (!resolvedPromise) {
            return { state: "pending" };
        }
        return resolvedPromise.inspect();
    };

    if (Q.longStackSupport && hasStacks) {
        try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
        }
    }

    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
    // consolidating them into `become`, since otherwise we'd create new
    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

    function become(newPromise) {
        resolvedPromise = newPromise;
        promise.source = newPromise;

        array_reduce(messages, function (undefined, message) {
            Q.nextTick(function () {
                newPromise.promiseDispatch.apply(newPromise, message);
            });
        }, void 0);

        messages = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(Q(value));
    };

    deferred.fulfill = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(fulfill(value));
    };
    deferred.reject = function (reason) {
        if (resolvedPromise) {
            return;
        }

        become(reject(reason));
    };
    deferred.notify = function (progress) {
        if (resolvedPromise) {
            return;
        }

        array_reduce(progressListeners, function (undefined, progressListener) {
            Q.nextTick(function () {
                progressListener(progress);
            });
        }, void 0);
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */
Q.Promise = promise; // ES6
Q.promise = promise;
function promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("resolver must be a function.");
    }
    var deferred = defer();
    try {
        resolver(deferred.resolve, deferred.reject, deferred.notify);
    } catch (reason) {
        deferred.reject(reason);
    }
    return deferred.promise;
}

promise.race = race; // ES6
promise.all = all; // ES6
promise.reject = reject; // ES6
promise.resolve = Q; // ES6

// XXX experimental.  This method is a way to denote that a local value is
// serializable and should be immediately dispatched to a remote upon request,
// instead of passing a reference.
Q.passByCopy = function (object) {
    //freeze(object);
    //passByCopies.set(object, true);
    return object;
};

Promise.prototype.passByCopy = function () {
    //freeze(object);
    //passByCopies.set(object, true);
    return this;
};

/**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */
Q.join = function (x, y) {
    return Q(x).join(y);
};

Promise.prototype.join = function (that) {
    return Q([this, that]).spread(function (x, y) {
        if (x === y) {
            // TODO: "===" should be Object.is or equiv
            return x;
        } else {
            throw new Error("Can't join: not the same: " + x + " " + y);
        }
    });
};

/**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */
Q.race = race;
function race(answerPs) {
    return promise(function (resolve, reject) {
        // Switch to this once we can assume at least ES5
        // answerPs.forEach(function (answerP) {
        //     Q(answerP).then(resolve, reject);
        // });
        // Use this in the meantime
        for (var i = 0, len = answerPs.length; i < len; i++) {
            Q(answerPs[i]).then(resolve, reject);
        }
    });
}

Promise.prototype.race = function () {
    return this.then(Q.race);
};

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = Promise;
function Promise(descriptor, fallback, inspect) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error(
                "Promise does not support operation: " + op
            ));
        };
    }
    if (inspect === void 0) {
        inspect = function () {
            return {state: "unknown"};
        };
    }

    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    promise.inspect = inspect;

    // XXX deprecated `valueOf` and `exception` support
    if (inspect) {
        var inspected = inspect();
        if (inspected.state === "rejected") {
            promise.exception = inspected.reason;
        }

        promise.valueOf = function () {
            var inspected = inspect();
            if (inspected.state === "pending" ||
                inspected.state === "rejected") {
                return promise;
            }
            return inspected.value;
        };
    }

    return promise;
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.then = function (fulfilled, rejected, progressed) {
    var self = this;
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, self);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    Q.nextTick(function () {
        self.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    self.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
};

Q.tap = function (promise, callback) {
    return Q(promise).tap(callback);
};

/**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */
Promise.prototype.tap = function (callback) {
    callback = Q(callback);

    return this.then(function (value) {
        return callback.fcall(value).thenResolve(value);
    });
};

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    return Q(value).then(fulfilled, rejected, progressed);
}

Promise.prototype.thenResolve = function (value) {
    return this.then(function () { return value; });
};

Q.thenResolve = function (promise, value) {
    return Q(promise).thenResolve(value);
};

Promise.prototype.thenReject = function (reason) {
    return this.then(function () { throw reason; });
};

Q.thenReject = function (promise, reason) {
    return Q(promise).thenReject(reason);
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */

// XXX should we re-do this?
Q.nearer = nearer;
function nearer(value) {
    if (isPromise(value)) {
        var inspected = value.inspect();
        if (inspected.state === "fulfilled") {
            return inspected.value;
        }
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object instanceof Promise;
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return isObject(object) && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return isPromise(object) && object.inspect().state === "pending";
}

Promise.prototype.isPending = function () {
    return this.inspect().state === "pending";
};

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromise(object) || object.inspect().state === "fulfilled";
}

Promise.prototype.isFulfilled = function () {
    return this.inspect().state === "fulfilled";
};

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    return isPromise(object) && object.inspect().state === "rejected";
}

Promise.prototype.isRejected = function () {
    return this.inspect().state === "rejected";
};

//// BEGIN UNHANDLED REJECTION TRACKING

// This promise library consumes exceptions thrown in handlers so they can be
// handled by a subsequent promise.  The exceptions get added to this array when
// they are created, and removed when they are handled.  Note that in ES6 or
// shimmed environments, this would naturally be a `Set`.
var unhandledReasons = [];
var unhandledRejections = [];
var reportedUnhandledRejections = [];
var trackUnhandledRejections = true;

function resetUnhandledRejections() {
    unhandledReasons.length = 0;
    unhandledRejections.length = 0;

    if (!trackUnhandledRejections) {
        trackUnhandledRejections = true;
    }
}

function trackRejection(promise, reason) {
    if (!trackUnhandledRejections) {
        return;
    }
    if (typeof process === "object" && typeof process.emit === "function") {
        Q.nextTick.runAfter(function () {
            if (array_indexOf(unhandledRejections, promise) !== -1) {
                process.emit("unhandledRejection", reason, promise);
                reportedUnhandledRejections.push(promise);
            }
        });
    }

    unhandledRejections.push(promise);
    if (reason && typeof reason.stack !== "undefined") {
        unhandledReasons.push(reason.stack);
    } else {
        unhandledReasons.push("(no stack) " + reason);
    }
}

function untrackRejection(promise) {
    if (!trackUnhandledRejections) {
        return;
    }

    var at = array_indexOf(unhandledRejections, promise);
    if (at !== -1) {
        if (typeof process === "object" && typeof process.emit === "function") {
            Q.nextTick.runAfter(function () {
                var atReport = array_indexOf(reportedUnhandledRejections, promise);
                if (atReport !== -1) {
                    process.emit("rejectionHandled", unhandledReasons[at], promise);
                    reportedUnhandledRejections.splice(atReport, 1);
                }
            });
        }
        unhandledRejections.splice(at, 1);
        unhandledReasons.splice(at, 1);
    }
}

Q.resetUnhandledRejections = resetUnhandledRejections;

Q.getUnhandledReasons = function () {
    // Make a copy so that consumers can't interfere with our internal state.
    return unhandledReasons.slice();
};

Q.stopUnhandledRejectionTracking = function () {
    resetUnhandledRejections();
    trackUnhandledRejections = false;
};

resetUnhandledRejections();

//// END UNHANDLED REJECTION TRACKING

/**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */
Q.reject = reject;
function reject(reason) {
    var rejection = Promise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                untrackRejection(this);
            }
            return rejected ? rejected(reason) : this;
        }
    }, function fallback() {
        return this;
    }, function inspect() {
        return { state: "rejected", reason: reason };
    });

    // Note that the reason has not been handled.
    trackRejection(rejection, reason);

    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(value) {
    return Promise({
        "when": function () {
            return value;
        },
        "get": function (name) {
            return value[name];
        },
        "set": function (name, rhs) {
            value[name] = rhs;
        },
        "delete": function (name) {
            delete value[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name === null || name === void 0) {
                return value.apply(void 0, args);
            } else {
                return value[name].apply(value, args);
            }
        },
        "apply": function (thisp, args) {
            return value.apply(thisp, args);
        },
        "keys": function () {
            return object_keys(value);
        }
    }, void 0, function inspect() {
        return { state: "fulfilled", value: value };
    });
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    Q.nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return Promise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return Q(object).inspect();
    });
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(value, fulfilled, rejected) {
    return Q(value).spread(fulfilled, rejected);
}

Promise.prototype.spread = function (fulfilled, rejected) {
    return this.all().then(function (array) {
        return fulfilled.apply(void 0, array);
    }, rejected);
};

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;

            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
            // engine that has a deployed base of browsers that support generators.
            // However, SM's generators use the Python-inspired semantics of
            // outdated ES6 drafts.  We would like to support ES6, but we'd also
            // like to make it possible to use generators in deployed browsers, so
            // we also support Python-style generators.  At some point we can remove
            // this block.

            if (typeof StopIteration === "undefined") {
                // ES6 Generators
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    return reject(exception);
                }
                if (result.done) {
                    return Q(result.value);
                } else {
                    return when(result.value, callback, errback);
                }
            } else {
                // SpiderMonkey Generators
                // FIXME: Remove this case when SM does ES6 generators.
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    if (isStopIteration(exception)) {
                        return Q(exception.value);
                    } else {
                        return reject(exception);
                    }
                }
                return when(result, callback, errback);
            }
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "next");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */
Q.spawn = spawn;
function spawn(makeGenerator) {
    Q.done(Q.async(makeGenerator)());
}

// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q["return"] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    return Q(object).dispatch(op, args);
}

Promise.prototype.dispatch = function (op, args) {
    var self = this;
    var deferred = defer();
    Q.nextTick(function () {
        self.promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
};

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = function (object, key) {
    return Q(object).dispatch("get", [key]);
};

Promise.prototype.get = function (key) {
    return this.dispatch("get", [key]);
};

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = function (object, key, value) {
    return Q(object).dispatch("set", [key, value]);
};

Promise.prototype.set = function (key, value) {
    return this.dispatch("set", [key, value]);
};

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q.del = // XXX legacy
Q["delete"] = function (object, key) {
    return Q(object).dispatch("delete", [key]);
};

Promise.prototype.del = // XXX legacy
Promise.prototype["delete"] = function (key) {
    return this.dispatch("delete", [key]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
Q.mapply = // XXX As proposed by "Redsandro"
Q.post = function (object, name, args) {
    return Q(object).dispatch("post", [name, args]);
};

Promise.prototype.mapply = // XXX As proposed by "Redsandro"
Promise.prototype.post = function (name, args) {
    return this.dispatch("post", [name, args]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = // XXX Mark Miller's proposed parlance
Q.mcall = // XXX As proposed by "Redsandro"
Q.invoke = function (object, name /*...args*/) {
    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
};

Promise.prototype.send = // XXX Mark Miller's proposed parlance
Promise.prototype.mcall = // XXX As proposed by "Redsandro"
Promise.prototype.invoke = function (name /*...args*/) {
    return this.dispatch("post", [name, array_slice(arguments, 1)]);
};

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = function (object, args) {
    return Q(object).dispatch("apply", [void 0, args]);
};

Promise.prototype.fapply = function (args) {
    return this.dispatch("apply", [void 0, args]);
};

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] =
Q.fcall = function (object /* ...args*/) {
    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
};

Promise.prototype.fcall = function (/*...args*/) {
    return this.dispatch("apply", [void 0, array_slice(arguments)]);
};

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = function (object /*...args*/) {
    var promise = Q(object);
    var args = array_slice(arguments, 1);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};
Promise.prototype.fbind = function (/*...args*/) {
    var promise = this;
    var args = array_slice(arguments);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */
Q.keys = function (object) {
    return Q(object).dispatch("keys", []);
};

Promise.prototype.keys = function () {
    return this.dispatch("keys", []);
};

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var pendingCount = 0;
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            var snapshot;
            if (
                isPromise(promise) &&
                (snapshot = promise.inspect()).state === "fulfilled"
            ) {
                promises[index] = snapshot.value;
            } else {
                ++pendingCount;
                when(
                    promise,
                    function (value) {
                        promises[index] = value;
                        if (--pendingCount === 0) {
                            deferred.resolve(promises);
                        }
                    },
                    deferred.reject,
                    function (progress) {
                        deferred.notify({ index: index, value: progress });
                    }
                );
            }
        }, void 0);
        if (pendingCount === 0) {
            deferred.resolve(promises);
        }
        return deferred.promise;
    });
}

Promise.prototype.all = function () {
    return all(this);
};

/**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */
Q.any = any;

function any(promises) {
    if (promises.length === 0) {
        return Q.resolve();
    }

    var deferred = Q.defer();
    var pendingCount = 0;
    array_reduce(promises, function (prev, current, index) {
        var promise = promises[index];

        pendingCount++;

        when(promise, onFulfilled, onRejected, onProgress);
        function onFulfilled(result) {
            deferred.resolve(result);
        }
        function onRejected() {
            pendingCount--;
            if (pendingCount === 0) {
                deferred.reject(new Error(
                    "Can't get fulfillment value from any promise, all " +
                    "promises were rejected."
                ));
            }
        }
        function onProgress(progress) {
            deferred.notify({
                index: index,
                value: progress
            });
        }
    }, undefined);

    return deferred.promise;
}

Promise.prototype.any = function () {
    return any(this);
};

/**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, Q);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

Promise.prototype.allResolved = function () {
    return allResolved(this);
};

/**
 * @see Promise#allSettled
 */
Q.allSettled = allSettled;
function allSettled(promises) {
    return Q(promises).allSettled();
}

/**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */
Promise.prototype.allSettled = function () {
    return this.then(function (promises) {
        return all(array_map(promises, function (promise) {
            promise = Q(promise);
            function regardless() {
                return promise.inspect();
            }
            return promise.then(regardless, regardless);
        }));
    });
};

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q.fail = // XXX legacy
Q["catch"] = function (object, rejected) {
    return Q(object).then(void 0, rejected);
};

Promise.prototype.fail = // XXX legacy
Promise.prototype["catch"] = function (rejected) {
    return this.then(void 0, rejected);
};

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(object, progressed) {
    return Q(object).then(void 0, void 0, progressed);
}

Promise.prototype.progress = function (progressed) {
    return this.then(void 0, void 0, progressed);
};

/**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q.fin = // XXX legacy
Q["finally"] = function (object, callback) {
    return Q(object)["finally"](callback);
};

Promise.prototype.fin = // XXX legacy
Promise.prototype["finally"] = function (callback) {
    callback = Q(callback);
    return this.then(function (value) {
        return callback.fcall().then(function () {
            return value;
        });
    }, function (reason) {
        // TODO attempt to recycle the rejection with "this".
        return callback.fcall().then(function () {
            throw reason;
        });
    });
};

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = function (object, fulfilled, rejected, progress) {
    return Q(object).done(fulfilled, rejected, progress);
};

Promise.prototype.done = function (fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        Q.nextTick(function () {
            makeStackTraceLong(error, promise);
            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promise = fulfilled || rejected || progress ?
        this.then(fulfilled, rejected, progress) :
        this;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }

    promise.then(void 0, onUnhandledError);
};

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = function (object, ms, error) {
    return Q(object).timeout(ms, error);
};

Promise.prototype.timeout = function (ms, error) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        if (!error || "string" === typeof error) {
            error = new Error(error || "Timed out after " + ms + " ms");
            error.code = "ETIMEDOUT";
        }
        deferred.reject(error);
    }, ms);

    this.then(function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    }, deferred.notify);

    return deferred.promise;
};

/**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */
Q.delay = function (object, timeout) {
    if (timeout === void 0) {
        timeout = object;
        object = void 0;
    }
    return Q(object).delay(timeout);
};

Promise.prototype.delay = function (timeout) {
    return this.then(function (value) {
        var deferred = defer();
        setTimeout(function () {
            deferred.resolve(value);
        }, timeout);
        return deferred.promise;
    });
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = function (callback, args) {
    return Q(callback).nfapply(args);
};

Promise.prototype.nfapply = function (args) {
    var deferred = defer();
    var nodeArgs = array_slice(args);
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */
Q.nfcall = function (callback /*...args*/) {
    var args = array_slice(arguments, 1);
    return Q(callback).nfapply(args);
};

Promise.prototype.nfcall = function (/*...args*/) {
    var nodeArgs = array_slice(arguments);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */
Q.nfbind =
Q.denodeify = function (callback /*...args*/) {
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(callback).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nfbind =
Promise.prototype.denodeify = function (/*...args*/) {
    var args = array_slice(arguments);
    args.unshift(this);
    return Q.denodeify.apply(void 0, args);
};

Q.nbind = function (callback, thisp /*...args*/) {
    var baseArgs = array_slice(arguments, 2);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        function bound() {
            return callback.apply(thisp, arguments);
        }
        Q(bound).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nbind = function (/*thisp, ...args*/) {
    var args = array_slice(arguments, 0);
    args.unshift(this);
    return Q.nbind.apply(void 0, args);
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nmapply = // XXX As proposed by "Redsandro"
Q.npost = function (object, name, args) {
    return Q(object).npost(name, args);
};

Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
Promise.prototype.npost = function (name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = // XXX Based on Mark Miller's proposed "send"
Q.nmcall = // XXX Based on "Redsandro's" proposal
Q.ninvoke = function (object, name /*...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
Promise.prototype.ninvoke = function (name /*...args*/) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */
Q.nodeify = nodeify;
function nodeify(object, nodeback) {
    return Q(object).nodeify(nodeback);
}

Promise.prototype.nodeify = function (nodeback) {
    if (nodeback) {
        this.then(function (value) {
            Q.nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            Q.nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return this;
    }
};

Q.noConflict = function() {
    throw new Error("Q.noConflict only works when Q is used as a global");
};

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.backToFactors"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 106
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.options.appState.trigger('backToFactors');
      this.back();
    }
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);

    if (this.options.appState.get('prevLink')) {
      // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
      // correct state. Fortunately, this means that the router will
      // handle navigation once the request is finished.
      this.model.doTransaction(function (transaction) {
        return transaction.prev();
      });
    } else {
      this.options.appState.trigger('navigate', 'signin/enroll');
    }
  }
});

exports.default = _default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(110);
var IndexedObject = __webpack_require__(166);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(22);
var arraySpeciesCreate = __webpack_require__(174);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__ = __webpack_require__(415);





// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["m" /* nativeKeys */]) return Object(__WEBPACK_IMPORTED_MODULE_1__setup_js__["m" /* nativeKeys */])(obj);
  var keys = [];
  for (var key in obj) if (Object(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, key)) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) Object(__WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var propertyIsEnumerableModule = __webpack_require__(207);
var createPropertyDescriptor = __webpack_require__(100);
var toIndexedObject = __webpack_require__(62);
var toPrimitive = __webpack_require__(81);
var has = __webpack_require__(37);
var IE8_DOM_DEFINE = __webpack_require__(359);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var definePropertyModule = __webpack_require__(25);
var createPropertyDescriptor = __webpack_require__(100);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var createNonEnumerableProperty = __webpack_require__(50);
var has = __webpack_require__(37);
var setGlobal = __webpack_require__(260);
var inspectSource = __webpack_require__(261);
var InternalStateModule = __webpack_require__(57);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(854);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tagTester;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Internal function for creating a `toString`-based type tester.
function tagTester(name) {
  var tag = '[object ' + name + ']';
  return function(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj) === tag;
  };
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function ConfigError(message) {
  this.name = _Enums.default.CONFIG_ERROR;
  this.message = message || (0, _okta.loc)('error.config');
}

ConfigError.prototype = new Error();

function UnsupportedBrowserError(message) {
  this.name = _Enums.default.UNSUPPORTED_BROWSER_ERROR;
  this.message = message || (0, _okta.loc)('error.unsupported.browser');
}

UnsupportedBrowserError.prototype = new Error();

function OAuthError(message) {
  this.name = _Enums.default.OAUTH_ERROR;
  this.message = message;
}

OAuthError.prototype = new Error();

function RegistrationError(message) {
  this.name = _Enums.default.REGISTRATION_FAILED;
  this.message = message;
}

RegistrationError.prototype = new Error(); // Thrown when initiation of poll was cancelled.

function AuthStopPollInitiationError() {
  this.name = _Enums.default.AUTH_STOP_POLL_INITIATION_ERROR;
}

AuthStopPollInitiationError.prototype = new Error();

function U2FError(err) {
  this.name = _Enums.default.U2F_ERROR;
  this.message = err.xhr.responseJSON.errorSummary;
  this.xhr = err.xhr;
}

U2FError.prototype = new Error();

function WebAuthnError(err) {
  this.name = _Enums.default.WEB_AUTHN_ERROR;
  this.message = err.xhr.responseJSON.errorSummary;
  this.xhr = err.xhr;
}

WebAuthnError.prototype = new Error(); // This is triggered only when code aborts webauthn browser prompt.

function WebauthnAbortError() {
  this.name = _Enums.default.WEBAUTHN_ABORT_ERROR;
}

WebauthnAbortError.prototype = new Error();
var _default = {
  ConfigError: ConfigError,
  UnsupportedBrowserError: UnsupportedBrowserError,
  OAuthError: OAuthError,
  RegistrationError: RegistrationError,
  AuthStopPollInitiationError: AuthStopPollInitiationError,
  U2FError: U2FError,
  WebAuthnError: WebAuthnError,
  WebauthnAbortError: WebauthnAbortError
};
exports.default = _default;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var fn = {};
var hasFullCorsSupport = ('withCredentials' in new window.XMLHttpRequest());
var hasXDomainRequest = typeof XDomainRequest !== 'undefined';

fn.corsIsNotSupported = function () {
  return !(hasFullCorsSupport || hasXDomainRequest);
};

fn.corsIsNotEnabled = function (jqXhr) {
  // Not a definitive check, but it's the best we've got.
  // Note: This will change when OktaAuth is updated
  return jqXhr.status === 0;
}; // This is currently not being used, but we'll keep it around for when we
// want a fallback mechanism - i.e. use localStorage if it exists, else fall
// back to cookies.


fn.localStorageIsNotSupported = function () {
  var test = 'test';

  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return false;
  } catch (e) {
    return true;
  }
};

fn.supportsPushState = function (win) {
  win = win || window;
  return !!(win.history && win.history.pushState);
};

fn.isIE = function () {
  return /(msie|trident)/i.test(navigator.userAgent);
};

fn.isFirefox = function () {
  var _context;

  return (0, _indexOf.default)(_context = navigator.userAgent.toLowerCase()).call(_context, 'firefox') > -1;
};

fn.isEdge = function () {
  var _context2;

  // This is to just check for windows edge. Mac edge - chromium based's UA is 'edg'.
  return (0, _indexOf.default)(_context2 = navigator.userAgent.toLowerCase()).call(_context2, 'edge') > -1;
};

fn.isSafari = function () {
  var _context3, _context4;

  // Chrome has safari in its useragent string so adding this extra check.
  return (0, _indexOf.default)(_context3 = navigator.userAgent.toLowerCase()).call(_context3, 'safari') > -1 && (0, _indexOf.default)(_context4 = navigator.userAgent.toLowerCase()).call(_context4, 'chrome') === -1;
};

fn.isMac = function () {
  var _context5;

  return (0, _indexOf.default)(_context5 = navigator.platform.toUpperCase()).call(_context5, 'MAC') >= 0;
};

fn.isAndroid = function () {
  // Windows Phone also contains "Android"
  return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
};

fn.isIOS = function () {
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}; // Returns a list of languages the user has configured for their browser, in
// order of preference.


fn.getUserLanguages = function () {
  var languages, properties; // Chrome, Firefox

  if (navigator.languages) {
    return navigator.languages;
  }

  languages = [];
  properties = ['language', // Safari, IE11
  'userLanguage', // IE
  'browserLanguage', // IE
  'systemLanguage' // IE
  ];
  (0, _forEach.default)(properties).call(properties, function (property) {
    if (navigator[property]) {
      languages.push(navigator[property]);
    }
  });
  return languages;
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(360);
var global = __webpack_require__(9);
var isObject = __webpack_require__(15);
var createNonEnumerableProperty = __webpack_require__(50);
var objectHas = __webpack_require__(37);
var shared = __webpack_require__(262);
var sharedKey = __webpack_require__(208);
var hiddenKeys = __webpack_require__(168);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(169);
var has = __webpack_require__(37);
var wrappedWellKnownSymbolModule = __webpack_require__(366);
var defineProperty = __webpack_require__(25).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iteratee_js__ = __webpack_require__(426);




// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value, context, argCount) {
  if (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee !== __WEBPACK_IMPORTED_MODULE_2__iteratee_js__["a" /* default */]) return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee(value, context);
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, argCount);
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(166);
var requireObjectCoercible = __webpack_require__(49);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(169);
var global = __webpack_require__(9);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(49);

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(148);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var fails = __webpack_require__(28);
var has = __webpack_require__(59);

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = restArguments;
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// If Underscore is called as a function, it returns a wrapped object that can
// be used OO-style. This wrapper holds altered versions of all functions added
// through `_.mixin`. Wrapped objects may be chained.
function _(obj) {
  if (obj instanceof _) return obj;
  if (!(this instanceof _)) return new _(obj);
  this._wrapped = obj;
}

_.VERSION = __WEBPACK_IMPORTED_MODULE_0__setup_js__["e" /* VERSION */];

// Extracts the result from a wrapped and chained object.
_.prototype.value = function() {
  return this._wrapped;
};

// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

_.prototype.toString = function() {
  return String(this._wrapped);
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(77);



// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1041);

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(37);
var toObject = __webpack_require__(32);
var sharedKey = __webpack_require__(208);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(269);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(131);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);



var isFunction = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Function');

// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = __WEBPACK_IMPORTED_MODULE_1__setup_js__["p" /* root */].document && __WEBPACK_IMPORTED_MODULE_1__setup_js__["p" /* root */].document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(414);


// Internal helper to obtain the `length` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('length'));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(488);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function _log(level, args) {
  // Only log statements in development mode or if
  // throwing an error through console.error
  if (false || level === 'error') {
    window.console[level].apply(window.console, args);
  }
}
/**
 * Utility library of logging functions.
 */


var _default = {
  trace: function trace() {
    return _log('trace', arguments);
  },
  dir: function dir() {
    return _log('dir', arguments);
  },
  time: function time() {
    return _log('time', arguments);
  },
  timeEnd: function timeEnd() {
    return _log('timeEnd', arguments);
  },
  group: function group() {
    return _log('group', arguments);
  },
  groupEnd: function groupEnd() {
    return _log('groupEnd', arguments);
  },
  assert: function assert() {
    return _log('assert', arguments);
  },
  log: function log() {
    return _log('log', arguments);
  },
  info: function info() {
    return _log('info', arguments);
  },
  warn: function warn() {
    return _log('warn', arguments);
  },
  error: function error() {
    return _log('error', arguments);
  },
  deprecate: function deprecate(msg) {
    return _log('warn', ['[okta-signin-widget] DEPRECATED:', msg]);
  }
};
exports.default = _default;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(453);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(25).f;
var has = __webpack_require__(37);
var wellKnownSymbol = __webpack_require__(20);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(226);
var requireObjectCoercible = __webpack_require__(131);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var definePropertyModule = __webpack_require__(86);
var createPropertyDescriptor = __webpack_require__(129);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(399);
var anObject = __webpack_require__(53);
var toPrimitive = __webpack_require__(227);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(515);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _ErrorCodes = _interopRequireDefault(__webpack_require__(1128));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _OAuth2Util = _interopRequireDefault(__webpack_require__(326));

var _Util = _interopRequireDefault(__webpack_require__(31));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 47], max-statements: [2, 63] */
var fn = {};

var verifyUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 26
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 27
        },
        "end": {
          "line": 1,
          "column": 41
        }
      }
    }) : helper));
  },
  "useData": true
});

var verifyUrlMultipleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 26
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 27
        },
        "end": {
          "line": 1,
          "column": 41
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorIndex") || (depth0 != null ? lookupProperty(depth0, "factorIndex") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorIndex",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 42
        },
        "end": {
          "line": 1,
          "column": 57
        }
      }
    }) : helper));
  },
  "useData": true
});

var verifyUrlNoProviderTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/verify/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 28
        }
      }
    }) : helper));
  },
  "useData": true
});

var enrollFactorUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/enroll/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 26
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 27
        },
        "end": {
          "line": 1,
          "column": 41
        }
      }
    }) : helper));
  },
  "useData": true
});

var activateFactorUrlTpl = _runtime.default.template({
  "1": function _(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "step") || (depth0 != null ? lookupProperty(depth0, "step") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "step",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 63
        },
        "end": {
          "line": 1,
          "column": 71
        }
      }
    }) : helper));
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/enroll-activate/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 23
        },
        "end": {
          "line": 1,
          "column": 35
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 36
        },
        "end": {
          "line": 1,
          "column": 50
        }
      }
    }) : helper)) + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "step") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 50
        },
        "end": {
          "line": 1,
          "column": 78
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});

var recoveryUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/recovery/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "recoveryToken") || (depth0 != null ? lookupProperty(depth0, "recoveryToken") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "recoveryToken",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 16
        },
        "end": {
          "line": 1,
          "column": 33
        }
      }
    }) : helper));
  },
  "useData": true
});

var refreshUrlTpl = _runtime.default.template({
  "1": function _(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "token",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 39
        },
        "end": {
          "line": 1,
          "column": 48
        }
      }
    }) : helper));
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "signin/refresh-auth-state" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "token") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 25
        },
        "end": {
          "line": 1,
          "column": 55
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});

var sessionCookieRedirectTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "baseUrl",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 11
        }
      }
    }) : helper)) + "/login/sessionCookieRedirect?checkAccountSetupComplete=true&token=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "token",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 77
        },
        "end": {
          "line": 1,
          "column": 88
        }
      }
    }) : helper)) != null ? stack1 : "") + "&redirectUrl=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "redirectUrl") || (depth0 != null ? lookupProperty(depth0, "redirectUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "redirectUrl",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 101
        },
        "end": {
          "line": 1,
          "column": 118
        }
      }
    }) : helper)) != null ? stack1 : "");
  },
  "useData": true
});

var deviceActivationStatuses = ['DEVICE_ACTIVATED', 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED', 'DEVICE_NOT_ACTIVATED'];

fn.isHostBackgroundChromeTab = function () {
  // Checks if the SIW is loaded in a chrome webview and
  // it is in an app that is in background.
  if (navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden) {
    return true;
  } else {
    return false;
  }
};

fn.isDocumentVisible = function () {
  return document.visibilityState === 'visible';
};

fn.createVerifyUrl = function (provider, factorType, factorIndex) {
  if (provider && factorIndex) {
    return verifyUrlMultipleTpl({
      provider: encodeURIComponent(provider.toLowerCase()),
      factorType: encodeURIComponent(factorType),
      factorIndex: encodeURIComponent(factorIndex)
    });
  } else if (provider) {
    return verifyUrlTpl({
      provider: encodeURIComponent(provider.toLowerCase()),
      factorType: encodeURIComponent(factorType)
    });
  } else {
    return verifyUrlNoProviderTpl({
      factorType: encodeURIComponent(factorType)
    });
  }
};

fn.createEnrollFactorUrl = function (provider, factorType) {
  return enrollFactorUrlTpl({
    provider: encodeURIComponent(provider.toLowerCase()),
    factorType: encodeURIComponent(factorType)
  });
};

fn.createActivateFactorUrl = function (provider, factorType, step) {
  return activateFactorUrlTpl({
    provider: encodeURIComponent(provider.toLowerCase()),
    factorType: encodeURIComponent(factorType),
    step: step ? encodeURIComponent(step) : false
  });
};

fn.createRecoveryUrl = function (recoveryToken) {
  return recoveryUrlTpl({
    recoveryToken: encodeURIComponent(recoveryToken)
  });
};

fn.createRefreshUrl = function (stateToken) {
  var token = stateToken ? encodeURIComponent(stateToken) : null;
  return refreshUrlTpl({
    token: token
  });
};

fn.routeAfterAuthStatusChangeError = function (router, err) {
  if (!err) {
    return;
  } // Global error handling for CORS enabled errors


  if (err.xhr && _BrowserFeatures.default.corsIsNotEnabled(err.xhr)) {
    router.settings.callGlobalError(new _Errors.default.UnsupportedBrowserError((0, _okta.loc)('error.enabled.cors')));
    return;
  } // Token has expired - no longer valid. Navigate back to primary auth.


  if (err.errorCode === _ErrorCodes.default.INVALID_TOKEN_EXCEPTION) {
    router.appState.set('flashError', err);
    router.controller.state.set('navigateDir', _Enums.default.DIRECTION_BACK);

    if (router.settings.get('features.mfaOnlyFlow')) {
      router.navigate('signin/error', {
        trigger: true
      });
    } else {
      router.navigate('', {
        trigger: true
      });
    }

    return;
  }

  _Util.default.triggerAfterError(router.controller, err);
};

fn.routeAfterAuthStatusChange = function (router, res) {
  // Other errors are handled by the function making the authClient request
  if (!res || !res.status) {
    router.appState.clearLastAuthResponse();
    return;
  }

  router.appState.setAuthResponse(res);

  if (router.controller && router.controller.trapAuthResponse(res)) {
    return;
  }

  fn.handleResponseStatus(router, res);
};

fn.handleResponseStatus = function (router, res) {
  switch (res.status) {
    case 'SUCCESS':
      {
        handleSuccessResponseStatus(router, res);
        return;
      }

    case 'ADMIN_CONSENT_REQUIRED':
      router.navigate('signin/admin-consent', {
        trigger: true
      });
      return;

    case 'CONSENT_REQUIRED':
      router.navigate('signin/consent', {
        trigger: true
      });
      return;

    case 'DEVICE_ACTIVATE':
      router.navigate('signin/device-activate', {
        trigger: true
      });
      return;
    // We want the same view for FACTOR_REQUIRED & FACTOR_CHALLENGE
    // In the new idx pipeline FACTOR_CHALLENGE API response does not contain a prev link

    case 'FACTOR_REQUIRED':
    case 'FACTOR_CHALLENGE':
    case 'MFA_REQUIRED':
      {
        var lastFailedChallengeFactorData = router.appState.get('lastFailedChallengeFactorData'); // When the widget is bootstrapped with an error in MFA_CHALLENGE state, we pass the
        // lastFailedChallengeFactorData to MFA_REQUIRED, in order to show the error message
        // on the correct factor view

        if (lastFailedChallengeFactorData && lastFailedChallengeFactorData.factor) {
          router.appState.get('factors').lastUsedFactor = lastFailedChallengeFactorData.factor;
        }

        var factor = router.appState.get('factors').getDefaultFactor();
        var url = fn.createVerifyUrl(factor.get('provider'), factor.get('factorType'));
        router.navigate(url, {
          trigger: true
        });
        router.appState.clearLastFailedChallengeFactorData();
        return;
      }

    case 'POLL':
      {
        var pollUrl = 'signin/poll';
        router.navigate(pollUrl, {
          trigger: true
        });
        return;
      }

    case 'MFA_CHALLENGE':
      // Since we normally trap MFA_CHALLENGE, this will only get called on a
      // page refresh or when an error is returned on verification with an IdP.
      // We need to return to MFA_REQUIRED to initialize the
      // page correctly (i.e. factors dropdown, etc)
      if (router.appState.get('isFactorResultFailed')) {
        router.appState.setLastFailedChallengeFactorData();
      }

      router.appState.get('transaction').prev().then(function (trans) {
        router.appState.set('transaction', trans);
      }); // TODO: catch/handle error here?

      return;

    case 'MFA_ENROLL':
    case 'FACTOR_ENROLL':
      router.navigate('signin/enroll', {
        trigger: true
      });
      return;

    case 'MFA_ENROLL_ACTIVATE':
    case 'FACTOR_ENROLL_ACTIVATE':
      {
        var activateUrl = fn.createActivateFactorUrl(router.appState.get('activatedFactorProvider'), router.appState.get('activatedFactorType'));
        router.navigate(activateUrl, {
          trigger: true
        });
        return;
      }

    case 'PASSWORD_WARN':
    case 'PASSWORD_EXPIRED':
      if (router.settings.get('features.customExpiredPassword') && !router.appState.get('isPwdManagedByOkta')) {
        router.navigate('signin/custom-password-expired', {
          trigger: true
        });
      } else {
        router.navigate('signin/password-expired', {
          trigger: true
        });
      }

      return;

    case 'RECOVERY_CHALLENGE':
      {
        var fromEmail = res.factorType.toLowerCase() === _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase();

        var isForgotPassword = res.recoveryType === _Enums.default.RECOVERY_TYPE_PASSWORD;
        var isUnlock = res.recoveryType === _Enums.default.RECOVERY_TYPE_UNLOCK; // Will use this workaround (lowercasing response) until OKTA-69083 is resolved

        if (isForgotPassword && fromEmail) {
          router.navigate('signin/recovery-emailed', {
            trigger: true
          });
        } else if (isUnlock && fromEmail) {
          router.navigate('signin/unlock-emailed', {
            trigger: true
          });
        } else {
          router.navigate('signin/recovery-challenge', {
            trigger: true
          });
        }

        return;
      }

    case 'RECOVERY':
      router.navigate('signin/recovery-question', {
        trigger: true
      });
      return;

    case 'PASSWORD_RESET':
      router.navigate('signin/password-reset', {
        trigger: true
      });
      return;

    case 'LOCKED_OUT':
      {
        if (router.settings.get('features.selfServiceUnlock')) {
          router.navigate('signin/unlock', {
            trigger: true
          });
        } else {
          var errorMessage = (0, _okta.loc)('error.auth.lockedOut', 'login');
          var resError = {
            responseJSON: {
              errorCauses: [],
              errorSummary: errorMessage,
              errorCode: 'E0000119'
            }
          };
          var err = {
            name: 'AuthApiError',
            message: errorMessage,
            xhr: resError
          };
          router.controller.model.appState.trigger('removeLoading');
          router.controller.model.trigger('error', router.controller.model, resError);

          _Util.default.triggerAfterError(router.controller, err);
        }

        return;
      }

    case 'PROFILE_REQUIRED':
      router.navigate('signin/enroll-user', {
        trigger: true
      });
      return;

    case 'UNAUTHENTICATED':
      // Either we have factors and we are in passwordlessAuth mode
      if (router.appState.get('promptForFactorInUnauthenticated')) {
        var defaultFactor = router.appState.get('factors').getDefaultFactor();
        var factorURL = fn.createVerifyUrl(defaultFactor.get('provider'), defaultFactor.get('factorType'));
        router.navigate(factorURL, {
          trigger: true
        });
        return;
      } // Or we don't have anything and we need to show the login page


      router.navigate('', {
        trigger: true
      });
      return;

    default:
      throw new Error('Unknown status: ' + res.status);
  }
};

function handleSuccessResponseStatus(router, res) {
  var _res$_embedded;

  if (res.recoveryType === _Enums.default.RECOVERY_TYPE_UNLOCK) {
    router.navigate('signin/account-unlocked', {
      trigger: true
    });
    return;
  }

  if (_okta._.contains(deviceActivationStatuses, (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : _res$_embedded.deviceActivationStatus)) {
    router.navigate('signin/device-activate-complete', {
      trigger: true
    });
    return;
  } // If the desired end result object needs to have idToken (and not sessionToken),
  // get the id token from session token before calling the global success function.


  if (router.settings.get('oauth2Enabled')) {
    _OAuth2Util.default.getTokens(router.settings, {
      sessionToken: res.sessionToken
    }, router.controller);

    return;
  }

  var successData = {
    user: res._embedded.user,
    type: res.type || _Enums.default.SESSION_SSO
  };

  if (res.relayState) {
    successData.relayState = res.relayState;
  }

  var redirectFn = router.settings.get('redirectUtilFn');
  var nextUrl = res._links && (res._links.original && res._links.original.href || res._links.next && res._links.next.href);

  if (res.type === _Enums.default.SESSION_STEP_UP) {
    var targetUrl = res._links && res._links.next && res._links.next.href;
    successData.stepUp = {
      url: targetUrl,
      finish: function finish() {
        redirectFn(targetUrl);
      }
    };
  } else if (nextUrl) {
    successData.next = function () {
      redirectFn(nextUrl);
    };
  } else {
    // Add the type for now until the API returns it.
    successData.type = _Enums.default.SESSION_SSO;
    successData.session = {
      token: res.sessionToken,
      setCookieAndRedirect: function setCookieAndRedirect(redirectUri) {
        if (redirectUri) {
          _Util.default.debugMessage("\n            Passing a \"redirectUri\" to \"setCookieAndRedirect\" is strongly discouraged.\n            It is recommended to set a \"redirectUri\" option in the config object passed to the widget constructor.\n          ");
        }

        redirectUri = redirectUri || router.settings.get('redirectUri');

        if (!redirectUri) {
          throw new _Errors.default.ConfigError('"redirectUri" is required');
        }

        redirectFn(sessionCookieRedirectTpl({
          baseUrl: router.settings.get('baseUrl'),
          token: encodeURIComponent(res.sessionToken),
          redirectUrl: encodeURIComponent(redirectUri)
        }));
      }
    };
  } // Check if we need to wait for redirect based on host.


  if (fn.isHostBackgroundChromeTab()) {
    document.addEventListener('visibilitychange', function checkVisibilityAndCallSuccess() {
      if (fn.isDocumentVisible()) {
        document.removeEventListener('visibilitychange', checkVisibilityAndCallSuccess);
        router.settings.callGlobalSuccess(_Enums.default.SUCCESS, successData);
      }
    });
  } else {
    router.settings.callGlobalSuccess(_Enums.default.SUCCESS, successData);
  }
}

var _default = fn;
exports.default = _default;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.WIDGET_FOOTER_CLASS = exports.CANCEL_POLLING_ACTION = exports.UNIVERSAL_LINK_POST_DELAY = exports.MS_PER_SEC = exports.CHALLENGE_TIMEOUT = exports.WARNING_TIMEOUT = exports.SHOW_RESEND_TIMEOUT = void 0;
var SHOW_RESEND_TIMEOUT = 30000;
exports.SHOW_RESEND_TIMEOUT = SHOW_RESEND_TIMEOUT;
var WARNING_TIMEOUT = 30000;
exports.WARNING_TIMEOUT = WARNING_TIMEOUT;
var CHALLENGE_TIMEOUT = 300000;
exports.CHALLENGE_TIMEOUT = CHALLENGE_TIMEOUT;
var MS_PER_SEC = 1000;
exports.MS_PER_SEC = MS_PER_SEC;
var UNIVERSAL_LINK_POST_DELAY = 500;
exports.UNIVERSAL_LINK_POST_DELAY = UNIVERSAL_LINK_POST_DELAY;
var CANCEL_POLLING_ACTION = 'authenticatorChallenge-cancel';
exports.CANCEL_POLLING_ACTION = CANCEL_POLLING_ACTION;
var WIDGET_FOOTER_CLASS = 'siw-main-footer';
exports.WIDGET_FOOTER_CLASS = WIDGET_FOOTER_CLASS;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var defineProperties = __webpack_require__(268);
var enumBugKeys = __webpack_require__(265);
var hiddenKeys = __webpack_require__(168);
var html = __webpack_require__(364);
var documentCreateElement = __webpack_require__(259);
var sharedKey = __webpack_require__(208);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(460);
var global = __webpack_require__(33);
var isObject = __webpack_require__(38);
var createNonEnumerableProperty = __webpack_require__(85);
var objectHas = __webpack_require__(59);
var sharedKey = __webpack_require__(233);
var hiddenKeys = __webpack_require__(183);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(23);
var global = __webpack_require__(33);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(115);
var IndexedObject = __webpack_require__(226);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(66);
var arraySpeciesCreate = __webpack_require__(235);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(494);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(58);
var wellKnownSymbol = __webpack_require__(20);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(19);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(285);
var ArrayBufferViewCore = __webpack_require__(21);
var ArrayBufferModule = __webpack_require__(224);
var anInstance = __webpack_require__(114);
var createPropertyDescriptor = __webpack_require__(100);
var createNonEnumerableProperty = __webpack_require__(50);
var toLength = __webpack_require__(22);
var toIndex = __webpack_require__(393);
var toOffset = __webpack_require__(394);
var toPrimitive = __webpack_require__(81);
var has = __webpack_require__(37);
var classof = __webpack_require__(177);
var isObject = __webpack_require__(15);
var create = __webpack_require__(94);
var setPrototypeOf = __webpack_require__(111);
var getOwnPropertyNames = __webpack_require__(123).f;
var typedArrayFrom = __webpack_require__(395);
var forEach = __webpack_require__(46).forEach;
var setSpecies = __webpack_require__(144);
var definePropertyModule = __webpack_require__(25);
var getOwnPropertyDescriptorModule = __webpack_require__(48);
var InternalStateModule = __webpack_require__(57);
var inheritIfRequired = __webpack_require__(220);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return it instanceof ArrayBuffer || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && typeof key != 'symbol'
    && key in target
    && String(+key) == String(key);
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  return isTypedArrayIndex(target, key = toPrimitive(key, true))
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  if (isTypedArrayIndex(target, key = toPrimitive(key, true))
    && isObject(descriptor)
    && has(descriptor, 'value')
    && !has(descriptor, 'get')
    && !has(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!has(descriptor, 'writable') || descriptor.writable)
    && (!has(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructor, CONSTRUCTOR_NAME);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructor, CONSTRUCTOR_NAME);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
var DOMIterables = __webpack_require__(951);
var global = __webpack_require__(33);
var classof = __webpack_require__(118);
var createNonEnumerableProperty = __webpack_require__(85);
var Iterators = __webpack_require__(137);
var wellKnownSymbol = __webpack_require__(34);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(311);
var defineProperty = __webpack_require__(86).f;
var createNonEnumerableProperty = __webpack_require__(85);
var has = __webpack_require__(59);
var toString = __webpack_require__(949);
var wellKnownSymbol = __webpack_require__(34);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var template = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<span class=\"icon error-24\"></span><h4><strong>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "message",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 47
        },
        "end": {
          "line": 1,
          "column": 60
        }
      }
    }) : helper)) != null ? stack1 : "") + "</strong></h4>";
  },
  "useData": true
}); // Have to be unescaped for the html in enroll.windowsHello.error.notConfiguredHtml


var _default = _okta.View.extend({
  template: template,
  className: 'okta-infobox-error infobox infobox-error infobox-md margin-btm-25',
  attributes: {
    'data-se': 'o-form-error-html'
  },
  message: '',
  initialize: function initialize(options) {
    if (options && options.message) {
      this.message = options.message;
    }
  },
  getTemplateData: function getTemplateData() {
    return {
      message: this.message
    };
  }
});

exports.default = _default;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(58);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(16);
var aPossiblePrototype = __webpack_require__(367);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var isArrayIteratorMethod = __webpack_require__(270);
var toLength = __webpack_require__(22);
var bind = __webpack_require__(110);
var getIteratorMethod = __webpack_require__(176);
var iteratorClose = __webpack_require__(368);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(20);
var create = __webpack_require__(94);
var definePropertyModule = __webpack_require__(25);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(84);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Internal function to check whether `key` is an own property name of `obj`.
function has(obj, key) {
  return obj != null && __WEBPACK_IMPORTED_MODULE_0__setup_js__["i" /* hasOwnProperty */].call(obj, key);
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(456);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(311);
var classofRaw = __webpack_require__(130);
var wellKnownSymbol = __webpack_require__(34);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var isArrayIteratorMethod = __webpack_require__(474);
var toLength = __webpack_require__(66);
var bind = __webpack_require__(115);
var getIteratorMethod = __webpack_require__(192);
var callWithSafeIterationClosing = __webpack_require__(473);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1215);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var _Promise = __webpack_require__(1216);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    _Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new _Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getReloadPageButtonLink = exports.getSkipSetupLink = exports.getBackToSignInLink = exports.getSignOutLink = exports.getSignUpLink = exports.goBackLink = exports.getForgotPasswordLink = exports.getSwitchAuthenticatorLink = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

var ENROLLED_PASSWORD_RECOVERY_LINK = _RemediationConstants.ACTIONS.ENROLLED_PASSWORD_RECOVERY_LINK,
    ORG_PASSWORD_RECOVERY_LINK = _RemediationConstants.ACTIONS.ORG_PASSWORD_RECOVERY_LINK;

var getSwitchAuthenticatorLink = function getSwitchAuthenticatorLink(appState) {
  if (appState.getRemediationAuthenticationOptions(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE).length > 1) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('oie.verification.switch.authenticator', 'login'),
      'name': 'switchAuthenticator',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE
    }];
  }

  if (appState.getRemediationAuthenticationOptions(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL).length > 1) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('oie.enroll.switch.authenticator', 'login'),
      'name': 'switchAuthenticator',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL
    }];
  }

  return [];
};

exports.getSwitchAuthenticatorLink = getSwitchAuthenticatorLink;

var getForgotPasswordLink = function getForgotPasswordLink(appState, settings) {
  var forgotPasswordLink = {
    'type': 'link',
    'label': (0, _okta.loc)('forgotpassword', 'login'),
    'name': 'forgot-password'
  };
  var customForgotPasswordHref = settings.get('helpLinks.forgotPassword');

  if (customForgotPasswordHref) {
    return [(0, _assign.default)({}, {
      'href': customForgotPasswordHref,
      'label': (0, _okta.loc)('forgotpassword', 'login'),
      'name': 'forgot-password'
    })];
  } // at identify page when only Org Authenticator Password may be available
  else if (appState.getActionByPath(ORG_PASSWORD_RECOVERY_LINK)) {
      return [(0, _assign.default)({}, forgotPasswordLink, {
        actionPath: ORG_PASSWORD_RECOVERY_LINK
      })];
    } // at password verify page
    else if (appState.getActionByPath(ENROLLED_PASSWORD_RECOVERY_LINK)) {
        return [(0, _assign.default)({}, forgotPasswordLink, {
          actionPath: ENROLLED_PASSWORD_RECOVERY_LINK
        })];
      }

  return [];
};

exports.getForgotPasswordLink = getForgotPasswordLink;

var goBackLink = function goBackLink(appState) {
  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL)) {
    return [{
      'type': 'link',
      'label': (0, _okta.loc)('oie.go.back', 'login'),
      'name': 'go-back',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL
    }];
  }

  return [];
};

exports.goBackLink = goBackLink;

var getSkipSetupLink = function getSkipSetupLink(appState, linkName) {
  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SKIP)) {
    return [{
      'type': 'link',
      'label': linkName !== null && linkName !== void 0 ? linkName : (0, _okta.loc)('oie.enroll.skip.setup', 'login'),
      'name': 'skip-setup',
      'actionPath': _RemediationConstants.FORMS.SKIP
    }];
  }

  return [];
};

exports.getSkipSetupLink = getSkipSetupLink;

var getSignOutLink = function getSignOutLink(settings) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (settings === null || settings === void 0 ? void 0 : settings.get('signOutLink')) {
    return [{
      'label': (0, _okta.loc)('signout', 'login'),
      'name': 'cancel',
      'href': settings.get('signOutLink')
    }];
  } else {
    return [{
      'actionPath': 'cancel',
      'label': !options.label ? (0, _okta.loc)('goback', 'login') : options.label,
      'name': 'cancel',
      'type': 'link'
    }];
  }
}; // Use it to create a widget configured link in the absence of `cancel` object in remediation


exports.getSignOutLink = getSignOutLink;

var getBackToSignInLink = function getBackToSignInLink(settings) {
  return [{
    'type': 'link',
    'label': (0, _okta.loc)('goback', 'login'),
    'name': 'go-back',
    // TODO: OKTA-381328 back to baseUrl only works for default login page
    'href': settings === null || settings === void 0 ? void 0 : settings.get('baseUrl')
  }];
};

exports.getBackToSignInLink = getBackToSignInLink;

var getReloadPageButtonLink = function getReloadPageButtonLink() {
  return [{
    'type': 'link',
    'label': (0, _okta.loc)('oie.try.again', 'login'),
    'name': 'try-again',
    'href': window.location,
    'className': 'button button-primary text-align-c'
  }];
};

exports.getReloadPageButtonLink = getReloadPageButtonLink;

var getSignUpLink = function getSignUpLink(appState, settings) {
  var signupLink = [];

  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_ENROLL_PROFILE)) {
    var signupLinkData = {
      'type': 'link',
      'label': (0, _okta.loc)('oie.registration.form.title', 'login'),
      'name': 'enroll'
    };

    if (_okta._.isFunction(settings.get('registration.click'))) {
      signupLinkData.clickHandler = settings.get('registration.click');
    } else {
      signupLinkData.actionPath = _RemediationConstants.FORMS.SELECT_ENROLL_PROFILE;
    }

    signupLink.push(signupLinkData);
  }

  return signupLink;
};

exports.getSignUpLink = getSignUpLink;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(362);
var enumBugKeys = __webpack_require__(265);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(101);
var global = __webpack_require__(9);

module.exports = classof(global.process) == 'process';


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(101);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(81);
var definePropertyModule = __webpack_require__(25);
var createPropertyDescriptor = __webpack_require__(100);

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(168);
var isObject = __webpack_require__(15);
var has = __webpack_require__(37);
var defineProperty = __webpack_require__(25).f;
var uid = __webpack_require__(167);
var FREEZING = __webpack_require__(179);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var propertyIsEnumerableModule = __webpack_require__(225);
var createPropertyDescriptor = __webpack_require__(129);
var toIndexedObject = __webpack_require__(83);
var toPrimitive = __webpack_require__(227);
var has = __webpack_require__(59);
var IE8_DOM_DEFINE = __webpack_require__(399);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tagTester_js__ = __webpack_require__(54);



// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["k" /* nativeIsArray */] || Object(__WEBPACK_IMPORTED_MODULE_1__tagTester_js__["a" /* default */])('Array'));


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = each;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(47);




// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context);
  var i, length;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(28);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(130);

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(85);

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(467).charAt;
var InternalStateModule = __webpack_require__(95);
var defineIterator = __webpack_require__(462);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1028);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      endLineNumber = undefined,
      column = undefined,
      endColumn = undefined;

  if (loc) {
    line = loc.start.line;
    endLineNumber = loc.end.line;
    column = loc.start.column;
    endColumn = loc.end.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;
      this.endLineNumber = endLineNumber;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
        Object.defineProperty(this, 'endColumn', {
          value: endColumn,
          enumerable: true
        });
      } else {
        this.column = column;
        this.endColumn = endColumn;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getMessageFromBrowserError = exports.isCustomizedI18nKey = exports.doesI18NKeyExist = exports.getI18NParams = exports.getMessageKey = exports.getMessage = exports.default = void 0;

var _filter = _interopRequireDefault(__webpack_require__(39));

var _endsWith = _interopRequireDefault(__webpack_require__(535));

var _startsWith = _interopRequireDefault(__webpack_require__(239));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _okta = __webpack_require__(2);

var _Bundles = _interopRequireDefault(__webpack_require__(155));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _AuthenticatorUtil = __webpack_require__(204);

var _RemediationConstants = __webpack_require__(24);

var _FORMS$ENROLL_AUTHENT;

var WEBAUTHN_API_GENERIC_ERROR_KEY = 'authfactor.webauthn.error';
var SECURITY_QUESTION_PREFIXES = ['enroll-authenticator.security_question.credentials.questionKey.', 'challenge-authenticator.security_question.credentials.questionKey.'];
var I18N_OVERRIDE_MAPPINGS = {
  'identify.identifier': 'primaryauth.username.placeholder',
  'select-authenticator-unlock-account.identifier': 'primaryauth.username.placeholder',
  'identify.credentials.passcode': 'primaryauth.password.placeholder',
  'identify.rememberMe': 'oie.remember',
  'identify-recovery.identifier': 'password.forgot.email.or.username.placeholder',
  'select-authenticator-enroll.authenticator.duo': 'factor.duo',
  'select-authenticator-enroll.authenticator.google_otp': 'oie.google_authenticator.label',
  'select-authenticator-enroll.authenticator.okta_email': 'oie.email.label',
  'select-authenticator-enroll.authenticator.okta_password': 'oie.password.label',
  'select-authenticator-enroll.authenticator.okta_verify': 'oie.okta_verify.label',
  'select-authenticator-enroll.authenticator.phone_number': 'oie.phone.label',
  'select-authenticator-enroll.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
  'select-authenticator-enroll.authenticator.security_question': 'oie.security.question.label',
  'select-authenticator-enroll.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
  'select-authenticator-enroll.authenticator.webauthn': 'oie.webauthn.label',
  'select-authenticator-enroll.authenticator.yubikey_token': 'oie.yubikey.label',
  'select-authenticator-authenticate.authenticator.duo': 'factor.duo',
  'select-authenticator-authenticate.authenticator.google_otp': 'oie.google_authenticator.label',
  'select-authenticator-authenticate.authenticator.okta_email': 'oie.email.label',
  'select-authenticator-authenticate.authenticator.okta_password': 'oie.password.label',
  'select-authenticator-authenticate.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
  'select-authenticator-authenticate.authenticator.okta_verify.signed_nonce': 'oie.okta_verify.signed_nonce.label',
  'select-authenticator-authenticate.authenticator.okta_verify.totp': 'oie.okta_verify.totp.title',
  'select-authenticator-authenticate.authenticator.phone_number': 'oie.phone.label',
  'select-authenticator-authenticate.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
  'select-authenticator-authenticate.authenticator.security_question': 'oie.security.question.label',
  'select-authenticator-authenticate.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
  'select-authenticator-authenticate.authenticator.webauthn': 'oie.webauthn.label',
  'select-authenticator-authenticate.authenticator.yubikey_token': 'oie.yubikey.label',
  'select-authenticator-unlock-account.authenticator.okta_email': 'oie.email.label',
  'select-authenticator-unlock-account.authenticator.phone_number': 'oie.phone.label',
  'select-authenticator-unlock-account.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
  'authenticator-verification-data.okta_verify.authenticator.methodType.signed_nonce': 'oie.okta_verify.signed_nonce.label',
  'authenticator-verification-data.okta_verify.authenticator.methodType.push': 'oie.okta_verify.push.title',
  'authenticator-verification-data.okta_verify.authenticator.methodType.totp': 'oie.okta_verify.totp.title',
  'authenticator-enrollment-data.phone_number.authenticator.phoneNumber': 'mfa.phoneNumber.placeholder',
  'authenticator-enrollment-data.phone_number.authenticator.methodType.sms': 'oie.phone.enroll.sms.label',
  'authenticator-enrollment-data.phone_number.authenticator.methodType.voice': 'oie.phone.enroll.voice.label',
  'enroll-authenticator.okta_password.credentials.passcode': 'oie.password.passwordLabel',
  'enroll-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'enroll-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'enroll-authenticator.security_question.sub_schema_local_credentials.0': 'oie.security.question.questionKey.label',
  'enroll-authenticator.security_question.sub_schema_local_credentials.1': 'oie.security.question.createQuestion.label',
  'enroll-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
  'enroll-authenticator.security_question.credentials.question': 'oie.security.question.createQuestion.label',
  'enroll-authenticator.security_question.credentials.questionKey': 'oie.security.question.questionKey.label',
  'enroll-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
  'enroll-authenticator.onprem_mfa.credentials.clientData': 'enroll.onprem.username.placeholder',
  'enroll-authenticator.onprem_mfa.credentials.passcode': 'enroll.onprem.passcode.placeholder',
  'enroll-authenticator.rsa_token.credentials.clientData': 'enroll.onprem.username.placeholder',
  'enroll-authenticator.rsa_token.credentials.passcode': 'enroll.onprem.passcode.placeholder',
  'enroll-authenticator.symantec_vip.credentials.credentialId': 'enroll.symantecVip.credentialId.placeholder',
  'enroll-authenticator.symantec_vip.credentials.passcode': 'enroll.symantecVip.passcode1.placeholder',
  'enroll-authenticator.symantec_vip.credentials.nextPasscode': 'enroll.symantecVip.passcode2.placeholder',
  'enroll-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
  'enrollment-channel-data.email': 'oie.enroll.okta_verify.channel.email.label',
  'select-enrollment-channel.authenticator.channel.qrcode': 'oie.enroll.okta_verify.select.channel.qrcode.label',
  'select-enrollment-channel.authenticator.channel.email': 'oie.enroll.okta_verify.select.channel.email.label',
  'select-enrollment-channel.authenticator.channel.sms': 'oie.enroll.okta_verify.select.channel.sms.label',
  'challenge-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.okta_password.credentials.passcode': 'mfa.challenge.password.placeholder',
  'challenge-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
  'challenge-authenticator.okta_verify.credentials.totp': 'oie.okta_verify.totp.enterCodeText',
  'challenge-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
  'challenge-authenticator.onprem_mfa.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.rsa_token.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.custom_otp.credentials.passcode': 'oie.custom_otp.verify.passcode.label',
  'challenge-authenticator.symantec_vip.credentials.passcode': 'oie.symantecVip.verify.passcode.label',
  'challenge-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
  'challenge-authenticator.credentials.passcode': 'oie.password.label',
  'reset-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
  'reenroll-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
  'reenroll-authenticator-warning.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
  'incorrectPassword': 'oie.password.incorrect.message',
  'enroll-profile.userProfile.lastName': 'oie.user.profile.lastname',
  'enroll-profile.userProfile.firstName': 'oie.user.profile.firstname',
  'enroll-profile.userProfile.email': 'oie.user.profile.primary.email',
  'user-code.userCode': 'device.code.activate.label',
  // Remap authn API errors to OIE
  'api.authn.poll.error.push_rejected': 'oktaverify.rejected',
  // Remap duo API errors to OIE
  'oie.authenticator.duo.method.duo.verification_timeout': 'oie.authenticator.duo.error',
  'oie.authenticator.duo.method.duo.verification_failed': 'oie.authenticator.duo.error',
  'idx.email.verification.required': 'registration.complete.confirm.text',
  'tooManyRequests': 'oie.tooManyRequests',
  'api.users.auth.error.POST_PASSWORD_UPDATE_AUTH_FAILURE': 'oie.post.password.update.auth.failure.error',
  'security.access_denied': 'errors.E0000006',
  'E0000009': 'errors.E0000009',
  'api.factors.error.sms.invalid_phone': 'oie.phone.invalid',
  'app.ldap.password.reset.failed': 'errors.E0000017',
  'oie.selfservice.unlock_user.challenge.failed.permissions': 'errors.E0000006'
};
var I18N_PARAMS_MAPPING = (0, _defineProperty2.default)({}, _RemediationConstants.FORMS.ENROLL_AUTHENTICATOR, (_FORMS$ENROLL_AUTHENT = {}, (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM, {
  getParam: _AuthenticatorUtil.getAuthenticatorDisplayName
}), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.RSA, {
  getParam: _AuthenticatorUtil.getAuthenticatorDisplayName
}), _FORMS$ENROLL_AUTHENT));
/**
 * For i18n keys that require string interpolation using values from "params".
 * {baseKey} : {params}
 */

var I18N_OVERRIDE_WITH_PARAMS_MAP = {
  'registration.error.invalidLoginEmail': {
    Email: 'Email'
  },
  'registration.error.doesNotMatchPattern': {
    Email: 'Email'
  },
  'registration.error.notUniqueWithinOrg': {
    Email: 'Email'
  }
};
/**
 * For messages that need to be interpolated with param values.
 *
 * Enumerate each possible param interpolation and hardcode that into properties file.
 * This is to ensure proper translation.
 *
 * Example - a known param:
 *
 * input =
 *  "i18n": {
      "key": "registration.error.doesNotMatchPattern",
      "params": [
        "Email"
      ]
    }
 * output = registration.error.doesNotMatchPattern.Email
 *
 * Example - an unknown param:
 *
 * input =
 *  "i18n": {
      "key": "registration.error.doesNotMatchPattern",
      "params": [
        "Custom Property"
      ]
    }
 * output = registration.error.doesNotMatchPattern.custom
 *
 * @param {String} key
 * @param {String} param
 * @returns {String}
 */

var getI8nKeyUsingParams = function getI8nKeyUsingParams(key, param) {
  var i18nKey = key;

  if (I18N_OVERRIDE_WITH_PARAMS_MAP[i18nKey][param]) {
    i18nKey += ".".concat(param);
  } else {
    i18nKey += '.custom';
  }

  return i18nKey;
};

var getI18NParams = function getI18NParams(remediation, authenticatorKey) {
  var params = [];
  var formName = remediation.name;

  if (I18N_PARAMS_MAPPING[formName] && I18N_PARAMS_MAPPING[formName][authenticatorKey]) {
    var config = I18N_PARAMS_MAPPING[formName][authenticatorKey];
    var param = config.getParam(remediation);
    params.push(param);
  }

  return params;
};

exports.getI18NParams = getI18NParams;

var getI18nKey = function getI18nKey(i18nPath) {
  var i18nKey; // Extract security question value from i18nPath

  (0, _forEach.default)(SECURITY_QUESTION_PREFIXES).call(SECURITY_QUESTION_PREFIXES, function (prefix) {
    if ((0, _indexOf.default)(i18nPath).call(i18nPath, prefix) === 0) {
      var securityQuestionValue = i18nPath.replace(prefix, '');
      i18nKey = "security.".concat(securityQuestionValue);
    }
  });

  if (I18N_OVERRIDE_MAPPINGS[i18nPath]) {
    i18nKey = I18N_OVERRIDE_MAPPINGS[i18nPath];
  }

  if (i18nKey && !_Bundles.default.login[i18nKey]) {
    var _context;

    _Logger.default.warn((0, _concat.default)(_context = "expect i18n key ".concat(i18nKey, " for ")).call(_context, i18nPath, " but not found in 'login' bundle."));

    i18nKey = null;
  }

  return i18nKey;
};

var doesI18NKeyExist = function doesI18NKeyExist(i18nKey) {
  return !!_Bundles.default.login[i18nKey];
};
/**
 * Find i18n value using {@code i18nPath} if it exists.
 * Otherwise return {@code defaultValue}.
 *
 * @param {string} i18nPath
 * @param {string} defaultValue
 * @param {string[]} params
 */


exports.doesI18NKeyExist = doesI18NKeyExist;

var getI18NValue = function getI18NValue(i18nPath, defaultValue) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var i18nKey = getI18nKey(i18nPath); // TODO : OKTA-397225
  // here defaultValue is uiSchema label or placeholders, some lables may be customized by 
  // admin to anything string. We should not localize and replace these customized labels even if i18nkey exists

  if (i18nKey) {
    return (0, _okta.loc)(i18nKey, 'login', params);
  } else {
    _Logger.default.warn("Avoid rendering unlocalized text sent from the API: ".concat(defaultValue));

    return defaultValue;
  }
};

var updateLabelForUiSchema = function updateLabelForUiSchema(remediation, uiSchema) {
  var _context2, _remediation$relatesT, _remediation$relatesT2, _context3, _context4, _context5;

  if (uiSchema.mutable === false && (0, _indexOf.default)(_context2 = uiSchema.name).call(_context2, 'questionKey') < 0) {
    return;
  }

  _Logger.default.info('i18n label transformer');

  _Logger.default.info('\t remediationName: ', remediation.name);

  _Logger.default.info('\t uiSchema: ', (0, _stringify.default)(uiSchema));

  var authenticatorKey = (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key;
  var authenticatorKeyPath = authenticatorKey ? ".".concat(remediation.relatesTo.value.key) : '';
  var i18nPrefix = (0, _concat.default)(_context3 = "".concat(remediation.name)).call(_context3, authenticatorKeyPath, ".");
  var i18nPath = (0, _concat.default)(_context4 = "".concat(i18nPrefix)).call(_context4, uiSchema.name);

  if (uiSchema.type === 'text' && (0, _indexOf.default)(_context5 = uiSchema.name).call(_context5, 'questionKey') >= 0 && uiSchema.value !== 'custom') {
    var _context6;

    i18nPath = (0, _concat.default)(_context6 = "".concat(i18nPath, ".")).call(_context6, uiSchema.value);
  }

  if (uiSchema.type === 'checkbox' && uiSchema.placeholder) {
    _Logger.default.info('\t 1: ', i18nPath);

    uiSchema.placeholder = getI18NValue(i18nPath, uiSchema.placeholder);
  }

  if (uiSchema.label) {
    _Logger.default.info('\t 2: ', i18nPath);

    var params = getI18NParams(remediation, authenticatorKey);
    uiSchema.label = getI18NValue(i18nPath, uiSchema.label, params);
  }

  if (_okta.$.isPlainObject(uiSchema.options)) {
    uiSchema.options = _okta._.mapObject(uiSchema.options, function (value, key) {
      var _context7;

      var i18nPathOption = (0, _concat.default)(_context7 = "".concat(i18nPath, ".")).call(_context7, key);

      _Logger.default.info('\t 3: ', i18nPathOption);

      return getI18NValue(i18nPathOption, value);
    });
  }

  if ((0, _isArray.default)(uiSchema.options)) {
    var _context8;

    (0, _forEach.default)(_context8 = uiSchema.options).call(_context8, function (o) {
      if (!o.label) {
        return;
      }

      var i18nPathOption;

      if (o.authenticatorKey) {
        var _context9, _o$value;

        i18nPathOption = (0, _concat.default)(_context9 = "".concat(i18nPath, ".")).call(_context9, o.authenticatorKey);
        var methodType = (_o$value = o.value) === null || _o$value === void 0 ? void 0 : _o$value.methodType;

        if (o.authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.OV && methodType) {
          var _context10;

          i18nPathOption = (0, _concat.default)(_context10 = "".concat(i18nPathOption, ".")).call(_context10, methodType);
        }
      } else if (o.value !== undefined) {
        var _context11;

        // value could be string or number or undefined.
        i18nPathOption = (0, _concat.default)(_context11 = "".concat(i18nPath, ".")).call(_context11, o.value);
      }

      _Logger.default.info('\t 4: ', i18nPathOption);

      o.label = getI18NValue(i18nPathOption, o.label);
    });
  }

  if ((0, _isArray.default)(uiSchema.optionsUiSchemas)) {
    var _context12;

    (0, _forEach.default)(_context12 = uiSchema.optionsUiSchemas).call(_context12, function (optionsUiSchema) {
      (0, _forEach.default)(optionsUiSchema).call(optionsUiSchema, function (uiSchema) {
        return updateLabelForUiSchema(remediation, uiSchema);
      });
    });
  }
};

var isWebAuthnAPIError = function isWebAuthnAPIError(i18nKey) {
  return (0, _startsWith.default)(i18nKey).call(i18nKey, WEBAUTHN_API_GENERIC_ERROR_KEY);
};
/**
 * @typedef {Object} Message
 * @property {string} message
 * @property {Object=} i18n
 * @property {string} i18n.key
 * @property {string[]} i18n.params
 */

/**
 * - If `message.i18n.key` exists and has a value in 'login.properties'
 *   through the given key or via I18N_OVERRIDE_MAPPINGS, return the value.
 *
 * - returns `message.message` otherwise
 *
 * @param {Message} message
 */


var getMessage = function getMessage(message) {
  var _message$i18n;

  if ((_message$i18n = message.i18n) === null || _message$i18n === void 0 ? void 0 : _message$i18n.key) {
    var _message$i18n2;

    var i18nKey = message.i18n.key;
    var i18nParams = message.i18n.params || []; // TODO - remove this block once API fix is done - OKTA-398080
    // Sometimes API sends params: [""] an array with empty string.
    // example - error-authenticator-enroll-password-common mock

    if (i18nParams.length === 1 && i18nParams[0] === '') {
      i18nParams = [];
    }

    if (I18N_OVERRIDE_MAPPINGS[(_message$i18n2 = message.i18n) === null || _message$i18n2 === void 0 ? void 0 : _message$i18n2.key]) {
      var _message$i18n3;

      i18nKey = I18N_OVERRIDE_MAPPINGS[(_message$i18n3 = message.i18n) === null || _message$i18n3 === void 0 ? void 0 : _message$i18n3.key];
    } else if (I18N_OVERRIDE_WITH_PARAMS_MAP[i18nKey]) {
      var _message$i18n$params;

      var param = (_message$i18n$params = message.i18n.params) === null || _message$i18n$params === void 0 ? void 0 : _message$i18n$params[0];
      i18nKey = getI8nKeyUsingParams(i18nKey, param);
      i18nParams = (0, _endsWith.default)(i18nKey).call(i18nKey, 'custom') ? [param] : [];
    }

    if (_Bundles.default.login[i18nKey]) {
      _Logger.default.info("Override messages using i18n key ".concat(i18nKey)); // expect user config i18n properly.
      // e.g. the i18n value shall have placeholders like `{0}`, when params is not empty.


      return (0, _okta.loc)(i18nKey, 'login', i18nParams);
    }

    if (isWebAuthnAPIError(i18nKey)) {
      // The WebAuthn api error doesn't make much sense to a typical end user, but useful for developer.
      // So keep the api message in response, but show a generic error message on UI.
      return (0, _okta.loc)(WEBAUTHN_API_GENERIC_ERROR_KEY, 'login');
    }
  }

  _Logger.default.warn("Avoid rendering unlocalized text sent from the API: ".concat(message.message));

  return message.message;
};
/**
 * @param {Object} error
 */


exports.getMessage = getMessage;

var getMessageFromBrowserError = function getMessageFromBrowserError(error) {
  if (error.name) {
    var key = "oie.browser.error.".concat(error.name);

    if (_Bundles.default.login[key]) {
      _Logger.default.info("Override messages using i18n key ".concat(key)); // expect user config i18n properly.


      return (0, _okta.loc)(key, 'login');
    }
  }

  return error.message;
};
/**
 * - iff `message.i18n.key` exists return the key.
 *
 * @param {Message} message
 */


exports.getMessageFromBrowserError = getMessageFromBrowserError;

var getMessageKey = function getMessageKey(message) {
  var _message$i18n4;

  return (message === null || message === void 0 ? void 0 : (_message$i18n4 = message.i18n) === null || _message$i18n4 === void 0 ? void 0 : _message$i18n4.key) || '';
};

exports.getMessageKey = getMessageKey;

var uiSchemaLabelTransformer = function uiSchemaLabelTransformer(transformedResp) {
  var _transformedResp$mess;

  // Try to override label using i18n value
  if ((0, _isArray.default)(transformedResp.remediations)) {
    var _context13, _context14;

    (0, _forEach.default)(_context13 = (0, _filter.default)(_context14 = transformedResp.remediations).call(_context14, function (remediation) {
      return (0, _isArray.default)(remediation.uiSchema) && remediation.uiSchema.length;
    })).call(_context13, function (remediation) {
      var _context15;

      (0, _forEach.default)(_context15 = remediation.uiSchema).call(_context15, function (uiSchema) {
        return updateLabelForUiSchema(remediation, uiSchema);
      });
    });
  } // Try to override `messages` using i18n value.
  // 1. This is only handling top level `messages` object when response status is 200.
  // 2. See `IonResponseHelper.js` where handle `messages` object when none 200 response.
  // 3. Handling `messages` in remediation forms on 200 response is not considered yet.
  //    Is that possible?


  if ((0, _isArray.default)((_transformedResp$mess = transformedResp.messages) === null || _transformedResp$mess === void 0 ? void 0 : _transformedResp$mess.value)) {
    var _context16;

    (0, _forEach.default)(_context16 = transformedResp.messages.value).call(_context16, function (message) {
      message.message = getMessage(message);
    });
  }

  return transformedResp;
};
/**
 * Has this i18n key been overridden for customization?
 * @param {String} i18nKey
 * @param {Object} settings
 * @returns Boolean
 */


exports.default = uiSchemaLabelTransformer;

var isCustomizedI18nKey = function isCustomizedI18nKey(i18nKey, settings) {
  var language = settings.get('languageCode');
  var i18n = settings.get('i18n');
  var customizedProperty = i18n && i18n[language] && i18n[language][i18nKey];
  return !!customizedProperty;
};

exports.isCustomizedI18nKey = isCustomizedI18nKey;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var userAgent = __webpack_require__(172);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(63);
var definePropertyModule = __webpack_require__(25);
var wellKnownSymbol = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(19);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(16);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(49);
var whitespaces = __webpack_require__(219);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(51);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = values;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(47);


// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(298);





// Internal implementation of a recursive `flatten` function.
function flatten(input, depth, strict, output) {
  output = output || [];
  if (!depth && depth !== 0) {
    depth = Infinity;
  } else if (depth <= 0) {
    return output.concat(input);
  }
  var idx = output.length;
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(input); i < length; i++) {
    var value = input[i];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(value) && (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(value))) {
      // Flatten current level of array or arguments object.
      if (depth > 1) {
        flatten(value, depth - 1, strict, output);
        idx = output.length;
      } else {
        var j = 0, len = value.length;
        while (j < len) output[idx++] = value[j++];
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(47);




// Return the results of applying the iteratee to each element.
function map(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length,
      results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(227);
var definePropertyModule = __webpack_require__(86);
var createPropertyDescriptor = __webpack_require__(129);

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1011);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1024);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _keys = _interopRequireDefault(__webpack_require__(324));

var _config = _interopRequireDefault(__webpack_require__(238));

var _crossFetch = _interopRequireDefault(__webpack_require__(504));

var _country = _interopRequireDefault(__webpack_require__(1097));

var _login = _interopRequireDefault(__webpack_require__(1098));

var _q = _interopRequireDefault(__webpack_require__(43));

var _underscore = _interopRequireDefault(__webpack_require__(229));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _Logger = _interopRequireDefault(__webpack_require__(79));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var STORAGE_KEY = 'osw.languages';
/**
 * Converts options to our internal format, which distinguishes between
 * login and country bundles.
 *
 * Example options.i18n passed in by the developer:
 * {
 *   'en': {
 *     'needhelp': 'need help override',
 *     'primaryauth.title': 'new sign in text',
 *     'country.JP' = 'Japan, Japan'
 *   }
 * }
 *
 * Parsed:
 * {
 *  'en': {
 *    'login': {
 *      'needhelp': 'need help override',
 *      'primaryauth.title': 'new sign in text',
 *    },
 *    'country': {
 *      'JP': 'Japan, Japan'
 *    }
 *  }
 * }
 */

function parseOverrides(i18n) {
  if (!i18n) {
    return {};
  }

  var i18nWithLowerCaseKeys = {};

  _underscore.default.each((0, _keys.default)(_underscore.default).call(_underscore.default, i18n), function (key) {
    i18nWithLowerCaseKeys[key.toLowerCase()] = i18n[key];
  });

  return _underscore.default.mapObject(i18nWithLowerCaseKeys, function (props) {
    var mapped = {
      login: {},
      country: {}
    };

    if (!_underscore.default.isObject(props)) {
      throw new Error('Invalid format for "i18n"');
    }

    _underscore.default.each(props, function (val, key) {
      var split = key.split(/^country\./);

      if (split.length > 1) {
        mapped.country[split[1]] = val;
      } else {
        mapped.login[split[0]] = val;
      }
    });

    return mapped;
  });
} // Caching: We only bundle English by default in the Sign-In Widget. Other
// languages are loaded on demand and cached in localStorage. These languages
// are tied to the version of the widget - when it bumps, we reset the cache.


function getCachedLanguages() {
  var storage = JSON.parse(localStorage.getItem(STORAGE_KEY));

  if (!storage || storage.version !== _config.default.version) {
    storage = {
      version: _config.default.version
    };
  }

  return storage;
}

function addLanguageToCache(language, loginJson, countryJson) {
  var current = getCachedLanguages();
  current[language] = {
    login: loginJson,
    country: countryJson
  };
  localStorage.setItem(STORAGE_KEY, (0, _stringify.default)(current));
} // By default, the assets.bundleUrl is tied to the Okta CDN.
//
// There are two overrides available for modifying where we load the asset
// bundles from:
//
// 1. assets.baseUrl
//
//    This is the base path the OSW pulls assets from, which in this case is
//    the Okta CDN. Override this config option if you want to host the
//    files on your own domain, or if you're using a new version of the
//    widget whose language files haven't been published to the CDN yet.
//
// 2. assets.rewrite
//
//    This is a function that can be used to modify the path + fileName of
//    the bundle we're loading, relative to the baseUrl. When called, it
//    will pass the current path, and expect the new path to be returned.
//    This is useful, for example, if your build process has an extra
//    cachebusting step, i.e:
//
//    function rewrite(file) {
//      // file: /labels/json/login_ja.json
//      return file.replace('.json', '.' + md5file(file) + '.json');
//    }
//
// Note: Most developers will not need to use these overrides - the default
// is to use the Okta CDN and to use the same path + file structure the
// widget module publishes by default.


function fetchJson(bundle, language, assets) {
  var _context;

  var languageCode;
  var path; // Our bundles use _ to separate country and region, i.e:
  // zh-CN -> zh_CN

  languageCode = language.replace('-', '_');
  path = assets.rewrite(encodeURI((0, _concat.default)(_context = "/labels/json/".concat(bundle, "_")).call(_context, languageCode, ".json")));
  var headers = {
    Accept: 'application/json',
    'Content-Type': 'text/plain'
  };
  var mode = 'no-cors';
  return (0, _crossFetch.default)(assets.baseUrl + path, {
    method: 'GET',
    headers: headers,
    mode: mode
  }).then(function (res) {
    return res.text();
  }).then(function (txt) {
    return JSON.parse(txt);
  });
}

function getBundles(language, assets) {
  // Two special cases:
  // 1. English is already bundled with the widget
  // 2. If the language is not in our config file, it means that they've
  //    probably defined it on their own.
  if (language === 'en' || !_underscore.default.contains(_config.default.supportedLanguages, language)) {
    return (0, _q.default)({});
  } //local storage does not work correctly with android web views (embeded browers)
  //so skip the caching and just make the request to get the local info


  var localStorageIsSupported = !_BrowserFeatures.default.localStorageIsNotSupported();

  if (localStorageIsSupported) {
    var cached = getCachedLanguages();

    if (cached[language]) {
      return (0, _q.default)(cached[language]);
    }
  }

  return _q.default.all([fetchJson('login', language, assets), fetchJson('country', language, assets)]).spread(function (loginJson, countryJson) {
    if (localStorageIsSupported) {
      addLanguageToCache(language, loginJson, countryJson);
    }

    return {
      login: loginJson,
      country: countryJson
    };
  }).catch(function () {
    // If there is an error, this will default to the bundled language and
    // we will no longer try to load the language this session.
    _Logger.default.warn('Unable to load language: ' + language);

    return {};
  });
}

var _default = {
  login: _login.default,
  country: _country.default,
  // Courage components within the sign in widget point to courage bundle to look
  // up i18nkeys. Since we dont have courage.properties inside the sign in widget
  // we are pointing courage bundle to login.
  courage: _login.default,
  currentLanguage: null,
  isLoaded: function isLoaded(language) {
    return this.currentLanguage === language;
  },
  remove: function remove() {
    this.currentLanguage = null;
  },
  loadLanguage: function loadLanguage(language, overrides, assets) {
    var _this = this;

    var parsedOverrides = parseOverrides(overrides);
    var lowerCaseLanguage = language.toLowerCase();
    return getBundles(language, assets).then(function (bundles) {
      // Always extend from the built in defaults in the event that some
      // properties are not translated
      _this.login = _underscore.default.extend({}, _login.default, bundles.login);
      _this.country = _underscore.default.extend({}, _country.default, bundles.country);
      _this.courage = _underscore.default.extend({}, _login.default, bundles.login);

      if (parsedOverrides[lowerCaseLanguage]) {
        _underscore.default.extend(_this.login, parsedOverrides[lowerCaseLanguage]['login']);

        _underscore.default.extend(_this.country, parsedOverrides[lowerCaseLanguage]['country']);

        _underscore.default.extend(_this.courage, parsedOverrides[lowerCaseLanguage]['login']);
      }

      _this.currentLanguage = language;
    });
  }
};
exports.default = _default;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function getForm(controller) {
  return (0, _find.default)(_okta._).call(_okta._, controller.getChildren(), function (item) {
    return item instanceof _okta.Form;
  });
}

var _default = _okta.Controller.extend({
  // Ideally we should be attaching the listeners in the constructor, but because of the way
  // we construct the FormController (this.model is generated after the BaseLoginController's
  // constructor is called), this.model is undefined in when try to attach the events and
  // therefore we don't listen to events for such forms. And changing the order in which we call
  // the constructor doesn't help either (JS errors etc.). This at least guarantees that we
  // are listening to the model events.
  // Note - Figure out a way to call the constructor in the right order.
  addListeners: function addListeners() {
    // Events to enable/disable the primary button on the forms
    this.listenTo(this.model, 'save', function () {
      var form = getForm(this); //disable the submit button on forms while making the request
      //to prevent users from hitting rate limiting exceptions of
      //1 per second on the auth api

      var disableSubmitButton = form.disableSubmitButton;

      if (disableSubmitButton && !form.disableSubmitButton()) {
        return;
      }

      this.toggleButtonState(true);
    });
    this.listenTo(this.model, 'error', function () {
      this.toggleButtonState(false);
    });
    this.addModelListeners(this.model);
  },
  addModelListeners: function addModelListeners(model) {
    var _this = this;

    var setTransactionHandler = function setTransactionHandler(transaction) {
      _this.options.appState.set('transaction', transaction);
    };

    var transactionErrorHandler = function transactionErrorHandler(err) {
      _this.options.appState.set('transactionError', err);
    }; // Events to set the transaction attributes on the app state.


    this.listenTo(model, 'setTransaction', setTransactionHandler);
    this.listenTo(model, 'setTransactionError', transactionErrorHandler); // For TOTP factor model
    // TOTP model is special, its model will not be attached to a controller, but will
    // tag along with the push factor model. We need to listen to the transaction
    // changes on this as well (in case of the push+totp form).

    var totpModel = model.get('backupFactor');

    if (totpModel) {
      this.listenTo(totpModel, 'setTransaction', setTransactionHandler);
      this.listenTo(totpModel, 'setTransactionError', transactionErrorHandler);
    }
  },
  // Override this method to delay switching to this screen until return
  // promise is resolved. This is useful for cases like enrolling a security
  // question, which requires an additional request to fetch the question
  // list.
  fetchInitialData: function fetchInitialData() {
    return (0, _q.default)();
  },
  // Override this method to prevent route navigation. This is useful for
  // intermediate status changes that do not trigger a full refresh of the
  // page, like MFA_ENROLL_ACTIVATE and MFA_CHALLENGE.
  trapAuthResponse: function trapAuthResponse() {
    return false;
  },
  toJSON: function toJSON() {
    var data = _okta.Controller.prototype.toJSON.apply(this, arguments);

    return _okta._.extend(_okta._.pick(this.options, 'appState'), data);
  },
  toggleButtonState: function toggleButtonState(state) {
    var _context;

    var button = (0, _find.default)(_context = this.$el).call(_context, '.button');
    button.toggleClass('link-button-disabled', state).prop('disabled', state);
  },
  postRenderAnimation: function postRenderAnimation() {
    // Event triggered after a page is rendered along with the classname to identify the page
    // TODO: Deprecate this event in the next major version in favor of 'afterRender'
    this.trigger('pageRendered', {
      page: this.className
    });
    this.trigger('afterRender', {
      controller: this.className
    });
  }
});

exports.default = _default;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(2);

var _Bundles = _interopRequireDefault(__webpack_require__(155));

var _countryCallingCodes = _interopRequireDefault(__webpack_require__(1139));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var fn = {}; // () => [{ countryCode: countryName }], sorted by countryName

fn.getCountries = function () {
  var countries = _okta._.omit(_Bundles.default.country, 'HM', 'BV', 'TF'); // HM, BV, and TF do not have phone prefixes, so don't give the
  // user the option to choose these countries. FYI it appears that these
  // countries do not have calling codes because they are ~~uninhabited~~


  var collection = (0, _map.default)(_okta._).call(_okta._, countries, function (name, code) {
    return {
      name: name,
      code: code
    };
  }); // Sort it; figure out if there is a better way to do this (best would
  // be to sort it in the properties file!!)

  collection = _okta._.sortBy(collection, 'name');
  var sorted = {};

  _okta._.each(collection, function (country) {
    sorted[country.code] = country.name;
  });

  return sorted;
};

fn.getCallingCodeForCountry = function (countryCode) {
  return _countryCallingCodes.default[countryCode];
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _freeze = _interopRequireDefault(__webpack_require__(1162));

var _map = _interopRequireDefault(__webpack_require__(40));

var _q = _interopRequireDefault(__webpack_require__(43));

var _FidoUtil = _interopRequireDefault(__webpack_require__(328));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function adaptToOkta(promise) {
  return new _q.default(promise);
}

function makeCredential(accountInfo, cryptoParams, challenge) {
  cryptoParams = (0, _map.default)(cryptoParams).call(cryptoParams, function (param) {
    return {
      type: 'FIDO_2_0',
      algorithm: param.algorithm
    };
  });
  var promise = window.msCredentials.makeCredential(accountInfo, cryptoParams, challenge).then(function (cred) {
    return (0, _freeze.default)({
      credential: {
        id: cred.id
      },
      publicKey: JSON.parse(cred.publicKey),
      attestation: cred.attestation
    });
  });
  return adaptToOkta(promise);
}

function getAssertion(challenge, allowList) {
  var accept = (0, _map.default)(allowList).call(allowList, function (item) {
    return {
      type: 'FIDO_2_0',
      id: item.id
    };
  });
  var filters = {
    accept: accept
  };
  var promise = window.msCredentials.getAssertion(challenge, filters).then(function (attestation) {
    var signature = attestation.signature;
    return (0, _freeze.default)({
      credential: {
        id: attestation.id
      },
      clientData: signature.clientData,
      authenticatorData: signature.authnrData,
      signature: signature.signature
    });
  });
  return adaptToOkta(promise);
}

var _default = {
  makeCredential: makeCredential,
  getAssertion: getAssertion,
  isAvailable: function isAvailable() {
    return Object.prototype.hasOwnProperty.call(window, 'msCredentials');
  },
  isNewApiAvailable: function isNewApiAvailable() {
    return navigator && navigator.credentials && navigator.credentials.create;
  },
  isWebauthnOrU2fAvailable: function isWebauthnOrU2fAvailable() {
    return this.isNewApiAvailable() || _FidoUtil.default.isU2fAvailable();
  }
};
exports.default = _default;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _FooterSignout = _interopRequireDefault(__webpack_require__(246));

var _default = _FooterSignout.default.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "factorPageCustomLinkHref") || (depth0 != null ? lookupProperty(depth0, "factorPageCustomLinkHref") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorPageCustomLinkHref",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 68
          }
        }
      }) : helper)) + "\" data-se=\"factor-page-custom-link\" class=\"link js-factor-page-custom-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias4((helper = (helper = lookupProperty(helpers, "factorPageCustomLinkText") || (depth0 != null ? lookupProperty(depth0, "factorPageCustomLinkText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorPageCustomLinkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 186
          },
          "end": {
            "line": 1,
            "column": 214
          }
        }
      }) : helper)) + "</a>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "linkClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 265
          },
          "end": {
            "line": 1,
            "column": 282
          }
        }
      }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "linkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 307
          },
          "end": {
            "line": 1,
            "column": 319
          }
        }
      }) : helper)) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasFactorPageCustomLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 225
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 225
          },
          "end": {
            "line": 1,
            "column": 330
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  getTemplateData: function getTemplateData() {
    var signoutTemplateData = _FooterSignout.default.prototype.getTemplateData.apply(this, arguments);

    var factorPageCustomLinkHref = this.settings.get('helpLinks.factorPage.href');
    var factorPageCustomLinkText = this.settings.get('helpLinks.factorPage.text');
    var showLink = !this.settings.get('features.hideSignOutLinkInMFA') && !this.settings.get('features.mfaOnlyFlow');
    return (0, _assign.default)({}, signoutTemplateData, {
      hasFactorPageCustomLink: factorPageCustomLinkText && factorPageCustomLinkHref,
      factorPageCustomLinkHref: factorPageCustomLinkHref,
      factorPageCustomLinkText: factorPageCustomLinkText,
      showLink: showLink
    });
  }
});

exports.default = _default;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1236);

var iterableToArray = __webpack_require__(1237);

var unsupportedIterableToArray = __webpack_require__(520);

var nonIterableSpread = __webpack_require__(1238);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1241);


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(92);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(565);

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(250);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var _Promise = __webpack_require__(1277);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    _Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new _Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);
var classof = __webpack_require__(101);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);

module.exports = global;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(62);
var toLength = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(109);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(63);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(362);
var enumBugKeys = __webpack_require__(265);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var isArray = __webpack_require__(125);
var wellKnownSymbol = __webpack_require__(20);

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(177);
var Iterators = __webpack_require__(175);
var wellKnownSymbol = __webpack_require__(20);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(271);
var classofRaw = __webpack_require__(101);
var wellKnownSymbol = __webpack_require__(20);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);
var wellKnownSymbol = __webpack_require__(20);
var V8_VERSION = __webpack_require__(143);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var classof = __webpack_require__(101);
var wellKnownSymbol = __webpack_require__(20);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(404);
var enumBugKeys = __webpack_require__(293);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasStringTagBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIE11; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__ = __webpack_require__(871);



// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug = (
      __WEBPACK_IMPORTED_MODULE_0__setup_js__["s" /* supportsDataView */] && Object(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new DataView(new ArrayBuffer(8)))
    ),
    isIE11 = (typeof Map !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new Map));


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__ = __webpack_require__(415);




// Retrieve all the enumerable property names of an object.
function allKeys(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  var keys = [];
  for (var key in obj) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) Object(__WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(424);



// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path) {
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath(path);
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optimizeCb;
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func, context, argCount) {
  if (context === void 0) return func;
  switch (argCount == null ? 3 : argCount) {
    case 1: return function(value) {
      return func.call(context, value);
    };
    // The 2-argument case is omitted because we’re not using it.
    case 3: return function(value, index, collection) {
      return func.call(context, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(context, accumulator, value, index, collection);
    };
  }
  return function() {
    return func.apply(context, arguments);
  };
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(134);



// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indexOf_js__ = __webpack_require__(440);




// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return Object(__WEBPACK_IMPORTED_MODULE_2__indexOf_js__["a" /* default */])(obj, item, fromIndex) >= 0;
}


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(83);
var addToUnscopables = __webpack_require__(181);
var Iterators = __webpack_require__(137);
var InternalStateModule = __webpack_require__(95);
var defineIterator = __webpack_require__(462);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var defineProperties = __webpack_require__(310);
var enumBugKeys = __webpack_require__(293);
var hiddenKeys = __webpack_require__(183);
var html = __webpack_require__(466);
var documentCreateElement = __webpack_require__(286);
var sharedKey = __webpack_require__(233);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(118);
var Iterators = __webpack_require__(137);
var wellKnownSymbol = __webpack_require__(34);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);
var wellKnownSymbol = __webpack_require__(34);
var V8_VERSION = __webpack_require__(316);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1040);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(506);

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(84);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var KNOWN_ERRORS = ['OAuthError', 'AuthSdkError', 'AuthPollStopError', 'AuthApiError'];

var _default = _okta.Model.extend({
  // May return either a "standard" promise or a Q promise
  doTransaction: function doTransaction(fn, rethrow) {
    var self = this;
    return fn.call(this, this.appState.get('transaction')).then(function (trans) {
      self.trigger('setTransaction', trans);
      return trans;
    }).catch(function (err) {
      // Q may still consider AuthPollStopError to be unhandled
      if (err.name === 'AuthPollStopError' || err.name === _Enums.default.AUTH_STOP_POLL_INITIATION_ERROR || err.name === _Enums.default.WEBAUTHN_ABORT_ERROR) {
        return;
      }

      self.trigger('error', self, err.xhr);
      self.trigger('setTransactionError', err);

      if (rethrow || (0, _indexOf.default)(_okta._).call(_okta._, KNOWN_ERRORS, err.name) === -1) {
        throw err;
      }
    });
  },
  manageTransaction: function manageTransaction(fn) {
    var self = this;
    var res = fn.call(this, this.appState.get('transaction'), (0, _bind.default)(_okta._).call(_okta._, this.setTransaction, this)); // If it's a promise, listen for failures

    if (_q.default.isPromiseAlike(res)) {
      return res.catch(function (err) {
        if (err.name === 'AuthPollStopError' || err.name === _Enums.default.AUTH_STOP_POLL_INITIATION_ERROR || err.name === _Enums.default.WEBAUTHN_ABORT_ERROR) {
          return;
        }

        self.trigger('error', self, err.xhr);
        self.trigger('setTransactionError', err);
      });
    }

    return _q.default.resolve(res);
  },
  startTransaction: function startTransaction(fn) {
    var self = this;
    var res = fn.call(this, this.settings.getAuthClient()); // If it's a promise, then chain to it

    if (_q.default.isPromiseAlike(res)) {
      return res.then(function (trans) {
        self.trigger('setTransaction', trans);
        return trans;
      }).catch(function (err) {
        self.trigger('error', self, err.xhr);
        self.trigger('setTransactionError', err);
        throw err;
      });
    }

    return _q.default.resolve(res);
  },
  setTransaction: function setTransaction(trans) {
    this.appState.set('transaction', trans);
  }
});

exports.default = _default;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var fn = {}; // Validate the 'username' field on the model.

fn.validateUsername = function (model) {
  var username = model.get('username');

  if (username && username.length > 256) {
    return {
      username: (0, _okta.loc)('model.validation.field.username', 'login')
    };
  }
}; // Validate that the field1 and field2 fields on the model are a match.


fn.validateFieldsMatch = function (model, field1, field2, message) {
  if (model.get(field1) !== model.get(field2)) {
    var ret = {};
    ret[field2] = message;
    return ret;
  }
}; // Validate that the 'newPassword' and 'confirmPassword' fields on the model are a match.


fn.validatePasswordMatch = function (model) {
  return fn.validateFieldsMatch(model, 'newPassword', 'confirmPassword', (0, _okta.loc)('password.error.match', 'login'));
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(506);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(162);
var definePropertyModule = __webpack_require__(251);
var createPropertyDescriptor = __webpack_require__(562);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(486);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(162);
var defineProperty = __webpack_require__(251).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAuthenticatorDataForEnroll = getAuthenticatorDataForEnroll;
exports.getAuthenticatorDataForVerification = getAuthenticatorDataForVerification;
exports.getIconClassNameForBeacon = getIconClassNameForBeacon;
exports.removeRequirementsFromError = removeRequirementsFromError;
exports.getAuthenticatorDisplayName = getAuthenticatorDisplayName;
exports.getPasswordComplexityDescriptionForHtmlList = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _RemediationConstants = __webpack_require__(24);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var getPasswordComplexityDescriptionForHtmlList = _FactorUtil.default.getPasswordComplexityDescriptionForHtmlList;
exports.getPasswordComplexityDescriptionForHtmlList = getPasswordComplexityDescriptionForHtmlList;

var getButtonDataSeAttr = function getButtonDataSeAttr(authenticator) {
  if (authenticator.authenticatorKey) {
    var _authenticator$value, _authenticator$value2;

    var method = ((_authenticator$value = authenticator.value) === null || _authenticator$value === void 0 ? void 0 : _authenticator$value.methodType) ? '-' + ((_authenticator$value2 = authenticator.value) === null || _authenticator$value2 === void 0 ? void 0 : _authenticator$value2.methodType) : '';
    return authenticator.authenticatorKey + method;
  }

  return '';
};
/* eslint complexity: [0, 0] */


var getAuthenticatorData = function getAuthenticatorData(authenticator, isVerifyAuthenticator) {
  var _authenticator$relate, _authenticator$relate2;

  var authenticatorKey = authenticator.authenticatorKey;
  var key = _okta._.isString(authenticatorKey) ? authenticatorKey.toLowerCase() : '';
  var authenticatorData = {};

  switch (key) {
    case _RemediationConstants.AUTHENTICATOR_KEY.EMAIL:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.email.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-email',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.password.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-password',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.PHONE:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? (_authenticator$relate = authenticator.relatesTo) === null || _authenticator$relate === void 0 ? void 0 : (_authenticator$relate2 = _authenticator$relate.profile) === null || _authenticator$relate2 === void 0 ? void 0 : _authenticator$relate2.phoneNumber : (0, _okta.loc)('oie.phone.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-phone',
        noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.security.question.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-security-question',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.webauthn.description', 'login'),
        iconClassName: 'mfa-webauthn',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.OV:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.okta_verify.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-verify',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.google_authenticator.authenticator.description', 'login'),
        iconClassName: 'mfa-google-auth',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM:
      {
        var _authenticator$relate3;

        var vendorName = ((_authenticator$relate3 = authenticator.relatesTo) === null || _authenticator$relate3 === void 0 ? void 0 : _authenticator$relate3.displayName) || (0, _okta.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
        (0, _assign.default)(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.on_prem.authenticator.description', 'login', [vendorName]),
          iconClassName: 'mfa-onprem',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator)
        });
        break;
      }

    case _RemediationConstants.AUTHENTICATOR_KEY.RSA:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.rsa.authenticator.description', 'login'),
        iconClassName: 'mfa-rsa',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.DUO:
      (0, _assign.default)(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.duo.authenticator.description', 'login'),
        iconClassName: 'mfa-duo',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator)
      });
      break;

    case _RemediationConstants.AUTHENTICATOR_KEY.IDP:
      {
        var _authenticator$relate4;

        var idpName = (_authenticator$relate4 = authenticator.relatesTo) === null || _authenticator$relate4 === void 0 ? void 0 : _authenticator$relate4.displayName;
        (0, _assign.default)(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.idp.authenticator.description', 'login', [idpName]),
          iconClassName: 'mfa-custom-factor',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator)
        });
        break;
      }

    case _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_OTP:
      {
        (0, _assign.default)(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.custom_otp.description', 'login'),
          iconClassName: 'mfa-hotp',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator)
        });
        break;
      }

    case _RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP:
      {
        var _authenticator$relate5;

        var appName = (_authenticator$relate5 = authenticator.relatesTo) === null || _authenticator$relate5 === void 0 ? void 0 : _authenticator$relate5.displayName;
        (0, _assign.default)(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.symantecVip.authenticator.description', 'login', [appName]),
          iconClassName: 'mfa-symantec',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator)
        });
        break;
      }

    case _RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY:
      {
        (0, _assign.default)(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _okta.loc)('oie.yubikey.authenticator.description', 'login'),
          iconClassName: 'mfa-yubikey',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator)
        });
        break;
      }

    case _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP:
      {
        (0, _assign.default)(authenticatorData, {
          description: '',
          iconClassName: 'mfa-custom-app',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator)
        });
        break;
      }
  }

  return authenticatorData;
};

function getAuthenticatorDataForEnroll(authenticator) {
  return getAuthenticatorData(authenticator);
}

function getAuthenticatorDataForVerification(authenticator) {
  return getAuthenticatorData(authenticator, true);
}

function getIconClassNameForBeacon(authenticatorKey) {
  return getAuthenticatorData({
    authenticatorKey: authenticatorKey
  }).iconClassName;
}

function removeRequirementsFromError(errorJSON) {
  var _errorJSON$errorCause;

  if (((_errorJSON$errorCause = errorJSON.errorCauses) === null || _errorJSON$errorCause === void 0 ? void 0 : _errorJSON$errorCause.length) > 0 && (0, _isArray.default)(errorJSON.errorCauses[0].errorSummary) && errorJSON.errorCauses[0].errorSummary.length > 0) {
    var _errorJSON$errorCause2;

    // Change from Array to string for all errors.
    errorJSON.errorCauses[0].errorSummary = errorJSON.errorCauses[0].errorSummary[0]; // Overrides for particular error messages.

    var errorKey = ((_errorJSON$errorCause2 = errorJSON.errorCauses[0].errorKey) === null || _errorJSON$errorCause2 === void 0 ? void 0 : _errorJSON$errorCause2.length) > 0 && errorJSON.errorCauses[0].errorKey[0]; // Remove the requirements string only if this is requirements were not met error.

    if (errorKey === 'password.passwordRequirementsNotMet') {
      errorJSON.errorCauses[0].errorSummary = (0, _okta.loc)('registration.error.password.passwordRequirementsNotMet', 'login');
    }
  }

  return errorJSON;
}
/**
 * Get authenticator display name from {@code remediation}.
 *
 * @param {Object} remediation
 */


function getAuthenticatorDisplayName(remediation) {
  var _remediation$relatesT, _remediation$relatesT2;

  return (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.displayName;
} // Re-export function from FactorUtil

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Link = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 9
          }
        }
      }) : helper));
    },
    "useData": true
  }),
  tagName: 'a',
  attributes: function attributes() {
    var href = this.options.href || '#';
    return {
      'data-se': this.options.name,
      href: href
    };
  },
  className: function className() {
    var names = ['link'];

    if (this.options.name) {
      var nameToClass = this.options.name.replace(/[ ]/g, '-');
      names.push("js-".concat(nameToClass));
    }

    return names.join(' ');
  },
  postRender: function postRender() {
    var _this = this;

    // TODO OKTA-245224: create sub class of Link to dispatch following if/else logic.
    if (!this.options.href) {
      this.$el.click(function (event) {
        event.preventDefault();
        var _this$options = _this.options,
            appState = _this$options.appState,
            formName = _this$options.formName,
            actionPath = _this$options.actionPath,
            clickHandler = _this$options.clickHandler;

        if (clickHandler) {
          clickHandler();
        } else if (formName) {
          appState.trigger('switchForm', formName);
        } else if (actionPath) {
          appState.trigger('invokeAction', actionPath);
        }
      });
    }
  }
});

module.exports = Link;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _find = _interopRequireDefault(__webpack_require__(13));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _map = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(2);

var _FormInputFactory = _interopRequireDefault(__webpack_require__(598));

var FormUtil = _okta.internal.views.forms.helpers.FormUtil;

var _default = _okta.Form.extend({
  layout: 'o-form-theme',
  className: 'ion-form',
  hasSavingState: true,
  autoSave: false,
  noCancelButton: true,
  title: function title() {
    return (0, _okta.loc)('oform.title.authenticate', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oform.next', 'login');
  },
  modelEvents: {
    'clearFormError': 'handleClearFormError',
    'error': 'triggerAfterError'
  },
  initialize: function initialize() {
    var _this = this;

    var uiSchemas = this.getUISchema();
    var inputOptions = (0, _map.default)(uiSchemas).call(uiSchemas, _FormInputFactory.default.create); //should be used before adding any other input components

    this.showMessages(); // Render CAPTCHA if one of the form fields requires us to.

    this.listenTo(this.options.appState, 'onCaptchaLoaded', function (captchaObject) {
      _this.captchaObject = captchaObject;
    });
    (0, _forEach.default)(inputOptions).call(inputOptions, function (input) {
      _this.addInputOrView(input);
    });
    this.listenTo(this, 'save', this.saveForm);
    this.listenTo(this, 'cancel', this.cancelForm);
  },
  handleClearFormError: function handleClearFormError() {
    if (this.$('.o-form-error-container').hasClass('o-form-has-errors')) {
      this.clearErrors();
    }
  },
  triggerAfterError: function triggerAfterError(model, error) {
    this.options.appState.trigger('afterError', error);
  },
  saveForm: function saveForm(model) {
    var _context;

    //remove any existing warnings or messages before saving form
    (0, _find.default)(_context = this.$el).call(_context, '.o-form-error-container').empty(); // Execute Captcha if enabled for this form.

    if (this.captchaObject) {
      this.captchaObject.execute();
    } else {
      this.options.appState.trigger('saveForm', model);
    }
  },
  cancelForm: function cancelForm() {
    this.options.appState.trigger('invokeAction', 'cancel');
  },
  getUISchema: function getUISchema() {
    if ((0, _isArray.default)(this.options.currentViewState.uiSchema)) {
      return this.options.currentViewState.uiSchema;
    } else {
      return [];
    }
  },
  addInputOrView: function addInputOrView(input) {
    if (input.visible === false || input.mutable === false) {
      return;
    }

    if (input.View) {
      this.add(input.View, _okta._.omit(input, 'View', 'showWhen'));

      if (input.showWhen) {
        FormUtil.applyShowWhen(this.last(), input.showWhen);
      }
    } else {
      this.addInput(input);
    }

    if ((0, _isArray.default)(input.optionsUiSchemas)) {
      if (this.options.optionUiSchemaConfig[input.name]) {
        var _context2;

        var optionUiSchemaIndex = Number(this.options.optionUiSchemaConfig[input.name]);
        var optionUiSchemas = input.optionsUiSchemas[optionUiSchemaIndex] || [];
        (0, _forEach.default)(optionUiSchemas).call(optionUiSchemas, (0, _bind.default)(_context2 = this.addInputOrView).call(_context2, this));
      }
    }
  },

  /*
   * Whether an form error message should be rendered as the default BaseForm error banner or not
   * if this function returns true, BaseForm won't render the error banner after form submit. Instead,
   * the form needs to override showCustomErrorCallout with the logic to render that error message
   */
  isErrorCalloutCustomized: function isErrorCalloutCustomized() {
    return false;
  },

  /*
   * Renders an error message (if any) after form is submitted
   * This should be overriden if isErrorCalloutCustomized() returns true
   */
  showCustomErrorCallout: function showCustomErrorCallout() {
    this.$('.o-form-error-container').addClass('o-form-has-errors');
  },

  /*
   * Renders the contents of messages object (if any) during initialize
   * This function is called during Form.initialize, and will display
   * messages when the form renders.
   * Note: any errors happening after the form is rendered won't use this function,
   * this is only used during initialize
   */
  showMessages: function showMessages() {
    // render messages as text
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs === null || messagesObjs === void 0 ? void 0 : messagesObjs.value.length) {
      var _context3;

      var content = (0, _map.default)(_context3 = messagesObjs.value).call(_context3, function (messagesObj) {
        return messagesObj.message;
      });
      this.add("<div class=\"ion-messages-container\">".concat(content.join(' '), "</div>"), '.o-form-error-container');
    }
  }
});

exports.default = _default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(263);
var uid = __webpack_require__(167);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(20);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(58);
var toObject = __webpack_require__(32);
var IndexedObject = __webpack_require__(166);
var toLength = __webpack_require__(22);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(62);
var addToUnscopables = __webpack_require__(113);
var Iterators = __webpack_require__(175);
var InternalStateModule = __webpack_require__(57);
var defineIterator = __webpack_require__(273);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(72);
var global = __webpack_require__(9);
var fails = __webpack_require__(6);

// Forced replacement object prototype accessors methods
module.exports = IS_PURE || !fails(function () {
  var key = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call -- required for testing
  __defineSetter__.call(null, key, function () { /* empty */ });
  delete global[key];
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var requireObjectCoercible = __webpack_require__(49);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(277);
var redefine = __webpack_require__(51);
var fails = __webpack_require__(6);
var wellKnownSymbol = __webpack_require__(20);
var regexpExec = __webpack_require__(215);
var createNonEnumerableProperty = __webpack_require__(50);

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__(145);
var stickyHelpers = __webpack_require__(216);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
// eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__(6);

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(213).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(101);
var regexpExec = __webpack_require__(215);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),
/* 219 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var setPrototypeOf = __webpack_require__(111);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

var nativeExpm1 = Math.expm1;
var exp = Math.exp;

// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
module.exports = (!nativeExpm1
  // Old FF bug
  || nativeExpm1(10) > 22025.465794806719 || nativeExpm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || nativeExpm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : exp(x) - 1;
} : nativeExpm1;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(58);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var isForced = __webpack_require__(171);
var redefine = __webpack_require__(51);
var InternalMetadataModule = __webpack_require__(127);
var iterate = __webpack_require__(112);
var anInstance = __webpack_require__(114);
var isObject = __webpack_require__(15);
var fails = __webpack_require__(6);
var checkCorrectnessOfIteration = __webpack_require__(209);
var setToStringTag = __webpack_require__(82);
var inheritIfRequired = __webpack_require__(220);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(19);
var NATIVE_ARRAY_BUFFER = __webpack_require__(284);
var createNonEnumerableProperty = __webpack_require__(50);
var redefineAll = __webpack_require__(147);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(114);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(22);
var toIndex = __webpack_require__(393);
var IEEE754 = __webpack_require__(789);
var getPrototypeOf = __webpack_require__(74);
var setPrototypeOf = __webpack_require__(111);
var getOwnPropertyNames = __webpack_require__(123).f;
var defineProperty = __webpack_require__(25).f;
var arrayFill = __webpack_require__(272);
var setToStringTag = __webpack_require__(82);
var InternalStateModule = __webpack_require__(57);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var $DataView = global[DATA_VIEW];
var $DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var RangeError = global.RangeError;

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = bytes.slice(start, start + count);
  return isLittleEndian ? pack : pack.reverse();
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: arrayFill.call(new Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.name != ARRAY_BUFFER;
  })) {
  /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new NativeArrayBuffer(toIndex(length));
    };
    var ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE] = NativeArrayBuffer[PROTOTYPE];
    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }
    ArrayBufferPrototype.constructor = $ArrayBuffer;
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf($DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf($DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var nativeSetInt8 = $DataViewPrototype.setInt8;
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll($DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      nativeSetInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      nativeSetInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);
var classof = __webpack_require__(130);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_default_js__ = __webpack_require__(865);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__index_default_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(295);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["VERSION"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["restArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNull"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isUndefined"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isBoolean"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isElement"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isString"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNumber"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isRegExp"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSymbol"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArrayBuffer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDataView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFunction"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFinite"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNaN"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isTypedArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEmpty"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMatch"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEqual"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["keys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["allKeys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["values"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pairs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invert"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["functions"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["methods"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extend"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extendOwn"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["assign"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defaults"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["create"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["clone"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["get"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["has"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mapObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["identity"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["constant"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["noop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toPath"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["property"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["propertyOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matcher"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matches"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["times"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["random"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["now"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["escape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unescape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["templateSettings"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["template"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["result"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniqueId"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chain"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["iteratee"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bind"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bindAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["memoize"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["delay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["throttle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["debounce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["wrap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["negate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["after"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["before"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findKey"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findLastIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortedIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["lastIndexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["find"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["detect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findWhere"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["each"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["forEach"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["map"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["collect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldl"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["inject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduceRight"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldr"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["filter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["select"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["every"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["all"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["some"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["any"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["contains"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["includes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["include"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invoke"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pluck"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["where"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["max"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["min"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["shuffle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sample"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["groupBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["countBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partition"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["size"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pick"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["omit"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["first"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["head"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["take"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["initial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["last"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["rest"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tail"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["drop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compact"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["flatten"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["without"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniq"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unique"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["union"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["intersection"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["difference"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unzip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["transpose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["zip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["object"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["range"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chunk"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mixin"]; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.




/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendOwn_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMatch_js__ = __webpack_require__(416);



// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = Object(__WEBPACK_IMPORTED_MODULE_0__extendOwn_js__["a" /* default */])({}, attrs);
  return function(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isMatch_js__["a" /* default */])(obj, attrs);
  };
}


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__executeBound_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(69);




// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, boundArgs) {
  var placeholder = partial.placeholder;
  var bound = function() {
    var position = 0, length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return Object(__WEBPACK_IMPORTED_MODULE_1__executeBound_js__["a" /* default */])(func, bound, this, this, args);
  };
  return bound;
});

partial.placeholder = __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (partial);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = group;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(134);



// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(290);
var uid = __webpack_require__(228);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(59);
var toObject = __webpack_require__(75);
var sharedKey = __webpack_require__(233);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(465);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);
var isArray = __webpack_require__(136);
var wellKnownSymbol = __webpack_require__(34);

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @okta/qtip2 v3.0.3-5-g | Plugins: tips modal viewport svg imagemap ie6 | Styles: core basic css3 | qtip2.com | Licensed MIT | Wed May 24 2017 01:22:57 */

!function(a,b,c){!function(a){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(325)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):jQuery&&!jQuery.fn.qtip&&a(jQuery)}(function(d){"use strict";function e(a,b,c,e){this.id=c,this.target=a,this.tooltip=F,this.elements={target:a},this._id=S+"-"+c,this.timers={img:{}},this.options=b,this.plugins={},this.cache={event:{},target:d(),disabled:E,attr:e,onTooltip:E,lastClass:""},this.rendered=this.destroyed=this.disabled=this.waiting=this.hiddenDuringWait=this.positioning=this.triggering=E}function f(a){return a===F||"object"!==d.type(a)}function g(a){return!(d.isFunction(a)||a&&a.attr||a.length||"object"===d.type(a)&&(a.jquery||a.then))}function h(a){var b,c,e,h;return f(a)?E:(f(a.metadata)&&(a.metadata={type:a.metadata}),"content"in a&&(b=a.content,f(b)||b.jquery||b.done?(c=g(b)?E:b,b=a.content={text:c}):c=b.text,"ajax"in b&&(e=b.ajax,h=e&&e.once!==E,delete b.ajax,b.text=function(a,b){var f=c||d(this).attr(b.options.content.attr)||"Loading...",g=d.ajax(d.extend({},e,{context:b})).then(e.success,F,e.error).then(function(a){return a&&h&&b.set("content.text",a),a},function(a,c,d){b.destroyed||0===a.status||b.set("content.text",c+": "+d)});return h?f:(b.set("content.text",f),g)}),"title"in b&&(d.isPlainObject(b.title)&&(b.button=b.title.button,b.title=b.title.text),g(b.title||E)&&(b.title=E))),"position"in a&&f(a.position)&&(a.position={my:a.position,at:a.position}),"show"in a&&f(a.show)&&(a.show=a.show.jquery?{target:a.show}:a.show===D?{ready:D}:{event:a.show}),"hide"in a&&f(a.hide)&&(a.hide=a.hide.jquery?{target:a.hide}:{event:a.hide}),"style"in a&&f(a.style)&&(a.style={classes:a.style}),d.each(R,function(){this.sanitize&&this.sanitize(a)}),a)}function i(a,b){for(var c,d=0,e=a,f=b.split(".");e=e[f[d++]];)d<f.length&&(c=e);return[c||a,f.pop()]}function j(a,b){var c,d,e;for(c in this.checks)if(this.checks.hasOwnProperty(c))for(d in this.checks[c])this.checks[c].hasOwnProperty(d)&&(e=new RegExp(d,"i").exec(a))&&(b.push(e),("builtin"===c||this.plugins[c])&&this.checks[c][d].apply(this.plugins[c]||this,b))}function k(a){return V.concat("").join(a?"-"+a+" ":" ")}function l(a,b){return b>0?setTimeout(d.proxy(a,this),b):void a.call(this)}function m(a){this.tooltip.hasClass(aa)||(clearTimeout(this.timers.show),clearTimeout(this.timers.hide),this.timers.show=l.call(this,function(){this.toggle(D,a)},this.options.show.delay))}function n(a){if(!this.tooltip.hasClass(aa)&&!this.destroyed){var b=d(a.relatedTarget),c=b.closest(W)[0]===this.tooltip[0],e=b[0]===this.options.show.target[0];if(clearTimeout(this.timers.show),clearTimeout(this.timers.hide),this!==b[0]&&"mouse"===this.options.position.target&&c||this.options.hide.fixed&&/mouse(out|leave|move)/.test(a.type)&&(c||e))try{a.preventDefault(),a.stopImmediatePropagation()}catch(f){}else this.timers.hide=l.call(this,function(){this.toggle(E,a)},this.options.hide.delay,this)}}function o(a){!this.tooltip.hasClass(aa)&&this.options.hide.inactive&&(clearTimeout(this.timers.inactive),this.timers.inactive=l.call(this,function(){this.hide(a)},this.options.hide.inactive))}function p(a){this.rendered&&this.tooltip[0].offsetWidth>0&&this.reposition(a)}function q(a,c,e){d(b.body).delegate(a,(c.split?c:c.join("."+S+" "))+"."+S,function(){var a=y.api[d.attr(this,U)];a&&!a.disabled&&e.apply(a,arguments)})}function r(a,c,f){var g,i,j,k,l,m=d(b.body),n=a[0]===b?m:a,o=a.metadata?a.metadata(f.metadata):F,p="html5"===f.metadata.type&&o?o[f.metadata.name]:F,q=a.data(f.metadata.name||"qtipopts");try{q="string"==typeof q?d.parseJSON(q):q}catch(r){}if(k=d.extend(D,{},y.defaults,f,"object"==typeof q?h(q):F,h(p||o)),i=k.position,k.id=c,"boolean"==typeof k.content.text){if(j=a.attr(k.content.attr),k.content.attr===E||!j)return E;k.content.text=j}if(i.container.length||(i.container=m),i.target===E&&(i.target=n),k.show.target===E&&(k.show.target=n),k.show.solo===D&&(k.show.solo=i.container.closest("body")),k.hide.target===E&&(k.hide.target=n),k.position.viewport===D&&(k.position.viewport=i.container),i.container=i.container.eq(0),i.at=new A(i.at,D),i.my=new A(i.my),a.data(S))if(k.overwrite)a.qtip("destroy",!0);else if(k.overwrite===E)return E;return a.attr(T,c),k.suppress&&(l=a.attr("title"))&&a.removeAttr("title").attr(ca,l).attr("title",""),g=new e(a,k,c,(!!j)),a.data(S,g),g}function s(a){return a.charAt(0).toUpperCase()+a.slice(1)}function t(a,b){var d,e,f=b.charAt(0).toUpperCase()+b.slice(1),g=(b+" "+va.join(f+" ")+f).split(" "),h=0;if(ua[b])return a.css(ua[b]);for(;d=g[h++];)if((e=a.css(d))!==c)return ua[b]=d,e}function u(a,b){return Math.ceil(parseFloat(t(a,b)))}function v(a,b){this._ns="tip",this.options=b,this.offset=b.offset,this.size=[b.width,b.height],this.qtip=a,this.init(a)}function w(a,b){this.options=b,this._ns="-modal",this.qtip=a,this.init(a)}function x(a){this._ns="ie6",this.qtip=a,this.init(a)}var y,z,A,B,C,D=!0,E=!1,F=null,G="x",H="y",I="width",J="height",K="top",L="left",M="bottom",N="right",O="center",P="flipinvert",Q="shift",R={},S="qtip",T="data-hasqtip",U="data-qtip-id",V=["ui-widget","ui-tooltip"],W="."+S,X="click dblclick mousedown mouseup mousemove mouseleave mouseenter".split(" "),Y=S+"-fixed",Z=S+"-default",$=S+"-focus",_=S+"-hover",aa=S+"-disabled",ba="_replacedByqTip",ca="oldtitle",da={ie:function(){var a,c;for(a=4,c=b.createElement("div");(c.innerHTML="<!--[if gt IE "+a+"]><i></i><![endif]-->")&&c.getElementsByTagName("i")[0];a+=1);return a>4?a:NaN}(),iOS:parseFloat((""+(/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent)||[0,""])[1]).replace("undefined","3_2").replace("_",".").replace("_",""))||E};z=e.prototype,z._when=function(a){return d.when.apply(d,a)},z.render=function(a){if(this.rendered||this.destroyed)return this;var b=this,c=this.options,e=this.cache,f=this.elements,g=c.content.text,h=c.content.title,i=c.content.button,j=c.position,k=[];return d.attr(this.target[0],"aria-describedby",this._id),e.posClass=this._createPosClass((this.position={my:j.my,at:j.at}).my),this.tooltip=f.tooltip=d("<div/>",{id:this._id,"class":[S,Z,c.style.classes,e.posClass].join(" "),width:c.style.width||"",height:c.style.height||"",tracking:"mouse"===j.target&&j.adjust.mouse,role:"alert","aria-live":"polite","aria-atomic":E,"aria-describedby":this._id+"-content","aria-hidden":D}).toggleClass(aa,this.disabled).attr(U,this.id).data(S,this).appendTo(j.container).append(f.content=d("<div />",{"class":S+"-content",id:this._id+"-content","aria-atomic":D})),this.rendered=-1,this.positioning=D,h&&(this._createTitle(),d.isFunction(h)||k.push(this._updateTitle(h,E))),i&&this._createButton(),d.isFunction(g)||k.push(this._updateContent(g,E)),this.rendered=D,this._setWidget(),d.each(R,function(a){var c;"render"===this.initialize&&(c=this(b))&&(b.plugins[a]=c)}),this._unassignEvents(),this._assignEvents(),this._when(k).then(function(){b._trigger("render"),b.positioning=E,b.hiddenDuringWait||!c.show.ready&&!a||b.toggle(D,e.event,E),b.hiddenDuringWait=E}),y.api[this.id]=this,this},z.destroy=function(a){function b(){if(!this.destroyed){this.destroyed=D;var a,b=this.target,c=b.attr(ca);this.rendered&&this.tooltip.stop(1,0).find("*").remove().end().remove(),d.each(this.plugins,function(){this.destroy&&this.destroy()});for(a in this.timers)this.timers.hasOwnProperty(a)&&clearTimeout(this.timers[a]);b.removeData(S).removeAttr(U).removeAttr(T).removeAttr("aria-describedby"),this.options.suppress&&c&&b.attr("title",c).removeAttr(ca),this._unassignEvents(),this.options=this.elements=this.cache=this.timers=this.plugins=this.mouse=F,delete y.api[this.id]}}return this.destroyed?this.target:(a===D&&"hide"!==this.triggering||!this.rendered?b.call(this):(this.tooltip.one("tooltiphidden",d.proxy(b,this)),!this.triggering&&this.hide()),this.target)},B=z.checks={builtin:{"^id$":function(a,b,c,e){var f=c===D?y.nextid:c,g=S+"-"+f;f!==E&&f.length>0&&!d("#"+g).length?(this._id=g,this.rendered&&(this.tooltip[0].id=this._id,this.elements.content[0].id=this._id+"-content",this.elements.title[0].id=this._id+"-title")):a[b]=e},"^prerender":function(a,b,c){c&&!this.rendered&&this.render(this.options.show.ready)},"^content.text$":function(a,b,c){this._updateContent(c)},"^content.attr$":function(a,b,c,d){this.options.content.text===this.target.attr(d)&&this._updateContent(this.target.attr(c))},"^content.title$":function(a,b,c){return c?(c&&!this.elements.title&&this._createTitle(),void this._updateTitle(c)):this._removeTitle()},"^content.button$":function(a,b,c){this._updateButton(c)},"^content.title.(text|button)$":function(a,b,c){this.set("content."+b,c)},"^position.(my|at)$":function(a,b,c){"string"==typeof c&&(this.position[b]=a[b]=new A(c,"at"===b))},"^position.container$":function(a,b,c){this.rendered&&this.tooltip.appendTo(c)},"^show.ready$":function(a,b,c){c&&(!this.rendered&&this.render(D)||this.toggle(D))},"^style.classes$":function(a,b,c,d){this.rendered&&this.tooltip.removeClass(d).addClass(c)},"^style.(width|height)":function(a,b,c){this.rendered&&this.tooltip.css(b,c)},"^style.widget|content.title":function(){this.rendered&&this._setWidget()},"^style.def":function(a,b,c){this.rendered&&this.tooltip.toggleClass(Z,!!c)},"^events.(render|show|move|hide|focus|blur)$":function(a,b,c){this.rendered&&this.tooltip[(d.isFunction(c)?"":"un")+"bind"]("tooltip"+b,c)},"^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)":function(){if(this.rendered){var a=this.options.position;this.tooltip.attr("tracking","mouse"===a.target&&a.adjust.mouse),this._unassignEvents(),this._assignEvents()}}}},z.get=function(a){if(this.destroyed)return this;var b=i(this.options,a.toLowerCase()),c=b[0][b[1]];return c.precedance?c.string():c};var ea=/^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,fa=/^prerender|show\.ready/i;z.set=function(a,b){if(this.destroyed)return this;var c,e=this.rendered,f=E,g=this.options;return"string"==typeof a?(c=a,a={},a[c]=b):a=d.extend({},a),d.each(a,function(b,c){if(e&&fa.test(b))return void delete a[b];var h,j=i(g,b.toLowerCase());h=j[0][j[1]],j[0][j[1]]=c&&c.nodeType?d(c):c,f=ea.test(b)||f,a[b]=[j[0],j[1],c,h]}),h(g),this.positioning=D,d.each(a,d.proxy(j,this)),this.positioning=E,this.rendered&&this.tooltip[0].offsetWidth>0&&f&&this.reposition("mouse"===g.position.target?F:this.cache.event),this},z._update=function(a,b){var c=this,e=this.cache;return this.rendered&&a?(d.isFunction(a)&&(a=a.call(this.elements.target,e.event,this)||""),d.isFunction(a.then)?(e.waiting=D,a.then(function(a){return e.waiting=E,c._update(a,b)},F,function(a){return c._update(a,b)})):a===E||!a&&""!==a?E:(a.jquery&&a.length>0?b.empty().append(a.css({display:"block",visibility:"visible"})):b.html(a),this._waitForContent(b).then(function(a){c.rendered&&c.tooltip[0].offsetWidth>0&&c.reposition(e.event,!a.length)}))):E},z._waitForContent=function(a){var b=this.cache;return b.waiting=D,(d.fn.imagesLoaded?a.imagesLoaded():(new d.Deferred).resolve([])).done(function(){b.waiting=E}).promise()},z._updateContent=function(a,b){this._update(a,this.elements.content,b)},z._updateTitle=function(a,b){this._update(a,this.elements.title,b)===E&&this._removeTitle(E)},z._createTitle=function(){var a=this.elements,b=this._id+"-title";a.titlebar&&this._removeTitle(),a.titlebar=d("<div />",{"class":S+"-titlebar "+(this.options.style.widget?k("header"):"")}).append(a.title=d("<div />",{id:b,"class":S+"-title","aria-atomic":D})).insertBefore(a.content).delegate(".qtip-close","mousedown keydown mouseup keyup mouseout",function(a){d(this).toggleClass("ui-state-active ui-state-focus","down"===a.type.substr(-4))}).delegate(".qtip-close","mouseover mouseout",function(a){d(this).toggleClass("ui-state-hover","mouseover"===a.type)}),this.options.content.button&&this._createButton()},z._removeTitle=function(a){var b=this.elements;b.title&&(b.titlebar.remove(),b.titlebar=b.title=b.button=F,a!==E&&this.reposition())},z._createPosClass=function(a){return S+"-pos-"+(a||this.options.position.my).abbrev()},z.reposition=function(c,e){if(!this.rendered||this.positioning||this.destroyed)return this;this.positioning=D;var f,g,h,i,j=this.cache,k=this.tooltip,l=this.options.position,m=l.target,n=l.my,o=l.at,p=l.viewport,q=l.container,r=l.adjust,s=r.method.split(" "),t=k.outerWidth(E),u=k.outerHeight(E),v=0,w=0,x=k.css("position"),y={left:0,top:0},z=k[0].offsetWidth>0,A=c&&"scroll"===c.type,B=d(a),C=q[0].ownerDocument,F=this.mouse;if(d.isArray(m)&&2===m.length)o={x:L,y:K},y={left:m[0],top:m[1]};else if("mouse"===m)o={x:L,y:K},(!r.mouse||this.options.hide.distance)&&j.origin&&j.origin.pageX?c=j.origin:!c||c&&("resize"===c.type||"scroll"===c.type)?c=j.event:F&&F.pageX&&(c=F),"static"!==x&&(y=q.offset()),C.body.offsetWidth!==(a.innerWidth||C.documentElement.clientWidth)&&(g=d(b.body).offset()),y={left:c.pageX-y.left+(g&&g.left||0),top:c.pageY-y.top+(g&&g.top||0)},r.mouse&&A&&F&&(y.left-=(F.scrollX||0)-B.scrollLeft(),y.top-=(F.scrollY||0)-B.scrollTop());else{if("event"===m?c&&c.target&&"scroll"!==c.type&&"resize"!==c.type?j.target=d(c.target):c.target||(j.target=this.elements.target):"event"!==m&&(j.target=d(m.jquery?m:this.elements.target)),m=j.target,m=d(m).eq(0),0===m.length)return this;m[0]===b||m[0]===a?(v=da.iOS?a.innerWidth:m.width(),w=da.iOS?a.innerHeight:m.height(),m[0]===a&&(y={top:(p||m).scrollTop(),left:(p||m).scrollLeft()})):R.imagemap&&m.is("area")?f=R.imagemap(this,m,o,R.viewport?s:E):R.svg&&m&&m[0].ownerSVGElement?f=R.svg(this,m,o,R.viewport?s:E):(v=m.outerWidth(E),w=m.outerHeight(E),y=m.offset()),f&&(v=f.width,w=f.height,g=f.offset,y=f.position),y=this.reposition.offset(m,y,q),(da.iOS>3.1&&da.iOS<4.1||da.iOS>=4.3&&da.iOS<4.33||!da.iOS&&"fixed"===x)&&(y.left-=B.scrollLeft(),y.top-=B.scrollTop()),(!f||f&&f.adjustable!==E)&&(y.left+=o.x===N?v:o.x===O?v/2:0,y.top+=o.y===M?w:o.y===O?w/2:0)}return y.left+=r.x+(n.x===N?-t:n.x===O?-t/2:0),y.top+=r.y+(n.y===M?-u:n.y===O?-u/2:0),R.viewport?(h=y.adjusted=R.viewport(this,y,l,v,w,t,u),g&&h.left&&(y.left+=g.left),g&&h.top&&(y.top+=g.top),h.my&&(this.position.my=h.my)):y.adjusted={left:0,top:0},j.posClass!==(i=this._createPosClass(this.position.my))&&(j.posClass=i,k.removeClass(j.posClass).addClass(i)),this._trigger("move",[y,p.elem||p],c)?(delete y.adjusted,e===E||!z||isNaN(y.left)||isNaN(y.top)||"mouse"===m||!d.isFunction(l.effect)?k.css(y):d.isFunction(l.effect)&&(l.effect.call(k,this,d.extend({},y)),k.queue(function(a){d(this).css({opacity:"",height:""}),da.ie&&this.style.removeAttribute("filter"),a()})),this.positioning=E,this):this},z.reposition.offset=function(a,c,e){function f(a,b){c.left+=b*a.scrollLeft(),c.top+=b*a.scrollTop()}if(!e[0])return c;var g,h,i,j,k=d(a[0].ownerDocument),l=!!da.ie&&"CSS1Compat"!==b.compatMode,m=e[0];do"static"!==(h=d.css(m,"position"))&&("fixed"===h?(i=m.getBoundingClientRect(),f(k,-1)):(i=d(m).position(),i.left+=parseFloat(d.css(m,"borderLeftWidth"))||0,i.top+=parseFloat(d.css(m,"borderTopWidth"))||0),c.left-=i.left+(parseFloat(d.css(m,"marginLeft"))||0),c.top-=i.top+(parseFloat(d.css(m,"marginTop"))||0),g||"hidden"===(j=d.css(m,"overflow"))||"visible"===j||"BODY"===d.prop(m,"tagName")||(g=d(m)));while(m=m.offsetParent);return g&&(g[0]!==k[0]||l)&&f(g,1),c};var ga=(A=z.reposition.Corner=function(a,b){a=(""+a).replace(/([A-Z])/," $1").replace(/middle/gi,O).toLowerCase(),this.x=(a.match(/left|right/i)||a.match(/center/)||["inherit"])[0].toLowerCase(),this.y=(a.match(/top|bottom|center/i)||["inherit"])[0].toLowerCase(),this.forceY=!!b;var c=a.charAt(0);this.precedance="t"===c||"b"===c?H:G}).prototype;ga.invert=function(a,b){this[a]=this[a]===L?N:this[a]===N?L:b||this[a]},ga.string=function(a){var b=this.x,c=this.y,d=b!==c?"center"===b||"center"!==c&&(this.precedance===H||this.forceY)?[c,b]:[b,c]:[b];return a!==!1?d.join(" "):d},ga.abbrev=function(){var a=this.string(!1);return a[0].charAt(0)+(a[1]&&a[1].charAt(0)||"")},ga.clone=function(){return new A(this.string(),this.forceY)},z.toggle=function(a,c){var e=this.cache,f=this.options,g=this.tooltip;if(c){if(/over|enter/.test(c.type)&&e.event&&/out|leave/.test(e.event.type)&&f.show.target.add(c.target).length===f.show.target.length&&g.has(c.relatedTarget).length)return this;e.event=d.event.fix(c)}if(this.waiting&&!a&&(this.hiddenDuringWait=D),!this.rendered)return a?this.render(1):this;if(this.destroyed||this.disabled)return this;var h,i,j,k=a?"show":"hide",l=this.options[k],m=this.options.position,n=this.options.content,o=this.tooltip.css("width"),p=this.tooltip.is(":visible"),q=a||1===l.target.length,r=!c||l.target.length<2||e.target[0]===c.target;return(typeof a).search("boolean|number")&&(a=!p),h=!g.is(":animated")&&p===a&&r,i=h?F:!!this._trigger(k,[90]),this.destroyed?this:(i!==E&&a&&this.focus(c),!i||h?this:(d.attr(g[0],"aria-hidden",!a),a?(this.mouse&&(e.origin=d.event.fix(this.mouse)),d.isFunction(n.text)&&this._updateContent(n.text,E),d.isFunction(n.title)&&this._updateTitle(n.title,E),!C&&"mouse"===m.target&&m.adjust.mouse&&(d(b).bind("mousemove."+S,this._storeMouse),C=D),o||g.css("width",g.outerWidth(E)),this.reposition(c,arguments[2]),o||g.css("width",""),l.solo&&("string"==typeof l.solo?d(l.solo):d(W,l.solo)).not(g).not(l.target).qtip("hide",new d.Event("tooltipsolo"))):(clearTimeout(this.timers.show),delete e.origin,C&&!d(W+'[tracking="true"]:visible',l.solo).not(g).length&&(d(b).unbind("mousemove."+S),C=E),this.blur(c)),j=d.proxy(function(){a?(da.ie&&g[0].style.removeAttribute("filter"),g.css("overflow",""),"string"==typeof l.autofocus&&d(this.options.show.autofocus,g).focus(),this.options.show.target.trigger("qtip-"+this.id+"-inactive")):g.css({display:"",visibility:"",opacity:"",left:"",top:""}),this._trigger(a?"visible":"hidden")},this),l.effect===E||q===E?(g[k](),j()):d.isFunction(l.effect)?(g.stop(1,1),l.effect.call(g,this),g.queue("fx",function(a){j(),a()})):g.fadeTo(90,a?1:0,j),a&&l.target.trigger("qtip-"+this.id+"-inactive"),this))},z.show=function(a){return this.toggle(D,a)},z.hide=function(a){return this.toggle(E,a)},z.focus=function(a){if(!this.rendered||this.destroyed)return this;var b=d(W),c=this.tooltip,e=parseInt(c[0].style.zIndex,10),f=y.zindex+b.length;return c.hasClass($)||this._trigger("focus",[f],a)&&(e!==f&&(b.each(function(){this.style.zIndex>e&&(this.style.zIndex=this.style.zIndex-1)}),b.filter("."+$).qtip("blur",a)),c.addClass($)[0].style.zIndex=f),this},z.blur=function(a){return!this.rendered||this.destroyed?this:(this.tooltip.removeClass($),this._trigger("blur",[this.tooltip.css("zIndex")],a),this)},z.disable=function(a){return this.destroyed?this:("toggle"===a?a=!(this.rendered?this.tooltip.hasClass(aa):this.disabled):"boolean"!=typeof a&&(a=D),this.rendered&&this.tooltip.toggleClass(aa,a).attr("aria-disabled",a),this.disabled=!!a,this)},z.enable=function(){return this.disable(E)},z._createButton=function(){var a=this,b=this.elements,c=b.tooltip,e=this.options.content.button,f="string"==typeof e,g=f?e:"Close tooltip";b.button&&b.button.remove(),e.jquery?b.button=e:b.button=d("<a />",{"class":"qtip-close "+(this.options.style.widget?"":S+"-icon"),title:g,"aria-label":g}).prepend(d("<span />",{"class":"ui-icon ui-icon-close",html:"&times;"})),b.button.appendTo(b.titlebar||c).attr("role","button").click(function(b){return c.hasClass(aa)||a.hide(b),E})},z._updateButton=function(a){if(!this.rendered)return E;var b=this.elements.button;a?this._createButton():b.remove()},z._setWidget=function(){var a=this.options.style.widget,b=this.elements,c=b.tooltip,d=c.hasClass(aa);c.removeClass(aa),aa=a?"ui-state-disabled":"qtip-disabled",c.toggleClass(aa,d),c.toggleClass("ui-helper-reset "+k(),a).toggleClass(Z,this.options.style.def&&!a),b.content&&b.content.toggleClass(k("content"),a),b.titlebar&&b.titlebar.toggleClass(k("header"),a),b.button&&b.button.toggleClass(S+"-icon",!a)},z._storeMouse=function(a){return(this.mouse=d.event.fix(a)).type="mousemove",this},z._bind=function(a,b,c,e,f){if(a&&c&&b.length){var g="."+this._id+(e?"-"+e:"");return d(a).bind((b.split?b:b.join(g+" "))+g,d.proxy(c,f||this)),this}},z._unbind=function(a,b){return a&&d(a).unbind("."+this._id+(b?"-"+b:"")),this},z._trigger=function(a,b,c){var e=new d.Event("tooltip"+a);return e.originalEvent=c&&d.extend({},c)||this.cache.event||F,this.triggering=a,this.tooltip.trigger(e,[this].concat(b||[])),this.triggering=E,!e.isDefaultPrevented()},z._bindEvents=function(a,b,c,e,f,g){var h=c.filter(e).add(e.filter(c)),i=[];h.length&&(d.each(b,function(b,c){var e=d.inArray(c,a);e>-1&&i.push(a.splice(e,1)[0])}),i.length&&(this._bind(h,i,function(a){var b=!!this.rendered&&this.tooltip[0].offsetWidth>0;(b?g:f).call(this,a)}),c=c.not(h),e=e.not(h))),this._bind(c,a,f),this._bind(e,b,g)},z._assignInitialEvents=function(a){function b(a){return this.disabled||this.destroyed?E:(this.cache.event=a&&d.event.fix(a),this.cache.target=a&&d(a.target),clearTimeout(this.timers.show),void(this.timers.show=l.call(this,function(){this.render("object"==typeof a||c.show.ready)},c.prerender?0:c.show.delay)))}var c=this.options,e=c.show.target,f=c.hide.target,g=c.show.event?d.trim(""+c.show.event).split(" "):[],h=c.hide.event?d.trim(""+c.hide.event).split(" "):[];this._bind(this.elements.target,["remove","removeqtip"],function(){this.destroy(!0)},"destroy"),/mouse(over|enter)/i.test(c.show.event)&&!/mouse(out|leave)/i.test(c.hide.event)&&h.push("mouseleave"),this._bind(e,"mousemove",function(a){this._storeMouse(a),this.cache.onTarget=D}),this._bindEvents(g,h,e,f,b,function(){return this.timers?void clearTimeout(this.timers.show):E}),(c.show.ready||c.prerender)&&b.call(this,a)},z._assignEvents=function(){var c=this,e=this.options,f=e.position,g=this.tooltip,h=e.show.target,i=e.hide.target,j=f.container,k=f.viewport,l=d(b),q=d(a),r=e.show.event?d.trim(""+e.show.event).split(" "):[],s=e.hide.event?d.trim(""+e.hide.event).split(" "):[];d.each(e.events,function(a,b){c._bind(g,"toggle"===a?["tooltipshow","tooltiphide"]:["tooltip"+a],b,null,g)}),/mouse(out|leave)/i.test(e.hide.event)&&"window"===e.hide.leave&&this._bind(l,["mouseout","blur"],function(a){/select|option/.test(a.target.nodeName)||a.relatedTarget||this.hide(a)}),e.hide.fixed?i=i.add(g.addClass(Y)):/mouse(over|enter)/i.test(e.show.event)&&this._bind(i,"mouseleave",function(){clearTimeout(this.timers.show)}),(""+e.hide.event).indexOf("unfocus")>-1&&this._bind(j.closest("html"),["mousedown","touchstart"],function(a){var b=d(a.target),c=this.rendered&&!this.tooltip.hasClass(aa)&&this.tooltip[0].offsetWidth>0,e=b.parents(W).filter(this.tooltip[0]).length>0;b[0]===this.target[0]||b[0]===this.tooltip[0]||e||this.target.has(b[0]).length||!c||this.hide(a)}),"number"==typeof e.hide.inactive&&(this._bind(h,"qtip-"+this.id+"-inactive",o,"inactive"),this._bind(i.add(g),y.inactiveEvents,o)),this._bindEvents(r,s,h,i,m,n),this._bind(h.add(g),"mousemove",function(a){if("number"==typeof e.hide.distance){var b=this.cache.origin||{},c=this.options.hide.distance,d=Math.abs;(d(a.pageX-b.pageX)>=c||d(a.pageY-b.pageY)>=c)&&this.hide(a)}this._storeMouse(a)}),"mouse"===f.target&&f.adjust.mouse&&(e.hide.event&&this._bind(h,["mouseenter","mouseleave"],function(a){return this.cache?void(this.cache.onTarget="mouseenter"===a.type):E}),this._bind(l,"mousemove",function(a){this.rendered&&this.cache.onTarget&&!this.tooltip.hasClass(aa)&&this.tooltip[0].offsetWidth>0&&this.reposition(a)})),(f.adjust.resize||k.length)&&this._bind(d.event.special.resize?k:q,"resize",p),f.adjust.scroll&&this._bind(q.add(f.container),"scroll",p)},z._unassignEvents=function(){var c=this.options,e=c.show.target,f=c.hide.target,g=d.grep([this.elements.target[0],this.rendered&&this.tooltip[0],c.position.container[0],c.position.viewport[0],c.position.container.closest("html")[0],a,b],function(a){return"object"==typeof a});e&&e.toArray&&(g=g.concat(e.toArray())),f&&f.toArray&&(g=g.concat(f.toArray())),this._unbind(g)._unbind(g,"destroy")._unbind(g,"inactive")},d(function(){q(W,["mouseenter","mouseleave"],function(a){var b="mouseenter"===a.type,c=d(a.currentTarget),e=d(a.relatedTarget||a.target),f=this.options;b?(this.focus(a),c.hasClass(Y)&&!c.hasClass(aa)&&clearTimeout(this.timers.hide)):"mouse"===f.position.target&&f.position.adjust.mouse&&f.hide.event&&f.show.target&&!e.closest(f.show.target[0]).length&&this.hide(a),c.toggleClass(_,b)}),q("["+U+"]",X,o)}),y=d.fn.qtip=function(a,b,e){var f=(""+a).toLowerCase(),g=F,i=d.makeArray(arguments).slice(1),j=i[i.length-1],k=this[0]?d.data(this[0],S):F;return!arguments.length&&k||"api"===f?k:"string"==typeof a?(this.each(function(){var a=d.data(this,S);if(!a)return D;if(j&&j.timeStamp&&(a.cache.event=j),!b||"option"!==f&&"options"!==f)a[f]&&a[f].apply(a,i);else{if(e===c&&!d.isPlainObject(b))return g=a.get(b),E;a.set(b,e)}}),g!==F?g:this):"object"!=typeof a&&arguments.length?void 0:(k=h(d.extend(D,{},a)),this.each(function(a){var b,c;return c=d.isArray(k.id)?k.id[a]:k.id,c=!c||c===E||c.length<1||y.api[c]?y.nextid++:c,b=r(d(this),c,k),b===E?D:(y.api[c]=b,d.each(R,function(){"initialize"===this.initialize&&this(b)}),void b._assignInitialEvents(j))}))},d.qtip=e,y.api={},d.each({attr:function(a,b){if(this.length){var c=this[0],e="title",f=d.data(c,"qtip");if(a===e&&f&&f.options&&"object"==typeof f&&"object"==typeof f.options&&f.options.suppress)return arguments.length<2?d.attr(c,ca):(f&&f.options.content.attr===e&&f.cache.attr&&f.set("content.text",b),this.attr(ca,b))}return d.fn["attr"+ba].apply(this,arguments)},clone:function(a){var b=d.fn["clone"+ba].apply(this,arguments);return a||b.filter("["+ca+"]").attr("title",function(){return d.attr(this,ca)}).removeAttr(ca),b}},function(a,b){if(!b||d.fn[a+ba])return D;var c=d.fn[a+ba]=d.fn[a];d.fn[a]=function(){return b.apply(this,arguments)||c.apply(this,arguments)}}),d.ui||(d["cleanData"+ba]=d.cleanData,d.cleanData=function(a){for(var b,c=0;(b=d(a[c])).length;c++)if(b.attr(T))try{b.triggerHandler("removeqtip")}catch(e){}d["cleanData"+ba].apply(this,arguments)}),y.version="3.0.3-5-g",y.nextid=0,y.inactiveEvents=X,y.zindex=15e3,y.defaults={prerender:E,id:E,overwrite:D,suppress:D,content:{text:D,attr:"title",title:E,button:E},position:{my:"top left",at:"bottom right",target:E,container:E,viewport:E,adjust:{x:0,y:0,mouse:D,scroll:D,resize:D,method:"flipinvert flipinvert"},effect:function(a,b){d(this).animate(b,{duration:200,queue:E})}},show:{target:E,event:"mouseenter",effect:D,delay:90,solo:E,ready:E,autofocus:E},hide:{target:E,event:"mouseleave",effect:D,delay:0,fixed:E,inactive:E,leave:"window",distance:E},style:{classes:"",widget:E,width:E,height:E,def:D},events:{render:F,move:F,show:F,hide:F,toggle:F,visible:F,hidden:F,focus:F,blur:F}};var ha,ia,ja,ka,la,ma="margin",na="border",oa="color",pa="background-color",qa="transparent",ra=" !important",sa=!!b.createElement("canvas").getContext,ta=/rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i,ua={},va=["Webkit","O","Moz","ms"];sa?(ka=a.devicePixelRatio||1,la=function(){var a=b.createElement("canvas").getContext("2d");return a.backingStorePixelRatio||a.webkitBackingStorePixelRatio||a.mozBackingStorePixelRatio||a.msBackingStorePixelRatio||a.oBackingStorePixelRatio||1}(),ja=ka/la):ia=function(a,b,c){return"<qtipvml:"+a+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(b||"")+' style="behavior: url(#default#VML); '+(c||"")+'" />'},d.extend(v.prototype,{init:function(a){var b,c;c=this.element=a.elements.tip=d("<div />",{"class":S+"-tip"}).prependTo(a.tooltip),sa?(b=d("<canvas />").appendTo(this.element)[0].getContext("2d"),b.lineJoin="miter",b.miterLimit=1e5,b.save()):(b=ia("shape",'coordorigin="0,0"',"position:absolute;"),this.element.html(b+b),a._bind(d("*",c).add(c),["click","mousedown"],function(a){a.stopPropagation()},this._ns)),a._bind(a.tooltip,"tooltipmove",this.reposition,this._ns,this),this.create()},_swapDimensions:function(){this.size[0]=this.options.height,this.size[1]=this.options.width},_resetDimensions:function(){this.size[0]=this.options.width,this.size[1]=this.options.height},_useTitle:function(a){var b=this.qtip.elements.titlebar;return b&&(a.y===K||a.y===O&&this.element.position().top+this.size[1]/2+this.options.offset<b.outerHeight(D))},_parseCorner:function(a){var b=this.qtip.options.position.my;return a===E||b===E?a=E:a===D?a=new A(b.string()):a.string||(a=new A(a),a.fixed=D),a},_parseWidth:function(a,b,c){var d=this.qtip.elements,e=na+s(b)+"Width";return(c?u(c,e):u(d.content,e)||u(this._useTitle(a)&&d.titlebar||d.content,e)||u(d.tooltip,e))||0},_parseRadius:function(a){var b=this.qtip.elements,c=na+s(a.y)+s(a.x)+"Radius";return da.ie<9?0:u(this._useTitle(a)&&b.titlebar||b.content,c)||u(b.tooltip,c)||0},_invalidColour:function(a,b,c){var d=a.css(b);return!d||c&&d===a.css(c)||ta.test(d)?E:d},_parseColours:function(a){var b=this.qtip.elements,c=this.element.css("cssText",""),e=na+s(a[a.precedance])+s(oa),f=this._useTitle(a)&&b.titlebar||b.content,g=this._invalidColour,h=[];return h[0]=g(c,pa)||g(f,pa)||g(b.content,pa)||g(b.tooltip,pa)||c.css(pa),h[1]=g(c,e,oa)||g(f,e,oa)||g(b.content,e,oa)||g(b.tooltip,e,oa)||b.tooltip.css(e),d("*",c).add(c).css("cssText",pa+":"+qa+ra+";"+na+":0"+ra+";"),h},_calculateSize:function(a){var b,c,d,e=a.precedance===H,f=this.options.width,g=this.options.height,h="c"===a.abbrev(),i=(e?f:g)*(h?.5:1),j=Math.pow,k=Math.round,l=Math.sqrt(j(i,2)+j(g,2)),m=[this.border/i*l,this.border/g*l];return m[2]=Math.sqrt(j(m[0],2)-j(this.border,2)),m[3]=Math.sqrt(j(m[1],2)-j(this.border,2)),b=l+m[2]+m[3]+(h?0:m[0]),c=b/l,d=[k(c*f),k(c*g)],e?d:d.reverse()},_calculateTip:function(a,b,c){c=c||1,b=b||this.size;var d=b[0]*c,e=b[1]*c,f=Math.ceil(d/2),g=Math.ceil(e/2),h={br:[0,0,d,e,d,0],bl:[0,0,d,0,0,e],tr:[0,e,d,0,d,e],tl:[0,0,0,e,d,e],tc:[0,e,f,0,d,e],bc:[0,0,d,0,f,e],rc:[0,0,d,g,0,e],lc:[d,0,d,e,0,g]};return h.lt=h.br,h.rt=h.bl,h.lb=h.tr,h.rb=h.tl,h[a.abbrev()]},_drawCoords:function(a,b){a.beginPath(),a.moveTo(b[0],b[1]),a.lineTo(b[2],b[3]),a.lineTo(b[4],b[5]),a.closePath()},create:function(){var a=this.corner=(sa||da.ie)&&this._parseCorner(this.options.corner);return this.enabled=!!this.corner&&"c"!==this.corner.abbrev(),this.enabled&&(this.qtip.cache.corner=a.clone(),this.update()),this.element.toggle(this.enabled),this.corner},update:function(b,c){if(!this.enabled)return this;var e,f,g,h,i,j,k,l,m=this.qtip.elements,n=this.element,o=n.children(),p=this.options,q=this.size,r=p.mimic,s=Math.round;b||(b=this.qtip.cache.corner||this.corner),r===E?r=b:(r=new A(r),r.precedance=b.precedance,"inherit"===r.x?r.x=b.x:"inherit"===r.y?r.y=b.y:r.x===r.y&&(r[b.precedance]=b[b.precedance])),f=r.precedance,b.precedance===G?this._swapDimensions():this._resetDimensions(),e=this.color=this._parseColours(b),e[1]!==qa?(l=this.border=this._parseWidth(b,b[b.precedance]),p.border&&l<1&&!ta.test(e[1])&&(e[0]=e[1]),this.border=l=p.border!==D?p.border:l):this.border=l=0,k=this.size=this._calculateSize(b),n.css({width:k[0],height:k[1],lineHeight:k[1]+"px"}),j=b.precedance===H?[s(r.x===L?l:r.x===N?k[0]-q[0]-l:(k[0]-q[0])/2),s(r.y===K?k[1]-q[1]:0)]:[s(r.x===L?k[0]-q[0]:0),s(r.y===K?l:r.y===M?k[1]-q[1]-l:(k[1]-q[1])/2)],sa?(g=o[0].getContext("2d"),g.restore(),g.save(),g.clearRect(0,0,6e3,6e3),h=this._calculateTip(r,q,ja),i=this._calculateTip(r,this.size,ja),o.attr(I,k[0]*ja).attr(J,k[1]*ja),o.css(I,k[0]).css(J,k[1]),this._drawCoords(g,i),g.fillStyle=e[1],g.fill(),g.translate(j[0]*ja,j[1]*ja),this._drawCoords(g,h),g.fillStyle=e[0],g.fill()):(h=this._calculateTip(r),h="m"+h[0]+","+h[1]+" l"+h[2]+","+h[3]+" "+h[4]+","+h[5]+" xe",j[2]=l&&/^(r|b)/i.test(b.string())?8===da.ie?2:1:0,o.css({coordsize:k[0]+l+" "+k[1]+l,antialias:""+(r.string().indexOf(O)>-1),left:j[0]-j[2]*Number(f===G),top:j[1]-j[2]*Number(f===H),width:k[0]+l,height:k[1]+l}).each(function(a){var b=d(this);b[b.prop?"prop":"attr"]({coordsize:k[0]+l+" "+k[1]+l,path:h,fillcolor:e[0],filled:!!a,stroked:!a}).toggle(!(!l&&!a)),!a&&b.html(ia("stroke",'weight="'+2*l+'px" color="'+e[1]+'" miterlimit="1000" joinstyle="miter"'))})),a.opera&&setTimeout(function(){m.tip.css({display:"inline-block",visibility:"visible"})},1),c!==E&&this.calculate(b,k)},calculate:function(a,b){if(!this.enabled)return E;
var c,e,f=this,g=this.qtip.elements,h=this.element,i=this.options.offset,j={};return a=a||this.corner,c=a.precedance,b=b||this._calculateSize(a),e=[a.x,a.y],c===G&&e.reverse(),d.each(e,function(d,e){var h,k,l;e===O?(h=c===H?L:K,j[h]="50%",j[ma+"-"+h]=-Math.round(b[c===H?0:1]/2)+i):(h=f._parseWidth(a,e,g.tooltip),k=f._parseWidth(a,e,g.content),l=f._parseRadius(a),j[e]=Math.max(-f.border,d?k:i+(l>h?l:-h)))}),j[a[c]]-=b[c===G?0:1],h.css({margin:"",top:"",bottom:"",left:"",right:""}).css(j),j},reposition:function(a,b,d){function e(a,b,c,d,e){a===Q&&j.precedance===b&&k[d]&&j[c]!==O?j.precedance=j.precedance===G?H:G:a!==Q&&k[d]&&(j[b]=j[b]===O?k[d]>0?d:e:j[b]===d?e:d)}function f(a,b,e){j[a]===O?p[ma+"-"+b]=o[a]=g[ma+"-"+b]-k[b]:(h=g[e]!==c?[k[b],-g[b]]:[-k[b],g[b]],(o[a]=Math.max(h[0],h[1]))>h[0]&&(d[b]-=k[b],o[b]=E),p[g[e]!==c?e:b]=o[a])}if(this.enabled){var g,h,i=b.cache,j=this.corner.clone(),k=d.adjusted,l=b.options.position.adjust.method.split(" "),m=l[0],n=l[1]||l[0],o={left:E,top:E,x:0,y:0},p={};this.corner.fixed!==D&&(e(m,G,H,L,N),e(n,H,G,K,M),j.string()===i.corner.string()&&i.cornerTop===k.top&&i.cornerLeft===k.left||this.update(j,E)),g=this.calculate(j),g.right!==c&&(g.left=-g.right),g.bottom!==c&&(g.top=-g.bottom),g.user=this.offset,o.left=m===Q&&!!k.left,o.left&&f(G,L,N),o.top=n===Q&&!!k.top,o.top&&f(H,K,M),this.element.css(p).toggle(!(o.x&&o.y||j.x===O&&o.y||j.y===O&&o.x)),d.left-=g.left.charAt?g.user:m!==Q||o.top||!o.left&&!o.top?g.left+this.border:0,d.top-=g.top.charAt?g.user:n!==Q||o.left||!o.left&&!o.top?g.top+this.border:0,i.cornerLeft=k.left,i.cornerTop=k.top,i.corner=j.clone()}},destroy:function(){this.qtip._unbind(this.qtip.tooltip,this._ns),this.qtip.elements.tip&&this.qtip.elements.tip.find("*").remove().end().remove()}}),ha=R.tip=function(a){return new v(a,a.options.style.tip)},ha.initialize="render",ha.sanitize=function(a){if(a.style&&"tip"in a.style){var b=a.style.tip;"object"!=typeof b&&(b=a.style.tip={corner:b}),/string|boolean/i.test(typeof b.corner)||(b.corner=D)}},B.tip={"^position.my|style.tip.(corner|mimic|border)$":function(){this.create(),this.qtip.reposition()},"^style.tip.(height|width)$":function(a){this.size=[a.width,a.height],this.update(),this.qtip.reposition()},"^content.title|style.(classes|widget)$":function(){this.update()}},d.extend(D,y.defaults,{style:{tip:{corner:D,mimic:E,width:6,height:6,border:D,offset:0}}});var wa,xa,ya="qtip-modal",za="."+ya;xa=function(){function a(a){if(d.expr[":"].focusable)return d.expr[":"].focusable;var b,c,e,f=!isNaN(d.attr(a,"tabindex")),g=a.nodeName&&a.nodeName.toLowerCase();return"area"===g?(b=a.parentNode,c=b.name,!(!a.href||!c||"map"!==b.nodeName.toLowerCase())&&(e=d("img[usemap=#"+c+"]")[0],!!e&&e.is(":visible"))):/input|select|textarea|button|object/.test(g)?!a.disabled:"a"===g?a.href||f:f}function c(a){j.length<1&&a.length?a.not("body").blur():j.first().focus()}function e(a){if(h.is(":visible")){var b,e=d(a.target),g=f.tooltip,i=e.closest(W);b=i.length<1?E:parseInt(i[0].style.zIndex,10)>parseInt(g[0].style.zIndex,10),b||e.closest(W)[0]===g[0]||c(e)}}var f,g,h,i=this,j={};d.extend(i,{init:function(){return h=i.elem=d("<div />",{id:"qtip-overlay",html:"<div></div>",mousedown:function(){return E}}).hide(),d(b.body).bind("focusin"+za,e),d(b).bind("keydown"+za,function(a){f&&f.options.show.modal.escape&&27===a.keyCode&&f.hide(a)}),h.bind("click"+za,function(a){f&&f.options.show.modal.blur&&f.hide(a)}),i},update:function(b){f=b,j=b.options.show.modal.stealfocus!==E?b.tooltip.find("*").filter(function(){return a(this)}):[]},toggle:function(a,e,j){var k=a.tooltip,l=a.options.show.modal,m=l.effect,n=e?"show":"hide",o=h.is(":visible"),p=d(za).filter(":visible:not(:animated)").not(k);return i.update(a),e&&l.stealfocus!==E&&c(d(":focus")),h.toggleClass("blurs",l.blur),e&&h.appendTo(b.body),h.is(":animated")&&o===e&&g!==E||!e&&p.length?i:(h.stop(D,E),d.isFunction(m)?m.call(h,e):m===E?h[n]():h.fadeTo(parseInt(j,10)||90,e?1:0,function(){e||h.hide()}),e||h.queue(function(a){h.css({left:"",top:""}),d(za).length||h.detach(),a()}),g=e,f.destroyed&&(f=F),i)}}),i.init()},xa=new xa,d.extend(w.prototype,{init:function(a){var b=a.tooltip;return this.options.on?(a.elements.overlay=xa.elem,b.addClass(ya).css("z-index",y.modal_zindex+d(za).length),a._bind(b,["tooltipshow","tooltiphide"],function(a,c,e){var f=a.originalEvent;if(a.target===b[0])if(f&&"tooltiphide"===a.type&&/mouse(leave|enter)/.test(f.type)&&d(f.relatedTarget).closest(xa.elem[0]).length)try{a.preventDefault()}catch(g){}else(!f||f&&"tooltipsolo"!==f.type)&&this.toggle(a,"tooltipshow"===a.type,e)},this._ns,this),a._bind(b,"tooltipfocus",function(a,c){if(!a.isDefaultPrevented()&&a.target===b[0]){var e=d(za),f=y.modal_zindex+e.length,g=parseInt(b[0].style.zIndex,10);xa.elem[0].style.zIndex=f-1,e.each(function(){this.style.zIndex>g&&(this.style.zIndex-=1)}),e.filter("."+$).qtip("blur",a.originalEvent),b.addClass($)[0].style.zIndex=f,xa.update(c);try{a.preventDefault()}catch(h){}}},this._ns,this),void a._bind(b,"tooltiphide",function(a){a.target===b[0]&&d(za).filter(":visible").not(b).last().qtip("focus",a)},this._ns,this)):this},toggle:function(a,b,c){return a&&a.isDefaultPrevented()?this:void xa.toggle(this.qtip,!!b,c)},destroy:function(){this.qtip.tooltip.removeClass(ya),this.qtip._unbind(this.qtip.tooltip,this._ns),xa.toggle(this.qtip,E),delete this.qtip.elements.overlay}}),wa=R.modal=function(a){return new w(a,a.options.show.modal)},wa.sanitize=function(a){a.show&&("object"!=typeof a.show.modal?a.show.modal={on:!!a.show.modal}:"undefined"==typeof a.show.modal.on&&(a.show.modal.on=D))},y.modal_zindex=y.zindex-200,wa.initialize="render",B.modal={"^show.modal.(on|blur)$":function(){this.destroy(),this.init(),this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth>0)}},d.extend(D,y.defaults,{show:{modal:{on:E,effect:D,blur:D,stealfocus:D,escape:D}}}),R.viewport=function(c,d,e,f,g,h,i){function j(a,b,c,e,f,g,h,i,j){var k=d[f],s=u[a],t=v[a],w=c===Q,x=s===f?j:s===g?-j:-j/2,y=t===f?i:t===g?-i:-i/2,z=q[f]+r[f]-(n?0:m[f]),A=z-k,B=k+j-(h===I?o:p)-z,C=x-(u.precedance===a||s===u[b]?y:0)-(t===O?i/2:0);return w?(C=(s===f?1:-1)*x,d[f]+=A>0?A:B>0?-B:0,d[f]=Math.max(-m[f]+r[f],k-C,Math.min(Math.max(-m[f]+r[f]+(h===I?o:p),k+C),d[f],"center"===s?k-x:1e9))):(e*=c===P?2:0,A>0&&(s!==f||B>0)?(d[f]-=C+e,l.invert(a,f)):B>0&&(s!==g||A>0)&&(d[f]-=(s===O?-C:C)+e,l.invert(a,g)),d[f]<q[f]&&-d[f]>B&&(d[f]=k,l=u.clone())),d[f]-k}var k,l,m,n,o,p,q,r,s=e.target,t=c.elements.tooltip,u=e.my,v=e.at,w=e.adjust,x=w.method.split(" "),y=x[0],z=x[1]||x[0],A=e.viewport,B=e.container,C={left:0,top:0};return A.jquery&&s[0]!==a&&s[0]!==b.body&&"none"!==w.method?(m=B.offset()||C,n="static"===B.css("position"),k="fixed"===t.css("position"),o=A[0]===a?A.width():A.outerWidth(E),p=A[0]===a?A.height():A.outerHeight(E),q={left:k?0:A.scrollLeft(),top:k?0:A.scrollTop()},r=A.offset()||C,"shift"===y&&"shift"===z||(l=u.clone()),C={left:"none"!==y?j(G,H,y,w.x,L,N,I,f,h):0,top:"none"!==z?j(H,G,z,w.y,K,M,J,g,i):0,my:l}):C},R.polys={polygon:function(a,b){var c,d,e,f={width:0,height:0,position:{top:1e10,right:0,bottom:0,left:1e10},adjustable:E},g=0,h=[],i=1,j=1,k=0,l=0;for(g=a.length;g--;)c=[parseInt(a[--g],10),parseInt(a[g+1],10)],c[0]>f.position.right&&(f.position.right=c[0]),c[0]<f.position.left&&(f.position.left=c[0]),c[1]>f.position.bottom&&(f.position.bottom=c[1]),c[1]<f.position.top&&(f.position.top=c[1]),h.push(c);if(d=f.width=Math.abs(f.position.right-f.position.left),e=f.height=Math.abs(f.position.bottom-f.position.top),"c"===b.abbrev())f.position={left:f.position.left+f.width/2,top:f.position.top+f.height/2};else{for(;d>0&&e>0&&i>0&&j>0;)for(d=Math.floor(d/2),e=Math.floor(e/2),b.x===L?i=d:b.x===N?i=f.width-d:i+=Math.floor(d/2),b.y===K?j=e:b.y===M?j=f.height-e:j+=Math.floor(e/2),g=h.length;g--&&!(h.length<2);)k=h[g][0]-f.position.left,l=h[g][1]-f.position.top,(b.x===L&&k>=i||b.x===N&&k<=i||b.x===O&&(k<i||k>f.width-i)||b.y===K&&l>=j||b.y===M&&l<=j||b.y===O&&(l<j||l>f.height-j))&&h.splice(g,1);f.position={left:h[0][0],top:h[0][1]}}return f},rect:function(a,b,c,d){return{width:Math.abs(c-a),height:Math.abs(d-b),position:{left:Math.min(a,c),top:Math.min(b,d)}}},_angles:{tc:1.5,tr:7/4,tl:5/4,bc:.5,br:.25,bl:.75,rc:2,lc:1,c:0},ellipse:function(a,b,c,d,e){var f=R.polys._angles[e.abbrev()],g=0===f?0:c*Math.cos(f*Math.PI),h=d*Math.sin(f*Math.PI);return{width:2*c-Math.abs(g),height:2*d-Math.abs(h),position:{left:a+g,top:b+h},adjustable:E}},circle:function(a,b,c,d){return R.polys.ellipse(a,b,c,c,d)}},R.svg=function(a,c,e){for(var f,g,h,i,j,k,l,m,n,o=c[0],p=d(o.ownerSVGElement),q=o.ownerDocument,r=(parseInt(c.css("stroke-width"),10)||0)/2;!o.getBBox;)o=o.parentNode;if(!o.getBBox||!o.parentNode)return E;switch(o.nodeName){case"ellipse":case"circle":m=R.polys.ellipse(o.cx.baseVal.value,o.cy.baseVal.value,(o.rx||o.r).baseVal.value+r,(o.ry||o.r).baseVal.value+r,e);break;case"line":case"polygon":case"polyline":for(l=o.points||[{x:o.x1.baseVal.value,y:o.y1.baseVal.value},{x:o.x2.baseVal.value,y:o.y2.baseVal.value}],m=[],k=-1,i=l.numberOfItems||l.length;++k<i;)j=l.getItem?l.getItem(k):l[k],m.push.apply(m,[j.x,j.y]);m=R.polys.polygon(m,e);break;default:m=o.getBBox(),m={width:m.width,height:m.height,position:{left:m.x,top:m.y}}}return n=m.position,p=p[0],p.createSVGPoint&&(g=o.getScreenCTM(),l=p.createSVGPoint(),l.x=n.left,l.y=n.top,h=l.matrixTransform(g),n.left=h.x,n.top=h.y),q!==b&&"mouse"!==a.position.target&&(f=d((q.defaultView||q.parentWindow).frameElement).offset(),f&&(n.left+=f.left,n.top+=f.top)),q=d(q),n.left+=q.scrollLeft(),n.top+=q.scrollTop(),m},R.imagemap=function(a,b,c){b.jquery||(b=d(b));var e,f,g,h,i,j=(b.attr("shape")||"rect").toLowerCase().replace("poly","polygon"),k=d('img[usemap="#'+b.parent("map").attr("name")+'"]'),l=d.trim(b.attr("coords")),m=l.replace(/,$/,"").split(",");if(!k.length)return E;if("polygon"===j)h=R.polys.polygon(m,c);else{if(!R.polys[j])return E;for(g=-1,i=m.length,f=[];++g<i;)f.push(parseInt(m[g],10));h=R.polys[j].apply(this,f.concat(c))}return e=k.offset(),e.left+=Math.ceil((k.outerWidth(E)-k.width())/2),e.top+=Math.ceil((k.outerHeight(E)-k.height())/2),h.position.left+=e.left,h.position.top+=e.top,h};var Aa,Ba='<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';d.extend(x.prototype,{_scroll:function(){var b=this.qtip.elements.overlay;b&&(b[0].style.top=d(a).scrollTop()+"px")},init:function(c){var e=c.tooltip;d("select, object").length<1&&(this.bgiframe=c.elements.bgiframe=d(Ba).appendTo(e),c._bind(e,"tooltipmove",this.adjustBGIFrame,this._ns,this)),this.redrawContainer=d("<div/>",{id:S+"-rcontainer"}).appendTo(b.body),c.elements.overlay&&c.elements.overlay.addClass("qtipmodal-ie6fix")&&(c._bind(a,["scroll","resize"],this._scroll,this._ns,this),c._bind(e,["tooltipshow"],this._scroll,this._ns,this)),this.redraw()},adjustBGIFrame:function(){var a,b,c=this.qtip.tooltip,d={height:c.outerHeight(E),width:c.outerWidth(E)},e=this.qtip.plugins.tip,f=this.qtip.elements.tip;b=parseInt(c.css("borderLeftWidth"),10)||0,b={left:-b,top:-b},e&&f&&(a="x"===e.corner.precedance?[I,L]:[J,K],b[a[1]]-=f[a[0]]()),this.bgiframe.css(b).css(d)},redraw:function(){if(this.qtip.rendered<1||this.drawing)return this;var a,b,c,d,e=this.qtip.tooltip,f=this.qtip.options.style,g=this.qtip.options.position.container;return this.qtip.drawing=1,f.height&&e.css(J,f.height),f.width?e.css(I,f.width):(e.css(I,"").appendTo(this.redrawContainer),b=e.width(),b%2<1&&(b+=1),c=e.css("maxWidth")||"",d=e.css("minWidth")||"",a=(c+d).indexOf("%")>-1?g.width()/100:0,c=(c.indexOf("%")>-1?a:1*parseInt(c,10))||b,d=(d.indexOf("%")>-1?a:1*parseInt(d,10))||0,b=c+d?Math.min(Math.max(b,d),c):b,e.css(I,Math.round(b)).appendTo(g)),this.drawing=0,this},destroy:function(){this.bgiframe&&this.bgiframe.remove(),this.qtip._unbind([a,this.qtip.tooltip],this._ns)}}),Aa=R.ie6=function(a){return 6===da.ie?new x(a):E},Aa.initialize="render",B.ie6={"^content|style$":function(){this.redraw()}}})}(window,document);


/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = {"version":"5.10.0","supportedLanguages":["en","cs","da","de","el","es","fi","fr","hu","id","in","it","ja","ko","ms","nb","nl-NL","ok-PL","pl","pt-BR","ro","ru","sv","th","tr","uk","vi","zh-CN","zh-TW"]}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1099);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(138);

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine(target, key, src[key], options);
  } return target;
};


/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _findIndex = _interopRequireDefault(__webpack_require__(153));

var _reduce = _interopRequireDefault(__webpack_require__(140));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _BaseLoginModel = _interopRequireDefault(__webpack_require__(198));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13] */
var PUSH_INTERVAL = 4000; // Avoid setting interval to same value as keep-alive time (5 seconds) because it
// caused an occasional issue with network connection lost errors in Safari and IE

var FactorFactor = _BaseLoginModel.default.extend({
  extraProperties: true,
  flat: false,
  props: {
    id: 'string',
    factorType: {
      type: 'string',
      values: ['sms', 'call', 'email', 'token', 'token:software:totp', 'token:hotp', 'token:hardware', 'question', 'push', 'u2f', 'password', 'assertion:saml2', 'assertion:oidc', 'claims_provider', 'webauthn']
    },
    provider: {
      type: 'string',
      values: ['OKTA', 'RSA', 'DEL_OATH', 'SYMANTEC', 'GOOGLE', 'YUBICO', 'FIDO', 'CUSTOM', 'GENERIC_SAML', 'GENERIC_OIDC']
    },
    enrollment: {
      type: 'string',
      values: ['OPTIONAL', 'REQUIRED']
    },
    status: {
      type: 'string',
      values: ['NOT_SETUP', 'ACTIVE']
    },
    profile: ['object'],
    vendorName: 'string',
    policy: ['object'],
    profiles: ['object']
  },
  local: {
    answer: 'string',
    password: 'string',
    backupFactor: 'object',
    showAnswer: 'boolean',
    rememberDevice: 'boolean',
    autoPush: ['boolean', true, false]
  },
  derived: {
    isOktaFactor: {
      deps: ['provider'],
      fn: function fn(provider) {
        return provider === 'OKTA';
      }
    },
    factorName: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorName
    },
    factorLabel: {
      deps: ['provider', 'factorType', 'vendorName'],
      fn: function fn(provider, factorType, vendorName) {
        if (_okta._.contains(['DEL_OATH', 'GENERIC_SAML', 'GENERIC_OIDC', 'CUSTOM'], provider)) {
          return vendorName;
        }

        return _FactorUtil.default.getFactorLabel.apply(this, [provider, factorType]);
      }
    },
    factorDescription: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorDescription
    },
    sortOrder: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorSortOrder
    },
    iconClassName: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorIconClassName
    },
    securityQuestion: {
      deps: ['profile', 'factorType'],
      fn: function fn(profile, factorType) {
        if (factorType !== 'question') {
          return null;
        }

        return profile && _FactorUtil.default.getSecurityQuestionLabel(profile);
      }
    },
    phoneNumber: {
      deps: ['profile', 'factorType'],
      fn: function fn(profile, factorType) {
        if (_okta._.contains(['sms', 'call'], factorType)) {
          return profile && profile.phoneNumber;
        }

        return null;
      }
    },
    email: {
      deps: ['profile', 'factorType'],
      fn: function fn(profile, factorType) {
        if (factorType === 'email') {
          return profile && profile.email;
        }

        return null;
      }
    },
    deviceName: {
      deps: ['profile', 'factorType'],
      fn: function fn(profile, factorType) {
        if (factorType !== 'push') {
          return null;
        }

        return profile && profile.name;
      }
    },
    enrolled: {
      deps: ['status'],
      fn: function fn(status) {
        return status === 'ACTIVE';
      }
    },
    cardinality: {
      deps: ['policy', 'profiles'],
      fn: function fn(policy, profiles) {
        if (profiles && profiles.length > 0) {
          var profile = profiles[0]; //assume for now we only get one profile (multiple profiles are not supported yet)

          var enrolled = profile._embedded.enrolledFactors.length;

          var adoption = _okta._.findWhere(profile._embedded.features, {
            type: 'adoption'
          });

          if (adoption && adoption.cardinality) {
            return {
              enrolled: enrolled,
              minimum: adoption.cardinality.min,
              maximum: adoption.cardinality.max
            };
          }

          return false;
        } else if (policy && policy.enrollment) {
          return policy.enrollment;
        } else {
          return false;
        }
      }
    },
    additionalEnrollment: {
      deps: ['cardinality'],
      fn: function fn(cardinality) {
        if (cardinality) {
          return cardinality.enrolled !== 0 && cardinality.enrolled < cardinality.maximum;
        } else {
          return false;
        }
      }
    },
    required: {
      deps: ['enrollment'],
      fn: function fn(enrollment) {
        return enrollment === 'REQUIRED';
      }
    },
    canUseResend: {
      deps: ['provider', 'factorType'],
      fn: function fn(provider, factorType) {
        // Only push, sms and call have resend links.
        return provider === 'OKTA' && _okta._.contains(['push', 'sms', 'call', 'email'], factorType);
      }
    },
    isAnswerRequired: {
      deps: ['factorType'],
      fn: function fn(factorType) {
        return _okta._.contains(['sms', 'call', 'email', 'token', 'token:software:totp', 'question'], factorType);
      }
    },
    isFactorTypeVerification: {
      deps: ['provider', 'id'],
      fn: function fn(provider, id) {
        return provider === undefined && id === undefined;
      }
    }
  },
  parse: function parse(attributes) {
    this.settings = attributes.settings;
    this.appState = attributes.appState; // set the initial value for remember device.

    attributes.rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState); // Add vendorname for custom totp enroll

    this.setCustomHotpVendorName(attributes);
    return _okta._.omit(attributes, ['settings', 'appState']);
  },
  validate: function validate() {
    if (this.get('isAnswerRequired') && !this.get('answer')) {
      return {
        answer: (0, _okta.loc)('model.validation.field.blank')
      };
    } else if (this.get('factorType') === 'password' && !this.get('password')) {
      return {
        password: (0, _okta.loc)('error.password.required')
      };
    }
  },
  needsPasscode: function needsPasscode() {
    // we don't need passcode for email with magic link flow
    return !(this.options.appState.get('isIdxStateToken') && this.get('factorType') === 'email');
  },
  resend: function resend() {
    this.trigger('form:clear-errors');
    return this.manageTransaction(function (transaction) {
      var firstLink = transaction.data._links.resend[0];
      return transaction.resend(firstLink.name);
    });
  },
  save: function save() {
    var rememberDevice = !!this.get('rememberDevice');
    var self = this; // Set/Remove the remember device cookie based on the remember device input.

    return this.manageTransaction(function (transaction, setTransaction) {
      var data = {
        rememberDevice: rememberDevice
      };

      if (this.get('factorType') === 'question') {
        data.answer = this.get('answer');
      } else if (this.get('factorType') === 'password') {
        data.password = this.get('password');
      } else if (this.needsPasscode()) {
        data.passCode = this.get('answer');
      }

      if (this.pushFactorHasAutoPush()) {
        data.autoPush = this.get('autoPush');
      }

      var promise; // MFA_REQUIRED, FACTOR_REQUIRED or UNAUTHENTICATED with factors (passwordlessAuth)

      if (transaction.status === 'MFA_REQUIRED' || transaction.status === 'FACTOR_REQUIRED' || this.appState.get('promptForFactorInUnauthenticated')) {
        var factor = this._findFactor(transaction);

        promise = factor.verify(data);
      } else if (this.get('canUseResend') && !this.get('answer') && transaction.resend) {
        // MFA_CHALLENGE/ FACTOR_CHALLENGE
        var firstLink = transaction.data._links.resend[0];
        promise = transaction.resend(firstLink.name);
      } else {
        promise = transaction.verify(data);
      } //the 'save' event here is triggered and used in the BaseLoginController
      //to disable the primary button on the factor form


      this.trigger('save');
      return promise.then(function (trans) {
        var options = {
          delay: PUSH_INTERVAL,
          transactionCallBack: function transactionCallBack(transaction) {
            self.options.appState.set('lastAuthResponse', transaction);
          }
        };
        setTransaction(trans); // In Okta verify case we initiate poll.

        if (trans.status === 'MFA_CHALLENGE' && trans.poll || trans.status === 'FACTOR_CHALLENGE' && trans.poll) {
          var deferred = _q.default.defer();

          var initiatePollTimout = _Util.default.callAfterTimeout(deferred.resolve, PUSH_INTERVAL);

          self.listenToOnce(self.options.appState, 'factorSwitched', function () {
            clearTimeout(initiatePollTimout);
            deferred.reject(new _Errors.default.AuthStopPollInitiationError());
          });
          return deferred.promise.then(function () {
            // Stop listening if factor was not switched before poll.
            self.stopListening(self.options.appState, 'factorSwitched');

            if (self.pushFactorHasAutoPush()) {
              options.autoPush = function () {
                return self.get('autoPush');
              };

              options.rememberDevice = function () {
                return self.get('rememberDevice');
              };
            }

            return trans.poll(options).then(function (trans) {
              self.options.appState.set('lastAuthResponse', trans.data);
              setTransaction(trans);
            });
          });
        }
      });
    });
  },
  _findFactor: function _findFactor(transaction) {
    var factor;

    if (transaction.factorTypes) {
      factor = _okta._.findWhere(transaction.factorTypes, {
        factorType: this.get('factorType')
      });
    }

    if (!factor) {
      factor = _okta._.findWhere(transaction.factors, {
        id: this.get('id')
      });
    }

    return factor;
  },
  pushFactorHasAutoPush: function pushFactorHasAutoPush() {
    return this.settings.get('features.autoPush') && this.get('factorType') === 'push';
  },
  setCustomHotpVendorName: function setCustomHotpVendorName(attributes) {
    // If factor is token:hotp and not enrolled, we assume the first profile is the default.
    // If factor is enrolled, we only support one profile to be enrolled, so find that one
    // and display as enrolled profile. We do this by populating profile name in vendorName.
    if (attributes.factorType === 'token:hotp' && attributes.profiles) {
      if (attributes.status === 'NOT_SETUP') {
        attributes.vendorName = attributes.profiles[0].name;
      } else if (attributes.status === 'ACTIVE') {
        var _context;

        var enrolledProfiles = (0, _filter.default)(_context = attributes.profiles).call(_context, function (profile) {
          return profile._embedded.enrolledFactors.length > 0;
        });
        attributes.vendorName = enrolledProfiles[0].name;
      }
    }

    return attributes;
  }
});

var FactorFactors = _okta.Collection.extend({
  model: FactorFactor,
  comparator: 'sortOrder',
  // One override necessary here - When Okta Verify OTP and Push are in the list,
  // they are presented in the view as one factor - in the beacon menu,
  // there's only one option (Okta Verify), and we show a form with Push
  // with an inline totp option. What we need to do is to add totp
  // as a "backupFactor" for push
  parse: function parse(factors) {
    // Keep a track of the last used factor, since
    // we need it to determine the default factor.
    this.lastUsedFactor = factors[0];

    var oktaPushFactor = _okta._.findWhere(factors, {
      provider: 'OKTA',
      factorType: 'push'
    });

    var totpFactor;

    if (_okta._.where(factors, {
      factorType: 'push'
    }).length > 1) {
      totpFactor = _okta._.findWhere(factors, {
        factorType: 'token:software:totp'
      });
    } else {
      totpFactor = _okta._.findWhere(factors, {
        provider: 'OKTA',
        factorType: 'token:software:totp'
      });
    }

    if (!oktaPushFactor || !totpFactor) {
      return factors;
    }

    var isTotpFirst = totpFactor === factors[0];
    var parsedFactors = (0, _reduce.default)(_okta._).call(_okta._, factors, function (memo, factor) {
      var isOkta = factor.provider === 'OKTA';
      var isOktaTotp = isOkta && factor.factorType === 'token:software:totp';
      var isOktaPush = isOkta && factor.factorType === 'push';
      var notEnrolled = factor.status !== 'ACTIVE';
      var hideOktaTotp = isOktaTotp && (notEnrolled || oktaPushFactor.status === 'ACTIVE');
      var hideOktaPush = isOktaPush && notEnrolled && totpFactor.status === 'ACTIVE';

      if (hideOktaTotp || hideOktaPush) {
        return memo;
      }

      if (isOktaPush) {
        factor.backupFactor = new FactorFactor(totpFactor, {
          parse: true
        });
      }

      memo.push(factor);
      return memo;
    }, []); // Use push factor instead of TOTP, if TOTP is first in the list
    // (since it is stored as backupFactor for push).

    if (isTotpFirst) {
      this.lastUsedFactor = oktaPushFactor;
    }

    return parsedFactors;
  },
  // Will need to update this to use HAL link to get last used factor:
  // https://oktainc.atlassian.net/browse/OKTA-58380
  // However, current code returns last used factor as first factor in list.
  // Also, will need to add priority - i.e. if they do not have a last used
  // factor, should try Okta Verify, then Okta SMS, etc.
  getDefaultFactor: function getDefaultFactor() {
    var factor = _okta._.pick(this.lastUsedFactor, 'factorType', 'provider');

    return this.findWhere(factor);
  },
  getFirstUnenrolledRequiredFactor: function getFirstUnenrolledRequiredFactor() {
    return this.findWhere({
      required: true,
      enrolled: false
    });
  },
  _getFactorsOfType: function _getFactorsOfType(factorType) {
    return this.where({
      factorType: factorType
    });
  },
  getFactorIndex: function getFactorIndex(factorType, factorId) {
    var _context2;

    return (0, _findIndex.default)(_context2 = this._getFactorsOfType(factorType)).call(_context2, function (factor) {
      return factor.get('id') === factorId;
    });
  },
  hasMultipleFactorsOfSameType: function hasMultipleFactorsOfSameType(factorType) {
    return this._getFactorsOfType(factorType).length > 1;
  },
  getFactorByTypeAndIndex: function getFactorByTypeAndIndex(factorType, factorIndex) {
    return this._getFactorsOfType(factorType)[factorIndex];
  }
});

var _default = {
  Model: FactorFactor,
  Collection: FactorFactors
};
exports.default = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _reduce = _interopRequireDefault(__webpack_require__(140));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* global Uint8Array */
var fn = {};
/**
 * Light weight hashing algorithm that hashes string into an integer between 0 and 4294967295
 * Not recommended for data set of size greater than 10000
 * https://www.npmjs.com/package/string-hash
 *
 * @param str the string to be hashed
 * @returns string hash of integer type
 */

fn.getStringHash = function (str) {
  var hash = 5381;
  var i = str.length;

  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }

  return hash >>> 0;
};
/**
 * Converts any url safe characters in a base64 string to regular base64 characters
 * @param str base64 string that might contain url safe characters
 * @returns base64 formatted string
 */


fn.base64UrlSafeToBase64 = function (str) {
  return str.replace(new RegExp('_', 'g'), '/').replace(new RegExp('-', 'g'), '+');
};
/**
 * Converts an ArrayBuffer object that contains binary data to base64 encoded string
 * @param bin ArrayBuffer object
 * @returns base64 encoded string
 */


fn.binToStr = function (bin) {
  var _context;

  return btoa((0, _reduce.default)(_context = new Uint8Array(bin)).call(_context, function (s, byte) {
    return s + String.fromCharCode(byte);
  }, ''));
};
/**
 * Converts base64 string to binary data view
 * @param str in base64 or base64UrlSafe format
 * @returns converted Uint8Array view of binary data
 */


fn.strToBin = function (str) {
  return Uint8Array.from(atob(this.base64UrlSafeToBase64(str)), function (c) {
    return c.charCodeAt(0);
  });
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(183);
var isObject = __webpack_require__(38);
var has = __webpack_require__(59);
var defineProperty = __webpack_require__(86).f;
var uid = __webpack_require__(228);
var FREEZING = __webpack_require__(539);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Cookie = _okta.internal.util.Cookie;
var LAST_USERNAME_COOKIE_NAME = 'ln';
var DAYS_SAVE_REMEMBER = 365;
var fn = {};

fn.getCookieUsername = function () {
  return Cookie.getCookie(LAST_USERNAME_COOKIE_NAME);
};

fn.setUsernameCookie = function (username) {
  Cookie.setCookie(LAST_USERNAME_COOKIE_NAME, username, {
    expires: DAYS_SAVE_REMEMBER,
    path: '/'
  });
};

fn.removeUsernameCookie = function () {
  Cookie.removeCookie(LAST_USERNAME_COOKIE_NAME, {
    path: '/'
  });
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "linkClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 24
          },
          "end": {
            "line": 1,
            "column": 41
          }
        }
      }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "linkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 78
          }
        }
      }) : helper)) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  events: {
    'click a[data-se="signout-link"]': 'handleSignout'
  },
  handleSignout: function handleSignout(e) {
    var _this = this;

    e.preventDefault();
    var appState = this.options.appState;
    appState.trigger('signOut');
    var isSMSPasswordRecovery = appState.get('isSMSPasswordRecovery');
    this.model.doTransaction(function (transaction) {
      return transaction.cancel();
    }).then(function () {
      if (_this.settings.get('signOutLink') && !isSMSPasswordRecovery) {
        Util.redirect(_this.settings.get('signOutLink'));
      } else {
        _this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);

        appState.trigger('navigate', '');
      }
    });
  },
  getTemplateData: function getTemplateData() {
    return {
      linkClassName: _okta._.isUndefined(this.options.linkClassName) ? 'goto' : this.options.linkClassName,
      linkText: this.options.linkText || (0, _okta.loc)('goback', 'login')
    };
  }
});

exports.default = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _q = _interopRequireDefault(__webpack_require__(43));

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-statements: [2, 15] */
var SWAP_PAGE_TIME = 200;
var fn = {};

function zoom($el, start, finish) {
  var deferred = _q.default.defer();

  $el.animate({
    'text-indent': 1
  }, {
    duration: 200,
    easing: 'swing',
    step: function step(now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css('transform', 'scale(' + now + ', ' + now + ')');
    },
    always: function always() {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
}

function rotate($el, start, finish) {
  var deferred = _q.default.defer();

  $el.animate({
    'text-indent': 1
  }, {
    duration: 150,
    easing: 'swing',
    step: function step(now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css('transform', 'rotate(' + now + 'deg)');
    },
    always: function always() {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
} // Note: It is necessary to pass in a success callback because we must
// remove the old dom node (and controller) in the same tick of the event
// loop. Waiting for "then" results in a glitchy animation.


fn.swapPages = function (options) {
  var deferred = _q.default.defer();

  var $parent = options.$parent;
  var $oldRoot = options.$oldRoot;
  var $newRoot = options.$newRoot;
  var success = options.success;
  var ctx = options.ctx;
  var directionClassName = 'transition-from-right';

  if (options.dir && options.dir === _Enums.default.DIRECTION_BACK) {
    directionClassName = 'transition-from-left';
  }

  $newRoot.addClass(directionClassName);
  $parent.append($newRoot);
  $parent.addClass('animation-container-overflow');
  $newRoot.animate({
    left: '0px',
    top: '0px',
    opacity: 1
  }, SWAP_PAGE_TIME, function () {
    $parent.removeClass('animation-container-overflow');
    $newRoot.removeClass(directionClassName);
    $newRoot.removeAttr('style');
    success.call(ctx);
    deferred.resolve();
  });
  $oldRoot.animate({
    height: $newRoot.height(),
    opacity: 0
  }, SWAP_PAGE_TIME * 0.8);
  return deferred.promise;
};

fn.swapBeacons = function (options) {
  var $el = options.$el;
  var swap = options.swap;
  var ctx = options.ctx;
  return this.implode($el).then(function () {
    swap.call(ctx);
    return $el;
  }).then(this.explode);
};

fn.explode = function ($el) {
  return zoom($el, 0, 1); //zoom in
};

fn.implode = function ($el) {
  return zoom($el, 1, 0); //zoom out
};

fn.radialProgressBar = function (options) {
  var radialProgressBar = options.$el;
  var swap = options.swap;
  var circles = radialProgressBar.children();
  return rotate(circles, 0, 180).then(function () {
    radialProgressBar.css({
      clip: 'auto'
    });
  }).then(function () {
    var leftHalf = circles.eq(0);
    swap();
    return rotate(leftHalf, 180, 360);
  }).then(function () {
    //reset values to initial state
    radialProgressBar.css({
      clip: 'rect(0px, 96px, 96px, 48px)'
    });
    circles.css({
      transform: 'rotate(0deg)',
      'text-indent': '1px'
    });
  });
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(563);
var requireObjectCoercible = __webpack_require__(249);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(162);
var IE8_DOM_DEFINE = __webpack_require__(566);
var anObject = __webpack_require__(164);
var toPrimitive = __webpack_require__(564);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 252 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var shared = __webpack_require__(338);
var has = __webpack_require__(163);
var uid = __webpack_require__(571);
var NATIVE_SYMBOL = __webpack_require__(574);
var USE_SYMBOL_AS_UID = __webpack_require__(1272);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$keys = __webpack_require__(255);

var _Object$getOwnPropertySymbols = __webpack_require__(343);

var _filterInstanceProperty = __webpack_require__(256);

var _Object$getOwnPropertyDescriptor = __webpack_require__(344);

var _forEachInstanceProperty2 = __webpack_require__(202);

var _Object$getOwnPropertyDescriptors = __webpack_require__(345);

var _Object$defineProperties = __webpack_require__(346);

var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.request = exports.HttpClient = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(161));

var _forEach = _interopRequireDefault(__webpack_require__(202));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(347));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(165));

var _crossFetch = _interopRequireDefault(__webpack_require__(504));

var _userAgent = __webpack_require__(1286);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty2(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty2(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Reusable interceptor interface
 */
function Interceptor() {
  this.handlers = []; // Adds a new interceptor to our HttpClient

  this.use = function (before) {
    this.handlers.push({
      before: before
    });
  }; // Clears all interceptors


  this.clear = function () {
    this.handlers = [];
  };
}
/**
 * Singleton instance of the IdX HTTP Client
 *
 * Invoke the `use` method to add a new interceptor:
 *   - client.interceptors.request.use((requestConfig) => { some logic });
 */


var HttpClient = {
  interceptors: {
    request: new Interceptor()
  }
};
exports.HttpClient = HttpClient;

var request = /*#__PURE__*/function () {
  var _request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(target, _ref) {
    var _ref$method, method, _ref$headers, headers, _ref$credentials, credentials, body, requestOptions, _context, url;

    return _regenerator.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref$method = _ref.method, method = _ref$method === void 0 ? 'POST' : _ref$method, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, _ref$credentials = _ref.credentials, credentials = _ref$credentials === void 0 ? 'include' : _ref$credentials, body = _ref.body;
            requestOptions = {
              url: target,
              method: method,
              headers: _objectSpread(_objectSpread({}, (0, _userAgent.userAgentHeaders)()), headers),
              credentials: credentials,
              body: body
            };

            if (HttpClient.interceptors) {
              (0, _forEach.default)(_context = HttpClient.interceptors.request.handlers).call(_context, function (interceptor) {
                interceptor.before(requestOptions);
              });
            } // Extract the URL to adhere to the fetch API


            url = requestOptions.url;
            delete requestOptions.url;
            return _context2.abrupt("return", (0, _crossFetch.default)(url, requestOptions));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  function request(_x, _x2) {
    return _request.apply(this, arguments);
  }

  return request;
}();

exports.request = request;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(456);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(487);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setInterval2 = _interopRequireDefault(__webpack_require__(194));

var _some = _interopRequireDefault(__webpack_require__(320));

var _okta = __webpack_require__(2);

var _Constants = __webpack_require__(93);

var _default = {
  startPolling: function startPolling(newRefreshInterval) {
    this.fixedPollingInterval = this.options.currentViewState.refresh;
    this.dynamicPollingInterval = newRefreshInterval;
    this.countDownCounterValue = Math.ceil(this.pollingInterval / _Constants.MS_PER_SEC); // Poll is present in remediation form

    if (this.fixedPollingInterval) {
      this._startRemediationPolling();
    } else {
      // Poll is present in authenticator/ authenticator Enrollment obj.
      // Authenticator won't co-exists hence it's safe to trigger both.
      this._startAuthenticatorPolling();
    }
  },
  _startAuthenticatorPolling: function _startAuthenticatorPolling() {
    var _context,
        _this = this;

    // Authenticator won't co-exists hence it's safe to trigger both.
    (0, _some.default)(_context = ['currentAuthenticator', 'currentAuthenticatorEnrollment']).call(_context, function (responseKey) {
      if (_this.options.appState.has(responseKey)) {
        var _authenticator$poll;

        var authenticator = _this.options.appState.get(responseKey);

        var authenticatorPollAction = "".concat(responseKey, "-poll");
        var pollInterval = _this.dynamicPollingInterval || (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$poll = authenticator.poll) === null || _authenticator$poll === void 0 ? void 0 : _authenticator$poll.refresh);

        if (_okta._.isNumber(pollInterval)) {
          _this.polling = (0, _setInterval2.default)(function () {
            _this.options.appState.trigger('invokeAction', authenticatorPollAction);
          }, pollInterval);
        }

        return true;
      } else {
        return false;
      }
    });
  },
  _startRemediationPolling: function _startRemediationPolling() {
    var _this2 = this;

    var pollInterval = this.dynamicPollingInterval || this.fixedPollingInterval;

    if (_okta._.isNumber(pollInterval)) {
      this.polling = (0, _setInterval2.default)(function () {
        _this2.options.appState.trigger('saveForm', _this2.model);
      }, pollInterval);
    }
  },
  stopPolling: function stopPolling() {
    if (this.polling) {
      clearInterval(this.polling);
      this.polling = null;
    }
  }
};
exports.default = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _AuthenticatorUtil = __webpack_require__(204);

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.password.enroll.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oform.next', 'login');
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    var policy = this.getPasswordPolicySettings();
    this.displayPasswordPolicy(policy);
  },
  displayPasswordPolicy: function displayPasswordPolicy(policy) {
    if (policy) {
      var rulesList = (0, _AuthenticatorUtil.getPasswordComplexityDescriptionForHtmlList)(policy);
      this.add(_okta.View.extend({
        tagName: 'section',
        template: _runtime.default.template({
          "1": function _(container, depth0, helpers, partials, data) {
            return "<li>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
          },
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var stack1,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<div class=\"password-authenticator--heading\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "password.complexity.requirements.header"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 45
                },
                "end": {
                  "line": 1,
                  "column": 115
                }
              }
            })) + "</div><ul class=\"password-authenticator--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "rulesList") : depth0, {
              "name": "each",
              "hash": {},
              "fn": container.program(1, data, 0),
              "inverse": container.noop,
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 162
                },
                "end": {
                  "line": 1,
                  "column": 207
                }
              }
            })) != null ? stack1 : "") + "</ul>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            rulesList: rulesList
          };
        },
        attributes: {
          'data-se': 'password-authenticator--rules'
        }
      }), {
        prepend: true,
        selector: '.o-form-fieldset-container'
      });
    }
  },
  triggerAfterError: function triggerAfterError(model, error) {
    error.responseJSON = (0, _AuthenticatorUtil.removeRequirementsFromError)(error.responseJSON);
    this.options.appState.trigger('afterError', error);
  },
  getPasswordPolicySettings: function getPasswordPolicySettings() {
    var _relatesToObject$valu;

    // This will be overridden by following scenario since the policies could be different for those.
    // - password reset (`ReEnrollAuthenticatorPasswordView.js`)
    //
    var relatesToObject = this.options.currentViewState.relatesTo;
    return relatesToObject === null || relatesToObject === void 0 ? void 0 : (_relatesToObject$valu = relatesToObject.value) === null || _relatesToObject$valu === void 0 ? void 0 : _relatesToObject$valu.settings;
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    return (0, _concat.default)(uiSchemas).call(uiSchemas, [{
      name: 'confirmPassword',
      label: (0, _okta.loc)('oie.password.confirmPasswordLabel', 'login'),
      type: 'password',
      'label-top': true,
      params: {
        showPasswordToggle: this.settings.get('showPasswordToggle')
      }
    }]);
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass() {
    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      confirmPassword: {
        type: 'string',
        required: true
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local,
      validate: function validate() {
        if (this.get('credentials.passcode') !== this.get('confirmPassword') && this.get('credential.value') !== this.get('confirmPassword')) {
          var errors = {
            'confirmPassword': (0, _okta.loc)('password.error.match', 'login')
          };
          return errors;
        } else {
          return null;
        }
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var isObject = __webpack_require__(15);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var createNonEnumerableProperty = __webpack_require__(50);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(262);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var setGlobal = __webpack_require__(260);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(72);
var store = __webpack_require__(262);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.9.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(63);
var getOwnPropertyNamesModule = __webpack_require__(123);
var getOwnPropertySymbolsModule = __webpack_require__(266);
var anObject = __webpack_require__(16);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 266 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var IS_NODE = __webpack_require__(124);
var V8_VERSION = __webpack_require__(143);
var fails = __webpack_require__(6);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  /* global Symbol -- required for testing */
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (IS_NODE ? V8_VERSION === 38 : V8_VERSION > 37 && V8_VERSION < 41);
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var definePropertyModule = __webpack_require__(25);
var anObject = __webpack_require__(16);
var objectKeys = __webpack_require__(173);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(20);
var Iterators = __webpack_require__(175);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(20);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(109);
var toLength = __webpack_require__(22);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createIteratorConstructor = __webpack_require__(274);
var getPrototypeOf = __webpack_require__(74);
var setPrototypeOf = __webpack_require__(111);
var setToStringTag = __webpack_require__(82);
var createNonEnumerableProperty = __webpack_require__(50);
var redefine = __webpack_require__(51);
var wellKnownSymbol = __webpack_require__(20);
var IS_PURE = __webpack_require__(72);
var Iterators = __webpack_require__(175);
var IteratorsCore = __webpack_require__(374);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(374).IteratorPrototype;
var create = __webpack_require__(94);
var createPropertyDescriptor = __webpack_require__(100);
var setToStringTag = __webpack_require__(82);
var Iterators = __webpack_require__(175);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(180);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(20);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var exec = __webpack_require__(215);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(22);
var repeat = __webpack_require__(279);
var requireObjectCoercible = __webpack_require__(49);

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(73);
var requireObjectCoercible = __webpack_require__(49);

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);
var whitespaces = __webpack_require__(219);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),
/* 281 */
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var fails = __webpack_require__(6);
var bind = __webpack_require__(110);
var html = __webpack_require__(364);
var createElement = __webpack_require__(259);
var IS_IOS = __webpack_require__(388);
var IS_NODE = __webpack_require__(124);

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(9);
var fails = __webpack_require__(6);
var checkCorrectnessOfIteration = __webpack_require__(209);
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(21).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var isObject = __webpack_require__(38);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(83);
var toLength = __webpack_require__(66);
var toAbsoluteIndex = __webpack_require__(288);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(148);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(860);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(87);
var store = __webpack_require__(401);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(34);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 294 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__setup_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restArguments_js__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__restArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_2__isObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isNull_js__ = __webpack_require__(866);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_3__isNull_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isElement_js__ = __webpack_require__(867);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_6__isElement_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isString_js__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_7__isString_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isNumber_js__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_8__isNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isDate_js__ = __webpack_require__(868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_9__isDate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__ = __webpack_require__(869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isError_js__ = __webpack_require__(870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_11__isError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isDataView_js__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_14__isDataView_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_15__isArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isFunction_js__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_16__isFunction_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isArguments_js__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_17__isArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isFinite_js__ = __webpack_require__(872);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_18__isFinite_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isNaN_js__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_19__isNaN_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__ = __webpack_require__(874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isMatch_js__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_22__isMatch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isEqual_js__ = __webpack_require__(875);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_23__isEqual_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isMap_js__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_24__isMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__ = __webpack_require__(878);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isSet_js__ = __webpack_require__(879);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_26__isSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__ = __webpack_require__(880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__keys_js__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_28__keys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__allKeys_js__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_29__allKeys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__values_js__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_30__values_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pairs_js__ = __webpack_require__(881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_31__pairs_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__invert_js__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_32__invert_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__functions_js__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__extend_js__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_34__extend_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__defaults_js__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_36__defaults_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__create_js__ = __webpack_require__(882);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_37__create_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__clone_js__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_38__clone_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tap_js__ = __webpack_require__(883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_39__tap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__get_js__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_40__get_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__has_js__ = __webpack_require__(884);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_41__has_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__mapObject_js__ = __webpack_require__(885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_42__mapObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__identity_js__ = __webpack_require__(304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_43__identity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__constant_js__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_44__constant_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__noop_js__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_45__noop_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__toPath_js__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_46__toPath_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__property_js__ = __webpack_require__(305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_47__property_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__matcher_js__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__times_js__ = __webpack_require__(887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_50__times_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__random_js__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_51__random_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__now_js__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_52__now_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__escape_js__ = __webpack_require__(888);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_53__escape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__unescape_js__ = __webpack_require__(889);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_54__unescape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__template_js__ = __webpack_require__(891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_56__template_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__result_js__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_57__result_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__ = __webpack_require__(893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__chain_js__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_59__chain_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__iteratee_js__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_60__iteratee_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__partial_js__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_61__partial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__bind_js__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_62__bind_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__bindAll_js__ = __webpack_require__(895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_63__bindAll_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__memoize_js__ = __webpack_require__(896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_64__memoize_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__delay_js__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_65__delay_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__defer_js__ = __webpack_require__(897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_66__defer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__throttle_js__ = __webpack_require__(898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_67__throttle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__debounce_js__ = __webpack_require__(899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_68__debounce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__wrap_js__ = __webpack_require__(900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_69__wrap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__negate_js__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_70__negate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__compose_js__ = __webpack_require__(901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_71__compose_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__after_js__ = __webpack_require__(902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_72__after_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__before_js__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_73__before_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__once_js__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_74__once_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__findKey_js__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_75__findKey_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__findIndex_js__ = __webpack_require__(308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_76__findIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__indexOf_js__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_79__indexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__ = __webpack_require__(904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__find_js__ = __webpack_require__(442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__findWhere_js__ = __webpack_require__(905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_82__findWhere_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__each_js__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__map_js__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__reduce_js__ = __webpack_require__(906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__ = __webpack_require__(907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__filter_js__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__reject_js__ = __webpack_require__(908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_88__reject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__every_js__ = __webpack_require__(909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__some_js__ = __webpack_require__(910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__contains_js__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__invoke_js__ = __webpack_require__(911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_92__invoke_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__pluck_js__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_93__pluck_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__where_js__ = __webpack_require__(912);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_94__where_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__max_js__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_95__max_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__min_js__ = __webpack_require__(913);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_96__min_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__shuffle_js__ = __webpack_require__(914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_97__shuffle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__sample_js__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_98__sample_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__sortBy_js__ = __webpack_require__(915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_99__sortBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__groupBy_js__ = __webpack_require__(916);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_100__groupBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__indexBy_js__ = __webpack_require__(917);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_101__indexBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__countBy_js__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_102__countBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__partition_js__ = __webpack_require__(919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_103__partition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__toArray_js__ = __webpack_require__(920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_104__toArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__size_js__ = __webpack_require__(921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_105__size_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__pick_js__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_106__pick_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__omit_js__ = __webpack_require__(923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_107__omit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__first_js__ = __webpack_require__(924);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__initial_js__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_109__initial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__last_js__ = __webpack_require__(925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_110__last_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__rest_js__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__compact_js__ = __webpack_require__(926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_112__compact_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__flatten_js__ = __webpack_require__(927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_113__flatten_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__without_js__ = __webpack_require__(928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_114__without_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__uniq_js__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__union_js__ = __webpack_require__(929);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_116__union_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__intersection_js__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_117__intersection_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__difference_js__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_118__difference_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__unzip_js__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__zip_js__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_120__zip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__object_js__ = __webpack_require__(932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_121__object_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__range_js__ = __webpack_require__(933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_122__range_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__chunk_js__ = __webpack_require__(934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_123__chunk_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__mixin_js__ = __webpack_require__(935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_124__mixin_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__ = __webpack_require__(936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__["a"]; });
// Named Exports
// =============

//     Underscore.js 1.13.1
//     https://underscorejs.org
//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

// Baseline setup.



// Object Functions
// ----------------
// Our most fundamental functions operate on any JavaScript object.
// Most functions in Underscore depend on at least one function in this section.

// A group of functions that check the types of core JavaScript values.
// These are often informally referred to as the "isType" functions.



























// Functions that treat an object as a dictionary of key-value pairs.
















// Utility Functions
// -----------------
// A bit of a grab bag: Predicate-generating functions for use with filters and
// loops, string escaping and templating, create random numbers and unique ids,
// and functions that facilitate Underscore's chaining and iteration conventions.



















// Function (ahem) Functions
// -------------------------
// These functions take a function as an argument and return a new function
// as the result. Also known as higher-order functions.















// Finders
// -------
// Functions that extract (the position of) a single element from an object
// or array based on some criterion.









// Collection Functions
// --------------------
// Functions that work on any collection of elements: either an array, or
// an object of key-value pairs.
























// `_.pick` and `_.omit` are actually object functions, but we put
// them here in order to create a more natural reading order in the
// monolithic build as they depend on `_.contains`.



// Array Functions
// ---------------
// Functions that operate on arrays (and array-likes) only, because they’re
// expressed in terms of operations on an ordered list of values.

















// OOP
// ---
// These modules support the "object-oriented" calling style. See also
// `underscore.js` and `index-default.js`.




/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('String'));


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__ = __webpack_require__(184);





var isDataView = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('DataView');

// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function ie10IsDataView(obj) {
  return obj != null && Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj.getInt8) && Object(__WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__["a" /* default */])(obj.buffer);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__["a" /* hasStringTagBug */] ? ie10IsDataView : isDataView);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(116);



var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(obj, 'callee');
    };
  }
}());

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(414);


// Internal helper to obtain the `byteLength` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('byteLength'));


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ie11fingerprint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return weakMapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setMethods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__allKeys_js__ = __webpack_require__(185);




// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods) {
  var length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(methods);
  return function(obj) {
    if (obj == null) return false;
    // `Map`, `WeakMap` and `Set` have no enumerable keys.
    var keys = Object(__WEBPACK_IMPORTED_MODULE_2__allKeys_js__["a" /* default */])(obj);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(keys)) return false;
    for (var i = 0; i < length; i++) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[methods[i]])) return false;
    }
    // If we are testing against `WeakMap`, we need to ensure that
    // `obj` doesn't have a `forEach` method in order to distinguish
    // it from a regular `Map`.
    return methods !== weakMapMethods || !Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[forEachName]);
  };
}

// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName = 'forEach',
    hasName = 'has',
    commonInit = ['clear', 'delete'],
    mapTail = ['get', hasName, 'set'];

// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods = commonInit.concat(forEachName, mapTail),
    weakMapMethods = commonInit.concat(mapTail),
    setMethods = ['add'].concat(commonInit, forEachName, hasName);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAssigner;
// An internal function for creating assigner functions.
function createAssigner(keysFunc, defaults) {
  return function(obj) {
    var length = arguments.length;
    if (defaults) obj = Object(obj);
    if (length < 2 || obj == null) return obj;
    for (var index = 1; index < length; index++) {
      var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
      for (var i = 0; i < l; i++) {
        var key = keys[i];
        if (!defaults || obj[key] === void 0) obj[key] = source[key];
      }
    }
    return obj;
  };
}


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(47);



// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]));


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepGet;
// Internal function to obtain a nested property in `obj` along `path`.
function deepGet(obj, path) {
  var length = path.length;
  for (var i = 0; i < length; i++) {
    if (obj == null) return void 0;
    obj = obj[path[i]];
  }
  return length ? obj : void 0;
}


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
// Keep the identity function around for default iteratees.
function identity(value) {
  return value;
}


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = property;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deepGet_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(186);



// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  return function(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__deepGet_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A (possibly faster) way to get the current timestamp as an integer.
/* harmony default export */ __webpack_exports__["a"] = (Date.now || function() {
  return new Date().getTime();
});


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = negate;
// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(437);


// Returns the first index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(1));


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__property_js__ = __webpack_require__(305);



// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj, key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__property_js__["a" /* default */])(key));
}


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var definePropertyModule = __webpack_require__(86);
var anObject = __webpack_require__(53);
var objectKeys = __webpack_require__(182);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(34);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var aPossiblePrototype = __webpack_require__(950);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(469);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(34);

exports.f = wellKnownSymbol;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(479);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var userAgent = __webpack_require__(317);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(96);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 318 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(404);
var enumBugKeys = __webpack_require__(293);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1020);

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1049);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(131);
var whitespaces = __webpack_require__(236);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1054);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1069);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v1.12.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2017-10-25T15:48Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var deletedIds = [];

var document = window.document;

var slice = deletedIds.slice;

var concat = deletedIds.concat;

var push = deletedIds.push;

var indexOf = deletedIds.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "1.12.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1, IE<9
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: deletedIds.sort,
	splice: deletedIds.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var src, copyIsArray, copy, name, options, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				// Prevent Object.prototype pollution to avoid CVE-2019-11358 vulnerability
				// https://oktainc.atlassian.net/browse/OKTA-277796
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type( obj ) === "array";
	},

	isWindow: function( obj ) {
		/* jshint eqeqeq: false */
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	isPlainObject: function( obj ) {
		var key;

		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {

			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
		} catch ( e ) {

			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Support: IE<9
		// Handle iteration over inherited properties before own properties.
		if ( !support.ownFirst ) {
			for ( key in obj ) {
				return hasOwn.call( obj, key );
			}
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && jQuery.trim( data ) ) {

			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1, IE<9
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		var len;

		if ( arr ) {
			if ( indexOf ) {
				return indexOf.call( arr, elem, i );
			}

			len = arr.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {

				// Skip accessing in sparse arrays
				if ( i in arr && arr[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		while ( j < len ) {
			first[ i++ ] = second[ j++ ];
		}

		// Support: IE<9
		// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
		if ( len !== len ) {
			while ( second[ j ] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var args, proxy, tmp;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: function() {
		return +( new Date() );
	},

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			ret = [],
			self = this,
			len = self.length;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// init accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector.charAt( 0 ) === "<" &&
				selector.charAt( selector.length - 1 ) === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {

						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[ 2 ] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof root.ready !== "undefined" ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var i,
			targets = jQuery( target, this ),
			len = targets.length;

		return this.filter( function() {
			for ( i = 0; i < len; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[ 0 ], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem, this );
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	do {
		cur = cur[ dir ];
	} while ( cur && cur.nodeType !== 1 );

	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				ret = jQuery.uniqueSort( ret );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				ret = ret.reverse();
			}
		}

		return this.pushStack( ret );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = true;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );

					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// if we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * Clean-up method for dom ready events
 */
function detach() {
	if ( document.addEventListener ) {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );

	} else {
		document.detachEvent( "onreadystatechange", completed );
		window.detachEvent( "onload", completed );
	}
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {

	// readyState === "complete" is good enough for us to call the dom ready in oldIE
	if ( document.addEventListener ||
		window.event.type === "load" ||
		document.readyState === "complete" ) {

		detach();
		jQuery.ready();
	}
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE6-10
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		// Standards-based browsers support DOMContentLoaded
		} else if ( document.addEventListener ) {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );

		// If IE event model is used
		} else {

			// Ensure firing before onload, maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", completed );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", completed );

			// If IE and not a frame
			// continually check to see if the document is ready
			var top = false;

			try {
				top = window.frameElement == null && document.documentElement;
			} catch ( e ) {}

			if ( top && top.doScroll ) {
				( function doScrollCheck() {
					if ( !jQuery.isReady ) {

						try {

							// Use the trick by Diego Perini
							// http://javascript.nwbox.com/IEContentLoaded/
							top.doScroll( "left" );
						} catch ( e ) {
							return window.setTimeout( doScrollCheck, 50 );
						}

						// detach all dom ready events
						detach();

						// and execute any waiting functions
						jQuery.ready();
					}
				} )();
			}
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Support: IE<9
// Iteration over object's inherited properties before its own
var i;
for ( i in jQuery( support ) ) {
	break;
}
support.ownFirst = i === "0";

// Note: most support tests are defined in their respective modules.
// false until the test is run
support.inlineBlockNeedsLayout = false;

// Execute ASAP in case we need to set body.style.zoom
jQuery( function() {

	// Minified: var a,b,c,d
	var val, div, body, container;

	body = document.getElementsByTagName( "body" )[ 0 ];
	if ( !body || !body.style ) {

		// Return for frameset docs that don't have a body
		return;
	}

	// Setup
	div = document.createElement( "div" );
	container = document.createElement( "div" );
	container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
	body.appendChild( container ).appendChild( div );

	if ( typeof div.style.zoom !== "undefined" ) {

		// Support: IE<8
		// Check if natively block-level elements act like inline-block
		// elements when setting their display to 'inline' and giving
		// them layout
		div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";

		support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
		if ( val ) {

			// Prevent IE 6 from affecting layout for positioned elements #11048
			// Prevent IE from shrinking the body in IE 7 mode #12869
			// Support: IE<8
			body.style.zoom = 1;
		}
	}

	body.removeChild( container );
} );


( function() {
	var div = document.createElement( "div" );

	// Support: IE<9
	support.deleteExpando = true;
	try {
		delete div.test;
	} catch ( e ) {
		support.deleteExpando = false;
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();
var acceptData = function( elem ) {
	var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
};




var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	var name;
	for ( name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}

function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var ret, thisCache,
		internalKey = jQuery.expando,

		// We have to handle DOM nodes and JS objects differently because IE6-7
		// can't GC object references properly across the DOM-JS boundary
		isNode = elem.nodeType,

		// Only DOM nodes need the global jQuery cache; JS object data is
		// attached directly to the object so GC can occur automatically
		cache = isNode ? jQuery.cache : elem,

		// Only defining an ID for JS objects if its cache already exists allows
		// the code to shortcut on the same path as a DOM node with no cache
		id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

	// Avoid doing any more work than we need to when trying to get data on an
	// object that has no data at all
	if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
		data === undefined && typeof name === "string" ) {
		return;
	}

	if ( !id ) {

		// Only DOM nodes need a new unique ID for each element since their data
		// ends up in the global cache
		if ( isNode ) {
			id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
		} else {
			id = internalKey;
		}
	}

	if ( !cache[ id ] ) {

		// Avoid exposing jQuery metadata on plain JS objects when the object
		// is serialized using JSON.stringify
		cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
	}

	// An object can be passed to jQuery.data instead of a key/value pair; this gets
	// shallow copied over onto the existing cache
	if ( typeof name === "object" || typeof name === "function" ) {
		if ( pvt ) {
			cache[ id ] = jQuery.extend( cache[ id ], name );
		} else {
			cache[ id ].data = jQuery.extend( cache[ id ].data, name );
		}
	}

	thisCache = cache[ id ];

	// jQuery data() is stored in a separate object inside the object's internal data
	// cache in order to avoid key collisions between internal data and user-defined
	// data.
	if ( !pvt ) {
		if ( !thisCache.data ) {
			thisCache.data = {};
		}

		thisCache = thisCache.data;
	}

	if ( data !== undefined ) {
		thisCache[ jQuery.camelCase( name ) ] = data;
	}

	// Check for both converted-to-camel and non-converted data property names
	// If a data property was specified
	if ( typeof name === "string" ) {

		// First Try to find as-is property data
		ret = thisCache[ name ];

		// Test for null|undefined property data
		if ( ret == null ) {

			// Try to find the camelCased property
			ret = thisCache[ jQuery.camelCase( name ) ];
		}
	} else {
		ret = thisCache;
	}

	return ret;
}

function internalRemoveData( elem, name, pvt ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var thisCache, i,
		isNode = elem.nodeType,

		// See jQuery.data for more information
		cache = isNode ? jQuery.cache : elem,
		id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

	// If there is already no cache entry for this object, there is no
	// purpose in continuing
	if ( !cache[ id ] ) {
		return;
	}

	if ( name ) {

		thisCache = pvt ? cache[ id ] : cache[ id ].data;

		if ( thisCache ) {

			// Support array or space separated string names for data keys
			if ( !jQuery.isArray( name ) ) {

				// try the string as a key before any manipulation
				if ( name in thisCache ) {
					name = [ name ];
				} else {

					// split the camel cased version by spaces unless a key with the spaces exists
					name = jQuery.camelCase( name );
					if ( name in thisCache ) {
						name = [ name ];
					} else {
						name = name.split( " " );
					}
				}
			} else {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = name.concat( jQuery.map( name, jQuery.camelCase ) );
			}

			i = name.length;
			while ( i-- ) {
				delete thisCache[ name[ i ] ];
			}

			// If there is no data left in the cache, we want to continue
			// and let the cache object itself get destroyed
			if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
				return;
			}
		}
	}

	// See jQuery.data for more information
	if ( !pvt ) {
		delete cache[ id ].data;

		// Don't destroy the parent cache unless the internal data object
		// had been the only thing left in it
		if ( !isEmptyDataObject( cache[ id ] ) ) {
			return;
		}
	}

	// Destroy the cache
	if ( isNode ) {
		jQuery.cleanData( [ elem ], true );

	// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	/* jshint eqeqeq: false */
	} else if ( support.deleteExpando || cache != cache.window ) {
		/* jshint eqeqeq: true */
		delete cache[ id ];

	// When all else fails, undefined
	} else {
		cache[ id ] = undefined;
	}
}

jQuery.extend( {
	cache: {},

	// The following elements (space-suffixed to avoid Object.prototype collisions)
	// throw uncatchable exceptions if you attempt to set expando properties
	noData: {
		"applet ": true,
		"embed ": true,

		// ...but Flash objects (which have this classid) *can* handle expandos
		"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data ) {
		return internalData( elem, name, data );
	},

	removeData: function( elem, name ) {
		return internalRemoveData( elem, name );
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return internalData( elem, name, data, true );
	},

	_removeData: function( elem, name ) {
		return internalRemoveData( elem, name, true );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Special expections of .data basically thwart jQuery.access,
		// so implement the relevant behavior ourselves

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				jQuery.data( this, key );
			} );
		}

		return arguments.length > 1 ?

			// Sets one value
			this.each( function() {
				jQuery.data( this, key, value );
			} ) :

			// Gets one value
			// Try to fetch any internally stored data first
			elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
	},

	removeData: function( key ) {
		return this.each( function() {
			jQuery.removeData( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// not intended for public consumption - generates a queueHooks object,
	// or returns the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return jQuery._data( elem, key ) || jQuery._data( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				jQuery._removeData( elem, type + "queue" );
				jQuery._removeData( elem, key );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = jQuery._data( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );


( function() {
	var shrinkWrapBlocksVal;

	support.shrinkWrapBlocks = function() {
		if ( shrinkWrapBlocksVal != null ) {
			return shrinkWrapBlocksVal;
		}

		// Will be changed later if needed.
		shrinkWrapBlocksVal = false;

		// Minified: var b,c,d
		var div, body, container;

		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {

			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );

		// Support: IE6
		// Check if elements with layout shrink-wrap their children
		if ( typeof div.style.zoom !== "undefined" ) {

			// Reset CSS: box-sizing; display; margin; border
			div.style.cssText =

				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;" +
				"padding:1px;width:1px;zoom:1";
			div.appendChild( document.createElement( "div" ) ).style.width = "5px";
			shrinkWrapBlocksVal = div.offsetWidth !== 3;
		}

		body.removeChild( container );

		return shrinkWrapBlocksVal;
	};

} )();
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		length = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < length; i++ ) {
				fn(
					elems[ i ],
					key,
					raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			length ? fn( elems[ 0 ], key ) : emptyGet;
};
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );

var rleadingWhitespace = ( /^\s+/ );

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
		"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
		"mark|meter|nav|output|picture|progress|section|summary|template|time|video";



function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}


( function() {
	var div = document.createElement( "div" ),
		fragment = document.createDocumentFragment(),
		input = document.createElement( "input" );

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

	// IE strips leading whitespace when .innerHTML is used
	support.leadingWhitespace = div.firstChild.nodeType === 3;

	// Make sure that tbody elements aren't automatically inserted
	// IE will insert them into empty tables
	support.tbody = !div.getElementsByTagName( "tbody" ).length;

	// Make sure that link elements get serialized correctly by innerHTML
	// This requires a wrapper element in IE
	support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

	// Makes sure cloning an html5 element does not cause problems
	// Where outerHTML is undefined, this still works
	support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	input.type = "checkbox";
	input.checked = true;
	fragment.appendChild( input );
	support.appendChecked = input.checked;

	// Make sure textarea (and checkbox) defaultValue is properly cloned
	// Support: IE6-IE11+
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// #11217 - WebKit loses check when the name is after the checked attribute
	fragment.appendChild( div );

	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input = document.createElement( "input" );
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	// old WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<9
	// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
	support.noCloneEvent = !!div.addEventListener;

	// Support: IE<9
	// Since attributes and properties are the same in IE,
	// cleanData must set properties to undefined rather than use removeAttribute
	div[ jQuery.expando ] = 1;
	support.attributes = !div.getAttribute( jQuery.expando );
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {
	option: [ 1, "<select multiple='multiple'>", "</select>" ],
	legend: [ 1, "<fieldset>", "</fieldset>" ],
	area: [ 1, "<map>", "</map>" ],

	// Support: IE8
	param: [ 1, "<object>", "</object>" ],
	thead: [ 1, "<table>", "</table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
	// unless wrapped in a div with non-breaking characters in front of it.
	_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
};

// Support: IE8-IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {
	var elems, elem,
		i = 0,
		found = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
				undefined;

	if ( !found ) {
		for ( found = [], elems = context.childNodes || context;
			( elem = elems[ i ] ) != null;
			i++
		) {
			if ( !tag || jQuery.nodeName( elem, tag ) ) {
				found.push( elem );
			} else {
				jQuery.merge( found, getAll( elem, tag ) );
			}
		}
	}

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], found ) :
		found;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; ( elem = elems[ i ] ) != null; i++ ) {
		jQuery._data(
			elem,
			"globalEval",
			!refElements || jQuery._data( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/,
	rtbody = /<tbody/i;

function fixDefaultChecked( elem ) {
	if ( rcheckableType.test( elem.type ) ) {
		elem.defaultChecked = elem.checked;
	}
}

function buildFragment( elems, context, scripts, selection, ignored ) {
	var j, elem, contains,
		tmp, tag, tbody, wrap,
		l = elems.length,

		// Ensure a safe fragment
		safe = createSafeFragment( context ),

		nodes = [],
		i = 0;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || safe.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;

				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Manually add leading whitespace removed by IE
				if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
					nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
				}

				// Remove IE's autoinserted <tbody> from table fragments
				if ( !support.tbody ) {

					// String was a <table>, *may* have spurious <tbody>
					elem = tag === "table" && !rtbody.test( elem ) ?
						tmp.firstChild :

						// String was a bare <thead> or <tfoot>
						wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
							tmp :
							0;

					j = elem && elem.childNodes.length;
					while ( j-- ) {
						if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
							!tbody.childNodes.length ) {

							elem.removeChild( tbody );
						}
					}
				}

				jQuery.merge( nodes, tmp.childNodes );

				// Fix #12392 for WebKit and IE > 9
				tmp.textContent = "";

				// Fix #12392 for oldIE
				while ( tmp.firstChild ) {
					tmp.removeChild( tmp.firstChild );
				}

				// Remember the top-level container for proper cleanup
				tmp = safe.lastChild;
			}
		}
	}

	// Fix #11356: Clear elements from fragment
	if ( tmp ) {
		safe.removeChild( tmp );
	}

	// Reset defaultChecked for any radios and checkboxes
	// about to be appended to the DOM in IE 6/7 (#8060)
	if ( !support.appendChecked ) {
		jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
	}

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}

			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( safe.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	tmp = null;

	return safe;
}


( function() {
	var i, eventName,
		div = document.createElement( "div" );

	// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
	for ( i in { submit: true, change: true, focusin: true } ) {
		eventName = "on" + i;

		if ( !( support[ i ] = eventName in window ) ) {

			// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
			div.setAttribute( eventName, "t" );
			support[ i ] = div.attributes[ eventName ].expando === false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();


var rformElems = /^(?:input|select|textarea)$/i,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {
		var tmp, events, t, handleObjIn,
			special, eventHandle, handleObj,
			handlers, type, namespaces, origType,
			elemData = jQuery._data( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" &&
					( !e || jQuery.event.triggered !== e.type ) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};

			// Add elem as a property of the handle fn to prevent a memory leak
			// with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {
		var j, handleObj, tmp,
			origCount, t, events,
			special, handlers, type,
			namespaces, origType,
			elemData = jQuery.hasData( elem ) && jQuery._data( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery._removeData( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		var handle, ontype, cur,
			bubbleType, special, tmp, i,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
				jQuery._data( cur, "handle" );

			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if (
				( !special._default ||
				 special._default.apply( eventPath.pop(), data ) === false
				) && acceptData( elem )
			) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					try {
						elem[ type ]();
					} catch ( e ) {

						// IE<9 dies on focus/blur to hidden element (#1486,#12518)
						// only reproducible on winXP IE8 native, not IE9 in IE8 mode
					}
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			/* jshint eqeqeq: false */
			for ( ; cur != this; cur = cur.parentNode || this ) {
				/* jshint eqeqeq: true */

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: IE<9
		// Fix target property (#1925)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Support: Safari 6-8+
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// Support: IE<9
		// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
		event.metaKey = !!event.metaKey;

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
			"pageX pageY screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var body, eventDoc, doc,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ?
					original.toElement :
					fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					try {
						this.focus();
						return false;
					} catch ( e ) {

						// Support: IE<9
						// If we error on focus to hidden element (#1486, #12518),
						// let .trigger() run the handlers
					}
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	// Piggyback on a donor event to simulate a different one
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true

				// Previously, `originalEvent: {}` was set here, so stopPropagation call
				// would not be triggered on donor event, since in our own
				// jQuery.event.stopPropagation function we had a check for existence of
				// originalEvent.stopPropagation method, so, consequently it would be a noop.
				//
				// Guard for simulated events was moved to jQuery.event.stopPropagation function
				// since `originalEvent` should point to the original event for the
				// constancy with other events and for more focused logic
			}
		);

		jQuery.event.trigger( e, null, elem );

		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	} :
	function( elem, type, handle ) {
		var name = "on" + type;

		if ( elem.detachEvent ) {

			// #8545, #7054, preventing memory leaks for custom events in IE6-8
			// detachEvent needed property on element, by name of that event,
			// to properly expose it to GC
			if ( typeof elem[ name ] === "undefined" ) {
				elem[ name ] = null;
			}

			elem.detachEvent( name, handle );
		}
	};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: IE < 9, Android < 4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;
		if ( !e ) {
			return;
		}

		// If preventDefault exists, run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// Support: IE
		// Otherwise set the returnValue property of the original event to false
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( !e || this.isSimulated ) {
			return;
		}

		// If stopPropagation exists, run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}

		// Support: IE
		// Set the cancelBubble property of the original event to true
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

// IE submit delegation
if ( !support.submit ) {

	jQuery.event.special.submit = {
		setup: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {

				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?

						// Support: IE <=8
						// We use jQuery.prop instead of elem.form
						// to allow fixing the IE8 delegated submit issue (gh-2332)
						// by 3rd party polyfills/workarounds.
						jQuery.prop( elem, "form" ) :
						undefined;

				if ( form && !jQuery._data( form, "submit" ) ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submitBubble = true;
					} );
					jQuery._data( form, "submit", true );
				}
			} );

			// return undefined since we don't need an event listener
		},

		postDispatch: function( event ) {

			// If form was submitted by the user, bubble the event up the tree
			if ( event._submitBubble ) {
				delete event._submitBubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event );
				}
			}
		},

		teardown: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !support.change ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {

				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._justChanged = true;
						}
					} );
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._justChanged && !event.isTrigger ) {
							this._justChanged = false;
						}

						// Allow triggered, simulated change events (#11500)
						jQuery.event.simulate( "change", this, event );
					} );
				}
				return false;
			}

			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event );
						}
					} );
					jQuery._data( elem, "change", true );
				}
			} );
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger ||
				( elem.type !== "radio" && elem.type !== "checkbox" ) ) {

				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return !rformElems.test( this.nodeName );
		}
	};
}

// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					jQuery._removeData( doc, fix );
				} else {
					jQuery._data( doc, fix, attaches );
				}
			}
		};
	} );
}

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	},

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	safeFragment = createSafeFragment( document ),
	fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );

// Support: IE<8
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );
	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}
	return elem;
}

function cloneCopyEvent( src, dest ) {
	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function fixCloneNodeIssues( src, dest ) {
	var nodeName, e, data;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 copies events bound via attachEvent when using cloneNode.
	if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
		data = jQuery._data( dest );

		for ( e in data.events ) {
			jQuery.removeEvent( dest, e, data.handle );
		}

		// Event data gets referenced instead of copied if the expando gets copied too
		dest.removeAttribute( jQuery.expando );
	}

	// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
	if ( nodeName === "script" && dest.text !== src.text ) {
		disableScript( dest ).text = src.text;
		restoreScript( dest );

	// IE6-10 improperly clones children of object elements using classid.
	// IE10 throws NoModificationAllowedError if parent is null, #12132.
	} else if ( nodeName === "object" ) {
		if ( dest.parentNode ) {
			dest.outerHTML = src.outerHTML;
		}

		// This path appears unavoidable for IE9. When cloning an object
		// element in IE9, the outerHTML strategy above is not sufficient.
		// If the src has innerHTML and the destination does not,
		// copy the src.innerHTML into the dest.innerHTML. #10324
		if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
			dest.innerHTML = src.innerHTML;
		}

	} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {

		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set

		dest.defaultChecked = dest.checked = src.checked;

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.defaultSelected = dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var first, node, hasScripts,
		scripts, doc, fragment,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!jQuery._data( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval(
								( node.text || node.textContent || node.innerHTML || "" )
									.replace( rcleanScript, "" )
							);
						}
					}
				}
			}

			// Fix #11809: Avoid leaking memory
			fragment = first = null;
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		elems = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = elems[ i ] ) != null; i++ ) {

		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function (html) {
		// OKTA-293330: Support patched jQuery prefilter to avoid possible XSS
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var destElements, node, clone, i, srcElements,
			inPage = jQuery.contains( elem.ownerDocument, elem );

		if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
			!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {

			clone = elem.cloneNode( true );

		// IE<=8 does not properly clone detached, unknown element nodes
		} else {
			fragmentDiv.innerHTML = elem.outerHTML;
			fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
		}

		if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
				( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			// Fix all IE cloning issues
			for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {

				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[ i ] ) {
					fixCloneNodeIssues( node, destElements[ i ] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
					cloneCopyEvent( node, destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		destElements = srcElements = node = null;

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems, /* internal */ forceAcceptData ) {
		var elem, type, id, data,
			i = 0,
			internalKey = jQuery.expando,
			cache = jQuery.cache,
			attributes = support.attributes,
			special = jQuery.event.special;

		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			if ( forceAcceptData || acceptData( elem ) ) {

				id = elem[ internalKey ];
				data = id && cache[ id ];

				if ( data ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Remove cache only if it was not already removed by jQuery.event.remove
					if ( cache[ id ] ) {

						delete cache[ id ];

						// Support: IE<9
						// IE does not allow us to delete expando properties from nodes
						// IE creates expando attributes along with the property
						// IE does not have a removeAttribute function on Document nodes
						if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
							elem.removeAttribute( internalKey );

						// Webkit & Blink performance suffers when deleting properties
						// from DOM nodes, so set to undefined instead
						// https://code.google.com/p/chromium/issues/detail?id=378607
						} else {
							elem[ internalKey ] = undefined;
						}

						deletedIds.push( id );
					}
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append(
					( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
				);
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {

			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem, false ) );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}

			// If this is a select, ensure that it displays empty (#12336)
			// Support: IE<9
			if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
				elem.options.length = 0;
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					undefined;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {

						// Remove element nodes and prevent memory leaks
						elem = this[ i ] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			i = 0,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'></iframe>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
		reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	div.style.cssText = "float:left;opacity:.5";

	// Support: IE<9
	// Make sure that element opacity exists (as opposed to filter)
	support.opacity = div.style.opacity === "0.5";

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!div.style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container = document.createElement( "div" );
	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	div.innerHTML = "";
	container.appendChild( div );

	// Support: Firefox<29, Android 2.3
	// Vendor-prefix box-sizing
	support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
		div.style.WebkitBoxSizing === "";

	jQuery.extend( support, {
		reliableHiddenOffsets: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableHiddenOffsetsVal;
		},

		boxSizingReliable: function() {

			// We're checking for pixelPositionVal here instead of boxSizingReliableVal
			// since that compresses better and they're computed together anyway.
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},

		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},

		pixelPosition: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelPositionVal;
		},

		reliableMarginRight: function() {

			// Support: Android 2.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginRightVal;
		},

		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		}
	} );

	function computeStyleTests() {
		var contents, divStyle,
			documentElement = document.documentElement;

		// Setup
		documentElement.appendChild( container );

		div.style.cssText =

			// Support: Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";

		// Support: IE<9
		// Assume reasonable values in the absence of getComputedStyle
		pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
		pixelMarginRightVal = reliableMarginRightVal = true;

		// Check for getComputedStyle so that this code is not run in IE<9.
		if ( window.getComputedStyle ) {
			divStyle = window.getComputedStyle( div );
			pixelPositionVal = ( divStyle || {} ).top !== "1%";
			reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
			boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";

			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";

			// Support: Android 2.3 only
			// Div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			contents = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			contents.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
			contents.style.marginRight = contents.style.width = "0";
			div.style.width = "1px";

			reliableMarginRightVal =
				!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );

			div.removeChild( contents );
		}

		// Support: IE6-8
		// First check that getClientRects works as expected
		// Check if table cells still have offsetWidth/Height when they are set
		// to display:none and there are still other visible table cells in a
		// table row; if so, offsetWidth/Height are not reliable for use when
		// determining if an element has been hidden directly using
		// display:none (it is still safe to use offsets if a parent element is
		// hidden; don safety goggles and see bug #4512 for more information).
		div.style.display = "none";
		reliableHiddenOffsetsVal = div.getClientRects().length === 0;
		if ( reliableHiddenOffsetsVal ) {
			div.style.display = "";
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			div.childNodes[ 0 ].style.borderCollapse = "separate";
			contents = div.getElementsByTagName( "td" );
			contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			if ( reliableHiddenOffsetsVal ) {
				contents[ 0 ].style.display = "";
				contents[ 1 ].style.display = "none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			}
		}

		// Teardown
		documentElement.removeChild( container );
	}

} )();


var getStyles, curCSS,
	rposition = /^(top|right|bottom|left)$/;

if ( window.getComputedStyle ) {
	getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

	curCSS = function( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is only needed for .css('filter') in IE9, see #12537
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		if ( computed ) {

			// A tribute to the "awesome hack by Dean Edwards"
			// Chrome < 17 and Safari 5.0 uses "computed value"
			// instead of "used value" for margin-right
			// Safari 5.1.7 (at least) returns percentage for a larger set of values,
			// but width seems to be reliably pixels
			// this is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "";
	};
} else if ( documentElement.currentStyle ) {
	getStyles = function( elem ) {
		return elem.currentStyle;
	};

	curCSS = function( elem, name, computed ) {
		var left, rs, rsLeft, ret,
			style = elem.style;

		computed = computed || getStyles( elem );
		ret = computed ? computed[ name ] : undefined;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && style[ name ] ) {
			ret = style[ name ];
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		// but not position css attributes, as those are
		// proportional to the parent element instead
		// and we can't measure the parent instead because it
		// might trigger a "stacking dolls" problem
		if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

			// Remember the original values
			left = style.left;
			rs = elem.runtimeStyle;
			rsLeft = rs && rs.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				rs.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				rs.left = rsLeft;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "" || "auto";
	};
}




function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

		ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity\s*=\s*([^)]*)/i,

	// swappable if display is none or starts with table except
	// "table", "table-cell", or "table-caption"
	// see here for display values:
	// https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;


// return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// check for vendor prefixed names
	var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = jQuery._data( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] =
					jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display && display !== "none" || !hidden ) {
				jQuery._data(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// at this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// at this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// at this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = support.boxSizing &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// we need the check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {

		// normalize float css property
		"float": support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set. See: #7116
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
			// but it would mean to define eight
			// (for every problematic property) identical functions
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				// Support: IE
				// Swallow errors from 'invalid' CSS values (#5509)
				try {
					style[ name ] = value;
				} catch ( e ) {}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var num, val, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		//convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Return, converting to number if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// certain elements can have dimension info if we invisibly show them
				// however, it must have a current display style that would benefit from this
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					support.boxSizing &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
} );

if ( !support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {

			// IE uses filters for opacity
			return ropacity.test( ( computed && elem.currentStyle ?
				elem.currentStyle.filter :
				elem.style.filter ) || "" ) ?
					( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
					computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist -
			// attempt to remove filter attribute #6652
			// if value === "", then remove inline opacity #12685
			if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there is no filter style applied in a css rule
				// or unset inline opacity, we are done
				if ( value === "" || currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return (
				parseFloat( curCSS( elem, "marginLeft" ) ) ||

				// Support: IE<=11+
				// Running getBoundingClientRect on a disconnected node in IE throws an error
				// Support: IE8 only
				// getClientRects() errors on disconnected elems
				( jQuery.contains( elem.ownerDocument, elem ) ?
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} ) :
					0
				)
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails
			// so, simple values such as "10px" are parsed to Float.
			// complex values such as "rotate(1rad)" are returned as is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// use step hook for back compat - use cssHook if its there - use .style if its
			// available and use plain properties where available
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9
// Panic based approach to setting things on disconnected nodes

Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		attrs = { height: type },
		i = 0;

	// if we include width, step value is 1 to do all cssExpand values,
	// if we don't include width, step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// we're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = jQuery._data( elem, "fxshow" );

	// handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// doing this makes sure that the complete handler will be called
			// before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE does not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {

			// inline-level elements accept inline-block;
			// block-level elements need to be inline with layout
			if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
				style.display = "inline-block";
			} else {
				style.zoom = 1;
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		if ( !support.shrinkWrapBlocks() ) {
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = jQuery._data( elem, "fxshow", {} );
		}

		// store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;
			jQuery._removeData( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// not quite $.extend, this wont overwrite keys already present.
			// also - reusing 'index' from above because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// resolve when we played the last frame
				// otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || jQuery._data( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = jQuery._data( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = jQuery._data( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// enable finishing flag on private data
			data.finish = true;

			// empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		timers = jQuery.timers,
		i = 0;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var a,
		input = document.createElement( "input" ),
		div = document.createElement( "div" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	// Setup
	div = document.createElement( "div" );
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];

	// Support: Windows Web Apps (WWA)
	// `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "checkbox" );
	div.appendChild( input );

	a = div.getElementsByTagName( "a" )[ 0 ];

	// First batch of tests.
	a.style.cssText = "top:1px";

	// Test setAttribute on camelCase class.
	// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	support.getSetAttribute = div.className !== "t";

	// Get the style information from getAttribute
	// (IE uses .cssText instead)
	support.style = /top/.test( a.getAttribute( "style" ) );

	// Make sure that URLs aren't manipulated
	// (IE normalizes it by default)
	support.hrefNormalized = a.getAttribute( "href" ) === "/a";

	// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
	support.checkOn = !!input.value;

	// Make sure that a selected-by-default option has a working selected property.
	// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	support.optSelected = opt.selected;

	// Tests for enctype support on a form (#6743)
	support.enctype = !!document.createElement( "form" ).enctype;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE8 only
	// Check if we can trust getAttribute("value")
	input = document.createElement( "input" );
	input.setAttribute( "value", "" );
	support.input = input.getAttribute( "value" ) === "";

	// Check if an input maintains its value after becoming a radio
	input.value = "t";
	input.setAttribute( "type", "radio" );
	support.radioValue = input.value === "t";
} )();


var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if (
					hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// handle most common string cases
					ret.replace( rreturn, "" ) :

					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// oldIE doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled :
								option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {

						// Support: IE6
						// When new option element is added to select box we need to
						// force reflow of newly added node in order to workaround delay
						// of initialization properties
						try {
							option.selected = optionSet = true;

						} catch ( _ ) {

							// Will be executed only in IE6
							option.scrollHeight;
						}

					} else {
						option.selected = false;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}

				return options;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle,
	ruseDefault = /^(?:checked|selected)$/i,
	getSetAttribute = support.getSetAttribute,
	getSetInput = support.input;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {

					// Setting the type on a radio button after the value resets the value in IE8-9
					// Reset value to default in case type is set after value during creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
						elem[ propName ] = false;

					// Support: IE<9
					// Also clear defaultChecked/defaultSelected (if appropriate)
					} else {
						elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
					}

				// See #9699 for explanation of this approach (setting first, then removal)
				} else {
					jQuery.attr( elem, name, "" );
				}

				elem.removeAttribute( getSetAttribute ? name : propName );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {

			// IE<8 needs the *property* name
			elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

		} else {

			// Support: IE<9
			// Use defaultChecked and defaultSelected for oldIE
			elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} else {
		attrHandle[ name ] = function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem[ jQuery.camelCase( "default-" + name ) ] ?
					name.toLowerCase() :
					null;
			}
		};
	}
} );

// fix oldIE attroperties
if ( !getSetInput || !getSetAttribute ) {
	jQuery.attrHooks.value = {
		set: function( elem, value, name ) {
			if ( jQuery.nodeName( elem, "input" ) ) {

				// Does not return so that setAttribute is also used
				elem.defaultValue = value;
			} else {

				// Use nodeHook if defined (#1954); otherwise setAttribute is fine
				return nodeHook && nodeHook.set( elem, value, name );
			}
		}
	};
}

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = {
		set: function( elem, value, name ) {

			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				elem.setAttributeNode(
					( ret = elem.ownerDocument.createAttribute( name ) )
				);
			}

			ret.value = value += "";

			// Break association with cloned elements by also using setAttribute (#9646)
			if ( name === "value" || value === elem.getAttribute( name ) ) {
				return value;
			}
		}
	};

	// Some attributes are constructed with empty-string values when not defined
	attrHandle.id = attrHandle.name = attrHandle.coords =
		function( elem, name, isXML ) {
			var ret;
			if ( !isXML ) {
				return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
					ret.value :
					null;
			}
		};

	// Fixing value retrieval on a button requires this module
	jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret = elem.getAttributeNode( name );
			if ( ret && ret.specified ) {
				return ret.value;
			}
		},
		set: nodeHook.set
	};

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		set: function( elem, value, name ) {
			nodeHook.set( elem, value === "" ? false : value, name );
		}
	};

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each( [ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		};
	} );
}

if ( !support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {

			// Return undefined in the case of empty string
			// Note: IE uppercases css property names, but if we were to .toLowerCase()
			// .cssText, that would destroy case sensitivity in URL's, like in "background"
			return elem.style.cssText || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = value + "" );
		}
	};
}




var rfocusable = /^(?:input|select|textarea|button|object)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each( function() {

			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch ( e ) {}
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Some attributes require a special call on IE
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !support.hrefNormalized ) {

	// href/src property should get the full normalized URL (#10299/#12915)
	jQuery.each( [ "href", "src" ], function( i, name ) {
		jQuery.propHooks[ name ] = {
			get: function( elem ) {
				return elem.getAttribute( name, 4 );
			}
		};
	} );
}

// Support: Safari, IE9+
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

// IE6/7 call enctype encoding
if ( !support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return jQuery.attr( elem, "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// store className if set
					jQuery._data( this, "__className__", className );
				}

				// If the element has a class name or if we're passed "false",
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				jQuery.attr( this, "class",
					className || value === false ?
					"" :
					jQuery._data( this, "__className__" ) || ""
				);
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




// Return jQuery for attributes-only inclusion


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );


var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

jQuery.parseJSON = function( data ) {

	// Attempt to parse using the native JSON parser first
	if ( window.JSON && window.JSON.parse ) {

		// Support: Android 2.3
		// Workaround failure to string-cast null input
		return window.JSON.parse( data + "" );
	}

	var requireNonComma,
		depth = null,
		str = jQuery.trim( data + "" );

	// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	// after removing valid tokens
	return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

		// Force termination if we see a misplaced comma
		if ( requireNonComma && comma ) {
			depth = 0;
		}

		// Perform no more replacements after returning to outermost depth
		if ( depth === 0 ) {
			return token;
		}

		// Commas must not follow "[", "{", or ","
		requireNonComma = open || comma;

		// Determine new depth
		// array/object open ("[" or "{"): depth += true - false (increment)
		// array/object close ("]" or "}"): depth += false - true (decrement)
		// other cases ("," or primitive): depth += true - true (numeric cast)
		depth += !close - !open;

		// Remove this token
		return "";
	} ) ) ?
		( Function( "return " + str ) )() :
		jQuery.error( "Invalid JSON: " + data );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	try {
		if ( window.DOMParser ) { // Standard
			tmp = new window.DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} else { // IE
			xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
			xml.async = "false";
			xml.loadXML( data );
		}
	} catch ( e ) {
		xml = undefined;
	}
	if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,

	// IE leaves an \r character at EOL
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType.charAt( 0 ) === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var deep, key,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {
	var firstDataType, ct, finalDataType, type,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var

			// Cross-domain detection vars
			parts,

			// Loop variable
			i,

			// URL without anti-cache param
			cacheURL,

			// Response headers as string
			responseHeadersString,

			// timeout handle
			timeoutTimer,

			// To know if global events are to be dispatched
			fireGlobals,

			transport,

			// Response headers
			responseHeaders,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" )
			.replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


function getDisplay( elem ) {
	return elem.style && elem.style.display || jQuery.css( elem, "display" );
}

function filterHidden( elem ) {

	// Disconnected elements are considered hidden
	if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
		return true;
	}
	while ( elem && elem.nodeType === 1 ) {
		if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
			return true;
		}
		elem = elem.parentNode;
	}
	return false;
}

jQuery.expr.filters.hidden = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return support.reliableHiddenOffsets() ?
		( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
			!elem.getClientRects().length ) :
			filterHidden( elem );
};

jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is(":disabled") so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?

	// Support: IE6-IE8
	function() {

		// XHR cannot access local files, always use ActiveX for that case
		if ( this.isLocal ) {
			return createActiveXHR();
		}

		// Support: IE 9-11
		// IE seems to error on cross-domain PATCH requests when ActiveX XHR
		// is used. In IE 9+ always use the native XHR.
		// Note: this condition won't catch Edge as it doesn't define
		// document.documentMode but it also doesn't support ActiveX so it won't
		// reach this code.
		if ( document.documentMode > 8 ) {
			return createStandardXHR();
		}

		// Support: IE<9
		// oldIE XHR does not support non-RFC2616 methods (#13240)
		// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
		// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
		// Although this check for six methods instead of eight
		// since IE also does not support "trace" and "connect"
		return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
			createStandardXHR() || createActiveXHR();
	} :

	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

var xhrId = 0,
	xhrCallbacks = {},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE<10
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( undefined, true );
		}
	} );
}

// Determine support properties
support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
xhrSupported = support.ajax = !!xhrSupported;

// Create transport if the browser can provide an xhr
if ( xhrSupported ) {

	jQuery.ajaxTransport( function( options ) {

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !options.crossDomain || support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;

					// Open the socket
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {

						// Support: IE<9
						// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
						// request header to a null-value.
						//
						// To keep consistent with other XHR implementations, cast the value
						// to string and ignore `undefined`.
						if ( headers[ i ] !== undefined ) {
							xhr.setRequestHeader( i, headers[ i ] + "" );
						}
					}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( options.hasContent && options.data ) || null );

					// Listener
					callback = function( _, isAbort ) {
						var status, statusText, responses;

						// Was never called and is aborted or complete
						if ( callback && ( isAbort || xhr.readyState === 4 ) ) {

							// Clean up
							delete xhrCallbacks[ id ];
							callback = undefined;
							xhr.onreadystatechange = jQuery.noop;

							// Abort manually if needed
							if ( isAbort ) {
								if ( xhr.readyState !== 4 ) {
									xhr.abort();
								}
							} else {
								responses = {};
								status = xhr.status;

								// Support: IE<10
								// Accessing binary-data responseText throws an exception
								// (#11426)
								if ( typeof xhr.responseText === "string" ) {
									responses.text = xhr.responseText;
								}

								// Firefox throws an exception when accessing
								// statusText for faulty cross-domain requests
								try {
									statusText = xhr.statusText;
								} catch ( e ) {

									// We normalize with Webkit giving an empty statusText
									statusText = "";
								}

								// Filter status for non standard behaviors

								// If the request is local and we have data: assume a success
								// (success with no data won't get notified, that's the best we
								// can do given current implementations)
								if ( !status && options.isLocal && !options.crossDomain ) {
									status = responses.text ? 200 : 404;

								// IE - #1450: sometimes returns 1223 when it should be 204
								} else if ( status === 1223 ) {
									status = 204;
								}
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, xhr.getAllResponseHeaders() );
						}
					};

					// Do send the request
					// `xhr.send` may raise an exception, but it will be
					// handled in jQuery.ajax (so no try/catch here)
					if ( !options.async ) {

						// If we're in sync mode we fire the callback
						callback();
					} else if ( xhr.readyState === 4 ) {

						// (IE6 & IE7) if it's in cache and has been
						// retrieved directly we need to fire the callback
						window.setTimeout( callback );
					} else {

						// Register the callback, but delay it in case `xhr.send` throws
						// Add to the list of active xhr callbacks
						xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback( undefined, true );
					}
				}
			};
		}
	} );
}

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch ( e ) {}
}




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
// https://oktainc.atlassian.net/browse/OKTA-131142
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement( "script" );

				script.async = true;

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( script.parentNode ) {
							script.parentNode.removeChild( script );
						}

						// Dereference the script
						script = null;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};

				// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
				// Use native DOM manipulation to avoid our domManip AJAX trickery
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( undefined, true );
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// data: string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off, url.length ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};





/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;

		// need to be able to calculate position if either top or left
		// is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			box = { top: 0, left: 0 },
			elem = this[ 0 ],
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// If we don't have gBCR, just use 0,0 rather than error
		// BlackBerry 5, iOS 3 (original iPhone)
		if ( typeof elem.getBoundingClientRect !== "undefined" ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
			left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			parentOffset = { top: 0, left: 0 },
			elem = this[ 0 ];

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// we assume that getBoundingClientRect is available when computed position is fixed
			offset = elem.getBoundingClientRect();
		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		return {
			top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? ( prop in win ) ? win[ prop ] :
					win.document.documentElement[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// getComputedStyle returns percent when specified for top/left/bottom/right
// rather than make the css module depend on the offset module, we just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// if curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
	function( defaultExtra, funcName ) {

		// margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					// unfortunately, this causes bug #3838 in IE6/8 only,
					// but there is currently no good, small way to fix it.
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in
// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)

//9/10/2018 - OKTA-187649 - Expose jQuery in the global window object to externalize it
//OKTA-Core used to load separate jquery as part of the saasure.min.js file along with the one that is bundled in dll.common
if ( !noGlobal || window.__OKTA_EXPORT_JQUERY__ ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _Util = _interopRequireDefault(__webpack_require__(31));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var util = {}; // https://github.com/okta/okta-auth-js#authorize-options

var AUTH_PARAMS = ['responseType', 'scopes', 'state', 'nonce', 'idp', 'idpScope', 'display', 'prompt', 'maxAge', 'loginHint'];
util.AUTH_PARAMS = AUTH_PARAMS;
/**
 * Get the tokens in the OIDC/OAUTH flows
 *
 * @param settings - settings model object
 * @param params - {idp: 'xxx'} for social auth
 *                 {sessionToken: 'xxx'} for okta idp
 */

util.getTokens = function (settings, params, controller) {
  function success(result) {
    settings.callGlobalSuccess(_Enums.default.SUCCESS, result);
  }

  function error(error) {
    var showError = false;
    var responseJSON = error; // user is not assigned to OIDC client

    if (error.errorCode === 'access_denied') {
      showError = true;
    } // MFA is required but prompt=none (authn V1)


    var mfaRequiredMsg = 'The client specified not to prompt, but the client app requires re-authentication or MFA.';

    if (error.errorCode === 'login_required' && error.errorSummary === mfaRequiredMsg) {
      showError = true;
      responseJSON = {
        errorSummary: (0, _okta.loc)('error.mfa.required', 'login')
      };
    }

    if (showError) {
      controller.model.trigger('error', controller.model, {
        responseJSON: responseJSON
      });
      controller.model.appState.trigger('removeLoading');
    }

    _Util.default.triggerAfterError(controller, new _Errors.default.OAuthError(error.message), settings);
  }

  var authClient = settings.getAuthClient();
  var isAuthorizationCodeFlow = authClient.isAuthorizationCodeFlow() && !authClient.isPKCE();
  var options = settings.toJSON({
    verbose: true
  });
  var getTokenOptions = {};

  _okta._.extend(getTokenOptions, _okta._.pick(options, 'clientId', 'redirectUri'), _okta._.pick(options.authParams, AUTH_PARAMS), params); // Extra Options for Social Idp popup window title and id_token response timeout


  getTokenOptions.popupTitle = (0, _okta.loc)('socialauth.popup.title', 'login');
  getTokenOptions.timeout = options.oAuthTimeout; // Redirect flow - this can be used when logging into an external IDP, or
  // converting the Okta sessionToken to an access_token, id_token, and/or
  // authorization code. Note: The authorization code flow will always redirect.

  if (options.redirect === 'always' || isAuthorizationCodeFlow) {
    authClient.token.getWithRedirect(getTokenOptions).catch(error);
  } else if (getTokenOptions.sessionToken) {
    // Default flow if logging in with Okta as the IDP - convert sessionToken to
    // tokens in a hidden iframe. Used in Single Page Apps where the app does
    // not want to redirect away from the page to convert the token.
    authClient.token.getWithoutPrompt(getTokenOptions).then(success).catch(error);
  } else {
    // Default flow if logging in with an external IDP - opens a popup and
    // gets the token from a postMessage response.
    authClient.token.getWithPopup(getTokenOptions).then(success).catch(error);
  }
};

var _default = util;
exports.default = _default;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _endsWith = _interopRequireDefault(__webpack_require__(535));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

/**
 * 
 * This file has been modified to override doPostBack
 * Check out the doPostBack function below for more details.
 * Override the doPostBack function when upgrading.
 * Unable to make a wrapper because it is invoked using an internal name within 
 * this library.
 * 
 * Current Verison = https://github.com/duosecurity/duo_web_sdk/blob/7aec8dd895ea4bd4549069e76076850eccfe07f2/index.js
 * PS: they dont seem to version correctly hence using commit.
 */

/**
 * Duo Web SDK v2
 * Copyright 2019, Duo Security
 */
(function (root, factory) {
  /*eslint-disable */
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    /*eslint-enable */
  } else if ((typeof module === "undefined" ? "undefined" : (0, _typeof2.default)(module)) === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    var Duo = factory(); // If the Javascript was loaded via a script tag, attempt to autoload
    // the frame.

    Duo._onReady(Duo.init); // Attach Duo to the `window` object


    root.Duo = Duo;
  }
})(void 0, function () {
  var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
  var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
  var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
  var VALID_OPEN_WINDOW_DOMAINS = ['duo.com', 'duosecurity.com', 'duomobile.s3-us-west-1.amazonaws.com'];
  var postAction, postArgument, host, sigRequest, duoSig, appSig, iframe, submitCallback; // We use this function instead of setting initial values in the var
  // declarations to make sure the initial values and subsequent
  // re-initializations are always the same.

  initializeStatefulVariables();
  /**
   * Set local variables to whatever they should be before you call init().
   */

  function initializeStatefulVariables() {
    postAction = '';
    postArgument = 'sig_response';
    host = undefined;
    sigRequest = undefined;
    duoSig = undefined;
    appSig = undefined;
    iframe = undefined;
    submitCallback = undefined;
  }

  function throwError(message, givenUrl) {
    var url = givenUrl || 'https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe';
    throw new Error('Duo Web SDK error: ' + message + (url ? '\n' + 'See ' + url + ' for more information' : ''));
  }

  function hyphenize(str) {
    return str.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase();
  } // cross-browser data attributes


  function getDataAttribute(element, name) {
    if ('dataset' in element) {
      return element.dataset[name];
    } else {
      return element.getAttribute('data-' + hyphenize(name));
    }
  } // cross-browser event binding/unbinding


  function on(context, event, fallbackEvent, callback) {
    if ('addEventListener' in window) {
      context.addEventListener(event, callback, false);
    } else {
      context.attachEvent(fallbackEvent, callback);
    }
  }

  function off(context, event, fallbackEvent, callback) {
    if ('removeEventListener' in window) {
      context.removeEventListener(event, callback, false);
    } else {
      context.detachEvent(fallbackEvent, callback);
    }
  }

  function onReady(callback) {
    on(document, 'DOMContentLoaded', 'onreadystatechange', callback);
  }

  function offReady(callback) {
    off(document, 'DOMContentLoaded', 'onreadystatechange', callback);
  }

  function onMessage(callback) {
    on(window, 'message', 'onmessage', callback);
  }

  function offMessage(callback) {
    off(window, 'message', 'onmessage', callback);
  }
  /**
   * Parse the sig_request parameter, throwing errors if the token contains
   * a server error or if the token is invalid.
   *
   * @param {String} sig Request token
   */


  function parseSigRequest(sig) {
    if (!sig) {
      // nothing to do
      return;
    } // see if the token contains an error, throwing it if it does


    if ((0, _indexOf.default)(sig).call(sig, 'ERR|') === 0) {
      throwError(sig.split('|')[1]);
    } // validate the token


    if ((0, _indexOf.default)(sig).call(sig, ':') === -1 || sig.split(':').length !== 2) {
      throwError('Duo was given a bad token.  This might indicate a configuration ' + 'problem with one of Duo\'s client libraries.');
    }

    var sigParts = sig.split(':'); // hang on to the token, and the parsed duo and app sigs

    sigRequest = sig;
    duoSig = sigParts[0];
    appSig = sigParts[1];
    return {
      sigRequest: sig,
      duoSig: sigParts[0],
      appSig: sigParts[1]
    };
  }
  /**
   * Validate that a MessageEvent came from the Duo service, and that it
   * is a properly formatted payload.
   *
   * The Google Chrome sign-in page injects some JS into pages that also
   * make use of postMessage, so we need to do additional validation above
   * and beyond the origin.
   *
   * @param {MessageEvent} event Message received via postMessage
   */


  function isDuoMessage(event) {
    return Boolean(event.origin === 'https://' + host && typeof event.data === 'string' && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
  }
  /**
   * Validate the request token and prepare for the iframe to become ready.
   *
   * All options below can be passed into an options hash to `Duo.init`, or
   * specified on the iframe using `data-` attributes.
   *
   * Options specified using the options hash will take precedence over
   * `data-` attributes.
   *
   * Example using options hash:
   * ```javascript
   * Duo.init({
   *     iframe: "some_other_id",
   *     host: "api-main.duo.test",
   *     sig_request: "...",
   *     post_action: "/auth",
   *     post_argument: "resp"
   * });
   * ```
   *
   * Example using `data-` attributes:
   * ```html
   * <iframe id="duo_iframe"
   *         data-host="api-main.duo.test"
   *         data-sig-request="..."
   *         data-post-action="/auth"
   *         data-post-argument="resp"
   *         >
   * </iframe>
   * ```
   *
   * Some browsers (especially embedded browsers) don't like it when the Duo
   * Web SDK changes the `src` attribute on the iframe. To prevent this, there
   * is an alternative way to use the Duo Web SDK:
   *
   * Add a div (or any other container element) instead of an iframe to the
   * DOM with an id of "duo_iframe", or pass that element to the
   * `iframeContainer` parameter of `Duo.init`. An iframe will be created and
   * inserted into that container element, preventing `src` change related
   * bugs. WARNING: All other elements in the container will be deleted.
   *
   * The `iframeAttributes` parameter of `Duo.init` is available to set any
   * attributes on the inserted iframe if the Duo Web SDK is inserting the
   * iframe. For details, see the parameter documentation below.
   *
   * @param {Object} options
   * @param {String} options.host - Hostname for the Duo Prompt.
   * @param {String} options.sig_request - Request token.
   * @param {String|HTMLElement} [options.iframe] - The iframe, or id of an
   *     iframe that will be used for the Duo Prompt. If you don't provide
   *     this or the `iframeContainer` parameter the Duo Web SDK will default
   *     to using whatever element has an id of "duo_iframe".
   * @param {String|HTMLElement} [options.iframeContainer] - The element you
   *     want the Duo Prompt inserted into, or the id of that element.
   *     Anything inside this element will be deleted and replaced with an
   *     iframe hosting the Duo prompt. If you don't provide this or the
   *     `iframe` parameter the Duo Web SDK will default to using whatever
   *     element has an id of "duo_iframe".
   * @param {Object} [options.iframeAttributes] - Object with  names and
   *     values coresponding to attributes you want added to the  Duo Prompt
   *     iframe, like `title`, `width` and `allow`. WARNING: this parameter
   *     only works if you use the `iframeContainer` parameter or add an id
   *     of "duo_iframe" to an element that isn't an iframe. If you have
   *     added an iframe to the DOM yourself, you should set those attributes
   *     directly on the iframe.
   * @param {String} [options.post_action=''] - URL to POST back to after a
   *     successful auth.
   * @param {String} [options.post_argument='sig_response'] - Parameter name
   *     to use for response token.
   * @param {Function} [options.submit_callback] - If provided, the Duo Web
   *     SDK will not submit the form. Instead it will execute this callback
   *     function passing in a reference to the "duo_form" form object.
   *     `submit_callback`` can be used to prevent the webpage from reloading.
   */


  function init(options) {
    // If init() is called more than once we have to reset all the local
    // variables to ensure init() will work the same way every time. This
    // helps people making single page applications. SPAs may periodically
    // remove the iframe and add a new one that has to be initialized.
    initializeStatefulVariables();

    if (options) {
      if (options.host) {
        host = options.host;
      }

      if (options.sig_request) {
        parseSigRequest(options.sig_request);
      }

      if (options.post_action) {
        postAction = options.post_action;
      }

      if (options.post_argument) {
        postArgument = options.post_argument;
      }

      if (typeof options.submit_callback === 'function') {
        submitCallback = options.submit_callback;
      }
    }

    var promptElement = getPromptElement(options);

    if (promptElement) {
      // If we can get the element that will host the prompt, set it.
      ready(promptElement, options.iframeAttributes || {});
    } else {
      // If the element that will host the prompt isn't available yet, set
      // it up after the DOM finishes loading.
      asyncReady(options);
    } // always clean up after yourself!


    offReady(init);
  }
  /**
   * Given the options from init(), get the iframe or iframe container that
   * should be used for the Duo Prompt. Returns `null` if nothing was found.
   */


  function getPromptElement(options) {
    var result;

    if (options.iframe && options.iframeContainer) {
      throwError('Passing both `iframe` and `iframeContainer` arguments at the' + ' same time is not allowed.');
    } else if (options.iframe) {
      // If we are getting an iframe, try to get it and raise if the
      // element we find is NOT an iframe.
      result = getUserDefinedElement(options.iframe);
      validateIframe(result);
    } else if (options.iframeContainer) {
      result = getUserDefinedElement(options.iframeContainer);
      validateIframeContainer(result);
    } else {
      result = document.getElementById('duo_iframe');
    }

    return result;
  }
  /**
   * When given an HTMLElement, return it. When given a string, get an element
   * with that id, else return null.
   */


  function getUserDefinedElement(object) {
    if (object.tagName) {
      return object;
    } else if (typeof object == 'string') {
      return document.getElementById(object);
    }

    return null;
  }
  /**
   * Check if the given thing is an iframe.
   */


  function isIframe(element) {
    return element && element.tagName && element.tagName.toLowerCase() === 'iframe';
  }
  /**
   * Throw an error if we are given an element that is NOT an iframe.
   */


  function validateIframe(element) {
    if (element && !isIframe(element)) {
      throwError('`iframe` only accepts an iframe element or the id of an' + ' iframe. To use a non-iframe element, use the' + ' `iframeContainer` argument.');
    }
  }
  /**
   * Throw an error if we are given an element that IS an iframe instead of an
   * element that we can insert an iframe into.
   */


  function validateIframeContainer(element) {
    if (element && isIframe(element)) {
      throwError('`iframeContainer` only accepts a non-iframe element or the' + ' id of a non-iframe. To use a non-iframe element, use the' + ' `iframeContainer` argument on Duo.init().');
    }
  }
  /**
   * Generate the URL that goes to the Duo Prompt.
   */


  function generateIframeSrc() {
    return ['https://', host, '/frame/web/v1/auth?tx=', duoSig, '&parent=', encodeURIComponent(document.location.href), '&v=2.8'].join('');
  }
  /**
   * This function is called when a message was received from another domain
   * using the `postMessage` API.  Check that the event came from the Duo
   * service domain, and that the message is a properly formatted payload,
   * then perform the post back to the primary service.
   *
   * @param event Event object (contains origin and data)
   */


  function onReceivedMessage(event) {
    if (isDuoMessage(event)) {
      if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
        var url = event.data.substring("DUO_OPEN_WINDOW|".length);

        if (isValidUrlToOpen(url)) {
          // Open the URL that comes after the DUO_WINDOW_OPEN token.
          window.open(url, "_self");
        }
      } else {
        // the event came from duo, do the post back
        doPostBack(event.data); // always clean up after yourself!

        offMessage(onReceivedMessage);
      }
    }
  }
  /**
   * Validate that this passed in URL is one that we will actually allow to
   * be opened.
   * @param url String URL that the message poster wants to open
   * @returns {boolean} true if we allow this url to be opened in the window
   */


  function isValidUrlToOpen(url) {
    if (!url) {
      return false;
    }

    var parser = document.createElement('a');
    parser.href = url;

    if (parser.protocol === "duotrustedendpoints:") {
      return true;
    } else if (parser.protocol !== "https:") {
      return false;
    }

    for (var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++) {
      var _context;

      if ((0, _endsWith.default)(_context = parser.hostname).call(_context, "." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) {
        return true;
      }
    }

    return false;
  }
  /**
   * Register a callback to call ready() after the DOM has loaded.
   */


  function asyncReady(options) {
    var callback = function callback() {
      var promptElement = getPromptElement(options);

      if (!promptElement) {
        throwError('This page does not contain an iframe for Duo to use.' + ' Add an element like' + ' <iframe id="duo_iframe"></iframe> to this page.');
      }

      ready(promptElement, options.iframeAttributes || {}); // Always clean up after yourself.

      offReady(callback);
    };

    onReady(callback);
  }
  /**
   * Point the iframe at Duo, then wait for it to postMessage back to us.
   */


  function ready(promptElement, iframeAttributes) {
    if (!host) {
      host = getDataAttribute(promptElement, 'host');

      if (!host) {
        throwError('No API hostname is given for Duo to use.  Be sure to pass ' + 'a `host` parameter to Duo.init, or through the `data-host` ' + 'attribute on the iframe element.');
      }
    }

    if (!duoSig || !appSig) {
      parseSigRequest(getDataAttribute(promptElement, 'sigRequest'));

      if (!duoSig || !appSig) {
        throwError('No valid signed request is given.  Be sure to give the ' + '`sig_request` parameter to Duo.init, or use the ' + '`data-sig-request` attribute on the iframe element.');
      }
    } // if postAction/Argument are defaults, see if they are specified
    // as data attributes on the iframe


    if (postAction === '') {
      postAction = getDataAttribute(promptElement, 'postAction') || postAction;
    }

    if (postArgument === 'sig_response') {
      postArgument = getDataAttribute(promptElement, 'postArgument') || postArgument;
    }

    if (isIframe(promptElement)) {
      iframe = promptElement;
      iframe.src = generateIframeSrc();
    } else {
      // If given a container to put an iframe in, clean out any children
      // child elements in case `init()` was called more than once.
      while (promptElement.firstChild) {
        // We call `removeChild()` instead of doing `innerHTML = ""`
        // to make sure we unbind any events.
        promptElement.removeChild(promptElement.firstChild);
      }

      iframe = document.createElement('iframe'); // Set the src and all other attributes on the new iframe.

      iframeAttributes['src'] = generateIframeSrc();

      for (var name in iframeAttributes) {
        iframe.setAttribute(name, iframeAttributes[name]);
      }

      promptElement.appendChild(iframe);
    } // listen for the 'message' event


    onMessage(onReceivedMessage);
  }
  /**
   * We received a postMessage from Duo.  POST back to the primary service
   * with the response token, and any additional user-supplied parameters
   * given in form#duo_form.
   */
  // function doPostBack(response) {
  //     // create a hidden input to contain the response token
  //     var input = document.createElement('input');
  //     input.type = 'hidden';
  //     input.name = postArgument;
  //     input.value = response + ':' + appSig;
  //     // user may supply their own form with additional inputs
  //     var form = document.getElementById('duo_form');
  //     // if the form doesn't exist, create one
  //     if (!form) {
  //         form = document.createElement('form');
  //         // insert the new form after the iframe
  //         iframe.parentElement.insertBefore(form, iframe.nextSibling);
  //     }
  //     // make sure we are actually posting to the right place
  //     form.method = 'POST';
  //     form.action = postAction;
  //     // add the response token input to the form
  //     form.appendChild(input);
  //     // away we go!
  //     if (typeof submitCallback === "function") {
  //         submitCallback.call(null, form);
  //     } else {
  //         form.submit();
  //     }
  // }
  // OKTA: Overriding their doPostBack logic because we want to submit this
  // through ajax, not a postBack


  function doPostBack(response) {
    postAction(response + ':' + appSig);
  }

  return {
    init: init,
    _onReady: onReady,
    _parseSigRequest: parseSigRequest,
    _isDuoMessage: isDuoMessage,
    _doPostBack: doPostBack
  };
});

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 9] */
var fn = {};

fn.getU2fEnrollErrorMessageKeyByCode = function (errorCode) {
  switch (errorCode) {
    default:
    case 1:
      return 'u2f.error.other';

    case 2:
    case 3:
      return 'u2f.error.badRequest';

    case 4:
      return 'u2f.error.unsupported';

    case 5:
      return 'u2f.error.timeout';
  }
};

fn.getU2fVerifyErrorMessageKeyByCode = function (errorCode, isOneFactor) {
  switch (errorCode) {
    case 1:
      // OTHER_ERROR
      return isOneFactor ? 'u2f.error.other.oneFactor' : 'u2f.error.other';

    case 2: // BAD_REQUEST

    case 3:
      // CONFIGURATION_UNSUPPORTED
      return isOneFactor ? 'u2f.error.badRequest.oneFactor' : 'u2f.error.badRequest';

    case 4:
      // DEVICE_INELIGIBLE
      return isOneFactor ? 'u2f.error.unsupported.oneFactor' : 'u2f.error.unsupported';

    case 5:
      // TIMEOUT
      return 'u2f.error.timeout';
  }
};

fn.getU2fEnrollErrorMessageByCode = function (errorCode) {
  return (0, _okta.loc)(fn.getU2fEnrollErrorMessageKeyByCode(errorCode), 'login');
};

fn.getU2fVerifyErrorMessageByCode = function (errorCode, isOneFactor) {
  return (0, _okta.loc)(fn.getU2fVerifyErrorMessageKeyByCode(errorCode, isOneFactor), 'login');
};

fn.getU2fVersion = function () {
  return 'U2F_V2';
};

fn.isU2fAvailable = function () {
  return Object.prototype.hasOwnProperty.call(window, 'u2f');
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _okta = __webpack_require__(2);

var _CookieUtil = _interopRequireDefault(__webpack_require__(245));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _BaseLoginModel = _interopRequireDefault(__webpack_require__(198));

var _Util = _interopRequireDefault(__webpack_require__(31));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginModel.default.extend({
  props: function props() {
    var cookieUsername = _CookieUtil.default.getCookieUsername();

    var properties = this.getUsernameAndRemember(cookieUsername);
    var props = {
      username: {
        type: 'string',
        validate: function validate(value) {
          if (_okta._.isEmpty(value)) {
            return (0, _okta.loc)('error.username.required', 'login');
          }
        },
        value: properties.username
      },
      lastUsername: ['string', false, cookieUsername],
      context: ['object', false],
      remember: ['boolean', true, properties.remember],
      multiOptionalFactorEnroll: ['boolean', true]
    };

    if (!(this.settings && this.settings.get('features.passwordlessAuth'))) {
      props.password = {
        type: 'string',
        validate: function validate(value) {
          if (_okta._.isEmpty(value)) {
            return (0, _okta.loc)('error.password.required', 'login');
          }
        }
      };
    }

    return props;
  },
  getUsernameAndRemember: function getUsernameAndRemember(cookieUsername) {
    var settingsUsername = this.settings && this.settings.get('username');
    var rememberMeEnabled = this.settings && this.settings.get('features.rememberMe');
    var remember = false;
    var username;

    if (settingsUsername) {
      username = settingsUsername;
      remember = rememberMeEnabled && username === cookieUsername;
    } else if (rememberMeEnabled && cookieUsername) {
      // Only respect the cookie if the feature is enabled.
      // Allows us to force prompting when necessary, e.g. SAML ForceAuthn
      username = cookieUsername;
      remember = true;
    }

    return {
      username: username,
      remember: remember
    };
  },
  constructor: function constructor(options) {
    this.settings = options && options.settings;
    this.appState = options && options.appState;

    _okta.Model.apply(this, arguments);

    this.listenTo(this, 'change:username', function (model, username) {
      this.set({
        remember: username === this.get('lastUsername')
      });
    });
  },
  parse: function parse(options) {
    return _okta._.omit(options, ['settings', 'appState']);
  },
  save: function save() {
    var _this = this;

    var username = this.settings.transformUsername(this.get('username'), _Enums.default.PRIMARY_AUTH);
    var remember = this.get('remember');
    var lastUsername = this.get('lastUsername');
    this.setUsernameCookie(username, remember, lastUsername); //the 'save' event here is triggered and used in the BaseLoginController
    //to disable the primary button on the primary auth form

    this.trigger('save');
    this.appState.trigger('loading', true);
    var signInArgs = this.getSignInArgs(username);
    var primaryAuthPromise;

    if (this.appState.get('isUnauthenticated')) {
      var authClient = this.appState.settings.authClient; // bootstrapped with stateToken

      if (this.appState.get('isIdxStateToken')) {
        // if its an idx stateToken, we send the parameter as identifier to login API
        primaryAuthPromise = this.doTransaction(function (transaction) {
          return this.doPrimaryAuth(authClient, signInArgs, transaction.login);
        });
      } else {
        primaryAuthPromise = this.doTransaction(function (transaction) {
          return this.doPrimaryAuth(authClient, signInArgs, transaction.authenticate);
        });
      }
    } else {
      //normal username/password flow without stateToken
      primaryAuthPromise = this.startTransaction(function (authClient) {
        return this.doPrimaryAuth(authClient, signInArgs, (0, _bind.default)(_okta._).call(_okta._, authClient.signInWithCredentials, authClient));
      });
    }

    return primaryAuthPromise.catch(function () {
      // Specific event handled by the Header for the case where the security image is not
      // enabled and we want to show a spinner. (Triggered only here and handled only by Header).
      _this.appState.trigger('removeLoading');

      _CookieUtil.default.removeUsernameCookie();
    }).finally(function () {
      _this.appState.trigger('loading', false);
    });
  },
  getSignInArgs: function getSignInArgs(username) {
    var multiOptionalFactorEnroll = this.get('multiOptionalFactorEnroll');
    var signInArgs = {};

    if (!this.settings.get('features.passwordlessAuth')) {
      signInArgs.password = this.get('password');
    } // if its an idx stateToken, we send the parameter as identifier to login API


    if (this.appState.get('isIdxStateToken')) {
      signInArgs.identifier = username;
    } else {
      //only post options param for non-idx flows
      signInArgs.username = username;
      signInArgs.options = {
        warnBeforePasswordExpired: true,
        multiOptionalFactorEnroll: multiOptionalFactorEnroll
      };
    }

    return signInArgs;
  },
  setUsernameCookie: function setUsernameCookie(username, remember, lastUsername) {
    // Do not modify the cookie when feature is disabled, relevant for SAML ForceAuthn prompts
    if (this.settings.get('features.rememberMe')) {
      // Only delete the cookie if its owner says so. This allows other
      // users to log in on a one-off basis.
      if (!remember && lastUsername === username) {
        _CookieUtil.default.removeUsernameCookie();
      } else if (remember) {
        _CookieUtil.default.setUsernameCookie(username);
      }
    }
  },
  doPrimaryAuth: function doPrimaryAuth(authClient, signInArgs, func) {
    var deviceFingerprintEnabled = this.settings.get('features.deviceFingerprinting');
    var typingPatternEnabled = this.settings.get('features.trackTypingPattern'); // Add the custom header for fingerprint, typing pattern if needed, and then remove it afterwards
    // Since we only need to send it for primary auth

    if (deviceFingerprintEnabled && this.appState.get('deviceFingerprint')) {
      // OKTA-325445
      authClient.options.headers['X-Device-Fingerprint'] = this.appState.get('deviceFingerprint');
    }

    if (typingPatternEnabled && this.appState.get('typingPattern')) {
      // OKTA-325445
      authClient.options.headers['X-Typing-Pattern'] = this.appState.get('typingPattern');
    } // TODO: remove when auth-js is updated: OKTA-325445


    authClient.options.headers = _Util.default.removeNils(authClient.options.headers);
    var self = this;
    return func(signInArgs).finally(function () {
      if (deviceFingerprintEnabled) {
        delete authClient.options.headers['X-Device-Fingerprint'];
        self.appState.unset('deviceFingerprint'); //Fingerprint can only be used once
      }

      if (typingPatternEnabled) {
        delete authClient.options.headers['X-Typing-Pattern'];
        self.appState.unset('typingPattern');
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  getUserAgent: function getUserAgent() {
    return navigator.userAgent;
  },
  isMessageFromCorrectSource: function isMessageFromCorrectSource($iframe, event) {
    return event.source === $iframe[0].contentWindow;
  },
  generateDeviceFingerprint: function generateDeviceFingerprint(oktaDomainUrl, element) {
    var userAgent = this.getUserAgent();

    if (!userAgent) {
      return _q.default.reject('user agent is not defined');
    } else if (isWindowsPhone(userAgent)) {
      return _q.default.reject('device fingerprint is not supported on Windows phones');
    }

    var deferred = _q.default.defer();

    var self = this;
    var $iframe;
    var iFrameTimeout;

    function isWindowsPhone(userAgent) {
      return userAgent.match(/windows phone|iemobile|wpdesktop/i);
    }

    function removeIframe() {
      $iframe.off();
      $iframe.remove();
      window.removeEventListener('message', onMessageReceivedFromOkta, false);
    }

    function handleError(reason) {
      removeIframe();
      deferred.reject(reason);
    }

    function onMessageReceivedFromOkta(event) {
      if (!self.isMessageFromCorrectSource($iframe, event)) {
        return;
      } // deviceFingerprint service is available, clear timeout


      clearTimeout(iFrameTimeout);

      if (!event || !event.data || event.origin !== oktaDomainUrl) {
        handleError('no data');
        return;
      }

      try {
        var message = JSON.parse(event.data);

        if (message && message.type === 'FingerprintServiceReady') {
          sendMessageToOkta({
            type: 'GetFingerprint'
          });
        } else if (message && message.type === 'FingerprintAvailable') {
          removeIframe();
          deferred.resolve(message.fingerprint);
        } else {
          handleError('no data');
        }
      } catch (error) {//Ignore any errors since we could get other messages too
      }
    }

    function sendMessageToOkta(message) {
      var win = $iframe[0].contentWindow;

      if (win) {
        win.postMessage((0, _stringify.default)(message), oktaDomainUrl);
      }
    } // Attach listener


    window.addEventListener('message', onMessageReceivedFromOkta, false); // Create and Load devicefingerprint page inside the iframe

    $iframe = (0, _okta.$)('<iframe>', {
      style: 'display: none;',
      src: oktaDomainUrl + '/auth/services/devicefingerprint'
    });
    element.append($iframe);
    iFrameTimeout = (0, _setTimeout2.default)(function () {
      // If the iFrame does not load, throw an error
      handleError('service not available');
    }, 2000);
    return deferred.promise;
  }
};
exports.default = _default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var STATE_HANDLE_SESSION_STORAGE_KEY = 'osw-oie-state-handle';
var LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY = 'osw-oie-last-initiated-login-url';

var removeStateHandle = function removeStateHandle() {
  sessionStorage.removeItem(STATE_HANDLE_SESSION_STORAGE_KEY);
  sessionStorage.removeItem(LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY);
};

var setStateHandle = function setStateHandle(token) {
  sessionStorage.setItem(STATE_HANDLE_SESSION_STORAGE_KEY, token);
  sessionStorage.setItem(LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY, window.location.href);
};

var getStateHandle = function getStateHandle() {
  return sessionStorage.getItem(STATE_HANDLE_SESSION_STORAGE_KEY);
};

var getLastInitiatedLoginUrl = function getLastInitiatedLoginUrl() {
  return sessionStorage.getItem(LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY);
};

var _default = {
  removeStateHandle: removeStateHandle,
  setStateHandle: setStateHandle,
  getStateHandle: getStateHandle,
  getLastInitiatedLoginUrl: getLastInitiatedLoginUrl
};
exports.default = _default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createTransactionMeta = createTransactionMeta;
exports.getTransactionMeta = getTransactionMeta;
exports.saveTransactionMeta = saveTransactionMeta;
exports.clearTransactionMeta = clearTransactionMeta;
exports.isTransactionMetaValid = isTransactionMetaValid;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _find = _interopRequireDefault(__webpack_require__(13));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _Logger = _interopRequireDefault(__webpack_require__(79));

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// Calculate new values
function createTransactionMeta(_x) {
  return _createTransactionMeta.apply(this, arguments);
}

function _createTransactionMeta() {
  _createTransactionMeta = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(settings) {
    var authClient;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authClient = settings.getAuthClient();
            return _context.abrupt("return", authClient.token.prepareTokenParams());

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createTransactionMeta.apply(this, arguments);
}

function getTransactionMeta(_x2) {
  return _getTransactionMeta.apply(this, arguments);
}

function _getTransactionMeta() {
  _getTransactionMeta = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(settings) {
    var authClient, existing, meta, codeChallenge, codeChallengeMethod;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            authClient = settings.getAuthClient(); // Load existing transaction meta from storage

            if (!authClient.transactionManager.exists()) {
              _context2.next = 6;
              break;
            }

            existing = authClient.transactionManager.load();

            if (!isTransactionMetaValid(settings, existing)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", existing);

          case 5:
            // existing meta is not valid for this configuration
            // this is common when changing configuration in local development environment
            // in a production environment, this may indicate that two apps are sharing a storage key
            _Logger.default.warn('Saved transaction meta does not match the current configuration. ' + 'This may indicate that two apps are sharing a storage key.');

          case 6:
            _context2.next = 8;
            return createTransactionMeta(settings);

          case 8:
            meta = _context2.sent;
            // If a codeChallenge was passed in config, use it
            codeChallenge = settings.get('codeChallenge');
            codeChallengeMethod = settings.get('codeChallengeMethod');

            if (codeChallenge) {
              meta.codeChallenge = codeChallenge;
            }

            if (codeChallengeMethod) {
              meta.codeChallengeMethod = codeChallengeMethod;
            }

            return _context2.abrupt("return", meta);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getTransactionMeta.apply(this, arguments);
}

function saveTransactionMeta(settings, meta) {
  var authClient = settings.getAuthClient();
  authClient.transactionManager.save(meta);
}

function clearTransactionMeta(settings) {
  var authClient = settings.getAuthClient();
  authClient.transactionManager.clear();
}

function isTransactionMetaValid(settings, meta) {
  // returns false if values in meta do not match current authClient options
  // this logic can be moved to okta-auth-js OKTA-371584
  var authOptions = ['clientId', 'redirectUri'];
  var authClient = settings.getAuthClient();
  var mismatch = (0, _find.default)(authOptions).call(authOptions, function (key) {
    return authClient.options[key] !== meta[key];
  });

  if (mismatch) {
    return false;
  } // if `codeChallenge` option was provided, validate it against the meta


  var codeChallenge = settings.get('codeChallenge');

  if (codeChallenge && meta.codeChallenge !== codeChallenge) {
    return false;
  } // if `codeChallengeMethod` option was provided, validate it against the meta


  var codeChallengeMethod = settings.get('codeChallengeMethod');

  if (codeChallengeMethod && meta.codeChallengeMethod !== codeChallengeMethod) {
    return false;
  }

  return true;
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(161));

var _indexOf = _interopRequireDefault(__webpack_require__(1242));

var _promise = _interopRequireDefault(__webpack_require__(200));

var _url = _interopRequireDefault(__webpack_require__(1243));

__webpack_require__(1249);

__webpack_require__(559);

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(165));

var _introspect = _interopRequireDefault(__webpack_require__(1278));

var _bootstrap = _interopRequireDefault(__webpack_require__(1287));

var _parsers = _interopRequireDefault(__webpack_require__(1294));

var _client = __webpack_require__(254);

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var LATEST_SUPPORTED_IDX_API_VERSION = '1.0.0';

var start = /*#__PURE__*/function () {
  var _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var _issuer, _issuer2;

    var clientId, domain, issuer, stateHandle, interactionHandle, version, redirectUri, state, scopes, codeChallenge, codeChallengeMethod, baseUrl, toPersist, cleanVersion, bootstrapParams, interaction_handle, _parsersForVersion, _makeIdxState, idxResponse, idxState;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            clientId = _ref.clientId, domain = _ref.domain, issuer = _ref.issuer, stateHandle = _ref.stateHandle, interactionHandle = _ref.interactionHandle, version = _ref.version, redirectUri = _ref.redirectUri, state = _ref.state, scopes = _ref.scopes, codeChallenge = _ref.codeChallenge, codeChallengeMethod = _ref.codeChallengeMethod;
            issuer = (_issuer = issuer) === null || _issuer === void 0 ? void 0 : _issuer.replace(/\/+$/, '');
            baseUrl = ((_issuer2 = issuer) === null || _issuer2 === void 0 ? void 0 : (0, _indexOf.default)(_issuer2).call(_issuer2, '/oauth2')) > 0 ? issuer : issuer + '/oauth2'; // org AS uses domain as AS, but we need the base url for calls

            toPersist = {
              baseUrl: baseUrl,
              clientId: clientId,
              state: state
            };

            if (!(!domain && !issuer)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", _promise.default.reject({
              error: 'issuer is required'
            }));

          case 6:
            if (!(!stateHandle && !clientId)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", _promise.default.reject({
              error: 'clientId is required'
            }));

          case 8:
            if (!(!stateHandle && !redirectUri)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _promise.default.reject({
              error: 'redirectUri is required'
            }));

          case 10:
            if (!(!stateHandle && !(codeChallenge && codeChallengeMethod))) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", _promise.default.reject({
              error: 'PKCE params (codeChallenge, codeChallengeMethod) are required'
            }));

          case 12:
            if (!domain) {
              domain = new _url.default(issuer).origin;
            }

            if (version) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", _promise.default.reject({
              error: 'version is required'
            }));

          case 15:
            cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');

            if (!(cleanVersion !== version || !version)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", _promise.default.reject({
              error: 'invalid version supplied - version is required and uses semver syntax'
            }));

          case 18:
            if (!(!stateHandle && !interactionHandle)) {
              _context.next = 31;
              break;
            }

            _context.prev = 19;
            bootstrapParams = {
              clientId: clientId,
              baseUrl: baseUrl,
              scopes: scopes,
              redirectUri: redirectUri,
              codeChallenge: codeChallenge,
              codeChallengeMethod: codeChallengeMethod,
              state: state
            };
            _context.next = 23;
            return (0, _bootstrap.default)(bootstrapParams);

          case 23:
            interaction_handle = _context.sent;
            interactionHandle = interaction_handle;
            toPersist.interactionHandle = interactionHandle;
            _context.next = 31;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](19);
            return _context.abrupt("return", _promise.default.reject({
              error: _context.t0
            }));

          case 31:
            _context.prev = 31;
            _parsersForVersion = (0, _parsers.default)(version), _makeIdxState = _parsersForVersion.makeIdxState;
            _context.next = 35;
            return (0, _introspect.default)({
              domain: domain,
              interactionHandle: interactionHandle,
              stateHandle: stateHandle,
              version: version
            }).catch(function (err) {
              return _promise.default.reject({
                error: 'introspect call failed',
                // Transform all errors into an IdX State object.
                // This allows IdX based errors (messages) to optionally proceed with remediation forms
                details: _makeIdxState(err, toPersist)
              });
            });

          case 35:
            idxResponse = _context.sent;
            idxState = _makeIdxState(idxResponse, toPersist);
            return _context.abrupt("return", idxState);

          case 40:
            _context.prev = 40;
            _context.t1 = _context["catch"](31);
            return _context.abrupt("return", _promise.default.reject({
              error: _context.t1
            }));

          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[19, 28], [31, 40]]);
  }));

  function start(_x) {
    return _start.apply(this, arguments);
  }

  return start;
}();

var _parsersForVersion2 = (0, _parsers.default)(LATEST_SUPPORTED_IDX_API_VERSION),
    makeIdxState = _parsersForVersion2.makeIdxState;

var _default = {
  start: start,
  introspect: _introspect.default,
  interact: _bootstrap.default,
  makeIdxState: makeIdxState,
  client: _client.HttpClient,
  LATEST_SUPPORTED_IDX_API_VERSION: LATEST_SUPPORTED_IDX_API_VERSION
};
exports.default = _default;

/***/ }),
/* 334 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var createNonEnumerableProperty = __webpack_require__(201);
var has = __webpack_require__(163);
var setGlobal = __webpack_require__(336);
var inspectSource = __webpack_require__(568);
var InternalStateModule = __webpack_require__(569);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var createNonEnumerableProperty = __webpack_require__(201);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var setGlobal = __webpack_require__(336);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(1253);
var store = __webpack_require__(337);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(1256);
var global = __webpack_require__(91);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 341 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = __webpack_require__(1262);
var stickyHelpers = __webpack_require__(1263);
var shared = __webpack_require__(338);
var create = __webpack_require__(1264);
var getInternalState = __webpack_require__(569).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(1268);
var UNSUPPORTED_NCG = __webpack_require__(1269);

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(str) {
    var re = this;
    var state = getInternalState(re);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(576);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(578);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(580);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(581);

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(1285);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(479);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(490);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(484);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(253);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _find = _interopRequireDefault(__webpack_require__(13));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _okta = __webpack_require__(2);

var _ViewFactory = _interopRequireDefault(__webpack_require__(1332));

var _IonResponseHelper = _interopRequireDefault(__webpack_require__(1426));

var _ViewClassNamesFactory = __webpack_require__(602);

var _RemediationConstants = __webpack_require__(24);

var _Util = _interopRequireDefault(__webpack_require__(31));

var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(331));

var _client = __webpack_require__(555);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Controller.extend({
  className: 'form-controller',
  appStateEvents: {
    'change:currentFormName': 'handleFormNameChange',
    'afterError': 'handleAfterError',
    'invokeAction': 'handleInvokeAction',
    'saveForm': 'handleSaveForm',
    'switchForm': 'handleSwitchForm'
  },
  preRender: function preRender() {
    this.removeChildren();
  },
  postRender: function postRender() {
    var currentViewState = this.options.appState.getCurrentViewState(); // TODO: add comments regarding when `currentViewState` would be null?

    if (!currentViewState) {
      return;
    }

    this.clearMetadata();

    var TheView = _ViewFactory.default.create(currentViewState.name, this.options.appState.get('authenticatorKey'));

    try {
      this.formView = this.add(TheView, {
        options: {
          currentViewState: currentViewState
        }
      }).last();
    } catch (error) {
      // This is the place where runtime error (NPE) happens at most of time.
      // It has been swallowed by Q.js hence add try/catch to surface up errors.
      this.options.settings.callGlobalError(error);
      return;
    }

    this.triggerAfterRenderEvent();
  },
  clearMetadata: function clearMetadata() {
    var formName = this.options.appState.get('currentFormName'); // TODO: OKTA-392835 shall not clear state handle at terminal page

    if ((0, _includes.default)(_RemediationConstants.TERMINAL_FORMS).call(_RemediationConstants.TERMINAL_FORMS, formName)) {
      _sessionStorageHelper.default.removeStateHandle();
    }
  },
  triggerAfterRenderEvent: function triggerAfterRenderEvent() {
    var contextData = this.createAfterEventContext();
    this.trigger('afterRender', contextData);
  },
  handleFormNameChange: function handleFormNameChange() {
    this.render();
  },
  handleAfterError: function handleAfterError() {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var contextData = this.createAfterEventContext();
    var errorContextData = {
      xhr: error,
      errorSummary: error.responseJSON && error.responseJSON.errorSummary
    }; // TODO: need some enhancement after https://github.com/okta/okta-idx-js/pull/27
    // OKTA-318062

    this.trigger('afterError', contextData, errorContextData);
  },
  createAfterEventContext: function createAfterEventContext() {
    var formName = this.options.appState.get('currentFormName');
    var authenticatorKey = this.options.appState.get('authenticatorKey');
    var methodType = this.options.appState.get('authenticatorMethodType');
    var isPasswordRecoveryFlow = this.options.appState.get('isPasswordRecoveryFlow');
    var v1ControllerClassName = (0, _ViewClassNamesFactory.getV1ClassName)(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
    var eventData = {
      controller: v1ControllerClassName,
      formName: formName
    };

    if (authenticatorKey) {
      eventData.authenticatorKey = authenticatorKey;
    }

    if (methodType) {
      eventData.methodType = methodType;
    }

    return eventData;
  },
  handleSwitchForm: function handleSwitchForm(formName) {
    // trigger formName change to change view
    if (this.options.appState.get('messages')) {
      // Clear messages before calling switch form.
      // If a form has errors sent form API inside messages
      // and user hits back to factors list which triggers switchForm,
      // those error will show up on another screen that gets rendered after switchForm
      this.options.appState.unset('messages');
    }

    this.options.appState.set('currentFormName', formName);
  },
  handleInvokeAction: function handleInvokeAction() {
    var _context,
        _this = this;

    var actionPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var idx = this.options.appState.get('idx');

    if (actionPath === 'cancel') {
      (0, _client.clearTransactionMeta)(this.options.settings);

      _sessionStorageHelper.default.removeStateHandle();

      this.options.appState.clearAppStateCache();
    }

    if ((0, _find.default)(_context = idx['neededToProceed']).call(_context, function (item) {
      return item.name === actionPath;
    })) {
      var _context2;

      idx.proceed(actionPath, {}).then((0, _bind.default)(_context2 = this.handleIdxSuccess).call(_context2, this)).catch(function (error) {
        _this.showFormErrors(_this.formView.model, error, _this.formView.form);
      });
      return;
    }

    var actionFn = idx['actions'][actionPath];

    if (_okta._.isFunction(actionFn)) {
      // TODO: OKTA-243167 what's the approach to show spinner indicating API in flight?
      actionFn().then(function (resp) {
        if (actionPath === 'cancel' && _this.options.settings.get('useInteractionCodeFlow')) {
          // In this case we need to restart login flow and recreate transaction meta
          // that will be used in interactionCodeFlow function
          _this.options.appState.trigger('restartLoginFlow');
        } else {
          _this.handleIdxSuccess(resp);
        }
      }).catch(function (error) {
        _this.showFormErrors(_this.formView.model, error, _this.formView.form);
      });
    } else {
      this.options.settings.callGlobalError("Invalid action selected: ".concat(actionPath));
      this.showFormErrors(this.formView.model, 'Invalid action selected.', this.formView.form);
    }
  },
  handleSaveForm: function handleSaveForm(model) {
    var _this2 = this;

    var formName = model.get('formName'); // Toggle Form saving status (e.g. disabling save button, etc)

    this.toggleFormButtonState(true);
    model.trigger('request'); // Use full page redirection if necessary

    if (model.get('useRedirect')) {
      // Clear when navigates away from SIW page, e.g. success, IdP Authenticator.
      // Because SIW sort of finished its current /transaction/
      _sessionStorageHelper.default.removeStateHandle();

      var currentViewState = this.options.appState.getCurrentViewState();

      _Util.default.redirectWithFormGet(currentViewState.href);

      return;
    } // Run hook: transform the user name (a.k.a identifier)


    var modelJSON = this.transformIdentifier(formName, model); // Error out when this is not a remediation form. Unexpected Exception.

    var idx = this.options.appState.get('idx');

    if (!this.options.appState.hasRemediationObject(formName)) {
      this.options.settings.callGlobalError("Cannot find http action for \"".concat(formName, "\"."));
      this.showFormErrors(this.formView.model, 'Cannot find action to proceed.', this.formView.form);
      return;
    } // Submit request to idx endpoint


    idx.proceed(formName, modelJSON).then(function (resp) {
      var _context3;

      var onSuccess = (0, _bind.default)(_context3 = _this2.handleIdxSuccess).call(_context3, _this2, resp);

      if (formName === _RemediationConstants.FORMS.ENROLL_PROFILE) {
        var _modelJSON$userProfil;

        // call registration (aka enroll profile) hook
        _this2.settings.postRegistrationSubmit(modelJSON === null || modelJSON === void 0 ? void 0 : (_modelJSON$userProfil = modelJSON.userProfile) === null || _modelJSON$userProfil === void 0 ? void 0 : _modelJSON$userProfil.email, onSuccess, function (error) {
          model.trigger('error', model, {
            responseJSON: error
          });
        });
      } else {
        onSuccess();
      }
    }).catch(function (error) {
      if (error.proceed && error.rawIdxState) {
        // Okta server responds 401 status code with WWW-Authenticate header and new remediation
        // so that the iOS/MacOS credential SSO extension (Okta Verify) can intercept
        // the response reaches here when Okta Verify is not installed
        // we need to return an idx object so that
        // the SIW can proceed to the next step without showing error
        _this2.handleIdxSuccess(error);
      } else {
        _this2.showFormErrors(model, error, _this2.formView.form);
      }
    }).finally(function () {
      _this2.toggleFormButtonState(false);
    });
  },
  transformIdentifier: function transformIdentifier(formName, model) {
    var modelJSON = model.toJSON();

    if (Object.prototype.hasOwnProperty.call(modelJSON, 'identifier')) {
      // The callback function is passed two arguments:
      // 1) username: The name entered by the user
      // 2) operation: The type of operation the user is trying to perform:
      //      - PRIMARY_AUTH
      //      - FORGOT_PASSWORD
      //      - UNLOCK_ACCOUNT
      var operation = _RemediationConstants.FORM_NAME_TO_OPERATION_MAP[formName];
      modelJSON.identifier = this.settings.transformUsername(modelJSON.identifier, operation);
    }

    return modelJSON;
  },
  showFormErrors: function showFormErrors(model, error, form) {
    model.trigger('clearFormError');

    if (!error) {
      error = 'FormController - unknown error found';
      this.options.settings.callGlobalError(error);
    }

    var errorObj;

    if (_IonResponseHelper.default.isIonErrorResponse(error)) {
      errorObj = _IonResponseHelper.default.convertFormErrors(error);
    } else if (error.errorSummary) {
      errorObj = {
        responseJSON: error
      };
    }

    var showErrorBanner = !(form === null || form === void 0 ? void 0 : form.isErrorCalloutCustomized(errorObj));
    model.trigger('error', model, errorObj || {
      responseJSON: {
        errorSummary: String(error)
      }
    }, showErrorBanner);

    if (!showErrorBanner) {
      form.showCustomErrorCallout(errorObj);
    }
  },
  handleIdxSuccess: function handleIdxSuccess(idxResp) {
    this.options.appState.trigger('remediationSuccess', idxResp);
  },

  /**
   * SignIn widget has its own (hacky) way to customize the button disabled state:
   * adding `link-button-disabled` despite the name was intend only to disable
   * `link-button`.
   * Instead of doing decent refactor, we want to follow the convention for now.
   *
   * @param {boolean} disabled whether add extra disable CSS class.
   */
  toggleFormButtonState: function toggleFormButtonState(disabled) {
    var _context4;

    var button = (0, _find.default)(_context4 = this.$el).call(_context4, '.o-form-button-bar .button');
    button.toggleClass('link-button-disabled', disabled);
  }
});

exports.default = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(581);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(580);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(578);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(576);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.FORGOT_PASSWORD_NOT_ENABLED = exports.REGISTRATION_NOT_ENABLED = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _find = _interopRequireDefault(__webpack_require__(13));

var _keys = _interopRequireDefault(__webpack_require__(117));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(160));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _LinksUtil = __webpack_require__(122);

var _EmailAuthenticatorHeader = _interopRequireDefault(__webpack_require__(606));

var _context, _context2, _terminalViewTitles;

var RETURN_LINK_EXPIRED_KEY = 'idx.return.link.expired';
var SAFE_MODE_KEY_PREFIX = 'idx.error.server.safe.mode';
var UNLOCK_ACCOUNT_TERMINAL_KEY = 'oie.selfservice.unlock_user.success.message';
var UNLOCK_ACCOUNT_FAILED_PERMISSIONS = 'oie.selfservice.unlock_user.challenge.failed.permissions';
var RESET_PASSWORD_NOT_ALLOWED = 'oie.selfservice.reset.password.not.allowed';
var RETURN_TO_ORIGINAL_TAB_KEY = 'idx.return.to.original.tab';
var OPERATION_CANCELED_ON_OTHER_DEVICE_KEY = 'idx.operation.cancelled.on.other.device';
var OPERATION_CANCELED_BY_USER_KEY = 'idx.operation.cancelled.by.user';
var DEVICE_ACTIVATED = 'idx.device.activated';
var DEVICE_NOT_ACTIVATED_CONSENT_DENIED = 'idx.device.not.activated.consent.denied';
var DEVICE_NOT_ACTIVATED_INTERNAL_ERROR = 'idx.device.not.activated.internal.error';
var FLOW_CONTINUE_IN_NEW_TAB = 'idx.transferred.to.new.tab';
var EMAIL_LINK_OUT_OF_DATE = 'idx.return.stale';
var EMAIL_LINK_CANT_BE_PROCESSED = 'idx.return.error';
var EMAIL_VERIFICATION_REQUIRED = 'idx.email.verification.required';
var EMAIL_ACTIVATION_EMAIL_EXPIRE = 'idx.expired.activation.token';
var EMAIL_ACTIVATION_EMAIL_INVALID = 'idx.missing.activation.token';
var EMAIL_ACTIVATION_EMAIL_SUBMITTED = 'idx.request.activation.email';
var EMAIL_ACTIVATION_EMAIL_SUSPENDED = 'idx.activating.inactive.user';
var REGISTRATION_NOT_ENABLED = 'oie.registration.is.not.enabled';
exports.REGISTRATION_NOT_ENABLED = REGISTRATION_NOT_ENABLED;
var FORGOT_PASSWORD_NOT_ENABLED = 'oie.forgot.password.is.not.enabled';
exports.FORGOT_PASSWORD_NOT_ENABLED = FORGOT_PASSWORD_NOT_ENABLED;
var EMAIL_AUTHENTICATOR_TERMINAL_KEYS = [FLOW_CONTINUE_IN_NEW_TAB, EMAIL_LINK_OUT_OF_DATE, EMAIL_LINK_CANT_BE_PROCESSED, EMAIL_VERIFICATION_REQUIRED, RETURN_TO_ORIGINAL_TAB_KEY, RETURN_LINK_EXPIRED_KEY, OPERATION_CANCELED_ON_OTHER_DEVICE_KEY, OPERATION_CANCELED_BY_USER_KEY];
var DEVICE_CODE_ERROR_KEYS = [DEVICE_NOT_ACTIVATED_CONSENT_DENIED, DEVICE_NOT_ACTIVATED_INTERNAL_ERROR];
var DEVICE_CODE_FLOW_TERMINAL_KEYS = (0, _concat.default)(_context = [DEVICE_ACTIVATED]).call(_context, DEVICE_CODE_ERROR_KEYS); // These terminal views build their own links, basically they have cancel remediation in error response
// Or doesn't require a Back to Sign in link because the flow didn't start from login screen

var NO_BACKTOSIGNIN_LINK_VIEWS = (0, _concat.default)(_context2 = [UNLOCK_ACCOUNT_TERMINAL_KEY, RETURN_TO_ORIGINAL_TAB_KEY, FLOW_CONTINUE_IN_NEW_TAB, OPERATION_CANCELED_ON_OTHER_DEVICE_KEY]).call(_context2, (0, _toConsumableArray2.default)(DEVICE_CODE_FLOW_TERMINAL_KEYS), [UNLOCK_ACCOUNT_FAILED_PERMISSIONS, RESET_PASSWORD_NOT_ALLOWED]); // Key map to transform terminal view titles {ApiKey : WidgetKey}  

var terminalViewTitles = (_terminalViewTitles = {}, (0, _defineProperty2.default)(_terminalViewTitles, RETURN_LINK_EXPIRED_KEY, 'oie.email.return.link.expired.title'), (0, _defineProperty2.default)(_terminalViewTitles, UNLOCK_ACCOUNT_TERMINAL_KEY, 'account.unlock.unlocked.title'), (0, _defineProperty2.default)(_terminalViewTitles, DEVICE_ACTIVATED, 'device.code.activated.success.title'), (0, _defineProperty2.default)(_terminalViewTitles, REGISTRATION_NOT_ENABLED, 'oie.registration.form.title'), (0, _defineProperty2.default)(_terminalViewTitles, FORGOT_PASSWORD_NOT_ENABLED, 'password.reset.title.generic'), (0, _defineProperty2.default)(_terminalViewTitles, EMAIL_ACTIVATION_EMAIL_EXPIRE, 'oie.activation.request.email.title.expire'), (0, _defineProperty2.default)(_terminalViewTitles, EMAIL_ACTIVATION_EMAIL_SUBMITTED, 'oie.activation.request.email.title.submitted'), (0, _defineProperty2.default)(_terminalViewTitles, EMAIL_ACTIVATION_EMAIL_SUSPENDED, 'oie.activation.request.email.title.suspended'), (0, _defineProperty2.default)(_terminalViewTitles, EMAIL_ACTIVATION_EMAIL_INVALID, 'oie.activation.request.email.title.invalid'), (0, _defineProperty2.default)(_terminalViewTitles, DEVICE_NOT_ACTIVATED_CONSENT_DENIED, 'device.code.activated.error.title'), (0, _defineProperty2.default)(_terminalViewTitles, DEVICE_NOT_ACTIVATED_INTERNAL_ERROR, 'device.code.activated.error.title'), (0, _defineProperty2.default)(_terminalViewTitles, RETURN_TO_ORIGINAL_TAB_KEY, 'oie.consent.enduser.email.allow.title'), _terminalViewTitles);

var Body = _internals.BaseForm.extend({
  noButtonBar: true,
  postRender: function postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);

    this.$el.addClass('terminal-state'); // show device code terminal icons

    if (this.options.appState.containsMessageWithI18nKey(DEVICE_CODE_FLOW_TERMINAL_KEYS)) {
      var iconClass = this.options.appState.containsMessageWithI18nKey(DEVICE_ACTIVATED) ? 'success-24-green' : 'error-24-red';
      this.$('.o-form-head').before('<div class="device-code-terminal--icon-container">' + '<span class="device-code-terminal--icon ' + iconClass + '"></span>' + '</div>');
    }
  },
  title: function title() {
    return this.getTerminalViewTitle();
  },
  getTerminalViewTitle: function getTerminalViewTitle() {
    var _this = this;

    if (this.options.appState.containsMessageStartingWithI18nKey(SAFE_MODE_KEY_PREFIX)) {
      return (0, _okta.loc)('oie.safe.mode.title', 'login');
    }

    var apiKeys = (0, _keys.default)(terminalViewTitles);
    var key = (0, _find.default)(apiKeys).call(apiKeys, function (key) {
      return _this.options.appState.containsMessageWithI18nKey(key);
    });

    if (key) {
      return (0, _okta.loc)(terminalViewTitles[key], 'login');
    }
  },
  showMessages: function showMessages() {
    var _this2 = this;

    var messagesObjs = this.options.appState.get('messages');
    var description;

    if (this.options.appState.containsMessageWithI18nKey(OPERATION_CANCELED_ON_OTHER_DEVICE_KEY)) {
      description = (0, _okta.loc)('idx.operation.cancelled.on.other.device', 'login');
      messagesObjs.value.push({
        message: (0, _okta.loc)('oie.consent.enduser.deny.description', 'login')
      });
    } else if (this.options.appState.containsMessageWithI18nKey(RETURN_TO_ORIGINAL_TAB_KEY)) {
      description = (0, _okta.loc)('oie.consent.enduser.email.allow.description', 'login');
      messagesObjs.value.push({
        message: (0, _okta.loc)('oie.return.to.original.tab', 'login')
      });
    } else if (this.options.appState.containsMessageWithI18nKey('tooManyRequests')) {
      description = (0, _okta.loc)('oie.tooManyRequests', 'login');
    }

    if (description && (0, _isArray.default)(messagesObjs === null || messagesObjs === void 0 ? void 0 : messagesObjs.value)) {
      messagesObjs.value[0].message = description;
    }

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context3;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context3 = messagesObjs.value).call(_context3, function (messagesObj) {
        var _messagesObj$i18n;

        var msg = messagesObj.message;

        if (messagesObj.class === 'ERROR' || ((_messagesObj$i18n = messagesObj.i18n) === null || _messagesObj$i18n === void 0 ? void 0 : _messagesObj$i18n.key) === RETURN_LINK_EXPIRED_KEY) {
          _this2.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), {
            selector: '.o-form-error-container',
            prepend: true
          });
        } else {
          _this2.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
});

var Footer = _internals.BaseFooter.extend({
  // All terminal views should have Back to sign in link either widget configured or server configured.
  links: function links() {
    if (this.options.appState.containsMessageStartingWithI18nKey(SAFE_MODE_KEY_PREFIX)) {
      return (0, _LinksUtil.getSkipSetupLink)(this.options.appState);
    }

    if (this.options.appState.containsMessageWithI18nKey(DEVICE_CODE_ERROR_KEYS)) {
      return (0, _LinksUtil.getReloadPageButtonLink)();
    }

    if (!this.options.appState.containsMessageWithI18nKey(NO_BACKTOSIGNIN_LINK_VIEWS)) {
      return (0, _LinksUtil.getBackToSignInLink)(this.options.settings);
    }
  }
});

var _default = _internals.BaseView.extend({
  initialize: function initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);

    if (this.options.appState.containsMessageWithI18nKey(EMAIL_AUTHENTICATOR_TERMINAL_KEYS)) {
      this.Header = _EmailAuthenticatorHeader.default;
    }
  },
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _LinksUtil = __webpack_require__(122);

var _default = _internals.BaseFooter.extend({
  links: function links() {
    return (0, _LinksUtil.getSwitchAuthenticatorLink)(this.options.appState);
  }
});

exports.default = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var fails = __webpack_require__(6);
var createElement = __webpack_require__(259);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var inspectSource = __webpack_require__(261);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(37);
var ownKeys = __webpack_require__(264);
var getOwnPropertyDescriptorModule = __webpack_require__(48);
var definePropertyModule = __webpack_require__(25);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(37);
var toIndexedObject = __webpack_require__(62);
var indexOf = __webpack_require__(170).indexOf;
var hiddenKeys = __webpack_require__(168);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(267);

module.exports = NATIVE_SYMBOL
  /* global Symbol -- safe */
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(63);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(62);
var nativeGetOwnPropertyNames = __webpack_require__(123).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(20);

exports.f = wellKnownSymbol;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(110);
var toObject = __webpack_require__(32);
var callWithSafeIterationClosing = __webpack_require__(641);
var isArrayIteratorMethod = __webpack_require__(270);
var toLength = __webpack_require__(22);
var createProperty = __webpack_require__(126);
var getIteratorMethod = __webpack_require__(176);

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(109);
var toLength = __webpack_require__(22);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(125);
var toLength = __webpack_require__(22);
var bind = __webpack_require__(110);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(46).forEach;
var arrayMethodIsStrict = __webpack_require__(102);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(62);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(22);
var arrayMethodIsStrict = __webpack_require__(102);

var min = Math.min;
var nativeLastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return nativeLastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(74);
var createNonEnumerableProperty = __webpack_require__(50);
var has = __webpack_require__(37);
var wellKnownSymbol = __webpack_require__(20);
var IS_PURE = __webpack_require__(72);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(58);
var isObject = __webpack_require__(15);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(19);
var fails = __webpack_require__(6);
var objectKeys = __webpack_require__(173);
var getOwnPropertySymbolsModule = __webpack_require__(266);
var propertyIsEnumerableModule = __webpack_require__(207);
var toObject = __webpack_require__(32);
var IndexedObject = __webpack_require__(166);

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  /* global Symbol -- required for testing */
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var objectKeys = __webpack_require__(173);
var toIndexedObject = __webpack_require__(62);
var propertyIsEnumerable = __webpack_require__(207).f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__(172);

// eslint-disable-next-line unicorn/no-unsafe-regex -- safe
module.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(32);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(213).charAt;
var InternalStateModule = __webpack_require__(57);
var defineIterator = __webpack_require__(273);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var trim = __webpack_require__(146).trim;
var whitespaces = __webpack_require__(219);

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var trim = __webpack_require__(146).trim;
var whitespaces = __webpack_require__(219);

var $parseFloat = global.parseFloat;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(101);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  if (typeof value != 'number' && classof(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

var log = Math.log;

// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : log(1 + x);
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);

module.exports = global.Promise;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(172);

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var getOwnPropertyDescriptor = __webpack_require__(48).f;
var macrotask = __webpack_require__(282).set;
var IS_IOS = __webpack_require__(388);
var IS_WEBOS_WEBKIT = __webpack_require__(779);
var IS_NODE = __webpack_require__(124);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var isObject = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(222);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(25).f;
var create = __webpack_require__(94);
var redefineAll = __webpack_require__(147);
var bind = __webpack_require__(110);
var anInstance = __webpack_require__(114);
var iterate = __webpack_require__(112);
var defineIterator = __webpack_require__(273);
var setSpecies = __webpack_require__(144);
var DESCRIPTORS = __webpack_require__(19);
var fastKey = __webpack_require__(127).fastKey;
var InternalStateModule = __webpack_require__(57);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(147);
var getWeakData = __webpack_require__(127).getWeakData;
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(15);
var anInstance = __webpack_require__(114);
var iterate = __webpack_require__(112);
var ArrayIterationModule = __webpack_require__(46);
var $has = __webpack_require__(37);
var InternalStateModule = __webpack_require__(57);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.3.3.3 WeakMap.prototype.get(key)
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // 23.3.3.5 WeakMap.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // 23.4.3.1 WeakSet.prototype.add(value)
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(22);

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var toPositiveInteger = __webpack_require__(794);

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(32);
var toLength = __webpack_require__(22);
var getIteratorMethod = __webpack_require__(176);
var isArrayIteratorMethod = __webpack_require__(270);
var bind = __webpack_require__(110);
var aTypedArrayConstructor = __webpack_require__(21).aTypedArrayConstructor;

module.exports = function from(source /* , mapfn, thisArg */) {
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod != undefined && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    O = [];
    while (!(step = next.call(iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2], 2);
  }
  length = toLength(O.length);
  result = new (aTypedArrayConstructor(this))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};


/***/ }),
/* 396 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(6);
var wellKnownSymbol = __webpack_require__(20);
var IS_PURE = __webpack_require__(72);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(211);
var $ = __webpack_require__(3);
var getBuiltIn = __webpack_require__(63);
var USE_NATIVE_URL = __webpack_require__(397);
var redefine = __webpack_require__(51);
var redefineAll = __webpack_require__(147);
var setToStringTag = __webpack_require__(82);
var createIteratorConstructor = __webpack_require__(274);
var InternalStateModule = __webpack_require__(57);
var anInstance = __webpack_require__(114);
var hasOwn = __webpack_require__(37);
var bind = __webpack_require__(110);
var classof = __webpack_require__(177);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(15);
var create = __webpack_require__(94);
var createPropertyDescriptor = __webpack_require__(100);
var getIterator = __webpack_require__(851);
var getIteratorMethod = __webpack_require__(176);
var wellKnownSymbol = __webpack_require__(20);

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var fails = __webpack_require__(28);
var createElement = __webpack_require__(286);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var setGlobal = __webpack_require__(861);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(291);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(44);
var fails = __webpack_require__(28);
var objectKeys = __webpack_require__(182);
var getOwnPropertySymbolsModule = __webpack_require__(294);
var propertyIsEnumerableModule = __webpack_require__(225);
var toObject = __webpack_require__(75);
var IndexedObject = __webpack_require__(226);

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(59);
var toIndexedObject = __webpack_require__(83);
var indexOf = __webpack_require__(287).indexOf;
var hiddenKeys = __webpack_require__(183);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefined;
// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBoolean;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || __WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj) === '[object Boolean]';
}


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Number'));


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Symbol'));


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('ArrayBuffer'));


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNaN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNumber_js__ = __webpack_require__(407);



// Is the given value `NaN`?
function isNaN(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isNumber_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["g" /* _isNaN */])(obj);
}


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isDataView_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__ = __webpack_require__(873);





// Is a given value a typed array?
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  // `ArrayBuffer.isView` is the most future-proof, so use it when available.
  // Otherwise, fall back on the above regular expression.
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* nativeIsView */] ? (Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* nativeIsView */])(obj) && !Object(__WEBPACK_IMPORTED_MODULE_1__isDataView_js__["a" /* default */])(obj)) :
                Object(__WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__["a" /* default */])(obj) && typedArrayPattern.test(__WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["r" /* supportsArrayBuffer */] ? isTypedArray : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(false));


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constant;
// Predicate-generating function. Often useful outside of Underscore.
function constant(value) {
  return function() {
    return value;
  };
}


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSizePropertyCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Common internal logic for `isArrayLike` and `isBufferLike`.
function createSizePropertyCheck(getSizeProperty) {
  return function(collection) {
    var sizeProperty = getSizeProperty(collection);
    return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= __WEBPACK_IMPORTED_MODULE_0__setup_js__["b" /* MAX_ARRAY_INDEX */];
  }
}


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowProperty;
// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collectNonEnumProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(116);




// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys) {
  var hash = {};
  for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
  return {
    contains: function(key) { return hash[key]; },
    push: function(key) {
      hash[key] = true;
      return keys.push(key);
    }
  };
}

// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj, keys) {
  keys = emulatedSet(keys);
  var nonEnumIdx = __WEBPACK_IMPORTED_MODULE_0__setup_js__["n" /* nonEnumerableProps */].length;
  var constructor = obj.constructor;
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(constructor) && constructor.prototype || __WEBPACK_IMPORTED_MODULE_0__setup_js__["c" /* ObjProto */];

  // Constructor is a special case.
  var prop = 'constructor';
  if (Object(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, prop) && !keys.contains(prop)) keys.push(prop);

  while (nonEnumIdx--) {
    prop = __WEBPACK_IMPORTED_MODULE_0__setup_js__["n" /* nonEnumerableProps */][nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
      keys.push(prop);
    }
  }
}


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(47);


// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object, attrs) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(attrs), length = _keys.length;
  if (object == null) return !length;
  var obj = Object(object);
  for (var i = 0; i < length; i++) {
    var key = _keys[i];
    if (attrs[key] !== obj[key] || !(key in obj)) return false;
  }
  return true;
}


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(47);


// Invert the keys and values of an object. The values must be serializable.
function invert(obj) {
  var result = {};
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  for (var i = 0, length = _keys.length; i < length; i++) {
    result[obj[_keys[i]]] = _keys[i];
  }
  return result;
}


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = functions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(76);


// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(obj[key])) names.push(key);
  }
  return names.sort();
}


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(185);



// Extend a given object with all the properties in passed-in object(s).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */]));


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(185);



// Fill in a given object with default properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */], true));


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);



// Create a naked function reference for surrogate-prototype-swapping.
function ctor() {
  return function(){};
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(prototype)) return {};
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["j" /* nativeCreate */]) return Object(__WEBPACK_IMPORTED_MODULE_1__setup_js__["j" /* nativeCreate */])(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor;
  Ctor.prototype = null;
  return result;
}


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extend_js__ = __webpack_require__(419);




// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return obj;
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) ? obj.slice() : Object(__WEBPACK_IMPORTED_MODULE_2__extend_js__["a" /* default */])({}, obj);
}


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPath_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepGet_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isUndefined_js__ = __webpack_require__(405);




// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object, path, defaultValue) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__deepGet_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_0__toPath_js__["a" /* default */])(path));
  return Object(__WEBPACK_IMPORTED_MODULE_2__isUndefined_js__["a" /* default */])(value) ? defaultValue : value;
}


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(133);



// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(path) ? path : [path];
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath = toPath;


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseIteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matcher_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__property_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__ = __webpack_require__(187);








// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(value)) return Object(__WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__["a" /* default */])(value, context, argCount);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)) return Object(__WEBPACK_IMPORTED_MODULE_4__matcher_js__["a" /* default */])(value);
  return Object(__WEBPACK_IMPORTED_MODULE_5__property_js__["a" /* default */])(value);
}


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(425);



// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee(value, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, Infinity);
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee = iteratee;


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
// Predicate-generating function. Often useful outside of Underscore.
function noop(){}


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = random;
// Return a random integer between `min` and `max` (inclusive).
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEscaper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(47);


// Internal helper to generate functions for escaping and unescaping strings
// to/from HTML interpolation.
function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  // Regexes for identifying a key that needs to be escaped.
  var source = '(?:' + Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(map).join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Internal list of HTML entities for escaping.
/* harmony default export */ __webpack_exports__["a"] = ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
});


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);


// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
});


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = executeBound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(132);



// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(result)) return result;
  return self;
}


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__executeBound_js__ = __webpack_require__(432);




// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, context, args) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(func)) throw new TypeError('Bind must be called on a function');
  var bound = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(callArgs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__executeBound_js__["a" /* default */])(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
}));


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);


// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
}));


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = before;
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function before(times, func) {
  var memo;
  return function() {
    if (--times > 0) {
      memo = func.apply(this, arguments);
    }
    if (times <= 1) func = null;
    return memo;
  };
}


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(47);



// Returns the first key on an object that passes a truth test.
function findKey(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj), key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPredicateIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(77);



// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir) {
  return function(array, predicate, context) {
    predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
    var length = Object(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(437);


// Returns the last index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(-1));


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortedIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(77);



// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array, obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0, high = Object(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
  }
  return low;
}


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__ = __webpack_require__(441);




// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__["a" /* default */])(1, __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__["a" /* default */]));


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isNaN_js__ = __webpack_require__(410);




// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function(array, item, idx) {
    var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(__WEBPACK_IMPORTED_MODULE_1__setup_js__["q" /* slice */].call(array, i, length), __WEBPACK_IMPORTED_MODULE_2__isNaN_js__["a" /* default */]);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = find;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findKey_js__ = __webpack_require__(436);




// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__findKey_js__["a" /* default */];
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(187);




// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function(obj, iteratee, memo, initial) {
    var _keys = !Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  return function(obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, Object(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, context, 4), memo, initial);
  };
}


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(134);





// Return the maximum element (or element-based computation).
function max(obj, iteratee, context) {
  var result = -Infinity, lastComputed = -Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value > result) {
        result = value;
      }
    }
  } else {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clone_js__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__random_js__ = __webpack_require__(428);






// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample(obj, n, guard) {
  if (n == null || guard) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = Object(__WEBPACK_IMPORTED_MODULE_2__values_js__["a" /* default */])(obj);
    return obj[Object(__WEBPACK_IMPORTED_MODULE_4__random_js__["a" /* default */])(obj.length - 1)];
  }
  var sample = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? Object(__WEBPACK_IMPORTED_MODULE_1__clone_js__["a" /* default */])(obj) : Object(__WEBPACK_IMPORTED_MODULE_2__values_js__["a" /* default */])(obj);
  var length = Object(__WEBPACK_IMPORTED_MODULE_3__getLength_js__["a" /* default */])(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = Object(__WEBPACK_IMPORTED_MODULE_4__random_js__["a" /* default */])(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__allKeys_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flatten_js__ = __webpack_require__(150);







// Return a copy of the object only containing the allowed properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var result = {}, iteratee = keys[0];
  if (obj == null) return result;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    if (keys.length > 1) iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, keys[1]);
    keys = Object(__WEBPACK_IMPORTED_MODULE_3__allKeys_js__["a" /* default */])(obj);
  } else {
    iteratee = __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__["a" /* default */];
    keys = Object(__WEBPACK_IMPORTED_MODULE_5__flatten_js__["a" /* default */])(keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = keys.length; i < length; i++) {
    var key = keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
}));


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, n == null || guard ? 1 : n);
}


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(189);





// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, rest) {
  rest = Object(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(rest, true, true);
  return Object(__WEBPACK_IMPORTED_MODULE_2__filter_js__["a" /* default */])(array, function(value){
    return !Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(rest, value);
  });
}));


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBoolean_js__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(189);





// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isBoolean_js__["a" /* default */])(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = Object(__WEBPACK_IMPORTED_MODULE_1__cb_js__["a" /* default */])(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_2__getLength_js__["a" /* default */])(array); i < length; i++) {
    var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(result, value)) {
      result.push(value);
    }
  }
  return result;
}


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unzip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pluck_js__ = __webpack_require__(309);




// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = array && Object(__WEBPACK_IMPORTED_MODULE_0__max_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]).length || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = Object(__WEBPACK_IMPORTED_MODULE_2__pluck_js__["a" /* default */])(array, index);
  }
  return result;
}


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);


// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? Object(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj).chain() : obj;
}


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(454);

module.exports = parent;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(937);
var path = __webpack_require__(23);

var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(938);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(457);

module.exports = parent;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(948);
var path = __webpack_require__(23);

module.exports = path.Object.keys;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(459);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(139);
var getIterator = __webpack_require__(468);

module.exports = getIterator;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var inspectSource = __webpack_require__(461);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(401);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var createIteratorConstructor = __webpack_require__(463);
var getPrototypeOf = __webpack_require__(234);
var setPrototypeOf = __webpack_require__(312);
var setToStringTag = __webpack_require__(106);
var createNonEnumerableProperty = __webpack_require__(85);
var redefine = __webpack_require__(138);
var wellKnownSymbol = __webpack_require__(34);
var IS_PURE = __webpack_require__(87);
var Iterators = __webpack_require__(137);
var IteratorsCore = __webpack_require__(464);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(464).IteratorPrototype;
var create = __webpack_require__(191);
var createPropertyDescriptor = __webpack_require__(129);
var setToStringTag = __webpack_require__(106);
var Iterators = __webpack_require__(137);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(234);
var createNonEnumerableProperty = __webpack_require__(85);
var has = __webpack_require__(59);
var wellKnownSymbol = __webpack_require__(34);
var IS_PURE = __webpack_require__(87);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(96);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(148);
var requireObjectCoercible = __webpack_require__(131);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var getIteratorMethod = __webpack_require__(192);

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(139);
var isIterable = __webpack_require__(952);

module.exports = isIterable;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(471);

module.exports = parent;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
__webpack_require__(954);
var path = __webpack_require__(23);

module.exports = path.Array.from;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(115);
var toObject = __webpack_require__(75);
var callWithSafeIterationClosing = __webpack_require__(473);
var isArrayIteratorMethod = __webpack_require__(474);
var toLength = __webpack_require__(66);
var createProperty = __webpack_require__(152);
var getIteratorMethod = __webpack_require__(192);

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(34);
var Iterators = __webpack_require__(137);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(34);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(477);

module.exports = parent;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(478);
__webpack_require__(139);
__webpack_require__(105);
var WrappedWellKnownSymbolModule = __webpack_require__(314);

module.exports = WrappedWellKnownSymbolModule.f('iterator');


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(480);
__webpack_require__(984);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
// TODO: Remove from `core-js@4`
__webpack_require__(988);

module.exports = parent;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(481);
__webpack_require__(318);
__webpack_require__(482);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(478);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
var path = __webpack_require__(23);

module.exports = path.Symbol;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var fails = __webpack_require__(28);
var isArray = __webpack_require__(136);
var isObject = __webpack_require__(38);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(66);
var createProperty = __webpack_require__(152);
var arraySpeciesCreate = __webpack_require__(235);
var arrayMethodHasSpeciesSupport = __webpack_require__(193);
var wellKnownSymbol = __webpack_require__(34);
var V8_VERSION = __webpack_require__(316);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var global = __webpack_require__(33);
var getBuiltIn = __webpack_require__(96);
var IS_PURE = __webpack_require__(87);
var DESCRIPTORS = __webpack_require__(44);
var NATIVE_SYMBOL = __webpack_require__(291);
var USE_SYMBOL_AS_UID = __webpack_require__(402);
var fails = __webpack_require__(28);
var has = __webpack_require__(59);
var isArray = __webpack_require__(136);
var isObject = __webpack_require__(38);
var anObject = __webpack_require__(53);
var toObject = __webpack_require__(75);
var toIndexedObject = __webpack_require__(83);
var toPrimitive = __webpack_require__(227);
var createPropertyDescriptor = __webpack_require__(129);
var nativeObjectCreate = __webpack_require__(191);
var objectKeys = __webpack_require__(182);
var getOwnPropertyNamesModule = __webpack_require__(319);
var getOwnPropertyNamesExternal = __webpack_require__(968);
var getOwnPropertySymbolsModule = __webpack_require__(294);
var getOwnPropertyDescriptorModule = __webpack_require__(128);
var definePropertyModule = __webpack_require__(86);
var propertyIsEnumerableModule = __webpack_require__(225);
var createNonEnumerableProperty = __webpack_require__(85);
var redefine = __webpack_require__(138);
var shared = __webpack_require__(290);
var sharedKey = __webpack_require__(233);
var hiddenKeys = __webpack_require__(183);
var uid = __webpack_require__(228);
var wellKnownSymbol = __webpack_require__(34);
var wrappedWellKnownSymbolModule = __webpack_require__(314);
var defineWellKnownSymbol = __webpack_require__(42);
var setToStringTag = __webpack_require__(106);
var InternalStateModule = __webpack_require__(95);
var $forEach = __webpack_require__(97).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(996);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(485);

module.exports = parent;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1001);
var path = __webpack_require__(23);

module.exports = path.Array.isArray;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
var forEach = __webpack_require__(1002);
var classof = __webpack_require__(118);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.forEach)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? forEach : own;
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1015);

module.exports = parent;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(489);

module.exports = parent;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(1018);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.indexOf) ? indexOf : own;
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1037);

module.exports = parent;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var global = __webpack_require__(33);
var userAgent = __webpack_require__(317);

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1042);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1046);

module.exports = parent;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1063);

module.exports = parent;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(496);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(497);

module.exports = parent;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var slice = __webpack_require__(1065);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.slice) ? slice : own;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1067);

module.exports = parent;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(480);

module.exports = parent;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(99);

var _exception = __webpack_require__(141);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(501);

var _decorators = __webpack_require__(1087);

var _logger = __webpack_require__(502);

var _logger2 = _interopRequireDefault(_logger);

var _internalProtoAccess = __webpack_require__(503);

var VERSION = '4.7.6';
exports.VERSION = VERSION;
var COMPILER_REVISION = 8;
exports.COMPILER_REVISION = COMPILER_REVISION;
var LAST_COMPATIBLE_COMPILER_REVISION = 7;

exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0 <4.3.0',
  8: '>= 4.3.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
    _internalProtoAccess.resetLoggedProperties();
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
exports.moveHelperToHooks = moveHelperToHooks;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(1080);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(1081);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(1082);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(1083);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(1084);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(1085);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(1086);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}

function moveHelperToHooks(instance, helperName, keepHelper) {
  if (instance.helpers[helperName]) {
    instance.hooks[helperName] = instance.helpers[helperName];
    if (!keepHelper) {
      delete instance.helpers[helperName];
    }
  }
}


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(99);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      // eslint-disable-next-line no-console
      if (!console[method]) {
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createProtoAccessControl = createProtoAccessControl;
exports.resultIsAllowed = resultIsAllowed;
exports.resetLoggedProperties = resetLoggedProperties;
// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _createNewLookupObject = __webpack_require__(1089);

var _logger = __webpack_require__(502);

var logger = _interopRequireWildcard(_logger);

var loggedProperties = Object.create(null);

function createProtoAccessControl(runtimeOptions) {
  var defaultMethodWhiteList = Object.create(null);
  defaultMethodWhiteList['constructor'] = false;
  defaultMethodWhiteList['__defineGetter__'] = false;
  defaultMethodWhiteList['__defineSetter__'] = false;
  defaultMethodWhiteList['__lookupGetter__'] = false;

  var defaultPropertyWhiteList = Object.create(null);
  // eslint-disable-next-line no-proto
  defaultPropertyWhiteList['__proto__'] = false;

  return {
    properties: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
      defaultValue: runtimeOptions.allowProtoMethodsByDefault
    }
  };
}

function resultIsAllowed(result, protoAccessControl, propertyName) {
  if (typeof result === 'function') {
    return checkWhiteList(protoAccessControl.methods, propertyName);
  } else {
    return checkWhiteList(protoAccessControl.properties, propertyName);
  }
}

function checkWhiteList(protoAccessControlForType, propertyName) {
  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
    return protoAccessControlForType.whitelist[propertyName] === true;
  }
  if (protoAccessControlForType.defaultValue !== undefined) {
    return protoAccessControlForType.defaultValue;
  }
  logUnexpecedPropertyAccessOnce(propertyName);
  return false;
}

function logUnexpecedPropertyAccessOnce(propertyName) {
  if (loggedProperties[propertyName] !== true) {
    loggedProperties[propertyName] = true;
    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
  }
}

function resetLoggedProperties() {
  Object.keys(loggedProperties).forEach(function (propertyName) {
    delete loggedProperties[propertyName];
  });
}


/***/ }),
/* 504 */
/***/ (function(module, exports) {

var __self__ = (function (root) {
function F() {
this.fetch = false;
this.DOMException = root.DOMException
}
F.prototype = root;
return new F();
})(typeof self !== 'undefined' ? self : this);
(function(self) {

var irrelevant = (function (exports) {
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

}({}));
})(__self__);
delete __self__.fetch.polyfill
exports = __self__.fetch // To enable: import fetch from 'cross-fetch'
exports.default = __self__.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = __self__.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = __self__.Headers
exports.Request = __self__.Request
exports.Response = __self__.Response
module.exports = exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 * 
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 * 
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.OktaAuth=t():e.OktaAuth=t()}(window,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=41)}([function(e,t,n){"use strict";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function r(e){return o(btoa(e))}function o(e){return e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}function i(e){return e.replace(/-/g,"+").replace(/_/g,"/")}function a(e){var t=i(e);switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Not a valid Base64Url"}var n=atob(t);try{return decodeURIComponent(escape(n))}catch(e){return n}}function s(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}function u(e){return atob(i(e))}function c(e,t){var n=Array.prototype.slice.call(arguments,2);return function(){var r=Array.prototype.slice.call(arguments);return r=n.concat(r),e.apply(t,r)}}function f(e){return/^(?:[a-z]+:)?\/\//i.test(e)}function d(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return f(e)?e:(t=C(t),"/"===e[0]?"".concat(t).concat(e):"".concat(t,"/").concat(e))}function l(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return f(e)&&(e=e.substring(t.length)),"/"===e[0]?e:"/".concat(e)}function h(e){return"[object String]"===Object.prototype.toString.call(e)}function p(e){return"[object Object]"===Object.prototype.toString.call(e)}function g(e){return"[object Number]"===Object.prototype.toString.call(e)}function v(e){var t=e.match(/\d+/g),n=Date.UTC(t[0],t[1]-1,t[2],t[3],t[4],t[5]);return new Date(n).toUTCString()}function y(e){var t=[];if(null!==e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&void 0!==e[n]&&null!==e[n]&&t.push(n+"="+encodeURIComponent(e[n]));return t.length?"?"+t.join("&"):""}function T(e){for(var t="abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",n="",r=0,o=t.length;r<e;++r)n+=t[Math.floor(Math.random()*o)];return n}function m(){var e=arguments[0],t=[].slice.call(arguments,1);return t.forEach((function(t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&void 0!==t[n]&&(e[n]=t[n])})),e}function k(e){var t={};for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)){var r=e[n];null!=r&&(t[n]=r)}return t}function b(e){if(e){var t=JSON.stringify(e);if(t)return JSON.parse(t)}return e}function E(e){for(var t={},n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&-1==r.indexOf(i)&&(t[i]=e[i]);return b(t)}function O(e,t){for(var n=e.length;n--;){var r=e[n],o=!0;for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&r[i]!==t[i]){o=!1;break}if(o)return r}}function w(e,t,n){if(e&&e._links){var r=b(e._links[t]);return r&&r.name&&n?r.name===n?r:void 0:r}}function _(){return"undefined"!=typeof window?window.console:"undefined"!=typeof console?console:void 0}function S(){var e=_();return e&&e.log?e:{log:function(){},warn:function(){},group:function(){},groupEnd:function(){}}}function A(e){S().warn("[okta-auth-sdk] WARN: "+e)}function x(e){S().warn("[okta-auth-sdk] DEPRECATION: "+e)}function R(e,t){return function(){return x(e),t.apply(null,arguments)}}function C(e){if(e){var t=e.replace(/^\s+|\s+$/gm,"");return t=t.replace(/\/+$/,"")}}function j(){return!!document.documentMode&&document.documentMode<=11}function M(e){return!!e&&"[object Function]"==={}.toString.call(e)}function P(e){return new Promise((function(t){setTimeout(t,e)}))}function I(e){return e&&e.finally&&"function"==typeof e.finally}n.d(t,"A",(function(){return r})),n.d(t,"a",(function(){return o})),n.d(t,"c",(function(){return i})),n.d(t,"d",(function(){return a})),n.d(t,"B",(function(){return s})),n.d(t,"b",(function(){return u})),n.d(t,"e",(function(){return c})),n.d(t,"p",(function(){return f})),n.d(t,"C",(function(){return d})),n.d(t,"E",(function(){return l})),n.d(t,"v",(function(){return h})),n.d(t,"t",(function(){return p})),n.d(t,"s",(function(){return g})),n.d(t,"w",(function(){return v})),n.d(t,"D",(function(){return y})),n.d(t,"l",(function(){return T})),n.d(t,"j",(function(){return m})),n.d(t,"y",(function(){return k})),n.d(t,"f",(function(){return b})),n.d(t,"x",(function(){return E})),n.d(t,"k",(function(){return O})),n.d(t,"n",(function(){return w})),n.d(t,"o",(function(){return _})),n.d(t,"m",(function(){return S})),n.d(t,"F",(function(){return A})),n.d(t,"h",(function(){return x})),n.d(t,"i",(function(){return R})),n.d(t,"z",(function(){return C})),n.d(t,"r",(function(){return j})),n.d(t,"q",(function(){return M})),n.d(t,"g",(function(){return P})),n.d(t,"u",(function(){return I}))},function(e,t,n){"use strict";n.d(t,"a",(function(){return r.a})),n.d(t,"b",(function(){return o.a})),n.d(t,"c",(function(){return i.a})),n.d(t,"d",(function(){return g}));var r=n(21),o=n(19),i=n(2),a=n(4),s=n.n(a),u=n(12),c=n.n(u),f=n(13),d=n.n(f),l=n(10),h=n.n(l);function p(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */();return function(){var n,r=h()(e);if(t){var o=h()(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return d()(this,n)}}var g=function(e){c()(n,e);var t=p(n);function n(e,r){var o;return s()(this,n),(o=t.call(this,r)).name="OAuthError",o.errorCode=e,o.errorSummary=r,o}return n}(n(17).a);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t,n){"use strict";n.d(t,"a",(function(){return l}));var r=n(4),o=n.n(r),i=n(12),a=n.n(i),s=n(13),u=n.n(s),c=n(10),f=n.n(c);function d(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */();return function(){var n,r=f()(e);if(t){var o=f()(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return u()(this,n)}}var l=function(e){a()(n,e);var t=d(n);function n(e,r){var i;return o()(this,n),(i=t.call(this,e)).name="AuthSdkError",i.errorCode="INTERNAL",i.errorSummary=e,i.errorLink="INTERNAL",i.errorId="INTERNAL",i.errorCauses=[],r&&(i.xhr=r),i}return n}(n(17).a)},function(e,t,n){"use strict";n.r(t),n.d(t,"STATE_TOKEN_KEY_NAME",(function(){return r})),n.d(t,"DEFAULT_POLLING_DELAY",(function(){return o})),n.d(t,"DEFAULT_MAX_CLOCK_SKEW",(function(){return i})),n.d(t,"DEFAULT_CACHE_DURATION",(function(){return a})),n.d(t,"REDIRECT_OAUTH_PARAMS_NAME",(function(){return s})),n.d(t,"REDIRECT_STATE_COOKIE_NAME",(function(){return u})),n.d(t,"REDIRECT_NONCE_COOKIE_NAME",(function(){return c})),n.d(t,"TOKEN_STORAGE_NAME",(function(){return f})),n.d(t,"CACHE_STORAGE_NAME",(function(){return d})),n.d(t,"PKCE_STORAGE_NAME",(function(){return l})),n.d(t,"TRANSACTION_STORAGE_NAME",(function(){return h})),n.d(t,"ACCESS_TOKEN_STORAGE_KEY",(function(){return p})),n.d(t,"ID_TOKEN_STORAGE_KEY",(function(){return g})),n.d(t,"REFRESH_TOKEN_STORAGE_KEY",(function(){return v})),n.d(t,"REFERRER_PATH_STORAGE_KEY",(function(){return y})),n.d(t,"MIN_VERIFIER_LENGTH",(function(){return T})),n.d(t,"MAX_VERIFIER_LENGTH",(function(){return m})),n.d(t,"DEFAULT_CODE_CHALLENGE_METHOD",(function(){return k}));
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var r="oktaStateToken",o=500,i=300,a=86400,s="okta-oauth-redirect-params",u="okta-oauth-state",c="okta-oauth-nonce",f="okta-token-storage",d="okta-cache-storage",l="okta-pkce-storage",h="okta-transaction-storage",p="accessToken",g="idToken",v="refreshToken",y="referrerPath",T=43,m=128,k="S256"},function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t,n){e.exports=n(42)},function(e,t,n){"use strict";var r=n(0),o=n(21),i=n(3);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
function a(e,t){var n=(t=t||{}).url,a=t.method,s=t.args,u=t.saveAuthnState,c=t.accessToken,f=!1!==t.withCredentials,d=e.options.storageUtil.storage,l=e.storageManager.getHttpCache(e.options.cookies);if(t.cacheResponse){var h=l.getStorage()[n];if(h&&Date.now()/1e3<h.expiresAt)return Promise.resolve(h.response)}var p={Accept:"application/json","Content-Type":"application/json","X-Okta-User-Agent-Extended":e.userAgent};Object.assign(p,e.options.headers,t.headers),p=Object(r.y)(p),c&&Object(r.v)(c)&&(p.Authorization="Bearer "+c);var g,v,y={headers:p,data:s||void 0,withCredentials:f};return e.options.httpRequestClient(a,n,y).then((function(o){return(v=o.responseText)&&Object(r.v)(v)&&(v=JSON.parse(v)),u&&(v.stateToken||d.delete(i.STATE_TOKEN_KEY_NAME)),v&&v.stateToken&&v.expiresAt&&d.set(i.STATE_TOKEN_KEY_NAME,v.stateToken,v.expiresAt,e.options.cookies),v&&t.cacheResponse&&l.updateStorage(n,{expiresAt:Math.floor(Date.now()/1e3)+i.DEFAULT_CACHE_DURATION,response:v}),v})).catch((function(t){var n=t.responseText||{};if(Object(r.v)(n))try{n=JSON.parse(n)}catch(e){n={errorSummary:"Unknown error"}}throw t.status>=500&&(n.errorSummary="Unknown error"),e.options.transformErrorXHR&&(t=e.options.transformErrorXHR(Object(r.f)(t))),"E0000011"===(g=new o.a(n,t)).errorCode&&d.delete(i.STATE_TOKEN_KEY_NAME),g}))}t.a={get:function(e,t,n){var o={url:t=Object(r.p)(t)?t:e.getIssuerOrigin()+t,method:"GET"};return Object.assign(o,n),a(e,o)},post:function(e,t,n,o){var i={url:t=Object(r.p)(t)?t:e.getIssuerOrigin()+t,method:"POST",args:n,saveAuthnState:!0};return Object.assign(i,o),a(e,i)},httpRequest:a}},function(e,t,n){"use strict";n.r(t);var r=n(27);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(20);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var a=n(28);n.d(t,"isOAuthTransactionMeta",(function(){return a.c})),n.d(t,"isPKCETransactionMeta",(function(){return a.d})),n.d(t,"isIdxTransactionMeta",(function(){return a.b})),n.d(t,"isCustomAuthTransactionMeta",(function(){return a.a})),n.d(t,"isTransactionMeta",(function(){return a.e}));var s=n(29);for(var o in s)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return s[e]}))}(o);var u=n(30);for(var o in u)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var c=n(31);for(var o in c)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var f=n(32);for(var o in f)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var d=n(33);for(var o in d)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var l=n(34);for(var o in l)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return l[e]}))}(o);var h=n(35);n.d(t,"isToken",(function(){return h.d})),n.d(t,"isAccessToken",(function(){return h.a})),n.d(t,"isIDToken",(function(){return h.b})),n.d(t,"isRefreshToken",(function(){return h.c}));var p=n(36);for(var o in p)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","isToken","isAccessToken","isIDToken","isRefreshToken","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return p[e]}))}(o);for(var o in i)["isOAuthTransactionMeta","isPKCETransactionMeta","isIdxTransactionMeta","isCustomAuthTransactionMeta","isTransactionMeta","isToken","isAccessToken","isIDToken","isRefreshToken","default"].indexOf(o)<0&&function(e){n.d(t,e,(function(){return i[e]}))}(o)
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t,n){"use strict";n.d(t,"d",(function(){return i})),n.d(t,"c",(function(){return a})),n.d(t,"H",(function(){return f})),n.d(t,"G",(function(){return d})),n.d(t,"o",(function(){return h})),n.d(t,"k",(function(){return p})),n.d(t,"a",(function(){return g})),n.d(t,"J",(function(){return v})),n.d(t,"C",(function(){return y})),n.d(t,"D",(function(){return T})),n.d(t,"b",(function(){return m})),n.d(t,"i",(function(){return O})),n.d(t,"z",(function(){return w})),n.d(t,"w",(function(){return _})),n.d(t,"t",(function(){return S})),n.d(t,"v",(function(){return A})),n.d(t,"u",(function(){return x})),n.d(t,"B",(function(){return R})),n.d(t,"x",(function(){return C})),n.d(t,"j",(function(){return j})),n.d(t,"A",(function(){return M})),n.d(t,"y",(function(){return P})),n.d(t,"h",(function(){return k})),n.d(t,"g",(function(){return b})),n.d(t,"l",(function(){return E})),n.d(t,"F",(function(){return I.a})),n.d(t,"I",(function(){return N})),n.d(t,"N",(function(){return L})),n.d(t,"O",(function(){return D})),n.d(t,"e",(function(){return K})),n.d(t,"M",(function(){return F})),n.d(t,"K",(function(){return $})),n.d(t,"L",(function(){return Z})),n.d(t,"P",(function(){return J})),n.d(t,"n",(function(){return te})),n.d(t,"s",(function(){return W})),n.d(t,"f",(function(){return G})),n.d(t,"m",(function(){return Y})),n.d(t,"r",(function(){return X})),n.d(t,"p",(function(){return ne})),n.d(t,"q",(function(){return re})),n.d(t,"E",(function(){return oe}));var r=n(0),o=n(1);function i(e){if(!e.clientId)throw new o.c("A clientId must be specified in the OktaAuth constructor to get a token");if(Object(r.v)(e.responseType)&&-1!==e.responseType.indexOf(" "))throw new o.c("Multiple OAuth responseTypes must be defined as an array");var t={client_id:e.clientId,code_challenge:e.codeChallenge,code_challenge_method:e.codeChallengeMethod,display:e.display,idp:e.idp,idp_scope:e.idpScope,login_hint:e.loginHint,max_age:e.maxAge,nonce:e.nonce,prompt:e.prompt,redirect_uri:e.redirectUri,response_mode:e.responseMode,response_type:e.responseType,sessionToken:e.sessionToken,state:e.state};if(t=Object(r.y)(t),["idp_scope","response_type"].forEach((function(e){Array.isArray(t[e])&&(t[e]=t[e].join(" "))})),-1!==e.responseType.indexOf("id_token")&&-1===e.scopes.indexOf("openid"))throw new o.c("openid scope must be specified in the scopes argument when requesting an id_token");return t.scope=e.scopes.join(" "),t}function a(e){var t=i(e);return Object(r.D)(t)}var s=n(40),u=n.n(s),c=n(6);function f(e,t,n){!function(e){if(!e.clientId)throw new o.c("A clientId must be specified in the OktaAuth constructor to get a token");if(!e.redirectUri)throw new o.c("The redirectUri passed to /authorize must also be passed to /token");if(!e.authorizationCode&&!e.interactionCode)throw new o.c("An authorization code (returned from /authorize) must be passed to /token");if(!e.codeVerifier)throw new o.c('The "codeVerifier" (generated and saved by your app) must be passed to /token')}(t);var i=function(e){var t=Object(r.y)({client_id:e.clientId,redirect_uri:e.redirectUri,grant_type:e.interactionCode?"interaction_code":"authorization_code",code_verifier:e.codeVerifier});return e.interactionCode?t.interaction_code=e.interactionCode:e.authorizationCode&&(t.code=e.authorizationCode),Object(r.D)(t).slice(1)}(t);return c.a.httpRequest(e,{url:n.tokenUrl,method:"POST",args:i,withCredentials:!1,headers:{"Content-Type":"application/x-www-form-urlencoded"}})}function d(e,t,n){return c.a.httpRequest(e,{url:n.tokenUrl,method:"POST",withCredentials:!1,headers:{"Content-Type":"application/x-www-form-urlencoded"},args:Object.entries({client_id:t.clientId,grant_type:"refresh_token",scope:n.scopes.join(" "),refresh_token:n.refreshToken}).map((function(e){var t=u()(e,2),n=t[0],r=t[1];return n+"="+encodeURIComponent(r)})).join("&")})}var l=n(2);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function h(e,t){var n=t||e.options.issuer;return c.a.get(e,n+"/.well-known/openid-configuration",{cacheResponse:!0})}function p(e,t,n){var o=e.storageManager.getHttpCache(e.options.cookies);return h(e,t).then((function(t){var i=t.jwks_uri,a=o.getStorage()[i];if(a&&Date.now()/1e3<a.expiresAt){var s=Object(r.k)(a.response.keys,{kid:n});if(s)return s}return o.clearStorage(i),c.a.get(e,i,{cacheResponse:!0}).then((function(e){var t=Object(r.k)(e.keys,{kid:n});if(t)return t;throw new l.a("The key id, "+n+", was not found in the server's keys")}))}))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function g(e,t,n){e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,n)}function v(e,t,n){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)}function y(e){var t=document.createElement("iframe");return t.style.display="none",t.src=e,document.body.appendChild(t)}function T(e,t){var n=t.popupTitle||"External Identity Provider User Authentication",o="toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";if(Object(r.r)()){var i=window.open("/",n,o);return i.location.href=e,i}return window.open(e,n,o)}function m(e,t,n){var r,i;return new Promise((function(a,s){r=function(t){if(t.data&&t.data.state===n)return t.origin!==e.getIssuerOrigin()?s(new o.c("The request does not match client configuration")):void a(t.data)},g(window,"message",r),i=setTimeout((function(){s(new o.c("OAuth flow timed out"))}),t||12e4)})).finally((function(){clearTimeout(i),v(window,"message",r)}))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function k(){return Object(r.l)(64)}function b(){return Object(r.l)(64)}function E(e,t){if(arguments.length>2)throw new l.a('As of version 3.0, "getOAuthUrls" takes only a single set of options');t=t||{};var n=Object(r.z)(t.authorizeUrl)||e.options.authorizeUrl,o=Object(r.z)(t.issuer)||e.options.issuer,i=Object(r.z)(t.userinfoUrl)||e.options.userinfoUrl,a=Object(r.z)(t.tokenUrl)||e.options.tokenUrl,s=Object(r.z)(t.logoutUrl)||e.options.logoutUrl,u=Object(r.z)(t.revokeUrl)||e.options.revokeUrl,c=o.indexOf("/oauth2")>0?o:o+"/oauth2";return{issuer:o,authorizeUrl:n=n||c+"/v1/authorize",userinfoUrl:i=i||c+"/v1/userinfo",tokenUrl:a=a||c+"/v1/token",revokeUrl:u=u||c+"/v1/revoke",logoutUrl:s=s||c+"/v1/logout"}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function O(e){var t=e.options,n=t.pkce,r=t.clientId,o=t.redirectUri,i=t.responseType,a=t.responseMode,s=t.scopes,u=t.state,c=t.ignoreSignature;return{pkce:n,clientId:r,redirectUri:o||window.location.href,responseType:i||["token","id_token"],responseMode:a,state:u||k(),nonce:b(),scopes:s||["openid","email"],ignoreSignature:c}}function w(e){return"OAuthError"===e.name&&"interaction_required"===e.errorCode}function _(e){return/((id|access)_token=)/i.test(e)}function S(e){return/(code=)/i.test(e)}function A(e){return/(interaction_code=)/i.test(e)}function x(e){return/(error=)/i.test(e)||/(error_description)/i.test(e)}function R(e,t){var n=t.options;return e&&0===e.indexOf(n.redirectUri)}function C(e){return e.pkce||"code"===e.responseType||"query"===e.responseMode}function j(e){return C(e)&&"fragment"!==e.responseMode?window.location.search:window.location.hash}function M(e){if(!R(window.location.href,e))return!1;var t=C(e.options),n=j(e.options);return!!x(n)||(t?S(n)||A(n):_(window.location.hash))}function P(e){if(!M(e))return!1;var t=j(e.options);return/(error=interaction_required)/i.test(t)}var I=n(15),U=n(3);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
function N(e,t){var n=O(e);if(!1===(t=Object.assign({},n,Object(r.f)(t))).pkce)return Promise.resolve(t);if(!e.features.isPKCESupported()){var i="PKCE requires a modern browser with encryption support running in a secure context.";return e.features.isHTTPS()||(i+="\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."),e.features.hasTextEncoder()||(i+='\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),Promise.reject(new o.c(i))}return t.codeChallengeMethod||(t.codeChallengeMethod=U.DEFAULT_CODE_CHALLENGE_METHOD),t.responseType="code",h(e,null).then((function(e){if(-1===(e.code_challenge_methods_supported||[]).indexOf(t.codeChallengeMethod))throw new o.c("Invalid code_challenge_method")})).then((function(){return t.codeVerifier||(t.codeVerifier=I.a.generateVerifier()),I.a.computeChallenge(t.codeVerifier)})).then((function(e){var n=Object(r.f)(t)||{};return Object.assign(n,t,{codeChallenge:e}),n}))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function L(e){var t=/\+/g,n=/([^&=]+)=?([^&]*)/g,r=e;"#"===r.charAt(0)&&"/"===r.charAt(1)&&(r=r.substring(2)),"#"!==r.charAt(0)&&"?"!==r.charAt(0)||(r=r.substring(1));for(var o,i={};o=n.exec(r);){var a=o[1],s=o[2];i[a]="id_token"===a||"access_token"===a||"code"===a?s:decodeURIComponent(s.replace(t," "))}return i}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function D(e,t,n){var r=n.clientId,o=n.issuer,i=n.nonce;if(!t||!o||!r)throw new l.a("The jwt, iss, and aud arguments are all required");if(i&&t.nonce!==i)throw new l.a("OAuth flow response nonce doesn't match request nonce");var a=Math.floor(Date.now()/1e3);if(t.iss!==o)throw new l.a("The issuer ["+t.iss+"] does not match ["+o+"]");if(t.aud!==r)throw new l.a("The audience ["+t.aud+"] does not match ["+r+"]");if(t.iat>t.exp)throw new l.a("The JWT expired before it was issued");if(a-e.options.maxClockSkew>t.exp)throw new l.a("The JWT expired and is no longer valid");if(t.iat>a+e.options.maxClockSkew)throw new l.a("The JWT was issued in the future")}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function K(e){var t,n=e.split(".");try{t={header:JSON.parse(Object(r.d)(n[0])),payload:JSON.parse(Object(r.d)(n[1])),signature:n[2]}}catch(e){throw new o.c("Malformed token")}return t}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function F(e,t){return Promise.resolve().then((function(){var n,o;if(t&&(n=t.accessToken,o=t.refreshToken),!n&&!o)throw new l.a("A valid access or refresh token object is required");var i=e.options.clientId;if(!i)throw new l.a("A clientId must be specified in the OktaAuth constructor to revoke a token");var a=E(e).revokeUrl,s=Object(r.D)({token_type_hint:o?"refresh_token":"access_token",token:o||n}).slice(1),u=btoa(i);return c.a.post(e,a,s,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+u}})}))}var H=n(7);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function G(e,t,n){n=n||E(e,t);var o=t=Object.assign({},O(e),Object(r.f)(t)),i=o.authorizationCode,a=o.interactionCode,s=o.codeVerifier,u=o.clientId,c=o.redirectUri,d=o.scopes,l=o.ignoreSignature;return f(e,{clientId:u,redirectUri:c,authorizationCode:i,interactionCode:a,codeVerifier:s},n).then((function(t){var r=["token"];return-1!==d.indexOf("openid")&&r.push("id_token"),W(e,{clientId:u,redirectUri:c,scopes:d,responseType:r,ignoreSignature:l},t,n).then((function(e){return e.code=i,e}))}))}var q=n(5),z=n.n(q);function B(e,t){t=Object(r.f)(t);var n={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}};return delete t.use,crypto.subtle.importKey("jwk",t,n,!0,["verify"]).then((function(t){var o=e.split("."),i=Object(r.B)(o[0]+"."+o[1]),a=Object(r.b)(o[2]),s=Object(r.B)(a);return crypto.subtle.verify(n,t,s,i)}))}var V=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{u(r.next(e))}catch(e){i(e)}}function s(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((r=r.apply(e,t||[])).next())}))};
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function J(e,t,n){return V(this,void 0,void 0,z.a.mark((function i(){var a,s,u,c;return z.a.wrap((function(i){for(;;)switch(i.prev=i.next){case 0:if(t&&t.idToken){i.next=2;break}throw new o.c("Only idTokens may be verified");case 2:return a=K(t.idToken),i.next=5,h(e);case 5:if(s=i.sent,u={issuer:s.issuer,clientId:e.options.clientId,ignoreSignature:e.options.ignoreSignature},Object.assign(u,n),D(e,a.payload,u),1!=u.ignoreSignature&&e.features.isTokenVerifySupported()){i.next=11;break}return i.abrupt("return",t);case 11:return i.next=13,p(e,t.issuer,a.header.kid);case 13:return c=i.sent,i.next=16,B(t.idToken,c);case 16:if(i.sent){i.next=19;break}throw new o.c("The token signature is not valid");case 19:if(!(n&&n.accessToken&&t.claims.at_hash)){i.next=25;break}return i.next=22,f=n.accessToken,d=void 0,d=(new TextEncoder).encode(f),crypto.subtle.digest("SHA-256",d).then((function(e){var t=new Uint8Array(e).slice(0,16),n=String.fromCharCode.apply(null,t);return Object(r.A)(n)}));case 22:if(i.sent===t.claims.at_hash){i.next=25;break}throw new o.c("Token hash verification failed");case 25:return i.abrupt("return",t);case 26:case"end":return i.stop()}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var f,d}),i)})))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function W(e,t,n,i){if(!1!==e.options.pkce&&(n.code||n.interaction_code))return G(e,Object.assign({},t,{authorizationCode:n.code,interactionCode:n.interaction_code}),i);t=t||O(e),i=i||E(e,t);var a,s=t.responseType;Array.isArray(s)||(s=[s]),a=n.scope?n.scope.split(" "):Object(r.f)(t.scopes);var u=t.clientId||e.options.clientId;return Promise.resolve().then((function(){!function(e,t){if(e.error||e.error_description)throw new o.d(e.error,e.error_description);if(e.state!==t.state)throw new o.c("OAuth flow response state doesn't match request state")}(n,t)})).then((function(){var r={},o=n.expires_in,s=n.token_type,c=n.access_token,f=n.id_token,d=n.refresh_token;if(c){var l=e.token.decode(c);r.accessToken={value:c,accessToken:c,claims:l.payload,expiresAt:Number(o)+Math.floor(Date.now()/1e3),tokenType:s,scopes:a,authorizeUrl:i.authorizeUrl,userinfoUrl:i.userinfoUrl}}if(d&&(r.refreshToken={value:d,refreshToken:d,expiresAt:Number(o)+Math.floor(Date.now()/1e3),scopes:a,tokenUrl:i.tokenUrl,authorizeUrl:i.authorizeUrl,issuer:i.issuer}),f){var h=e.token.decode(f),p={value:f,idToken:f,claims:h.payload,expiresAt:h.payload.exp,scopes:a,authorizeUrl:i.authorizeUrl,issuer:i.issuer,clientId:u},g={clientId:u,issuer:i.issuer,nonce:t.nonce,accessToken:c};return void 0!==t.ignoreSignature&&(g.ignoreSignature=t.ignoreSignature),J(e,p,g).then((function(){return r.idToken=p,r}))}return r})).then((function(e){if(-1!==s.indexOf("token")&&!e.accessToken)throw new o.c('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');if(-1!==s.indexOf("id_token")&&!e.idToken)throw new o.c('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');return{tokens:e,state:n.state,code:n.code}}))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function Y(e,t){return arguments.length>2?Promise.reject(new l.a('As of version 3.0, "getToken" takes only a single set of options')):N(e,t=t||{}).then((function(n){var r,o;switch(t.sessionToken?Object.assign(n,{prompt:"none",responseMode:"okta_post_message",display:null}):t.idp&&Object.assign(n,{display:"popup"}),o=E(e,n),r=(t.codeVerifier?o.tokenUrl:o.authorizeUrl)+a(n),n.sessionToken||null===n.display?"IFRAME":"popup"===n.display?"POPUP":"IMPLICIT"){case"IFRAME":var i=m(e,t.timeout,n.state),s=y(r);return i.then((function(t){return W(e,n,t,o)})).finally((function(){document.body.contains(s)&&s.parentElement.removeChild(s)}));case"POPUP":var u;if("okta_post_message"===n.responseMode){if(!e.features.isPopupPostMessageSupported())throw new l.a("This browser doesn't have full postMessage support");u=m(e,t.timeout,n.state)}var c=T(r,{popupTitle:t.popupTitle});return new Promise((function(e,t){var n=setInterval((function(){c&&!c.closed||(clearInterval(n),t(new l.a("Unable to parse OAuth flow response")))}),100);u.then((function(t){clearInterval(n),e(t)})).catch((function(e){clearInterval(n),t(e)}))})).then((function(t){return W(e,n,t,o)})).finally((function(){c&&!c.closed&&c.close()}));default:throw new l.a("The full page redirect flow is not supported")}}))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function X(e,t){return arguments.length>2?Promise.reject(new o.c('As of version 3.0, "getWithoutPrompt" takes only a single set of options')):(t=Object(r.f)(t)||{},Object.assign(t,{prompt:"none",responseMode:"okta_post_message",display:null}),Y(e,t))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function $(e,t){return Object(H.isToken)(t)?X(e,{responseType:e.options.pkce?"code":Object(H.isAccessToken)(t)?"token":"id_token",scopes:t.scopes,authorizeUrl:t.authorizeUrl,userinfoUrl:t.userinfoUrl,issuer:t.issuer}).then((function(e){var n=e.tokens;return Object(H.isIDToken)(t)?n.idToken:n.accessToken})):Promise.reject(new o.c("Renew must be passed a token with an array of scopes and an accessToken or idToken"))}var Q=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{u(r.next(e))}catch(e){i(e)}}function s(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((r=r.apply(e,t||[])).next())}))};
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function Z(e,t){return e.tokenManager.getTokens().then((function(e){return e.refreshToken})).then((function(n){if(n)return function(e,t,n){return Q(this,void 0,void 0,z.a.mark((function r(){var i,a,s,u,c,f;return z.a.wrap((function(r){for(;;)switch(r.prev=r.next){case 0:if(i=e.options.clientId){r.next=3;break}throw new o.c("A clientId must be specified in the OktaAuth constructor to renew tokens");case 3:return a=Object.assign({},t,{clientId:i}),r.next=6,d(e,a,n);case 6:return s=r.sent,u=E(e,t),r.next=10,W(e,a,s,u);case 10:return c=r.sent,f=c.tokens,r.abrupt("return",f);case 13:case"end":return r.stop()}}),r)})))}(e,t,n);if(t=Object.assign({scopes:e.options.scopes,authorizeUrl:e.options.authorizeUrl,userinfoUrl:e.options.userinfoUrl,issuer:e.options.issuer},t),e.options.pkce)t.responseType="code";else{var r=O(e).responseType;t.responseType=r}return X(e,t).then((function(e){return e.tokens}))}))}var ee=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{u(r.next(e))}catch(e){i(e)}}function s(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((r=r.apply(e,t||[])).next())}))};
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function te(e,t,n){return ee(this,void 0,void 0,z.a.mark((function i(){return z.a.wrap((function(i){for(;;)switch(i.prev=i.next){case 0:if(t){i.next=4;break}return i.next=3,e.tokenManager.getTokens();case 3:t=i.sent.accessToken;case 4:if(n){i.next=8;break}return i.next=7,e.tokenManager.getTokens();case 7:n=i.sent.idToken;case 8:if(t&&Object(H.isAccessToken)(t)){i.next=10;break}return i.abrupt("return",Promise.reject(new o.c("getUserInfo requires an access token object")));case 10:if(n&&Object(H.isIDToken)(n)){i.next=12;break}return i.abrupt("return",Promise.reject(new o.c("getUserInfo requires an ID token object")));case 12:return i.abrupt("return",c.a.httpRequest(e,{url:t.userinfoUrl,method:"GET",accessToken:t.accessToken}).then((function(e){return e.sub===n.claims.sub?e:Promise.reject(new o.c("getUserInfo request was rejected due to token mismatch"))})).catch((function(e){var t;if(e.xhr&&(401===e.xhr.status||403===e.xhr.status)&&(e.xhr.headers&&Object(r.q)(e.xhr.headers.get)&&e.xhr.headers.get("WWW-Authenticate")?t=e.xhr.headers.get("WWW-Authenticate"):Object(r.q)(e.xhr.getResponseHeader)&&(t=e.xhr.getResponseHeader("WWW-Authenticate")),t)){var n=t.match(/error="(.*?)"/)||[],i=t.match(/error_description="(.*?)"/)||[],a=n[1],s=i[1];a&&s&&(e=new o.d(a,s))}throw e})));case 13:case"end":return i.stop()}}),i)})))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function ne(e,t){return arguments.length>2?Promise.reject(new o.c('As of version 3.0, "getWithPopup" takes only a single set of options')):(t=Object(r.f)(t)||{},Object.assign(t,{display:"popup",responseMode:"okta_post_message"}),Y(e,t))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function re(e,t){return arguments.length>2?Promise.reject(new o.c('As of version 3.0, "getWithRedirect" takes only a single set of options')):(t=Object(r.f)(t)||{},N(e,t).then((function(n){var r=E(e,t),o=r.authorizeUrl+a(n),i={responseType:n.responseType,state:n.state,nonce:n.nonce,scopes:n.scopes,clientId:n.clientId,urls:r,ignoreSignature:n.ignoreSignature,redirectUri:n.redirectUri,codeVerifier:n.codeVerifier,codeChallenge:n.codeChallenge,codeChallengeMethod:n.codeChallengeMethod};e.transactionManager.save(i,{oauth:!0}),e.token.getWithRedirect._setLocation(o)})))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function oe(e,t){t=t||{},t=Object(r.v)(t)?{url:t}:t;var n,i=e.options.pkce?"query":"fragment",a=t.url,s=t.responseMode||e.options.responseMode||i,u=e.token.parseFromUrl._getLocation();if(!(n="query"===s?a?a.substring(a.indexOf("?")):u.search:a?a.substring(a.indexOf("#")):u.hash))return Promise.reject(new o.c("Unable to parse a token from the url"));var c=e.transactionManager.load({oauth:!0,pkce:e.options.pkce}),f=c.urls;return delete c.urls,Promise.resolve(L(n)).then((function(t){return a||("query"===s?function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.hash):r.search=""}(e):function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.search):r.hash=""}(e)),W(e,c,t,f).finally((function(){e.transactionManager.clear()}))}))}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}},function(e,t){function n(t){return e.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},n(t)}e.exports=n},function(e,t){function n(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}e.exports=function(e,t,r){return t&&n(e.prototype,t),r&&n(e,r),e}},function(e,t,n){var r=n(25);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&r(e,t)}},function(e,t,n){var r=n(18),o=n(9);e.exports=function(e,t){return!t||"object"!==r(t)&&"function"!=typeof t?o(e):t}},function(e,t,n){"use strict";n.d(t,"j",(function(){return v})),n.d(t,"h",(function(){return y})),n.d(t,"i",(function(){return m})),n.d(t,"g",(function(){return k})),n.d(t,"f",(function(){return T})),n.d(t,"a",(function(){return h})),n.d(t,"d",(function(){return l})),n.d(t,"b",(function(){return b})),n.d(t,"c",(function(){return a})),n.d(t,"e",(function(){return s}));var r=n(6),o=n(2),i=n(3);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
function a(e,t){var n={};return Object.assign(n,t),!n.stateToken&&e.stateToken&&(n.stateToken=e.stateToken),n}function s(e){return a(e)}var u=n(4),c=n.n(u),f=n(0),d=n(19);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
function l(e,t,n){return function(a){var u,c,l,p;Object(f.s)(a)?u=a:Object(f.t)(a)&&(u=(a=a).delay,c=a.rememberDevice,l=a.autoPush,p=a.transactionCallBack),u||0===u||(u=i.DEFAULT_POLLING_DELAY);var g=Object(f.n)(t,"next","poll");n.isPolling=!0;var v=0;return function i(){return n.isPolling?function(){var n={};if("function"==typeof l)try{n.autoPush=!!l()}catch(e){return Promise.reject(new o.a("AutoPush resulted in an error."))}else null!=l&&(n.autoPush=!!l);if("function"==typeof c)try{n.rememberDevice=!!c()}catch(e){return Promise.reject(new o.a("RememberDevice resulted in an error."))}else null!=c&&(n.rememberDevice=!!c);var i=g.href+Object(f.D)(n);return r.a.post(e,i,s(t),{saveAuthnState:!1})}().then((function(t){if(v=0,t.factorResult&&"WAITING"===t.factorResult){if(!n.isPolling)throw new d.a;return"function"==typeof p&&p(t),Object(f.g)(u).then(i)}return n.isPolling=!1,new h(e,t)})).catch((function(e){if(e.xhr&&(0===e.xhr.status||429===e.xhr.status)&&v<=4){var t=1e3*Math.pow(2,v);return v++,Object(f.g)(t).then(i)}throw e})):Promise.reject(new d.a)}().catch((function(e){throw n.isPolling=!1,e}))}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */var h=function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;c()(this,e),n&&(this.data=n,Object.assign(this,g(t,n,n,{})),delete this.stateToken,"RECOVERY_CHALLENGE"!==n.status||n._links||(this.cancel=function(){return Promise.resolve(new e(t))}))};function p(e,t,n,i,s){if(Array.isArray(i))return function(r,a){if(!r)throw new o.a("Must provide a link name");var u=Object(f.k)(i,{name:r});if(!u)throw new o.a("No link found for that name");return p(e,t,n,u,s)(a)};if(i.hints&&i.hints.allow&&1===i.hints.allow.length)switch(i.hints.allow[0]){case"GET":return function(){return r.a.get(e,i.href)};case"POST":return function(r){s&&s.isPolling&&(s.isPolling=!1);var u=a(t,r);"MFA_ENROLL"!==t.status&&"FACTOR_ENROLL"!==t.status||Object.assign(u,{factorType:n.factorType,provider:n.provider});var c={},d=u.autoPush;if(void 0!==d){if("function"==typeof d)try{c.autoPush=!!d()}catch(e){return Promise.reject(new o.a("AutoPush resulted in an error."))}else null!==d&&(c.autoPush=!!d);u=Object(f.x)(u,"autoPush")}var l=u.rememberDevice;if(void 0!==l){if("function"==typeof l)try{c.rememberDevice=!!l()}catch(e){return Promise.reject(new o.a("RememberDevice resulted in an error."))}else null!==l&&(c.rememberDevice=!!l);u=Object(f.x)(u,"rememberDevice")}else u.profile&&void 0!==u.profile.updatePhone&&(u.profile.updatePhone&&(c.updatePhone=!0),u.profile=Object(f.x)(u.profile,"updatePhone"));var h=i.href+Object(f.D)(c);return k(e,h,u)}}}function g(e,t,n,r){if(n=n||t,n=Object(f.f)(n),Array.isArray(n)){for(var o=[],i=0,a=n.length;i<a;i++)o.push(g(e,t,n[i],r));return o}var s=n._embedded||{};for(var u in s)Object.prototype.hasOwnProperty.call(s,u)&&(Object(f.t)(s[u])||Array.isArray(s[u]))&&(s[u]=g(e,t,s[u],r));var c=function(e,t,n,r){var o={};for(var i in n._links)if(Object.prototype.hasOwnProperty.call(n._links,i)){var a=n._links[i];if("next"===i&&(i=a.name),a.type)o[i]=a;else switch(i){case"poll":o.poll=l(e,t,r);break;default:var s=p(e,t,n,a,r);s&&(o[i]=s)}}return o}(e,t,n,r);return Object.assign(s,c),n=Object(f.x)(n,"_embedded","_links"),Object.assign(n,s),n}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */function v(e,t){return t=a(e,t),r.a.post(e,e.getIssuerOrigin()+"/api/v1/authn",t)}function y(e,t){if(!t||!t.stateToken){var n=e.tx.exists._get(i.STATE_TOKEN_KEY_NAME);if(!n)return Promise.reject(new o.a("No transaction to resume"));t={stateToken:n}}return e.tx.status(t).then((function(t){return new h(e,t)}))}function T(e,t){if(!t||!t.stateToken){var n=e.tx.exists._get(i.STATE_TOKEN_KEY_NAME);if(!n)return Promise.reject(new o.a("No transaction to evaluate"));t={stateToken:n}}return function(e,t){return t=a(e,t),r.a.post(e,e.getIssuerOrigin()+"/api/v1/authn/introspect",t)}(e,t).then((function(t){return new h(e,t)}))}function m(e){return!!e.tx.exists._get(i.STATE_TOKEN_KEY_NAME)}function k(e,t,n,o){return r.a.post(e,t,n,o).then((function(t){return new h(e,t)}))}var b=function e(){c()(this,e)};
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */},function(e,t,n){"use strict";var r=n(0),o=n(3);
/*!
 * Copyright (c) 2019-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
function i(e){return("0"+e.toString(16)).substr(-2)}t.a={DEFAULT_CODE_CHALLENGE_METHOD:o.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:function(e){var t,n,r=e||"";return r.length<o.MIN_VERIFIER_LENGTH&&(r+=(t=o.MIN_VERIFIER_LENGTH-r.length,n=new Uint8Array(Math.ceil(t/2)),crypto.getRandomValues(n),Array.from(n,i).join("").slice(0,t))),encodeURIComponent(r).slice(0,o.MAX_VERIFIER_LENGTH)},computeChallenge:function(e){var t=(new TextEncoder).encode(e);return crypto.subtle.digest("SHA-256",t).then((function(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return Object(r.A)(t)}))}}},function(e,t,n){"use strict";n.d(t,"c",(function(){return y})),n.d(t,"e",(function(){return T})),n.d(t,"a",(function(){return m})),n.d(t,"d",(function(){return k})),n.d(t,"b",(function(){return b})),n.d(t,"f",(function(){return V}));var r=n(18),o=n.n(r),i=n(4),a=n.n(i),s=n(24),u=n.n(s),c=n(0),f=n(2),d=n(3),l=n(11),h=n.n(l),p=function(){function e(t){a()(this,e),this.localOffset=parseInt(t||0)}return h()(e,[{key:"now",value:function(){var e=(Date.now()+this.localOffset)/1e3;return e}}],[{key:"create",value:function(){return new e(0)}}]),e}(),g=n(7),v={autoRenew:!0,autoRemove:!0,storage:"localStorage",expireEarlySeconds:30,storageKey:d.TOKEN_STORAGE_NAME,_storageEventDelay:0},y="expired",T="renewed",m="added",k="removed",b="error";function E(e,t){return t.expiresAt-e.options.expireEarlySeconds}function O(e,t){return E(e,t)<=e.clock.now()}function w(e,t,n,r){e.emitter.emit(T,t,n,r)}function _(e,t,n){e.emitter.emit(m,t,n)}function S(e,t,n){e.emitter.emit(k,t,n)}function A(e,t){e.emitter.emit(b,t)}function x(e,t,n){var r=B(n),o=B(t);Object.keys(o).forEach((function(t){var n=r[t],i=o[t];JSON.stringify(n)!==JSON.stringify(i)&&_(e,t,i)})),Object.keys(r).forEach((function(t){var n=r[t];o[t]||S(e,t,n)}))}function R(e,t){clearTimeout(e.expireTimeouts[t]),delete e.expireTimeouts[t],delete e.renewPromise[t]}function C(e){var t=e.expireTimeouts;for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&R(e,n)}function j(e,t,n,r){var o=E(t,r),i=1e3*Math.max(o-t.clock.now(),0);R(t,n);var a=setTimeout((function(){!function(e,t,n){e.emitter.emit(y,t,n)}(t,n,r)}),i);t.expireTimeouts[n]=a}function M(e,t,n){try{var r=n.getStorage()}catch(e){return void A(t,e)}for(var o in r){if(Object.prototype.hasOwnProperty.call(r,o))j(0,t,o,r[o])}}function P(e,t,n){C(t),M(0,t,n)}function I(e){if(!Object(c.t)(e)||!e.scopes||!e.expiresAt&&0!==e.expiresAt||!Object(g.isIDToken)(e)&&!Object(g.isAccessToken)(e)&&!Object(g.isRefreshToken)(e))throw new f.a("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property")}function U(e,t,n,r,o){e.features.isLocalhost()&&Object(c.F)("Use setTokens() instead if you want to add a set of tokens at same time.\nIt prevents current tab from emitting unnecessary StorageEvent,\nwhich may cause false-positive authState change cross tabs.");var i=n.getStorage();I(o),i[r]=o,n.setStorage(i),_(t,r,o),j(0,t,r,o)}function N(e,t){return e.getStorage()[t]}function L(e,t){var n=e.getStorage();return Object.keys(n).filter((function(e){var r=n[e];return Object(g.isAccessToken)(r)&&"accessToken"===t||Object(g.isIDToken)(r)&&"idToken"===t||Object(g.isRefreshToken)(r)&&"refreshToken"===t}))[0]}function D(e,t){return new Promise((function(n){return n(N(e,t))}))}function K(e){var t={},n=e.getStorage();return Object.keys(n).forEach((function(e){var r=n[e];Object(g.isAccessToken)(r)?t.accessToken=r:Object(g.isIDToken)(r)?t.idToken=r:Object(g.isRefreshToken)(r)&&(t.refreshToken=r)})),t}function F(e){return new Promise((function(t){return t(K(e))}))}function H(e,t,n,r,o,i,a){var s=r.accessToken,c=r.idToken,f=r.refreshToken,l=function(e,n,r){_(t,e,n),j(0,t,e,n),r&&r(e,n)},h=function(e,n,r){R(t,e),S(t,e,n),r&&r(e,n)};c&&I(c),s&&I(s);var p=L(n,"idToken")||d.ID_TOKEN_STORAGE_KEY,g=L(n,"accessToken")||d.ACCESS_TOKEN_STORAGE_KEY,v=L(n,"refreshToken")||d.REFRESH_TOKEN_STORAGE_KEY,y=Object.assign(Object.assign(Object.assign({},c&&u()({},p,c)),s&&u()({},g,s)),f&&u()({},v,f));n.setStorage(y);var T=K(n);c?l(p,c,i):T.idToken&&h(p,T.idToken,i),s?l(g,s,o):T.accessToken&&h(g,T.accessToken,o),f?l(v,f,a):T.refreshToken&&h(v,T.refreshToken,a)}function G(e,t,n){R(e,n);var r=t.getStorage(),o=r[n];delete r[n],t.setStorage(r),S(e,n,o)}function q(e,t,n,r){var o=t.renewPromise[r];if(o)return o;try{var i=N(n,r);if(!i)throw new f.a("The tokenManager has no token for the key: "+r)}catch(e){return Promise.reject(e)}return C(t),t.renewPromise[r]=e.token.renewTokens({scopes:i.scopes}).then((function(e){var o=n.getStorage();return H(0,t,n,e,(function(e,n){return w(t,e,n,o[e])}),(function(e,n){return w(t,e,n,o[e])})),N(n,r)})).catch((function(e){if("OAuthError"===e.name||"AuthSdkError"===e.name){var o=[],i=n.getStorage();Object.keys(i).forEach((function(e){var n=i[e];n&&O(t,n)&&(delete i[e],o.push({key:e,token:n}),R(t,e))})),n.setStorage(i),o.length?o.forEach((function(e,n){return S(t,e,n)})):(S(t,d.ID_TOKEN_STORAGE_KEY),S(t,d.ACCESS_TOKEN_STORAGE_KEY)),e.tokenKey=r,A(t,e)}throw e})).finally((function(){delete t.renewPromise[r]})),t.renewPromise[r]}function z(e,t){C(e),t.clearStorage()}function B(e){var t;try{t=JSON.parse(e)||{}}catch(e){t={}}return t}var V=function e(t,n){var r=this;a()(this,e),n=Object.assign({},v,Object(c.y)(n));var i=t.emitter;if(!i)throw new f.a("Emitter should be initialized before TokenManager");Object(c.r)()&&(n._storageEventDelay=n._storageEventDelay||1e3);var s=Object(c.y)({storageKey:n.storageKey,secure:n.secure});"object"===o()(n.storage)?s.storageProvider=n.storage:n.storage&&(s.storageType=n.storage);var u=t.storageManager.getTokenStorage(s),d={clock:p.create(),options:n,emitter:i,expireTimeouts:{},renewPromise:{}};this.add=U.bind(this,t,d,u),this.get=D.bind(this,u),this.remove=G.bind(this,d,u),this.clear=z.bind(this,d,u),this.renew=q.bind(this,t,d,u),this.on=d.emitter.on.bind(d.emitter),this.off=d.emitter.off.bind(d.emitter),this.hasExpired=O.bind(this,d),this.getTokens=F.bind(this,u),this.setTokens=H.bind(this,t,d,u),this._getStorageKeyByType=L.bind(this,u),this._clearExpireEventTimeoutAll=C.bind(this,d),this._getOptions=function(){return Object(c.f)(n)},this._resetExpireEventTimeoutAll=P.bind(this,t,d,u),this._emitEventsForCrossTabsStorageUpdate=x.bind(this,d);var l=[];this.on(y,(function(e){if(n.autoRenew)if(function(e){var t=!1;if(e.push(Date.now()),e.length>=10){var n=e.shift();t=e[e.length-1]-n<3e4}return t}(l)){var t=new f.a("Too many token renew requests");A(d,t)}else r.renew(e).catch((function(){}));else n.autoRemove&&r.remove(e)})),M(0,d,u),window.addEventListener("storage",(function(e){var t=e.key,o=e.newValue,i=e.oldValue;(!t||t===n.storageKey&&o!==i)&&setTimeout((function(){return r._resetExpireEventTimeoutAll(),void r._emitEventsForCrossTabsStorageUpdate(o,i)}),n._storageEventDelay)}))}},function(e,t,n){"use strict";n.d(t,"a",(function(){return g}));var r=n(4),o=n.n(r),i=n(9),a=n.n(i),s=n(12),u=n.n(s),c=n(13),f=n.n(c),d=n(10),l=n.n(d),h=n(26);function p(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */();return function(){var n,r=l()(e);if(t){var o=l()(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return f()(this,n)}}var g=function(e){u()(n,e);var t=p(n);function n(e){var r;return o()(this,n),r=t.call(this,e),Object.setPrototypeOf(a()(r),(this instanceof n?this.constructor:void 0).prototype),r}return n}(n.n(h)()(Error))},function(e,t){function n(t){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?e.exports=n=function(e){return typeof e}:e.exports=n=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(t)}e.exports=n},function(e,t,n){"use strict";n.d(t,"a",(function(){return l}));var r=n(4),o=n.n(r),i=n(12),a=n.n(i),s=n(13),u=n.n(s),c=n(10),f=n.n(c);function d(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */();return function(){var n,r=f()(e);if(t){var o=f()(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return u()(this,n)}}var l=function(e){a()(n,e);var t=d(n);function n(){o()(this,n);return t.call(this,"The poll was stopped by the sdk")}return n}(n(17).a)},function(e,t){},function(e,t,n){"use strict";n.d(t,"a",(function(){return l}));var r=n(4),o=n.n(r),i=n(12),a=n.n(i),s=n(13),u=n.n(s),c=n(10),f=n.n(c);function d(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */();return function(){var n,r=f()(e);if(t){var o=f()(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return u()(this,n)}}var l=function(e){a()(n,e);var t=d(n);function n(e,r){var i;o()(this,n);var a=e.errorSummary;return(i=t.call(this,a)).name="AuthApiError",i.errorSummary=e.errorSummary,i.errorCode=e.errorCode,i.errorLink=e.errorLink,i.errorId=e.errorId,i.errorCauses=e.errorCauses,r&&(i.xhr=r),i}return n}(n(17).a)},function(e,t,n){"use strict";n.d(t,"a",(function(){return d}));var r=n(4),o=n.n(r),i=n(11),a=n.n(i),s=n(1),u=n(3),c=n(7),f=n(0),d=function(){function e(t){o()(this,e),this.storageManager=t.storageManager,this.legacyWidgetSupport=!1!==t.legacyWidgetSupport,this.saveNonceCookie=!1!==t.saveNonceCookie,this.saveStateCookie=!1!==t.saveStateCookie,this.saveParamsCookie=!1!==t.saveParamsCookie,this.options=t}return a()(e,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this.storageManager.getTransactionStorage();t.clearStorage(),this.legacyWidgetSupport&&(e.oauth&&this.clearLegacyOAuthParams(),e.pkce&&this.clearLegacyPKCE())}},{key:"save",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this.storageManager.getTransactionStorage(),r=n.getStorage();if(Object(c.isTransactionMeta)(r)&&Object(f.F)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."),n.setStorage(e),t.oauth&&(this.saveNonceCookie||this.saveStateCookie||this.saveParamsCookie)){var o=this.storageManager.getStorage({storageType:"cookie"});if(this.saveParamsCookie){var i=e.responseType,a=e.state,s=e.nonce,d=e.scopes,l=e.clientId,h=e.urls,p=e.ignoreSignature,g={responseType:i,state:a,nonce:s,scopes:d,clientId:l,urls:h,ignoreSignature:p};o.setItem(u.REDIRECT_OAUTH_PARAMS_NAME,JSON.stringify(g),null)}this.saveNonceCookie&&e.nonce&&o.setItem(u.REDIRECT_NONCE_COOKIE_NAME,e.nonce,null),this.saveStateCookie&&e.state&&o.setItem(u.REDIRECT_STATE_COOKIE_NAME,e.state,null)}}},{key:"exists",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};try{var t=this.load(e);return!!t}catch(e){return!1}}},{key:"load",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this.storageManager.getTransactionStorage(),n=t.getStorage();if(Object(c.isTransactionMeta)(n))return n;if(!this.legacyWidgetSupport)return null;if(e.oauth)try{var r=this.loadLegacyOAuthParams();Object.assign(n,r)}finally{this.clearLegacyOAuthParams()}if(e.pkce)try{var o=this.loadLegacyPKCE();Object.assign(n,o)}finally{this.clearLegacyPKCE()}return Object(c.isTransactionMeta)(n)?n:null}},{key:"clearLegacyPKCE",value:function(){this.storageManager.storageUtil.testStorageType("localStorage")&&this.storageManager.getLegacyPKCEStorage({storageType:"localStorage"}).clearStorage(),this.storageManager.storageUtil.testStorageType("sessionStorage")&&this.storageManager.getLegacyPKCEStorage({storageType:"sessionStorage"}).clearStorage()}},{key:"loadLegacyPKCE",value:function(){var e;if(this.storageManager.storageUtil.testStorageType("localStorage")&&(e=this.storageManager.getLegacyPKCEStorage({storageType:"localStorage"}).getStorage())&&e.codeVerifier)return e;if(this.storageManager.storageUtil.testStorageType("sessionStorage")&&(e=this.storageManager.getLegacyPKCEStorage({storageType:"sessionStorage"}).getStorage())&&e.codeVerifier)return e;throw new s.c("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.",null)}},{key:"clearLegacyOAuthParams",value:function(){this.storageManager.storageUtil.testStorageType("sessionStorage")&&this.storageManager.getLegacyOAuthParamsStorage({storageType:"sessionStorage"}).clearStorage(),this.storageManager.storageUtil.testStorageType("cookie")&&this.storageManager.getLegacyOAuthParamsStorage({storageType:"cookie"}).clearStorage()}},{key:"loadLegacyOAuthParams",value:function(){var e;if(this.storageManager.storageUtil.testStorageType("sessionStorage")&&(e=this.storageManager.getLegacyOAuthParamsStorage({storageType:"sessionStorage"}).getStorage()),Object(c.isOAuthTransactionMeta)(e))return e;if(this.storageManager.storageUtil.testStorageType("cookie")&&(e=this.storageManager.getLegacyOAuthParamsStorage({storageType:"cookie"}).getStorage()),Object(c.isOAuthTransactionMeta)(e))return e;throw new s.c("Unable to retrieve OAuth redirect params from storage")}}]),e}()},function(e,t,n){"use strict";n.d(t,"a",(function(){return f}));var r=n(4),o=n.n(r),i=n(11),a=n.n(i),s=n(3),u=n(2),c=function(){function e(t,n){if(o()(this,e),!t)throw new u.a('"storage" is required');if("string"!=typeof n||!n.length)throw new u.a('"storageName" is required');this.storageName=n,this.storageProvider=t}return a()(e,[{key:"getItem",value:function(e){return this.getStorage()[e]}},{key:"setItem",value:function(e,t){return this.updateStorage(e,t)}},{key:"removeItem",value:function(e){return this.clearStorage(e)}},{key:"getStorage",value:function(){var e=this.storageProvider.getItem(this.storageName);e=e||"{}";try{return JSON.parse(e)}catch(e){throw new u.a("Unable to parse storage string: "+this.storageName)}}},{key:"setStorage",value:function(e){try{var t=e?JSON.stringify(e):"{}";this.storageProvider.setItem(this.storageName,t)}catch(e){throw new u.a("Unable to set storage: "+this.storageName)}}},{key:"clearStorage",value:function(e){if(e){var t=this.getStorage();delete t[e],this.setStorage(t)}else this.storageProvider.removeItem?this.storageProvider.removeItem(this.storageName):this.setStorage()}},{key:"updateStorage",value:function(e,t){var n=this.getStorage();n[e]=t,this.setStorage(n)}}]),e}(),f=function(){function e(t,n,r){o()(this,e),this.storageManagerOptions=t,this.cookieOptions=n,this.storageUtil=r}return a()(e,[{key:"getOptionsForSection",value:function(e,t){return Object.assign({},this.storageManagerOptions[e],t)}},{key:"getStorage",value:function(e){if((e=Object.assign({},this.cookieOptions,e)).storageProvider)return e.storageProvider;var t=e,n=t.storageType,r=t.storageTypes;if(n&&r){var o=r.indexOf(n);o>=0&&(r=r.slice(o),n=null)}return n||(n=this.storageUtil.findStorageType(r)),this.storageUtil.getStorageByType(n,e)}},{key:"getTransactionStorage",value:function(e){e=this.getOptionsForSection("transaction",e);var t=this.getStorage(e),n=e.storageKey||s.TRANSACTION_STORAGE_NAME;return new c(t,n)}},{key:"getTokenStorage",value:function(e){e=this.getOptionsForSection("token",e);var t=this.getStorage(e),n=e.storageKey||s.TOKEN_STORAGE_NAME;return new c(t,n)}},{key:"getHttpCache",value:function(e){e=this.getOptionsForSection("cache",e);var t=this.getStorage(e),n=e.storageKey||s.CACHE_STORAGE_NAME;return new c(t,n)}},{key:"getLegacyPKCEStorage",value:function(e){e=this.getOptionsForSection("legacy-pkce",e);var t=this.getStorage(e),n=e.storageKey||s.PKCE_STORAGE_NAME;return new c(t,n)}},{key:"getLegacyOAuthParamsStorage",value:function(e){e=this.getOptionsForSection("legacy-oauth-params",e);var t=this.getStorage(e),n=e.storageKey||s.REDIRECT_OAUTH_PARAMS_NAME;return new c(t,n)}}]),e}()},function(e,t){e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t){function n(t,r){return e.exports=n=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},n(t,r)}e.exports=n},function(e,t,n){var r=n(10),o=n(25),i=n(43),a=n(44);function s(t){var n="function"==typeof Map?new Map:void 0;return e.exports=s=function(e){if(null===e||!i(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return a(e,arguments,r(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),o(t,e)},s(t)}e.exports=s},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t,n){"use strict";n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return s})),n.d(t,"b",(function(){return u})),n.d(t,"a",(function(){return c})),n.d(t,"e",(function(){return f}));var r=n(18),o=n.n(r);function i(e){return!(!e||"object"!==o()(e)||0===Object.values(e).length)}function a(e){return!!i(e)&&(!!e.redirectUri||!!e.responseType)}function s(e){return!!a(e)&&!!e.codeVerifier}function u(e){return!!s(e)&&!!e.interactionHandle}function c(e){return!!i(e)&&void 0===Object.values(e).find((function(e){return"string"!=typeof e}))}function f(e){return!(!a(e)&&!c(e))}},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t){},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t,n){"use strict";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function r(e){return!!(e&&(e.accessToken||e.idToken||e.refreshToken)&&Array.isArray(e.scopes))}function o(e){return e&&e.accessToken}function i(e){return e&&e.idToken}function a(e){return e&&e.refreshToken}n.d(t,"d",(function(){return r})),n.d(t,"a",(function(){return o})),n.d(t,"b",(function(){return i})),n.d(t,"c",(function(){return a}))},function(e,t){
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */},function(e,t,n){"use strict";var r={};n.r(r),n.d(r,"getUserAgent",(function(){return A})),n.d(r,"isFingerprintSupported",(function(){return x})),n.d(r,"isPopupPostMessageSupported",(function(){return R})),n.d(r,"isTokenVerifySupported",(function(){return C})),n.d(r,"hasTextEncoder",(function(){return j})),n.d(r,"isPKCESupported",(function(){return M})),n.d(r,"isHTTPS",(function(){return P})),n.d(r,"isLocalhost",(function(){return I}));var o=n(5),i=n.n(o),a=n(4),s=n.n(a),u=n(11),c=n.n(u),f=n(9),d=n.n(f),l=n(12),h=n.n(l),p=n(13),g=n.n(p),v=n(10),y=n.n(v),T=n(2);function m(e,t){var n=e.userAgent||{};return n.value?n.value:n.template?n.template.replace("$OKTA_AUTH_JS",t):t}var k=n(0),b=n(14),E=n(15),O=n(23),w=n(22),_=function(){function e(t){s()(this,e),
/*!
 * Copyright (c) 2018-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function(e){var t=(e=e||{}).issuer;if(!t)throw new T.a('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(!new RegExp("^http?s?://.+").test(e.issuer))throw new T.a('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(-1!==t.indexOf("-admin."))throw new T.a('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');var n=e.userAgent;if(n&&n.template&&-1===n.template.indexOf("$OKTA_AUTH_JS"))throw new T.a('UserAgentTemplate must include "$OKTA_AUTH_JS" placeholder. Required usage: new OktaAuth({userAgentTemplate: "xxx $OKTA_AUTH_JS xxx"})')}(t),this.options={issuer:Object(k.z)(t.issuer),tokenUrl:Object(k.z)(t.tokenUrl),authorizeUrl:Object(k.z)(t.authorizeUrl),userinfoUrl:Object(k.z)(t.userinfoUrl),revokeUrl:Object(k.z)(t.revokeUrl),logoutUrl:Object(k.z)(t.logoutUrl),clientId:t.clientId,redirectUri:t.redirectUri,state:t.state,scopes:t.scopes,postLogoutRedirectUri:t.postLogoutRedirectUri,responseMode:t.responseMode,responseType:t.responseType,pkce:t.pkce,httpRequestClient:t.httpRequestClient,transformErrorXHR:t.transformErrorXHR,transformAuthState:t.transformAuthState,restoreOriginalUri:t.restoreOriginalUri,storageUtil:t.storageUtil,headers:t.headers,devMode:t.devMode||!1,storageManager:Object.assign({token:{},transaction:{}},t.storageManager),cookies:t.cookies,ignoreSignature:!!t.ignoreSignature};var n=this.options,r=n.storageManager,o=n.cookies,i=n.storageUtil;this.storageManager=new O.a(r,o,i),this.transactionManager=new w.a(Object.assign({storageManager:this.storageManager},t.transactionManager)),this.tx={status:b.j.bind(null,this),resume:b.h.bind(null,this),exists:Object.assign(b.i.bind(null,this),{_get:function(e){return i.storage.get(e)}}),introspect:b.f.bind(null,this)},this.pkce={DEFAULT_CODE_CHALLENGE_METHOD:E.a.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:E.a.generateVerifier,computeChallenge:E.a.computeChallenge}}return c()(e,[{key:"signIn",value:function(e){return Object(b.g)(this,"/api/v1/authn",e)}},{key:"getIssuerOrigin",value:function(){return this.options.issuer.split("/oauth2/")[0]}},{key:"forgotPassword",value:function(e){return Object(b.g)(this,"/api/v1/authn/recovery/password",e)}},{key:"unlockAccount",value:function(e){return Object(b.g)(this,"/api/v1/authn/recovery/unlock",e)}},{key:"verifyRecoveryToken",value:function(e){return Object(b.g)(this,"/api/v1/authn/recovery/token",e)}}]),e}(),S=/windows phone|iemobile|wpdesktop/i;function A(){return navigator.userAgent}function x(){var e=A();return e&&!S.test(e)}function R(){var e=document.documentMode&&document.documentMode<10;return!(!window.postMessage||e)}function C(){return"undefined"!=typeof crypto&&crypto.subtle&&"undefined"!=typeof Uint8Array}function j(){return"undefined"!=typeof TextEncoder}function M(){return C()&&j()}function P(){return"https:"===window.location.protocol}function I(){return"localhost"===window.location.hostname}var U=n(38),N=n(47),L={getHttpCache:function(){return null},getPKCEStorage:function(){return null},browserHasLocalStorage:function(){try{var e=L.getLocalStorage();return L.testStorage(e)}catch(e){return!1}},browserHasSessionStorage:function(){try{var e=L.getSessionStorage();return L.testStorage(e)}catch(e){return!1}},testStorageType:function(e){var t=!1;switch(e){case"sessionStorage":t=L.browserHasSessionStorage();break;case"localStorage":t=L.browserHasLocalStorage();break;case"cookie":case"memory":t=!0;break;default:t=!1}return t},getStorageByType:function(e,t){var n=null;switch(e){case"sessionStorage":n=L.getSessionStorage();break;case"localStorage":n=L.getLocalStorage();break;case"cookie":n=L.getCookieStorage(t);break;case"memory":n=L.getInMemoryStorage();break;default:throw new T.a("Unrecognized storage option: ".concat(e))}return n},findStorageType:function(e){var t,n;return t=(e=e.slice()).shift(),(n=e.length?e[0]:null)?L.testStorageType(t)?t:(Object(k.F)("This browser doesn't support ".concat(t,". Switching to ").concat(n,".")),L.findStorageType(e)):t},getLocalStorage:function(){return localStorage},getSessionStorage:function(){return sessionStorage},getCookieStorage:function(e){var t=e.secure,n=e.sameSite;if(void 0===t||void 0===n)throw new T.a('getCookieStorage: "secure" and "sameSite" options must be provided');var r={getItem:L.storage.get,setItem:function(e,r,o){o=void 0===o?"2200-01-01T00:00:00.000Z":o,L.storage.set(e,r,o,{secure:t,sameSite:n})},removeItem:function(e){L.storage.delete(e)}};return e.useMultipleCookies?{getItem:function(e){var t=r.getItem(),n={};return Object.keys(t).forEach((function(r){0===r.indexOf(e)&&(n[r.replace("".concat(e,"_"),"")]=JSON.parse(t[r]))})),JSON.stringify(n)},setItem:function(e,t){var n=JSON.parse(this.getItem(e));t=JSON.parse(t),Object.keys(t).forEach((function(o){var i=e+"_"+o,a=JSON.stringify(t[o]);r.setItem(i,a),delete n[o]})),Object.keys(n).forEach((function(t){r.removeItem(e+"_"+t)}))},removeItem:function(e){var t=JSON.parse(this.getItem(e));Object.keys(t).forEach((function(t){r.removeItem(e+"_"+t)}))}}:r},getInMemoryStorage:function(){var e={};return{getItem:function(t){return e[t]},setItem:function(t,n){e[t]=n}}},testStorage:function(e){var t="okta-test-storage";try{return e.setItem(t,t),e.removeItem(t),!0}catch(e){return!1}},storage:{set:function(e,t,n,r){var o=r.secure,i=r.sameSite;if(void 0===o||void 0===i)throw new T.a('storage.set: "secure" and "sameSite" options must be provided');var a={path:r.path||"/",secure:o,sameSite:i};return Date.parse(n)&&(a.expires=new Date(n)),N.set(e,t,a),L.storage.get(e)},get:function(e){return N.get(e)},delete:function(e){return N.remove(e,{path:"/"})}}},D=L,K=n(3),F=n(6);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 */
function H(e){return e.session.get().then((function(e){return"ACTIVE"===e.status})).catch((function(){return!1}))}function G(e){return F.a.get(e,"/api/v1/sessions/me").then((function(t){var n=Object(k.x)(t,"_links");return n.refresh=function(){return F.a.post(e,Object(k.n)(t,"refresh").href)},n.user=function(){return F.a.get(e,Object(k.n)(t,"user").href)},n})).catch((function(){return{status:"INACTIVE"}}))}function q(e){return F.a.httpRequest(e,{url:e.getIssuerOrigin()+"/api/v1/sessions/me",method:"DELETE"})}function z(e){return F.a.post(e,"/api/v1/sessions/me/lifecycle/refresh")}function B(e,t,n){n=n||window.location.href,window.location.assign(e.getIssuerOrigin()+"/login/sessionCookieRedirect"+Object(k.D)({checkAccountSetupComplete:!0,token:t,redirectUrl:n}))}var V=n(8),J=n(16),W=function(){function e(){s()(this,e),this.queue=[],this.running=!1}return c()(e,[{key:"push",value:function(e,t){for(var n=this,r=arguments.length,o=new Array(r>2?r-2:0),i=2;i<r;i++)o[i-2]=arguments[i];return new Promise((function(r,i){n.queue.push({method:e,thisObject:t,args:o,resolve:r,reject:i}),n.run()}))}},{key:"run",value:function(){var e=this;if(!this.running&&0!==this.queue.length){this.running=!0;var t=this.queue.shift(),n=t.method.apply(t.thisObject,t.args);Object(k.u)(n)?n.then(t.resolve,t.reject).finally((function(){e.running=!1,e.run()})):(t.resolve(n),this.running=!1,this.run())}}}]),e}(),Y=n(1);function X(e,t){return t=t||{},x()?new Promise((function(i,a){(r=document.createElement("iframe")).style.display="none",o=function(t){if(t&&t.data&&t.origin===e.getIssuerOrigin()){try{var n=JSON.parse(t.data)}catch(e){return}if(n)return"FingerprintAvailable"===n.type?i(n.fingerprint):void("FingerprintServiceReady"===n.type&&t.source.postMessage(JSON.stringify({type:"GetFingerprint"}),t.origin))}},Object(V.a)(window,"message",o),r.src=e.getIssuerOrigin()+"/auth/services/devicefingerprint",document.body.appendChild(r),n=setTimeout((function(){a(new Y.c("Fingerprinting timed out"))}),t.timeout||15e3)})).finally((function(){clearTimeout(n),Object(V.J)(window,"message",o),document.body.contains(r)&&r.parentElement.removeChild(r)})):Promise.reject(new Y.c("Fingerprinting is not supported on this device"));var n,r,o}var $=n(53),Q={isPending:!0,isAuthenticated:!1,idToken:null,accessToken:null,refreshToken:null},Z={updateAuthStatePromise:null,canceledTimes:0},ee=function(){function e(t){var n=this;if(s()(this,e),!t.emitter)throw new Y.c("Emitter should be initialized before AuthStateManager");this._sdk=t,this._pending=Object.assign({},Z),this._authState=Object.assign({},Q),this._logOptions={},t.tokenManager.on(J.a,(function(e,t){n._setLogOptions({event:J.a,key:e,token:t}),n.updateAuthState()})),t.tokenManager.on(J.d,(function(e,t){n._setLogOptions({event:J.d,key:e,token:t}),n.updateAuthState()}))}return c()(e,[{key:"_setLogOptions",value:function(e){this._logOptions=e}},{key:"getAuthState",value:function(){return this._authState}},{key:"updateAuthState",value:function(){var e=this;this._sdk.emitter.e&&this._sdk.emitter.e.authStateChange&&this._sdk.emitter.e.authStateChange.length||Object(k.F)("updateAuthState is an asynchronous method with no return, please subscribe to the latest authState update with authStateManager.subscribe(handler) method before calling updateAuthState.");var t=this._sdk.options,n=t.transformAuthState,r=t.devMode,o=this._sdk.tokenManager._getOptions(),i=o.autoRenew,a=o.autoRemove,s=function(t){var n=e._logOptions,r=n.event,o=n.key,i=n.token;Object(k.m)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(r," Status:").concat(t)),Object(k.m)().log(o,i),Object(k.m)().log("Current authState",e._authState),Object(k.m)().groupEnd(),e._logOptions={}},u=function(t){var n,o;(n=e._authState,o=t,n.isPending!==o.isPending||n.isAuthenticated!==o.isAuthenticated||JSON.stringify(n.idToken)!==JSON.stringify(o.idToken)||JSON.stringify(n.accessToken)!==JSON.stringify(o.accessToken)||n.error!==o.error)?(e._authState=t,e._sdk.emitter.emit("authStateChange",Object.assign({},t)),r&&s("emitted")):r&&s("unchanged")},c=function(){return i||a};if(this._pending.updateAuthStatePromise){if(this._pending.canceledTimes>=10)return void(r&&s("terminated"));this._pending.updateAuthStatePromise.cancel()}var f=new $((function(t,o,i){i.shouldReject=!1,i((function(){e._pending.updateAuthStatePromise=null,e._pending.canceledTimes=e._pending.canceledTimes+1,r&&s("canceled")}));var a=function(n){f.isCanceled||(u(n),e._pending=Object.assign({},Z)),t()};e._sdk.tokenManager.getTokens().then((function(r){var o=r.accessToken,i=r.idToken,s=r.refreshToken;if(f.isCanceled)t();else{var u=!1;o&&e._sdk.tokenManager.hasExpired(o)&&(o=null,u=c()),i&&e._sdk.tokenManager.hasExpired(i)&&(i=null,u=c());var d={accessToken:o,idToken:i,refreshToken:s,isPending:u,isAuthenticated:!(!o||!i)};(n?n(e._sdk,d):Promise.resolve(d)).then((function(e){return a(e)})).catch((function(e){return a({accessToken:o,idToken:i,refreshToken:s,isAuthenticated:!1,isPending:!1,error:e})}))}}))}));this._pending.updateAuthStatePromise=f}},{key:"subscribe",value:function(e){this._sdk.emitter.on("authStateChange",e)}},{key:"unsubscribe",value:function(e){this._sdk.emitter.off("authStateChange",e)}}]),e}();function te(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */();return function(){var n,r=y()(e);if(t){var o=y()(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return g()(this,n)}}var ne=function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{u(r.next(e))}catch(e){i(e)}}function s(e){try{u(r.throw(e))}catch(e){i(e)}}function u(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}u((r=r.apply(e,t||[])).next())}))},re=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n},oe=n(54);function ie(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0,n=e.cookies||{};return void 0===n.secure&&(n.secure=t),void 0===n.sameSite&&(n.sameSite=n.secure?"none":"lax"),n.secure&&!t&&(Object(k.F)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'),n.secure=!1),"none"!==n.sameSite||n.secure||(n.sameSite="lax"),n}var ae=function(e){h()(n,e);var t=te(n);function n(){var e,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};s()(this,n),e=t.call(this,Object.assign({httpRequestClient:U.a,storageUtil:r.storageUtil||D,cookies:ie(r,n.features.isHTTPS()),storageManager:Object.assign({token:{storageTypes:["localStorage","sessionStorage","cookie"],useMultipleCookies:!0},cache:{storageTypes:["localStorage","sessionStorage","cookie"]},transaction:{storageTypes:["sessionStorage","localStorage","cookie"]}},r.storageManager)},r)),Object.assign(e.options.storageUtil,{getPKCEStorage:e.storageManager.getLegacyPKCEStorage.bind(e.storageManager),getHttpCache:e.storageManager.getHttpCache.bind(e.storageManager)}),e._pending={handleLogin:!1},e.options=Object.assign(e.options,{pkce:!1!==r.pkce,redirectUri:Object(k.C)(r.redirectUri,window.location.origin)}),e.userAgent=m(r,"okta-auth-js/".concat("4.8.0")),r.maxClockSkew||0===r.maxClockSkew?e.options.maxClockSkew=r.maxClockSkew:e.options.maxClockSkew=K.DEFAULT_MAX_CLOCK_SKEW,e.session={close:q.bind(null,d()(e)),exists:H.bind(null,d()(e)),get:G.bind(null,d()(e)),refresh:z.bind(null,d()(e)),setCookieAndRedirect:B.bind(null,d()(e))},e._tokenQueue=new W,e.token={prepareTokenParams:V.I.bind(null,d()(e)),exchangeCodeForTokens:V.f.bind(null,d()(e)),getWithoutPrompt:V.r.bind(null,d()(e)),getWithPopup:V.p.bind(null,d()(e)),getWithRedirect:V.q.bind(null,d()(e)),parseFromUrl:V.E.bind(null,d()(e)),decode:V.e,revoke:V.M.bind(null,d()(e)),renew:V.K.bind(null,d()(e)),renewTokens:V.L.bind(null,d()(e)),getUserInfo:V.n.bind(null,d()(e)),verify:V.P.bind(null,d()(e)),isLoginRedirect:V.A.bind(null,d()(e))};var o=["decode","isLoginRedirect"];return Object.keys(e.token).forEach((function(t){if(!(o.indexOf(t)>=0)){var n=e.token[t];e.token[t]=W.prototype.push.bind(e._tokenQueue,n,null)}})),Object.assign(e.token.getWithRedirect,{_setLocation:function(e){window.location=e}}),Object.assign(e.token.parseFromUrl,{_getHistory:function(){return window.history},_getLocation:function(){return window.location},_getDocument:function(){return window.document}}),e.fingerprint=X.bind(null,d()(e)),e.emitter=new oe,e.tokenManager=new J.f(d()(e),r.tokenManager),e.authStateManager=new ee(d()(e)),e}return c()(n,[{key:"isInteractionRequired",value:function(){return Object(V.y)(this)}},{key:"isInteractionRequiredError",value:function(e){return Object(V.z)(e)}},{key:"signIn",value:function(e){return this.features.isLocalhost()&&Object(k.h)("This method has been deprecated, please use signInWithCredentials() instead."),this.signInWithCredentials(e)}},{key:"signInWithCredentials",value:function(e){var t=this;e=Object(k.f)(e||{});var n=function(n){return delete e.sendFingerprint,Object(b.g)(t,"/api/v1/authn",e,n)};return e.sendFingerprint?this.fingerprint().then((function(e){return n({headers:{"X-Device-Fingerprint":e}})})):n()}},{key:"signInWithRedirect",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.originalUri,n=re(e,["originalUri"]);return ne(this,void 0,void 0,i.a.mark((function e(){var r;return i.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this._pending.handleLogin){e.next=2;break}return e.abrupt("return");case 2:return this._pending.handleLogin=!0,e.prev=3,t&&this.setOriginalUri(t),r=Object.assign({scopes:this.options.scopes||["openid","email","profile"]},n),e.next=8,this.token.getWithRedirect(r);case 8:return e.prev=8,this._pending.handleLogin=!1,e.finish(8);case 11:case"end":return e.stop()}}),e,this,[[3,,8,11]])})))}},{key:"closeSession",value:function(){return this.tokenManager.clear(),this.session.close().catch((function(e){if("AuthApiError"!==e.name||"E0000007"!==e.errorCode)throw e}))}},{key:"revokeAccessToken",value:function(e){return ne(this,void 0,void 0,i.a.mark((function t(){var n;return i.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(e){t.next=6;break}return t.next=3,this.tokenManager.getTokens();case 3:e=t.sent.accessToken,n=this.tokenManager._getStorageKeyByType("accessToken"),this.tokenManager.remove(n);case 6:if(e){t.next=8;break}return t.abrupt("return",Promise.resolve());case 8:return t.abrupt("return",this.token.revoke(e));case 9:case"end":return t.stop()}}),t,this)})))}},{key:"revokeRefreshToken",value:function(e){return ne(this,void 0,void 0,i.a.mark((function t(){var n;return i.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(e){t.next=6;break}return t.next=3,this.tokenManager.getTokens();case 3:e=t.sent.refreshToken,n=this.tokenManager._getStorageKeyByType("refreshToken"),this.tokenManager.remove(n);case 6:if(e){t.next=8;break}return t.abrupt("return",Promise.resolve());case 8:return t.abrupt("return",this.token.revoke(e));case 9:case"end":return t.stop()}}),t,this)})))}},{key:"signOut",value:function(e){return ne(this,void 0,void 0,i.a.mark((function t(){var n,r,o,a,s,u,c,f,d,l,h,p;return i.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(e=Object.assign({},e),n=window.location.origin,r=window.location.href,o=e.postLogoutRedirectUri||this.options.postLogoutRedirectUri||n,a=e.accessToken,s=e.refreshToken,u=!1!==e.revokeAccessToken,c=!1!==e.revokeRefreshToken,f=e.idToken,d=Object(V.l)(this).logoutUrl,void 0!==f){t.next=14;break}return t.next=13,this.tokenManager.getTokens();case 13:f=t.sent.idToken;case 14:if(!c||void 0!==s){t.next=18;break}return t.next=17,this.tokenManager.getTokens();case 17:s=t.sent.refreshToken;case 18:if(!u||void 0!==a){t.next=22;break}return t.next=21,this.tokenManager.getTokens();case 21:a=t.sent.accessToken;case 22:if(this.tokenManager.clear(),!c||!s){t.next=26;break}return t.next=26,this.revokeRefreshToken(s);case 26:if(!u||!a){t.next=29;break}return t.next=29,this.revokeAccessToken(a);case 29:if(f){t.next=31;break}return t.abrupt("return",this.closeSession().then((function(){o===r?window.location.reload():window.location.assign(o)})));case 31:l=e.state,h=f.idToken,p=d+"?id_token_hint="+encodeURIComponent(h)+"&post_logout_redirect_uri="+encodeURIComponent(o),l&&(p+="&state="+encodeURIComponent(l)),window.location.assign(p);case 36:case"end":return t.stop()}}),t,this)})))}},{key:"webfinger",value:function(e){var t="/.well-known/webfinger"+Object(k.D)(e);return F.a.get(this,t,{headers:{Accept:"application/jrd+json"}})}},{key:"isAuthenticated",value:function(e){return ne(this,void 0,void 0,i.a.mark((function t(){var n,r,o,a,s=this;return i.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if((n=this.authStateManager.getAuthState()).isPending){t.next=3;break}return t.abrupt("return",Promise.resolve(n.isAuthenticated));case 3:return t.abrupt("return",new Promise((function(t){r=function(){s.authStateManager.unsubscribe(o),clearTimeout(a)},o=function(e){var n=e.isAuthenticated;e.isPending||(t(n),r())},a=setTimeout((function(){t(!1),r()}),e||6e4),s.authStateManager.subscribe(o),s.authStateManager.updateAuthState()})));case 4:case"end":return t.stop()}}),t,this)})))}},{key:"getUser",value:function(){return ne(this,void 0,void 0,i.a.mark((function e(){var t,n,r;return i.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=this.authStateManager.getAuthState(),n=t.idToken,r=t.accessToken,e.abrupt("return",this.token.getUserInfo(r,n));case 2:case"end":return e.stop()}}),e,this)})))}},{key:"getIdToken",value:function(){var e=this.authStateManager.getAuthState().idToken;return e?e.idToken:void 0}},{key:"getAccessToken",value:function(){var e=this.authStateManager.getAuthState().accessToken;return e?e.accessToken:void 0}},{key:"getRefreshToken",value:function(){var e=this.authStateManager.getAuthState().refreshToken;return e?e.refreshToken:void 0}},{key:"storeTokensFromRedirect",value:function(){return ne(this,void 0,void 0,i.a.mark((function e(){var t,n;return i.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.token.parseFromUrl();case 2:t=e.sent,n=t.tokens,this.tokenManager.setTokens(n);case 5:case"end":return e.stop()}}),e,this)})))}},{key:"setOriginalUri",value:function(e){e=e||window.location.href,D.getSessionStorage().setItem(K.REFERRER_PATH_STORAGE_KEY,e)}},{key:"getOriginalUri",value:function(){return D.getSessionStorage().getItem(K.REFERRER_PATH_STORAGE_KEY)||window.location.origin}},{key:"removeOriginalUri",value:function(){D.getSessionStorage().removeItem(K.REFERRER_PATH_STORAGE_KEY)}},{key:"isLoginRedirect",value:function(){return Object(V.A)(this)}},{key:"handleLoginRedirect",value:function(e){return ne(this,void 0,void 0,i.a.mark((function t(){var n,r=this;return i.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(n=function e(t){var n=t.isPending;return ne(r,void 0,void 0,i.a.mark((function t(){var r,o;return i.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!n){t.next=2;break}return t.abrupt("return");case 2:if(this.authStateManager.unsubscribe(e),r=this.getOriginalUri(),this.removeOriginalUri(),!(o=this.options.restoreOriginalUri)){t.next=11;break}return t.next=9,o(this,r);case 9:t.next=12;break;case 11:window.location.replace(r);case 12:case"end":return t.stop()}}),t,this)})))},this.authStateManager.subscribe(n),!e){t.next=6;break}this.tokenManager.setTokens(e),t.next=12;break;case 6:if(!this.isLoginRedirect()){t.next=11;break}return t.next=9,this.storeTokensFromRedirect();case 9:t.next=12;break;case 11:this.authStateManager.unsubscribe(n);case 12:case"end":return t.stop()}}),t,this)})))}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){var t=!1;return t=Array.isArray(this.options.responseType)&&this.options.responseType.length?this.options.responseType.indexOf(e)>=0:this.options.responseType===e,t}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}}]),n}(_);ae.features=ae.prototype.features=r,Object.assign(ae,{constants:K,isInteractionRequiredError:V.z});t.a=ae},function(e,t,n){"use strict";(function(e){var r=n(18),o=n.n(r),i=n(39),a=n.n(i);t.a=function(t,n,r){var i=r.data,s=r.headers||{};"application/json"===(s["Content-Type"]||s["content-type"]||"")&&i&&"string"!=typeof i&&(i=JSON.stringify(i));var u=(e.fetch||a.a)(n,{method:t,headers:r.headers,body:i,credentials:r.withCredentials?"include":"omit"});return u.finally||(u=Promise.resolve(u)),u.then((function(e){var t=!e.ok,n=e.status;
/*!
 * Copyright (c) 2018-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
return function(e){return e.headers.get("Content-Type")&&e.headers.get("Content-Type").toLowerCase().indexOf("application/json")>=0?e.json().catch((function(e){return{error:e,errorSummary:"Could not parse server response"}})):e.text()}(e).then((function(e){return function(e,t){var n="object"===o()(t),r={responseText:n?JSON.stringify(t):t,status:e};return n&&(r.responseType="json",r.responseJSON=t),r}(n,e)})).then((function(e){if(t)throw e;return e}))}))}}).call(this,n(46))},function(e,t){var n=function(e){function t(){this.fetch=!1,this.DOMException=e.DOMException}return t.prototype=e,new t}("undefined"!=typeof self?self:this);!function(e){!function(t){var n="URLSearchParams"in e,r="Symbol"in e&&"iterator"in Symbol,o="FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),i="FormData"in e,a="ArrayBuffer"in e;if(a)var s=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],u=ArrayBuffer.isView||function(e){return e&&s.indexOf(Object.prototype.toString.call(e))>-1};function c(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function f(e){return"string"!=typeof e&&(e=String(e)),e}function d(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return r&&(t[Symbol.iterator]=function(){return t}),t}function l(e){this.map={},e instanceof l?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function h(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function p(e){return new Promise((function(t,n){e.onload=function(){t(e.result)},e.onerror=function(){n(e.error)}}))}function g(e){var t=new FileReader,n=p(t);return t.readAsArrayBuffer(e),n}function v(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function y(){return this.bodyUsed=!1,this._initBody=function(e){var t;this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:o&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:i&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:n&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():a&&o&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=v(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):a&&(ArrayBuffer.prototype.isPrototypeOf(e)||u(e))?this._bodyArrayBuffer=v(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):n&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},o&&(this.blob=function(){var e=h(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?h(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(g)}),this.text=function(){var e,t,n,r=h(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,t=new FileReader,n=p(t),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},i&&(this.formData=function(){return this.text().then(k)}),this.json=function(){return this.text().then(JSON.parse)},this}l.prototype.append=function(e,t){e=c(e),t=f(t);var n=this.map[e];this.map[e]=n?n+", "+t:t},l.prototype.delete=function(e){delete this.map[c(e)]},l.prototype.get=function(e){return e=c(e),this.has(e)?this.map[e]:null},l.prototype.has=function(e){return this.map.hasOwnProperty(c(e))},l.prototype.set=function(e,t){this.map[c(e)]=f(t)},l.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this)},l.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n)})),d(e)},l.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),d(e)},l.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t])})),d(e)},r&&(l.prototype[Symbol.iterator]=l.prototype.entries);var T=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function m(e,t){var n,r,o=(t=t||{}).body;if(e instanceof m){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new l(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,o||null==e._bodyInit||(o=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new l(t.headers)),this.method=(n=t.method||this.method||"GET",r=n.toUpperCase(),T.indexOf(r)>-1?r:n),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&o)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(o)}function k(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),o=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(o))}})),t}function b(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new l(t.headers),this.url=t.url||"",this._initBody(e)}m.prototype.clone=function(){return new m(this,{body:this._bodyInit})},y.call(m.prototype),y.call(b.prototype),b.prototype.clone=function(){return new b(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new l(this.headers),url:this.url})},b.error=function(){var e=new b(null,{status:0,statusText:""});return e.type="error",e};var E=[301,302,303,307,308];b.redirect=function(e,t){if(-1===E.indexOf(t))throw new RangeError("Invalid status code");return new b(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function O(e,n){return new Promise((function(r,i){var a=new m(e,n);if(a.signal&&a.signal.aborted)return i(new t.DOMException("Aborted","AbortError"));var s=new XMLHttpRequest;function u(){s.abort()}s.onload=function(){var e,t,n={status:s.status,statusText:s.statusText,headers:(e=s.getAllResponseHeaders()||"",t=new l,e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var o=n.join(":").trim();t.append(r,o)}})),t)};n.url="responseURL"in s?s.responseURL:n.headers.get("X-Request-URL");var o="response"in s?s.response:s.responseText;r(new b(o,n))},s.onerror=function(){i(new TypeError("Network request failed"))},s.ontimeout=function(){i(new TypeError("Network request failed"))},s.onabort=function(){i(new t.DOMException("Aborted","AbortError"))},s.open(a.method,a.url,!0),"include"===a.credentials?s.withCredentials=!0:"omit"===a.credentials&&(s.withCredentials=!1),"responseType"in s&&o&&(s.responseType="blob"),a.headers.forEach((function(e,t){s.setRequestHeader(t,e)})),a.signal&&(a.signal.addEventListener("abort",u),s.onreadystatechange=function(){4===s.readyState&&a.signal.removeEventListener("abort",u)}),s.send(void 0===a._bodyInit?null:a._bodyInit)}))}O.polyfill=!0,e.fetch||(e.fetch=O,e.Headers=l,e.Request=m,e.Response=b),t.Headers=l,t.Request=m,t.Response=b,t.fetch=O}({})}(n),delete n.fetch.polyfill,(t=n.fetch).default=n.fetch,t.fetch=n.fetch,t.Headers=n.Headers,t.Request=n.Request,t.Response=n.Response,e.exports=t},function(e,t,n){var r=n(48),o=n(49),i=n(50),a=n(52);e.exports=function(e,t){return r(e)||o(e,t)||i(e,t)||a()}},function(e,t,n){"use strict";n.r(t);var r=n(37);n.d(t,"OktaAuth",(function(){return r.a}));var o=n(3);n.d(t,"STATE_TOKEN_KEY_NAME",(function(){return o.STATE_TOKEN_KEY_NAME})),n.d(t,"DEFAULT_POLLING_DELAY",(function(){return o.DEFAULT_POLLING_DELAY})),n.d(t,"DEFAULT_MAX_CLOCK_SKEW",(function(){return o.DEFAULT_MAX_CLOCK_SKEW})),n.d(t,"DEFAULT_CACHE_DURATION",(function(){return o.DEFAULT_CACHE_DURATION})),n.d(t,"REDIRECT_OAUTH_PARAMS_NAME",(function(){return o.REDIRECT_OAUTH_PARAMS_NAME})),n.d(t,"REDIRECT_STATE_COOKIE_NAME",(function(){return o.REDIRECT_STATE_COOKIE_NAME})),n.d(t,"REDIRECT_NONCE_COOKIE_NAME",(function(){return o.REDIRECT_NONCE_COOKIE_NAME})),n.d(t,"TOKEN_STORAGE_NAME",(function(){return o.TOKEN_STORAGE_NAME})),n.d(t,"CACHE_STORAGE_NAME",(function(){return o.CACHE_STORAGE_NAME})),n.d(t,"PKCE_STORAGE_NAME",(function(){return o.PKCE_STORAGE_NAME})),n.d(t,"TRANSACTION_STORAGE_NAME",(function(){return o.TRANSACTION_STORAGE_NAME})),n.d(t,"ACCESS_TOKEN_STORAGE_KEY",(function(){return o.ACCESS_TOKEN_STORAGE_KEY})),n.d(t,"ID_TOKEN_STORAGE_KEY",(function(){return o.ID_TOKEN_STORAGE_KEY})),n.d(t,"REFRESH_TOKEN_STORAGE_KEY",(function(){return o.REFRESH_TOKEN_STORAGE_KEY})),n.d(t,"REFERRER_PATH_STORAGE_KEY",(function(){return o.REFERRER_PATH_STORAGE_KEY})),n.d(t,"MIN_VERIFIER_LENGTH",(function(){return o.MIN_VERIFIER_LENGTH})),n.d(t,"MAX_VERIFIER_LENGTH",(function(){return o.MAX_VERIFIER_LENGTH})),n.d(t,"DEFAULT_CODE_CHALLENGE_METHOD",(function(){return o.DEFAULT_CODE_CHALLENGE_METHOD}));var i=n(7);for(var a in i)["OktaAuth","STATE_TOKEN_KEY_NAME","DEFAULT_POLLING_DELAY","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_CACHE_DURATION","REDIRECT_OAUTH_PARAMS_NAME","REDIRECT_STATE_COOKIE_NAME","REDIRECT_NONCE_COOKIE_NAME","TOKEN_STORAGE_NAME","CACHE_STORAGE_NAME","PKCE_STORAGE_NAME","TRANSACTION_STORAGE_NAME","ACCESS_TOKEN_STORAGE_KEY","ID_TOKEN_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","REFERRER_PATH_STORAGE_KEY","MIN_VERIFIER_LENGTH","MAX_VERIFIER_LENGTH","DEFAULT_CODE_CHALLENGE_METHOD","default"].indexOf(a)<0&&function(e){n.d(t,e,(function(){return i[e]}))}(a);var s=n(14);n.d(t,"transactionStatus",(function(){return s.j})),n.d(t,"resumeTransaction",(function(){return s.h})),n.d(t,"transactionExists",(function(){return s.i})),n.d(t,"postToTransaction",(function(){return s.g})),n.d(t,"introspect",(function(){return s.f})),n.d(t,"AuthTransaction",(function(){return s.a})),n.d(t,"getPollFn",(function(){return s.d})),n.d(t,"TransactionState",(function(){return s.b})),n.d(t,"addStateToken",(function(){return s.c})),n.d(t,"getStateToken",(function(){return s.e}));var u=n(1);n.d(t,"AuthApiError",(function(){return u.a})),n.d(t,"AuthPollStopError",(function(){return u.b})),n.d(t,"AuthSdkError",(function(){return u.c})),n.d(t,"OAuthError",(function(){return u.d}));var c=n(8);n.d(t,"convertTokenParamsToOAuthParams",(function(){return c.d})),n.d(t,"buildAuthorizeParams",(function(){return c.c})),n.d(t,"postToTokenEndpoint",(function(){return c.H})),n.d(t,"postRefreshToken",(function(){return c.G})),n.d(t,"getWellKnown",(function(){return c.o})),n.d(t,"getKey",(function(){return c.k})),n.d(t,"addListener",(function(){return c.a})),n.d(t,"removeListener",(function(){return c.J})),n.d(t,"loadFrame",(function(){return c.C})),n.d(t,"loadPopup",(function(){return c.D})),n.d(t,"addPostMessageListener",(function(){return c.b})),n.d(t,"getDefaultTokenParams",(function(){return c.i})),n.d(t,"isInteractionRequiredError",(function(){return c.z})),n.d(t,"hasTokensInHash",(function(){return c.w})),n.d(t,"hasAuthorizationCode",(function(){return c.t})),n.d(t,"hasInteractionCode",(function(){return c.v})),n.d(t,"hasErrorInUrl",(function(){return c.u})),n.d(t,"isRedirectUri",(function(){return c.B})),n.d(t,"isCodeFlow",(function(){return c.x})),n.d(t,"getHashOrSearch",(function(){return c.j})),n.d(t,"isLoginRedirect",(function(){return c.A})),n.d(t,"isInteractionRequired",(function(){return c.y})),n.d(t,"generateState",(function(){return c.h})),n.d(t,"generateNonce",(function(){return c.g})),n.d(t,"getOAuthUrls",(function(){return c.l})),n.d(t,"pkce",(function(){return c.F})),n.d(t,"prepareTokenParams",(function(){return c.I})),n.d(t,"urlParamsToObject",(function(){return c.N})),n.d(t,"validateClaims",(function(){return c.O})),n.d(t,"decodeToken",(function(){return c.e})),n.d(t,"revokeToken",(function(){return c.M})),n.d(t,"renewToken",(function(){return c.K})),n.d(t,"renewTokens",(function(){return c.L})),n.d(t,"verifyToken",(function(){return c.P})),n.d(t,"getUserInfo",(function(){return c.n})),n.d(t,"handleOAuthResponse",(function(){return c.s})),n.d(t,"exchangeCodeForTokens",(function(){return c.f})),n.d(t,"getToken",(function(){return c.m})),n.d(t,"getWithoutPrompt",(function(){return c.r})),n.d(t,"getWithPopup",(function(){return c.p})),n.d(t,"getWithRedirect",(function(){return c.q})),n.d(t,"parseFromUrl",(function(){return c.E}));n(23),n(22);var f=n(16);n.d(t,"EVENT_EXPIRED",(function(){return f.c})),n.d(t,"EVENT_RENEWED",(function(){return f.e})),n.d(t,"EVENT_ADDED",(function(){return f.a})),n.d(t,"EVENT_REMOVED",(function(){return f.d})),n.d(t,"EVENT_ERROR",(function(){return f.b})),n.d(t,"TokenManager",(function(){return f.f}));var d=n(0);n.d(t,"stringToBase64Url",(function(){return d.A})),n.d(t,"base64ToBase64Url",(function(){return d.a})),n.d(t,"base64UrlToBase64",(function(){return d.c})),n.d(t,"base64UrlToString",(function(){return d.d})),n.d(t,"stringToBuffer",(function(){return d.B})),n.d(t,"base64UrlDecode",(function(){return d.b})),n.d(t,"bind",(function(){return d.e})),n.d(t,"isAbsoluteUrl",(function(){return d.p})),n.d(t,"toAbsoluteUrl",(function(){return d.C})),n.d(t,"toRelativeUrl",(function(){return d.E})),n.d(t,"isString",(function(){return d.v})),n.d(t,"isObject",(function(){return d.t})),n.d(t,"isNumber",(function(){return d.s})),n.d(t,"isoToUTCString",(function(){return d.w})),n.d(t,"toQueryString",(function(){return d.D})),n.d(t,"genRandomString",(function(){return d.l})),n.d(t,"extend",(function(){return d.j})),n.d(t,"removeNils",(function(){return d.y})),n.d(t,"clone",(function(){return d.f})),n.d(t,"omit",(function(){return d.x})),n.d(t,"find",(function(){return d.k})),n.d(t,"getLink",(function(){return d.n})),n.d(t,"getNativeConsole",(function(){return d.o})),n.d(t,"getConsole",(function(){return d.m})),n.d(t,"warn",(function(){return d.F})),n.d(t,"deprecate",(function(){return d.h})),n.d(t,"deprecateWrap",(function(){return d.i})),n.d(t,"removeTrailingSlash",(function(){return d.z})),n.d(t,"isIE11OrLess",(function(){return d.r})),n.d(t,"isFunction",(function(){return d.q})),n.d(t,"delay",(function(){return d.g})),n.d(t,"isPromise",(function(){return d.u}))},function(e,t,n){var r=function(e){"use strict";var t=Object.prototype,n=t.hasOwnProperty,r="function"==typeof Symbol?Symbol:{},o=r.iterator||"@@iterator",i=r.asyncIterator||"@@asyncIterator",a=r.toStringTag||"@@toStringTag";function s(e,t,n,r){var o=t&&t.prototype instanceof f?t:f,i=Object.create(o.prototype),a=new E(r||[]);return i._invoke=function(e,t,n){var r="suspendedStart";return function(o,i){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===o)throw i;return w()}for(n.method=o,n.arg=i;;){var a=n.delegate;if(a){var s=m(a,n);if(s){if(s===c)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var f=u(e,t,n);if("normal"===f.type){if(r=n.done?"completed":"suspendedYield",f.arg===c)continue;return{value:f.arg,done:n.done}}"throw"===f.type&&(r="completed",n.method="throw",n.arg=f.arg)}}}(e,n,a),i}function u(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}e.wrap=s;var c={};function f(){}function d(){}function l(){}var h={};h[o]=function(){return this};var p=Object.getPrototypeOf,g=p&&p(p(O([])));g&&g!==t&&n.call(g,o)&&(h=g);var v=l.prototype=f.prototype=Object.create(h);function y(e){["next","throw","return"].forEach((function(t){e[t]=function(e){return this._invoke(t,e)}}))}function T(e,t){var r;this._invoke=function(o,i){function a(){return new t((function(r,a){!function r(o,i,a,s){var c=u(e[o],e,i);if("throw"!==c.type){var f=c.arg,d=f.value;return d&&"object"==typeof d&&n.call(d,"__await")?t.resolve(d.__await).then((function(e){r("next",e,a,s)}),(function(e){r("throw",e,a,s)})):t.resolve(d).then((function(e){f.value=e,a(f)}),(function(e){return r("throw",e,a,s)}))}s(c.arg)}(o,i,r,a)}))}return r=r?r.then(a,a):a()}}function m(e,t){var n=e.iterator[t.method];if(void 0===n){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=void 0,m(e,t),"throw"===t.method))return c;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return c}var r=u(n,e.iterator,t.arg);if("throw"===r.type)return t.method="throw",t.arg=r.arg,t.delegate=null,c;var o=r.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,c):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,c)}function k(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function b(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function E(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(k,this),this.reset(!0)}function O(e){if(e){var t=e[o];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var r=-1,i=function t(){for(;++r<e.length;)if(n.call(e,r))return t.value=e[r],t.done=!1,t;return t.value=void 0,t.done=!0,t};return i.next=i}}return{next:w}}function w(){return{value:void 0,done:!0}}return d.prototype=v.constructor=l,l.constructor=d,l[a]=d.displayName="GeneratorFunction",e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===d||"GeneratorFunction"===(t.displayName||t.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,l):(e.__proto__=l,a in e||(e[a]="GeneratorFunction")),e.prototype=Object.create(v),e},e.awrap=function(e){return{__await:e}},y(T.prototype),T.prototype[i]=function(){return this},e.AsyncIterator=T,e.async=function(t,n,r,o,i){void 0===i&&(i=Promise);var a=new T(s(t,n,r,o),i);return e.isGeneratorFunction(n)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},y(v),v[a]="Generator",v[o]=function(){return this},v.toString=function(){return"[object Generator]"},e.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},e.values=O,E.prototype={constructor:E,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(b),!e)for(var t in this)"t"===t.charAt(0)&&n.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function r(n,r){return a.type="throw",a.arg=e,t.next=n,r&&(t.method="next",t.arg=void 0),!!r}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],a=i.completion;if("root"===i.tryLoc)return r("end");if(i.tryLoc<=this.prev){var s=n.call(i,"catchLoc"),u=n.call(i,"finallyLoc");if(s&&u){if(this.prev<i.catchLoc)return r(i.catchLoc,!0);if(this.prev<i.finallyLoc)return r(i.finallyLoc)}else if(s){if(this.prev<i.catchLoc)return r(i.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return r(i.finallyLoc)}}}},abrupt:function(e,t){for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=e,a.arg=t,i?(this.method="next",this.next=i.finallyLoc,c):this.complete(a)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),c},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),b(n),c}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;b(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:O(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),c}},e}(e.exports);try{regeneratorRuntime=r}catch(e){Function("r","regeneratorRuntime = r")(r)}},function(e,t){e.exports=function(e){return-1!==Function.toString.call(e).indexOf("[native code]")}},function(e,t,n){var r=n(25),o=n(45);function i(t,n,a){return o()?e.exports=i=Reflect.construct:e.exports=i=function(e,t,n){var o=[null];o.push.apply(o,t);var i=new(Function.bind.apply(e,o));return n&&r(i,n.prototype),i},i.apply(null,arguments)}e.exports=i},function(e,t){e.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){var r,o;
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */!function(i){if(void 0===(o="function"==typeof(r=i)?r.call(t,n,t,e):r)||(e.exports=o),!0,e.exports=i(),!!0){var a=window.Cookies,s=window.Cookies=i();s.noConflict=function(){return window.Cookies=a,s}}}((function(){function e(){for(var e=0,t={};e<arguments.length;e++){var n=arguments[e];for(var r in n)t[r]=n[r]}return t}function t(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function n(r){function o(){}function i(t,n,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},o.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var a=JSON.stringify(n);/^[\{\[]/.test(a)&&(n=a)}catch(e){}n=r.write?r.write(n,t):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),t=encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var s="";for(var u in i)i[u]&&(s+="; "+u,!0!==i[u]&&(s+="="+i[u].split(";")[0]));return document.cookie=t+"="+n+s}}function a(e,n){if("undefined"!=typeof document){for(var o={},i=document.cookie?document.cookie.split("; "):[],a=0;a<i.length;a++){var s=i[a].split("="),u=s.slice(1).join("=");n||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var c=t(s[0]);if(u=(r.read||r)(u,c)||t(u),n)try{u=JSON.parse(u)}catch(e){}if(o[c]=u,e===c)break}catch(e){}}return e?o[e]:o}}return o.set=i,o.get=function(e){return a(e,!1)},o.getJSON=function(e){return a(e,!0)},o.remove=function(t,n){i(t,"",e(n,{expires:-1}))},o.defaults={},o.withConverter=n,o}((function(){}))}))},function(e,t){e.exports=function(e){if(Array.isArray(e))return e}},function(e,t){e.exports=function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=e[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==s.return||s.return()}finally{if(o)throw i}}return n}}},function(e,t,n){var r=n(51);e.exports=function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}}},function(e,t){e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}},function(e,t,n){"use strict";var r=n(4),o=n(11),i=n(12),a=n(13),s=n(10);function u(e,t){var n;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return c(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return c(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function f(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=s(e);if(t){var o=s(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return a(this,n)}}var d=function(e){i(n,e);var t=f(n);function n(e){var o;return r(this,n),(o=t.call(this,e||"Promise was canceled")).name="CancelError",o}return o(n,[{key:"isCanceled",get:function(){return!0}}]),n}(n(26)(Error)),l=function(){function e(t){var n=this;r(this,e),this._cancelHandlers=[],this._isPending=!0,this._isCanceled=!1,this._rejectOnCancel=!0,this._promise=new Promise((function(e,r){n._reject=r;var o=function(e){if(!n._isPending)throw new Error("The `onCancel` handler was attached after the promise settled.");n._cancelHandlers.push(e)};return Object.defineProperties(o,{shouldReject:{get:function(){return n._rejectOnCancel},set:function(e){n._rejectOnCancel=e}}}),t((function(t){n._isPending=!1,e(t)}),(function(e){n._isPending=!1,r(e)}),o)}))}return o(e,null,[{key:"fn",value:function(t){return function(){for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return new e((function(e,n,o){r.push(o),t.apply(void 0,r).then(e,n)}))}}}]),o(e,[{key:"then",value:function(e,t){return this._promise.then(e,t)}},{key:"catch",value:function(e){return this._promise.catch(e)}},{key:"finally",value:function(e){return this._promise.finally(e)}},{key:"cancel",value:function(e){if(this._isPending&&!this._isCanceled){if(this._cancelHandlers.length>0)try{var t,n=u(this._cancelHandlers);try{for(n.s();!(t=n.n()).done;){(0,t.value)()}}catch(e){n.e(e)}finally{n.f()}}catch(e){this._reject(e)}this._isCanceled=!0,this._rejectOnCancel&&this._reject(new d(e))}}},{key:"isCanceled",get:function(){return this._isCanceled}}]),e}();Object.setPrototypeOf(l.prototype,Promise.prototype),e.exports=l,e.exports.CancelError=d},function(e,t){function n(){}n.prototype={on:function(e,t,n){var r=this.e||(this.e={});return(r[e]||(r[e]=[])).push({fn:t,ctx:n}),this},once:function(e,t,n){var r=this;function o(){r.off(e,o),t.apply(n,arguments)}return o._=t,this.on(e,o,n)},emit:function(e){for(var t=[].slice.call(arguments,1),n=((this.e||(this.e={}))[e]||[]).slice(),r=0,o=n.length;r<o;r++)n[r].fn.apply(n[r].ctx,t);return this},off:function(e,t){var n=this.e||(this.e={}),r=n[e],o=[];if(r&&t)for(var i=0,a=r.length;i<a;i++)r[i].fn!==t&&r[i].fn._!==t&&o.push(r[i]);return o.length?n[e]=o:delete n[e],this}},e.exports=n}])}));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(507);

module.exports = parent;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(318);
__webpack_require__(139);
__webpack_require__(105);
__webpack_require__(1106);
__webpack_require__(513);
__webpack_require__(1110);
var path = __webpack_require__(23);

module.exports = path.Promise;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);

module.exports = global.Promise;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var aFunction = __webpack_require__(84);
var wellKnownSymbol = __webpack_require__(34);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var fails = __webpack_require__(28);
var classof = __webpack_require__(130);
var bind = __webpack_require__(115);
var html = __webpack_require__(466);
var createElement = __webpack_require__(286);
var IS_IOS = __webpack_require__(511);

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    !fails(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(317);

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var isObject = __webpack_require__(38);
var newPromiseCapability = __webpack_require__(197);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var aFunction = __webpack_require__(84);
var newPromiseCapabilityModule = __webpack_require__(197);
var perform = __webpack_require__(241);
var iterate = __webpack_require__(119);

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (e) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: e };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var form = {
  title: function title() {
    var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

    return (0, _okta.loc)('enroll.totp.title', 'login', [factorName]);
  },
  subtitle: _okta._.partial(_okta.loc, 'enroll.totp.enterCode', 'login'),
  autoSave: true,
  noButtonBar: true,
  attributes: {
    'data-se': 'step-sendcode'
  },
  formChildren: function formChildren() {
    return [_FormType.default.Input({
      label: (0, _okta.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      explain: _Util.default.createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
      'explain-top': true,
      name: 'passCode',
      input: _TextBox.default,
      type: 'tel'
    }), _FormType.default.Toolbar({
      noCancelButton: true,
      save: (0, _okta.loc)('oform.verify', 'login') // TODO: deprecated by mfa.challenge.verify

    })];
  }
};
var _default = form;
exports.default = _default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(516);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(454);

module.exports = parent;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1116);

var iterableToArrayLimit = __webpack_require__(1117);

var unsupportedIterableToArray = __webpack_require__(520);

var nonIterableRest = __webpack_require__(1119);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(519);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(485);

module.exports = parent;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(521);

var _sliceInstanceProperty = __webpack_require__(1118);

var arrayLikeToArray = __webpack_require__(524);

function _unsupportedIterableToArray(o, minLen) {
  var _context;

  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);

  var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(522);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(471);

module.exports = parent;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(497);

module.exports = parent;


/***/ }),
/* 524 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1121);

module.exports = parent;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _ScopeItem = _interopRequireDefault(__webpack_require__(1126));

var SCOPE_N_GROUP_CONFIG = {
  groups: 'user',
  myAccount: 'user',
  users: 'user',
  apps: 'resource',
  authenticators: 'resource',
  authorizationServers: 'resource',
  clients: 'resource',
  domains: 'resource',
  factors: 'resource',
  idps: 'resource',
  linkedObjects: 'resource',
  policies: 'resource',
  templates: 'resource',
  eventHooks: 'hook',
  inlineHooks: 'hook',
  events: 'system',
  logs: 'system',
  orgs: 'system',
  roles: 'system',
  schemas: 'system',
  sessions: 'system',
  trustedOrigins: 'system'
};
var DEFAULT_GROUP = 'system';

var findScopeGroupKey = function findScopeGroupKey(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name;
  var xs = name.split('.');
  var groupType = xs[1];
  return SCOPE_N_GROUP_CONFIG[groupType] || DEFAULT_GROUP;
};

var ScopeGroupHeaderView = _okta.View.extend({
  className: 'scope-group',
  events: {
    'click': 'expandScopes'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"scope-group--header\"><h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "groupName") || (depth0 != null ? lookupProperty(depth0, "groupName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "groupName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 37
          },
          "end": {
            "line": 1,
            "column": 50
          }
        }
      }) : helper)) + "</h3><span class=\"scope-group--toggle\"><svg class=\"caret\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"path\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z\" fill=\"#A0A7AC\"></path></svg></span></div>";
    },
    "useData": true
  }),
  expandScopes: function expandScopes() {
    this.$el.toggleClass('scope-group--is-expanded');
    this.$('.caret').toggleClass('caret--is-rotated');
  },
  preRender: function preRender() {
    var _this = this;

    _okta._.chain(this.options.scopes).sortBy(function (_ref2) {
      var name = _ref2.name;
      return name;
    }).each(function (_ref3) {
      var name = _ref3.name,
          displayName = _ref3.displayName,
          description = _ref3.description;

      _this.add(_ScopeItem.default, {
        options: {
          name: displayName || name,
          description: description
        }
      });
    });
  }
});

var _default = _okta.View.extend({
  className: 'scope-list detail-row',
  postRender: function postRender() {
    var _this2 = this;

    var allScopes = this.model.get('scopes');

    var scopesWithGroup = _okta._.groupBy(allScopes, findScopeGroupKey);

    var SCOPE_GROUP_NAMES_CONFIG = {
      'user': (0, _okta.loc)('admin.consent.group.user.group', 'login'),
      'resource': (0, _okta.loc)('admin.consent.group.resource.policy', 'login'),
      'hook': (0, _okta.loc)('admin.consent.group.hook', 'login'),
      'system': (0, _okta.loc)('admin.consent.group.system', 'login')
    }; // loop through SCOPE_GROUP_NAMES_CONFIG to keep group order consistent in UI.

    _okta._.each(SCOPE_GROUP_NAMES_CONFIG, function (groupName, groupKey) {
      var scopes = scopesWithGroup[groupKey];

      if (!(0, _isArray.default)(scopes)) {
        return;
      } // add scope group header and scopes


      _this2.add(ScopeGroupHeaderView, {
        options: {
          groupName: groupName,
          scopes: scopes
        }
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var consentLogoHeaderTemplate = _runtime.default.template({
  "1": function _(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "clientURI",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 26
        },
        "end": {
          "line": 1,
          "column": 39
        }
      }
    }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
  },
  "3": function _(container, depth0, helpers, partials, data) {
    var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<img class=\"client-logo custom-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
      "name": "customLogo",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 149
        },
        "end": {
          "line": 1,
          "column": 163
        }
      }
    }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
      "name": "i18n",
      "hash": {
        "bundle": "login",
        "code": "common.logo.alt"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 170
        },
        "end": {
          "line": 1,
          "column": 216
        }
      }
    })) + "\" aria-hidden=\"true\" />";
  },
  "5": function _(container, depth0, helpers, partials, data) {
    var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<img class=\"client-logo default-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
      "name": "defaultLogo",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 290
        },
        "end": {
          "line": 1,
          "column": 305
        }
      }
    }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
      "name": "i18n",
      "hash": {
        "bundle": "login",
        "code": "common.logo.alt"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 312
        },
        "end": {
          "line": 1,
          "column": 358
        }
      }
    })) + "\" aria-hidden=\"true\" />";
  },
  "7": function _(container, depth0, helpers, partials, data) {
    return "</a>";
  },
  "9": function _(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<div class=\"issuer\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "issuer",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 566
        },
        "end": {
          "line": 1,
          "column": 576
        }
      }
    }) : helper)) + "</span></div>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 89
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.program(5, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 89
        },
        "end": {
          "line": 1,
          "column": 388
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(7, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 388
        },
        "end": {
          "line": 1,
          "column": 416
        }
      }
    })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
      "name": "i18n",
      "hash": {
        "arguments": "appName",
        "bundle": "login",
        "code": "consent.required.text"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 445
        },
        "end": {
          "line": 1,
          "column": 519
        }
      }
    })) != null ? stack1 : "") + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(9, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 526
        },
        "end": {
          "line": 1,
          "column": 596
        }
      }
    })) != null ? stack1 : "") + "</h1>";
  },
  "useData": true
});

var _default = consentLogoHeaderTemplate;
exports.default = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'scan-instructions clearfix',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"scan-instructions-details-wrapper\"><div class=\"scan-instructions-details\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "instructions",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 89
          },
          "end": {
            "line": 1,
            "column": 105
          }
        }
      }) : helper)) + "</p></div></div><div class=\"scan-instructions-qrcode-wrapper\"><div class=\"qrcode-wrap\"><img data-se=\"qrcode\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altQRCode") || (depth0 != null ? lookupProperty(depth0, "altQRCode") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "altQRCode",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 219
          },
          "end": {
            "line": 1,
            "column": 232
          }
        }
      }) : helper)) + "\" class=\"qrcode-image\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "qrcode") || (depth0 != null ? lookupProperty(depth0, "qrcode") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "qrcode",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 260
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      }) : helper)) + "\"><div data-se=\"qrcode-success\" class=\"qrcode-success\"></div><div data-se=\"qrcode-error\" class=\"qrcode-error\"></div></div><a href=\"#\" data-type=\"manual-setup\" data-se=\"manual-setup\" class=\"link manual-setup\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 478
          },
          "end": {
            "line": 1,
            "column": 531
          }
        }
      })) + "</a><a href=\"#\" data-type=\"refresh-qrcode\" data-se=\"refresh-qrcode\" class=\"link refresh-qrcode\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.refreshBarcode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 627
          },
          "end": {
            "line": 1,
            "column": 684
          }
        }
      })) + "</a></div>";
    },
    "useData": true
  }),
  events: {
    'click [data-type="manual-setup"]': function clickDataTypeManualSetup(e) {
      var _this = this;

      e.preventDefault();

      var url = _RouterUtil.default.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'manual');

      if (this.model.get('__factorType__') === 'push') {
        // cancel the poll and navigate to manual setup.
        this.model.doTransaction(function (transaction) {
          return transaction.prev().then(function (trans) {
            var factor = _okta._.findWhere(trans.factors, {
              factorType: 'push',
              provider: 'OKTA'
            });

            return factor.enroll();
          });
        }).then(function () {
          _this.options.appState.trigger('navigate', url);
        });
      } else {
        this.options.appState.trigger('navigate', url);
      }
    },
    'click [data-type="refresh-qrcode"]': function clickDataTypeRefreshQrcode(e) {
      e.preventDefault();
      this.model.trigger('errors:clear');
      var self = this;
      this.model.doTransaction(function (transaction) {
        if (this.appState.get('isWaitingForActivation')) {
          return transaction.poll();
        } else {
          return transaction.activate();
        }
      }).then(function (trans) {
        var res = trans.data;

        if ((res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE') && res.factorResult === 'WAITING') {
          // defer the render here to have a lastResponse set in AppState
          // so that we get new QRcode rendered
          _okta._.defer((0, _bind.default)(_okta._).call(_okta._, self.render, self));
        }
      });
    }
  },
  initialize: function initialize() {
    this.listenTo(this.options.appState, 'change:lastAuthResponse', function () {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.$el.toggleClass('qrcode-expired', !this.options.appState.get('isWaitingForActivation'));
      } else if (this.options.appState.get('isSuccessResponse')) {
        this.$el.addClass('qrcode-success');
      }
    });
    this.listenTo(this.model, 'error', function () {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.$el.toggleClass('qrcode-expired', true);
      }
    });
  },
  getTemplateData: function getTemplateData() {
    var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

    var instructions;

    if (this.model.get('__provider__') === 'GOOGLE') {
      instructions = (0, _okta.loc)('enroll.totp.setupGoogleAuthApp', 'login', [factorName]);
    } else {
      instructions = (0, _okta.loc)('enroll.totp.setupApp', 'login', [factorName]);
    }

    return {
      instructions: instructions,
      qrcode: this.options.appState.get('qrcode'),
      altQRCode: (0, _okta.loc)('mfa.altQrCode', 'login')
    };
  }
});

exports.default = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(2);

var _ScopeItem = _interopRequireDefault(__webpack_require__(1131));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'scope-list detail-row',
  postRender: function postRender() {
    var _context,
        _this = this;

    (0, _forEach.default)(_context = this.model.get('scopes')).call(_context, function (scope) {
      _this.add(_ScopeItem.default, {
        options: {
          name: scope.displayName || scope.name,
          description: scope.description,
          isCustomized: scope.isCustomized
        }
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "password.expiring.later"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 78
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "passwordWarn") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 143
          }
        }
      })) != null ? stack1 : "") + "<a href=\"#\" class=\"link help goto js-signout\" data-se=\"signout-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "signout"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 212
          },
          "end": {
            "line": 1,
            "column": 250
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  events: {
    'click .js-signout': function clickJsSignout(e) {
      e.preventDefault();
      var self = this;
      var authClient = self.settings.authClient;
      this.model.doTransaction(function (transaction) {
        return transaction.cancel();
      }).then(function () {
        return authClient.session.exists();
      }).then(function (sessionExists) {
        if (sessionExists) {
          return authClient.closeSession().catch(function () {});
        }
      }).then(function () {
        if (self.settings.get('signOutLink')) {
          Util.redirect(self.settings.get('signOutLink'));
        } else {
          self.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
          self.options.appState.trigger('navigate', '');
        }
      });
    },
    'click .js-skip': function clickJsSkip(e) {
      e.preventDefault();
      this.model.doTransaction(function (transaction) {
        return transaction.skip();
      });
    }
  },
  getTemplateData: function getTemplateData() {
    return {
      passwordWarn: this.options.appState.get('isPwdExpiringSoon')
    };
  }
});

exports.default = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _FormController.default.extend({
  className: 'enroll-custom-factor',
  Model: {
    local: {
      provider: 'string',
      factorType: 'string'
    },
    save: function save() {
      var _this = this;

      return this.manageTransaction(function (transaction, setTransaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          provider: _this.get('provider'),
          factorType: _this.get('factorType')
        });

        return factor.enroll().then(function (trans) {
          setTransaction(trans);

          var url = _this.appState.get('enrollCustomFactorRedirectUrl');

          if (url !== null) {
            Util.redirect(url);
          }
        }).catch(function (err) {
          throw err;
        });
      });
    }
  },
  Form: function Form() {
    var factors = this.options.appState.get('factors');
    var factor = factors.findWhere({
      provider: this.options.provider,
      factorType: this.options.factorType
    });
    var vendorName = factor.get('vendorName');
    var subtitle = (0, _okta.loc)('enroll.customFactor.subtitle', 'login', [vendorName]);
    var saveText = (0, _okta.loc)('enroll.customFactor.save', 'login');
    return {
      autoSave: true,
      title: vendorName,
      subtitle: subtitle,
      save: saveText
    };
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  },
  initialize: function initialize() {
    this.model.set('provider', this.options.provider);
    this.model.set('factorType', this.options.factorType);
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2020-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'hide resend-email-infobox',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"infobox infobox-warning\" aria-live=\"polite\"><span class=\"icon warning-16\"></span><p><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "email.code.not.received"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 102
          },
          "end": {
            "line": 1,
            "column": 156
          }
        }
      })) + "</span><a href=\"#\" class=\"resend-email-btn\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "email.button.resend"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 200
          },
          "end": {
            "line": 1,
            "column": 250
          }
        }
      })) + "</a></p></div>";
    },
    "useData": true
  }),
  events: {
    'click .resend-email-btn': 'resendEmail'
  },
  postRender: function postRender() {
    this.showResendCallout();
  },
  showResendCallout: function showResendCallout() {
    var _this = this;

    _okta._.delay(function () {
      _this.$el.removeClass('hide');
    }, _Enums.default.API_RATE_LIMIT);
  },
  hideResendCallout: function hideResendCallout() {
    this.$el.addClass('hide');
  },
  resendEmail: function resendEmail(e) {
    var _context;

    e.preventDefault();
    this.hideResendCallout();
    this.model.resend().finally((0, _bind.default)(_context = this.showResendCallout).call(_context, this));
  }
});

exports.default = _default;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var TextBox = _okta.internal.views.forms.inputs.TextBox;

var _default = TextBox.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"okta-form-label-inline o-form-label-inline\">" + alias4((helper = (helper = lookupProperty(helpers, "countryCallingCode") || (depth0 != null ? lookupProperty(depth0, "countryCallingCode") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "countryCallingCode",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 57
          },
          "end": {
            "line": 1,
            "column": 79
          }
        }
      }) : helper)) + "</span><span class=\"okta-form-input-field input-fix o-form-control\"><input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "type",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 160
          },
          "end": {
            "line": 1,
            "column": 168
          }
        }
      }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 183
          },
          "end": {
            "line": 1,
            "column": 198
          }
        }
      }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 206
          },
          "end": {
            "line": 1,
            "column": 214
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 220
          },
          "end": {
            "line": 1,
            "column": 231
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 240
          },
          "end": {
            "line": 1,
            "column": 249
          }
        }
      }) : helper)) + "\" autocomplete=\"tel\"></span>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    this.listenTo(this.model, 'change:countryCallingCode', function () {
      this.$('.o-form-label-inline').text(this.model.get('countryCallingCode'));
    });
  },
  preRender: function preRender() {
    this.options.countryCallingCode = this.model.get('countryCallingCode');
  },
  postRender: function postRender() {
    var _this = this;

    // This is a hack - once inputGroups are done, get rid of it!!
    this.$el.removeClass('input-fix o-form-control');

    _okta._.defer(function () {
      _this.$el.parent().addClass('o-form-input-group');
    });
  }
});

exports.default = _default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var cardinalityTextTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<span class=\"factor-cardinality\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "cardinalityText") || (depth0 != null ? lookupProperty(depth0, "cardinalityText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "cardinalityText",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 33
        },
        "end": {
          "line": 1,
          "column": 52
        }
      }
    }) : helper)) + "</span>";
  },
  "useData": true
});

var FactorListFactorRow = _okta.View.extend({
  tagName: 'li',
  className: 'enroll-factor-row clearfix',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorDescription") || (depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "factorDescription",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 235
          },
          "end": {
            "line": 1,
            "column": 256
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"enroll-factor-icon-container\"><div class=\"factor-icon enroll-factor-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"enroll-factor-description\"><h3 class=\"enroll-factor-label\">" + alias4((helper = (helper = lookupProperty(helpers, "factorLabel") || (depth0 != null ? lookupProperty(depth0, "factorLabel") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "factorLabel",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 187
          },
          "end": {
            "line": 1,
            "column": 202
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 207
          },
          "end": {
            "line": 1,
            "column": 267
          }
        }
      })) != null ? stack1 : "") + "<div class=\"enroll-factor-button\"></div></div>";
    },
    "useData": true
  }),
  attributes: function attributes() {
    return {
      'data-se': this.model.get('factorName')
    };
  },
  children: function children() {
    var children = [];
    var enrolled = this.model.get('enrolled');
    var required = this.model.get('required');
    var cardinality = this.model.get('cardinality');

    if (this.options.showInlineSetupButton) {
      return [[(0, _okta.createButton)({
        className: 'button',
        title: this.getSetupButtonText(),
        click: function click() {
          this.options.appState.trigger('navigate', _RouterUtil.default.createEnrollFactorUrl(this.model.get('provider'), this.model.get('factorType')));
        }
      }), '.enroll-factor-button']];
    } else if (enrolled) {
      children.push(['<span class="icon success-16-green"></span>', '.enroll-factor-label']);
    } else if (required) {
      children.push(['<span class="icon success-16-gray"></span>', '.enroll-factor-label']);
    }

    var cardinalityText = _FactorUtil.default.getCardinalityText(enrolled, required, cardinality);

    if (cardinalityText) {
      children.push([cardinalityTextTpl({
        cardinalityText: cardinalityText
      }), '.enroll-factor-description']);
    }

    return children;
  },
  minimize: function minimize() {
    this.$el.addClass('enroll-factor-row-min');
  },
  maximize: function maximize() {
    this.$el.removeClass('enroll-factor-row-min');
  },
  getSetupButtonText: function getSetupButtonText() {
    return this.model.get('additionalEnrollment') ? (0, _okta.loc)('enroll.choices.setup.another', 'login') : (0, _okta.loc)('enroll.choices.setup', 'login');
  }
});

var _default = _okta.ListView.extend({
  className: 'enroll-factor-list',
  item: FactorListFactorRow,
  itemSelector: '.list-content',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h3 class=\"list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "listTitle") || (depth0 != null ? lookupProperty(depth0, "listTitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "listTitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) + "</h3>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "listTitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 65
          }
        }
      })) != null ? stack1 : "") + "<ul class=\"list-content\"></ul>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var json = _okta.ListView.prototype.getTemplateData.call(this);

    _okta._.extend(json, this);

    return json;
  },
  postRender: function postRender() {
    if (this.options.minimize) {
      this.invoke('minimize');
    }
  }
});

exports.default = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1144);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//Copyright 2014-2015 Google Inc. All rights reserved.

//Use of this source code is governed by a BSD-style
//license that can be found in the LICENSE file or at
//https://developers.google.com/open-source/licenses/bsd

/**
 * @fileoverview The U2F api.
 */


(function (){
  var isChrome = 'chrome' in window && window.navigator.userAgent.indexOf('Edge') < 0;
  if ('u2f' in window || !isChrome) {
    return;
  }

  /** Namespace for the U2F api.
   * @type {Object}
   */
  var u2f = window.u2f = {};

  /**
   * FIDO U2F Javascript API Version
   * @number
   */
  var js_api_version;

  /**
   * The U2F extension id
   * @const {string}
   */
  // The Chrome packaged app extension ID.
  // Uncomment this if you want to deploy a server instance that uses
  // the package Chrome app and does not require installing the U2F Chrome extension.
   u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';
  // The U2F Chrome extension ID.
  // Uncomment this if you want to deploy a server instance that uses
  // the U2F Chrome extension to authenticate.
  // u2f.EXTENSION_ID = 'pfboblefjcgdjicmnffhdgionmgcdmne';


  /**
   * Message types for messsages to/from the extension
   * @const
   * @enum {string}
   */
  u2f.MessageTypes = {
      'U2F_REGISTER_REQUEST': 'u2f_register_request',
      'U2F_REGISTER_RESPONSE': 'u2f_register_response',
      'U2F_SIGN_REQUEST': 'u2f_sign_request',
      'U2F_SIGN_RESPONSE': 'u2f_sign_response',
      'U2F_GET_API_VERSION_REQUEST': 'u2f_get_api_version_request',
      'U2F_GET_API_VERSION_RESPONSE': 'u2f_get_api_version_response'
  };


  /**
   * Response status codes
   * @const
   * @enum {number}
   */
  u2f.ErrorCodes = {
      'OK': 0,
      'OTHER_ERROR': 1,
      'BAD_REQUEST': 2,
      'CONFIGURATION_UNSUPPORTED': 3,
      'DEVICE_INELIGIBLE': 4,
      'TIMEOUT': 5
  };


  /**
   * A message for registration requests
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   appId: ?string,
   *   timeoutSeconds: ?number,
   *   requestId: ?number
   * }}
   */
  u2f.U2fRequest;


  /**
   * A message for registration responses
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
   *   requestId: ?number
   * }}
   */
  u2f.U2fResponse;


  /**
   * An error object for responses
   * @typedef {{
   *   errorCode: u2f.ErrorCodes,
   *   errorMessage: ?string
   * }}
   */
  u2f.Error;

  /**
   * Data object for a single sign request.
   * @typedef {enum {BLUETOOTH_RADIO, BLUETOOTH_LOW_ENERGY, USB, NFC}}
   */
  u2f.Transport;


  /**
   * Data object for a single sign request.
   * @typedef {Array<u2f.Transport>}
   */
  u2f.Transports;

  /**
   * Data object for a single sign request.
   * @typedef {{
   *   version: string,
   *   challenge: string,
   *   keyHandle: string,
   *   appId: string
   * }}
   */
  u2f.SignRequest;


  /**
   * Data object for a sign response.
   * @typedef {{
   *   keyHandle: string,
   *   signatureData: string,
   *   clientData: string
   * }}
   */
  u2f.SignResponse;


  /**
   * Data object for a registration request.
   * @typedef {{
   *   version: string,
   *   challenge: string
   * }}
   */
  u2f.RegisterRequest;


  /**
   * Data object for a registration response.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: Transports,
   *   appId: string
   * }}
   */
  u2f.RegisterResponse;


  /**
   * Data object for a registered key.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: ?Transports,
   *   appId: ?string
   * }}
   */
  u2f.RegisteredKey;


  /**
   * Data object for a get API register response.
   * @typedef {{
   *   js_api_version: number
   * }}
   */
  u2f.GetJsApiVersionResponse;


  //Low level MessagePort API support

  /**
   * Sets up a MessagePort to the U2F extension using the
   * available mechanisms.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   */
  u2f.getMessagePort = function(callback) {
    if (typeof chrome != 'undefined' && chrome.runtime) {
      // The actual message here does not matter, but we need to get a reply
      // for the callback to run. Thus, send an empty signature request
      // in order to get a failure response.
      var msg = {
          type: u2f.MessageTypes.U2F_SIGN_REQUEST,
          signRequests: []
      };
      chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
        if (!chrome.runtime.lastError) {
          // We are on a whitelisted origin and can talk directly
          // with the extension.
          u2f.getChromeRuntimePort_(callback);
        } else {
          // chrome.runtime was available, but we couldn't message
          // the extension directly, use iframe
          u2f.getIframePort_(callback);
        }
      });
    } else if (u2f.isAndroidChrome_()) {
      u2f.getAuthenticatorPort_(callback);
    } else if (u2f.isIosChrome_()) {
      u2f.getIosPort_(callback);
    } else {
      // chrome.runtime was not available at all, which is normal
      // when this origin doesn't have access to any extensions.
      u2f.getIframePort_(callback);
    }
  };

  /**
   * Detect chrome running on android based on the browser's useragent.
   * @private
   */
  u2f.isAndroidChrome_ = function() {
    var userAgent = navigator.userAgent;
    return userAgent.indexOf('Chrome') != -1 &&
    userAgent.indexOf('Android') != -1;
  };

  /**
   * Detect chrome running on iOS based on the browser's platform.
   * @private
   */
  u2f.isIosChrome_ = function() {
    return ["iPhone", "iPad", "iPod"].indexOf(navigator.platform) > -1;
  };

  /**
   * Connects directly to the extension via chrome.runtime.connect.
   * @param {function(u2f.WrappedChromeRuntimePort_)} callback
   * @private
   */
  u2f.getChromeRuntimePort_ = function(callback) {
    var port = chrome.runtime.connect(u2f.EXTENSION_ID,
        {'includeTlsChannelId': true});
    setTimeout(function() {
      callback(new u2f.WrappedChromeRuntimePort_(port));
    }, 0);
  };

  /**
   * Return a 'port' abstraction to the Authenticator app.
   * @param {function(u2f.WrappedAuthenticatorPort_)} callback
   * @private
   */
  u2f.getAuthenticatorPort_ = function(callback) {
    setTimeout(function() {
      callback(new u2f.WrappedAuthenticatorPort_());
    }, 0);
  };

  /**
   * Return a 'port' abstraction to the iOS client app.
   * @param {function(u2f.WrappedIosPort_)} callback
   * @private
   */
  u2f.getIosPort_ = function(callback) {
    setTimeout(function() {
      callback(new u2f.WrappedIosPort_());
    }, 0);
  };

  /**
   * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
   * @param {Port} port
   * @constructor
   * @private
   */
  u2f.WrappedChromeRuntimePort_ = function(port) {
    this.port_ = port;
  };

  /**
   * Format and return a sign request compliant with the JS API version supported by the extension.
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */
  u2f.formatSignRequest_ =
    function(appId, challenge, registeredKeys, timeoutSeconds, reqId) {
    if (js_api_version === undefined || js_api_version < 1.1) {
      // Adapt request to the 1.0 JS API
      var signRequests = [];
      for (var i = 0; i < registeredKeys.length; i++) {
        signRequests[i] = {
            version: registeredKeys[i].version,
            challenge: challenge,
            keyHandle: registeredKeys[i].keyHandle,
            appId: appId
        };
      }
      return {
        type: u2f.MessageTypes.U2F_SIGN_REQUEST,
        signRequests: signRequests,
        timeoutSeconds: timeoutSeconds,
        requestId: reqId
      };
    }
    // JS 1.1 API
    return {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      appId: appId,
      challenge: challenge,
      registeredKeys: registeredKeys,
      timeoutSeconds: timeoutSeconds,
      requestId: reqId
    };
  };

  /**
   * Format and return a register request compliant with the JS API version supported by the extension..
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {Array<u2f.RegisterRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */
  u2f.formatRegisterRequest_ =
    function(appId, registeredKeys, registerRequests, timeoutSeconds, reqId) {
    if (js_api_version === undefined || js_api_version < 1.1) {
      // Adapt request to the 1.0 JS API
      for (var i = 0; i < registerRequests.length; i++) {
        registerRequests[i].appId = appId;
      }
      var signRequests = [];
      for (var i = 0; i < registeredKeys.length; i++) {
        signRequests[i] = {
            version: registeredKeys[i].version,
            challenge: registerRequests[0],
            keyHandle: registeredKeys[i].keyHandle,
            appId: appId
        };
      }
      return {
        type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
        signRequests: signRequests,
        registerRequests: registerRequests,
        timeoutSeconds: timeoutSeconds,
        requestId: reqId
      };
    }
    // JS 1.1 API
    return {
      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
      appId: appId,
      registerRequests: registerRequests,
      registeredKeys: registeredKeys,
      timeoutSeconds: timeoutSeconds,
      requestId: reqId
    };
  };


  /**
   * Posts a message on the underlying channel.
   * @param {Object} message
   */
  u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
    this.port_.postMessage(message);
  };


  /**
   * Emulates the HTML 5 addEventListener interface. Works only for the
   * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedChromeRuntimePort_.prototype.addEventListener =
      function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == 'message' || name == 'onmessage') {
      this.port_.onMessage.addListener(function(message) {
        // Emulate a minimal MessageEvent object
        handler({'data': message});
      });
    } else {
      console.error('WrappedChromeRuntimePort only supports onMessage');
    }
  };

  /**
   * Wrap the Authenticator app with a MessagePort interface.
   * @constructor
   * @private
   */
  u2f.WrappedAuthenticatorPort_ = function() {
    this.requestId_ = -1;
    this.requestObject_ = null;
  }

  /**
   * Launch the Authenticator intent.
   * @param {Object} message
   */
  u2f.WrappedAuthenticatorPort_.prototype.postMessage = function(message) {
    var intentUrl =
      u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ +
      ';S.request=' + encodeURIComponent(JSON.stringify(message)) +
      ';end';
    document.location = intentUrl;
  };

  /**
   * Tells what type of port this is.
   * @return {String} port type
   */
  u2f.WrappedAuthenticatorPort_.prototype.getPortType = function() {
    return "WrappedAuthenticatorPort_";
  };


  /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedAuthenticatorPort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == 'message') {
      var self = this;
      /* Register a callback to that executes when
       * chrome injects the response. */
      window.addEventListener(
          'message', self.onRequestUpdate_.bind(self, handler), false);
    } else {
      console.error('WrappedAuthenticatorPort only supports message');
    }
  };

  /**
   * Callback invoked  when a response is received from the Authenticator.
   * @param function({data: Object}) callback
   * @param {Object} message message Object
   */
  u2f.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ =
      function(callback, message) {
    var messageObject = JSON.parse(message.data);
    var intentUrl = messageObject['intentURL'];

    var errorCode = messageObject['errorCode'];
    var responseObject = null;
    if (messageObject.hasOwnProperty('data')) {
      responseObject = /** @type {Object} */ (
          JSON.parse(messageObject['data']));
    }

    callback({'data': responseObject});
  };

  /**
   * Base URL for intents to Authenticator.
   * @const
   * @private
   */
  u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ =
    'intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE';

  /**
   * Wrap the iOS client app with a MessagePort interface.
   * @constructor
   * @private
   */
  u2f.WrappedIosPort_ = function() {};

  /**
   * Launch the iOS client app request
   * @param {Object} message
   */
  u2f.WrappedIosPort_.prototype.postMessage = function(message) {
    var str = JSON.stringify(message);
    var url = "u2f://auth?" + encodeURI(str);
    location.replace(url);
  };

  /**
   * Tells what type of port this is.
   * @return {String} port type
   */
  u2f.WrappedIosPort_.prototype.getPortType = function() {
    return "WrappedIosPort_";
  };

  /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedIosPort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name !== 'message') {
      console.error('WrappedIosPort only supports message');
    }
  };

  /**
   * Sets up an embedded trampoline iframe, sourced from the extension.
   * @param {function(MessagePort)} callback
   * @private
   */
  u2f.getIframePort_ = function(callback) {
    // Create the iframe
    var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
    var iframe = document.createElement('iframe');
    iframe.src = iframeOrigin + '/u2f-comms.html';
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);

    var channel = new MessageChannel();
    var ready = function(message) {
      if (message.data == 'ready') {
        channel.port1.removeEventListener('message', ready);
        callback(channel.port1);
      } else {
        console.error('First event on iframe port was not "ready"');
      }
    };
    channel.port1.addEventListener('message', ready);
    channel.port1.start();

    iframe.addEventListener('load', function() {
      // Deliver the port to the iframe and initialize
      iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
    });
  };


  //High-level JS API

  /**
   * Default extension response timeout in seconds.
   * @const
   */
  u2f.EXTENSION_TIMEOUT_SEC = 30;

  /**
   * A singleton instance for a MessagePort to the extension.
   * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
   * @private
   */
  u2f.port_ = null;

  /**
   * Callbacks waiting for a port
   * @type {Array<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
   * @private
   */
  u2f.waitingForPort_ = [];

  /**
   * A counter for requestIds.
   * @type {number}
   * @private
   */
  u2f.reqCounter_ = 0;

  /**
   * A map from requestIds to client callbacks
   * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
   *                       |function((u2f.Error|u2f.SignResponse)))>}
   * @private
   */
  u2f.callbackMap_ = {};

  /**
   * Creates or retrieves the MessagePort singleton to use.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   * @private
   */
  u2f.getPortSingleton_ = function(callback) {
    if (u2f.port_) {
      callback(u2f.port_);
    } else {
      if (u2f.waitingForPort_.length == 0) {
        u2f.getMessagePort(function(port) {
          u2f.port_ = port;
          u2f.port_.addEventListener('message',
              /** @type {function(Event)} */ (u2f.responseHandler_));

          // Careful, here be async callbacks. Maybe.
          while (u2f.waitingForPort_.length)
            u2f.waitingForPort_.shift()(u2f.port_);
        });
      }
      u2f.waitingForPort_.push(callback);
    }
  };

  /**
   * Handles response messages from the extension.
   * @param {MessageEvent.<u2f.Response>} message
   * @private
   */
  u2f.responseHandler_ = function(message) {
    var response = message.data;
    var reqId = response['requestId'];
    if (!reqId || !u2f.callbackMap_[reqId]) {
      console.error('Unknown or missing requestId in response.');
      return;
    }
    var cb = u2f.callbackMap_[reqId];
    delete u2f.callbackMap_[reqId];
    cb(response['responseData']);
  };

  /**
   * Dispatches an array of sign requests to available U2F tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the sign request.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sign = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
    if (js_api_version === undefined) {
      // Send a message to get the extension to JS API version, then send the actual sign request.
      u2f.getApiVersion(
          function (response) {
            js_api_version = response['js_api_version'] === undefined ? 0 : response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
          });
    } else {
      // We know the JS API version. Send the actual sign request in the supported API version.
      u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
    }
  };

  /**
   * Dispatches an array of sign requests to available U2F tokens.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sendSignRequest = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
    u2f.getPortSingleton_(function(port) {
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var timeoutSeconds = (typeof opt_timeoutSeconds !== 'undefined' ?
          opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC);
      var req = u2f.formatSignRequest_(appId, challenge, registeredKeys, timeoutSeconds, reqId);
      port.postMessage(req);
    });
  };

  /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the register request.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.register = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
    if (js_api_version === undefined) {
      // Send a message to get the extension to JS API version, then send the actual register request.
      u2f.getApiVersion(
          function (response) {
            js_api_version = response['js_api_version'] === undefined ? 0: response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendRegisterRequest(appId, registerRequests, registeredKeys,
                callback, opt_timeoutSeconds);
          });
    } else {
      // We know the JS API version. Send the actual register request in the supported API version.
      u2f.sendRegisterRequest(appId, registerRequests, registeredKeys,
          callback, opt_timeoutSeconds);
    }
  };

  /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sendRegisterRequest = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
    u2f.getPortSingleton_(function(port) {
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var timeoutSeconds = (typeof opt_timeoutSeconds !== 'undefined' ?
          opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC);
      var req = u2f.formatRegisterRequest_(
          appId, registeredKeys, registerRequests, timeoutSeconds, reqId);
      port.postMessage(req);
    });
  };


  /**
   * Dispatches a message to the extension to find out the supported
   * JS API version.
   * If the user is on a mobile phone and is thus using Google Authenticator instead
   * of the Chrome extension, don't send the request and simply return 0.
   * @param {function((u2f.Error|u2f.GetJsApiVersionResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.getApiVersion = function(callback, opt_timeoutSeconds) {
   u2f.getPortSingleton_(function(port) {
     // If we are using Android Google Authenticator or iOS client app,
     // do not fire an intent to ask which JS API version to use.
     if (port.getPortType) {
       var apiVersion;
       switch (port.getPortType()) {
         case 'WrappedIosPort_':
         case 'WrappedAuthenticatorPort_':
           apiVersion = 1.1;
           break;

         default:
           apiVersion = 0;
           break;
       }
       callback({ 'js_api_version': apiVersion });
       return;
     }
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var req = {
        type: u2f.MessageTypes.U2F_GET_API_VERSION_REQUEST,
        timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
            opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
        requestId: reqId
      };
      port.postMessage(req);
    });
  };
})();


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _okta = __webpack_require__(2);

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/* eslint max-statements: [2, 23],  max-depth: [2, 3], complexity: [2, 13] */

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var SchemaFormFactory = _okta.internal.views.forms.helpers.SchemaFormFactory;

var getParts = function getParts(username) {
  var usernameArr = username.split('');
  var minPartsLength = 3;
  var userNameParts = [];
  var delimiters = [',', '.', '-', '_', '#', '@'];
  var userNamePart = '';

  _okta._.each(usernameArr, function (part) {
    if ((0, _indexOf.default)(delimiters).call(delimiters, part) === -1) {
      userNamePart += part;
    } else {
      if (userNamePart.length >= minPartsLength) {
        userNameParts.push(_okta._.clone(userNamePart));
      }

      userNamePart = '';
    }
  });

  if (userNamePart.length >= minPartsLength) {
    userNameParts.push(_okta._.clone(userNamePart));
  }

  return (0, _filter.default)(userNameParts).call(userNameParts, Boolean);
};

var passwordContainsFormField = function passwordContainsFormField(formField, password) {
  if (!formField) {
    return false;
  }

  formField = formField.toLowerCase();
  password = password.toLowerCase();
  var formFieldArr = getParts(formField); //check if each formField part contains password

  for (var i = 0; i < formFieldArr.length; i++) {
    var formFieldPart = formFieldArr[i];

    if ((0, _indexOf.default)(password).call(password, formFieldPart) !== -1) {
      return true;
    }
  }

  return false;
};

var checkSubSchema = function checkSubSchema(subSchema, value, model) {
  var minLength = subSchema.get('minLength');
  var maxLength = subSchema.get('maxLength');
  var regex = subSchema.get('format');

  if (_okta._.isNumber(minLength)) {
    if (value.length < minLength) {
      return false;
    }
  }

  if (_okta._.isNumber(maxLength)) {
    if (value.length > maxLength) {
      return false;
    }
  }

  var password = value;

  if (_okta._.isString(regex)) {
    // call passwordContainsFormField if regex is userName, firstName, lastName
    if (regex === '^[#/userName]' || regex === '^[#/firstName]' || regex === '^[#/lastName]') {
      var fieldName = regex.split('^[#/')[1].split(']')[0];
      var fieldValue = model.get(fieldName);

      if (fieldName === 'userName') {
        // with email as login enabled, we only have email populated
        // Therefore we fallback and run validation with email attribute.
        fieldValue = model.has('userName') ? model.get('userName') : model.get('email');
      }

      return !passwordContainsFormField(fieldValue, password);
    } else {
      if (!new RegExp(regex).test(value)) {
        return false;
      }
    }
  }

  return true;
};

var checkSubSchemas = function checkSubSchemas(fieldName, model, subSchemas, showError) {
  var value = model.get(fieldName);

  if (!_okta._.isString(value)) {
    return;
  }

  subSchemas.each(function (subSchema, index) {
    var ele = (0, _okta.$)('#subschemas-' + fieldName + ' .subschema-' + index); //hide password complexity if no password

    if (value) {
      ele.children('p').removeClass('default-schema');
    } else {
      ele.children('p').addClass('default-schema');
    }

    ele.removeClass('subschema-satisfied subschema-unsatisfied subschema-error');

    if (checkSubSchema(subSchema, value, model)) {
      ele.addClass('subschema-satisfied');
      (0, _find.default)(ele).call(ele, 'p span').removeClass('error error-16-small');
      (0, _find.default)(ele).call(ele, 'p span').addClass('confirm-16');
    } else {
      if (showError) {
        (0, _find.default)(ele).call(ele, 'p span').removeClass('confirm-16');
        (0, _find.default)(ele).call(ele, 'p span').addClass('error error-16-small');
        ele.addClass('subschema-error subschema-unsatisfied');
      }
    }
  });
};

var fnCreateInputOptions = function fnCreateInputOptions(schemaProperty) {
  var inputOptions = SchemaFormFactory.createInputOptions(schemaProperty);

  if (inputOptions.type === 'select') {
    inputOptions = _okta._.extend(inputOptions, {
      label: schemaProperty.get('title')
    });
  } else {
    var placeholder = schemaProperty.get('title');

    if (schemaProperty.get('required')) {
      placeholder += ' *';
    }

    inputOptions = _okta._.extend(inputOptions, {
      label: false,
      'label-top': true,
      placeholder: placeholder
    });
  }

  var fieldName = schemaProperty.get('name');

  switch (fieldName) {
    case 'userName':
      inputOptions.input = _TextBox.default;
      inputOptions.params = {
        icon: 'person-16-gray'
      };
      break;

    case 'password':
      inputOptions.type = 'password';
      inputOptions.input = _TextBox.default;
      inputOptions.params = {
        icon: 'remote-lock-16'
      };
  }

  var subSchemas = schemaProperty.get('subSchemas');

  if (subSchemas) {
    inputOptions.events = {
      input: function input() {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      focusout: function focusout() {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:userName': function changeUserName() {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:firstName': function changeFirstName() {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:lastName': function changeLastName() {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:email': function changeEmail() {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      }
    };
  }

  return inputOptions;
};

var _default = {
  createInputOptions: fnCreateInputOptions,
  getUsernameParts: getParts,
  passwordContainsFormField: passwordContainsFormField
};
exports.default = _default;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 87
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .help': function clickHelp(e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});

exports.default = _default;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'okta-waiting-spinner',
  attributes: {
    'data-se': 'o-form-okta-waiting-spinner'
  },
  modelEvents: {
    'spinner:show': 'show',
    'spinner:hide': 'hide'
  },
  initialize: function initialize(options) {
    if (options && options.visible === false) {
      this.hide();
    }
  },
  show: function show() {
    this.$el.removeClass('hide');
  },
  hide: function hide() {
    this.$el.addClass('hide');
  }
});

exports.default = _default;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"infobox\"><span class=\"icon info-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "helpSupportNumber",
          "bundle": "login",
          "code": "contact.support"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 134
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  }),
  className: 'contact-support',
  getTemplateData: function getTemplateData() {
    return this.settings.pick('helpSupportNumber');
  }
});

exports.default = _default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _PrimaryAuth = _interopRequireDefault(__webpack_require__(329));

var _BaseLoginController = _interopRequireDefault(__webpack_require__(156));

var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(330));

var _CustomButtons = _interopRequireDefault(__webpack_require__(543));

var _PrimaryAuthForm = _interopRequireDefault(__webpack_require__(544));

var _Footer = _interopRequireDefault(__webpack_require__(1178));

var _FooterRegistration = _interopRequireDefault(__webpack_require__(1179));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginController.default.extend({
  className: 'primary-auth',
  state: {
    enabled: true
  },
  View: _PrimaryAuthForm.default,
  constructor: function constructor(options) {
    options.appState.unset('username');
    this.model = new _PrimaryAuth.default({
      multiOptionalFactorEnroll: options.settings.get('features.multiOptionalFactorEnroll'),
      settings: options.settings,
      appState: options.appState
    }, {
      parse: true
    });

    _BaseLoginController.default.apply(this, arguments);

    this.addListeners(); // If social auth is configured, 'socialAuthPositionTop' will determine
    // the order in which the social auth and primary auth are shown on the screen.

    if (options.settings.get('hasConfiguredButtons')) {
      this.add(_CustomButtons.default, {
        prepend: options.settings.get('socialAuthPositionTop'),
        options: {
          // To trigger an afterError event, we require the current controller
          currentController: this
        }
      });
    }

    this.addFooter(options);
    this.setUsername();
  },
  addFooter: function addFooter(options) {
    this.add(new _Footer.default(this.toJSON({
      appState: options.appState
    })));

    if (options.settings.get('features.registration') || options.appState.get('isIdxStateToken')) {
      this.add(new _FooterRegistration.default({
        settings: this.settings,
        appState: options.appState
      }));
    }
  },
  setUsername: function setUsername() {
    var username = this.model.get('username');

    if (username) {
      this.options.appState.set('username', username);
    }
  },
  events: {
    'focusout input[name=username]': function focusoutInputNameUsername() {
      if (this.shouldComputeDeviceFingerprint() && this.model.get('username')) {
        var self = this;
        this.options.appState.trigger('loading', true);

        _DeviceFingerprint.default.generateDeviceFingerprint(this.settings.get('baseUrl'), this.$el).then(function (fingerprint) {
          self.options.appState.set('deviceFingerprint', fingerprint);
          self.options.appState.set('username', self.model.get('username'));
        }).catch(function () {
          // Keep going even if device fingerprint fails
          self.options.appState.set('username', self.model.get('username'));
        }).finally(function () {
          self.options.appState.trigger('loading', false);
        });
      } else {
        this.options.appState.set('username', this.model.get('username'));
      }
    },
    'focusin input': function focusinInput(e) {
      (0, _okta.$)(e.target.parentElement).addClass('focused-input');
    },
    'focusout input': function focusoutInput(e) {
      (0, _okta.$)(e.target.parentElement).removeClass('focused-input');
    }
  },
  // This model and the AppState both have a username property.
  // The controller updates the AppState's username when the user is
  // done editing (on blur) or deletes the username (see below).
  initialize: function initialize() {
    this.options.appState.unset('deviceFingerprint');
    this.listenTo(this.model, 'change:username', function (model, value) {
      if (!value) {
        // reset AppState to an undefined user.
        this.options.appState.set('username', '');
      }
    });
    this.listenTo(this.model, 'save', function () {
      this.state.set('enabled', false);
    });
    this.listenTo(this.model, 'error', function () {
      this.state.set('enabled', true);
    });
    this.listenTo(this.state, 'togglePrimaryAuthButton', function (buttonState) {
      this.toggleButtonState(buttonState);
    });
  },
  shouldComputeDeviceFingerprint: function shouldComputeDeviceFingerprint() {
    return this.settings.get('features.securityImage') && this.settings.get('features.deviceFingerprinting') && this.settings.get('features.useDeviceFingerprintForSecurityImage');
  }
});

exports.default = _default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _OAuth2Util = _interopRequireDefault(__webpack_require__(326));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var SharedUtil = _okta.internal.util.Util;

var dividerTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<div class=\"auth-divider\"><span class=\"auth-divider-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "text",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 58
        },
        "end": {
          "line": 1,
          "column": 66
        }
      }
    }) : helper)) + "</span></div>";
  },
  "useData": true
});

var formTitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 62
        },
        "end": {
          "line": 1,
          "column": 71
        }
      }
    }) : helper)) + "</h2>";
  },
  "useData": true
});

var _default = _okta.View.extend({
  className: 'primary-auth-container',
  children: function children() {
    var children = [];
    var socialIdpButtons = this.settings.get('configuredSocialIdps');
    var pivButton = this.settings.get('piv');
    var customButtons = this.settings.get('customButtons');
    var divider = dividerTpl({
      text: (0, _okta.loc)('socialauth.divider.text', 'login')
    });

    if (this.settings.get('hasPivCard')) {
      children.push(this._createPivButton(pivButton));
    }

    _okta._.each(socialIdpButtons, function (button) {
      children.push(this._createSocialIdpButton(button));
    }, this);

    _okta._.each(customButtons, function (button) {
      children.push(this._createCustomButton(button));
    }, this); // If the social auth buttons have to be above the Okta form, the title moves from
    // primary auth form to the social auth (above the buttons) and the divider goes below
    // the buttons (in between social auth and primary auth). If social auth needs to go below
    // Okta form, just add the divider at the top of the social auth container. The title still
    // lives in primary auth form.


    if (this.settings.get('socialAuthPositionTop')) {
      children.unshift(formTitleTpl({
        title: (0, _okta.loc)('primaryauth.title', 'login')
      })); // Divider between Primary Auth and the Social Auth

      children.push(divider);
    } else {
      children.unshift(divider);
    }

    return children;
  },
  _createSocialIdpButton: function _createSocialIdpButton(options) {
    return (0, _okta.createButton)({
      attributes: {
        'data-se': options.dataAttr
      },
      className: options.className,
      title: function title() {
        return options.text || (0, _okta.loc)(options.i18nKey);
      },
      click: function click(e) {
        e.preventDefault();

        if (this.settings.get('oauth2Enabled')) {
          _OAuth2Util.default.getTokens(this.settings, {
            idp: options.id
          }, this.options.currentController);
        } else {
          var _context, _context2;

          var baseUrl = this.settings.get('baseUrl');

          var params = _okta.$.param({
            fromURI: this.settings.get('relayState')
          });

          var targetUri = (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(baseUrl, "/sso/idps/")).call(_context2, options.id, "?")).call(_context, params);
          SharedUtil.redirect(targetUri);
        }
      }
    });
  },
  _createPivButton: function _createPivButton(options) {
    var className = options.className || '';
    return (0, _okta.createButton)({
      attributes: {
        'data-se': 'piv-card-button'
      },
      className: className + ' piv-button',
      title: options.text || (0, _okta.loc)('piv.cac.card', 'login'),
      click: function click(e) {
        e.preventDefault();
        this.options.appState.trigger('navigate', 'signin/verify/piv');
      }
    });
  },
  _createCustomButton: function _createCustomButton(options) {
    return (0, _okta.createButton)({
      attributes: {
        'data-se': options.dataAttr
      },
      className: options.className + ' default-custom-button',
      title: function title() {
        return options.title || (0, _okta.loc)(options.i18nKey);
      },
      click: options.click
    });
  }
});

exports.default = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _okta = __webpack_require__(2);

var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(330));

var _TypingUtil = _interopRequireDefault(__webpack_require__(1172));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Form.extend({
  className: 'primary-auth-form',
  noCancelButton: true,
  attributes: {
    novalidate: 'novalidate'
  },
  save: function save() {
    if (this.settings.get('features.passwordlessAuth')) {
      return (0, _okta.loc)('oform.next', 'login');
    }

    return (0, _okta.loc)('primaryauth.submit', 'login');
  },
  saveId: 'okta-signin-submit',
  layout: 'o-form-theme',
  // If socialAuth is configured, the title moves from the form to
  // the top of the container (and is rendered in socialAuth).
  title: function title() {
    var formTitle = (0, _okta.loc)('primaryauth.title', 'login');

    if (this.settings.get('socialAuthPositionTop')) {
      formTitle = '';
    }

    return formTitle;
  },
  initialize: function initialize() {
    var trackTypingPattern = this.settings.get('features.trackTypingPattern');
    this.listenTo(this, 'save', function () {
      if (trackTypingPattern) {
        var typingPattern = _TypingUtil.default.getTypingPattern();

        this.options.appState.set('typingPattern', typingPattern);
      }

      var self = this;
      var creds = {
        username: this.model.get('username')
      };

      if (!this.settings.get('features.passwordlessAuth')) {
        creds.password = this.model.get('password');
      }

      this.settings.processCreds(creds).then(function () {
        if (!self.settings.get('features.deviceFingerprinting')) {
          return;
        }

        self.options.appState.trigger('loading', true);
        self.state.trigger('togglePrimaryAuthButton', true);
        return _DeviceFingerprint.default.generateDeviceFingerprint(self.settings.get('baseUrl'), self.$el).then(function (fingerprint) {
          self.options.appState.set('deviceFingerprint', fingerprint);
        }).catch(function () {// Keep going even if device fingerprint fails
        }).finally(function () {
          self.options.appState.trigger('loading', false);
          self.state.trigger('togglePrimaryAuthButton', false);
        });
      }).then((0, _bind.default)(_okta._).call(_okta._, this.model.save, this.model));
    });
    this.stateEnableChange();
  },
  stateEnableChange: function stateEnableChange() {
    this.listenTo(this.state, 'change:enabled', function (model, enable) {
      if (enable) {
        this.enable();
      } else {
        this.disable();
      }
    });
  },
  inputs: function inputs() {
    var inputs = [];
    inputs.push(this.getUsernameField());

    if (!this.settings.get('features.passwordlessAuth')) {
      inputs.push(this.getPasswordField());
    }

    if (this.settings.get('features.rememberMe')) {
      inputs.push(this.getRemeberMeCheckbox());
    }

    return inputs;
  },
  getUsernameField: function getUsernameField() {
    var _this = this;

    var userNameFieldObject = {
      className: 'margin-btm-5',
      label: (0, _okta.loc)('primaryauth.username.placeholder', 'login'),
      'label-top': true,
      explain: function explain() {
        if (!_this.isCustomized('primaryauth.username.tooltip')) {
          return false;
        }

        return _Util.default.createInputExplain('primaryauth.username.tooltip', 'primaryauth.username.placeholder', 'login');
      },
      'explain-top': true,
      name: 'username',
      input: _TextBox.default,
      inputId: 'okta-signin-username',
      type: 'text',
      disabled: this.options.appState.get('disableUsername'),
      autoComplete: 'username',
      // TODO: support a11y attrs in Courage - OKTA-279025
      render: function render() {
        this.$("input[name=".concat(this.options.name, "]")).prop('required', true);
      }
    };
    return userNameFieldObject;
  },
  getPasswordField: function getPasswordField() {
    var _this2 = this;

    var passwordFieldObject = {
      className: 'margin-btm-30',
      label: (0, _okta.loc)('primaryauth.password.placeholder', 'login'),
      'label-top': true,
      explain: function explain() {
        if (!_this2.isCustomized('primaryauth.password.tooltip')) {
          return false;
        }

        return _Util.default.createInputExplain('primaryauth.password.tooltip', 'primaryauth.password.placeholder', 'login');
      },
      'explain-top': true,
      name: 'password',
      inputId: 'okta-signin-password',
      validateOnlyIfDirty: true,
      type: 'password',
      autoComplete: 'current-password',
      // TODO: support a11y attrs in Courage - OKTA-279025
      render: function render() {
        this.$("input[name=".concat(this.options.name, "]")).prop('required', true);
      }
    };

    if (this.settings.get('features.showPasswordToggleOnSignInPage')) {
      passwordFieldObject.params = {};
      passwordFieldObject.params.showPasswordToggle = true;
    }

    return passwordFieldObject;
  },
  isCustomized: function isCustomized(property) {
    var language = this.settings.get('language');
    var i18n = this.settings.get('i18n');
    var customizedProperty = i18n && i18n[language] && i18n[language][property];
    return !!customizedProperty;
  },
  getRemeberMeCheckbox: function getRemeberMeCheckbox() {
    return {
      label: false,
      placeholder: (0, _okta.loc)('remember', 'login'),
      name: 'remember',
      type: 'checkbox',
      'label-top': true,
      className: 'margin-btm-0',
      initialize: function initialize() {
        this.listenTo(this.model, 'change:remember', function (model, val) {
          // OKTA-98946: We normally re-render on changes to model values,
          // but in this case we will manually update the checkbox due to
          // iOS Safari and how it handles autofill - it will autofill the
          // form anytime the dom elements are re-rendered, which prevents
          // the user from editing their username.
          this.$(':checkbox').prop('checked', val).trigger('updateState');
        });
      }
    };
  },
  focus: function focus() {
    if (!this.model.get('username')) {
      this.getInputs().first().focus();
    } else if (!this.settings.get('features.passwordlessAuth')) {
      this.getInputs().toArray()[1].focus();
    }

    if (this.settings.get('features.trackTypingPattern')) {
      _TypingUtil.default.track('okta-signin-username');
    }
  }
});

exports.default = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1174);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"password-requirements--header\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "password.complexity.requirements.header"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 133
          }
        }
      })) + "</div><ul class=\"password-requirements--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
        "name": "each",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 179
          },
          "end": {
            "line": 1,
            "column": 268
          }
        }
      })) != null ? stack1 : "") + "</ul>";
    },
    "2": function _(container, depth0, helpers, partials, data) {
      return "<li class=\"password-requirements--list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 280
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  attributes: {
    'data-se': 'password-requirements-html'
  },
  allRequirements: [],
  initialize: function initialize(options) {
    var policy = options.policy;

    if (!policy) {
      return;
    }

    this.allRequirements = _FactorUtil.default.getPasswordComplexityDescriptionForHtmlList(policy);
  },
  getTemplateData: function getTemplateData() {
    return {
      requirements: this.allRequirements
    };
  }
});

exports.default = _default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(507);
__webpack_require__(1217);
// TODO: Remove from `core-js@4`
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(1220);

module.exports = parent;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(__webpack_require__(40));

var _lastIndexOf = _interopRequireDefault(__webpack_require__(455));

var _keys = _interopRequireDefault(__webpack_require__(117));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _keys2 = _interopRequireDefault(__webpack_require__(324));

var _bind = _interopRequireDefault(__webpack_require__(27));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _config = _interopRequireDefault(__webpack_require__(238));

var _q = _interopRequireDefault(__webpack_require__(43));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _IDP = _interopRequireDefault(__webpack_require__(549));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _CountryUtil = _interopRequireDefault(__webpack_require__(157));

/* eslint max-statements: [2, 22],  complexity: [2, 12] */

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var SharedUtil = _okta.internal.util.Util;
var DEFAULT_LANGUAGE = 'en';
var ConfigError = _Errors.default.ConfigError;
var UnsupportedBrowserError = _Errors.default.UnsupportedBrowserError;

var assetBaseUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "https://global.oktacdn.com/okta-signin-widget/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "version") || (depth0 != null ? lookupProperty(depth0, "version") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "version",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 46
        },
        "end": {
          "line": 1,
          "column": 57
        }
      }
    }) : helper));
  },
  "useData": true
});

var _default = _okta.Model.extend({
  authClient: undefined,
  local: {
    baseUrl: ['string', true],
    recoveryToken: ['string', false, undefined],
    stateToken: ['string', false, undefined],
    username: ['string', false],
    signOutLink: ['string', false],
    relayState: ['string', false],
    redirect: {
      type: 'string',
      values: ['never', 'always', 'auto'],
      value: 'auto'
    },
    // Function to transform the username before passing it to the API
    // for Primary Auth, Forgot Password and Unlock Account.
    transformUsername: ['function', false],
    // CALLBACKS
    globalSuccessFn: 'function',
    globalErrorFn: 'function',
    processCreds: 'function',
    // IMAGES
    logo: 'string',
    logoText: ['string', false],
    helpSupportNumber: 'string',
    // IDX API VERSION
    apiVersion: ['string', true, '1.0.0'],
    // <OIE>
    // attribute to hold proxy (fake) idx response
    // to render static pages without initiating idx pipeline
    proxyIdxResponse: ['object', false],
    // <OIE>
    // By default, state handle will be saved to session storage
    // and will be clear when terminal error or success redirect.
    // Set this flag to true if you want to override this behavior.
    // a.k.a dishonor the state handle stored in session storage.
    overrideExistingStateToken: ['boolean', false, false],
    // FEATURES
    'features.router': ['boolean', true, false],
    'features.securityImage': ['boolean', true, false],
    'features.rememberMe': ['boolean', true, true],
    'features.autoPush': ['boolean', true, false],
    'features.smsRecovery': ['boolean', true, false],
    'features.callRecovery': ['boolean', true, false],
    'features.emailRecovery': ['boolean', false, true],
    'features.webauthn': ['boolean', true, false],
    'features.selfServiceUnlock': ['boolean', true, false],
    'features.multiOptionalFactorEnroll': ['boolean', true, false],
    'features.deviceFingerprinting': ['boolean', false, false],
    'features.hideSignOutLinkInMFA': ['boolean', false, false],
    'features.hideBackToSignInForReset': ['boolean', false, false],
    'features.customExpiredPassword': ['boolean', true, false],
    'features.registration': ['boolean', false, false],
    'features.idpDiscovery': ['boolean', false, false],
    'features.passwordlessAuth': ['boolean', false, false],
    'features.showPasswordToggleOnSignInPage': ['boolean', false, false],
    'features.trackTypingPattern': ['boolean', false, false],
    'features.redirectByFormSubmit': ['boolean', false, false],
    'features.useDeviceFingerprintForSecurityImage': ['boolean', false, true],
    'features.showPasswordRequirementsAsHtmlList': ['boolean', false, false],
    'features.mfaOnlyFlow': ['boolean', false, false],
    'features.scrollOnError': ['boolean', false, true],
    defaultCountryCode: ['string', false, 'US'],
    // I18N
    language: ['any', false],
    // Can be a string or a function
    i18n: ['object', false],
    // ASSETS
    'assets.baseUrl': ['string', false],
    'assets.rewrite': {
      type: 'function',
      value: _okta._.identity
    },
    // OAUTH2
    clientId: 'string',
    redirectUri: 'string',
    state: 'string',
    scopes: 'array',
    codeChallenge: 'string',
    codeChallengeMethod: ['string', false],
    oAuthTimeout: ['number', false],
    authScheme: ['string', false, 'OAUTH2'],
    // External IdPs
    idps: ['array', false, []],
    idpDisplay: {
      type: 'string',
      values: ['PRIMARY', 'SECONDARY'],
      value: 'SECONDARY'
    },
    // HELP LINKS
    'helpLinks.help': 'string',
    'helpLinks.forgotPassword': 'string',
    'helpLinks.unlock': 'string',
    'helpLinks.custom': 'array',
    'helpLinks.factorPage.href': 'string',
    'helpLinks.factorPage.text': 'string',
    //Custom Buttons
    customButtons: ['array', false, []],
    //Registration
    policyId: 'string',
    'registration.click': 'function',
    'registration.parseSchema': 'function',
    'registration.preSubmit': 'function',
    'registration.postSubmit': 'function',
    //Consent
    'consent.cancel': 'function',
    //IDP Discovery
    'idpDiscovery.requestContext': 'string',
    //Colors
    'colors.brand': 'string',
    //Descriptions
    brandName: 'string',
    //PIV
    piv: ['object', false, {}]
  },
  derived: {
    showPasswordToggle: {
      deps: ['features.showPasswordToggleOnSignInPage'],
      fn: function fn() {
        var _this$options$feature, _this$options, _this$options$feature2, _this$options2;

        // showPasswordToggle is for OIE only.
        // Used to default showPasswordToggleOnSignInPage to true.
        var defaultValue = true;
        var customizedValue = (_this$options$feature = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$feature2 = _this$options.features) === null || _this$options$feature2 === void 0 ? void 0 : _this$options$feature2.showPasswordToggleOnSignInPage) !== null && _this$options$feature !== void 0 ? _this$options$feature : (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2['features.showPasswordToggleOnSignInPage'];
        return customizedValue !== null && customizedValue !== void 0 ? customizedValue : defaultValue;
      },
      cache: true
    },
    redirectUtilFn: {
      deps: ['features.redirectByFormSubmit'],
      fn: function fn(redirectByFormSubmit) {
        var _context, _context2;

        return redirectByFormSubmit ? (0, _bind.default)(_context = _Util.default.redirectWithFormGet).call(_context, _Util.default) : (0, _bind.default)(_context2 = SharedUtil.redirect).call(_context2, SharedUtil);
      },
      cache: true
    },
    supportedLanguages: {
      deps: ['i18n'],
      fn: function fn(i18n) {
        // Developers can pass in their own languages
        return _okta._.union(_config.default.supportedLanguages, (0, _keys2.default)(_okta._).call(_okta._, i18n));
      },
      cache: true
    },
    languageCode: {
      deps: ['language', 'supportedLanguages'],
      fn: function fn(language, supportedLanguages) {
        var userLanguages = _BrowserFeatures.default.getUserLanguages();

        var preferred = _okta._.clone(userLanguages);

        var supportedLowerCase = _Util.default.toLower(supportedLanguages);

        var expanded; // Any developer defined "language" takes highest priority:
        // As a string, i.e. 'en', 'ja', 'zh-CN'

        if (_okta._.isString(language)) {
          preferred.unshift(language);
        } else if (_okta._.isFunction(language)) {
          // As a callback function, which is passed the list of supported
          // languages and detected user languages. This function must return
          // a languageCode, i.e. 'en', 'ja', 'zh-CN'
          preferred.unshift(language(supportedLanguages, userLanguages));
        } // Add english as the default, and expand to include any language
        // codes that do not include region, dialect, etc.


        preferred.push(DEFAULT_LANGUAGE);
        expanded = _Util.default.toLower(_Util.default.expandLanguages(preferred)); // Perform a case insensitive search - this is necessary in the case
        // of browsers like Safari

        var i;
        var supportedPos;

        for (i = 0; i < expanded.length; i++) {
          supportedPos = (0, _indexOf.default)(supportedLowerCase).call(supportedLowerCase, expanded[i]);

          if (supportedPos > -1) {
            return supportedLanguages[supportedPos];
          }
        }
      }
    },
    countryCode: {
      deps: ['defaultCountryCode'],
      fn: function fn(defaultCountryCode) {
        var _context3;

        var countries = _CountryUtil.default.getCountries();

        return (0, _includes.default)(_context3 = (0, _keys.default)(countries)).call(_context3, defaultCountryCode) ? defaultCountryCode : 'US';
      }
    },
    mode: {
      deps: ['useInteractionCodeFlow', 'codeChallenge'],
      fn: function fn(useInteractionCodeFlow, codeChallenge) {
        if (useInteractionCodeFlow && codeChallenge) {
          return 'remediation';
        }

        return 'relying-party';
      }
    },
    oauth2Enabled: {
      deps: ['clientId', 'authScheme'],
      fn: function fn(clientId, authScheme) {
        return !!clientId && authScheme.toLowerCase() === 'oauth2';
      },
      cache: true
    },
    oieEnabled: {
      deps: ['stateToken', 'proxyIdxResponse', 'useInteractionCodeFlow'],
      fn: function fn(stateToken, proxyIdxResponse, useInteractionCodeFlow) {
        return stateToken || proxyIdxResponse || useInteractionCodeFlow;
      },
      cache: true
    },
    // Redirect Uri to provide in the oauth API
    oauthRedirectUri: {
      deps: ['redirectUri'],
      fn: function fn(redirectUri) {
        if (redirectUri) {
          return redirectUri;
        }

        var origin = window.location.origin; // IE8

        if (!origin) {
          var href = window.location.href;
          var path = window.location.pathname;

          if (path !== '') {
            origin = href.substring(0, (0, _lastIndexOf.default)(href).call(href, path));
          }
        }

        return encodeURI(origin);
      }
    },
    // Adjusts the idps passed into the widget based on if they get explicit support
    configuredSocialIdps: {
      deps: ['idps'],
      fn: function fn(idps) {
        return (0, _map.default)(_okta._).call(_okta._, idps, function (idpConfig) {
          var idp = _okta._.clone(idpConfig);

          var type = idp.type && idp.type.toLowerCase();

          if (!(type && _okta._.contains(_IDP.default.SUPPORTED_SOCIAL_IDPS, type))) {
            type = 'general-idp';
            idp.text = idp.text || '{ Please provide a text value }';
          }

          idp.className = ['social-auth-button', 'social-auth-' + type + '-button ', idp.className ? idp.className : ''].join(' ');
          idp.dataAttr = 'social-auth-' + type + '-button';
          idp.i18nKey = 'socialauth.' + type + '.label';
          return idp;
        });
      },
      cache: true
    },
    // Can support piv authentication
    hasPivCard: {
      deps: ['piv'],
      fn: function fn(piv) {
        return piv && piv.certAuthUrl;
      },
      cache: true
    },
    // social auth buttons order - 'above'/'below' the primary auth form (boolean)
    socialAuthPositionTop: {
      deps: ['configuredSocialIdps', 'hasPivCard', 'idpDisplay'],
      fn: function fn(configuredSocialIdps, hasPivCard, idpDisplay) {
        return (!_okta._.isEmpty(configuredSocialIdps) || hasPivCard) && idpDisplay.toUpperCase() === 'PRIMARY';
      },
      cache: true
    },
    hasConfiguredButtons: {
      deps: ['configuredSocialIdps', 'customButtons', 'hasPivCard'],
      fn: function fn(configuredSocialIdps, customButtons, hasPivCard) {
        return !_okta._.isEmpty(configuredSocialIdps) || !_okta._.isEmpty(customButtons) || hasPivCard;
      },
      cache: true
    }
  },
  initialize: function initialize(options) {
    if (!options.baseUrl) {
      this.callGlobalError(new ConfigError((0, _okta.loc)('error.required.baseUrl')));
    } else if (options.colors && _okta._.isString(options.colors.brand) && !options.colors.brand.match(/^#[0-9A-Fa-f]{6}$/)) {
      this.callGlobalError(new ConfigError((0, _okta.loc)('error.invalid.colors.brand')));
    } else if (_BrowserFeatures.default.corsIsNotSupported()) {
      this.callGlobalError(new UnsupportedBrowserError((0, _okta.loc)('error.unsupported.cors')));
    }
  },
  setAcceptLanguageHeader: function setAcceptLanguageHeader(authClient) {
    if (authClient && authClient.options && authClient.options.headers) {
      authClient.options.headers['Accept-Language'] = this.get('languageCode');
    }
  },
  setAuthClient: function setAuthClient(authClient) {
    this.setAcceptLanguageHeader(authClient);
    this.authClient = authClient;
  },
  getAuthClient: function getAuthClient() {
    return this.authClient;
  },
  set: function set() {
    try {
      return _okta.Model.prototype.set.apply(this, arguments);
    } catch (e) {
      var message = e.message ? e.message : e;
      this.callGlobalError(new ConfigError(message));
    }
  },
  // Invokes the global success function. This should only be called on a
  // terminal part of the code (i.e. authStatus SUCCESS or after sending
  // a recovery email)
  callGlobalSuccess: function callGlobalSuccess(status, data) {
    var res = _okta._.extend(data, {
      status: status
    }); // Defer this to ensure that our functions have rendered completely
    // before invoking their function


    _okta._.defer(_okta._.partial(this.get('globalSuccessFn'), res));
  },
  // Invokes the global error function. This should only be called on non
  // recoverable errors (i.e. configuration errors, browser unsupported
  // errors, etc)
  callGlobalError: function callGlobalError(err) {
    var globalErrorFn = this.get('globalErrorFn') || this.options.globalErrorFn; // Note: Must use "this.options.globalErrorFn" when they've passed invalid
    // arguments - globalErrorFn will not have been set yet

    if (globalErrorFn) {
      globalErrorFn(err);
    } else {
      // Only throw the error if they have not registered a globalErrorFn
      throw err;
    }
  },
  // Get the username by applying the transform function if it exists.
  transformUsername: function transformUsername(username, operation) {
    var transformFn = this.get('transformUsername');

    if (transformFn && _okta._.isFunction(transformFn)) {
      return transformFn(username, operation);
    }

    return username;
  },
  processCreds: function processCreds(creds) {
    var processCreds = this.get('processCreds');
    return _q.default.Promise(function (resolve) {
      if (!_okta._.isFunction(processCreds)) {
        resolve();
      } else if (processCreds.length === 2) {
        processCreds(creds, resolve);
      } else {
        processCreds(creds);
        resolve();
      }
    });
  },
  parseRegistrationSchema: function parseRegistrationSchema(schema, onSuccess, onFailure) {
    var parseSchema = this.get('registration.parseSchema'); //check for parseSchema callback

    if (_okta._.isFunction(parseSchema)) {
      parseSchema(schema, function (schema) {
        onSuccess(schema);
      }, function (error) {
        error = error || {
          errorSummary: (0, _okta.loc)('registration.default.callbackhook.error')
        };
        error['callback'] = 'parseSchema';
        onFailure(error);
      });
    } else {
      //no callback
      onSuccess(schema);
    }
  },
  preRegistrationSubmit: function preRegistrationSubmit(postData, onSuccess, onFailure) {
    var preSubmit = this.get('registration.preSubmit'); //check for preSubmit callback

    if (_okta._.isFunction(preSubmit)) {
      preSubmit(postData, function (postData) {
        onSuccess(postData);
      }, function (error) {
        error = error || {
          errorSummary: (0, _okta.loc)('registration.default.callbackhook.error')
        };
        error['callback'] = 'preSubmit';
        onFailure(error);
      });
    } else {
      //no callback
      onSuccess(postData);
    }
  },
  postRegistrationSubmit: function postRegistrationSubmit(response, onSuccess, onFailure) {
    var postSubmit = this.get('registration.postSubmit'); //check for postSubmit callback

    if (_okta._.isFunction(postSubmit)) {
      postSubmit(response, function (response) {
        onSuccess(response);
      }, function (error) {
        error = error || {
          errorSummary: (0, _okta.loc)('registration.default.callbackhook.error')
        };
        error['callback'] = 'postSubmit';
        onFailure(error);
      });
    } else {
      //no callback
      onSuccess(response);
    }
  },
  // Use the parse function to transform config options to the standard
  // settings we currently support. This is a good place to deprecate old
  // option formats.
  parse: function parse(options) {
    if (options.labels || options.country) {
      _Logger.default.deprecate('Use "i18n" instead of "labels" and "country"');

      var overrides = options.labels || {};

      _okta._.each(options.country, function (val, key) {
        overrides['country.' + key] = val;
      }); // Old behavior is to treat the override as a global override, so we
      // need to add these overrides to each language


      options.i18n = {};

      _okta._.each(_config.default.supportedLanguages, function (language) {
        options.i18n[language] = overrides;
      });

      delete options.labels;
      delete options.country;
    } // Default the assets.baseUrl to the cdn, or remove any trailing slashes


    if (!options.assets) {
      options.assets = {};
    }

    var abu = options.assets.baseUrl;

    if (!abu) {
      options.assets.baseUrl = assetBaseUrlTpl({
        version: _config.default.version
      });
    } else if (abu[abu.length - 1] === '/') {
      options.assets.baseUrl = abu.substring(0, abu.length - 1);
    }

    return options;
  },
  isDsTheme: function isDsTheme() {
    return false;
  }
});

exports.default = _default;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var SUPPORTED_SOCIAL_IDPS = ['facebook', 'google', 'linkedin', 'microsoft', 'apple'];
var _default = {
  SUPPORTED_SOCIAL_IDPS: SUPPORTED_SOCIAL_IDPS
};
exports.default = _default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var CAN_REMOVE_BEACON_CLS = 'can-remove-beacon';

var _default = _okta.View.extend({
  tagName: 'main',
  className: 'auth-container main-container',
  id: _Enums.default.WIDGET_CONTAINER_ID,
  attributes: {
    'data-se': 'auth-container',
    tabindex: '-1'
  },
  initialize: function initialize(options) {
    this.listenTo(options.appState, 'change:beaconType', function (model, type) {
      this.$el.toggleClass(CAN_REMOVE_BEACON_CLS, type === 'security');
    });
  }
});

exports.default = _default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Animations = _interopRequireDefault(__webpack_require__(247));

var _LoadingBeacon = _interopRequireDefault(__webpack_require__(1227));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var NO_BEACON_CLS = 'no-beacon';
var LOADING_BEACON_CLS = 'beacon-small beacon-loading';

function isLoadingBeacon(beacon) {
  return beacon && beacon.equals(_LoadingBeacon.default);
}

function removeBeacon(view) {
  // There are some timing issues with removing beacons (i.e. the case of
  // transitioning from loadingBeacon -> loadingBeacon)
  if (!view.currentBeacon) {
    return;
  }

  view.currentBeacon.remove();
  view.currentBeacon = null;
}

function addBeacon(view, NextBeacon, selector, options) {
  view.add(NextBeacon, {
    selector: selector,
    options: options
  });
  view.currentBeacon = view.first();
}

function typeOfTransition(currentBeacon, NextBeacon, options) {
  if (!currentBeacon && !NextBeacon) {
    return 'none';
  } // Show Loading beacon


  if (!currentBeacon && options.loading) {
    return 'load';
  } // Swap/Hide Loading beacon


  if (currentBeacon && isLoadingBeacon(currentBeacon)) {
    return NextBeacon ? 'swap' : 'unload';
  }

  if (currentBeacon && currentBeacon.equals(NextBeacon, options)) {
    return 'same';
  }

  if (!currentBeacon && NextBeacon) {
    return 'add';
  }

  if (currentBeacon && !NextBeacon) {
    return 'remove';
  }

  if (currentBeacon instanceof NextBeacon) {
    return 'fade';
  } // If none of the above
  // then we are changing the type of beacon
  // ex. from SecurityBeacon to FactorBeacon


  return 'swap';
}

var _default = _okta.View.extend({
  currentBeacon: null,

  /* eslint-disable @okta/okta/no-unlocalized-text-in-templates */
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<img src=\"" + alias4((helper = (helper = lookupProperty(helpers, "logo") || (depth0 != null ? lookupProperty(depth0, "logo") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "logo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 67
          },
          "end": {
            "line": 1,
            "column": 75
          }
        }
      }) : helper)) + "\" class=\"auth-org-logo\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "logoText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 104
          },
          "end": {
            "line": 1,
            "column": 116
          }
        }
      }) : helper)) + " logo\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "logoText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 135
          },
          "end": {
            "line": 1,
            "column": 147
          }
        }
      }) : helper)) + " logo\">";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"okta-sign-in-header auth-header\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "logo") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 45
          },
          "end": {
            "line": 1,
            "column": 161
          }
        }
      })) != null ? stack1 : "") + "<div data-type=\"beacon-container\" class=\"beacon-container\"></div></div><div class=\"auth-content\"><div class=\"auth-content-inner\"></div></div>";
    },
    "useData": true
  }),

  /* eslint-enable @okta/okta/no-unlocalized-text-in-templates */
  // Attach a 'no-beacon' class if the security image feature
  // is not passed in to prevent the beacon from jumping.
  initialize: function initialize(options) {
    if (!options.settings.get('features.securityImage')) {
      this.$el.addClass(NO_BEACON_CLS); // To show/hide the spinner when there is no security image,
      // listen to the appState's loading/removeLoading events.

      this.listenTo(options.appState, 'loading', this.setLoadingBeacon);
      this.listenTo(options.appState, 'removeLoading', this.removeLoadingBeacon);
    }
  },

  /* eslint complexity: 0 */
  setBeacon: function setBeacon(NextBeacon, options) {
    var selector = '[data-type="beacon-container"]';
    var container = this.$(selector);
    var transition = typeOfTransition(this.currentBeacon, NextBeacon, options);
    var self = this;

    switch (transition) {
      case 'none':
        this.$el.addClass(NO_BEACON_CLS);
        return;

      case 'same':
        return;

      case 'add':
        this.$el.removeClass(NO_BEACON_CLS);
        addBeacon(this, NextBeacon, selector, options);
        return _Animations.default.explode(container);

      case 'remove':
        this.$el.addClass(NO_BEACON_CLS);
        return _Animations.default.implode(container).then(function () {
          removeBeacon(self);
        }).done();
      // TODO: can this be removed if Animations.implode returns standard ES6 Promise?

      case 'fade':
        // Other transitions are performed on the beacon container,
        // but this transition is on the content inside the beacon.
        // For a SecurityBeacon the username change will update the
        // AppState and trigger an transition to a new Becon
        // Since there is no url change this method is not called.
        // For a FactorBeacon a page refresh has occurred
        // so we execute the beacon's own transition method.
        if (!this.currentBeacon.fadeOut) {
          throw new Error('The current beacon is missing the "fadeOut" method');
        }

        options.animate = true;
        return this.currentBeacon.fadeOut().then(function () {
          removeBeacon(self);
          addBeacon(self, NextBeacon, selector, options);
        }).done();
      // TODO: can this be removed if fadeOut returns standard ES6 Promise?

      case 'swap':
        return _Animations.default.swapBeacons({
          $el: container,
          swap: function swap() {
            var isLoading = isLoadingBeacon(self.currentBeacon); // Order of these calls is important for -
            // loader --> security/factor beacon swap.

            removeBeacon(self);

            if (isLoading) {
              container.removeClass(LOADING_BEACON_CLS);
              self.$el.removeClass(NO_BEACON_CLS);
            }

            addBeacon(self, NextBeacon, selector, options);
          }
        }).done();
      // TODO: can this be removed if Animations.swapBeacons returns standard ES6 Promise?

      case 'load':
        // Show the loading beacon. Add a couple of classes
        // before triggering the add beacon code.
        container.addClass(LOADING_BEACON_CLS);
        addBeacon(self, NextBeacon, selector, options);
        return _Animations.default.explode(container);

      case 'unload':
        // Hide the loading beacon.
        return this.removeLoadingBeacon();

      default:
        throw new Error('the "' + transition + '" is not recognized');
    }
  },
  // Show the loading beacon when the security image feature is not enabled.
  setLoadingBeacon: function setLoadingBeacon(isLoading) {
    if (!isLoading || isLoadingBeacon(this.currentBeacon)) {
      return;
    }

    this.setBeacon(_LoadingBeacon.default, {
      loading: true
    });
  },
  // Hide the beacon on primary auth failure. On primary auth success, setBeacon does this job.
  removeLoadingBeacon: function removeLoadingBeacon() {
    var self = this;
    var container = this.$('[data-type="beacon-container"]');
    return _Animations.default.implode(container).then(function () {
      removeBeacon(self);
      container.removeClass(LOADING_BEACON_CLS);
    }).done(); // TODO: can this be removed if Animations.implode returns standard ES6 Promise?
  },
  getTemplateData: function getTemplateData() {
    return this.settings.toJSON({
      verbose: true
    });
  },
  getContentEl: function getContentEl() {
    return this.$('.auth-content-inner');
  }
});

exports.default = _default;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _find = _interopRequireDefault(__webpack_require__(13));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Animations = _interopRequireDefault(__webpack_require__(247));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function setBackgroundImage(el, appState) {
  var imgSrc = appState.get('securityImage');
  var imgDescription = appState.get('securityImageDescription');
  var isUndefinedUser = appState.get('isUndefinedUser');
  var isNewUser = appState.get('isNewUser');
  var isSecurityImage = !isUndefinedUser && !isNewUser; // NOTE: The imgSrc is returned by the server so that every
  // user has a unique image. However new and undefined user states
  // are hard coded into the css and the value returned by the server
  // is ignored.

  el.css('background-image', '');
  el.removeClass('new-user undefined-user');

  if (isNewUser) {
    el.addClass('new-user');
    return;
  }

  if (isUndefinedUser) {
    el.addClass('undefined-user');
    return;
  }

  if (isSecurityImage) {
    // TODO: Newer versions of qtip will remove aria-describedby on their own when destroy() is called.
    el.removeAttr('aria-describedby');
    (0, _find.default)(el).call(el, '.accessibility-text').text(imgDescription);
    el.css('background-image', 'url(' + _okta._.escape(imgSrc) + ')');
    return;
  }
}

function antiPhishingMessage(image, host) {
  (0, _okta.$)(window).on('resize.securityBeaconQtip', _okta._.debounce(function () {
    if (image.is(':visible')) {
      image.qtip('show');
    }
  }, 300)); // Show the message that the user has not logged in from this device before.

  image.qtip({
    prerender: true,
    content: {
      text: (0, _okta.loc)('primaryauth.newUser.tooltip', 'login', [_okta._.escape(host)]),
      button: (0, _okta.loc)('primaryauth.newUser.tooltip.close', 'login')
    },
    style: {
      classes: 'okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded',
      tip: {
        height: 12,
        width: 16
      }
    },
    position: {
      my: 'top center',
      at: 'center',
      target: (0, _okta.$)('.auth-beacon-security'),
      adjust: {
        method: 'flip',
        scroll: false,
        resize: true
      },
      effect: false
    },
    hide: {
      event: false,
      fixed: true
    },
    show: {
      event: false,
      delay: 200
    },
    events: {
      move: function move(event, api) {
        if (!api.elements.target.is(':visible')) {
          // Have to hide it immediately, with no effect
          api.set('hide.effect', false);
          api.hide();
          api.set('hide.effect', true);
        }
      }
    }
  }); // It is necessary to delay toggle to the next render cycle, since qtip internally defers some setup tasks.

  (0, _setTimeout2.default)(function () {
    image.qtip('toggle', image.is(':visible'));
  }, 0);
}

function destroyAntiPhishingMessage(image) {
  image.qtip('destroy');
  (0, _okta.$)(window).off('resize.securityBeaconQtip');
}

function updateSecurityImage(_x, _x2, _x3) {
  return _updateSecurityImage.apply(this, arguments);
}

function _updateSecurityImage() {
  _updateSecurityImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee($el, appState, animate) {
    var image, border, hasBorder, hasAntiPhishing, radialProgressBar, host, duration;
    return _regenerator.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            image = (0, _find.default)($el).call($el, '.auth-beacon-security');
            border = (0, _find.default)($el).call($el, '.js-auth-beacon-border');
            hasBorder = !appState.get('isUndefinedUser');
            hasAntiPhishing = appState.get('isNewUser');
            radialProgressBar = (0, _find.default)($el).call($el, '.radial-progress-bar');
            host = appState.get('baseUrl').match(/https?:\/\/(.[^/]+)/)[1];
            duration = 200;

            if (animate) {
              _context2.next = 11;
              break;
            }

            // Do not animate the security beacon
            // This occurs when initializing the form
            setBackgroundImage(image, appState);
            border.toggleClass('auth-beacon-border', hasBorder);
            return _context2.abrupt("return");

          case 11:
            destroyAntiPhishingMessage(image); // Animate loading the security beacon

            if (hasBorder) {
              _context2.next = 16;
              break;
            }

            // This occurrs when appState username is blank
            // we do not yet know if the user is recognized
            image.fadeOut(duration, function () {
              setBackgroundImage(image, appState);
              border.removeClass('auth-beacon-border');
              image.fadeIn(duration);
            });
            _context2.next = 21;
            break;

          case 16:
            // Animate loading the security beacon with a loading bar for the border
            // This occurrs when the username has been checked against Okta.
            border.removeClass('auth-beacon-border');
            _context2.next = 19;
            return _Animations.default.radialProgressBar({
              $el: radialProgressBar,
              swap: function swap() {
                image.fadeOut(duration, function () {
                  setBackgroundImage(image, appState);
                  image.fadeIn(duration);
                });
              }
            });

          case 19:
            border.addClass('auth-beacon-border');

            if (hasAntiPhishing) {
              antiPhishingMessage(image, host);
            }

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _updateSecurityImage.apply(this, arguments);
}

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"beacon-blank\"><div class=\"radial-progress-bar\"><div class=\"circle left\"></div><div class=\"circle right\"></div></div></div><div aria-live=\"polite\" role=\"img\" class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"security-beacon\"><span class=\"accessibility-text\"></span><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
    },
    "useData": true
  }),
  className: 'js-security-beacon',
  initialize: function initialize(options) {
    this.update = _okta._.partial(updateSecurityImage, this.$el, options.appState);
    this.listenTo(options.appState, 'change:securityImage', this.update);
    this.listenTo(options.appState, 'loading', function (isLoading) {
      this.$el.toggleClass('beacon-loading', isLoading);
      this.removeAntiPhishingMessage();
    });
    this.options.appState.set('beaconType', 'security');
    this.listenTo(options.appState, 'navigate', this.removeAntiPhishingMessage);
  },
  postRender: function postRender() {
    this.update(false);
  },
  equals: function equals(Beacon) {
    return Beacon && this instanceof Beacon;
  },
  removeAntiPhishingMessage: function removeAntiPhishingMessage() {
    var _context;

    var image = (0, _find.default)(_context = this.$el).call(_context, '.auth-beacon-security');
    image.qtip('destroy');
  }
});

exports.default = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _parseInt2 = _interopRequireDefault(__webpack_require__(323));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var fn = {};

var template = function template(colors) {
  var _context, _context2;

  return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "\n#okta-sign-in.auth-container .button-primary,\n#okta-sign-in.auth-container .button-primary:active,\n#okta-sign-in.auth-container .button-primary:focus { background: ".concat(colors.brand, "; }\n#okta-sign-in.auth-container .button-primary:hover { background: ")).call(_context2, fn.lighten(colors.brand, 0.05), "; }\n#okta-sign-in.auth-container .button.button-primary.link-button-disabled {\n  background: ")).call(_context, colors.brand, ";\n  opacity: 0.5;\n}\n    ");
}; // visible for testing


fn.lighten = function (hex, lum) {
  lum = lum || 0;
  hex = hex.substr(1);
  var newHex = '#';

  for (var i = 0; i < 3; i++) {
    var c = (0, _parseInt2.default)(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    newHex += ('00' + c).substr(c.length);
  }

  return newHex;
};

fn.addStyle = function (colors) {
  var css = template(colors);
  var main = document.getElementById(_Enums.default.WIDGET_CONTAINER_ID);
  var style = document.createElement('style');
  style.id = _Enums.default.WIDGET_CONFIG_COLORS_ID;
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  main.appendChild(style);
};

fn.isLoaded = function () {
  return !!document.getElementById(_Enums.default.WIDGET_CONFIG_COLORS_ID);
};

var _default = fn;
exports.default = _default;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createOVOptions = createOVOptions;
exports.default = createUiSchemaForObject;

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _reduce = _interopRequireDefault(__webpack_require__(140));

var _map = _interopRequireDefault(__webpack_require__(40));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _splice = _interopRequireDefault(__webpack_require__(154));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _findIndex = _interopRequireDefault(__webpack_require__(153));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(160));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Example of the option like
 * @param {AuthenticatorOption[]} options
 * @param {( AuthenticatorEnrollment[] || Authenticator[] )} authenticators
 */
function createOVOptions() {
  var _ovItem$value, _ovItem$value$form, _ovItem$value$form$va;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Split OV into individual entries for verification (one for each method).
  var ovItem = (0, _find.default)(options).call(options, function (option) {
    return option.relatesTo.key === _RemediationConstants.AUTHENTICATOR_KEY.OV;
  });
  var methodTypeObj = ovItem === null || ovItem === void 0 ? void 0 : (_ovItem$value = ovItem.value) === null || _ovItem$value === void 0 ? void 0 : (_ovItem$value$form = _ovItem$value.form) === null || _ovItem$value$form === void 0 ? void 0 : (_ovItem$value$form$va = _ovItem$value$form.value) === null || _ovItem$value$form$va === void 0 ? void 0 : (0, _find.default)(_ovItem$value$form$va).call(_ovItem$value$form$va, function (v) {
    return v.name === 'methodType';
  });
  var methodOptions = methodTypeObj === null || methodTypeObj === void 0 ? void 0 : methodTypeObj.options;
  var signedNonceOption;

  if (methodOptions) {
    var _spliceInstanceProper, _context2;

    var ovOptions = [];
    (0, _forEach.default)(methodOptions).call(methodOptions, function (method) {
      var _context;

      // get value object from the ov item
      var value = (0, _toConsumableArray2.default)(ovItem.value.form.value); // get index of the methodType object within the value object

      var methodTypeIndex = (0, _findIndex.default)(_context = ovItem.value.form.value).call(_context, function (v) {
        return v.name === 'methodType';
      }); // create a new methodType object that removes the options array and
      // has a value of the current method

      var newMethodTypeObj = (0, _assign.default)(_okta._.omit(methodTypeObj, 'options'), method); // set the methodType field to be required and immutable in our UI,
      // so it is always sent to the backend.

      newMethodTypeObj.required = true;
      newMethodTypeObj.mutable = false; // replace old methodType object with the new one

      (0, _splice.default)(value).call(value, methodTypeIndex, 1, newMethodTypeObj); // return a new ov item for a specific method

      var newItem = (0, _assign.default)({}, ovItem, {
        label: method.label,
        value: {
          form: {
            value: value
          }
        }
      });

      if (method.value === 'signed_nonce') {
        signedNonceOption = newItem;
      } else {
        ovOptions.push(newItem);
      }
    });
    var ovIndex = (0, _findIndex.default)(options).call(options, function (option) {
      return option.relatesTo.key === _RemediationConstants.AUTHENTICATOR_KEY.OV;
    });

    (_spliceInstanceProper = (0, _splice.default)(options)).call.apply(_spliceInstanceProper, (0, _concat.default)(_context2 = [options, ovIndex, 1]).call(_context2, ovOptions)); // ReArrange fastpass in options based on deviceKnown


    if (signedNonceOption) {
      ovItem.relatesTo.deviceKnown ? options.unshift(signedNonceOption) : options.push(signedNonceOption);
    }
  }
}

function createAuthenticatorOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  createOVOptions(options);
  return (0, _map.default)(options).call(options, function (option) {
    var _option$value, _option$value$form, _context3, _option$relatesTo;

    var value = ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value) || []; // Each authenticator option has list of ION field.
    // Currently we only support merely selecting one of options
    // rather than pop up another page to collect extra data
    // (in order to fill value for `mutable: true; value: null` fields).
    // The only reason of such design is to simplify widget implementation
    // but could subject to change in later releases.
    // Thus only surface up fields that are `required: true; mutable: false`
    // which implies it already has `value`.

    var valueObject = (0, _reduce.default)(_context3 = (0, _filter.default)(value).call(value, function (v) {
      return v.required === true && v.mutable === false;
    })).call(_context3, function (init, v) {
      return (0, _assign.default)(init, (0, _defineProperty2.default)({}, v.name, v.value));
    }, {});
    return {
      label: option.label,
      value: valueObject,
      relatesTo: option.relatesTo,
      authenticatorKey: (_option$relatesTo = option.relatesTo) === null || _option$relatesTo === void 0 ? void 0 : _option$relatesTo.key
    };
  });
}

function getAuthenticatorsEnrollUiSchema(_ref) {
  var options = _ref.options;
  return {
    type: 'authenticatorEnrollSelect',
    options: createAuthenticatorOptions(options)
  };
}

function getAuthenticatorsVerifyUiSchema(_ref2) {
  var options = _ref2.options;
  return {
    type: 'authenticatorVerifySelect',
    options: createAuthenticatorOptions(options)
  };
}
/**
  * Create ui schema for ION field that has type 'object'.
  */


function createUiSchemaForObject(ionFormField, remediationForm, transformedResp, createUISchema, settings) {
  var uiSchema = {};

  if (ionFormField.name === 'authenticator' && (remediationForm.name === 'select-authenticator-authenticate' || remediationForm.name === 'select-authenticator-unlock-account')) {
    // 1. when `select-authenticator-authenticator`,
    // create customize type so that display authenticator list as selectable list
    (0, _assign.default)(uiSchema, getAuthenticatorsVerifyUiSchema(ionFormField));
  } else if (ionFormField.name === 'authenticator' && remediationForm.name === 'select-authenticator-enroll') {
    // 2. when `select-authenticator-enroll`,
    // create customize type so that display authenticator list as selectable list
    (0, _assign.default)(uiSchema, getAuthenticatorsEnrollUiSchema(ionFormField));
  } else if ((0, _isArray.default)(ionFormField.options)) {
    var _context4, _context5;

    // 3. For other cases, create ui schema for each `option` in order to render
    // different view for each option.
    //
    // e.g. { "name": "credentials", "type": "object", options: [ {value: {form: value:[]} ]
    uiSchema.optionsUiSchemas = (0, _map.default)(_context4 = ionFormField.options).call(_context4, function (opt) {
      return createUISchema(transformedResp, {
        value: [{
          name: ionFormField.name,
          value: opt.value
        }]
      }, settings);
    });
    uiSchema.options = (0, _map.default)(_context5 = ionFormField.options).call(_context5, function (opt, index) {
      return {
        label: opt.label,
        value: index
      };
    }); // assume (default to) use radio buttons to switch sub-schema.

    uiSchema.type = 'radio';
    uiSchema.value = '0';
    uiSchema.name = "sub_schema_local_".concat(ionFormField.name);
  }

  return uiSchema;
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$keys = __webpack_require__(117);

var _forEachInstanceProperty = __webpack_require__(17);

var _context, _context2, _context3, _context4, _context5, _context6;

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _interactionCodeFlow = __webpack_require__(1240);

_forEachInstanceProperty(_context = _Object$keys(_interactionCodeFlow)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interactionCodeFlow[key];
    }
  });
});

var _transactionMeta = __webpack_require__(332);

_forEachInstanceProperty(_context2 = _Object$keys(_transactionMeta)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _transactionMeta[key];
    }
  });
});

var _interact = __webpack_require__(556);

_forEachInstanceProperty(_context3 = _Object$keys(_interact)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interact[key];
    }
  });
});

var _introspect = __webpack_require__(595);

_forEachInstanceProperty(_context4 = _Object$keys(_introspect)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _introspect[key];
    }
  });
});

var _startLoginFlow = __webpack_require__(1325);

_forEachInstanceProperty(_context5 = _Object$keys(_startLoginFlow)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _startLoginFlow[key];
    }
  });
});

var _configIdxJsClient = __webpack_require__(1326);

_forEachInstanceProperty(_context6 = _Object$keys(_configIdxJsClient)).call(_context6, function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _configIdxJsClient[key];
    }
  });
});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.interact = interact;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _oktaIdxJs = _interopRequireDefault(__webpack_require__(333));

var _transactionMeta = __webpack_require__(332);

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)
// Begin or resume a transaction using an interactionHandle
function interact(_x) {
  return _interact.apply(this, arguments);
}

function _interact() {
  _interact = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(settings) {
    var authClient, meta, _meta, interactionHandle, codeChallenge, codeChallengeMethod, scopes, state, _authClient$options, issuer, clientId, redirectUri, version;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authClient = settings.getAuthClient();
            _context.next = 3;
            return (0, _transactionMeta.getTransactionMeta)(settings);

          case 3:
            meta = _context.sent;
            _meta = meta, interactionHandle = _meta.interactionHandle, codeChallenge = _meta.codeChallenge, codeChallengeMethod = _meta.codeChallengeMethod, scopes = _meta.scopes, state = _meta.state; // These properties are defined by global configuration

            _authClient$options = authClient.options, issuer = _authClient$options.issuer, clientId = _authClient$options.clientId, redirectUri = _authClient$options.redirectUri;
            version = settings.get('apiVersion');
            return _context.abrupt("return", _oktaIdxJs.default.start({
              // if interactionHandle is undefined here, idx will bootstrap a new interactionHandle
              interactionHandle: interactionHandle,
              version: version,
              // OAuth
              clientId: clientId,
              issuer: issuer,
              scopes: scopes,
              state: state,
              redirectUri: redirectUri,
              // PKCE code challenge: only used if interactionHandle is undefined
              codeChallenge: codeChallenge,
              codeChallengeMethod: codeChallengeMethod
            }).then(function (response) {
              // If this is a new transaction an interactionHandle was returned
              if (!interactionHandle && response.toPersist.interactionHandle) {
                meta = (0, _assign.default)({}, meta, {
                  interactionHandle: response.toPersist.interactionHandle
                });
              } // Save transaction meta so it can be resumed


              (0, _transactionMeta.saveTransactionMeta)(settings, meta); // return idx response

              return response;
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _interact.apply(this, arguments);
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);
var wellKnownSymbol = __webpack_require__(34);
var IS_PURE = __webpack_require__(87);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(190);
var $ = __webpack_require__(7);
var getBuiltIn = __webpack_require__(96);
var USE_NATIVE_URL = __webpack_require__(557);
var redefine = __webpack_require__(138);
var redefineAll = __webpack_require__(240);
var setToStringTag = __webpack_require__(106);
var createIteratorConstructor = __webpack_require__(463);
var InternalStateModule = __webpack_require__(95);
var anInstance = __webpack_require__(196);
var hasOwn = __webpack_require__(59);
var bind = __webpack_require__(115);
var classof = __webpack_require__(118);
var anObject = __webpack_require__(53);
var isObject = __webpack_require__(38);
var create = __webpack_require__(191);
var createPropertyDescriptor = __webpack_require__(129);
var getIterator = __webpack_require__(468);
var getIteratorMethod = __webpack_require__(192);
var wellKnownSymbol = __webpack_require__(34);

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(560);
var exec = __webpack_require__(342);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var getOwnPropertyDescriptor = __webpack_require__(561).f;
var createNonEnumerableProperty = __webpack_require__(201);
var redefine = __webpack_require__(335);
var setGlobal = __webpack_require__(336);
var copyConstructorProperties = __webpack_require__(1254);
var isForced = __webpack_require__(1261);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(162);
var propertyIsEnumerableModule = __webpack_require__(1251);
var createPropertyDescriptor = __webpack_require__(562);
var toIndexedObject = __webpack_require__(248);
var toPrimitive = __webpack_require__(564);
var has = __webpack_require__(163);
var IE8_DOM_DEFINE = __webpack_require__(566);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(92);
var classof = __webpack_require__(334);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(250);

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(249);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(162);
var fails = __webpack_require__(92);
var createElement = __webpack_require__(567);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var isObject = __webpack_require__(250);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(337);

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(1252);
var global = __webpack_require__(91);
var isObject = __webpack_require__(250);
var createNonEnumerableProperty = __webpack_require__(201);
var objectHas = __webpack_require__(163);
var shared = __webpack_require__(337);
var sharedKey = __webpack_require__(570);
var hiddenKeys = __webpack_require__(339);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(338);
var uid = __webpack_require__(571);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 571 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(163);
var toIndexedObject = __webpack_require__(248);
var indexOf = __webpack_require__(1258).indexOf;
var hiddenKeys = __webpack_require__(339);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(252);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(1270);
var fails = __webpack_require__(92);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(494);

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(577);

module.exports = parent;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(482);
var path = __webpack_require__(23);

module.exports = path.Object.getOwnPropertySymbols;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(579);

module.exports = parent;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1279);
var path = __webpack_require__(23);

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1280);

module.exports = parent;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1283);

module.exports = parent;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1290);

var iterableToArrayLimit = __webpack_require__(1291);

var unsupportedIterableToArray = __webpack_require__(586);

var nonIterableRest = __webpack_require__(1293);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(519);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(459);

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(469);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(587);

var _sliceInstanceProperty = __webpack_require__(1292);

var arrayLikeToArray = __webpack_require__(588);

function _unsupportedIterableToArray(o, minLen) {
  var _context;

  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);

  var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(522);

/***/ }),
/* 588 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(525);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(498);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(161));

__webpack_require__(203);

var _find = _interopRequireDefault(__webpack_require__(1296));

var _promise = _interopRequireDefault(__webpack_require__(200));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(165));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1297));

var _idxResponseParser = __webpack_require__(1301);

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var makeIdxState = function makeIdxState(idxResponse, toPersist) {
  var _rawIdxResponse$succe, _context2;

  var rawIdxResponse = idxResponse;

  var _parseIdxResponse = (0, _idxResponseParser.parseIdxResponse)(idxResponse, toPersist),
      remediations = _parseIdxResponse.remediations,
      context = _parseIdxResponse.context,
      actions = _parseIdxResponse.actions;

  var neededToProceed = (0, _toConsumableArray2.default)(remediations);

  var proceed = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(remediationChoice) {
      var paramsFromUser,
          remediationChoiceObject,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              paramsFromUser = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              /*
              remediationChoice is the name attribute on each form
              name should remain unique for items inside the remediation that are considered forms(identify, select-factor)
              name can be duplicate for items like redirect where its not considered a form(redirect)
              when names are not unique its a redirect to a href, so widget wont POST to idx-js layer.
              */
              remediationChoiceObject = (0, _find.default)(remediations).call(remediations, function (remediation) {
                return remediation.name === remediationChoice;
              });

              if (remediationChoiceObject) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", _promise.default.reject("Unknown remediation choice: [".concat(remediationChoice, "]")));

            case 4:
              return _context.abrupt("return", remediationChoiceObject.action(paramsFromUser));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function proceed(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var hasInteractionCode = function hasInteractionCode() {
    return !!rawIdxResponse.successWithInteractionCode;
  };

  var findCode = function findCode(item) {
    return item.name === 'interaction_code';
  };

  var interactionCode = (_rawIdxResponse$succe = rawIdxResponse.successWithInteractionCode) === null || _rawIdxResponse$succe === void 0 ? void 0 : (0, _find.default)(_context2 = _rawIdxResponse$succe.value).call(_context2, findCode).value;
  return {
    proceed: proceed,
    neededToProceed: neededToProceed,
    actions: actions,
    context: context,
    rawIdxState: rawIdxResponse,
    hasInteractionCode: hasInteractionCode,
    interactionCode: interactionCode,
    toPersist: toPersist
  };
};

var _default = makeIdxState;
exports.default = _default;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1303);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1311);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$keys = __webpack_require__(255);

var _Object$getOwnPropertySymbols = __webpack_require__(343);

var _filterInstanceProperty = __webpack_require__(256);

var _Object$getOwnPropertyDescriptor = __webpack_require__(344);

var _forEachInstanceProperty = __webpack_require__(202);

var _Object$getOwnPropertyDescriptors = __webpack_require__(345);

var _Object$defineProperties = __webpack_require__(346);

var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

__webpack_require__(203);

var _regenerator = _interopRequireDefault(__webpack_require__(161));

var _stringify = _interopRequireDefault(__webpack_require__(575));

var _promise = _interopRequireDefault(__webpack_require__(200));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(347));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(165));

var _client = __webpack_require__(254);

var _actionParser = __webpack_require__(1315);

var _makeIdxState = _interopRequireDefault(__webpack_require__(591));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var generateDirectFetch = function generateDirectFetch(_ref) {
  var actionDefinition = _ref.actionDefinition,
      _ref$defaultParamsFor = _ref.defaultParamsForAction,
      defaultParamsForAction = _ref$defaultParamsFor === void 0 ? {} : _ref$defaultParamsFor,
      _ref$immutableParamsF = _ref.immutableParamsForAction,
      immutableParamsForAction = _ref$immutableParamsF === void 0 ? {} : _ref$immutableParamsF,
      toPersist = _ref.toPersist;
  var target = actionDefinition.href;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(params) {
      var headers, body;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              headers = {
                'content-type': 'application/json',
                'accept': actionDefinition.accepts || 'application/ion+json'
              };
              body = (0, _stringify.default)(_objectSpread(_objectSpread(_objectSpread({}, defaultParamsForAction), params), immutableParamsForAction));
              return _context.abrupt("return", (0, _client.request)(target, {
                method: actionDefinition.method,
                headers: headers,
                body: body
              }).then(function (response) {
                var respJson = response.json();

                if (response.ok) {
                  return respJson;
                } else if (response.status === 401 && response.headers.get('WWW-Authenticate') === 'Oktadevicejwt realm="Okta Device"') {
                  // Okta server responds 401 status code with WWW-Authenticate header and new remediation
                  // so that the iOS/MacOS credential SSO extension (Okta Verify) can intercept
                  // the response reaches here when Okta Verify is not installed
                  // we need to return an idx object so that
                  // the SIW can proceed to the next step without showing error
                  return respJson.then(function (err) {
                    return _promise.default.reject((0, _makeIdxState.default)(err, toPersist));
                  });
                }

                return respJson.then(function (err) {
                  return _promise.default.reject(err);
                });
              }).then(function (idxResponse) {
                return (0, _makeIdxState.default)(idxResponse, toPersist);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}; // TODO: Resolve in M2: Either build the final polling solution or remove this code
// const generatePollingFetch = function generatePollingFetch( { actionDefinition, defaultParamsForAction = {}, immutableParamsForAction = {} } ) {
//   // TODO: Discussions ongoing about when/how to terminate polling: OKTA-246581
//   const target = actionDefinition.href;
//   return async function(params) {
//     return fetch(target, {
//       method: actionDefinition.method,
//       headers: {
//         'content-type': actionDefinition.accepts,
//       },
//       body: JSON.stringify({ ...defaultParamsForAction, ...params, ...immutableParamsForAction })
//     })
//       .then( response => response.ok ? response.json() : response.json().then( err => Promise.reject(err)) )
//       .then( idxResponse => makeIdxState(idxResponse) );
//   };
// };


var generateIdxAction = function generateIdxAction(actionDefinition, toPersist) {
  // TODO: leaving this here to see where the polling is EXPECTED to drop into the code, but removing any accidental trigger of incomplete code
  // const generator =  actionDefinition.refresh ? generatePollingFetch : generateDirectFetch;
  var generator = generateDirectFetch;

  var _divideActionParamsBy = (0, _actionParser.divideActionParamsByMutability)(actionDefinition),
      defaultParams = _divideActionParamsBy.defaultParams,
      neededParams = _divideActionParamsBy.neededParams,
      immutableParams = _divideActionParamsBy.immutableParams;

  var action = generator({
    actionDefinition: actionDefinition,
    defaultParamsForAction: defaultParams[actionDefinition.name],
    immutableParamsForAction: immutableParams[actionDefinition.name],
    toPersist: toPersist
  });
  action.neededParams = neededParams;
  return action;
};

var _default = generateIdxAction;
exports.default = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.introspect = introspect;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _oktaIdxJs = _interopRequireDefault(__webpack_require__(333));

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function introspect(_x, _x2) {
  return _introspect.apply(this, arguments);
}

function _introspect() {
  _introspect = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(settings, stateHandle) {
    var domain, version;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            domain = settings.get('baseUrl');
            version = settings.get('apiVersion');
            return _context.abrupt("return", _oktaIdxJs.default.start({
              domain: domain,
              stateHandle: stateHandle,
              version: version
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _introspect.apply(this, arguments);
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _Animations = _interopRequireDefault(__webpack_require__(247));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _default = _okta.View.extend({
  HeaderBeacon: null,
  initialize: function initialize() {
    if (this.HeaderBeacon) {
      this.add(this.HeaderBeacon);
    }
  },
  postRender: function postRender() {
    var mainContentContainer = (0, _okta.$)("#".concat(_Enums.default.WIDGET_CONTAINER_ID));

    if (this.HeaderBeacon) {
      var _context;

      mainContentContainer.removeClass('no-beacon'); // animate beacon

      var beaconContainer = (0, _find.default)(_context = this.$el).call(_context, '[data-type="beacon-container"]');

      _Animations.default.explode(beaconContainer);
    } else {
      mainContentContainer.addClass('no-beacon');
    }
  }
});

exports.default = _default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _okta = __webpack_require__(2);

var _Link = _interopRequireDefault(__webpack_require__(205));

var _ToggleTextLink = _interopRequireDefault(__webpack_require__(1333));

var _LinksUtil = __webpack_require__(122);

/**
 * When `href` is present, the Link behaviors as normal link (anchor element).
 * When `actionPath` is present, the Link behaviors as link button
 *   on which user clicks, will trigger the action `actionPath`.
 * When `formName` is present, the link behaviors as link button
 *   on which user clicks, will submit a remediation form.
 *
 * @typedef {Object} Link
 * @property {string} label
 * @property {string} name
 * @property {string=} href
 * @property {string=} actionPath
 * @property {string=} formName
 */
var _default = _okta.View.extend({
  className: 'auth-footer',

  /**
   * {Link[]} links
   */
  links: [],

  /**
   * View
   * adds any view to the footer in footer info section
   */
  footerInfo: null,

  /**
   * Boolean
   * If false then 'Back to sign in' does not get added to the view
   */
  hasBackToSignInLink: true,
  initialize: function initialize() {
    var _this = this;

    var links = _okta._.resultCtx(this, 'links', this);

    var footerInfo = _okta._.resultCtx(this, 'footerInfo', this);

    var hasBackToSignInLink = _okta._.resultCtx(this, 'hasBackToSignInLink', this); // safe check
    // 1. avoid none array from override
    // 2. ignore any none plain object arguments


    if (!(0, _isArray.default)(links)) {
      links = [];
    } else {
      links = (0, _filter.default)(links).call(links, function (l) {
        return _okta.$.isPlainObject(l);
      });
    } // add 'back to sign in' link if the form qualifies for it by default.
    // Previously called cancel/Sign Out links


    if (this.options.appState.shouldShowSignOutLinkInCurrentForm(this.options.settings.get('features.hideSignOutLinkInMFA') || this.settings.get('features.mfaOnlyFlow')) && hasBackToSignInLink) {
      links = (0, _concat.default)(links).call(links, (0, _LinksUtil.getSignOutLink)(this.options.settings));
    }

    (0, _forEach.default)(links).call(links, function (link) {
      var LinkView = _Link.default;

      if (link.type === 'toggle-text-link') {
        LinkView = _ToggleTextLink.default;
      }

      _this.add(LinkView, {
        options: link
      });
    });

    if (footerInfo) {
      this.add(_okta.View.extend({
        className: 'footer-info'
      }));
      this.add(footerInfo, '.footer-info');
    }
  }
});

exports.default = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(353));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(354));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(355));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(356));

var _keys = _interopRequireDefault(__webpack_require__(117));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(160));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(88));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _map = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(2);

var _AuthenticatorEnrollOptions = _interopRequireDefault(__webpack_require__(1334));

var _AuthenticatorVerifyOptions = _interopRequireDefault(__webpack_require__(599));

var _AuthenticatorUtil = __webpack_require__(204);

var _RemediationConstants = __webpack_require__(24);

var _IDP = _interopRequireDefault(__webpack_require__(549));

var _ScopeList = _interopRequireDefault(__webpack_require__(526));

var _ScopeList2 = _interopRequireDefault(__webpack_require__(529));

var _CaptchaView = _interopRequireDefault(__webpack_require__(1336));

var _inputCreationStrateg;

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source))).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var isTextOverflow = function isTextOverflow(text, maxWidth) {
  // Create a temporary element and attach it to the document so we can compare the client width to the 
  // max width allowed.
  var elem = document.createElement('div');
  elem.style.position = 'absolute';
  elem.style.left = '-9999px';
  elem.style.whiteSpace = 'nowrap';
  elem.innerHTML = text;
  document.body.appendChild(elem);
  var result = elem.clientWidth;
  document.body.removeChild(elem);
  return result > maxWidth;
};

var createAuthenticatorEnrollSelectView = function createAuthenticatorEnrollSelectView(opt) {
  var _context;

  var optionItems = (0, _map.default)(_context = opt.options || []).call(_context, function (opt) {
    return (0, _assign.default)({}, opt, (0, _AuthenticatorUtil.getAuthenticatorDataForEnroll)(opt));
  });
  return {
    View: _AuthenticatorEnrollOptions.default,
    options: {
      name: opt.name,
      collection: new _okta.Collection(optionItems)
    }
  };
};

var createAuthenticatorVerifySelectView = function createAuthenticatorVerifySelectView(opt) {
  var optionItems = opt.options || []; // If webauthn enrollments > 1 just show one entry with a generic namne (first) so user doesnt have to select which
  // one to pick. eg) If there is yubikey5 and another unknown u2f key, user cannot identify that easily. We need to
  // do this at least  until users can give authenticator enrollments custom names.

  var hasSecurityKey = false;
  optionItems = (0, _filter.default)(optionItems).call(optionItems, function (opt) {
    if (opt.authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN) {
      if (!hasSecurityKey) {
        hasSecurityKey = true;
        return true;
      } else {
        return false;
      }
    }

    return true;
  });
  optionItems = (0, _map.default)(optionItems).call(optionItems, function (opt) {
    return (0, _assign.default)({}, opt, (0, _AuthenticatorUtil.getAuthenticatorDataForVerification)(opt));
  });
  return {
    View: _AuthenticatorVerifyOptions.default,
    options: {
      name: opt.name,
      collection: new _okta.Collection(optionItems)
    }
  };
};

var createAdminScopesView = function createAdminScopesView() {
  return {
    View: _ScopeList.default
  };
};

var createEnduserScopesView = function createEnduserScopesView() {
  return {
    View: _ScopeList2.default
  };
};

var createCaptchaView = function createCaptchaView(opt) {
  return {
    View: _CaptchaView.default,
    options: {
      name: opt.name
    }
  };
};

var inputCreationStrategy = (_inputCreationStrateg = {
  authenticatorEnrollSelect: createAuthenticatorEnrollSelectView,
  authenticatorVerifySelect: createAuthenticatorVerifySelectView
}, (0, _defineProperty3.default)(_inputCreationStrateg, 'admin-consent', createAdminScopesView), (0, _defineProperty3.default)(_inputCreationStrateg, 'consent', createEnduserScopesView), (0, _defineProperty3.default)(_inputCreationStrateg, 'captcha', createCaptchaView), _inputCreationStrateg); // TODO: move logic to uiSchemaTransformer

var create = function create(uiSchemaObj) {
  var strategyFn = inputCreationStrategy[uiSchemaObj.type] || _okta._.identity;
  return strategyFn(uiSchemaObj);
};

var createPIVButton = function createPIVButton(settings, appState) {
  var _context2;

  var pivIdp = (0, _filter.default)(_context2 = appState.get('remediations')).call(_context2, function (idp) {
    return idp.name === _RemediationConstants.FORMS.PIV_IDP;
  });

  if (pivIdp.length < 1) {
    return [];
  }

  var pivConfig = settings.get('piv');
  var className = pivConfig.className || '';
  return [{
    attributes: {
      'data-se': 'piv-card-button'
    },
    className: className + ' piv-button',
    title: pivConfig.text || (0, _okta.loc)('piv.cac.card', 'login'),
    click: function click(e) {
      e.preventDefault();
      appState.trigger('switchForm', _RemediationConstants.FORMS.PIV_IDP);
    }
  }];
};
/**
 * Example of `redirect-idp` remediation.
 * {
 *   "name": "redirect-idp",
 *   "type": "MICROSOFT",
 *   "idp": {
 *      "id": "0oa2szc1K1YPgz1pe0g4",
 *      "name": "Microsoft IDP"
 *    },
 *   "href": "http://localhost:3000/sso/idps/0oa2szc1K1YPgz1pe0g4?stateToken=BB...AA",
 *   "method": "GET"
 * }
 *
 */


var createIdpButtons = function createIdpButtons(_ref) {
  var _context3, _context4;

  var settings = _ref.settings,
      appState = _ref.appState;
  // This is the max allowable text width that we can display for IDP buttons.
  // Generated by taking the 316px width of button minus padding-left (90 px) and padding-right (50px)
  var MAX_IDP_BUTTON_WIDTH = 186;
  var redirectIdpRemediations = (0, _filter.default)(_context3 = appState.get('remediations')).call(_context3, function (idp) {
    return idp.name === _RemediationConstants.FORMS.REDIRECT_IDP;
  });

  if (!(0, _isArray.default)(redirectIdpRemediations)) {
    return [];
  } // create piv button


  var pivButton = createPIVButton(settings, appState); //add buttons from idp object

  var idpButtons = (0, _map.default)(redirectIdpRemediations).call(redirectIdpRemediations, function (idpObject) {
    var _idpObject$type;

    var type = (_idpObject$type = idpObject.type) === null || _idpObject$type === void 0 ? void 0 : _idpObject$type.toLowerCase();
    var displayName;

    if (!_okta._.contains(_IDP.default.SUPPORTED_SOCIAL_IDPS, type)) {
      var _idpObject$idp;

      type = 'general-idp'; // OKTA-396684 - makes sure that custom idps always have a name

      displayName = (0, _okta.loc)('customauth.sign.in.with.label', 'login', [(_idpObject$idp = idpObject.idp) === null || _idpObject$idp === void 0 ? void 0 : _idpObject$idp.name]);
    } else {
      displayName = (0, _okta.loc)("socialauth.".concat(type, ".label"), 'login');
    }

    var classNames = ['social-auth-button', "social-auth-".concat(type, "-button")];

    if (type === 'general-idp') {
      classNames.push('no-translate');
    }

    if (idpObject.idp.className) {
      classNames.push(idpObject.idp.className);
    }

    var button = {
      attributes: {
        'data-se': "social-auth-".concat(type, "-button")
      },
      className: classNames.join(' '),
      title: displayName,
      href: idpObject.href
    };

    if (isTextOverflow(displayName, MAX_IDP_BUTTON_WIDTH)) {
      // We add a tooltip in case the name gets truncated if too long
      button.attributes.title = displayName;
    }

    return button;
  });
  return (0, _concat.default)(_context4 = []).call(_context4, (0, _toConsumableArray2.default)(pivButton), (0, _toConsumableArray2.default)(idpButtons));
};

var createCustomButtons = function createCustomButtons(settings) {
  var customButtons = settings.get('customButtons');
  return (0, _map.default)(customButtons).call(customButtons, function (customButton) {
    var button = {
      attributes: {
        'data-se': customButton.dataAttr
      },
      className: customButton.className + ' default-custom-button',
      title: customButton.title,
      click: customButton.click
    };
    return button;
  });
};

var addCustomButton = function addCustomButton(customButtonSettings) {
  return (0, _okta.createButton)(_objectSpread(_objectSpread({}, customButtonSettings), {}, {
    className: "".concat(customButtonSettings.className, " default-custom-button button-primary")
  }));
};

module.exports = {
  create: create,
  createIdpButtons: createIdpButtons,
  createCustomButtons: createCustomButtons,
  addCustomButton: addCustomButton,
  isTextOverflowing: isTextOverflow
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var AuthenticatorRow = _okta.View.extend({
  className: 'authenticator-row clearfix',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "authenticator-label--small";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"authenticator-description--text " + alias4((helper = (helper = lookupProperty(helpers, "noTranslateClassName") || (depth0 != null ? lookupProperty(depth0, "noTranslateClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "noTranslateClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 333
          },
          "end": {
            "line": 1,
            "column": 357
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 359
          },
          "end": {
            "line": 1,
            "column": 374
          }
        }
      }) : helper)) + "</p>";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "data-se=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "buttonDataSeAttr") || (depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "buttonDataSeAttr",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 458
          },
          "end": {
            "line": 1,
            "column": 478
          }
        }
      }) : helper)) + "\"";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"authenticator-icon-container\"><div class=\"factor-icon authenticator-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"authenticator-description\"><div><h3 class=\"authenticator-label no-translate " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 204
          },
          "end": {
            "line": 1,
            "column": 256
          }
        }
      })) != null ? stack1 : "") + "\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 258
          },
          "end": {
            "line": 1,
            "column": 267
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 272
          },
          "end": {
            "line": 1,
            "column": 385
          }
        }
      })) != null ? stack1 : "") + "</div><div class=\"authenticator-button\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 425
          },
          "end": {
            "line": 1,
            "column": 486
          }
        }
      })) != null ? stack1 : "") + "></div></div>";
    },
    "useData": true
  }),
  children: function children() {
    return [[(0, _okta.createButton)({
      className: 'button select-factor',
      title: function title() {
        return (0, _okta.loc)('oie.verify.authenticator.button.text', 'login');
      },
      click: function click() {
        this.model.trigger('selectAutheticator', this.model.get('value'));
      }
    }), '.authenticator-button']];
  },
  minimize: function minimize() {
    this.$el.addClass('authenticator-row-min');
  }
});

var _default = _okta.ListView.extend({
  className: 'authenticator-verify-list authenticator-list',
  item: AuthenticatorRow,
  itemSelector: '.list-content',
  initialize: function initialize() {
    this.listenTo(this.collection, 'selectAutheticator', this.handleSelect);
  },
  handleSelect: function handleSelect(data) {
    var _this$model$getProper;

    //If schema contains a required identifier to fill first then validate the form
    var validationError = this.model.validateField('identifier');
    this.model.trigger('clearFormError');

    if (((_this$model$getProper = this.model.getPropertySchema('identifier')) === null || _this$model$getProper === void 0 ? void 0 : _this$model$getProper.required) && validationError) {
      this.model.trigger('invalid', this.model, validationError);
    } else {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    }
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"list-content\"></div>";
    },
    "useData": true
  })
});

exports.default = _default;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _polling = _interopRequireDefault(__webpack_require__(257));

var _BaseForm = _interopRequireDefault(__webpack_require__(206));

var _default = _BaseForm.default.extend((0, _assign.default)({
  initialize: function initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);

    this.listenTo(this.options.appState, 'change:dynamicRefreshInterval', this.updateRefreshInterval);
  },
  updateRefreshInterval: function updateRefreshInterval() {
    if (this.polling) {
      this.stopPolling();
      this.startPolling(this.options.appState.get('dynamicRefreshInterval'));
    }
  }
}, _polling.default));

exports.default = _default;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var convertUiSchemaFieldToProp = function convertUiSchemaFieldToProp(uiSchemaField) {
  var config = (0, _assign.default)({}, _okta._.chain(uiSchemaField).pick('minLength', 'maxLength', 'required', 'value').defaults({
    type: 'string',
    required: true
  }).value());

  if (uiSchemaField.modelType) {
    config.type = uiSchemaField.modelType;
  }

  return (0, _defineProperty2.default)({}, uiSchemaField.name, config);
};

var createPropsAndLocals = function createPropsAndLocals() {
  var remediation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionUiSchemaConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var local = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var uiSchemas = remediation.uiSchema || [];
  (0, _forEach.default)(uiSchemas).call(uiSchemas, function (schema) {
    if ((0, _isArray.default)(schema.optionsUiSchemas)) {
      var optionUiSchemaIndex;
      var optionUiSchemaValue = {};

      if (Number(schema.value) >= 0) {
        optionUiSchemaIndex = schema.value;
      }

      if (optionUiSchemaConfig[schema.name]) {
        optionUiSchemaValue = {
          value: optionUiSchemaConfig[schema.name]
        };
        optionUiSchemaIndex = Number(optionUiSchemaValue.value);
      }

      (0, _assign.default)(local, convertUiSchemaFieldToProp((0, _assign.default)({}, schema, optionUiSchemaValue)));

      if (optionUiSchemaIndex) {
        createPropsAndLocals({
          uiSchema: schema.optionsUiSchemas[optionUiSchemaIndex]
        }, optionUiSchemaConfig, props, local);
      }
    } else {
      (0, _assign.default)(props, convertUiSchemaFieldToProp(schema));
    }
  });
};

var create = function create() {
  var remediation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionUiSchemaConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var props = {};
  var local = {
    // current remediation form name
    formName: 'string',
    // use full page redirect instead of AJAX
    useRedirect: 'boolean'
  };
  createPropsAndLocals(remediation, optionUiSchemaConfig, props, local);

  var BaseModel = _okta.Model.extend({
    props: props,
    local: local
  });

  return BaseModel;
};

module.exports = {
  create: create
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getV1ClassName = exports.getClassNameMapping = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _RemediationConstants = __webpack_require__(24);

var _FORMS$IDENTIFY, _FORMS$CHALLENGE_AUTH, _FORMS$CHALLENGE_POLL, _FORMS$RESEND_PUSH, _FORMS$ENROLL_AUTHENT, _FORMNAME_CLASSNAME_M;

var FORMNAME_CLASSNAME_MAPPINGS = (_FORMNAME_CLASSNAME_M = {}, (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.IDENTIFY, (_FORMS$IDENTIFY = {}, (0, _defineProperty2.default)(_FORMS$IDENTIFY, _RemediationConstants.FORMS.IDENTIFY, 'primary-auth'), (0, _defineProperty2.default)(_FORMS$IDENTIFY, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, 'primary-auth'), _FORMS$IDENTIFY)), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.IDENTIFY_RECOVERY, (0, _defineProperty2.default)({}, _RemediationConstants.FORMS.IDENTIFY_RECOVERY, 'forgot-password')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.ENROLL_PROFILE, (0, _defineProperty2.default)({}, _RemediationConstants.FORMS.ENROLL_PROFILE, 'registration')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR, (_FORMS$CHALLENGE_AUTH = {}, (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.EMAIL, 'mfa-verify-passcode'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, 'mfa-verify-password'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, "sms", 'mfa-verify-passcode'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, "voice", 'mfa-verify-passcode'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION, 'mfa-verify-question'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN, 'mfa-verify-webauthn'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM, 'mfa-verify-totp'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.RSA, 'mfa-verify-totp'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.OV, 'mfa-verify'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP, 'mfa-verify'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.DUO, 'mfa-verify-duo'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP, 'mfa-verify'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY, 'mfa-verify'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_AUTH, _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP, 'mfa-verify'), _FORMS$CHALLENGE_AUTH)), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.CHALLENGE_POLL, (_FORMS$CHALLENGE_POLL = {}, (0, _defineProperty2.default)(_FORMS$CHALLENGE_POLL, _RemediationConstants.AUTHENTICATOR_KEY.OV, 'mfa-verify'), (0, _defineProperty2.default)(_FORMS$CHALLENGE_POLL, _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP, 'mfa-verify'), _FORMS$CHALLENGE_POLL)), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.RESEND_PUSH, (_FORMS$RESEND_PUSH = {}, (0, _defineProperty2.default)(_FORMS$RESEND_PUSH, _RemediationConstants.AUTHENTICATOR_KEY.OV, 'mfa-verify'), (0, _defineProperty2.default)(_FORMS$RESEND_PUSH, _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP, 'mfa-verify'), _FORMS$RESEND_PUSH)), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.ENROLL_AUTHENTICATOR, (_FORMS$ENROLL_AUTHENT = {}, (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.EMAIL, 'enroll-email'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, 'enroll-password'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, "sms", 'enroll-sms'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, "voice", 'enroll-call'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION, 'enroll-question'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN, 'enroll-webauthn'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM, 'enroll-onprem'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.RSA, 'enroll-rsa'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.DUO, 'enroll-duo'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP, 'enroll-symantec'), (0, _defineProperty2.default)(_FORMS$ENROLL_AUTHENT, _RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY, 'enroll-yubikey'), _FORMS$ENROLL_AUTHENT)), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL, {
  'select-authenticator-enroll': 'enroll-choices'
}), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, 'forgot-password')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.REENROLL_AUTHENTICATOR, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, 'password-expired')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.RESET_AUTHENTICATOR, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, 'forgot-password')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.CONSENT_ADMIN, (0, _defineProperty2.default)({}, _RemediationConstants.FORMS.CONSENT_ADMIN, 'admin-consent-required')), (0, _defineProperty2.default)(_FORMNAME_CLASSNAME_M, _RemediationConstants.FORMS.CONSENT_ENDUSER, (0, _defineProperty2.default)({}, _RemediationConstants.FORMS.CONSENT_ENDUSER, 'consent-required')), _FORMNAME_CLASSNAME_M);

var getV1ClassName = function getV1ClassName(formName, authenticatorKey, methodType, isPasswordRecoveryFlow) {
  // if password reset flow from identifier page with recoveryAuthenticator add forgot-password class
  if (isPasswordRecoveryFlow && formName === _RemediationConstants.FORMS.IDENTIFY) {
    return 'forgot-password';
  } else {
    var key = formName;

    if (authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.PHONE) {
      // Both sms and call have same type phone
      // currentAuthenticatorEnrollment is during verify and currentAuthenticator during enroll flows
      key = "".concat(methodType);
    } else if (authenticatorKey) {
      key = "".concat(authenticatorKey);
    }

    if (FORMNAME_CLASSNAME_MAPPINGS[formName] && FORMNAME_CLASSNAME_MAPPINGS[formName][key]) {
      return FORMNAME_CLASSNAME_MAPPINGS[formName][key];
    } else {
      return null;
    }
  }
};

exports.getV1ClassName = getV1ClassName;

var getClassNameMapping = function getClassNameMapping(formName, authenticatorKey, methodType, isPasswordRecoveryFlow) {
  // 1. Generates V2 class name
  // If we have a type which is authenticatorType/methodType use that to generate a V2 className
  // Otherwise just use formName
  var v2ClassName = formName;

  if (authenticatorKey) {
    v2ClassName = v2ClassName + '--' + authenticatorKey;
  } // 2. do a lookup for any V1 classNames and concat


  var v1ClassName = getV1ClassName(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
  var result = [v2ClassName];

  if (v1ClassName) {
    result.push(v1ClassName);
  }

  return result;
};

exports.getClassNameMapping = getClassNameMapping;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(353));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(354));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(355));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(356));

var _keys = _interopRequireDefault(__webpack_require__(117));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(88));

var _map = _interopRequireDefault(__webpack_require__(40));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

var _internals = __webpack_require__(5);

var _DeviceFingerprinting = _interopRequireDefault(__webpack_require__(1338));

var _IdentifierFooter = _interopRequireDefault(__webpack_require__(604));

var _Link = _interopRequireDefault(__webpack_require__(205));

var _SignInWithIdps = _interopRequireDefault(__webpack_require__(1339));

var _CustomButtons = _interopRequireDefault(__webpack_require__(1340));

var _SignInWithDeviceOption = _interopRequireDefault(__webpack_require__(605));

var _i18nTransformer = __webpack_require__(142);

var _LinksUtil = __webpack_require__(122);

var _CookieUtil = _interopRequireDefault(__webpack_require__(245));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source))).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('primaryauth.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oform.next', 'login');
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    var uiSchema = this.getUISchema();

    if ((0, _find.default)(uiSchema).call(uiSchema, function (schema) {
      return schema.name === 'credentials.passcode';
    })) {
      this.save = (0, _okta.loc)('oie.primaryauth.submit', 'login');
    } // Set username/identifier from the config. Note this takes precedence over the "remember my username" feature.


    if (this._shouldAddUsername(uiSchema)) {
      // Set username/identifier from the config (i.e. config.username)
      this.model.set('identifier', this.settings.get('username'));
    } else if (this._shouldApplyRememberMyUsername(uiSchema)) {
      this._applyRememberMyUsername();
    }
  },
  saveForm: function saveForm() {
    var _this = this,
        _arguments = arguments;

    // Ideally this can be added to a "preSaveForm" handler - but keeping this here for now.
    if (!this.settings.get('features.deviceFingerprinting')) {
      _internals.BaseForm.prototype.saveForm.apply(this, arguments);

      return;
    } // Before the XHR is made for "identify", we'll generate this one-time use fingerprint via
    // a hidden-iframe (similar to authn/v1 flows)


    var fingerprintData = {
      oktaDomainUrl: this.settings.get('baseUrl'),
      element: this.$el
    };

    _DeviceFingerprinting.default.generateDeviceFingerprint(fingerprintData).then(function (fingerprint) {
      _this.options.appState.set('deviceFingerprint', fingerprint);
    }).catch(function () {
      /* Keep going even if device fingerprint fails */
    }).finally(function () {
      _internals.BaseForm.prototype.saveForm.apply(_this, _arguments);
    });
  },
  render: function render() {
    _internals.BaseForm.prototype.render.apply(this, arguments); // Launch Device Authenticator


    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR)) {
      this.add(_SignInWithDeviceOption.default, '.o-form-fieldset-container', false, true, {
        isRequired: false
      });
    } // add forgot password link and external idps buttons if needed


    var idpButtons = (0, _internals.createIdpButtons)(this.options);

    if ((0, _isArray.default)(idpButtons) && idpButtons.length) {
      // Add the forgot password link before the buttons for multiple IDPs
      this._addForgotPasswordView();

      this._addIdpView(idpButtons);
    }

    var customButtons = (0, _internals.createCustomButtons)(this.options.settings);

    if ((0, _isArray.default)(customButtons) && customButtons.length) {
      this.add(_CustomButtons.default, {
        selector: '.o-form-button-bar',
        options: {
          customButtons: customButtons,
          addSeparateLine: true
        }
      });
    }
  },
  showMessages: function showMessages() {
    /**
     * Renders a warning callout for unknown user flow
     * Note: Anytime we get back `messages` object along with identify view
     * we would render it as a warning callout
     * */
    var messagesObj = this.options.appState.get('messages');

    if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.value.length) && this.options.appState.get('currentFormName') === 'identify') {
      var content = messagesObj.value[0].message;
      var messageCallout = (0, _okta.createCallout)({
        content: content,
        type: 'warning'
      });
      this.add(messageCallout, '.o-form-error-container');
    }
  },

  /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */
  getUISchema: function getUISchema() {
    var schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    var settings = this.options.settings;
    var identifierExplainLabeli18nKey = 'primaryauth.username.tooltip';
    var passwordExplainLabeli18nKey = 'primaryauth.password.tooltip';
    var newSchemas = (0, _map.default)(schemas).call(schemas, function (schema) {
      var newSchema = _objectSpread({}, schema);

      if (schema.name === 'identifier') {
        if ((0, _i18nTransformer.isCustomizedI18nKey)(identifierExplainLabeli18nKey, settings)) {
          newSchema = _objectSpread(_objectSpread({}, newSchema), {}, {
            explain: (0, _okta.loc)(identifierExplainLabeli18nKey, 'login'),
            'explain-top': true
          });
        } // We enable the browser's autocomplete for the identifier input
        // because we want to allow the user to choose from previously used identifiers.


        newSchema = _objectSpread(_objectSpread({}, newSchema), {}, {
          autoComplete: 'identifier'
        });
      } else if (schema.name === 'credentials.passcode' && (0, _i18nTransformer.isCustomizedI18nKey)(passwordExplainLabeli18nKey, settings)) {
        newSchema = _objectSpread(_objectSpread({}, newSchema), {}, {
          explain: (0, _okta.loc)(passwordExplainLabeli18nKey, 'login'),
          'explain-top': true
        });
      }

      return newSchema;
    });
    return newSchemas;
  },
  _addForgotPasswordView: function _addForgotPasswordView() {
    var forgotPasswordLink = (0, _LinksUtil.getForgotPasswordLink)(this.options.appState, this.options.settings);

    if (forgotPasswordLink.length) {
      this.add('<div class="links-primary"></div>', {
        selector: '.o-form-button-bar'
      });
      this.add(_Link.default, {
        selector: '.links-primary',
        options: forgotPasswordLink[0]
      });
    }
  },
  _addIdpView: function _addIdpView(idpButtons) {
    // We check the 'idpDisplay' option config to determine whether to render the idp buttons 
    // above or below the login fields
    var idpDisplay = this.options.settings.get('idpDisplay');
    var isPrimaryIdpDisplay = idpDisplay && idpDisplay.toUpperCase() === 'PRIMARY';
    this.add(_SignInWithIdps.default, {
      prepend: isPrimaryIdpDisplay,
      selector: isPrimaryIdpDisplay ? '.o-form-fieldset-container' : '.o-form-button-bar',
      options: {
        idpButtons: idpButtons,
        isPrimaryIdpDisplay: isPrimaryIdpDisplay
      }
    });
  },
  _shouldAddUsername: function _shouldAddUsername(uiSchema) {
    // We pre-populate the identifier/username field only if we're in an identifier
    // form and if the option is passed in.
    return (0, _find.default)(uiSchema).call(uiSchema, function (schema) {
      return schema.name === 'identifier';
    }) && this.settings.get('username');
  },
  _shouldApplyRememberMyUsername: function _shouldApplyRememberMyUsername(uiSchema) {
    return (0, _find.default)(uiSchema).call(uiSchema, function (schema) {
      return schema.name === 'identifier';
    }) && this.settings.get('features.rememberMe');
  },

  /**
   * When "Remember My Username" is enabled, we pre-fill the identifier
   * field with the saved userName cookie. The cookie would have been originally
   * saved when submitting the form previously.
   */
  _applyRememberMyUsername: function _applyRememberMyUsername() {
    var cookieUsername = _CookieUtil.default.getCookieUsername();

    if (cookieUsername) {
      this.model.set('identifier', cookieUsername);
    }
  }
});

var _default = _internals.BaseView.extend({
  Body: Body,
  initialize: function initialize() {
    var _this2 = this;

    // Override Footer by overriding showForgotPasswordLink method
    this.Footer = _IdentifierFooter.default.extend({
      showForgotPasswordLink: function showForgotPasswordLink() {
        // We don't add the forgot password link in the footer if SIW renders multi IDPs,
        // instead in that case we add it before the IDP buttons in IdentifierView as primary links.
        var idpButtons = (0, _internals.createIdpButtons)(_this2.options);
        return !_this2.options.appState.isIdentifierOnlyView() && (!(0, _isArray.default)(idpButtons) || idpButtons.length === 0);
      }
    });
  },
  postRender: function postRender() {
    var _context;

    _internals.BaseView.prototype.postRender.apply(this, arguments); // If user entered identifier is not found, API sends back a message with a link to sign up
    // This is the click handler for that link


    var appState = this.options.appState;
    (0, _find.default)(_context = this.$el).call(_context, '.js-sign-up').click(function () {
      appState.trigger('invokeAction', _RemediationConstants.FORMS.SELECT_ENROLL_PROFILE);
      return false;
    });
  }
});

exports.default = _default;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _RemediationConstants = __webpack_require__(24);

var _LinksUtil = __webpack_require__(122);

var _Link = _interopRequireDefault(__webpack_require__(205));

var _default = _internals.BaseFooter.extend({
  showForgotPasswordLink: function showForgotPasswordLink() {
    return !this.options.appState.isIdentifierOnlyView();
  },
  footerInfo: function footerInfo() {
    var signUpLinkData = (0, _LinksUtil.getSignUpLink)(this.options.appState, this.options.settings);
    var SignUpLinkWithText; //Build sign up link view appended with a text. Link class can only build anchor tags

    if (signUpLinkData.length) {
      SignUpLinkWithText = _okta.View.extend({
        className: 'signup-info',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "registration.signup.label"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 6
                },
                "end": {
                  "line": 1,
                  "column": 62
                }
              }
            })) + "</span><span class=\"signup-link\"></span>";
          },
          "useData": true
        }),
        initialize: function initialize() {
          this.add(_Link.default, '.signup-link', {
            options: signUpLinkData[0]
          });
        }
      });
    }

    return SignUpLinkWithText;
  },
  links: function links() {
    var _context2, _context3;

    var _this$options = this.options,
        appState = _this$options.appState,
        settings = _this$options.settings;
    var helpLinkHref;

    if (settings.get('helpLinks.help')) {
      helpLinkHref = settings.get('helpLinks.help');
    } else {
      var baseUrl = settings.get('baseUrl');
      helpLinkHref = baseUrl + '/help/login';
    }

    var helpLink = [{
      'name': 'help',
      'label': (0, _okta.loc)('help', 'login'),
      'href': helpLinkHref
    }];
    var forgotPasswordLink = [];

    if (this.showForgotPasswordLink()) {
      forgotPasswordLink = (0, _LinksUtil.getForgotPasswordLink)(appState, settings);
    }

    var customHelpLinks = [];

    if (settings.get('helpLinks.custom')) {
      var _context;

      //add custom helpLinks
      (0, _forEach.default)(_context = settings.get('helpLinks.custom')).call(_context, function (customHelpLink) {
        customHelpLink.name = 'custom';
        customHelpLink.label = customHelpLink.text;
        customHelpLinks.push(customHelpLink);
      });
    }

    var unlockAccountLink = [];

    if (settings.get('helpLinks.unlock')) {
      unlockAccountLink.push({
        'type': 'link',
        'label': (0, _okta.loc)('unlockaccount', 'login'),
        'name': 'unlock',
        'href': settings.get('helpLinks.unlock')
      });
    } else if (appState.hasRemediationObject(_RemediationConstants.FORMS.UNLOCK_ACCOUNT)) {
      unlockAccountLink.push({
        'type': 'link',
        'label': (0, _okta.loc)('unlockaccount', 'login'),
        'name': 'unlock',
        'actionPath': _RemediationConstants.FORMS.UNLOCK_ACCOUNT
      });
    }

    return (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(forgotPasswordLink).call(forgotPasswordLink, unlockAccountLink)).call(_context3, helpLink)).call(_context2, customHelpLinks);
  }
});

exports.default = _default;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Util = _interopRequireDefault(__webpack_require__(31));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Constants = __webpack_require__(93);

var _RemediationConstants = __webpack_require__(24);

var _default = _okta.View.extend({
  className: 'sign-in-with-device-option',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"signin-with-ov-description\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oktaVerify.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 109
          },
          "end": {
            "line": 1,
            "column": 162
          }
        }
      })) + "</div>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "authbutton.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 254
          },
          "end": {
            "line": 1,
            "column": 308
          }
        }
      })) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"okta-verify-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "signInWithDeviceIsRequired") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 35
          },
          "end": {
            "line": 1,
            "column": 175
          }
        }
      })) != null ? stack1 : "") + "</div>" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "signInWithDeviceIsRequired") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 181
          },
          "end": {
            "line": 1,
            "column": 332
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  initialize: function initialize() {
    var _deviceChallengePollR;

    var appState = this.options.appState;
    var deviceChallengePollRemediation = this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR);
    var deviceChallenge = deviceChallengePollRemediation === null || deviceChallengePollRemediation === void 0 ? void 0 : (_deviceChallengePollR = deviceChallengePollRemediation.relatesTo) === null || _deviceChallengePollR === void 0 ? void 0 : _deviceChallengePollR.value;
    this.add((0, _okta.createButton)({
      className: 'button',
      icon: 'okta-verify-authenticator',
      title: (0, _okta.loc)('oktaVerify.button', 'login'),
      click: function click() {
        var _this = this;

        var isUVapproach = (deviceChallenge === null || deviceChallenge === void 0 ? void 0 : deviceChallenge.challengeMethod) === _Enums.default.UNIVERSAL_LINK_CHALLENGE;

        if (isUVapproach) {
          // launch the Okta Verify app
          _Util.default.redirect(deviceChallenge.href);
        }

        var isAppLinkapproach = (deviceChallenge === null || deviceChallenge === void 0 ? void 0 : deviceChallenge.challengeMethod) === _Enums.default.APP_LINK_CHALLENGE;

        if (isAppLinkapproach) {
          // launch the Okta Verify app
          _Util.default.redirect(deviceChallenge.href, window, true);
        } // OKTA-350084
        // For the universal link (iOS) and app link (Android) approach,
        // we need to 1. launch the Okta Verify app
        // and 2. take the enduser to the next step right away
        // In Safari, when Okta Verify app is not installed, step 1 responds with error immediately,
        // then step 2 will respond with error.
        // To avoid showing the error right before switching to the next UI,
        // wait for 500 milliseconds before invoking step 2


        _Util.default.callAfterTimeout(function () {
          if (_this.options.isRequired) {
            appState.trigger('saveForm', _this.model);
          } else {
            appState.trigger('invokeAction', _RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR);
          }
        }, isUVapproach || isAppLinkapproach ? _Constants.UNIVERSAL_LINK_POST_DELAY : 0);
      }
    }), '.okta-verify-container');
  },
  getTemplateData: function getTemplateData() {
    return {
      signInWithDeviceIsRequired: !!this.options.isRequired
    };
  }
});

exports.default = _default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _RemediationConstants = __webpack_require__(24);

var _BaseAuthenticatorView = __webpack_require__(14);

var _default = _internals.BaseHeader.extend({
  HeaderBeacon: _BaseAuthenticatorView.BaseAuthenticatorBeacon.extend({
    authenticatorKey: _RemediationConstants.AUTHENTICATOR_KEY.EMAIL
  })
});

exports.default = _default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var BeaconView = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div data-type=\"beacon-container\" class=\"beacon-container\"><div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 230
          },
          "end": {
            "line": 1,
            "column": 243
          }
        }
      }) : helper)) + "\" data-se=\"factor-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div></div >";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    return {
      className: this.getBeaconClassName() || ''
    };
  },
  getBeaconClassName: function getBeaconClassName() {
    return 'undefined-user';
  }
});

module.exports = BeaconView;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _map = _interopRequireDefault(__webpack_require__(40));

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

var _AdminConsentViewHeader = _interopRequireDefault(__webpack_require__(609));

var _ConsentViewForm = _interopRequireDefault(__webpack_require__(610));

var _i18nTransformer = __webpack_require__(142);

var _default = _internals.BaseView.extend({
  Header: _AdminConsentViewHeader.default,
  Body: _ConsentViewForm.default,
  createModelClass: function createModelClass(currentViewState) {
    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var uiSchema = currentViewState.uiSchema;
    var scopes = uiSchema[0].scopes;
    var i18nKeyPrefix = 'consent.scopes';
    var localizedScopes = (0, _map.default)(scopes).call(scopes, function (_ref) {
      var _context;

      var name = _ref.name,
          displayName = _ref.displayName,
          description = _ref.description;
      var scopeKey = (0, _concat.default)(_context = "".concat(i18nKeyPrefix, ".")).call(_context, name);
      var labelKey = "".concat(scopeKey, ".label");
      var descKey = "".concat(scopeKey, ".desc");
      var doesLabelExist = (0, _i18nTransformer.doesI18NKeyExist)(labelKey);
      var doesDescExist = (0, _i18nTransformer.doesI18NKeyExist)(descKey);
      var i18nDisplayName = doesLabelExist ? (0, _okta.loc)(labelKey, 'login') : displayName;
      var i18nDescription = doesDescExist ? (0, _okta.loc)(descKey, 'login') : description;
      return {
        name: name,
        displayName: i18nDisplayName,
        description: i18nDescription,
        isCustomized: !doesLabelExist
      };
    });
    return ModelClass.extend({
      props: {
        scopes: {
          type: 'array',
          value: localizedScopes
        }
      },
      local: {
        consent: {
          type: 'boolean',
          value: false
        }
      },
      toJSON: function toJSON() {
        return {
          consent: this.get('consent')
        };
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var defaultLogo = '/img/logos/default.png';

var AdminConsentViewHeader = _okta.View.extend({
  className: 'consent-title detail-row',
  titleText: function titleText() {
    return (0, _okta.loc)('oie.consent.scopes.admin.title', 'login');
  },
  hasIssuer: true,
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "clientURI",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<img class=\"client-logo custom-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "customLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 149
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 170
          },
          "end": {
            "line": 1,
            "column": 181
          }
        }
      }) : helper)) + "\" aria-hidden=\"true\" />";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<img class=\"client-logo default-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "defaultLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 255
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 277
          },
          "end": {
            "line": 1,
            "column": 288
          }
        }
      }) : helper)) + "\" aria-hidden=\"true\" />";
    },
    "7": function _(container, depth0, helpers, partials, data) {
      return "</a>";
    },
    "9": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"issuer no-translate\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "issuer",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 493
          },
          "end": {
            "line": 1,
            "column": 503
          }
        }
      }) : helper)) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 89
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.program(5, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 89
          },
          "end": {
            "line": 1,
            "column": 318
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 318
          },
          "end": {
            "line": 1,
            "column": 346
          }
        }
      })) != null ? stack1 : "") + "<h1><span class=\"title-text\"><b class=\"no-translate\">" + alias4((helper = (helper = lookupProperty(helpers, "appName") || (depth0 != null ? lookupProperty(depth0, "appName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "appName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 399
          },
          "end": {
            "line": 1,
            "column": 410
          }
        }
      }) : helper)) + "</b>&nbsp;" + alias4((helper = (helper = lookupProperty(helpers, "titleText") || (depth0 != null ? lookupProperty(depth0, "titleText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "titleText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 420
          },
          "end": {
            "line": 1,
            "column": 433
          }
        }
      }) : helper)) + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(9, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 440
          },
          "end": {
            "line": 1,
            "column": 523
          }
        }
      })) != null ? stack1 : "") + "</h1>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var appState = this.options.appState;

    var _appState$get = appState.get('app'),
        label = _appState$get.label,
        clientUri = _appState$get.clientUri,
        logo = _appState$get.logo;

    var _appState$get2 = appState.get('authentication'),
        issuerObj = _appState$get2.issuer;

    var customLogo = logo === null || logo === void 0 ? void 0 : logo.href;
    var altText = (0, _okta.loc)('logo.for.the.app.alt.text', 'login');

    var appName = _okta._.escape(label);

    var clientURI = clientUri === null || clientUri === void 0 ? void 0 : clientUri.href;
    var issuer = this.hasIssuer ? issuerObj === null || issuerObj === void 0 ? void 0 : issuerObj.uri : null;
    var titleText = this.titleText();
    return {
      customLogo: customLogo,
      defaultLogo: defaultLogo,
      clientURI: clientURI,
      issuer: issuer,
      altText: altText,
      appName: appName,
      titleText: titleText
    };
  }
});

var _default = AdminConsentViewHeader;
exports.default = _default;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _default = _internals.BaseForm.extend({
  noButtonBar: false,
  noCancelButton: false,
  buttonOrder: ['cancel', 'save'],
  save: function save() {
    return (0, _okta.loc)('consent.required.consentButton', 'login');
  },
  cancel: function cancel() {
    return (0, _okta.loc)('consent.required.cancelButton', 'login');
  },
  title: false,
  events: {
    'click input[data-type="save"]': function clickInputDataTypeSave() {
      this.setConsent(true);
    }
  },
  setConsent: function setConsent(bool) {
    this.model.set('consent', bool);
  },
  cancelForm: function cancelForm() {
    // override BaseForm.prototype.cancelForm which cancels auth flow
    this.setConsent(false);
    this.options.appState.trigger('saveForm', this.model);
  }
});

exports.default = _default;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.doChallenge = doChallenge;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Util = _interopRequireDefault(__webpack_require__(31));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function doChallenge(view) {
  var deviceChallenge = view.getDeviceChallengePayload();

  switch (deviceChallenge.challengeMethod) {
    case _Enums.default.LOOPBACK_CHALLENGE:
      view.title = (0, _okta.loc)('deviceTrust.sso.redirectText', 'login');
      view.add(_okta.View.extend({
        className: 'loopback-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            return "<div class=\"spinner\"></div>";
          },
          "useData": true
        })
      }));
      view.doLoopback(deviceChallenge);
      break;

    case _Enums.default.CUSTOM_URI_CHALLENGE:
      view.title = (0, _okta.loc)('customUri.title', 'login');
      view.add(_okta.View.extend({
        className: 'skinny-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.prompt"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 67
                }
              }
            })) + "</p>";
          },
          "useData": true
        })
      }));
      view.add((0, _okta.createButton)({
        className: 'ul-button button button-wide button-primary',
        title: (0, _okta.loc)('customUri.required.content.button', 'login'),
        id: 'launch-ov',
        click: function click() {
          view.doCustomURI();
        }
      }));
      view.add(_okta.View.extend({
        className: 'skinny-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                alias2 = container.hooks.helperMissing,
                alias3 = container.escapeExpression,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.download.title"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 75
                }
              }
            })) + "</p><p><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "downloadOVLink") || (depth0 != null ? lookupProperty(depth0, "downloadOVLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
              "name": "downloadOVLink",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 91
                },
                "end": {
                  "line": 1,
                  "column": 109
                }
              }
            }) : helper)) + "\" target=\"_blank\" id=\"download-ov\" class=\"link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.download.linkText"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 157
                },
                "end": {
                  "line": 1,
                  "column": 232
                }
              }
            })) + "</a></p>";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          return {
            downloadOVLink: deviceChallenge.downloadHref
          };
        }
      }));
      view.customURI = deviceChallenge.href;
      view.doCustomURI();
      break;

    case _Enums.default.UNIVERSAL_LINK_CHALLENGE:
      view.title = (0, _okta.loc)('universalLink.title', 'login');
      view.add(_okta.View.extend({
        className: 'universal-link-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<div class=\"spinner\"></div>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "universalLink.content"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 27
                },
                "end": {
                  "line": 1,
                  "column": 79
                }
              }
            }));
          },
          "useData": true
        })
      }));
      view.add((0, _okta.createButton)({
        className: 'ul-button button button-wide button-primary',
        title: (0, _okta.loc)('oktaVerify.reopen.button', 'login'),
        click: function click() {
          // only window.location.href can open universal link in iOS/MacOS
          // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
          _Util.default.redirect(deviceChallenge.href);
        }
      }));
      break;

    case _Enums.default.APP_LINK_CHALLENGE:
      view.title = (0, _okta.loc)('appLink.title', 'login');
      view.add(_okta.View.extend({
        className: 'app-link-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "appLink.content"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 46
                }
              }
            }));
          },
          "useData": true
        })
      }));
      view.add((0, _okta.createButton)({
        className: 'al-button button button-wide button-primary',
        title: (0, _okta.loc)('oktaVerify.open.button', 'login'),
        click: function click() {
          // only window.location.href can open app link in Android
          // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
          _Util.default.redirect(deviceChallenge.href, window, true);
        }
      }));
      break;
  }
}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _RemediationConstants = __webpack_require__(24);

var _BaseAuthenticatorView = __webpack_require__(14);

var _default = _internals.BaseHeader.extend({
  HeaderBeacon: _BaseAuthenticatorView.BaseAuthenticatorBeacon.extend({
    authenticatorKey: _RemediationConstants.AUTHENTICATOR_KEY.OV
  })
});

exports.default = _default;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.Body = void 0;

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

var Body = _internals.BaseForm.extend({
  title: function title() {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _okta.loc)('password.reset.title.generic', 'login');
    }

    return (0, _okta.loc)('oie.select.authenticators.verify.title', 'login');
  },
  subtitle: function subtitle() {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _okta.loc)('oie.password.reset.verification', 'login');
    }

    return (0, _okta.loc)('oie.select.authenticators.verify.subtitle', 'login');
  },
  isPasswordRecoveryFlow: function isPasswordRecoveryFlow() {
    return this.options.appState.get('isPasswordRecovery');
  },
  noButtonBar: true
});

exports.Body = Body;

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ResendView = exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _Constants = __webpack_require__(93);

var ResendView = _okta.View.extend({
  // To be shown after a timeout
  className: 'phone-authenticator-challenge__resend-warning hide',
  events: {
    'click a.resend-link': 'handleResendLink'
  },
  // Override this to change the resend action location from response
  resendActionKey: 'currentAuthenticatorEnrollment-resend',
  initialize: function initialize() {
    var _context;

    var resendText = this.model.get('mode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.resendText', 'login') : (0, _okta.loc)('oie.phone.verify.call.resendText', 'login');
    var linkText = this.model.get('mode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.resendLinkText', 'login') : (0, _okta.loc)('oie.phone.verify.call.resendLinkText', 'login');
    this.add((0, _okta.createCallout)({
      content: (0, _concat.default)(_context = "".concat(resendText, "&nbsp;<a class='resend-link'>")).call(_context, linkText, "</a>"),
      type: 'warning'
    }));
  },
  handleResendLink: function handleResendLink() {
    this.options.appState.trigger('invokeAction', this.resendActionKey); // Hide warning, but start a timeout again..

    if (!this.el.classList.contains('hide')) {
      this.el.classList.add('hide');
    }

    this.showCalloutAfterTimeout();
  },
  postRender: function postRender() {
    this.showCalloutAfterTimeout();
  },
  showCalloutAfterTimeout: function showCalloutAfterTimeout() {
    var _this = this;

    this.showCalloutTimer = (0, _setTimeout2.default)(function () {
      _this.el.classList.remove('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showCalloutTimer);
  }
});

exports.ResendView = ResendView;

var Body = _internals.BaseForm.extend((0, _assign.default)({
  className: 'phone-authenticator-challenge',
  title: function title() {
    return (0, _okta.loc)('oie.phone.verify.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  initialize: function initialize() {
    var _context2, _context3, _context4, _context5;

    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    var sendText = this.model.get('mode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.codeSentText', 'login') : (0, _okta.loc)('mfa.calling', 'login');
    var enterCodeText = (0, _okta.loc)('oie.phone.verify.enterCodeText', 'login');
    var carrierChargesText = (0, _okta.loc)('oie.phone.carrier.charges', 'login');
    var strongClass = this.model.get('phoneNumber') !== (0, _okta.loc)('oie.phone.alternate.title', 'login') ? 'strong no-translate' : ''; // Courage doesn't support HTML, hence creating a subtitle here.

    this.add((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "<div class=\"okta-form-subtitle\" data-se=\"o-form-explain\">\n        ".concat(sendText, "&nbsp;<span class='")).call(_context5, strongClass, "'>")).call(_context4, this.model.escape('phoneNumber'), ".</span>\n        &nbsp;")).call(_context3, enterCodeText, "\n        <p>")).call(_context2, carrierChargesText, "</p>\n        </div>"), {
      prepend: true,
      selector: '.o-form-fieldset-container'
    });
  },
  postRender: function postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);

    this.add(ResendView, {
      selector: '.o-form-error-container',
      prepend: true
    });
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass() {
    var relatesToObject = this.options.currentViewState.relatesTo;

    var _ref = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {},
        methods = _ref.methods,
        profile = _ref.profile;

    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      mode: {
        'value': methods[0].type,
        'type': 'string'
      },
      phoneNumber: {
        'value': (profile === null || profile === void 0 ? void 0 : profile.phoneNumber) ? profile.phoneNumber : (0, _okta.loc)('oie.phone.alternate.title', 'login'),
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local
    });
  }
});

exports.default = _default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _email = _interopRequireDefault(__webpack_require__(1393));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _Constants = __webpack_require__(93);

var _BaseFormWithPolling = _interopRequireDefault(__webpack_require__(600));

var ResendView = _okta.View.extend({
  className: 'hide resend-email-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize: function initialize() {
    var _context;

    this.add((0, _okta.createCallout)({
      content: (0, _concat.default)(_context = "".concat((0, _okta.loc)('email.code.not.received', 'login'), "\n        <a class='resend-link'>")).call(_context, (0, _okta.loc)('email.button.resend', 'login'), "</a>"),
      type: 'warning'
    }));
  },
  handelResendLink: function handelResendLink() {
    this.options.appState.trigger('invokeAction', this.options.resendEmailAction); // Hide warning, but reinitiate to show warning again after some threshold of polling

    if (!this.$el.hasClass('hide')) {
      this.$el.addClass('hide');
    }

    this.showCalloutWithDelay();
  },
  postRender: function postRender() {
    this.showCalloutWithDelay();
  },
  showCalloutWithDelay: function showCalloutWithDelay() {
    var _this = this;

    this.showMeTimeout = _okta._.delay(function () {
      _this.$el.removeClass('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showMeTimeout);
  }
});

var Body = _BaseFormWithPolling.default.extend((0, _assign.default)({
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  initialize: function initialize() {
    _BaseFormWithPolling.default.prototype.initialize.apply(this, arguments);

    this.add(ResendView, {
      selector: '.o-form-error-container',
      options: {
        resendEmailAction: this.resendEmailAction
      }
    });
    this.startPolling();
  },
  saveForm: function saveForm() {
    _internals.BaseForm.prototype.saveForm.apply(this, arguments);

    this.stopPolling();
  },
  remove: function remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);

    this.stopPolling();
  },
  triggerAfterError: function triggerAfterError(model, error) {
    var _error$responseJSON, _error$responseJSON$e;

    _internals.BaseForm.prototype.triggerAfterError.apply(this, arguments);

    var isFormPolling = !!this.polling;
    this.stopPolling();

    if ((_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) === null || _error$responseJSON$e === void 0 ? void 0 : (0, _includes.default)(_error$responseJSON$e).call(_error$responseJSON$e, 'idx.session.expired')) {
      // Do NOT resume polling since session is invalid and polling is already stopped
      return;
    }

    if (this.isRateLimitError(error)) {
      // When polling encounter rate limit error, wait 60 sec for rate limit bucket to reset
      // before polling again & hide error message
      if (isFormPolling) {
        (0, _setTimeout2.default)(function () {
          model.trigger('clearFormError');
        }, 0);
      }

      this.startPolling(60000);
    } else {
      this.startPolling(this.options.appState.get('dynamicRefreshInterval'));
    }
  },
  isRateLimitError: function isRateLimitError(error) {
    var _error$responseJSON2, _error$responseJSON2$, _error$responseJSON3, _error$responseJSON4;

    return (((_error$responseJSON2 = error.responseJSON) === null || _error$responseJSON2 === void 0 ? void 0 : (_error$responseJSON2$ = _error$responseJSON2.errorSummaryKeys) === null || _error$responseJSON2$ === void 0 ? void 0 : (0, _includes.default)(_error$responseJSON2$).call(_error$responseJSON2$, 'tooManyRequests')) || ((_error$responseJSON3 = error.responseJSON) === null || _error$responseJSON3 === void 0 ? void 0 : _error$responseJSON3.errorCode) === 'E0000047') && !((_error$responseJSON4 = error.responseJSON) === null || _error$responseJSON4 === void 0 ? void 0 : _error$responseJSON4.errorIntent);
  }
}, _email.default));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

var _default = _okta.View.extend({
  className: 'switch-channel-text',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"switch-channel-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 116
          }
        }
      })) + "</a>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.switch.channel.link.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 128
          },
          "end": {
            "line": 1,
            "column": 208
          }
        }
      })) != null ? stack1 : "";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isQRcodeChannel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 215
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    return {
      isQRcodeChannel: this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'qrcode'
    };
  },
  postRender: function postRender() {
    var _context,
        _this = this;

    (0, _find.default)(_context = this.$el).call(_context, '.switch-channel-link').on('click', function (event) {
      var appState = _this.options.appState;
      event.preventDefault();
      appState.trigger('switchForm', _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL);
    });
  }
});

exports.default = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Body = exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _polling = _interopRequireDefault(__webpack_require__(257));

var _Constants = __webpack_require__(93);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _RemediationConstants = __webpack_require__(24);

// Common view for OV push and custom push.
var warningTemplate = _okta.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 51
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  })
});

var Body = _internals.BaseForm.extend((0, _assign.default)({
  noButtonBar: true,
  title: function title() {
    return this.isOV() ? (0, _okta.loc)('oie.okta_verify.push.title', 'login') : (0, _okta.loc)('oie.verify.custom_app.title', 'login', [this.options.appState.getAuthenticatorDisplayName()]);
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.stopPoll);
    this.addView();
  },
  addView: function addView() {
    this.add((0, _okta.createButton)({
      className: 'button button-wide button-primary send-push link-button-disabled',
      title: this.isOV() ? (0, _okta.loc)('oie.okta_verify.push.sent', 'login') : (0, _okta.loc)('oie.custom_app.push.sent', 'login'),
      click: function click(e) {
        e.preventDefault();
      }
    }));
    this.add("<span class='accessibility-text' role='alert'>\n        ".concat(this.isOV() ? (0, _okta.loc)('oie.okta_verify.push.sent', 'login') : (0, _okta.loc)('oie.custom_app.push.sent', 'login'), "</span>"));
  },
  postRender: function postRender() {
    var className = this.isOV() ? 'okta-verify-push-challenge' : ' custom-app-push-challenge';
    this.$el.addClass(className);
    this.startPoll();
  },
  startPoll: function startPoll() {
    var _this = this;

    this.startPolling();
    this.warningTimeout = (0, _setTimeout2.default)(function () {
      var warningText = _this.isOV() ? (0, _okta.loc)('oktaverify.warning', 'login') : (0, _okta.loc)('oie.custom_app.push.warning', 'login', [_this.options.appState.getAuthenticatorDisplayName()]);

      _this.showWarning(warningText);
    }, _Constants.WARNING_TIMEOUT);
  },
  stopPoll: function stopPoll() {
    this.stopPolling();
    this.clearWarning();
  },
  showWarning: function showWarning(msg) {
    this.clearWarning();
    this.add(warningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarning: function clearWarning() {
    if (this.$('.o-form-error-container div').hasClass('okta-form-infobox-warning')) {
      this.$('.okta-form-infobox-warning').remove();
    }

    clearTimeout(this.warningTimeout);
  },
  remove: function remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);

    this.stopPolling();
  },
  isOV: function isOV() {
    return this.options.appState.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.OV;
  }
}, _polling.default));

exports.Body = Body;

var AuthenticatorView = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = AuthenticatorView;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _duo = _interopRequireDefault(__webpack_require__(327));

var _internals = __webpack_require__(5);

var _default = _internals.BaseForm.extend({
  noButtonBar: true,
  postRender: function postRender() {
    var _this = this;

    var contextualData = this.getContextualData(); // This is the place to check contextualData.integrationType once we support more types
    // Currently we only support IFRAME

    var duoFrame = this.add("<iframe frameborder=\"0\" title=\"'".concat(this.title(), "'\"></iframe>")).last();

    try {
      _duo.default.init({
        host: contextualData.host,
        sig_request: contextualData.signedToken,
        // eslint-disable-line camelcase
        iframe: duoFrame.el,
        post_action: function post_action(signedData) {
          // eslint-disable-line camelcase
          _this.model.set('credentials.signatureData', signedData);

          _this.saveForm(_this.model);
        }
      });
    } catch (e) {
      duoFrame.remove();
      this.add((0, _okta.createCallout)({
        type: 'error',
        subtitle: (0, _okta.loc)('oie.duo.iFrameError', 'login')
      }), '.o-form-error-container');
      console.error(e); // eslint-disable-line no-console
    }
  },
  getContextualData: function getContextualData() {// to be overriden
  }
});

exports.default = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _default = _internals.BaseForm.extend({
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.model.set('useRedirect', true);
  },
  showMessages: function showMessages() {
    var _this = this;

    // IdP Authenticator error messages are not form errors
    // Parse and display them here.
    // TODO: OKTA-383470
    var messages = this.options.appState.get('messages') || {};

    if ((0, _isArray.default)(messages.value)) {
      var _context;

      this.add('<div class="ion-messages-container”></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messages.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if (messagesObj.class === 'ERROR') {
          _this.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(621);
__webpack_require__(622);
module.exports = __webpack_require__(853);


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(623);
__webpack_require__(843);
var path = __webpack_require__(169);

module.exports = path;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(211);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(381);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(277);
__webpack_require__(731);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
var path = __webpack_require__(169);

module.exports = path;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var getBuiltIn = __webpack_require__(63);
var IS_PURE = __webpack_require__(72);
var DESCRIPTORS = __webpack_require__(19);
var NATIVE_SYMBOL = __webpack_require__(267);
var USE_SYMBOL_AS_UID = __webpack_require__(363);
var fails = __webpack_require__(6);
var has = __webpack_require__(37);
var isArray = __webpack_require__(125);
var isObject = __webpack_require__(15);
var anObject = __webpack_require__(16);
var toObject = __webpack_require__(32);
var toIndexedObject = __webpack_require__(62);
var toPrimitive = __webpack_require__(81);
var createPropertyDescriptor = __webpack_require__(100);
var nativeObjectCreate = __webpack_require__(94);
var objectKeys = __webpack_require__(173);
var getOwnPropertyNamesModule = __webpack_require__(123);
var getOwnPropertyNamesExternal = __webpack_require__(365);
var getOwnPropertySymbolsModule = __webpack_require__(266);
var getOwnPropertyDescriptorModule = __webpack_require__(48);
var definePropertyModule = __webpack_require__(25);
var propertyIsEnumerableModule = __webpack_require__(207);
var createNonEnumerableProperty = __webpack_require__(50);
var redefine = __webpack_require__(51);
var shared = __webpack_require__(263);
var sharedKey = __webpack_require__(208);
var hiddenKeys = __webpack_require__(168);
var uid = __webpack_require__(167);
var wellKnownSymbol = __webpack_require__(20);
var wrappedWellKnownSymbolModule = __webpack_require__(366);
var defineWellKnownSymbol = __webpack_require__(60);
var setToStringTag = __webpack_require__(82);
var InternalStateModule = __webpack_require__(57);
var $forEach = __webpack_require__(46).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var global = __webpack_require__(9);
var has = __webpack_require__(37);
var isObject = __webpack_require__(15);
var defineProperty = __webpack_require__(25).f;
var copyConstructorProperties = __webpack_require__(361);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(60);

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(74);
var setPrototypeOf = __webpack_require__(111);
var create = __webpack_require__(94);
var createNonEnumerableProperty = __webpack_require__(50);
var createPropertyDescriptor = __webpack_require__(100);
var iterate = __webpack_require__(112);

var $AggregateError = function AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  if (setPrototypeOf) {
    // eslint-disable-next-line unicorn/error-message -- expected
    that = setPrototypeOf(new Error(undefined), getPrototypeOf(that));
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', String(message));
  var errorsArray = [];
  iterate(errors, errorsArray.push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

$AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ''),
  name: createPropertyDescriptor(5, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true }, {
  AggregateError: $AggregateError
});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var from = __webpack_require__(369);
var checkCorrectnessOfIteration = __webpack_require__(209);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var iteratorClose = __webpack_require__(368);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var isArray = __webpack_require__(125);

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var createProperty = __webpack_require__(126);

var ISNT_GENERIC = fails(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
});

// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
  of: function of(/* ...args */) {
    var index = 0;
    var argumentsLength = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(argumentsLength);
    while (argumentsLength > index) createProperty(result, index, arguments[index++]);
    result.length = argumentsLength;
    return result;
  }
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var isArray = __webpack_require__(125);
var isObject = __webpack_require__(15);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(22);
var createProperty = __webpack_require__(126);
var arraySpeciesCreate = __webpack_require__(174);
var arrayMethodHasSpeciesSupport = __webpack_require__(178);
var wellKnownSymbol = __webpack_require__(20);
var V8_VERSION = __webpack_require__(143);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var copyWithin = __webpack_require__(370);
var addToUnscopables = __webpack_require__(113);

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('copyWithin');


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $every = __webpack_require__(46).every;
var arrayMethodIsStrict = __webpack_require__(102);

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fill = __webpack_require__(272);
var addToUnscopables = __webpack_require__(113);

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $filter = __webpack_require__(46).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(178);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $find = __webpack_require__(46).find;
var addToUnscopables = __webpack_require__(113);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $findIndex = __webpack_require__(46).findIndex;
var addToUnscopables = __webpack_require__(113);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(371);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(22);
var toInteger = __webpack_require__(73);
var arraySpeciesCreate = __webpack_require__(174);

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(371);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(22);
var aFunction = __webpack_require__(58);
var arraySpeciesCreate = __webpack_require__(174);

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A;
    aFunction(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var forEach = __webpack_require__(372);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $includes = __webpack_require__(170).includes;
var addToUnscopables = __webpack_require__(113);

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $indexOf = __webpack_require__(170).indexOf;
var arrayMethodIsStrict = __webpack_require__(102);

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var IndexedObject = __webpack_require__(166);
var toIndexedObject = __webpack_require__(62);
var arrayMethodIsStrict = __webpack_require__(102);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var lastIndexOf = __webpack_require__(373);

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $map = __webpack_require__(46).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(178);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $reduce = __webpack_require__(210).left;
var arrayMethodIsStrict = __webpack_require__(102);
var CHROME_VERSION = __webpack_require__(143);
var IS_NODE = __webpack_require__(124);

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $reduceRight = __webpack_require__(210).right;
var arrayMethodIsStrict = __webpack_require__(102);
var CHROME_VERSION = __webpack_require__(143);
var IS_NODE = __webpack_require__(124);

var STRICT_METHOD = arrayMethodIsStrict('reduceRight');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var isArray = __webpack_require__(125);

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var isObject = __webpack_require__(15);
var isArray = __webpack_require__(125);
var toAbsoluteIndex = __webpack_require__(109);
var toLength = __webpack_require__(22);
var toIndexedObject = __webpack_require__(62);
var createProperty = __webpack_require__(126);
var wellKnownSymbol = __webpack_require__(20);
var arrayMethodHasSpeciesSupport = __webpack_require__(178);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $some = __webpack_require__(46).some;
var arrayMethodIsStrict = __webpack_require__(102);

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var aFunction = __webpack_require__(58);
var toObject = __webpack_require__(32);
var fails = __webpack_require__(6);
var arrayMethodIsStrict = __webpack_require__(102);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD;

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(109);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(22);
var toObject = __webpack_require__(32);
var arraySpeciesCreate = __webpack_require__(174);
var createProperty = __webpack_require__(126);
var arrayMethodHasSpeciesSupport = __webpack_require__(178);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var setSpecies = __webpack_require__(144);

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies('Array');


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(113);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(113);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var bind = __webpack_require__(375);

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var defineProperty = __webpack_require__(25).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(15);
var definePropertyModule = __webpack_require__(25);
var getPrototypeOf = __webpack_require__(74);
var wellKnownSymbol = __webpack_require__(20);

var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype = Function.prototype;

// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!(HAS_INSTANCE in FunctionPrototype)) {
  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: function (O) {
    if (typeof this != 'function' || !isObject(O)) return false;
    if (!isObject(this.prototype)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
    return false;
  } });
}


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var global = __webpack_require__(9);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var assign = __webpack_require__(376);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var create = __webpack_require__(94);

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var objectDefinePropertyModile = __webpack_require__(25);

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var defineProperties = __webpack_require__(268);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var $entries = __webpack_require__(377).entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var FREEZING = __webpack_require__(179);
var fails = __webpack_require__(6);
var isObject = __webpack_require__(15);
var onFreeze = __webpack_require__(127).onFreeze;

var nativeFreeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { nativeFreeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return nativeFreeze && isObject(it) ? nativeFreeze(onFreeze(it)) : it;
  }
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var iterate = __webpack_require__(112);
var createProperty = __webpack_require__(126);

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var toIndexedObject = __webpack_require__(62);
var nativeGetOwnPropertyDescriptor = __webpack_require__(48).f;
var DESCRIPTORS = __webpack_require__(19);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var ownKeys = __webpack_require__(264);
var toIndexedObject = __webpack_require__(62);
var getOwnPropertyDescriptorModule = __webpack_require__(48);
var createProperty = __webpack_require__(126);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var nativeGetOwnPropertyNames = __webpack_require__(365).f;

var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: nativeGetOwnPropertyNames
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var toObject = __webpack_require__(32);
var nativeGetPrototypeOf = __webpack_require__(74);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(269);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var is = __webpack_require__(378);

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({ target: 'Object', stat: true }, {
  is: is
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var isObject = __webpack_require__(15);

var nativeIsExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { nativeIsExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  isExtensible: function isExtensible(it) {
    return isObject(it) ? nativeIsExtensible ? nativeIsExtensible(it) : true : false;
  }
});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var isObject = __webpack_require__(15);

var nativeIsFrozen = Object.isFrozen;
var FAILS_ON_PRIMITIVES = fails(function () { nativeIsFrozen(1); });

// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  isFrozen: function isFrozen(it) {
    return isObject(it) ? nativeIsFrozen ? nativeIsFrozen(it) : false : true;
  }
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var isObject = __webpack_require__(15);

var nativeIsSealed = Object.isSealed;
var FAILS_ON_PRIMITIVES = fails(function () { nativeIsSealed(1); });

// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  isSealed: function isSealed(it) {
    return isObject(it) ? nativeIsSealed ? nativeIsSealed(it) : false : true;
  }
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var toObject = __webpack_require__(32);
var nativeKeys = __webpack_require__(173);
var fails = __webpack_require__(6);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var isObject = __webpack_require__(15);
var onFreeze = __webpack_require__(127).onFreeze;
var FREEZING = __webpack_require__(179);
var fails = __webpack_require__(6);

var nativePreventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES = fails(function () { nativePreventExtensions(1); });

// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(it) {
    return nativePreventExtensions && isObject(it) ? nativePreventExtensions(onFreeze(it)) : it;
  }
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var isObject = __webpack_require__(15);
var onFreeze = __webpack_require__(127).onFreeze;
var FREEZING = __webpack_require__(179);
var fails = __webpack_require__(6);

var nativeSeal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function () { nativeSeal(1); });

// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  seal: function seal(it) {
    return nativeSeal && isObject(it) ? nativeSeal(onFreeze(it)) : it;
  }
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var setPrototypeOf = __webpack_require__(111);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var $values = __webpack_require__(377).values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(271);
var redefine = __webpack_require__(51);
var toString = __webpack_require__(694);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(271);
var classof = __webpack_require__(177);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var FORCED = __webpack_require__(212);
var toObject = __webpack_require__(32);
var aFunction = __webpack_require__(58);
var definePropertyModule = __webpack_require__(25);

// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var FORCED = __webpack_require__(212);
var toObject = __webpack_require__(32);
var aFunction = __webpack_require__(58);
var definePropertyModule = __webpack_require__(25);

// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var FORCED = __webpack_require__(212);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(81);
var getPrototypeOf = __webpack_require__(74);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject(this);
      var key = toPrimitive(P, true);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
      } while (O = getPrototypeOf(O));
    }
  });
}


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var FORCED = __webpack_require__(212);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(81);
var getPrototypeOf = __webpack_require__(74);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var key = toPrimitive(P, true);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
      } while (O = getPrototypeOf(O));
    }
  });
}


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(109);

var fromCharCode = String.fromCharCode;
var nativeFromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!nativeFromCodePoint && nativeFromCodePoint.length != 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError(code + ' is not a valid code point');
      elements.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00)
      );
    } return elements.join('');
  }
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var toIndexedObject = __webpack_require__(62);
var toLength = __webpack_require__(22);

// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$({ target: 'String', stat: true }, {
  raw: function raw(template) {
    var rawTemplate = toIndexedObject(template.raw);
    var literalSegments = toLength(rawTemplate.length);
    var argumentsLength = arguments.length;
    var elements = [];
    var i = 0;
    while (literalSegments > i) {
      elements.push(String(rawTemplate[i++]));
      if (i < argumentsLength) elements.push(String(arguments[i]));
    } return elements.join('');
  }
});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var codeAt = __webpack_require__(213).codeAt;

// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var getOwnPropertyDescriptor = __webpack_require__(48).f;
var toLength = __webpack_require__(22);
var notARegExp = __webpack_require__(275);
var requireObjectCoercible = __webpack_require__(49);
var correctIsRegExpLogic = __webpack_require__(276);
var IS_PURE = __webpack_require__(72);

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var notARegExp = __webpack_require__(275);
var requireObjectCoercible = __webpack_require__(49);
var correctIsRegExpLogic = __webpack_require__(276);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(214);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(22);
var requireObjectCoercible = __webpack_require__(49);
var advanceStringIndex = __webpack_require__(217);
var regExpExec = __webpack_require__(218);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createIteratorConstructor = __webpack_require__(274);
var requireObjectCoercible = __webpack_require__(49);
var toLength = __webpack_require__(22);
var aFunction = __webpack_require__(58);
var anObject = __webpack_require__(16);
var classof = __webpack_require__(101);
var isRegExp = __webpack_require__(180);
var getRegExpFlags = __webpack_require__(145);
var createNonEnumerableProperty = __webpack_require__(50);
var fails = __webpack_require__(6);
var wellKnownSymbol = __webpack_require__(20);
var speciesConstructor = __webpack_require__(103);
var advanceStringIndex = __webpack_require__(217);
var InternalStateModule = __webpack_require__(57);
var IS_PURE = __webpack_require__(72);

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var regExpBuiltinExec = RegExpPrototype.exec;
var nativeMatchAll = ''.matchAll;

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  'a'.matchAll(/./);
});

var regExpExec = function (R, S) {
  var exec = R.exec;
  var result;
  if (typeof exec == 'function') {
    result = exec.call(R, S);
    if (typeof result != 'object') throw TypeError('Incorrect exec result');
    return result;
  } return regExpBuiltinExec.call(R, S);
};

// eslint-disable-next-line max-len -- ignore
var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return { value: undefined, done: true };
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) return { value: undefined, done: state.done = true };
  if (state.global) {
    if (String(match[0]) == '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return { value: match, done: false };
  }
  state.done = true;
  return { value: match, done: false };
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = String(string);
  var C, flagsValue, flags, matcher, global, fullUnicode;
  C = speciesConstructor(R, RegExp);
  flagsValue = R.flags;
  if (flagsValue === undefined && R instanceof RegExp && !('flags' in RegExpPrototype)) {
    flagsValue = getRegExpFlags.call(R);
  }
  flags = flagsValue === undefined ? '' : String(flagsValue);
  matcher = new C(C === RegExp ? R.source : R, flags);
  global = !!~flags.indexOf('g');
  fullUnicode = !!~flags.indexOf('u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (regexp != null) {
      if (isRegExp(regexp)) {
        flags = String(requireObjectCoercible('flags' in RegExpPrototype
          ? regexp.flags
          : getRegExpFlags.call(regexp)
        ));
        if (!~flags.indexOf('g')) throw TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll.apply(O, arguments);
      matcher = regexp[MATCH_ALL];
      if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher != null) return aFunction(matcher).call(regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll.apply(O, arguments);
    S = String(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? $matchAll.call(rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || createNonEnumerableProperty(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $padEnd = __webpack_require__(278).end;
var WEBKIT_BUG = __webpack_require__(379);

// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $padStart = __webpack_require__(278).start;
var WEBKIT_BUG = __webpack_require__(379);

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var repeat = __webpack_require__(279);

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(214);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(22);
var toInteger = __webpack_require__(73);
var requireObjectCoercible = __webpack_require__(49);
var advanceStringIndex = __webpack_require__(217);
var getSubstitution = __webpack_require__(380);
var regExpExec = __webpack_require__(218);

var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(214);
var anObject = __webpack_require__(16);
var requireObjectCoercible = __webpack_require__(49);
var sameValue = __webpack_require__(378);
var regExpExec = __webpack_require__(218);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(214);
var isRegExp = __webpack_require__(180);
var anObject = __webpack_require__(16);
var requireObjectCoercible = __webpack_require__(49);
var speciesConstructor = __webpack_require__(103);
var advanceStringIndex = __webpack_require__(217);
var toLength = __webpack_require__(22);
var callRegExpExec = __webpack_require__(218);
var regexpExec = __webpack_require__(215);
var fails = __webpack_require__(6);

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var getOwnPropertyDescriptor = __webpack_require__(48).f;
var toLength = __webpack_require__(22);
var notARegExp = __webpack_require__(275);
var requireObjectCoercible = __webpack_require__(49);
var correctIsRegExpLogic = __webpack_require__(276);
var IS_PURE = __webpack_require__(72);

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $trim = __webpack_require__(146).trim;
var forcedStringTrimMethod = __webpack_require__(280);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $trimStart = __webpack_require__(146).start;
var forcedStringTrimMethod = __webpack_require__(280);

var FORCED = forcedStringTrimMethod('trimStart');

var trimStart = FORCED ? function trimStart() {
  return $trimStart(this);
} : ''.trimStart;

// `String.prototype.{ trimStart, trimLeft }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$({ target: 'String', proto: true, forced: FORCED }, {
  trimStart: trimStart,
  trimLeft: trimStart
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var $trimEnd = __webpack_require__(146).end;
var forcedStringTrimMethod = __webpack_require__(280);

var FORCED = forcedStringTrimMethod('trimEnd');

var trimEnd = FORCED ? function trimEnd() {
  return $trimEnd(this);
} : ''.trimEnd;

// `String.prototype.{ trimEnd, trimRight }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$({ target: 'String', proto: true, forced: FORCED }, {
  trimEnd: trimEnd,
  trimRight: trimEnd
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('blink') }, {
  blink: function blink() {
    return createHTML(this, 'blink', '', '');
  }
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontcolor') }, {
  fontcolor: function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  }
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontsize') }, {
  fontsize: function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  }
});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
  italics: function italics() {
    return createHTML(this, 'i', '', '');
  }
});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
  strike: function strike() {
    return createHTML(this, 'strike', '', '');
  }
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var createHTML = __webpack_require__(64);
var forcedStringHTMLMethod = __webpack_require__(65);

// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
  sup: function sup() {
    return createHTML(this, 'sup', '', '');
  }
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var requireObjectCoercible = __webpack_require__(49);
var isRegExp = __webpack_require__(180);
var getRegExpFlags = __webpack_require__(145);
var getSubstitution = __webpack_require__(380);
var wellKnownSymbol = __webpack_require__(20);
var IS_PURE = __webpack_require__(72);

var REPLACE = wellKnownSymbol('replace');
var RegExpPrototype = RegExp.prototype;
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return string.indexOf(searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (searchValue != null) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = String(requireObjectCoercible('flags' in RegExpPrototype
          ? searchValue.flags
          : getRegExpFlags.call(searchValue)
        ));
        if (!~flags.indexOf('g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = searchValue[REPLACE];
      if (replacer !== undefined) {
        return replacer.call(searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return String(O).replace(searchValue, replaceValue);
      }
    }
    string = String(O);
    searchString = String(searchValue);
    functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      if (functionalReplace) {
        replacement = String(replaceValue(searchString, position, string));
      } else {
        replacement = getSubstitution(searchString, string, position, [], undefined, replaceValue);
      }
      result += string.slice(endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += string.slice(endOfLastMatch);
    }
    return result;
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var global = __webpack_require__(9);
var isForced = __webpack_require__(171);
var inheritIfRequired = __webpack_require__(220);
var defineProperty = __webpack_require__(25).f;
var getOwnPropertyNames = __webpack_require__(123).f;
var isRegExp = __webpack_require__(180);
var getFlags = __webpack_require__(145);
var stickyHelpers = __webpack_require__(216);
var redefine = __webpack_require__(51);
var fails = __webpack_require__(6);
var setInternalState = __webpack_require__(57).set;
var setSpecies = __webpack_require__(144);
var wellKnownSymbol = __webpack_require__(20);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var objectDefinePropertyModule = __webpack_require__(25);
var regExpFlags = __webpack_require__(145);
var UNSUPPORTED_Y = __webpack_require__(216).UNSUPPORTED_Y;

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (DESCRIPTORS && (/./g.flags != 'g' || UNSUPPORTED_Y)) {
  objectDefinePropertyModule.f(RegExp.prototype, 'flags', {
    configurable: true,
    get: regExpFlags
  });
}


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var UNSUPPORTED_Y = __webpack_require__(216).UNSUPPORTED_Y;
var defineProperty = __webpack_require__(25).f;
var getInternalState = __webpack_require__(57).get;
var RegExpPrototype = RegExp.prototype;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && UNSUPPORTED_Y) {
  defineProperty(RegExp.prototype, 'sticky', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (this instanceof RegExp) {
        return !!getInternalState(this).sticky;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(277);
var $ = __webpack_require__(3);
var isObject = __webpack_require__(15);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (str) {
    if (typeof this.exec !== 'function') {
      return nativeTest.call(this, str);
    }
    var result = this.exec(str);
    if (result !== null && !isObject(result)) {
      throw new Error('RegExp exec method returned something other than an Object or null');
    }
    return !!result;
  }
});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__(51);
var anObject = __webpack_require__(16);
var fails = __webpack_require__(6);
var flags = __webpack_require__(145);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var parseIntImplementation = __webpack_require__(382);

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var parseFloatImplementation = __webpack_require__(383);

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(19);
var global = __webpack_require__(9);
var isForced = __webpack_require__(171);
var redefine = __webpack_require__(51);
var has = __webpack_require__(37);
var classof = __webpack_require__(101);
var inheritIfRequired = __webpack_require__(220);
var toPrimitive = __webpack_require__(81);
var fails = __webpack_require__(6);
var create = __webpack_require__(94);
var getOwnPropertyNames = __webpack_require__(123).f;
var getOwnPropertyDescriptor = __webpack_require__(48).f;
var defineProperty = __webpack_require__(25).f;
var trim = __webpack_require__(146).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$({ target: 'Number', stat: true }, {
  EPSILON: Math.pow(2, -52)
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var numberIsFinite = __webpack_require__(740);

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var isInteger = __webpack_require__(384);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var isInteger = __webpack_require__(384);

var abs = Math.abs;

// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$({ target: 'Number', stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
  }
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$({ target: 'Number', stat: true }, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var parseFloat = __webpack_require__(383);

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
$({ target: 'Number', stat: true, forced: Number.parseFloat != parseFloat }, {
  parseFloat: parseFloat
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var parseInt = __webpack_require__(382);

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var toInteger = __webpack_require__(73);
var thisNumberValue = __webpack_require__(385);
var repeat = __webpack_require__(279);
var fails = __webpack_require__(6);

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var thisNumberValue = __webpack_require__(385);

var nativeToPrecision = 1.0.toPrecision;

var FORCED = fails(function () {
  // IE7-
  return nativeToPrecision.call(1, undefined) !== '1';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToPrecision.call({});
});

// `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision
$({ target: 'Number', proto: true, forced: FORCED }, {
  toPrecision: function toPrecision(precision) {
    return precision === undefined
      ? nativeToPrecision.call(thisNumberValue(this))
      : nativeToPrecision.call(thisNumberValue(this), precision);
  }
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var log1p = __webpack_require__(386);

var nativeAcosh = Math.acosh;
var log = Math.log;
var sqrt = Math.sqrt;
var LN2 = Math.LN2;

var FORCED = !nativeAcosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  || Math.floor(nativeAcosh(Number.MAX_VALUE)) != 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  || nativeAcosh(Infinity) != Infinity;

// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$({ target: 'Math', stat: true, forced: FORCED }, {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? log(x) + LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var nativeAsinh = Math.asinh;
var log = Math.log;
var sqrt = Math.sqrt;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : log(x + sqrt(x * x + 1));
}

// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$({ target: 'Math', stat: true, forced: !(nativeAsinh && 1 / nativeAsinh(0) > 0) }, {
  asinh: asinh
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var nativeAtanh = Math.atanh;
var log = Math.log;

// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$({ target: 'Math', stat: true, forced: !(nativeAtanh && 1 / nativeAtanh(-0) < 0) }, {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var sign = __webpack_require__(281);

var abs = Math.abs;
var pow = Math.pow;

// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$({ target: 'Math', stat: true }, {
  cbrt: function cbrt(x) {
    return sign(x = +x) * pow(abs(x), 1 / 3);
  }
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var floor = Math.floor;
var log = Math.log;
var LOG2E = Math.LOG2E;

// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$({ target: 'Math', stat: true }, {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - floor(log(x + 0.5) * LOG2E) : 32;
  }
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var expm1 = __webpack_require__(221);

var nativeCosh = Math.cosh;
var abs = Math.abs;
var E = Math.E;

// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$({ target: 'Math', stat: true, forced: !nativeCosh || nativeCosh(710) === Infinity }, {
  cosh: function cosh(x) {
    var t = expm1(abs(x) - 1) + 1;
    return (t + 1 / (t * E * E)) * (E / 2);
  }
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var expm1 = __webpack_require__(221);

// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
$({ target: 'Math', stat: true, forced: expm1 != Math.expm1 }, { expm1: expm1 });


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fround = __webpack_require__(758);

// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$({ target: 'Math', stat: true }, { fround: fround });


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var sign = __webpack_require__(281);

var abs = Math.abs;
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
module.exports = Math.fround || function fround(x) {
  var $abs = abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var $hypot = Math.hypot;
var abs = Math.abs;
var sqrt = Math.sqrt;

// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity;

// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$({ target: 'Math', stat: true, forced: BUGGY }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  hypot: function hypot(value1, value2) {
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * sqrt(sum);
  }
});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);

var nativeImul = Math.imul;

var FORCED = fails(function () {
  return nativeImul(0xFFFFFFFF, 5) != -5 || nativeImul.length != 2;
});

// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$({ target: 'Math', stat: true, forced: FORCED }, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var log = Math.log;
var LOG10E = Math.LOG10E;

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$({ target: 'Math', stat: true }, {
  log10: function log10(x) {
    return log(x) * LOG10E;
  }
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var log1p = __webpack_require__(386);

// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$({ target: 'Math', stat: true }, { log1p: log1p });


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var log = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$({ target: 'Math', stat: true }, {
  log2: function log2(x) {
    return log(x) / LN2;
  }
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var sign = __webpack_require__(281);

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var expm1 = __webpack_require__(221);

var abs = Math.abs;
var exp = Math.exp;
var E = Math.E;

var FORCED = fails(function () {
  return Math.sinh(-2e-17) != -2e-17;
});

// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$({ target: 'Math', stat: true, forced: FORCED }, {
  sinh: function sinh(x) {
    return abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (E / 2);
  }
});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var expm1 = __webpack_require__(221);

var exp = Math.exp;

// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$({ target: 'Math', stat: true }, {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var setToStringTag = __webpack_require__(82);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: function trunc(it) {
    return (it > 0 ? floor : ceil)(it);
  }
});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(81);

var FORCED = fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
});

// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$({ target: 'Date', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var toISOString = __webpack_require__(772);

// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
  toISOString: toISOString
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);
var padStart = __webpack_require__(278).start;

var abs = Math.abs;
var DatePrototype = Date.prototype;
var getTime = DatePrototype.getTime;
var nativeDateToISOString = DatePrototype.toISOString;

// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
module.exports = (fails(function () {
  return nativeDateToISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  nativeDateToISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var date = this;
  var year = date.getUTCFullYear();
  var milliseconds = date.getUTCMilliseconds();
  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
    '-' + padStart(date.getUTCMonth() + 1, 2, 0) +
    '-' + padStart(date.getUTCDate(), 2, 0) +
    'T' + padStart(date.getUTCHours(), 2, 0) +
    ':' + padStart(date.getUTCMinutes(), 2, 0) +
    ':' + padStart(date.getUTCSeconds(), 2, 0) +
    '.' + padStart(milliseconds, 3, 0) +
    'Z';
} : nativeDateToISOString;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(51);

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(50);
var dateToPrimitive = __webpack_require__(775);
var wellKnownSymbol = __webpack_require__(20);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!(TO_PRIMITIVE in DatePrototype)) {
  createNonEnumerableProperty(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(81);

module.exports = function (hint) {
  if (hint !== 'string' && hint !== 'number' && hint !== 'default') {
    throw TypeError('Incorrect hint');
  } return toPrimitive(anObject(this), hint !== 'number');
};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var getBuiltIn = __webpack_require__(63);
var fails = __webpack_require__(6);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var setToStringTag = __webpack_require__(82);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var IS_PURE = __webpack_require__(72);
var global = __webpack_require__(9);
var getBuiltIn = __webpack_require__(63);
var NativePromise = __webpack_require__(387);
var redefine = __webpack_require__(51);
var redefineAll = __webpack_require__(147);
var setToStringTag = __webpack_require__(82);
var setSpecies = __webpack_require__(144);
var isObject = __webpack_require__(15);
var aFunction = __webpack_require__(58);
var anInstance = __webpack_require__(114);
var inspectSource = __webpack_require__(261);
var iterate = __webpack_require__(112);
var checkCorrectnessOfIteration = __webpack_require__(209);
var speciesConstructor = __webpack_require__(103);
var task = __webpack_require__(282).set;
var microtask = __webpack_require__(389);
var promiseResolve = __webpack_require__(390);
var hostReportErrors = __webpack_require__(780);
var newPromiseCapabilityModule = __webpack_require__(222);
var perform = __webpack_require__(283);
var InternalStateModule = __webpack_require__(57);
var isForced = __webpack_require__(171);
var wellKnownSymbol = __webpack_require__(20);
var IS_NODE = __webpack_require__(124);
var V8_VERSION = __webpack_require__(143);

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && !NATIVE_REJECTION_EVENT) return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(172);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var aFunction = __webpack_require__(58);
var newPromiseCapabilityModule = __webpack_require__(222);
var perform = __webpack_require__(283);
var iterate = __webpack_require__(112);

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var aFunction = __webpack_require__(58);
var getBuiltIn = __webpack_require__(63);
var newPromiseCapabilityModule = __webpack_require__(222);
var perform = __webpack_require__(283);
var iterate = __webpack_require__(112);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var IS_PURE = __webpack_require__(72);
var NativePromise = __webpack_require__(387);
var fails = __webpack_require__(6);
var getBuiltIn = __webpack_require__(63);
var speciesConstructor = __webpack_require__(103);
var promiseResolve = __webpack_require__(390);
var redefine = __webpack_require__(51);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(223);
var collectionStrong = __webpack_require__(391);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(223);
var collectionStrong = __webpack_require__(391);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var redefineAll = __webpack_require__(147);
var InternalMetadataModule = __webpack_require__(127);
var collection = __webpack_require__(223);
var collectionWeak = __webpack_require__(392);
var isObject = __webpack_require__(15);
var enforceIternalState = __webpack_require__(57).enforce;
var NATIVE_WEAK_MAP = __webpack_require__(360);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(223);
var collectionWeak = __webpack_require__(392);

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var arrayBufferModule = __webpack_require__(224);
var setSpecies = __webpack_require__(144);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),
/* 789 */
/***/ (function(module, exports) {

// IEEE754 conversions based on https://github.com/feross/ieee754
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = new Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    if (number * (c = pow(2, -exponent)) < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ArrayBufferViewCore = __webpack_require__(21);

var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

// `ArrayBuffer.isView` method
// https://tc39.es/ecma262/#sec-arraybuffer.isview
$({ target: 'ArrayBuffer', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
  isView: ArrayBufferViewCore.isView
});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);
var fails = __webpack_require__(6);
var ArrayBufferModule = __webpack_require__(224);
var anObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(109);
var toLength = __webpack_require__(22);
var speciesConstructor = __webpack_require__(103);

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var nativeArrayBufferSlice = ArrayBuffer.prototype.slice;

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice !== undefined && end === undefined) {
      return nativeArrayBufferSlice.call(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      viewTarget.setUint8(index++, viewSource.getUint8(first++));
    } return result;
  }
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ArrayBufferModule = __webpack_require__(224);
var NATIVE_ARRAY_BUFFER = __webpack_require__(284);

// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
$({ global: true, forced: !NATIVE_ARRAY_BUFFER }, {
  DataView: ArrayBufferModule.DataView
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);

module.exports = function (it) {
  var result = toInteger(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var createTypedArrayConstructor = __webpack_require__(104);

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float64', function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(285);
var exportTypedArrayStaticMethod = __webpack_require__(21).exportTypedArrayStaticMethod;
var typedArrayFrom = __webpack_require__(395);

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(285);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;

// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
exportTypedArrayStaticMethod('of', function of(/* ...items */) {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor(this))(length);
  while (length > index) result[index] = arguments[index++];
  return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $copyWithin = __webpack_require__(370);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return $copyWithin.call(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $every = __webpack_require__(46).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $fill = __webpack_require__(272);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  return $fill.apply(aTypedArray(this), arguments);
});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $filter = __webpack_require__(46).filter;
var fromSpeciesAndList = __webpack_require__(809);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var aTypedArrayConstructor = __webpack_require__(21).aTypedArrayConstructor;
var speciesConstructor = __webpack_require__(103);

module.exports = function (instance, list) {
  var C = speciesConstructor(instance, instance.constructor);
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $find = __webpack_require__(46).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $findIndex = __webpack_require__(46).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $forEach = __webpack_require__(46).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $includes = __webpack_require__(170).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $indexOf = __webpack_require__(170).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var ArrayBufferViewCore = __webpack_require__(21);
var ArrayIterators = __webpack_require__(211);
var wellKnownSymbol = __webpack_require__(20);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = ArrayIterators.values;
var arrayKeys = ArrayIterators.keys;
var arrayEntries = ArrayIterators.entries;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var nativeTypedArrayIterator = Uint8Array && Uint8Array.prototype[ITERATOR];

var CORRECT_ITER_NAME = !!nativeTypedArrayIterator
  && (nativeTypedArrayIterator.name == 'values' || nativeTypedArrayIterator.name == undefined);

var typedArrayValues = function values() {
  return arrayValues.call(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries.call(aTypedArray(this));
});
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys.call(aTypedArray(this));
});
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, !CORRECT_ITER_NAME);
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, !CORRECT_ITER_NAME);


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = [].join;

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('join', function join(separator) {
  return $join.apply(aTypedArray(this), arguments);
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $lastIndexOf = __webpack_require__(373);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  return $lastIndexOf.apply(aTypedArray(this), arguments);
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $map = __webpack_require__(46).map;
var speciesConstructor = __webpack_require__(103);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (aTypedArrayConstructor(speciesConstructor(O, O.constructor)))(length);
  });
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $reduce = __webpack_require__(210).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  return $reduce(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $reduceRight = __webpack_require__(210).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRicht` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  return $reduceRight(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var toLength = __webpack_require__(22);
var toOffset = __webpack_require__(394);
var toObject = __webpack_require__(32);
var fails = __webpack_require__(6);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  /* global Int8Array -- safe */
  new Int8Array(1).set({});
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var length = this.length;
  var src = toObject(arrayLike);
  var len = toLength(src.length);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, FORCED);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var speciesConstructor = __webpack_require__(103);
var fails = __webpack_require__(6);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $slice = [].slice;

var FORCED = fails(function () {
  /* global Int8Array -- safe */
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = $slice.call(aTypedArray(this), start, end);
  var C = speciesConstructor(this, this.constructor);
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var $some = __webpack_require__(46).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $sort = [].sort;

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  return $sort.call(aTypedArray(this), comparefn);
});


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(21);
var toLength = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(109);
var speciesConstructor = __webpack_require__(103);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  return new (speciesConstructor(O, O.constructor))(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var ArrayBufferViewCore = __webpack_require__(21);
var fails = __webpack_require__(6);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var $slice = [].slice;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return $toLocaleString.apply(TO_LOCALE_STRING_BUG ? $slice.call(aTypedArray(this)) : aTypedArray(this), arguments);
}, FORCED);


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exportTypedArrayMethod = __webpack_require__(21).exportTypedArrayMethod;
var fails = __webpack_require__(6);
var global = __webpack_require__(9);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var arrayJoin = [].join;

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return arrayJoin.call(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var getBuiltIn = __webpack_require__(63);
var aFunction = __webpack_require__(58);
var anObject = __webpack_require__(16);
var fails = __webpack_require__(6);

var nativeApply = getBuiltIn('Reflect', 'apply');
var functionApply = Function.apply;

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  nativeApply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    aFunction(target);
    anObject(argumentsList);
    return nativeApply
      ? nativeApply(target, thisArgument, argumentsList)
      : functionApply.call(target, thisArgument, argumentsList);
  }
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var getBuiltIn = __webpack_require__(63);
var aFunction = __webpack_require__(58);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(15);
var create = __webpack_require__(94);
var bind = __webpack_require__(375);
var fails = __webpack_require__(6);

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(81);
var definePropertyModule = __webpack_require__(25);
var fails = __webpack_require__(6);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var ERROR_INSTEAD_OF_FALSE = fails(function () {
  /* global Reflect -- required for testing */
  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
});

// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      definePropertyModule.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var anObject = __webpack_require__(16);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$({ target: 'Reflect', stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var isObject = __webpack_require__(15);
var anObject = __webpack_require__(16);
var has = __webpack_require__(37);
var getOwnPropertyDescriptorModule = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(74);

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  if (descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey)) return has(descriptor, 'value')
    ? descriptor.value
    : descriptor.get === undefined
      ? undefined
      : descriptor.get.call(receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var anObject = __webpack_require__(16);
var getOwnPropertyDescriptorModule = __webpack_require__(48);

// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$({ target: 'Reflect', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var anObject = __webpack_require__(16);
var objectGetPrototypeOf = __webpack_require__(74);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(269);

// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$({ target: 'Reflect', stat: true }, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var anObject = __webpack_require__(16);

var objectIsExtensible = Object.isExtensible;

// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$({ target: 'Reflect', stat: true }, {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return objectIsExtensible ? objectIsExtensible(target) : true;
  }
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ownKeys = __webpack_require__(264);

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var getBuiltIn = __webpack_require__(63);
var anObject = __webpack_require__(16);
var FREEZING = __webpack_require__(179);

// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$({ target: 'Reflect', stat: true, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(15);
var has = __webpack_require__(37);
var fails = __webpack_require__(6);
var definePropertyModule = __webpack_require__(25);
var getOwnPropertyDescriptorModule = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(74);
var createPropertyDescriptor = __webpack_require__(100);

// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  var existingDescriptor, prototype;
  if (!ownDescriptor) {
    if (isObject(prototype = getPrototypeOf(target))) {
      return set(prototype, propertyKey, V, receiver);
    }
    ownDescriptor = createPropertyDescriptor(0);
  }
  if (has(ownDescriptor, 'value')) {
    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
    return true;
  }
  return ownDescriptor.set === undefined ? false : (ownDescriptor.set.call(receiver, V), true);
}

// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails(function () {
  var Constructor = function () { /* empty */ };
  var object = definePropertyModule.f(new Constructor(), 'a', { configurable: true });
  /* global Reflect -- required for testing */
  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});

$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
  set: set
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var anObject = __webpack_require__(16);
var aPossiblePrototype = __webpack_require__(367);
var objectSetPrototypeOf = __webpack_require__(111);

// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if (objectSetPrototypeOf) $({ target: 'Reflect', stat: true }, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject(target);
    aPossiblePrototype(proto);
    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var setToStringTag = __webpack_require__(82);

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(852);
__webpack_require__(398);
var path = __webpack_require__(169);

module.exports = path;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var DOMIterables = __webpack_require__(396);
var forEach = __webpack_require__(372);
var createNonEnumerableProperty = __webpack_require__(50);

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var DOMIterables = __webpack_require__(396);
var ArrayIteratorMethods = __webpack_require__(211);
var createNonEnumerableProperty = __webpack_require__(50);
var wellKnownSymbol = __webpack_require__(20);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var task = __webpack_require__(282);

var FORCED = !global.setImmediate || !global.clearImmediate;

// http://w3c.github.io/setImmediate/
$({ global: true, bind: true, enumerable: true, forced: FORCED }, {
  // `setImmediate` method
  // http://w3c.github.io/setImmediate/#si-setImmediate
  setImmediate: task.set,
  // `clearImmediate` method
  // http://w3c.github.io/setImmediate/#si-clearImmediate
  clearImmediate: task.clear
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var microtask = __webpack_require__(389);
var IS_NODE = __webpack_require__(124);

var process = global.process;

// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$({ global: true, enumerable: true, noTargetGet: true }, {
  queueMicrotask: function queueMicrotask(fn) {
    var domain = IS_NODE && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var global = __webpack_require__(9);
var userAgent = __webpack_require__(172);

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(381);
var $ = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(19);
var USE_NATIVE_URL = __webpack_require__(397);
var global = __webpack_require__(9);
var defineProperties = __webpack_require__(268);
var redefine = __webpack_require__(51);
var anInstance = __webpack_require__(114);
var has = __webpack_require__(37);
var assign = __webpack_require__(376);
var arrayFrom = __webpack_require__(369);
var codeAt = __webpack_require__(213).codeAt;
var toASCII = __webpack_require__(850);
var setToStringTag = __webpack_require__(82);
var URLSearchParamsModule = __webpack_require__(398);
var InternalStateModule = __webpack_require__(57);

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
/* eslint-disable no-control-regex -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\t\u000A\u000D #%/:?@[\\]]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\t\u000A\u000D #/:?@[\\]]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
var TAB_AND_NEW_LINE = /[\t\u000A\u000D]/g;
/* eslint-enable no-control-regex -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var getIteratorMethod = __webpack_require__(176);

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(3);

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return URL.prototype.toString.call(this);
  }
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _includes = _interopRequireDefault(__webpack_require__(52));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _underscore = _interopRequireDefault(__webpack_require__(229));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _createAuthClient = _interopRequireDefault(__webpack_require__(1103));

var _buildRenderOptions = _interopRequireDefault(__webpack_require__(1104));

var _createRouter = _interopRequireDefault(__webpack_require__(1105));

var _LoginRouter = _interopRequireDefault(__webpack_require__(1111));

var _WidgetRouter = _interopRequireDefault(__webpack_require__(1232));

var EVENTS_LIST = ['ready', 'afterError', 'afterRender'];

var OktaSignIn = function () {
  var router;

  function getProperties(authClient, Router) {
    var widgetOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // Returns a promise that will resolve on success or reject on error
    function render(renderOptions, successFn, errorFn) {
      if (router) {
        throw new Error('An instance of the widget has already been rendered. Call remove() first.');
      }

      var res = (0, _createRouter.default)(Router, widgetOptions, renderOptions, authClient, successFn, errorFn);
      router = res.router;
      return res.promise;
    }

    function hide() {
      if (router) {
        router.hide();
      }
    }

    function show() {
      if (router) {
        router.show();
      }
    }

    function remove() {
      if (router) {
        router.remove();
        router = undefined;
      }
    }
    /**
     * Renders the Widget and returns a promise that resolves to OAuth tokens
     * @param options - options for the signin widget
     */


    function showSignInToGetTokens() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var renderOptions = (0, _assign.default)((0, _buildRenderOptions.default)(widgetOptions, options), {
        redirect: 'never'
      });
      var promise = this.renderEl(renderOptions).then(function (res) {
        return res.tokens;
      });
      var authClient = router.settings.getAuthClient();

      if (authClient.isAuthorizationCodeFlow() && !authClient.isPKCE()) {
        throw new _Errors.default.ConfigError('"showSignInToGetTokens()" should not be used for authorization_code flow. ' + 'Use "showSignInAndRedirect()" instead');
      }

      return promise;
    }
    /**
     * Renders the widget and redirects to the OAuth callback
     * @param options - options for the signin widget
     */


    function showSignInAndRedirect() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var renderOptions = (0, _assign.default)((0, _buildRenderOptions.default)(widgetOptions, options), {
        redirect: 'always'
      });
      return this.renderEl(renderOptions);
    }
    /**
     * Renders the widget. Either resolves the returned promise, or redirects.
     * @param options - options for the signin widget
     */


    function showSignIn() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var renderOptions = (0, _assign.default)((0, _buildRenderOptions.default)(widgetOptions, options));
      return this.renderEl(renderOptions);
    } // Properties exposed on OktaSignIn object.


    return {
      renderEl: render,
      authClient: authClient,
      showSignIn: showSignIn,
      showSignInToGetTokens: showSignInToGetTokens,
      showSignInAndRedirect: showSignInAndRedirect,
      hide: hide,
      show: show,
      remove: remove
    };
  }
  /**
   * Render the sign in widget to an element.
   * @param options - options for the signin widget.
   *        Must have an el or $el property to render the widget to.
   * @param success - success callback function
   * @param error - error callback function
   */


  function OktaSignIn(options) {
    _Util.default.debugMessage("\n        The Okta Sign-In Widget is running in development mode.\n        When you are ready to publish your app, embed the minified version to turn on production mode.\n        See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn\n      ");

    var authParams = _underscore.default.extend({
      clientId: options.clientId,
      redirectUri: options.redirectUri,
      state: options.state,
      scopes: options.scopes
    }, options.authParams);

    if (!authParams.issuer) {
      authParams.issuer = options.baseUrl + '/oauth2/default';
    }

    var authClient = options.authClient ? options.authClient : (0, _createAuthClient.default)(authParams); // validate authClient configuration against widget options

    if (options.useInteractionCodeFlow && authClient.isPKCE() === false) {
      throw new _Errors.default.ConfigError('The "useInteractionCodeFlow" option requires PKCE to be enabled on the authClient.');
    }

    var Router;

    if (options.stateToken && !_Util.default.isV1StateToken(options.stateToken) || // Self hosted widget can use `useInteractionCodeFlow` to use V2Router
    options.useInteractionCodeFlow || options.proxyIdxResponse) {
      Router = _WidgetRouter.default;
    } else {
      Router = _LoginRouter.default;
    }

    _underscore.default.extend(this, Router.prototype.Events, {
      on: function on() {
        for (var _len = arguments.length, onArgs = new Array(_len), _key = 0; _key < _len; _key++) {
          onArgs[_key] = arguments[_key];
        }

        // custom events listener on widget instance to trap third-party callback errors
        var event = onArgs[0],
            callback = onArgs[1];

        if ((0, _includes.default)(EVENTS_LIST).call(EVENTS_LIST, event)) {
          onArgs[1] = function () {
            try {
              for (var _len2 = arguments.length, callbackArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                callbackArgs[_key2] = arguments[_key2];
              }

              callback.apply(this, callbackArgs);
            } catch (err) {
              _Logger.default.error("[okta-signin-widget] \"".concat(event, "\" event handler error:"), err);
            }
          };
        }

        Router.prototype.Events.on.apply(this, onArgs);
      }
    });

    _underscore.default.extend(this, getProperties(authClient, Router, options)); // Triggers the event up the chain so it is available to the consumers of the widget.


    this.listenTo(Router.prototype, 'all', this.trigger); // On the first afterRender event (usually when the Widget is ready) - emit a 'ready' event

    this.once('afterRender', function (context) {
      this.trigger('ready', context);
    });
  }

  return OktaSignIn;
}();

module.exports = OktaSignIn;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(855);

module.exports = parent;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var arrayIncludes = __webpack_require__(856);
var stringIncludes = __webpack_require__(858);

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.includes)) return arrayIncludes;
  if (typeof it === 'string' || it === StringPrototype || (it instanceof String && own === StringPrototype.includes)) {
    return stringIncludes;
  } return own;
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(857);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').includes;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $includes = __webpack_require__(287).includes;
var addToUnscopables = __webpack_require__(181);
var arrayMethodUsesToLength = __webpack_require__(67);

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(859);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('String').includes;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var notARegExp = __webpack_require__(289);
var requireObjectCoercible = __webpack_require__(131);
var correctIsRegExpLogic = __webpack_require__(292);

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);
var classof = __webpack_require__(130);
var wellKnownSymbol = __webpack_require__(34);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var createNonEnumerableProperty = __webpack_require__(85);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(863);

module.exports = parent;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(864);
var path = __webpack_require__(23);

module.exports = path.Object.assign;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var assign = __webpack_require__(403);

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(295);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```



// Add all of the Underscore functions to the wrapper object.
var _ = Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["mixin"])(__WEBPACK_IMPORTED_MODULE_0__index_js__);
// Legacy Node.js API.
_._ = _;
// Export the Underscore API.
/* harmony default export */ __webpack_exports__["a"] = (_);


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNull;
// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isElement;
// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Date'));


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('RegExp'));


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Error'));


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Object'));


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFinite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(408);



// Is a given object a finite number?
function isFinite(obj) {
  return !Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["f" /* _isFinite */])(obj) && !isNaN(parseFloat(obj));
}


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getByteLength_js__ = __webpack_require__(299);



// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getByteLength_js__["a" /* default */]));


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_js__ = __webpack_require__(47);






// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  // Skip the more expensive `toString`-based type checks if `obj` has no
  // `.length`.
  var length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(obj);
  if (typeof length == 'number' && (
    Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(obj)
  )) return length === 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__keys_js__["a" /* default */])(obj)) === 0;
}


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getByteLength_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isDataView_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keys_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__has_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toBufferView_js__ = __webpack_require__(876);











// We use this string twice, so give it a name for minification.
var tagDataView = '[object DataView]';

// Internal recursive comparison function for `_.isEqual`.
function eq(a, b, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) return a !== 0 || 1 / a === 1 / b;
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) return false;
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) return b !== b;
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
  return deepEq(a, b, aStack, bStack);
}

// Internal recursive comparison function for `_.isEqual`.
function deepEq(a, b, aStack, bStack) {
  // Unwrap any wrapped objects.
  if (a instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) a = a._wrapped;
  if (b instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) b = b._wrapped;
  // Compare `[[Class]]` names.
  var className = __WEBPACK_IMPORTED_MODULE_1__setup_js__["t" /* toString */].call(a);
  if (className !== __WEBPACK_IMPORTED_MODULE_1__setup_js__["t" /* toString */].call(b)) return false;
  // Work around a bug in IE 10 - Edge 13.
  if (__WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__["a" /* hasStringTagBug */] && className == '[object Object]' && Object(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(a)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(b)) return false;
    className = tagDataView;
  }
  switch (className) {
    // These types are compared by value.
    case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case '[object String]':
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return '' + a === '' + b;
    case '[object Number]':
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) return +b !== +b;
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case '[object Symbol]':
      return __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* SymbolProto */].valueOf.call(a) === __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* SymbolProto */].valueOf.call(b);
    case '[object ArrayBuffer]':
    case tagDataView:
      // Coerce to typed array so we can fall through.
      return deepEq(Object(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(a), Object(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(b), aStack, bStack);
  }

  var areArrays = className === '[object Array]';
  if (!areArrays && Object(__WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__["a" /* default */])(a)) {
      var byteLength = Object(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(a);
      if (byteLength !== Object(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(b)) return false;
      if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
      areArrays = true;
  }
  if (!areArrays) {
    if (typeof a != 'object' || typeof b != 'object') return false;

    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(aCtor) && aCtor instanceof aCtor &&
                             Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(bCtor) && bCtor instanceof bCtor)
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) return bStack[length] === b;
  }

  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);

  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) return false;
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], aStack, bStack)) return false;
    }
  } else {
    // Deep compare objects.
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(a), key;
    length = _keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(b).length !== length) return false;
    while (length--) {
      // Deep compare each member
      key = _keys[length];
      if (!(Object(__WEBPACK_IMPORTED_MODULE_8__has_js__["a" /* default */])(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}

// Perform a deep comparison to check if two objects are equal.
function isEqual(a, b) {
  return eq(a, b);
}


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toBufferView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getByteLength_js__ = __webpack_require__(299);


// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource) {
  return new Uint8Array(
    bufferSource.buffer || bufferSource,
    bufferSource.byteOffset || 0,
    Object(__WEBPACK_IMPORTED_MODULE_0__getByteLength_js__["a" /* default */])(bufferSource)
  );
}


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(300);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["b" /* mapMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Map'));


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(300);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["d" /* weakMapMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakMap'));


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(300);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["c" /* setMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Set'));


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakSet'));


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pairs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(47);


// Convert an object into a list of `[key, value]` pairs.
// The opposite of `_.object` with one argument.
function pairs(obj) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var pairs = Array(length);
  for (var i = 0; i < length; i++) {
    pairs[i] = [_keys[i], obj[_keys[i]]];
  }
  return pairs;
}


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extendOwn_js__ = __webpack_require__(302);



// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(prototype);
  if (props) Object(__WEBPACK_IMPORTED_MODULE_1__extendOwn_js__["a" /* default */])(result, props);
  return result;
}


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tap;
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(186);



// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has(obj, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(obj, key)) return false;
    obj = obj[key];
  }
  return !!length;
}


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(47);



// Returns the results of applying the `iteratee` to each element of `obj`.
// In contrast to `_.map` it returns an object.
function mapObject(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
      length = _keys.length,
      results = {};
  for (var index = 0; index < length; index++) {
    var currentKey = _keys[index];
    results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = propertyOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(423);



// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */];
  return function(path) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = times;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(187);


// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(430);



// Function for escaping strings to HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__ = __webpack_require__(890);



// Function for unescaping strings from HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__["a" /* default */]));


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invert_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(430);



// Internal list of HTML entities for unescaping.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__invert_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = template;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults_js__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templateSettings_js__ = __webpack_require__(431);




// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch = /(.)^/;

// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes = {
  "'": "'",
  '\\': '\\',
  '\r': 'r',
  '\n': 'n',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

function escapeChar(match) {
  return '\\' + escapes[match];
}

// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var bareIdentifier = /^\s*(\w|\$)+\s*$/;

// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template(text, settings, oldSettings) {
  if (!settings && oldSettings) settings = oldSettings;
  settings = Object(__WEBPACK_IMPORTED_MODULE_0__defaults_js__["a" /* default */])({}, settings, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */].templateSettings);

  // Combine delimiters into one regular expression via alternation.
  var matcher = RegExp([
    (settings.escape || noMatch).source,
    (settings.interpolate || noMatch).source,
    (settings.evaluate || noMatch).source
  ].join('|') + '|$', 'g');

  // Compile the template source, escaping string literals appropriately.
  var index = 0;
  var source = "__p+='";
  text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
    source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
    index = offset + match.length;

    if (escape) {
      source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
    } else if (interpolate) {
      source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
    } else if (evaluate) {
      source += "';\n" + evaluate + "\n__p+='";
    }

    // Adobe VMs need the match returned to produce the correct offset.
    return match;
  });
  source += "';\n";

  var argument = settings.variable;
  if (argument) {
    // Insure against third-party code injection. (CVE-2021-23358)
    if (!bareIdentifier.test(argument)) throw new Error(
      'variable is not a bare identifier: ' + argument
    );
  } else {
    // If a variable is not specified, place data values in local scope.
    source = 'with(obj||{}){\n' + source + '}\n';
    argument = 'obj';
  }

  source = "var __t,__p='',__j=Array.prototype.join," +
    "print=function(){__p+=__j.call(arguments,'');};\n" +
    source + 'return __p;\n';

  var render;
  try {
    render = new Function(argument, '_', source);
  } catch (e) {
    e.source = source;
    throw e;
  }

  var template = function(data) {
    return render.call(this, data, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */]);
  };

  // Provide the compiled source as a convenience for precompilation.
  template.source = 'function(' + argument + '){\n' + source + '}';

  return template;
}


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = result;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(186);



// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj, path, fallback) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  if (!length) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(prop) ? prop.call(obj) : prop;
  }
  return obj;
}


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniqueId;
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);


// Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = Object(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj);
  instance._chain = true;
  return instance;
}


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind_js__ = __webpack_require__(433);




// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  keys = Object(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(keys, false, false);
  var index = keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = keys[index];
    obj[key] = Object(__WEBPACK_IMPORTED_MODULE_2__bind_js__["a" /* default */])(obj[key], obj);
  }
  return obj;
}));


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(116);


// Memoize an expensive function by storing its results.
function memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__delay_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(69);




// Defers a function, scheduling it to run after the current call stack has
// cleared.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__delay_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */], 1));


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now_js__ = __webpack_require__(306);


// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var _now = Object(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    if (!previous && options.leading === false) previous = _now;
    var remaining = wait - (_now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = _now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function() {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(306);



// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce(func, wait, immediate) {
  var timeout, previous, args, result, context;

  var later = function() {
    var passed = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])() - previous;
    if (wait > passed) {
      timeout = setTimeout(later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) result = func.apply(context, args);
      // This check is needed because `func` can recursively invoke `debounced`.
      if (!timeout) args = context = null;
    }
  };

  var debounced = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(_args) {
    context = this;
    args = _args;
    previous = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (!timeout) {
      timeout = setTimeout(later, wait);
      if (immediate) result = func.apply(context, args);
    }
    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = args = context = null;
  };

  return debounced;
}


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(231);


// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(wrapper, func);
}


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose() {
  var args = arguments;
  var start = args.length - 1;
  return function() {
    var i = start;
    var result = args[start].apply(this, arguments);
    while (i--) result = args[i].call(this, result);
    return result;
  };
}


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = after;
// Returns a function that will only be executed on and after the Nth call.
function after(times, func) {
  return function() {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__before_js__ = __webpack_require__(435);



// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__before_js__["a" /* default */], 2));


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__ = __webpack_require__(441);



// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__["a" /* default */])(-1, __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__["a" /* default */]));


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findWhere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__find_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(230);



// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__find_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(443);


// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(1));


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(443);


// The right-associative version of reduce, also known as `foldr`.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(-1));


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__negate_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(61);




// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__negate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(predicate)), context);
}


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = every;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(47);




// Determine whether all of the elements pass a truth test.
function every(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = some;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(47);




// Determine if at least one element in the object passes a truth test.
function some(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }
  return false;
}


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepGet_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toPath_js__ = __webpack_require__(186);






// Invoke a method (with arguments) on every item in a collection.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, path, args) {
  var contextPath, func;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(path)) {
    func = path;
  } else {
    path = Object(__WEBPACK_IMPORTED_MODULE_4__toPath_js__["a" /* default */])(path);
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = Object(__WEBPACK_IMPORTED_MODULE_3__deepGet_js__["a" /* default */])(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
}));


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = where;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(230);



// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj, attrs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(134);





// Return the minimum element (or element-based computation).
function min(obj, iteratee, context) {
  var result = Infinity, lastComputed = Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value < result) {
        result = value;
      }
    }
  } else {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed < lastComputed || computed === Infinity && result === Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sample_js__ = __webpack_require__(445);


// Shuffle a collection.
function shuffle(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__sample_js__["a" /* default */])(obj, Infinity);
}


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortBy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pluck_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(151);




// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  return Object(__WEBPACK_IMPORTED_MODULE_1__pluck_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function(left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(116);



// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key].push(value); else result[key] = [value];
}));


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(232);


// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  result[key] = value;
}));


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(116);



// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key]++; else result[key] = 1;
}));


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(232);


// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true));


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__identity_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__values_js__ = __webpack_require__(149);








// Safely create a real, live array from anything iterable.
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(obj) {
  if (!obj) return [];
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(obj)) return __WEBPACK_IMPORTED_MODULE_1__setup_js__["q" /* slice */].call(obj);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj)) {
    // Keep surrogate pair characters together.
    return obj.match(reStrSymbol);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(obj)) return Object(__WEBPACK_IMPORTED_MODULE_4__map_js__["a" /* default */])(obj, __WEBPACK_IMPORTED_MODULE_5__identity_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_6__values_js__["a" /* default */])(obj);
}


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = size;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(47);



// Return the number of elements in a collection.
function size(obj) {
  if (obj == null) return 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj.length : Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj).length;
}


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyInObj;
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value, key, obj) {
  return key in obj;
}


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__negate_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flatten_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pick_js__ = __webpack_require__(446);








// Return a copy of the object without the disallowed properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var iteratee = keys[0], context;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__negate_js__["a" /* default */])(iteratee);
    if (keys.length > 1) context = keys[1];
  } else {
    keys = Object(__WEBPACK_IMPORTED_MODULE_3__map_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__flatten_js__["a" /* default */])(keys, false, false), String);
    iteratee = function(value, key) {
      return !Object(__WEBPACK_IMPORTED_MODULE_5__contains_js__["a" /* default */])(keys, key);
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_6__pick_js__["a" /* default */])(obj, iteratee, context);
}));


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = first;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initial_js__ = __webpack_require__(447);


// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[0];
  return Object(__WEBPACK_IMPORTED_MODULE_0__initial_js__["a" /* default */])(array, array.length - n);
}


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_js__ = __webpack_require__(448);


// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return Object(__WEBPACK_IMPORTED_MODULE_0__rest_js__["a" /* default */])(array, Math.max(0, array.length - n));
}


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compact;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(188);


// Trim out all falsy values from an array.
function compact(array) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(array, Boolean);
}


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(150);


// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array, depth) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */])(array, depth, false);
}


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__difference_js__ = __webpack_require__(449);



// Return a version of the array that does not contain the specified value(s).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, otherArrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__difference_js__["a" /* default */])(array, otherArrays);
}));


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uniq_js__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flatten_js__ = __webpack_require__(150);




// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(arrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__uniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__flatten_js__["a" /* default */])(arrays, true, true));
}));


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intersection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contains_js__ = __webpack_require__(189);



// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array); i < length; i++) {
    var item = array[i];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unzip_js__ = __webpack_require__(451);



// Zip together multiple lists into a single array -- elements that share
// an index go together.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unzip_js__["a" /* default */]));


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(77);


// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object(list, values) {
  var result = {};
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start, stop, step) {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var idx = 0; idx < length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chunk;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(30);


// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array, count) {
  if (count == null || count < 1) return [];
  var result = [];
  var i = 0, length = array.length;
  while (i < length) {
    result.push(__WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, i, i += count));
  }
  return result;
}


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chainResult_js__ = __webpack_require__(452);






// Add your own custom functions to the Underscore object.
function mixin(obj) {
  Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__functions_js__["a" /* default */])(obj), function(name) {
    var func = __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */][name] = obj[name];
    __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
      var args = [this._wrapped];
      __WEBPACK_IMPORTED_MODULE_3__setup_js__["o" /* push */].apply(args, arguments);
      return Object(__WEBPACK_IMPORTED_MODULE_4__chainResult_js__["a" /* default */])(this, func.apply(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */], args));
    };
  });
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */];
}


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setup_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chainResult_js__ = __webpack_require__(452);





// Add all mutator `Array` functions to the wrapper.
Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["a" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) {
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) {
        delete obj[0];
      }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

// Add all accessor `Array` functions to the wrapper.
Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['concat', 'join', 'slice'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["a" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) obj = method.apply(obj, arguments);
    return Object(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]);


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(44);
var objectDefinePropertyModile = __webpack_require__(86);

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(939);

module.exports = parent;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var lastIndexOf = __webpack_require__(940);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.lastIndexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.lastIndexOf) ? lastIndexOf : own;
};


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(941);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').lastIndexOf;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var lastIndexOf = __webpack_require__(942);

// `Array.prototype.lastIndexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(83);
var toInteger = __webpack_require__(148);
var toLength = __webpack_require__(66);
var arrayMethodIsStrict = __webpack_require__(135);
var arrayMethodUsesToLength = __webpack_require__(67);

var min = Math.min;
var nativeLastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
// For preventing possible almost infinite loop in non-standard implementations, test the forward version of the method
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return nativeLastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(944);

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(945);

module.exports = parent;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var reverse = __webpack_require__(946);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reverse;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reverse) ? reverse : own;
};


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(947);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').reverse;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var isArray = __webpack_require__(136);

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var toObject = __webpack_require__(75);
var nativeKeys = __webpack_require__(182);
var fails = __webpack_require__(28);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(311);
var classof = __webpack_require__(118);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 951 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(118);
var wellKnownSymbol = __webpack_require__(34);
var Iterators = __webpack_require__(137);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(470);

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var from = __webpack_require__(472);
var checkCorrectnessOfIteration = __webpack_require__(475);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(956);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(957);

module.exports = parent;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(958);
var path = __webpack_require__(23);

module.exports = path.Object.getPrototypeOf;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var fails = __webpack_require__(28);
var toObject = __webpack_require__(75);
var nativeGetPrototypeOf = __webpack_require__(234);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(465);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(960);

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(961);

module.exports = parent;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(962);
var path = __webpack_require__(23);

module.exports = path.Object.setPrototypeOf;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var setPrototypeOf = __webpack_require__(312);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(964);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(965);

module.exports = parent;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(966);
var path = __webpack_require__(23);

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(44);
var create = __webpack_require__(191);

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(476);

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(83);
var nativeGetOwnPropertyNames = __webpack_require__(319).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),
/* 970 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.hasInstance` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.match` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.matchAll` well-known symbol
defineWellKnownSymbol('matchAll');


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.replace` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.search` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.species` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.split` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.toStringTag` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.unscopables` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var setToStringTag = __webpack_require__(106);

// Math[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var setToStringTag = __webpack_require__(106);

// JSON[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(42);

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(42);

defineWellKnownSymbol('replaceAll');


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(990);

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(991);

module.exports = parent;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var flat = __webpack_require__(992);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.flat;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.flat) ? flat : own;
};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(993);
__webpack_require__(995);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').flat;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var flattenIntoArray = __webpack_require__(994);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(66);
var toInteger = __webpack_require__(148);
var arraySpeciesCreate = __webpack_require__(235);

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(136);
var toLength = __webpack_require__(66);
var bind = __webpack_require__(115);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(181);

addToUnscopables('flat');


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(997);

module.exports = parent;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var flags = __webpack_require__(998);

var RegExpPrototype = RegExp.prototype;

module.exports = function (it) {
  return (it === RegExpPrototype || it instanceof RegExp) && !('flags' in it) ? flags(it) : it.flags;
};


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(999);
var flags = __webpack_require__(1000);

module.exports = function (it) {
  return flags.call(it);
};


/***/ }),
/* 999 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(53);

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var isArray = __webpack_require__(136);

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1003);

module.exports = parent;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1004);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').forEach;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var forEach = __webpack_require__(1005);

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(97).forEach;
var arrayMethodIsStrict = __webpack_require__(135);
var arrayMethodUsesToLength = __webpack_require__(67);

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1007);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1008);

module.exports = parent;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var every = __webpack_require__(1009);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.every;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.every) ? every : own;
};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1010);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').every;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $every = __webpack_require__(97).every;
var arrayMethodIsStrict = __webpack_require__(135);
var arrayMethodUsesToLength = __webpack_require__(67);

var STRICT_METHOD = arrayMethodIsStrict('every');
var USES_TO_LENGTH = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1012);

module.exports = parent;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var findIndex = __webpack_require__(1013);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.findIndex;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.findIndex) ? findIndex : own;
};


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1014);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').findIndex;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $findIndex = __webpack_require__(97).findIndex;
var addToUnscopables = __webpack_require__(181);
var arrayMethodUsesToLength = __webpack_require__(67);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var filter = __webpack_require__(1016);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.filter) ? filter : own;
};


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1017);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').filter;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $filter = __webpack_require__(97).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(193);
var arrayMethodUsesToLength = __webpack_require__(67);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1019);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').indexOf;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $indexOf = __webpack_require__(287).indexOf;
var arrayMethodIsStrict = __webpack_require__(135);
var arrayMethodUsesToLength = __webpack_require__(67);

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1021);

module.exports = parent;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var some = __webpack_require__(1022);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.some;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.some) ? some : own;
};


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1023);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').some;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $some = __webpack_require__(97).some;
var arrayMethodIsStrict = __webpack_require__(135);
var arrayMethodUsesToLength = __webpack_require__(67);

var STRICT_METHOD = arrayMethodIsStrict('some');
var USES_TO_LENGTH = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1025);

module.exports = parent;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var splice = __webpack_require__(1026);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.splice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.splice) ? splice : own;
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1027);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').splice;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(288);
var toInteger = __webpack_require__(148);
var toLength = __webpack_require__(66);
var toObject = __webpack_require__(75);
var arraySpeciesCreate = __webpack_require__(235);
var createProperty = __webpack_require__(152);
var arrayMethodHasSpeciesSupport = __webpack_require__(193);
var arrayMethodUsesToLength = __webpack_require__(67);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1029);

module.exports = parent;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var reduce = __webpack_require__(1030);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reduce) ? reduce : own;
};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1031);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').reduce;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $reduce = __webpack_require__(1032).left;
var arrayMethodIsStrict = __webpack_require__(135);
var arrayMethodUsesToLength = __webpack_require__(67);

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(84);
var toObject = __webpack_require__(75);
var IndexedObject = __webpack_require__(226);
var toLength = __webpack_require__(66);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1034);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
var values = __webpack_require__(1035);
var classof = __webpack_require__(118);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.values;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.values)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? values : own;
};


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1036);

module.exports = parent;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').values;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(1038);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.map) ? map : own;
};


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1039);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').map;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $map = __webpack_require__(97).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(193);
var arrayMethodUsesToLength = __webpack_require__(67);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(491);
var path = __webpack_require__(23);

module.exports = path.setInterval;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(491);
var path = __webpack_require__(23);

module.exports = path.setTimeout;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1043);

module.exports = parent;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1044);
var path = __webpack_require__(23);

module.exports = path.Number.isInteger;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var isInteger = __webpack_require__(1045);

// `Number.isInteger` method
// https://tc39.github.io/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.github.io/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var find = __webpack_require__(1047);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.find;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.find) ? find : own;
};


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1048);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').find;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $find = __webpack_require__(97).find;
var addToUnscopables = __webpack_require__(181);
var arrayMethodUsesToLength = __webpack_require__(67);

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1050);

module.exports = parent;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(1051);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.trim) ? trim : own;
};


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1052);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('String').trim;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $trim = __webpack_require__(322).trim;
var forcedStringTrimMethod = __webpack_require__(1053);

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(28);
var whitespaces = __webpack_require__(236);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1055);

module.exports = parent;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1056);
var path = __webpack_require__(23);

module.exports = path.parseInt;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var parseIntImplementation = __webpack_require__(1057);

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var trim = __webpack_require__(322).trim;
var whitespaces = __webpack_require__(236);

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1059);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1060);

module.exports = parent;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1061);
var path = __webpack_require__(23);

module.exports = path.parseFloat;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var parseFloatImplementation = __webpack_require__(1062);

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var trim = __webpack_require__(322).trim;
var whitespaces = __webpack_require__(236);

var $parseFloat = global.parseFloat;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1064);
var core = __webpack_require__(23);

if (!core.JSON) core.JSON = { stringify: JSON.stringify };

// eslint-disable-next-line no-unused-vars
module.exports = function stringify(it, replacer, space) {
  return core.JSON.stringify.apply(null, arguments);
};


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var getBuiltIn = __webpack_require__(96);
var fails = __webpack_require__(28);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1066);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').slice;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var isObject = __webpack_require__(38);
var isArray = __webpack_require__(136);
var toAbsoluteIndex = __webpack_require__(288);
var toLength = __webpack_require__(66);
var toIndexedObject = __webpack_require__(83);
var createProperty = __webpack_require__(152);
var wellKnownSymbol = __webpack_require__(34);
var arrayMethodHasSpeciesSupport = __webpack_require__(193);
var arrayMethodUsesToLength = __webpack_require__(67);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var concat = __webpack_require__(1068);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.concat) ? concat : own;
};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(481);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').concat;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
var keys = __webpack_require__(1070);
var classof = __webpack_require__(118);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.keys;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.keys)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? keys : own;
};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1071);

module.exports = parent;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').keys;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1073);

module.exports = parent;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(1074);

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind : own;
};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1075);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Function').bind;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var bind = __webpack_require__(1076);

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(84);
var isObject = __webpack_require__(38);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1078);

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(477);

module.exports = parent;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(499);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(99);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(99);

var _exception = __webpack_require__(141);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else if (global.Symbol && context[global.Symbol.iterator]) {
        var newContext = [];
        var iterator = context[global.Symbol.iterator]();
        for (var it = iterator.next(); !it.done; it = iterator.next()) {
          newContext.push(it.value);
        }
        context = newContext;
        for (var j = context.length; i < j; i++) {
          execIteration(i, i, i === context.length - 1);
        }
      } else {
        (function () {
          var priorKey = undefined;

          Object.keys(context).forEach(function (key) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          });
          if (priorKey !== undefined) {
            execIteration(priorKey, i - 1, true);
          }
        })();
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(141);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(99);

var _exception = __webpack_require__(141);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#if requires exactly one argument');
    }
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#unless requires exactly one argument');
    }
    return instance.helpers['if'].call(this, conditional, {
      fn: options.inverse,
      inverse: options.fn,
      hash: options.hash
    });
  });
};

module.exports = exports['default'];


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field, options) {
    if (!obj) {
      // Note for 5.0: Change to "obj == null" in 5.0
      return obj;
    }
    return options.lookupProperty(obj, field);
  });
};

module.exports = exports['default'];


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(99);

var _exception = __webpack_require__(141);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#with requires exactly one argument');
    }
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(1088);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(99);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createNewLookupObject = createNewLookupObject;

var _utils = __webpack_require__(99);

/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */

function createNewLookupObject() {
  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
}


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(99);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(141);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(500);

var _helpers = __webpack_require__(501);

var _internalWrapHelper = __webpack_require__(1092);

var _internalProtoAccess = __webpack_require__(503);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
    return;
  }

  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
  } else {
    // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as pseudo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }
    partial = env.VM.resolvePartial.call(this, partial, context, options);

    var extendedOptions = Utils.extend({}, options, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    });

    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, extendedOptions);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name, loc) {
      if (!obj || !(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
          loc: loc
        });
      }
      return obj[name];
    },
    lookupProperty: function lookupProperty(parent, propertyName) {
      var result = parent[propertyName];
      if (result == null) {
        return result;
      }
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return result;
      }

      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
        return result;
      }
      return undefined;
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        var result = depths[i] && container.lookupProperty(depths[i], name);
        if (result != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    mergeIfNeeded: function mergeIfNeeded(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }

    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }

  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
      wrapHelpersToPassLookupProperty(mergedHelpers, container);
      container.helpers = mergedHelpers;

      if (templateSpec.usePartial) {
        // Use mergeIfNeeded here to prevent compiling global partials multiple times
        container.partials = container.mergeIfNeeded(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = Utils.extend({}, env.decorators, options.decorators);
      }

      container.hooks = {};
      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
    } else {
      container.protoAccessControl = options.protoAccessControl; // internal option
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
      container.hooks = options.hooks;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}

function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
  Object.keys(mergedHelpers).forEach(function (helperName) {
    var helper = mergedHelpers[helperName];
    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
  });
}

function passLookupPropertyOption(helper, container) {
  var lookupProperty = container.lookupProperty;
  return _internalWrapHelper.wrapHelper(helper, function (options) {
    return Utils.extend({ lookupProperty: lookupProperty }, options);
  });
}


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrapHelper = wrapHelper;

function wrapHelper(helper, transformOptionsFn) {
  if (typeof helper !== 'function') {
    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
  }
  var wrapper = function wrapper() /* dynamic arguments */{
    var options = arguments[arguments.length - 1];
    arguments[arguments.length - 1] = transformOptionsFn(options);
    return helper.apply(this, arguments);
  };
  return wrapper;
}


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.2.1

//     (c) 2010-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self == self && self) ||
            (typeof global == 'object' && global.global == global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1095), __webpack_require__(325), exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch(e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = [].slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.2.1';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Underscore methods to a Backbone class' prototype using a
  // particular attribute as the data argument
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], iteratee, context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], iteratee, defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`), reducing them by manipulating `memo`.
  // Passes a normalized single event name and callback, as well as any
  // optional `opts`.
  var eventsApi = function(iteratee, memo, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        memo = iteratee(memo, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space separated event names.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        memo = iteratee(memo, names[i], callback, opts);
      }
    } else {
      memo = iteratee(memo, name, callback, opts);
    }
    return memo;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // An internal use `on` function, used to guard the `listening` argument from
  // the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
        context: context,
        ctx: obj,
        listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to.
  Events.listenTo =  function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({ callback: callback, context: context, ctx: context || ctx, listening: listening });
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off =  function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
        context: context,
        listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening =  function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }
    if (_.isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    // No events to consider.
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    if (_.size(events)) return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, it will be removed. When multiple events are
  // passed in using the space-separated syntax, the event will fire once for every
  // event you passed in, not once for a combination of all events
  Events.once =  function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    return this.on(events, void 0, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce =  function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger =  function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, cb, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.defaults({validate: true}, options));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = { keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1 };

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      var removed = this._removeModels(models, options);
      if (!options.silent && removed) this.trigger('update', this, options);
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse && !this._isModel(models)) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : models.slice();
      var id, model, attrs, existing, sort;
      var at = options.at;
      if (at != null) at = +at;
      if (at < 0) at += this.length + 1;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;
      var orderChanged = false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (var i = 0; i < models.length; i++) {
        attrs = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(attrs)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge && attrs !== existing) {
            attrs = this._isModel(attrs) ? attrs.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (!model) continue;
        id = this.modelId(model.attributes);
        if (order && (model.isNew() || !modelMap[id])) {
          order.push(model);

          // Check to see if this is actually a new model at this index.
          orderChanged = orderChanged || !this.models[i] || model.cid !== this.models[i].cid;
        }

        modelMap[id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (var i = 0; i < this.length; i++) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || orderChanged) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (var i = 0; i < toAdd.length; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (var i = 0; i < orderedModels.length; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        var addOpts = at != null ? _.clone(options) : options;
        for (var i = 0; i < toAdd.length; i++) {
          if (at != null) addOpts.index = at + i;
          (model = toAdd[i]).trigger('add', model, this, addOpts);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length) this.trigger('update', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      var id = this.modelId(this._isModel(obj) ? obj.attributes : obj);
      return this._byId[obj] || this._byId[id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      var matches = _.matches(attrs);
      return this[first ? 'find' : 'filter'](function(model) {
        return matches(model.attributes);
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp, callbackOpts) {
        if (wait) collection.add(model, callbackOpts);
        if (success) success.call(callbackOpts.context, model, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function (attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    // Returns removed models, or false if nothing is removed.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed.length ? removed : false;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function (model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (event === 'change') {
        var prevId = this.modelId(model.previousAttributes());
        var id = this.modelId(model.attributes);
        if (prevId !== id) {
          if (prevId != null) delete this._byId[prevId];
          if (id != null) this._byId[id] = model;
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = { forEach: 3, each: 3, map: 3, collect: 3, reduce: 4,
      foldl: 4, inject: 4, reduceRight: 4, foldr: 4, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 2,
      contains: 2, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3 };

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    if (!_[method]) return;
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var root = path.slice(0, this.root.length - 1) + '/';
      return root === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window;
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var root = this.root.slice(0, -1) || '/';
          this.location.replace(root + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function (eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function (eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var root = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        root = root.slice(0, -1) || '/';
      }
      var url = root + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getHash(this.iframe.contentWindow))) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent` constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108), __webpack_require__(1096)(module)))

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia, Plurinational State of","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"Virgin Islands, British","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CO":"Colombia","KM":"Comoros","CG":"Congo","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","CD":"Congo, the Democratic Republic of the","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","TL":"Timor-Leste","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KR":"Korea, Republic of","XK":"Kosovo, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"Korea, Democratic People's Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"São Tomé and Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","VI":"Virgin Islands, U.S.","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Holy See (Vatican City State)","VE":"Venezuela, Bolivarian Republic of","VN":"Viet Nam","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = {"signout":"Sign Out","signin":"Sign In","signup":"Sign Up","remember":"Remember me","rememberDevice":"Trust this device","rememberDevice.timebased":"Do not challenge me on this device for the next {0}","rememberDevice.devicebased":"Do not challenge me on this device again","autoPush":"Send push automatically","unlockaccount":"Unlock account?","haveaccount":"Already have an account?","needhelp":"Need help signing in?","forgotpassword":"Forgot password?","help":"Help","retry":"Retry","iphone":"iPhone","android":"Android","goback":"Back to sign in","closeWindow":"You can close this window","country.label":"Country","phone.extention.label":"Extension","skip.to.main.content":"Skip to main content","minutes.oneMinute":"minute","minutes":"{0} minutes","hours":"{0} hours","days":"{0} days","error.config":"There was a configuration error","error.required.authParams":"Missing parameters for the configured authentication scheme - \"OAUTH2\"","error.required.baseUrl":"\"baseUrl\" is a required widget parameter","error.required.success":"A success handler is required","error.required.el":"\"el\" is a required widget parameter","error.invalid.colors.brand":"\"colors.brand\" must be in six-digit hex format","error.unsupported.browser":"Unsupported browser","error.unsupported.cors":"Unsupported browser - missing CORS support","error.unsupported.localStorage":"Unsupported browser - missing localStorage support","error.enabled.cors":"There was an error sending the request - have you enabled CORS?","error.expired.session":"Your session has expired. Please try to sign in again.","error.mfa.only.expired.session":"Unable to authenticate at this time.","error.auth.lockedOut":"Your account is locked. Please contact your administrator.","error.oauth.idToken":"There was a problem generating the id_token for the user. Please try again.","error.network.connection":"Unable to connect to the server. Please check your network connection.","error.username.required":"Please enter a username","error.password.required":"Please enter a password","error.mfa.required":"The current sign on policy requires this client to redirect for re-authentication or MFA. Please contact your administrator.","errors.E0000004":"Unable to sign in","errors.E0000069":"Your account is locked because of too many authentication attempts.","errors.E0000047":"You exceeded the maximum number of requests. Try again in a while.","errors.E0000079":"The operation is not allowed. Please refresh the page to proceed.","errors.E0000001":"Api validation failed: {0}","errors.E0000002":"The request was not valid: {0}","errors.E0000003":"The request body was not well-formed.","errors.E0000005":"Invalid session","errors.E0000006":"You do not have permission to perform the requested action","errors.E0000007":"Not found: {0}","errors.E0000008":"The requested path was not found","errors.E0000009":"Internal Server Error","errors.E0000010":"Service is in read only mode","errors.E0000011":"Invalid token provided","errors.E0000012":"Unsupported media type","errors.E0000013":"Invalid client app id","errors.E0000015":"You do not have permission to access the feature you are requesting","errors.E0000016":"Activation failed because the user is already active","errors.E0000017":"Password reset failed","errors.E0000018":"Bad request.  Accept and/or Content-Type headers are likely not set.","errors.E0000019":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000020":"Bad request.","errors.E0000021":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000022":"The endpoint does not support the provided HTTP method","errors.E0000023":"Operation failed because user profile is mastered under another system","errors.E0000024":"Bad request.  This operation on app metadata is not yet supported.","errors.E0000025":"App version assignment failed.","errors.E0000026":"This endpoint has been deprecated.","errors.E0000027":"Group push bad request : {0}","errors.E0000028":"The request is missing a required parameter.","errors.E0000029":"Invalid paging request.","errors.E0000030":"Bad request. Invalid date. Dates must be of the form yyyy-MM-dd''T''HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.","errors.E0000031":"Invalid search criteria.","errors.E0000032":"Unlock is not allowed for this user.","errors.E0000033":"Bad request. Can't specify a search query and filter in the same request.","errors.E0000034":"Forgot password not allowed on specified user.","errors.E0000035":"Change password not allowed on specified user.","errors.E0000036":"Change recovery question not allowed on specified user.","errors.E0000037":"Type mismatch exception.","errors.E0000038":"This operation is not allowed in the user''s current status.","errors.E0000039":"Operation on application settings failed.","errors.E0000040":"Application label must not be the same as an existing application label.","errors.E0000041":"Credentials should not be set on this resource based on the scheme.","errors.E0000042":"Setting the error page redirect URL failed.","errors.E0000043":"Self service application assignment is not enabled.","errors.E0000044":"Self service application assignment is not supported.","errors.E0000045":"Field mapping bad request.","errors.E0000046":"Deactivate application for user forbidden.","errors.E0000048":"Entity not found exception.","errors.E0000049":"Invalid SCIM data from SCIM implementation.","errors.E0000050":"Invalid SCIM data from client.","errors.E0000051":"No response from SCIM implementation.","errors.E0000052":"Endpoint not implemented.","errors.E0000053":"Invalid SCIM filter.","errors.E0000054":"Invalid pagination properties.","errors.E0000055":"Duplicate group.","errors.E0000056":"Delete application forbidden.","errors.E0000057":"Access to this application is denied due to a policy.","errors.E0000058":"Access to this application requires MFA: {0}","errors.E0000059":"The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.","errors.E0000060":"Unsupported operation.","errors.E0000061":"Tab error: {0}","errors.E0000062":"The specified user is already assigned to the application.","errors.E0000063":"Invalid combination of parameters specified.","errors.E0000064":"Password is expired and must be changed.","errors.E0000065":"Internal error processing app metadata.","errors.E0000066":"APNS is not configured, contact your admin","errors.E0000067":"Factors Service Error.","errors.E0000070":"Waiting for ACK","errors.E0000071":"Unsupported OS Version: {0}","errors.E0000072":"MIM policy settings have disallowed enrollment for this user","errors.E0000073":"User rejected authentication","errors.E0000074":"Factor Service Error","errors.E0000075":"Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.","errors.E0000076":"Cannot modify the app user because it is mastered by an external app.","errors.E0000077":"Cannot modify the {0} attribute because it is read-only.","errors.E0000078":"Cannot modify the {0} attribute because it is immutable.","errors.E0000081":"Cannot modify the {0} attribute because it is a reserved attribute for this application.","errors.E0000082":"Each code can only be used once. Please wait for a new code and try again.","errors.E0000083":"PassCode is valid but exceeded time window.","errors.E0000084":"App evaluation error.","errors.E0000085":"You do not have permission to access your account at this time.","errors.E0000086":"This policy cannot be activated at this time.","errors.E0000087":"The recovery question answer did not match our records.","errors.E0000090":"The role specified is already assigned to the user.","errors.E0000091":"The provided role type was not the same as required role type.","errors.E0000092":"Access to this application requires re-authentication: {0}","errors.E0000093":"Target count limit exceeded","errors.E0000094":"The provided filter is unsupported.","errors.E0000095":"Recovery not allowed for unknown user.","errors.E0000096":"This certificate has already been uploaded with kid={0}.","errors.E0000097":"There is no verified phone number on file.","errors.E0000098":"This phone number is invalid.","errors.E0000099":"Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.","errors.E0000100":"Unable to perform search query.","errors.E0000101":"Upload failed because of a problem with your ipa file, {0}","errors.E0000102":"YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again","errors.E0000103":"Action on device already in queue or in progress","errors.E0000104":"Device is already locked and cannot be locked again","errors.E0000105":"You have accessed an account recovery link that has expired or been previously used.","errors.E0000106":"Wait for token to change, then enter the new tokencode.","errors.E0000107":"The entity is not in the expected state for the requested transition.","errors.E0000109":"An SMS message was recently sent. Please wait 30 seconds before trying again.","errors.E0000110":"You have accessed a link that has expired or has been previously used.","errors.E0000111":"Cannot modify the {0} object because it is read-only.","errors.E0000112":"Cannot update this user because they are still being activated. Please try again in a few minutes.","errors.E0000113":"{0}.","errors.E0000114":"A user with this login already exists in the current organization.","errors.E0000115":"Upload failed, {0}","errors.E0000116":"{0}","errors.E0000119":"Your account is locked. Please contact your administrator.","errors.E0000124":"Could not create user. To create a user and expire their password immediately, a password must be specified","errors.E0000125":"Could not create user. To create a user and expire their password immediately, \"activate\" must be true","errors.E0000133":"A phone call was recently made. Please wait 30 seconds before trying again.","oform.next":"Next","oform.verify":"Verify","oform.send":"Send","oform.back":"Back","oform.title.authenticate":"Authenticate","oform.save":"Save","oform.cancel":"Cancel","oform.edit":"Edit","oform.previous":"Previous","oform.error.icon.ariaLabel":"Error","oform.errorbanner.title":"We found some errors. Please review the form and make corrections.","oform.errormsg.title":"Please review the form to correct the following errors:","oform.error.unexpected":"There was an unexpected internal error. Please try again.","model.validation.field.blank":"This field cannot be left blank","model.validation.field.wrong.type":"This field is of the wrong type","model.validation.field.invalid":"This field has an invalid value","model.validation.field.value.not.allowed":"This field value is not allowed","model.validation.field.array.minItems":"This array does not have enough items","model.validation.field.array.maxItems":"This array contains too many items","model.validation.field.array.unique":"This array can only have unique values","model.validation.field.string.minLength":"This field cannot be less than the minimum required characters","model.validation.field.string.maxLength":"This field cannot exceed the maximum allowed characters","model.validation.field.invalid.format.email":"This value is not a valid email address","model.validation.field.invalid.format.uri":"This value is not a valid URI","model.validation.field.invalid.format.ipv4":"This value is not a valid IPv4 address","model.validation.field.invalid.format.hostname":"This value is not a valid hostname","model.validation.field.username":"Please check your username","schema.validation.field.value.must.string":"Value must be a string","schema.validation.field.value.must.number":"Value must be a number","schema.validation.field.value.must.integer":"Value must be an integer","schema.validation.field.value.must.object":"Value must be an object","universal-directory.profiles.attribute.source.oktamastered":"Inherit from Okta","universal-directory.profiles.attribute.source.override":"Override profile source","universal-directory.profiles.attribute.form.union.disable.display":"Combine values across groups","universal-directory.profiles.attribute.source.inherit":"Inherit from profile source","universal-directory.profiles.attribute.enduser.permission.readonly":"Read Only","universal-directory.profiles.attribute.enduser.permission.hide":"Hide","universal-directory.profiles.attribute.enduser.permission.readwrite":"Read-Write","universal-directory.profiles.attribute.form.union.enable.display":"Use Group Priority","factor.totpSoft.oktaVerify":"Okta Verify","factor.totpSoft.googleAuthenticator":"Google Authenticator","factor.totpSoft.description":"Enter single-use code from the mobile app.","factor.totpHard.rsaSecurId":"RSA SecurID","factor.totpHard.symantecVip":"Symantec VIP","factor.totpHard.description":"Enter a single-use code from a hardware token.","factor.totpHard.yubikey":"YubiKey","factor.totpHard.yubikey.description":"Insert your YubiKey and tap it to get a verification code.","factor.totpHard.yubikey.placeholder":"Click here, then tap your YubiKey","factor.oktaVerifyPush":"Okta Verify","factor.push.description":"Use a push notification sent to the mobile app.","factor.duo":"Duo Security","factor.duo.description":"Use Push Notification, SMS, or Voice call to authenticate.","factor.sms":"SMS Authentication","factor.sms.description":"Enter a single-use code sent to your mobile phone.","factor.sms.time.warning":"Haven't received an SMS? To try again, click <span style=\"font-weight:bold\">Re-send code</span>.","factor.call":"Voice Call Authentication","factor.call.description":"Use a phone to authenticate by following voice instructions.","factor.call.time.warning":"Haven't received a voice call? To try again, click <span style=\"font-weight:bold\">Redial</span>.","factor.securityQuestion":"Security Question","factor.securityQuestion.description":"Use the answer to a security question to authenticate.","factor.windowsHello":"Windows Hello","factor.windowsHello.signin.description":"Sign in to Okta using Windows Hello.","factor.windowsHello.signin.description.generic":"Sign in using Windows Hello.","factor.windowsHello.signin.description.specific":"Sign in to {0} using Windows Hello.","factor.u2f":"Security Key (U2F)","factor.u2f.description":"Use a Universal 2nd Factor (U2F) security key to sign on to Okta.","factor.u2f.description.generic":"Use a Universal 2nd Factor (U2F) security key to sign in.","factor.u2f.description.specific":"Use a Universal 2nd Factor (U2F) security key to sign in to {0}.","factor.email":"Email Authentication","factor.email.description":"Enter a verification code sent to your email.","factor.password":"Password","factor.customFactor.description":"Redirect to a third party MFA provider to sign in to Okta.","factor.customFactor.description.generic":"Redirect to a third party MFA provider to sign in.","factor.customFactor.description.specific":"Redirect to a third party MFA provider to sign in to {0}.","factor.webauthn.biometric":"Security Key or Biometric Authenticator","factor.webauthn.biometric.description":"Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)","factor.hotp.description":"Enter a single-use code from an authenticator.","mfa.challenge.verify":"Verify","mfa.challenge.answer.placeholder":"Answer","mfa.challenge.answer.tooltip":"Answer","mfa.challenge.answer.showAnswer":"Show","mfa.challenge.answer.hideAnswer":"Hide","mfa.challenge.enterCode.placeholder":"Enter Code","mfa.challenge.enterCode.tooltip":"Enter Code","mfa.challenge.password.placeholder":"Password","mfa.backToFactors":"Back to factor list","mfa.enroll":"Enroll","mfa.phoneNumber.placeholder":"Phone number","mfa.phoneNumber.ext.placeholder":"Extension","mfa.sendCode":"Send code","mfa.sent":"Sent","mfa.resendCode":"Re-send code","mfa.call":"Call","mfa.calling":"Calling","mfa.redial":"Redial","mfa.sendEmail":"Send email","mfa.resendEmail":"Re-send email","mfa.scanBarcode":"Scan barcode","mfa.altQrCode":"qr code","mfa.noAccessToEmail":"Can't access email","password.reset":"Reset Password","password.oldPassword.placeholder":"Old password","password.oldPassword.tooltip":"Old password","password.newPassword.placeholder":"New password","password.newPassword.tooltip":"New password","password.confirmPassword.placeholder":"Repeat password","password.confirmPassword.tooltip":"Repeat password","password.error.match":"New passwords must match","password.enroll.error.match":"Passwords must match","recovery.sms.hint":"SMS can only be used if a mobile phone number has been configured.","recovery.mobile.hint":"{0} can only be used if a mobile phone number has been configured.","recovery.sms":"SMS","recovery.call":"Voice Call","recovery.smsOrCall":"SMS or Voice Call","verify.choices.description":"Verify with one of the following factors.","email.button.send":"Send me the code","email.button.resend":"Send again","email.code.label":"Verification code","email.code.not.received":"Haven't received an email?","email.enroll.title":"Set up Email Authentication","email.enroll.description":"Send a verification code to your registered email.","email.enroll.enterCode":"Enter code","email.link.terminal.msg":"To finish signing in, return to the screen where you requested the email link.","email.mfa.title":"Verify with Email Authentication","email.mfa.description":"Send a verification code to {0}.","email.mfa.email.sent.description":"A verification code was sent to {0}. Check your email and enter the code below.","email.mfa.email.sent.description.sentText":"A verification code was sent to","email.mfa.email.sent.description.emailCodeText":"Check your email and enter the code below.","enroll.choices.title":"Set up multifactor authentication","enroll.choices.description":"Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account","enroll.choices.description.generic":"Your company requires multifactor authentication to add an additional layer of security when signing in to your account","enroll.choices.description.specific":"Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account","enroll.choices.description.gracePeriod.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.","enroll.choices.description.gracePeriod.oneDay.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.","enroll.choices.optional":"You can configure any additional optional factor or click finish","enroll.choices.list.setup":"Setup required","enroll.choices.list.enrolled":"Enrolled factors","enroll.choices.list.optional":"Additional optional factors","enroll.choices.setup":"Setup","enroll.choices.setup.another":"Set up another","enroll.choices.submit.finish":"Finish","enroll.choices.submit.configure":"Configure factor","enroll.choices.submit.next":"Configure next factor","enroll.choices.cardinality.setup":"({0} set up)","enroll.choices.cardinality.setup.remaining":"({0} of {1} set up)","enroll.choices.setup.skip":"Skip set up","enroll.securityQuestion.setup":"Setup secret question authentication","security.disliked_food":"What is the food you least liked as a child?","security.name_of_first_plush_toy":"What is the name of your first stuffed animal?","security.first_award":"What did you earn your first medal or award for?","security.favorite_security_question":"What is your favorite security question?","security.favorite_toy":"What is the toy/stuffed animal you liked the most as a kid?","security.first_computer_game":"What was the first computer game you played?","security.favorite_movie_quote":"What is your favorite movie quote?","security.first_sports_team_mascot":"What was the mascot of the first sports team you played on?","security.first_music_purchase":"What music album or song did you first purchase?","security.favorite_art_piece":"What is your favorite piece of art?","security.grandmother_favorite_desert":"What was your grandmother's favorite dessert?","security.first_thing_cooked":"What was the first thing you learned to cook?","security.childhood_dream_job":"What was your dream job as a child?","security.first_kiss_location":"Where did you have your first kiss?","security.place_where_significant_other_was_met":"Where did you meet your spouse/significant other?","security.favorite_vacation_location":"Where did you go for your favorite vacation?","security.new_years_two_thousand":"Where were you on New Year's Eve in the year 2000?","security.favorite_speaker_actor":"Who is your favorite speaker/orator?","security.favorite_book_movie_character":"Who is your favorite book/movie character?","security.favorite_sports_player":"Who is your favorite sports player?","enroll.password.setup":"Select a password","save.password":"Save password","enroll.sms.setup":"Receive a code via SMS to authenticate","enroll.sms.try_again":"The number you entered seems invalid. If the number is correct, please try again.","enroll.call.setup":"Follow phone call instructions to authenticate","enroll.onprem.username.placeholder":"Enter {0} username","enroll.onprem.username.tooltip":"Enter {0} username","enroll.onprem.passcode.placeholder":"Enter {0} passcode","enroll.onprem.passcode.tooltip":"Enter {0} passcode","enroll.symantecVip.subtitle":"Enter Credential ID and two consecutive generated codes","enroll.symantecVip.credentialId.placeholder":"Enter credential ID","enroll.symantecVip.credentialId.tooltip":"Enter credential ID","enroll.symantecVip.passcode1.placeholder":"Security code 1","enroll.symantecVip.passcode1.tooltip":"Security code 1","enroll.symantecVip.passcode2.placeholder":"Security code 2","enroll.symantecVip.passcode2.tooltip":"Security code 2","enroll.yubikey.title":"Setup YubiKey","enroll.yubikey.subtitle":"Insert your YubiKey into a USB port and tap it to generate a verification code","enroll.totp.title":"Setup {0}","enroll.totp.selectDevice":"Select your device type","enroll.totp.downloadApp":"Download <a href=\"{0}\" class=\"inline-link\">{1} from the {2}</a> onto your mobile device.","enroll.hotp.restricted":"Contact your administrator to continue enrollment.","enroll.duo.title":"Setup Duo Security","enroll.windowsHello.title":"Enroll Windows Hello","enroll.windowsHello.subtitle":"Click below to enroll Windows Hello as a second form of authentication","enroll.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","enroll.windowsHello.save":"Enroll Windows Hello","enroll.windowsHello.error.notWindows":"Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.","enroll.windowsHello.error.notConfiguredHtml":"Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.","verify.windowsHello.subtitle":"Verify your identity with Windows Hello","verify.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","verify.windowsHello.subtitle.signingIn":"Signing in to Okta...","verify.windowsHello.subtitle.signingIn.generic":"Signing in...","verify.windowsHello.subtitle.signingIn.specific":"Signing in to {0}...","verify.windowsHello.save":"Verify with Windows Hello","verify.windowsHello.error.notFound":"Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.","verify.windowsHello.error.notFound.selectAnother":"Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.","enroll.u2f.title":"Setup Security Key (U2F)","enroll.u2f.save":"Register Security Key","enroll.u2f.general2":"Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer's Bluetooth.","enroll.u2f.general3":"Click the button below to register","enroll.u2f.instructions":"Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.","enroll.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, press the button.","u2f.error.factorNotSupported":"Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.","u2f.error.factorNotSupported.oneFactor":"Security Key (U2F) is not supported on this browser. Contact your admin for assistance.","u2f.error.other":"An unknown error has occured. Try again or select another factor.","u2f.error.other.oneFactor":"An unknown error has occured. Try again or contact your admin for assistance.","u2f.error.badRequest":"There was an error with the U2F request. Try again or select another factor.","u2f.error.badRequest.oneFactor":"There was an error with the U2F request. Try again or contact your admin for assistance.","u2f.error.unsupported":"The security key is unsupported. Select another factor.","u2f.error.unsupported.oneFactor":"The security key is unsupported. Contact your admin for assistance.","u2f.error.timeout":"You have timed out of the authentication period. Please try again.","verify.u2f.instructions":"Insert your Security Key. If it has a button or gold disk, tap it.","verify.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, turn on your computer's Bluetooth and press the button.","verify.u2f.retry":"Retry","enroll.customFactor.subtitle":"Clicking below will redirect to MFA enrollment with {0}","enroll.customFactor.save":"Enroll","verify.customFactor.subtitle":"Clicking below will redirect to verification with {0}","enroll.webauthn.biometric.title":"Set up security key or biometric authenticator","enroll.webauthn.save":"Enroll","enroll.webauthn.biometric.instructions":"Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.","enroll.webauthn.biometric.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select '<b>Cancel</b>' in the prompt before continuing.","verify.webauthn.biometric.instructions":"Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.","webauthn.biometric.error.factorNotSupported":"Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.","webauthn.biometric.error.factorNotSupported.oneFactor":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","enroll.webauthn.instructions.noSupportForBiometric":"Note: Some browsers may not support biometric authenticators.","authfactor.webauthn.error":"You are currently unable to use a Security key or biometric authenticator. Try again.","enroll.totp.enterCode":"Enter code displayed from the application","enroll.totp.setupApp":"Launch {0} application on your mobile device and select Add an account.","enroll.totp.setupGoogleAuthApp":"Launch {0}, tap the \"+\" icon, then select \"Scan barcode\".","enroll.totp.cannotScan":"Can't scan?","enroll.totp.refreshBarcode":"Refresh code","enroll.totp.cannotScanBarcode":"Can't scan barcode?","enroll.totp.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.generic":"To set up manually enter your Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.specific":"To set up manually enter your {0} Account username and then input the following in the Secret Key Field","enroll.totp.sharedSecretInstructions":"Enter your Okta Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.generic":"Enter your Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.specific":"Enter your {0} Account username and enter the following in the Secret Key Field","enroll.totp.sendSms":"Send activation link via SMS","enroll.totp.sendEmail":"Send activation link via email","enroll.totp.setupManually":"Setup manually without push notification","enroll.totp.enrollViaEmail.title":"Activation email sent!","enroll.totp.enrollViaEmail.msg":"Open the email from your mobile device.","enroll.totp.enrollViaSms.title":"SMS sent!","enroll.totp.enrollViaSms.msg":"View the SMS on your mobile device.","recoveryChallenge.sms.title":"Enter verification code sent via SMS","recoveryChallenge.call.title":"Enter verification code received via Voice Call","mfa.factors.dropdown.title":"Select an authentication factor","mfa.factors.dropdown.sr.text":"Select Authentication Factor - {0} Factor Selected","mfa.duoSecurity.push":"Push — {0}","mfa.duoSecurity.sms":"SMS — {0}","mfa.duoSecurity.call":"Call — {0}","mfa.switch":"Switch Factor","mfa.challenge.title":"Enter your {0} passcode","mfa.challenge.orEnterCode":"Or enter code","mfa.challenge.totp.subtitle.multiple":"Enter code from any registered {0} device.","mfa.emailVerification.checkEmail":"To finish signing in, click the link in your email.","mfa.emailVerification.title":"Sign in using a link sent to your email.","mfa.emailVerification.subtitle":"Emails will be sent to {0}","mfa.emailVerification.otc.finish":"To finish signing in, enter the code which was emailed to you.","oktaverify.send":"Send Push","oktaverify.resend":"Re-send Push","oktaverify.sent":"Push sent!","oktaverify.rejected":"You have chosen to reject this login.","oktaverify.rejected.upgradeRequired.ios":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.","oktaverify.rejected.upgradeRequired.android":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.","oktaverify.timeout":"Your push notification has expired.","oktaverify.warning":"Haven't received a push notification yet? Try opening the Okta Verify App on your phone.","oktaverify.numberchallenge.instruction":"On your phone, tap <span class=\"challenge-number\">{0}</span> on Okta Verify prompt to continue.","oktaverify.numberchallenge.explain":"This extra step helps us make sure it's really you signing in.","primaryauth.title":"Sign In","primaryauth.username.placeholder":"Username","primaryauth.username.tooltip":"Username","primaryauth.password.placeholder":"Password","primaryauth.password.tooltip":"Password","primaryauth.submit":"Sign In","primaryauth.newUser.tooltip":"This is the first time you are connecting to {0} from this browser","primaryauth.newUser.tooltip.close":"Close","oktaVerify.description":"To access this resource, your organization requires you to sign in using your device.","oktaVerify.button":"Sign in with Okta FastPass","idpDiscovery.email.placeholder":"Email","password.forgot.email.or.username.placeholder":"Email or Username","password.forgot.email.or.username.tooltip":"Email or Username","password.forgot.sendText":"Reset via SMS","password.forgot.sendEmail":"Reset via Email","password.forgot.call":"Reset via Voice Call","password.forgot.emailSent.title":"Email sent!","password.forgot.emailSent.desc":"Email has been sent to {0} with instructions on resetting your password.","password.forgot.question.title":"Answer Forgotten Password Challenge","password.forgot.question.submit":"Reset Password","password.forgot.code.notReceived":"Didn't receive a code? Reset via email","password.forgot.noFactorsEnabled":"No password reset options available. Please contact your administrator.","password.reset.title":"Reset your Okta password","password.reset.title.generic":"Reset your password","password.reset.title.specific":"Reset your {0} password","password.complexity.requirements":"Password requirements: {0}.","password.complexity.history":"Your password cannot be any of your last {0} passwords.","password.complexity.minAgeMinutes":"At least {0} minute(s) must have elapsed since you last changed your password.","password.complexity.minAgeHours":"At least {0} hour(s) must have elapsed since you last changed your password.","password.complexity.minAgeDays":"At least {0} day(s) must have elapsed since you last changed your password.","password.reset.verification":"Verify with one of the following factors to reset your password.","password.complexity.length":"at least {0} characters","password.complexity.list.element":", {0}","password.complexity.lowercase":"a lowercase letter","password.complexity.uppercase":"an uppercase letter","password.complexity.number":"a number","password.complexity.symbol":"a symbol","password.complexity.no_username":"no parts of your username","password.complexity.no_first_name":"does not include your first name","password.complexity.no_last_name":"does not include your last name","password.complexity.requirements.header":"Password requirements:","password.complexity.length.description":"At least {0} characters","password.complexity.lowercase.description":"A lowercase letter","password.complexity.uppercase.description":"An uppercase letter","password.complexity.number.description":"A number","password.complexity.symbol.description":"A symbol","password.complexity.no_username.description":"No parts of your username","password.complexity.no_first_name.description":"Does not include your first name","password.complexity.no_last_name.description":"Does not include your last name","password.complexity.history.description":"Your password cannot be any of your last {0} passwords","password.complexity.minAgeMinutes.description":"At least {0} minute(s) must have elapsed since you last changed your password","password.complexity.minAgeHours.description":"At least {0} hour(s) must have elapsed since you last changed your password","password.complexity.minAgeDays.description":"At least {0} day(s) must have elapsed since you last changed your password","password.expired.submit":"Change Password","password.expired.title":"Your Okta password has expired","password.expired.title.generic":"Your password has expired","password.expired.title.specific":"Your {0} password has expired","password.expiring.later":"Remind me later","password.expiring.title":"Your password will expire in {0} days","password.expiring.today":"Your password will expire later today","password.expiring.soon":"Your password is expiring soon","password.expiring.subtitle":"When password expires you may be locked out of Okta Mobile, mobile email, and other services.","password.expiring.subtitle.generic":"When password expires you will be locked out of your account.","password.expiring.subtitle.specific":"When password expires you will be locked out of your {0} account.","password.expired.custom.submit":"Go to {0}","password.expired.custom.subtitle":"This password is set on another website. Click the button below to go there and set a new password.","hcaptcha.footer.label":"This site is protected by hCaptcha and its <$1>Privacy Policy</$1> and <$2>Terms of Service</$2> apply.","account.unlock.title":"Unlock account","account.unlock.email.or.username.placeholder":"Email or username","account.unlock.email.or.username.tooltip":"Email or username","account.unlock.sendText":"Send SMS","account.unlock.voiceCall":"Voice Call","account.unlock.sendEmail":"Send Email","account.unlock.emailSent.title":"Email sent!","account.unlock.emailSent.desc":"Email has been sent to {0} with instructions on unlocking your account.","account.unlock.question.title":"Answer Unlock Account Challenge","account.unlock.question.submit":"Unlock Account","account.unlock.unlocked.title":"Account successfully unlocked!","account.unlock.unlocked.desc":"You can log in using your existing username and password.","account.unlock.code.notReceived":"Didn't receive a code? Unlock via email","account.unlock.noFactorsEnabled":"No unlock options available. Please contact your administrator.","contact.support":"If you didn't provide a secondary email address or don't have access to email, please contact your administrator at {0}","customauth.sign.in.with.label":"Sign in with {0}","socialauth.divider.text":"OR","socialauth.facebook.label":"Sign in with Facebook","socialauth.google.label":"Sign in with Google","socialauth.linkedin.label":"Sign in with LinkedIn","socialauth.microsoft.label":"Sign in with Microsoft","socialauth.apple.label":"Sign in with Apple","socialauth.popup.title":"External Identity Provider User Authentication","authbutton.divider.text":"or","registration.signup.label":"Don't have an account?","registration.signup.text":"Sign up","registration.complete.title":"Verification email sent","registration.complete.confirm.text":"To finish signing in, check your email.","registration.form.title":"Create Account","registration.form.submit":"Register","registration.passwordComplexity.minLength":"At least {0} character(s)","registration.passwordComplexity.minLower":"At least {0} lowercase letter(s)","registration.passwordComplexity.minUpper":"At least {0} uppercase letter(s)","registration.passwordComplexity.minNumber":"At least {0} number(s)","registration.passwordComplexity.minSymbol":"At least {0} symbol(s)","registration.passwordComplexity.excludeUsername":"Does not contain part of username","registration.passwordComplexity.excludeAttribute":"Does not contain '{0}'","registration.required.fields.label":"* indicates required field","registration.default.callbackhook.error":"We could not process your registration at this time. Please try again later.","registration.error.userName.invalidEmail":"Invalid email address","registration.error.password.passwordRequirementsNotMet":"Password requirements were not met","registration.error.userName.notUniqueWithinOrg":"An account with that {0} already exists","registration.error.notUniqueWithinOrg.Email":"A user with this Email already exists","registration.error.notUniqueWithinOrg.custom":"A user with this {0} already exists","registration.error.invalidLoginEmail.Email":"'Email' must be in the form of an email address","registration.error.invalidLoginEmail.custom":"'{0}' must be in the form of an email address","registration.error.doesNotMatchPattern.Email":"Provided value for property 'Email' does not match required pattern","registration.error.doesNotMatchPattern.custom":"Provided value for property '{0}' does not match required pattern","registration.error.generic":"There was an error creating your account. Please try registering again.","registration.error.request.not.completed":"Your request could not be completed. Try again later.","registration.model.validation.field.string.too.short":"Please enter something at least {0} characters long","registration.model.validation.field.string.too.long":"Please enter something shorter than {0} characters","piv.card":"PIV Card","piv.card.insert":"Please insert your PIV card and select the user certificate.","piv.card.error":"Certificate authentication failed. Contact your admin.","piv.card.error.empty":"No certificate selected. Choose a certificate and try again.","piv.card.error.invalid":"Certificate validation failed. Choose another certificate and try again.","piv.cac.card":"Sign in with PIV / CAC card","piv.cac.title":"PIV / CAC card","piv.cac.card.insert":"Please insert your PIV / CAC card and select the user certificate.","piv.cac.error":"There was an error signing in. Click the button below to try again.","unsupported.oneDrive.title":"Your OneDrive version is not supported","unsupported.oneDrive.desc":"Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta","unsupported.oneDrive.action":"Learn how to upgrade","unsupported.cookies.title":"Cookies are required","unsupported.cookies.desc":"Cookies are disabled on your browser. Please enable Cookies and refresh this page.","unsupported.cookies.action":"Refresh","deviceTrust.sso.text":"Sign in to access company resources","deviceTrust.sso.subtitle.2":"Your company uses Okta Mobile to get you approved to access this app.","deviceTrust.sso.button":"Sign in with Okta Mobile","deviceTrust.sso.expire.title":"Oops let's get you back on track","deviceTrust.sso.redirectText":"Verifying your identity","deviceTrust.sso.expire.subtitle":"Unfortunately the steps required to sign in took longer than expected and your attempt timed out.","deviceTrust.sso.expire.button":"Sign in using Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.title":"Get Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.subtitle":"Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.","loopback.polling.cancel.link":"Cancel and take me to sign in","loopback.polling.cancel.link.with.form.error":"Take me to sign in","customUri.subtitle":"Launching Okta Verify...","customUri.content":"<div class=\"skinny-content\"> If nothing prompts from the browser, <a href=\"#\" id=\"launch-ov\" class=\"link\">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>","customUri.title":"Click \"Open Okta Verify\" on the browser prompt","customUri.required.content.prompt":"Didn’t get a prompt?","customUri.required.content.download.title":"Don’t have Okta Verify?","customUri.required.content.download.linkText":"Download here","customUri.required.content.button":"Launch Okta Verify","universalLink.title":"Sign in with Okta FastPass","universalLink.content":"Open Okta Verify to continue signing in. If Okta Verify did not open automatically, tap the button below to reopen Okta Verify.","appLink.title":"Sign in with Okta FastPass","appLink.content":"If Okta Verify did not open automatically, tap the button below to reopen Okta Verify.","oktaVerify.open.button":"Open Okta Verify","oktaVerify.reopen.button":"Reopen Okta Verify","consent.required.text":"<b>{0}</b> would like to access:","consent.required.description":"By clicking Allow Access, you allow the actions listed above.","consent.required.termsOfService":"Terms of Service","consent.required.privacyPolicy":"Privacy Policy","consent.required.consentButton":"Allow Access","consent.required.cancelButton":"Don't Allow","admin.consent.group.user.group":"User and groups","admin.consent.group.resource.policy":"Resource and policies","admin.consent.group.hook":"Hooks","admin.consent.group.system":"System","polling.title":"There are too many users trying to sign in right now. We will automatically retry in {0} seconds.","poll.form.title":"Unable to complete your request","poll.form.message":"We will automatically retry in <$1>{0}</$1> seconds.","cert.authentication.title":"Certificate authentication","common.logo.alt":"aria logo","oie.authenticator.enroll.error.fail":"Unable to enroll authenticator. Try again.","oie.authenticator.verify.error.fail":"Unable to verify authenticator. Try again.","oie.form.field.optional":"Optional","oie.password.label":"Password","oie.password.newPasswordLabel":"New password","oie.password.authenticator.description":"Choose a password for your account","oie.password.challenge.title":"Verify with your password","oie.password.enroll.title":"Set up password","oie.password.passwordLabel":"Enter password","oie.password.confirmPasswordLabel":"Re-enter password","oie.password.reset.verification":"Verify with one of the following security methods to reset your password.","idx.password.expiring.message":"When your password expires you will be locked out of your Okta account.","oie.password.incorrect.message":"Password is incorrect","oie.selfservice.reset.password.not.allowed":"Reset password is not allowed at this time. Please contact support for assistance.","password.common":"This password was found in a list of commonly used passwords. Please try another password.","idx.recovery.completed":"You can now sign in with your existing username and new password.","oie.phone.label":"Phone","oie.phone.authenticator.description":"Verify with a code sent to your phone","oie.phone.enroll.sms.label":"SMS","oie.phone.enroll.voice.label":"Voice call","oie.phone.enroll.title":"Set up phone authentication","oie.phone.enroll.call.subtitle":"Enter your phone number to receive a verification code via voice call.","oie.phone.enroll.sms.subtitle":"Enter your phone number to receive a verification code via SMS.","oie.phone.sms.primaryButton":"Receive a code via SMS","oie.phone.sms.secondaryButton":"Receive an SMS instead","oie.phone.call.primaryButton":"Receive a code via voice call","oie.phone.call.secondaryButton":"Receive a voice call instead","oie.phone.verify.sms.resendText":"Haven't received an SMS?","oie.phone.verify.sms.codeSentText":"A code was sent to","oie.phone.verify.sms.sendText":"Send a code via SMS to","oie.phone.verify.call.sendText":"Send a code via voice call to","oie.phone.verify.call.resendText":"Haven't received a call?","oie.phone.verify.call.resendLinkText":"Call again","oie.phone.verify.sms.resendLinkText":"Send again","oie.phone.verify.enterCodeText":"Enter the code below to verify.","oie.phone.verify.title":"Verify with your phone","oie.phone.alternate.title":"your phone","oie.phone.carrier.charges":"Carrier messaging charges may apply","oie.phone.invalid":"Invalid Phone Number.","oie.email.label":"Email","oie.email.authenticator.description":"Verify with a link or code sent to your email","oie.email.mfa.title":"Verify with your email","oie.email.verify.alternate.magicLinkToEmailAddress":"An email magic link was sent to <$1>{0}</$1>. ","oie.email.verify.alternate.magicLinkToYourEmail":"An email magic link was sent to <$1>your email</$1>. ","oie.email.verify.alternate.instructions":"Click the link in the email or enter the code below to continue.","oie.email.verify.alternate.showCodeTextField":"Enter a code from the email instead","oie.email.enroll.subtitle":"Please check your email and enter the code below.","oie.email.return.link.expired.title":"Verify with your email","oie.profile.additional.title":"Additional Profile information","oie.profile.additional.secondemail.subtitle":"Use a second email to <$1> recover your account </$1> in case you become locked out. This email must be verified after setup.","oie.webauthn.label":"Security Key or Biometric Authenticator","oie.webauthn.description":"Use a security key or a biometric authenticator to sign in","oie.enroll.webauthn.title":"Set up security key or biometric authenticator","oie.enroll.webauthn.instructions":"You will be prompted to register a security key or biometric authenticator (Windows Hello, Touch ID, Face ID, etc.). Follow the instructions to complete set up.","oie.enroll.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to setup this authenticator.","oie.enroll.webauthn.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select 'Cancel' in the prompt before continuing.","oie.enroll.webauthn.save":"Set up","oie.webauthn.error.not.supported":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","oie.verify.webauth.title":"Verify with Security Key or Biometric Authenticator","oie.verify.webauthn.instructions":"You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.","oie.verify.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to sign in with this authenticator.","oie.verify.webauthn.cant.verify":"Can't verify?","oie.verify.webauthn.cant.verify.biometric.authenticator.title":"Are you trying to use a biometric authenticator?","oie.verify.webauthn.cant.verify.biometric.authenticator.description1":"Biometric authenticators (fingerprint, face recognition, PIN) will only work on the same device on which they were set up.","oie.verify.webauthn.cant.verify.biometric.authenticator.description2":"If available, set up another security method on the device you used to set up your biometric authenticator.","oie.verify.webauthn.cant.verify.security.key.title":"Are you trying to use a security key?","oie.verify.webauthn.cant.verify.security.key.description":"If you have set up a security key, insert it in a USB port when prompted by the browser and tap on the button or gold disk. Security keys can work on multiple devices.","oie.verify.webauthn.cant.verify.enrollment.step1":"Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your security key or biometric authenticator","oie.verify.webauthn.cant.verify.enrollment.step2":"Go to Settings > Security Methods","oie.verify.webauthn.cant.verify.enrollment.step3":"On Okta Verify, click \"Set up\"","oie.verify.webauthn.cant.verify.enrollment.step4":"Scan the QR code using Okta Verify and follow instructions to finish enrolling your account","oie.security.question.label":"Security Question","oie.security.question.enroll.title":"Set up security question","oie.security.question.challenge.title":"Verify with your Security Question","oie.security.question.questionKey.label":"Choose a security question","oie.security.question.createQuestion.label":"Create my own security question","oie.security.question.authenticator.description":"Choose a security question and answer that will be used for signing in","securityQuestion.answer.tooShort.arg":"The security question answer must be at least {0} characters in length","oie.okta_verify.label":"Okta Verify","oie.okta_verify.authenticator.description":"Okta Verify is an authenticator app, installed on your phone, used to prove your identity","oie.enroll.okta_verify.setup.title":"Set up Okta Verify","oie.enroll.okta_verify.setup.email.title":"Check your email","oie.enroll.okta_verify.setup.sms.title":"Check your text messages","oie.enroll.okta_verify.select.channel.description":"Which option do you want to try?","oie.enroll.okta_verify.select.channel.qrcode.label":"Scan a QR code","oie.enroll.okta_verify.select.channel.email.label":"Email me a setup link","oie.enroll.okta_verify.select.channel.sms.label":"Text me a setup link","oie.enroll.okta_verify.select.channel.title":"More options","oie.enroll.okta_verify.channel.email.label":"Email","oie.enroll.okta_verify.enroll.channel.email.title":"Set up Okta Verify via email link","oie.enroll.okta_verify.enroll.channel.sms.title":"Set up Okta Verify via SMS","oie.enroll.okta_verify.channel.email.description":"Make sure you can access the email on your mobile device.","oie.enroll.okta_verify.channel.sms.description":"Make sure you can access the text on your mobile device.","oie.enroll.okta_verify.qrcode.step1":"On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).","oie.enroll.okta_verify.qrcode.step2":"Open the app and follow the instructions to add your account","oie.enroll.okta_verify.qrcode.step3":"When prompted, tap Scan a QR code, then scan the QR code below:","oie.enroll.okta_verify.qrcode.cannotScan":"Can't scan?","oie.enroll.okta_verify.switch.channel.link.text":"Or <a href=\"#\" class=\"switch-channel-link\">try a different way</a> to set up Okta Verify.","oie.enroll.okta_verify.email.info":"We sent an email to <span class=\"strong\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.email.notReceived":"Haven’t received an email? Check your spam folder or <a href=\"#\" class=\"resend-link\">send again</a>","oie.enroll.okta_verify.sms.info":"We sent an SMS to <span class=\"strong\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.sms.notReceived":"Haven’t received an SMS? <a href=\"#\" class=\"resend-link\">Send again</a>","oie.enroll.okta_verify.setupLink":"Send me the setup link","oie.okta_verify.totp.title":"Enter a code","oie.okta_verify.totp.enterCodeText":"Enter code from Okta Verify app","oie.okta_verify.push.title":"Get a push notification","oie.okta_verify.push.sent":"Push notification sent","oie.okta_verify.push.resend":"Resend push notification","oie.okta_verify.signed_nonce.label":"Use Okta FastPass","oie.okta_verify.enroll.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible":"The device used to set up Okta Verify does not meet your organization’s security requirements because it is not FIPS compliant. Contact your administrator for help.","oie.authenticator.app.non_fips_compliant_enrollment_app_update_required":"The Okta Verify version on the device used does not meet your organization’s security requirements. To add your account, update Okta Verify to the latest version, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.app.method.push.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.app.method.push.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.app.method.push.enroll.enable.biometrics":"Your organization requires biometrics. To proceed, ensure your device supports biometrics, then add your account and enable biometrics when prompted.","oie.authenticator.app.method.push.enroll.enable.biometrics.title":"Enable biometrics to add an account in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.google_authenticator.label":"Google Authenticator","oie.google_authenticator.authenticator.description":"Enter a temporary code generated from the Google Authenticator app.","oie.enroll.google_authenticator.setup.title":"Set up Google Authenticator","oie.enroll.google_authenticator.scanBarcode.title":"Scan barcode","oie.enroll.google_authenticator.scanBarcode.description":"Launch Google Authenticator, tap the \"+\" icon, then select \"Scan barcode\".","oie.enroll.google_authenticator.scanBarcode.cannotScan":"Can't scan?","oie.enroll.google_authenticator.cannotScanBarcode.title":"Can't scan barcode?","oie.enroll.google_authenticator.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","oie.enroll.google_authenticator.enterCode.title":"Enter code displayed from application","oie.verify.google_authenticator.otp.title":"Verify with Google Authenticator","oie.verify.google_authenticator.otp.description":"Enter the temporary code generated in your Google Authenticator app","oie.google_authenticator.otp.enterCodeText":"Enter code","oie.verify.custom_otp.title":"Verify with {0}","oie.verify.custom_otp.description":"Enter the code generated on your authenticator and verify.","oie.custom_otp.description":"Enter a temporary code generated from an authenticator device.","oie.custom_otp.authenticator.default.vendorName":"Custom OTP Authenticator","oie.custom_otp.verify.passcode.label":"Enter code","oie.verify.custom_app.title":"Verify with {0}","oie.custom_app.push.sent":"Push notification sent","oie.custom_app.push.resend":"Resend push notification","oie.custom_app.push.warning":"Haven't received a push notification yet? Try opening {0} on your phone.","oie.on_prem.authenticator.description":"Verify by entering a code generated by {0}.","oie.on_prem.authenticator.default.vendorName":"Custom On-prem Authenticator","oie.on_prem.enroll.title":"Set up {0}","oie.on_prem.verify.title":"Verify with {0}","oie.numberchallenge.warning":"Haven't received a push notification yet? Try opening the Okta Verify app on your device, or <$1>resend the push notification</$1>.","oie.numberchallenge.instruction":"On your mobile device, open the Okta Verify prompt, then tap <$1>{0}</$1> in Okta Verify to continue.","oie.numberchallenge.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.method.push.force.upgrade.number_challenge":"Your response was received, but your Okta Verify version is no longer supported by your organization. To verify your identity with push notifications, update Okta Verify to the latest version, then try again.","oie.rsa.authenticator.description":"Verify by entering a code generated by RSA SecurID","oie.duo.authenticator.description":"Verify your identity using Duo Security.","oie.duo.enroll.title":"Set up Duo Security","oie.duo.verify.title":"Verify with Duo Security","oie.duo.iFrameError":"Error loading Duo. Try again or contact your admin for assistance.","oie.authenticator.duo.error":"We were unable to verify with Duo. Try again.","oie.idp.authenticator.description":"Redirect to verify with {0}.","oie.idp.enroll.title":"Set up {0}","oie.idp.enroll.description":"Clicking below will redirect to enrollment in {0}","oie.idp.challenge.title":"Verify with {0}","oie.idp.challenge.description":"You will be redirected to verify with {0}","oie.symantecVip.authenticator.description":"Verify by entering a temporary code from the {0} app.","oie.symantecVip.enroll.title":"Set up {0}","oie.symantecVip.enroll.description":"From the {0} app, enter your credential ID and two consecutive generated codes","oie.symantecVip.challenge.title":"Verify with {0}","oie.symantecVip.challenge.description":"Enter the generated security code from the {0} app.","oie.symantecVip.verify.passcode.label":"Enter security code","oie.yubikey.label":"YubiKey Authenticator","oie.yubikey.authenticator.description":"Verify your identity using YubiKey","oie.yubikey.enroll.title":"Set up YubiKey","oie.yubikey.challenge.title":"Verify with YubiKey","oie.yubikey.description":"Insert the YubiKey into a USB port and tap it to generate a verification code.","oie.yubikey.passcode.label":"Insert then tap your YubiKey","oie.select.authenticators.enroll.title":"Set up security methods","oie.select.authenticators.enroll.subtitle":"Security methods help protect your account by ensuring only you have access.","oie.select.authenticators.enroll.subtitle.custom":"Security methods help protect your {0} account by ensuring only you have access.","oie.setup.required":"Set up required","oie.setup.optional":"Set up optional","oie.optional.authenticator.button.title":"Finish","oie.verify.authenticator.button.text":"Select","oie.enroll.authenticator.button.text":"Set up","oie.select.authenticators.verify.title":"Verify it's you with a security method","oie.select.authenticators.verify.subtitle":"Select from the following options","oie.success.text.signingIn":"Signing in","oie.success.text.signingIn.with.ellipsis":"Signing in...","oie.success.text.signingIn.with.appName":"Signing in to {0}","oie.success.text.signingIn.with.appName.and.identifier":"Signing in to {0} as {1}","oie.go.back":"Go back","oie.enroll.switch.authenticator":"Return to authenticator list","oie.enroll.skip.setup":"Skip set up","oie.enroll.skip.profile":"Skip Profile","oie.verification.switch.authenticator":"Verify with something else","oie.remember":"Keep me signed in","oie.try.again":"Try again","enroll.title.oda":"Download Okta Verify","enroll.title.mdm":"Additional setup required","enroll.explanation.p1":"To sign in using Okta Verify, you will need to set up Okta Verify on this device.","enroll.explanation.p2":"In the app, follow the instructions to add an organizational account. When prompted, choose <span class=\"semi-strong\">Sign In</span>, then enter the <span class=\"semi-strong\">sign-in URL</span>:","enroll.oda.android.step1":"On Google Play, download the Okta Verify app.","enroll.oda.step1":"Open Okta Verify and follow the steps to add your account.","enroll.oda.step2":"When prompted, choose Sign In, then enter the sign-in URL:","enroll.oda.step3":"Download the Okta Verify app.","enroll.oda.step6":"Finish setting up your account in Okta Verify, then try accessing this app again.","enroll.appleStore":"the App Store","enroll.googleStore":"Google Play","enroll.copy.ios":"Apple®, App Store, and the Apple logo are trademarks of Apple Inc.","enroll.copy.android":"Google Play and the Google Play logo are trademarks of Google LLC.","enroll.explanation.mdm":"To access this app, your device needs to meet your organization's security requirements. Follow the instructions below to continue.","enroll.oda.org.copyLink":"Copy sign-in URL to clipboard","enroll.oda.org.copyLink.success":"Sign-in URL copied.","enroll.mdm.copyLink":"Copy link to clipboard","enroll.mdm.copyLink.success":"Link copied.","enroll.mdm.step1":"Tap the Copy Link button below.","enroll.mdm.step2":"On this device, open your browser, then paste the copied link into the address bar.","enroll.mdm.step3":"Follow the instructions in your browser to set up <span class=\"semi-strong\">{0}</span>, then try accessing this app again.","oie.safe.mode.title":"Authenticator set up unavailable","idx.error.server.safe.mode.enrollment.unavailable":"Set up is temporarily unavailable due to server maintenance. Try again later.","oie.primaryauth.submit":"Sign in","oie.registration.form.title":"Sign up","oie.registration.form.submit":"Sign Up","oie.user.profile.lastname":"Last name","oie.user.profile.firstname":"First name","oie.user.profile.primary.email":"Email","oie.selfservice.unlock_user.success.message":"You can log in using your existing username and password.","oie.selfservice.unlock_user.failed.message":"We are unable to unlock your account at this time, please contact your administrator","oie.selfservice.user.unlock.not.allowed":"Self Service Unlock is not allowed at this time. Please contact support for assistance.","idx.session.expired":"The session has expired.","oie.registration.is.not.enabled":"Sign up is not enabled for this organization.","oie.forgot.password.is.not.enabled":"Forgot password is not enabled for this organization.","idx.return.error":"Could not process this email link. Return to the screen where you requested it.","idx.return.stale":"This email link is out of date. Return to the screen where you requested it.","idx.invalid.forgot.password.token":"Your reset password token is no longer valid.","idx.invalid.reset.password.token":"Your reset password token is no longer valid. Contact your administrator to obtain a new token.","idx.reset.password.activating.user":"Reset password cannot be performed while the user is activating. Contact your administrator to obtain a new token.","tagsNotAllowed":"The field must not contain HTML tags","api.authn.error.PASSCODE_INVALID":"Invalid code. Try again.","oie.feature.disabled":"The requested feature is not enabled in this environment.","authfactor.challenge.suspended_factor":"This factor is suspended for your account due to too many failed attempts","oie.post.password.update.auth.failure.error":"Your password has been updated but there was a problem signing you in. Please try again or contact your administrator.","oie.assurance.unsatisfiable":"Unable to login to \"{0}\" at this time. For assistance, please contact your administrator.","errors.E0000150":"You have reached the limit of sms requests, please try again later.","errors.E0000151":"You have reached the limit of call requests, please try again later.","oie.consent.scopes.admin.title":"would like to access:","oie.consent.scopes.enduser.title":"would like to:","oie.consent.enduser.accept.label":"Yes, it's me","oie.consent.enduser.deny.label":"No, it's not me","oie.consent.enduser.title":"Did you just try to sign in?","oie.consent.enduser.email.allow.title":"Success! Return to the original tab or window","oie.consent.enduser.email.allow.description":"To continue, please return to the original browser tab or window you used to verify.","oie.consent.enduser.deny.description":"Close this window anytime.","oie.return.to.original.tab":"Close this window anytime.","idx.operation.cancelled.by.user":"Operation cancelled by user.","idx.transferred.to.new.tab":"Flow continued in a new tab.","idx.return.link.expired":"This email link has expired. To resend it, return to the screen where you requested it.","consent.scopes.email.label":"View your email address.","consent.scopes.profile.label":"View your profile information.","consent.scopes.phone.label":"View your phone number.","consent.scopes.address.label":"View your address.","consent.scopes.offlineAccess.label":"Keep you signed in to the app.","consent.scopes.onlineAccess.label":"Keep you signed in to the app.","consent.scopes.deviceSSO.label":"Request device secret.","consent.scopes.openid.desc":"Signals that a request is an OpenID request.","consent.scopes.profile.desc":"The exact data varies based on what profile information you have provided, such as: name, time zone, picture, or birthday.","consent.scopes.email.desc":"This allows the app to view your email address.","consent.scopes.address.desc":"This allows the app to view your address, such as: street address, city, state, and zip code.","consent.scopes.phone.desc":"This allows the app to view your phone number.","consent.scopes.offlineAccess.desc":"This keeps you signed in to the app, even when you are not using it.","consent.scopes.onlineAccess.desc":"This allows the app to access your data only when you are logged in to the application.","consent.scopes.deviceSSO.desc":"This allows you to single sign on between native client applications on your device.","consent.scopes.okta.users.manage.desc":"Allows the app to create new users and to manage all users'' profile and credentials information.","consent.scopes.okta.users.manage.self.desc":"Allows the app to manage the signed-in user''s profile and credentials.","consent.scopes.okta.users.read.desc":"Allows the app to read the existing users'' profiles and credentials.","consent.scopes.okta.users.read.self.desc":"Allows the app to read the signed-in user''s profile and credentials.","consent.scopes.okta.linkedObjects.manage.desc":"Allows the app to manage linked object definitions in your Okta organization.","consent.scopes.okta.linkedObjects.read.desc":"Allows the app to read linked object definitions in your Okta organization.","consent.scopes.okta.myAccount.manage.desc":"Allows the end-user to manage their account profile.","consent.scopes.okta.myAccount.read.desc":"Allows the end-user to read their account profile.","consent.scopes.okta.riskEvents.manage.desc":"Allows the app to publish risk events to your Okta organization.","consent.scopes.okta.clients.manage.desc":"Allows the app to manage clients in your Okta organization.","consent.scopes.okta.clients.read.desc":"Allows the app to read information about clients in your Okta organization.","consent.scopes.okta.clients.register.desc":"Allows the app to create new clients in your Okta organization.","consent.scopes.okta.authorizationServers.manage.desc":"Allows the app to create and manage Authorization Servers in your Okta organization.","consent.scopes.okta.authorizationServers.read.desc":"Allows the app to read information about Authorization Servers in your Okta organization.","consent.scopes.okta.groups.manage.desc":"Allows the app to manage existing groups in your Okta organization.","consent.scopes.okta.groups.read.desc":"Allows the app to read information about groups and their members in your Okta organization.","consent.scopes.okta.groups.register.desc":"Allows the app to create new groups in your Okta organization.","consent.scopes.okta.events.read.desc":"Allows the app to read information about deprecated Events v1 API entries in your Okta organization.","consent.scopes.okta.logs.read.desc":"Allows the app to read information about System Log entries in your Okta organization.","consent.scopes.okta.inlineHooks.manage.desc":"Allows the app to create and manage Inline Hooks in your Okta organization.","consent.scopes.okta.inlineHooks.read.desc":"Allows the app to read information about Inline Hooks in your Okta organization.","consent.scopes.okta.eventHooks.manage.desc":"Allows the app to create and manage Event Hooks in your Okta organization.","consent.scopes.okta.eventHooks.read.desc":"Allows the app to read information about Event Hooks in your Okta organization.","consent.scopes.okta.apps.manage.desc":"Allows the app to create and manage Apps in your Okta organization.","consent.scopes.okta.apps.read.desc":"Allows the app to read information about Apps in your Okta organization.","consent.scopes.okta.schemas.manage.desc":"Allows the app to create and manage Schemas in your Okta organization.","consent.scopes.okta.schemas.read.desc":"Allows the app to read information about Schemas in your Okta organization.","consent.scopes.okta.idps.manage.desc":"Allows the app to create and manage Identity Providers in your Okta organization.","consent.scopes.okta.idps.read.desc":"Allows the app to read information about Identity Providers in your Okta organization.","consent.scopes.okta.roles.manage.desc":"Allows the app to manage administrative role assignments for users in your Okta organization.","consent.scopes.okta.roles.read.desc":"Allows the app to read administrative role assignments for users in your Okta organization.","consent.scopes.okta.policies.manage.desc":"Allows the app to manage policies in your Okta organization.","consent.scopes.okta.policies.read.desc":"Allows the app to read information about policies in your Okta organization.","consent.scopes.okta.orgs.manage.desc":"Allows the app to manage organization-specific details for your Okta organization.","consent.scopes.okta.orgs.read.desc":"Allows the app to read organization-specific details about your Okta organization.","consent.scopes.okta.captchas.manage.desc":"Allows the app to create and manage CAPTCHAs in your Okta organization.","consent.scopes.okta.captchas.read.desc":"Allows the app to read information about CAPTCHAs in your Okta organization.","consent.scopes.okta.sessions.manage.desc":"Allows the app to manage all sessions in your Okta organization.","consent.scopes.okta.sessions.read.desc":"Allows the app to read all sessions in your Okta organization.","consent.scopes.okta.trustedOrigins.manage.desc":"Allows the app to manage all Trusted Origins in your Okta organization.","consent.scopes.okta.trustedOrigins.read.desc":"Allows the app to read all Trusted Origins in your Okta organization.","consent.scopes.okta.templates.manage.desc":"Allows the app to manage all custom templates in your Okta organization.","consent.scopes.okta.templates.read.desc":"Allows the app to read all custom templates in your Okta organization.","consent.scopes.okta.factors.manage.desc":"Allows the app to manage all admin operations for org factors (e.g. activate, deactivate, read).","consent.scopes.okta.factors.read.desc":"Allows the app to read org factors information.","consent.scopes.okta.authenticators.manage.desc":"Allows the app to manage all security methods (e.g. enrollments, reset).","consent.scopes.okta.authenticators.read.desc":"Allows the app to read org security method information.","consent.scopes.okta.authenticators.manage.self.desc":"Allows the app to manage users own security methods (e.g. enrollments, reset).","consent.scopes.idSnapshot.read.desc":"Allows the app to read your identity snapshot attestation.","consent.scopes.idSnapshot.manage.desc":"Allows the app to create and manage your identity snapshot attestation.","logo.for.the.app.alt.text":"Logo for the app","device.code.activate.title":"Activate your device","device.code.activate.subtitle":"Follow the instructions on your device to get an activation code","device.code.activate.label":"Activation Code","device.code.activated.success.title":"Device activated","device.code.activated.error.title":"Device not activated","idx.device.activated":"Follow the instructions on your device for next steps","idx.device.not.activated.consent.denied":"Your device cannot be activated because you did not allow access","idx.device.not.activated.internal.error":"Your device cannot be activated because of an internal error","idx.invalid.device.code":"Invalid code. Try again.","idx.operation.cancelled.on.other.device":"Access denied on other device.","idx.expired.activation.token":"Your account activation link is no longer valid. Request a new activation email below.","idx.missing.activation.token":"This can happen if you have already activated your account, or if the URL you are trying to use is invalid. Contact your administrator for further assistance.","idx.activating.inactive.user":"Your account has been temporarily suspended. Contact your administrator for further assistance.","idx.request.activation.email":"New activation link requested. If your information matches our records, you will receive a new activation link in your inbox soon.","oie.activation.request.email.title.expire":"Activation link has expired","oie.activation.request.email.title.invalid":"Activation link no longer valid","oie.activation.request.email.title.suspended":"Account suspended","oie.activation.request.email.title.submitted":"Request submitted","oie.activation.request.email.button":"Request activation email","oie.browser.error.NotAllowedError":"The operation either timed out or was not allowed.","authfactor.challenge.soft_token.invalid_passcode":"Your code doesn't match our records. Please try again.","authfactor.challenge.soft_token.used_passcode":"Each code can only be used once. Please wait for a new code and try again.","oie.tooManyRequests":"Too many attempts. Try again later.","E0000010":"Server is unable to respond at the moment.","idx.error.registration.unavailable":"Registration is currently unavailable.","idx.error.user.not.assigned.to.app":"User is not assigned to this application.","idx.error.code.user_not_assigned":"You are not allowed to access this app. To request access, contact an admin."}

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1100);

module.exports = parent;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var startsWith = __webpack_require__(1101);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.startsWith;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.startsWith) ? startsWith : own;
};


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1102);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('String').startsWith;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(128).f;
var toLength = __webpack_require__(66);
var notARegExp = __webpack_require__(289);
var requireObjectCoercible = __webpack_require__(131);
var correctIsRegExpLogic = __webpack_require__(292);
var IS_PURE = __webpack_require__(87);

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _default;

var _oktaAuthJs = __webpack_require__(505);

var _Util = _interopRequireDefault(__webpack_require__(31));

var _config = _interopRequireDefault(__webpack_require__(238));

var _underscore = _interopRequireDefault(__webpack_require__(229));

function _default(options) {
  var authParams = _underscore.default.extend({
    transformErrorXHR: _Util.default.transformErrorXHR,
    headers: {
      'X-Okta-User-Agent-Extended': 'okta-signin-widget-' + _config.default.version
    }
  }, options); // Disable token manager auto renew


  authParams.tokenManager = _underscore.default.extend({}, authParams.tokenManager, {
    autoRenew: false
  }); // TODO: remove when auth-js is updated: OKTA-325445

  authParams.headers = _Util.default.removeNils(authParams.headers);
  return new _oktaAuthJs.OktaAuth(authParams);
}

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = buildRenderOptions;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _OAuth2Util = _interopRequireDefault(__webpack_require__(326));

function buildRenderOptions() {
  var widgetOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var authParams = _okta.$.extend(true, {}, widgetOptions.authParams, _okta._.pick(options, _OAuth2Util.default.AUTH_PARAMS));

  var _Object$assign = (0, _assign.default)({}, widgetOptions, options),
      el = _Object$assign.el,
      clientId = _Object$assign.clientId,
      redirectUri = _Object$assign.redirectUri;

  var renderOptions = (0, _assign.default)({}, {
    el: el,
    clientId: clientId,
    redirectUri: redirectUri,
    authParams: authParams
  });

  if (!renderOptions.el) {
    throw new _Errors.default.ConfigError('"el" is required');
  }

  if (!renderOptions.clientId) {
    throw new _Errors.default.ConfigError('"clientId" is required');
  }

  if (!renderOptions.redirectUri) {
    throw new _Errors.default.ConfigError('"redirectUri" is required');
  }

  return renderOptions;
}

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = createRouter;

var _promise = _interopRequireDefault(__webpack_require__(195));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

function createRouter(Router, widgetOptions, renderOptions, authClient, successFn, errorFn) {
  var router;
  var routerOptions;
  var promise = new _promise.default(function (resolve, reject) {
    routerOptions = _okta.$.extend(true, {}, widgetOptions, renderOptions, {
      authClient: authClient,
      globalSuccessFn: function globalSuccessFn(res) {
        successFn && successFn(res); // call success function if provided

        if (res && res.status === _Enums.default.SUCCESS) {
          resolve(res);
        }
      },
      globalErrorFn: function globalErrorFn(error) {
        errorFn && errorFn(error); // call error function if provided

        reject(error);
      }
    });
    router = new Router(routerOptions);
    router.start();
  });
  return {
    router: router,
    routerOptions: routerOptions,
    promise: promise
  };
}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(87);
var global = __webpack_require__(33);
var getBuiltIn = __webpack_require__(96);
var NativePromise = __webpack_require__(508);
var redefine = __webpack_require__(138);
var redefineAll = __webpack_require__(240);
var setToStringTag = __webpack_require__(106);
var setSpecies = __webpack_require__(1107);
var isObject = __webpack_require__(38);
var aFunction = __webpack_require__(84);
var anInstance = __webpack_require__(196);
var classof = __webpack_require__(130);
var inspectSource = __webpack_require__(461);
var iterate = __webpack_require__(119);
var checkCorrectnessOfIteration = __webpack_require__(475);
var speciesConstructor = __webpack_require__(509);
var task = __webpack_require__(510).set;
var microtask = __webpack_require__(1108);
var promiseResolve = __webpack_require__(512);
var hostReportErrors = __webpack_require__(1109);
var newPromiseCapabilityModule = __webpack_require__(197);
var perform = __webpack_require__(241);
var InternalStateModule = __webpack_require__(95);
var isForced = __webpack_require__(400);
var wellKnownSymbol = __webpack_require__(34);
var V8_VERSION = __webpack_require__(316);

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(96);
var definePropertyModule = __webpack_require__(86);
var wellKnownSymbol = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(44);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var getOwnPropertyDescriptor = __webpack_require__(128).f;
var classof = __webpack_require__(130);
var macrotask = __webpack_require__(510).set;
var IS_IOS = __webpack_require__(511);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(87);
var NativePromise = __webpack_require__(508);
var fails = __webpack_require__(28);
var getBuiltIn = __webpack_require__(96);
var speciesConstructor = __webpack_require__(509);
var promiseResolve = __webpack_require__(512);
var redefine = __webpack_require__(138);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _AccountUnlockedController = _interopRequireDefault(__webpack_require__(1112));

var _ActivateTotpController = _interopRequireDefault(__webpack_require__(1113));

var _AdminConsentRequiredController = _interopRequireDefault(__webpack_require__(1125));

var _BarcodePushController = _interopRequireDefault(__webpack_require__(1127));

var _BarcodeTotpController = _interopRequireDefault(__webpack_require__(1129));

var _ConsentRequiredController = _interopRequireDefault(__webpack_require__(1130));

var _CustomPasswordExpiredController = _interopRequireDefault(__webpack_require__(1133));

var _DeviceActivateController = _interopRequireDefault(__webpack_require__(1134));

var _DeviceActivateTerminalController = _interopRequireDefault(__webpack_require__(1135));

var _EnrollActivateCustomFactorController = _interopRequireDefault(__webpack_require__(1136));

var _EnrollActivateEmailController = _interopRequireDefault(__webpack_require__(1137));

var _EnrollCallAndSmsController = _interopRequireDefault(__webpack_require__(1138));

var _EnrollChoicesController = _interopRequireDefault(__webpack_require__(1140));

var _EnrollCustomFactorController = _interopRequireDefault(__webpack_require__(531));

var _EnrollDuoController = _interopRequireDefault(__webpack_require__(1143));

var _EnrollEmailController = _interopRequireDefault(__webpack_require__(1148));

var _EnrollHotpController = _interopRequireDefault(__webpack_require__(1149));

var _EnrollOnPremController = _interopRequireDefault(__webpack_require__(1150));

var _EnrollPasswordController = _interopRequireDefault(__webpack_require__(1151));

var _EnrollQuestionController = _interopRequireDefault(__webpack_require__(1152));

var _EnrollSymantecVipController = _interopRequireDefault(__webpack_require__(1153));

var _EnrollTotpController = _interopRequireDefault(__webpack_require__(1154));

var _EnrollU2FController = _interopRequireDefault(__webpack_require__(1156));

var _EnrollUserController = _interopRequireDefault(__webpack_require__(1157));

var _EnrollWebauthnController = _interopRequireDefault(__webpack_require__(1161));

var _EnrollWindowsHelloController = _interopRequireDefault(__webpack_require__(1166));

var _EnrollYubikeyController = _interopRequireDefault(__webpack_require__(1167));

var _EnrollmentLinkSentController = _interopRequireDefault(__webpack_require__(1168));

var _EnterPasscodePushFlowController = _interopRequireDefault(__webpack_require__(1169));

var _ForgotPasswordController = _interopRequireDefault(__webpack_require__(1170));

var _IDPDiscoveryController = _interopRequireDefault(__webpack_require__(1171));

var _ManualSetupPushController = _interopRequireDefault(__webpack_require__(1182));

var _ManualSetupTotpController = _interopRequireDefault(__webpack_require__(1184));

var _MfaVerifyController = _interopRequireDefault(__webpack_require__(1186));

var _PasswordExpiredController = _interopRequireDefault(__webpack_require__(1197));

var _PasswordResetController = _interopRequireDefault(__webpack_require__(1198));

var _PollController = _interopRequireDefault(__webpack_require__(1199));

var _PrimaryAuthController = _interopRequireDefault(__webpack_require__(542));

var _PwdResetEmailSentController = _interopRequireDefault(__webpack_require__(1200));

var _RecoveryChallengeController = _interopRequireDefault(__webpack_require__(1201));

var _RecoveryLoadingController = _interopRequireDefault(__webpack_require__(1202));

var _RecoveryQuestionController = _interopRequireDefault(__webpack_require__(1203));

var _RefreshAuthStateController = _interopRequireDefault(__webpack_require__(1204));

var _RegistrationCompleteController = _interopRequireDefault(__webpack_require__(1205));

var _RegistrationController = _interopRequireDefault(__webpack_require__(1206));

var _UnlockAccountController = _interopRequireDefault(__webpack_require__(1210));

var _UnlockEmailSentController = _interopRequireDefault(__webpack_require__(1211));

var _VerifyCustomFactorController = _interopRequireDefault(__webpack_require__(1212));

var _VerifyDuoController = _interopRequireDefault(__webpack_require__(1213));

var _VerifyPIVController = _interopRequireDefault(__webpack_require__(1214));

var _VerifyU2FController = _interopRequireDefault(__webpack_require__(1221));

var _VerifyWebauthnController = _interopRequireDefault(__webpack_require__(1222));

var _VerifyWindowsHelloController = _interopRequireDefault(__webpack_require__(1223));

var _ErrorStateController = _interopRequireDefault(__webpack_require__(1224));

var _BaseLoginRouter = _interopRequireDefault(__webpack_require__(1225));

var _FactorBeacon = _interopRequireDefault(__webpack_require__(1228));

var _PIVBeacon = _interopRequireDefault(__webpack_require__(1231));

var _SecurityBeacon = _interopRequireDefault(__webpack_require__(552));

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-params: 0 */
var _default = _BaseLoginRouter.default.extend({
  routes: {
    '': 'defaultAuth',
    signin: 'primaryAuth',
    'signin/verify/duo/web': 'verifyDuo',
    'signin/verify/piv': 'verifyPIV',
    'signin/poll': 'poll',
    'signin/verify/fido/webauthn': 'verifyWebauthn',
    'signin/verify/webauthn': 'verifyWebauthn',
    'signin/verify/fido/u2f': 'verifyU2F',
    'signin/verify/u2f': 'verifyU2F',
    'signin/verify/generic_saml/assertion:saml2': 'verifySAMLFactor',
    'signin/verify/generic_oidc/assertion:oidc': 'verifyOIDCFactor',
    'signin/verify/custom/claims_provider': 'verifyClaimsFactor',
    'signin/verify/:factorType': 'verifyNoProvider',
    'signin/verify/:provider/:factorType(/:factorIndex)': 'verify',
    'signin/enroll': 'enrollChoices',
    'signin/enroll/duo/web': 'enrollDuo',
    'signin/enroll/okta/question': 'enrollQuestion',
    'signin/enroll/okta/password': 'enrollPassword',
    'signin/enroll/okta/sms': 'enrollSms',
    'signin/enroll/okta/call': 'enrollCall',
    'signin/enroll/okta/email': 'enrollEmail',
    'signin/enroll-activate/okta/sms': 'enrollSms',
    'signin/enroll-activate/okta/call': 'enrollCall',
    'signin/enroll/rsa/token': 'enrollRsa',
    'signin/enroll/del_oath/token': 'enrollOnPrem',
    'signin/enroll/symantec/token': 'enrollSymantecVip',
    'signin/enroll/yubico/token:hardware': 'enrollYubikey',
    'signin/enroll/fido/webauthn': 'enrollWebauthn',
    'signin/enroll/fido/u2f': 'enrollU2F',
    'signin/enroll/generic_saml/assertion:saml2': 'enrollSAMLFactor',
    'signin/enroll/generic_oidc/assertion:oidc': 'enrollOIDCFactor',
    'signin/enroll/custom/claims_provider': 'enrollClaimsFactor',
    'signin/enroll/custom/token:hotp': 'enrollHotpFactor',
    'signin/enroll/:provider/:factorType': 'enrollTotpFactor',
    'signin/enroll-activate/okta/email': 'enrollActivateEmail',
    'signin/enroll-activate/okta/push': 'scanBarcodePushFactor',
    'signin/enroll-activate/okta/push/manual': 'manualSetupPushFactor',
    'signin/enroll-activate/okta/push/sent': 'activationLinkSent',
    'signin/enroll-activate/okta/token:software:totp/passcode': 'enterPasscodeInPushEnrollmentFlow',
    'signin/enroll-activate/custom/claims_provider': 'enrollActivateClaimsFactor',
    'signin/enroll-activate/:provider/:factorType': 'scanBarcodeTotpFactor',
    'signin/enroll-activate/:provider/:factorType/activate': 'activateTotpFactor',
    'signin/enroll-activate/:provider/:factorType/manual': 'manualSetupTotpFactor',
    'signin/password-expired': 'passwordExpired',
    'signin/custom-password-expired': 'customPasswordExpired',
    'signin/forgot-password': 'forgotPassword',
    'signin/recovery-challenge': 'recoveryChallenge',
    'signin/recovery-emailed': 'recoveryEmailSent',
    'signin/recovery-question': 'recoveryQuestion',
    'signin/password-reset': 'passwordReset',
    'signin/reset-password/:token': 'recoveryLoading',
    'signin/user-unlock/:token': 'recoveryLoading',
    'signin/recovery/:token': 'recoveryLoading',
    'signin/unlock-emailed': 'unlockEmailSent',
    'signin/unlock': 'unlockAccount',
    'signin/account-unlocked': 'accountUnlocked',
    'signin/refresh-auth-state(/:token)': 'refreshAuthState',
    'signin/register': 'register',
    'signin/register-complete': 'registerComplete',
    'signin/error': 'errorState',
    'signin/consent': 'consentRequired',
    'signin/admin-consent': 'adminConsentRequired',
    'signin/enroll-user': 'enrollUser',
    'signin/device-activate-complete': 'deviceActivateComplete',
    'signin/device-activate': 'deviceActivate',
    '*wildcard': 'defaultAuth'
  },
  // Route handlers that do not require a stateToken. If the page is refreshed,
  // these functions will not require a status call to refresh the stateToken.
  stateLessRouteHandlers: ['defaultAuth', 'idpDiscovery', 'primaryAuth', 'forgotPassword', 'recoveryLoading', 'unlockAccount', 'refreshAuthState', 'register', 'registerComplete', 'errorState', 'verifyPIV'],
  defaultAuth: function defaultAuth() {
    if (location.hash === "#".concat(_Enums.default.WIDGET_CONTAINER_ID)) {
      document.getElementById(_Enums.default.WIDGET_CONTAINER_ID).focus();
      return;
    }

    if (this.settings.get('features.idpDiscovery')) {
      this.idpDiscovery();
    } else {
      this.primaryAuth();
    }
  },
  idpDiscovery: function idpDiscovery() {
    this.render(_IDPDiscoveryController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  primaryAuth: function primaryAuth() {
    this.render(_PrimaryAuthController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  verifyDuo: function verifyDuo() {
    this.render(_VerifyDuoController.default, {
      provider: 'DUO',
      factorType: 'web',
      Beacon: _FactorBeacon.default
    });
  },
  verifyPIV: function verifyPIV() {
    this.render(_VerifyPIVController.default, {
      Beacon: _PIVBeacon.default
    });
  },
  poll: function poll() {
    this.render(_PollController.default);
  },
  verifyWebauthn: function verifyWebauthn() {
    if (this.settings.get('features.webauthn')) {
      this.render(_VerifyWebauthnController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    } else {
      this.render(_VerifyWindowsHelloController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    }
  },
  verifyU2F: function verifyU2F() {
    this.render(_VerifyU2FController.default, {
      provider: 'FIDO',
      factorType: 'u2f',
      Beacon: _FactorBeacon.default
    });
  },
  verifySAMLFactor: function verifySAMLFactor() {
    this.render(_VerifyCustomFactorController.default, {
      provider: 'GENERIC_SAML',
      factorType: 'assertion:saml2',
      Beacon: _FactorBeacon.default
    });
  },
  verifyOIDCFactor: function verifyOIDCFactor() {
    this.render(_VerifyCustomFactorController.default, {
      provider: 'GENERIC_OIDC',
      factorType: 'assertion:oidc',
      Beacon: _FactorBeacon.default
    });
  },
  verifyClaimsFactor: function verifyClaimsFactor() {
    this.render(_VerifyCustomFactorController.default, {
      provider: 'CUSTOM',
      factorType: 'claims_provider',
      Beacon: _FactorBeacon.default
    });
  },
  verify: function verify(provider, factorType, factorIndex) {
    this.render(_MfaVerifyController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      factorIndex: factorIndex,
      Beacon: _FactorBeacon.default
    });
  },
  verifyNoProvider: function verifyNoProvider(factorType) {
    this.render(_MfaVerifyController.default, {
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  enrollChoices: function enrollChoices() {
    this.render(_EnrollChoicesController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  enrollDuo: function enrollDuo() {
    this.render(_EnrollDuoController.default, {
      provider: 'DUO',
      factorType: 'web',
      Beacon: _FactorBeacon.default
    });
  },
  enrollQuestion: function enrollQuestion() {
    this.render(_EnrollQuestionController.default, {
      provider: 'OKTA',
      factorType: 'question',
      Beacon: _FactorBeacon.default
    });
  },
  enrollPassword: function enrollPassword() {
    this.render(_EnrollPasswordController.default, {
      provider: 'OKTA',
      factorType: 'password',
      Beacon: _FactorBeacon.default
    });
  },
  enrollSms: function enrollSms() {
    this.render(_EnrollCallAndSmsController.default, {
      provider: 'OKTA',
      factorType: 'sms',
      Beacon: _FactorBeacon.default
    });
  },
  enrollCall: function enrollCall() {
    this.render(_EnrollCallAndSmsController.default, {
      provider: 'OKTA',
      factorType: 'call',
      Beacon: _FactorBeacon.default
    });
  },
  enrollEmail: function enrollEmail() {
    this.render(_EnrollEmailController.default, {
      provider: 'OKTA',
      factorType: 'email',
      Beacon: _FactorBeacon.default
    });
  },
  enrollActivateEmail: function enrollActivateEmail() {
    this.render(_EnrollActivateEmailController.default, {
      provider: 'OKTA',
      factorType: 'email',
      Beacon: _FactorBeacon.default
    });
  },
  enrollRsa: function enrollRsa() {
    this.render(_EnrollOnPremController.default, {
      provider: 'RSA',
      factorType: 'token',
      Beacon: _FactorBeacon.default
    });
  },
  enrollOnPrem: function enrollOnPrem() {
    this.render(_EnrollOnPremController.default, {
      provider: 'DEL_OATH',
      factorType: 'token',
      Beacon: _FactorBeacon.default
    });
  },
  enrollSymantecVip: function enrollSymantecVip() {
    this.render(_EnrollSymantecVipController.default, {
      provider: 'SYMANTEC',
      factorType: 'token',
      Beacon: _FactorBeacon.default
    });
  },
  enrollYubikey: function enrollYubikey() {
    this.render(_EnrollYubikeyController.default, {
      provider: 'YUBICO',
      factorType: 'token:hardware',
      Beacon: _FactorBeacon.default
    });
  },
  enrollSAMLFactor: function enrollSAMLFactor() {
    this.render(_EnrollCustomFactorController.default, {
      provider: 'GENERIC_SAML',
      factorType: 'assertion:saml2',
      Beacon: _FactorBeacon.default
    });
  },
  enrollOIDCFactor: function enrollOIDCFactor() {
    this.render(_EnrollCustomFactorController.default, {
      provider: 'GENERIC_OIDC',
      factorType: 'assertion:oidc',
      Beacon: _FactorBeacon.default
    });
  },
  enrollClaimsFactor: function enrollClaimsFactor() {
    this.render(_EnrollCustomFactorController.default, {
      provider: 'CUSTOM',
      factorType: 'claims_provider',
      Beacon: _FactorBeacon.default
    });
  },
  enrollActivateClaimsFactor: function enrollActivateClaimsFactor() {
    this.render(_EnrollActivateCustomFactorController.default, {
      provider: 'CUSTOM',
      factorType: 'claims_provider',
      Beacon: _FactorBeacon.default
    });
  },
  enrollTotpFactor: function enrollTotpFactor(provider, factorType) {
    this.render(_EnrollTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  enrollHotpFactor: function enrollHotpFactor() {
    this.render(_EnrollHotpController.default, {
      provider: 'CUSTOM',
      factorType: 'token:hotp',
      Beacon: _FactorBeacon.default
    });
  },
  enrollWebauthn: function enrollWebauthn() {
    if (this.settings.get('features.webauthn')) {
      this.render(_EnrollWebauthnController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    } else {
      this.render(_EnrollWindowsHelloController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    }
  },
  enrollU2F: function enrollU2F() {
    this.render(_EnrollU2FController.default, {
      provider: 'FIDO',
      factorType: 'u2f',
      Beacon: _FactorBeacon.default
    });
  },
  scanBarcodeTotpFactor: function scanBarcodeTotpFactor(provider, factorType) {
    this.render(_BarcodeTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  scanBarcodePushFactor: function scanBarcodePushFactor() {
    this.render(_BarcodePushController.default, {
      provider: 'OKTA',
      factorType: 'push',
      Beacon: _FactorBeacon.default
    });
  },
  activateTotpFactor: function activateTotpFactor(provider, factorType) {
    this.render(_ActivateTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  manualSetupTotpFactor: function manualSetupTotpFactor(provider, factorType) {
    this.render(_ManualSetupTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  manualSetupPushFactor: function manualSetupPushFactor() {
    this.render(_ManualSetupPushController.default, {
      provider: 'OKTA',
      factorType: 'push',
      Beacon: _FactorBeacon.default
    });
  },
  activationLinkSent: function activationLinkSent() {
    this.render(_EnrollmentLinkSentController.default, {
      provider: 'OKTA',
      factorType: 'push',
      Beacon: _FactorBeacon.default
    });
  },
  enterPasscodeInPushEnrollmentFlow: function enterPasscodeInPushEnrollmentFlow() {
    this.render(_EnterPasscodePushFlowController.default, {
      provider: 'OKTA',
      factorType: 'token:software:totp',
      Beacon: _FactorBeacon.default
    });
  },
  passwordExpired: function passwordExpired() {
    this.render(_PasswordExpiredController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  customPasswordExpired: function customPasswordExpired() {
    this.render(_CustomPasswordExpiredController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  forgotPassword: function forgotPassword() {
    this.render(_ForgotPasswordController.default);
  },
  recoveryChallenge: function recoveryChallenge() {
    this.render(_RecoveryChallengeController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  recoveryEmailSent: function recoveryEmailSent() {
    this.render(_PwdResetEmailSentController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  unlockEmailSent: function unlockEmailSent() {
    this.render(_UnlockEmailSentController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  recoveryQuestion: function recoveryQuestion() {
    this.render(_RecoveryQuestionController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  passwordReset: function passwordReset() {
    this.render(_PasswordResetController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  recoveryLoading: function recoveryLoading(token) {
    this.render(_RecoveryLoadingController.default, {
      token: token,
      Beacon: _SecurityBeacon.default
    });
  },
  unlockAccount: function unlockAccount() {
    this.render(_UnlockAccountController.default);
  },
  accountUnlocked: function accountUnlocked() {
    this.render(_AccountUnlockedController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  refreshAuthState: function refreshAuthState(token) {
    this.render(_RefreshAuthStateController.default, {
      token: token,
      Beacon: _SecurityBeacon.default
    });
  },
  register: function register() {
    this.render(_RegistrationController.default);
  },
  registerComplete: function registerComplete() {
    this.render(_RegistrationCompleteController.default);
  },
  errorState: function errorState() {
    this.render(_ErrorStateController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  consentRequired: function consentRequired() {
    this.render(_ConsentRequiredController.default);
  },
  adminConsentRequired: function adminConsentRequired() {
    this.render(_AdminConsentRequiredController.default);
  },
  enrollUser: function enrollUser() {
    this.render(_EnrollUserController.default);
  },
  deviceActivate: function deviceActivate() {
    this.render(_DeviceActivateController.default);
  },
  deviceActivateComplete: function deviceActivateComplete() {
    this.render(_DeviceActivateTerminalController.default);
  }
});

exports.default = _default;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'account-unlocked',
  Model: function Model() {
    return {
      local: {
        userFullName: ['string', false, this.options.appState.get('userFullName')]
      }
    };
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'account.unlock.unlocked.title', 'login'),
    subtitle: _okta._.partial(_okta.loc, 'account.unlock.unlocked.desc', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'account-unlocked'
    },
    formChildren: function formChildren() {
      return [_FormType.default.Button({
        title: (0, _okta.loc)('goback', 'login'),
        className: 'button button-primary button-wide',
        attributes: {
          'data-se': 'back-button'
        },
        click: function click() {
          this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
          this.options.appState.trigger('navigate', '');
        }
      })];
    }
  }
});

exports.default = _default;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _EnterPasscodeForm = _interopRequireDefault(__webpack_require__(514));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'activate-totp',
  Model: function Model() {
    return {
      props: {
        factorId: ['string', true, this.options.appState.get('activatedFactorId')],
        passCode: ['string', true]
      },
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    };
  },
  Form: _EnterPasscodeForm.default,
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _reduce = _interopRequireDefault(__webpack_require__(140));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _keys = _interopRequireDefault(__webpack_require__(117));

var _toMilliseconds = _interopRequireDefault(__webpack_require__(1115));

var _parseMs = _interopRequireDefault(__webpack_require__(1124));

var MOMENT_UNIT = {
  MILLISECOND: 'milliseconds',
  SECOND: 'seconds',
  MINUTE: 'minutes',
  HOUR: 'hours',
  DAY: 'days'
};
var MOMENT_UNIT_KEYS = (0, _keys.default)(MOMENT_UNIT);
/**
 * @method convertMomentUnits
 * Conversion between moment's units and our units internally
 *
 * @param {String} momentUnit The units that val is in
 * @return {String} The key in the MOMENT_UNIT hash
 */

var convertMomentUnits = function convertMomentUnits(momentUnit) {
  var entry = (0, _filter.default)(MOMENT_UNIT_KEYS).call(MOMENT_UNIT_KEYS, function (k) {
    return MOMENT_UNIT[k] === momentUnit;
  });
  return entry.length === 1 ? entry[0] : momentUnit;
};

var _default = {
  /**
   * @method getTimeInHighestRelevantUnit
   * Will return a number in the units of the highest relevant time unit.
   * Only checks milliseconds, seconds, minutes, hours, and days.
   * E.g.
   *   15 MINUTE  -> 15 MINUTE
   *   15 minutes -> 15 MINUTE
   *   60 minutes ->  1 HOUR
   *   90 minutes -> 90 MINUTE
   *   24 HOUR    ->  1 DAY
   *   24 hours   ->  1 DAY
   *   30 DAY     -> 30 DAY
   *
   * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" } TimeUnit
   *
   * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" |
   *            "milliseconds" | "seconds" | "minutes" | "hours" | "days"
   *          } FlexibleTimeUnit
   *
   * @typedef TimeAndUnit
   * @property {number} time the consolidated time
   * @property {TimeUnit} unit the unit of the time
   *
   * @param {FlexibleTimeUnit} unit The time unit
   * @return {TimeAndUnit} An object containing the amount of time and the unit
   */
  getTimeInHighestRelevantUnit: function getTimeInHighestRelevantUnit(val, unit) {
    var _context;

    var defaultTimeObj = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    };
    var normalizedUnit = MOMENT_UNIT[unit] || unit;
    var timeObj;

    try {
      var ms = (0, _toMilliseconds.default)((0, _assign.default)(defaultTimeObj, (0, _defineProperty2.default)({}, normalizedUnit, val)));
      timeObj = (0, _parseMs.default)(ms);
    } catch (error) {
      timeObj = {};
    }

    var duration = (0, _reduce.default)(_context = (0, _keys.default)(timeObj)).call(_context, function (init, k) {
      if (timeObj[k] !== 0) {
        init[k] = timeObj[k];
      }

      return init;
    }, {});
    var highestUnit;
    var time;

    if ((0, _keys.default)(duration).length === 1) {
      var _context2;

      (0, _forEach.default)(_context2 = (0, _keys.default)(duration)).call(_context2, function (k) {
        time = duration[k];
        highestUnit = k;
      });
    } else {
      time = val;
      highestUnit = normalizedUnit;
    }

    return {
      time: time,
      unit: convertMomentUnits(highestUnit)
    };
  }
};
exports.default = _default;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(517));

var _entries = _interopRequireDefault(__webpack_require__(1120));

var _reduce = _interopRequireDefault(__webpack_require__(140));

var converters = {
  days: function days(value) {
    return value * 864e5;
  },
  hours: function hours(value) {
    return value * 36e5;
  },
  minutes: function minutes(value) {
    return value * 6e4;
  },
  seconds: function seconds(value) {
    return value * 1e3;
  },
  milliseconds: function milliseconds(value) {
    return value;
  },
  microseconds: function microseconds(value) {
    return value / 1e3;
  },
  nanoseconds: function nanoseconds(value) {
    return value / 1e6;
  }
};

var toMilliseconds = function toMilliseconds(object) {
  var _context;

  return (0, _reduce.default)(_context = (0, _entries.default)(object)).call(_context, function (milliseconds, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value !== 'number') {
      var _context2, _context3;

      throw new TypeError((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "Expected a `number` for key `".concat(key, "`, got `")).call(_context3, value, "` (")).call(_context2, (0, _typeof2.default)(value), ")"));
    }

    if (!converters[key]) {
      throw new Error('Unsupported time key');
    }

    return milliseconds + converters[key](value);
  }, 0);
};

module.exports = toMilliseconds; // TODO: remove this for next major version

module.exports.default = toMilliseconds;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(518);

function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var _getIterator = __webpack_require__(458);

var _isIterable = __webpack_require__(313);

var _Symbol = __webpack_require__(315);

function _iterableToArrayLimit(arr, i) {
  if (typeof _Symbol === "undefined" || !_isIterable(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(523);

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(525);

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1122);
var path = __webpack_require__(23);

module.exports = path.Object.entries;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var $entries = __webpack_require__(1123).entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(44);
var objectKeys = __webpack_require__(182);
var toIndexedObject = __webpack_require__(83);
var propertyIsEnumerable = __webpack_require__(225).f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (milliseconds) {
  if (typeof milliseconds !== 'number') {
    throw new TypeError('Expected a number');
  }

  var roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
  return {
    days: roundTowardsZero(milliseconds / 86400000),
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1000,
    microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000
  };
};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _ScopeList = _interopRequireDefault(__webpack_require__(526));

var _consentLogoHeaderTemplate = _interopRequireDefault(__webpack_require__(527));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var ConsentModel = {
  props: {
    scopes: ['array', true]
  },
  save: function save() {
    return this.doTransaction(function (transaction) {
      return transaction.consent({
        consent: {
          scopes: _okta._.pluck(this.get('scopes'), 'name')
        }
      });
    });
  },
  cancel: function cancel() {
    var self = this;
    return this.doTransaction(function (transaction) {
      return transaction.cancel();
    }).then(function () {
      var consentCancelFn = self.settings.get('consent.cancel');

      if (_okta._.isFunction(consentCancelFn)) {
        consentCancelFn();
      }
    });
  }
};

var ConsentHeader = _okta.View.extend({
  className: 'consent-title detail-row',
  template: _consentLogoHeaderTemplate.default,
  getTemplateData: function getTemplateData() {
    var appState = this.options.appState;
    return {
      appName: appState.escape('targetLabel'),
      customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
      defaultLogo: appState.get('defaultAppLogo'),
      clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href,
      issuer: appState.get('issuer')
    };
  }
});

var ConsentForm = {
  noCancelButton: false,
  buttonOrder: ['cancel', 'save'],
  autoSave: true,
  save: _okta._.partial(_okta.loc, 'consent.required.consentButton', 'login'),
  cancel: _okta._.partial(_okta.loc, 'consent.required.cancelButton', 'login'),
  formChildren: [_FormType.default.View({
    View: ConsentHeader
  }), _FormType.default.View({
    View: _ScopeList.default
  })]
};

var AdminConsentRequiredController = _FormController.default.extend({
  Model: ConsentModel,
  Form: ConsentForm,
  className: 'admin-consent-required',
  initialize: function initialize() {
    var _this = this;

    this.model.set('scopes', this.options.appState.get('scopes'));
    this.listenTo(this.form, 'cancel', function () {
      _this.model.cancel();
    });
  }
});

module.exports = AdminConsentRequiredController;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

__webpack_require__(237);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'scope-item',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "<span class=\"scope-item-tooltip icon form-help-16\" />";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"scope-item-text no-translate\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 48
          }
        }
      }) : helper)) + "</p>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 52
          },
          "end": {
            "line": 1,
            "column": 131
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  postRender: function postRender() {
    this.$('.scope-item-tooltip').qtip({
      content: {
        text: _okta._.escape(this.options.description)
      },
      style: {
        classes: 'okta-tooltip qtip-custom qtip-shadow'
      },
      position: {
        my: 'bottom left',
        target: 'mouse'
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _BarcodeView = _interopRequireDefault(__webpack_require__(528));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var PUSH_INTERVAL = 6000; // Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
// in network connection lost errors in Safari and IE.

var _default = _FormController.default.extend({
  className: 'barcode-push',
  Model: function Model() {
    return {
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function title() {
      var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

      return (0, _okta.loc)('enroll.totp.title', 'login', [factorName]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'step-scan'
    },
    className: 'barcode-scan',
    initialize: function initialize() {
      this.listenTo(this.model, 'error errors:clear', function () {
        this.clearErrors();
      });
    },
    formChildren: [_FormType.default.View({
      View: _BarcodeView.default
    })]
  },
  Footer: _Footer.default,
  initialize: function initialize() {
    this.pollForEnrollment();
  },
  pollForEnrollment: function pollForEnrollment() {
    return this.model.doTransaction(function (transaction) {
      return transaction.poll(PUSH_INTERVAL);
    });
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  INVALID_TOKEN_EXCEPTION: 'E0000011'
};
exports.default = _default;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

var _BarcodeView = _interopRequireDefault(__webpack_require__(528));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'barcode-totp',
  Model: function Model() {
    return {
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function title() {
      var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

      return (0, _okta.loc)('enroll.totp.title', 'login', [factorName]);
    },
    save: _okta._.partial(_okta.loc, 'oform.next', 'login'),
    noCancelButton: true,
    attributes: {
      'data-se': 'step-scan'
    },
    className: 'barcode-scan',
    formChildren: [_FormType.default.View({
      View: _BarcodeView.default
    })]
  },
  Footer: _Footer.default,
  initialize: function initialize() {
    this.listenTo(this.form, 'save', function () {
      var url = _RouterUtil.default.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');

      this.options.appState.trigger('navigate', url);
    });
  }
});

exports.default = _default;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _ScopeList = _interopRequireDefault(__webpack_require__(529));

var _SkipLink = _interopRequireDefault(__webpack_require__(1132));

var _consentLogoHeaderTemplate = _interopRequireDefault(__webpack_require__(527));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len: [2, 160] */
var _default = _FormController.default.extend({
  className: 'consent-required',
  initialize: function initialize() {
    this.model.set('expiresAt', this.options.appState.get('expiresAt'));
    this.model.set('scopes', this.options.appState.get('scopes'));
    this.listenTo(this.form, 'cancel', (0, _bind.default)(_okta._).call(_okta._, this.model.cancel, this.model)); // add Skip to main content link

    var skipLink = new _SkipLink.default();
    (0, _okta.$)("#".concat(_Enums.default.WIDGET_LOGIN_CONTAINER_ID)).prepend(skipLink.render().$el);
  },
  postRender: function postRender() {
    _FormController.default.prototype.postRender.apply(this, arguments); // Update the "don't allow" and "allow access" buttons to be neutral by changing "allow button" to be gray.


    this.$('.o-form-button-bar .button-primary').removeClass('button-primary');
  },
  Model: {
    props: {
      expiresAt: ['string', true],
      scopes: ['array', true]
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        return transaction.consent({
          consent: {
            expiresAt: this.get('expiresAt'),
            scopes: _okta._.pluck(this.get('scopes'), 'name')
          }
        });
      });
    },
    cancel: function cancel() {
      var self = this;
      return this.doTransaction(function (transaction) {
        return transaction.cancel();
      }).then(function () {
        var consentCancelFn = self.settings.get('consent.cancel');

        if (_okta._.isFunction(consentCancelFn)) {
          consentCancelFn();
        }
      });
    }
  },
  Form: {
    noCancelButton: false,
    buttonOrder: ['cancel', 'save'],
    autoSave: true,
    save: _okta._.partial(_okta.loc, 'consent.required.consentButton', 'login'),
    cancel: _okta._.partial(_okta.loc, 'consent.required.cancelButton', 'login'),
    formChildren: function formChildren() {
      return [_FormType.default.View({
        View: _okta.View.extend({
          className: 'consent-title detail-row',
          template: _consentLogoHeaderTemplate.default,
          getTemplateData: function getTemplateData() {
            var appState = this.options.appState;
            return {
              appName: appState.escape('targetLabel'),
              customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
              defaultLogo: appState.get('defaultAppLogo'),
              clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href
            };
          }
        })
      }), _FormType.default.View({
        View: new _ScopeList.default({
          model: this.model
        })
      }), _FormType.default.View({
        View: _okta.View.extend({
          className: 'consent-description detail-row',
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "consent.required.description"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 3
                  },
                  "end": {
                    "line": 1,
                    "column": 62
                  }
                }
              })) + "</p>";
            },
            "useData": true
          })
        })
      })];
    }
  },
  Footer: _okta.View.extend({
    className: 'consent-footer',
    template: _runtime.default.template({
      "1": function _(container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
          "name": "termsOfService",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 56
            },
            "end": {
              "line": 1,
              "column": 74
            }
          }
        }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "consent.required.termsOfService"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 92
            },
            "end": {
              "line": 1,
              "column": 154
            }
          }
        })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(2, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 158
            },
            "end": {
              "line": 1,
              "column": 194
            }
          }
        })) != null ? stack1 : "");
      },
      "2": function _(container, depth0, helpers, partials, data) {
        return " &#8226 ";
      },
      "4": function _(container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
          "name": "privacyPolicy",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 254
            },
            "end": {
              "line": 1,
              "column": 271
            }
          }
        }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "consent.required.privacyPolicy"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 289
            },
            "end": {
              "line": 1,
              "column": 350
            }
          }
        })) + "</a>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 201
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(4, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 201
            },
            "end": {
              "line": 1,
              "column": 361
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    getTemplateData: function getTemplateData() {
      var appState = this.options.appState;
      return {
        termsOfService: appState.get('targetTermsOfService') && appState.get('targetTermsOfService').href,
        privacyPolicy: appState.get('targetPrivacyPolicy') && appState.get('targetPrivacyPolicy').href
      };
    }
  })
});

exports.default = _default;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

__webpack_require__(237);

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'scope-item',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      return "<span class=\"scope-item-tooltip icon form-help-16\"></span>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"" + alias4((helper = (helper = lookupProperty(helpers, "classNames") || (depth0 != null ? lookupProperty(depth0, "classNames") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "classNames",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 12
          },
          "end": {
            "line": 1,
            "column": 26
          }
        }
      }) : helper)) + "\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 31
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 49
          },
          "end": {
            "line": 1,
            "column": 133
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var _this$options = this.options,
        name = _this$options.name,
        description = _this$options.description,
        isCustomized = _this$options.isCustomized;
    var baseClass = 'scope-item-text';
    var classNames = name === 'openid' || isCustomized ? "".concat(baseClass, " no-translate") : baseClass;
    return {
      classNames: classNames,
      name: name,
      description: description
    };
  },
  postRender: function postRender() {
    this.$('.scope-item-tooltip').qtip({
      content: {
        text: _okta._.escape(this.options.description)
      },
      style: {
        classes: 'okta-tooltip qtip-custom qtip-shadow'
      },
      position: {
        my: 'bottom right',
        target: 'mouse'
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _default = _okta.View.extend({
  tagName: 'a',
  className: 'skip-to-content-link',
  attributes: {
    href: "#".concat(_Enums.default.WIDGET_CONTAINER_ID)
  },
  initialize: function initialize() {
    this.$el.append((0, _okta.loc)('skip.to.main.content', 'login'));
  }
});

exports.default = _default;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Footer = _interopRequireDefault(__webpack_require__(530));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _FormController.default.extend({
  className: 'custom-password-expired',
  Model: {},
  Form: {
    noButtonBar: true,
    title: function title() {
      var expiringSoon = this.options.appState.get('isPwdExpiringSoon');
      var numDays = this.options.appState.get('passwordExpireDays');

      if (expiringSoon && numDays > 0) {
        return (0, _okta.loc)('password.expiring.title', 'login', [numDays]);
      } else if (expiringSoon && numDays === 0) {
        return (0, _okta.loc)('password.expiring.today', 'login');
      } else if (expiringSoon) {
        return (0, _okta.loc)('password.expiring.soon', 'login');
      } else {
        return this.settings.get('brandName') ? (0, _okta.loc)('password.expired.title.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('password.expired.title.generic', 'login');
      }
    },
    subtitle: function subtitle() {
      if (this.options.appState.get('isPwdExpiringSoon')) {
        var subtitle = this.settings.get('brandName') ? (0, _okta.loc)('password.expiring.subtitle.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('password.expiring.subtitle.generic', 'login');
        return subtitle + ' ' + (0, _okta.loc)('password.expired.custom.subtitle', 'login');
      }

      return (0, _okta.loc)('password.expired.custom.subtitle', 'login');
    },
    formChildren: function formChildren() {
      return [_FormType.default.Button({
        title: _okta._.partial(_okta.loc, 'password.expired.custom.submit', 'login', [this.options.appState.get('passwordExpiredWebsiteName')]),
        className: 'button button-primary button-wide',
        attributes: {
          'data-se': 'custom-button'
        },
        click: function click() {
          Util.redirect(this.options.appState.get('passwordExpiredLinkUrl'));
        }
      })];
    }
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

var InvalidUserCodeErrorView = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "api.authn.error.PASSCODE_INVALID"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 173
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  })
});

var _default = _FormController.default.extend({
  className: 'device-code-activate',
  Model: {
    props: {
      userCode: ['string', true],
      stateToken: 'string'
    },
    save: function save() {
      var self = this;
      return this.doTransaction(function (transaction) {
        return transaction.deviceActivate({
          userCode: self.get('userCode')
        });
      });
    }
  },
  Form: {
    noCancelButton: true,
    autoSave: true,
    save: function save() {
      return (0, _okta.loc)('oform.next', 'login');
    },
    title: function title() {
      return (0, _okta.loc)('device.code.activate.title', 'login');
    },
    subtitle: function subtitle() {
      return (0, _okta.loc)('device.code.activate.subtitle', 'login');
    },
    formChildren: function formChildren() {
      if (this.options.appState.get('deviceActivationStatus') === 'INVALID_USER_CODE') {
        this.add(InvalidUserCodeErrorView, '.o-form-error-container');
      }

      return [_FormType.default.Input({
        label: (0, _okta.loc)('device.code.activate.label', 'login'),
        'label-top': true,
        name: 'userCode',
        input: _TextBox.default,
        inputId: 'user-code',
        type: 'text',
        inlineValidation: false
      })];
    },
    events: {
      'keyup input[name="userCode"]': function keyupInputNameUserCode(e) {
        e.preventDefault();
        this.addHyphen(e);
      }
    },
    addHyphen: function addHyphen(evt) {
      var _context;

      var currentVal = evt.target.value; // add hyphen after 4th character

      if (currentVal && currentVal.length === 4 && !(0, _includes.default)(_context = ['Backspace', 'Delete', '-']).call(_context, evt.key)) {
        evt.target.value = (0, _concat.default)(currentVal).call(currentVal, '-');
      }
    }
  }
});

exports.default = _default;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len: [2, 160] */
var DEVICE_ACTIVATED = 'DEVICE_ACTIVATED';
var DEVICE_NOT_ACTIVATED_CONSENT_DENIED = 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED';
var DEVICE_NOT_ACTIVATED = 'DEVICE_NOT_ACTIVATED';
var DEVICE_CODE_ERROR_KEYS = [DEVICE_NOT_ACTIVATED_CONSENT_DENIED, DEVICE_NOT_ACTIVATED];

var _default = _FormController.default.extend({
  className: 'device-code-terminal',
  postRender: function postRender() {
    _FormController.default.prototype.postRender.apply(this, arguments); // show device code terminal icons


    var iconClass = this.options.appState.get('deviceActivationStatus') === DEVICE_ACTIVATED ? 'success-24-green' : 'error-24-red';
    this.$('.o-form-head').before('<div class="device-code-terminal--icon-container">' + '<span class="device-code-terminal--icon ' + iconClass + '"></span>' + '</div>');
  },
  Model: {},
  Form: {
    noCancelButton: true,
    noButtonBar: true,
    title: function title() {
      var deviceActivationStatus = this.options.appState.get('deviceActivationStatus');

      if (deviceActivationStatus === DEVICE_ACTIVATED) {
        return (0, _okta.loc)('device.code.activated.success.title', 'login');
      }

      if (_okta._.contains(DEVICE_CODE_ERROR_KEYS, deviceActivationStatus)) {
        return (0, _okta.loc)('device.code.activated.error.title', 'login');
      }
    },
    subtitle: function subtitle() {
      var deviceActivationStatus = this.options.appState.get('deviceActivationStatus');

      if (deviceActivationStatus === DEVICE_ACTIVATED) {
        return (0, _okta.loc)('idx.device.activated', 'login');
      }

      if (deviceActivationStatus === DEVICE_NOT_ACTIVATED_CONSENT_DENIED) {
        return (0, _okta.loc)('idx.device.not.activated.consent.denied', 'login');
      }

      if (deviceActivationStatus === DEVICE_NOT_ACTIVATED) {
        return (0, _okta.loc)('idx.device.not.activated.internal.error', 'login');
      }
    },
    formChildren: function formChildren() {
      return [_FormType.default.View({
        View: _okta.View.extend({
          template: _runtime.default.template({
            "1": function _(container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<a href=\"/activate\" class=\"button button-primary text-align-c retry-button\" data-se=\"try-again\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "oie.try.again"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 121
                  },
                  "end": {
                    "line": 1,
                    "column": 165
                  }
                }
              })) + "</a>";
            },
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isDeviceCodeError") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 176
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          }),
          getTemplateData: function getTemplateData() {
            return {
              isDeviceCodeError: _okta._.contains(DEVICE_CODE_ERROR_KEYS, this.options.appState.get('deviceActivationStatus'))
            };
          }
        })
      })];
    }
  }
});

exports.default = _default;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _EnrollCustomFactorController = _interopRequireDefault(__webpack_require__(531));

var _Factor = _interopRequireDefault(__webpack_require__(242));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

/*!
 * Copyright (c) 2019-2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _EnrollCustomFactorController.default.extend({
  Model: {
    local: {
      provider: 'string',
      factorType: 'string'
    },
    save: function save() {
      var _this = this;

      return this.manageTransaction(function () {
        var url = _this.appState.get('enrollCustomFactorRedirectUrl');

        if (url !== null) {
          Util.redirect(url);
        }
      });
    }
  },
  Form: function Form() {
    var factor = new _Factor.default.Model(this.options.appState.get('factor'), this.toJSON());
    var vendorName = factor.get('vendorName');
    var subtitle = (0, _okta.loc)('enroll.customFactor.subtitle', 'login', [vendorName]);
    var saveText = (0, _okta.loc)('enroll.customFactor.save', 'login');
    return {
      autoSave: true,
      title: vendorName,
      subtitle: subtitle,
      save: saveText,
      formChildren: function formChildren() {
        var result = [];

        if (this.options.appState.get('isFactorResultFailed')) {
          result.push(_FormType.default.View({
            View: new _HtmlErrorMessageView.default({
              message: this.options.appState.get('factorResultErrorMessage')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }

        return result;
      }
    };
  }
});

exports.default = _default;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _ResendEmailView = _interopRequireDefault(__webpack_require__(532));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Model = {
  props: {
    passCode: 'string'
  },
  resend: function resend() {
    this.trigger('form:clear-errors');
    return this.doTransaction(function (transaction) {
      // authn support multiple `resend` hence has to specify name.
      return transaction.resend('email');
    });
  },
  save: function save() {
    this.trigger('save');
    var formData = this.toJSON();
    return this.doTransaction(function (transaction) {
      return transaction.activate(formData);
    });
  }
};

var Form = function Form() {
  return {
    title: _okta._.partial(_okta.loc, 'email.enroll.title', 'login'),
    noButtonBar: false,
    autoSave: true,
    save: _okta._.partial(_okta.loc, 'oform.verify', 'login'),
    // TODO: deprecated by mfa.challenge.verify
    formChildren: [// message
    _FormType.default.View({
      View: _okta.View.extend({
        className: 'enroll-activate-email-content',
        attributes: {
          'data-se': 'enroll-activate-email-content'
        },
        // Why use `{{{` for the description?
        // - factorEmail is actually an HTML fragment which
        //   is created via another handlebar template and used for bold the email address.
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var stack1,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "arguments": "factorEmail",
                "bundle": "login",
                "code": "email.mfa.email.sent.description"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 89
                }
              }
            })) != null ? stack1 : "";
          },
          "useData": true
        }),
        getTemplateData: function getTemplateData() {
          var factor = this.options.appState.get('factor');
          var factorEmailVal = factor && factor.profile ? factor.profile.email : '';

          var factorEmail = _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "email",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 25
                  },
                  "end": {
                    "line": 1,
                    "column": 34
                  }
                }
              }) : helper)) + "</span>";
            },
            "useData": true
          })({
            email: factorEmailVal
          });

          return {
            factorEmail: factorEmail
          };
        }
      })
    }), // send again callout message and link button
    _FormType.default.View({
      View: _ResendEmailView.default
    }), // passcode input
    _FormType.default.Input({
      label: (0, _okta.loc)('email.code.label', 'login'),
      'label-top': true,
      name: 'passCode',
      type: 'text',
      wide: true
    })]
  };
};

var _default = _FormController.default.extend({
  className: 'enroll-activate-email',
  Model: Model,
  Form: Form,
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _CountryUtil = _interopRequireDefault(__webpack_require__(157));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _PhoneTextBox = _interopRequireDefault(__webpack_require__(533));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 8] */
var Keys = _okta.internal.util.Keys;

var EnrollCallAndSmsControllerwarningTemplate = _okta.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
  attributes: {
    'aria-live': 'polite'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) != null ? stack1 : "") + "</p>";
    },
    "useData": true
  })
});

var factorIdIsDefined = {
  factorId: function factorId(val) {
    return !_okta._.isUndefined(val);
  }
};

function isCallFactor(factorType) {
  return factorType === 'call';
}

function getClassName(factorType) {
  return isCallFactor(factorType) ? 'enroll-call' : 'enroll-sms';
}

function sendCode(e) {
  if (Keys.isEnter(e)) {
    e.stopPropagation();
    e.preventDefault();

    if (e.type === 'keyup' && e.data && e.data.model) {
      e.data.model.sendCode();
    }
  }
}

var _default = _FormController.default.extend({
  className: function className() {
    return getClassName(this.options.factorType);
  },
  Model: function Model() {
    return {
      props: {
        phoneNumber: ['string', true],
        phoneExtension: ['string', false],
        lastEnrolledPhoneNumber: 'string',
        passCode: ['string', true],
        factorId: 'string'
      },
      local: {
        countryCode: ['string', false, this.options.appState.get('userCountryCode')],
        hasExistingPhones: 'boolean',
        trapEnrollment: 'boolean',
        ableToResend: 'boolean',
        factorType: 'string',
        skipPhoneValidation: 'boolean'
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function fn(countryCode) {
            return '+' + _CountryUtil.default.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function fn(countryCallingCode, phoneNumber) {
            return phoneNumber ? countryCallingCode + phoneNumber : '';
          }
        },
        enrolled: {
          deps: ['lastEnrolledPhoneNumber', 'fullPhoneNumber'],
          fn: function fn(lastEnrolled, current) {
            return lastEnrolled === current;
          }
        }
      },
      limitResending: function limitResending() {
        this.set({
          ableToResend: false
        });

        _okta._.delay((0, _bind.default)(_okta._).call(_okta._, this.set, this), _Enums.default.API_RATE_LIMIT, {
          ableToResend: true
        });
      },
      sendCode: function sendCode() {
        var self = this;
        var phoneNumber = this.get('fullPhoneNumber');
        var phoneExtension = this.get('phoneExtension');
        self.trigger('errors:clear');

        if (!phoneNumber.length) {
          self.trigger('invalid', self, {
            phoneNumber: 'model.validation.field.blank'
          });
          return;
        }

        return this.doTransaction(function (transaction) {
          var isMfaEnroll = transaction.status === 'MFA_ENROLL' || transaction.status === 'FACTOR_ENROLL';
          var profileData = {
            phoneNumber: phoneNumber,
            updatePhone: isMfaEnroll ? self.get('hasExistingPhones') : true
          };

          if (isCallFactor(self.get('factorType'))) {
            profileData['phoneExtension'] = phoneExtension;
          }

          if (self.get('skipPhoneValidation')) {
            profileData['validatePhone'] = false;
          }

          var doEnroll = function doEnroll(trans) {
            var factor = _okta._.findWhere(trans.factors, {
              factorType: self.get('factorType'),
              provider: 'OKTA'
            });

            return factor.enroll({
              profile: profileData
            }).catch(function (error) {
              if (error.errorCode === 'E0000098') {
                // E0000098: "This phone number is invalid."
                self.set('skipPhoneValidation', true);
                error.xhr.responseJSON.errorSummary = (0, _okta.loc)('enroll.sms.try_again', 'login');
              }

              throw error;
            });
          };

          if (isMfaEnroll) {
            return doEnroll(transaction);
          } else {
            // We must transition to MfaEnroll before updating the phone number
            self.set('trapEnrollment', true);
            return transaction.prev().then(doEnroll).then(function (trans) {
              self.set('trapEnrollment', false);
              return trans;
            });
          } // Rethrow errors so we can change state
          // AFTER setting the new transaction

        }, true).then(function () {
          self.set('lastEnrolledPhoneNumber', phoneNumber);
          self.limitResending();
        }).catch(function () {
          self.set('ableToResend', true);
          self.set('trapEnrollment', false);
        });
      },
      resendCode: function resendCode() {
        this.trigger('errors:clear');
        this.limitResending();
        return this.doTransaction(function (transaction) {
          return transaction.resend(this.get('factorType'));
        });
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    };
  },
  Form: function Form() {
    var factorType = this.options.factorType;
    var isCall = isCallFactor(factorType);
    var formTitle = (0, _okta.loc)(isCall ? 'enroll.call.setup' : 'enroll.sms.setup', 'login');
    var formSubmit = (0, _okta.loc)(isCall ? 'mfa.call' : 'mfa.sendCode', 'login');
    var formRetry = (0, _okta.loc)(isCall ? 'mfa.redial' : 'mfa.resendCode', 'login');
    var formSubmitted = (0, _okta.loc)(isCall ? 'mfa.calling' : 'mfa.sent', 'login');
    var numberFieldClassName = isCall ? 'enroll-call-phone' : 'enroll-sms-phone';
    var buttonClassName = isCall ? 'call-request-button' : 'sms-request-button';
    var formChildren = [_FormType.default.Input({
      name: 'countryCode',
      type: 'select',
      wide: true,
      options: _CountryUtil.default.getCountries()
    }), _FormType.default.Input({
      label: (0, _okta.loc)('mfa.phoneNumber.placeholder', 'login'),
      'label-top': true,
      className: numberFieldClassName,
      name: 'phoneNumber',
      input: _PhoneTextBox.default,
      type: 'text',
      render: function render() {
        this.$('input[name="phoneNumber"]').off('keydown keyup', sendCode).keydown(sendCode).keyup({
          model: this.model
        }, sendCode);
      }
    })];

    if (isCall) {
      formChildren.push(_FormType.default.Input({
        label: (0, _okta.loc)('mfa.phoneNumber.ext.placeholder', 'login'),
        'label-top': true,
        className: 'enroll-call-extension',
        name: 'phoneExtension',
        input: _TextBox.default,
        type: 'text'
      }));
    }

    formChildren.push(_FormType.default.Button({
      title: formSubmit,
      attributes: {
        'data-se': buttonClassName
      },
      className: 'button button-primary js-enroll-phone margin-top-30 ' + buttonClassName,
      click: function click() {
        this.model.sendCode();
      }
    }), _FormType.default.Button({
      title: formRetry,
      attributes: {
        'data-se': buttonClassName
      },
      className: 'button js-enroll-phone margin-top-30 ' + buttonClassName,
      click: function click() {
        this.model.resendCode();
      },
      initialize: function initialize() {
        this.$el.css({
          display: 'none'
        });
        this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
          if (ableToResend) {
            this.options.title = formRetry;
            this.enable();
          } else {
            this.options.title = formSubmitted;
            this.disable();
          }

          this.render();
        });
      }
    }), _FormType.default.Divider({
      showWhen: factorIdIsDefined
    }), _FormType.default.Input({
      label: (0, _okta.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      explain: _Util.default.createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
      'explain-top': true,
      name: 'passCode',
      input: _TextBox.default,
      type: 'tel',
      showWhen: factorIdIsDefined
    }), _FormType.default.Toolbar({
      noCancelButton: true,
      save: (0, _okta.loc)('mfa.challenge.verify', 'login'),
      showWhen: factorIdIsDefined
    }));
    return {
      title: formTitle,
      noButtonBar: true,
      autoSave: true,
      className: getClassName(factorType),
      showWarning: function showWarning(msg) {
        this.clearWarnings();
        this.add(EnrollCallAndSmsControllerwarningTemplate, '.o-form-error-container', {
          options: {
            warning: msg
          }
        });
      },
      clearWarnings: function clearWarnings() {
        this.$('.okta-form-infobox-warning').remove();
      },
      initialize: function initialize() {
        this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
          if (ableToResend) {
            this.showWarning((0, _okta.loc)(isCall ? 'factor.call.time.warning' : 'factor.sms.time.warning', 'login'));
          } else {
            this.clearWarnings();
          }
        });
        this.listenTo(this.model, 'error errors:clear', function () {
          this.clearWarnings();
          this.clearErrors();
        });
        this.listenTo(this.model, 'change:enrolled', function () {
          this.$('.js-enroll-phone').toggle();
        });
      },
      formChildren: formChildren
    };
  },
  Footer: _Footer.default,
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.set('factorId', this.options.appState.get('activatedFactorId'));
      return true;
    }

    if (this.options.appState.get('isMfaEnroll') && this.model.get('trapEnrollment')) {
      return true;
    }
  },
  initialize: function initialize() {
    if (isCallFactor(this.options.factorType)) {
      this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhonesForCall'));
    } else {
      this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhones'));
    }

    this.model.set('factorType', this.options.factorType);
  }
});

exports.default = _default;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len:0 */
var _default = {
  US: '1',
  AG: '1',
  AI: '1',
  AS: '1',
  BB: '1',
  BM: '1',
  BS: '1',
  CA: '1',
  DM: '1',
  DO: '1',
  GD: '1',
  GU: '1',
  JM: '1',
  KN: '1',
  KY: '1',
  LC: '1',
  MP: '1',
  MS: '1',
  PR: '1',
  SX: '1',
  TC: '1',
  TT: '1',
  VC: '1',
  VG: '1',
  VI: '1',
  RU: '7',
  KZ: '7',
  EG: '20',
  ZA: '27',
  GR: '30',
  NL: '31',
  BE: '32',
  FR: '33',
  ES: '34',
  HU: '36',
  IT: '39',
  VA: '39',
  RO: '40',
  CH: '41',
  AT: '43',
  GB: '44',
  GG: '44',
  IM: '44',
  JE: '44',
  DK: '45',
  SE: '46',
  NO: '47',
  SJ: '47',
  PL: '48',
  DE: '49',
  PE: '51',
  MX: '52',
  CU: '53',
  AR: '54',
  BR: '55',
  CL: '56',
  CO: '57',
  VE: '58',
  MY: '60',
  AU: '61',
  CC: '61',
  CX: '61',
  ID: '62',
  PH: '63',
  NZ: '64',
  SG: '65',
  TH: '66',
  JP: '81',
  KR: '82',
  VN: '84',
  CN: '86',
  TR: '90',
  IN: '91',
  PK: '92',
  AF: '93',
  LK: '94',
  MM: '95',
  IR: '98',
  SS: '211',
  MA: '212',
  EH: '212',
  DZ: '213',
  TN: '216',
  LY: '218',
  GM: '220',
  SN: '221',
  MR: '222',
  ML: '223',
  GN: '224',
  CI: '225',
  BF: '226',
  NE: '227',
  TG: '228',
  BJ: '229',
  MU: '230',
  LR: '231',
  SL: '232',
  GH: '233',
  NG: '234',
  TD: '235',
  CF: '236',
  CM: '237',
  CV: '238',
  ST: '239',
  GQ: '240',
  GA: '241',
  CG: '242',
  CD: '243',
  AO: '244',
  GW: '245',
  IO: '246',
  AC: '247',
  SC: '248',
  SD: '249',
  RW: '250',
  ET: '251',
  SO: '252',
  DJ: '253',
  KE: '254',
  TZ: '255',
  UG: '256',
  BI: '257',
  MZ: '258',
  ZM: '260',
  MG: '261',
  RE: '262',
  YT: '262',
  ZW: '263',
  NA: '264',
  MW: '265',
  LS: '266',
  BW: '267',
  SZ: '268',
  KM: '269',
  SH: '290',
  TA: '290',
  ER: '291',
  AW: '297',
  FO: '298',
  GL: '299',
  GI: '350',
  PT: '351',
  LU: '352',
  IE: '353',
  IS: '354',
  AL: '355',
  MT: '356',
  CY: '357',
  FI: '358',
  AX: '358',
  BG: '359',
  LT: '370',
  LV: '371',
  EE: '372',
  MD: '373',
  AM: '374',
  BY: '375',
  AD: '376',
  MC: '377',
  SM: '378',
  UA: '380',
  RS: '381',
  ME: '382',
  XK: '383',
  HR: '385',
  SI: '386',
  BA: '387',
  MK: '389',
  CZ: '420',
  SK: '421',
  LI: '423',
  FK: '500',
  BZ: '501',
  GT: '502',
  SV: '503',
  HN: '504',
  NI: '505',
  CR: '506',
  PA: '507',
  PM: '508',
  HT: '509',
  GP: '590',
  BL: '590',
  MF: '590',
  BO: '591',
  GY: '592',
  EC: '593',
  GF: '594',
  PY: '595',
  MQ: '596',
  SR: '597',
  UY: '598',
  CW: '599',
  BQ: '599',
  TL: '670',
  NF: '672',
  BN: '673',
  NR: '674',
  PG: '675',
  TO: '676',
  SB: '677',
  VU: '678',
  FJ: '679',
  PW: '680',
  WF: '681',
  CK: '682',
  NU: '683',
  WS: '685',
  KI: '686',
  NC: '687',
  TV: '688',
  PF: '689',
  TK: '690',
  FM: '691',
  MH: '692',
  '001': '979',
  KP: '850',
  HK: '852',
  MO: '853',
  KH: '855',
  LA: '856',
  BD: '880',
  TW: '886',
  MV: '960',
  LB: '961',
  JO: '962',
  SY: '963',
  IQ: '964',
  KW: '965',
  SA: '966',
  YE: '967',
  OM: '968',
  PS: '970',
  AE: '971',
  IL: '972',
  BH: '973',
  QA: '974',
  BT: '975',
  MN: '976',
  NP: '977',
  TJ: '992',
  TM: '993',
  AZ: '994',
  GE: '995',
  KG: '996',
  UZ: '998',
  GS: '500',
  PN: '64',
  AQ: '672',
  UM: '1',
  AN: '599'
};
exports.default = _default;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _filter = _interopRequireDefault(__webpack_require__(39));

var _isInteger = _interopRequireDefault(__webpack_require__(492));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FactorList = _interopRequireDefault(__webpack_require__(534));

var _Footer = _interopRequireDefault(__webpack_require__(1141));

var _RequiredFactorList = _interopRequireDefault(__webpack_require__(1142));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13] */
var subtitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<span>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 6
        },
        "end": {
          "line": 1,
          "column": 20
        }
      }
    }) : helper)) != null ? stack1 : "") + "</span>";
  },
  "useData": true
});

var _default = _FormController.default.extend({
  className: 'enroll-choices',
  state: {
    pageType: null
  },
  Model: {},
  Form: {
    noCancelButton: true,
    title: _okta._.partial(_okta.loc, 'enroll.choices.title', 'login'),
    noButtonBar: function noButtonBar() {
      return this.state.get('pageType') === _Enums.default.ALL_OPTIONAL_NONE_ENROLLED;
    },
    subtitle: ' ',
    getSubtitle: function getSubtitle() {
      switch (this.state.get('pageType')) {
        case _Enums.default.ALL_OPTIONAL_SOME_ENROLLED:
        case _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
          return (0, _okta.loc)('enroll.choices.optional', 'login');

        case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
          {
            var remainingDays = this.options.appState.get('gracePeriodRemainingDays');
            return (0, _isInteger.default)(remainingDays) && remainingDays >= 0 ? this.getGracePeriodSubtitle(remainingDays) : this.getDefaultSubtitle();
          }

        default:
          return this.getDefaultSubtitle();
      }
    },
    getDefaultSubtitle: function getDefaultSubtitle() {
      return this.settings.get('brandName') ? (0, _okta.loc)('enroll.choices.description.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('enroll.choices.description.generic', 'login');
    },
    getGracePeriodSubtitle: function getGracePeriodSubtitle(remainingDays) {
      return remainingDays >= 1 ? (0, _okta.loc)('enroll.choices.description.gracePeriod.bold', 'login', [remainingDays]) : (0, _okta.loc)('enroll.choices.description.gracePeriod.oneDay.bold', 'login');
    },
    save: function save() {
      switch (this.state.get('pageType')) {
        case _Enums.default.ALL_OPTIONAL_SOME_ENROLLED:
        case _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
          return (0, _okta.loc)('enroll.choices.submit.finish', 'login');

        case _Enums.default.HAS_REQUIRED_NONE_ENROLLED:
          return (0, _okta.loc)('enroll.choices.submit.configure', 'login');

        case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
          return (0, _okta.loc)('enroll.choices.submit.next', 'login');

        default:
          return '';
      }
    },
    initialize: function initialize(options) {
      this.listenTo(this, 'save', function () {
        var current;

        switch (this.state.get('pageType')) {
          case _Enums.default.HAS_REQUIRED_NONE_ENROLLED:
          case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
            current = options.appState.get('factors').getFirstUnenrolledRequiredFactor();
            options.appState.trigger('navigate', _RouterUtil.default.createEnrollFactorUrl(current.get('provider'), current.get('factorType')));
            break;

          default:
            return this.model.doTransaction(function (transaction) {
              return transaction.skip();
            });
        }
      });
    },
    preRender: function preRender() {
      // form subtitle does not support unescaped strings, and we need some html elements
      // in the subtitle for this form. So instead of a regular subtitle, we add a <span>
      // with the text we need
      this.add(subtitleTpl({
        subtitle: this.getSubtitle()
      }), 'p.okta-form-subtitle');
      var factors = this.options.appState.get('factors');

      switch (this.state.get('pageType')) {
        case _Enums.default.HAS_REQUIRED_NONE_ENROLLED:
        case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
          this.add(new _RequiredFactorList.default({
            minimize: true,
            collection: new _okta.Collection(factors.where({
              required: true
            })),
            appState: this.options.appState
          }));
          break;

        case _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
        case _Enums.default.ALL_OPTIONAL_SOME_ENROLLED:
        case _Enums.default.ALL_OPTIONAL_NONE_ENROLLED:
          {
            var enrolled = factors.where({
              enrolled: true
            });
            var notEnrolled = (0, _filter.default)(factors).call(factors, function (factor) {
              // pick factors that are not enrolled or have additional enrollments
              return !factor.get('enrolled') || factor.get('additionalEnrollment');
            });
            var notEnrolledListTitle;

            if (enrolled.length > 0) {
              notEnrolledListTitle = (0, _okta.loc)('enroll.choices.list.optional', 'login');
              this.add(new _FactorList.default({
                listTitle: (0, _okta.loc)('enroll.choices.list.enrolled', 'login'),
                minimize: true,
                collection: new _okta.Collection(enrolled),
                appState: this.options.appState
              }));
            }

            this.add(new _FactorList.default({
              listTitle: notEnrolledListTitle,
              collection: new _okta.Collection(notEnrolled),
              appState: this.options.appState,
              showInlineSetupButton: true
            }));
            break;
          }
      }
    }
  },
  initialize: function initialize(options) {
    var numRequiredEnrolled = 0;
    var numRequiredNotEnrolled = 0;
    var numOptionalEnrolled = 0;
    var numOptionalNotEnrolled = 0;
    var hasRequired;
    var pageType;
    options.appState.get('factors').each(function (factor) {
      var required = factor.get('required');
      var enrolled = factor.get('enrolled');
      var additionalEnrollment = factor.get('additionalEnrollment');

      if (required && enrolled) {
        numRequiredEnrolled++;
      } else if (required && !enrolled) {
        numRequiredNotEnrolled++;
      } else if (!required && enrolled) {
        numOptionalEnrolled++;
      } else if (!required && !enrolled) {
        numOptionalNotEnrolled++;
      } // If a factor has multiple instances and
      // additional optional enrollments


      if (enrolled && additionalEnrollment) {
        numOptionalNotEnrolled++;
      }
    });
    hasRequired = numRequiredEnrolled > 0 || numRequiredNotEnrolled > 0; // There are 5 possible states this screen can be in:
    // 1. Has required, but none have been enrolled. Wizard start page.

    if (hasRequired && numRequiredEnrolled === 0) {
      pageType = _Enums.default.HAS_REQUIRED_NONE_ENROLLED;
    } else if (hasRequired && numRequiredNotEnrolled > 0) {
      // 2. Has required, and have enrolled at least one. The page layout
      //    to configure the remaining required factors.
      pageType = _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED;
    } else if (hasRequired && numOptionalNotEnrolled > 0) {
      // 3. Has required, and finished enrolling all required factors. The
      //    page layout you see to configure any optional factors or skip.
      pageType = _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED;
    } else if (numOptionalEnrolled === 0 && numOptionalNotEnrolled > 0) {
      // 4. Factors are all optional, no factors enrolled.
      pageType = _Enums.default.ALL_OPTIONAL_NONE_ENROLLED;
    } else if (numOptionalNotEnrolled > 0) {
      // 5. Factors are all optional, some factors have already been
      //    enrolled (can either enroll more or skip).
      pageType = _Enums.default.ALL_OPTIONAL_SOME_ENROLLED;
    } else {
      // 6. Factors are all optional, all factors have already been
      //    enrolled, among them there is OktaVerify with Push enrolled as totp
      //    (API return OktaVerify push factor as unenrolled in this case and as we always merge
      //    push and totp in UI so we redirect to skip link here).
      this.model.doTransaction(function (transaction) {
        return transaction.skip();
      });
    }

    this.state.set('pageType', pageType);

    if (this.options.appState.get('skipLink') && pageType === _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED) {
      this.add(new _Footer.default(this.toJSON()));
    }
  }
});

exports.default = _default;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link goto js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.choices.setup.skip"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  events: {
    'click .js-skip': function clickJsSkip(e) {
      e.preventDefault();
      this.model.doTransaction(function (transaction) {
        return transaction.skip();
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _FactorList = _interopRequireDefault(__webpack_require__(534));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FactorList.default.extend({
  listTitle: _okta._.partial(_okta.loc, 'enroll.choices.list.setup', 'login'),
  className: function className() {
    return _FactorList.default.prototype.className + ' enroll-required-factor-list';
  },
  postRender: function postRender() {
    var _context;

    var currentModel;
    var currentRow;

    _FactorList.default.prototype.postRender.apply(this, arguments);

    currentModel = this.options.appState.get('factors').getFirstUnenrolledRequiredFactor();
    currentRow = (0, _find.default)(_context = this).call(_context, function (view) {
      return view.model === currentModel;
    });
    currentRow.maximize();
  }
});

exports.default = _default;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _okta = __webpack_require__(2);

var _duo = _interopRequireDefault(__webpack_require__(327));

var _q = _interopRequireDefault(__webpack_require__(43));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint camelcase: 0*/
var _default = _FormController.default.extend({
  className: 'enroll-duo duo-form',
  Model: {
    props: {
      host: 'string',
      signature: 'string',
      postAction: 'string',
      factorId: 'string',
      stateToken: 'string'
    },
    getInitOptions: function getInitOptions() {
      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'web',
          provider: 'DUO'
        });

        return factor.enroll();
      });
    },
    activate: function activate(signedResponse) {
      var url = this.get('postAction');
      var factorId = this.get('factorId');
      var self = this;
      var data = {
        id: factorId,
        stateToken: this.get('stateToken'),
        sig_response: signedResponse
      }; // Note: We should be doing this in OktaAuth! Fix when it's updated.
      // We don't actually use authClient.post() here (unlike all the other cases in the
      // sign-in widget) since the endpoint is wired to accept serialized form post instead
      // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
      // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
      // are the only two places where we actually do this.
      // NOTE - If we ever decide to change this, we should test this very carefully.

      return (0, _q.default)(_okta.$.post(url, data)).then(function () {
        return self.doTransaction(function (transaction) {
          return transaction.poll();
        });
      }).catch(function (err) {
        self.trigger('error', self, err.xhr);
      });
    }
  },
  Form: {
    autoSave: true,
    noButtonBar: true,
    title: _okta._.partial(_okta.loc, 'enroll.duo.title', 'login'),
    postRender: function postRender() {
      this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');

      _duo.default.init({
        host: this.model.get('host'),
        sig_request: this.model.get('signature'),
        iframe: this.$('iframe').get(0),
        post_action: (0, _bind.default)(_okta._).call(_okta._, this.model.activate, this.model)
      });
    }
  },
  Footer: _Footer.default,
  fetchInitialData: function fetchInitialData() {
    var self = this;
    return this.model.getInitOptions(this.options.appState).then(function (trans) {
      var res = trans.data;

      if (!res || !res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.activation) {
        throw new Error('Response does not have duo activation options');
      }

      var factor = res._embedded.factor;
      var activation = factor._embedded.activation;
      self.model.set({
        host: activation.host,
        signature: activation.signature,
        postAction: activation._links.complete.href,
        factorId: factor.id,
        stateToken: res.stateToken
      });
    });
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1145);

module.exports = parent;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var endsWith = __webpack_require__(1146);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.endsWith;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.endsWith) ? endsWith : own;
};


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1147);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('String').endsWith;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(128).f;
var toLength = __webpack_require__(66);
var notARegExp = __webpack_require__(289);
var requireObjectCoercible = __webpack_require__(131);
var correctIsRegExpLogic = __webpack_require__(292);
var IS_PURE = __webpack_require__(87);

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Model = {
  local: {
    factorType: 'string',
    provider: 'string'
  },
  save: function save() {
    this.trigger('save');
    var factorOpt = this.pick('factorType', 'provider');
    return this.doTransaction(function (transaction) {
      var factor = _okta._.findWhere(transaction.factors, factorOpt);

      return factor.enroll();
    });
  }
};

var Form = function Form() {
  return {
    title: _okta._.partial(_okta.loc, 'email.enroll.title', 'login'),
    noButtonBar: false,
    autoSave: true,
    save: _okta._.partial(_okta.loc, 'email.button.send', 'login'),
    formChildren: [_FormType.default.View({
      View: _okta.View.extend({
        attributes: {
          'data-se': 'enroll-email-content'
        },
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "email.enroll.description"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 55
                }
              }
            }));
          },
          "useData": true
        })
      })
    })]
  };
};

var _default = _FormController.default.extend({
  className: 'enroll-email',
  Model: Model,
  Form: Form,
  Footer: _Footer.default,
  initialize: function initialize() {
    this.model.set(_okta._.pick(this.options, 'factorType', 'provider'));
  }
});

exports.default = _default;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-hotp',
  Model: function Model() {
    return {
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function title() {
      var factors = this.options.appState.get('factors');
      var hotpFactor = factors.findWhere({
        provider: this.model.get('__provider__'),
        factorType: this.model.get('__factorType__')
      });
      return (0, _okta.loc)('enroll.totp.title', 'login', [hotpFactor.get('factorLabel')]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'restrict-enroll'
    },
    formChildren: function formChildren() {
      var children = [_FormType.default.View({
        View: new _HtmlErrorMessageView.default({
          message: (0, _okta.loc)('enroll.hotp.restricted', 'login')
        })
      })];
      return children;
    }
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function isRSA(provider) {
  return provider === 'RSA';
}

function getClassName(provider) {
  return isRSA(provider) ? 'enroll-rsa' : 'enroll-onprem';
}

var _default = _FormController.default.extend({
  className: function className() {
    return getClassName(this.options.provider);
  },
  Model: function Model() {
    var provider = this.options.provider;
    var factors = this.options.appState.get('factors');
    var factor = factors.findWhere(_okta._.pick(this.options, 'provider', 'factorType'));
    var profile = factor.get('profile');
    var credentialId = profile && profile.credentialId ? profile.credentialId : '';
    return {
      props: {
        credentialId: ['string', true, credentialId],
        passCode: ['string', true],
        factorId: 'string'
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          var factor = _okta._.findWhere(transaction.factors, {
            factorType: 'token',
            provider: provider
          });

          return factor.enroll({
            passCode: this.get('passCode'),
            profile: {
              credentialId: this.get('credentialId')
            }
          });
        });
      }
    };
  },
  Form: function Form() {
    var provider = this.options.provider;
    var factors = this.options.appState.get('factors');
    var factor = factors.findWhere(_okta._.pick(this.options, 'provider', 'factorType'));
    var vendorName = factor.get('vendorName');
    var title = isRSA(provider) ? (0, _okta.loc)('factor.totpHard.rsaSecurId', 'login') : vendorName;
    return {
      title: title,
      noButtonBar: true,
      autoSave: true,
      className: getClassName(provider),
      initialize: function initialize() {
        var _this = this;

        this.listenTo(this.model, 'error', function (source, error) {
          if (error && error.status === 409) {
            // 409 means we are in change pin, so we should clear out answer input
            _this.$('.o-form-input-name-passCode input').val('');

            _this.$('.o-form-input-name-passCode input').trigger('change');

            _this.$('.o-form-input-name-passCode input').focus();
          }
        });
      },
      formChildren: [_FormType.default.Input({
        label: (0, _okta.loc)('enroll.onprem.username.placeholder', 'login', [vendorName]),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.onprem.username.tooltip', 'enroll.onprem.username.placeholder', 'login', [vendorName], [vendorName]),
        'explain-top': true,
        name: 'credentialId',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Input({
        label: (0, _okta.loc)('enroll.onprem.passcode.placeholder', 'login', [vendorName]),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.onprem.passcode.tooltip', 'enroll.onprem.passcode.placeholder', 'login', [vendorName], [vendorName]),
        'explain-top': true,
        name: 'passCode',
        input: _TextBox.default,
        type: 'password'
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _okta.loc)('mfa.challenge.verify', 'login')
      })]
    };
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _ValidationUtil = _interopRequireDefault(__webpack_require__(199));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-password',
  Model: {
    props: {
      password: ['string', true],
      confirmPassword: ['string', true]
    },
    validate: function validate() {
      return _ValidationUtil.default.validateFieldsMatch(this, 'password', 'confirmPassword', (0, _okta.loc)('password.enroll.error.match', 'login'));
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'password',
          provider: 'OKTA'
        });

        return factor.enroll({
          profile: {
            password: this.get('password')
          }
        });
      });
    }
  },
  Form: {
    autoSave: true,
    title: _okta._.partial(_okta.loc, 'enroll.password.setup', 'login'),
    inputs: function inputs() {
      return [{
        label: (0, _okta.loc)('mfa.challenge.password.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'password',
        input: _TextBox.default,
        type: 'password'
      }, {
        label: (0, _okta.loc)('password.confirmPassword.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'confirmPassword',
        input: _TextBox.default,
        type: 'password'
      }];
    }
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-question',
  Model: {
    props: {
      question: 'string',
      answer: ['string', true]
    },
    local: {
      securityQuestions: 'object'
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'question',
          provider: 'OKTA'
        });

        return factor.enroll({
          profile: {
            question: this.get('question'),
            answer: this.get('answer')
          }
        });
      });
    }
  },
  Form: {
    autoSave: true,
    title: _okta._.partial(_okta.loc, 'enroll.securityQuestion.setup', 'login'),
    inputs: function inputs() {
      return [{
        label: false,
        'label-top': true,
        name: 'question',
        type: 'select',
        wide: true,
        options: function options() {
          return this.model.get('securityQuestions');
        },
        params: {
          searchThreshold: 25
        }
      }, {
        label: (0, _okta.loc)('mfa.challenge.answer.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('mfa.challenge.answer.tooltip', 'mfa.challenge.answer.placeholder', 'login'),
        'explain-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'answer',
        input: _TextBox.default,
        type: 'text'
      }];
    }
  },
  Footer: _Footer.default,
  fetchInitialData: function fetchInitialData() {
    var self = this;
    return this.model.manageTransaction(function (transaction) {
      var factor = _okta._.findWhere(transaction.factors, {
        factorType: 'question',
        provider: 'OKTA'
      });

      return factor.questions();
    }).then(function (questionsRes) {
      var questions = {};

      _okta._.each(questionsRes, function (question) {
        questions[question.question] = _FactorUtil.default.getSecurityQuestionLabel(question);
      });

      self.model.set('securityQuestions', questions);
    });
  }
});

exports.default = _default;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-symantec',
  Model: {
    props: {
      credentialId: ['string', true],
      passCode: ['string', true],
      nextPassCode: ['string', true],
      factorId: 'string'
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'token',
          provider: 'SYMANTEC'
        });

        return factor.enroll({
          passCode: this.get('passCode'),
          nextPassCode: this.get('nextPassCode'),
          profile: {
            credentialId: this.get('credentialId')
          }
        });
      });
    }
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'factor.totpHard.symantecVip', 'login'),
    subtitle: _okta._.partial(_okta.loc, 'enroll.symantecVip.subtitle', 'login'),
    noButtonBar: true,
    autoSave: true,
    className: 'enroll-symantec',
    formChildren: function formChildren() {
      return [_FormType.default.Input({
        label: (0, _okta.loc)('enroll.symantecVip.credentialId.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.symantecVip.credentialId.tooltip', 'enroll.symantecVip.credentialId.placeholder', 'login'),
        'explain-top': true,
        name: 'credentialId',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Input({
        label: (0, _okta.loc)('enroll.symantecVip.passcode1.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.symantecVip.passcode1.tooltip', 'enroll.symantecVip.passcode1.placeholder', 'login'),
        'explain-top': true,
        name: 'passCode',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Input({
        label: (0, _okta.loc)('enroll.symantecVip.passcode2.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.symantecVip.passcode2.tooltip', 'enroll.symantecVip.passcode2.placeholder', 'login'),
        'explain-top': true,
        name: 'nextPassCode',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _okta.loc)('mfa.challenge.verify', 'login')
      })];
    }
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _StoreLinks = _interopRequireDefault(__webpack_require__(1155));

var _Footer = _interopRequireDefault(__webpack_require__(45));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var showWhenDeviceTypeSelected = {
  __deviceType__: function __deviceType__(val) {
    return val !== undefined;
  }
};

var EnrollTotpControllerAppDownloadInstructionsView = _okta.View.extend({
  attributes: {
    'data-se': 'app-download-instructions'
  },
  className: 'app-download-instructions',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"app-logo " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "appIcon") || (depth0 != null ? lookupProperty(depth0, "appIcon") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "appIcon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 22
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper)) + "\"></span><p class=\"instructions\">" + ((stack1 = (helper = (helper = lookupProperty(helpers, "appStoreLinkText") || (depth0 != null ? lookupProperty(depth0, "appStoreLinkText") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "appStoreLinkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 88
          }
        }
      }) : helper)) != null ? stack1 : "") + "</p>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    this.listenTo(this.model, 'change:__deviceType__', this.render);
  },
  postRender: function postRender() {
    var _context;

    var link = (0, _find.default)(_context = this.$el).call(_context, '.instructions a');

    if (link.length) {
      link[0].setAttribute('target', '_blank');
      link[0].setAttribute('rel', 'noreferer noopener');
    }
  },
  getTemplateData: function getTemplateData() {
    var appStoreLink;
    var appIcon;
    var appStoreName;

    var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

    appStoreName = _StoreLinks.default.STORE[this.model.get('__deviceType__')];

    if (this.model.get('__provider__') === 'GOOGLE') {
      appStoreLink = _StoreLinks.default.GOOGLE[this.model.get('__deviceType__')];
      appIcon = 'google-auth-38';
    } else {
      appStoreLink = _StoreLinks.default.OKTA[this.model.get('__deviceType__')];
      appIcon = 'okta-verify-download-icon';
    }

    return {
      appStoreLinkText: (0, _okta.loc)('enroll.totp.downloadApp', 'login', [appStoreLink, factorName, appStoreName]),
      appIcon: appIcon
    };
  }
});

var EnrollTotpControllerEnrollTotpController = _FormController.default.extend({
  className: 'enroll-totp',
  Model: function Model() {
    return {
      local: {
        __deviceType__: 'string',
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          var factor = _okta._.findWhere(transaction.factors, {
            factorType: this.get('__factorType__'),
            provider: this.get('__provider__')
          });

          return factor.enroll();
        });
      }
    };
  },
  Form: {
    title: function title() {
      var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

      return (0, _okta.loc)('enroll.totp.title', 'login', [factorName]);
    },
    subtitle: _okta._.partial(_okta.loc, 'enroll.totp.selectDevice', 'login'),
    autoSave: true,
    noButtonBar: true,
    attributes: {
      'data-se': 'step-device-type'
    },
    formChildren: function formChildren() {
      var inputOptions = {
        APPLE: (0, _okta.loc)('iphone', 'login'),
        ANDROID: (0, _okta.loc)('android', 'login')
      };
      var children = [_FormType.default.Input({
        name: '__deviceType__',
        type: 'radio',
        options: inputOptions
      }), _FormType.default.Divider({
        showWhen: showWhenDeviceTypeSelected
      }), _FormType.default.View({
        View: EnrollTotpControllerAppDownloadInstructionsView,
        showWhen: showWhenDeviceTypeSelected
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _okta.loc)('oform.next', 'login'),
        showWhen: showWhenDeviceTypeSelected
      })];
      return children;
    }
  },
  Footer: _Footer.default
});

var _default = EnrollTotpControllerEnrollTotpController;
exports.default = _default;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  OKTA: {
    APPLE: 'https://itunes.apple.com/us/app/okta-verify/id490179405',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.okta.android.auth'
  },
  GOOGLE: {
    APPLE: 'https://itunes.apple.com/us/app/google-authenticator/id388497605',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
  },
  STORE: {
    APPLE: 'App Store',
    ANDROID: 'Google Play Store'
  }
};
exports.default = _default;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

__webpack_require__(536);

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _FidoUtil = _interopRequireDefault(__webpack_require__(328));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* global u2f */
var _default = _FormController.default.extend({
  className: 'enroll-u2f',
  Model: {
    local: {
      __enrolled__: 'boolean'
    },
    save: function save() {
      this.trigger('request');

      if (this.get('__enrolled__')) {
        return this.activate();
      }

      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'u2f',
          provider: 'FIDO'
        });

        return factor.enroll();
      });
    },
    activate: function activate() {
      this.set('__enrolled__', true);
      this.trigger('errors:clear');
      return this.doTransaction(function (transaction) {
        var activation = transaction.factor.activation;
        var appId = activation.appId;
        var registerRequests = [{
          version: _FidoUtil.default.getU2fVersion(),
          challenge: activation.nonce
        }];
        var self = this;

        var deferred = _q.default.defer();

        u2f.register(appId, registerRequests, [], function (data) {
          self.trigger('errors:clear');

          if (data.errorCode && data.errorCode !== 0) {
            deferred.reject(new _Errors.default.U2FError({
              xhr: {
                responseJSON: {
                  errorSummary: _FidoUtil.default.getU2fEnrollErrorMessageByCode(data.errorCode)
                }
              }
            }));
          } else {
            deferred.resolve(transaction.activate({
              registrationData: data.registrationData,
              version: data.version,
              challenge: data.challenge,
              clientData: data.clientData
            }));
          }
        });
        return deferred.promise;
      });
    }
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'enroll.u2f.title', 'login'),
    save: _okta._.partial(_okta.loc, 'enroll.u2f.save', 'login'),
    noCancelButton: true,
    hasSavingState: false,
    autoSave: true,
    className: 'enroll-u2f-form',
    noButtonBar: function noButtonBar() {
      return !_FidoUtil.default.isU2fAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function formChildren() {
      var result = [];

      if (!_FidoUtil.default.isU2fAvailable()) {
        var errorMessageKey = 'u2f.error.factorNotSupported';

        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
        }

        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _okta.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      } else {
        //There is html in enroll.u2f.general2 in our properties file, reason why is unescaped
        result.push(_FormType.default.View({
          View: _okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var stack1,
                    alias1 = depth0 != null ? depth0 : container.nullContext || {},
                    alias2 = container.hooks.helperMissing,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"u2f-instructions\"><ol><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.general2"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 38
                    },
                    "end": {
                      "line": 1,
                      "column": 90
                    }
                  }
                })) != null ? stack1 : "") + "</li><li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.general3"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 99
                    },
                    "end": {
                      "line": 1,
                      "column": 149
                    }
                  }
                })) + "</li></ol></div>";
              },
              "useData": true
            })
          })
        }));
        result.push(_FormType.default.View({
          View: _okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var alias1 = depth0 != null ? depth0 : container.nullContext || {},
                    alias2 = container.hooks.helperMissing,
                    alias3 = container.escapeExpression,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"u2f-enroll-text hide\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 37
                    },
                    "end": {
                      "line": 1,
                      "column": 91
                    }
                  }
                })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.instructionsBluetooth"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 98
                    },
                    "end": {
                      "line": 1,
                      "column": 161
                    }
                  }
                })) + "</p><div data-se=\"u2f-devices\" class=\"u2f-devices-images\"><div class=\"u2f-usb\"></div><div class=\"u2f-bluetooth\"></div></div><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
              },
              "useData": true
            })
          })
        }));
      }

      return result;
    },
    _startEnrollment: function _startEnrollment() {
      this.$('.u2f-instructions').addClass('hide');
      this.$('.u2f-enroll-text').removeClass('hide');
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function _stopEnrollment() {
      this.$('.u2f-instructions').removeClass('hide');
      this.$('.u2f-enroll-text').addClass('hide');
      this.$('.o-form-button-bar').show();
    }
  },
  Footer: _Footer.default,
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.activate();
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _EnrollUser = _interopRequireDefault(__webpack_require__(1158));

var _BaseLoginController = _interopRequireDefault(__webpack_require__(156));

var _EnrollUserForm = _interopRequireDefault(__webpack_require__(1159));

var _FooterWithBackLink = _interopRequireDefault(__webpack_require__(538));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginController.default.extend({
  className: 'enroll-user',
  initialize: function initialize(options) {
    this.options = options || {}; // create model

    this.model = new _EnrollUser.default(this.options);
  },
  fetchInitialData: function fetchInitialData() {
    // If user is unauthenticated and starts enroll flow make a post call to transition state to PROFILE_REQUIRED
    if (this.options.appState.get('isUnauthenticated')) {
      return this.model.getEnrollFormData();
    } else {
      return _BaseLoginController.default.prototype.fetchInitialData.call();
    }
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isProfileRequired')) {
      return true;
    }
  },
  postRender: function postRender() {
    var form = new _EnrollUserForm.default(this.toJSON());
    this.add(form);
    this.add(new _FooterWithBackLink.default(this.toJSON()));
    this.addListeners();
  }
});

exports.default = _default;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseLoginModel = _interopRequireDefault(__webpack_require__(198));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the 'License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginModel.default.extend({
  initialize: function initialize(options) {
    this.options = options || {};
    this.appState = this.options.appState;
  },
  constructPostData: function constructPostData(profileAttributes) {
    var postData = {
      registration: {
        profile: profileAttributes
      }
    }; // send createNewAccount flag for new user creation

    if (this.appState.get('policy').registration.createNewAccount) {
      postData.registration['createNewAccount'] = true;
    }

    return postData;
  },
  getEnrollFormData: function getEnrollFormData() {
    return this.manageTransaction(function (transaction, setTransaction) {
      return transaction.enroll().then(function (trans) {
        setTransaction(trans);
      });
    });
  },
  save: function save() {
    var data = _BaseLoginModel.default.prototype.toJSON.apply(this, arguments);

    data = _okta._.omit(data, ['appState', 'settings', 'createNewAccount']);

    if (_okta._.isEmpty(data)) {
      var error = {
        errorSummary: (0, _okta.loc)('oform.errorbanner.title', 'login')
      };
      this.trigger('error', this, {
        responseJSON: error
      });
    } else {
      return this.manageTransaction(function (transaction, setTransaction) {
        transaction.enroll(this.constructPostData(data)).then(function (trans) {
          setTransaction(trans);
        });
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _ProfileSchema = _interopRequireDefault(__webpack_require__(1160));

var _RegistrationFormFactory = _interopRequireDefault(__webpack_require__(537));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len: [2, 130] */
var _default = _okta.Form.extend({
  layout: 'o-form-theme',
  autoSave: true,
  noCancelButton: true,
  title: function title() {
    return (0, _okta.loc)('registration.form.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('registration.form.submit', 'login');
  },
  initialize: function initialize(options) {
    var _this = this;

    this.options = options || {};
    this.schema = new _ProfileSchema.default({
      profileSchemaAttributes: this.options.appState.get('policy').registration.profile
    });
    this.schema.properties.each(function (schemaProperty) {
      var inputOptions = _RegistrationFormFactory.default.createInputOptions(schemaProperty);

      _this.addInput(inputOptions);
    });

    var requiredFieldsLabel = _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 36
            },
            "end": {
              "line": 1,
              "column": 45
            }
          }
        }) : helper)) + "</span>";
      },
      "useData": true
    })({
      label: (0, _okta.loc)('registration.required.fields.label', 'login')
    });

    this.add(requiredFieldsLabel);
  }
});

exports.default = _default;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var BaseSchema = _okta.internal.models.BaseSchema;

var _default = BaseSchema.Model.extend({
  expand: ['schema'],
  setFieldPlaceholder: function setFieldPlaceholder(formFields) {
    _okta._.each(formFields, function (formField) {
      formField.title = formField.label;
    });

    return formFields;
  },
  initialize: function initialize(options) {
    var profileAttributes = options.profileSchemaAttributes;
    profileAttributes = this.setFieldPlaceholder(profileAttributes);

    if (profileAttributes) {
      var userProfileSchema = {
        properties: {}
      };

      for (var i = 0; i < profileAttributes.length; i++) {
        var profileAttributeObject = profileAttributes[i];
        userProfileSchema.properties[profileAttributeObject.name] = profileAttributeObject;
      }

      this.parse.apply(this, [{
        schema: userProfileSchema
      }]);
    }
  }
});

exports.default = _default;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(243));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _webauthn = _interopRequireDefault(__webpack_require__(158));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function getExcludeCredentials(credentials) {
  var excludeCredentials = [];

  _okta._.each(credentials, function (credential) {
    excludeCredentials.push({
      type: 'public-key',
      id: _CryptoUtil.default.strToBin(credential.id)
    });
  });

  return excludeCredentials;
}

var _default = _FormController.default.extend({
  className: 'enroll-webauthn',
  Model: {
    local: {
      __enrolled__: 'boolean'
    },
    save: function save() {
      this.trigger('request');

      if (this.get('__enrolled__')) {
        return this.activate();
      }

      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'webauthn',
          provider: 'FIDO'
        });

        return factor.enroll();
      });
    },
    activate: function activate() {
      var _this = this;

      this.set('__enrolled__', true);
      this.trigger('errors:clear');
      this.appState.on('backToFactors', function () {
        if (_this.webauthnAbortController) {
          _this.webauthnAbortController.abort();

          _this.webauthnAbortController = null;
        }
      });
      return this.doTransaction(function (transaction) {
        var activation = transaction.factor.activation; // enroll via browser webauthn js

        var self = this;

        if (_webauthn.default.isNewApiAvailable()) {
          var options = _okta._.extend({}, activation, {
            challenge: _CryptoUtil.default.strToBin(activation.challenge),
            user: {
              id: _CryptoUtil.default.strToBin(activation.user.id),
              name: activation.user.name,
              displayName: activation.user.displayName
            },
            excludeCredentials: getExcludeCredentials(activation.excludeCredentials)
          });

          self.webauthnAbortController = new AbortController();
          return new _q.default(navigator.credentials.create({
            publicKey: options,
            signal: self.webauthnAbortController.signal
          })).then(function (newCredential) {
            return transaction.activate({
              attestation: _CryptoUtil.default.binToStr(newCredential.response.attestationObject),
              clientData: _CryptoUtil.default.binToStr(newCredential.response.clientDataJSON)
            });
          }).catch(function (error) {
            self.trigger('errors:clear'); // Do not display if it is abort error triggered by code when switching.
            // self.webauthnAbortController would be null if abort was triggered by code.

            if (!self.webauthnAbortController) {
              throw new _Errors.default.WebauthnAbortError();
            } else {
              throw new _Errors.default.WebAuthnError({
                xhr: {
                  responseJSON: {
                    errorSummary: error.message
                  }
                }
              });
            }
          }).finally(function () {
            // unset webauthnAbortController on successful authentication or error
            self.webauthnAbortController = null;
          });
        }
      });
    }
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'enroll.webauthn.biometric.title', 'login'),
    save: _okta._.partial(_okta.loc, 'enroll.webauthn.save', 'login'),
    noCancelButton: true,
    hasSavingState: false,
    autoSave: true,
    className: 'enroll-webauthn-form',
    noButtonBar: function noButtonBar() {
      return !_webauthn.default.isNewApiAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function formChildren() {
      var children = [];

      if (_webauthn.default.isNewApiAvailable()) {
        //enroll.webauthn.biometric.instructions.edge is unescaped because it contains html
        children.push(_FormType.default.View({
          View: _okta.View.extend({
            className: 'webauthn-enroll-text',
            template: _runtime.default.template({
              "1": function _(container, depth0, helpers, partials, data) {
                var stack1,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"webauthn-edge-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.webauthn.biometric.instructions.edge"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 173
                    },
                    "end": {
                      "line": 1,
                      "column": 249
                    }
                  }
                })) != null ? stack1 : "") + "</p></div>";
              },
              "3": function _(container, depth0, helpers, partials, data) {
                var stack1,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"webauthn-restrictions-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.webauthn.instructions.noSupportForBiometric"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 340
                    },
                    "end": {
                      "line": 1,
                      "column": 423
                    }
                  }
                })) != null ? stack1 : "") + "</p></div>";
              },
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var stack1,
                    alias1 = depth0 != null ? depth0 : container.nullContext || {},
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"webauthn-enroll-instructions\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.webauthn.biometric.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 45
                    },
                    "end": {
                      "line": 1,
                      "column": 114
                    }
                  }
                })) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isEdge") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(1, data, 0),
                  "inverse": container.noop,
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 124
                    },
                    "end": {
                      "line": 1,
                      "column": 266
                    }
                  }
                })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "onlySupportsSecurityKey") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(3, data, 0),
                  "inverse": container.noop,
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 266
                    },
                    "end": {
                      "line": 1,
                      "column": 440
                    }
                  }
                })) != null ? stack1 : "") + "<div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner hide\"></div>";
              },
              "useData": true
            }),
            getTemplateData: function getTemplateData() {
              return {
                isEdge: _BrowserFeatures.default.isEdge(),
                onlySupportsSecurityKey: (_BrowserFeatures.default.isFirefox() || _BrowserFeatures.default.isSafari()) && _BrowserFeatures.default.isMac()
              };
            }
          })
        }));
      } else {
        var errorMessageKey = 'webauthn.biometric.error.factorNotSupported';

        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
        }

        children.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _okta.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }

      return children;
    },
    _startEnrollment: function _startEnrollment() {
      this.$('.okta-waiting-spinner').show();
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function _stopEnrollment() {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar').show();
    }
  },
  Footer: _Footer.default,
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.activate();
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1163);

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1164);

module.exports = parent;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1165);
var path = __webpack_require__(23);

module.exports = path.Object.freeze;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var FREEZING = __webpack_require__(539);
var fails = __webpack_require__(28);
var isObject = __webpack_require__(38);
var onFreeze = __webpack_require__(244).onFreeze;

var nativeFreeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { nativeFreeze(1); });

// `Object.freeze` method
// https://tc39.github.io/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return nativeFreeze && isObject(it) ? nativeFreeze(onFreeze(it)) : it;
  }
});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _webauthn = _interopRequireDefault(__webpack_require__(158));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

var _Spinner = _interopRequireDefault(__webpack_require__(540));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-windows-hello',
  Model: {
    local: {
      __isEnrolled__: 'boolean'
    },
    save: function save() {
      if (!_webauthn.default.isAvailable()) {
        return;
      }

      this.trigger('request');

      if (this.get('__isEnrolled__')) {
        return this.activate();
      }

      return this.doTransaction(function (transaction) {
        return this._enroll(transaction);
      });
    },
    _enroll: function _enroll(transaction) {
      var factor = _okta._.findWhere(transaction.factors, {
        factorType: 'webauthn',
        provider: 'FIDO'
      });

      return factor.enroll();
    },
    activate: function activate() {
      this.set('__isEnrolled__', true);
      return this.doTransaction(function (transaction) {
        var activation = transaction.factor.activation;
        var user = transaction.user;
        var model = this;
        var accountInfo = {
          rpDisplayName: activation.rpDisplayName,
          userDisplayName: user.profile.displayName,
          accountName: user.profile.login,
          userId: user.id
        };
        var cryptoParams = [{
          algorithm: activation.algorithm
        }];
        var challenge = activation.nonce;
        return _webauthn.default.makeCredential(accountInfo, cryptoParams, challenge).then(function (creds) {
          return transaction.activate({
            credentialId: creds.credential.id,
            publicKey: creds.publicKey,
            attestation: null
          });
        }).catch(function (error) {
          switch (error.message) {
            case 'AbortError':
            case 'NotFoundError':
            case 'NotSupportedError':
              model.trigger('abort', error.message);
              return transaction;
          }

          throw error;
        });
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _okta._.partial(_okta.loc, 'enroll.windowsHello.title', 'login'),
    subtitle: function subtitle() {
      return _webauthn.default.isAvailable() ? (0, _okta.loc)('enroll.windowsHello.subtitle', 'login') : '';
    },
    save: _okta._.partial(_okta.loc, 'enroll.windowsHello.save', 'login'),
    customSavingState: {
      stop: 'abort'
    },
    modelEvents: function modelEvents() {
      if (!_webauthn.default.isAvailable()) {
        return {};
      }

      return {
        request: '_startEnrollment',
        error: '_stopEnrollment',
        abort: '_stopEnrollment'
      };
    },
    noButtonBar: function noButtonBar() {
      return !_webauthn.default.isAvailable();
    },
    formChildren: function formChildren() {
      var result = [];

      if (!_webauthn.default.isAvailable()) {
        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _okta.loc)('enroll.windowsHello.error.notWindows', 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }

      result.push(_FormType.default.View({
        View: new _Spinner.default({
          model: this.model,
          visible: false
        })
      }));
      return result;
    },
    _startEnrollment: function _startEnrollment() {
      this.subtitle = (0, _okta.loc)('enroll.windowsHello.subtitle.loading', 'login');
      this.model.trigger('spinner:show');

      this._resetErrorMessage();

      this.render();
      this.$('.o-form-button-bar').addClass('hide');
    },
    _stopEnrollment: function _stopEnrollment(errorMessage) {
      this.subtitle = (0, _okta.loc)('enroll.windowsHello.subtitle', 'login');
      this.model.trigger('spinner:hide');
      var message;

      switch (errorMessage) {
        case 'NotSupportedError':
          message = (0, _okta.loc)('enroll.windowsHello.error.notConfiguredHtml', 'login');
          break;
      }

      this._resetErrorMessage();

      if (message) {
        var messageView = new _HtmlErrorMessageView.default({
          message: message
        });
        this.$('.o-form-error-container').addClass('o-form-has-errors');
        this.add(messageView, {
          selector: '.o-form-error-container'
        });
        this._errorMessageView = this.last();
      }

      this.render();
      this.$('.o-form-button-bar').removeClass('hide');
    },
    _resetErrorMessage: function _resetErrorMessage() {
      this._errorMessageView && this._errorMessageView.remove();
      this._errorMessageView = undefined;
      this.clearErrors();
    }
  },
  Footer: _Footer.default,
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.activate();
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Footer = _interopRequireDefault(__webpack_require__(45));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-yubikey',
  Model: {
    props: {
      passCode: ['string', true],
      factorId: 'string'
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'token:hardware',
          provider: 'YUBICO'
        });

        return factor.enroll({
          passCode: this.get('passCode')
        });
      });
    }
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'enroll.yubikey.title', 'login'),
    subtitle: _okta._.partial(_okta.loc, 'enroll.yubikey.subtitle', 'login'),
    noCancelButton: true,
    save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
    autoSave: true,
    className: 'enroll-yubikey',
    formChildren: [_FormType.default.View({
      View: '<div class="yubikey-demo" data-type="yubikey-example"></div>'
    }), _FormType.default.Input({
      name: 'passCode',
      input: _TextBox.default,
      type: 'password'
    })]
  },
  Footer: _Footer.default
});

exports.default = _default;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _CountryUtil = _interopRequireDefault(__webpack_require__(157));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var PUSH_INTERVAL = 6000; // Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
// in network connection lost errors in Safari and IE.

var EnrollmentLinkSentControllerFooter = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oform.back"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function back() {
    var url = _RouterUtil.default.createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), this.options.appState.get('activatedFactorType'), 'manual');

    this.options.appState.trigger('navigate', url);
  }
});

var emailSentForm = {
  title: _okta._.partial(_okta.loc, 'enroll.totp.enrollViaEmail.title', 'login'),
  noButtonBar: true,
  attributes: {
    'data-se': 'sent-email-activation-link'
  },
  formChildren: [_FormType.default.View({
    View: _okta.View.extend({
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "enroll.totp.enrollViaEmail.msg"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 3
              },
              "end": {
                "line": 1,
                "column": 64
              }
            }
          })) + "</p><p class=\"email-address\">" + alias3((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "email",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 93
              },
              "end": {
                "line": 1,
                "column": 102
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      }),
      getTemplateData: function getTemplateData() {
        return {
          email: this.options.appState.get('userEmail')
        };
      }
    })
  })]
};
var smsSentForm = {
  title: _okta._.partial(_okta.loc, 'enroll.totp.enrollViaSms.title', 'login'),
  noButtonBar: true,
  attributes: {
    'data-se': 'sent-sms-activation-link'
  },
  formChildren: [_FormType.default.View({
    View: _okta.View.extend({
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "enroll.totp.enrollViaSms.msg"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 3
              },
              "end": {
                "line": 1,
                "column": 62
              }
            }
          })) + "</p><p class=\"phone-number\">" + alias3((helper = (helper = lookupProperty(helpers, "phoneNumber") || (depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "phoneNumber",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 90
              },
              "end": {
                "line": 1,
                "column": 105
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      }),
      getTemplateData: function getTemplateData() {
        return {
          phoneNumber: this.model.get('fullPhoneNumber')
        };
      }
    })
  })]
};

var _default = _FormController.default.extend({
  className: 'enroll-activation-link-sent',
  Model: function Model() {
    return {
      local: {
        countryCode: ['string', false, this.options.appState.get('userCountryCode')],
        phoneNumber: ['string', false, this.options.appState.get('userPhoneNumber')],
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function fn(countryCode) {
            return '+' + _CountryUtil.default.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function fn(countryCallingCode, phoneNumber) {
            return countryCallingCode + phoneNumber;
          }
        }
      }
    };
  },
  Form: function Form() {
    var activationType = this.options.appState.get('factorActivationType');

    switch (activationType) {
      case 'SMS':
        return smsSentForm;

      case 'EMAIL':
        return emailSentForm;

      default:
        throw new Error('Unknown activation option: ' + activationType);
    }
  },
  Footer: EnrollmentLinkSentControllerFooter,
  initialize: function initialize() {
    this.pollForEnrollment();
  },
  remove: function remove() {
    return _FormController.default.prototype.remove.apply(this, arguments);
  },
  pollForEnrollment: function pollForEnrollment() {
    return this.model.doTransaction(function (transaction) {
      return transaction.poll(PUSH_INTERVAL);
    });
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isWaitingForActivation')) {
      this.pollForEnrollment();
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

var _EnterPasscodeForm = _interopRequireDefault(__webpack_require__(514));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var EnterPasscodePushFlowControllerFooter = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oform.back"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function back() {
    var url = _RouterUtil.default.createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), 'push', 'manual');

    this.options.appState.trigger('navigate', url);
  }
});

var _default = _FormController.default.extend({
  className: 'activate-push',
  Model: function Model() {
    return {
      props: {
        factorId: ['string', true, this.options.appState.get('activatedFactorId')],
        passCode: ['string', true]
      },
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      save: function save() {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    };
  },
  Form: _EnterPasscodeForm.default,
  Footer: EnterPasscodePushFlowControllerFooter
});

exports.default = _default;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _ValidationUtil = _interopRequireDefault(__webpack_require__(199));

var _ContactSupport = _interopRequireDefault(__webpack_require__(541));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var ForgotPasswordControllernoFactorsError = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "password.forgot.noFactorsEnabled"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 173
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  })
});

var ForgotPasswordControllerFooter = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 94
          },
          "end": {
            "line": 1,
            "column": 131
          }
        }
      })) + "</a>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.noAccessToEmail"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 220
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hideBackToSignInForReset") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 146
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 146
          },
          "end": {
            "line": 1,
            "column": 281
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.back();
    },
    'click .js-contact-support': function clickJsContactSupport(e) {
      e.preventDefault();
      this.state.trigger('contactSupport');
      this.$('.js-contact-support').hide();
    }
  },
  getTemplateData: function getTemplateData() {
    return {
      hideBackToSignInForReset: this.settings.get('features.hideBackToSignInForReset'),
      helpSupportNumber: this.settings.get('helpSupportNumber')
    };
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});

var _default = _FormController.default.extend({
  className: 'forgot-password',
  Model: {
    props: {
      username: ['string', true],
      factorType: ['string', true]
    },
    validate: function validate() {
      return _ValidationUtil.default.validateUsername(this);
    },
    save: function save() {
      var self = this;
      var relayState = this.settings.get('relayState');
      this.startTransaction(function (authClient) {
        return authClient.forgotPassword({
          username: self.settings.transformUsername(self.get('username'), _Enums.default.FORGOT_PASSWORD),
          factorType: self.get('factorType'),
          relayState: relayState
        });
      }).catch(function () {//need empty fail handler on model to display errors on form
      });
    }
  },
  Form: {
    noButtonBar: true,
    title: _okta._.partial(_okta.loc, 'password.reset', 'login'),
    formChildren: function formChildren() {
      var smsEnabled = this.settings.get('features.smsRecovery');
      /*eslint complexity: [2, 9] max-statements: [2, 23] */

      var callEnabled = this.settings.get('features.callRecovery');
      var emailEnabled = this.settings.get('features.emailRecovery');
      var noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
      var formChildren = [];

      if (noFactorsEnabled) {
        this.add(ForgotPasswordControllernoFactorsError, '.o-form-error-container');
      } else {
        formChildren.push(_FormType.default.Input({
          label: (0, _okta.loc)('password.forgot.email.or.username.placeholder', 'login'),
          'label-top': true,
          explain: _Util.default.createInputExplain('password.forgot.email.or.username.tooltip', 'password.forgot.email.or.username.placeholder', 'login'),
          'explain-top': true,
          name: 'username',
          input: _TextBox.default,
          inputId: 'account-recovery-username',
          autoComplete: 'username',
          type: 'text',
          inlineValidation: false
        }));

        if (smsEnabled || callEnabled) {
          formChildren.push(_FormType.default.View({
            View: _okta.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "arguments": "mobileFactors",
                      "bundle": "login",
                      "code": "recovery.mobile.hint"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 32
                      },
                      "end": {
                        "line": 1,
                        "column": 109
                      }
                    }
                  })) + "</p>";
                },
                "useData": true
              }),
              getTemplateData: function getTemplateData() {
                var mobileFactors;

                if (smsEnabled && callEnabled) {
                  mobileFactors = (0, _okta.loc)('recovery.smsOrCall');
                } else if (callEnabled) {
                  mobileFactors = (0, _okta.loc)('recovery.call');
                } else {
                  mobileFactors = (0, _okta.loc)('recovery.sms');
                }

                return {
                  mobileFactors: mobileFactors
                };
              }
            })
          }));
        }

        if (smsEnabled) {
          this.$el.addClass('forgot-password-sms-enabled');
          formChildren.push(this.createRecoveryFactorButton('sms-button', 'password.forgot.sendText', _Enums.default.RECOVERY_FACTOR_TYPE_SMS, this));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_SMS);
        }

        if (callEnabled) {
          this.$el.addClass('forgot-password-call-enabled');
          formChildren.push(this.createRecoveryFactorButton('call-button', 'password.forgot.call', _Enums.default.RECOVERY_FACTOR_TYPE_CALL, this));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_CALL);
        }

        if (emailEnabled) {
          this.$el.addClass('forgot-password-email-enabled');
          formChildren.push(this.createRecoveryFactorButton('email-button', 'password.forgot.sendEmail', _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL, this));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_EMAIL);
        }
      }

      return formChildren;
    },
    initialize: function initialize() {
      this.listenTo(this.state, 'contactSupport', function () {
        this.add(_ContactSupport.default, '.o-form-error-container');
      });
      this.listenTo(this, 'save', function () {
        this.options.appState.set('username', this.model.get('username'));
        this.model.save();
      });
    },
    setDefaultFactorType: function setDefaultFactorType(factorType) {
      if (_okta._.isEmpty(this.model.get('factorType'))) {
        this.model.set('factorType', factorType);
      }
    },
    createRecoveryFactorButton: function createRecoveryFactorButton(className, labelCode, factorType, form) {
      return _FormType.default.Button({
        attributes: {
          'data-se': className
        },
        className: 'button button-primary button-wide ' + className,
        title: (0, _okta.loc)(labelCode, 'login'),
        click: function click() {
          form.clearErrors();

          if (this.model.isValid()) {
            this.model.set('factorType', factorType);
            form.trigger('save', this.model);
          }
        }
      });
    }
  },
  Footer: ForgotPasswordControllerFooter,
  initialize: function initialize() {
    this.options.appState.unset('username');
  }
});

exports.default = _default;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _PrimaryAuthController = _interopRequireDefault(__webpack_require__(542));

var _IDPDiscovery = _interopRequireDefault(__webpack_require__(1180));

var _PrimaryAuth = _interopRequireDefault(__webpack_require__(329));

var _BaseLoginController = _interopRequireDefault(__webpack_require__(156));

var _IDPDiscoveryForm = _interopRequireDefault(__webpack_require__(1181));

var _CustomButtons = _interopRequireDefault(__webpack_require__(543));

var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(330));

/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _PrimaryAuthController.default.extend({
  className: 'idp-discovery',
  View: _IDPDiscoveryForm.default,
  constructor: function constructor(options) {
    options.appState.unset('username');
    this.model = new _IDPDiscovery.default({
      requestContext: options.settings.get('idpDiscovery.requestContext'),
      settings: options.settings,
      appState: options.appState
    }, {
      parse: true
    });

    _BaseLoginController.default.apply(this, arguments);

    this.addListeners(); // If social auth is configured, 'socialAuthPositionTop' will determine
    // the order in which the social auth and primary auth are shown on the screen.

    if (options.settings.get('hasConfiguredButtons')) {
      this.add(_CustomButtons.default, {
        prepend: options.settings.get('socialAuthPositionTop'),
        options: {
          // To trigger an afterError event, we require the current controller
          currentController: this
        }
      });
    }

    this.addFooter(options);
    this.setUsername();
  },
  initialize: function initialize() {
    _PrimaryAuthController.default.prototype.initialize.apply(this);

    this.listenTo(this.model, 'goToPrimaryAuth', function () {
      this.settings.set('username', this.model.get('username'));
      var self = this;

      if (this.settings.get('features.deviceFingerprinting')) {
        _DeviceFingerprint.default.generateDeviceFingerprint(this.settings.get('baseUrl'), this.$el).then(function (fingerprint) {
          self.options.appState.set('deviceFingerprint', fingerprint);
          self.options.appState.set('username', self.model.get('username'));
        }).catch(function () {
          // Keep going even if device fingerprint fails
          self.options.appState.set('username', self.model.get('username'));
        }).finally(function () {
          self.doPrimaryAuth();
        });
      } else {
        self.doPrimaryAuth();
      }
    });
  },
  doPrimaryAuth: function doPrimaryAuth() {
    if (this.settings.get('features.passwordlessAuth')) {
      var primaryAuthModel = new _PrimaryAuth.default({
        username: this.model.get('username'),
        multiOptionalFactorEnroll: this.options.settings.get('features.multiOptionalFactorEnroll'),
        settings: this.options.settings,
        appState: this.options.appState
      }, {
        parse: true
      }); // Events to set the transaction attributes on the app state.

      this.addModelListeners(primaryAuthModel); // Make the primary auth request

      primaryAuthModel.save();
    } else {
      this.options.appState.set('disableUsername', true);
      this.options.appState.trigger('navigate', 'signin');
    }
  }
});

exports.default = _default;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typingdna = _interopRequireDefault(__webpack_require__(1173));

/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var tdna;
var _default = {
  track: function track(selectorId) {
    try {
      tdna = new _typingdna.default();
      tdna.addTarget(selectorId);
      tdna.start();
    } catch (e) {// Issues in typing should not stop Primary auth.
    }
  },
  getTypingPattern: function getTypingPattern() {
    try {
      return tdna.getTypingPattern({
        type: 1
      });
    } catch (e) {
      return null;
    }
  }
};
exports.default = _default;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _slice = _interopRequireDefault(__webpack_require__(495));

var _parseInt2 = _interopRequireDefault(__webpack_require__(323));

var _sort = _interopRequireDefault(__webpack_require__(545));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _flags = _interopRequireDefault(__webpack_require__(483));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(517));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _splice = _interopRequireDefault(__webpack_require__(154));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _setInterval2 = _interopRequireDefault(__webpack_require__(194));

/*
 * Checking in as there is no npm module to consume. 
 * Current version is 2.15.
 * Repo - https://github.com/TypingDNA/TypingDnaRecorder-JavaScript
 */

/**
 * TypingDNA - Typing Biometrics JavaScript API
 * https://api.typingdna.com/scripts/typingdna.js
 * https://typingdna.com/scripts/typingdna.js (alternative)
 *
 * @version 2.15
 * @author Raul Popa
 * @copyright SC TypingDNA SRL, http://typingdna.com
 * @license http://www.apache.org/licenses/LICENSE-2.0
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Typical usage:
 * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
 * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
 * returns a type 1 typing pattern (and continues recording afterwards)
 *
 * Optional:
 * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
 * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
 * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
 * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
 * (there is no need to initialize the class to do pattern quality checking)
 */

/**
 * Creates a single instance (or a reference) of the TypingDNA class
 * @return {Object} Returns the single instance of the TypingDNA class.
 * @example var tdna = new TypingDNA();
 */
module.exports = function TypingDNA() {
  if (TypingDNA.initialized != true) {
    TypingDNA.prototype.start = function () {
      return TypingDNA.start.apply(this, arguments);
    };

    TypingDNA.prototype.stop = function () {
      return TypingDNA.stop.apply(this, arguments);
    };

    TypingDNA.prototype.reset = function () {
      return TypingDNA.reset.apply(this, arguments);
    };

    TypingDNA.prototype.addTarget = function () {
      return TypingDNA.addTarget.apply(this, arguments);
    };

    TypingDNA.prototype.removeTarget = function () {
      return TypingDNA.removeTarget.apply(this, arguments);
    };

    TypingDNA.prototype.getTypingPattern = function () {
      return TypingDNA.getTypingPattern.apply(this, arguments);
    };

    TypingDNA.prototype.get = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.get.apply(this, arguments);
    };

    TypingDNA.prototype.startDiagram = function () {// deprecated in favor of start()
      //return TypingDNA.startDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.stopDiagram = function () {// deprecated in favor of stop()
      //return TypingDNA.stopDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.getDiagram = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.getDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.getExtendedDiagram = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.getExtendedDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.getMouseDiagram = function () {
      return TypingDNA.getMouseDiagram.apply(this, arguments);
    };

    TypingDNA.prototype.startMouse = function () {
      return TypingDNA.startMouse.apply(this, arguments);
    };

    TypingDNA.prototype.stopMouse = function () {
      return TypingDNA.stopMouse.apply(this, arguments);
    };

    TypingDNA.prototype.getQuality = function () {
      return TypingDNA.getQuality.apply(this, arguments);
    };

    TypingDNA.prototype.getLength = function () {
      return TypingDNA.getLength.apply(this, arguments);
    };

    TypingDNA.prototype.isMobile = function () {
      return TypingDNA.isMobile.apply(this, arguments);
    };

    TypingDNA.prototype.getTextId = function () {
      return TypingDNA.getTextId.apply(this, arguments);
    };

    TypingDNA.initialized = true;
    TypingDNA.prototype.maxHistoryLength = TypingDNA.maxHistoryLength;
    TypingDNA.prototype.defaultHistoryLength = TypingDNA.defaultHistoryLength;
    TypingDNA.prototype.maxSeekTime = TypingDNA.maxSeekTime;
    TypingDNA.prototype.maxPressTime = TypingDNA.maxPressTime;
    TypingDNA.version = 2.15;
    TypingDNA.flags = 0;
    TypingDNA.instance = this;
    TypingDNA.document = document;
    TypingDNA.maxHistoryLength = 2000;
    TypingDNA.maxSeekTime = 1500;
    TypingDNA.maxPressTime = 300;
    TypingDNA.defaultHistoryLength = 160;
    TypingDNA.spKeyCodes = [8, 13, 32];
    TypingDNA.spKeyCodesObj = {
      8: 1,
      13: 1,
      32: 1
    };
    TypingDNA.keyCodes = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 32, 222, 188, 190, 186, 187, 189, 191, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    TypingDNA.keyCodesObj = {};

    for (var i in TypingDNA.keyCodes) {
      TypingDNA.keyCodesObj[TypingDNA.keyCodes[i]] = 1;
    }

    TypingDNA.pt1 = TypingDNA.ut1 = new Date().getTime();
    TypingDNA.wfk = [];
    TypingDNA.sti = [];
    TypingDNA.skt = [];
    TypingDNA.recording = true;
    TypingDNA.mouseRecording = true;
    TypingDNA.mouseMoveRecording = false;
    TypingDNA.spKeyRecording = true;
    TypingDNA.diagramRecording = true;
    TypingDNA.dwfk = [];
    TypingDNA.dsti = [];
    TypingDNA.dskt = [];
    TypingDNA.drkc = [];
    TypingDNA.dlastDownKey;
    TypingDNA.prevKeyCode = 0;
    TypingDNA.maxMoveDeltaTime = 600;
    TypingDNA.maxScrollDeltaTime = 800;
    TypingDNA.maxStopTime = 1500;
    TypingDNA.maxClickTime = 600;
    TypingDNA.maxMouseHistoryLength = 500;
    TypingDNA.lastMouseMoveTime = TypingDNA.lastMouseDownTime = new Date().getTime();
    TypingDNA.stopTimes = [];
    TypingDNA.clickTimes = [];
    TypingDNA.lastMouseStop = true;
    TypingDNA.zl = 0.0000001;
    TypingDNA.isAndroidChrome = false;
    TypingDNA.ACLastTime = new Date().getTime();
    TypingDNA.ACSeekTime = 0;
    TypingDNA.ACPressTime = 0;
    TypingDNA.ACLastCharCode = 0;
    TypingDNA.ACLastKeyCode = 0;
    TypingDNA.ACInputLengths = {
      inputs: [],
      lastLength: []
    };
    TypingDNA.ACPreviousKeyCode = 0;
    TypingDNA.targetIds = [];
    TypingDNA.lastTarget = "";
    TypingDNA.lastTargetFound = false;
    TypingDNA.replaceMissingKeys = true;
    TypingDNA.replaceMissingKeysPerc = 7;

    TypingDNA.keyDown = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      var keyCode = e.keyCode;

      if (TypingDNA.wfk[keyCode] == 1 || TypingDNA.dwfk[keyCode] == 1) {//return;
      }

      if (keyCode == 229 && TypingDNA.isMobile() && !TypingDNA.isAndroidChrome) {
        TypingDNA.isAndroidChrome = true;
        TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
        TypingDNA.ACLastTime = new Date().getTime();
        TypingDNA.document.removeEventListener("keydown", TypingDNA.keyDown);
        TypingDNA.document.removeEventListener("keyup", TypingDNA.keyUp);
        TypingDNA.document.removeEventListener("keypress", TypingDNA.keyPress); // if android

        TypingDNA.document.addEventListener("keydown", TypingDNA.ACKeyDown);
        TypingDNA.document.addEventListener("keyup", TypingDNA.ACKeyUp);
      } else {
        var t0 = TypingDNA.pt1;
        TypingDNA.pt1 = new Date().getTime();
        var seekTotal = TypingDNA.pt1 - t0;
        var startTime = TypingDNA.pt1;

        if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
          if (!e.shiftKey || TypingDNA.isMobile()) {
            TypingDNA.wfk[keyCode] = 1;
            TypingDNA.skt[keyCode] = seekTotal;
            TypingDNA.sti[keyCode] = startTime;
          }
        }

        if (TypingDNA.diagramRecording == true) {
          TypingDNA.dwfk[keyCode] = 1;
          TypingDNA.dskt[keyCode] = seekTotal;
          TypingDNA.dsti[keyCode] = startTime;
          TypingDNA.dlastDownKey = keyCode;
        }
      }
    };

    TypingDNA.keyPress = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      if (TypingDNA.diagramRecording == true) {
        var keyCode = TypingDNA.dlastDownKey;
        TypingDNA.drkc[keyCode] = e.charCode;
      }
    };

    TypingDNA.keyUp = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      var ut = new Date().getTime();
      var keyCode = e.keyCode;

      if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
        if (!e.shiftKey || TypingDNA.isMobile()) {
          if (TypingDNA.wfk[keyCode] == 1) {
            var pressTime = ut - TypingDNA.sti[keyCode];
            var seekTime = TypingDNA.skt[keyCode];
            var arr = [keyCode, seekTime, pressTime, TypingDNA.prevKeyCode, ut, e.target.id];
            TypingDNA.history.add(arr);
            TypingDNA.prevKeyCode = keyCode;
          }
        }

        TypingDNA.wfk[keyCode] = 0;
      }

      if (TypingDNA.diagramRecording == true) {
        if (TypingDNA.drkc[keyCode] != undefined && TypingDNA.drkc[keyCode] != 0) {
          if (TypingDNA.dwfk[keyCode] == 1) {
            var pressTime = ut - TypingDNA.dsti[keyCode];
            var seekTime = TypingDNA.dskt[keyCode];
            var realKeyCode = TypingDNA.drkc[keyCode];
            var arrD = [keyCode, seekTime, pressTime, realKeyCode, ut, e.target.id];
            TypingDNA.history.addDiagram(arrD);
          }
        }

        TypingDNA.dwfk[keyCode] = 0;
      }
    };

    TypingDNA.mouseScroll = function (e) {
      if (TypingDNA.mouseRecording == true) {
        if (TypingDNA.mouseMoveRecording == true) {
          if (TypingDNA.mouse.scrollStarted == true) {
            var currentTime = new Date().getTime();
            TypingDNA.mouse.scrollTimes.push(currentTime);
            TypingDNA.mouse.scrollTopArr.push(TypingDNA.document.body.scrollTop);
            clearInterval(TypingDNA.scrollInterval);
            TypingDNA.scrollInterval = (0, _setInterval2.default)(TypingDNA.mouse.checkScroll, TypingDNA.maxScrollDeltaTime);
          } else {
            TypingDNA.mouse.scrollStarted = true;
          }
        }
      }
    };

    TypingDNA.mouseMove = function (e) {
      if (TypingDNA.mouseRecording == true) {
        var currentTime = new Date().getTime();

        if (TypingDNA.mouseMoveRecording == true) {
          if (TypingDNA.mouse.started == true) {
            TypingDNA.mouse.times.push(currentTime);
            TypingDNA.mouse.xPositions.push(e.screenX);
            TypingDNA.mouse.yPositions.push(e.screenY);
            clearInterval(TypingDNA.moveInterval);
            TypingDNA.moveInterval = (0, _setInterval2.default)(TypingDNA.mouse.checkMove, TypingDNA.maxMoveDeltaTime);
          } else {
            TypingDNA.mouse.started = true;
          }
        }

        TypingDNA.lastMouseMoveTime = currentTime;
      }
    };

    TypingDNA.mouseDown = function (e) {
      if (TypingDNA.mouseRecording == true) {
        TypingDNA.mouse.checkMove();
        TypingDNA.mouse.checkScroll();

        if (e.which == 1) {
          TypingDNA.lastMouseDownTime = new Date().getTime();
          var stopTime = TypingDNA.lastMouseDownTime - TypingDNA.lastMouseMoveTime;

          if (stopTime < TypingDNA.maxStopTime && TypingDNA.lastMouseStop == false) {
            TypingDNA.stopTimes.push(stopTime);

            if (TypingDNA.mouseMoveRecording == true) {
              var eventType = 3;
              var arr = [eventType, stopTime];
              TypingDNA.mouse.history.add(arr);
              TypingDNA.lastMouseStop = true;
            }
          }
        }
      }
    };

    TypingDNA.mouseUp = function (e) {
      if (TypingDNA.mouseRecording == true) {
        if (e.which == 1) {
          var clickTime = new Date().getTime() - TypingDNA.lastMouseDownTime;

          if (clickTime < TypingDNA.maxClickTime && TypingDNA.lastMouseDownTime > TypingDNA.lastMouseMoveTime) {
            TypingDNA.clickTimes.push(clickTime);

            if (TypingDNA.mouseMoveRecording == true) {
              var eventType = 4;
              var arr = [eventType, clickTime];
              TypingDNA.mouse.history.add(arr);
            }
          }
        }
      }
    };

    TypingDNA.ACKeyDown = function (e) {
      var _context;

      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
      TypingDNA.ACLastTime = new Date().getTime();

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      if ((0, _indexOf.default)(_context = TypingDNA.ACInputLengths.inputs).call(_context, e.target) === -1) {
        TypingDNA.ACInputLengths.inputs.push(e.target);
        TypingDNA.ACInputLengths.lastLength.push(0);
      }
    };

    TypingDNA.ACKeyUp = function (e) {
      var _context2;

      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }

      TypingDNA.ACPressTime = new Date().getTime() - TypingDNA.ACLastTime;
      TypingDNA.ACLastTime = new Date().getTime();

      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }

      var keyCode = e.keyCode;
      var targetIndex = (0, _indexOf.default)(_context2 = TypingDNA.ACInputLengths.inputs).call(_context2, e.target);

      if (targetIndex === -1) {
        var _context3;

        TypingDNA.ACInputLengths.inputs.push(e.target);
        TypingDNA.ACInputLengths.lastLength.push(0);
        targetIndex = (0, _indexOf.default)(_context3 = TypingDNA.ACInputLengths.inputs).call(_context3, e.target);
      }

      if (keyCode == 229 && e.target.value.length >= TypingDNA.ACInputLengths.lastLength[targetIndex]) {
        var char = e.target.value.substr(e.target.selectionStart - 1 || 0, 1);
        keyCode = char.toUpperCase().charCodeAt(0);
        TypingDNA.ACLastCharCode = char.charCodeAt(0);
        TypingDNA.ACLastKeyCode = char.toUpperCase().charCodeAt(0);
      }

      TypingDNA.ACInputLengths.lastLength[targetIndex] = e.target.value.length;
      var arr = [keyCode, TypingDNA.ACSeekTime, TypingDNA.ACPressTime, TypingDNA.ACPreviousKeyCode, TypingDNA.ACLastTime];
      TypingDNA.history.add(arr);
      TypingDNA.ACPreviousKeyCode = keyCode;

      if (TypingDNA.diagramRecording == true) {
        var arrD = [keyCode, TypingDNA.ACSeekTime, TypingDNA.ACPressTime, TypingDNA.ACLastCharCode];
        TypingDNA.history.addDiagram(arrD);
      }
    };

    TypingDNA.isTarget = function (target) {
      if (TypingDNA.lastTarget == target && TypingDNA.lastTargetFound) {
        return true;
      } else {
        var targetLength = TypingDNA.targetIds.length;
        var targetFound = false;

        if (targetLength > 0) {
          for (var i = 0; i < targetLength; i++) {
            if (TypingDNA.targetIds[i] == target) {
              targetFound = true;
              break;
            }
          }

          TypingDNA.lastTarget = target;
          TypingDNA.lastTargetFound = targetFound;
          return targetFound;
        } else {
          TypingDNA.lastTarget = target;
          TypingDNA.lastTargetFound = true;
          return true;
        }
      }
    };

    if (TypingDNA.document.addEventListener) {
      TypingDNA.document.addEventListener("keydown", TypingDNA.keyDown);
      TypingDNA.document.addEventListener("keyup", TypingDNA.keyUp);
      TypingDNA.document.addEventListener("keypress", TypingDNA.keyPress);
      TypingDNA.document.addEventListener("mousemove", TypingDNA.mouseMove);
      TypingDNA.document.addEventListener("mousedown", TypingDNA.mouseDown);
      TypingDNA.document.addEventListener("mouseup", TypingDNA.mouseUp);
      TypingDNA.document.addEventListener("scroll", TypingDNA.mouseScroll);
    } else if (TypingDNA.document.attachEvent) {
      TypingDNA.document.attachEvent("onkeydown", TypingDNA.keyDown);
      TypingDNA.document.attachEvent("onkeyup", TypingDNA.keyUp);
      TypingDNA.document.attachEvent("onkeypress", TypingDNA.keyPress);
      TypingDNA.document.attachEvent("onmousemove", TypingDNA.mouseMove);
      TypingDNA.document.attachEvent("onmousedown", TypingDNA.mouseDown);
      TypingDNA.document.attachEvent("onmouseup", TypingDNA.mouseUp);
      TypingDNA.document.attachEvent("onscroll", TypingDNA.mouseScroll);
    } else {
      console.log("browser not supported");
    }

    TypingDNA.mouse = {};
    TypingDNA.mouse.times = [];
    TypingDNA.mouse.xPositions = [];
    TypingDNA.mouse.yPositions = [];
    TypingDNA.mouse.scrollTimes = [];
    TypingDNA.mouse.scrollTopArr = [];
    TypingDNA.mouse.history = {};
    TypingDNA.mouse.history.stack = [];

    TypingDNA.mouse.getDistance = function (a, b) {
      return Math.sqrt(a * a + b * b);
    };

    TypingDNA.mouse.getTotalDistance = function (xPositions, yPositions) {
      var totalDistance = 0;
      var length = xPositions.length;

      for (i = 1; i < length - 1; i++) {
        var a = xPositions[i] - xPositions[i - 1];
        var b = yPositions[i] - yPositions[i - 1];
        totalDistance += TypingDNA.mouse.getDistance(a, b);
      }

      return totalDistance;
    };

    TypingDNA.mouse.getAngle = function (xPosDelta, yPosDelta) {
      var angle = 0;
      var leftRight = xPosDelta >= 0; // 1 if left, 0 if right

      var downUp = yPosDelta < 0; // 1 if down, 0 if up

      if (leftRight) {
        if (downUp) {
          angle = 180 + Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251); // 0.01745329251 = pi/180
        } else {
          angle = 270 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
        }
      } else {
        if (downUp) {
          angle = 90 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
        } else {
          angle = Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251);
        }
      }

      return angle;
    };

    TypingDNA.mouse.recordMoveAction = function () {
      var length = TypingDNA.mouse.times.length;

      if (length < 3) {
        return;
      }

      var deltaTime = TypingDNA.mouse.times[length - 1] - TypingDNA.mouse.times[0];
      var xPosDelta = TypingDNA.mouse.xPositions[length - 1] - TypingDNA.mouse.xPositions[0];
      var yPosDelta = TypingDNA.mouse.yPositions[length - 1] - TypingDNA.mouse.yPositions[0];
      var directDistance = Math.round(TypingDNA.mouse.getDistance(xPosDelta, yPosDelta));
      var totalDistance = Math.round(TypingDNA.mouse.getTotalDistance(TypingDNA.mouse.xPositions, TypingDNA.mouse.yPositions));
      var ratioDistance = Math.round(totalDistance * 100 / directDistance);
      var speed = Math.round(directDistance * 100 / deltaTime);
      var angle = TypingDNA.mouse.getAngle(xPosDelta, yPosDelta);
      var eventType = 1;
      var arr = [eventType, deltaTime, directDistance, speed, angle, ratioDistance];

      for (i in arr) {
        if (isNaN(arr[i])) {
          return;
        }
      }

      TypingDNA.mouse.history.add(arr);
      TypingDNA.lastMouseStop = false;
    };

    TypingDNA.mouse.recordScrollAction = function () {
      var length = TypingDNA.mouse.scrollTimes.length;

      if (length < 2) {
        return;
      }

      var deltaTime = TypingDNA.mouse.scrollTimes[length - 1] - TypingDNA.mouse.scrollTimes[0];
      var directDistance = TypingDNA.mouse.scrollTopArr[length - 1] - TypingDNA.mouse.scrollTopArr[0];
      var speed = Math.round(directDistance * 100 / deltaTime);
      var eventType = 2;
      var arr = [eventType, deltaTime, directDistance, speed];

      for (i in arr) {
        if (isNaN(arr[i]) && !isFinite(arr[i])) {
          return;
        }
      }

      TypingDNA.mouse.history.add(arr);
    };

    TypingDNA.mouse.history.add = function (arr) {
      this.stack.push(arr);

      if (this.stack.length > TypingDNA.maxMouseHistoryLength) {
        this.stack.shift();
      }
    };

    TypingDNA.mouse.history.getDiagram = function () {
      var mouseDiagram = this.stack.join("|");
      return [String(TypingDNA.isMobile()) + "," + String(TypingDNA.version), mouseDiagram].join("|");
    };

    TypingDNA.mouse.clearLastMove = function () {
      TypingDNA.mouse.times = [];
      TypingDNA.mouse.xPositions = [];
      TypingDNA.mouse.yPositions = [];
    };

    TypingDNA.mouse.checkMove = function () {
      clearInterval(TypingDNA.moveInterval);

      if (TypingDNA.mouse.started == true) {
        TypingDNA.mouse.started = false;
        TypingDNA.mouse.recordMoveAction();
        TypingDNA.mouse.clearLastMove();
      }
    };

    TypingDNA.mouse.clearLastScroll = function () {
      TypingDNA.mouse.scrollTimes = [];
      TypingDNA.mouse.scrollTopArr = [];
    };

    TypingDNA.mouse.checkScroll = function () {
      clearInterval(TypingDNA.scrollInterval);

      if (TypingDNA.mouse.scrollStarted == true) {
        TypingDNA.mouse.scrollStarted = false;
        TypingDNA.mouse.recordScrollAction();
        TypingDNA.mouse.clearLastScroll();
      }
    };
    /**
     * Adds a target to the targetIds array.
     */


    TypingDNA.addTarget = function (target) {
      var targetLength = TypingDNA.targetIds.length;
      var targetFound = false;

      if (targetLength > 0) {
        for (var i = 0; i < targetLength; i++) {
          if (TypingDNA.targetIds[i] == target) {
            targetFound = true;
            break;
          }
        }

        if (!targetFound) {
          TypingDNA.targetIds.push(target);
        }
      } else {
        TypingDNA.targetIds.push(target);
      }
    };
    /**
     * Adds a target to the targetIds array.
     */


    TypingDNA.removeTarget = function (target) {
      var targetLength = TypingDNA.targetIds.length;

      if (targetLength > 0) {
        for (var i = 0; i < targetLength; i++) {
          if (TypingDNA.targetIds[i] == target) {
            var _context4;

            (0, _splice.default)(_context4 = TypingDNA.targetIds).call(_context4, i, 1);
            break;
          }
        }
      }
    };
    /**
     * Resets the history stack
     */


    TypingDNA.reset = function (all) {
      TypingDNA.history.stack = [];
      TypingDNA.history.stackDiagram = [];
      TypingDNA.clickTimes = [];
      TypingDNA.stopTimes = [];
      TypingDNA.ACInputLengths = {
        inputs: [],
        lastLength: []
      };

      if (all == true) {
        TypingDNA.mouse.history.stack = [];
      }
    };
    /**
     * Automatically called at initilization. It starts the recording of keystrokes.
     */


    TypingDNA.start = function () {
      TypingDNA.diagramRecording = true;
      return TypingDNA.recording = true;
    };
    /**
     * Ends the recording of further keystrokes. To restart recording afterwards you can
     * either call TypingDNA.start() or create a new TypingDNA object again, not recommended.
     */


    TypingDNA.stop = function () {
      TypingDNA.diagramRecording = false;
      return TypingDNA.recording = false;
    };
    /**
     * Starts the recording of mouse activity.
     */


    TypingDNA.startMouse = function () {
      return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = true;
    };
    /**
     * Stops the recording of mouse activity.
     */


    TypingDNA.stopMouse = function () {
      return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = false;
    };
    /**
     * This is the main function that outputs the typing pattern as a String
     * {type:Number, text:String, textId:Number, length: Number, targetId:String, caseSensitive:Boolean}
     * @param {Object} obj an object with the following properties
     * * * @param {String} type 0 for anytext pattern, 1 for sametext pattern (also called diagram pattern)
     * * * and 2 for extended pattern (most versatile, can replace both anytext and sametext patterns)
     * * * @param {Number} length (Optional) the length of the text in the history for which you want
     * * * the typing pattern. length is ignored when text or targetId is set (or both).
     * * * @param {String} text  (Only for type 1 and type 2) a typed string that you want the typing pattern for
     * * * @param {Number} textId (Optional, only for type 1 and type 2) a personalized id for the typed text
     * * * @param {String} targetId (Optional) specifies if pattern is obtain only from text typed in a certain target
     * * * @param {Boolean} caseSensitive (Optional, default: false) Used if you pass a text for type 1 or type 2
     * * * DEPRECATED * * * in favor of type = 2 * * *
     * * * @param {Boolean} extended (Only for type 1) specifies if full information about what was typed is produced,
     * * * including the actual key pressed, if false, only the order of pressed keys is kept (no actual content)
     * @return {String} A typing pattern in string form
     * @example var typingPattern = tdna.getTypingPattern({type=0, length=180});
     * @example var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
     * @example var typingPattern = tdna.getTypingPattern({type=2, text="example@mail.com"});
     */


    TypingDNA.getTypingPattern = function (obj) {
      if ((0, _typeof2.default)(obj) === 'object') {
        switch (obj.type) {
          case 0:
            return TypingDNA.get(obj.length, obj.targetId);
            break;

          case 1:
            var str = obj.text != undefined ? obj.text : obj.length;
            return TypingDNA.history.getDiagram(obj.extended, str, obj.textId, obj.targetId, obj.caseSensitive);
            break;

          case 2:
            var str = obj.text != undefined ? obj.text : obj.length;
            return TypingDNA.history.getDiagram(true, str, obj.textId, obj.targetId, obj.caseSensitive);
            break;

          default:
            return TypingDNA.get(obj.length);
            break;
        }
      } else {
        return TypingDNA.get();
      }
    };

    TypingDNA.getDiagram = function (str, textId) {
      return TypingDNA.history.getDiagram(false, str, textId, undefined, false);
    };

    TypingDNA.getExtendedDiagram = function (str, textId) {
      return TypingDNA.history.getDiagram(true, str, textId, undefined, false);
    };

    TypingDNA.getMouseDiagram = function () {
      return TypingDNA.mouse.history.getDiagram();
    };

    TypingDNA.get = function (length, targetId) {
      var historyTotalLength = TypingDNA.history.stack.length;

      if (length == undefined || length == 0) {
        length = TypingDNA.defaultHistoryLength;
      }

      if (length > historyTotalLength) {
        length = historyTotalLength;
      }

      var obj = {};

      var _TypingDNA$history$ge = TypingDNA.history.get(length, "", targetId);

      var _TypingDNA$history$ge2 = (0, _slicedToArray2.default)(_TypingDNA$history$ge, 2);

      obj.arr = _TypingDNA$history$ge2[0];
      targetLength = _TypingDNA$history$ge2[1];

      if (targetId != undefined && targetId != "") {
        length = targetLength;
      }

      var zl = TypingDNA.zl;
      var histRev = length;
      var histSktF = TypingDNA.math.fo(TypingDNA.history.get(length, "seek", targetId));
      var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(length, "press", targetId));
      var pressHistMean = Math.round(TypingDNA.math.avg(histPrtF));
      var seekHistMean = Math.round(TypingDNA.math.avg(histSktF));
      var pressHistSD = Math.round(TypingDNA.math.sd(histPrtF));
      var seekHistSD = Math.round(TypingDNA.math.sd(histSktF));
      var charMeanTime = seekHistMean + pressHistMean;
      var pressRatio = TypingDNA.math.rd((pressHistMean + zl) / (charMeanTime + zl), 4);
      var seekToPressRatio = TypingDNA.math.rd((1 - pressRatio) / pressRatio, 4);
      var pressSDToPressRatio = TypingDNA.math.rd((pressHistSD + zl) / (pressHistMean + zl), 4);
      var seekSDToPressRatio = TypingDNA.math.rd((seekHistSD + zl) / (pressHistMean + zl), 4);
      var cpm = Math.round(6E4 / (charMeanTime + zl));

      if (histRev == 0) {
        cpm = 0;
      }

      for (var i in obj.arr) {
        var rev = obj.arr[i][1].length;
        var seekMean = 0;
        var pressMean = 0;
        var postMean = 0;
        var seekSD = 0;
        var pressSD = 0;
        var postSD = 0;

        switch (obj.arr[i][0].length) {
          case 0:
            break;

          case 1:
            var seekMean = TypingDNA.math.rd((obj.arr[i][0][0] + zl) / (seekHistMean + zl), 4);
            break;

          default:
            var arr = TypingDNA.math.fo(obj.arr[i][0]);
            seekMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
            seekSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
        }

        switch (obj.arr[i][1].length) {
          case 0:
            break;

          case 1:
            var pressMean = TypingDNA.math.rd((obj.arr[i][1][0] + zl) / (pressHistMean + zl), 4);
            break;

          default:
            var arr = TypingDNA.math.fo(obj.arr[i][1]);
            pressMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (pressHistMean + zl), 4);
            pressSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (pressHistSD + zl), 4);
        }

        switch (obj.arr[i][2].length) {
          case 0:
            break;

          case 1:
            var postMean = TypingDNA.math.rd((obj.arr[i][2][0] + zl) / (seekHistMean + zl), 4);
            break;

          default:
            var arr = TypingDNA.math.fo(obj.arr[i][2]);
            postMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
            postSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
        }

        delete obj.arr[i][2];
        delete obj.arr[i][1];
        delete obj.arr[i][0];
        obj.arr[i][0] = rev;
        obj.arr[i][1] = seekMean;
        obj.arr[i][2] = pressMean;
        obj.arr[i][3] = postMean;
        obj.arr[i][4] = seekSD;
        obj.arr[i][5] = pressSD;
        obj.arr[i][6] = postSD;
      }

      var arr = [];
      TypingDNA.apu(arr, histRev);
      TypingDNA.apu(arr, cpm);
      TypingDNA.apu(arr, charMeanTime);
      TypingDNA.apu(arr, pressRatio);
      TypingDNA.apu(arr, seekToPressRatio);
      TypingDNA.apu(arr, pressSDToPressRatio);
      TypingDNA.apu(arr, seekSDToPressRatio);
      TypingDNA.apu(arr, pressHistMean);
      TypingDNA.apu(arr, seekHistMean);
      TypingDNA.apu(arr, pressHistSD);
      TypingDNA.apu(arr, seekHistSD);

      for (var c = 0; c <= 6; c++) {
        for (var i = 0; i < 44; i++) {
          var keyCode = TypingDNA.keyCodes[i];
          var val = obj.arr[keyCode][c];

          if (val == 0 && c > 0) {
            val = 1;
          }

          TypingDNA.apu(arr, val);
        }
      }

      TypingDNA.apu(arr, TypingDNA.isMobile());
      TypingDNA.apu(arr, TypingDNA.version);
      TypingDNA.apu(arr, (0, _flags.default)(TypingDNA));
      arr.push(TypingDNA.history.getSpecialKeys());
      return arr.join(",");
    };

    TypingDNA.apu = function (arr, val) {
      "NaN" == String(val) && (val = 0);
      arr.push(val);
    };

    TypingDNA.math = {};

    TypingDNA.math.rd = function (val, dec) {
      return Number(val.toFixed(dec));
    };

    TypingDNA.math.avg = function (arr) {
      var len = arr.length;

      if (len > 0) {
        var sum = 0;

        for (var i = 0; i < len; i++) {
          sum += arr[i];
        }

        return this.rd(sum / len, 4);
      } else {
        return 0;
      }
    };

    TypingDNA.math.sd = function (arr) {
      var len = arr.length;

      if (len < 2) {
        return 0;
      } else {
        var sumVS = 0;
        var mean = this.avg(arr);

        for (var i = 0; i < len; i++) {
          sumVS += (arr[i] - mean) * (arr[i] - mean);
        }

        var sd = Math.sqrt(sumVS / len);
        return sd;
      }
    };

    TypingDNA.math.fo = function (arr) {
      if (arr.length > 1) {
        var values = (0, _concat.default)(arr).call(arr);
        var len = arr.length;
        (0, _sort.default)(values).call(values, function (a, b) {
          return a - b;
        });
        var asd = this.sd(values);
        var aMean = values[Math.ceil(arr.length / 2)];
        var multiplier = 2;
        var maxVal = aMean + multiplier * asd;
        var minVal = aMean - multiplier * asd;

        if (len < 20) {
          minVal = 0;
        }

        var fVal = [];

        for (var i = 0; i < len; i++) {
          var tempval = values[i];

          if (tempval < maxVal && tempval > minVal) {
            fVal.push(tempval);
          }
        }

        return fVal;
      } else {
        return arr;
      }
    }; // Calculate a 32 bit FNV-1a hash


    TypingDNA.math.fnv1aHash = function (str) {
      if (str == undefined && typeof str !== 'string') {
        return 0;
      }

      str = str.toLowerCase();
      var i, l;
      var hval = 0x721b5ad4;

      for (i = 0, l = str.length; i < l; i++) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
      }

      return hval >>> 0;
    };

    TypingDNA.history = {};
    TypingDNA.history.stack = [];
    TypingDNA.history.stackDiagram = [];

    TypingDNA.history.add = function (arr) {
      this.stack.push(arr);

      if (this.stack.length > TypingDNA.maxHistoryLength) {
        this.stack.shift();
      }
    };

    TypingDNA.history.addDiagram = function (arr) {
      this.stackDiagram.push(arr);
    };

    TypingDNA.history.getDiagram = function (extended, str, textId, targetId, caseSensitive) {
      var caseSensitive = caseSensitive != undefined ? caseSensitive : str == undefined || str == "";
      var returnArr = [];
      var diagramType = extended == true ? 1 : 0;
      var stackDiagram = this.stackDiagram;

      if (targetId != undefined && targetId != "" && stackDiagram.length > 0) {
        stackDiagram = TypingDNA.sliceStackByTargetId(stackDiagram, targetId);

        if (str == undefined || str == "") {
          var element = TypingDNA.document.getElementById(targetId);

          if (element != null) {
            str = element.value;
          }
        }
      } else {
        var targetLength = TypingDNA.targetIds.length;

        if (str == undefined || str == "") {
          if (targetLength > 0) {
            str = "";

            for (var i = 0; i < targetLength; i++) {
              var element = TypingDNA.document.getElementById(TypingDNA.targetIds[i]);

              if (element != null) {
                str += element.value;
              }
            }
          } else {
            if (!extended) {
              console.log("Please use extended pattern OR provide a fixed string param OR use the addTarget method.");
            }
          }
        }
      }

      var missingCount = 0;
      var diagramHistoryLength = stackDiagram.length;
      var strLength = diagramHistoryLength;

      if (typeof str === 'string') {
        strLength = str.length;
      } else if (typeof str === 'number' && str < diagramHistoryLength) {
        strLength = str;
      }

      var returnTextId = 0;

      if (textId != undefined) {
        if (isNaN((0, _parseInt2.default)(textId))) {
          returnTextId = TypingDNA.math.fnv1aHash(textId);
        } else {
          returnTextId = (0, _parseInt2.default)(textId);
        }
      } else {
        if (typeof str === 'string') {
          returnTextId = TypingDNA.math.fnv1aHash(str);
        }
      }

      returnArr.push([TypingDNA.isMobile(), TypingDNA.version, (0, _flags.default)(TypingDNA), diagramType, strLength, returnTextId, TypingDNA.history.getSpecialKeys()]);

      if (str != undefined && str.length > 0 && typeof str === 'string') {
        var strLower = str.toLowerCase();
        var strUpper = str.toUpperCase();
        var lastFoundPos = [];
        var lastPos = 0;
        var strUpperCharCode;
        var currentSensitiveCharCode;

        for (var i = 0; i < str.length; i++) {
          var currentCharCode = str.charCodeAt(i);

          if (!caseSensitive) {
            strUpperCharCode = strUpper.charCodeAt(i);
            currentSensitiveCharCode = strUpperCharCode != currentCharCode ? strUpperCharCode : strLower.charCodeAt(i);
          }

          var startPos = lastPos;
          var finishPos = diagramHistoryLength;
          var found = false;

          while (found == false) {
            for (var j = startPos; j < finishPos; j++) {
              var arr = stackDiagram[j];
              var charCode = arr[3];

              if (charCode == currentCharCode || !caseSensitive && charCode == currentSensitiveCharCode) {
                found = true;

                if (j == lastPos) {
                  lastPos++;
                  lastFoundPos = [];
                } else {
                  lastFoundPos.push(j);
                  var len = lastFoundPos.length;

                  if (len > 1 && lastFoundPos[len - 1] == lastFoundPos[len - 2] + 1) {
                    lastPos = j + 1;
                    lastFoundPos = [];
                  }
                }

                var keyCode = arr[0];
                var seekTime = arr[1];
                var pressTime = arr[2];

                if (extended) {
                  returnArr.push([charCode, seekTime, pressTime, keyCode]);
                } else {
                  returnArr.push([seekTime, pressTime]);
                }

                break;
              }
            }

            if (found == false) {
              if (startPos != 0) {
                startPos = 0;
                finishPos = lastPos;
              } else {
                found = true;

                if (TypingDNA.replaceMissingKeys) {
                  missingCount++;

                  if ((0, _typeof2.default)(TypingDNA.savedMissingAvgValues) !== 'object' || TypingDNA.savedMissingAvgValues.historyLength != diagramHistoryLength) {
                    var histSktF = TypingDNA.math.fo(TypingDNA.history.get(0, "seek"));
                    var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(0, "press"));
                    var seekTime = Math.round(TypingDNA.math.avg(histSktF));
                    var pressTime = Math.round(TypingDNA.math.avg(histPrtF));
                    TypingDNA.savedMissingAvgValues = {
                      seekTime: seekTime,
                      pressTime: pressTime,
                      historyLength: diagramHistoryLength
                    };
                  } else {
                    var seekTime = TypingDNA.savedMissingAvgValues.seekTime;
                    var pressTime = TypingDNA.savedMissingAvgValues.pressTime;
                  }

                  var missing = 1;

                  if (extended) {
                    returnArr.push([currentCharCode, seekTime, pressTime, currentCharCode, missing]);
                  } else {
                    returnArr.push([seekTime, pressTime, missing]);
                  }

                  break;
                }
              }
            }
          }

          if (TypingDNA.replaceMissingKeysPerc < missingCount * 100 / strLength) {
            return null;
          }
        }
      } else {
        var startCount = 0;

        if (typeof str === 'number') {
          startCount = diagramHistoryLength - str;
        }

        if (startCount < 0) {
          startCount = 0;
        }

        for (var i = startCount; i < diagramHistoryLength; i++) {
          var arr = stackDiagram[i];
          var keyCode = arr[0];
          var seekTime = arr[1];
          var pressTime = arr[2];

          if (extended) {
            var charCode = arr[3];
            returnArr.push([charCode, seekTime, pressTime, keyCode]);
          } else {
            returnArr.push([seekTime, pressTime]);
          }
        }
      }

      return returnArr.join("|");
    };

    TypingDNA.sliceStackByTargetId = function (stack, targetId) {
      var length = stack.length;
      var newStack = [];

      for (i = 0; i < length; i++) {
        var arr = stack[i];

        if (arr[5] == targetId) {
          newStack.push(arr);
        }
      }

      return newStack;
    };

    TypingDNA.history.get = function (length, type, targetId) {
      var stack = this.stack;

      if (targetId != undefined && targetId != "" && stack.length > 0) {
        stack = TypingDNA.sliceStackByTargetId(stack, targetId);
      }

      var historyTotalLength = stack.length;

      if (length == 0 || length == undefined) {
        length = TypingDNA.defaultHistoryLength;
      }

      if (length > historyTotalLength) {
        length = historyTotalLength;
      }

      switch (type) {
        case "seek":
          var seekArr = [];

          for (i = 1; i <= length; i++) {
            var seekTime = stack[historyTotalLength - i][1];

            if (seekTime <= TypingDNA.maxSeekTime) {
              seekArr.push(seekTime);
            }
          }

          ;
          return seekArr;
          break;

        case "press":
          var pressArr = [];

          for (i = 1; i <= length; i++) {
            var pressTime = stack[historyTotalLength - i][2];

            if (pressTime <= TypingDNA.maxPressTime) {
              pressArr.push(pressTime);
            }
          }

          ;
          return pressArr;
          break;

        default:
          var historyStackObj = {};

          for (var i in TypingDNA.keyCodes) {
            historyStackObj[TypingDNA.keyCodes[i]] = [[], [], []];
          }

          for (i = 1; i <= length; i++) {
            var arr = stack[historyTotalLength - i];
            var keyCode = arr[0];
            var seekTime = arr[1];
            var pressTime = arr[2];
            var prevKeyCode = arr[3];

            if (TypingDNA.keyCodesObj[keyCode]) {
              if (seekTime <= TypingDNA.maxSeekTime) {
                historyStackObj[keyCode][0].push(seekTime);

                if (prevKeyCode != 0 && TypingDNA.keyCodesObj[prevKeyCode]) {
                  historyStackObj[prevKeyCode][2].push(seekTime);
                }
              }

              if (pressTime <= TypingDNA.maxPressTime) {
                historyStackObj[keyCode][1].push(pressTime);
              }
            }
          }

          ;
          return [historyStackObj, length];
      }
    };

    TypingDNA.history.getSpecialKeys = function () {
      var returnArr = [];
      var length = this.stack.length;
      var historyStackObj = {};

      for (var i in TypingDNA.spKeyCodes) {
        historyStackObj[TypingDNA.spKeyCodes[i]] = [[]];
      }

      for (i = 1; i <= length; i++) {
        var arr = this.stack[length - i];

        if (TypingDNA.spKeyCodesObj[arr[0]]) {
          var keyCode = arr[0];
          var pressTime = arr[2];

          if (pressTime <= TypingDNA.maxPressTime) {
            historyStackObj[keyCode][0].push(pressTime);
          }
        }
      }

      for (var i in TypingDNA.spKeyCodes) {
        var arr = TypingDNA.math.fo(historyStackObj[TypingDNA.spKeyCodes[i]][0]);
        var arrLen = arr.length;
        returnArr.push(arrLen);

        if (arrLen > 1) {
          returnArr.push(Math.round(TypingDNA.math.avg(arr)));
          returnArr.push(Math.round(TypingDNA.math.sd(arr)));
        } else if (arrLen == 1) {
          returnArr.push([arr[0], -1]);
        } else {
          returnArr.push([-1, -1]);
        }
      }

      var clicksArrLen = TypingDNA.clickTimes.length;
      returnArr.push(clicksArrLen);

      if (clicksArrLen > 1) {
        returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.clickTimes)));
        returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.clickTimes)));
      } else if (clicksArrLen == 1) {
        returnArr.push(TypingDNA.clickTimes[0], -1);
      } else {
        returnArr.push([-1, -1]);
      }

      var stopArrLen = TypingDNA.stopTimes.length;
      returnArr.push(stopArrLen);

      if (stopArrLen > 1) {
        returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.stopTimes)));
        returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.stopTimes)));
      } else if (stopArrLen == 1) {
        returnArr.push(TypingDNA.stopTimes[0], -1);
      } else {
        returnArr.push([-1, -1]);
      }

      return returnArr;
    };
    /**
     * Checks the quality of a typing pattern, how well it is revelated, how useful the
     * information will be for matching applications. It returns a value between 0 and 1.
     * Values over 0.3 are acceptable, however a value over 0.7 shows good pattern strength.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A close to 1 value means a stronger pattern.
     * @example var quality = tdna.getQuality(typingPattern);
     */


    TypingDNA.getQuality = function (typingPattern) {
      var obj = typingPattern.split(",");

      for (i = 0; i < obj.length; i++) {
        obj[i] = Number(obj[i]);
      }

      var totalEvents = obj[0];
      var acc = rec = avgAcc = 0;
      var avg = TypingDNA.math.avg(obj);
      var revs = (0, _slice.default)(obj).call(obj, 11, 55);

      for (var i in revs) {
        rec += Number(revs[i] > 0);
        acc += Number(revs[i] > 4);
        avgAcc += Number(revs[i] > avg);
      }

      var tReturn = Math.sqrt(rec * acc * avgAcc) / 80;
      return tReturn > 1 ? 1 : tReturn;
    };
    /**
     * Checks the validity of a typing pattern if recorded on mobile.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A number larger than 0.7 usually means a valid pattern.
     * @example var quality = tdna.checkMobileValidity(typingPattern);
     */


    TypingDNA.checkMobileValidity = function (typingPattern) {
      var obj = typingPattern.split(",");
      var totalEvents = obj[0];

      if (totalEvents == 0) {
        return 0;
      }

      var rec = 0;
      var revs = (0, _slice.default)(obj).call(obj, 11, 55);

      for (var i in revs) {
        rec += Number(revs[i]);
      }

      return rec / totalEvents;
    };

    TypingDNA.getLength = function (typingPattern) {
      return Number(typingPattern.split(",")[1]);
    };

    TypingDNA.isMobile = function () {
      if (TypingDNA.mobile != undefined) {
        return TypingDNA.mobile;
      } else {
        var check = 0;

        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = 1;
          }
        })(navigator.userAgent || navigator.vendor || window.opera);

        TypingDNA.mobile = check;
        return check;
      }
    };

    TypingDNA.getTextId = function (str) {
      return TypingDNA.math.fnv1aHash(str);
    };
  } else {
    // TypingDNA is a static class, currently doesn't support actual multiple instances (Singleton implementation)
    return TypingDNA.instance;
  }
};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1175);

module.exports = parent;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var sort = __webpack_require__(1176);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.sort;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.sort) ? sort : own;
};


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1177);
var entryVirtual = __webpack_require__(29);

module.exports = entryVirtual('Array').sort;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var aFunction = __webpack_require__(84);
var toObject = __webpack_require__(75);
var fails = __webpack_require__(28);
var arrayMethodIsStrict = __webpack_require__(135);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD;

// `Array.prototype.sort` method
// https://tc39.github.io/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<li><a href=\"#\" data-se=\"unlock\" class=\"link js-unlock\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "unlockaccount"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 440
          },
          "end": {
            "line": 1,
            "column": 484
          }
        }
      })) + "</a></li>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<li><a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 539
          },
          "end": {
            "line": 1,
            "column": 547
          }
        }
      }) : helper)) + "\" class=\"link js-custom\" rel=\"noopener noreferrer\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "target") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 598
          },
          "end": {
            "line": 1,
            "column": 638
          }
        }
      })) != null ? stack1 : "") + ">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 639
          },
          "end": {
            "line": 1,
            "column": 647
          }
        }
      }) : helper)) + "</a></li>";
    },
    "4": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "target=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "target") || (depth0 != null ? lookupProperty(depth0, "target") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "target",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 620
          },
          "end": {
            "line": 1,
            "column": 630
          }
        }
      }) : helper)) + "\"";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" data-se=\"needhelp\" aria-expanded=\"false\" aria-controls=\"help-links-container\" class=\"link help js-help\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "needhelp"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 116
          },
          "end": {
            "line": 1,
            "column": 155
          }
        }
      })) + "</a><ul class=\"help-links js-help-links\" id=\"help-links-container\"><li><a href=\"#\" data-se=\"forgot-password\" class=\"link js-forgot-password\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "forgotpassword"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 296
          },
          "end": {
            "line": 1,
            "column": 341
          }
        }
      })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "features") : depth0) != null ? lookupProperty(stack1, "selfServiceUnlock") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 350
          },
          "end": {
            "line": 1,
            "column": 500
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "each").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "helpLinks") : depth0) != null ? lookupProperty(stack1, "custom") : stack1, {
        "name": "each",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 500
          },
          "end": {
            "line": 1,
            "column": 665
          }
        }
      })) != null ? stack1 : "") + "<li><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "helpLinkUrl") || (depth0 != null ? lookupProperty(depth0, "helpLinkUrl") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "helpLinkUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 678
          },
          "end": {
            "line": 1,
            "column": 693
          }
        }
      }) : helper)) + "\" data-se=\"help-link\" class=\"link js-help-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "help"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 783
          },
          "end": {
            "line": 1,
            "column": 818
          }
        }
      })) + "</a></li></ul>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  initialize: function initialize() {
    this.listenTo(this.state, 'change:enabled', function (model, enable) {
      this.$('.link').toggleClass('o-form-disabled', !enable);
    });
  },
  getTemplateData: function getTemplateData() {
    var helpLinkUrl;
    var customHelpPage = this.settings.get('helpLinks.help');

    if (customHelpPage) {
      helpLinkUrl = customHelpPage;
    } else {
      helpLinkUrl = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var helper,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "baseUrl",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 11
              }
            }
          }) : helper)) + "/help/login";
        },
        "useData": true
      })({
        baseUrl: this.settings.get('baseUrl')
      });
    }

    return _okta._.extend(this.settings.toJSON({
      verbose: true
    }), {
      helpLinkUrl: helpLinkUrl
    });
  },
  postRender: function postRender() {
    this.$('.js-help-links').hide();
  },
  toggleLinks: function toggleLinks(e) {
    var _this = this;

    e.preventDefault();
    this.$('.js-help-links').slideToggle(200, function () {
      _this.$('.js-help').attr('aria-expanded', _this.$('.js-help-links').is(':visible'));
    });
  },
  events: {
    'click .js-help': function clickJsHelp(e) {
      e.preventDefault();

      if (!this.state.get('enabled')) {
        return;
      }

      this.toggleLinks(e);
    },
    'click .js-forgot-password': function clickJsForgotPassword(e) {
      e.preventDefault();

      if (!this.state.get('enabled')) {
        return;
      }

      var customResetPasswordPage = this.settings.get('helpLinks.forgotPassword');

      if (customResetPasswordPage) {
        Util.redirect(customResetPasswordPage);
      } else {
        this.options.appState.trigger('navigate', 'signin/forgot-password');
      }
    },
    'click .js-unlock': function clickJsUnlock(e) {
      e.preventDefault();

      if (!this.state.get('enabled')) {
        return;
      }

      var customUnlockPage = this.settings.get('helpLinks.unlock');

      if (customUnlockPage) {
        Util.redirect(customUnlockPage);
      } else {
        this.options.appState.trigger('navigate', 'signin/unlock');
      }
    }
  }
});

exports.default = _default;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2016-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"content-container\"><span class=\"registration-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 73
          }
        }
      }) : helper)) + "</span><a title=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 90
          },
          "end": {
            "line": 1,
            "column": 98
          }
        }
      }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 112
          },
          "end": {
            "line": 1,
            "column": 120
          }
        }
      }) : helper)) + "\" class=\"registration-link\" href=\"#\">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 157
          },
          "end": {
            "line": 1,
            "column": 165
          }
        }
      }) : helper)) + "</a></div>";
    },
    "useData": true
  }),
  className: 'registration-container',
  events: {
    'click a.registration-link': 'handleClickEvent'
  },
  handleClickEvent: function handleClickEvent(e) {
    e.preventDefault();
    var clickHandler = this.settings.get('registration.click');

    if (clickHandler) {
      clickHandler();
    } else if (this.options.appState.get('isIdxStateToken')) {
      this.options.appState.trigger('navigate', 'signin/enroll-user');
    } else {
      this.options.appState.trigger('navigate', 'signin/register');
    }
  },
  getTemplateData: function getTemplateData() {
    var templateData = {
      label: (0, _okta.loc)('registration.signup.label', 'login'),
      text: (0, _okta.loc)('registration.signup.text', 'login')
    };
    return templateData;
  }
});

exports.default = _default;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _PrimaryAuth = _interopRequireDefault(__webpack_require__(329));

var _CookieUtil = _interopRequireDefault(__webpack_require__(245));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Util = _interopRequireDefault(__webpack_require__(31));

/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _PrimaryAuth.default.extend({
  props: function props() {
    var cookieUsername = _CookieUtil.default.getCookieUsername();

    var properties = this.getUsernameAndRemember(cookieUsername);
    return {
      username: ['string', true, properties.username],
      lastUsername: ['string', false, cookieUsername],
      context: ['object', false],
      remember: ['boolean', true, properties.remember]
    };
  },
  local: {},
  save: function save() {
    var _this = this;

    var username = this.settings.transformUsername(this.get('username'), _Enums.default.IDP_DISCOVERY);
    var remember = this.get('remember');
    var lastUsername = this.get('lastUsername');
    var resource = 'okta:acct:' + username;
    var requestContext = this.get('requestContext');
    this.setUsernameCookie(username, remember, lastUsername); //the 'save' event here is triggered and used in the BaseLoginController
    //to disable the primary button

    this.trigger('save');
    this.appState.trigger('loading', true);
    var webfingerArgs = {
      resource: resource,
      requestContext: requestContext
    };
    var authClient = this.appState.settings.authClient;
    authClient.webfinger(webfingerArgs).then(function (res) {
      if (res && res.links && res.links[0]) {
        if (res.links[0].properties['okta:idp:type'] === 'OKTA') {
          _this.trigger('goToPrimaryAuth');
        } else if (res.links[0].href) {
          var _context, _context2;

          var redirectFn = (0, _includes.default)(_context = res.links[0].href).call(_context, 'OKTA_INVALID_SESSION_REPOST%3Dtrue') ? (0, _bind.default)(_context2 = _Util.default.redirectWithFormGet).call(_context2, _Util.default) : _this.settings.get('redirectUtilFn'); //override redirectFn to only use Util.redirectWithFormGet if OKTA_INVALID_SESSION_REPOST is included
          //it will be encoded since it will be included in the encoded fromURI

          redirectFn(res.links[0].href);
        }
      }
    }).catch(function () {
      _this.trigger('error'); // Specific event handled by the Header for the case where the security image is not
      // enabled and we want to show a spinner. (Triggered only here and handled only by Header).


      _this.appState.trigger('removeLoading');

      _CookieUtil.default.removeUsernameCookie();
    }).finally(function () {
      _this.appState.trigger('loading', false);
    });
  }
});

exports.default = _default;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _okta = __webpack_require__(2);

var _PrimaryAuthForm = _interopRequireDefault(__webpack_require__(544));

/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _PrimaryAuthForm.default.extend({
  className: 'idp-discovery-form',
  save: function save() {
    return (0, _okta.loc)('oform.next', 'login');
  },
  saveId: 'idp-discovery-submit',
  initialize: function initialize() {
    this.listenTo(this, 'save', (0, _bind.default)(_okta._).call(_okta._, this.model.save, this.model));
    this.stateEnableChange();
  },
  inputs: function inputs() {
    var inputs = [];
    var usernameProps = {
      className: 'margin-btm-30',
      label: (0, _okta.loc)('primaryauth.username.placeholder', 'login'),
      inputId: 'idp-discovery-username',
      disabled: false
    };
    inputs.push(_okta._.extend(this.getUsernameField(), usernameProps));

    if (this.settings.get('features.rememberMe')) {
      inputs.push(this.getRemeberMeCheckbox());
    }

    return inputs;
  },
  focus: function focus() {
    if (!this.model.get('username')) {
      this.getInputs().first().focus();
    } else if (this.getInputs().toArray()[1]) {
      this.getInputs().toArray()[1].focus();
    }
  }
});

exports.default = _default;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _CountryUtil = _interopRequireDefault(__webpack_require__(157));

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

var _ManualSetupPushFooter = _interopRequireDefault(__webpack_require__(1183));

var _PhoneTextBox = _interopRequireDefault(__webpack_require__(533));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function goToFactorActivation(view, step) {
  var url = _RouterUtil.default.createActivateFactorUrl(view.options.appState.get('activatedFactorProvider'), view.options.appState.get('activatedFactorType'), step);

  view.options.appState.trigger('navigate', url);
}

function setStateValues(view) {
  var userPhoneNumber;
  var userCountryCode;

  if (view.model.get('activationType') === 'SMS') {
    userCountryCode = view.model.get('countryCode');
    userPhoneNumber = view.model.get('phoneNumber');
  }

  view.options.appState.set({
    factorActivationType: view.model.get('activationType'),
    userCountryCode: userCountryCode,
    userPhoneNumber: userPhoneNumber
  });
}

function enrollFactor(view, factorType) {
  return view.model.doTransaction(function (transaction) {
    return transaction.prev().then(function (trans) {
      var factor = _okta._.findWhere(trans.factors, {
        factorType: factorType,
        provider: 'OKTA'
      });

      return factor.enroll();
    }).then(function (trans) {
      var textActivationLinkUrl;
      var emailActivationLinkUrl;
      var sharedSecret;
      var res = trans.data;

      if (res && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.activation) {
        var factor = res._embedded.factor; // Shared secret

        sharedSecret = factor._embedded.activation.sharedSecret;

        if (factor._embedded.activation._links && factor._embedded.activation._links.send) {
          var activationSendLinks = factor._embedded.activation._links.send;

          var smsItem = _okta._.findWhere(activationSendLinks, {
            name: 'sms'
          }); // SMS activation url


          textActivationLinkUrl = smsItem ? smsItem.href : null; // Email activation url

          var emailItem = _okta._.findWhere(activationSendLinks, {
            name: 'email'
          });

          emailActivationLinkUrl = emailItem ? emailItem.href : null;
        }
      }

      view.model.set({
        SMS: textActivationLinkUrl,
        EMAIL: emailActivationLinkUrl,
        sharedSecret: sharedSecret
      });
      return trans;
    });
  });
}

var _default = _FormController.default.extend({
  className: 'enroll-manual-push',
  Model: function Model() {
    return {
      local: {
        activationType: ['string', true, this.options.appState.get('factorActivationType') || 'SMS'],
        countryCode: ['string', false, this.options.appState.get('userCountryCode')],
        phoneNumber: 'string',
        SMS: ['string', false, this.options.appState.get('textActivationLinkUrl')],
        EMAIL: ['string', false, this.options.appState.get('emailActivationLinkUrl')],
        sharedSecret: ['string', false, this.options.appState.get('sharedSecret')],
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function fn(countryCode) {
            return '+' + _CountryUtil.default.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function fn(countryCallingCode, phoneNumber) {
            return countryCallingCode + phoneNumber;
          }
        }
      }
    };
  },
  Form: {
    title: function title() {
      var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

      return (0, _okta.loc)('enroll.totp.title', 'login', [factorName]);
    },
    subtitle: _okta._.partial(_okta.loc, 'enroll.totp.cannotScanBarcode', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'step-manual-setup'
    },
    formChildren: function formChildren() {
      var _this = this;

      var instructions = this.settings.get('brandName') ? (0, _okta.loc)('enroll.totp.sharedSecretInstructions.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('enroll.totp.sharedSecretInstructions.generic', 'login');
      var children = [_FormType.default.Input({
        name: 'activationType',
        type: 'select',
        wide: true,
        options: {
          SMS: (0, _okta.loc)('enroll.totp.sendSms', 'login'),
          EMAIL: (0, _okta.loc)('enroll.totp.sendEmail', 'login'),
          MANUAL: (0, _okta.loc)('enroll.totp.setupManually', 'login')
        }
      }), _FormType.default.Input({
        name: 'countryCode',
        type: 'select',
        wide: true,
        options: _CountryUtil.default.getCountries(),
        showWhen: {
          activationType: 'SMS'
        }
      }), _FormType.default.Input({
        label: (0, _okta.loc)('mfa.phoneNumber.placeholder', 'login'),
        'label-top': true,
        className: 'enroll-sms-phone',
        name: 'phoneNumber',
        input: _PhoneTextBox.default,
        type: 'text',
        showWhen: {
          activationType: 'SMS'
        }
      }), _FormType.default.View({
        View: _okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<p class=\"okta-form-subtitle o-form-explain text-align-c\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "instructions",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 58
                  },
                  "end": {
                    "line": 1,
                    "column": 74
                  }
                }
              }) : helper)) + "</p>";
            },
            "useData": true
          }),
          getTemplateData: function getTemplateData() {
            return {
              instructions: instructions
            };
          }
        }),
        showWhen: {
          activationType: 'MANUAL'
        }
      }), _FormType.default.Input({
        name: 'sharedSecret',
        input: _TextBox.default,
        type: 'text',
        disabled: true,
        showWhen: {
          activationType: 'MANUAL'
        },
        initialize: function initialize() {
          this.listenTo(this.model, 'change:sharedSecret', this.render);
        }
      }), _FormType.default.View({
        View: _okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              return "<div data-type=\"next-button-wrap\"></div>";
            },
            "useData": true
          })
        }),
        showWhen: {
          activationType: 'MANUAL'
        }
      }), _FormType.default.Button({
        title: (0, _okta.loc)('oform.next', 'login'),
        className: 'button button-primary button-wide button-next',
        attributes: {
          'data-se': 'next-button'
        },
        click: function click() {
          setStateValues(_this);
          goToFactorActivation(_this, 'passcode');
        }
      }, '[data-type="next-button-wrap"]'), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _okta.loc)('oform.send', 'login'),
        showWhen: {
          activationType: function activationType(val) {
            return val === 'SMS' || val === 'EMAIL';
          }
        }
      })];
      return children;
    }
  },
  Footer: _ManualSetupPushFooter.default,
  initialize: function initialize() {
    this.setInitialModel(); // Move this logic to a model when AuthClient supports sending email and sms

    this.listenTo(this.form, 'save', function () {
      var self = this;
      this.model.doTransaction(function (transaction) {
        var activationType = this.get('activationType').toLowerCase();
        var opts = {};

        if (activationType === 'sms') {
          opts.profile = {
            phoneNumber: this.get('fullPhoneNumber')
          };
        }

        return transaction.factor.activation.send(activationType, opts).then(function (trans) {
          setStateValues(self); // Note: Need to defer because OktaAuth calls our router success
          // handler on the next tick - if we immediately called, appState would
          // still be populated with the last response

          _okta._.defer(function () {
            goToFactorActivation(self, 'sent');
          });

          return trans;
        });
      });
    });
    this.listenTo(this.model, 'change:activationType', function (model, value) {
      this.form.clearErrors();

      if (value === 'MANUAL' && this.options.appState.get('activatedFactorType') !== 'token:software:totp') {
        enrollFactor(this, 'token:software:totp');
      } else if (this.options.appState.get('activatedFactorType') !== 'push') {
        enrollFactor(this, 'push');
      }
    });
  },
  setInitialModel: function setInitialModel() {
    if (this.options.appState.get('factorActivationType') === 'SMS') {
      this.model.set({
        countryCode: this.options.appState.get('userCountryCode') || 'US',
        phoneNumber: this.options.appState.get('userPhoneNumber')
      });
    }
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaEnrollActivate') || this.options.appState.get('isMfaEnroll')) {
      return true;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function goToFactorActivation(appState) {
  var url = _RouterUtil.default.createActivateFactorUrl(appState.get('activatedFactorProvider'), appState.get('activatedFactorType'));

  appState.trigger('navigate', url);
}

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.backToFactors"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 106
          }
        }
      })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.scanBarcode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 173
          },
          "end": {
            "line": 1,
            "column": 219
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.back();
    },
    'click .js-goto': function clickJsGoto(e) {
      e.preventDefault();

      var goToFactor = _okta._.partial(goToFactorActivation, this.options.appState);

      this.options.appState.unset('factorActivationType');
      this.model.doTransaction(function (transaction) {
        return transaction.prev().then(function (trans) {
          var factor = _okta._.findWhere(trans.factors, {
            factorType: 'push',
            provider: 'OKTA'
          });

          return factor.enroll();
        });
      }).then(goToFactor);
    }
  },
  back: function back() {
    var self = this;
    self.options.appState.unset('factorActivationType');

    if (self.options.appState.get('prevLink')) {
      this.model.doTransaction(function (transaction) {
        return transaction.prev();
      }).then(function () {
        // we trap 'MFA_ENROLL' response that's why we need to trigger navigation from here
        self.options.appState.trigger('navigate', 'signin/enroll');
      });
    } else {
      self.options.appState.trigger('navigate', 'signin/enroll');
    }
  }
});

exports.default = _default;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

var _ManualSetupFooter = _interopRequireDefault(__webpack_require__(1185));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-manual-totp',
  Model: function Model() {
    return {
      local: {
        sharedSecret: ['string', false, this.options.appState.get('sharedSecret')],
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function title() {
      var factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));

      return (0, _okta.loc)('enroll.totp.title', 'login', [factorName]);
    },
    subtitle: _okta._.partial(_okta.loc, 'enroll.totp.cannotScanBarcode', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'step-manual-setup'
    },
    formChildren: function formChildren() {
      var instructions = this.settings.get('brandName') ? (0, _okta.loc)('enroll.totp.manualSetupInstructions.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('enroll.totp.manualSetupInstructions.generic', 'login');
      return [_FormType.default.View({
        View: _okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<p class=\"okta-form-subtitle o-form-explain text-align-c\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "instructions",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 58
                  },
                  "end": {
                    "line": 1,
                    "column": 74
                  }
                }
              }) : helper)) + "</p>";
            },
            "useData": true
          }),
          getTemplateData: function getTemplateData() {
            return {
              instructions: instructions
            };
          }
        })
      }), _FormType.default.Input({
        name: 'sharedSecret',
        input: _TextBox.default,
        type: 'text',
        disabled: true
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _okta.loc)('oform.next', 'login')
      })];
    }
  },
  Footer: _ManualSetupFooter.default,
  initialize: function initialize() {
    this.listenTo(this.form, 'save', function () {
      var url = _RouterUtil.default.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');

      this.options.appState.trigger('navigate', url);
    });
  }
});

exports.default = _default;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.backToFactors"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 106
          }
        }
      })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.scanBarcode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 173
          },
          "end": {
            "line": 1,
            "column": 219
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.back();
    },
    'click .js-goto': function clickJsGoto(e) {
      e.preventDefault(); // go to a different screen with current auth status:
      // refresh the latest response

      this.model.startTransaction(function (authClient) {
        return authClient.tx.resume();
      });
    }
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);

    if (this.options.appState.get('prevLink')) {
      // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
      // correct state. Fortunately, this means that the router will
      // handle navigation once the request is finished.
      this.model.doTransaction(function (transaction) {
        return transaction.prev();
      });
    } else {
      this.options.appState.trigger('navigate', 'signin/enroll');
    }
  }
});

exports.default = _default;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseLoginController = _interopRequireDefault(__webpack_require__(156));

var _EmailMagicLinkForm = _interopRequireDefault(__webpack_require__(1187));

var _InlineTOTPForm = _interopRequireDefault(__webpack_require__(1188));

var _PassCodeForm = _interopRequireDefault(__webpack_require__(1189));

var _PasswordForm = _interopRequireDefault(__webpack_require__(1190));

var _PushForm = _interopRequireDefault(__webpack_require__(1191));

var _SecurityQuestionForm = _interopRequireDefault(__webpack_require__(1193));

var _SendEmailAndVerifyCodeForm = _interopRequireDefault(__webpack_require__(1194));

var _TOTPForm = _interopRequireDefault(__webpack_require__(1195));

var _YubikeyForm = _interopRequireDefault(__webpack_require__(1196));

var _FooterMFA = _interopRequireDefault(__webpack_require__(159));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 21] max-statements: [2, 25] max-params: 0 */
var CheckBox = _okta.internal.views.forms.inputs.CheckBox;

var _default = _BaseLoginController.default.extend({
  className: 'mfa-verify',
  initialize: function initialize(options) {
    var factorType = options.factorType;
    var View;

    switch (factorType) {
      case 'question':
        View = _SecurityQuestionForm.default;
        break;

      case 'email':
        if (this.options.appState.get('isIdxStateToken')) {
          View = _EmailMagicLinkForm.default;
        } else {
          View = _SendEmailAndVerifyCodeForm.default;
        }

        break;

      case 'sms':
      case 'call':
        View = _PassCodeForm.default;
        break;

      case 'token':
      case 'token:software:totp':
      case 'token:hotp':
        View = _TOTPForm.default;
        break;

      case 'token:hardware':
        View = _YubikeyForm.default;
        break;

      case 'push':
        View = _PushForm.default;
        break;

      case 'password':
        View = _PasswordForm.default;
        break;

      default:
        throw new Error('Unrecognized factor type');
    }

    this.model = this.findModel(factorType, options);

    if (!this.model) {
      // TODO: recover from this more gracefully - probably to redirect
      // to default factor
      throw new Error('Unrecognized factor/provider');
    }

    this.addListeners();
    this.add(new View(this.toJSON())); // If Okta Verify Push and Okta Verify totp are both enabled,
    // then we show Push first, and totp is the "backup" factor,
    // which is rendered in an additional InlineTOTPForm

    if (factorType === 'push' && this.model.get('isOktaFactor')) {
      if (this.model.get('backupFactor')) {
        this.inlineTotpForm = this.add(_InlineTOTPForm.default, {
          options: {
            model: this.model.get('backupFactor')
          }
        }).last();
      }

      if (this.settings.get('features.autoPush')) {
        this.autoPushCheckBox = this.add(CheckBox, {
          options: {
            model: this.model,
            name: 'autoPush',
            placeholder: (0, _okta.loc)('autoPush', 'login'),
            label: false,
            'label-top': false,
            className: 'margin-btm-0'
          }
        }).last();
      } // Remember Device checkbox resides outside of the Push and TOTP forms.


      if (this.options.appState.get('allowRememberDevice')) {
        this.rememberDeviceCheckbox = this.add(CheckBox, {
          options: {
            model: this.model,
            name: 'rememberDevice',
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            label: false,
            'label-top': true,
            className: 'margin-btm-0'
          }
        }).last();
      } // Set rememberDevice on the backup factor (totp) if available


      if (this.model.get('backupFactor')) {
        this.listenTo(this.model, 'change:rememberDevice', function (model, rememberDevice) {
          model.get('backupFactor').set('rememberDevice', rememberDevice);
        });
      }
    }

    this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (state, isWaitingForNumberChallenge) {
      if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
        this.autoPushCheckBox && this.autoPushCheckBox.$el.hide();
        this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide();
        this.inlineTotpForm && this.inlineTotpForm.$el.hide();
      } else {
        this.autoPushCheckBox && this.autoPushCheckBox.$el.show();
        this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show();
        this.inlineTotpForm && this.inlineTotpForm.$el.show();
      }
    });
    this.add(new _FooterMFA.default(this.toJSON()));
  },
  findModel: function findModel(factorType, options) {
    var factors = options.appState.get('factors');
    var provider = options.provider;
    var factorIndex = options.factorIndex;

    if (!provider) {
      return factors.findWhere({
        factorType: factorType,
        isFactorTypeVerification: true
      });
    } else if (factors.hasMultipleFactorsOfSameType(factorType) && factorIndex) {
      return factors.getFactorByTypeAndIndex(factorType, factorIndex);
    } else {
      return factors.findWhere({
        provider: provider,
        factorType: factorType
      });
    }
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaRequired') && this.options.appState.get('trapMfaRequiredResponse') || this.options.appState.get('isMfaChallenge')) {
      this.options.appState.set('trapMfaRequiredResponse', false);
      return true;
    }

    return false;
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  }
});

exports.default = _default;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

var _Enums = _interopRequireDefault(__webpack_require__(10));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 7] */
var _default = _okta.Form.extend({
  layout: 'o-form-theme',
  className: 'factor-verify-magiclink',
  autoSave: true,
  noCancelButton: true,
  initialize: function initialize() {
    var form = this; // for FACTOR_REQUIRED with email magic link we dont need to show otp code input field and verify button

    this.title = this.model.get('factorLabel'); //TODO: OKTA-211618 Temp fix for demo. FACTOR_REQUIRED after sign up is missing the profile object in API response

    var email = this.model.get('email') || this.options.appState.get('lastAuthResponse')._embedded.user.profile.login;

    this.subtitle = '(' + email + ')';
    this.add((0, _okta.createButton)({
      attributes: {
        'data-se': 'email-send-code'
      },
      className: 'button email-request-button',
      title: (0, _okta.loc)('mfa.sendEmail', 'login'),
      click: function click() {
        var _this = this;

        form.clearErrors();
        this.disable();
        this.options.title = (0, _okta.loc)('mfa.sent', 'login');
        this.render();
        this.model.save().then(function () {
          return _q.default.delay(_Enums.default.API_RATE_LIMIT);
        }).then(function () {
          _this.options.title = (0, _okta.loc)('mfa.resendEmail', 'login');

          _this.enable();

          _this.render();
        });
      }
    }));
  }
});

exports.default = _default;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function addInlineTotp(form) {
  form.addDivider();
  form.addInput({
    label: (0, _okta.loc)('mfa.challenge.enterCode.placeholder', 'login'),
    'label-top': true,
    className: 'o-form-fieldset o-form-label-top inline-input auth-passcode',
    name: 'answer',
    input: _TextBox.default,
    type: 'tel'
  });
  form.add((0, _okta.createButton)({
    attributes: {
      'data-se': 'inline-totp-verify'
    },
    className: 'button inline-totp-verify margin-top-30',
    title: (0, _okta.loc)('mfa.challenge.verify', 'login'),
    click: function click() {
      form.clearErrors();

      if (!form.isValid()) {
        return;
      }

      form.model.manageTransaction(function (transaction, setTransaction) {
        // This is the case where we enter the TOTP code and verify while there is an
        // active Push request (or polling) running. We need to invoke previous() on authClient
        // and then call model.save(). If not, we would still be in MFA_CHALLENGE state and
        // verify would result in a wrong request (push verify instead of a TOTP verify).
        if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
          form.options.appState.set('trapMfaRequiredResponse', true);
          return transaction.prev().then(function (trans) {
            setTransaction(trans);
            form.model.save();
          });
        } else {
          // Push is not active and we enter the code to verify.
          form.model.save();
        }
      });
    }
  }));
  form.at(1).focus();
}

var _default = _okta.Form.extend({
  autoSave: true,
  noButtonBar: true,
  scrollOnError: false,
  layout: 'o-form-theme',
  className: 'mfa-verify-totp-inline',
  attributes: {
    'data-se': 'factor-inline-totp'
  },
  initialize: function initialize() {
    var form = this;
    this.listenTo(this.model, 'error', function () {
      this.clearErrors();
    });
    this.add((0, _okta.createButton)({
      className: 'link',
      attributes: {
        'data-se': 'inline-totp-add'
      },
      title: (0, _okta.loc)('mfa.challenge.orEnterCode', 'login'),
      click: function click() {
        this.remove();
        addInlineTotp(form);
      }
    }));
  }
});

exports.default = _default;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 7] */
var subtitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "(" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 1
        },
        "end": {
          "line": 1,
          "column": 13
        }
      }
    }) : helper)) + ")";
  },
  "useData": true
});

var PassCodeFormwarningTemplate = _okta.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
  attributes: {
    'aria-live': 'polite'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) != null ? stack1 : "") + "</p>";
    },
    "useData": true
  })
});

function getFormAndButtonDetails(factorType) {
  switch (factorType) {
    case 'sms':
      return {
        buttonDataSe: 'sms-send-code',
        buttonClassName: 'sms-request-button',
        formSubmit: (0, _okta.loc)('mfa.sendCode', 'login'),
        formRetry: (0, _okta.loc)('mfa.resendCode', 'login'),
        formSubmitted: (0, _okta.loc)('mfa.sent', 'login'),
        subtitle: subtitleTpl({
          subtitle: this.model.get('phoneNumber')
        }),
        warning: (0, _okta.loc)('factor.sms.time.warning', 'login')
      };

    case 'call':
      return {
        buttonDataSe: 'make-call',
        buttonClassName: 'call-request-button',
        formSubmit: (0, _okta.loc)('mfa.call', 'login'),
        formRetry: (0, _okta.loc)('mfa.redial', 'login'),
        formSubmitted: (0, _okta.loc)('mfa.calling', 'login'),
        subtitle: subtitleTpl({
          subtitle: this.model.get('phoneNumber')
        }),
        warning: (0, _okta.loc)('factor.call.time.warning', 'login')
      };

    case 'email':
      return {
        buttonDataSe: 'email-send-code',
        buttonClassName: 'email-request-button',
        formSubmit: (0, _okta.loc)('mfa.sendEmail', 'login'),
        formRetry: (0, _okta.loc)('mfa.resendEmail', 'login'),
        formSubmitted: (0, _okta.loc)('mfa.sent', 'login'),
        subtitle: subtitleTpl({
          subtitle: this.model.get('email')
        })
      };

    default:
      return {
        buttonDataSe: '',
        buttonClassName: '',
        formSubmit: '',
        formRetry: '',
        formSubmitted: ''
      };
  }
}

var _default = _okta.Form.extend({
  className: 'mfa-verify-passcode',
  autoSave: true,
  noCancelButton: true,
  save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  disableSubmitButton: function disableSubmitButton() {
    return this.model.appState.get('isMfaChallenge') && this.model.get('answer');
  },
  showWarning: function showWarning(msg) {
    this.clearWarnings();
    this.add(PassCodeFormwarningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarnings: function clearWarnings() {
    this.$('.okta-form-infobox-warning').remove();
  },
  initialize: function initialize() {
    var form = this;
    this.title = this.model.get('factorLabel');
    var factorType = this.model.get('factorType');
    var formAndButtonDetails = getFormAndButtonDetails.call(this, factorType);
    var warningDetails = formAndButtonDetails.warning;
    this.$el.attr('data-se', 'factor-' + factorType);
    this.subtitle = formAndButtonDetails.subtitle;
    this.listenTo(this.model, 'error', function () {
      this.clearErrors();
    });
    this.addInput({
      label: (0, _okta.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top auth-passcode',
      name: 'answer',
      input: _TextBox.default,
      type: 'tel'
    });
    this.add((0, _okta.createButton)({
      attributes: {
        'data-se': formAndButtonDetails.buttonDataSe
      },
      className: 'button ' + formAndButtonDetails.buttonClassName,
      title: formAndButtonDetails.formSubmit,
      click: function click() {
        var _this = this;

        form.clearErrors();
        this.disable();
        form.clearWarnings();
        this.options.title = formAndButtonDetails.formSubmitted;
        this.render(); // To send an OTP to the device, make the same request but use
        // an empty passCode

        this.model.set('answer', '');
        this.model.save().then(function () {
          // render and focus on the passcode input field.
          form.getInputs().first().render().focus();
          return _q.default.delay(_Enums.default.API_RATE_LIMIT);
        }).then(function () {
          _this.options.title = formAndButtonDetails.formRetry;

          _this.enable();

          if (factorType === 'call' || factorType === 'sms') {
            form.showWarning(warningDetails);
          }

          _this.render();
        });
      }
    }));

    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2016-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Form.extend({
  className: 'mfa-verify-password',
  autoSave: true,
  noCancelButton: true,
  save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-password'
  },
  initialize: function initialize() {
    this.title = this.model.get('factorLabel');
    this.addInput({
      label: (0, _okta.loc)('mfa.challenge.password.placeholder', 'login'),
      'label-top': true,
      className: 'auth-passcode',
      name: 'password',
      type: 'password',
      params: {
        showPasswordToggle: true
      }
    });

    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _find = _interopRequireDefault(__webpack_require__(13));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Util = _interopRequireDefault(__webpack_require__(31));

var _NumberChallengeView = _interopRequireDefault(__webpack_require__(1192));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var titleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 14
        }
      }
    }) : helper)) + " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "deviceName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 16
        },
        "end": {
          "line": 1,
          "column": 32
        }
      }
    }) : helper)) != null ? stack1 : "") + ")";
  },
  "useData": true
}); // deviceName is escaped on BaseForm (see BaseForm's template)


var WARNING_TIMEOUT = 30000; // milliseconds

var PushFormwarningTemplate = _okta.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning',
  attributes: {
    'aria-live': 'polite'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 51
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  })
});

var _default = _okta.Form.extend({
  className: 'mfa-verify-push',
  autoSave: true,
  noCancelButton: true,
  save: _okta._.partial(_okta.loc, 'oktaverify.send', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-push'
  },
  events: {
    submit: 'submit'
  },
  initialize: function initialize() {
    this.enabled = true;
    this.listenTo(this.options.appState, 'change:isMfaRejected', this.handleRejectStateChange);
    this.numberChallengeView = this.add(_NumberChallengeView.default).last();
    this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (state, isWaitingForNumberChallenge) {
      if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
        var _context;

        this.clearWarnings();
        (0, _find.default)(_context = this.$el).call(_context, '.button').hide();
        this.numberChallengeView.$el.show();
      } else {
        var _context2;

        this.numberChallengeView.$el.hide();
        (0, _find.default)(_context2 = this.$el).call(_context2, '.button').show();
      }
    });
    this.listenTo(this.options.appState, 'change:isMfaTimeout', function (state, isMfaTimeout) {
      this.setSubmitState(isMfaTimeout);

      if (isMfaTimeout) {
        this.showError((0, _okta.loc)('oktaverify.timeout', 'login'));
      }
    });
    this.listenTo(this.options.appState, 'change:isMfaRequired', function (state, isMfaRequired) {
      if (isMfaRequired) {
        this.clearErrors();
        this.clearWarnings();
      }
    });
    this.title = titleTpl({
      factorName: this.model.get('factorLabel'),
      deviceName: this.model.get('deviceName')
    });
  },
  setSubmitState: function setSubmitState(ableToSubmit) {
    var _context3, _context4;

    var button = (0, _find.default)(_context3 = this.$el).call(_context3, '.button');
    var a11ySpan = (0, _find.default)(_context4 = this.$el).call(_context4, '.accessibility-text');
    this.enabled = ableToSubmit;

    if (ableToSubmit) {
      button.removeClass('link-button-disabled');
      button.prop('value', (0, _okta.loc)('oktaverify.send', 'login'));
      button.prop('disabled', false);

      if (a11ySpan) {
        a11ySpan.remove();
      }
    } else {
      button.addClass('link-button-disabled');
      button.prop('value', (0, _okta.loc)('oktaverify.sent', 'login'));
      button.prop('disabled', true);
      this.add("<span class='accessibility-text' role='alert'>".concat((0, _okta.loc)('oktaverify.sent', 'login'), "</span>"));
    }
  },
  submit: function submit(e) {
    if (e !== undefined) {
      e.preventDefault();
    }

    if (this.enabled) {
      this.setSubmitState(false);
      this.doSave();
    }
  },
  postRender: function postRender() {
    var factorsPolicyInfo = this.options.appState.get('factorsPolicyInfo');
    var id = this.model.get('id');
    var isAutoPushEnabled = this.settings.get('features.autoPush') && factorsPolicyInfo && factorsPolicyInfo[id] ? factorsPolicyInfo[id]['autoPushEnabled'] : false;

    if (isAutoPushEnabled) {
      this.model.set('autoPush', true); // bind after $el has been rendered, and trigger push once DOM is fully loaded

      _okta._.defer((0, _bind.default)(_okta._).call(_okta._, this.submit, this));
    }
  },
  doSave: function doSave() {
    var _this = this;

    var warningTimeout;
    this.clearErrors();
    this.clearWarnings();

    if (this.model.isValid()) {
      this.listenToOnce(this.model, 'error', function () {
        this.setSubmitState(true);
        this.clearWarnings();
        clearTimeout(warningTimeout);
      });
      this.trigger('save', this.model);
      warningTimeout = _Util.default.callAfterTimeout(function () {
        if (!_this.options.appState.get('isWaitingForNumberChallenge')) {
          _this.showWarning((0, _okta.loc)('oktaverify.warning', 'login'));
        }
      }, WARNING_TIMEOUT);
    }
  },
  showError: function showError(msg) {
    this.clearWarnings();
    this.model.trigger('error', this.model, {
      responseJSON: {
        errorSummary: msg
      }
    });
  },
  showWarning: function showWarning(msg) {
    this.clearWarnings();
    this.add(PushFormwarningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarnings: function clearWarnings() {
    this.$('.okta-form-infobox-warning').remove();
  },
  handleRejectStateChange: function handleRejectStateChange(state, isMfaRejected) {
    if (isMfaRejected) {
      this.setSubmitState(isMfaRejected);
      this.setRejectedErrorMessage();
    }
  },
  setRejectedErrorMessage: function setRejectedErrorMessage() {
    // If rejection is due to outdated app, show error message per platform
    // else show user rejected message.
    if (this.options.appState.get('lastAuthResponse').factorResultMessage === 'OKTA_VERIFY_UPGRADE_REQUIRED') {
      if (this.options.appState.get('factor').profile.platform === 'IOS') {
        this.showError((0, _okta.loc)('oktaverify.rejected.upgradeRequired.ios', 'login'));
      } else {
        this.showError((0, _okta.loc)('oktaverify.rejected.upgradeRequired.android', 'login'));
      }
    } else {
      this.showError((0, _okta.loc)('oktaverify.rejected', 'login'));
    }
  }
});

exports.default = _default;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'number-challenge-view',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p data-se=\"number-challenge-instruction\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "number",
          "bundle": "login",
          "code": "oktaverify.numberchallenge.instruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 42
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) != null ? stack1 : "") + "</p><div class=\"phone\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "number") || (depth0 != null ? lookupProperty(depth0, "number") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "number",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 262
          },
          "end": {
            "line": 1,
            "column": 272
          }
        }
      }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oktaverify.numberchallenge.explain"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 338
          },
          "end": {
            "line": 1,
            "column": 403
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var _this = this;

    this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function () {
      if (_this.options.appState.get('lastAuthResponse').status !== 'SUCCESS') {
        _this.render();
      }
    });
  },
  getTemplateData: function getTemplateData() {
    var lastAuthResponse = this.options.appState.get('lastAuthResponse');

    if (!this.options.appState.get('isWaitingForNumberChallenge')) {
      return {
        number: null
      };
    }

    return {
      number: lastAuthResponse._embedded.factor._embedded.challenge.correctAnswer
    };
  }
});

exports.default = _default;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Form.extend({
  className: 'mfa-verify-question',
  autoSave: true,
  noCancelButton: true,
  save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-question'
  },
  initialize: function initialize() {
    this.title = this.model.get('factorLabel');
    this.addInput({
      label: this.model.get('securityQuestion'),
      'label-top': true,
      placeholder: (0, _okta.loc)('mfa.challenge.answer.placeholder', 'login'),
      className: 'auth-passcode',
      name: 'answer',
      type: 'password',
      params: {
        showPasswordToggle: true
      }
    });

    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _ResendEmailView = _interopRequireDefault(__webpack_require__(532));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var createEmailMaskElement = function createEmailMaskElement() {
  var email = this.model.get('email');

  var emailTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "email",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 25
          },
          "end": {
            "line": 1,
            "column": 34
          }
        }
      }) : helper)) + "</span>";
    },
    "useData": true
  });

  return {
    factorEmail: emailTpl({
      email: email
    })
  };
};

var SendEmailAndVerifyCodeFormVerifyEmailCodeForm = _okta.Form.extend({
  layout: 'o-form-theme',
  className: 'mfa-verify-email',
  title: _okta._.partial(_okta.loc, 'email.mfa.title', 'login'),
  noButtonBar: false,
  autoSave: true,
  noCancelButton: true,
  attributes: {
    'data-se': 'factor-email'
  },
  save: function save() {
    return this.options.appState.get('isMfaChallenge') ? (0, _okta.loc)('mfa.challenge.verify', 'login') : (0, _okta.loc)('email.button.send', 'login');
  },
  events: (0, _assign.default)({}, _okta.Form.prototype.events, {
    submit: function submit(e) {
      e.preventDefault();
      this.handleSubmit();
    }
  }),
  handleSubmit: function handleSubmit() {
    this.clearErrors();

    if (this.options.appState.get('isMfaChallenge')) {
      if (this.isValid()) {
        this.model.save();
      }
    } else {
      var _context;

      // Send email and switch to verification view
      this.model.set('answer', '');
      this.model.save().then((0, _bind.default)(_context = this.renderChallengView).call(_context, this));
    }
  },
  initialize: function initialize() {
    _okta.Form.prototype.initialize.apply(this, arguments); // render 'Send Email' page at first place


    this.add(_okta.View.extend({
      attributes: {
        'data-se': 'mfa-send-email-content'
      },
      className: 'mfa-send-email-content',
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "arguments": "factorEmail",
              "bundle": "login",
              "code": "email.mfa.description"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 78
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      getTemplateData: createEmailMaskElement
    }));
  },
  renderChallengView: function renderChallengView() {
    this.removeChildren();
    this.add(_okta.View.extend({
      className: 'mfa-email-sent-content',
      attributes: {
        'data-se': 'mfa-email-sent-content'
      },
      // Why use `{{{` for the description?
      // - factorEmail is actually an HTML fragment which
      //   is created via another handlebar template and used for bold the email address.
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "arguments": "factorEmail",
              "bundle": "login",
              "code": "email.mfa.email.sent.description"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 89
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      getTemplateData: createEmailMaskElement
    }));
    this.add(_ResendEmailView.default);
    this.addInput({
      label: (0, _okta.loc)('email.code.label', 'login'),
      'label-top': true,
      name: 'answer',
      input: _TextBox.default,
      wide: true,
      type: 'tel'
    });

    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }

    this.render();
  }
});

var _default = SendEmailAndVerifyCodeFormVerifyEmailCodeForm;
exports.default = _default;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Form.extend({
  className: 'mfa-verify-totp',
  autoSave: true,
  noCancelButton: true,
  save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-totp'
  },
  initialize: function initialize() {
    var _this = this;

    var factorName = this.model.get('factorLabel');
    var maskPasswordField = this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH';
    this.title = factorName;

    if (this.model.get('isFactorTypeVerification')) {
      this.subtitle = (0, _okta.loc)('mfa.challenge.totp.subtitle.multiple', 'login', [factorName]);
    } else {
      this.subtitle = (0, _okta.loc)('mfa.challenge.title', 'login', [factorName]);
    }

    this.addInput({
      label: (0, _okta.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top auth-passcode',
      name: 'answer',
      input: _TextBox.default,
      type: maskPasswordField ? 'password' : 'tel'
    });

    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }

    if (this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH') {
      this.listenTo(this.model, 'error', function (source, error) {
        if (error && error.status === 409) {
          // 409 means we are in change pin, so we should clear out answer input
          _this.$('.auth-passcode input').val('');

          _this.$('.auth-passcode input').trigger('change');

          _this.$('.auth-passcode input').focus();
        }
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.Form.extend({
  className: 'mfa-verify-yubikey',
  autoSave: true,
  noCancelButton: true,
  save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-yubikey'
  },
  initialize: function initialize() {
    var factorName = this.model.get('factorLabel');
    this.title = factorName;
    this.subtitle = (0, _okta.loc)('factor.totpHard.yubikey.description', 'login');
    this.addInput({
      label: (0, _okta.loc)('factor.totpHard.yubikey.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top auth-passcode',
      name: 'answer',
      input: _TextBox.default,
      inputId: 'mfa-answer',
      type: 'password'
    });

    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        className: 'margin-btm-0',
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _ValidationUtil = _interopRequireDefault(__webpack_require__(199));

var _Footer = _interopRequireDefault(__webpack_require__(530));

var _PasswordRequirements = _interopRequireDefault(__webpack_require__(546));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'password-expired',
  Model: {
    props: {
      oldPassword: ['string', true],
      newPassword: ['string', true],
      confirmPassword: ['string', true]
    },
    validate: function validate() {
      return _ValidationUtil.default.validatePasswordMatch(this);
    },
    save: function save() {
      this.trigger('save');
      return this.doTransaction(function (transaction) {
        return transaction.changePassword({
          oldPassword: this.get('oldPassword'),
          newPassword: this.get('newPassword')
        });
      });
    }
  },
  Form: {
    save: _okta._.partial(_okta.loc, 'password.expired.submit', 'login'),
    title: function title() {
      var expiringSoon = this.options.appState.get('isPwdExpiringSoon');
      var numDays = this.options.appState.get('passwordExpireDays');

      if (expiringSoon && numDays > 0) {
        return (0, _okta.loc)('password.expiring.title', 'login', [numDays]);
      } else if (expiringSoon && numDays === 0) {
        return (0, _okta.loc)('password.expiring.today', 'login');
      } else if (expiringSoon) {
        return (0, _okta.loc)('password.expiring.soon', 'login');
      } else {
        return this.settings.get('brandName') ? (0, _okta.loc)('password.expired.title.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('password.expired.title.generic', 'login');
      }
    },
    subtitle: function subtitle() {
      if (this.options.appState.get('isPwdExpiringSoon')) {
        return this.settings.get('brandName') ? (0, _okta.loc)('password.expiring.subtitle.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('password.expiring.subtitle.generic', 'login');
      }

      var policy = this.options.appState.get('policy');

      if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        return;
      }

      return _FactorUtil.default.getPasswordComplexityDescription(policy);
    },
    parseErrorMessage: function parseErrorMessage(responseJSON) {
      var policy = this.options.appState.get('policy');

      if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        /*
          - This is a specific case where don't want to repeat the requirements again in the error message, since this
            is already shown in the description. The description as bullet-points itself should give an indication
            of the requirements.
          - We cannot check for error code this in this case, as the error code is shared between
            requirements not met message, common password message, etc. So error summary is the only differentiating
            factor. Replace the password requirements string with empty string in this case.
        */
        responseJSON = _FactorUtil.default.removeRequirementsFromError(responseJSON, policy);
      }

      return responseJSON;
    },
    formChildren: function formChildren() {
      var children = [];

      if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        children.push(_FormType.default.View({
          View: new _PasswordRequirements.default({
            policy: this.options.appState.get('policy')
          })
        }));
      }

      children = (0, _concat.default)(children).call(children, [_FormType.default.Input({
        'label-top': true,
        label: (0, _okta.loc)('password.oldPassword.placeholder', 'login'),
        explain: _Util.default.createInputExplain('password.oldPassword.tooltip', 'password.oldPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'oldPassword',
        input: _TextBox.default,
        type: 'password'
      }), _FormType.default.Divider(), _FormType.default.Input({
        className: 'margin-btm-5',
        'label-top': true,
        label: (0, _okta.loc)('password.newPassword.placeholder', 'login'),
        explain: _Util.default.createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'newPassword',
        input: _TextBox.default,
        type: 'password'
      }), _FormType.default.Input({
        'label-top': true,
        label: (0, _okta.loc)('password.confirmPassword.placeholder', 'login'),
        explain: _Util.default.createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'confirmPassword',
        input: _TextBox.default,
        type: 'password'
      })]);
      return children;
    }
  },
  Footer: _Footer.default,
  initialize: function initialize() {
    this.listenTo(this.form, 'save', function () {
      var creds = {
        username: this.options.appState.get('userEmail'),
        password: this.model.get('newPassword')
      };
      this.settings.processCreds(creds).then((0, _bind.default)(_okta._).call(_okta._, this.model.save, this.model));
    });
  }
});

exports.default = _default;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _ValidationUtil = _interopRequireDefault(__webpack_require__(199));

var _FooterSignout = _interopRequireDefault(__webpack_require__(246));

var _PasswordRequirements = _interopRequireDefault(__webpack_require__(546));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'password-reset',
  Model: {
    props: {
      newPassword: ['string', true],
      confirmPassword: ['string', true]
    },
    validate: function validate() {
      return _ValidationUtil.default.validatePasswordMatch(this);
    },
    save: function save() {
      this.trigger('save');
      var self = this;
      return this.doTransaction(function (transaction) {
        return transaction.resetPassword({
          newPassword: self.get('newPassword')
        });
      });
    }
  },
  Form: {
    save: _okta._.partial(_okta.loc, 'password.reset', 'login'),
    title: function title() {
      return this.settings.get('brandName') ? (0, _okta.loc)('password.reset.title.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('password.reset.title.generic', 'login');
    },
    subtitle: function subtitle() {
      var policy = this.options.appState.get('policy');

      if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        return;
      }

      return _FactorUtil.default.getPasswordComplexityDescription(policy);
    },
    parseErrorMessage: function parseErrorMessage(responseJSON) {
      var policy = this.options.appState.get('policy');

      if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        /*
          - This is a specific case where don't want to repeat the requirements again in the error message, since this
            is already shown in the description. The description as bullet-points itself should give an indication
            of the requirements.
          - We cannot check for error code this in this case, as the error code is shared between
            requirements not met message, common password message, etc. So error summary is the only differentiating
            factor. Replace the password requirements string with empty string in this case.
        */
        responseJSON = _FactorUtil.default.removeRequirementsFromError(responseJSON, policy);
      }

      return responseJSON;
    },
    formChildren: function formChildren() {
      var children = [];

      if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        children.push(_FormType.default.View({
          View: new _PasswordRequirements.default({
            policy: this.options.appState.get('policy')
          })
        }));
      }

      children = (0, _concat.default)(children).call(children, [_FormType.default.Input({
        className: 'margin-btm-5',
        label: (0, _okta.loc)('password.newPassword.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'newPassword',
        input: _TextBox.default,
        type: 'password',
        autoComplete: 'new-password'
      }), _FormType.default.Input({
        label: (0, _okta.loc)('password.confirmPassword.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'confirmPassword',
        input: _TextBox.default,
        type: 'password',
        autoComplete: 'new-password'
      })]);
      return children;
    }
  },
  initialize: function initialize() {
    this.listenTo(this.form, 'save', function () {
      var creds = {
        username: this.options.appState.get('userEmail'),
        password: this.model.get('newPassword')
      };
      this.settings.processCreds(creds).then((0, _bind.default)(_okta._).call(_okta._, this.model.save, this.model));
    });

    if (!this.settings.get('features.hideBackToSignInForReset')) {
      this.addFooter(_FooterSignout.default);
    }
  }
});

exports.default = _default;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _setInterval2 = _interopRequireDefault(__webpack_require__(194));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'poll',
  Model: {
    save: function save() {
      var _this = this;

      this.trigger('cancelRequest');
      return this.appState.get('transaction').cancel().then(function () {
        _this.options.appState.trigger('navigate', '');
      }).catch(function () {
        _this._stopCountDown();
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: function title() {
      return this.title;
    },
    className: 'poll-controller',
    noCancelButton: true,
    save: (0, _okta.loc)('oform.cancel', 'login'),
    modelEvents: {
      cancelRequest: '_stopCountDown'
    },
    formChildren: [_FormType.default.View({
      View: '<div >\
               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>\
             </div>'
    })],
    _checkStatus: function _checkStatus() {
      var _this2 = this;

      // start polling request
      this.transactionObject.poll().then(function (resp) {
        if (resp.data && resp.status !== 'POLL') {
          _this2.options.appState.set('transaction', resp);

          return;
        }

        _this2.$('.okta-waiting-spinner').hide();

        var factorPollingIntervalSeconds = Math.ceil(resp.transaction.profile.refresh / 1000);

        _this2._startCountDown(factorPollingIntervalSeconds);
      }).catch(function () {
        _this2._stopCountDown();
      });
    },
    _startCountDown: function _startCountDown(factorPollingIntervalSeconds) {
      var _this3 = this;

      // start one second countdown for next poll request
      this.countDown = (0, _setInterval2.default)(function () {
        // update title after every second and check if countdown == 1 to poll again
        _this3._updateTitle(factorPollingIntervalSeconds);

        if (factorPollingIntervalSeconds === 0) {
          /* when countdown hits 0
                       - stop current poll
                       - show spinner
                       - check status
                      */
          _this3._stopCountDown();

          _this3.$('.okta-waiting-spinner').show(); // start after a small delay so that the spinner does not get hidden too soon


          _this3.checkStatusTimeout = (0, _setTimeout2.default)(function () {
            _this3._checkStatus();
          }, 200);
        } else {
          // reduce countdown after every second
          factorPollingIntervalSeconds = factorPollingIntervalSeconds - 1;
        }
      }, 1000);
    },
    _updateTitle: function _updateTitle(factorPollingIntervalSeconds) {
      var _context;

      this.title = (0, _okta.loc)('polling.title', 'login', [factorPollingIntervalSeconds]);
      (0, _find.default)(_context = this.$el).call(_context, '.okta-form-title').text(this.title);
    },
    _stopCountDown: function _stopCountDown() {
      // clear countdown setInterval
      if (this.countDown) {
        clearInterval(this.countDown);
      } // clear checkstatus setTimeout


      if (this.checkStatusTimeout) {
        clearInterval(this.checkStatusTimeout);
      }
    },
    initialize: function initialize(options) {
      this.transactionObject = options.appState.get('transaction');
      this.factorPollingIntervalSeconds = Math.ceil(this.transactionObject.transaction.profile.refresh / 1000);

      this._updateTitle(this.factorPollingIntervalSeconds);

      this._startCountDown(this.factorPollingIntervalSeconds);
    }
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  remove: function remove() {
    this.form._stopCountDown();
  }
});

exports.default = _default;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'password-reset-email-sent',
  Model: function Model() {
    return {
      local: {
        userFullName: ['string', false, this.options.appState.get('userFullName')]
      }
    };
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'password.forgot.emailSent.title', 'login'),
    subtitle: function subtitle() {
      var username = this.options.appState.get('username');
      return (0, _okta.loc)('password.forgot.emailSent.desc', 'login', [username]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'pwd-reset-email-sent'
    },
    formChildren: function formChildren() {
      var children = [_FormType.default.View({
        View: _okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<span class=\"accessibility-text\" role=\"status\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "alert") || (depth0 != null ? lookupProperty(depth0, "alert") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "alert",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 47
                  },
                  "end": {
                    "line": 1,
                    "column": 56
                  }
                }
              }) : helper)) + "</span>";
            },
            "useData": true
          }),
          getTemplateData: function getTemplateData() {
            return {
              alert: (0, _okta.loc)('password.forgot.emailSent.title', 'login')
            };
          }
        })
      })];

      if (!this.settings.get('features.hideBackToSignInForReset')) {
        children.push(_FormType.default.Button({
          title: (0, _okta.loc)('goback', 'login'),
          className: 'button button-primary button-wide',
          attributes: {
            'data-se': 'back-button'
          },
          click: function click() {
            var self = this;
            return this.model.doTransaction(function (transaction) {
              return transaction.cancel();
            }).then(function () {
              self.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
              self.options.appState.trigger('navigate', '');
            });
          }
        }));
      }

      return children;
    }
  },
  initialize: function initialize(options) {
    this.settings.callGlobalSuccess(_Enums.default.FORGOT_PASSWORD_EMAIL_SENT, {
      username: options.appState.get('username')
    });
  }
});

exports.default = _default;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _FooterSignout = _interopRequireDefault(__webpack_require__(246));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'recovery-challenge',
  Model: {
    props: {
      passCode: ['string', true]
    },
    local: {
      ableToResend: 'boolean'
    },
    resendCode: function resendCode() {
      // Note: This does not require a trapAuthResponse because Backbone's
      // router will not navigate if the url path is the same
      this.limitResending();
      return this.doTransaction(function (transaction) {
        return transaction.resend();
      });
    },
    limitResending: function limitResending() {
      this.set({
        ableToResend: false
      });

      _okta._.delay((0, _bind.default)(_okta._).call(_okta._, this.set, this), _Enums.default.API_RATE_LIMIT, {
        ableToResend: true
      });
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        return transaction.verify({
          passCode: this.get('passCode')
        });
      });
    }
  },
  Form: {
    autoSave: true,
    save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
    title: function title() {
      if (this.options.appState.get('factorType') === _Enums.default.RECOVERY_FACTOR_TYPE_CALL) {
        return (0, _okta.loc)('recoveryChallenge.call.title', 'login');
      } else {
        return (0, _okta.loc)('recoveryChallenge.sms.title', 'login');
      }
    },
    className: 'recovery-challenge',
    initialize: function initialize() {
      this.listenTo(this.model, 'error', function () {
        this.clearErrors();
      });
    },
    formChildren: function formChildren() {
      return [_FormType.default.Button({
        title: (0, _okta.loc)('mfa.resendCode', 'login'),
        attributes: {
          'data-se': 'resend-button'
        },
        className: 'button sms-request-button margin-top-30',
        click: function click() {
          this.model.resendCode();
        },
        initialize: function initialize() {
          this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
            if (ableToResend) {
              this.options.title = (0, _okta.loc)('mfa.resendCode', 'login');
              this.enable();
              this.render();
            } else {
              this.options.title = (0, _okta.loc)('mfa.sent', 'login');
              this.disable();
              this.render();
            }
          });
        }
      }), _FormType.default.Input({
        label: (0, _okta.loc)('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        className: 'enroll-sms-phone',
        name: 'passCode',
        input: _TextBox.default,
        type: 'text'
      })];
    }
  },
  events: {
    'click .send-email-link': function clickSendEmailLink(e) {
      e.preventDefault();
      var settings = this.model.settings;
      var username = this.options.appState.get('username');
      var recoveryType = this.options.appState.get('recoveryType');
      this.model.startTransaction(function (authClient) {
        // The user could have landed here via the Forgot Password/Unlock Account flow
        switch (recoveryType) {
          case _Enums.default.RECOVERY_TYPE_PASSWORD:
            return authClient.forgotPassword({
              username: settings.transformUsername(username, _Enums.default.FORGOT_PASSWORD),
              factorType: _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL
            });

          case _Enums.default.RECOVERY_TYPE_UNLOCK:
            return authClient.unlockAccount({
              username: settings.transformUsername(username, _Enums.default.UNLOCK_ACCOUNT),
              factorType: _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL
            });

          default:
            return;
        }
      });
    }
  },
  initialize: function initialize() {
    var recoveryType = this.options.appState.get('recoveryType');
    var sendEmailLink;

    switch (recoveryType) {
      case _Enums.default.RECOVERY_TYPE_PASSWORD:
        sendEmailLink = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "password.forgot.code.notReceived"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 63
                }
              }
            }));
          },
          "useData": true
        });
        break;

      case _Enums.default.RECOVERY_TYPE_UNLOCK:
        sendEmailLink = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "account.unlock.code.notReceived"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 62
                }
              }
            }));
          },
          "useData": true
        });
        break;

      default:
        break;
    }

    if (sendEmailLink && this.settings.get('features.emailRecovery')) {
      this.add(_okta.View.extend({
        className: 'link send-email-link',
        tagName: 'a',
        attributes: {
          href: '#',
          'data-se': 'send-email-link'
        },
        template: sendEmailLink
      }));
    }

    if (!this.settings.get('features.hideBackToSignInForReset')) {
      this.addFooter(_FooterSignout.default);
    }
  },
  postRender: function postRender() {
    this.model.limitResending();
  }
});

exports.default = _default;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _FormController = _interopRequireDefault(__webpack_require__(8));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'recovery-loading',
  Model: {},
  Form: {
    noButtonBar: true
  },
  initialize: function initialize(options) {
    var self = this;
    return this.model.startTransaction(function (authClient) {
      return authClient.verifyRecoveryToken({
        recoveryToken: options.token
      });
    }).catch(function () {
      self.options.appState.trigger('loading', false);
      self.options.appState.trigger('removeLoading');
    });
  },
  preRender: function preRender() {
    this.options.appState.trigger('loading', true);
  },
  trapAuthResponse: function trapAuthResponse() {
    this.options.appState.trigger('loading', false);
    return false;
  }
});

exports.default = _default;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _FooterSignout = _interopRequireDefault(__webpack_require__(246));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'recovery-question',
  Model: {
    props: {
      answer: ['string', true],
      showAnswer: 'boolean'
    },
    save: function save() {
      return this.doTransaction(function (transaction) {
        return transaction.answer({
          answer: this.get('answer')
        });
      });
    }
  },
  Form: {
    autoSave: true,
    save: function save() {
      switch (this.options.appState.get('recoveryType')) {
        case 'PASSWORD':
          return (0, _okta.loc)('password.forgot.question.submit', 'login');

        case 'UNLOCK':
          return (0, _okta.loc)('account.unlock.question.submit', 'login');

        default:
          return (0, _okta.loc)('mfa.challenge.verify', 'login');
      }
    },
    title: function title() {
      switch (this.options.appState.get('recoveryType')) {
        case 'PASSWORD':
          return (0, _okta.loc)('password.forgot.question.title', 'login');

        case 'UNLOCK':
          return (0, _okta.loc)('account.unlock.question.title', 'login');

        default:
          return '';
      }
    },
    formChildren: function formChildren() {
      return [_FormType.default.Input({
        label: this.options.appState.get('recoveryQuestion'),
        placeholder: (0, _okta.loc)('mfa.challenge.answer.placeholder', 'login'),
        name: 'answer',
        input: _TextBox.default,
        type: 'password',
        initialize: function initialize() {
          this.listenTo(this.model, 'change:showAnswer', function () {
            var type = this.model.get('showAnswer') ? 'text' : 'password';
            this.getInputs()[0].changeType(type);
          });
        }
      }), _FormType.default.Input({
        label: false,
        'label-top': true,
        placeholder: (0, _okta.loc)('mfa.challenge.answer.showAnswer', 'login'),
        className: 'recovery-question-show margin-btm-0',
        name: 'showAnswer',
        type: 'checkbox'
      })];
    }
  },
  initialize: function initialize() {
    if (!this.settings.get('features.hideBackToSignInForReset')) {
      this.addFooter(_FooterSignout.default);
    }
  }
});

exports.default = _default;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _FormController = _interopRequireDefault(__webpack_require__(8));

/* eslint-disable max-depth */

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'refresh-auth-state',
  Model: {},
  Form: {
    noButtonBar: true
  },
  preRender: function preRender() {
    var appState = this.options.appState;
    var token = this.options.token;
    this.model.startTransaction(function (authClient) {
      appState.trigger('loading', true);

      if (token) {
        return authClient.tx.introspect({
          stateToken: token
        });
      } // get stateToken from cookie
      // currently only applies to old pipeline


      if (authClient.tx.exists()) {
        return authClient.tx.resume();
      }

      appState.trigger('navigate', '');
    });
  },
  remove: function remove() {
    this.options.appState.trigger('loading', false);
    return _FormController.default.prototype.remove.apply(this, arguments);
  }
});

exports.default = _default;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  events: {
    'click .back-btn': function clickBackBtn(e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  },
  className: 'registration-complete',
  Model: function Model() {},
  initialize: function initialize() {
    this.settings.callGlobalSuccess(_Enums.default.ACTIVATION_EMAIL_SENT, {
      username: this.options.appState.get('username')
    });
  },
  Form: {
    noButtonBar: true,
    formChildren: function formChildren() {
      return [_FormType.default.View({
        View: _okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var helper,
                  alias1 = depth0 != null ? depth0 : container.nullContext || {},
                  alias2 = container.hooks.helperMissing,
                  alias3 = "function",
                  alias4 = container.escapeExpression,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return "<div class=\"container\"><span class=\"title-icon icon icon-16 confirm-16-green\"></span><h2 class=\"title\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 103
                  },
                  "end": {
                    "line": 1,
                    "column": 112
                  }
                }
              }) : helper)) + "</h2><div class=\"desc\">" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
                "name": "desc",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 135
                  },
                  "end": {
                    "line": 1,
                    "column": 143
                  }
                }
              }) : helper)) + "</div></div><a href=\"#\" class=\"back-btn\" data-se=\"back-link\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "goback"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 204
                  },
                  "end": {
                    "line": 1,
                    "column": 241
                  }
                }
              })) + "</a>";
            },
            "useData": true
          }),
          getTemplateData: function getTemplateData() {
            return {
              desc: (0, _okta.loc)('registration.complete.confirm.text', 'login'),
              title: (0, _okta.loc)('registration.complete.title', 'login')
            };
          }
        })
      })];
    }
  }
});

exports.default = _default;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _LoginModel = _interopRequireDefault(__webpack_require__(1207));

var _RegistrationSchema = _interopRequireDefault(__webpack_require__(1208));

var _q = _interopRequireDefault(__webpack_require__(43));

var _BaseLoginController = _interopRequireDefault(__webpack_require__(156));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _RegistrationFormFactory = _interopRequireDefault(__webpack_require__(537));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _SubSchema = _interopRequireDefault(__webpack_require__(1209));

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var RegistrationControllerFooter = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 87
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .help': function clickHelp(e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});

var _default = _BaseLoginController.default.extend({
  className: 'registration',
  initialize: function initialize() {
    var RegistrationControllerSchema = _RegistrationSchema.default.extend({
      settings: this.options.settings,
      url: this.options.settings.get('baseUrl') + '/api/v1/registration/form'
    }); // setup schema


    var schema = new RegistrationControllerSchema();
    this.state.set('schema', schema);
  },
  getRegistrationApiUrl: function getRegistrationApiUrl() {
    var defaultPolicyId = this.settings.get('defaultPolicyId'); // default policyId

    var orgPolicyId = this.options.settings.get('policyId'); // org policyId

    var apiUrl = defaultPolicyId ? this.getRegistrationPolicyApi(defaultPolicyId) : this.getRegistrationPolicyApi(orgPolicyId);
    return apiUrl;
  },
  getRegistrationPolicyApi: function getRegistrationPolicyApi(policyId) {
    return this.options.settings.get('baseUrl') + '/api/v1/registration/' + policyId;
  },
  doPostSubmit: function doPostSubmit() {
    if (this.model.get('activationToken')) {
      var self = this; // register via activation token

      self.settings.callGlobalSuccess(_Enums.default.REGISTRATION_COMPLETE, {
        activationToken: this.model.get('activationToken')
      });
      var loginModel = new _LoginModel.default({
        settings: self.model.appState.settings
      });
      loginModel.loginWithActivationToken(this.model.get('activationToken')).then(function (transaction) {
        self.model.trigger('setTransaction', transaction);
      });
    } else {
      // register via activation email
      this.model.appState.set('username', this.model.get('email'));
      this.model.appState.trigger('navigate', 'signin/register-complete');
    }
  },
  registerUser: function registerUser(postData) {
    var _this = this;

    var self = this;
    this.model.attributes = postData; // Model.save returns a jqXHR

    _okta.Backbone.Model.prototype.save.call(this.model).then(function () {
      var activationToken = self.model.get('activationToken');
      var postSubmitData = activationToken ? activationToken : self.model.get('email');
      self.settings.postRegistrationSubmit(postSubmitData, function () {
        self.doPostSubmit();
      }, function (errors) {
        self.showErrors(errors);
      });
    }).fail(function (err) {
      var responseJSON = err.responseJSON;

      if (responseJSON && responseJSON.errorCauses.length) {
        var errorCode = responseJSON.errorCode,
            errorCauses = responseJSON.errorCauses;
        var _errorCauses$ = errorCauses[0],
            errorSummary = _errorCauses$.errorSummary,
            reason = _errorCauses$.reason,
            location = _errorCauses$.location;
        var isNotUniqueValue = errorCode === 'E0000001' && reason === 'UNIQUE_CONSTRAINT';

        if (isNotUniqueValue) {
          _this.renderIsNotUniqueError(responseJSON);
        }

        _this.renderLegacyLocationErrorIfNeeded(location, errorSummary);

        _Util.default.triggerAfterError(_this, new _Errors.default.RegistrationError(errorSummary));
      }
    });
  },
  renderIsNotUniqueError: function renderIsNotUniqueError(error) {
    var _context;

    var location = error.errorCauses[0].location;
    var errorSummary = (0, _okta.loc)('registration.error.userName.notUniqueWithinOrg', 'login', [location]); // replace generic error message with more specific one
    // without using backbone events because there was a race condition
    // between clearing and triggering errors

    (0, _find.default)(_context = this.$el).call(_context, '.okta-form-infobox-error p').text(errorSummary);
  },
  renderLegacyLocationErrorIfNeeded: function renderLegacyLocationErrorIfNeeded(location, errorSummary) {
    // replace generic error message with errorSummary for v1 SIW
    // this makes sure that with legacy location that starts with `data.userProfile`
    // we still see the errorSummary in the error banner instead of only a generic error
    // See example in https://developer.okta.com/docs/reference/registration-hook/#sample-json-payload-of-request
    if (location && /^data\.userProfile.*/.test(location)) {
      var _context2;

      (0, _find.default)(_context2 = this.$el).call(_context2, '.okta-form-infobox-error p').text(errorSummary);
    }
  },
  createRegistrationModel: function createRegistrationModel(modelProperties) {
    var self = this;

    var RegistrationControllerModel = _okta.Model.extend({
      url: self.getRegistrationApiUrl() + '/register',
      settings: this.settings,
      appState: this.options.appState,
      props: modelProperties,
      local: {
        activationToken: 'string'
      },
      toJSON: function toJSON() {
        var data = _okta.Model.prototype.toJSON.apply(this, arguments);

        return {
          userProfile: data,
          relayState: this.settings.get('relayState')
        };
      },
      parse: function parse(resp) {
        this.set('activationToken', resp.activationToken);
        delete resp.activationToken;
        return resp;
      },
      save: function save() {
        this.settings.preRegistrationSubmit(this.attributes, function (postData) {
          self.registerUser(postData);
        }, function (errors) {
          self.showErrors(errors);
        });
      }
    });

    return new RegistrationControllerModel();
  },
  showErrors: function showErrors(error, hideRegisterButton) {
    //for parseSchema error hide form and show error at form level
    if (error.callback === 'parseRegistrationSchema' && error.errorCauses) {
      error.errorSummary = _okta._.clone(error.errorCauses[0].errorSummary);
      delete error.errorCauses;
    } //show error on form


    this.model.trigger('error', this.model, {
      responseJSON: error
    }); //throw registration error

    var errMsg = error.callback ? error.callback + ':' + error.errorSummary : error.errorSummary;

    _Util.default.triggerAfterError(this, new _Errors.default.RegistrationError(errMsg));

    if (hideRegisterButton) {
      var _context3;

      (0, _find.default)(_context3 = this.$el).call(_context3, '.button-primary').hide();
    }
  },
  fetchInitialData: function fetchInitialData() {
    var self = this; // register parse complete event listener

    self.state.get('schema').on('parseComplete', function (updatedSchema) {
      var modelProperties = updatedSchema.properties.createModelProperties();
      self.settings.set('defaultPolicyId', updatedSchema.properties.defaultPolicyId); // create model

      self.model = self.createRegistrationModel(modelProperties); // create form

      var RegistrationControllerForm = _okta.Form.extend({
        layout: 'o-form-theme',
        autoSave: true,
        noCancelButton: true,
        title: (0, _okta.loc)('registration.form.title', 'login'),
        save: (0, _okta.loc)('registration.form.submit', 'login'),
        modelEvents: {
          'invalid': 'modifyErrors'
        },
        modifyErrors: function modifyErrors(model, errorResp) {
          // overwrite courage errorResp object to show custom error message
          for (var formFieldName in errorResp) {
            if (errorResp[formFieldName] === 'model.validation.field.string.minLength') {
              errorResp[formFieldName] = (0, _okta.loc)('registration.model.validation.field.string.too.short', 'login', [model.props[formFieldName].minLength]);
            } else if (errorResp[formFieldName] === 'model.validation.field.string.maxLength') {
              errorResp[formFieldName] = (0, _okta.loc)('registration.model.validation.field.string.too.long', 'login', [model.props[formFieldName].maxLength + 1]);
            }
          }
        }
      });

      var form = new RegistrationControllerForm(self.toJSON()); // add form

      self.add(form); // add footer

      self.footer = new self.Footer(self.toJSON());
      self.add(self.footer);
      self.addListeners();

      if (updatedSchema.error) {
        self.showErrors(updatedSchema.error, true);
      } else {
        // add fields
        updatedSchema.properties.each(function (schemaProperty) {
          var inputOptions = _RegistrationFormFactory.default.createInputOptions(schemaProperty);

          var subSchemas = schemaProperty.get('subSchemas');
          var name = schemaProperty.get('name');
          form.addInput(inputOptions);

          if (name === 'password' && subSchemas) {
            form.add(_SubSchema.default.extend({
              id: 'subschemas-' + name,
              subSchemas: subSchemas
            }));
          }
        });

        var requiredFieldsLabel = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "label",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 36
                },
                "end": {
                  "line": 1,
                  "column": 45
                }
              }
            }) : helper)) + "</span>";
          },
          "useData": true
        })({
          label: (0, _okta.loc)('registration.required.fields.label', 'login')
        });

        form.add(requiredFieldsLabel);
      }
    }); // fetch schema from API, returns a jqXHR. Wrap it in a Q

    return (0, _q.default)(this.state.get('schema').fetch());
  },
  Footer: RegistrationControllerFooter
});

exports.default = _default;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseLoginModel = _interopRequireDefault(__webpack_require__(198));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginModel.default.extend({
  constructor: function constructor(options) {
    this.settings = options && options.settings;

    _okta.Model.apply(this, arguments);
  },
  loginWithActivationToken: function loginWithActivationToken(activationToken) {
    return this.startTransaction(function (authClient) {
      return authClient.signInWithCredentials({
        token: activationToken
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _sort = _interopRequireDefault(__webpack_require__(545));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _internal$models = _okta.internal.models,
    BaseSchema = _internal$models.BaseSchema,
    SchemaProperty = _internal$models.SchemaProperty;
var RegistrationSchemaRegistrationSchemaPropertyCollection = SchemaProperty.Collection.extend({
  createModelProperties: function createModelProperties() {
    var modelProperties = SchemaProperty.Collection.prototype.createModelProperties.apply(this);

    _okta._.each(modelProperties, function (modelProperty, name) {
      modelProperty.required = !!this.get(name).get('required');
    }, this);

    return modelProperties;
  }
});

var _default = BaseSchema.Model.extend({
  expand: ['schema'],
  constructor: function constructor() {
    this.properties = new RegistrationSchemaRegistrationSchemaPropertyCollection();

    _okta.BaseModel.apply(this, arguments);
  },
  parse: function parse(resp) {
    var _this = this;

    var parseResponseData = function parseResponseData(resp) {
      var requireFields = resp.schema.required;

      if (_okta._.isArray(requireFields)) {
        _okta._.each(requireFields, function (requireField) {
          var field = this.properties.get(requireField);

          if (field) {
            field.set('required', true);
          }
        }, _this);
      }

      var fieldOrderIds = resp.schema.fieldOrder;

      if (_okta._.isArray(fieldOrderIds)) {
        var _context;

        _okta._.each(fieldOrderIds, function (fieldOrderId, sortOrder) {
          var field = this.properties.get(fieldOrderId);

          if (field) {
            field.set('sortOrder', sortOrder);
          }
        }, _this);

        _this.properties.comparator = 'sortOrder';
        (0, _sort.default)(_context = _this.properties).call(_context);
      }

      _this.properties.defaultPolicyId = resp.policyId;
      return resp;
    };

    var self = this;
    this.settings.parseRegistrationSchema(resp, function (resp) {
      if (resp.profileSchema) {
        resp.schema = resp.profileSchema;
        BaseSchema.Model.prototype.parse.apply(self, [resp]);
        resp = parseResponseData(resp);
      }

      self.trigger('parseComplete', {
        properties: self.properties
      });
    }, function (error) {
      self.trigger('parseComplete', {
        properties: self.properties,
        error: error
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(__webpack_require__(40));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var SubSchemaSubSchema = _okta.View.extend({
  index: '',
  message: '',
  class: function _class() {
    return;
  },
  className: function className() {
    return 'subschema-unsatisfied subschema-' + this.index;
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"default-schema\"><span class=\"icon icon-16\"></span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 60
          },
          "end": {
            "line": 1,
            "column": 71
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    return {
      message: this.message
    };
  }
});

var _default = _okta.View.extend({
  className: 'subschema',
  children: function children() {
    var _context;

    return (0, _map.default)(_context = this.subSchemas).call(_context, function (subSchema, index) {
      var description = subSchema.get('description');
      var message = description; // TODO API should send translated strings instead of i18n code inside description
      // or send param with i18n code

      return SubSchemaSubSchema.extend({
        index: index,
        message: message
      });
    });
  }
});

exports.default = _default;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _Util = _interopRequireDefault(__webpack_require__(31));

var _ValidationUtil = _interopRequireDefault(__webpack_require__(199));

var _ContactSupport = _interopRequireDefault(__webpack_require__(541));

var _TextBox = _interopRequireDefault(__webpack_require__(36));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var UnlockAccountControllernoFactorsError = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "account.unlock.noFactorsEnabled"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 172
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  })
});

var UnlockAccountControllerFooter = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.noAccessToEmail"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 173
          },
          "end": {
            "line": 1,
            "column": 223
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 95
          }
        }
      })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 99
          },
          "end": {
            "line": 1,
            "column": 234
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function clickJsBack(e) {
      e.preventDefault();
      this.back();
    },
    'click .js-contact-support': function clickJsContactSupport(e) {
      e.preventDefault();
      this.state.trigger('contactSupport');
      this.$('.js-contact-support').hide();
    }
  },
  getTemplateData: function getTemplateData() {
    return this.settings.pick('helpSupportNumber');
  },
  back: function back() {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});

var _default = _FormController.default.extend({
  className: 'account-unlock',
  Model: {
    props: {
      username: ['string', true],
      factorType: ['string', true]
    },
    validate: function validate() {
      return _ValidationUtil.default.validateUsername(this);
    },
    save: function save() {
      var self = this;
      return this.startTransaction(function (authClient) {
        return authClient.unlockAccount({
          username: self.settings.transformUsername(self.get('username'), _Enums.default.UNLOCK_ACCOUNT),
          factorType: self.get('factorType')
        });
      }).catch(function () {//need empty fail handler on model to display errors on form
      });
    }
  },
  Form: {
    noButtonBar: true,
    title: _okta._.partial(_okta.loc, 'account.unlock.title', 'login'),
    formChildren: function formChildren() {
      var smsEnabled = this.settings.get('features.smsRecovery');
      /*eslint complexity: [2, 9] max-statements: [2, 24] */

      var callEnabled = this.settings.get('features.callRecovery');
      var emailEnabled = this.settings.get('features.emailRecovery');
      var noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
      var formChildren = [];
      var form = this;

      if (noFactorsEnabled) {
        this.add(UnlockAccountControllernoFactorsError, '.o-form-error-container');
      } else {
        formChildren.push(_FormType.default.Input({
          label: (0, _okta.loc)('account.unlock.email.or.username.placeholder', 'login'),
          'label-top': true,
          explain: _Util.default.createInputExplain('account.unlock.email.or.username.tooltip', 'account.unlock.email.or.username.placeholder', 'login'),
          'explain-top': true,
          name: 'username',
          input: _TextBox.default,
          inputId: 'account-recovery-username',
          type: 'text',
          inlineValidation: false
        }));

        if (smsEnabled || callEnabled) {
          formChildren.push(_FormType.default.View({
            View: _okta.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function main(container, depth0, helpers, partials, data) {
                  var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }

                    return undefined;
                  };

                  return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "arguments": "mobileFactors",
                      "bundle": "login",
                      "code": "recovery.mobile.hint"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 32
                      },
                      "end": {
                        "line": 1,
                        "column": 109
                      }
                    }
                  })) + "</p>";
                },
                "useData": true
              }),
              getTemplateData: function getTemplateData() {
                var mobileFactors;

                if (smsEnabled && callEnabled) {
                  mobileFactors = (0, _okta.loc)('recovery.smsOrCall');
                } else if (callEnabled) {
                  mobileFactors = (0, _okta.loc)('recovery.call');
                } else {
                  mobileFactors = (0, _okta.loc)('recovery.sms');
                }

                return {
                  mobileFactors: mobileFactors
                };
              }
            })
          }));
        }

        if (smsEnabled) {
          this.$el.addClass('forgot-password-sms-enabled');
          formChildren.push(this.createRecoveryFactorButton('sms-button', 'account.unlock.sendText', _Enums.default.RECOVERY_FACTOR_TYPE_SMS, form));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_SMS);
        }

        if (callEnabled) {
          this.$el.addClass('forgot-password-call-enabled');
          formChildren.push(this.createRecoveryFactorButton('call-button', 'account.unlock.voiceCall', _Enums.default.RECOVERY_FACTOR_TYPE_CALL, form));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_CALL);
        }

        if (emailEnabled) {
          this.$el.addClass('forgot-password-email-enabled');
          formChildren.push(this.createRecoveryFactorButton('email-button', 'account.unlock.sendEmail', _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL, form));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_EMAIL);
        }
      }

      return formChildren;
    },
    initialize: function initialize() {
      this.listenTo(this, 'save', function () {
        this.options.appState.set('username', this.model.get('username'));
        this.model.save();
      });
      this.listenTo(this.state, 'contactSupport', function () {
        this.add(_ContactSupport.default, '.o-form-error-container');
      });
    },
    setDefaultFactorType: function setDefaultFactorType(factorType) {
      if (_okta._.isEmpty(this.model.get('factorType'))) {
        this.model.set('factorType', factorType);
      }
    },
    createRecoveryFactorButton: function createRecoveryFactorButton(className, labelCode, factorType, form) {
      return _FormType.default.Button({
        attributes: {
          'data-se': className
        },
        className: 'button button-primary button-wide ' + className,
        title: (0, _okta.loc)(labelCode, 'login'),
        click: function click() {
          form.clearErrors();

          if (this.model.isValid()) {
            this.model.set('factorType', factorType);
            form.trigger('save', this.model);
          }
        }
      });
    }
  },
  Footer: UnlockAccountControllerFooter
});

exports.default = _default;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'account-unlock-email-sent',
  Model: function Model() {
    return {
      local: {
        userFullName: ['string', false, this.options.appState.get('userFullName')]
      }
    };
  },
  Form: {
    title: _okta._.partial(_okta.loc, 'account.unlock.emailSent.title', 'login'),
    subtitle: function subtitle() {
      var username = this.options.appState.get('username');
      return (0, _okta.loc)('account.unlock.emailSent.desc', 'login', [username]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'unlock-email-sent'
    },
    formChildren: function formChildren() {
      return [_FormType.default.Button({
        title: (0, _okta.loc)('goback', 'login'),
        className: 'button button-primary button-wide',
        attributes: {
          'data-se': 'back-button'
        },
        click: function click() {
          this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
          this.options.appState.trigger('navigate', '');
        }
      })];
    }
  },
  initialize: function initialize(options) {
    this.settings.callGlobalSuccess(_Enums.default.UNLOCK_ACCOUNT_EMAIL_SENT, {
      username: options.appState.get('username')
    });
  }
});

exports.default = _default;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

var _FooterMFA = _interopRequireDefault(__webpack_require__(159));

/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var Util = _okta.internal.util.Util;

var _default = _FormController.default.extend({
  className: 'verify-custom-factor custom-factor-form',
  Model: {
    props: {
      rememberDevice: 'boolean'
    },
    initialize: function initialize() {
      var rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).


      this.set('rememberDevice', rememberDevice);
    },
    save: function save() {
      var _this = this;

      var rememberDevice = !!this.get('rememberDevice');
      return this.manageTransaction(function (transaction, setTransaction) {
        var data = {
          rememberDevice: rememberDevice
        };

        var factor = _okta._.findWhere(transaction.factors, {
          provider: _this.get('provider'),
          factorType: _this.get('factorType')
        });

        return factor.verify(data).then(function (trans) {
          setTransaction(trans);

          var url = _this.appState.get('verifyCustomFactorRedirectUrl');

          if (url !== null) {
            Util.redirect(url);
          }
        }).catch(function (err) {
          throw err;
        });
      });
    }
  },
  Form: function Form() {
    var factors = this.options.appState.get('factors');
    var factor = factors.findWhere({
      provider: this.options.provider,
      factorType: this.options.factorType
    });
    var vendorName = factor.get('vendorName');
    var saveText = (0, _okta.loc)('mfa.challenge.verify', 'login');
    var subtitle = (0, _okta.loc)('verify.customFactor.subtitle', 'login', [vendorName]);
    return {
      autoSave: true,
      title: vendorName,
      save: saveText,
      subtitle: subtitle,
      attributes: {
        'data-se': 'factor-custom'
      },
      initialize: function initialize() {
        if (this.options.appState.get('allowRememberDevice')) {
          this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
          });
        }
      },
      formChildren: function formChildren() {
        var result = [];
        var lastFailedChallengeFactorData = this.options.appState.get('lastFailedChallengeFactorData');

        if (lastFailedChallengeFactorData) {
          result.push(_FormType.default.View({
            View: new _HtmlErrorMessageView.default({
              message: lastFailedChallengeFactorData.errorMessage
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }

        return result;
      }
    };
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaChallenge')) {
      return true;
    }
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  initialize: function initialize() {
    this.model.set('provider', this.options.provider);
    this.model.set('factorType', this.options.factorType);
    this.addFooter(_FooterMFA.default);
  }
});

exports.default = _default;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _okta = __webpack_require__(2);

var _duo = _interopRequireDefault(__webpack_require__(327));

var _q = _interopRequireDefault(__webpack_require__(43));

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FooterMFA = _interopRequireDefault(__webpack_require__(159));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint camelcase: 0 */
var _default = _FormController.default.extend({
  className: 'mfa-verify-duo duo-form',
  Model: {
    props: {
      host: 'string',
      signature: 'string',
      postAction: 'string',
      factorId: 'string',
      stateToken: 'string',
      rememberDevice: 'boolean'
    },
    initialize: function initialize() {
      var rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).


      this.set('rememberDevice', rememberDevice);
    },
    getInitOptions: function getInitOptions() {
      var rememberDevice = !!this.get('rememberDevice');
      return this.doTransaction(function (transaction) {
        var data = {
          rememberDevice: rememberDevice
        };

        var factor = _okta._.findWhere(transaction.factors, {
          provider: 'DUO',
          factorType: 'web'
        });

        return factor.verify(data).catch(function (err) {
          // Clean up the cookie on failure.
          throw err;
        });
      }, true
      /* rethrow errors */
      );
    },
    verify: function verify(signedResponse) {
      var url = this.get('postAction');
      var factorId = this.get('factorId');
      var self = this;
      var data = {
        id: factorId,
        stateToken: this.get('stateToken'),
        sig_response: signedResponse
      }; // Note: We should be doing this in OktaAuth! Fix when it's updated.

      var rememberDevice = this.get('rememberDevice'); // We don't actually use authClient.post() here (unlike all the other cases in the
      // sign-in widget) since the endpoint is wired to accept serialized form post instead
      // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
      // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
      // are the only two places where we actually do this.
      // NOTE - If we ever decide to change this, we should test this very carefully.

      return (0, _q.default)(_okta.$.post(url, data)).then(function () {
        return self.doTransaction(function (transaction) {
          var data;

          if (rememberDevice) {
            data = {
              rememberDevice: rememberDevice
            };
          }

          return transaction.poll(data);
        });
      }).catch(function (err) {
        self.trigger('error', self, err.xhr);
      });
    }
  },
  Form: {
    autoSave: true,
    noButtonBar: true,
    title: _okta._.partial(_okta.loc, 'factor.duo'),
    attributes: {
      'data-se': 'factor-duo'
    },
    postRender: function postRender() {
      this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');

      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }

      _duo.default.init({
        host: this.model.get('host'),
        sig_request: this.model.get('signature'),
        iframe: this.$('iframe').get(0),
        post_action: (0, _bind.default)(_okta._).call(_okta._, this.model.verify, this.model)
      });
    }
  },
  fetchInitialData: function fetchInitialData() {
    var self = this;
    return this.model.getInitOptions().then(function (trans) {
      var res = trans.data;

      if (!res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.verification) {
        throw new Error('Response does not have duo verification options');
      }

      var verification = res._embedded.factor._embedded.verification;
      self.model.set({
        host: verification.host,
        signature: verification.signature,
        postAction: verification._links.complete.href,
        factorId: res._embedded.factor.id,
        stateToken: res.stateToken
      });
    });
  },
  trapAuthResponse: function trapAuthResponse() {
    if (this.options.appState.get('isMfaChallenge')) {
      return true;
    }
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});

exports.default = _default;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _FooterWithBackLink = _interopRequireDefault(__webpack_require__(538));

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 10], max-params: [2, 11] */
var Util = _okta.internal.util.Util;

var _default = _FormController.default.extend({
  className: 'piv-cac-card',
  Model: {
    save: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var self, pivConfig, data, res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.trigger('request');
                self = this;
                pivConfig = this.settings.get('piv');
                data = {
                  fromURI: this.settings.get('relayState'),
                  isCustomDomain: pivConfig.isCustomDomain
                };
                _context.prev = 4;
                _context.next = 7;
                return this.getCert(pivConfig.certAuthUrl);

              case 7:
                _context.next = 9;
                return this.postCert(pivConfig.certAuthUrl, data);

              case 9:
                res = _context.sent;
                Util.redirect(res.redirectUrl);
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);

                if (_okta._.isEmpty(_context.t0.responseJSON) && !_context.t0.responseText) {
                  _context.t0.responseJSON = {
                    errorSummary: (0, _okta.loc)('piv.cac.error', 'login')
                  };
                }

                self.trigger('error', self, _context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 13]]);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }(),
    getCert: function getCert(certAuthUrl) {
      return _okta.$.get({
        url: certAuthUrl,
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function beforeSend() {// overriding this function to prevent our jquery-wrapper from
          // setting headers. Need to keep this a simple request in order for
          // PIV / CAC to work in IE.
        }
      });
    },
    postCert: function postCert(certAuthUrl, data) {
      return _okta.$.post({
        url: certAuthUrl,
        xhrFields: {
          withCredentials: true
        },
        data: (0, _stringify.default)(data),
        contentType: 'text/plain',
        beforeSend: function beforeSend() {// overriding this function to prevent our jquery-wrapper from
          // setting headers. Need to keep this a simple request in order for
          // PIV / CAC to work in IE.
        }
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _okta._.partial(_okta.loc, 'piv.cac.title', 'login'),
    className: 'piv-cac-card',
    noCancelButton: true,
    save: _okta._.partial(_okta.loc, 'retry', 'login'),
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: [_FormType.default.View({
      View: _okta.View.extend({
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return "<div class=\"piv-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "piv.cac.card.insert"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 32
                },
                "end": {
                  "line": 1,
                  "column": 82
                }
              }
            })) + "</p><div data-se=\"piv-waiting\" class=\"okta-waiting-spinner\"></div></div>";
          },
          "useData": true
        })
      })
    })],
    _startEnrollment: function _startEnrollment() {
      this.$('.okta-waiting-spinner').show();
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function _stopEnrollment() {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar').show();
    },
    postRender: function postRender() {
      var _this = this;

      _okta._.defer(function () {
        _this.model.save();
      });
    }
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterWithBackLink.default
});

exports.default = _default;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(547);

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(44);
var getPrototypeOf = __webpack_require__(234);
var setPrototypeOf = __webpack_require__(312);
var create = __webpack_require__(191);
var defineProperty = __webpack_require__(86);
var createPropertyDescriptor = __webpack_require__(129);
var iterate = __webpack_require__(119);
var createNonEnumerableProperty = __webpack_require__(85);
var InternalStateModule = __webpack_require__(95);

var setInternalState = InternalStateModule.set;
var getInternalAggregateErrorState = InternalStateModule.getterFor('AggregateError');

var $AggregateError = function AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  if (setPrototypeOf) {
    that = setPrototypeOf(new Error(message), getPrototypeOf(that));
  }
  var errorsArray = [];
  iterate(errors, errorsArray.push, errorsArray);
  if (DESCRIPTORS) setInternalState(that, { errors: errorsArray, type: 'AggregateError' });
  else that.errors = errorsArray;
  if (message !== undefined) createNonEnumerableProperty(that, 'message', String(message));
  return that;
};

$AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ''),
  name: createPropertyDescriptor(5, 'AggregateError')
});

if (DESCRIPTORS) defineProperty.f($AggregateError.prototype, 'errors', {
  get: function () {
    return getInternalAggregateErrorState(this).errors;
  },
  configurable: true
});

$({ global: true }, {
  AggregateError: $AggregateError
});


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(513);


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var newPromiseCapabilityModule = __webpack_require__(197);
var perform = __webpack_require__(241);

// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$({ target: 'Promise', stat: true }, {
  'try': function (callbackfn) {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(callbackfn);
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var aFunction = __webpack_require__(84);
var getBuiltIn = __webpack_require__(96);
var newPromiseCapabilityModule = __webpack_require__(197);
var perform = __webpack_require__(241);
var iterate = __webpack_require__(119);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://github.com/tc39/proposal-promise-any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (e) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = e;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

__webpack_require__(536);

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FidoUtil = _interopRequireDefault(__webpack_require__(328));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

var _FooterMFA = _interopRequireDefault(__webpack_require__(159));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* global u2f */
function getRegisteredKeysSequence(factors) {
  var keys = [];

  _okta._.each(factors, function (factor) {
    keys.push({
      version: factor.profile.version,
      keyHandle: factor.profile.credentialId
    });
  });

  return keys;
}

var _default = _FormController.default.extend({
  className: 'mfa-verify verify-u2f',
  Model: {
    props: {
      rememberDevice: 'boolean'
    },
    initialize: function initialize() {
      var rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).


      this.set('rememberDevice', rememberDevice);
    },
    save: function save() {
      this.trigger('request');
      return this.doTransaction(function (transaction) {
        var factor;

        if (transaction.factorTypes) {
          factor = _okta._.findWhere(transaction.factorTypes, {
            factorType: 'u2f'
          });
        } else {
          factor = _okta._.findWhere(transaction.factors, {
            factorType: 'u2f',
            provider: 'FIDO'
          });
        }

        var self = this;
        return factor.verify().then(function (transaction) {
          var registeredKeys;
          var appId;
          var nonce;

          if (transaction.factors) {
            var factors = transaction.factors;
            appId = factors[0]['profile']['appId'];
            nonce = transaction.challenge.nonce;
            registeredKeys = getRegisteredKeysSequence(factors);
          } else {
            var factorData = transaction.factor;
            appId = factorData.profile.appId;
            nonce = factorData.challenge.nonce;
            registeredKeys = [{
              version: _FidoUtil.default.getU2fVersion(),
              keyHandle: factorData.profile.credentialId
            }];
          }

          self.trigger('request');

          var deferred = _q.default.defer();

          u2f.sign(appId, nonce, registeredKeys, function (data) {
            self.trigger('errors:clear');

            if (data.errorCode && data.errorCode !== 0) {
              var isOneFactor = self.options.appState.get('factors').length === 1;
              deferred.reject(new _Errors.default.U2FError({
                xhr: {
                  responseJSON: {
                    errorSummary: _FidoUtil.default.getU2fVerifyErrorMessageByCode(data.errorCode, isOneFactor)
                  }
                }
              }));
            } else {
              var rememberDevice = !!self.get('rememberDevice');
              return factor.verify({
                clientData: data.clientData,
                signatureData: data.signatureData,
                rememberDevice: rememberDevice
              }).then(deferred.resolve);
            }
          });
          return deferred.promise;
        });
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _okta._.partial(_okta.loc, 'factor.u2f', 'login'),
    className: 'verify-u2f-form',
    noCancelButton: true,
    save: _okta._.partial(_okta.loc, 'verify.u2f.retry', 'login'),
    noButtonBar: function noButtonBar() {
      return !_FidoUtil.default.isU2fAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function formChildren() {
      var result = [];

      if (!_FidoUtil.default.isU2fAvailable()) {
        var errorMessageKey = 'u2f.error.factorNotSupported';

        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
        }

        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _okta.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      } else {
        result.push(_FormType.default.View({
          View: _okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var alias1 = depth0 != null ? depth0 : container.nullContext || {},
                    alias2 = container.hooks.helperMissing,
                    alias3 = container.escapeExpression,
                    lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"u2f-verify-text\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "verify.u2f.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 32
                    },
                    "end": {
                      "line": 1,
                      "column": 86
                    }
                  }
                })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "verify.u2f.instructionsBluetooth"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 93
                    },
                    "end": {
                      "line": 1,
                      "column": 156
                    }
                  }
                })) + "</p><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
              },
              "useData": true
            })
          })
        }));
      }

      if (this.options.appState.get('allowRememberDevice')) {
        result.push(_FormType.default.Input({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        }));
      }

      return result;
    },
    postRender: function postRender() {
      var _this = this;

      _okta._.defer(function () {
        if (_FidoUtil.default.isU2fAvailable()) {
          _this.model.save();
        } else {
          _this.$('[data-se="u2f-waiting"]').addClass('hide');
        }
      });
    },
    _startEnrollment: function _startEnrollment() {
      this.$('.okta-waiting-spinner').removeClass('hide');
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function _stopEnrollment() {
      this.$('.okta-waiting-spinner').addClass('hide');
      this.$('.o-form-button-bar').show();
    }
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});

exports.default = _default;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _q = _interopRequireDefault(__webpack_require__(43));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(243));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _webauthn = _interopRequireDefault(__webpack_require__(158));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

var _FooterMFA = _interopRequireDefault(__webpack_require__(159));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 10], max-params: [2, 11] */
function getAllowCredentials(factors) {
  var allowCredentials = [];

  _okta._.each(factors, function (factor) {
    allowCredentials.push({
      type: 'public-key',
      id: _CryptoUtil.default.strToBin(factor.profile.credentialId)
    });
  });

  return allowCredentials;
}

var _default = _FormController.default.extend({
  className: 'mfa-verify verify-webauthn',
  Model: {
    props: {
      rememberDevice: 'boolean'
    },
    initialize: function initialize() {
      var _this = this;

      var rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState); // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).


      this.set('rememberDevice', rememberDevice);
      this.appState.on('factorSwitched signOut', function () {
        if (_this.webauthnAbortController) {
          _this.webauthnAbortController.abort();

          _this.webauthnAbortController = null;
        }
      });
    },
    save: function save() {
      this.trigger('request');
      return this.doTransaction(function (transaction) {
        var factor;

        if (transaction.factorTypes) {
          factor = _okta._.findWhere(transaction.factorTypes, {
            factorType: 'webauthn'
          });
        } else {
          factor = _okta._.findWhere(transaction.factors, {
            factorType: 'webauthn',
            provider: 'FIDO'
          });
        }

        var self = this;
        return factor.verify().then(function (transaction) {
          var allowCredentials;
          var challenge;

          if (transaction.factors) {
            var factors = transaction.factors;
            challenge = transaction.challenge;
            allowCredentials = getAllowCredentials(factors);
          } else {
            var factorData = transaction.factor;
            challenge = factorData.challenge;
            allowCredentials = getAllowCredentials([factorData]);
          }

          self.trigger('request'); // verify via browser webauthn js

          var options = _okta._.extend({}, challenge, {
            allowCredentials: allowCredentials,
            challenge: _CryptoUtil.default.strToBin(challenge.challenge)
          });

          self.webauthnAbortController = new AbortController();
          return new _q.default(navigator.credentials.get({
            publicKey: options,
            signal: self.webauthnAbortController.signal
          })).then(function (assertion) {
            var rememberDevice = !!self.get('rememberDevice');
            return factor.verify({
              clientData: _CryptoUtil.default.binToStr(assertion.response.clientDataJSON),
              authenticatorData: _CryptoUtil.default.binToStr(assertion.response.authenticatorData),
              signatureData: _CryptoUtil.default.binToStr(assertion.response.signature),
              rememberDevice: rememberDevice
            });
          }).catch(function (error) {
            self.trigger('errors:clear'); // Do not display if it is abort error triggered by code when switching.
            // self.webauthnAbortController would be null if abort was triggered by code.

            if (!self.webauthnAbortController) {
              throw new _Errors.default.WebauthnAbortError();
            } else {
              throw new _Errors.default.WebAuthnError({
                xhr: {
                  responseJSON: {
                    errorSummary: error.message
                  }
                }
              });
            }
          }).finally(function () {
            // unset webauthnAbortController on successful authentication or error
            self.webauthnAbortController = null;
          });
        });
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _okta._.partial(_okta.loc, 'factor.webauthn.biometric', 'login'),
    className: 'verify-webauthn-form',
    noCancelButton: true,
    save: _okta._.partial(_okta.loc, 'mfa.challenge.verify', 'login'),
    noButtonBar: function noButtonBar() {
      return !_webauthn.default.isNewApiAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function formChildren() {
      var children = [];

      if (_webauthn.default.isNewApiAvailable()) {
        children.push(_FormType.default.View({
          View: _okta.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function main(container, depth0, helpers, partials, data) {
                var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }

                  return undefined;
                };

                return "<div class=\"webauthn-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "verify.webauthn.biometric.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 37
                    },
                    "end": {
                      "line": 1,
                      "column": 106
                    }
                  }
                })) + "</p><div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner\"></div></div>";
              },
              "useData": true
            })
          })
        }));
      } else {
        var errorMessageKey = 'webauthn.biometric.error.factorNotSupported';

        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
        }

        children.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _okta.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }

      if (this.options.appState.get('allowRememberDevice')) {
        children.push(_FormType.default.Input({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        }));
      }

      return children;
    },
    _startEnrollment: function _startEnrollment() {
      this.$('.okta-waiting-spinner').show();
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function _stopEnrollment() {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar [type="submit"]')[0].value = (0, _okta.loc)('verify.u2f.retry', 'login');
      this.$('.o-form-button-bar').show();
    }
  },
  postRender: function postRender() {
    var _this2 = this;

    _okta._.defer(function () {
      // Trigger browser prompt automatically for other browsers for better UX.
      if (_webauthn.default.isNewApiAvailable() && !_BrowserFeatures.default.isSafari()) {
        _this2.model.save();
      }
    });
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});

exports.default = _default;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _FormController = _interopRequireDefault(__webpack_require__(8));

var _FormType = _interopRequireDefault(__webpack_require__(12));

var _webauthn = _interopRequireDefault(__webpack_require__(158));

var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(107));

var _FooterMFA = _interopRequireDefault(__webpack_require__(159));

var _Spinner = _interopRequireDefault(__webpack_require__(540));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'mfa-verify verify-windows-hello',
  Model: {
    local: {
      __autoTriggered__: 'boolean'
    },
    save: function save() {
      if (!_webauthn.default.isAvailable()) {
        return;
      }

      this.trigger('request');
      var model = this;
      return this.doTransaction(function (transaction) {
        var factor = _okta._.findWhere(transaction.factors, {
          factorType: 'webauthn',
          provider: 'FIDO'
        });

        return factor.verify().then(function (verifyData) {
          var factorData = verifyData.factor;
          return _webauthn.default.getAssertion(factorData.challenge.nonce, [{
            id: factorData.profile.credentialId
          }]).then(function (assertion) {
            return factor.verify({
              authenticatorData: assertion.authenticatorData,
              clientData: assertion.clientData,
              signatureData: assertion.signature
            });
          }).then(function (data) {
            model.trigger('sync');
            model.trigger('signIn');
            return data;
          }).catch(function (error) {
            switch (error.message) {
              case 'AbortError':
              case 'NotFoundError':
              case 'NotSupportedError':
                model.trigger('abort', error.message);
                return transaction;
            }

            throw error;
          });
        });
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _okta._.partial(_okta.loc, 'factor.windowsHello', 'login'),
    subtitle: function subtitle() {
      return _webauthn.default.isAvailable() ? (0, _okta.loc)('verify.windowsHello.subtitle', 'login') : '';
    },
    save: _okta._.partial(_okta.loc, 'verify.windowsHello.save', 'login'),
    customSavingState: {
      stop: 'abort'
    },
    modelEvents: function modelEvents() {
      if (!_webauthn.default.isAvailable()) {
        return {};
      }

      return {
        request: '_startEnrollment',
        error: '_stopEnrollment',
        abort: '_stopEnrollment',
        signIn: '_successEnrollment'
      };
    },
    noButtonBar: function noButtonBar() {
      return !_webauthn.default.isAvailable();
    },
    formChildren: function formChildren() {
      var result = [];

      if (!_webauthn.default.isAvailable()) {
        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _okta.loc)('enroll.windowsHello.error.notWindows', 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }

      result.push(_FormType.default.View({
        View: new _Spinner.default({
          model: this.model,
          visible: false
        })
      }));
      return result;
    },
    postRender: function postRender() {
      if (this.options.appState.get('factors').length === 1 && !this.model.get('__autoTriggered__')) {
        this.model.set('__autoTriggered__', true);
        this.model.save();
      }
    },
    _startEnrollment: function _startEnrollment() {
      this.subtitle = (0, _okta.loc)('verify.windowsHello.subtitle.loading', 'login');
      this.model.trigger('spinner:show');

      this._resetErrorMessage();

      this.render();
      this.$('.o-form-button-bar').addClass('hide');
    },
    _stopEnrollment: function _stopEnrollment(errorMessage) {
      this.subtitle = (0, _okta.loc)('verify.windowsHello.subtitle', 'login');
      this.model.trigger('spinner:hide');
      this.$('.o-form-button-bar').removeClass('hide');
      var message;

      switch (errorMessage) {
        case 'NotFoundError':
          message = this.options.appState.get('factors').length > 1 ? (0, _okta.loc)('verify.windowsHello.error.notFound.selectAnother', 'login') : (0, _okta.loc)('verify.windowsHello.error.notFound', 'login');
          break;

        case 'NotSupportedError':
          message = (0, _okta.loc)('enroll.windowsHello.error.notConfiguredHtml', 'login');
          break;
      }

      this._resetErrorMessage();

      if (message) {
        var messageView = new _HtmlErrorMessageView.default({
          message: message
        });
        this.$('.o-form-error-container').addClass('o-form-has-errors');
        this.add(messageView, {
          selector: '.o-form-error-container'
        });
        this._errorMessageView = this.last();
      }

      this.render();
    },
    _successEnrollment: function _successEnrollment() {
      this.subtitle = this.settings.get('brandName') ? (0, _okta.loc)('verify.windowsHello.subtitle.signingIn.specific', 'login', [this.settings.get('brandName')]) : (0, _okta.loc)('verify.windowsHello.subtitle.signingIn.generic', 'login');
      this.render();
      this.$('.o-form-button-bar').addClass('hide');
    },
    _resetErrorMessage: function _resetErrorMessage() {
      this._errorMessageView && this._errorMessageView.remove();
      this._errorMessageView = undefined;
      this.clearErrors();
    }
  },
  back: function back() {// Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});

exports.default = _default;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _FormController = _interopRequireDefault(__webpack_require__(8));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'error-state',
  Model: {},
  Form: {
    noButtonBar: true
  }
});

exports.default = _default;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _AppState = _interopRequireDefault(__webpack_require__(1226));

var _Settings = _interopRequireDefault(__webpack_require__(548));

var _Bundles = _interopRequireDefault(__webpack_require__(155));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _AuthContainer = _interopRequireDefault(__webpack_require__(550));

var _Header = _interopRequireDefault(__webpack_require__(551));

var _SecurityBeacon = _interopRequireDefault(__webpack_require__(552));

var _Animations = _interopRequireDefault(__webpack_require__(247));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _ColorsUtil = _interopRequireDefault(__webpack_require__(553));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

var _Util = _interopRequireDefault(__webpack_require__(31));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-params: [2, 16], max-statements: [2, 18] */
// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)
function isStateLessRouteHandler(router, fn) {
  return (0, _find.default)(_okta._).call(_okta._, router.stateLessRouteHandlers, function (routeName) {
    return fn === router[routeName];
  });
}

function beaconIsAvailable(Beacon, settings) {
  if (!Beacon) {
    return false;
  }

  if (Beacon === _SecurityBeacon.default) {
    return settings.get('features.securityImage');
  }

  return true;
}
/**
 * TODO: deprecated by `util/LanguageUtil.loadLanguage`
 */


function loadLanguage(appState, i18n, assetBaseUrl, assetRewrite) {
  var timeout = (0, _setTimeout2.default)(function () {
    // Trigger a spinner if we're waiting on a request for a new language.
    appState.trigger('loading', true);
  }, 200);
  return _Bundles.default.loadLanguage(appState.get('languageCode'), i18n, {
    baseUrl: assetBaseUrl,
    rewrite: assetRewrite
  }).then(function () {
    clearTimeout(timeout);
    appState.trigger('loading', false);
  });
}

var _default = _okta.Router.extend({
  Events: _okta.Backbone.Events,
  initialize: function initialize(options) {
    // Create a default success and/or error handler if
    // one is not provided.
    if (!options.globalSuccessFn) {
      options.globalSuccessFn = function () {};
    }

    if (!options.globalErrorFn) {
      options.globalErrorFn = function (err) {
        _Logger.default.error(err);
      };
    }

    this.settings = new _Settings.default(_okta._.omit(options, 'el', 'authClient'), {
      parse: true
    });
    this.settings.setAuthClient(options.authClient);

    if (!options.el) {
      this.settings.callGlobalError(new _Errors.default.ConfigError((0, _okta.loc)('error.required.el')));
    }

    (0, _okta.$)('body > div').on('click', function () {// OKTA-69769 Tooltip wont close on iPhone/iPad
      // Registering a click handler on the first div
      // allows a tap that falls outside the tooltip
      // to be registered as a tap by iOS
      // and then the open tooltip will lose focus and close.
    });
    this.appState = new _AppState.default({
      baseUrl: this.settings.get('baseUrl'),
      settings: this.settings
    }, {
      parse: true
    });
    var wrapper = new _AuthContainer.default({
      appState: this.appState
    });
    (0, _okta.$)(options.el).append(wrapper.render().$el);
    this.el = "#".concat(_Enums.default.WIDGET_CONTAINER_ID);
    this.header = new _Header.default({
      el: this.el,
      appState: this.appState,
      settings: this.settings
    });
    this.listenTo(this.appState, 'change:transactionError', function (appState, err) {
      _RouterUtil.default.routeAfterAuthStatusChangeError(this, err);
    });
    this.listenTo(this.appState, 'change:transaction', function (appState, trans) {
      _RouterUtil.default.routeAfterAuthStatusChange(this, trans.data);
    });
    this.listenTo(this.appState, 'navigate', function (url) {
      this.navigate(url, {
        trigger: true
      });
    });
  },
  execute: function execute(cb, args) {
    var recoveryToken = this.settings.get('recoveryToken'); // Recovery flow with a token passed through widget settings

    if (recoveryToken) {
      this.settings.unset('recoveryToken');
      this.navigate(_RouterUtil.default.createRecoveryUrl(recoveryToken), {
        trigger: true
      });
      return;
    } // Refresh flow with a stateToken passed through widget settings


    var stateToken = this.settings.get('stateToken');

    if (stateToken) {
      this.settings.unset('stateToken');
      this.navigate(_RouterUtil.default.createRefreshUrl(stateToken), {
        trigger: true
      });
      return;
    } // Normal flow - we've either navigated to a stateless page, or are
    // in the middle of an auth flow


    var trans = this.appState.get('transaction');

    if (trans && trans.data || isStateLessRouteHandler(this, cb)) {
      cb.apply(this, args);
      return;
    } // StateToken cookie exists on page load, and we are on a stateful url


    if (this.settings.getAuthClient().tx.exists()) {
      this.navigate(_RouterUtil.default.createRefreshUrl(), {
        trigger: true
      });
      return;
    } // We've hit a page that requires state, but have no stateToken - redirect
    // back to primary auth


    this.navigate('', {
      trigger: true
    });
  },
  // Overriding the default navigate method to allow the widget consumer
  // to "turn off" routing - if features.router is false, the browser
  // location bar will not update when the router navigates
  navigate: function navigate(fragment, options) {
    if (this.settings.get('features.router')) {
      return _okta.Router.prototype.navigate.apply(this, arguments);
    }

    if (options && options.trigger) {
      return _okta.Backbone.history.loadUrl(fragment);
    }
  },
  render: function render(Controller, options) {
    var _this = this;

    options || (options = {});
    var Beacon = options.Beacon;

    var controllerOptions = _okta._.extend({
      settings: this.settings,
      appState: this.appState
    }, _okta._.omit(options, 'Beacon')); // Since we have a wrapper view, render our wrapper and use its content
    // element as our new el.
    // Note: Render it here because we know dom is ready at this point


    if (!this.header.rendered()) {
      this.el = this.header.render().getContentEl();
    } // If we need to load a language (or apply custom i18n overrides), do
    // this now and re-run render after it's finished.


    if (!_Bundles.default.isLoaded(this.appState.get('languageCode'))) {
      return loadLanguage(this.appState, this.settings.get('i18n'), this.settings.get('assets.baseUrl'), this.settings.get('assets.rewrite')).then((0, _bind.default)(_okta._).call(_okta._, this.render, this, Controller, options));
    } // Load the custom colors only on the first render


    if (this.settings.get('colors.brand') && !_ColorsUtil.default.isLoaded()) {
      var colors = {
        brand: this.settings.get('colors.brand')
      };

      _ColorsUtil.default.addStyle(colors);
    }

    var oldController = this.controller;
    this.controller = new Controller(controllerOptions); // Bubble up all controller events

    this.listenTo(this.controller, 'all', this.trigger); // First run fetchInitialData, in case the next controller needs data
    // before it's initial render. This will leave the current page in a
    // loading state.

    return this.controller.fetchInitialData().then(function () {
      // Beacon transition occurs in parallel to page swap
      if (!beaconIsAvailable(Beacon, _this.settings)) {
        Beacon = null;
      }

      _this.header.setBeacon(Beacon, controllerOptions);

      _this.controller.render();

      if (!oldController) {
        _this.el.append(_this.controller.el);

        _this.controller.postRenderAnimation();

        return;
      }

      return _Animations.default.swapPages({
        $parent: _this.el,
        $oldRoot: oldController.$el,
        $newRoot: _this.controller.$el,
        dir: oldController.state.get('navigateDir'),
        ctx: _this,
        success: function success() {
          var flashError = this.appState.get('flashError');
          var model = this.controller.model;
          oldController.remove();
          oldController.$el.remove();
          this.controller.postRenderAnimation();

          if (flashError) {
            var errorKey = this.settings.get('features.mfaOnlyFlow') ? 'error.mfa.only.expired.session' : 'error.expired.session';
            model.trigger('error', model, {
              responseJSON: {
                errorSummary: (0, _okta.loc)(errorKey)
              }
            });
            this.appState.unset('flashError');

            _Util.default.triggerAfterError(this.controller, flashError);
          }
        }
      });
    }).catch(function () {
      // OKTA-69665 - if an error occurs in fetchInitialData, we're left in
      // a state with two active controllers. Therefore, we clean up the
      // old one. Note: This explicitly handles the invalid token case -
      // if we get some other type of error which doesn't force a redirect,
      // we will probably be left in a bad state. I.e. old controller is
      // dropped and new controller is not rendered.
      if (oldController) {
        oldController.remove();
        oldController.$el.remove();
      }
    });
  },
  start: function start() {
    var _this2 = this;

    var pushState = false; // Support for browser's back button.

    if (window.addEventListener && this.settings.get('features.router')) {
      window.addEventListener('popstate', function (e) {
        if (_this2.controller.back) {
          e.preventDefault();
          e.stopImmediatePropagation();

          _this2.controller.back();
        }
      });
      pushState = _BrowserFeatures.default.supportsPushState();
    }

    _okta.Router.prototype.start.call(this, {
      pushState: pushState
    });
  },
  hide: function hide() {
    this.header.$el.hide();
  },
  show: function show() {
    this.header.$el.show();
  },
  remove: function remove() {
    if (this.controller) {
      this.controller.remove();
    }

    this.header.$el.remove();

    _Bundles.default.remove();

    _okta.Backbone.history.stop();
  }
});

exports.default = _default;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _startsWith = _interopRequireDefault(__webpack_require__(239));

var _map = _interopRequireDefault(__webpack_require__(40));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Factor = _interopRequireDefault(__webpack_require__(242));

var _q = _interopRequireDefault(__webpack_require__(43));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _Errors = _interopRequireDefault(__webpack_require__(55));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var DEFAULT_APP_LOGO = '/img/logos/default.png'; // Keep track of stateMachine with this special model. Some reasons to not
// keep it generic:
// 1. We know exactly what we're using appState for by requiring props
// 2. Can have some derived functions to help us translate the lastAuthRes

var USER_NOT_SEEN_ON_DEVICE = '/img/security/unknown.png';
var UNDEFINED_USER = '/img/security/default.png';
var NEW_USER = '/img/security/unknown-device.png';
var NEW_USER_IMAGE_DESCRIPTION = '';
var UNDEFINED_USER_IMAGE_DESCRIPTION = '';
var UNKNOWN_IMAGE_DESCRIPTION = '';

var securityImageUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return alias4((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "baseUrl",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 11
        }
      }
    }) : helper)) + "/login/getimage?username=" + alias4((helper = (helper = lookupProperty(helpers, "username") || (depth0 != null ? lookupProperty(depth0, "username") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "username",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 36
        },
        "end": {
          "line": 1,
          "column": 48
        }
      }
    }) : helper));
  },
  "useData": true
});

function getSecurityImage(baseUrl, username, deviceFingerprint) {
  // When the username is empty, we want to show the default image.
  if (_okta._.isEmpty(username) || _okta._.isUndefined(username)) {
    return (0, _q.default)({
      securityImage: UNDEFINED_USER,
      securityImageDescription: UNDEFINED_USER_IMAGE_DESCRIPTION
    });
  } // Reserved characters in the username must be escaped before the query can be safely executed


  username = encodeURIComponent(username);
  var url = securityImageUrlTpl({
    baseUrl: baseUrl,
    username: username
  });
  var data = {
    url: url,
    dataType: 'json'
  };

  if (deviceFingerprint) {
    data['headers'] = {
      'X-Device-Fingerprint': deviceFingerprint
    };
  }

  return (0, _q.default)(_okta.$.ajax(data)).then(function (res) {
    if (res.pwdImg === USER_NOT_SEEN_ON_DEVICE) {
      // When we get an unknown.png security image from OKTA,
      // we want to show the unknown-device security image.
      // We are mapping the server's img url to a new one because
      // we still need to support the original login page.
      return {
        securityImage: NEW_USER,
        securityImageDescription: NEW_USER_IMAGE_DESCRIPTION
      };
    }

    return {
      securityImage: res.pwdImg,
      securityImageDescription: res.imageDescription || UNKNOWN_IMAGE_DESCRIPTION
    };
  });
}

function getMinutesString(factorLifetimeInMinutes) {
  if (factorLifetimeInMinutes > 60 && factorLifetimeInMinutes <= 1440) {
    var lifetimeInHours = factorLifetimeInMinutes / 60;
    return (0, _okta.loc)('hours', 'login', [lifetimeInHours]);
  } else if (factorLifetimeInMinutes > 1440) {
    var lifetimeInDays = factorLifetimeInMinutes / 1440;
    return (0, _okta.loc)('days', 'login', [lifetimeInDays]);
  } //Use minutes as the time unit by default


  if (factorLifetimeInMinutes === 1) {
    return (0, _okta.loc)('minutes.oneMinute', 'login');
  }

  return (0, _okta.loc)('minutes', 'login', [factorLifetimeInMinutes]);
}

function getGracePeriodRemainingDays(gracePeriodEndDate) {
  var endDate = new Date(gracePeriodEndDate).getTime();
  var remainingDays = Math.floor((endDate - new Date().getTime()) / (1000 * 3600 * 24));
  return remainingDays;
}

function combineFactorsObjects(factorTypes, factors) {
  var addedFactorTypes = [];
  var combinedFactors = [];

  _okta._.each(factors, function (factor) {
    var factorType = factor.factorType;

    if (!_okta._.contains(addedFactorTypes, factorType)) {
      var factorTypeObj = _okta._.findWhere(factorTypes, {
        factorType: factorType
      });

      if (factorTypeObj) {
        addedFactorTypes.push(factorType);
        combinedFactors.push(factorTypeObj);
      } else {
        combinedFactors.push(factor);
      }
    }
  });

  return combinedFactors;
}

var _default = _okta.Model.extend({
  initialize: function initialize() {
    // Handle this in initialize (as opposed to a derived property) because
    // the operation is asynchronous
    if (this.settings.get('features.securityImage')) {
      var self = this;
      this.listenTo(this, 'change:username', function (model, username) {
        getSecurityImage(this.get('baseUrl'), username, this.get('deviceFingerprint')).then(function (image) {
          model.set('securityImage', image.securityImage);
          model.set('securityImageDescription', image.securityImageDescription);
          model.unset('deviceFingerprint'); //Fingerprint can only be used once
        }).fail(function (jqXhr) {
          // Only notify the consumer on a CORS error
          if (_BrowserFeatures.default.corsIsNotEnabled(jqXhr)) {
            self.settings.callGlobalError(new _Errors.default.UnsupportedBrowserError((0, _okta.loc)('error.enabled.cors')));
          } else {
            throw jqXhr;
          }
        }).done();
      });
    }
  },
  local: {
    baseUrl: 'string',
    lastAuthResponse: ['object', true, {}],
    transaction: 'object',
    transactionError: 'object',
    username: 'string',
    factors: 'object',
    policy: 'object',
    securityImage: ['string', true, UNDEFINED_USER],
    securityImageDescription: ['string', true, UNDEFINED_USER_IMAGE_DESCRIPTION],
    userCountryCode: 'string',
    userPhoneNumber: 'string',
    factorActivationType: 'string',
    flashError: 'object',
    beaconType: 'string',
    deviceFingerprint: 'string',
    // valid only once
    typingPattern: 'string',
    // Note: languageCode is special in that it is shared between Settings
    // and AppState. Settings is the *configured* language, and is static.
    // AppState is the dynamic language state - it can be changed via a
    // language picker, etc.
    // Note: this is conceptial feasible but not yet being implemented.
    languageCode: ['string', true],
    disableUsername: ['boolean', false, false],
    trapMfaRequiredResponse: ['boolean', false, false],
    lastFailedChallengeFactorData: ['object', false]
  },
  setAuthResponse: function setAuthResponse(res) {
    var _this = this;

    // Because of MFA_CHALLENGE (i.e. DUO), we need to remember factors
    // across auth responses. Not doing this, for example, results in being
    // unable to switch away from the duo factor dropdown.
    if (res._embedded && res._embedded.policy) {
      this.set('policy', res._embedded.policy);
    }

    if (res._embedded && res._embedded.factors) {
      var factors = res._embedded.factors;

      if (res._embedded.factorTypes) {
        factors = combineFactorsObjects(res._embedded.factorTypes, factors);
      }

      var factorsObject = (0, _map.default)(_okta._).call(_okta._, factors, function (factor) {
        factor.settings = _this.settings;
        factor.appState = _this;
        return factor;
      });
      this.set('factors', new _Factor.default.Collection(factorsObject, {
        parse: true
      }));
    }

    this.set('lastAuthResponse', res);
  },
  clearLastAuthResponse: function clearLastAuthResponse() {
    this.set('lastAuthResponse', {});
  },
  setLastFailedChallengeFactorData: function setLastFailedChallengeFactorData() {
    this.set('lastFailedChallengeFactorData', {
      factor: this.get('factor'),
      errorMessage: this.get('factorResultErrorMessage')
    });
  },
  clearLastFailedChallengeFactorData: function clearLastFailedChallengeFactorData() {
    this.unset('lastFailedChallengeFactorData');
  },
  derived: {
    isSuccessResponse: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'SUCCESS';
      }
    },
    isMfaRequired: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'MFA_REQUIRED' || res.status === 'FACTOR_REQUIRED';
      }
    },
    isProfileRequired: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'PROFILE_REQUIRED';
      }
    },
    isMfaEnroll: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL';
      }
    },
    isMfaChallenge: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'MFA_CHALLENGE' || res.status === 'FACTOR_CHALLENGE';
      }
    },
    isSMSPasswordRecovery: {
      deps: ['lastAuthResponse'],
      fn: function fn(_ref) {
        var status = _ref.status,
            factorType = _ref.factorType,
            recoveryType = _ref.recoveryType;
        return status === 'RECOVERY_CHALLENGE' && (factorType === null || factorType === void 0 ? void 0 : factorType.toLowerCase()) === 'sms' && (recoveryType === null || recoveryType === void 0 ? void 0 : recoveryType.toLowerCase()) === 'password';
      }
    },
    isUnauthenticated: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'UNAUTHENTICATED';
      }
    },
    isMfaRejected: {
      // MFA failures are usually error responses
      // except in the case of Okta Push, when a
      // user clicks 'deny' on his phone or OV app
      // version is below a required version no.
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.factorResult === 'REJECTED';
      }
    },
    isMfaTimeout: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.factorResult === 'TIMEOUT';
      }
    },
    isMfaEnrollActivate: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE';
      }
    },
    isWaitingForActivation: {
      deps: ['isMfaEnrollActivate', 'lastAuthResponse'],
      fn: function fn(isMfaEnrollActivate, res) {
        return isMfaEnrollActivate && res.factorResult === 'WAITING';
      }
    },
    isWaitingForNumberChallenge: {
      deps: ['lastAuthResponse', 'isMfaChallenge'],
      fn: function fn(res, isMfaChallenge) {
        if (isMfaChallenge && res && res.factorResult === 'WAITING' && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.challenge) {
          return true;
        }

        return false;
      }
    },
    hasMultipleFactorsAvailable: {
      deps: ['factors', 'isMfaRequired', 'isMfaChallenge', 'isUnauthenticated'],
      fn: function fn(factors, isMfaRequired, isMfaChallenge, isUnauthenticated) {
        if (!isMfaRequired && !isMfaChallenge && !isUnauthenticated) {
          return false;
        }

        return factors && factors.length > 1;
      }
    },
    promptForFactorInUnauthenticated: {
      deps: ['lastAuthResponse', 'factors'],
      fn: function fn(res, factors) {
        if (res.status !== 'UNAUTHENTICATED') {
          return false;
        }

        return factors && factors.length > 0;
      }
    },
    userId: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded || !res._embedded.user) {
          return null;
        }

        return res._embedded.user.id;
      }
    },
    isIdxStateToken: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        var _context;

        return res && _okta._.isString(res.stateToken) && (0, _startsWith.default)(_context = res.stateToken).call(_context, '01');
      }
    },
    isPwdExpiringSoon: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.status === 'PASSWORD_WARN';
      }
    },
    passwordExpireDays: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded || !res._embedded.policy || !res._embedded.policy.expiration) {
          return null;
        }

        return res._embedded.policy.expiration.passwordExpireDays;
      }
    },
    isPwdManagedByOkta: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._links || !res._links.next || !res._links.next.title) {
          return true;
        }

        return false;
      }
    },
    passwordExpiredWebsiteName: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._links || !res._links.next || !res._links.next.title) {
          return null;
        }

        return res._links.next.title;
      }
    },
    passwordExpiredLinkUrl: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._links || !res._links.next || !res._links.next.title || !res._links.next.href) {
          return null;
        }

        return res._links.next.href;
      }
    },
    recoveryType: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.recoveryType;
      }
    },
    factorType: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.factorType;
      }
    },
    factor: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded || !res._embedded.factor) {
          return null;
        }

        return res._embedded.factor;
      }
    },
    activatedFactorId: {
      deps: ['factor'],
      fn: function fn(factor) {
        return factor ? factor.id : null;
      }
    },
    activatedFactorType: {
      deps: ['factor'],
      fn: function fn(factor) {
        return factor ? factor.factorType : null;
      }
    },
    activatedFactorProvider: {
      deps: ['factor'],
      fn: function fn(factor) {
        return factor ? factor.provider : null;
      }
    },
    qrcode: {
      deps: ['factor'],
      fn: function fn(factor) {
        try {
          return factor._embedded.activation._links.qrcode.href;
        } catch (err) {
          return null;
        }
      }
    },
    activationSendLinks: {
      deps: ['factor'],
      fn: function fn(factor) {
        var sendLinks;

        try {
          sendLinks = factor._embedded.activation._links.send;
        } catch (err) {
          sendLinks = [];
        }

        return sendLinks;
      }
    },
    textActivationLinkUrl: {
      deps: ['activationSendLinks'],
      fn: function fn(activationSendLinks) {
        var item = _okta._.findWhere(activationSendLinks, {
          name: 'sms'
        });

        return item ? item.href : null;
      }
    },
    emailActivationLinkUrl: {
      deps: ['activationSendLinks'],
      fn: function fn(activationSendLinks) {
        var item = _okta._.findWhere(activationSendLinks, {
          name: 'email'
        });

        return item ? item.href : null;
      }
    },
    sharedSecret: {
      deps: ['factor'],
      fn: function fn(factor) {
        try {
          return factor._embedded.activation.sharedSecret;
        } catch (err) {
          return null;
        }
      }
    },
    duoEnrollActivation: {
      deps: ['factor'],
      fn: function fn(factor) {
        if (!factor || !factor._embedded || !factor._embedded.activation) {
          return null;
        }

        return factor._embedded.activation;
      }
    },
    prevLink: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (res._links && res._links.prev) {
          return res._links.prev.href;
        }

        return null;
      }
    },
    skipLink: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (res._links && res._links.skip) {
          return res._links.skip.href;
        }

        return null;
      }
    },
    gracePeriodRemainingDays: {
      deps: ['policy'],
      fn: function fn(policy) {
        if (policy && policy.gracePeriod && policy.gracePeriod.endDate) {
          return getGracePeriodRemainingDays(policy.gracePeriod.endDate);
        }

        return null;
      }
    },
    user: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded || !res._embedded.user) {
          return null;
        }

        return res._embedded.user;
      }
    },
    recoveryQuestion: {
      deps: ['user'],
      fn: function fn(user) {
        if (!user || !user.recovery_question) {
          return null;
        }

        return user.recovery_question.question;
      }
    },
    userProfile: {
      deps: ['user'],
      fn: function fn(user) {
        if (!user || !user.profile) {
          return null;
        }

        return user.profile;
      }
    },
    userConsentName: {
      deps: ['userProfile', 'username'],
      fn: function fn(userProfile, username) {
        if (!userProfile || _okta._.isEmpty(userProfile.firstName)) {
          return username;
        }

        if (_okta._.isEmpty(userProfile.lastName)) {
          return userProfile.firstName;
        }

        return userProfile.firstName + ' ' + userProfile.lastName.charAt(0) + '.';
      }
    },
    userEmail: {
      deps: ['userProfile'],
      fn: function fn(userProfile) {
        if (!userProfile || !userProfile.login) {
          return null;
        }

        return userProfile.login;
      }
    },
    userFullName: {
      deps: ['userProfile'],
      fn: function fn(userProfile) {
        if (!userProfile || !userProfile.firstName && !userProfile.lastName) {
          return '';
        }

        return userProfile.firstName + ' ' + userProfile.lastName;
      }
    },
    defaultAppLogo: {
      deps: ['baseUrl'],
      fn: function fn(baseUrl) {
        return baseUrl + DEFAULT_APP_LOGO;
      }
    },
    expiresAt: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.expiresAt;
      }
    },
    target: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded) {
          return null;
        }

        return res._embedded.target;
      }
    },
    targetLabel: {
      deps: ['target'],
      fn: function fn(target) {
        if (!target) {
          return null;
        }

        return target.label;
      }
    },
    targetLogo: {
      deps: ['target'],
      fn: function fn(target) {
        if (!target || !target._links) {
          return null;
        }

        return target._links.logo;
      }
    },
    targetTermsOfService: {
      deps: ['target'],
      fn: function fn(target) {
        if (!target || !target._links) {
          return null;
        }

        return target._links['terms-of-service'];
      }
    },
    targetPrivacyPolicy: {
      deps: ['target'],
      fn: function fn(target) {
        if (!target || !target._links) {
          return null;
        }

        return target._links['privacy-policy'];
      }
    },
    targetClientURI: {
      deps: ['target'],
      fn: function fn(target) {
        if (!target || !target._links) {
          return null;
        }

        return target._links['client-uri'];
      }
    },
    scopes: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded) {
          return null;
        }

        return res._embedded.scopes;
      }
    },
    issuer: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        var _res$_embedded, _res$_embedded$authen, _res$_embedded$authen2;

        return res === null || res === void 0 ? void 0 : (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : (_res$_embedded$authen = _res$_embedded.authentication) === null || _res$_embedded$authen === void 0 ? void 0 : (_res$_embedded$authen2 = _res$_embedded$authen.issuer) === null || _res$_embedded$authen2 === void 0 ? void 0 : _res$_embedded$authen2.uri;
      }
    },
    hasExistingPhones: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded || !res._embedded.factors) {
          return false;
        }

        var factors = res._embedded.factors;

        var factor = _okta._.findWhere(factors, {
          factorType: 'sms',
          provider: 'OKTA'
        });

        if (!factor || !factor._embedded) {
          return false;
        }

        return !!factor._embedded.phones.length;
      }
    },
    hasExistingPhonesForCall: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded || !res._embedded.factors) {
          return false;
        }

        var factors = res._embedded.factors;

        var factor = _okta._.findWhere(factors, {
          factorType: 'call',
          provider: 'OKTA'
        });

        if (!factor || !factor._embedded) {
          return false;
        }

        return !!factor._embedded.phones.length;
      }
    },
    isUndefinedUser: {
      deps: ['securityImage'],
      fn: function fn(securityImage) {
        return securityImage === UNDEFINED_USER;
      }
    },
    isNewUser: {
      deps: ['securityImage'],
      fn: function fn(securityImage) {
        return securityImage === NEW_USER;
      }
    },
    allowRememberDevice: {
      deps: ['policy'],
      fn: function fn(policy) {
        return policy && policy.allowRememberDevice;
      }
    },
    rememberDeviceLabel: {
      deps: ['policy'],
      fn: function fn(policy) {
        if (policy && policy.rememberDeviceLifetimeInMinutes > 0) {
          var timeString = getMinutesString(policy.rememberDeviceLifetimeInMinutes);
          return (0, _okta.loc)('rememberDevice.timebased', 'login', [timeString]);
        } else if (policy && policy.rememberDeviceLifetimeInMinutes === 0) {
          return (0, _okta.loc)('rememberDevice.devicebased', 'login');
        }

        return (0, _okta.loc)('rememberDevice', 'login');
      }
    },
    rememberDeviceByDefault: {
      deps: ['policy'],
      fn: function fn(policy) {
        return policy && policy.rememberDeviceByDefault;
      }
    },
    factorsPolicyInfo: {
      deps: ['policy'],
      fn: function fn(policy) {
        return policy && policy.factorsPolicyInfo ? policy.factorsPolicyInfo : null;
      }
    },
    verifyCustomFactorRedirectUrl: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._links || !res._links.next || res._links.next.name !== 'redirect' || !res._links.next.href) {
          return null;
        }

        return res._links.next.href;
      }
    },
    enrollCustomFactorRedirectUrl: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._links || !res._links.next || res._links.next.name !== 'activate' || !res._links.next.href) {
          return null;
        }

        return res._links.next.href;
      }
    },
    isFactorResultFailed: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        return res.factorResult === 'FAILED';
      }
    },
    factorResultErrorMessage: {
      deps: ['lastAuthResponse', 'isFactorResultFailed'],
      fn: function fn(res, isFactorResultFailed) {
        if (isFactorResultFailed) {
          return res.factorResultMessage || (0, _okta.loc)('oform.error.unexpected', 'login');
        }

        return null;
      }
    },
    deviceActivationStatus: {
      deps: ['lastAuthResponse'],
      fn: function fn(res) {
        if (!res._embedded) {
          return null;
        }

        return res._embedded.deviceActivationStatus;
      }
    }
  },
  parse: function parse(options) {
    this.settings = options.settings;
    return _okta._.extend(_okta._.omit(options, 'settings'), {
      languageCode: this.settings.get('languageCode'),
      userCountryCode: this.settings.get('countryCode')
    });
  }
});

exports.default = _default;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"beacon-blank\"></div><div class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"loading-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
    },
    "useData": true
  }),
  equals: function equals(Beacon) {
    return Beacon && this instanceof Beacon;
  }
});

exports.default = _default;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Factor = _interopRequireDefault(__webpack_require__(242));

var _q = _interopRequireDefault(__webpack_require__(43));

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _FactorsDropDown = _interopRequireDefault(__webpack_require__(1229));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 8] */
var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 171
          },
          "end": {
            "line": 1,
            "column": 184
          }
        }
      }) : helper)) + "\" data-se=\"factor-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div><div data-type=\"factor-types-dropdown\" class=\"factors-dropdown-wrap\"></div>";
    },
    "useData": true
  }),
  events: {
    'click .auth-beacon-factor': function clickAuthBeaconFactor(e) {
      e.preventDefault();
      e.stopPropagation();
      var expanded = this.$('.dropdown .options').toggle().is(':visible');
      this.$('a.option-selected').attr('aria-expanded', expanded);

      if (expanded) {
        var _context;

        (0, _find.default)(_context = this.$('#okta-dropdown-options')).call(_context, 'li.factor-option:first a').focus();
      }
    }
  },
  initialize: function initialize() {
    this.options.appState.set('beaconType', 'factor');
  },
  getTemplateData: function getTemplateData() {
    var factors = this.options.appState.get('factors');
    var factor;
    var className;

    if (factors) {
      factor = _FactorUtil.default.findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
    } else {
      factor = new _Factor.default.Model(this.options.appState.get('factor'));
    }

    className = factor.get('iconClassName');
    return {
      className: className || ''
    };
  },
  postRender: function postRender() {
    if (this.options.animate) {
      this.$('.auth-beacon-factor').fadeIn(200);
    }

    var appState = this.options.appState;

    if (appState.get('hasMultipleFactorsAvailable')) {
      this.add(_FactorsDropDown.default, '[data-type="factor-types-dropdown"]');
    }
  },
  fadeOut: function fadeOut() {
    var deferred = _q.default.defer();

    this.$('.auth-beacon-factor').fadeOut(200, function () {
      deferred.resolve();
    });
    return deferred.promise;
  },
  equals: function equals(Beacon, options) {
    return Beacon && this instanceof Beacon && options.provider === this.options.provider && (options.factorType === this.options.factorType || _FactorUtil.default.isOktaVerify(options.provider, options.factorType) && _FactorUtil.default.isOktaVerify(this.options.provider, this.options.factorType));
  }
});

exports.default = _default;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _FactorUtil = _interopRequireDefault(__webpack_require__(41));

var _Factor = _interopRequireDefault(__webpack_require__(242));

var _FactorsDropDownOptions = _interopRequireDefault(__webpack_require__(1230));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var BaseDropDown = _okta.internal.views.components.BaseDropDown;
(0, _okta.$)(document).click(function (e) {
  var $target = (0, _okta.$)(e.target);
  var isDropdown = $target.closest('.option-selected').length > 0 && $target.closest('.dropdown').length > 0;

  if (!isDropdown) {
    (0, _okta.$)('.dropdown .options').hide();
    (0, _okta.$)('.dropdown a.option-selected').attr('aria-expanded', false);
  }
});

var _default = BaseDropDown.extend({
  className: 'bg-helper icon-button',
  screenReaderText: function screenReaderText() {
    var factors = this.options.appState.get('factors');
    var factor;
    var factorLabel;

    if (factors) {
      factor = _FactorUtil.default.findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
    } else {
      factor = new _Factor.default.Model(this.options.appState.get('factor'), this.toJSON());
    }

    factorLabel = factor.get('factorLabel');
    return (0, _okta.loc)('mfa.factors.dropdown.sr.text', 'login', [factorLabel]);
  },
  events: {
    'click a.option-selected': function clickAOptionSelected(e) {
      e.preventDefault();

      if (_okta._.result(this, 'disabled')) {
        e.stopPropagation();
      } else {
        var expanded = this.$('.options').toggle().is(':visible');
        this.$('a.option-selected').attr('aria-expanded', expanded);

        if (expanded) {
          var _context;

          (0, _find.default)(_context = this.$('#okta-dropdown-options')).call(_context, 'li.factor-option:first a').focus();
        }
      }
    },
    'click .dropdown-disabled': function clickDropdownDisabled(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  initialize: function initialize() {
    this.addOption(_FactorsDropDownOptions.default.getDropdownOption('TITLE'));
    var factorsList = this.options.appState.get('factors');
    var multiplePushFactors = factorsList.hasMultipleFactorsOfSameType('push');
    factorsList.each(function (factor) {
      // Do not add okta totp if there are multiple okta push (each push will have an inline totp)
      if (!(factor.get('factorType') === 'token:software:totp' && multiplePushFactors)) {
        this.addOption(_FactorsDropDownOptions.default.getDropdownOption(factor.get('factorName')), {
          model: factor
        });
        this.listenTo(this.last(), 'options:toggle', function () {
          this.$('.options').hide();
          this.$('a.option-selected').attr('aria-expanded', false);
        });
      }
    }, this);
  }
});

exports.default = _default;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _RouterUtil = _interopRequireDefault(__webpack_require__(89));

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-statements: [2, 16], complexity: [2, 10] */
var pushTitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "factorName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 14
        }
      }
    }) : helper)) + " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
      "name": "deviceName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 16
        },
        "end": {
          "line": 1,
          "column": 32
        }
      }
    }) : helper)) != null ? stack1 : "") + ")";
  },
  "useData": true
}); // deviceName is escaped on BaseForm (see BaseForm's template)


var _action = function action(model) {
  var factorIndex;
  var factorType = model.get('factorType');
  var factorsList = this.options.appState.get('factors');

  if (factorsList.hasMultipleFactorsOfSameType(factorType)) {
    factorIndex = factorsList.getFactorIndex(factorType, model.get('id'));
  }

  var url = _RouterUtil.default.createVerifyUrl(model.get('provider'), factorType, factorIndex);

  var self = this;
  this.options.appState.trigger('factorSwitched');
  this.model.manageTransaction(function (transaction, setTransaction) {
    // FACTOR_CHALLENGE does not have a prev link
    if (transaction.status === 'FACTOR_CHALLENGE') {
      this.options.appState.set('trapMfaRequiredResponse', true);
    }

    if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
      this.options.appState.set('trapMfaRequiredResponse', true);
      return transaction.prev().then(function (trans) {
        self.trigger('options:toggle');
        setTransaction(trans);
        self.options.appState.trigger('navigate', url);
      });
    } else {
      self.trigger('options:toggle');
      self.options.appState.trigger('navigate', url);
    }
  });
};

var dropdownOptions = {
  TITLE: {
    title: _okta._.partial(_okta.loc, 'mfa.factors.dropdown.title', 'login'),
    className: 'dropdown-list-title',
    disabled: true
  },
  OKTA_VERIFY: {
    icon: 'factor-icon mfa-okta-verify-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  OKTA_VERIFY_PUSH: {
    icon: 'factor-icon mfa-okta-verify-30',
    className: 'factor-option',
    title: function title() {
      return pushTitleTpl({
        factorName: this.model.get('factorLabel'),
        deviceName: this.model.get('deviceName')
      });
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  GOOGLE_AUTH: {
    icon: 'factor-icon mfa-google-auth-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  CUSTOM_HOTP: {
    icon: 'factor-icon mfa-hotp-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  SYMANTEC_VIP: {
    icon: 'factor-icon mfa-symantec-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  RSA_SECURID: {
    icon: 'factor-icon mfa-rsa-30',
    className: 'factor-option',
    title: _okta._.partial(_okta.loc, 'factor.totpHard.rsaSecurId', 'login'),
    action: function action() {
      _action.call(this, this.model);
    }
  },
  ON_PREM: {
    icon: 'factor-icon mfa-onprem-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  DUO: {
    icon: 'factor-icon mfa-duo-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  DUO_PUSH: {
    icon: 'duo-push-16',
    className: 'suboption factor-option',
    // TODO: add phone number here
    title: _okta._.partial(_okta.loc, 'mfa.duoSecurity.push', 'login', ['XXX-XXX-7890'])
  },
  DUO_SMS: {
    icon: 'duo-sms-16',
    className: 'suboption factor-option',
    // TODO: add phone number here
    title: _okta._.partial(_okta.loc, 'mfa.duoSecurity.sms', 'login', ['XXX-XXX-7890'])
  },
  DUO_CALL: {
    icon: 'duo-call-16',
    className: 'suboption factor-option',
    // TODO: add phone number here
    title: _okta._.partial(_okta.loc, 'mfa.duoSecurity.call', 'login', ['XXX-XXX-7890'])
  },
  YUBIKEY: {
    icon: 'factor-icon mfa-yubikey-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  SMS: {
    icon: 'factor-icon mfa-sms-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  CALL: {
    icon: 'factor-icon mfa-call-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  QUESTION: {
    icon: 'factor-icon mfa-question-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  PASSWORD: {
    icon: 'factor-icon mfa-password-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  WINDOWS_HELLO: {
    icon: 'factor-icon mfa-windows-hello-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  U2F: {
    icon: 'factor-icon mfa-u2f-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  WEBAUTHN: {
    icon: 'factor-icon mfa-webauthn-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  EMAIL: {
    icon: 'factor-icon mfa-email-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  GENERIC_SAML: {
    icon: 'factor-icon mfa-custom-factor-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  GENERIC_OIDC: {
    icon: 'factor-icon mfa-custom-factor-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  },
  CUSTOM_CLAIMS: {
    icon: 'factor-icon mfa-custom-factor-30',
    className: 'factor-option',
    title: function title() {
      return this.model.get('factorLabel');
    },
    action: function action() {
      _action.call(this, this.model);
    }
  }
};
var _default = {
  getDropdownOption: function getDropdownOption(factorName) {
    return dropdownOptions[factorName];
  }
};
exports.default = _default;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  className: 'piv-beacon',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon smartcard\" data-se=\"piv-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div>";
    },
    "useData": true
  }),
  equals: function equals(Beacon) {
    return Beacon && this instanceof Beacon;
  }
});

exports.default = _default;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _BaseLoginRouter = _interopRequireDefault(__webpack_require__(1233));

var _FormController = _interopRequireDefault(__webpack_require__(352));

var _RegistrationFormController = _interopRequireDefault(__webpack_require__(1427));

var _ForgotPasswordFormController = _interopRequireDefault(__webpack_require__(1428));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
module.exports = _BaseLoginRouter.default.extend({
  routes: {
    '': 'defaultAuth',
    'signin/register': 'renderRegister',
    'signin/forgot-password': 'renderForgotPassword',
    '*wildcard': 'defaultAuth'
  },
  defaultAuth: function defaultAuth() {
    this.render(_FormController.default);
  },

  /**
   * Bootstrap registration flow when navigates
   * to '/signin/register' directly.
   */
  renderRegister: function renderRegister() {
    this.render(_RegistrationFormController.default);
  },

  /**
   * Bootstrap forgot password flow when navigates
   * to '/signin/forgot-password'
   */
  renderForgotPassword: function renderForgotPassword() {
    this.render(_ForgotPasswordFormController.default);
  }
});

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _Settings = _interopRequireDefault(__webpack_require__(548));

var _Bundles = _interopRequireDefault(__webpack_require__(155));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _ColorsUtil = _interopRequireDefault(__webpack_require__(553));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _LanguageUtil = _interopRequireDefault(__webpack_require__(1234));

var _AuthContainer = _interopRequireDefault(__webpack_require__(550));

var _Header = _interopRequireDefault(__webpack_require__(551));

var _AppState = _interopRequireDefault(__webpack_require__(1235));

var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(331));

var _client = __webpack_require__(555);

var _transformIdxResponse = _interopRequireDefault(__webpack_require__(1327));

var _RemediationConstants = __webpack_require__(24);

var _CookieUtil = _interopRequireDefault(__webpack_require__(245));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)
var _default = _okta.Router.extend({
  Events: _okta.Backbone.Events,
  initialize: function initialize(options) {
    // Create a default success and/or error handler if
    // one is not provided.
    if (!options.globalSuccessFn) {
      options.globalSuccessFn = function () {};
    }

    if (!options.globalErrorFn) {
      options.globalErrorFn = function (err) {
        _Logger.default.error(err);
      };
    }

    this.settings = new _Settings.default(_okta._.omit(options, 'el', 'authClient'), {
      parse: true
    });
    this.settings.setAuthClient(options.authClient);

    if (!options.el) {
      this.settings.callGlobalError(new _Errors.default.ConfigError((0, _okta.loc)('error.required.el')));
    }

    (0, _okta.$)('body > div').on('click', function () {// OKTA-69769 Tooltip wont close on iPhone/iPad
      // Registering a click handler on the first div
      // allows a tap that falls outside the tooltip
      // to be registered as a tap by iOS
      // and then the open tooltip will lose focus and close.
    });
    this.appState = new _AppState.default();
    var wrapper = new _AuthContainer.default({
      appState: this.appState
    });
    (0, _okta.$)(options.el).append(wrapper.render().$el);
    this.el = "#".concat(_Enums.default.WIDGET_CONTAINER_ID);
    this.header = new _Header.default({
      el: this.el,
      appState: this.appState,
      settings: this.settings
    });
    (0, _client.configIdxJsClient)(this.appState);
    this.listenTo(this.appState, 'remediationSuccess', this.handleIdxResponseSuccess);
    this.listenTo(this.appState, 'remediationError', this.handleIdxResponseFailure);
    this.listenTo(this.appState, 'restartLoginFlow', this.restartLoginFlow);
  },
  handleIdxResponseSuccess: function handleIdxResponseSuccess(idxResponse) {
    // Only update the cookie when the user has successfully authenticated themselves 
    // to avoid incorrect/uneccessary updates.
    if (this.hasAuthenticationSucceeded(idxResponse)) {
      this.updateIdentifierCookie(idxResponse);
    }

    if (idxResponse.interactionCode) {
      // Although session.stateHandle isn't used by interation flow,
      // it's better to clean up at the end of the flow.
      _sessionStorageHelper.default.removeStateHandle(); // This is the end of the IDX flow, now entering OAuth


      return (0, _client.interactionCodeFlow)(this.settings, idxResponse);
    }

    var lastResponse = this.appState.get('idx'); // Do not save state handle for the first page loads.
    // Because there shall be no difference between following behavior
    // 1. bootstrap widget
    //    -> save state handle to session storage
    //    -> refresh page
    //    -> introspect using sessionStorage.stateHandle
    // 2. bootstrap widget
    //    -> do not save state handle to session storage
    //    -> refresh page
    //    -> introspect using options.stateHandle

    if (lastResponse) {
      var _idxResponse$context;

      _sessionStorageHelper.default.setStateHandle(idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.stateHandle);
    } // Login flows that mimic step up (moving forward in login pipeline) via internal api calls,
    // need to clear stored stateHandles.
    // This way the flow can maintain the latest state handle. For eg. Device probe calls


    if (this.appState.get('currentFormName') === _RemediationConstants.FORMS.CANCEL_TRANSACTION) {
      _sessionStorageHelper.default.removeStateHandle();
    } // transform response


    var ionResponse = (0, _transformIdxResponse.default)(this.settings, idxResponse, lastResponse);
    this.appState.setIonResponse(ionResponse);
  },
  handleIdxResponseFailure: function handleIdxResponseFailure() {
    var _error, _error2, _error2$details;

    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // special case: `useInteractionCodeFlow` is true but the Org does not have OIE enabled
    // The response is not in IDX format. See playground/mocks/data/oauth2/error-feature-not-enabled.json
    if (((_error = error) === null || _error === void 0 ? void 0 : _error.error) === 'access_denied' && error.error_description) {
      // simulate an IDX error response
      var idxMessages = {
        messages: {
          type: 'array',
          value: [{
            message: error.error_description,
            i18n: {
              key: 'oie.feature.disabled'
            },
            class: 'ERROR'
          }]
        }
      }; // Format the error to resemble an IdX error

      error = (0, _assign.default)({
        details: {
          rawIdxState: idxMessages,
          context: idxMessages,
          neededToProceed: []
        }
      }, error);
    } // loosely check whether is IDX error response
    // see idx for details: https://github.com/okta/okta-idx-js/blob/master/src/index.js


    if ((_error2 = error) === null || _error2 === void 0 ? void 0 : (_error2$details = _error2.details) === null || _error2$details === void 0 ? void 0 : _error2$details.rawIdxState) {
      // Populate generic error message if there isn't any.
      if (!error.details.rawIdxState.messages) {
        var idxMessage = {
          type: 'array',
          value: [{
            message: (0, _okta.loc)('oform.error.unexpected', 'login'),
            class: 'ERROR'
          }]
        }; // Format the error to resemble an IdX error

        error.details.rawIdxState.messages = idxMessage;
        error.details.context = {
          messages: idxMessage
        };
      }

      return this.handleIdxResponseSuccess(error.details);
    } // assume it's a config error


    this.settings.callGlobalError(new _Errors.default.ConfigError(error)); // -- TODO: OKTA-244631 How to surface up the CORS error in IDX?
    // -- The `err` object from idx.js doesn't have XHR object
    // Global error handling for CORS enabled errors
    // if (err.xhr && BrowserFeatures.corsIsNotEnabled(err.xhr)) {
    //   this.settings.callGlobalError(new Errors.UnsupportedBrowserError(loc('error.enabled.cors')));
    //   return;
    // }
  },

  /* eslint max-statements: [2, 21] */
  render: function () {
    var _render = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(Controller) {
      var options,
          idxResp,
          colors,
          controllerOptions,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              // If url changes then widget assumes that user's intention was to initiate a new login flow,
              // so clear stored token to use the latest token.
              if (_sessionStorageHelper.default.getLastInitiatedLoginUrl() !== window.location.href) {
                _sessionStorageHelper.default.removeStateHandle();
              } // Since we have a wrapper view, render our wrapper and use its content
              // element as our new el.
              // Note: Render it here because we know dom is ready at this point


              if (!this.header.rendered()) {
                this.el = this.header.render().getContentEl();
              } // If we need to load a language (or apply custom i18n overrides), do
              // this now and re-run render after it's finished.


              if (_Bundles.default.isLoaded(this.settings.get('languageCode'))) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return _LanguageUtil.default.loadLanguage(this.appState, this.settings);

            case 6:
              if (!this.settings.get('oieEnabled')) {
                _context.next = 21;
                break;
              }

              _context.prev = 7;
              _context.next = 10;
              return (0, _client.startLoginFlow)(this.settings);

            case 10:
              idxResp = _context.sent;
              this.appState.trigger('remediationSuccess', idxResp);
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](7);
              this.appState.trigger('remediationError', _context.t0.error || _context.t0);

            case 17:
              _context.prev = 17;
              this.settings.unset('stateToken');
              this.settings.unset('proxyIdxResponse');
              return _context.finish(17);

            case 21:
              // Load the custom colors only on the first render
              if (this.settings.get('colors.brand') && !_ColorsUtil.default.isLoaded()) {
                colors = {
                  brand: this.settings.get('colors.brand')
                };

                _ColorsUtil.default.addStyle(colors);
              } // render Controller


              this.unload();
              controllerOptions = _okta._.extend({
                el: this.el,
                settings: this.settings,
                appState: this.appState
              }, options);
              this.controller = new Controller(controllerOptions); // Bubble up all controller events

              this.listenTo(this.controller, 'all', this.trigger);
              this.controller.render();

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[7, 14, 17, 21]]);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
    * When "Remember My Username" is enabled, we save the identifier in a cookie
    * so that the next time the user visits the SIW, the identifier field can be 
    * pre-filled with this value.
   */
  updateIdentifierCookie: function updateIdentifierCookie(idxResponse) {
    if (this.settings.get('features.rememberMe')) {
      var _idxResponse$context2;

      // Update the cookie with the identifier
      var user = idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context2 = idxResponse.context) === null || _idxResponse$context2 === void 0 ? void 0 : _idxResponse$context2.user;

      var _ref = (user === null || user === void 0 ? void 0 : user.value) || {},
          identifier = _ref.identifier;

      if (identifier) {
        _CookieUtil.default.setUsernameCookie(identifier);
      }
    } else {
      // We remove the cookie explicitly if this feature is disabled.
      _CookieUtil.default.removeUsernameCookie();
    }
  },
  hasAuthenticationSucceeded: function hasAuthenticationSucceeded(idxResponse) {
    var _idxResponse$rawIdxSt, _idxResponse$rawIdxSt2;

    // Check whether authentication has succeeded. This is done by checking the server response
    // and seeing if either the 'success' or 'successWithInteractionCode' objects are present.
    return (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt === void 0 ? void 0 : _idxResponse$rawIdxSt.success) || (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt2 = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt2 === void 0 ? void 0 : _idxResponse$rawIdxSt2.successWithInteractionCode);
  },
  restartLoginFlow: function restartLoginFlow() {
    this.render(this.controller.constructor);
  },
  start: function start() {
    var pushState = _BrowserFeatures.default.supportsPushState();

    _okta.Router.prototype.start.call(this, {
      pushState: pushState
    });
  },
  hide: function hide() {
    this.header.$el.hide();
  },
  show: function show() {
    this.header.$el.show();
  },
  remove: function remove() {
    this.unload();
    this.header.$el.remove();
    this.stopListening(this.appState);
    this.stopListening(this.settings);

    _Bundles.default.remove();

    _okta.Backbone.history.stop();
  }
});

exports.default = _default;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _Bundles = _interopRequireDefault(__webpack_require__(155));

function loadLanguage(appState, settings) {
  var languageCode = settings.get('languageCode');
  var i18n = settings.get('i18n');
  var assetBaseUrl = settings.get('assets.baseUrl');
  var assetRewrite = settings.get('assets.rewrite');
  var timeout = (0, _setTimeout2.default)(function () {
    // Trigger a spinner if we're waiting on a request for a new language.
    appState.trigger('loading', true);
  }, 200);
  return _Bundles.default.loadLanguage(languageCode, i18n, {
    baseUrl: assetBaseUrl,
    rewrite: assetRewrite
  }).then(function () {
    clearTimeout(timeout);
    appState.trigger('loading', false);
  }); // TODO: what if load language error?
}

var _default = {
  loadLanguage: loadLanguage
};
exports.default = _default;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _startsWith = _interopRequireDefault(__webpack_require__(239));

var _some = _interopRequireDefault(__webpack_require__(320));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _map = _interopRequireDefault(__webpack_require__(40));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(160));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _RemediationConstants = __webpack_require__(24);

var _ionObjectHandler = __webpack_require__(554);

var _mixins = __webpack_require__(1239);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Keep track of stateMachine with this special model. Similar to `src/models/AppState.js`
 */
var _default = _okta.Model.extend({
  local: {
    user: 'object',
    // optional
    currentFormName: 'string',
    idx: 'object',
    remediations: 'array',
    dynamicRefreshInterval: 'number',
    deviceFingerprint: 'string'
  },
  derived: {
    authenticatorProfile: {
      deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
      fn: function fn() {
        var currentAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentAuthenticatorEnrollment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return currentAuthenticator.profile || currentAuthenticatorEnrollment.profile || {};
      }
    },
    authenticatorKey: {
      deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
      fn: function fn() {
        var currentAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentAuthenticatorEnrollment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return currentAuthenticator.key || currentAuthenticatorEnrollment.key || '';
      }
    },
    authenticatorMethodType: {
      deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
      fn: function fn() {
        var currentAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentAuthenticatorEnrollment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return currentAuthenticator.methods && currentAuthenticator.methods[0].type || currentAuthenticatorEnrollment.methods && currentAuthenticatorEnrollment.methods[0].type || '';
      }
    },
    isPasswordRecovery: {
      deps: ['recoveryAuthenticator'],
      fn: function fn() {
        var recoveryAuthenticator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return (recoveryAuthenticator === null || recoveryAuthenticator === void 0 ? void 0 : recoveryAuthenticator.type) === 'password';
      }
    }
  },
  isIdentifierOnlyView: function isIdentifierOnlyView() {
    var _this$get, _this$get$find, _this$get$find$uiSche;

    return !((_this$get = this.get('remediations')) === null || _this$get === void 0 ? void 0 : (_this$get$find = (0, _find.default)(_this$get).call(_this$get, function (_ref) {
      var name = _ref.name;
      return name === 'identify';
    })) === null || _this$get$find === void 0 ? void 0 : (_this$get$find$uiSche = _this$get$find.uiSchema) === null || _this$get$find$uiSche === void 0 ? void 0 : (0, _find.default)(_this$get$find$uiSche).call(_this$get$find$uiSche, function (_ref2) {
      var name = _ref2.name;
      return name === 'credentials.passcode';
    }));
  },
  hasRemediationObject: function hasRemediationObject(formName) {
    var _context;

    return (0, _find.default)(_context = this.get('idx').neededToProceed).call(_context, function (remediation) {
      return remediation.name === formName;
    });
  },
  getRemediationAuthenticationOptions: function getRemediationAuthenticationOptions(formName) {
    var _context2;

    var form = this.hasRemediationObject(formName);

    if (!form) {
      return [];
    }

    var authenticator = (0, _find.default)(_context2 = form.value).call(_context2, function (value) {
      return value.name === 'authenticator';
    });
    var authenticatorOptions = (authenticator === null || authenticator === void 0 ? void 0 : authenticator.options) || []; // OV is a special case, so process OV options

    authenticatorOptions = (0, _toConsumableArray2.default)(authenticatorOptions); //clone it since we are changing it for OV

    (0, _ionObjectHandler.createOVOptions)(authenticatorOptions);
    return authenticatorOptions;
  },
  getActionByPath: function getActionByPath(actionPath) {
    var paths = actionPath.split('.');
    var targetObject;

    if (paths.length === 1) {
      targetObject = this.get('idx').actions;
    } else {
      targetObject = this.get(paths.shift());
    } // Limitation
    // At the time of writting, action only lives in first level of state objects.


    var actionName = paths.shift();

    if (targetObject && _mixins._.isFunction(targetObject[actionName])) {
      return targetObject[actionName];
    } else {
      return null;
    }
  },
  getCurrentViewState: function getCurrentViewState() {
    var _context3;

    var currentFormName = this.get('currentFormName');

    if (!currentFormName) {
      return;
    } // didn't expect `remediations` is empty. See `setIonResponse`.


    var currentViewState = (0, _filter.default)(_context3 = this.get('remediations')).call(_context3, function (r) {
      return r.name === currentFormName;
    })[0];

    if (!currentViewState) {
      var _context4;

      _Logger.default.error('Panic!!');

      _Logger.default.error("\tCannot find view state for form ".concat(currentFormName, "."));

      var allFormNames = (0, _map.default)(_context4 = this.get('remediations')).call(_context4, function (r) {
        return r.name;
      });

      _Logger.default.error("\tAll available form names: ".concat(allFormNames));
    }

    return currentViewState;
  },

  /**
   * Returns the displayName of the authenticator
   * @returns {string}
   */
  getAuthenticatorDisplayName: function getAuthenticatorDisplayName() {
    var currentAuthenticator = this.get('currentAuthenticator') || {};
    var currentAuthenticatorEnrollment = this.get('currentAuthenticatorEnrollment') || {}; // For enrollment and certain verification flows, the currentAuthenticator object will be present.
    // If not, we're likely in a traditional verify/challenge flow.

    return currentAuthenticator.displayName || currentAuthenticatorEnrollment.displayName;
  },

  /**
   * Checks to see if we're in an authenticator challenge flow.
   * @returns {boolean}
   */
  isAuthenticatorChallenge: function isAuthenticatorChallenge() {
    var currentFormName = this.get('currentFormName');
    return (0, _includes.default)(_RemediationConstants.FORMS_FOR_VERIFICATION).call(_RemediationConstants.FORMS_FOR_VERIFICATION, currentFormName);
  },
  shouldReRenderView: function shouldReRenderView(transformedResponse) {
    var previousRawState = this.has('idx') ? this.get('idx').rawIdxState : null;

    var identicalResponse = _mixins._.isEqual(_mixins._.nestedOmit(transformedResponse.idx.rawIdxState, ['expiresAt', 'refresh', 'stateHandle']), _mixins._.nestedOmit(previousRawState, ['expiresAt', 'refresh', 'stateHandle']));

    var isSameRefreshInterval = _mixins._.isEqual(_mixins._.nestedOmit(transformedResponse.idx.rawIdxState, ['expiresAt', 'stateHandle']), _mixins._.nestedOmit(previousRawState, ['expiresAt', 'stateHandle']));

    if (identicalResponse && !isSameRefreshInterval) {
      this.set('dynamicRefreshInterval', this.getRefreshInterval(transformedResponse));
    }

    var reRender = true;

    if (identicalResponse) {
      /**
       * returns false: When new response is same as last.
       * usually happens during polling when pipeline doesn't proceed to next step.
       * expiresAt will be different for each response, hence compare objects without that property
       */
      reRender = false;
    }

    if (identicalResponse && this.get('currentFormName') === 'poll') {
      /**
       * returns true: We want to force reRender when currentForm is poll because request has to reinitiate
       * based on new refresh and UI has to reflect new timer.
       * We dont technical poll here we just make a request after the specified refresh time each time
       * we get a new response.
       */
      reRender = true;
    }

    if (identicalResponse && (0, _includes.default)(_RemediationConstants.FORMS_WITH_STATIC_BACK_LINK).call(_RemediationConstants.FORMS_WITH_STATIC_BACK_LINK, this.get('currentFormName'))) {
      /**
       * returns true: We want to force reRender if you go back to selection screen from challenge or enroll screen
       * and re-select the same authenticator for challenge. In this case also new response will be identical
       * to the old response.
       */
      reRender = true;
    }

    return reRender;
  },
  getRefreshInterval: function getRefreshInterval(transformedResponse) {
    var _context5, _transformedResponse$, _transformedResponse$2, _transformedResponse$3, _transformedResponse$4;

    // Only polling refresh interval has changed in the response,
    // make sure to update the correct poll view's refresh value
    var currentFormName = this.get('currentFormName');
    var currentViewState = (0, _filter.default)(_context5 = transformedResponse.remediations).call(_context5, function (r) {
      return r.name === currentFormName;
    })[0]; // Get new refresh interval for either: remediations, authenticator, or authenticator enrollment

    return currentViewState.refresh || ((_transformedResponse$ = transformedResponse.currentAuthenticatorEnrollment) === null || _transformedResponse$ === void 0 ? void 0 : (_transformedResponse$2 = _transformedResponse$.poll) === null || _transformedResponse$2 === void 0 ? void 0 : _transformedResponse$2.refresh) || ((_transformedResponse$3 = transformedResponse.currentAuthenticator) === null || _transformedResponse$3 === void 0 ? void 0 : (_transformedResponse$4 = _transformedResponse$3.poll) === null || _transformedResponse$4 === void 0 ? void 0 : _transformedResponse$4.refresh);
  },
  // Sign Out link will be displayed in the footer of a form, unless:
  // - widget configuration set hideSignOutLinkInMFA or mfaOnlyFlow to true
  // - cancel remediation form is not present in the response
  // - form is part of our list FORMS_WITHOUT_SIGNOUT
  shouldShowSignOutLinkInCurrentForm: function shouldShowSignOutLinkInCurrentForm(hideSignOutLinkInMFA) {
    var idxActions = this.get('idx') && this.get('idx').actions;
    var currentFormName = this.get('currentFormName');
    return !hideSignOutLinkInMFA && _mixins._.isFunction(idxActions === null || idxActions === void 0 ? void 0 : idxActions.cancel) && !(0, _includes.default)(_RemediationConstants.FORMS_WITHOUT_SIGNOUT).call(_RemediationConstants.FORMS_WITHOUT_SIGNOUT, currentFormName);
  },
  containsMessageWithI18nKey: function containsMessageWithI18nKey(keys) {
    var _context6;

    if (!(0, _isArray.default)(keys)) {
      keys = [keys];
    }

    var messagesObjs = this.get('messages');
    return messagesObjs && (0, _isArray.default)(messagesObjs.value) && (0, _some.default)(_context6 = messagesObjs.value).call(_context6, function (messagesObj) {
      var _messagesObj$i18n;

      return _mixins._.contains(keys, (_messagesObj$i18n = messagesObj.i18n) === null || _messagesObj$i18n === void 0 ? void 0 : _messagesObj$i18n.key);
    });
  },
  containsMessageStartingWithI18nKey: function containsMessageStartingWithI18nKey(keySubStr) {
    var _context7;

    var messagesObjs = this.get('messages');
    return messagesObjs && (0, _isArray.default)(messagesObjs.value) && (0, _some.default)(_context7 = messagesObjs.value).call(_context7, function (messagesObj) {
      var _messagesObj$i18n2, _context8;

      return (_messagesObj$i18n2 = messagesObj.i18n) === null || _messagesObj$i18n2 === void 0 ? void 0 : (0, _startsWith.default)(_context8 = _messagesObj$i18n2.key).call(_context8, keySubStr);
    });
  },
  clearAppStateCache: function clearAppStateCache() {
    // clear appState before setting new values
    this.clear({
      silent: true
    }); // clear cache for derived props.

    this.trigger('cache:clear');
  },
  setIonResponse: function setIonResponse(transformedResponse) {
    if (!this.shouldReRenderView(transformedResponse)) {
      return;
    } // `currentFormName` is default to first form of remediations or nothing.


    var currentFormName = null;

    if (!_mixins._.isEmpty(transformedResponse.remediations)) {
      currentFormName = transformedResponse.remediations[0].name;
    } else {
      _Logger.default.error('Panic!!');

      _Logger.default.error('\tNo remediation found.');

      _Logger.default.error('\tHere is the entire response');

      _Logger.default.error((0, _stringify.default)(transformedResponse, null, 2));
    }

    this.clearAppStateCache(); // set new app state properties

    this.set(transformedResponse); // make sure change `currentFormName` is last step.
    // change `currentFormName` will re-render FormController,
    // which may depend on other derived properties hence
    // those derived properties must be re-computed before
    // re-rendering controller.

    this.set({
      currentFormName: currentFormName
    });
  }
});

exports.default = _default;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(518);

var arrayLikeToArray = __webpack_require__(524);

function _arrayWithoutHoles(arr) {
  if (_Array$isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(521);

var _isIterable = __webpack_require__(313);

var _Symbol = __webpack_require__(315);

function _iterableToArray(iter) {
  if (typeof _Symbol !== "undefined" && _isIterable(Object(iter))) return _Array$from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "_", {
  enumerable: true,
  get: function get() {
    return _okta._;
  }
});

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _map = _interopRequireDefault(__webpack_require__(40));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _okta = __webpack_require__(2);

_okta._.mixin({
  nestedOmit: function nestedOmit(obj, names) {
    var result = _okta._.omit(obj, names);

    if ((0, _includes.default)(names).call(names, result.name)) {
      result = _okta._.omit(result, 'value');
    }

    _okta._.each(result, function (val, key) {
      if ((0, _isArray.default)(val)) {
        result[key] = (0, _map.default)(val).call(val, function (v) {
          return _okta._.nestedOmit(v, names);
        });
      } else if ((0, _typeof2.default)(val) === 'object') {
        result[key] = _okta._.nestedOmit(val, names);
      }
    });

    return result;
  }
});

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.interactionCodeFlow = interactionCodeFlow;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _oktaAuthJs = __webpack_require__(505);

var _transactionMeta = __webpack_require__(332);

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function interactionCodeFlow(_x, _x2) {
  return _interactionCodeFlow.apply(this, arguments);
}

function _interactionCodeFlow() {
  _interactionCodeFlow = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(settings, idxResponse) {
    var interactionCode, authClient, transactionMeta, state, isRemediationMode, shouldRedirect, redirectUri, qs, codeVerifier;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            interactionCode = idxResponse.interactionCode;
            authClient = settings.getAuthClient();
            transactionMeta = authClient.transactionManager.load();
            state = authClient.options.state || transactionMeta.state; // In remediation mode the transaction is owned by another client.

            isRemediationMode = settings.get('mode') === 'remediation';

            if (isRemediationMode) {
              (0, _transactionMeta.clearTransactionMeta)(settings);
            } // server-side applications will want to received interaction_code as a query parameter
            // this option can also be used to force a redirect for client-side/SPA applications


            shouldRedirect = settings.get('redirect') === 'always';

            if (!shouldRedirect) {
              _context.next = 14;
              break;
            }

            redirectUri = settings.get('redirectUri');

            if (redirectUri) {
              _context.next = 11;
              break;
            }

            throw new _Errors.default.ConfigError('"redirectUri" is required');

          case 11:
            qs = (0, _oktaAuthJs.toQueryString)({
              'interaction_code': interactionCode,
              state: state
            });
            window.location.assign(redirectUri + qs);
            return _context.abrupt("return");

          case 14:
            if (!isRemediationMode) {
              _context.next = 17;
              break;
            }

            settings.callGlobalSuccess(_Enums.default.SUCCESS, {
              'interaction_code': interactionCode,
              state: state
            });
            return _context.abrupt("return");

          case 17:
            // Operating in "relying-party" mode. The widget owns this transaction.
            // Complete the transaction client-side and call success/resolve promise
            codeVerifier = transactionMeta.codeVerifier;
            return _context.abrupt("return", authClient.token.exchangeCodeForTokens({
              codeVerifier: codeVerifier,
              interactionCode: interactionCode
            }).then(function (_ref) {
              var tokens = _ref.tokens;
              settings.callGlobalSuccess(_Enums.default.SUCCESS, {
                tokens: tokens
              });
            }).catch(function (err) {
              settings.callGlobalError(err);
            }).finally(function () {
              // clear all meta related to this transaction
              (0, _transactionMeta.clearTransactionMeta)(settings);
            }));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _interactionCodeFlow.apply(this, arguments);
}

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(488);

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1244);

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1245);

module.exports = parent;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1246);
__webpack_require__(1248);
__webpack_require__(558);
var path = __webpack_require__(23);

module.exports = path.URL;


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(139);
var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(44);
var USE_NATIVE_URL = __webpack_require__(557);
var global = __webpack_require__(33);
var defineProperties = __webpack_require__(310);
var redefine = __webpack_require__(138);
var anInstance = __webpack_require__(196);
var has = __webpack_require__(59);
var assign = __webpack_require__(403);
var arrayFrom = __webpack_require__(472);
var codeAt = __webpack_require__(467).codeAt;
var toASCII = __webpack_require__(1247);
var setToStringTag = __webpack_require__(106);
var URLSearchParamsModule = __webpack_require__(558);
var InternalStateModule = __webpack_require__(95);

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(1250);
var fails = __webpack_require__(92);
var anObject = __webpack_require__(164);
var toLength = __webpack_require__(573);
var toInteger = __webpack_require__(252);
var requireObjectCoercible = __webpack_require__(249);
var advanceStringIndex = __webpack_require__(1273);
var getSubstitution = __webpack_require__(1275);
var regExpExec = __webpack_require__(1276);
var wellKnownSymbol = __webpack_require__(253);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, this, string, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(this);
      var S = String(string);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(559);
var redefine = __webpack_require__(335);
var regexpExec = __webpack_require__(342);
var fails = __webpack_require__(92);
var wellKnownSymbol = __webpack_require__(253);
var createNonEnumerableProperty = __webpack_require__(201);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var inspectSource = __webpack_require__(568);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(163);
var ownKeys = __webpack_require__(1255);
var getOwnPropertyDescriptorModule = __webpack_require__(561);
var definePropertyModule = __webpack_require__(251);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(340);
var getOwnPropertyNamesModule = __webpack_require__(1257);
var getOwnPropertySymbolsModule = __webpack_require__(1260);
var anObject = __webpack_require__(164);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);

module.exports = global;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(572);
var enumBugKeys = __webpack_require__(341);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(248);
var toLength = __webpack_require__(573);
var toAbsoluteIndex = __webpack_require__(1259);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(252);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(92);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(164);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(92);

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
var RE = function (s, f) {
  return RegExp(s, f);
};

exports.UNSUPPORTED_Y = fails(function () {
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(164);
var defineProperties = __webpack_require__(1265);
var enumBugKeys = __webpack_require__(341);
var hiddenKeys = __webpack_require__(339);
var html = __webpack_require__(1267);
var documentCreateElement = __webpack_require__(567);
var sharedKey = __webpack_require__(570);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(162);
var definePropertyModule = __webpack_require__(251);
var anObject = __webpack_require__(164);
var objectKeys = __webpack_require__(1266);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(572);
var enumBugKeys = __webpack_require__(341);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(340);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(92);

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
  var re = RegExp('.', (typeof '').charAt(0));
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(92);

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
  var re = RegExp('(?<a>b)', (typeof '').charAt(5));
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(91);
var userAgent = __webpack_require__(1271);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(340);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(574);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(1274).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(252);
var requireObjectCoercible = __webpack_require__(249);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(565);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(334);
var regexpExec = __webpack_require__(342);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(547);

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(161));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(165));

var _promise = _interopRequireDefault(__webpack_require__(200));

var _stringify = _interopRequireDefault(__webpack_require__(575));

var _client = __webpack_require__(254);

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var parseAndReject = function parseAndReject(response) {
  return response.json().then(function (err) {
    return _promise.default.reject(err);
  });
};

var introspect = /*#__PURE__*/function () {
  var _introspect = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var domain, interactionHandle, stateHandle, version, target, body, headers;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            domain = _ref.domain, interactionHandle = _ref.interactionHandle, stateHandle = _ref.stateHandle, version = _ref.version;
            target = "".concat(domain, "/idp/idx/introspect");
            body = stateHandle ? {
              stateToken: stateHandle
            } : {
              interactionHandle: interactionHandle
            };
            headers = {
              'content-type': "application/ion+json; okta-version=".concat(version),
              // Server wants this version info
              accept: "application/ion+json; okta-version=".concat(version)
            };
            return _context.abrupt("return", (0, _client.request)(target, {
              headers: headers,
              body: (0, _stringify.default)(body)
            }).then(function (response) {
              return response.ok ? response.json() : parseAndReject(response);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function introspect(_x) {
    return _introspect.apply(this, arguments);
  }

  return introspect;
}();

var _default = introspect;
exports.default = _default;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var fails = __webpack_require__(28);
var toIndexedObject = __webpack_require__(83);
var nativeGetOwnPropertyDescriptor = __webpack_require__(128).f;
var DESCRIPTORS = __webpack_require__(44);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1281);
var path = __webpack_require__(23);

module.exports = path.Object.getOwnPropertyDescriptors;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(44);
var ownKeys = __webpack_require__(1282);
var toIndexedObject = __webpack_require__(83);
var getOwnPropertyDescriptorModule = __webpack_require__(128);
var createProperty = __webpack_require__(152);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(96);
var getOwnPropertyNamesModule = __webpack_require__(319);
var getOwnPropertySymbolsModule = __webpack_require__(294);
var anObject = __webpack_require__(53);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1284);
var path = __webpack_require__(23);

var Object = path.Object;

var defineProperties = module.exports = function defineProperties(T, D) {
  return Object.defineProperties(T, D);
};

if (Object.defineProperties.sham) defineProperties.sham = true;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(44);
var defineProperties = __webpack_require__(310);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(516);

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.userAgentHeaders = exports.getUserAgent = void 0;

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* SDK_VERSION is defined in webpack config */
var getUserAgent = function getUserAgent() {
  // TODO: Allow for extending
  return "okta-idx-js/".concat("0.19.0");
};

exports.getUserAgent = getUserAgent;

var userAgentHeaders = function userAgentHeaders() {
  return {
    'X-Okta-User-Agent-Extended': getUserAgent()
  };
};

exports.userAgentHeaders = userAgentHeaders;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(161));

__webpack_require__(1288);

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(582));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(165));

var _promise = _interopRequireDefault(__webpack_require__(200));

var _map = _interopRequireDefault(__webpack_require__(349));

var _entries = _interopRequireDefault(__webpack_require__(589));

var _concat = _interopRequireDefault(__webpack_require__(590));

var _client = __webpack_require__(254);

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var parseAndReject = function parseAndReject(response) {
  return response.json().then(function (err) {
    return _promise.default.reject(err);
  });
};

var bootstrap = /*#__PURE__*/function () {
  var _bootstrap = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var _context;

    var clientId, baseUrl, _ref$scopes, scopes, redirectUri, codeChallenge, codeChallengeMethod, state, target, body, headers;

    return _regenerator.default.wrap(function _callee$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            clientId = _ref.clientId, baseUrl = _ref.baseUrl, _ref$scopes = _ref.scopes, scopes = _ref$scopes === void 0 ? ['openid', 'email'] : _ref$scopes, redirectUri = _ref.redirectUri, codeChallenge = _ref.codeChallenge, codeChallengeMethod = _ref.codeChallengeMethod, state = _ref.state;
            target = "".concat(baseUrl, "/v1/interact");
            body = (0, _map.default)(_context = (0, _entries.default)({
              client_id: clientId,
              scope: scopes.join(' '),
              redirect_uri: redirectUri,
              code_challenge: codeChallenge,
              code_challenge_method: codeChallengeMethod,
              state: state
            })).call(_context, function (_ref2) {
              var _context2;

              var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                  param = _ref3[0],
                  value = _ref3[1];

              return (0, _concat.default)(_context2 = "".concat(param, "=")).call(_context2, encodeURIComponent(value));
            }).join('&');
            headers = {
              'content-type': 'application/x-www-form-urlencoded'
            };
            return _context3.abrupt("return", (0, _client.request)(target, {
              headers: headers,
              body: body
            }).then(function (response) {
              return response.ok ? response.json() : parseAndReject(response);
            }).then(function (data) {
              return data.interaction_handle;
            }));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee);
  }));

  function bootstrap(_x) {
    return _bootstrap.apply(this, arguments);
  }

  return bootstrap;
}();

var _default = bootstrap;
exports.default = _default;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(560);
var IndexedObject = __webpack_require__(563);
var toIndexedObject = __webpack_require__(248);
var arrayMethodIsStrict = __webpack_require__(1289);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(92);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(583);

function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var _getIterator = __webpack_require__(584);

var _isIterable = __webpack_require__(585);

var _Symbol = __webpack_require__(348);

function _iterableToArrayLimit(arr, i) {
  if (typeof _Symbol === "undefined" || !_isIterable(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(523);

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _parsers = _interopRequireDefault(__webpack_require__(1295));

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// We load all the current parsers, because we won't know in advance which version(s) we need to parse
// Expect to only support current major - 1 (also suspect that this limit may never be hit)
// More granularity to be defined as needed
var parsersForVersion = function parsersForVersion(version) {
  switch (version) {
    case '1.0.0':
      return _parsers.default;

    case undefined:
    case null:
      throw new Error('Api version is required');

    default:
      throw new Error("Unknown api version: ".concat(version, ".  Use an exact semver version."));
  }
};

var _default = parsersForVersion;
exports.default = _default;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _makeIdxState = _interopRequireDefault(__webpack_require__(591));

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  makeIdxState: _makeIdxState.default
};
exports.default = _default;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(493);

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1298);

var iterableToArray = __webpack_require__(1299);

var unsupportedIterableToArray = __webpack_require__(586);

var nonIterableSpread = __webpack_require__(1300);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(583);

var arrayLikeToArray = __webpack_require__(588);

function _arrayWithoutHoles(arr) {
  if (_Array$isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(587);

var _isIterable = __webpack_require__(585);

var _Symbol = __webpack_require__(348);

function _iterableToArray(iter) {
  if (typeof _Symbol !== "undefined" && _isIterable(Object(iter))) return _Array$from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$keys2 = __webpack_require__(255);

var _Object$getOwnPropertySymbols = __webpack_require__(343);

var _filterInstanceProperty2 = __webpack_require__(256);

var _Object$getOwnPropertyDescriptor = __webpack_require__(344);

var _forEachInstanceProperty2 = __webpack_require__(202);

var _Object$getOwnPropertyDescriptors = __webpack_require__(345);

var _Object$defineProperties = __webpack_require__(346);

var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.parseIdxResponse = exports.parseNonRemediations = void 0;

__webpack_require__(203);

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(582));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(347));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(1302));

var _typeof2 = _interopRequireDefault(__webpack_require__(1309));

var _fromEntries = _interopRequireDefault(__webpack_require__(593));

var _map = _interopRequireDefault(__webpack_require__(349));

var _forEach = _interopRequireDefault(__webpack_require__(202));

var _filter = _interopRequireDefault(__webpack_require__(256));

var _keys = _interopRequireDefault(__webpack_require__(255));

var _entries = _interopRequireDefault(__webpack_require__(589));

var _concat = _interopRequireDefault(__webpack_require__(590));

var _isArray = _interopRequireDefault(__webpack_require__(350));

var _remediationParser = __webpack_require__(1314);

var _generateIdxAction = _interopRequireDefault(__webpack_require__(594));

var _jsonpathPlus = __webpack_require__(1324);

var _context;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context8; _forEachInstanceProperty2(_context8 = ownKeys(Object(source), true)).call(_context8, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context9; _forEachInstanceProperty2(_context9 = ownKeys(Object(source))).call(_context9, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SKIP_FIELDS = (0, _fromEntries.default)((0, _map.default)(_context = ['remediation', // remediations are put into proceed/neededToProceed
'context' // the API response of 'context' isn't externally useful.  We ignore it and put all non-action (contextual) info into idxState.context
]).call(_context, function (field) {
  return [field, !!'skip this field'];
}));

var parseNonRemediations = function parseNonRemediations(idxResponse) {
  var _context2, _context3;

  var toPersist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var actions = {};
  var context = {};
  (0, _forEach.default)(_context2 = (0, _filter.default)(_context3 = (0, _keys.default)(idxResponse)).call(_context3, function (field) {
    return !SKIP_FIELDS[field];
  })).call(_context2, function (field) {
    var _context4;

    var fieldIsObject = (0, _typeof2.default)(idxResponse[field]) === 'object' && !!idxResponse[field];

    if (!fieldIsObject) {
      // simple fields are contextual info
      context[field] = idxResponse[field];
      return;
    }

    if (idxResponse[field].rel) {
      // top level actions
      actions[idxResponse[field].name] = (0, _generateIdxAction.default)(idxResponse[field], toPersist);
      return;
    }

    var _idxResponse$field = idxResponse[field],
        fieldValue = _idxResponse$field.value,
        type = _idxResponse$field.type,
        info = (0, _objectWithoutProperties2.default)(_idxResponse$field, ["value", "type"]);
    context[field] = _objectSpread({
      type: type
    }, info); // add the non-action parts as context

    if (type !== 'object') {
      // only object values hold actions
      context[field].value = fieldValue;
      return;
    } // We are an object field containing an object value


    context[field].value = {};
    (0, _forEach.default)(_context4 = (0, _entries.default)(fieldValue)).call(_context4, function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          subField = _ref2[0],
          value = _ref2[1];

      if (value.rel) {
        var _context5;

        // is [field].value[subField] an action?
        // add any "action" value subfields to actions
        actions[(0, _concat.default)(_context5 = "".concat(field, "-")).call(_context5, subField.name || subField)] = (0, _generateIdxAction.default)(value, toPersist);
      } else {
        // add non-action value subfields to context
        context[field].value[subField] = value;
      }
    });
  });
  return {
    context: context,
    actions: actions
  };
};

exports.parseNonRemediations = parseNonRemediations;

var expandRelatesTo = function expandRelatesTo(idxResponse, value) {
  var _context6;

  (0, _forEach.default)(_context6 = (0, _keys.default)(value)).call(_context6, function (k) {
    if (k === 'relatesTo') {
      var query = (0, _isArray.default)(value[k]) ? value[k][0] : value[k];

      if (typeof query === 'string') {
        // eslint-disable-next-line new-cap
        var result = (0, _jsonpathPlus.JSONPath)({
          path: query,
          json: idxResponse
        })[0];

        if (result) {
          value[k] = result;
          return;
        }
      }
    }

    if ((0, _isArray.default)(value[k])) {
      var _context7;

      (0, _forEach.default)(_context7 = value[k]).call(_context7, function (innerValue) {
        return expandRelatesTo(idxResponse, innerValue);
      });
    }
  });
};

var convertRemediationAction = function convertRemediationAction(remediation, toPersist) {
  var remediationActions = (0, _remediationParser.generateRemediationFunctions)([remediation], toPersist);
  var actionFn = remediationActions[remediation.name];
  return _objectSpread(_objectSpread({}, remediation), {}, {
    action: actionFn
  });
};

var parseIdxResponse = function parseIdxResponse(idxResponse) {
  var _idxResponse$remediat;

  var toPersist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var remediationData = ((_idxResponse$remediat = idxResponse.remediation) === null || _idxResponse$remediat === void 0 ? void 0 : _idxResponse$remediat.value) || [];
  (0, _forEach.default)(remediationData).call(remediationData, function (remediation) {
    return expandRelatesTo(idxResponse, remediation);
  });
  var remediations = (0, _map.default)(remediationData).call(remediationData, function (remediation) {
    return convertRemediationAction(remediation, toPersist);
  });

  var _parseNonRemediations = parseNonRemediations(idxResponse, toPersist),
      context = _parseNonRemediations.context,
      actions = _parseNonRemediations.actions;

  return {
    remediations: remediations,
    context: context,
    actions: actions
  };
};

exports.parseIdxResponse = parseIdxResponse;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var _indexOfInstanceProperty = __webpack_require__(592);

var _Object$getOwnPropertySymbols = __webpack_require__(1304);

var objectWithoutPropertiesLoose = __webpack_require__(1306);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (_Object$getOwnPropertySymbols) {
    var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (_indexOfInstanceProperty(excluded).call(excluded, key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(489);

module.exports = parent;


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1305);

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(577);

module.exports = parent;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var _indexOfInstanceProperty = __webpack_require__(592);

var _Object$keys = __webpack_require__(1307);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (_indexOfInstanceProperty(excluded).call(excluded, key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1308);

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(457);

module.exports = parent;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol$iterator = __webpack_require__(1310);

var _Symbol = __webpack_require__(348);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(476);

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1312);

module.exports = parent;


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
__webpack_require__(1313);
var path = __webpack_require__(23);

module.exports = path.Object.fromEntries;


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var iterate = __webpack_require__(119);
var createProperty = __webpack_require__(152);

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, undefined, true);
    return obj;
  }
});


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.generateRemediationFunctions = void 0;

__webpack_require__(203);

var _fromEntries = _interopRequireDefault(__webpack_require__(593));

var _map = _interopRequireDefault(__webpack_require__(349));

var _generateIdxAction = _interopRequireDefault(__webpack_require__(594));

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var generateRemediationFunctions = function generateRemediationFunctions(remediationValue) {
  var toPersist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _fromEntries.default)((0, _map.default)(remediationValue).call(remediationValue, function (remediation) {
    return [remediation.name, (0, _generateIdxAction.default)(remediation, toPersist)];
  }));
};

exports.generateRemediationFunctions = generateRemediationFunctions;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1316);

var _sliceInstanceProperty = __webpack_require__(1319);

var _Array$from = __webpack_require__(1320);

var _Symbol = __webpack_require__(1321);

var _getIteratorMethod = __webpack_require__(1322);

var _Array$isArray2 = __webpack_require__(350);

var _getIterator = __webpack_require__(584);

var _Object$defineProperty = __webpack_require__(80);

var _interopRequireDefault = __webpack_require__(90);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.divideActionParamsByMutability = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(350));

__webpack_require__(203);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (_Array$isArray2(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var isFieldMutable = function isFieldMutable(field) {
  // mutable defaults to true, annoyingly
  return field.mutable !== false;
};

var divideSingleActionParamsByMutability = function divideSingleActionParamsByMutability(action) {
  var defaultParamsForAction = {}; // mutable and present

  var neededParamsForAction = []; // mutable values

  var immutableParamsForAction = {}; // immutable
  // TODO: remove assumption that form names are unique, neededParams being an array is a temp fix
  // not all actions have value (e.g. redirect)
  // making sure they are not empty and instead hold the remediation object

  if (!action.value) {
    neededParamsForAction.push(action);
    return {
      defaultParamsForAction: defaultParamsForAction,
      neededParamsForAction: neededParamsForAction,
      immutableParamsForAction: immutableParamsForAction
    };
  }

  var _iterator = _createForOfIteratorHelper(action.value),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;

      if (isFieldMutable(field)) {
        var _field$value;

        neededParamsForAction.push(field);

        if ((_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : false) {
          defaultParamsForAction[field.name] = field.value;
        }
      } else {
        var _field$value2;

        immutableParamsForAction[field.name] = (_field$value2 = field.value) !== null && _field$value2 !== void 0 ? _field$value2 : '';
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    defaultParamsForAction: defaultParamsForAction,
    neededParamsForAction: neededParamsForAction,
    immutableParamsForAction: immutableParamsForAction
  };
};

var divideActionParamsByMutability = function divideActionParamsByMutability(actionList) {
  // TODO: when removing form name is unique assumption, this may all be redundant
  actionList = (0, _isArray.default)(actionList) ? actionList : [actionList];
  var neededParams = [];
  var defaultParams = {};
  var immutableParams = {};

  var _iterator2 = _createForOfIteratorHelper(actionList),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var action = _step2.value;

      var _divideSingleActionPa = divideSingleActionParamsByMutability(action),
          defaultParamsForAction = _divideSingleActionPa.defaultParamsForAction,
          neededParamsForAction = _divideSingleActionPa.neededParamsForAction,
          immutableParamsForAction = _divideSingleActionPa.immutableParamsForAction;

      neededParams.push(neededParamsForAction);
      defaultParams[action.name] = defaultParamsForAction;
      immutableParams[action.name] = immutableParamsForAction;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return {
    defaultParams: defaultParams,
    neededParams: neededParams,
    immutableParams: immutableParams
  };
};

exports.divideActionParamsByMutability = divideActionParamsByMutability;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(351);
var redefine = __webpack_require__(335);
var toString = __webpack_require__(1317);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(351);
var classof = __webpack_require__(1318);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(351);
var classofRaw = __webpack_require__(334);
var wellKnownSymbol = __webpack_require__(253);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(496);

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(470);

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(499);

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1323);

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(139);
var getIteratorMethod = __webpack_require__(192);

module.exports = getIteratorMethod;


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JSONPath", function() { return JSONPath; });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var hasOwnProp = Object.prototype.hasOwnProperty;
/**
* @typedef {null|boolean|number|string|PlainObject|GenericArray} JSONObject
*/

/**
 * Copies array and then pushes item into it.
 * @param {GenericArray} arr Array to copy and into which to push
 * @param {any} item Array item to add (to end)
 * @returns {GenericArray} Copy of the original array
 */

function push(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
/**
 * Copies array and then unshifts item into it.
 * @param {any} item Array item to add (to beginning)
 * @param {GenericArray} arr Array to copy and into which to unshift
 * @returns {GenericArray} Copy of the original array
 */


function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
/**
 * Caught when JSONPath is used without `new` but rethrown if with `new`
 * @extends Error
 */


var NewError = /*#__PURE__*/function (_Error) {
  _inherits(NewError, _Error);

  var _super = _createSuper(NewError);

  /**
   * @param {any} value The evaluated scalar value
   */
  function NewError(value) {
    var _this;

    _classCallCheck(this, NewError);

    _this = _super.call(this, 'JSONPath should not be called with "new" (it prevents return ' + 'of (unwrapped) scalar values)');
    _this.avoidNew = true;
    _this.value = value;
    _this.name = 'NewError';
    return _this;
  }

  return NewError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
* @typedef {PlainObject} ReturnObject
* @property {string} path
* @property {JSONObject} value
* @property {PlainObject|GenericArray} parent
* @property {string} parentProperty
*/

/**
* @callback JSONPathCallback
* @param {string|PlainObject} preferredOutput
* @param {"value"|"property"} type
* @param {ReturnObject} fullRetObj
* @returns {void}
*/

/**
* @callback OtherTypeCallback
* @param {JSONObject} val
* @param {string} path
* @param {PlainObject|GenericArray} parent
* @param {string} parentPropName
* @returns {boolean}
*/

/* eslint-disable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @typedef {PlainObject} JSONPathOptions
 * @property {JSON} json
 * @property {string|string[]} path
 * @property {"value"|"path"|"pointer"|"parent"|"parentProperty"|"all"} [resultType="value"]
 * @property {boolean} [flatten=false]
 * @property {boolean} [wrap=true]
 * @property {PlainObject} [sandbox={}]
 * @property {boolean} [preventEval=false]
 * @property {PlainObject|GenericArray|null} [parent=null]
 * @property {string|null} [parentProperty=null]
 * @property {JSONPathCallback} [callback]
 * @property {OtherTypeCallback} [otherTypeCallback] Defaults to
 *   function which throws on encountering `@other`
 * @property {boolean} [autostart=true]
 */

/* eslint-enable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @param {string|JSONPathOptions} opts If a string, will be treated as `expr`
 * @param {string} [expr] JSON path to evaluate
 * @param {JSON} [obj] JSON object to evaluate against
 * @param {JSONPathCallback} [callback] Passed 3 arguments: 1) desired payload
 *     per `resultType`, 2) `"value"|"property"`, 3) Full returned object with
 *     all payloads
 * @param {OtherTypeCallback} [otherTypeCallback] If `@other()` is at the end
 *   of one's query, this will be invoked with the value of the item, its
 *   path, its parent, and its parent's property name, and it should return
 *   a boolean indicating whether the supplied value belongs to the "other"
 *   type or not (or it may handle transformations and return `false`).
 * @returns {JSONPath}
 * @class
 */


function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  // eslint-disable-next-line no-restricted-syntax
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e) {
      if (!e.avoidNew) {
        throw e;
      }

      return e.value;
    }
  }

  if (typeof opts === 'string') {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }

  var optObj = opts && _typeof(opts) === 'object';
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || 'value';
  this.flatten = opts.flatten || false;
  this.wrap = hasOwnProp.call(opts, 'wrap') ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.preventEval = opts.preventEval || false;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;

  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function () {
    throw new TypeError('You must supply an otherTypeCallback callback option ' + 'with the @other() operator.');
  };

  if (opts.autostart !== false) {
    var args = {
      path: optObj ? opts.path : expr
    };

    if (!optObj) {
      args.json = obj;
    } else if ('json' in opts) {
      args.json = opts.json;
    }

    var ret = this.evaluate(args);

    if (!ret || _typeof(ret) !== 'object') {
      throw new NewError(ret);
    }

    return ret;
  }
} // PUBLIC METHODS


JSONPath.prototype.evaluate = function (expr, json, callback, otherTypeCallback) {
  var _this2 = this;

  var currParent = this.parent,
      currParentProperty = this.parentProperty;
  var flatten = this.flatten,
      wrap = this.wrap;
  this.currResultType = this.resultType;
  this.currPreventEval = this.preventEval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;

  if (expr && _typeof(expr) === 'object' && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== '') {
      throw new TypeError('You must supply a "path" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    if (!hasOwnProp.call(expr, 'json')) {
      throw new TypeError('You must supply a "json" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    var _expr = expr;
    json = _expr.json;
    flatten = hasOwnProp.call(expr, 'flatten') ? expr.flatten : flatten;
    this.currResultType = hasOwnProp.call(expr, 'resultType') ? expr.resultType : this.currResultType;
    this.currSandbox = hasOwnProp.call(expr, 'sandbox') ? expr.sandbox : this.currSandbox;
    wrap = hasOwnProp.call(expr, 'wrap') ? expr.wrap : wrap;
    this.currPreventEval = hasOwnProp.call(expr, 'preventEval') ? expr.preventEval : this.currPreventEval;
    callback = hasOwnProp.call(expr, 'callback') ? expr.callback : callback;
    this.currOtherTypeCallback = hasOwnProp.call(expr, 'otherTypeCallback') ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = hasOwnProp.call(expr, 'parent') ? expr.parent : currParent;
    currParentProperty = hasOwnProp.call(expr, 'parentProperty') ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }

  currParent = currParent || null;
  currParentProperty = currParentProperty || null;

  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }

  if (!expr && expr !== '' || !json) {
    return undefined;
  }

  var exprList = JSONPath.toPathArray(expr);

  if (exprList[0] === '$' && exprList.length > 1) {
    exprList.shift();
  }

  this._hasParentSelector = null;

  var result = this._trace(exprList, json, ['$'], currParent, currParentProperty, callback).filter(function (ea) {
    return ea && !ea.isParentSelector;
  });

  if (!result.length) {
    return wrap ? [] : undefined;
  }

  if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }

  return result.reduce(function (rslt, ea) {
    var valOrPath = _this2._getPreferredOutput(ea);

    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }

    return rslt;
  }, []);
}; // PRIVATE METHODS


JSONPath.prototype._getPreferredOutput = function (ea) {
  var resultType = this.currResultType;

  switch (resultType) {
    case 'all':
      {
        var path = Array.isArray(ea.path) ? ea.path : JSONPath.toPathArray(ea.path);
        ea.pointer = JSONPath.toPointer(path);
        ea.path = typeof ea.path === 'string' ? ea.path : JSONPath.toPathString(ea.path);
        return ea;
      }

    case 'value':
    case 'parent':
    case 'parentProperty':
      return ea[resultType];

    case 'path':
      return JSONPath.toPathString(ea[resultType]);

    case 'pointer':
      return JSONPath.toPointer(ea.path);

    default:
      throw new TypeError('Unknown result type');
  }
};

JSONPath.prototype._handleCallback = function (fullRetObj, callback, type) {
  if (callback) {
    var preferredOutput = this._getPreferredOutput(fullRetObj);

    fullRetObj.path = typeof fullRetObj.path === 'string' ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path); // eslint-disable-next-line node/callback-return

    callback(preferredOutput, type, fullRetObj);
  }
};
/**
 *
 * @param {string} expr
 * @param {JSONObject} val
 * @param {string} path
 * @param {PlainObject|GenericArray} parent
 * @param {string} parentPropName
 * @param {JSONPathCallback} callback
 * @param {boolean} hasArrExpr
 * @param {boolean} literalPriority
 * @returns {ReturnObject|ReturnObject[]}
 */


JSONPath.prototype._trace = function (expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
  var _this3 = this;

  // No expr to follow? return path and value as the result of
  //  this trace branch
  var retObj;

  if (!expr.length) {
    retObj = {
      path: path,
      value: val,
      parent: parent,
      parentProperty: parentPropName,
      hasArrExpr: hasArrExpr
    };

    this._handleCallback(retObj, callback, 'value');

    return retObj;
  }

  var loc = expr[0],
      x = expr.slice(1); // We need to gather the return value of recursive trace calls in order to
  // do the parent sel computation.

  var ret = [];
  /**
   *
   * @param {ReturnObject|ReturnObject[]} elems
   * @returns {void}
   */

  function addRet(elems) {
    if (Array.isArray(elems)) {
      // This was causing excessive stack size in Node (with or
      //  without Babel) against our performance test:
      //  `ret.push(...elems);`
      elems.forEach(function (t) {
        ret.push(t);
      });
    } else {
      ret.push(elems);
    }
  }

  if ((typeof loc !== 'string' || literalPriority) && val && hasOwnProp.call(val, loc)) {
    // simple case--directly follow property
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr)); // eslint-disable-next-line unicorn/prefer-switch -- Part of larger `if`
  } else if (loc === '*') {
    // all child properties
    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      addRet(_this3._trace(unshift(m, _x), v, p, par, pr, cb, true, true));
    });
  } else if (loc === '..') {
    // all descendent parent properties
    // Check remaining expression with val's immediate children
    addRet(this._trace(x, val, path, parent, parentPropName, callback, hasArrExpr));

    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      // We don't join m and x here because we only want parents,
      //   not scalar values
      if (_typeof(v[m]) === 'object') {
        // Keep going with recursive descent on val's
        //   object children
        addRet(_this3._trace(unshift(l, _x), v[m], push(p, m), v, m, cb, true));
      }
    }); // The parent sel computation is handled in the frame above using the
    // ancestor object of val

  } else if (loc === '^') {
    // This is not a final endpoint, so we do not invoke the callback here
    this._hasParentSelector = true;
    return {
      path: path.slice(0, -1),
      expr: x,
      isParentSelector: true
    };
  } else if (loc === '~') {
    // property name
    retObj = {
      path: push(path, loc),
      value: parentPropName,
      parent: parent,
      parentProperty: null
    };

    this._handleCallback(retObj, callback, 'property');

    return retObj;
  } else if (loc === '$') {
    // root only
    addRet(this._trace(x, val, path, null, null, callback, hasArrExpr));
  } else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(loc)) {
    // [start:end:step]  Python slice syntax
    addRet(this._slice(loc, x, val, path, parent, parentPropName, callback));
  } else if (loc.indexOf('?(') === 0) {
    // [?(expr)] (filtering)
    if (this.currPreventEval) {
      throw new Error('Eval [?(expr)] prevented in JSONPath expression.');
    }

    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      if (_this3._eval(l.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, '$1'), v[m], m, p, par, pr)) {
        addRet(_this3._trace(unshift(m, _x), v, p, par, pr, cb, true));
      }
    });
  } else if (loc[0] === '(') {
    // [(expr)] (dynamic property/index)
    if (this.currPreventEval) {
      throw new Error('Eval [(expr)] prevented in JSONPath expression.');
    } // As this will resolve to a property name (but we don't know it
    //  yet), property and parent information is relative to the
    //  parent of the property to which this expression will resolve


    addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x), val, path, parent, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === '@') {
    // value type: @boolean(), etc.
    var addType = false;
    var valueType = loc.slice(1, -2);

    switch (valueType) {
      case 'scalar':
        if (!val || !['object', 'function'].includes(_typeof(val))) {
          addType = true;
        }

        break;

      case 'boolean':
      case 'string':
      case 'undefined':
      case 'function':
        // eslint-disable-next-line valid-typeof
        if (_typeof(val) === valueType) {
          addType = true;
        }

        break;

      case 'integer':
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }

        break;

      case 'number':
        if (Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'nonFinite':
        if (typeof val === 'number' && !Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'object':
        // eslint-disable-next-line valid-typeof
        if (val && _typeof(val) === valueType) {
          addType = true;
        }

        break;

      case 'array':
        if (Array.isArray(val)) {
          addType = true;
        }

        break;

      case 'other':
        addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
        break;

      case 'null':
        if (val === null) {
          addType = true;
        }

        break;

      /* istanbul ignore next */

      default:
        throw new TypeError('Unknown value type ' + valueType);
    }

    if (addType) {
      retObj = {
        path: path,
        value: val,
        parent: parent,
        parentProperty: parentPropName
      };

      this._handleCallback(retObj, callback, 'value');

      return retObj;
    } // `-escaped property

  } else if (loc[0] === '`' && val && hasOwnProp.call(val, loc.slice(1))) {
    var locProp = loc.slice(1);
    addRet(this._trace(x, val[locProp], push(path, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(',')) {
    // [name1,name2,...]
    var parts = loc.split(',');

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;
        addRet(this._trace(unshift(part, x), val, path, parent, parentPropName, callback, true));
      } // simple case--directly follow property

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr, true));
  } // We check the resulting values for parent selections. For parent
  // selections we discard the value object and continue the trace with the
  // current val object


  if (this._hasParentSelector) {
    for (var t = 0; t < ret.length; t++) {
      var rett = ret[t];

      if (rett && rett.isParentSelector) {
        var tmp = this._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);

        if (Array.isArray(tmp)) {
          ret[t] = tmp[0];
          var tl = tmp.length;

          for (var tt = 1; tt < tl; tt++) {
            t++;
            ret.splice(t, 0, tmp[tt]);
          }
        } else {
          ret[t] = tmp;
        }
      }
    }
  }

  return ret;
};

JSONPath.prototype._walk = function (loc, expr, val, path, parent, parentPropName, callback, f) {
  if (Array.isArray(val)) {
    var n = val.length;

    for (var i = 0; i < n; i++) {
      f(i, loc, expr, val, path, parent, parentPropName, callback);
    }
  } else if (val && _typeof(val) === 'object') {
    Object.keys(val).forEach(function (m) {
      f(m, loc, expr, val, path, parent, parentPropName, callback);
    });
  }
};

JSONPath.prototype._slice = function (loc, expr, val, path, parent, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return undefined;
  }

  var len = val.length,
      parts = loc.split(':'),
      step = parts[2] && Number.parseInt(parts[2]) || 1;
  var start = parts[0] && Number.parseInt(parts[0]) || 0,
      end = parts[1] && Number.parseInt(parts[1]) || len;
  start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
  end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
  var ret = [];

  for (var i = start; i < end; i += step) {
    var tmp = this._trace(unshift(i, expr), val, path, parent, parentPropName, callback, true); // Should only be possible to be an array here since first part of
    //   ``unshift(i, expr)` passed in above would not be empty, nor `~`,
    //     nor begin with `@` (as could return objects)
    // This was causing excessive stack size in Node (with or
    //  without Babel) against our performance test: `ret.push(...tmp);`


    tmp.forEach(function (t) {
      ret.push(t);
    });
  }

  return ret;
};

JSONPath.prototype._eval = function (code, _v, _vname, path, parent, parentPropName) {
  if (code.includes('@parentProperty')) {
    this.currSandbox._$_parentProperty = parentPropName;
    code = code.replace(/@parentProperty/g, '_$_parentProperty');
  }

  if (code.includes('@parent')) {
    this.currSandbox._$_parent = parent;
    code = code.replace(/@parent/g, '_$_parent');
  }

  if (code.includes('@property')) {
    this.currSandbox._$_property = _vname;
    code = code.replace(/@property/g, '_$_property');
  }

  if (code.includes('@path')) {
    this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
    code = code.replace(/@path/g, '_$_path');
  }

  if (code.includes('@root')) {
    this.currSandbox._$_root = this.json;
    code = code.replace(/@root/g, '_$_root');
  }

  if (/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(code)) {
    this.currSandbox._$_v = _v;
    code = code.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, '_$_v$1');
  }

  try {
    return this.vm.runInNewContext(code, this.currSandbox);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    throw new Error('jsonPath: ' + e.message + ': ' + code);
  }
}; // PUBLIC CLASS PROPERTIES AND METHODS
// Could store the cache object itself


JSONPath.cache = {};
/**
 * @param {string[]} pathArr Array to convert
 * @returns {string} The path string
 */

JSONPath.toPathString = function (pathArr) {
  var x = pathArr,
      n = x.length;
  var p = '$';

  for (var i = 1; i < n; i++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
      p += /^[\*0-9]+$/.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
    }
  }

  return p;
};
/**
 * @param {string} pointer JSON Path
 * @returns {string} JSON Pointer
 */


JSONPath.toPointer = function (pointer) {
  var x = pointer,
      n = x.length;
  var p = '';

  for (var i = 1; i < n; i++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
      p += '/' + x[i].toString().replace(/~/g, '~0').replace(/\//g, '~1');
    }
  }

  return p;
};
/**
 * @param {string} expr Expression to convert
 * @returns {string[]}
 */


JSONPath.toPathArray = function (expr) {
  var cache = JSONPath.cache;

  if (cache[expr]) {
    return cache[expr].concat();
  }

  var subx = [];
  var normalized = expr // Properties
  .replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ';$&;') // Parenthetical evaluations (filtering and otherwise), directly
  //   within brackets or single quotes
  .replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function ($0, $1) {
    return '[#' + (subx.push($1) - 1) + ']';
  }) // Escape periods and tildes within properties
  .replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function ($0, prop) {
    return "['" + prop.replace(/\./g, '%@%').replace(/~/g, '%%@@%%') + "']";
  }) // Properties operator
  .replace(/~/g, ';~;') // Split by property boundaries
  .replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ';') // Reinsert periods within properties
  .replace(/%@%/g, '.') // Reinsert tildes within properties
  .replace(/%%@@%%/g, '~') // Parent
  .replace(/(?:;)?(\^+)(?:;)?/g, function ($0, ups) {
    return ';' + ups.split('').join(';') + ';';
  }) // Descendents
  .replace(/;;;|;;/g, ';..;') // Remove trailing
  .replace(/;$|'?\]|'$/g, '');
  var exprList = normalized.split(';').map(function (exp) {
    var match = exp.match(/#([0-9]+)/);
    return !match || !match[1] ? exp : subx[match[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};

/**
* @callback ConditionCallback
* @param {any} item
* @returns {boolean}
*/

/**
 * Copy items out of one array into another.
 * @param {GenericArray} source Array with items to copy
 * @param {GenericArray} target Array to which to copy
 * @param {ConditionCallback} conditionCb Callback passed the current item;
 *     will move item if evaluates to `true`
 * @returns {void}
 */

var moveToAnotherArray = function moveToAnotherArray(source, target, conditionCb) {
  var il = source.length;

  for (var i = 0; i < il; i++) {
    var item = source[i];

    if (conditionCb(item)) {
      target.push(source.splice(i--, 1)[0]);
    }
  }
};

JSONPath.prototype.vm = {
  /**
   * @param {string} expr Expression to evaluate
   * @param {PlainObject} context Object whose items will be added
   *   to evaluation
   * @returns {any} Result of evaluated code
   */
  runInNewContext: function runInNewContext(expr, context) {
    var keys = Object.keys(context);
    var funcs = [];
    moveToAnotherArray(keys, funcs, function (key) {
      return typeof context[key] === 'function';
    });
    var values = keys.map(function (vr, i) {
      return context[vr];
    });
    var funcString = funcs.reduce(function (s, func) {
      var fString = context[func].toString();

      if (!/function/.test(fString)) {
        fString = 'function ' + fString;
      }

      return 'var ' + func + '=' + fString + ';' + s;
    }, '');
    expr = funcString + expr; // Mitigate http://perfectionkills.com/global-eval-what-are-the-options/#new_function

    if (!/(["'])use strict\1/.test(expr) && !keys.includes('arguments')) {
      expr = 'var arguments = undefined;' + expr;
    } // Remove last semi so `return` will be inserted before
    //  the previous one instead, allowing for the return
    //  of a bare ending expression


    expr = expr.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, ''); // Insert `return`

    var lastStatementEnd = expr.lastIndexOf(';');
    var code = lastStatementEnd > -1 ? expr.slice(0, lastStatementEnd + 1) + ' return ' + expr.slice(lastStatementEnd + 1) : ' return ' + expr; // eslint-disable-next-line no-new-func

    return _construct(Function, _toConsumableArray(keys).concat([code])).apply(void 0, _toConsumableArray(values));
  }
};




/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.startLoginFlow = startLoginFlow;

var _regenerator = _interopRequireDefault(__webpack_require__(120));

var _promise = _interopRequireDefault(__webpack_require__(195));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(121));

var _Errors = _interopRequireDefault(__webpack_require__(55));

var _interact = __webpack_require__(556);

var _introspect = __webpack_require__(595);

var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(331));

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var handleProxyIdxResponse = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(settings) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _promise.default.resolve({
              rawIdxState: settings.get('proxyIdxResponse'),
              context: settings.get('proxyIdxResponse'),
              neededToProceed: []
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleProxyIdxResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();

function startLoginFlow(_x2) {
  return _startLoginFlow.apply(this, arguments);
}

function _startLoginFlow() {
  _startLoginFlow = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(settings) {
    var stateHandleFromSession, stateHandle;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!settings.get('proxyIdxResponse')) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", handleProxyIdxResponse(settings));

          case 2:
            if (settings.get('overrideExistingStateToken')) {
              _sessionStorageHelper.default.removeStateHandle();
            } // Use interaction code flow, if enabled


            if (!settings.get('useInteractionCodeFlow')) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", (0, _interact.interact)(settings));

          case 5:
            // Use stateToken from session storage if exists
            // See more details at ./docs/use-session-token-prior-to-settings.png
            stateHandleFromSession = _sessionStorageHelper.default.getStateHandle();

            if (!stateHandleFromSession) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", (0, _introspect.introspect)(settings, stateHandleFromSession).then(function (idxResp) {
              // 1. abandon the settings.stateHandle given session.stateHandle is still valid
              settings.set('stateToken', stateHandleFromSession); // 2. chain the idxResp to next handler

              return idxResp;
            }).catch(function () {
              // 1. remove session.stateHandle
              _sessionStorageHelper.default.removeStateHandle(); // 2. start the login again in order to introspect on settings.stateHandle


              return startLoginFlow(settings);
            }));

          case 8:
            // Use stateToken from options
            stateHandle = settings.get('stateToken');

            if (!stateHandle) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", (0, _introspect.introspect)(settings, stateHandle));

          case 11:
            throw new _Errors.default.ConfigError('Set "useInteractionCodeFlow" to true in configuration to enable the ' + 'interaction_code" flow for self-hosted widget.');

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _startLoginFlow.apply(this, arguments);
}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.configIdxJsClient = configIdxJsClient;

var _oktaIdxJs = _interopRequireDefault(__webpack_require__(333));

var _config = _interopRequireDefault(__webpack_require__(238));

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function configIdxJsClient(appState) {
  // For certain flows, we need to generate a device fingerprint
  // to determine if we need to send a "New Device Sign-on Notification".
  // In the future, this should be handled by okta-auth-js
  _oktaIdxJs.default.client.interceptors.request.use(function (requestConfig) {
    var fingerprint = appState.get('deviceFingerprint');

    if (fingerprint) {
      requestConfig.headers['X-Device-Fingerprint'] = fingerprint;
    }

    requestConfig.headers['X-Okta-User-Agent-Extended'] = "okta-signin-widget-".concat(_config.default.version);
  });
}

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = transformIdxResponse;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _okta = __webpack_require__(2);

var _responseTransformer = _interopRequireDefault(__webpack_require__(1328));

var _uiSchemaTransformer = _interopRequireDefault(__webpack_require__(1329));

var _i18nTransformer = _interopRequireDefault(__webpack_require__(142));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// Transforms an IDX response to an ION response
function transformIdxResponse(settings, curResponse, lastResponse) {
  var ionResponse = _okta._.compose(_i18nTransformer.default, (0, _bind.default)(_uiSchemaTransformer.default).call(_uiSchemaTransformer.default, {}, settings), (0, _bind.default)(_responseTransformer.default).call(_responseTransformer.default, {}, settings))(curResponse, lastResponse);

  return ionResponse;
}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _map = _interopRequireDefault(__webpack_require__(40));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(160));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Transform the ion spec response into canonical format.
 */

/**
 * Authn V2 response
 * @typedef {Object} AuthnResponse
 */

/**
 * @typedef {Object} AuthnResult
 * @property {Object=} user
 * @property {Object=} authenticator
 */
var isObject = function isObject(x) {
  return _okta._.isObject(x);
};

var isError = function isError(response) {
  return !!response.messages;
};
/**
 * Flatten first level objects from response
 */


var getFirstLevelObjects = function getFirstLevelObjects(resp) {
  var result = {};

  _okta._.each(resp, function () {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = arguments.length > 1 ? arguments[1] : undefined;

    // if key is remediation we don't do any transformation
    if (key === 'remediation') {
      return;
    } // for arrays we just want it as a top level object
    // Example authenticators array in select-authenticator form


    if (val.type === 'array') {
      result[key] = {
        value: val.value
      };
    } // for handling attributes with type object


    if (val.type === 'object') {
      result[key] = val.value;
    }
  });

  return result;
};

var getRemediationValues = function getRemediationValues(idx) {
  var _context;

  var remediationValues = [];
  var hasSkipRemediationOnly = idx.neededToProceed.length === 1 && idx.neededToProceed[0].name === 'skip';

  if (_okta._.isEmpty(idx.neededToProceed) || hasSkipRemediationOnly) {
    // no remediation or only skip remediation with success
    if (idx.context.success) {
      remediationValues.push({
        name: idx.context.success.name,
        href: idx.context.success.href,
        value: []
      });
    } else if (idx.context.messages) {
      // no remediation or only skip remediation with messages
      remediationValues.push({
        name: _RemediationConstants.FORMS.TERMINAL,
        // Using `value` is unnecessary as `messages` will be display via `TerminalView.showMessages`,
        // even though might sound a little counterintuitive.
        // The reason being is there is `BaseForm.showMessages` that is intended to handle
        // messages generically.
        value: []
      });
    } else if (idx.context.deviceEnrollment) {
      // no remediation or only skip remediation with messages for device enrollment state
      // and the state is meant to be terminal state with different UI than the regular terminal view
      remediationValues.push({
        name: _RemediationConstants.FORMS.DEVICE_ENROLLMENT_TERMINAL,
        value: []
      });
    }
  }

  return {
    remediations: (0, _concat.default)(_context = []).call(_context, remediationValues, (0, _toConsumableArray2.default)(idx.neededToProceed))
  };
};
/**
 * To support `idps` configuration in OIE.
 * https://github.com/okta/okta-signin-widget#openid-connect
 */


var injectIdPConfigButtonToRemediation = function injectIdPConfigButtonToRemediation(settings, idxResp) {
  var widgetRemedations = idxResp.remediations;
  var hasIdentifyRemedation = (0, _filter.default)(widgetRemedations).call(widgetRemedations, function (r) {
    return r.name === 'identify';
  });

  if (hasIdentifyRemedation.length === 0) {
    return idxResp;
  }

  var idpsConfig = settings.get('idps');

  if ((0, _isArray.default)(idpsConfig)) {
    var _context2;

    var existsRedirectIdpIds = {};
    (0, _forEach.default)(widgetRemedations).call(widgetRemedations, function (r) {
      if (r.name === _RemediationConstants.FORMS.REDIRECT_IDP && r.idp) {
        existsRedirectIdpIds[r.idp.id] = true;
      }
    });
    var baseUrl = settings.get('baseUrl');
    var stateHandle = idxResp.idx.context.stateHandle;
    var redirectIdpRemedations = (0, _map.default)(_context2 = (0, _filter.default)(idpsConfig).call(idpsConfig, function (c) {
      return !existsRedirectIdpIds[c.id];
    }) // omit idps that are already in remediation.
    ).call(_context2, function (idpConfig) {
      var _context3, _context4;

      var idp = {
        id: idpConfig.id,
        name: idpConfig.text
      };
      var redirectUri = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(baseUrl, "/sso/idps/")).call(_context4, idpConfig.id, "?stateToken=")).call(_context3, stateHandle);

      if (idpConfig.className) {
        idp.className = idpConfig.className;
      }

      return {
        name: _RemediationConstants.FORMS.REDIRECT_IDP,
        type: idpConfig.type,
        idp: idp,
        href: redirectUri
      };
    });
    idxResp.remediations = (0, _concat.default)(widgetRemedations).call(widgetRemedations, redirectIdpRemedations);
  }

  return idxResp;
};
/**
 * IFF there is one `redirect-idp` remediation form, widget will automatically redirect to `redirect-idp.href`.
 *
 * The idea now is to reuse `success-redirect` thus converts `redirect-idp` to `success-redirect` form.
 */


var convertRedirectIdPToSuccessRedirectIffOneIdp = function convertRedirectIdPToSuccessRedirectIffOneIdp(settings, result, lastResult) {
  if ((0, _isArray.default)(result.remediations)) {
    var _context5;

    var redirectIdpRemediations = (0, _filter.default)(_context5 = result.remediations).call(_context5, function (idp) {
      return idp.name === _RemediationConstants.FORMS.REDIRECT_IDP;
    });

    if (redirectIdpRemediations.length !== 1 || result.remediations.length !== 1) {
      return;
    } // Direct auth clients should not redirect on the initial response


    var isDirectAuth = settings.get('oauth2Enabled');

    if (isDirectAuth && !lastResult) {
      return;
    }

    var successRedirect = {
      name: _RemediationConstants.FORMS.SUCCESS_REDIRECT,
      href: redirectIdpRemediations[0].href,
      value: []
    };
    result.remediations = [successRedirect];
  }
};
/**
 * API reuses `redirect-idp` remediation form for PIV IdP and IdP Authenticator.
 * IdP Authenticator becomes outlier comparing with other Authenticators in terms of
 * using `challenge-authenticator` and `enroll-authenticator` remediation form.
 * The UX for PIV IdP is different from other idps in terms of the PIV
 * instructions view that needs to be rendered before we redirect to mtls.
 *
 * This function changes `redirect-idp` to `challenge-authenticator` or `enroll-authenticator`
 * for IdP Authenticator and changes `redirect-idp` to `piv-idp` for PIV IdP.
 */


var modifyFormNameForIdP = function modifyFormNameForIdP(result) {
  if ((0, _isArray.default)(result.remediations)) {
    var _context6;

    (0, _forEach.default)(_context6 = result.remediations).call(_context6, function (remediation) {
      var _remediation$relatesT, _remediation$relatesT2;

      if (remediation.name === _RemediationConstants.FORMS.REDIRECT_IDP && (remediation === null || remediation === void 0 ? void 0 : (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key) === _RemediationConstants.AUTHENTICATOR_KEY.IDP) {
        // idp authenticator
        var isVerifyFlow = Object.prototype.hasOwnProperty.call(result, 'currentAuthenticatorEnrollment');
        remediation.name = isVerifyFlow ? 'challenge-authenticator' : 'enroll-authenticator';
      }

      if (remediation.name === _RemediationConstants.FORMS.REDIRECT_IDP && remediation.type === _RemediationConstants.IDP_FORM_TYPE.X509) {
        // piv idp
        remediation.name = _RemediationConstants.FORMS.PIV_IDP;
      }
    });
  }
};

var isFailureRedirect = function isFailureRedirect(result) {
  var context = result.idx.context;
  return context.failure && context.failure.name === 'failure-redirect';
};

var handleFailureRedirect = function handleFailureRedirect(settings, result) {
  var context = result.idx.context; // Direct auth clients will usually prefer to display the error instead of redirecting

  var isDirectAuth = settings.get('oauth2Enabled');
  var alwaysRedirect = settings.get('redirect') === 'always'; // redirect option overrides default behavior

  if (isDirectAuth && !alwaysRedirect) {
    return;
  }

  var failureRedirect = {
    name: _RemediationConstants.FORMS.FAILURE_REDIRECT,
    href: context.failure.href,
    value: []
  };
  result.remediations = [failureRedirect];
};
/**
 * @param {Models.Settings} user configuration
 * @param {idx} idx object
 * @returns {} transformed object with flattened firstlevel objects, idx and remediations array
 * Example: {
 *  idx: {
 *    proceed: ƒ(),
 *    neededToProceed: [],
 *    actions: {cancel: ƒ()},
 *    context: {},
 *  },
 *  remediations: [],
 *  authenticators: {},
 *  authenticator: {},
 *  messages: {},
 *  deviceEnrollment: {},
 * }
 */


var convert = function convert(settings) {
  var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lastResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!isObject(idx.rawIdxState)) {
    return null;
  } // build result object


  var firstLevelObjects = getFirstLevelObjects(idx.rawIdxState);
  var remediationValues = getRemediationValues(idx);
  var result = (0, _assign.default)({}, firstLevelObjects, remediationValues, {
    idx: idx
  }); // transform result object

  if (isError(result) && isFailureRedirect(result)) {
    handleFailureRedirect(settings, result);
  } // Override the `result` to handle custom IdP login buttons
  // and update the form for IdP Authenticators.


  injectIdPConfigButtonToRemediation(settings, result);
  modifyFormNameForIdP(result);

  if (!isError(result)) {
    // Only redirect to the IdP if we are not in an error flow
    convertRedirectIdPToSuccessRedirectIffOneIdp(settings, result, lastResult);
  }

  return result;
};

var _default = convert;
exports.default = _default;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _map = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(2);

var _ionBooleanHandler = _interopRequireDefault(__webpack_require__(1330));

var _ionObjectHandler = _interopRequireDefault(__webpack_require__(554));

var _ionStringHandler = _interopRequireDefault(__webpack_require__(1331));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Create UI Schema into remedation object base on remediation values
 */
var UISchemaHandlers = {
  string: _ionStringHandler.default,
  boolean: _ionBooleanHandler.default,
  object: _ionObjectHandler.default
};
/**
 *
 * @param {AuthResult} transformedResp
 * @param {IONForm} remeditationForm
 */

var createUISchema = function createUISchema(transformedResp, remediationForm, settings) {
  var _context, _context2;

  // For cases where field itself is a form, it has a formname and we are appending the formname to each field.
  // Sort of flat the structure in order to align Courage flatten Model. The flatten structure will be converted
  // back to object hierarchy through `Model.toJSON`.
  // For simplicity we are assuming that when field itself is a form its only one level deep.
  var remediationValue = (0, _map.default)(_context = (0, _filter.default)(_context2 = _okta._.chain(remediationForm.value || [])).call(_context2, function (v) {
    return v.visible !== false;
  })).call(_context, function (v) {
    var _v$value;

    var nestedForm;

    if (v.form) {
      nestedForm = v.form;
    } else if ((_v$value = v.value) === null || _v$value === void 0 ? void 0 : _v$value.form) {
      nestedForm = v.value.form;
    }

    if (nestedForm) {
      var _context3;

      var inputGroupName = v.name;
      return (0, _map.default)(_context3 = nestedForm.value).call(_context3, function (input) {
        return (0, _assign.default)({}, input, {
          name: inputGroupName + '.' + input.name
        });
      });
    } else {
      return v;
    }
  }).flatten().value();
  return (0, _map.default)(remediationValue).call(remediationValue, function (ionFormField) {
    var uiSchemaDefaultConfig = {
      'label-top': true,
      'data-se': "o-form-fieldset-".concat(ionFormField.name)
    };
    var fieldType = ionFormField.type || 'string';
    var uiSchemaHandler = UISchemaHandlers[fieldType];
    var uiSchemaResult = uiSchemaHandler(ionFormField, remediationForm, transformedResp, createUISchema, settings);
    return (0, _assign.default)({}, ionFormField, uiSchemaDefaultConfig, uiSchemaResult);
  });
};
/**
 *
 * @param {AuthResult} transformedResp
 */


var insertUISchema = function insertUISchema(settings, transformedResp) {
  if (transformedResp) {
    var _context4;

    transformedResp.remediations = (0, _map.default)(_context4 = transformedResp.remediations).call(_context4, function (obj) {
      obj.uiSchema = createUISchema(transformedResp, obj, settings);
      return obj;
    });
  }

  return transformedResp;
};

var _default = insertUISchema;
/**
 * @typedef {Object} Authenticator
 * @property {string} label
 * @property {AuthenticatorValue} value
 */

/**
 * @typedef {Object} AuthenticatorValue
 * @property {string} type Authenticator Type
 * @property {string} id Authenticator Org Authenticator ID
 * @property {AuthenticatorMethod[]} methods
 */

/**
 * @typedef {Object} AuthenticatorEnrollment
 * @property {string} label
 * @property {AuthenticatorEnrollmentValue} value
 */

/**
 * @typedef {Object} AuthenticatorEnrollmentValue
 * @property {string} authenticatorId Org Authenticator ID
 * @property {string} type Authenticator Type
 * @property {string} id Authenticator Enrollment ID
 * @property {AuthenticatorMethod[]} methods
 */

/**
 * @typedef {Object} AuthenticatorMethod
 * @property {string} type Authenticator method type
 */

/**
 * @typedef {Object} AuthenticatorOption
 * @property {string} label
 * @property {Object} form
 * @property {AuthenticatorOption[]} form.value
 */

/**
 * @typedef {Object} AuthenticatorOptionValue
 * @property {string} name
 * @property {boolean} required
 * @property {string} value
 * @property {boolean} mutable
 */

/**
 * @typedef {Object} IONForm
 * @property {string} name
 * @property {string[]} rel
 * @property {string} method
 * @property {string} href
 * @property {string} accepts
 * @property {IONFormField[]} value
 */

/**
 * @typedef {Object} IONFormField
 * @property {string} name
 * @property {string=} type
 * @property {string=} required
 * @property {string=} secret
 * @property {string=} label
 * @property {Object[]} options
 * @property {Object=} form
 * @property {IONFormField[]} form.value
 */

exports.default = _default;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(__webpack_require__(40));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _RemediationConstants = __webpack_require__(24);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var getCheckboxUiSchema = function getCheckboxUiSchema(_ref) {
  var label = _ref.label,
      type = _ref.type,
      required = _ref.required;
  return {
    // For Remember Me checkbox, we need the label only on the right side of it.
    placeholder: label,
    label: false,
    // Separating prop type for Backbone.Model
    // from html input type
    modelType: type,
    // uiSchema type is the html input type desired.
    type: 'checkbox',
    required: required || false
  };
};

var createUiSchemaForBoolean = function createUiSchemaForBoolean(ionFormField, remediationForm) {
  var _context;

  if ((0, _includes.default)(_context = [_RemediationConstants.FORMS.CONSENT_ENDUSER, _RemediationConstants.FORMS.CONSENT_ADMIN]).call(_context, remediationForm.name)) {
    var _context2;

    var scopes = (0, _map.default)(_context2 = remediationForm.scopes).call(_context2, function (_ref2) {
      var name = _ref2.name,
          label = _ref2.label,
          desc = _ref2.desc;
      return {
        name: name,
        displayName: label,
        description: desc
      };
    }); // setting 'type' here to add a specific View in FormInputFactory.create

    var type = remediationForm.name;
    return {
      type: type,
      scopes: scopes,
      options: ionFormField.options
    };
  } else {
    return getCheckboxUiSchema(ionFormField);
  }
};

var _default = createUiSchemaForBoolean;
exports.default = _default;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-depth: [2, 3] */
var ionOptionsToUiOptions = function ionOptionsToUiOptions(options) {
  var result = {};
  (0, _forEach.default)(options).call(options, function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    result[value] = label;
  });
  return result;
};

var getPasswordUiSchema = function getPasswordUiSchema(settings) {
  return {
    type: 'password',
    params: {
      showPasswordToggle: settings.get('showPasswordToggle')
    }
  };
};

var getCaptchaUiSchema = function getCaptchaUiSchema() {
  return {
    type: 'captcha'
  };
};

var shouldRenderAsRadio = function shouldRenderAsRadio(name) {
  return (0, _indexOf.default)(name).call(name, 'methodType') >= 0 || (0, _indexOf.default)(name).call(name, 'channel') >= 0;
};

var createUiSchemaForString = function createUiSchemaForString(ionFormField, remediationForm, transformedResp, createUISchema, settings) {
  var uiSchema = {
    type: 'text'
  }; // e.g. { name: 'password', secret: true }

  if (ionFormField.secret === true) {
    (0, _assign.default)(uiSchema, getPasswordUiSchema(settings));
  }

  if (ionFormField.hint === _RemediationConstants.HINTS.CAPTCHA) {
    (0, _assign.default)(uiSchema, getCaptchaUiSchema());
  }

  if ((0, _isArray.default)(ionFormField.options)) {
    if (shouldRenderAsRadio(ionFormField.name)) {
      // e.g. { name: 'methodType', options: [ {label: 'sms'} ], type: 'string' | null }
      uiSchema.type = 'radio'; // set the default value to the first value..

      if (ionFormField.options[0] && ionFormField.options[0].value) {
        ionFormField.value = ionFormField.options[0].value;
      }
    } else {
      // default to select (dropdown). no particular reason (certainly can default to radio.)
      // e.g. { name: 'questionKey', options: [], type: 'string' | null }
      uiSchema.type = 'select';
      uiSchema.wide = true;
      uiSchema.options = ionOptionsToUiOptions(ionFormField.options);
    }
  } // set optional label for text boxes


  if (ionFormField.required === false) {
    if (uiSchema.type === 'text') {
      uiSchema.sublabel = (0, _okta.loc)('oie.form.field.optional', 'login');
    }
  }

  return uiSchema;
};

var _default = createUiSchemaForString;
exports.default = _default;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _concat = _interopRequireDefault(__webpack_require__(18));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(88));

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _RemediationConstants = __webpack_require__(24);

var _internals = __webpack_require__(5);

var _IdentifierView = _interopRequireDefault(__webpack_require__(603));

var _RedirectIdPView = _interopRequireDefault(__webpack_require__(1341));

var _IdentifyRecoveryView = _interopRequireDefault(__webpack_require__(1342));

var _TerminalView = _interopRequireDefault(__webpack_require__(357));

var _AutoRedirectView = _interopRequireDefault(__webpack_require__(1343));

var _PollView = _interopRequireDefault(__webpack_require__(1344));

var _AdminConsentView = _interopRequireDefault(__webpack_require__(608));

var _EnduserConsentView = _interopRequireDefault(__webpack_require__(1345));

var _EnduserEmailConsentView = _interopRequireDefault(__webpack_require__(1349));

var _DeviceChallengePollView = _interopRequireDefault(__webpack_require__(1350));

var _SSOExtensionView = _interopRequireDefault(__webpack_require__(1351));

var _SignInDeviceView = _interopRequireDefault(__webpack_require__(1352));

var _DeviceEnrollmentTerminalView = _interopRequireDefault(__webpack_require__(1353));

var _EnrollProfileView = _interopRequireDefault(__webpack_require__(1356));

var _EnrollProfileUpdateView = _interopRequireDefault(__webpack_require__(1357));

var _RequestActivationEmailView = _interopRequireDefault(__webpack_require__(1358));

var _SelectAuthenticatorEnrollView = _interopRequireDefault(__webpack_require__(1359));

var _SelectAuthenticatorVerifyView = _interopRequireDefault(__webpack_require__(613));

var _SelectAuthenticatorUnlockAccountView = _interopRequireDefault(__webpack_require__(1360));

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(258));

var _ChallengeAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(1361));

var _ReEnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(1362));

var _ReEnrollAuthenticatorWarningPasswordView = _interopRequireDefault(__webpack_require__(1363));

var _ResetAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(1364));

var _EnrollAuthenticatorPhoneView = _interopRequireDefault(__webpack_require__(1365));

var _EnrollAuthenticatorDataPhoneView = _interopRequireDefault(__webpack_require__(1383));

var _ChallengeAuthenticatorPhoneView = _interopRequireDefault(__webpack_require__(614));

var _ChallengeAuthenticatorDataPhoneView = _interopRequireDefault(__webpack_require__(1384));

var _EnrollAuthenticatorSecurityQuestionView = _interopRequireDefault(__webpack_require__(1385));

var _ChallengeAuthenticatorSecurityQuestion = _interopRequireDefault(__webpack_require__(1386));

var _EnrollWebauthnView = _interopRequireDefault(__webpack_require__(1387));

var _ChallengeWebauthnView = _interopRequireDefault(__webpack_require__(1389));

var _EnrollAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(1392));

var _ChallengeAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(1394));

var _EnrollPollOktaVerifyView = _interopRequireDefault(__webpack_require__(1395));

var _SelectEnrollmentChannelOktaVerifyView = _interopRequireDefault(__webpack_require__(1398));

var _EnrollementChannelDataOktaVerifyView = _interopRequireDefault(__webpack_require__(1399));

var _ChallengeOktaVerifyView = _interopRequireDefault(__webpack_require__(1400));

var _ChallengeOktaVerifyTotpView = _interopRequireDefault(__webpack_require__(1405));

var _ChallengeOktaVerifyResendPushView = _interopRequireDefault(__webpack_require__(1406));

var _ChallengeAuthenticatorDataOktaVerifyView = _interopRequireDefault(__webpack_require__(1407));

var _ChallengeOktaVerifySSOExtensionView = _interopRequireDefault(__webpack_require__(1408));

var _EnrollAuthenticatorGoogleAuthenticatorView = _interopRequireDefault(__webpack_require__(1409));

var _ChallengeGoogleAuthenticatorView = _interopRequireDefault(__webpack_require__(1412));

var _EnrollAuthenticatorOnPremView = _interopRequireDefault(__webpack_require__(1413));

var _ChallengeAuthenticatorOnPremView = _interopRequireDefault(__webpack_require__(1414));

var _EnrollDuoAuthenticatorView = _interopRequireDefault(__webpack_require__(1415));

var _ChallengeDuoAuthenticatorView = _interopRequireDefault(__webpack_require__(1416));

var _AuthenticatorIdPVerifyView = _interopRequireDefault(__webpack_require__(1417));

var _AuthenticatorIdPEnrollView = _interopRequireDefault(__webpack_require__(1418));

var _ChallengeCustomOTPAuthenticatorView = _interopRequireDefault(__webpack_require__(1419));

var _AuthenticatorSymantecView = _interopRequireDefault(__webpack_require__(1420));

var _DeviceCodeActivateView = _interopRequireDefault(__webpack_require__(1421));

var _ChallengePIVView = _interopRequireDefault(__webpack_require__(1422));

var _AuthenticatorYubiKeyView = _interopRequireDefault(__webpack_require__(1424));

var _ChallengePushView = _interopRequireDefault(__webpack_require__(617));

var _ChallengeCustomAppResendPushView = _interopRequireDefault(__webpack_require__(1425));

var _RemediationForms$DEV2, _RemediationForms$ENR3, _RemediationForms$CHA, _RemediationForms$CHA2, _RemediationForms$RES2, _RemediationForms$AUT2, _VIEWS_MAPPING;

var DEFAULT = '_';
var VIEWS_MAPPING = (_VIEWS_MAPPING = {}, (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.IDENTIFY, (0, _defineProperty2.default)({}, DEFAULT, _IdentifierView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.IDENTIFY_RECOVERY, (0, _defineProperty2.default)({}, DEFAULT, _IdentifyRecoveryView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.DEVICE_CHALLENGE_POLL, (0, _defineProperty2.default)({}, DEFAULT, _DeviceChallengePollView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR, (0, _defineProperty2.default)({}, DEFAULT, _SignInDeviceView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.DEVICE_APPLE_SSO_EXTENSION, (_RemediationForms$DEV2 = {}, (0, _defineProperty2.default)(_RemediationForms$DEV2, DEFAULT, _SSOExtensionView.default), (0, _defineProperty2.default)(_RemediationForms$DEV2, _RemediationConstants.AUTHENTICATOR_KEY.OV, _ChallengeOktaVerifySSOExtensionView.default), _RemediationForms$DEV2)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CANCEL_TRANSACTION, (0, _defineProperty2.default)({}, DEFAULT, _SSOExtensionView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_PROFILE, (0, _defineProperty2.default)({}, DEFAULT, _EnrollProfileView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_PROFILE_UPDATE, (0, _defineProperty2.default)({}, DEFAULT, _EnrollProfileUpdateView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.POLL, (0, _defineProperty2.default)({}, DEFAULT, _PollView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REQUEST_ACTIVATION, (0, _defineProperty2.default)({}, DEFAULT, _RequestActivationEmailView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL, (0, _defineProperty2.default)({}, DEFAULT, _SelectAuthenticatorEnrollView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.AUTHENTICATOR_ENROLLMENT_DATA, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PHONE, _EnrollAuthenticatorDataPhoneView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CONSENT_ADMIN, (0, _defineProperty2.default)({}, DEFAULT, _AdminConsentView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CONSENT_ENDUSER, (0, _defineProperty2.default)({}, DEFAULT, _EnduserConsentView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CONSENT_EMAIL_CHALLENGE, (0, _defineProperty2.default)({}, DEFAULT, _EnduserEmailConsentView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_AUTHENTICATOR, (_RemediationForms$ENR3 = {}, (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.DUO, _EnrollDuoAuthenticatorView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.EMAIL, _EnrollAuthenticatorEmailView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP, _EnrollAuthenticatorGoogleAuthenticatorView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.IDP, _AuthenticatorIdPEnrollView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM, _EnrollAuthenticatorOnPremView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, _EnrollAuthenticatorPasswordView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.PHONE, _EnrollAuthenticatorPhoneView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.RSA, _EnrollAuthenticatorOnPremView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION, _EnrollAuthenticatorSecurityQuestionView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP, _AuthenticatorSymantecView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN, _EnrollWebauthnView.default), (0, _defineProperty2.default)(_RemediationForms$ENR3, _RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY, _AuthenticatorYubiKeyView.default), _RemediationForms$ENR3)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR, (_RemediationForms$CHA = {}, (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_OTP, _ChallengeCustomOTPAuthenticatorView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.DUO, _ChallengeDuoAuthenticatorView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.EMAIL, _ChallengeAuthenticatorEmailView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP, _ChallengeGoogleAuthenticatorView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.IDP, _AuthenticatorIdPVerifyView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM, _ChallengeAuthenticatorOnPremView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.OV, _ChallengeOktaVerifyTotpView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, _ChallengeAuthenticatorPasswordView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.PHONE, _ChallengeAuthenticatorPhoneView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.RSA, _ChallengeAuthenticatorOnPremView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION, _ChallengeAuthenticatorSecurityQuestion.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP, _AuthenticatorSymantecView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN, _ChallengeWebauthnView.default), (0, _defineProperty2.default)(_RemediationForms$CHA, _RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY, _AuthenticatorYubiKeyView.default), _RemediationForms$CHA)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLL_POLL, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.OV, _EnrollPollOktaVerifyView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.OV, _SelectEnrollmentChannelOktaVerifyView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.ENROLLMENT_CHANNEL_DATA, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.OV, _EnrollementChannelDataOktaVerifyView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REENROLL_AUTHENTICATOR, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, _ReEnrollAuthenticatorPasswordView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REENROLL_AUTHENTICATOR_WARNING, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, _ReEnrollAuthenticatorWarningPasswordView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.RESET_AUTHENTICATOR, (0, _defineProperty2.default)({}, _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD, _ResetAuthenticatorPasswordView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, (0, _defineProperty2.default)({}, DEFAULT, _SelectAuthenticatorVerifyView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_UNLOCK, (0, _defineProperty2.default)({}, DEFAULT, _SelectAuthenticatorUnlockAccountView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.CHALLENGE_POLL, (_RemediationForms$CHA2 = {}, (0, _defineProperty2.default)(_RemediationForms$CHA2, _RemediationConstants.AUTHENTICATOR_KEY.OV, _ChallengeOktaVerifyView.default), (0, _defineProperty2.default)(_RemediationForms$CHA2, _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP, _ChallengePushView.default), _RemediationForms$CHA2)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.RESEND, (_RemediationForms$RES2 = {}, (0, _defineProperty2.default)(_RemediationForms$RES2, _RemediationConstants.AUTHENTICATOR_KEY.OV, _ChallengeOktaVerifyResendPushView.default), (0, _defineProperty2.default)(_RemediationForms$RES2, _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP, _ChallengeCustomAppResendPushView.default), _RemediationForms$RES2)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.AUTHENTICATOR_VERIFICATION_DATA, (_RemediationForms$AUT2 = {}, (0, _defineProperty2.default)(_RemediationForms$AUT2, _RemediationConstants.AUTHENTICATOR_KEY.PHONE, _ChallengeAuthenticatorDataPhoneView.default), (0, _defineProperty2.default)(_RemediationForms$AUT2, _RemediationConstants.AUTHENTICATOR_KEY.OV, _ChallengeAuthenticatorDataOktaVerifyView.default), _RemediationForms$AUT2)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.FAILURE_REDIRECT, (0, _defineProperty2.default)({}, DEFAULT, _AutoRedirectView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.SUCCESS_REDIRECT, (0, _defineProperty2.default)({}, DEFAULT, _AutoRedirectView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.REDIRECT_IDP, (0, _defineProperty2.default)({}, DEFAULT, _RedirectIdPView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.PIV_IDP, (0, _defineProperty2.default)({}, DEFAULT, _ChallengePIVView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.DEVICE_ENROLLMENT_TERMINAL, (0, _defineProperty2.default)({}, DEFAULT, _DeviceEnrollmentTerminalView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.USER_CODE, (0, _defineProperty2.default)({}, DEFAULT, _DeviceCodeActivateView.default)), (0, _defineProperty2.default)(_VIEWS_MAPPING, _RemediationConstants.FORMS.TERMINAL, (0, _defineProperty2.default)({}, DEFAULT, _TerminalView.default)), _VIEWS_MAPPING);
module.exports = {
  create: function create(formName) {
    var authenticatorKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT;
    var config = VIEWS_MAPPING[formName];

    if (!config) {
      _Logger.default.warn("Cannot find customized View for ".concat(formName, "."));

      return _internals.BaseView;
    }

    var View = config[authenticatorKey] || config[DEFAULT];

    if (!View) {
      var _context;

      _Logger.default.warn((0, _concat.default)(_context = "Cannot find customized View for ".concat(formName, " + ")).call(_context, authenticatorKey, "."));

      return _internals.BaseView;
    }

    return View;
  }
};

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _Link = _interopRequireDefault(__webpack_require__(205));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _okta.View.extend({
  initialize: function initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);

    var textViewOptions = this.options.additionalOptions;
    var linkName = this.options.name;
    var linkOptions = (0, _assign.default)({}, this.options, {
      'type': 'link',
      'aria-expanded': false,
      'clickHandler': function clickHandler() {
        (0, _okta.$)(textViewOptions.selector).slideToggle(200, function () {
          (0, _okta.$)(".js-".concat(linkName)).attr('aria-expanded', (0, _okta.$)(textViewOptions.selector).is(':visible'));
        });
      }
    });
    this.add(_Link.default, {
      options: linkOptions
    });
    this.add(textViewOptions.view);
  },
  postRender: function postRender() {
    var textViewOptions = this.options.additionalOptions;
    this.$(textViewOptions.selector).hide();
  }
});

exports.default = _default;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

var _SkipOptionalEnrollmentButton = _interopRequireDefault(__webpack_require__(1335));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var AuthenticatorRow = _okta.View.extend({
  className: 'authenticator-row clearfix',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"authenticator-description--text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 276
          },
          "end": {
            "line": 1,
            "column": 291
          }
        }
      }) : helper)) + "</p>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "data-se=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "buttonDataSeAttr") || (depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "buttonDataSeAttr",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 369
          },
          "end": {
            "line": 1,
            "column": 389
          }
        }
      }) : helper)) + "\"";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"authenticator-icon-container\"><div class=\"factor-icon authenticator-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"authenticator-description\"><h3 class=\"authenticator-label no-translate\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 200
          },
          "end": {
            "line": 1,
            "column": 209
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 214
          },
          "end": {
            "line": 1,
            "column": 302
          }
        }
      })) != null ? stack1 : "") + "<div class=\"authenticator-button\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 336
          },
          "end": {
            "line": 1,
            "column": 397
          }
        }
      })) != null ? stack1 : "") + "></div></div>";
    },
    "useData": true
  }),
  children: function children() {
    return [[(0, _okta.createButton)({
      className: 'button select-factor',
      title: function title() {
        return (0, _okta.loc)('oie.enroll.authenticator.button.text', 'login');
      },
      click: function click() {
        this.model.trigger('selectAutheticator', this.model.get('value'));
      }
    }), '.authenticator-button']];
  },
  minimize: function minimize() {
    this.$el.addClass('authenticator-row-min');
  }
});

var _default = _okta.ListView.extend({
  className: 'authenticator-enroll-list authenticator-list',
  item: AuthenticatorRow,
  itemSelector: '.list-content',
  initialize: function initialize() {
    this.listenTo(this.collection, 'selectAutheticator', function (data) {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    });
    this.hasOptionalFactors = this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SKIP);

    if (this.hasOptionalFactors) {
      this.add(_SkipOptionalEnrollmentButton.default);
    }
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"list-content\"><div class=\"authenticator-list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 73
          }
        }
      }) : helper)) + "</div></div>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    // presence of the skip remediation form tells us that the authenticators are all optional
    var title = this.hasOptionalFactors ? (0, _okta.loc)('oie.setup.optional', 'login') : (0, _okta.loc)('oie.setup.required', 'login');
    return {
      title: title
    };
  }
});

exports.default = _default;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _RemediationConstants = __webpack_require__(24);

var skipAll = (0, _okta.createButton)({
  className: 'button-primary button skip-all',
  title: function title() {
    return (0, _okta.loc)('oie.optional.authenticator.button.title', 'login');
  },
  click: function click() {
    this.options.appState.trigger('invokeAction', _RemediationConstants.FORMS.SKIP);
  }
});
var _default = skipAll;
exports.default = _default;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _find = _interopRequireDefault(__webpack_require__(13));

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Constants = __webpack_require__(93);

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var OktaSignInWidgetOnCaptchaLoadedCallback = 'OktaSignInWidgetOnCaptchaLoaded';
var OktaSignInWidgetOnCaptchaSolvedCallback = 'OktaSignInWidgetOnCaptchaSolved';
var HCAPTCHA_URL = "https://hcaptcha.com/1/api.js?onload=".concat(OktaSignInWidgetOnCaptchaLoadedCallback, "&render=explicit");
var RECAPTCHAV2_URL = "https://www.google.com/recaptcha/api.js?onload=".concat(OktaSignInWidgetOnCaptchaLoadedCallback, "&render=explicit");

var _default = _okta.View.extend({
  className: 'captcha-view',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div id =\"captcha-container\" class=\"" + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 76
          }
        }
      }) : helper)) + "\" data-sitekey=\"" + alias4((helper = (helper = lookupProperty(helpers, "siteKey") || (depth0 != null ? lookupProperty(depth0, "siteKey") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "siteKey",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 103
          }
        }
      }) : helper)) + "\" data-callback=\"" + alias4((helper = (helper = lookupProperty(helpers, "onCaptchaSolvedCallback") || (depth0 != null ? lookupProperty(depth0, "onCaptchaSolvedCallback") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias3 ? helper.call(alias1, {
        "name": "onCaptchaSolvedCallback",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 120
          },
          "end": {
            "line": 1,
            "column": 147
          }
        }
      }) : helper)) + "\" data-size=\"invisible\"></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isCaptchaConfigured") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 184
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    if (this.captchaConfig) {
      var className = this.captchaConfig.type === 'HCAPTCHA' ? 'h-captcha' : 'g-recaptcha';
      return {
        siteKey: this.captchaConfig.siteKey,
        isCaptchaConfigured: true,
        onCaptchaSolvedCallback: OktaSignInWidgetOnCaptchaSolvedCallback,
        className: className
      };
    } else {
      return {};
    }
  },
  initialize: function initialize() {
    if (this.options.appState.get('captcha')) {
      this.captchaConfig = this.options.appState.get('captcha');

      this._addCaptcha();
    }
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments); // Cleanup global Captcha references


    if (this.captchaConfig.type === 'HCAPTCHA') {
      window.hcaptcha = undefined;
    } else if (this.captchaConfig.type === 'RECAPTCHA_V2') {
      window.grecaptcha = undefined;
    }
  },

  /**
   *  Load the CAPTCHA lib dynamically (either HCAPTCHA or RECAPTCHAV2). Once loaded, trigger an event to inform
   *  the parent form to actually render the CAPTCHA.
  * */
  _addCaptcha: function _addCaptcha() {
    var _this = this;

    // Callback invoked when CAPTCHA is solved.
    var onCaptchaSolved = function onCaptchaSolved(token) {
      var _context;

      var captchaObject = _this._getCaptchaOject(); // We reset the Captcha. We need to reset because every time the 
      // Captcha resolves back with a token and say we have a server side error, 
      // if we submit the form again it won't work otherwise. The Captcha 
      // has to be reset for it to work again in that scenario.


      var captchaId = (0, _find.default)(_context = _this.$el).call(_context, '#captcha-container').attr('data-captcha-id');
      captchaObject.reset(captchaId); // Set the token in the model

      var fieldName = _this.options.name;

      _this.model.set(fieldName, token);

      _this.options.appState.trigger('saveForm', _this.model);
    }; // Callback when CAPTCHA lib is loaded


    var onCaptchaLoaded = function onCaptchaLoaded() {
      var _context2, _context3;

      // This is just a safeguard to ensure we don't bind Captcha to an already bound element.
      // It shouldn't happen in practice.
      if ((0, _find.default)(_context2 = _this.$el).call(_context2, '#captcha-container').attr('data-captcha-id')) {
        return;
      }

      var captchaObject = _this._getCaptchaOject(); // We set a temporary token for Captcha because this is a required field for the form and is normally set
      // at a later time. In order to prevent client-side validation errors because of this, we have to set a 
      // dummy value. We then overwrite this with the proper token in the onCaptchaSolved callback.


      _this.model.set(_this.options.name, 'tempToken');

      var captchaId = captchaObject.render('captcha-container', {
        sitekey: _this.captchaConfig.siteKey,
        callback: onCaptchaSolved
      });
      (0, _find.default)(_context3 = _this.$el).call(_context3, '#captcha-container').attr('data-captcha-id', captchaId); // Let the Baseform know that Captcha is loaded.

      _this.options.appState.trigger('onCaptchaLoaded', captchaObject); // Render the HCAPTCHA footer - we need to do this manually since the HCAPTCHA lib doesn't do it


      if (_this.captchaConfig.type === 'HCAPTCHA') {
        _this._addHCaptchaFooter();
      }
    }; // Attaching the callback to the window object so that the CAPTCHA script that we dynamically render
    // can have access to it since it won't have access to this view's scope.


    window[OktaSignInWidgetOnCaptchaLoadedCallback] = onCaptchaLoaded; // Attaching the Captcha solved callback to the window object because we reference it in our template under
    // the 'data-callback' attribute which the Captcha library uses to invoke the callback.

    window[OktaSignInWidgetOnCaptchaSolvedCallback] = onCaptchaSolved;

    if (this.captchaConfig.type === 'HCAPTCHA') {
      this._loadCaptchaLib(this._getCaptchaUrl(HCAPTCHA_URL));
    } else if (this.captchaConfig.type === 'RECAPTCHA_V2') {
      this._loadCaptchaLib(this._getCaptchaUrl(RECAPTCHAV2_URL));
    }
  },

  /**
   *  We dynamically inject <script> tag into our login container because in case the customer is hosting
   *  the SIW, we need to ensure we don't go out of scope when injecting the script.
  * */
  _loadCaptchaLib: function _loadCaptchaLib(url) {
    var scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.async = true;
    scriptTag.defer = true;
    document.getElementById(_Enums.default.WIDGET_CONTAINER_ID).appendChild(scriptTag);
  },
  _addHCaptchaFooter: function _addHCaptchaFooter() {
    // NOTE: insetAdjacentHTML() is supported in all major browsers: 
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML#browser_compatibility
    var footerContainer = document.getElementsByClassName(_Constants.WIDGET_FOOTER_CLASS);

    if (footerContainer.length) {
      var template = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return "<div class=\"captcha-footer\"><span class=\"footer-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "$2": "<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",
              "$1": "<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",
              "bundle": "login",
              "code": "hcaptcha.footer.label"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 54
              },
              "end": {
                "line": 1,
                "column": 238
              }
            }
          })) + "</span></div>";
        },
        "useData": true
      });

      footerContainer[0].insertAdjacentHTML('beforeend', template());
    }
  },
  _getCaptchaOject: function _getCaptchaOject() {
    var captchaObject = this.captchaConfig.type === 'HCAPTCHA' ? window.hcaptcha : window.grecaptcha;
    return captchaObject;
  },
  _getCaptchaUrl: function _getCaptchaUrl(baseURL) {
    var _context4;

    var locale = this.options.settings.get('language');
    return (0, _concat.default)(_context4 = "".concat(baseURL, "&hl=")).call(_context4, locale || navigator.language);
  }
});

exports.default = _default;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _BaseHeader = _interopRequireDefault(__webpack_require__(596));

var _BaseForm = _interopRequireDefault(__webpack_require__(206));

var _BaseModel = _interopRequireDefault(__webpack_require__(601));

var _BaseFooter = _interopRequireDefault(__webpack_require__(597));

var _ViewClassNamesFactory = __webpack_require__(602);

var _default = _okta.View.extend({
  Header: _BaseHeader.default,
  Body: _BaseForm.default,
  Footer: _BaseFooter.default,
  className: function className() {
    var _context;

    var appState = this.options.appState;
    var formName = appState.get('currentFormName');
    var authenticatorKey = appState.get('authenticatorKey');
    var methodType = appState.get('authenticatorMethodType');
    var isPasswordRecoveryFlow = appState.get('isPasswordRecoveryFlow');
    var additionalClassNames = (0, _ViewClassNamesFactory.getClassNameMapping)(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
    var classNames = (0, _concat.default)(_context = ['siw-main-view']).call(_context, additionalClassNames);
    return classNames.join(' ');
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div class=\"siw-main-header\"></div><div class=\"siw-main-body\"></div><div class=\"siw-main-footer\"></div>";
    },
    "useData": true
  }),
  preRender: function preRender() {
    _okta.View.prototype.preRender.apply(this, arguments); // Add Views


    if (this.Header !== null) {
      this.add(this.Header, {
        selector: '.siw-main-header',
        options: this.options
      });
    }

    this.renderForm();
    this.add(this.Footer, {
      selector: '.siw-main-footer',
      options: this.options
    });
  },
  renderForm: function renderForm() {
    var _this = this;

    var optionUiSchemaConfig;

    if (this.form) {
      this.form.remove();
      optionUiSchemaConfig = this.form.model.toJSON({
        verbose: true
      });
    } // Create Model


    var IonModel = this.createModelClass(this.options.currentViewState, optionUiSchemaConfig, this.settings);
    var model = new IonModel({
      formName: this.options.currentViewState.name
    });

    if (!optionUiSchemaConfig) {
      optionUiSchemaConfig = model.toJSON({
        verbose: true
      });
    }

    this.model = model;
    this.form = this.add(this.Body, {
      selector: '.siw-main-body',
      options: (0, _assign.default)({}, this.options, {
        model: model,
        optionUiSchemaConfig: optionUiSchemaConfig
      })
    }).last();

    _okta._.each(model.attributes, function (value, key) {
      if (key.match(/sub_schema_local_[^ ]+/)) {
        // in order to render different sub-schema
        _this.listenTo(model, "change:".concat(key), function () {
          _this.renderForm();
        });
      }
    });
  },
  createModelClass: function createModelClass(currentViewState) {
    var optionUiSchemaConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _BaseModel.default.create(currentViewState, optionUiSchemaConfig);
  }
});

exports.default = _default;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _promise = _interopRequireDefault(__webpack_require__(195));

var _okta = __webpack_require__(2);

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function getUserAgent() {
  return navigator.userAgent;
}

function isWindowsPhone(userAgent) {
  return userAgent.match(/windows phone|iemobile|wpdesktop/i);
}

var _default = {
  isMessageFromCorrectSource: function isMessageFromCorrectSource($iframe, event) {
    return event.source === $iframe[0].contentWindow;
  },
  // NOTE: This utility is similar to the DeviceFingerprint.js file used for V1 authentication flows.
  generateDeviceFingerprint: function generateDeviceFingerprint(fingerprintData) {
    var _this = this;

    return new _promise.default(function (resolve, reject) {
      var userAgent = getUserAgent();

      if (!userAgent) {
        return reject('user agent is not defined');
      } else if (isWindowsPhone(userAgent)) {
        return reject('device fingerprint is not supported on Windows phones');
      }

      var $iframe;
      var iFrameTimeout;
      var self = _this; // Needed for mocking

      function removeIframe() {
        $iframe.off();
        $iframe.remove();
        window.removeEventListener('message', onMessageReceivedFromOkta, false);
      }

      function handleError(reason) {
        removeIframe();
        reject(reason);
      }

      function onMessageReceivedFromOkta(event) {
        if (!self.isMessageFromCorrectSource($iframe, event)) {
          return;
        } // deviceFingerprint service is available, clear timeout


        clearTimeout(iFrameTimeout);

        if (!event || !event.data || event.origin !== fingerprintData.oktaDomainUrl) {
          handleError('no data');
          return;
        }

        try {
          var message = JSON.parse(event.data);

          if (message && message.type === 'FingerprintServiceReady') {
            sendMessageToOkta({
              type: 'GetFingerprint'
            });
          } else if (message && message.type === 'FingerprintAvailable') {
            removeIframe();
            resolve(message.fingerprint);
          } else {
            handleError('no data');
          }
        } catch (error) {//Ignore any errors since we could get other messages too
        }
      }

      function sendMessageToOkta(message) {
        var win = $iframe[0].contentWindow;

        if (win) {
          win.postMessage((0, _stringify.default)(message), fingerprintData.oktaDomainUrl);
        }
      } // Attach listener


      window.addEventListener('message', onMessageReceivedFromOkta, false); // Create and Load devicefingerprint page inside the iframe

      $iframe = (0, _okta.$)('<iframe>', {
        style: 'display: none;',
        src: fingerprintData.oktaDomainUrl + '/auth/services/devicefingerprint'
      });
      fingerprintData.element.append($iframe);
      iFrameTimeout = (0, _setTimeout2.default)(function () {
        // If the iFrame does not load or there is a slow connection, throw an error
        handleError('service not available');
      }, 2000);
    });
  }
};
exports.default = _default;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  className: 'sign-in-with-idp',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "socialauth.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 118
          }
        }
      })) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isSecondaryIdpDisplay") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 138
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-idps-container\"></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isPrimaryIdpDisplay") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 177
          },
          "end": {
            "line": 1,
            "column": 313
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  initialize: function initialize() {
    var _context,
        _this = this;

    (0, _forEach.default)(_context = this.options.idpButtons).call(_context, function (idpButton) {
      _this.add((0, _okta.createButton)(idpButton), '.okta-idps-container');
    });
  },
  getTemplateData: function getTemplateData() {
    var jsonData = _okta.View.prototype.getTemplateData.apply(this, arguments);

    var addDivider = this.options.idpButtons.length > 0;
    return (0, _assign.default)(jsonData, {
      isPrimaryIdpDisplay: addDivider && this.options.isPrimaryIdpDisplay,
      isSecondaryIdpDisplay: addDivider && !this.options.isPrimaryIdpDisplay
    });
  }
});

exports.default = _default;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  className: 'custom-buttons',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "socialauth.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 112
          }
        }
      })) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "addSeparateLine") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-custom-buttons-container primary-auth-container\"></div>";
    },
    "useData": true
  }),
  initialize: function initialize(options) {
    var _context,
        _this = this;

    (0, _forEach.default)(_context = options.customButtons).call(_context, function (idpButton) {
      _this.add((0, _okta.createButton)(idpButton), '.okta-custom-buttons-container');
    });
  },
  getTemplateData: function getTemplateData() {
    var jsonData = _okta.View.prototype.getTemplateData.apply(this, arguments);

    return (0, _assign.default)(jsonData, {
      addSeparateLine: this.options.addSeparateLine
    });
  }
});

exports.default = _default;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _IdentifierView = _interopRequireDefault(__webpack_require__(603));

var _default = _IdentifierView.default.extend({
  render: function render() {
    var _context, _context2;

    _IdentifierView.default.prototype.render.apply(this, arguments);

    (0, _find.default)(_context = this.$el).call(_context, '.sign-in-with-idp .separation-line').hide();
    (0, _find.default)(_context2 = this.$el).call(_context2, '.button-primary').hide();
  }
});

exports.default = _default;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('password.reset.title.generic', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oform.next', 'login');
  }
});

var _default = _internals.BaseView.extend({
  Body: Body,
  Footer: _internals.BaseFooter
});

exports.default = _default;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _RemediationConstants = __webpack_require__(24);

var Body = _internals.BaseForm.extend({
  title: function title() {
    var titleString = (0, _okta.loc)('oie.success.text.signingIn', 'login'); // For more info on the API response available in appState, see IdxResponseBuilder.java

    var app = this.options.appState.get('app');
    var user = this.options.appState.get('user'); // If the option is not set, we treat that as being the case where we don't render the spinner.
    // This is to account for the customer hosted scenario, because by default okta-core will pass in
    // the correct value as set by the option in the Admin UI (which by default is "DEFAULT").

    if (!this.redirectView || this.redirectView === _RemediationConstants.INTERSTITIAL_REDIRECT_VIEW.NONE) {
      titleString = (0, _okta.loc)('oie.success.text.signingIn.with.ellipsis', 'login');
      return titleString;
    }

    if (_okta._.isEmpty(app)) {
      return titleString;
    }

    var appInstanceName = app.label,
        appDisplayName = app.name;

    var _ref = user || {},
        userEmail = _ref.identifier;

    var appName = appInstanceName ? appInstanceName : appDisplayName;

    if (appName && userEmail) {
      titleString = (0, _okta.loc)('oie.success.text.signingIn.with.appName.and.identifier', 'login', [appName, userEmail]);
    } else if (appName) {
      titleString = (0, _okta.loc)('oie.success.text.signingIn.with.appName', 'login', [appName]);
    }

    return titleString;
  },
  noButtonBar: true,
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.redirectView = this.settings.get('interstitialBeforeLoginRedirect');
    this.model.set('useRedirect', true);
    this.trigger('save', this.model);
  },
  render: function render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);

    if (this.redirectView === _RemediationConstants.INTERSTITIAL_REDIRECT_VIEW.DEFAULT) {
      this.add('<div class="okta-waiting-spinner"></div>');
    }
  }
});

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setInterval2 = _interopRequireDefault(__webpack_require__(194));

var _find = _interopRequireDefault(__webpack_require__(13));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _Constants = __webpack_require__(93);

var PollMessageView = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"ion-messages-container\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "countDownCounterValue",
          "bundle": "login",
          "code": "poll.form.message"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 39
          },
          "end": {
            "line": 1,
            "column": 157
          }
        }
      })) + "</p></div><div class=\"hide okta-waiting-spinner\"></div>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var countDownCounterValue = this.options;
    return {
      countDownCounterValue: countDownCounterValue
    };
  }
});

var Body = _internals.BaseForm.extend((0, _assign.default)({
  title: function title() {
    return (0, _okta.loc)('poll.form.title', 'login');
  },
  noButtonBar: true,
  initialize: function initialize() {
    var _this = this;

    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    var refreshInterval = this.options.appState.getCurrentViewState().refresh;
    this.refreshTimeout = (0, _setTimeout2.default)(function () {
      var _context;

      (0, _find.default)(_context = _this.$el).call(_context, '.okta-waiting-spinner').show(); // start after a small delay so that the spinner does not get hidden too soon

      (0, _setTimeout2.default)(function () {
        return _this.saveForm(_this.model);
      }, 200);
    }, refreshInterval);
  },
  render: function render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);

    this.countDownCounterValue = Math.ceil(this.options.appState.getCurrentViewState().refresh / _Constants.MS_PER_SEC);
    this.add(new PollMessageView(this.countDownCounterValue));
    this.startCountDown('.ion-messages-container span', _Constants.MS_PER_SEC);
  },
  remove: function remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);

    clearTimeout(this.refreshTimeout);
  },
  triggerAfterError: function triggerAfterError() {
    var _context2;

    _internals.BaseForm.prototype.triggerAfterError.apply(this, arguments);

    clearTimeout(this.refreshTimeout);
    this.stopCountDown();
    (0, _find.default)(_context2 = this.$el).call(_context2, '.o-form-fieldset-container').empty();
  },
  startCountDown: function startCountDown(selector, interval) {
    var _context3,
        _this2 = this;

    if (this.countDown) {
      clearInterval(this.countDown);
    }

    this.counterEl = (0, _find.default)(_context3 = this.$el).call(_context3, selector);
    this.countDown = (0, _setInterval2.default)(function () {
      if (_this2.counterEl.text() !== '0') {
        _this2.counterEl.text(_this2.counterEl.text() - 1);
      }
    }, interval, this);
  },
  stopCountDown: function stopCountDown() {
    if (this.countDown) {
      clearInterval(this.countDown);
    }
  }
}));

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _AdminConsentView = _interopRequireDefault(__webpack_require__(608));

var _EnduserConsentViewFooter = _interopRequireDefault(__webpack_require__(1346));

var _EnduserConsentViewHeader = _interopRequireDefault(__webpack_require__(1347));

var _EnduserConsentAgreementText = _interopRequireDefault(__webpack_require__(1348));

var _default = _AdminConsentView.default.extend({
  Header: _EnduserConsentViewHeader.default,
  Footer: _EnduserConsentViewFooter.default,
  postRender: function postRender() {
    var _context;

    var scopeList = (0, _find.default)(_context = this.$el).call(_context, '.scope-list');
    var consentAgreementText = new _EnduserConsentAgreementText.default().render().el;
    scopeList.after(consentAgreementText);
  }
});

exports.default = _default;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var ConsentViewFooter = _okta.View.extend({
  className: 'consent-footer',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "termsOfService",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 56
          },
          "end": {
            "line": 1,
            "column": 74
          }
        }
      }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "consent.required.termsOfService"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 154
          }
        }
      })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 158
          },
          "end": {
            "line": 1,
            "column": 226
          }
        }
      })) != null ? stack1 : "");
    },
    "2": function _(container, depth0, helpers, partials, data) {
      return "<span class=\"no-translate\">&#8226</span>";
    },
    "4": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "privacyPolicy",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 286
          },
          "end": {
            "line": 1,
            "column": 303
          }
        }
      }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "consent.required.privacyPolicy"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 321
          },
          "end": {
            "line": 1,
            "column": 382
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 233
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 233
          },
          "end": {
            "line": 1,
            "column": 393
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var appState = this.options.appState;
    var app = appState.get('app');
    return {
      termsOfService: app.termsOfService && app.termsOfService.href,
      privacyPolicy: app.privacyPolicy && app.privacyPolicy.href
    };
  }
});

var _default = ConsentViewFooter;
exports.default = _default;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _AdminConsentViewHeader = _interopRequireDefault(__webpack_require__(609));

var _default = _AdminConsentViewHeader.default.extend({
  titleText: function titleText() {
    return (0, _okta.loc)('oie.consent.scopes.enduser.title', 'login');
  },
  hasIssuer: false
});

exports.default = _default;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  className: 'consent-description detail-row',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "consent.required.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3
          },
          "end": {
            "line": 1,
            "column": 62
          }
        }
      })) + "</p>";
    },
    "useData": true
  })
});

exports.default = _default;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _find = _interopRequireDefault(__webpack_require__(13));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _ConsentViewForm = _interopRequireDefault(__webpack_require__(610));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _EmailAuthenticatorHeader = _interopRequireDefault(__webpack_require__(606));

var getInfo = _runtime.default.template({
  "1": function _(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<div class=\"enduser-email-consent--info no-translate\"><i class=\"enduser-email-consent--icon icon--desktop\"></i><div>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "browser") || (depth0 != null ? lookupProperty(depth0, "browser") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "browser",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 131
        },
        "end": {
          "line": 1,
          "column": 142
        }
      }
    }) : helper)) + "</div></div>";
  },
  "3": function _(container, depth0, helpers, partials, data) {
    var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return "<div class=\"enduser-email-consent--info no-translate\"><i class=\"enduser-email-consent--icon icon--app\"></i><div>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "app") || (depth0 != null ? lookupProperty(depth0, "app") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "app",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 284
        },
        "end": {
          "line": 1,
          "column": 291
        }
      }
    }) : helper)) + "</div></div>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }

      return undefined;
    };

    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "browser") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 161
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "app") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 161
        },
        "end": {
          "line": 1,
          "column": 310
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});

var enduserEmailConsentViewBody = _ConsentViewForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.consent.enduser.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oie.consent.enduser.accept.label', 'login');
  },
  cancel: function cancel() {
    return (0, _okta.loc)('oie.consent.enduser.deny.label', 'login');
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    var info = getInfo(this.model.pick('browser', 'app'));
    this.add(info);
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    return (0, _filter.default)(uiSchemas).call(uiSchemas, function (uiSchema) {
      return uiSchema.name !== 'consent';
    });
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  className: 'enduser-email-consent',
  Header: _EmailAuthenticatorHeader.default,
  buttonOrder: ['cancel', 'save'],
  postRender: function postRender() {
    var _context;

    var buttonContainer = (0, _find.default)(_context = this.$el).call(_context, '.o-form-button-bar');
    (0, _find.default)(buttonContainer).call(buttonContainer, '.button-primary').removeClass('button-primary');
  },
  Body: enduserEmailConsentViewBody,
  createModelClass: function createModelClass(_ref) {
    var requestInfo = _ref.requestInfo;

    var ModelClass = _BaseAuthenticatorView.default.prototype.createModelClass.apply(this, arguments);

    var browser = (0, _find.default)(requestInfo).call(requestInfo, function (_ref2) {
      var name = _ref2.name;
      return name === 'browser';
    });
    var app = (0, _find.default)(requestInfo).call(requestInfo, function (_ref3) {
      var name = _ref3.name;
      return name === 'appName';
    });
    var local = (0, _assign.default)({
      browser: {
        type: 'string',
        value: browser === null || browser === void 0 ? void 0 : browser.value
      },
      app: {
        type: 'string',
        value: app === null || app === void 0 ? void 0 : app.value
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local,
      toJSON: function toJSON() {
        return {
          consent: this.get('consent')
        };
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(__webpack_require__(52));

var _find = _interopRequireDefault(__webpack_require__(13));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _promise = _interopRequireDefault(__webpack_require__(195));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _Constants = __webpack_require__(93);

var _Link = _interopRequireDefault(__webpack_require__(205));

var _ChallengeViewUtil = __webpack_require__(611);

var _OktaVerifyAuthenticatorHeader = _interopRequireDefault(__webpack_require__(612));

var _LinksUtil = __webpack_require__(122);

var request = function request(opts) {
  var ajaxOptions = (0, _assign.default)({
    method: 'GET',
    contentType: 'application/json'
  }, opts);
  return _okta.$.ajax(ajaxOptions);
};

var Body = _internals.BaseFormWithPolling.extend({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  events: {
    'click #launch-ov': function clickLaunchOv(e) {
      e.preventDefault();
      this.doCustomURI();
    }
  },
  initialize: function initialize() {
    _internals.BaseFormWithPolling.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.onPollingFail);
    (0, _ChallengeViewUtil.doChallenge)(this);
    this.startPolling();
  },
  onPollingFail: function onPollingFail() {
    this.$('.spinner').hide();
    this.stopPolling(); // When SIW receives form error, polling is already stopped
    // SIW needs to update footer link from /poll/cancel to /idp/idx/cancel

    var data = {
      label: (0, _okta.loc)('loopback.polling.cancel.link.with.form.error', 'login')
    };
    this.options.appState.trigger('updateFooterLink', data);
  },
  remove: function remove() {
    _internals.BaseFormWithPolling.prototype.remove.apply(this, arguments);

    this.stopProbing();
    this.stopPolling();
  },
  getDeviceChallengePayload: function getDeviceChallengePayload() {
    return this.options.currentViewState.relatesTo.value;
  },
  doLoopback: function doLoopback(deviceChallenge) {
    var _this = this;

    var authenticatorDomainUrl = deviceChallenge.domain !== undefined ? deviceChallenge.domain : '';
    var ports = deviceChallenge.ports !== undefined ? deviceChallenge.ports : [];
    var challengeRequest = deviceChallenge.challengeRequest !== undefined ? deviceChallenge.challengeRequest : '';
    var probeTimeoutMillis = deviceChallenge.probeTimeoutMillis !== undefined ? deviceChallenge.probeTimeoutMillis : 100;
    var currentPort;
    var foundPort = false;
    var countFailedPorts = 0;

    var getAuthenticatorUrl = function getAuthenticatorUrl(path) {
      var _context, _context2;

      return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(authenticatorDomainUrl, ":")).call(_context2, currentPort, "/")).call(_context, path);
    };

    var checkPort = function checkPort() {
      return request({
        url: getAuthenticatorUrl('probe'),

        /*
        OKTA-278573 in loopback server, SSL handshake sometimes takes more than 100ms and thus needs additional
        timeout however, increasing timeout is a temporary solution since user will need to wait much longer in
        worst case.
        TODO: Android timeout is temporarily set to 3000ms and needs optimization post-Beta.
        OKTA-365427 introduces probeTimeoutMillis; but we should also consider probeTimeoutMillisHTTPS for
        customizing timeouts in the more costly Android and other (keyless) HTTPS scenarios.
        */
        timeout: _BrowserFeatures.default.isAndroid() ? 3000 : probeTimeoutMillis
      });
    };

    var onPortFound = function onPortFound() {
      return request({
        url: getAuthenticatorUrl('challenge'),
        method: 'POST',
        data: (0, _stringify.default)({
          challengeRequest: challengeRequest
        }),
        timeout: _Constants.CHALLENGE_TIMEOUT // authenticator should respond within 5 min (300000ms) for challenge request

      });
    };

    var onFailure = function onFailure() {
      _Logger.default.error("Something unexpected happened while we were checking port ".concat(currentPort, "."));
    };

    var onPortFail = function onPortFail() {
      countFailedPorts++;

      if (countFailedPorts === ports.length) {
        _Logger.default.error('No available ports. Loopback server failed and polling is cancelled.');

        _this.options.appState.trigger('invokeAction', _Constants.CANCEL_POLLING_ACTION);
      }
    };

    var doProbing = function doProbing() {
      _this.checkPortXhr = checkPort();
      return _this.checkPortXhr // TODO: can we use standard ES6 promise methods, then/catch?
      .done(function () {
        _this.probingXhr = onPortFound();
        return _this.probingXhr.done(function () {
          foundPort = true; // log in as soon as challenge request is finished

          return _this.trigger('save', _this.model);
        }).fail(function (xhr) {
          var _context3;

          _Logger.default.error((0, _concat.default)(_context3 = "OV challenge response with HTTP code ".concat(xhr.status, " ")).call(_context3, xhr.responseText));

          if (xhr.statusText === 'timeout') {
            foundPort = true;
            return _this.trigger('save', _this.model);
          } else {
            onPortFail();
          }
        });
      }).fail(onFailure);
    };

    var probeChain = _promise.default.resolve();

    (0, _forEach.default)(ports).call(ports, function (port) {
      probeChain = probeChain.then(function () {
        if (!foundPort) {
          currentPort = port;
          return doProbing();
        }
      }).catch(function () {
        _Logger.default.error("Authenticator is not listening on port ".concat(currentPort, "."));

        onPortFail();
      });
    });
  },
  doCustomURI: function doCustomURI() {
    this.ulDom && this.ulDom.remove();
    this.ulDom = this.add("\n        <iframe src=\"".concat(this.customURI, "\" id=\"custom-uri-container\" style=\"display:none;\"></iframe>\n      ")).last();
  },
  stopProbing: function stopProbing() {
    this.checkPortXhr && this.checkPortXhr.abort();
    this.probingXhr && this.probingXhr.abort();
  }
});

var Footer = _internals.BaseFooter.extend({
  initialize: function initialize() {
    this.listenTo(this.options.appState, 'updateFooterLink', this.handleUpdateFooterLink);

    if (this.isFallbackApproach()) {
      _internals.BaseFooter.prototype.initialize.apply(this, arguments);
    } else {
      this.add(_Link.default, {
        options: {
          name: 'cancel-authenticator-challenge',
          label: (0, _okta.loc)('loopback.polling.cancel.link', 'login'),
          actionPath: _Constants.CANCEL_POLLING_ACTION
        }
      });
    }
  },
  handleUpdateFooterLink: function handleUpdateFooterLink(data) {
    // only update link for loopback
    if (!this.isFallbackApproach()) {
      var _context4;

      (0, _find.default)(_context4 = this.$el).call(_context4, '.js-cancel-authenticator-challenge').remove();
      this.add(_Link.default, {
        options: (0, _LinksUtil.getSignOutLink)(this.options.settings, data)[0]
      });
    }
  },
  isFallbackApproach: function isFallbackApproach() {
    var _context5;

    return (0, _includes.default)(_context5 = [_Enums.default.CUSTOM_URI_CHALLENGE, _Enums.default.UNIVERSAL_LINK_CHALLENGE, _Enums.default.APP_LINK_CHALLENGE]).call(_context5, this.options.currentViewState.relatesTo.value.challengeMethod);
  }
});

var _default = _internals.BaseView.extend({
  Header: _OktaVerifyAuthenticatorHeader.default,
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

// for BETA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for EA
var Body = _internals.BaseForm.extend({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  title: function title() {
    return (0, _okta.loc)('deviceTrust.sso.redirectText', 'login');
  },
  initialize: function initialize() {
    var _this = this,
        _this$options$current,
        _this$options$current2;

    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', function () {
      _this.$('.spinner').hide();
    });
    this.add('<div class="spinner"></div>');
    var isGetMethod = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.method) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.toLowerCase()) === 'get';
    this.model.set('useRedirect', isGetMethod);
    this.trigger('save', this.model);
  }
});

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _IdentifierFooter = _interopRequireDefault(__webpack_require__(604));

var _SignInWithDeviceOption = _interopRequireDefault(__webpack_require__(605));

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('primaryauth.title', 'login');
  },
  noButtonBar: true,
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.add(_SignInWithDeviceOption.default, {
      selector: '.o-form-fieldset-container',
      bubble: false,
      prepend: true,
      options: {
        isRequired: true
      }
    });
  }
}); // override the footer to add all the supported links except the sign out link
// no session is granted at this point


var Footer = _IdentifierFooter.default.extend({
  hasBackToSignInLink: false
});

var _default = _internals.BaseView.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _OdaOktaVerifyTerminalView = _interopRequireDefault(__webpack_require__(1354));

var _MdmOktaVerifyTerminalView = _interopRequireDefault(__webpack_require__(1355));

var _Enums = _interopRequireDefault(__webpack_require__(10));

var _OktaVerifyAuthenticatorHeader = _interopRequireDefault(__webpack_require__(612));

var BaseDeviceEnrollTerminalForm = _internals.BaseForm.extend({
  noButtonBar: true,
  className: 'device-enrollment-terminal'
});

var OdaTerminalForm = BaseDeviceEnrollTerminalForm.extend({
  title: function title() {
    return (0, _okta.loc)('enroll.title.oda', 'login');
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.add(_OdaOktaVerifyTerminalView.default);
  }
});
var MdmTerminalForm = BaseDeviceEnrollTerminalForm.extend({
  title: function title() {
    return (0, _okta.loc)('enroll.title.mdm', 'login');
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.add(_MdmOktaVerifyTerminalView.default);
  }
});

var _default = _internals.BaseView.extend({
  initialize: function initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);

    var deviceEnrollment = this.options.appState.get('deviceEnrollment');
    this.enrollmentType = (deviceEnrollment.name || '').toLowerCase(); // oda/mdm

    switch (this.enrollmentType) {
      case _Enums.default.ODA:
        this.Header = _OktaVerifyAuthenticatorHeader.default;
        this.Body = OdaTerminalForm;
        break;

      case _Enums.default.MDM:
        this.Body = MdmTerminalForm;
        break;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(26));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Enums = _interopRequireDefault(__webpack_require__(10));

var Notification = _okta.internal.views.components.Notification;
var Clipboard = _okta.internal.util.Clipboard;

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 100
          },
          "end": {
            "line": 1,
            "column": 147
          }
        }
      })) + "<a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "appStoreLink") || (depth0 != null ? lookupProperty(depth0, "appStoreLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "appStoreLink",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 171
          },
          "end": {
            "line": 1,
            "column": 187
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 238
          },
          "end": {
            "line": 1,
            "column": 288
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 301
          },
          "end": {
            "line": 1,
            "column": 348
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 357
          },
          "end": {
            "line": 1,
            "column": 404
          }
        }
      })) + "</li>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.android.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 437
          },
          "end": {
            "line": 1,
            "column": 492
          }
        }
      })) + "</li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          alias4 = "function",
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"explanation\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.explanation.p1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 23
          },
          "end": {
            "line": 1,
            "column": 75
          }
        }
      })) + "</p><ol>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isIOS") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 83
          },
          "end": {
            "line": 1,
            "column": 416
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isAndroid") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 416
          },
          "end": {
            "line": 1,
            "column": 504
          }
        }
      })) != null ? stack1 : "") + "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 508
          },
          "end": {
            "line": 1,
            "column": 555
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 564
          },
          "end": {
            "line": 1,
            "column": 611
          }
        }
      })) + "<p class=\"org-signin-link\"><span class=\"no-translate\">" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias4 ? helper.call(alias1, {
        "name": "signInUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 665
          },
          "end": {
            "line": 1,
            "column": 678
          }
        }
      }) : helper)) + "</span></p><a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, (0, _typeof2.default)(helper) === alias4 ? helper.call(alias1, {
        "name": "signInUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 713
          },
          "end": {
            "line": 1,
            "column": 726
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.org.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 781
          },
          "end": {
            "line": 1,
            "column": 835
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step6"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 848
          },
          "end": {
            "line": 1,
            "column": 895
          }
        }
      })) + "</li></ol>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var deviceEnrollment = this.options.appState.get('deviceEnrollment');
    var platform = (deviceEnrollment.platform || '').toLowerCase();
    var isIOS = platform === _Enums.default.IOS;
    return {
      signInUrl: deviceEnrollment.signInUrl,
      isIOS: isIOS,
      isAndroid: platform === _Enums.default.ANDROID,
      appStoreLink: isIOS ? _Enums.default.OKTA_VERIFY_APPLE_APP_STORE_URL : null
    };
  },
  postRender: function postRender() {
    var _this = this;

    // Attach each button to the respective 'data-clipboard-text'
    Clipboard.attach('.copy-clipboard-button').done(function () {
      var notification = new Notification({
        message: (0, _okta.loc)('enroll.mdm.copyLink.success', 'login'),
        level: 'success'
      });

      _this.el.prepend(notification.render().el);

      return false;
    });
    Clipboard.attach('.copy-org-clipboard-button').done(function () {
      var notification = new Notification({
        message: (0, _okta.loc)('enroll.oda.org.copyLink.success', 'login'),
        level: 'success'
      });

      _this.el.prepend(notification.render().el);

      return false;
    });
  }
});

exports.default = _default;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var Notification = _okta.internal.views.components.Notification;
var Clipboard = _okta.internal.util.Clipboard;

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.explanation.mdm"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 5
          },
          "end": {
            "line": 1,
            "column": 58
          }
        }
      })) + "</div><ol><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 72
          },
          "end": {
            "line": 1,
            "column": 119
          }
        }
      })) + "<a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "enrollmentLink") || (depth0 != null ? lookupProperty(depth0, "enrollmentLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "enrollmentLink",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 143
          },
          "end": {
            "line": 1,
            "column": 161
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 212
          },
          "end": {
            "line": 1,
            "column": 262
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 275
          },
          "end": {
            "line": 1,
            "column": 322
          }
        }
      })) + "</li><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "vendor",
          "bundle": "login",
          "code": "enroll.mdm.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 331
          },
          "end": {
            "line": 1,
            "column": 399
          }
        }
      })) != null ? stack1 : "") + "</li></ol>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    return this.options.appState.get('deviceEnrollment');
  },
  postRender: function postRender() {
    var _this = this;

    // Attach each button to the respective 'data-clipboard-text'
    Clipboard.attach('.copy-clipboard-button').done(function () {
      var notification = new Notification({
        message: (0, _okta.loc)('enroll.mdm.copyLink.success', 'login'),
        level: 'success'
      });

      _this.el.prepend(notification.render().el);

      return false;
    });
  }
});

exports.default = _default;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(353));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(354));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(355));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(356));

var _keys = _interopRequireDefault(__webpack_require__(117));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(88));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _RemediationConstants = __webpack_require__(24);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.registration.form.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oie.registration.form.submit', 'login');
  },
  saveForm: function saveForm() {
    var _this = this;

    // SIW customization hook for registration
    this.settings.preRegistrationSubmit(this.model.toJSON(), function (postData) {
      _this.model.attributes = _objectSpread(_objectSpread({}, _this.model.attributes), _this.model.parse(postData));

      _internals.BaseForm.prototype.saveForm.call(_this, _this.model);
    }, function (error) {
      return _this.model.trigger('error', _this.model, {
        responseJSON: error
      });
    });
  }
});

var Footer = _internals.BaseFooter.extend({
  links: function links() {
    var links = [];

    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_IDENTIFY)) {
      links.push({
        'type': 'link',
        'label': (0, _okta.loc)('haveaccount', 'login'),
        'name': 'back',
        'actionPath': _RemediationConstants.FORMS.SELECT_IDENTIFY
      });
    }

    return links;
  }
});

var _default = _internals.BaseView.extend({
  Body: Body,
  Footer: Footer,
  createModelClass: function createModelClass(currentViewState, optionUiSchemaConfig, settings) {
    var _this2 = this;

    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var currentSchema = JSON.parse((0, _stringify.default)(currentViewState.uiSchema));
    settings.parseRegistrationSchema(currentSchema, function (schema) {
      if (!_okta._.isEqual(schema, currentViewState.uiSchema)) {
        currentViewState.uiSchema = schema;
        ModelClass = _internals.BaseView.prototype.createModelClass.call(_this2, currentViewState, optionUiSchemaConfig);
      }
    }, function (error) {
      ModelClass = ModelClass.extend({
        local: _objectSpread({
          parseSchemaError: {
            value: error,
            type: 'object'
          }
        }, ModelClass.prototype.local)
      });
    });
    return ModelClass;
  },
  postRender: function postRender() {
    _internals.BaseView.prototype.postRender.apply(this, arguments);

    var modelError = this.model.get('parseSchemaError');

    if (modelError) {
      this.model.trigger('error', this.model, {
        responseJSON: modelError
      });
    }
  }
});

exports.default = _default;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _filter = _interopRequireDefault(__webpack_require__(39));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _LinksUtil = __webpack_require__(122);

var Body = _internals.BaseForm.extend({
  className: 'profile-update',
  title: function title() {
    return (0, _okta.loc)('oie.profile.additional.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('enroll.choices.submit.finish', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    (0, _forEach.default)(uiSchemas).call(uiSchemas, function (input) {
      if (input.name === 'userProfile.secondEmail') {
        input.explain = _okta.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function main(container, depth0, helpers, partials, data) {
              var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }

                return undefined;
              };

              return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "$1": "<span class='strong'>$1</span>",
                  "bundle": "login",
                  "code": "oie.profile.additional.secondemail.subtitle"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 112
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          })
        });
      }
    });
    return uiSchemas;
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
  }
});

var Footer = _internals.BaseFooter.extend({
  className: 'auth-footer side-by-side-links',
  links: function links() {
    var uiSchema = this.options.currentViewState.uiSchema;
    var optionalParams = (0, _filter.default)(uiSchema).call(uiSchema, function (item) {
      return item.required === false;
    });

    if (uiSchema.length === optionalParams.length) {
      return (0, _LinksUtil.getSkipSetupLink)(this.options.appState, (0, _okta.loc)('oie.enroll.skip.profile', 'login'));
    } else {
      this.$el.removeClass('.side-by-side-links');
    }
  }
});

var _default = _internals.BaseView.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.activation.request.email.title.expire', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oie.activation.request.email.button', 'login');
  },
  showMessages: function showMessages() {
    var _this = this;

    var messages = this.options.appState.get('messages') || {};

    if ((0, _isArray.default)(messages.value)) {
      var _context;

      this.add('<div class="ion-messages-container”></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messages.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if (messagesObj.class === 'ERROR') {
          _this.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
});

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.select.authenticators.enroll.title', 'login');
  },
  subtitle: function subtitle() {
    var subtitle = this.options.settings.get('brandName') ? (0, _okta.loc)('oie.select.authenticators.enroll.subtitle.custom', 'login', [this.options.settings.get('brandName')]) : (0, _okta.loc)('oie.select.authenticators.enroll.subtitle', 'login');
    return subtitle;
  },
  noButtonBar: true
});

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

var UnlockAccountView = _internals.BaseForm.extend({
  noButtonBar: true,
  title: function title() {
    return (0, _okta.loc)('unlockaccount', 'login');
  }
});

var _default = _internals.BaseView.extend({
  initialize: function initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);

    this.Body = UnlockAccountView;
  }
});

exports.default = _default;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _AuthenticatorFooter = _interopRequireDefault(__webpack_require__(358));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _LinksUtil = __webpack_require__(122);

var _i18nTransformer = __webpack_require__(142);

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.password.challenge.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },

  /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */
  getUISchema: function getUISchema() {
    var schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    var settings = this.options.settings;
    var passwordExplainLabeli18nKey = 'primaryauth.password.tooltip';
    var passwordSchema = (0, _find.default)(schemas).call(schemas, function (_ref) {
      var name = _ref.name;
      return name === 'credentials.passcode';
    });

    if (passwordSchema && (0, _i18nTransformer.isCustomizedI18nKey)(passwordExplainLabeli18nKey, settings)) {
      passwordSchema.explain = (0, _okta.loc)(passwordExplainLabeli18nKey, 'login');
      passwordSchema['explain-top'] = true;
    }

    return schemas;
  }
});

var Footer = _AuthenticatorFooter.default.extend({
  links: function links() {
    var _context;

    var links = _AuthenticatorFooter.default.prototype.links.apply(this, arguments);

    links = (0, _concat.default)(_context = (0, _LinksUtil.getForgotPasswordLink)(this.options.appState, this.options.settings)).call(_context, links);
    return links;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(258));

var Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  title: function title() {
    var title = this.options.settings.get('brandName') ? (0, _okta.loc)('password.expired.title.specific', 'login', [this.options.settings.get('brandName')]) : (0, _okta.loc)('password.expired.title.generic', 'login');
    return title;
  },
  save: function save() {
    return (0, _okta.loc)('password.expired.submit', 'login');
  },
  getPasswordPolicySettings: function getPasswordPolicySettings() {
    var _this$options$appStat, _this$options$appStat2;

    return ((_this$options$appStat = this.options.appState.get('recoveryAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.settings) || ((_this$options$appStat2 = this.options.appState.get('enrollmentAuthenticator')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.settings);
  }
});

var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(258));

var Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  subtitle: function subtitle() {
    if (this.options.settings.get('brandName')) {
      return (0, _okta.loc)('password.expiring.subtitle.specific', 'login', [this.options.settings.get('brandName')]);
    }
  },
  title: function title() {
    var passwordPolicy = this.getPasswordPolicySettings() || {};
    var daysToExpiry = passwordPolicy.daysToExpiry;

    if (daysToExpiry > 0) {
      return (0, _okta.loc)('password.expiring.title', 'login', [daysToExpiry]);
    } else if (daysToExpiry === 0) {
      return (0, _okta.loc)('password.expiring.today', 'login');
    } else {
      return (0, _okta.loc)('password.expiring.soon', 'login');
    }
  },
  save: function save() {
    return (0, _okta.loc)('password.expired.submit', 'login');
  },
  showMessages: function showMessages() {
    // if brandName is configured and messages is present, render as subtitle with brandName in context
    if (this.options.settings.get('brandName')) {
      return null;
    } // else if brandName is not set, render messages object sent from server as text


    _EnrollAuthenticatorPasswordView.default.prototype.Body.prototype.showMessages.apply(this, arguments);
  }
});

var Footer = _internals.BaseFooter.extend({
  links: function links() {
    var links = [];

    if (this.options.appState.hasRemediationObject('skip')) {
      links.push({
        'type': 'link',
        'label': (0, _okta.loc)('password.expiring.later', 'login'),
        'name': 'skip',
        'actionPath': 'skip'
      });
    }

    return links;
  }
});

var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body: Body,
  Footer: Footer
});

exports.default = _default;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(258));

var Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  title: function title() {
    var title = this.options.settings.get('brandName') ? (0, _okta.loc)('password.reset.title.specific', 'login', [this.options.settings.get('brandName')]) : (0, _okta.loc)('password.reset.title.generic', 'login');
    return title;
  },
  save: function save() {
    return (0, _okta.loc)('password.reset', 'login');
  }
});

var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(1366);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _ChallengeAuthenticatorPhoneView = _interopRequireWildcard(__webpack_require__(614));

var _internals = __webpack_require__(5);

var EnrollResendView = _ChallengeAuthenticatorPhoneView.ResendView.extend({
  // To be shown after a timeout
  className: 'phone-authenticator-enroll--warning hide',
  resendActionKey: 'currentAuthenticator-resend'
});

var Body = _ChallengeAuthenticatorPhoneView.default.prototype.Body.extend({
  className: 'phone-authenticator-enroll',
  title: function title() {
    return (0, _okta.loc)('oie.phone.enroll.title', 'login');
  },
  postRender: function postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);

    this.add(EnrollResendView, {
      selector: '.o-form-error-container',
      prepend: true
    });
  }
});

var _default = _ChallengeAuthenticatorPhoneView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$getOwnPropertyDescriptor = __webpack_require__(1367);

var _Object$defineProperty = __webpack_require__(515);

var _typeof = __webpack_require__(26);

var _WeakMap = __webpack_require__(1369);

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1368);

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(579);

module.exports = parent;


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1370);

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(1371);
__webpack_require__(1375);
__webpack_require__(1377);
__webpack_require__(1379);
__webpack_require__(1381);

module.exports = parent;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(318);
__webpack_require__(1372);
__webpack_require__(105);
var path = __webpack_require__(23);

module.exports = path.WeakMap;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(33);
var redefineAll = __webpack_require__(240);
var InternalMetadataModule = __webpack_require__(244);
var collection = __webpack_require__(1373);
var collectionWeak = __webpack_require__(1374);
var isObject = __webpack_require__(38);
var enforceIternalState = __webpack_require__(95).enforce;
var NATIVE_WEAK_MAP = __webpack_require__(460);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.github.io/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var global = __webpack_require__(33);
var InternalMetadataModule = __webpack_require__(244);
var fails = __webpack_require__(28);
var createNonEnumerableProperty = __webpack_require__(85);
var iterate = __webpack_require__(119);
var anInstance = __webpack_require__(196);
var isObject = __webpack_require__(38);
var setToStringTag = __webpack_require__(106);
var defineProperty = __webpack_require__(86).f;
var forEach = __webpack_require__(97).forEach;
var DESCRIPTORS = __webpack_require__(44);
var InternalStateModule = __webpack_require__(95);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;

  if (!DESCRIPTORS || typeof NativeConstructor != 'function'
    || !(IS_WEAK || NativePrototype.forEach && !fails(function () { new NativeConstructor().entries().next(); }))
  ) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (iterable != undefined) iterate(iterable, target[ADDER], target, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
        createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });

    IS_WEAK || defineProperty(Constructor.prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).collection.size;
      }
    });
  }

  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: true }, exported);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(240);
var getWeakData = __webpack_require__(244).getWeakData;
var anObject = __webpack_require__(53);
var isObject = __webpack_require__(38);
var anInstance = __webpack_require__(196);
var iterate = __webpack_require__(119);
var ArrayIterationModule = __webpack_require__(97);
var $has = __webpack_require__(59);
var InternalStateModule = __webpack_require__(95);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.3.3.3 WeakMap.prototype.get(key)
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // 23.3.3.5 WeakMap.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // 23.4.3.1 WeakSet.prototype.add(value)
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var from = __webpack_require__(1376);

// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$({ target: 'WeakMap', stat: true }, {
  from: from
});


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var aFunction = __webpack_require__(84);
var bind = __webpack_require__(115);
var iterate = __webpack_require__(119);

module.exports = function from(source /* , mapFn, thisArg */) {
  var length = arguments.length;
  var mapFn = length > 1 ? arguments[1] : undefined;
  var mapping, A, n, boundFunction;
  aFunction(this);
  mapping = mapFn !== undefined;
  if (mapping) aFunction(mapFn);
  if (source == undefined) return new this();
  A = [];
  if (mapping) {
    n = 0;
    boundFunction = bind(mapFn, length > 2 ? arguments[2] : undefined, 2);
    iterate(source, function (nextItem) {
      A.push(boundFunction(nextItem, n++));
    });
  } else {
    iterate(source, A.push, A);
  }
  return new this(A);
};


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var of = __webpack_require__(1378);

// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$({ target: 'WeakMap', stat: true }, {
  of: of
});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
  var length = arguments.length;
  var A = new Array(length);
  while (length--) A[length] = arguments[length];
  return new this(A);
};


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(87);
var collectionDeleteAll = __webpack_require__(1380);

// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'WeakMap', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(53);
var aFunction = __webpack_require__(84);

// https://github.com/tc39/collection-methods
module.exports = function (/* ...elements */) {
  var collection = anObject(this);
  var remover = aFunction(collection['delete']);
  var allDeleted = true;
  var wasDeleted;
  for (var k = 0, len = arguments.length; k < len; k++) {
    wasDeleted = remover.call(collection, arguments[k]);
    allDeleted = allDeleted && wasDeleted;
  }
  return !!allDeleted;
};


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(87);
var $upsert = __webpack_require__(1382);

// `WeakMap.prototype.upsert` method
// https://github.com/thumbsupep/proposal-upsert
$({ target: 'WeakMap', proto: true, real: true, forced: IS_PURE }, {
  upsert: $upsert
});


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(53);

// `Map.prototype.upsert` method
// https://github.com/thumbsupep/proposal-upsert
module.exports = function upsert(key, updateFn /* , insertFn */) {
  var map = anObject(this);
  var insertFn = arguments.length > 2 ? arguments[2] : undefined;
  var value;
  if (typeof updateFn != 'function' && typeof insertFn != 'function') {
    throw TypeError('At least one callback required');
  }
  if (map.has(key)) {
    value = map.get(key);
    if (typeof updateFn == 'function') {
      value = updateFn(value);
      map.set(key, value);
    }
  } else if (typeof insertFn == 'function') {
    value = insertFn();
    map.set(key, value);
  } return value;
};


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _trim = _interopRequireDefault(__webpack_require__(321));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _bind = _interopRequireDefault(__webpack_require__(27));

var _find = _interopRequireDefault(__webpack_require__(13));

var _splice = _interopRequireDefault(__webpack_require__(154));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _findIndex = _interopRequireDefault(__webpack_require__(153));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _CountryUtil = _interopRequireDefault(__webpack_require__(157));

var Body = _internals.BaseForm.extend({
  className: 'phone-authenticator-enroll',
  title: function title() {
    return (0, _okta.loc)('oie.phone.enroll.title', 'login');
  },
  subtitle: function subtitle() {
    return this.model.get('authenticator.methodType') === 'voice' ? (0, _okta.loc)('oie.phone.enroll.call.subtitle', 'login') : (0, _okta.loc)('oie.phone.enroll.sms.subtitle', 'login');
  },
  render: function render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);

    var selectedMethod = this.model.get('authenticator.methodType');
    var phoneField = this.el.querySelector('.phone-authenticator-enroll__phone');
    var extensionField = this.el.querySelector('.phone-authenticator-enroll__phone-ext');

    if (selectedMethod === 'voice') {
      if (!phoneField.classList.contains('phone-authenticator-enroll__phone--small')) {
        phoneField.classList.add('phone-authenticator-enroll__phone--small');
      }

      extensionField.classList.remove('hide');
    }

    if (selectedMethod === 'sms') {
      phoneField.classList.remove('phone-authenticator-enroll__phone--small');

      if (!extensionField.classList.contains('hide')) {
        extensionField.classList.add('hide');
      }
    }

    this.el.querySelector('.phone-authenticator-enroll__phone-code').innerText = "+".concat(this.model.get('phoneCode'));
  },
  handlePhoneCodeChange: function handlePhoneCodeChange() {
    var countryCodeField = this.el.querySelector('.phone-authenticator-enroll__phone-code');
    countryCodeField.innerText = "+".concat(this.model.get('phoneCode'));
  },
  save: function save() {
    return this.model.get('authenticator.methodType') === 'voice' ? (0, _okta.loc)('oie.phone.call.primaryButton', 'login') : (0, _okta.loc)('oie.phone.sms.primaryButton', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments); // TODO: Using underscore to support IE, replace with Array.prototype methods (find, findIndex) when IE
    // support is removed


    var phoneNumberUISchemaIndex = (0, _findIndex.default)(_okta._).call(_okta._, uiSchemas, function (_ref) {
      var name = _ref.name;
      return name === 'authenticator.phoneNumber';
    });
    var countryUISchema = {
      'label-top': true,
      label: (0, _okta.loc)('country.label', 'login'),
      type: 'select',
      options: _CountryUtil.default.getCountries(),
      name: 'country',
      wide: true
    }; // Create an input group - serves as a display wrapper

    var phoneNumberWithCodeUISchema = {
      label: (0, _okta.loc)('mfa.phoneNumber.placeholder', 'login'),
      type: 'group',
      modelType: 'string',
      'label-top': true,
      name: 'phoneCode',
      className: 'phone-authenticator-enroll__phone',
      input: [{
        type: 'label',

        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
        label: "+".concat(this.model.get('phoneCode')),
        className: 'phone-authenticator-enroll__phone-code no-translate'
      }, (0, _assign.default)({}, uiSchemas[phoneNumberUISchemaIndex])]
    };
    var extensionUISchema = {
      label: (0, _okta.loc)('phone.extention.label', 'login'),
      type: 'text',
      // Need to manually hide and show
      // - toggleWhen puts display: block on the element when it unhides hence can't be used.
      //   Because in this case, the element needs to be rendered as an inline-block.
      // - showWhen has an animation on the element when unhiding
      //   The animation makes the element look weird because of the way it is positioned,
      //   hence can't be used
      className: 'phone-authenticator-enroll__phone-ext hide',
      'label-top': true,
      name: 'extension'
    };

    if (phoneNumberUISchemaIndex !== -1) {
      // Replace phoneNumberUISchema..
      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex, 1, phoneNumberWithCodeUISchema); // Add countryUISchema before & extensionUISchema after phone..

      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex, 0, countryUISchema);
      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex + 2, 0, extensionUISchema);
    }

    var methodType = (0, _find.default)(_okta._).call(_okta._, uiSchemas, function (_ref2) {
      var name = _ref2.name;
      return name === 'authenticator.methodType';
    });

    if (methodType && methodType.options.length === 1) {
      methodType.className = 'hide';
    }

    return uiSchemas;
  },
  initialize: function initialize() {
    var _context, _context2;

    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'change:authenticator.methodType', (0, _bind.default)(_context = this.render).call(_context, this));
    this.listenTo(this.model, 'change:phoneCode', (0, _bind.default)(_context2 = this.handlePhoneCodeChange).call(_context2, this));
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass() {
    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      country: {
        // Set default country to "US"
        'value': 'US',
        'type': 'string'
      },
      extension: {
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    var derived = (0, _assign.default)({
      phoneCode: {
        deps: ['country'],
        fn: function fn(country) {
          return _CountryUtil.default.getCallingCodeForCountry(country);
        }
      }
    }, ModelClass.prototype.derived);
    return ModelClass.extend({
      local: local,
      derived: derived,
      toJSON: function toJSON() {
        var _context3;

        var modelJSON = _okta.Model.prototype.toJSON.call(this, arguments);

        var extension = this.get('extension');
        var phoneCode = this.get('phoneCode'); // Add country code..

        var formattedPhoneNumber = (0, _concat.default)(_context3 = "+".concat(phoneCode)).call(_context3, modelJSON.authenticator.phoneNumber); // Add extension if present..

        if (modelJSON.authenticator.methodType === 'voice' && (extension === null || extension === void 0 ? void 0 : (0, _trim.default)(extension).call(extension).length)) {
          var _context4;

          formattedPhoneNumber = (0, _concat.default)(_context4 = "".concat(formattedPhoneNumber, "x")).call(_context4, extension);
        } // Override phone with formatted number..


        modelJSON.authenticator.phoneNumber = formattedPhoneNumber;
        return modelJSON;
      }
    });
  }
});

exports.default = _default;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _find = _interopRequireDefault(__webpack_require__(13));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _internals.BaseForm.extend({
  className: 'phone-authenticator-challenge',
  events: {
    'click a.phone-authenticator-challenge__link': 'handleSecondaryLinkClick'
  },
  title: function title() {
    return (0, _okta.loc)('oie.phone.verify.title', 'login');
  },
  save: function save() {
    return this.model.get('primaryMode') === 'sms' ? (0, _okta.loc)('oie.phone.sms.primaryButton', 'login') : (0, _okta.loc)('oie.phone.call.primaryButton', 'login');
  },
  handleSecondaryLinkClick: function handleSecondaryLinkClick() {
    // Call the API to send a code via secondary mode
    var secondaryMode = this.model.get('secondaryMode');
    this.model.set('authenticator.methodType', secondaryMode);
    this.saveForm(this.model);
  },
  initialize: function initialize() {
    var _this = this,
        _context,
        _context2,
        _context3;

    // This is needed when user clicks on secondary (say voice) and call fails with ratelimit server-side error.
    // Then the user clicks primary button (say sms) and right methodType needs to be sent.
    this.model.on('error', function () {
      return _this.model.set('authenticator.methodType', _this.model.get('primaryMode'));
    });

    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    var sendText = this.model.get('primaryMode') === 'sms' ? (0, _okta.loc)('oie.phone.verify.sms.sendText', 'login') : (0, _okta.loc)('oie.phone.verify.call.sendText', 'login');
    var carrierChargesText = (0, _okta.loc)('oie.phone.carrier.charges', 'login');
    var extraCssClasses = this.model.get('phoneNumber') !== (0, _okta.loc)('oie.phone.alternate.title', 'login') ? 'strong no-translate' : ''; // Courage doesn't support HTML, hence creating a subtitle here.

    this.add((0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "<div class=\"okta-form-subtitle\" data-se=\"o-form-explain\">".concat(sendText, "\n        <span ")).call(_context3, extraCssClasses ? 'class="' + extraCssClasses + '"' : '', ">")).call(_context2, this.model.escape('phoneNumber'), "</span>\n        <p>")).call(_context, carrierChargesText, "</p>\n      </div>"));
  },
  getUISchema: function getUISchema() {
    // Change the UI schema to not display radios here.
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    return (0, _filter.default)(uiSchemas).call(uiSchemas, function (schema) {
      return schema.name !== 'authenticator.methodType';
    });
  },
  render: function render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);

    var secondaryMode = this.model.get('secondaryMode');

    if (secondaryMode) {
      var secondaryButtonTitle = secondaryMode === 'sms' ? (0, _okta.loc)('oie.phone.sms.secondaryButton', 'login') : (0, _okta.loc)('oie.phone.call.secondaryButton', 'login');
      this.add("<a href=\"#\"\n            class=\"link phone-authenticator-challenge__link\"\n            data-se=\"phone-authenticator-challenge__link\">".concat(secondaryButtonTitle, "</a>"), '.o-form-button-bar');
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass(_ref) {
    var uiSchema = _ref.uiSchema;

    // It is important to get methods from here to maintain single source of truth.
    var _$find = (0, _find.default)(_okta._).call(_okta._, uiSchema, function (schema) {
      return schema.name === 'authenticator.methodType';
    }),
        methods = _$find.options;

    var relatesToObject = this.options.currentViewState.relatesTo;

    var _ref2 = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {},
        profile = _ref2.profile;

    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      primaryMode: {
        'value': methods[0].value,
        'type': 'string'
      },
      secondaryMode: {
        'value': methods[1] && methods[1].value,
        'type': 'string'
      },
      phoneNumber: {
        'value': (profile === null || profile === void 0 ? void 0 : profile.phoneNumber) ? profile.phoneNumber : (0, _okta.loc)('oie.phone.alternate.title', 'login'),
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local
    });
  }
});

exports.default = _default;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.security.question.enroll.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _indexOf = _interopRequireDefault(__webpack_require__(78));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.security.question.challenge.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    var questionKey = (0, _filter.default)(uiSchemas).call(uiSchemas, function (s) {
      var _context;

      return (0, _indexOf.default)(_context = s.name).call(_context, 'questionKey') >= 0;
    });
    var answer = (0, _filter.default)(uiSchemas).call(uiSchemas, function (s) {
      var _context2;

      return (0, _indexOf.default)(_context2 = s.name).call(_context2, 'answer') >= 0;
    });
    /**
     * At verify SQ case,
     * 'questionKey' is read-only hence it won't show up in UI anyway.
     * 'answer' has label 'answer' but apparently UI want to display the
     * actual question (label of `questionKey`) as better user experience.
     */

    if (questionKey.length === 1 && answer.length === 1) {
      answer[0].label = questionKey[0].label;
    }

    return uiSchemas;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _webauthn = _interopRequireDefault(__webpack_require__(158));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(243));

var _EnrollWebauthnInfoView = _interopRequireDefault(__webpack_require__(1388));

var _i18nTransformer = __webpack_require__(142);

function getExcludeCredentials() {
  var authenticatorEnrollments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var credentials = [];
  (0, _forEach.default)(authenticatorEnrollments).call(authenticatorEnrollments, function (enrollement) {
    if (enrollement.key === 'webauthn') {
      credentials.push({
        type: 'public-key',
        id: _CryptoUtil.default.strToBin(enrollement.credentialId)
      });
    }
  });
  return credentials;
}

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.enroll.webauthn.title', 'login');
  },
  className: 'oie-enroll-webauthn',
  modelEvents: {
    'error': '_stopEnrollment'
  },
  getUISchema: function getUISchema() {
    var _this = this;

    var schema = []; // Returning custom array so no input fields are displayed for webauthn

    if (_webauthn.default.isNewApiAvailable()) {
      schema.push({
        View: _EnrollWebauthnInfoView.default
      });
      schema.push({
        View: (0, _okta.createButton)({
          className: 'webauthn-setup button button-primary button-wide',
          title: (0, _okta.loc)('oie.enroll.webauthn.save', 'login'),
          click: function click() {
            _this.triggerWebauthnPrompt();
          }
        })
      });
    } else {
      schema.push({
        View: (0, _okta.createCallout)({
          className: 'webauthn-not-supported',
          type: 'error',
          subtitle: (0, _okta.loc)('oie.webauthn.error.not.supported', 'login')
        })
      });
    }

    return schema;
  },
  triggerWebauthnPrompt: function triggerWebauthnPrompt() {
    var _context,
        _this2 = this;

    (0, _find.default)(_context = this.$el).call(_context, '.o-form-error-container').empty();

    this._startEnrollment();

    var relatesToObject = this.options.currentViewState.relatesTo;
    var activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;

    if (_webauthn.default.isNewApiAvailable()) {
      var options = _okta._.extend({}, activationData, {
        challenge: _CryptoUtil.default.strToBin(activationData.challenge),
        user: {
          id: _CryptoUtil.default.strToBin(activationData.user.id),
          name: activationData.user.name,
          displayName: activationData.user.displayName
        },
        excludeCredentials: getExcludeCredentials(this.options.appState.get('authenticatorEnrollments').value)
      });

      this.webauthnAbortController = new AbortController();
      navigator.credentials.create({
        publicKey: options,
        signal: this.webauthnAbortController.signal
      }).then(function (newCredential) {
        _this2.model.set({
          credentials: {
            clientData: _CryptoUtil.default.binToStr(newCredential.response.clientDataJSON),
            attestation: _CryptoUtil.default.binToStr(newCredential.response.attestationObject)
          }
        });

        _this2.saveForm(_this2.model);
      }).catch(function (error) {
        _this2.model.trigger('error', _this2.model, {
          responseJSON: {
            errorSummary: (0, _i18nTransformer.getMessageFromBrowserError)(error)
          }
        });
      }).finally(function () {
        _this2.webauthnAbortController = null;
      });
    }
  },
  _startEnrollment: function _startEnrollment() {
    this.$('.okta-waiting-spinner').show();
    this.$('.webauthn-setup').hide();
  },
  _stopEnrollment: function _stopEnrollment() {
    this.$('.okta-waiting-spinner').hide();
    this.$('.webauthn-setup').show();
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  postRender: function postRender() {
    var _context2;

    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);

    (0, _find.default)(_context2 = this.$el).call(_context2, '.o-form-button-bar [type="submit"]').remove();
  }
});

exports.default = _default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _default = _okta.View.extend({
  // eslint-disable-next-line max-len
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"idx-webauthn-enroll-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.webauthn.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var relatesToObject = this.options.currentViewState.relatesTo;
    var activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;

    if (_BrowserFeatures.default.isEdge()) {
      this.add(_okta.View.extend({
        tagName: 'p',
        className: 'idx-webauthn-enroll-text-edge',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function main(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }

              return undefined;
            };

            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "oie.enroll.webauthn.instructions.edge"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 68
                }
              }
            }));
          },
          "useData": true
        })
      }));
    }

    if (activationData.authenticatorSelection.userVerification === 'required') {
      this.add((0, _okta.createCallout)({
        className: 'uv-required-callout',
        size: 'slim',
        type: 'warning',
        subtitle: (0, _okta.loc)('oie.enroll.webauthn.uv.required.instructions', 'login')
      }));
    }

    this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
  }
});

exports.default = _default;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _CryptoUtil = _interopRequireDefault(__webpack_require__(243));

var _webauthn = _interopRequireDefault(__webpack_require__(158));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _ChallengeWebauthnInfoView = _interopRequireDefault(__webpack_require__(1390));

var _i18nTransformer = __webpack_require__(142);

var _ChallengeWebauthnFooter = _interopRequireDefault(__webpack_require__(1391));

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.verify.webauth.title', 'login');
  },
  className: 'oie-verify-webauthn',
  getUISchema: function getUISchema() {
    var _this = this;

    var schema = []; // Returning custom array so no input fields are displayed for webauthn

    if (_webauthn.default.isNewApiAvailable()) {
      var retryButton = (0, _okta.createButton)({
        className: 'retry-webauthn button-primary default-custom-button',
        title: (0, _okta.loc)('mfa.challenge.verify', 'login'),
        click: function click() {
          _this.getCredentialsAndSave();
        }
      });
      schema.push({
        View: _ChallengeWebauthnInfoView.default
      }, {
        View: retryButton
      });
    } else {
      schema.push({
        View: (0, _okta.createCallout)({
          className: 'webauthn-not-supported',
          type: 'error',
          subtitle: (0, _okta.loc)('oie.webauthn.error.not.supported', 'login')
        })
      });
    }

    return schema;
  },
  remove: function remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);

    if (this.webauthnAbortController) {
      this.webauthnAbortController.abort();
      this.webauthnAbortController = null;
    }
  },
  noButtonBar: true,
  modelEvents: {
    'error': '_stopVerification'
  },
  getCredentialsAndSave: function getCredentialsAndSave() {
    var _this2 = this;

    this.clearErrors();

    this._startVerification();

    this.webauthnAbortController = new AbortController();
    var relatesToObject = this.options.currentViewState.relatesTo;
    var authenticatorData = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
    var allowCredentials = [];
    var authenticatorEnrollments = this.options.appState.get('authenticatorEnrollments').value || [];
    (0, _forEach.default)(authenticatorEnrollments).call(authenticatorEnrollments, function (enrollement) {
      if (enrollement.key === 'webauthn') {
        allowCredentials.push({
          type: 'public-key',
          id: _CryptoUtil.default.strToBin(enrollement.credentialId)
        });
      }
    });
    var challengeData = authenticatorData.contextualData.challengeData;

    var options = _okta._.extend({}, challengeData, {
      allowCredentials: allowCredentials,
      challenge: _CryptoUtil.default.strToBin(challengeData.challenge)
    });

    navigator.credentials.get({
      publicKey: options,
      signal: this.webauthnAbortController.signal
    }).then(function (assertion) {
      _this2.model.set({
        credentials: {
          clientData: _CryptoUtil.default.binToStr(assertion.response.clientDataJSON),
          authenticatorData: _CryptoUtil.default.binToStr(assertion.response.authenticatorData),
          signatureData: _CryptoUtil.default.binToStr(assertion.response.signature)
        }
      });

      _this2.saveForm(_this2.model);
    }, function (error) {
      // Do not display if it is abort error triggered by code when switching.
      // this.webauthnAbortController would be null if abort was triggered by code.
      if (_this2.webauthnAbortController) {
        _this2.model.trigger('error', _this2.model, {
          responseJSON: {
            errorSummary: (0, _i18nTransformer.getMessageFromBrowserError)(error)
          }
        });
      }
    }).finally(function () {
      // unset webauthnAbortController on successful authentication or error
      _this2.webauthnAbortController = null;
    });
  },
  _startVerification: function _startVerification() {
    this.$('.okta-waiting-spinner').show();
    this.$('.retry-webauthn').hide();
    this.$('.retry-webauthn')[0].textContent = (0, _okta.loc)('retry', 'login');
  },
  _stopVerification: function _stopVerification() {
    this.$('.okta-waiting-spinner').hide();
    this.$('.retry-webauthn').show();
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _ChallengeWebauthnFooter.default,
  postRender: function postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments); // Trigger browser prompt automatically for other browsers for better UX.


    if (_webauthn.default.isNewApiAvailable() && !_BrowserFeatures.default.isSafari()) {
      this.form.getCredentialsAndSave();
    }
  }
});

exports.default = _default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  // eslint-disable-next-line max-len
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p class=\"idx-webauthn-verify-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize: function initialize() {
    var relatesToObject = this.options.currentViewState.relatesTo;
    var challengeData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.challengeData;

    if (challengeData.userVerification === 'required') {
      this.add((0, _okta.createCallout)({
        className: 'uv-required-callout',
        size: 'slim',
        type: 'warning',
        subtitle: (0, _okta.loc)('oie.verify.webauthn.uv.required.instructions', 'login')
      }));
    }

    this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
  }
});

exports.default = _default;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _AuthenticatorFooter = _interopRequireDefault(__webpack_require__(358));

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var OKTA_AUTHENTICATOR = 'Okta_Authenticator';

var CantVerifyInfoVerifyFlowView = _okta.View.extend({
  id: 'help-description-container',
  className: 'help-description js-help-description',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<h3>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4
          },
          "end": {
            "line": 1,
            "column": 96
          }
        }
      })) + "</h3><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.description1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 108
          },
          "end": {
            "line": 1,
            "column": 207
          }
        }
      })) + "</p><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.description2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 218
          },
          "end": {
            "line": 1,
            "column": 317
          }
        }
      })) + "</p><br><h3>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.security.key.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 329
          },
          "end": {
            "line": 1,
            "column": 410
          }
        }
      })) + "</h3><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.security.key.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 422
          },
          "end": {
            "line": 1,
            "column": 509
          }
        }
      })) + "</p><br>";
    },
    "useData": true
  })
});

var CantVerifyInfoOVEnrollmentFlowView = _okta.View.extend({
  id: 'help-description-container',
  className: 'help-description js-help-description',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ol class=\"ov-enrollment-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 35
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 127
          },
          "end": {
            "line": 1,
            "column": 206
          }
        }
      })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 219
          },
          "end": {
            "line": 1,
            "column": 298
          }
        }
      })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step4"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 311
          },
          "end": {
            "line": 1,
            "column": 390
          }
        }
      })) + "</><br></ol>";
    },
    "useData": true
  })
});

var _default = _AuthenticatorFooter.default.extend({
  links: function links() {
    var links = _AuthenticatorFooter.default.prototype.links.apply(this, arguments);

    var cantVerifyInfoView = this.options.appState.get('app') && this.options.appState.get('app').name === OKTA_AUTHENTICATOR ? CantVerifyInfoOVEnrollmentFlowView : CantVerifyInfoVerifyFlowView;
    links.unshift({
      'label': (0, _okta.loc)('oie.verify.webauthn.cant.verify', 'login'),
      'name': 'cant-verify',
      'aria-controls': 'help-description-container',
      'class': 'link help js-help',
      'type': 'toggle-text-link',
      'additionalOptions': {
        view: cantVerifyInfoView,
        selector: '.js-help-description'
      }
    });
    return links;
  }
});

exports.default = _default;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _BaseAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(615));

var BaseAuthenticatorEmailForm = _BaseAuthenticatorEmailView.default.prototype.Body;
var Body = BaseAuthenticatorEmailForm.extend((0, _assign.default)({
  resendEmailAction: 'currentAuthenticator-resend',
  subtitle: function subtitle() {
    return (0, _okta.loc)('oie.email.enroll.subtitle', 'login');
  }
}));

var _default = _BaseAuthenticatorEmailView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _default = {
  title: function title() {
    return (0, _okta.loc)('oie.email.mfa.title', 'login');
  }
};
exports.default = _default;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _BaseAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(615));

var BaseAuthenticatorEmailForm = _BaseAuthenticatorEmailView.default.prototype.Body; // Courage doesn't support HTML, hence creating a subtitle here.

var CheckYourEmailTitle = _okta.View.extend({
  className: 'okta-form-subtitle',
  attributes: {
    'data-se': 'o-form-explain'
  },
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "email",
          "bundle": "login",
          "code": "oie.email.verify.alternate.magicLinkToEmailAddress"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 13
          },
          "end": {
            "line": 1,
            "column": 149
          }
        }
      }));
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "bundle": "login",
          "code": "oie.email.verify.alternate.magicLinkToYourEmail"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 157
          },
          "end": {
            "line": 1,
            "column": 272
          }
        }
      }));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 279
          }
        }
      })) != null ? stack1 : "") + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.verify.alternate.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 279
          },
          "end": {
            "line": 1,
            "column": 350
          }
        }
      }));
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var email = this.options.email;
    return {
      email: email
    };
  }
});

var EnterCodeLink = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<button class=\"button-link enter-auth-code-instead-link\" >" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "code": "oie.email.verify.alternate.showCodeTextField"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 118
          }
        }
      })) + "</button>";
    },
    "useData": true
  })
});

var Body = BaseAuthenticatorEmailForm.extend((0, _assign.default)({
  noButtonBar: true,
  resendEmailAction: 'currentAuthenticatorEnrollment-resend',
  events: {
    'click .enter-auth-code-instead-link': 'showAuthCodeEntry'
  },
  initialize: function initialize() {
    var _this$options$current, _this$options$current2;

    BaseAuthenticatorEmailForm.prototype.initialize.apply(this, arguments);

    var _ref = ((_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.profile) || {},
        email = _ref.email;

    this.add(EnterCodeLink, {
      prepend: true,
      selector: '.o-form-error-container'
    });
    this.add(CheckYourEmailTitle, {
      prepend: true,
      selector: '.o-form-error-container',
      options: {
        email: email
      }
    });
  },
  postRender: function postRender() {
    this.showCodeEntryField(false);
  },
  showAuthCodeEntry: function showAuthCodeEntry() {
    this.noButtonBar = false;
    this.render();
    this.showCodeEntryField(true);
    this.showEnterAuthCodeInsteadLink(false);
  },
  showCodeEntryField: function showCodeEntryField() {
    var _context;

    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var $textField = (0, _find.default)(_context = this.$el).call(_context, '.o-form-fieldset-container');
    $textField.toggle(show);
  },
  showEnterAuthCodeInsteadLink: function showEnterAuthCodeInsteadLink() {
    var _context2;

    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var $enterAuthCodeInsteadLink = (0, _find.default)(_context2 = this.$el).call(_context2, '.enter-auth-code-instead-link');
    $enterAuthCodeInsteadLink.toggle(show);
  }
}));

var _default = _BaseAuthenticatorEmailView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(__webpack_require__(52));

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _polling = _interopRequireDefault(__webpack_require__(257));

var _RemediationConstants = __webpack_require__(24);

var _ResendView = _interopRequireDefault(__webpack_require__(1396));

var _SwitchEnrollChannelLinkView = _interopRequireDefault(__webpack_require__(616));

var _EnrollChannelPollDescriptionView = _interopRequireDefault(__webpack_require__(1397));

var OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_IOS = 'oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible';
var OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_NON_IOS = 'oie.authenticator.app.non_fips_compliant_enrollment_app_update_required';
var OV_QR_ENROLL_ENABLE_BIOMETRICS_KEY = 'oie.authenticator.app.method.push.enroll.enable.biometrics';

var Body = _internals.BaseForm.extend((0, _assign.default)({
  title: function title() {
    var selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    var title;

    switch (selectedChannel) {
      case 'email':
        title = (0, _okta.loc)('oie.enroll.okta_verify.setup.email.title', 'login');
        break;

      case 'sms':
        title = (0, _okta.loc)('oie.enroll.okta_verify.setup.sms.title', 'login');
        break;

      default:
        title = (0, _okta.loc)('oie.enroll.okta_verify.setup.title', 'login');
    }

    return title;
  },
  className: 'oie-enroll-ov-poll',
  noButtonBar: true,
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.stopPolling);
    this.startPolling();
  },
  postRender: function postRender() {
    if ((_BrowserFeatures.default.isAndroid() || _BrowserFeatures.default.isIOS()) & this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'qrcode') {
      this.options.appState.trigger('switchForm', _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL);
    }
  },
  showMessages: function showMessages() {
    var _this = this;

    // override showMessages to display error message
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messagesObjs.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.class) === 'ERROR') {
          var options = {
            content: msg,
            type: 'error'
          };

          if (_this.options.appState.containsMessageWithI18nKey(OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_IOS) || _this.options.appState.containsMessageWithI18nKey(OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_NON_IOS)) {
            // add a title for ov force upgrade
            options.title = (0, _okta.loc)('oie.okta_verify.enroll.force.upgrade.title', 'login');
          } else if (_this.options.appState.containsMessageWithI18nKey(OV_QR_ENROLL_ENABLE_BIOMETRICS_KEY)) {
            // add a title for OV enable biometrics message during enrollment
            options.title = (0, _okta.loc)('oie.authenticator.app.method.push.enroll.enable.biometrics.title', 'login');
          }

          _this.add((0, _okta.createCallout)(options), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  },
  getUISchema: function getUISchema() {
    var _context2;

    var schema = [];
    var contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    var selectedChannel = contextualData.selectedChannel;
    schema.push({
      View: _EnrollChannelPollDescriptionView.default
    });
    schema.push({
      View: _SwitchEnrollChannelLinkView.default,
      options: {
        selectedChannel: selectedChannel
      },
      selector: selectedChannel === 'qrcode' ? '.qrcode-container' : '.switch-channel-content'
    });

    if ((0, _includes.default)(_context2 = ['email', 'sms']).call(_context2, selectedChannel)) {
      schema.push({
        View: _ResendView.default,
        selector: '.o-form-error-container'
      });
    }

    return schema;
  },
  remove: function remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);

    this.stopPolling();
  }
}, _polling.default));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Constants = __webpack_require__(93);

var _default = _okta.View.extend({
  //only show after certain threshold of polling
  className: 'hide resend-ov-link-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize: function initialize() {
    var selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    this.add((0, _okta.createCallout)({
      content: selectedChannel === 'email' ? _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "oie.enroll.okta_verify.email.notReceived"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 73
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }) : _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function main(container, depth0, helpers, partials, data) {
          var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }

            return undefined;
          };

          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "oie.enroll.okta_verify.sms.notReceived"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 71
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      type: 'warning'
    }));
  },
  handelResendLink: function handelResendLink() {
    this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend'); //hide warning, but reinitiate to show warning again after some threshold of polling

    this.$el.addClass('hide');
    this.showCalloutWithDelay();
  },
  postRender: function postRender() {
    this.showCalloutWithDelay();
  },
  showCalloutWithDelay: function showCalloutWithDelay() {
    var _this = this;

    this.showMeTimeout = _okta._.delay(function () {
      _this.$el.removeClass('hide');
    }, _Constants.SHOW_RESEND_TIMEOUT);
  },
  remove: function remove() {
    _okta.View.prototype.remove.apply(this, arguments);

    clearTimeout(this.showMeTimeout);
  }
});

exports.default = _default;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ol class=\"qrcode-info ov-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 48
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 123
          },
          "end": {
            "line": 1,
            "column": 189
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 198
          },
          "end": {
            "line": 1,
            "column": 264
          }
        }
      })) + "</li></ol><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 328
          },
          "end": {
            "line": 1,
            "column": 336
          }
        }
      }) : helper)) + " alt=\"qr code\"></img></div>";
    },
    "3": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ul class=\"email-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "email",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.email.info"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 418
          },
          "end": {
            "line": 1,
            "column": 502
          }
        }
      })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
    },
    "5": function _(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<ul class=\"sms-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "phoneNumber",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.sms.info"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 611
          },
          "end": {
            "line": 1,
            "column": 699
          }
        }
      })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 370
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 370
          },
          "end": {
            "line": 1,
            "column": 559
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 559
          },
          "end": {
            "line": 1,
            "column": 756
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var _contextualData$qrcod;

    var contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    return {
      href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href,
      email: _okta._.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.email),
      phoneNumber: _okta._.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.phoneNumber)
    };
  }
});

exports.default = _default;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(160));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var Body = _internals.BaseForm.extend({
  title: function title() {
    return _BrowserFeatures.default.isAndroid() || _BrowserFeatures.default.isIOS() ? (0, _okta.loc)('oie.enroll.okta_verify.setup.title', 'login') : (0, _okta.loc)('oie.enroll.okta_verify.select.channel.title', 'login');
  },
  getUISchema: function getUISchema() {
    var _this = this,
        _channelField$options,
        _context;

    var schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments); // filter selected channel


    var channelField = (0, _find.default)(_okta._).call(_okta._, schemas, function (schema) {
      return schema.name === 'authenticator.channel';
    });
    channelField.options = (0, _filter.default)(_okta._).call(_okta._, channelField === null || channelField === void 0 ? void 0 : channelField.options, function (option) {
      var _this$options$appStat, _this$options$appStat2;

      return option.value !== ((_this$options$appStat = _this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.selectedChannel);
    });
    channelField.value = (_channelField$options = channelField.options[0]) === null || _channelField$options === void 0 ? void 0 : _channelField$options.value;
    var description = {
      View: (0, _okta.loc)('oie.enroll.okta_verify.select.channel.description', 'login'),
      selector: '.o-form-fieldset-container'
    };
    return (0, _concat.default)(_context = [description]).call(_context, (0, _toConsumableArray2.default)(schemas));
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _bind = _interopRequireDefault(__webpack_require__(27));

var _splice = _interopRequireDefault(__webpack_require__(154));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _findIndex = _interopRequireDefault(__webpack_require__(153));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _CountryUtil = _interopRequireDefault(__webpack_require__(157));

var _SwitchEnrollChannelLinkView = _interopRequireDefault(__webpack_require__(616));

var Body = _internals.BaseForm.extend({
  className: 'oie-enroll-ov-data',
  title: function title() {
    return this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, _okta.loc)('oie.enroll.okta_verify.enroll.channel.email.title', 'login') : (0, _okta.loc)('oie.enroll.okta_verify.enroll.channel.sms.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oie.enroll.okta_verify.setupLink', 'login');
  },
  getUISchema: function getUISchema() {
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    var phoneNumberUISchema = (0, _find.default)(_okta._).call(_okta._, uiSchemas, function (_ref) {
      var name = _ref.name;
      return name === 'phoneNumber';
    });
    var phoneNumberUISchemaIndex = (0, _findIndex.default)(_okta._).call(_okta._, uiSchemas, function (_ref2) {
      var name = _ref2.name;
      return name === 'phoneNumber';
    });
    var countryUISchema = {
      'label-top': true,
      label: (0, _okta.loc)('country.label', 'login'),
      type: 'select',
      options: _CountryUtil.default.getCountries(),
      name: 'country',
      wide: true
    }; // Create an input group - serves as a display wrapper

    var phoneNumberWithCodeUISchema = {
      label: (0, _okta.loc)('mfa.phoneNumber.placeholder', 'login'),
      type: 'group',
      modelType: 'string',
      'label-top': true,
      name: 'phoneCode',
      input: [{
        type: 'label',

        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
        label: "+".concat(this.model.get('phoneCode')),
        className: 'country-code-label no-translate'
      }, (0, _assign.default)({}, phoneNumberUISchema)]
    };

    if (phoneNumberUISchemaIndex !== -1) {
      // Replace phoneNumberUISchema and add countryUISchema before phone.
      (0, _splice.default)(uiSchemas).call(uiSchemas, phoneNumberUISchemaIndex, 1, countryUISchema, phoneNumberWithCodeUISchema);
    }

    var description = {
      View: this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, _okta.loc)('oie.enroll.okta_verify.channel.email.description', 'login') : (0, _okta.loc)('oie.enroll.okta_verify.channel.sms.description', 'login'),
      selector: '.o-form-fieldset-container'
    };
    uiSchemas.push(description);
    return uiSchemas;
  },
  handlePhoneCodeChange: function handlePhoneCodeChange() {
    var countryCodeField = this.el.querySelector('.country-code-label');
    countryCodeField.innerText = "+".concat(this.model.get('phoneCode'));
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'sms') {
      var _context;

      this.listenTo(this.model, 'change:phoneCode', (0, _bind.default)(_context = this.handlePhoneCodeChange).call(_context, this));
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass() {
    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel !== 'sms') {
      return ModelClass;
    }

    var local = (0, _assign.default)({
      country: {
        // Set default country to "US"
        'value': 'US',
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    var derived = (0, _assign.default)({
      phoneCode: {
        deps: ['country'],
        fn: function fn(country) {
          return _CountryUtil.default.getCallingCodeForCountry(country);
        }
      }
    }, ModelClass.prototype.derived);
    return ModelClass.extend({
      local: local,
      derived: derived,
      toJSON: function toJSON() {
        var _context2;

        var modelJSON = _okta.Model.prototype.toJSON.call(this, arguments);

        var phoneCode = this.get('phoneCode'); // Add country code..

        var formattedPhoneNumber = (0, _concat.default)(_context2 = "+".concat(phoneCode)).call(_context2, modelJSON.phoneNumber); // Override phone with formatted number..

        modelJSON.phoneNumber = formattedPhoneNumber;
        return modelJSON;
      }
    });
  },
  postRender: function postRender() {
    this.add(_SwitchEnrollChannelLinkView.default, 'form');
  }
});

exports.default = _default;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _ChallengePushView = __webpack_require__(617);

var _ChallengeOktaVerifyFastPassView = _interopRequireDefault(__webpack_require__(1401));

var _NumberChallengePushView = _interopRequireDefault(__webpack_require__(1402));

var _RemediationConstants = __webpack_require__(24);

var _default = _BaseAuthenticatorView.default.extend({
  initialize: function initialize() {
    var _this$options, _this$options$appStat, _currentAuthenticator;

    _BaseAuthenticatorView.default.prototype.initialize.apply(this, arguments);

    var currentAuthenticator = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$appStat = _this$options.appState) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.get('currentAuthenticator');
    var selectedMethod = currentAuthenticator === null || currentAuthenticator === void 0 ? void 0 : currentAuthenticator.methods[0];

    if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === _RemediationConstants.AUTHENTICATOR_METHODS.PUSH && (currentAuthenticator === null || currentAuthenticator === void 0 ? void 0 : (_currentAuthenticator = currentAuthenticator.contextualData) === null || _currentAuthenticator === void 0 ? void 0 : _currentAuthenticator.correctAnswer)) {
      this.Body = _NumberChallengePushView.default;
    } else if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === _RemediationConstants.AUTHENTICATOR_METHODS.PUSH) {
      this.Body = _ChallengePushView.Body;
    } else {
      this.Body = _ChallengeOktaVerifyFastPassView.default;
    }
  }
});

exports.default = _default;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _promise = _interopRequireDefault(__webpack_require__(195));

var _stringify = _interopRequireDefault(__webpack_require__(98));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _Logger = _interopRequireDefault(__webpack_require__(79));

var _Constants = __webpack_require__(93);

var _BrowserFeatures = _interopRequireDefault(__webpack_require__(56));

var _ChallengeViewUtil = __webpack_require__(611);

var request = function request(opts) {
  var ajaxOptions = (0, _assign.default)({
    method: 'GET',
    contentType: 'application/json'
  }, opts);
  return _okta.$.ajax(ajaxOptions);
};

var Body = _internals.BaseFormWithPolling.extend((0, _assign.default)({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  events: {
    'click #launch-ov': function clickLaunchOv(e) {
      e.preventDefault();
      this.doCustomURI();
    }
  },
  initialize: function initialize() {
    _internals.BaseFormWithPolling.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', this.onPollingFail);
    (0, _ChallengeViewUtil.doChallenge)(this);
    this.startPolling();
  },
  onPollingFail: function onPollingFail() {
    this.$('.spinner').hide();
    this.stopPolling();
  },
  remove: function remove() {
    _internals.BaseFormWithPolling.prototype.remove.apply(this, arguments);

    this.stopPolling();
  },
  getDeviceChallengePayload: function getDeviceChallengePayload() {
    return this.options.currentViewState.relatesTo.value.contextualData.challenge.value;
  },
  doLoopback: function doLoopback(deviceChallenge) {
    var _this = this;

    var authenticatorDomainUrl = deviceChallenge.domain !== undefined ? deviceChallenge.domain : '';
    var ports = deviceChallenge.ports !== undefined ? deviceChallenge.ports : [];
    var challengeRequest = deviceChallenge.challengeRequest !== undefined ? deviceChallenge.challengeRequest : '';
    var probeTimeoutMillis = deviceChallenge.probeTimeoutMillis !== undefined ? deviceChallenge.probeTimeoutMillis : 100;
    var currentPort;
    var foundPort = false;
    var countFailedPorts = 0;

    var getAuthenticatorUrl = function getAuthenticatorUrl(path) {
      var _context, _context2;

      return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(authenticatorDomainUrl, ":")).call(_context2, currentPort, "/")).call(_context, path);
    };

    var checkPort = function checkPort() {
      return request({
        url: getAuthenticatorUrl('probe'),

        /*
        OKTA-278573 in loopback server, SSL handshake sometimes takes more than 100ms and thus needs additional
        timeout however, increasing timeout is a temporary solution since user will need to wait much longer in
        worst case.
        TODO: Android timeout is temporarily set to 3000ms and needs optimization post-Beta.
        OKTA-365427 introduces probeTimeoutMillis; but we should also consider probeTimeoutMillisHTTPS for
        customizing timeouts in the more costly Android and other (keyless) HTTPS scenarios.
        */
        timeout: _BrowserFeatures.default.isAndroid() ? 3000 : probeTimeoutMillis
      });
    };

    var onPortFound = function onPortFound() {
      foundPort = true;
      return request({
        url: getAuthenticatorUrl('challenge'),
        method: 'POST',
        data: (0, _stringify.default)({
          challengeRequest: challengeRequest
        }),
        timeout: _Constants.CHALLENGE_TIMEOUT // authenticator should respond within 5 min (300000ms) for challenge request

      });
    };

    var onFailure = function onFailure() {
      _Logger.default.error("Something unexpected happened while we were checking port ".concat(currentPort, "."));
    };

    var doProbing = function doProbing() {
      return checkPort() // TODO: can we use standard ES6 promise methods, then/catch?
      .done(onPortFound).fail(onFailure);
    };

    var probeChain = _promise.default.resolve();

    (0, _forEach.default)(ports).call(ports, function (port) {
      probeChain = probeChain.then(function () {
        if (!foundPort) {
          currentPort = port;
          return doProbing();
        }
      }).catch(function () {
        countFailedPorts++;

        _Logger.default.error("Authenticator is not listening on port ".concat(currentPort, "."));

        if (countFailedPorts === ports.length) {
          _Logger.default.error('No available ports. Loopback server failed and polling is cancelled.');

          _this.options.appState.trigger('invokeAction', 'currentAuthenticator-cancel');
        }
      });
    });
  },
  doCustomURI: function doCustomURI() {
    this.ulDom && this.ulDom.remove();
    this.ulDom = this.add("\n        <iframe src=\"".concat(this.customURI, "\" id=\"custom-uri-container\" style=\"display:none;\"></iframe>\n      ")).last();
  }
}));

var _default = Body;
exports.default = _default;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _find = _interopRequireDefault(__webpack_require__(13));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _polling = _interopRequireDefault(__webpack_require__(257));

var _ResendNumberChallengeView = _interopRequireDefault(__webpack_require__(1403));

var _NumberChallengePhoneView = _interopRequireDefault(__webpack_require__(1404));

var Body = _internals.BaseForm.extend((0, _assign.default)({
  noButtonBar: true,
  className: 'okta-verify-number-challenge',
  events: {
    'click a.resend-number-challenge': 'handleResendNumberChallenge'
  },
  handleResendNumberChallenge: function handleResendNumberChallenge() {
    this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend'); // hide the warning

    this.options.appState.trigger('hideNumberChallengeWarning');
  },
  title: function title() {
    return (0, _okta.loc)('oie.okta_verify.push.sent', 'login');
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.add(_NumberChallengePhoneView.default);
  },
  triggerAfterError: function triggerAfterError() {
    var _context;

    _internals.BaseForm.prototype.triggerAfterError.apply(this, arguments);

    this.stopPolling();
    (0, _find.default)(_context = this.$el).call(_context, '.o-form-fieldset-container').empty();
  },
  postRender: function postRender() {
    this.startPoll();
  },
  startPoll: function startPoll() {
    this.startPolling();
    this.addWarning();
  },
  stopPoll: function stopPoll() {
    this.stopPolling();
  },
  addWarning: function addWarning() {
    this.add(_ResendNumberChallengeView.default, '.o-form-error-container');
    this.options.appState.trigger('showNumberChallengeWarning');
  },
  remove: function remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);

    this.stopPolling();
  }
}, _polling.default));

var _default = Body;
exports.default = _default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(__webpack_require__(27));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(71));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _Constants = __webpack_require__(93);

var ResendNumberChallengeView = _okta.View.extend({
  initialize: function initialize() {
    var _this = this;

    this.listenTo(this.options.appState, 'showNumberChallengeWarning', function () {
      _this.startWarningTimeout();
    });
    this.listenTo(this.options.appState, 'hideNumberChallengeWarning', function () {
      _this.clearWarning();
    });
  },
  className: 'resend-number-challenge-warning hide',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"okta-form-infobox-warning infobox infobox-warning\"><span class=\"icon warning-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a href='#' class='resend-number-challenge'>$1</a>",
          "bundle": "login",
          "code": "oie.numberchallenge.warning"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 103
          },
          "end": {
            "line": 1,
            "column": 217
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  }),
  showWarning: function showWarning() {
    this.$el.removeClass('hide');
  },
  clearWarning: function clearWarning() {
    this.$el.addClass('hide');
    clearTimeout(this.warningTimeout);
    this.startWarningTimeout();
  },
  startWarningTimeout: function startWarningTimeout() {
    this.warningTimeout = (0, _setTimeout2.default)((0, _bind.default)(_okta._).call(_okta._, function () {
      this.showWarning();
    }, this), _Constants.WARNING_TIMEOUT);
  }
});

var _default = ResendNumberChallengeView;
exports.default = _default;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var NumberChallengePhoneView = _okta.View.extend({
  className: 'number-challenge-section',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "correctAnswer",
          "bundle": "login",
          "code": "oie.numberchallenge.instruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3
          },
          "end": {
            "line": 1,
            "column": 127
          }
        }
      })) + "</p><div class=\"phone no-translate\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "correctAnswer") || (depth0 != null ? lookupProperty(depth0, "correctAnswer") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "correctAnswer",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 270
          },
          "end": {
            "line": 1,
            "column": 287
          }
        }
      }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div>";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var _this$options$appStat, _this$options$appStat2;

    var correctAnswer = (_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.correctAnswer;
    return {
      correctAnswer: correctAnswer
    };
  }
});

var _default = NumberChallengePhoneView;
exports.default = _default;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(__webpack_require__(52));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var OV_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.oktaverify.method.totp.verify.enable.biometrics';

var Body = _internals.BaseForm.extend((0, _assign.default)({
  className: 'okta-verify-totp-challenge',
  title: function title() {
    return (0, _okta.loc)('oie.okta_verify.totp.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  isErrorCalloutCustomized: function isErrorCalloutCustomized(convertedErrors) {
    var _convertedErrors$resp;

    var errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;

    if (errorSummaryKeys && (0, _includes.default)(errorSummaryKeys).call(errorSummaryKeys, OV_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
      return true;
    }

    return false;
  },
  showCustomErrorCallout: function showCustomErrorCallout() {
    _internals.BaseForm.prototype.showCustomErrorCallout.apply(this, arguments);

    this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
    var options = {
      type: 'error',
      className: 'okta-verify-uv-callout-content',
      title: (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login'),
      subtitle: (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.description', 'login'),
      bullets: [(0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'), (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'), (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login')]
    };
    this.add((0, _okta.createCallout)(options), '.o-form-error-container');
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var OV_NMC_FORCE_UPGRAGE_SERVER_KEY = 'oie.authenticator.app.method.push.force.upgrade.number_challenge';
var OV_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.app.method.push.verify.enable.biometrics';

var Body = _internals.BaseForm.extend((0, _assign.default)({
  className: 'okta-verify-resend-push',
  title: function title() {
    return (0, _okta.loc)('oie.okta_verify.push.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('oie.okta_verify.push.resend', 'login');
  },
  showMessages: function showMessages() {
    var _this = this;

    // override showMessages to display error in cases like reject push
    // or timeout. Borrowed this logic from TerminalView.
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messagesObjs.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.class) === 'ERROR') {
          var options = {
            content: msg,
            type: 'error'
          };

          if (_this.options.appState.containsMessageWithI18nKey(OV_NMC_FORCE_UPGRAGE_SERVER_KEY)) {
            // add a title for OV force upgrade
            options.title = (0, _okta.loc)('oie.numberchallenge.force.upgrade.title', 'login');
          } else if (_this.options.appState.containsMessageWithI18nKey(OV_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
            // add a title for OV enable biometrics message during verification
            options.content = null;
            options.className = 'okta-verify-uv-callout-content';
            options.title = (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login');
            options.subtitle = (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.description', 'login');
            options.bullets = [(0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'), (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'), (0, _okta.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login')];
          }

          _this.add((0, _okta.createCallout)(options), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _splice = _interopRequireDefault(__webpack_require__(154));

var _findIndex = _interopRequireDefault(__webpack_require__(153));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _map = _interopRequireDefault(__webpack_require__(40));

var _find = _interopRequireDefault(__webpack_require__(13));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _AuthenticatorVerifyOptions = _interopRequireDefault(__webpack_require__(599));

var _AuthenticatorUtil = __webpack_require__(204);

var _SelectAuthenticatorVerifyView = __webpack_require__(613);

var _RemediationConstants = __webpack_require__(24);

var Body = _SelectAuthenticatorVerifyView.Body.extend({
  getUISchema: function getUISchema() {
    var _context;

    // Change the UI schema to not display radios here.
    var uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    var methodsSchema = (0, _find.default)(uiSchemas).call(uiSchemas, function (schema) {
      return schema.name === 'authenticator.methodType';
    });

    this._sortMethodOptionsIfDeviceKnown(methodsSchema.options);

    var methodOptions = (0, _map.default)(_context = methodsSchema.options).call(_context, function (option) {
      return (0, _assign.default)({}, option, (0, _AuthenticatorUtil.getAuthenticatorDataForVerification)({
        authenticatorKey: _RemediationConstants.AUTHENTICATOR_KEY.OV
      }));
    });
    return [{
      View: _AuthenticatorVerifyOptions.default,
      options: {
        name: methodsSchema.name,
        collection: new _okta.Collection(methodOptions)
      }
    }];
  },
  // If the `deviceKnown` attribute is true, we should put the signed_nonce method to the top of authenticator list.
  // This is in sync with v2/ion/ui-schema/ion-object-handler.js - createOVOptions
  _sortMethodOptionsIfDeviceKnown: function _sortMethodOptionsIfDeviceKnown(methodOptions) {
    var _this$options, _this$options$current, _this$options$current2, _this$options$current3;

    // Check if the `deviceKnown` attribute is true
    var deviceKnown = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$current = _this$options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.relatesTo) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.value) === null || _this$options$current3 === void 0 ? void 0 : _this$options$current3.deviceKnown;

    if (deviceKnown) {
      var signedNonceIndex = (0, _findIndex.default)(methodOptions).call(methodOptions, function (e) {
        return e.value === 'signed_nonce';
      });

      if (signedNonceIndex > 0) {
        var signedNonceModel = methodOptions[signedNonceIndex]; // Put the 'signed_nonce' option to the top of the list

        (0, _splice.default)(methodOptions).call(methodOptions, signedNonceIndex, 1);
        methodOptions.unshift(signedNonceModel);
      }
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  Footer: _internals.BaseFooter
});

exports.default = _default;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _internals = __webpack_require__(5);

var _okta = __webpack_require__(2);

// for EA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for GA
var Body = _internals.BaseForm.extend({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  title: function title() {
    return (0, _okta.loc)('deviceTrust.sso.redirectText', 'login');
  },
  initialize: function initialize() {
    var _this = this,
        _this$options$current,
        _this$options$current2;

    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.listenTo(this.model, 'error', function () {
      _this.$('.spinner').hide();
    });
    this.add('<div class="credential-sso-extension"><div class="spinner"></div></div>');
    var isGetMethod = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.method) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.toLowerCase()) === 'get';
    this.model.set('useRedirect', isGetMethod);
    this.trigger('save', this.model);
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _EnrollGoogleAuthenticatorBarcodeView = _interopRequireDefault(__webpack_require__(1410));

var _EnrollAuthenticatorManualSetupView = _interopRequireDefault(__webpack_require__(1411));

var VIEW_TO_DISPLAY = 'viewToDisplay';
var viewToDisplayState = {
  BARCODE: 'barcode',
  MANUAL: 'manual',
  ENTER_CODE: 'enterCode'
};

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('oie.enroll.google_authenticator.setup.title', 'login');
  },
  noButtonBar: true,
  className: 'oie-enroll-google-authenticator',
  enterCodeSubtitle: _okta.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function main(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }

          return undefined;
        };

        return "<div class=\"google-authenticator-setup-info-title enter-code-title\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "oie.enroll.google_authenticator.enterCode.title"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 68
            },
            "end": {
              "line": 1,
              "column": 146
            }
          }
        })) + "</div>";
      },
      "useData": true
    })
  }),
  getUISchema: function getUISchema() {
    var _this = this;

    var schema = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    var nextButton = (0, _internals.addCustomButton)({
      className: 'google-authenticator-next',
      title: (0, _okta.loc)('oform.next', 'login'),
      attributes: {
        style: 'display: block'
      },
      click: function click() {
        _this.model.set(VIEW_TO_DISPLAY, viewToDisplayState.ENTER_CODE);
      }
    });
    var verifyButton = (0, _internals.addCustomButton)({
      className: 'google-authenticator-verify',
      title: (0, _okta.loc)('oform.verify', 'login'),
      click: function click() {
        _this.$el.submit();
      }
    });
    schema[0].showWhen = {
      viewToDisplay: viewToDisplayState.ENTER_CODE
    }; // Add Enter Code Subtitle

    schema.unshift({
      View: this.enterCodeSubtitle,
      selector: '.o-form-fieldset-container',
      showWhen: {
        viewToDisplay: viewToDisplayState.ENTER_CODE
      }
    });
    schema.push({
      View: _EnrollGoogleAuthenticatorBarcodeView.default,
      selector: '.o-form-fieldset-container',
      showWhen: {
        viewToDisplay: viewToDisplayState.BARCODE
      }
    }, {
      View: _EnrollAuthenticatorManualSetupView.default,
      selector: '.o-form-fieldset-container',
      showWhen: {
        viewToDisplay: viewToDisplayState.MANUAL
      }
    }, {
      label: false,
      className: 'shared-secret',
      type: 'text',
      placeholder: this.options.appState.get('currentAuthenticator').contextualData.sharedSecret,
      disabled: true,
      showWhen: {
        viewToDisplay: viewToDisplayState.MANUAL
      }
    }, {
      View: nextButton,
      showWhen: {
        viewToDisplay: function viewToDisplay(val) {
          return val === viewToDisplayState.BARCODE || val === viewToDisplayState.MANUAL;
        }
      }
    }, {
      View: verifyButton,
      showWhen: {
        viewToDisplay: function viewToDisplay(val) {
          return val === viewToDisplayState.ENTER_CODE;
        }
      }
    });
    return schema;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body,
  createModelClass: function createModelClass() {
    var ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    var local = (0, _assign.default)({
      viewToDisplay: {
        value: 'barcode',
        type: 'string',
        required: true,
        values: [viewToDisplayState.BARCODE, viewToDisplayState.MANUAL, viewToDisplayState.ENTER_CODE]
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local: local
    });
  }
});

exports.default = _default;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  className: 'oie-enroll-google-authenticator-barcode',
  template: _runtime.default.template({
    "1": function _(container, depth0, helpers, partials, data) {
      var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"google-authenticator-setup-info-title barcode-setup-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.scanBarcode.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 83
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      })) + "</div><div class=\"qrcode-info-container\"><p class=\"google-authenticator-setup-info\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.scanBarcode.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 247
          },
          "end": {
            "line": 1,
            "column": 333
          }
        }
      })) + "</p><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 391
          },
          "end": {
            "line": 1,
            "column": 399
          }
        }
      }) : helper)) + " alt=\"qr code\"></img><a href=\"#\" class=\"cannot-scan-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.scanBarcode.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 457
          },
          "end": {
            "line": 1,
            "column": 542
          }
        }
      })) + "</a></div></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 565
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData: function getTemplateData() {
    var _contextualData$qrcod;

    var contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    return {
      href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href
    };
  },
  events: {
    'click .cannot-scan-link': function clickCannotScanLink(e) {
      e.preventDefault();
      this.options.model.set('viewToDisplay', 'manual');
    }
  }
});

exports.default = _default;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _default = _okta.View.extend({
  className: 'oie-enroll-google-authenticator-manual-setup',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }

        return undefined;
      };

      return "<div class=\"google-authenticator-setup-info-title manual-setup-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.cannotScanBarcode.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 70
          },
          "end": {
            "line": 1,
            "column": 156
          }
        }
      })) + "</div><p class=\"google-authenticator-setup-info\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.manualSetupInstructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 205
          },
          "end": {
            "line": 1,
            "column": 291
          }
        }
      })) + "</p>";
    },
    "useData": true
  })
});

exports.default = _default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _internals.BaseForm.extend((0, _assign.default)({
  className: 'google-authenticator-challenge',
  title: function title() {
    return (0, _okta.loc)('oie.verify.google_authenticator.otp.title', 'login');
  },
  subtitle: function subtitle() {
    return (0, _okta.loc)('oie.verify.google_authenticator.otp.description', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(__webpack_require__(52));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var ON_PREM_TOKEN_CHANGE_KEY = 'errors.E0000113';

var Body = _internals.BaseForm.extend({
  className: 'on-prem-authenticator-enroll',
  modelEvents: {
    'error': '_checkTokenChange'
  },
  title: function title() {
    var vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, _okta.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
    return (0, _okta.loc)('oie.on_prem.enroll.title', 'login', [vendorName]);
  },
  _checkTokenChange: function _checkTokenChange(model, convertedErrors) {
    var _convertedErrors$resp;

    var errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;

    if (errorSummaryKeys && (0, _includes.default)(errorSummaryKeys).call(errorSummaryKeys, ON_PREM_TOKEN_CHANGE_KEY)) {
      // this means we are in change pin, so we should clear out answer input
      this.model.set('credentials.passcode', '');
      this.render();
    }
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(__webpack_require__(52));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var ON_PREM_TOKEN_CHANGE_KEY = 'errors.E0000113';

var Body = _internals.BaseForm.extend({
  className: 'on-prem-authenticator-verify',
  modelEvents: {
    'error': '_checkTokenChange'
  },
  title: function title() {
    var vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, _okta.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
    return (0, _okta.loc)('oie.on_prem.verify.title', 'login', [vendorName]);
  },
  _checkTokenChange: function _checkTokenChange(model, convertedErrors) {
    var _convertedErrors$resp;

    var errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;

    if (errorSummaryKeys && (0, _includes.default)(errorSummaryKeys).call(errorSummaryKeys, ON_PREM_TOKEN_CHANGE_KEY)) {
      // this means we are in change pin, so we should clear out answer input
      this.model.set('credentials.passcode', '');
      this.render();
    }
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseDuoAuthenticatorForm = _interopRequireDefault(__webpack_require__(618));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _BaseDuoAuthenticatorForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.duo.enroll.title', 'login');
  },
  getContextualData: function getContextualData() {
    return this.options.appState.get('currentAuthenticator').contextualData;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseDuoAuthenticatorForm = _interopRequireDefault(__webpack_require__(618));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _BaseDuoAuthenticatorForm.default.extend({
  title: function title() {
    return (0, _okta.loc)('oie.duo.verify.title', 'login');
  },
  getContextualData: function getContextualData() {
    return this.options.appState.get('currentAuthenticatorEnrollment').contextualData;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseIdPAuthenticatorBody = _interopRequireDefault(__webpack_require__(619));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _BaseIdPAuthenticatorBody.default.extend({
  title: function title() {
    var displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _okta.loc)('oie.idp.challenge.title', 'login', [displayName]);
  },
  subtitle: function subtitle() {
    var displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _okta.loc)('oie.idp.challenge.description', 'login', [displayName]);
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseIdPAuthenticatorBody = _interopRequireDefault(__webpack_require__(619));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _BaseIdPAuthenticatorBody.default.extend({
  title: function title() {
    var displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _okta.loc)('oie.idp.enroll.title', 'login', [displayName]);
  },
  subtitle: function subtitle() {
    var displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _okta.loc)('oie.idp.enroll.description', 'login', [displayName]);
  },
  save: function save() {
    return (0, _okta.loc)('mfa.enroll', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _internals.BaseForm.extend((0, _assign.default)({
  className: 'mfa-verify-custom-otp',
  title: function title() {
    var vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, _okta.loc)('oie.custom_otp.authenticator.default.vendorName', 'login');
    return (0, _okta.loc)('oie.verify.custom_otp.title', 'login', [vendorName]);
  },
  subtitle: function subtitle() {
    return (0, _okta.loc)('oie.verify.custom_otp.description', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _okta = __webpack_require__(2);

var _BaseForm = _interopRequireDefault(__webpack_require__(206));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _BaseForm.default.extend({
  title: function title() {
    var displayName = this.options.appState.getAuthenticatorDisplayName();
    return this.options.appState.isAuthenticatorChallenge() ? (0, _okta.loc)('oie.symantecVip.challenge.title', 'login', [displayName]) : (0, _okta.loc)('oie.symantecVip.enroll.title', 'login', [displayName]);
  },
  subtitle: function subtitle() {
    var displayName = this.options.appState.getAuthenticatorDisplayName();
    return this.options.appState.isAuthenticatorChallenge() ? (0, _okta.loc)('oie.symantecVip.challenge.description', 'login', [displayName]) : (0, _okta.loc)('oie.symantecVip.enroll.description', 'login', [displayName]);
  },
  save: function save() {
    return this.options.appState.isAuthenticatorChallenge() ? (0, _okta.loc)('mfa.challenge.verify', 'login') : (0, _okta.loc)('mfa.enroll', 'login');
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _concat = _interopRequireDefault(__webpack_require__(18));

var _includes = _interopRequireDefault(__webpack_require__(52));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var Body = _internals.BaseForm.extend({
  title: function title() {
    return (0, _okta.loc)('device.code.activate.title', 'login');
  },
  subtitle: function subtitle() {
    return (0, _okta.loc)('device.code.activate.subtitle', 'login');
  },
  events: {
    'keyup input[name="userCode"]': function keyupInputNameUserCode(e) {
      e.preventDefault();
      this.addHyphen(e);
    }
  },
  addHyphen: function addHyphen(evt) {
    var _context;

    var currentVal = evt.target.value; // add hyphen after 4th character

    if (currentVal && currentVal.length === 4 && !(0, _includes.default)(_context = ['Backspace', 'Delete', '-']).call(_context, evt.key)) {
      evt.target.value = (0, _concat.default)(currentVal).call(currentVal, '-');
    }
  },
  showMessages: function showMessages() {
    var _this = this;

    // override showMessages to display error message
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context2;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context2 = messagesObjs.value).call(_context2, function (messagesObj) {
        var msg = messagesObj.message;

        if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.class) === 'ERROR') {
          _this.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
});

var _default = _internals.BaseView.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var _PIVHeader = _interopRequireDefault(__webpack_require__(1423));

var Body = _internals.BaseForm.extend({
  className: 'piv-cac-card',
  modelEvents: {
    request: 'startAuthentication',
    error: 'stopAuthentication'
  },
  initialize: function initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);

    this.model.set('useRedirect', true);
    this.addInstructions();
  },
  title: function title() {
    return (0, _okta.loc)('piv.cac.title', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('retry', 'login');
  },
  addInstructions: function addInstructions() {
    this.add("<div class='piv-verify-text'>\n        <p>".concat((0, _okta.loc)('piv.cac.card.insert', 'login'), "</p>\n        <div data-se='piv-waiting' class='okta-waiting-spinner'></div>\n      </div>"));
  },
  startAuthentication: function startAuthentication() {
    this.$('.okta-waiting-spinner').show();
    this.$('.o-form-button-bar').hide();
  },
  stopAuthentication: function stopAuthentication() {
    this.$('.okta-waiting-spinner').hide();
    this.$('.o-form-button-bar').show();
  },
  showMessages: function showMessages() {
    var _this = this;

    // PIV error messages are not form errors
    // Parse and display them here.
    // TODO: OKTA-383470
    var messages = this.options.appState.get('messages') || {};

    if ((0, _isArray.default)(messages.value)) {
      var _context;

      this.add('<div class="ion-messages-container”></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messages.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if (messagesObj.class === 'ERROR') {
          _this.add((0, _okta.createCallout)({
            content: msg,
            type: 'error'
          }), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Header: _PIVHeader.default,
  Body: Body,
  postRender: function postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);

    var messages = this.options.appState.get('messages') || {}; // if piv view has errors, show errors and stop authentication.
    // otherwise trigger authentication on page load

    if ((0, _isArray.default)(messages.value)) {
      this.form.stopAuthentication();
    } else {
      this.form.startAuthentication();
      this.form.trigger('save', this.model);
    }
  }
});

exports.default = _default;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _internals = __webpack_require__(5);

var _HeaderBeacon = _interopRequireDefault(__webpack_require__(607));

var _default = _internals.BaseHeader.extend({
  HeaderBeacon: _HeaderBeacon.default.extend({
    getBeaconClassName: function getBeaconClassName() {
      return 'smartcard';
    }
  })
});

exports.default = _default;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _runtime = _interopRequireDefault(__webpack_require__(4));

var _okta = __webpack_require__(2);

var _BaseForm = _interopRequireDefault(__webpack_require__(206));

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var ExampleView = _okta.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function main(container, depth0, helpers, partials, data) {
      return "<div aria-hidden=\"true\" class=\"yubikey-demo\"></div>";
    },
    "useData": true
  })
});

var Body = _BaseForm.default.extend({
  title: function title() {
    return this.options.appState.isAuthenticatorChallenge() ? (0, _okta.loc)('oie.yubikey.challenge.title', 'login') : (0, _okta.loc)('oie.yubikey.enroll.title', 'login');
  },
  subtitle: function subtitle() {
    return (0, _okta.loc)('oie.yubikey.description', 'login');
  },
  save: function save() {
    return (0, _okta.loc)('mfa.challenge.verify', 'login');
  },
  getUISchema: function getUISchema() {
    var schema = _BaseForm.default.prototype.getUISchema.apply(this, arguments);

    schema.unshift({
      View: ExampleView,
      selector: '.o-form-fieldset-container'
    });
    return schema;
  }
});

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _assign = _interopRequireDefault(__webpack_require__(11));

var _okta = __webpack_require__(2);

var _internals = __webpack_require__(5);

var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(14));

var Body = _internals.BaseForm.extend((0, _assign.default)({
  className: 'custom-app-verify-resend-push',
  title: function title() {
    return (0, _okta.loc)('oie.verify.custom_app.title', 'login', [this.options.appState.getAuthenticatorDisplayName()]);
  },
  save: function save() {
    return (0, _okta.loc)('oie.custom_app.push.resend', 'login');
  },
  showMessages: function showMessages() {
    var _this = this;

    // override showMessages to display error in cases like reject push
    // or timeout. Borrowed this logic from TerminalView.
    var messagesObjs = this.options.appState.get('messages');

    if (messagesObjs && (0, _isArray.default)(messagesObjs.value)) {
      var _context;

      this.add('<div class="ion-messages-container"></div>', '.o-form-error-container');
      (0, _forEach.default)(_context = messagesObjs.value).call(_context, function (messagesObj) {
        var msg = messagesObj.message;

        if ((messagesObj === null || messagesObj === void 0 ? void 0 : messagesObj.class) === 'ERROR') {
          var options = {
            content: msg,
            type: 'error'
          };

          _this.add((0, _okta.createCallout)(options), '.o-form-error-container');
        } else {
          _this.add("<p>".concat(msg, "</p>"), '.ion-messages-container');
        }
      });
    }
  }
}));

var _default = _BaseAuthenticatorView.default.extend({
  Body: Body
});

exports.default = _default;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(__webpack_require__(18));

var _isArray = _interopRequireDefault(__webpack_require__(35));

var _filter = _interopRequireDefault(__webpack_require__(39));

var _map = _interopRequireDefault(__webpack_require__(40));

var _okta = __webpack_require__(2);

var _i18nTransformer = __webpack_require__(142);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var convertErrorMessageToErrorSummary = function convertErrorMessageToErrorSummary(formName) {
  var _context, _context2;

  var remediationValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _map.default)(_context = (0, _filter.default)(_context2 = _okta._.chain(remediationValues)).call(_context2, function (field) {
    var _field$messages;

    return (0, _isArray.default)((_field$messages = field.messages) === null || _field$messages === void 0 ? void 0 : _field$messages.value) && field.messages.value.length;
  })).call(_context, function (field) {
    var _context3, _context4, _context5;

    return {
      property: formName ? (0, _concat.default)(_context3 = "".concat(formName, ".")).call(_context3, field.name) : field.name,
      errorSummary: (0, _map.default)(_context4 = field.messages.value).call(_context4, _i18nTransformer.getMessage),
      errorKey: (0, _map.default)(_context5 = field.messages.value).call(_context5, _i18nTransformer.getMessageKey)
    };
  }).value();
};
/**
 * Although time complexity is O(n^2),
 * the `array` is actually very small (size < 5),
 * hence performance doesn't matter.
 */


var uniqWith = function uniqWith(array, comparator) {
  if (!(0, _isArray.default)(array)) {
    return [];
  }

  if (!_okta._.isFunction(comparator) || array.length === 1) {
    return array;
  }

  var result = [];

  for (var i = 0; i < array.length; i++) {
    var seen = false;

    for (var j = i + 1; j < array.length; j++) {
      /* eslint max-depth: [2, 3] */
      if (comparator(array[i], array[j])) {
        seen = true;
        break;
      }
    }

    if (!seen) {
      result.push(array[i]);
    }
  }

  return result;
};
/**
 * returns errors
 * @example
 * errors = [
 *   {property : fieldName1, errorSummary: [errorMessage1]},
 *   {property : fieldName2, errorSummary: [errorMessage2]}
 *   {property : fieldName3, errorSummary: [errorMessage31, errorMessage32]}
 * ]
 */


var getRemediationErrors = function getRemediationErrors(res) {
  var errors = [];

  if (!res.remediation || !(0, _isArray.default)(res.remediation.value) || res.remediation.value.length === 0) {
    return errors;
  }

  var remediationFormFields = res.remediation.value[0].value;

  if (!(0, _isArray.default)(remediationFormFields)) {
    return errors;
  } // error at field


  errors.push(convertErrorMessageToErrorSummary(null, remediationFormFields));

  _okta._.each(remediationFormFields, function (remediationForm) {
    var _remediationForm$form;

    var formName = remediationForm.name; // error at form.value

    if ((0, _isArray.default)((_remediationForm$form = remediationForm.form) === null || _remediationForm$form === void 0 ? void 0 : _remediationForm$form.value)) {
      errors.push(convertErrorMessageToErrorSummary(formName, remediationForm.form.value));
    } // error at option.value.form.value


    if ((0, _isArray.default)(remediationForm.options)) {
      _okta._.each(remediationForm.options, function (option) {
        var _option$value, _option$value$form;

        if ((0, _isArray.default)((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value)) {
          errors.push(convertErrorMessageToErrorSummary(formName, option.value.form.value));
        }
      });
    }
  }); // API may return identical error on same field
  // thus run through `uniqWith`.
  // Check unit test for details.


  return uniqWith(_okta._.flatten(errors), _okta._.isEqual);
};
/**
 * return global error summary combined into one string
 * allErrors = 'error string1. error string2'
 */


var getGlobalErrors = function getGlobalErrors(res) {
  var _res$messages;

  var allErrors = [];

  if ((0, _isArray.default)((_res$messages = res.messages) === null || _res$messages === void 0 ? void 0 : _res$messages.value)) {
    var _context6;

    allErrors = (0, _map.default)(_context6 = res.messages.value).call(_context6, _i18nTransformer.getMessage);
  }

  return allErrors.join('. ');
};
/**
 * return array of error keys
 */


var getGlobalErrorKeys = function getGlobalErrorKeys(res) {
  var _res$messages2;

  var allKeys = [];

  if ((0, _isArray.default)((_res$messages2 = res.messages) === null || _res$messages2 === void 0 ? void 0 : _res$messages2.value)) {
    var _context7;

    allKeys = (0, _map.default)(_context7 = res.messages.value).call(_context7, _i18nTransformer.getMessageKey);
  }

  return allKeys;
};

var convertFormErrors = function convertFormErrors(response) {
  var errors = {
    errorCauses: getRemediationErrors(response),
    errorSummary: getGlobalErrors(response),
    errorSummaryKeys: getGlobalErrorKeys(response),
    errorIntent: response.intent
  };
  return {
    responseJSON: errors
  };
};

var isIonErrorResponse = function isIonErrorResponse() {
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // check if error format is an ION response by looking for version attribute.
  // a little sloppy.
  return response.version;
};

var _default = {
  convertFormErrors: convertFormErrors,
  isIonErrorResponse: isIonErrorResponse
};
exports.default = _default;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _FormController = _interopRequireDefault(__webpack_require__(352));

var _RemediationConstants = __webpack_require__(24);

var _TerminalView = __webpack_require__(357);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Render Registration Form (a.k.a profile enroll) immediately as long as
 * the remediation form is available and default remediation is Identify.
 * Otherwise show error messages that feature is not supported.
 *
 */
var _default = _FormController.default.extend({
  // TODO: what if user navigate to this page but there is valid state token in session storage?
  // The flow is like
  // 1. User tries to sign-in
  // 2. During the middle of sign-in, change URL to /signin/register/
  //
  // User probably expects to see sign-up page
  // But user will continue sign-in flow due to the saved state token
  postRender: function postRender() {
    // Auto switch to porfile enroll (register) page
    // basically mimic the flow that show identify page and click sign-up link.
    // Or show error messages.
    if (this.options.appState.get('currentFormName') === _RemediationConstants.FORMS.IDENTIFY) {
      if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_ENROLL_PROFILE)) {
        this.handleInvokeAction(_RemediationConstants.FORMS.SELECT_ENROLL_PROFILE);
      } else {
        var messages = {
          type: 'array',
          value: [{
            message: 'Sign up is not enabled for this organization.',
            i18n: {
              key: _TerminalView.REGISTRATION_NOT_ENABLED
            },
            class: 'ERROR'
          }]
        };
        var resp = {
          neededToProceed: [],
          // OKTA-382410 so bad that has to leverage rawIdxState
          rawIdxState: {
            messages: messages
          },
          context: {
            messages: messages
          }
        };
        this.options.appState.trigger('remediationSuccess', resp);
      }
    } else {
      // otherwise behavior as default FormController to handle remediations.
      _FormController.default.prototype.postRender.apply(this, arguments);
    }
  }
});

exports.default = _default;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _FormController = _interopRequireDefault(__webpack_require__(352));

var _RemediationConstants = __webpack_require__(24);

var _TerminalView = __webpack_require__(357);

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Render Password Reset Form immediately as long as
 * the remediation form is available and default remediation is Identify.
 * Otherwise show error messages that feature is not supported.
 */
var _default = _FormController.default.extend({
  postRender: function postRender() {
    // Auto switch to porfile enroll (register) page
    // basically mimic the flow that show identify page and click sign-up link.
    // Or show error messages.
    if (this.options.appState.get('currentFormName') === _RemediationConstants.FORMS.IDENTIFY) {
      if (this.options.appState.getActionByPath(_RemediationConstants.ACTIONS.ORG_PASSWORD_RECOVERY_LINK)) {
        this.handleInvokeAction(_RemediationConstants.ACTIONS.ORG_PASSWORD_RECOVERY_LINK);
      } else {
        var messages = {
          type: 'array',
          value: [{
            message: 'Forgot password is not enabled for this organization.',
            i18n: {
              key: _TerminalView.FORGOT_PASSWORD_NOT_ENABLED
            },
            class: 'ERROR'
          }]
        };
        var resp = {
          neededToProceed: [],
          // OKTA-382410 so bad that has to leverage rawIdxState
          rawIdxState: {
            messages: messages
          },
          context: {
            messages: messages
          }
        };
        this.options.appState.trigger('remediationSuccess', resp);
      }
    } else {
      // otherwise behavior as default FormController to handle remediations.
      _FormController.default.prototype.postRender.apply(this, arguments);
    }
  }
});

exports.default = _default;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// okta-sign-in.min.js